
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jUNyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f9af3e6f2fd91b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "notify", () => $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b);
$parcel$export(module.exports, "notifyElement", () => $e7f9af3e6f2fd91b$export$d21553c7a9993ef5);
$parcel$export(module.exports, "ask", () => $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8);

var $dx9qz = parcelRequire("dx9qz");
const $e7f9af3e6f2fd91b$var$makeHtml = function(args) {
    const loadingOnly = args.animation && !args.title && !args.text && !args.buttons;
    let html = `<div class="msgbox${loadingOnly ? ' msgbox--loading' : ''}">`;
    if (args.title) html += $e7f9af3e6f2fd91b$var$makeDiv('mb-title', args.title);
    if (args.animation) html += $e7f9af3e6f2fd91b$var$makeDiv('mb-icon mb-loading', '<div class="mb-spinner" role="status" aria-live="polite" aria-label="Carregando"></div><div class="mb-loading-text">Carregando...</div>');
    if (args.text) html += $e7f9af3e6f2fd91b$var$makeDiv('mb-text', args.text);
    if (args.buttons) html += $e7f9af3e6f2fd91b$var$makeButtons('button mtl', args.buttons);
    html += '</div>';
    return html;
};
const $e7f9af3e6f2fd91b$var$makeDiv = function(cls, html) {
    return `<div class="${cls}">${html}</div>`;
};
const $e7f9af3e6f2fd91b$var$makeButtons = function(cls, buttons) {
    return buttons.map((button)=>`<button class="${cls} ${button.cls}">${button.label}</button>`).join('\n');
};
const $e7f9af3e6f2fd91b$export$2e2bcd8739ae039 = function(args) {
    let dlg = (0, $dx9qz.default).create($e7f9af3e6f2fd91b$var$makeHtml(args), args.callback, /Enter|Escape/);
    if (args.timeout) setTimeout(()=>dlg.destroy(), args.timeout);
    return {
        destroy: ()=>dlg.destroy()
    };
};
const $e7f9af3e6f2fd91b$export$5e14cdade93d6f7b = function(text, title) {
    let mb = $e7f9af3e6f2fd91b$export$2e2bcd8739ae039({
        title: title,
        text: text,
        buttons: [
            {
                label: 'Continuar',
                cls: 'bn_Enter'
            }
        ],
        callback: ()=>mb.destroy()
    });
};
/** Modal «Continuar» com corpo já montado em DOM (evita quebrar o parser com `</…>` vindo de dados/texto). */ const $e7f9af3e6f2fd91b$export$d21553c7a9993ef5 = function(contentEl, title) {
    const wrap = document.createElement('div');
    wrap.className = 'msgbox';
    const titleDiv = document.createElement('div');
    titleDiv.className = 'mb-title';
    titleDiv.textContent = title || '';
    const mbText = document.createElement('div');
    mbText.className = 'mb-text';
    mbText.appendChild(contentEl);
    const btn = document.createElement('button');
    btn.className = 'button mtl bn_Enter';
    btn.textContent = 'Continuar';
    wrap.appendChild(titleDiv);
    wrap.appendChild(mbText);
    wrap.appendChild(btn);
    let dlg;
    dlg = (0, $dx9qz.default).create(wrap.outerHTML, ()=>dlg.destroy(), /Enter|Escape/);
    return dlg;
};
const $e7f9af3e6f2fd91b$export$1b4aee0b51c3def8 = function(text, title, callback) {
    let mb = $e7f9af3e6f2fd91b$export$2e2bcd8739ae039({
        title: title,
        text: text,
        buttons: [
            {
                label: "N\xe3o",
                cls: 'bn_N'
            },
            {
                label: 'Sim',
                cls: 'bn_Y'
            }
        ],
        callback: (key)=>{
            mb.destroy();
            callback(key);
        }
    });
};

});
parcelRegister("dx9qz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da5ab8aba8aa3e3$export$2e2bcd8739ae039);
const $9da5ab8aba8aa3e3$var$DIALOGS = [];
const $9da5ab8aba8aa3e3$var$FOCUSABLE = function() {
    let a = ':not([disabled])'; // Disabled elements
    let b = ':not([tabIndex^="-"])'; // Negative tabIndex elements
    let c = ':not([type="hidden"])'; // Hidden input elements
    return [
        'a[href]' + b,
        'area[href]' + b,
        'input' + c + a + b,
        'select' + a + b,
        'textarea' + a + b,
        'button' + a + b,
        'iframe',
        '[tabIndex]' + b
    ].join(', ');
}();
const $9da5ab8aba8aa3e3$var$getFocusableElements = function(node) {
    return node.querySelectorAll($9da5ab8aba8aa3e3$var$FOCUSABLE);
};
const $9da5ab8aba8aa3e3$var$createNode = function(html) {
    /* Raiz deve ser fluxo (ex.: div), não <button>: msgbox pode conter <div>, <table>, etc.
	   HTML5 não permite blocos/tabelas dentro de <button>; o parser descartava nós e o modal ficava vazio. */ let node = document.createElement('div');
    node.className = 'dialog';
    node.setAttribute('role', 'dialog');
    node.setAttribute('aria-modal', 'true');
    node.innerHTML = html;
    document.body.appendChild(node);
    return node;
};
const $9da5ab8aba8aa3e3$var$captureEvents = function(dialog) {
    [
        'keydown',
        'click'
    ].forEach((type)=>dialog.node.addEventListener(type, (ev)=>$9da5ab8aba8aa3e3$var$eventHandler.call(dialog, ev)));
};
const $9da5ab8aba8aa3e3$var$eventHandler = function(ev) {
    switch(ev.type){
        case 'keydown':
            $9da5ab8aba8aa3e3$var$trapFocus.call(this, ev);
            $9da5ab8aba8aa3e3$var$keyHandler.call(this, ev);
            break;
        case 'click':
            $9da5ab8aba8aa3e3$var$clickHandler.call(this, ev);
            break;
    }
};
const $9da5ab8aba8aa3e3$var$trapFocus = function(ev) {
    if (ev.key != 'Tab') return;
    let focusable_elements = $9da5ab8aba8aa3e3$var$getFocusableElements(this.node); // Get a fresh list everytime because new controls can be dinamically added to the dialog
    let first_focusable_element = focusable_elements[0];
    let last_focusable_element = focusable_elements[focusable_elements.length - 1];
    let current_focus = document.activeElement;
    if (ev.shiftKey) {
        if (current_focus == first_focusable_element) {
            ev.preventDefault(); // Prevent default action when we set the focus ourselves and let the system do its thing at all other times
            last_focusable_element.focus();
        }
    } else if (current_focus == last_focusable_element) {
        ev.preventDefault(); // Same here
        first_focusable_element.focus();
    }
};
const $9da5ab8aba8aa3e3$var$keyHandler = function(ev) {
    let is_key_expected = this.re_keys.test(ev.key);
    if (is_key_expected && this.callback) {
        let is_button = ev.target.nodeName == 'BUTTON' && ev.target.className != 'dialog'; // Ignore inputs on our "button" background of class "dialog"
        let is_enter = ev.key == 'Enter';
        if (is_enter) {
            ev.preventDefault(); // Prevent such actions from happening automatically
            if (is_button) $9da5ab8aba8aa3e3$var$clickHandler.call(this, ev);
            else this.callback.call(this, ev.key, ev.target);
        } else this.callback.call(this, ev.key, ev.target);
    }
};
const $9da5ab8aba8aa3e3$var$clickHandler = function(ev) {
    let el = ev.target;
    while(el && el !== this.node){
        const className = typeof el.className === 'string' ? el.className : '';
        const matches = className.match(this.re_clicks);
        if (matches && this.callback) {
            ev.preventDefault();
            this.callback.call(this, matches[1], el);
            return;
        }
        el = el.parentElement;
    }
};
const $9da5ab8aba8aa3e3$var$dialog = {
    id: null,
    node: null,
    re_keys: /./,
    re_clicks: /\bbn_([^\b\s]+)\b/,
    callback: null,
    last_focus: null,
    create (html, callback, re_keys, re_clicks) {
        let dialog = Object.create(this);
        dialog.id = Symbol();
        dialog.callback = callback;
        dialog.re_keys = re_keys || dialog.re_keys;
        dialog.re_clicks = re_clicks || dialog.re_clicks;
        dialog.last_focus = document.activeElement;
        dialog.node = $9da5ab8aba8aa3e3$var$createNode(html);
        $9da5ab8aba8aa3e3$var$getFocusableElements(dialog.node)[0]?.focus();
        $9da5ab8aba8aa3e3$var$captureEvents(dialog);
        $9da5ab8aba8aa3e3$var$DIALOGS.push(dialog);
        return dialog;
    },
    destroy () {
        // Blindagem: destroy duplo (ex. loading + notify) não pode remover outro dialog da pilha.
        try {
            if (this.node?.parentNode) this.node.parentNode.removeChild(this.node);
        } catch (_) {}
        let index = $9da5ab8aba8aa3e3$var$DIALOGS.findIndex((dialog)=>dialog.id == this.id);
        if (index < 0) return;
        if (index == $9da5ab8aba8aa3e3$var$DIALOGS.length - 1) this.last_focus?.focus?.();
        else $9da5ab8aba8aa3e3$var$DIALOGS[index + 1].last_focus = this.last_focus; // The next dialog in the chain points to the removed link's previous focus
        $9da5ab8aba8aa3e3$var$DIALOGS.splice(index, 1);
    },
    getNode () {
        return this.node;
    }
};
var $9da5ab8aba8aa3e3$export$2e2bcd8739ae039 = $9da5ab8aba8aa3e3$var$dialog;

});


parcelRegister("1uSXl", function(module, exports) {

$parcel$export(module.exports, "FIRST_ERROR", () => $117338eb3d66ea8c$export$f425698f5b896fd3);
$parcel$export(module.exports, "default", () => $117338eb3d66ea8c$export$2e2bcd8739ae039);

var $8gtbe = parcelRequire("8gtbe");
const $117338eb3d66ea8c$export$4a9440f82554b73e = 1; // setCursor() modes
const $117338eb3d66ea8c$export$de3ea91c1714c800 = 2;
const $117338eb3d66ea8c$export$ca00103691ff06e4 = 3;
const $117338eb3d66ea8c$export$f425698f5b896fd3 = 4;
const $117338eb3d66ea8c$var$setCursorHelper = function(field, where) {
    let node1 = field.queryNode ? field.queryNode() : document.querySelector(field.selector);
    let is_element_on_screen = node1 != null;
    if (!is_element_on_screen) return;
    let is_element_disabled = node1.hasAttribute('disabled');
    if (is_element_disabled) return;
    let is_element_hidden = node1.type == 'hidden';
    if (is_element_hidden) return;
    let is_multiple = node1.type && node1.type.match(/checkbox|radio/i);
    let is_mult_compatible = where == $117338eb3d66ea8c$export$4a9440f82554b73e || where == $117338eb3d66ea8c$export$f425698f5b896fd3;
    if (is_multiple && !is_mult_compatible) return;
    let is_not_input = node1.nodeName.match(/select|button/i);
    let is_text_compatible = where != $117338eb3d66ea8c$export$de3ea91c1714c800;
    if (is_not_input && !is_text_compatible) return;
    let is_error_requested = where == $117338eb3d66ea8c$export$f425698f5b896fd3;
    let is_error_flagged = field.getErrorState();
    if (is_error_requested && !is_error_flagged) return;
    let is_empty_requested = where === $117338eb3d66ea8c$export$ca00103691ff06e4;
    let is_value_empty = node1.value && node1.value.length == 0;
    if (is_empty_requested && !is_value_empty) return;
    if (node1.focus) node1.focus();
    if (node1.select) node1.select();
    return true;
};
const $117338eb3d66ea8c$var$forEachField = function(form, callback, field_criteria = {}) {
    let field_ids = Object.keys(form.fields);
    let first_index = field_criteria.initial_id ? field_ids.indexOf(field_criteria.initial_id) : 0;
    let last_index = field_ids.indexOf(field_criteria.final_id, first_index);
    if (last_index < 0) last_index = field_ids.length - 1;
    let skip_list = field_criteria.skip_list || [];
    for(let index = first_index; index <= last_index; index++){
        let in_skip_list = skip_list.indexOf(field_ids[index]) >= 0;
        if (in_skip_list) continue;
        let field_id = field_ids[index];
        let field = form.fields[field_id];
        let result = callback(field);
        if (result === true) break;
    }
};
const $117338eb3d66ea8c$export$2e2bcd8739ae039 = {
    selector: null,
    fields: null,
    callback: null,
    create (properties, fields, callback) {
        let form = Object.assign(Object.create(this), properties);
        form.fields = Object.create({});
        form.callback = callback;
        fields.forEach((entry)=>{
            form.insertOrUpdateField((0, $8gtbe.default).create(Object.assign(entry.properties, {
                form: form
            }), entry?.types));
        });
        return form;
    },
    insertOrUpdateField (field) {
        this.fields[field.getId()] = field;
    },
    deleteField (id) {
        delete this.fields[id];
    },
    getFieldById (id) {
        return this.fields[id];
    },
    getFieldByName (name) {
        let ids = Object.keys(this.fields);
        let idOrUndefined = ids.find((id)=>id.split('.')[1] == name);
        return this.fields[idOrUndefined];
    },
    getFieldBySelector (selector) {
        let ids = Object.keys(this.fields);
        let regex = new RegExp(`(^|\\b|\\s)${selector}(\\s|\\b|$)`); // Matches the entire word in the beginning, middle or end of string
        let idOrUndefined = ids.find((id)=>regex.test(this.fields[id].selector));
        return this.fields[idOrUndefined];
    },
    replaceFieldId (old_id, new_id) {
        if (old_id != new_id && this.fields[old_id] && !this.fields[new_id]) {
            this.fields[new_id] = this.fields[old_id];
            delete this.fields[old_id];
        }
    },
    captureFormEvents () {
        document.querySelector(this.selector).addEventListener('submit', this.submit.bind(this));
    },
    releaseFormEvents () {
        node = document.querySelector(this.selector);
        node.replaceWith(node.cloneNode(true));
    },
    captureFieldEvents (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.captureEvents(), field_criteria);
    },
    releaseFieldEvents (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.releaseEvents(), field_criteria);
    },
    setTabOrder (index = 1, field_criteria) {
        const callback = (field)=>{
            let node1 = field.queryNode ? field.queryNode() : document.querySelector(field.selector);
            if (node1) node1.tabIndex = index++;
        };
        $117338eb3d66ea8c$var$forEachField(this, callback, ffield_criteria);
    },
    setCursor (where, initial_field_id) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>$117338eb3d66ea8c$var$setCursorHelper(field, where), {
            'initial_id': initial_field_id
        });
    },
    setReadOnly (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.setReadOnly(), field_criteria);
    },
    setReadWrite (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.setReadWrite(), field_criteria);
    },
    disableInputs (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.disableInput(), field_criteria);
    },
    enableInputs (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.enableInput(), field_criteria);
    },
    refresh (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.refresh(), field_criteria);
    },
    getValues () {
        let json = {};
        const callback = (field)=>{
            if (!field.isEmpty()) json[field.getName()] = field.getValue();
        };
        $117338eb3d66ea8c$var$forEachField(this, callback);
        return json;
    },
    setValues (values) {
        const callback = (field_id)=>{
            let key = Object.keys(this.fields).find((key)=>new RegExp(`\\.${field_id}$`).test(key));
            let field = this.fields[key];
            field?.setValue.call(field, values[field_id]); // Some setValues() are overloaded, so let them handle this
        };
        Object.keys(values).forEach((field_id)=>callback(field_id));
    },
    eraseValues (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.eraseValue(), field_criteria);
    },
    checkErrorStates (field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.checkErrorState(), field_criteria);
    },
    setErrorStates (state, field_criteria) {
        $117338eb3d66ea8c$var$forEachField(this, (field)=>field.setErrorState(state), field_criteria);
    },
    init () {
        this.captureFormEvents();
        this.captureFieldEvents();
        this.refresh();
    },
    /** Sincroniza valores do DOM para o armazenamento antes da validação (ex.: campo com foco ao clicar Salvar). Só para formulário #carrier. */ syncFromDom () {
        const callback = (field)=>{
            if (field.selector && typeof field.syncFromDom === 'function') field.syncFromDom();
        };
        $117338eb3d66ea8c$var$forEachField(this, callback);
    },
    check () {
        const callback = (field)=>{
            if (!field.isDisabled() && field.isEmpty() && field.isRequired() || !field.isEmpty() && !field.checkValue()) {
                field.setErrorState(true);
                throw new Error(`Verificar ${field.getLabel()}`);
            }
        };
        Object.keys(this.fields).forEach((id)=>callback(this.fields[id]));
    },
    error (message) {
        this.checkErrorStates();
        this.setCursor($117338eb3d66ea8c$export$f425698f5b896fd3);
        alert(message);
    },
    submit (ev) {
        try {
            //ev?.preventDefault();
            this.syncFromDom();
            this.check();
            this.callback?.(this.getValues());
        } catch (e) {
            this.error(e.message);
            console.log(e);
        }
    }
};

});
parcelRegister("8gtbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $604673ecc72d1005$export$2e2bcd8739ae039);

var $9PIz7 = parcelRequire("9PIz7");
/*--------------------------------------------------------------------------
 * Define valor inicial do campo caso haja um atributo "value" no HTML
 -------------------------------------------------------------------------*/ const $604673ecc72d1005$var$setDefaultValueIfNoInternalValue = function(field, nodes) {
    let has_internal_value = field.getValue() !== undefined;
    let has_default_value = nodes[0]?.hasAttribute('value');
    if (!has_internal_value && has_default_value) field.setValue(nodes[0].getAttribute('value'));
};
/*--------------------------------------------------------------------------
 * Para input com list (datalist): resolve node.value (pode ser label) para o value da option
 -------------------------------------------------------------------------*/ const $604673ecc72d1005$var$resolveDatalistValue = function(node, node_value) {
    if (!node?.list?.options?.length || node_value == null || node_value === '') return node_value;
    const trimmed = String(node_value).trim();
    const opts = Array.from(node.list.options);
    let byValue = opts.filter((opt)=>String(opt.value).trim() === trimmed);
    if (byValue.length === 1) return byValue[0].value;
    let byLabel = opts.filter((opt)=>opt.innerText && opt.innerText.trim() === trimmed);
    if (byLabel.length === 1) return byLabel[0].value;
    const norm = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const n = norm(trimmed);
    let byNorm = opts.filter((opt)=>opt.innerText && norm(opt.innerText) === n);
    if (byNorm.length === 1) return byNorm[0].value;
    let option = (0, $9PIz7.findOptionByDocumentDigits)(node.list.options, trimmed);
    return option ? option.value : node_value;
};
/*--------------------------------------------------------------------------
 * Só invoca setValue() se o valor no elemento foi alterado
 -------------------------------------------------------------------------*/ /** Raiz do formulário no DOM — evita resolver `#campo-N` fora do modal/form em uso. */ const $604673ecc72d1005$var$getFormRoot = function(field) {
    const form = field.form;
    if (form?.node?.isConnected) return form.node;
    if (form?.selector) {
        const root = document.querySelector(form.selector);
        if (root) form.node = root;
        return root;
    }
    return null;
};
const $604673ecc72d1005$var$queryNode = function(field) {
    if (!field?.selector) return null;
    const root = $604673ecc72d1005$var$getFormRoot(field);
    if (root) return root.querySelector(field.selector);
    return document.querySelector(field.selector);
};
const $604673ecc72d1005$var$queryNodes = function(field) {
    if (!field?.selector) return [];
    const root = $604673ecc72d1005$var$getFormRoot(field);
    if (root) return root.querySelectorAll(field.selector);
    return document.querySelectorAll(field.selector);
};
const $604673ecc72d1005$var$setValueIfChanged = function(field, node) {
    let field_value = field.format(field.getValue());
    let field_has_value = Boolean(field_value);
    let node_value = node.value;
    let node_has_value = Boolean(node_value.length);
    // Arquivo: o valor enviado à API fica no armazenamento interno (ex.: base64 via types.file).
    // node.value é só o nome fakepath do browser ou fica vazio — nunca sincronizar senão apaga XML e grava lixo.
    if (node?.type === 'file') return void field.checkErrorState();
    // Checkbox precisa sincronizar pelo estado checked (node.value é sempre "on")
    if (node?.type === 'checkbox') {
        node_value = node.checked ? 1 : 0;
        node_has_value = true;
    }
    // Em campo com datalist, o node mostra o label; manter/salvar o value (id) da option
    if (node.list) {
        node_value = $604673ecc72d1005$var$resolveDatalistValue(node, node_value) ?? node_value;
        // Se o input está vazio mas o campo já tem valor (id), opções podem ainda não ter carregado – não sobrescrever
        if (!node_has_value && field_has_value && (typeof field.getValue() === 'number' || typeof field.getValue() === 'string' && field.getValue().length > 0)) return void field.checkErrorState();
    }
    let is_update_needed = (field_has_value || node_has_value) && node_value != field_value;
    if (is_update_needed) {
        field.setValue(node_value);
        field.refresh();
    }
    field.checkErrorState(); // Clear error states also when the field is emptied
};
const $604673ecc72d1005$var$field = {
    /*--------------------------------------------------------------------------
	 * selector: seletor CSS do elemento na tela
	 * events: array de eventos DOM a capturar
	 * regex: expressão regular usada para validar e formatar o dado
	 * filter: expressão regular para remover caracteres antes da validação
	 * store_mask: máscara de formatação para armazenamento do dado
	 * display_mask: máscara de formatação para exibição do dado
	 -------------------------------------------------------------------------*/ selector: null,
    events: [
        'keydown',
        'change',
        'blur'
    ],
    regex: /^(.*)$/,
    filter: /[]/g,
    store_mask: '$1',
    display_mask: '$1',
    /*--------------------------------------------------------------------------
	 * Cria um clone de field com as propriedades e tipos especificados
	 * properties são aplicadas (assigned) diretamente no clone criado e
	 * types são novos objetos encadeados através de herança prototípica
	 -------------------------------------------------------------------------*/ create (properties, types) {
        let field = Object.assign(Object.create(this), properties);
        types?.forEach((type)=>{
            if (type) field = this.appendType.call(field, type);
            else console.error(properties, 'Undefined type');
        });
        return field;
    },
    /*--------------------------------------------------------------------------
	 * Retorna novo objeto encadeado com as propriedades do tipo especificado
	 -------------------------------------------------------------------------*/ appendType (type) {
        return Object.assign(Object.create(this), type);
    },
    /*--------------------------------------------------------------------------
	 * Remove os últimos objetos encadeados escalando os prototypes
	 -------------------------------------------------------------------------*/ scrapeTypes (count) {
        let proto, that = this;
        for(let i = 0; i < count; i++){
            proto = Object.getPrototypeOf(that);
            that = proto;
        }
        return that;
    },
    /*--------------------------------------------------------------------------
	 * Retorna um identificador baseado no form e no id/classe do elemento
	 -------------------------------------------------------------------------*/ getFormRoot () {
        return $604673ecc72d1005$var$getFormRoot(this);
    },
    queryNode () {
        return $604673ecc72d1005$var$queryNode(this);
    },
    queryNodes () {
        return $604673ecc72d1005$var$queryNodes(this);
    },
    getId () {
        if (!this.selector) return 'unknown.unknown';
        let node = $604673ecc72d1005$var$queryNode(this);
        if (!node) {
            const form_id = this.form?.selector?.replace(/^#/, '') || 'unknown';
            const node_id = this.selector.replace(/^#/, '') || 'unknown';
            return `${form_id}.${node_id}`;
        }
        let node_id = node?.id || node?.className;
        let form_id = node?.form?.getAttribute?.('id') || node?.form?.className || ''; // getAttribute required
        return `${form_id}.${node_id}`;
    },
    /*--------------------------------------------------------------------------
	 * Retorna o nome do campo com base no atributo "name"
	 -------------------------------------------------------------------------*/ getName () {
        let node = $604673ecc72d1005$var$queryNode(this);
        return node?.getAttribute('name') || node?.id || node?.className;
    },
    /*--------------------------------------------------------------------------
	 * Retorna o texto do label associado ao elemento
	 -------------------------------------------------------------------------*/ getLabel () {
        let node = $604673ecc72d1005$var$queryNode(this);
        return node?.labels?.[0]?.innerText.trim() || node?.className || node?.id;
    },
    /*--------------------------------------------------------------------------
	 * Retorna o valor armazenado do campo ou um valor default
	 -------------------------------------------------------------------------*/ getValue (default_value) {
        let value = sessionStorage.getItem(this.getId()); // Return null if key doesn't exist
        return value ?? default_value;
    },
    /*--------------------------------------------------------------------------
	 * Armazena um novo valor
	 -------------------------------------------------------------------------*/ setValue (value) {
        value = this.format(value, this.store_mask);
        sessionStorage.setItem(this.getId(), value);
    },
    /*--------------------------------------------------------------------------
	 * Apaga o valor armazenado na sessionStorage
	 -------------------------------------------------------------------------*/ eraseValue () {
        sessionStorage.removeItem(this.getId());
    },
    /*--------------------------------------------------------------------------
	 * Informa se o dado contido no campo é válido ou inválido
	 * Não deve testar outros estados (por exemplo, se está vazio ou não)
	 -------------------------------------------------------------------------*/ checkValue (value = this.getValue()) {
        return this.regex.test(String(value ?? '').replace(this.filter, ''));
    },
    /*--------------------------------------------------------------------------
	 * Formata dados válidos conforme a máscara de exibição
	 -------------------------------------------------------------------------*/ format (value = this.getValue(), mask = this.display_mask) {
        value = String(value ?? '');
        return this.checkValue(value) ? value.replace(this.filter, '').replace(this.regex, typeof mask == 'function' ? mask.bind(this) : mask) : value;
    },
    /*--------------------------------------------------------------------------
	 * Exibe o valor armazenado de forma formatada no elemento
	 -------------------------------------------------------------------------*/ refresh () {
        let node = $604673ecc72d1005$var$queryNode(this);
        if (!node) return;
        // input[type=file]: o valor só pode ser ''; o navegador não permite atribuir filename
        if (node.type === 'file') return;
        node.value = this.format();
    },
    /*--------------------------------------------------------------------------
	 * Define o estado de erro conforme se o campo:
	 * 	- Não estiver desabilitado
	 * 	- For requerido e estiver vazio
	 * 	- Estiver preenchido com um dado inválido
	 -------------------------------------------------------------------------*/ checkErrorState () {
        this.setErrorState(!this.isDisabled() && (this.isRequired() || !this.isEmpty()) && !this.checkValue());
    },
    /*--------------------------------------------------------------------------
	 * Liga ou desliga o flag de erro do campo
	 -------------------------------------------------------------------------*/ setErrorState (state) {
        let node = $604673ecc72d1005$var$queryNode(this);
        if (node && state) node.setAttribute('data-error', true);
        else if (node?.hasAttribute('data-error')) node.removeAttribute('data-error');
    },
    /*--------------------------------------------------------------------------
	 * Sincroniza o valor atual do elemento DOM para o armazenamento (sessionStorage).
	 * Deve ser chamado antes da validação ao submeter, para que o campo com foco seja considerado.
	 -------------------------------------------------------------------------*/ syncFromDom () {
        if (!this.selector) return;
        const node = $604673ecc72d1005$var$queryNode(this);
        if (node) $604673ecc72d1005$var$setValueIfChanged(this, node);
    },
    /*--------------------------------------------------------------------------
	 * Informa o estado do flag de erro do campo
	 -------------------------------------------------------------------------*/ getErrorState () {
        return $604673ecc72d1005$var$queryNode(this)?.hasAttribute('data-error') || false;
    },
    /*--------------------------------------------------------------------------
	 * Define o campo como readonly (não funciona para SELECT)
	 -------------------------------------------------------------------------*/ setReadOnly () {
        $604673ecc72d1005$var$queryNodes(this).forEach((node)=>{
            node.setAttribute('readonly', Number(node.getAttribute('readonly')) + 1);
        });
    },
    /*--------------------------------------------------------------------------
	 * Remove o atributo readonly do campo
	 -------------------------------------------------------------------------*/ setReadWrite () {
        $604673ecc72d1005$var$queryNodes(this).forEach((node)=>{
            let count = Number(node.getAttribute('readonly')) - 1;
            if (count > 0) node.setAttribute('readonly', count);
            else if (count == 0) node.removeAttribute('readonly');
        });
    },
    /*--------------------------------------------------------------------------
	 * Desabilita o campo para edição
	 -------------------------------------------------------------------------*/ disableInput () {
        $604673ecc72d1005$var$queryNodes(this).forEach((node)=>{
            node.setAttribute('disabled', Number(node.getAttribute('disabled')) + 1);
        });
    },
    /*--------------------------------------------------------------------------
	 * Habilita o campo para edição
	 -------------------------------------------------------------------------*/ enableInput () {
        $604673ecc72d1005$var$queryNodes(this).forEach((node)=>{
            let count = Number(node.getAttribute('disabled')) - 1;
            if (count > 0) node.setAttribute('disabled', count);
            else if (count == 0) node.removeAttribute('disabled');
        });
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo está vazio
	 -------------------------------------------------------------------------*/ isEmpty (value = this.getValue()) {
        return value === undefined || value === null || value === ''; // MUST NOT use !value
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo é mandatório
	 -------------------------------------------------------------------------*/ isRequired () {
        return $604673ecc72d1005$var$queryNode(this)?.hasAttribute('required') || false;
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo é readonly
	 -------------------------------------------------------------------------*/ isReadOnly () {
        return $604673ecc72d1005$var$queryNode(this)?.hasAttribute('readonly') || false;
    },
    /*--------------------------------------------------------------------------
	 * Informa se o campo está desabilitado
	 -------------------------------------------------------------------------*/ isDisabled () {
        return $604673ecc72d1005$var$queryNode(this)?.hasAttribute('disabled') || false;
    },
    /*--------------------------------------------------------------------------
	 * Inicializa o valor e inicia a monitoração do campo
	 -------------------------------------------------------------------------*/ captureEvents () {
        let nodes = $604673ecc72d1005$var$queryNodes(this);
        $604673ecc72d1005$var$setDefaultValueIfNoInternalValue(this, nodes);
        nodes.forEach((node)=>{
            this.events.forEach((event)=>{
                node.addEventListener(event, this.handleEvents.bind(this));
            });
        });
    },
    /*--------------------------------------------------------------------------
	 * Cria um clone do nó desassociando todos os eventos previamente capturados
	 * removeEventListener() não funciona por conta do bind() na captura
	 -------------------------------------------------------------------------*/ releaseEvents () {
        $604673ecc72d1005$var$queryNodes(this).forEach((node)=>{
            node.replaceWith(node.cloneNode(true));
        });
    },
    /*--------------------------------------------------------------------------
	 * Trata os eventos capturados
	 * Esta rotina padrão armazena o valor interno quando o elemento é alterado
	 -------------------------------------------------------------------------*/ handleEvents (ev) {
        switch(ev.type){
            case 'keydown':
                if (ev.key == 'Enter') $604673ecc72d1005$var$setValueIfChanged(this, ev.target);
                break;
            case 'blur':
            case 'change':
                $604673ecc72d1005$var$setValueIfChanged(this, ev.target);
                break;
            default:
                this.setValue(ev.target.value).refresh();
        }
    },
    /*--------------------------------------------------------------------------
	 * Invoca a função de mesmo nome no protótipo do objeto
	 *
	 * O exemplo abaixo invocará getValue() no protótipo do objeto que invocou 
	 * safeProtoCall():
	 *
	 * 		getValue(_this = this)
	 * 		{
	 * 			this.safeProtoCall(_this);
	 * 		}
	 *
	 * Isso permite que múltiplos tipos possam ser encadeados a um field:
	 *
	 * field  company_id  pubsub  datalist
	 * +---+  +--------+  +----+  +------+
	 * |   |--|        |--|    |--|      |
	 * +---+  +--------+  +----+  +------+
	 *            ^                   ^
	 *           this               _this		(exemplo)
	 *
	 * Cada tipo é um objeto encadeado no anterior com seus próprios métodos,
	 * mas que podem invocar métodos cadeia acima.
	 * 
	 * "this" não deve ser manipulado com call, apply, bind, pois senão não
	 * é mais possível identificar o protótipo do objeto em questão.
	 *
	 * "_this" deve ser passado como último argumento à função e deve apontar 
	 * para o último objeto da cadeia (o objeto completamente tipificado).
	 *
	 * Quando a chamada chega à raiz da cadeia, ou seja, a "field", 
	 * safeProtoCall() invoca o protótipo com "this" apontando para "_this", 
	 * de forma que as ações de field sejam aplicadas sobre o objeto no final 
	 * da cadeia. Para ser capaz de fazer essa transição, safeProtoCall() 
	 * precisa estar sempre no objeto logo acima de field (obviamente pode 
	 * estar adicionalmente em outras posições).
	 *
	 * Para identificar se chegamos à raiz, estamos testando se o objeto tem
	 * uma função própria chamada "safeProtoCall". Portanto, estamos assumindo
	 * que esta função não será overloaded em outros pontos da cadeia.
	 -------------------------------------------------------------------------*/ safeProtoCall (...args) {
        let proto, that = this;
        let caller = this.getCaller();
        while(true){
            proto = Object.getPrototypeOf(that);
            if (proto[caller] != this[caller]) break;
            that = proto;
        }
        let at_root = Object.hasOwn(Object.getPrototypeOf(proto), 'safeProtoCall');
        return proto[caller].call(at_root ? args.pop() : proto, ...args);
    },
    /*--------------------------------------------------------------------------
	 * Identifica a função está chamando safeProtoCall()
	 * Usa uma funcionalidade não-standard dos navegadores para obter a stack 
	 * trace. A resposta varia conforme o navegador.
	 -------------------------------------------------------------------------*/ getCaller () {
        let stack = new Error().stack.split('\n');
        if (navigator.userAgent.includes('Chrome')) return stack[3].match(/\.(\w+)\b/)[1];
        else if (navigator.userAgent.includes('Firefox')) return stack[2].match(/^(\w+)@/)[1];
        else throw new Error(`Unexpected User Agent: ${navigator.userAgent}`);
    }
};
var $604673ecc72d1005$export$2e2bcd8739ae039 = $604673ecc72d1005$var$field;

});
parcelRegister("9PIz7", function(module, exports) {

$parcel$export(module.exports, "findOptionByDocumentDigits", () => $728b723a7139bbbf$export$ae4fc2b2a4e85a2a);
$parcel$export(module.exports, "default", () => $728b723a7139bbbf$export$2e2bcd8739ae039);
const $728b723a7139bbbf$var$findOption = function(node, value) {
    const opts = Array.from(node?.list?.options ?? []);
    if (!opts.length) return undefined;
    const v = String(value ?? '').trim();
    let matches = opts.filter((option)=>String(option.value).trim() === v || option.value == value);
    if (matches.length === 1) return matches[0];
    if (matches.length > 1) return undefined; // ids duplicados entre empresas — nunca pegar o 1º
    // wh:loc — mesmo par com string ligeiramente diferente ou option.value sem trim
    if (/^\d+:\d+$/.test(v)) {
        const a = Number(v.split(':')[0]);
        const b = Number(v.split(':')[1]);
        matches = opts.filter((option)=>{
            const p = String(option.value ?? '').trim();
            const m = /^(\d+):(\d+)$/.exec(p);
            return m && Number(m[1]) === a && Number(m[2]) === b;
        });
        if (matches.length === 1) return matches[0];
    }
    // company_id:id (filtro multi-empresa)
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:\d+$/i.test(v)) {
        matches = opts.filter((option)=>String(option.value).trim().toLowerCase() === v.toLowerCase());
        if (matches.length === 1) return matches[0];
    }
    return undefined;
};
const $728b723a7139bbbf$var$normalizeForMatch = function(str) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
};
const $728b723a7139bbbf$export$3360a57ef2ab91fb = function(str) {
    return String(str || '').replace(/\D/g, '');
};
const $728b723a7139bbbf$var$listOptions = function(options) {
    return Array.from(options ?? []);
};
/** Matches de documento (11/14 dígitos). Preferência: dígitos do rótulo iguais ao digitado; senão includes. */ const $728b723a7139bbbf$var$documentDigitMatches = function(options, rawTyped) {
    const d = $728b723a7139bbbf$export$3360a57ef2ab91fb(String(rawTyped || '').trim());
    if (d.length !== 11 && d.length !== 14) return [];
    const opts = $728b723a7139bbbf$var$listOptions(options);
    const exact = opts.filter((o)=>$728b723a7139bbbf$export$3360a57ef2ab91fb(o.innerText || '') === d);
    if (exact.length) return exact;
    return opts.filter((o)=>$728b723a7139bbbf$export$3360a57ef2ab91fb(o.innerText || '').includes(d));
};
const $728b723a7139bbbf$var$partialDocumentDigitMatches = function(options, rawTyped, minLen = 8) {
    const d = $728b723a7139bbbf$export$3360a57ef2ab91fb(String(rawTyped || '').trim());
    if (d.length < minLen || d.length === 11 || d.length === 14) return [];
    return $728b723a7139bbbf$var$listOptions(options).filter((o)=>$728b723a7139bbbf$export$3360a57ef2ab91fb(o.innerText || '').includes(d));
};
const $728b723a7139bbbf$export$ae4fc2b2a4e85a2a = function(options, rawTyped) {
    const matches = $728b723a7139bbbf$var$documentDigitMatches(options, rawTyped);
    return matches.length === 1 ? matches[0] : undefined;
};
const $728b723a7139bbbf$export$97a9e8f2a0bc972f = function(options, rawTyped, minLen = 8) {
    const matches = $728b723a7139bbbf$var$partialDocumentDigitMatches(options, rawTyped, minLen);
    return matches.length === 1 ? matches[0] : undefined;
};
const $728b723a7139bbbf$var$labelExactMatches = function(options, typed) {
    const t = String(typed || '').trim();
    if (!t) return [];
    return $728b723a7139bbbf$var$listOptions(options).filter((o)=>o.innerText && o.innerText.trim() === t);
};
const $728b723a7139bbbf$var$labelNormalizedExactMatches = function(options, typed) {
    const nTyped = $728b723a7139bbbf$var$normalizeForMatch(typed);
    if (!nTyped) return [];
    return $728b723a7139bbbf$var$listOptions(options).filter((o)=>o.innerText && $728b723a7139bbbf$var$normalizeForMatch(o.innerText) === nTyped);
};
const $728b723a7139bbbf$var$labelPrefixMatches = function(options, typed, caseSensitive) {
    if (caseSensitive) {
        const t = String(typed).trim();
        return $728b723a7139bbbf$var$listOptions(options).filter((o)=>o.innerText && String(o.innerText).startsWith(t));
    }
    const nTyped = $728b723a7139bbbf$var$normalizeForMatch(typed);
    if (!nTyped) return [];
    return $728b723a7139bbbf$var$listOptions(options).filter((o)=>o.innerText && $728b723a7139bbbf$var$normalizeForMatch(o.innerText).startsWith(nTyped));
};
const $728b723a7139bbbf$var$labelIncludesMatches = function(options, typed, caseSensitive) {
    if (caseSensitive) {
        const t = String(typed).trim();
        return $728b723a7139bbbf$var$listOptions(options).filter((o)=>o.innerText && String(o.innerText).includes(t));
    }
    const nTyped = $728b723a7139bbbf$var$normalizeForMatch(typed);
    if (!nTyped) return [];
    return $728b723a7139bbbf$var$listOptions(options).filter((o)=>o.innerText && $728b723a7139bbbf$var$normalizeForMatch(o.innerText).includes(nTyped));
};
const $728b723a7139bbbf$var$isValidId = function(val) {
    if (val == null || val === '' || val === -1 || val === '-1') return false;
    const n = Number(val);
    return !isNaN(n) && n >= 0;
};
/** Valor composto `warehouse_id:location_id` (saídas multi-armazém — obs_load_options `compositeWhLoc`). */ const $728b723a7139bbbf$var$isCompositeWhLocValue = function(val) {
    return /^\d+:\d+$/.test(String(val ?? '').trim());
};
/** `company_uuid:entity_id` — evita colisão de id entre empresas no datalist do filtro. */ const $728b723a7139bbbf$var$isCompanyEntityKey = function(val) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:\d+$/i.test(String(val ?? '').trim());
};
/**
 * Desempate: preferred → único → (caseSensitive) menor rótulo inequívoco → undefined.
 * Não pega o “1º da lista” em homônimos do mesmo tamanho (ex.: mesmo nick de filial).
 */ const $728b723a7139bbbf$var$disambiguateByPreferred = function(candidates, preferredValue, caseSensitive = false) {
    if (!candidates?.length) return undefined;
    if (candidates.length === 1) return candidates[0];
    if ($728b723a7139bbbf$var$isValidId(preferredValue) || $728b723a7139bbbf$var$isCompositeWhLocValue(preferredValue) || $728b723a7139bbbf$var$isCompanyEntityKey(preferredValue)) {
        const pref = candidates.find((o)=>String(o.value) === String(preferredValue));
        if (pref) return pref;
    }
    // Case-sensitive (posições): entre vários prefixos (S-1, S-10), o menor rótulo único vence.
    if (caseSensitive) {
        const sorted = [
            ...candidates
        ].sort((a, b)=>String(a.innerText || '').length - String(b.innerText || '').length || String(a.value).localeCompare(String(b.value)));
        const shortestLen = String(sorted[0].innerText || '').length;
        const sameLen = sorted.filter((o)=>String(o.innerText || '').length === shortestLen);
        if (sameLen.length === 1) return sameLen[0];
    }
    return undefined;
};
/**
 * Resolve texto digitado → option.
 * Ordem: id → rótulo exato → rótulo normalizado → CNPJ/CPF completo (único) →
 * prefixo → includes → CNPJ parcial.
 * Homônimos sem preferred → undefined (exceto caseSensitive com menor rótulo único).
 */ const $728b723a7139bbbf$var$resolveOptionFromTyped = function(options, rawTyped, preferredValue, caseSensitive = false) {
    const typed = String(rawTyped || '').trim();
    if (!typed.length) return undefined;
    const byValue = $728b723a7139bbbf$var$listOptions(options).filter((o)=>String(o.value) === typed || o.value == typed);
    const fromValue = $728b723a7139bbbf$var$disambiguateByPreferred(byValue, preferredValue, caseSensitive);
    if (fromValue) return fromValue;
    const fromLabelExact = $728b723a7139bbbf$var$disambiguateByPreferred($728b723a7139bbbf$var$labelExactMatches(options, typed), preferredValue, caseSensitive);
    if (fromLabelExact) return fromLabelExact;
    if (!caseSensitive) {
        const fromNorm = $728b723a7139bbbf$var$disambiguateByPreferred($728b723a7139bbbf$var$labelNormalizedExactMatches(options, typed), preferredValue, caseSensitive);
        if (fromNorm) return fromNorm;
    }
    const fromDoc = $728b723a7139bbbf$var$disambiguateByPreferred($728b723a7139bbbf$var$documentDigitMatches(options, typed), preferredValue, caseSensitive);
    if (fromDoc) return fromDoc;
    const fromPrefix = $728b723a7139bbbf$var$disambiguateByPreferred($728b723a7139bbbf$var$labelPrefixMatches(options, typed, caseSensitive), preferredValue, caseSensitive);
    if (fromPrefix) return fromPrefix;
    const fromIncludes = $728b723a7139bbbf$var$disambiguateByPreferred($728b723a7139bbbf$var$labelIncludesMatches(options, typed, caseSensitive), preferredValue, caseSensitive);
    if (fromIncludes) return fromIncludes;
    return $728b723a7139bbbf$var$disambiguateByPreferred($728b723a7139bbbf$var$partialDocumentDigitMatches(options, typed), preferredValue, caseSensitive);
};
const $728b723a7139bbbf$var$setOption = function(node, callback) {
    let options = Array.from(node?.list?.options ?? []);
    let option = options.find(callback);
    // -2: invalid, -1: empty. Opcional + sem match: se lista vazia (ex: produto sem estoque), manter texto digitado (-2); senão tratar como vazio (-1)
    let new_value = option?.value ?? (node.value.length ? this.isRequired() ? -2 : options.length === 0 ? -2 : -1 : -1);
    let old_value = this.getValue() ?? -1;
    // Input vazio e campo tem id: só preservar se opções ainda não carregaram (não há option para old_value). Se há option, usuário pode ter limpado de propósito.
    if (new_value === -1 && !node.value.length && ($728b723a7139bbbf$var$isValidId(old_value) || $728b723a7139bbbf$var$isCompositeWhLocValue(old_value) || $728b723a7139bbbf$var$isCompanyEntityKey(old_value)) && !$728b723a7139bbbf$var$findOption(node, old_value)) return void this.refresh();
    if (new_value != old_value) {
        this.setValue(new_value);
        this.checkErrorState();
    }
    this.refresh(); // Must be out here or it won't show properly when you clear the field and retype the old value
};
function $728b723a7139bbbf$export$2e2bcd8739ae039(...args) {
    const caseSensitive = args[0]?.caseSensitive === true;
    return {
        _caseSensitive: caseSensitive,
        events: [
            'input',
            'blur'
        ],
        checkValue (value = this.getValue()) {
            let node = document.querySelector(this.selector);
            if ($728b723a7139bbbf$var$findOption(node, value)) return true;
            // Campo opcional com id numérico válido: aceitar mesmo sem opção (ex.: lista ainda não carregou)
            if (!this.isRequired() && $728b723a7139bbbf$var$isValidId(value)) return true;
            // `warehouse_id:location_id` (datalist de posições na saída): válido antes da lista IndexedDB terminar de popular
            if ($728b723a7139bbbf$var$isCompositeWhLocValue(value)) return true;
            if ($728b723a7139bbbf$var$isCompanyEntityKey(value)) return true;
            // Campo opcional com valor inválido (-2): tratar como vazio para permitir avançar (usuário digitou algo que não está na lista)
            if (!this.isRequired() && (value == -2 || value == '-2')) return true;
            return false;
        },
        isEmpty (value = this.getValue()) {
            // Não usar !value: device_id 0 é válido; só null/undefined/''/-1 são vazios
            return value == null || value === '' || value == -1 || value === '-1';
        },
        refresh () {
            let node = document.querySelector(this.selector);
            if (!node || !node.list) return;
            let value = this.getValue();
            if (this.isEmpty(value)) {
                node.value = '';
                return;
            }
            let option = $728b723a7139bbbf$var$findOption(node, value);
            if (option) node.value = option.innerText;
            else if (value != -2) {
                // Opções ainda não carregaram: manter id (ou composto wh:loc / company:id) como fallback em vez de vazio
                const s = String(value ?? '').trim();
                const displayed = String(node.value ?? '').trim();
                if ($728b723a7139bbbf$var$isCompositeWhLocValue(s) || $728b723a7139bbbf$var$isCompanyEntityKey(s)) node.value = s;
                else if ($728b723a7139bbbf$var$isValidId(value)) node.value = String(value);
                else node.value = displayed;
            }
        },
        handleEvents (ev) {
            switch(ev.type){
                case 'input':
                    if (!ev.inputType || ev.inputType == 'insertReplacementText') {
                        const options = Array.from(ev.target?.list?.options ?? []);
                        const raw = String(ev.target.value).trim();
                        const prev = this.getValue();
                        const option = $728b723a7139bbbf$var$resolveOptionFromTyped(options, raw, prev, caseSensitive);
                        $728b723a7139bbbf$var$setOption.call(this, ev.target, (o)=>o === option);
                    }
                    break;
                case 'blur':
                    {
                        let node = document.querySelector(this.selector);
                        if (node.value != $728b723a7139bbbf$var$findOption(node, this.getValue())?.innerText) {
                            let options = Array.from(ev.target?.list?.options ?? []);
                            let resolved = $728b723a7139bbbf$var$resolveOptionFromTyped(options, ev.target.value, this.getValue(), caseSensitive);
                            $728b723a7139bbbf$var$setOption.call(this, ev.target, (option)=>option === resolved);
                        }
                        break;
                    }
            }
        }
    };
}

});



parcelRegister("b60a2", function(module, exports) {

$parcel$export(module.exports, "flatten", () => $814061363397c8d7$export$bffa455ba8c619a6);
$parcel$export(module.exports, "deepen", () => $814061363397c8d7$export$a6d6ddd317ec07a4);
$parcel$export(module.exports, "getTopIndex", () => $814061363397c8d7$export$5eff2b09abd87cc4);
$parcel$export(module.exports, "makeOptions", () => $814061363397c8d7$export$2c531902cb3b2ba);
$parcel$export(module.exports, "default", () => $814061363397c8d7$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
const $814061363397c8d7$var$REGEX = /(.+)-(\d+)/;
const $814061363397c8d7$export$bffa455ba8c619a6 = function(record, property) {
    let copy = {
        ...record
    };
    let is_array = Array.isArray(copy[property]);
    (is_array ? copy[property] : [
        copy[property]
    ]).forEach((entry, index)=>{
        Object.keys(entry || {}).forEach((key)=>{
            let new_key = is_array ? `${key}-${index}` : `${property}_${key}`;
            copy[new_key] = entry[key];
        });
    });
    delete copy[property];
    return copy;
};
const $814061363397c8d7$export$a6d6ddd317ec07a4 = function(record, property) {
    let copy = {
        ...record
    };
    Object.keys(copy).forEach((key)=>{
        let match = key.match($814061363397c8d7$var$REGEX);
        if (match) {
            let index = Number(match[2]);
            if (!copy[property]) copy[property] = [];
            if (!copy[property][index]) copy[property][index] = {};
            copy[property][index][match[1]] = copy[key];
            delete copy[key];
        }
    });
    if (copy[property]) copy[property] = copy[property].filter((entry)=>entry);
    return copy;
};
const $814061363397c8d7$export$5eff2b09abd87cc4 = function(record) {
    let index = -1;
    Object.keys(record || {}).forEach((key)=>{
        let match = key.match($814061363397c8d7$var$REGEX);
        if (match?.[2] > index) index = Number(match[2]);
    });
    return index;
};
/* 
 * Recebe um array de registros e monta um array de <option> com base em uma 
 * propriedade para o valor e uma ou mais propriedades para os rótulos da opção:
 *
 * <option value="array[value]">array[label]</option>
 *
 * Opcionalmente pode indicar que uma das opções receba o atributo "selected".
 *
 * Também permite que o rótulo seja uma combinação de mais de uma propriedade,
 * como CNPJ + Nome, por exemplo. Também pode indicar rótulos alternativos:
 * caso algum deles esteja undefined, o(s) seguinte(s) será(ão) adotado(s).
 *
 * No caso de uma dessas propriedades ser um array (SKU do produto), esse array
 * será concatenado antes de ser incluído como rótulo da opção. O separador dos
 * elementos do array também poderá ser especificado (default é '').
 *
 * Se add_empty = true, um <option> vazio com valor -1 será incluído no início
 * da lista.
 */ const $814061363397c8d7$export$2c531902cb3b2ba = function(array, value, labels, separator = '', selected = -1, add_empty = false) {
    const is_selected = function(index) {
        return index == selected ? ' selected' : '';
    };
    const format = function(value) {
        return Array.isArray(value) ? value.join(separator) : value;
    };
    let options = array.map((entry, index)=>`<option value="${entry[value]}"${is_selected(index)}>${labels.map((label)=>format(entry[label])).join(' ').trim()}</option>`).join('\n');
    return (add_empty ? '<option value="-1"></option>' : '') + options;
};
const $814061363397c8d7$export$2e2bcd8739ae039 = {
    edit (descriptor, callback, current_data, autorow = true) {
        let fs = (0, $h1m6J.default).create(descriptor, async (updated_data)=>{
            if (!callback || await callback(updated_data, current_data)) fs.destroy();
        });
        fs.init = (()=>{
            fs.form.eraseValues(); // Must come before init()
            Object.getPrototypeOf(fs).init.call(fs, autorow);
            let extra_row = autorow ? 1 : 0;
            if (fs.hasTables()) {
                fs.setTableHeight(fs.getTableSize());
                fs.appendRows(Math.max($814061363397c8d7$export$5eff2b09abd87cc4(current_data), fs.getTableSize() - 1 - extra_row) + extra_row);
            }
            if (current_data) {
                fs.form.setValues(current_data);
                fs.form.refresh();
                // Dispara 'change' só em company_id para carregar opções (Programa, Categoria, Classes, etc.) sem passar valores inválidos a outros observers
                const company_id = current_data.company_id;
                if (company_id != null && company_id !== '') {
                    const field = fs.form.getFieldBySelector('#company_id');
                    if (field && typeof field.publish === 'function') field.publish('change', field, company_id);
                    // Refresh da form após opções (Programa, Categoria, etc.) carregarem para exibir labels em vez de vazio
                    setTimeout(()=>fs.form.refresh(), 150);
                }
                // Dispara 'change' nos campos UF para carregar lista de municípios (obs_load_options cities)
                [
                    'billing_address_state',
                    'delivery_address_state',
                    'address_state'
                ].forEach((name)=>{
                    const val = current_data[name];
                    if (val != null && val !== '') {
                        const field = fs.form.getFieldBySelector(`#${name}`);
                        if (field && typeof field.publish === 'function') field.publish('change', field, val);
                    }
                });
                setTimeout(()=>{
                    fs.form.refresh();
                    // Chamar na instância (fs.form), não no descriptor: init grava hooks em fs.form
                    // (ex. _cdaLoadAddresses). descriptor.form.afterEditSetValues deixa this errado.
                    if (typeof fs.form.afterEditSetValues === 'function') fs.form.afterEditSetValues(fs, current_data);
                }, 300);
            } else fs.form.refresh();
        })();
        return fs;
    }
};

});
parcelRegister("h1m6J", function(module, exports) {

$parcel$export(module.exports, "loadOptions", () => $c643adc13e6018a8$export$cad72087bded938);
$parcel$export(module.exports, "default", () => $c643adc13e6018a8$export$2e2bcd8739ae039);

var $1uSXl = parcelRequire("1uSXl");

var $dZ5S0 = parcelRequire("dZ5S0");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");

var $b60a2 = parcelRequire("b60a2");

var $1cmSR = parcelRequire("1cmSR");

var $aGGTj = parcelRequire("aGGTj");
const $c643adc13e6018a8$var$listTablesFromIndexedFields = function(descriptor) {
    let tables = {};
    descriptor.fields.forEach((field)=>{
        let field_selector = field.properties.selector.match((0, $dZ5S0.REGEX));
        if (!field_selector || field_selector.length < 4) return;
        let row_selector = $c643adc13e6018a8$var$makeRowSelector(field_selector[0]);
        if (!tables[row_selector]) tables[row_selector] = {
            table: null,
            fields: []
        };
        if (tables[row_selector].fields.indexOf(field_selector[0]) == -1) tables[row_selector].fields.push(field_selector[0]);
    });
    return tables;
};
const $c643adc13e6018a8$var$makeRowSelector = function(index) {
    let dashes = index.match(/-/g).length;
    let letters = index.match(/[A-Z]/g);
    return '.' + 'sub'.repeat(dashes - 1) + 'row' + (letters ? '-' + letters.join('') : '');
};
const $c643adc13e6018a8$var$interceptCallbacks = function(formset) {
    formset._init = formset.form.init;
    formset._check = formset.form.check;
    formset._error = formset.form.error;
    formset._submit = formset.form.submit;
    formset.form.init = $c643adc13e6018a8$var$formInit.bind(formset);
    formset.form.check = $c643adc13e6018a8$var$formCheck.bind(formset);
    formset.form.error = $c643adc13e6018a8$var$formError.bind(formset);
    formset.form.submit = $c643adc13e6018a8$var$formSubmit.bind(formset);
};
const $c643adc13e6018a8$var$formInit = function(autorow = true) {
    const formRoot = this.dialog?.getNode?.()?.querySelector(this.form.selector) || document.querySelector(this.form.selector);
    if (formRoot) this.form.node = formRoot;
    if (autorow && formRoot) formRoot.addEventListener('change', $c643adc13e6018a8$var$autoRow.bind(this));
    Object.keys(this.tables).forEach((selector)=>{
        this.tables[selector].table = (0, $dZ5S0.default).create(this.form, selector);
    });
    this._init.call(this.form, this);
};
const $c643adc13e6018a8$var$autoRow = function(ev) {
    let root = this.dialog.getNode();
    let tables = Object.keys(this.tables);
    let table_selector;
    for(let node = ev.target; !table_selector && node != root; node = node.parentNode)table_selector = tables.find((table)=>table.substr(1) == node.className);
    let rows = root.querySelectorAll(table_selector);
    let in_last_row = rows[rows.length - 1]?.contains(ev.target);
    let is_checkbox = /checkbox|radio/.test(ev.target.getAttribute('type'));
    if (table_selector && in_last_row && !is_checkbox) this.appendRows(1, table_selector);
};
const $c643adc13e6018a8$var$formCheck = function() {
    this._check.call(this.form, this);
};
const $c643adc13e6018a8$var$formError = function(message) {
    this.form.setCursor((0, $1uSXl.FIRST_ERROR));
    (0, $jUNyh.notify)(message, 'Dados Incorretos');
};
const $c643adc13e6018a8$var$formSubmit = function(ev) {
    // Formulário com submitHandler próprio (ex.: Transportadores) não usa validação/getValues genéricos
    if (typeof this.form.submitHandler === 'function') {
        try {
            this.form.submitHandler(this, ev);
        } catch (e) {
            $c643adc13e6018a8$var$formError.call(this, e.message);
            console.log(e);
        } finally{
            if (document.querySelector(this.form.selector)) $c643adc13e6018a8$var$enableAllEmptyRows.call(this);
        }
        return;
    }
    try {
        ev?.preventDefault();
        $c643adc13e6018a8$var$disableAllEmptyRows.call(this, [
            '#filter',
            '#stocks-report-form'
        ].includes(this.form.selector));
        // Valores ficam em sessionStorage e só sincronizam do DOM em blur/change; sem isso, Salvar com foco no campo perde o dado (ex.: empenho, tipo recebimento).
        this.form.syncFromDom();
        $c643adc13e6018a8$var$formCheck.call(this);
        let data = this.form.getValues();
        this.callback?.call(this, data);
    } catch (e) {
        $c643adc13e6018a8$var$formError.call(this, e.message);
        console.log(e);
    } finally{
        if (document.querySelector(this.form.selector)) $c643adc13e6018a8$var$enableAllEmptyRows.call(this);
    }
};
const $c643adc13e6018a8$var$disableAllEmptyRows = function(allow_all_empty = false) {
    Object.keys(this.tables).forEach((selector)=>{
        $c643adc13e6018a8$var$disableEmptyRows(this.tables[selector], this.form, this.dialog.getNode().querySelectorAll(selector), allow_all_empty);
    });
};
const $c643adc13e6018a8$var$enableAllEmptyRows = function() {
    Object.keys(this.tables).forEach((selector)=>{
        $c643adc13e6018a8$var$enableEmptyRows(this.tables[selector], this.form, this.dialog.getNode().querySelectorAll(selector));
    });
};
const $c643adc13e6018a8$var$disableEmptyRows = function(table, form, rows, allow_all_empty) {
    let indices = [];
    rows.forEach((row, index)=>{
        if ($c643adc13e6018a8$var$isRowEmpty(table, form, index)) indices.push(index);
    });
    if (indices.length < rows.length || allow_all_empty) indices.forEach((index)=>$c643adc13e6018a8$var$disableRow(table, form, index));
};
const $c643adc13e6018a8$var$enableEmptyRows = function(table, form, rows) {
    rows.forEach((row, index)=>{
        if ($c643adc13e6018a8$var$isRowEmptyAndDisabled(table, form, index)) $c643adc13e6018a8$var$enableRow(table, form, index);
    });
};
const $c643adc13e6018a8$var$getEnabledRowsIndices = function(table, form, rows) {
    let indices = [];
    rows.forEach((row, index)=>{
        if (!$c643adc13e6018a8$var$isRowEmptyAndDisabled(table, form, index)) indices.push(index);
    });
    return indices;
};
const $c643adc13e6018a8$var$isRowEmpty = function(table, form, index) {
    return table.fields.every((selector)=>{
        const field = form.getFieldBySelector((0, $dZ5S0.replaceIndex)(selector, index));
        // Campo indexado ausente (ex.: id fora do padrão da grade) — não derruba o Salvar.
        return !field || field.isEmpty();
    });
};
const $c643adc13e6018a8$var$isRowEmptyAndDisabled = function(table, form, index) {
    return table.fields.every((selector)=>{
        let field = form.getFieldBySelector((0, $dZ5S0.replaceIndex)(selector, index));
        return !field || field.isEmpty() && field.isDisabled();
    });
};
const $c643adc13e6018a8$var$disableRow = function(table, form, index) {
    table.fields.forEach((selector)=>form.getFieldBySelector((0, $dZ5S0.replaceIndex)(selector, index))?.disableInput());
};
const $c643adc13e6018a8$var$enableRow = function(table, form, index) {
    table.fields.forEach((selector)=>form.getFieldBySelector((0, $dZ5S0.replaceIndex)(selector, index))?.enableInput());
};
const $c643adc13e6018a8$var$clearRow = function(table, form, index) {
    table.fields.forEach((selector)=>{
        let field = form.getFieldBySelector((0, $dZ5S0.replaceIndex)(selector, index));
        if (!field) return;
        field.eraseValue();
        field.setErrorState(false);
        field.refresh();
    });
};
const $c643adc13e6018a8$var$dialogHandler = function(key, source) {
    let table = source.getAttribute('data-table') || '.row';
    switch(key){
        case 'Invert':
            this.invertSelection(table);
            break;
        case 'Clear':
            this.clearSelectedRows(table);
            break;
        case 'ResetFilter':
            this.handler?.(key);
            break;
        case 'Insert':
            this.appendRows(1, table);
            break;
        case 'Remove':
            this.removeSelectedRows(table);
            break;
        case 'MoveUp':
            this.moveRows(-1, table);
            break;
        case 'MoveDn':
            this.moveRows(1, table);
            break;
        case 'Escape':
            this.dialog.destroy();
            break;
        case 'Enter':
            this.form.submit();
            break;
        default:
            this.handler?.call(this, key);
    }
};
const $c643adc13e6018a8$var$getCheckboxes = function(formset, table) {
    return formset.dialog.getNode().querySelectorAll((table ? `${table} ` : '') + 'INPUT[id^="checkbox-"]');
};
const $c643adc13e6018a8$var$collectSelectedIndices = function(formset, table) {
    let indices = [];
    $c643adc13e6018a8$var$getCheckboxes(formset, table).forEach((checkbox, index)=>{
        if (checkbox.checked) indices.push(index);
    });
    return indices;
};
const $c643adc13e6018a8$export$cad72087bded938 = function(selector, options, value, labels, separator, formSelector = null) {
    let node = formSelector ? document.querySelector(`${formSelector} ${selector}`) : document.querySelector(selector);
    if (!node) {
        console.log('Not found:', selector);
        return;
    }
    let list_name = node.getAttribute('list');
    let index = node.id.match((0, $dZ5S0.REGEX));
    if (index) {
        list_name = (0, $dZ5S0.replaceIndex)(list_name || `${index[1]}_list-0`, index[3]);
        node.setAttribute('list', list_name);
    }
    let datalist = document.getElementById(list_name);
    if (!datalist) {
        datalist = document.createElement('datalist');
        datalist.setAttribute('id', list_name);
        // Listas compartilhadas por linhas indexadas (ex.: operators/connectors)
        // não podem ser inseridas dentro da <tr>, senão são clonadas com IDs duplicados.
        const is_indexed_list = Boolean(list_name?.match((0, $dZ5S0.REGEX)));
        let parent_node = index && is_indexed_list ? node.parentNode : (0, $aGGTj.findByName)(node, 'form');
        parent_node.insertBefore(datalist, parent_node.firstChild);
    }
    let is_static_list = options.length && Object.keys(options[0]).every((key)=>[
            'value',
            'label'
        ].includes(key));
    if (is_static_list) datalist.innerHTML = (0, $b60a2.makeOptions)(options, 'value', [
        'label'
    ]);
    else datalist.innerHTML = (0, $b60a2.makeOptions)(options, value || 'id', labels, separator);
};
const $c643adc13e6018a8$export$2e2bcd8739ae039 = {
    tables: {},
    dialog: null,
    form: null,
    callback: null,
    handler: null,
    create (descriptor, callback, handler) {
        let formset = Object.create(this);
        formset.tables = $c643adc13e6018a8$var$listTablesFromIndexedFields(descriptor);
        formset.dialog = (0, $dx9qz.default).create(descriptor.html, $c643adc13e6018a8$var$dialogHandler.bind(formset));
        formset.form = (0, $1uSXl.default).create(descriptor.form, descriptor.fields, callback);
        formset.callback = callback;
        formset.handler = handler;
        $c643adc13e6018a8$var$interceptCallbacks(formset);
        return formset;
    },
    destroy () {
        this.dialog.destroy();
    },
    invertSelection (table = '.row') {
        $c643adc13e6018a8$var$getCheckboxes(this, table).forEach((checkbox)=>checkbox.click());
    },
    /** Índices das linhas com checkbox marcado (0-based na tabela). Usado por CRUDs (ex.: saídas). */ getSelectedIndices (table = '.row') {
        return $c643adc13e6018a8$var$collectSelectedIndices(this, table);
    },
    clearAllRows (table = '.row') {
        $c643adc13e6018a8$var$getCheckboxes(this, table).forEach((checkbox, index)=>$c643adc13e6018a8$var$clearRow(this.tables[table], this.form, index));
    },
    clearSelectedRows (table = '.row') {
        let indices = $c643adc13e6018a8$var$collectSelectedIndices(this, table);
        indices.forEach((index)=>$c643adc13e6018a8$var$clearRow(this.tables[table], this.form, index));
    },
    appendRows (count, table = '.row') {
        const slot = this.tables[table];
        if (!slot?.table) {
            console.error("formset.appendRows: tabela n\xe3o foi inicializada (prov\xe1vel falha em formInit).", table);
            return;
        }
        slot.table.appendRows(count);
    },
    removeRows (indices, table = '.row') {
        this.tables[table].table.removeRows(indices);
    },
    removeSelectedRows (table = '.row') {
        let indices = $c643adc13e6018a8$var$collectSelectedIndices(this, table);
        this.tables[table].table.removeRows(indices);
    },
    moveRows (count, table = '.row') {
        let indices = $c643adc13e6018a8$var$collectSelectedIndices(this, table);
        if (count > 0) indices.reverse(); // If moving down, start moving the bottom rows first
        indices.every((index)=>this.tables[table].table.moveRow(index, count));
    },
    getEnabledRowsIndices (table = '.row') {
        return $c643adc13e6018a8$var$getEnabledRowsIndices(this.tables[table], this.form, this.dialog.getNode().querySelectorAll(table));
    },
    hasTables () {
        return Object.keys(this.tables).length > 0;
    },
    getTableSize (table = '.row') {
        const root = this.dialog.getNode();
        const rows = root.querySelectorAll(table);
        const declared = rows[0]?.getAttribute('data-size');
        if (declared != null && declared !== '') {
            const n = parseInt(declared, 10);
            if (!Number.isNaN(n) && n > 0) return n;
        }
        // Sem data-size (ex.: modal #filter): contar linhas reais no DOM, não assumir 6.
        return rows.length || 1;
    },
    setTableHeight (rows, table = '.row') {
        let node = this.dialog.getNode().querySelector(`.form *:has(> table ${table})`);
        if (!node) return;
        // Grade padrão SIAL: altura via CSS (--sial-items-h); não sobrescrever com inline.
        if (node.classList.contains('sial-items-scroll')) {
            node.style.minHeight = '';
            node.style.maxHeight = '';
            node.style.height = '';
            node.style.overflowY = '';
            return;
        }
        node.style.minHeight = rows * 2.4 + 'rem';
        node.style.maxHeight = rows * 2.4 + 1.2 + 'rem';
    },
    async loadList (datalist, store, options) {
        let node = document.querySelector(`${this.form.selector} ${datalist}`);
        if (!node) return;
        let data = await (0, $1cmSR.default).list(store, options?.range, options?.index);
        if (store === 'warehouses' && data) data = data.filter((r)=>!(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1'));
        node.innerHTML = data ? (0, $b60a2.makeOptions)(data, options?.value ?? 'id', options?.labels ?? [
            'name'
        ], options?.separator) : '';
        this.form.refresh(); // Better to refresh after each load than have to await each individual load and then refresh once
    },
    init (autorow) {
        try {
            $c643adc13e6018a8$var$formInit.call(this, autorow);
        } catch (e) {
            console.error(e);
            const detail = e?.message || String(e);
            (0, $jUNyh.notify)(`${detail}\n\n` + 'Isso costuma indicar HTML e a lista fields fora de sincronia (id de coluna sem campo correspondente).', "Erro ao preparar o formul\xe1rio");
        }
    },
    submit () {
        this.form.submit();
    }
};

});
parcelRegister("dZ5S0", function(module, exports) {

$parcel$export(module.exports, "REGEX", () => $a2e5868bc3913d81$export$b38aa3fcbc4fc60a);
$parcel$export(module.exports, "replaceIndex", () => $a2e5868bc3913d81$export$77b8d1f921212127);
$parcel$export(module.exports, "default", () => $a2e5868bc3913d81$export$2e2bcd8739ae039);
const $a2e5868bc3913d81$export$b38aa3fcbc4fc60a = /([^-\s#.'"]+)((?:-[A-Z]?\d+)*-[A-Z]?)(\d+)/; // Matches "#(name)(-0)" or '.(name)(-A0-A0)' for example
/** Raiz do formulário no DOM — obrigatório para não misturar `.row` / campos indexados com outras tabelas na mesma página. */ /** Limpa valores visíveis após cloneNode(true); evita herdar Empresa/operador da linha 0. */ const $a2e5868bc3913d81$var$clearClonedRowDom = function(row) {
    row.querySelectorAll('input[type="text"], input:not([type])').forEach((el)=>{
        el.value = '';
    });
    row.querySelectorAll('input[type="checkbox"]').forEach((el)=>{
        el.checked = false;
    });
    row.querySelectorAll('button.parens').forEach((el)=>{
        el.value = '0';
    });
};
const $a2e5868bc3913d81$var$getFormRoot = function(form) {
    const root = document.querySelector(form.selector);
    if (!root) throw new Error(`Form root not found: ${form.selector}`);
    return root;
};
const $a2e5868bc3913d81$var$getColumns = function(form, selector) {
    let columns = [];
    const root = $a2e5868bc3913d81$var$getFormRoot(form);
    const firstRow = root.querySelector(selector);
    if (!firstRow) throw new Error(`No row ${selector} inside ${form.selector}`);
    firstRow.querySelectorAll('*').forEach((node)=>{
        let column = $a2e5868bc3913d81$var$getColumn(form, node);
        if (column) columns.push(column);
    });
    if (columns.length == 0) throw new Error(`No indexed columns in ${selector}`);
    return columns;
};
const $a2e5868bc3913d81$var$getColumn = function(form, node) {
    let id = $a2e5868bc3913d81$var$getId(node);
    if (!id) return;
    let parts = id.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a);
    if (!parts || parts.length < 4) return;
    let field = form.getFieldByName(parts[0]);
    // <datalist id="packagings-0"> (e similares) segue o índice da linha mas não é coluna em fields — só apoia o <input list="…">.
    if (!field && node.tagName === 'DATALIST') return;
    if (!field) throw new Error(`Campo \xab${parts[0]}\xbb aparece no HTML da tabela, mas n\xe3o est\xe1 declarado em fields do formul\xe1rio. ` + "Inclua a entrada em js/forms/\u2026 ou remova o id indexado do elemento.");
    return {
        'field': field
    };
};
const $a2e5868bc3913d81$var$getId = function(node) {
    return [
        node.id,
        node.className,
        node.name
    ].find((id)=>id && id.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a));
};
const $a2e5868bc3913d81$var$_appendRows = function(table, row_count, do_not_init) {
    const root = $a2e5868bc3913d81$var$getFormRoot(table.form);
    let rows = root.querySelectorAll(table.selector);
    let first_row = rows[0];
    let last_row = rows[rows.length - 1];
    for(let i = 0; i < row_count; i++){
        let cloned_row = first_row.cloneNode(true); // true: clone all descendants too
        $a2e5868bc3913d81$var$clearClonedRowDom(cloned_row);
        $a2e5868bc3913d81$var$incrementColumnsIndices(table, cloned_row);
        last_row = last_row.parentNode.insertBefore(cloned_row, last_row.nextSibling); // Update last_row for the next loop iteraction
        $a2e5868bc3913d81$var$insertFields(table, cloned_row, do_not_init);
    }
};
const $a2e5868bc3913d81$var$incrementColumnsIndices = function(table, cloned_row) {
    table.columns.forEach((column)=>{
        $a2e5868bc3913d81$var$incrementColumnIndices(table, cloned_row, column);
    });
};
const $a2e5868bc3913d81$var$incrementColumnIndices = function(table, cloned_row, column) {
    let new_node = $a2e5868bc3913d81$var$getColumnNode(cloned_row, column);
    let new_index = $a2e5868bc3913d81$var$addToIndex($a2e5868bc3913d81$var$getLastRowIndex(table, column), 1);
    $a2e5868bc3913d81$var$setIndex(new_node, new_index);
    if (new_node.nodeName == 'SELECT') new_node.selectedIndex = -1;
};
const $a2e5868bc3913d81$var$getColumnNode = function(row, column) {
    return $a2e5868bc3913d81$var$findElementIn(row, column.field.selector.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a)[1]); // "#form #field-0" --> "field"
};
const $a2e5868bc3913d81$var$findElementIn = function(node, selector) {
    return node.querySelector(`[id|="${selector}"],[class|="${selector}"],[name|="${selector}"],${selector}`); // Must match "field" and "field-0" but not "fields"
};
const $a2e5868bc3913d81$var$addToIndex = function(index_str, number) {
    if (!index_str) return;
    let new_index = String(Number(index_str) + number);
    let length = Math.max(new_index.length, index_str.length);
    return ('0000' + new_index).slice(-length);
};
const $a2e5868bc3913d81$var$getLastRowIndex = function(table, column) {
    const root = $a2e5868bc3913d81$var$getFormRoot(table.form);
    let last_row = Array.from(root.querySelectorAll(table.selector)).pop();
    let node = $a2e5868bc3913d81$var$getColumnNode(last_row, column);
    return $a2e5868bc3913d81$var$getIndex(node);
};
const $a2e5868bc3913d81$var$getIndex = function(node) {
    return $a2e5868bc3913d81$var$getId(node)?.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a)?.at(-1); // Rows may point to non-indexed datalists
};
const $a2e5868bc3913d81$var$setIndex = function(node, index) {
    [
        'id',
        'class',
        'name',
        'list'
    ].forEach((attr_name)=>{
        let attr_value = node.getAttribute(attr_name);
        let is_attr_indexed = Boolean(attr_value?.match($a2e5868bc3913d81$export$b38aa3fcbc4fc60a));
        if (is_attr_indexed) node.setAttribute(attr_name, $a2e5868bc3913d81$export$77b8d1f921212127(attr_value, index));
        if (is_attr_indexed && attr_name == 'list') node.parentNode.querySelector(`#${attr_value}`)?.setAttribute('id', $a2e5868bc3913d81$export$77b8d1f921212127(attr_value, index)); // Fix the <datalist> id, if present
    });
};
const $a2e5868bc3913d81$export$77b8d1f921212127 = function(string, index) {
    return string.replace($a2e5868bc3913d81$export$b38aa3fcbc4fc60a, '$1$2' + index);
};
const $a2e5868bc3913d81$var$insertFields = function(table, cloned_row, do_not_init) {
    table.columns.forEach((column)=>{
        $a2e5868bc3913d81$var$insertField(table, cloned_row, column, do_not_init);
    });
};
const $a2e5868bc3913d81$var$insertField = function(table, cloned_row, column, do_not_init) {
    let new_index = $a2e5868bc3913d81$var$getIndex($a2e5868bc3913d81$var$getColumnNode(cloned_row, column));
    let new_selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, new_index);
    let new_field = column.field.create({
        selector: new_selector,
        form: table.form
    });
    table.form.insertOrUpdateField(new_field);
    if (!do_not_init) {
        new_field.eraseValue();
        new_field.setErrorState(false);
        new_field.captureEvents();
        new_field.refresh();
    }
};
const $a2e5868bc3913d81$var$_removeRows = function(table, indices_to_remove) {
    const root = $a2e5868bc3913d81$var$getFormRoot(table.form);
    let rows = root.querySelectorAll(table.selector);
    let is_removing_all_rows = indices_to_remove.length == rows.length;
    if (is_removing_all_rows) indices_to_remove.pop(); // Always leave at least one row in the table
    $a2e5868bc3913d81$var$shiftRowsUp(table, rows, indices_to_remove); // Move values from rows below over rows-to-be-deleted, "compacting" the list
    $a2e5868bc3913d81$var$removeRowsAndFields(table, rows, indices_to_remove); // Remove excess rows listed in indices_to_remove after previous operation
};
const $a2e5868bc3913d81$var$shiftRowsUp = function(table, rows, indices_to_remove) {
    while(indices_to_remove.length){
        indices_to_remove.sort((a, b)=>a - b); // Sort in ascending order; List keeps changing and requires re-sorting;
        let to_index = indices_to_remove[0];
        let from_index = $a2e5868bc3913d81$var$findNextIndexNotRemoved(indices_to_remove, to_index, rows.length);
        let no_more_rows_to_move = from_index == rows.length;
        if (no_more_rows_to_move) break;
        $a2e5868bc3913d81$var$moveColumns(table, from_index, to_index);
        indices_to_remove.shift(); // Remove 'to' index from the list (refers to a regular row now)
        indices_to_remove.push(from_index); // Include 'from' index in the list (refers to a deleted row now)
    }
};
const $a2e5868bc3913d81$var$findNextIndexNotRemoved = function(indices, initial_index, row_count) {
    let current_index = initial_index, is_last_row, is_index_in_removed_list;
    do {
        current_index += 1;
        is_last_row = current_index == row_count;
        is_index_in_removed_list = indices.indexOf(current_index) != -1; // -1: not found
    }while (!is_last_row && is_index_in_removed_list);
    return current_index;
};
const $a2e5868bc3913d81$var$moveColumns = function(table, from_index, to_index) {
    table.columns.forEach((column)=>{
        $a2e5868bc3913d81$var$moveColumn(table, column, from_index, to_index);
    });
};
const $a2e5868bc3913d81$var$moveColumn = function(table, column, from_index, to_index) {
    let from_field_sel = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, from_index);
    let to_field_sel = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, to_index);
    let from_field = table.form.getFieldBySelector(from_field_sel);
    let to_field = table.form.getFieldBySelector(to_field_sel);
    if (!from_field || !to_field) return;
    let value = from_field.getValue();
    if (value) to_field.setValue(value);
    else to_field.eraseValue();
    to_field.refresh();
};
const $a2e5868bc3913d81$var$removeRowsAndFields = function(table, rows, indices_to_remove) {
    indices_to_remove.forEach((index)=>{
        table.columns.forEach((column)=>{
            let selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, index);
            let field = table.form.getFieldBySelector(selector);
            table.form.deleteField(field.getId());
        });
        rows[index]?.parentNode.removeChild(rows[index]); // Must be removed only AFTER the fields have been removed from the form
    });
};
const $a2e5868bc3913d81$var$_moveRow = function(table, from_index, count) {
    const root = $a2e5868bc3913d81$var$getFormRoot(table.form);
    let rows = root.querySelectorAll(table.selector);
    let to_index = from_index + count;
    if (to_index < 0 || to_index >= rows.length) return false;
    let is_moving_down = count > 0;
    let from_node = rows[from_index];
    let to_node = is_moving_down ? rows[to_index].nextSibling : rows[to_index];
    rows[0].parentNode.insertBefore(from_node, to_node);
    $a2e5868bc3913d81$var$renameColumnsAndFields(table, from_index, to_index, count);
    return true;
};
const $a2e5868bc3913d81$var$renameColumnsAndFields = function(table, from_index, to_index, count) {
    const root = $a2e5868bc3913d81$var$getFormRoot(table.form);
    let rows = root.querySelectorAll(table.selector);
    let first_index = from_index < to_index ? from_index : to_index;
    let last_index = from_index < to_index ? to_index : from_index;
    for(let i = first_index; i <= last_index; i++)table.columns.forEach((column)=>{
        let node = $a2e5868bc3913d81$var$getColumnNode(rows[i], column);
        let old_index = $a2e5868bc3913d81$var$getIndex(node);
        let new_index = $a2e5868bc3913d81$var$addToIndex(old_index, i == to_index ? count : Math.sign(count) * -1);
        let old_selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, old_index);
        let new_selector = $a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, new_index);
        let field = table.form.getFieldBySelector(old_selector);
        let old_id = field.getId();
        $a2e5868bc3913d81$var$setIndex(node, new_index);
        field.selector = new_selector;
        let new_id = field.getId();
        table.form.replaceFieldId(old_id, new_id + '_tmp'); // Create a temp id to avoid collisions (field-3 -> field-1 and field-1 exists)
    });
    $a2e5868bc3913d81$var$renameAndUpdate(table, rows, first_index, last_index);
};
const $a2e5868bc3913d81$var$renameAndUpdate = function(table, rows, first_index, last_index) {
    const root = $a2e5868bc3913d81$var$getFormRoot(table.form);
    for(let i = first_index; i <= last_index; i++)table.columns.forEach((column)=>{
        let index = $a2e5868bc3913d81$var$getIndex($a2e5868bc3913d81$var$getColumnNode(rows[i], column));
        let field = table.form.getFieldBySelector($a2e5868bc3913d81$export$77b8d1f921212127(column.field.selector, index));
        let id = field.getId();
        table.form.replaceFieldId(id + '_tmp', id);
        let node = root.querySelector(field.selector) ?? document.querySelector(field.selector);
        if (!node) return;
        //field.setValue(node.type.match(/checkbox/i) ? node.checked : node.value);
        node.dispatchEvent(new Event('change'));
        node.dispatchEvent(new Event('blur'));
    });
};
const $a2e5868bc3913d81$export$2e2bcd8739ae039 = {
    form: null,
    selector: null,
    columns: null,
    create (form, row_selector) {
        let table = Object.create(this);
        table.selector = row_selector;
        table.form = form;
        table.columns = $a2e5868bc3913d81$var$getColumns(form, row_selector);
        return table;
    },
    appendRows (count, do_not_init) {
        $a2e5868bc3913d81$var$_appendRows(this, count, do_not_init);
    },
    removeRows (indices) {
        $a2e5868bc3913d81$var$_removeRows(this, indices);
    },
    moveRow (index, count) {
        return $a2e5868bc3913d81$var$_moveRow(this, index, count);
    }
};

});

parcelRegister("1cmSR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0df8a9af55fc0513$export$2e2bcd8739ae039);
let $0df8a9af55fc0513$var$NAME = 'versa';
let $0df8a9af55fc0513$var$VERSION = 1;
let $0df8a9af55fc0513$var$STORES = '[{"store":"default","indices":["id"]}]';
// If the db stops working, clear the browser's "site data" in its settings
const $0df8a9af55fc0513$var$exec = function(action_type, store_name, index_number, argument, resolve, reject) {
    let stores = JSON.parse(sessionStorage.db_stores || $0df8a9af55fc0513$var$STORES);
    let version = sessionStorage.db_version || $0df8a9af55fc0513$var$VERSION;
    let request = indexedDB.open(sessionStorage.db_name || $0df8a9af55fc0513$var$NAME, version);
    request.onblocked = (ev)=>{
        alert("Recarregue a p\xe1gina para atualizar a aplica\xe7\xe3o");
    };
    request.onerror = (ev)=>{
        reject(ev.target.error);
    };
    request.onupgradeneeded = (ev)=>{
        let db = ev.target.result;
        stores.forEach((entry)=>{
            if (db.objectStoreNames.contains(entry.store)) return;
            let store = db.createObjectStore(entry.store, {
                keyPath: entry.keys[0]
            });
            entry.keys.forEach((key, index)=>{
                let name = `${entry.store}-${index + 1}`;
                if (!store.indexNames.contains(name)) store.createIndex(name, key);
            });
        });
    };
    request.onsuccess = (ev)=>{
        let db = ev.target.result;
        if (!db.objectStoreNames.contains(store_name)) {
            reject(new Error(`Object store "${store_name}" n\xe3o encontrado. Recarregue a p\xe1gina (F5) para atualizar o banco local.`));
            return;
        }
        let transaction = db.transaction(store_name, /GET|LIST/.test(action_type) ? 'readonly' : 'readwrite');
        let store = transaction.objectStore(store_name);
        let entry = stores.find((entry)=>entry.store == store_name);
        let index = store.index(`${store_name}-${index_number}`);
        let request;
        let list = [];
        try {
            switch(action_type){
                case 'CLEAR':
                    store.clear();
                    break;
                case 'PUT':
                    // Armazéns e posições: a API devolve só registros válidos; sem limpar o object store,
                    // chaves antigas (inativos / posições de armazéns inativos) permanecem e poluem filtros.
                    if (store_name === 'warehouses' || store_name === 'locations') store.clear();
                    (Array.isArray(argument) ? argument : []).forEach((entry)=>store.put(entry));
                    resolve();
                    break;
                case 'GET':
                    request = store.get(argument);
                    break;
                case 'DEL':
                    request = store.delete(argument);
                    break;
                case 'LIST':
                    request = (index || store).openCursor(argument);
                    break;
            }
        } catch (e) {
            reject(`${action_type} ${store_name} ${JSON.stringify(argument)} ${e.message}`);
            console.log(e);
        }
        if (request) request.onsuccess = (ev)=>{
            if (action_type != 'LIST') resolve(ev.target.result);
            else if (ev.target.result) {
                list.push(ev.target.result.value);
                ev.target.result.continue();
            } else resolve(list);
        };
        db.onerror = (ev)=>{
            reject(ev.target.error);
        };
    };
};
const $0df8a9af55fc0513$var$db = {
    define (stores, name, version) {
        sessionStorage.db_name = name;
        sessionStorage.db_version = version;
        sessionStorage.db_stores = JSON.stringify(stores);
    },
    init () {
        indexedDB.deleteDatabase($0df8a9af55fc0513$var$NAME);
    },
    clear (store) {
        $0df8a9af55fc0513$var$exec('CLEAR', store, 1);
    },
    set (store, array) {
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('PUT', store, 1, array, resolve, reject);
        });
    },
    get (store, key, index = 2) {
        const invalid = key == null || Array.isArray(key) && key.some((v)=>v == null || typeof v === 'number' && isNaN(v));
        if (invalid) return Promise.resolve(undefined);
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('GET', store, index, key, resolve, reject);
        });
    },
    list (store, range, index = 2) {
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('LIST', store, index, range, resolve, reject);
        });
    },
    remove (store, key) {
        return new Promise(function(resolve, reject) {
            $0df8a9af55fc0513$var$exec('DEL', store, 1, key, resolve, reject);
        });
    }
};
var $0df8a9af55fc0513$export$2e2bcd8739ae039 = $0df8a9af55fc0513$var$db;

});

parcelRegister("aGGTj", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $7c7f18e63e55bfe1$export$9a00dee1beb8f576);
$parcel$export(module.exports, "removeEvents", () => $7c7f18e63e55bfe1$export$da5f6eb3bb522cd);
$parcel$export(module.exports, "findByName", () => $7c7f18e63e55bfe1$export$a41585d0ab8307d6);
$parcel$export(module.exports, "findByAttr", () => $7c7f18e63e55bfe1$export$92a42bc44568c07);
$parcel$export(module.exports, "splitIdsByCompany", () => $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a);
$parcel$export(module.exports, "stringify", () => $7c7f18e63e55bfe1$export$fac44ee5b035f737);
$parcel$export(module.exports, "parse", () => $7c7f18e63e55bfe1$export$98e6a39c04603d36);
$parcel$export(module.exports, "formatLotNumber", () => $7c7f18e63e55bfe1$export$d7959d098aba6524);
$parcel$export(module.exports, "resolvePrinterDeviceId", () => $7c7f18e63e55bfe1$export$53f785e280b721a6);
const $7c7f18e63e55bfe1$export$9a00dee1beb8f576 = function(text) {
    if (text?.toLowerCase) {
        text = text.toLowerCase();
        text = text.replace(/(?:^|[^a-záéíóúâêôãõàüç])[a-záéíóúâêôãõàüç]/g, (a)=>a.toUpperCase());
        text = text.replace(/(^\w{1,3}\d?(?:\s|$)|(?<=\(.*)\b\w{2,3}\b(?=.*\)))/gi, (a)=>/Av|Al|Rua|Rod|Via|Est/i.test(a) ? a : a.toUpperCase()); // Siglas
        text = text.replace(/(\s(?:e|de|da|do|das|dos)\s)/gi, (a)=>a.toLowerCase()); // Conectores
        text = text.replace(/(\s(?:S\/A|S\/C|ME|EPP|EIRELI)\b)/gi, (a)=>a.toUpperCase()); // Empresas
        text = text.replace(/(\b(?:BR|AC|AL|AM|AP|BA|CE|DF|ES|GO|MA|MT|MS|MG)(?=.\d))/gi, (a)=>a.toUpperCase()); // Rodovias
        text = text.replace(/(\b(?:PA|PB|PR|PE|PI|RN|RS|RJ|RO|RR|SC|SP|SE|TO)(?=.\d))/gi, (a)=>a.toUpperCase());
        text = text.replace(/(\b(?:I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|XIII|XIV)\b)/gi, (a)=>a.toUpperCase()); // Romanos
        text = text.replace(/(\b(?:XV|XVI|XVII|XVIII|XIX|XX|XXI|XXII|XXIII|XXIV|XXV)\b)/gi, (a)=>a.toUpperCase());
        text = text.replace(/(\d(?:ml|mcg|mg|g|kg|mm|cm|m|km)\b)/gi, (a)=>a.toLowerCase()); // Unidades
        text = text.replace(/(\d(?:l)\b)/gi, (a)=>a.toUpperCase()); // Unidades
        text = text.replace(/(\bPM\b)/gi, (a)=>a.toUpperCase()); // Diversos
    }
    return text;
};
const $7c7f18e63e55bfe1$export$2077e0241d6afd3c = function(number, places) {
    let scale = Math.pow(10, places); // 1, 10, 100, 1000 ...
    let scaled = number * scale; // 1.2359 * 100 = 123.59
    let trunc = Math.trunc(scaled); // 123.59 = 123
    let rest = scaled - trunc; // 123.59 - 123 = 0.59
    if (rest > 0) {
        let next_digit = Math.trunc(rest * 10); // 0.59 * 10 = 5.9 -> trunc(5.9) -> 5
        let zero_or_one = Math.floor(next_digit / 10 * 2); // 5 / 10 = 0.5 * 2 = 1 -> floor(1) -> 1
        trunc += zero_or_one; // 123 + 1 = 124
    }
    return trunc / scale; // 124 / 100 -> 1.24
};
const $7c7f18e63e55bfe1$export$da5f6eb3bb522cd = function(node) {
    let clone = node.cloneNode(true);
    node.replaceWith(clone);
    return clone;
};
const $7c7f18e63e55bfe1$export$a41585d0ab8307d6 = function(node, name) {
    for(; node && node.nodeName != '#document'; node = node.parentNode)if (node.nodeName == name.toUpperCase()) return node;
};
const $7c7f18e63e55bfe1$export$92a42bc44568c07 = function(node, attribute) {
    for(; node && node.nodeName != '#document'; node = node.parentNode)if (node.hasAttribute(attribute)) return node;
};
const $7c7f18e63e55bfe1$export$aa1a1894961eafab = function() {
    return Math.random().toString().slice(-4) + Date.now().toString().slice(-12);
};
const $7c7f18e63e55bfe1$export$30fb59293ffac91 = function() {
    return crypto.getRandomValues(new BigUint64Array(1))[0].toString(36);
};
const $7c7f18e63e55bfe1$export$4f5ed8ef3908e45a = function(ids) {
    let split = {};
    ids.forEach((id)=>{
        if (!split[id[0]]) split[id[0]] = [];
        split[id[0]].push(id[1]);
    });
    return split;
};
const $7c7f18e63e55bfe1$export$fac44ee5b035f737 = function(data) {
    return JSON.stringify(data).replaceAll('"', "'");
};
const $7c7f18e63e55bfe1$export$98e6a39c04603d36 = function(text) {
    let result;
    try {
        result = JSON.parse(text.replaceAll("'", '"'));
    } catch (e) {
        result = text;
    }
    return result;
};
/** Lote fabricante é texto (ex.: 746E4, 606E4). Não interpretar E/D como expoente. */ const $7c7f18e63e55bfe1$export$d7959d098aba6524 = function(val) {
    if (val == null || val === undefined) return '';
    if (typeof val === 'number') {
        if (!isFinite(val)) return '';
        if (Number.isInteger(val) || val === Math.trunc(val)) return String(Math.trunc(val));
        return String(val);
    }
    return String(val).trim();
};
/**
 * Resolve o id numérico da impressora para APIs de etiqueta.
 * O datalist exibe o nome (label) no input; o valor interno às vezes não sincroniza antes do submit.
 * raw: valor vindo do form.getValues(); inputSelector: ex. '#stocks-select-printer #device_id'
 */ const $7c7f18e63e55bfe1$export$53f785e280b721a6 = function(raw, inputSelector) {
    const toNum = (x)=>{
        const n = Number(x);
        return !isNaN(n) && n >= 0 ? n : null;
    };
    if (raw != null && raw !== '' && raw !== -1 && raw !== '-1') {
        const n = toNum(raw);
        if (n != null) return n;
    }
    const node = typeof inputSelector === 'string' ? document.querySelector(inputSelector) : inputSelector;
    if (!node?.list?.options?.length) return null;
    const trimmed = String(node.value ?? '').trim();
    if (!trimmed) return null;
    const options = Array.from(node.list.options);
    let opt = options.find((o)=>o.innerText && o.innerText.trim() === trimmed);
    if (!opt && /^\d+$/.test(trimmed)) opt = options.find((o)=>String(o.value) === trimmed);
    return opt ? toNum(opt.value) : null;
};

});



parcelRegister("93O8T", function(module, exports) {

$parcel$export(module.exports, "checkbox", () => (parcelRequire("5Aed9")).default);
$parcel$export(module.exports, "checklist", () => (parcelRequire("hubZT")).default);
$parcel$export(module.exports, "datalist", () => (parcelRequire("9PIz7")).default);
$parcel$export(module.exports, "file", () => (parcelRequire("84MPM")).default);
$parcel$export(module.exports, "number", () => (parcelRequire("3eqAU")).default);
$parcel$export(module.exports, "password", () => (parcelRequire("jdpN4")).default);
$parcel$export(module.exports, "pubsub", () => (parcelRequire("6Jl4s")).default);
$parcel$export(module.exports, "radio", () => (parcelRequire("YermW")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("3OKkn")).default);
$parcel$export(module.exports, "opt_operator", () => (parcelRequire("1fpKo")).default);
// Types

var $fY6pa = parcelRequire("fY6pa");

var $h3Uiq = parcelRequire("h3Uiq");

var $gBwx4 = parcelRequire("gBwx4");

var $e3m9R = parcelRequire("e3m9R");

var $9Wik7 = parcelRequire("9Wik7");

var $aYyoz = parcelRequire("aYyoz");

var $gbkt2 = parcelRequire("gbkt2");

var $5Aed9 = parcelRequire("5Aed9");

var $hubZT = parcelRequire("hubZT");

var $9PIz7 = parcelRequire("9PIz7");
parcelRequire("1589n");
var $b7D1Q = parcelRequire("b7D1Q");

var $8IFAz = parcelRequire("8IFAz");

var $lVBv9 = parcelRequire("lVBv9");

var $7aGwp = parcelRequire("7aGwp");

var $84MPM = parcelRequire("84MPM");

var $hlPFs = parcelRequire("hlPFs");

var $gF6P4 = parcelRequire("gF6P4");

var $4dbYJ = parcelRequire("4dbYJ");

var $2rQ6E = parcelRequire("2rQ6E");

var $fE2eE = parcelRequire("fE2eE");

var $4KjZQ = parcelRequire("4KjZQ");

var $74yTJ = parcelRequire("74yTJ");

var $bWgzi = parcelRequire("bWgzi");

var $91trW = parcelRequire("91trW");

var $l0p8O = parcelRequire("l0p8O");

var $5UO7m = parcelRequire("5UO7m");

var $3eqAU = parcelRequire("3eqAU");

var $jdpN4 = parcelRequire("jdpN4");

var $jHqD0 = parcelRequire("jHqD0");

var $6Jl4s = parcelRequire("6Jl4s");

var $YermW = parcelRequire("YermW");

var $3OKkn = parcelRequire("3OKkn");

var $knytZ = parcelRequire("knytZ");

var $bSPRN = parcelRequire("bSPRN");

var $6lTH5 = parcelRequire("6lTH5");

var $badq7 = parcelRequire("badq7");

var $dg8P2 = parcelRequire("dg8P2");

var $1Wvh7 = parcelRequire("1Wvh7");

var $lwpk7 = parcelRequire("lwpk7");

var $1fpKo = parcelRequire("1fpKo");

var $9SpSV = parcelRequire("9SpSV");

var $fyCkJ = parcelRequire("fyCkJ");

var $a5v7C = parcelRequire("a5v7C");

var $c7jhB = parcelRequire("c7jhB");

var $6R5fG = parcelRequire("6R5fG");

var $k93VN = parcelRequire("k93VN");

var $5rlmp = parcelRequire("5rlmp");

var $e4pb7 = parcelRequire("e4pb7");

var $3HbPC = parcelRequire("3HbPC");

});
parcelRegister("fY6pa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba016d80ddaca15b$export$2e2bcd8739ae039);

var $aGGTj = parcelRequire("aGGTj");
function $ba016d80ddaca15b$export$2e2bcd8739ae039(...args) {
    return {
        _separator: args[0] || ';',
        getValue (default_value, _this = this) {
            return (0, $aGGTj.parse)(this.safeProtoCall(default_value, _this))?.map((entry)=>entry.trim());
        },
        setValue (value, _this = this) {
            this.safeProtoCall((0, $aGGTj.stringify)(Array.isArray(value) ? value : value?.split(this._separator) || []), _this);
        },
        checkValue (value = this.getValue()) {
            return this.isEmpty() || value?.every((entry)=>Boolean(entry));
        },
        isEmpty (value = this.getValue()) {
            return !value || value.length == 1 && value[0] == '';
        },
        format (value = this.getValue(), mask = this.display_mask) {
            return Array.isArray(value) ? value.join(`${this._separator} `) : value || '';
        }
    };
}

});

parcelRegister("h3Uiq", function(module, exports) {
function $c6be62c04ec8b9fb$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'click'
        ],
        getValue (default_value = 0, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        isEmpty (value = this.getValue()) {
            return value == 0;
        },
        handleEvents (ev) {
            this.setValue(this.getValue() ^ 1);
            this.refresh();
        }
    };
}

});

parcelRegister("gBwx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1695650808e6a21$export$2e2bcd8739ae039);
parcelRequire("aGGTj");
function $c1695650808e6a21$export$2e2bcd8739ae039(...args) {
    return {
        setValue (value, _this = this) {
            if (value?.toUpperCase) value = value.toUpperCase();
            this.safeProtoCall(value, _this);
        }
    };
}

});

parcelRegister("e3m9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b288a4e8d304b7$export$2e2bcd8739ae039);
function $a3b288a4e8d304b7$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{5})(\d{3})$/,
        filter: /[\-]/g,
        store_mask: '$1$2',
        display_mask: '$1-$2'
    };
}

});

parcelRegister("9Wik7", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c7be81b506e1d3$export$2e2bcd8739ae039);
function $73c7be81b506e1d3$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{2})(\d{3})(\d{2})$/,
        filter: /[.]/g,
        store_mask: '$1$2$3',
        display_mask: '$1.$2.$3'
    };
}

});

parcelRegister("aYyoz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fda302dcbccda19$export$2e2bcd8739ae039);
function $7fda302dcbccda19$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        filter: /[./-]/g,
        store_mask: '$1$2$3$4$5',
        display_mask: '$1.$2.$3/$4-$5'
    };
}

});

parcelRegister("gbkt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7d8cd598cdbfe0$export$2e2bcd8739ae039);
function $bc7d8cd598cdbfe0$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        filter: /[-.]/g,
        store_mask: '$1$2$3$4',
        display_mask: '$1.$2.$3-$4'
    };
}

});

parcelRegister("5Aed9", function(module, exports) {

$parcel$export(module.exports, "default", () => $410b568e9a67c35a$export$2e2bcd8739ae039);
function $410b568e9a67c35a$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = document.querySelector(this.selector).hasAttribute('checked') ? 1 : 0, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        setValue (value, _this = this) {
            // '0' é string truthy em JS — não usar "value ? 1 : 0" (quebrava checkboxes com '0'/'1' do JSON/API).
            const on = value === true || value === 1 || value === '1';
            this.safeProtoCall(on ? 1 : 0, _this);
        },
        isEmpty (value = this.getValue()) {
            return value == 0;
        },
        refresh () {
            let node = document.querySelector(this.selector);
            if (node) node.checked = this.getValue() != 0;
        },
        handleEvents (ev) {
            this.setValue(ev.target.checked ? 1 : 0);
        }
    };
}

});

parcelRegister("hubZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbae8b6ef4bb77e6$export$2e2bcd8739ae039);
function $cbae8b6ef4bb77e6$export$2e2bcd8739ae039(...args) {
    /** Valores marcados no DOM (estado checked, não só o atributo HTML [checked]). */ const checkedValuesFromDom = (selector)=>Array.from(document.querySelectorAll(`${selector}:checked`)).map((node)=>node.value).join(',');
    return {
        events: [
            'change'
        ],
        getValue (default_value = checkedValuesFromDom(this.selector), _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        refresh () {
            let values = this.getValue().split(',').filter(Boolean);
            let nodes = document.querySelectorAll(this.selector);
            nodes.forEach((node)=>{
                node.checked = values.includes(node.value);
            });
        },
        /** Evita que syncFromDom() do field trate só o 1º checkbox e grave "0"/"1" no lugar da lista. */ syncFromDom () {
            const v = checkedValuesFromDom(this.selector);
            this.setValue(v);
        },
        handleEvents (ev) {
            let values = this.getValue().split(',').filter(Boolean);
            let index = values.findIndex((value)=>value == ev.target.value);
            if (index < 0) values.unshift(ev.target.value); // Add if not found
            else values.splice(index, 1); // Remove if found
            this.setValue(values.join(','));
        }
    };
}

});

parcelRegister("1589n", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("b7D1Q")).default);
/**
 * Data (sem horário) com calendário nativo — mesmo comportamento do filtro (input type=date).
 * Formulários: lote, gerenciador de estoque (Lote/datas/programa), conferência de entrada, etc.
 */ 
var $b7D1Q = parcelRequire("b7D1Q");

});
parcelRegister("b7D1Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $818e9f7a26e0ae4f$export$2e2bcd8739ae039);
/**
 * Tipo de valor para filtros: apenas data (sem horário), com calendário nativo (input type=date).
 */ function $818e9f7a26e0ae4f$var$pad2(n) {
    return String(n).padStart(2, '0');
}
function $818e9f7a26e0ae4f$var$toIsoDate(y, m, d) {
    return `${y}-${$818e9f7a26e0ae4f$var$pad2(m)}-${$818e9f7a26e0ae4f$var$pad2(d)}`;
}
function $818e9f7a26e0ae4f$export$2e2bcd8739ae039() {
    return {
        kind: 'date',
        regex: /^(?:(\d{4})-(\d{2})-(\d{2})(?:T[\d:.+-Z]*)?|(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}))$/,
        store_mask (_m, y, mo, d, dd, mm, yyyy) {
            return $818e9f7a26e0ae4f$var$toIsoDate(y ?? yyyy, mo ?? mm, d ?? dd);
        },
        display_mask (_m, y, mo, d, dd, mm, yyyy) {
            return $818e9f7a26e0ae4f$var$toIsoDate(y ?? yyyy, mo ?? mm, d ?? dd);
        },
        captureEvents (_this = this) {
            this.safeProtoCall(_this);
            const node = _this.queryNode();
            if (node) {
                node.type = 'date';
                node.removeAttribute('placeholder');
                if (!node.getAttribute('title')) node.setAttribute('title', 'Selecione a data');
            }
        },
        refresh () {
            this.safeProtoCall();
            const node = this.queryNode();
            if (!node) return;
            node.type = 'date';
            const v = this.getValue();
            if (v == null || v === '') {
                node.value = '';
                return;
            }
            const s = String(v).trim();
            if (this.checkValue(s)) node.value = this.format(s);
            else {
                const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
                node.value = iso ? iso[1] : '';
            }
        }
    };
}

});


parcelRegister("8IFAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6592b17c40023188$export$2e2bcd8739ae039);
const $6592b17c40023188$var$dt = function(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz) {
    return new Date(`${ay ?? by}-${am ?? bm}-${ad ?? bd}T${aH ?? bH}:${aM ?? bM}:${aS ?? bS ?? 0}${tz ?? ''}`);
};
function $6592b17c40023188$export$2e2bcd8739ae039(...args) {
    return {
        kind: 'datetime',
        regex: /^(0?[1-9]|[1-2][0-9]|3[0-1])\/(0?[1-9]|1[0-2])\/(20[0-9][0-9])\s([0-1][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9]))?$|^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(.+)$/,
        store_mask (match, ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz) {
            return $6592b17c40023188$var$dt(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz).toISOString();
        },
        display_mask (match, ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz) {
            const d = $6592b17c40023188$var$dt(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            const h = String(d.getHours()).padStart(2, '0');
            const m = String(d.getMinutes()).padStart(2, '0');
            const s = String(d.getSeconds()).padStart(2, '0');
            return `${dd}-${mm}-${yyyy} ${h}:${m}:${s}`;
        }
    };
}

});

parcelRegister("lVBv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6c02d4f0df8745$export$2e2bcd8739ae039);
function $ff6c02d4f0df8745$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^([\w\-]+(?:\.[\w\-]+)*@[\w\-]+(?:\.[\w\-]+)+)$/i,
        setValue (value, _this = this) {
            this.safeProtoCall(value?.toLowerCase(), _this);
        }
    };
}

});

parcelRegister("7aGwp", function(module, exports) {
function $538a7387d2d871ea$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^((?:\/[a-z]+(?:-[a-z]+)*(?:\/\{[a-z_]*\})?)+)$/
    };
}

});

parcelRegister("84MPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e1493eb0305a487$export$2e2bcd8739ae039);
function $5e1493eb0305a487$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        refresh () {},
        handleEvents (ev) {
            let reader = new FileReader();
            reader.onloadend = ()=>{
                let result = reader.result;
                this.setValue(result.slice(result.indexOf(',') + 1));
            };
            reader.readAsDataURL(ev.target.files[0]);
        }
    };
}

});

parcelRegister("hlPFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1c79f4e173f347$export$2e2bcd8739ae039);
function $ca1c79f4e173f347$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{8,14}|SEM GTIN)$/,
        filter: /[]/g
    };
}

});

parcelRegister("gF6P4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c215c48c03ffee69$export$2e2bcd8739ae039);
function $c215c48c03ffee69$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{8,13})$/,
        filter: /[-.]/g,
        store_mask: '$1',
        display_mask: '$1'
    };
}

});

parcelRegister("4dbYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3111ab08af8d80d2$export$2e2bcd8739ae039);
function $3111ab08af8d80d2$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^((?:1?\d{1,2}|2[0-4]\d|25[0-5])\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])\.(?:1?\d{1,2}|2[0-4]\d|25[0-5]))$/,
        filter: /[]/g
    };
}

});

parcelRegister("2rQ6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8685a0a35fdb02$export$2e2bcd8739ae039);
function $1c8685a0a35fdb02$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\{(?:(\s*"\w+":\s*(?:\d+|"[\w-]+")\s*)(,\s*\"\w+":\s*(?:\d+|"[\w-]+")\s*)*)?\})$/
    };
}

});

parcelRegister("fE2eE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63c535296d208bd$export$2e2bcd8739ae039);

var $1cmSR = parcelRequire("1cmSR");

var $aGGTj = parcelRequire("aGGTj");
function $b63c535296d208bd$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'move'
        ],
        _store: args[0],
        _target: args[1],
        _values: args[2]?.values || [
            'id'
        ],
        _labels: args[2]?.labels || [
            'name'
        ],
        _index: args[2]?.index,
        captureEvents (_this = this) {
            this.capture();
            this.safeProtoCall(_this);
        },
        getValue (default_value = '[]', _this = this) {
            return (0, $aGGTj.parse)(this.safeProtoCall(default_value, _this)).map((entry)=>entry.length == 1 ? entry[0] : entry);
        },
        setValue (values, _this = this) {
            return this.safeProtoCall((0, $aGGTj.stringify)((values ?? []).map((entry)=>Array.isArray(entry) ? entry : [
                    entry
                ])), _this);
        },
        isEmpty (values = this.getValue()) {
            return (0, $aGGTj.parse)(values).length == 0;
        },
        async refresh () {
            let node = document.querySelector(`${this?.form.selector} ${this.selector}`);
            if (!node) return;
            node.innerHTML = (await Promise.all(this.getValue().map(async (key)=>{
                return await this.makeOption(await (0, $1cmSR.default).get(this._store, key, this._index));
            }))).join('\n');
        },
        async makeOption (data) {
            if (!data) return;
            let value = (0, $aGGTj.stringify)(this._values.map((entry)=>data[entry]));
            let label = this._labels.map((entry)=>data[entry]).join(' ');
            return `<option value="${value}">${label}</option>`;
        },
        handleEvents (ev) {
            this.setValue(Array.from(ev.target.children).map((option)=>(0, $aGGTj.parse)(option.value)));
        },
        // Compatível com form.syncFromDom(): lê o SELECT múltiplo e persiste no formato esperado (array JSON).
        syncFromDom () {
            const node = document.querySelector(`${this?.form.selector} ${this.selector}`);
            if (!node) return;
            this.setValue(Array.from(node.children).map((option)=>(0, $aGGTj.parse)(option.value)));
            this.checkErrorState();
        },
        capture () {
            let node = document.querySelector(`${this?.form.selector} ${this.selector}`);
            node.parentNode.nextElementSibling.querySelectorAll('button').forEach((button)=>{
                button.addEventListener('click', this.move.bind(this));
            });
        },
        async fill () {
            let available = await (0, $1cmSR.default).list(this._store, undefined, this._index); // Must be the first operation to give time for the form to set its values
            let selected = (0, $aGGTj.parse)(this.form.getFieldBySelector(this.selector).getValue()).map((entry)=>String(entry));
            available = available.filter((entry)=>!selected.includes(String(this._values.map((key)=>entry[key])))); // Remove currently selected options from the available list
            let options = await Promise.all((available ?? []).map((entry)=>this.makeOption(entry)));
            document.querySelector(`${this?.form.selector} ${this._target}`).innerHTML = options.join('\n'); // Join prevent commas from being automatically inserted by JS
        },
        move (ev) {
            let selected = document.querySelector(`${this?.form.selector} ${this.selector}`);
            let available = document.querySelector(`${this?.form.selector} ${this._target}`);
            switch(ev.target.className){
                case 'bn_Left':
                    Array.from(available.selectedOptions).forEach((option)=>selected.appendChild(option));
                    break;
                case 'bn_Right':
                    Array.from(selected.selectedOptions).forEach((option)=>available.appendChild(option));
                    break;
            }
            selected.dispatchEvent(new CustomEvent('move'));
        }
    };
}

});

parcelRegister("4KjZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $374af83299fa0b20$export$2e2bcd8739ae039);
// Requires keymap.js
function $374af83299fa0b20$export$2e2bcd8739ae039(...args) {
    return {
        captureEvents (_this = this) {
            this.fill();
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("74yTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5263fa1d5ed7aac5$export$2e2bcd8739ae039);

var $aGGTj = parcelRequire("aGGTj");
function $5263fa1d5ed7aac5$export$2e2bcd8739ae039(...args) {
    return {
        setValue (value, _this = this) {
            let has_changed = !new RegExp(value, 'i').test(this.getValue());
            this.safeProtoCall(has_changed ? (0, $aGGTj.capitalize)(value) : value, _this);
        }
    };
}

});

parcelRegister("bWgzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b11f696e7bab70f$export$2e2bcd8739ae039);
function $8b11f696e7bab70f$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{8})$/,
        filter: /[]/g
    };
}

});

parcelRegister("91trW", function(module, exports) {

$parcel$export(module.exports, "default", () => $691b0d282e4cd0d9$export$2e2bcd8739ae039);
function $691b0d282e4cd0d9$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^\s*(\d{1,9})(\s+\d{1,9})*\s*$/,
        store_mask (match) {
            return match.trim().replaceAll('  ', ' ');
        },
        display_mask (match, ...args) {
            return match.trim().replaceAll('  ', ' ');
        }
    };
}

});

parcelRegister("l0p8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ad198ec68f02f5$export$2e2bcd8739ae039);
function $f4ad198ec68f02f5$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})$/,
        filter: /[\s]/g,
        store_mask: '$1$2$3$4$5$6$7$8$9$10$11',
        display_mask: '$1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11'
    };
}

});

parcelRegister("5UO7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e90f12875d728e$export$2e2bcd8739ae039);
function $44e90f12875d728e$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{1,15})$/
    };
}

});

parcelRegister("3eqAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a74ef8f667cbaa$export$2e2bcd8739ae039);
const $25a74ef8f667cbaa$var$masks = [
    /^(-?\d{1,3})(\d{3})?(\d{3})?(\.\d{1,20})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?(,\d{1,20})?$/,
    /^(-?\d{1,3})(\d{3})?(\d{3})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?$/,
    /^(\d{1,3})(\d{3})?(\d{3})?$|^(\d{1,3})(\.?\d{3})?(\.?\d{3})?$/
];
/** Grupos do replace podem vir como número (API/DOM); .replace exige string. */ const $25a74ef8f667cbaa$var$_s = (v)=>v != null && v !== '' ? String(v) : '';
const $25a74ef8f667cbaa$var$store = function(g1, g2, g3, g4) {
    const dec = $25a74ef8f667cbaa$var$_s(g4);
    const decDigits = dec.length ? dec.slice(1) : '';
    const decPart = this.dp ? (this.pad ? decDigits + '000000' : decDigits).slice(0, this.dp) : '';
    return String(g1 ?? '') + $25a74ef8f667cbaa$var$_s(g2).replace(this.ts, '') + $25a74ef8f667cbaa$var$_s(g3).replace(this.ts, '') + (this.dp && decPart ? '.' + decPart : '');
};
const $25a74ef8f667cbaa$var$display = function(g1, g2, g3, g4) {
    const s2 = $25a74ef8f667cbaa$var$_s(g2);
    const s3 = $25a74ef8f667cbaa$var$_s(g3);
    const dec = $25a74ef8f667cbaa$var$_s(g4);
    const decDigits = dec.length ? dec.slice(1) : '';
    const decPart = this.dp ? (this.pad ? decDigits + '000000' : decDigits).slice(0, this.dp) : '';
    return String(g1 ?? '') + (s2 ? this.ts + s2.replace(/[.,]/, '') : '') + (s3 ? this.ts + s3.replace(/[.,]/, '') : '') + (this.dp && decPart ? this.ds + decPart : '');
};
function $25a74ef8f667cbaa$export$2e2bcd8739ae039(...args) {
    return {
        dp: args[0] ?? 0,
        ds: args[2] ?? ',',
        ts: args[3] ?? '.',
        pad: args[4] ?? true,
        regex: $25a74ef8f667cbaa$var$masks[args[1] ?? 0],
        store_mask (match, a1, a2, a3, a4, b1, b2, b3, b4) {
            return a1 ? $25a74ef8f667cbaa$var$store.call(this, a1, a2, a3, a4) : $25a74ef8f667cbaa$var$store.call(this, b1, b2, b3, b4);
        },
        display_mask (match, a1, a2, a3, a4, b1, b2, b3, b4) {
            return a1 ? $25a74ef8f667cbaa$var$display.call(this, a1, a2, a3, a4) : $25a74ef8f667cbaa$var$display.call(this, b1, b2, b3, b4);
        }
    };
}

});

parcelRegister("jdpN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfd33cae850bb039$export$2e2bcd8739ae039);
let $dfd33cae850bb039$var$password;
function $dfd33cae850bb039$export$2e2bcd8739ae039(...args) {
    return {
        getValue (default_value) {
            const stored = $dfd33cae850bb039$var$password ?? default_value;
            if (stored !== undefined && stored !== null && stored !== '') return stored;
            // Senha só sincroniza em change/blur; se usuário submete sem sair do campo, ler do DOM
            const node = document.querySelector(this.selector);
            return node?.value ?? default_value;
        },
        setValue (value) {
            $dfd33cae850bb039$var$password = this.format(value, this.store_mask);
        }
    };
}

});

parcelRegister("jHqD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e576b042880c33f1$export$2e2bcd8739ae039);
function $e576b042880c33f1$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^\+?(55)(1[1-9]|2[1247]|3[1234578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])([2-9]\d{3,4})(\d{4})$/,
        filter: /[\(\)\-\s.]/g,
        store_mask: '$1$2$3$4',
        display_mask: '+$1 ($2) $3-$4'
    };
}

});

parcelRegister("6Jl4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e674a4925cd65bb$export$2e2bcd8739ae039);

var $80JbA = parcelRequire("80JbA");
function $4e674a4925cd65bb$export$2e2bcd8739ae039(...args) {
    return (0, $80JbA.default)({
        captureEvents (_this = this) {
            _this.register(_this.getId()); // Need to be called with _this so pubsub registers the proper object 
            this.safeProtoCall(_this);
        },
        setValue (value, _this = this) {
            this.safeProtoCall(value, _this);
            _this.publish('change', value);
        }
    });
}

});
parcelRegister("80JbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d515fcf43788f0e$export$2e2bcd8739ae039);
const $5d515fcf43788f0e$var$REGISTRY = {};
function $5d515fcf43788f0e$var$pubsub(target) {
    target.register = function(id, catalog = 'default') {
        if (!$5d515fcf43788f0e$var$REGISTRY[catalog]) $5d515fcf43788f0e$var$REGISTRY[catalog] = [];
        let index = $5d515fcf43788f0e$var$REGISTRY[catalog].findIndex((member)=>member.id == id);
        if (index < 0) index = $5d515fcf43788f0e$var$REGISTRY[catalog].length;
        $5d515fcf43788f0e$var$REGISTRY[catalog][index] = {
            'id': id,
            'member': this
        };
    };
    target.locate = function(id, catalog = 'default') {
        const escaped = String(id).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return $5d515fcf43788f0e$var$REGISTRY[catalog].find((member)=>new RegExp(`\\b${escaped}\\b`).test(member.id))?.member;
    };
    target.subscribe = function(events_array, callback, once = true) {
        if (typeof callback != 'function') throw new Error('Callback must be a function');
        events_array.forEach((ev)=>{
            if (!Object.hasOwn(this, 'subscribers')) this.subscribers = {};
            if (!this.subscribers[ev]) this.subscribers[ev] = [];
            if (!this.subscribers[ev].find((subscriber)=>subscriber.callback == callback)) this.subscribers[ev].push({
                callback: callback,
                once: once
            });
        });
    };
    target.unsubscribe = function(events_array, callback) {
        events_array.forEach((ev)=>{
            if (Object.hasOwn(this, 'subscribers') && this.subscribers[ev]) this.subscribers[ev].find((entry, index, array)=>{
                if (entry.callback == callback) array.splice(index, 1);
            });
        });
    };
    target.publish = function(event_name, ...args) {
        for(let index = 0; this.subscribers?.[event_name] && index < this.subscribers[event_name].length;){
            let entry = this.subscribers[event_name][index];
            setTimeout(()=>entry.callback(event_name, this, ...args), 0);
            if (entry.once) this.subscribers[event_name].splice(index, 1);
            else index++;
        }
    };
    return target;
}
var $5d515fcf43788f0e$export$2e2bcd8739ae039 = $5d515fcf43788f0e$var$pubsub;

});


parcelRegister("YermW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b50ce47f660c06f$export$2e2bcd8739ae039);
function $0b50ce47f660c06f$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = document.querySelector(this.selector + ' [checked]')?.value, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        refresh () {
            let selected = this.getValue();
            let nodes = document.querySelectorAll(this.selector);
            nodes.forEach((node)=>{
                node.checked = node.value == selected;
            });
        },
        handleEvents (ev) {
            this.setValue(ev.target.value);
            this.refresh();
        }
    };
}

});

parcelRegister("3OKkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c79fa51f8e681d4$export$2e2bcd8739ae039);
function $2c79fa51f8e681d4$export$2e2bcd8739ae039(...args) {
    return {
        events: [
            'change'
        ],
        getValue (default_value = document.querySelector(this.selector + ' [selected]')?.value ?? -1, _this = this) {
            return this.safeProtoCall(default_value, _this);
        },
        checkValue (value = this.getValue()) {
            return value != -1;
        },
        isEmpty (value = this.getValue()) {
            return value == -1;
        },
        refresh () {
            let node = document.querySelector(this.selector);
            if (!node) return;
            let value = this.getValue();
            let option = node.querySelector(`OPTION[value="${value}"]`);
            node.selectedIndex = option ? option.index : -1;
        },
        handleEvents (ev) {
            this.setValue(ev.target.value);
            this.refresh();
            this.checkErrorState();
        }
    };
}

});

parcelRegister("knytZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed60b42a52adaca6$export$2e2bcd8739ae039);
function $ed60b42a52adaca6$export$2e2bcd8739ae039(...args) {
    return {
        display_mask (match) {
            return match.replaceAll('|', '\n');
        },
        setValue (value, _this = this) {
            this.safeProtoCall(value?.replaceAll('\n', '|'), _this);
        },
        handleEvents (ev, _this = this) {
            if (ev.type == 'keydown' && ev.key == 'Enter' && ev.ctrlKey) {
                let node = document.querySelector(this.selector);
                let cursor = node.selectionStart + 1;
                node.value = node.value.slice(0, node.selectionStart) + '\n' + node.value.slice(node.selectionEnd);
                node.setSelectionRange(cursor, cursor);
                ev.preventDefault();
                ev.stopPropagation();
            }
            this.safeProtoCall(ev, _this);
        }
    };
}

});

parcelRegister("bSPRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a6cf87eb88dd049$export$2e2bcd8739ae039);
function $8a6cf87eb88dd049$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^([a-z]{3,10}(?:[_.][a-z]{3,10})?)$/i,
        setValue (value, _this = this) {
            this.safeProtoCall(value?.toLowerCase(), _this);
        }
    };
}

});

parcelRegister("6lTH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ffe7e2640e6c04$export$2e2bcd8739ae039);

var $dZ5S0 = parcelRequire("dZ5S0");
function $49ffe7e2640e6c04$export$2e2bcd8739ae039(...args) {
    return {
        // If source is indexed, index will be replaced by the index of the current selector.
        // Source can be a single string or an array of strings pointing to multiple sources
        _source: args[0],
        captureEvents (_this = this) {
            this.hook(); // Must come after register()
            this.safeProtoCall(_this);
        },
        hook () {
            let names = Array.isArray(this._source) ? this._source : [
                this._source
            ];
            names.forEach((name)=>{
                let id = this.makeId(name);
                let field = this.locate(id);
                if (!field) throw Error(`Not found: ${id}`);
                field.subscribe([
                    'change'
                ], this.actions.bind(this), false); // false: trigger always
            });
        },
        makeId (name) {
            let parts = this.getIdParts();
            let form = parts[1]; // 'form.'
            let index = parts[3]; // '-0'
            if (name.match((0, $dZ5S0.REGEX))) name = (0, $dZ5S0.replaceIndex)(name, index.substr(1)); // 'name-0'
            return form + name; // 'form.name-0'
        },
        getIdParts () {
            return this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
        },
        async preventMultiCalls (object, primary_callback, secondary_callback, ...args) {
            const listAttr = document.querySelector(this.selector)?.getAttribute('list') || '';
            let is_datalist_indexed = (0, $dZ5S0.REGEX).test(listAttr);
            let is_action_ongoing = Boolean(object._this);
            if (!is_datalist_indexed && is_action_ongoing) object._this.subscribe([
                'done'
            ], secondary_callback);
            else {
                object._this = this;
                try {
                    await primary_callback(...args);
                    if (!is_datalist_indexed) object._this.publish('done', ...args);
                } finally{
                    object._this = null;
                }
            }
        },
        actions () {
        // Tipos compostos (ex.: obs_load_options) sobrescrevem actions.
        }
    };
}

});

parcelRegister("badq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $820b09dd9a503dcf$export$2e2bcd8739ae039);

var $1cmSR = parcelRequire("1cmSR");

var $aGGTj = parcelRequire("aGGTj");
function $820b09dd9a503dcf$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, key) {
            // key deve ser string não vazia ou número válido (IDBKeyRange não aceita null, undefined, array ou object)
            const valid = typeof key === 'string' && key !== '' || typeof key === 'number' && !isNaN(key) && key >= 0;
            if (!valid) return;
            let available = await (0, $1cmSR.default).list(this._store, IDBKeyRange.bound([
                key,
                ''
            ], [
                key,
                '\uffff'
            ]), this._index);
            let selected = (0, $aGGTj.parse)(this.form.getFieldBySelector(this.selector).getValue()).map((entry)=>String(entry));
            available = available.filter((entry)=>!selected.includes(String(this._values.map((key)=>entry[key]))));
            let options = await Promise.all((available ?? []).map((entry)=>this.makeOption(entry)));
            document.querySelector(`${this?.form.selector} ${this._target}`).innerHTML = options.join('\n');
        }
    };
}

});

parcelRegister("dg8P2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a739ce21637de64$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");

var $dZ5S0 = parcelRequire("dZ5S0");

var $1cmSR = parcelRequire("1cmSR");

var $9VcS9 = parcelRequire("9VcS9");

var $5zLFz = parcelRequire("5zLFz");
function $9a739ce21637de64$var$warehousesActiveOnly(rows) {
    return (Array.isArray(rows) ? rows : []).filter((r)=>!(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1'));
}
function $9a739ce21637de64$var$parseWarehouseId(raw) {
    if (raw == null || raw === '' || raw === -1 || raw === '-1') return null;
    // UUID de empresa não é armazém
    if (typeof raw === 'string' && /[a-f]/i.test(raw) && raw.includes('-')) return null;
    const n = Number(raw);
    return Number.isFinite(n) && n >= 0 ? n : null;
}
function $9a739ce21637de64$export$9386e97a46254c65(companyId, headerWarehouseId) {
    const c = companyId;
    const wh = $9a739ce21637de64$var$parseWarehouseId(headerWarehouseId);
    if (c == null || c === '') return {
        ok: false,
        companyId: null,
        warehouseId: null
    };
    return {
        ok: true,
        companyId: c,
        warehouseId: wh
    };
}
function $9a739ce21637de64$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    }; // Create a new object each time the function is called, ie when the type is being defined
    return {
        _store: args[0],
        _value: args[1]?.value || 'id',
        _labels: args[1]?.labels || [
            'name'
        ],
        _separator: args[1]?.sep,
        _filter: args[1]?.filter,
        _key: args[1]?.key,
        _range: args[1]?.range,
        _index: args[1]?.index,
        /** Saídas multi-armazém: id de posição não é global — value = `warehouse_id:location_id`, label com prefixo do armazém */ _compositeWhLoc: Boolean(args[1]?.compositeWhLoc),
        async actions (ev, publisher, key) {
            const fmtLocAddr = (a)=>Array.isArray(a) ? a.join('-') : String(a ?? '');
            const resolveHeaderWarehouseId = ()=>{
                try {
                    const fromField = $9a739ce21637de64$var$parseWarehouseId(this.locate?.('warehouse_id')?.getValue?.());
                    if (fromField != null) return fromField;
                } catch (_) {}
                // Se o publisher for o próprio armazém do cabeçalho, use o valor publicado
                try {
                    const pubId = String(publisher?.getId?.() || '');
                    if (/\bwarehouse_id\b/.test(pubId) && !/warehouse_company_id/.test(pubId)) return $9a739ce21637de64$var$parseWarehouseId(key);
                } catch (_) {}
                return null;
            };
            const action = async (keys)=>{
                const headerWh = resolveHeaderWarehouseId();
                const companyId = keys[0];
                const MAX_ID = 2147483647;
                /** Resposta da API — fonte preferencial da datalist (IDB pode falhar/esvaziar). */ let apiLocs = null;
                // Hidratar IDB a partir da API: no Inserir o store de locations costuma estar
                // vazio ou só com outro armazém — filtrar WH3 sem buscar na API = lista vazia.
                if (this._compositeWhLoc && this._store === 'locations' && companyId != null && companyId !== '') try {
                    const parts = [
                        `company_id*eq*${companyId}`
                    ];
                    if (headerWh != null) parts.push(`warehouse_id*eq*${headerWh}`);
                    const qs = new URLSearchParams({
                        filter: parts.join(','),
                        sort: '4',
                        limit: '0'
                    });
                    const locs = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, `?${qs.toString()}`);
                    if (Array.isArray(locs)) {
                        apiLocs = locs;
                        await (0, $1cmSR.default).set('locations', locs);
                    }
                } catch (_) {
                /* mantém IDB atual se a API falhar */ }
                // #MT-6BF7122 — Motivos cancelamento Entrada: IDB costuma vazio até abrir o catálogo.
                // Fetch silencioso — api.call abriria «Carregando...» e travava o formulário.
                let apiCancelReasons = null;
                if (this._store === 'input_cancel_reasons' && typeof companyId === 'string' && companyId.includes('-')) try {
                    const rows = await (0, $5zLFz.fetchInputCancelReasonsSilent)(companyId, false);
                    if (Array.isArray(rows) && rows.length) {
                        apiCancelReasons = rows.filter((r)=>!r.is_disabled);
                        await (0, $1cmSR.default).set('input_cancel_reasons', rows);
                    }
                } catch (_) {
                /* mantém IDB se API falhar (ex.: sem permissão GET) */ }
                let range;
                if (this._compositeWhLoc && this._store === 'locations' && keys.length === 1) {
                    const c = keys[0];
                    if (headerWh != null) range = IDBKeyRange.bound([
                        c,
                        headerWh,
                        0
                    ], [
                        c,
                        headerWh,
                        MAX_ID
                    ]);
                    else {
                        const MAX_WH = 2147483647;
                        range = IDBKeyRange.bound([
                            c,
                            0,
                            0
                        ], [
                            c,
                            MAX_WH,
                            MAX_ID
                        ]);
                    }
                } else {
                    let base_key = this._key ? [
                        ''
                    ] : '';
                    let top_key = this._key ? [
                        '\uffff'
                    ] : '\uffff';
                    range = this._range ? IDBKeyRange.only([
                        ...keys
                    ]) : IDBKeyRange.bound([
                        ...keys,
                        base_key
                    ], [
                        ...keys,
                        top_key
                    ]);
                }
                const idbIndex = this._compositeWhLoc && this._store === 'locations' ? 1 : this._index ?? 2;
                let data = await (0, $1cmSR.default).list(this._store, range, idbIndex);
                if (this._store === 'input_cancel_reasons' && Array.isArray(apiCancelReasons)) data = apiCancelReasons;
                if (this._store === 'warehouses') data = $9a739ce21637de64$var$warehousesActiveOnly(data);
                // Com armazém do cabeçalho já escolhido, não filtrar por catálogo de warehouses
                // no IDB (catálogo incompleto/race → lista de Posição vazia).
                if (this._store === 'locations' && data && data.length && !(this._compositeWhLoc && headerWh != null)) try {
                    const whsRaw = await (0, $1cmSR.default).list('warehouses').catch(()=>[]);
                    const activeWhKeys = new Set($9a739ce21637de64$var$warehousesActiveOnly(whsRaw).map((w)=>`${w.company_id}:${w.id}`));
                    if (activeWhKeys.size > 0) data = data.filter((l)=>activeWhKeys.has(`${l.company_id}:${l.warehouse_id}`));
                } catch (_) {}
                // Com hydrate OK, montar datalist a partir da API (evita IDB vazio/range/tipo).
                if (this._compositeWhLoc && this._store === 'locations' && Array.isArray(apiLocs)) data = headerWh != null ? apiLocs.filter((l)=>Number(l.warehouse_id) === headerWh) : apiLocs.slice();
                if (this._compositeWhLoc && this._store === 'locations' && headerWh != null) data = (data || []).filter((l)=>Number(l.warehouse_id) === headerWh);
                if (this._filter) data = (data || []).filter(this._filter);
                if (this._compositeWhLoc && this._store === 'locations') {
                    const companyIdForSel = keys[0];
                    let selVal = '';
                    try {
                        selVal = String(this.getValue?.() ?? '').trim();
                    } catch (_) {}
                    if (!selVal) {
                        const el = document.querySelector(this.selector);
                        if (el) selVal = String(el.value || '').trim();
                    }
                    const parsed = /^(\d+):(\d+)$/.exec(selVal);
                    if (parsed && companyIdForSel != null && companyIdForSel !== '') {
                        const wh = Number(parsed[1]);
                        const lid = Number(parsed[2]);
                        if (headerWh == null || wh === headerWh) {
                            const exists = (data || []).some((loc)=>String(loc.company_id) === String(companyIdForSel) && Number(loc.warehouse_id) === wh && Number(loc.id) === lid);
                            if (!exists) try {
                                const one = await (0, $1cmSR.default).get('locations', [
                                    companyIdForSel,
                                    wh,
                                    lid
                                ]);
                                if (one) data = [
                                    ...data || [],
                                    one
                                ];
                            } catch (_) {}
                        }
                    }
                    data = (data || []).map((loc)=>({
                            ...loc,
                            _wh_loc: `${loc.warehouse_id}:${loc.id}`,
                            _loc_label: headerWh != null ? fmtLocAddr(loc.address) : `${loc.warehouse_id} \xb7 ${fmtLocAddr(loc.address)}`
                        }));
                    // Garantia: nenhum endereço de outro armazém na lista
                    if (headerWh != null) {
                        const leaked = data.filter((l)=>Number(l.warehouse_id) !== headerWh);
                        if (leaked.length) data = data.filter((l)=>Number(l.warehouse_id) === headerWh);
                    }
                    (0, $h1m6J.loadOptions)(this.selector, data, '_wh_loc', [
                        '_loc_label'
                    ]);
                } else (0, $h1m6J.loadOptions)(this.selector, data, this._value, this._labels, this._separator);
                this.refresh();
            };
            let keys = [
                !isNaN(key) && !Array.isArray(key) ? Number(key) : key
            ];
            if (this._key) {
                if (this.getId().match((0, $dZ5S0.REGEX)) && this._key.match((0, $dZ5S0.REGEX))) this._key = (0, $dZ5S0.replaceIndex)(this._key, this.getId().match((0, $dZ5S0.REGEX)).pop());
                let val = this.locate(this._key)?.getValue();
                keys.unshift(typeof val === 'string' && /^\d+$/.test(val) ? Number(val) : val);
            }
            if (this._compositeWhLoc && this._store === 'locations' && this._key && keys.length >= 1) {
                const companyVal = keys[0];
                keys = companyVal != null && companyVal !== '' ? [
                    companyVal
                ] : [];
            }
            if (keys.length && keys.every((k)=>k != null && k !== '' && (typeof k === 'string' || typeof k === 'number' && !isNaN(k) && k >= 0))) this.preventMultiCalls(SHARED, action, ()=>this.refresh(), keys);
        }
    };
}

});
parcelRegister("9VcS9", function(module, exports) {

$parcel$export(module.exports, "getSialApiHost", () => $73936c209f170d43$export$ffe95df7b31670e0);
$parcel$export(module.exports, "default", () => $73936c209f170d43$export$2e2bcd8739ae039);

var $fBm2N = parcelRequire("fBm2N");
// Script set-api-host.ps1 atualiza API_BASE; '' = same-origin quando servido pela API
const $73936c209f170d43$var$API_BASE = 'https://sial.sialwms.com.br';
const $73936c209f170d43$var$AGENT_URL = 'http://localhost:9101';
const $73936c209f170d43$var$HOST = typeof window !== 'undefined' && window.location.port === '8001' ? '' : $73936c209f170d43$var$API_BASE;
function $73936c209f170d43$export$ffe95df7b31670e0() {
    return $73936c209f170d43$var$HOST;
}
const $73936c209f170d43$var$API = {
    call: (0, $fBm2N.default),
    HOST: /** Base URL da API — igual ao HOST interno do módulo (vazio em dev :8001, API_BASE em produção). */ $73936c209f170d43$var$HOST,
    // AUTH
    async auth (username, password) {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth`;
        // encodeURIComponent: senha com & = + quebrava o corpo (campos a mais / vazios) e podia virar 500/parse errado
        const body = 'username=' + encodeURIComponent(String(username ?? '')) + '&password=' + encodeURIComponent(String(password ?? ''));
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: body
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async request_password (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth/requests`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reset_password (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth/resets`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // ENDPOINTS
    async list_endpoints (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_endpoint (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_endpoint (endpoint_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_endpoint (endpoint_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_endpoint (endpoint_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/endpoints/${endpoint_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // GROUPS
    async list_groups (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_group (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_group (group_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_group (group_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_group (group_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/groups/${group_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // USERS
    async list_users (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/users${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_user (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_user (user_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_user (user_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_user (user_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOGS
    async list_logs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/logs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_log (log_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/logs/${log_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INTEGRATION EVENTS (Central de integrações #MT-6531173)
    async list_integration_events (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async integration_events_entity_alerts (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/entity-alerts${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_integration_event (integration_event_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/${integration_event_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_integration_event (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async integration_events_summary (hours = 24, stale_minutes = 12) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/summary?hours=${encodeURIComponent(hours)}&stale_minutes=${encodeURIComponent(stale_minutes)}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async get_integration_events_techhub_inbox_debug (inbox_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-inbox/${encodeURIComponent(inbox_id)}/debug`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /**
	 * @param {number} limit — lote automático (cron) quando não há inbox_ids
	 * @param {null|{ inbox_ids?: number[], inbox_id?: number }} extra — UI: { inbox_ids: [1,2] } ou legado { inbox_id: 742 }
	 */ async post_integration_events_techhub_process (limit = 200, extra = null) {
        let q = `limit=${encodeURIComponent(limit)}`;
        const ex = extra && typeof extra === 'object' ? extra : {};
        if (ex.inbox_id != null && ex.inbox_id !== '') q += `&inbox_id=${encodeURIComponent(ex.inbox_id)}`;
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-process?${q}`;
        const ids = Array.isArray(ex.inbox_ids) ? ex.inbox_ids.filter((n)=>n != null && String(n).trim() !== '') : [];
        const useBody = ids.length > 0;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: useBody ? {
                'Content-Type': 'application/json'
            } : {},
            body: useBody ? JSON.stringify({
                inbox_ids: ids.map((n)=>parseInt(String(n), 10)).filter((n)=>!Number.isNaN(n))
            }) : undefined
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_techhub_flush_status (limit = 200) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-flush-status?limit=${encodeURIComponent(limit)}`;
        let options = {
            method: 'POST',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_techhub_pull (body = {}) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-pull`;
        let options = {
            method: 'POST',
            body: JSON.stringify(body && typeof body === 'object' ? body : {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async get_integration_events_techhub_runtime_config () {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-runtime-config`;
        let response = await fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
        return response;
    },
    async put_integration_events_techhub_runtime_config (portal_enabled) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-runtime-config`;
        let options = {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                portal_enabled: !!portal_enabled
            })
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_techhub_list_integrated (body = {}) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/techhub-list-integrated`;
        let options = {
            method: 'POST',
            body: JSON.stringify(body && typeof body === 'object' ? body : {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_gsnet_validate (body = {}) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/gsnet-entry/validate`;
        let options = {
            method: 'POST',
            body: JSON.stringify(body && typeof body === 'object' ? body : {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_gsnet_send (body = {}) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/gsnet-entry/send`;
        let options = {
            method: 'POST',
            body: JSON.stringify(body && typeof body === 'object' ? body : {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async post_integration_events_gsnet_mappings_validate (body = {}) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/gsnet-entry/mappings-validate`;
        let options = {
            method: 'POST',
            body: JSON.stringify(body && typeof body === 'object' ? body : {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CITIES
    async list_cities (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/cities${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // COMPANIES
    async list_all_companies (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/all${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_companies (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_company (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_company (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // UNITS
    async list_units (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/units${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_unit (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_unit (company_id, unit_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units/${unit_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_unit (company_id, unit_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units/${unit_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_unit (company_id, unit_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/units/${unit_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CLASSES
    async list_classes (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/classes${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_class (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_class (company_id, class_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_class (company_id, class_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_class (company_id, class_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_class (company_id, class_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/classes/${class_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CATEGORIES
    async list_categories (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/categories${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_category (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_category (company_id, category_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories/${category_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_category (company_id, category_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories/${category_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_category (company_id, category_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/categories/${category_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // MANUFACTURERS
    async list_manufacturers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/manufacturers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_manufacturer (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_manufacturer (company_id, manufacturer_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_manufacturer (company_id, manufacturer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_manufacturer (company_id, manufacturer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PRODUCTS
    async list_products (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/products${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_product (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_product (company_id, product_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_product (company_id, product_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PRODUCT PACKAGINGS
    async list_product_packagings (query = '') {
        // Sob /companies/… para ambientes em que nginx só proxeia prefixos já listados (ex.: AWS QA sem /packagings).
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/packagings${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_product_packagings_by_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}/packagings`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Conferência / coletor: GTIN cadastrado na embalagem → registro da embalagem (incl. product_id). */ async resolve_packaging_gtin (company_id, gtin) {
        const q = new URLSearchParams({
            gtin: String(gtin || '').trim()
        });
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/resolve-gtin?${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_product_packaging (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_product_packaging (company_id, packaging_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_product_packaging (company_id, packaging_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_product_packaging (company_id, packaging_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_product_packaging (company_id, packaging_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/packagings/${packaging_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // WAREHOUSES
    async list_warehouses (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/warehouses${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_warehouse (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_warehouse (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_warehouse (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_warehouse (company_id, warehouse_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_warehouse (company_id, warehouse_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOCATIONS
    async list_locations (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/locations${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_location_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/locations/print-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_location (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_location (company_id, warehouse_id, location_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_location (company_id, warehouse_id, location_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_location (company_id, warehouse_id, location_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PAYMENT TERMS
    async list_payment_terms (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/payment-terms${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_payment_term (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_payment_term (company_id, payment_term_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_payment_term (company_id, payment_term_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_payment_term (company_id, payment_term_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PRICE LISTS
    async list_price_lists (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/price-lists${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_price_list (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_price_list (company_id, price_list_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists/${price_list_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_price_list (company_id, price_list_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists/${price_list_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_price_list (company_id, price_list_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/price-lists/${price_list_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // SUPPLIERS
    async list_suppliers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/suppliers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_supplier (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_supplier (company_id, supplier_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers/${supplier_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_supplier (company_id, supplier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers/${supplier_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_supplier (company_id, supplier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/suppliers/${supplier_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CUSTOMERS
    async list_customers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/customers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async count_customers_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/customers/count-report`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_customers_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/customers/print-report`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_customer (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_customer (company_id, customer_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_customer (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_customer (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CUSTOMER PRICES (tabela de preço por cliente)
    async customer_prices_template (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/template`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_import (company_id, customer_id, csv_content) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/import`;
        let options = {
            method: 'POST',
            body: JSON.stringify({
                csv: csv_content
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_summary (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-prices-summary`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_list (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_replace (company_id, customer_id, prices) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
        let options = {
            method: 'PUT',
            body: JSON.stringify({
                prices: prices
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_prices_delete (company_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async customer_price_get (company_id, customer_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/price?product_id=${product_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CUSTOMER DELIVERY ADDRESSES
    /**
	 * Lista endereços de entrega de um cliente.
	 * @param {string} active_only - se '1', retorna apenas ativos
	 */ async list_customer_delivery_addresses (company_id, customer_id, active_only = false) {
        const q = active_only ? '?active_only=1' : '';
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_customer_delivery_address (company_id, customer_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_customer_delivery_address (company_id, customer_id, address_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses/${address_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_customer_delivery_address (company_id, customer_id, address_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses/${address_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CARRIERS
    async list_carriers (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/carriers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_carrier (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_carrier (company_id, carrier_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers/${carrier_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_carrier (company_id, carrier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers/${carrier_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_carrier (company_id, carrier_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/carriers/${carrier_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // DEVICES
    async list_devices (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/devices${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_device (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_device (company_id, device_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices/${device_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_device (company_id, device_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices/${device_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_device (company_id, device_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/devices/${device_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CFOPS
    async list_cfops (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/cfops${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_class_tribs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/class-tribs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_class_trib (code) {
        let endpoint = `${$73936c209f170d43$var$HOST}/class-tribs/${encodeURIComponent(code)}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_cfop (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_cfop (company_id, cfop_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops/${cfop_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_cfop (company_id, cfop_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops/${cfop_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_cfop (company_id, cfop_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops/${cfop_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_cfops_by_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/cfops`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // PROGRAMS
    async list_programs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/programs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_programs_by_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_program (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_program (company_id, program_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs/${program_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_program (company_id, program_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs/${program_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_program (company_id, program_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/programs/${program_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // RECEIPT TYPES (tipo de recebimento — pedido de entrada)
    async list_receipt_types (query = '') {
        // Sob /companies/… para ambientes em que nginx só proxeia prefixos já listados (ex.: AWS QA sem /receipt-types).
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/receipt-types${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_receipt_types_by_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_receipt_type (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_receipt_type (company_id, receipt_type_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_receipt_type (company_id, receipt_type_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_receipt_type (company_id, receipt_type_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CUSTOMER ROUTES (rotas de cliente — Organização)
    async list_customer_routes (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/customer-routes${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_customer_routes_by_company (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_customer_route (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_customer_route (company_id, customer_route_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_customer_route (company_id, customer_route_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_customer_route (company_id, customer_route_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_customer_route (company_id, customer_route_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_customer_routes (query = '', format = 'csv') {
        const sep = query && query.includes('?') ? '&' : '?';
        let endpoint = `${$73936c209f170d43$var$HOST}/customer-routes${query || ''}${sep}format=${format}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_customer_routes_by_company (company_id, format = 'csv') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/export?format=${format}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_customer_route_customers (company_id, customer_route_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_customer_route_customers (company_id, customer_route_id, format = 'csv') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers?format=${format}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async link_customer_route_customers (company_id, customer_route_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async unlink_customer_route_customer (company_id, customer_route_id, customer_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers/${customer_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async search_customer_route_available (company_id, customer_route_id, query = '') {
        const q = encodeURIComponent(query || '');
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/customer-routes/${customer_route_id}/available-customers?query=${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INPUT DOCKS (#MT-B2FA396)
    async list_input_docks (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/input-docks${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_input_docks_by_company (company_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-docks${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input_dock (company_id, dock_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-docks/${dock_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input_dock (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-docks`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_input_dock (company_id, dock_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-docks/${dock_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_input_dock_disabled (company_id, dock_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-docks/${dock_id}/disabled`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INPUT DOCK SCHEDULING (#MT-B2FA396 Fase 3B)
    async list_input_dock_availability (company_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-availability${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_input_dock_schedules (company_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input_dock_schedule (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input_dock_schedule (company_id, schedule_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async cancel_input_dock_schedule (company_id, schedule_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}/cancel`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reschedule_input_dock_schedule (company_id, schedule_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}/reschedule`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input_order_dock_schedule (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}/dock-schedule`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_dock_schedule_control (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules/print-control`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_input_dock_schedules_xlsx (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-dock-schedules/export-xlsx`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input_order_dock_schedule (company_id, input_order_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}/dock-schedule`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INPUT ORDERS
    async list_input_orders (query = '') {
        // Sob /companies/… para nginx AWS que só proxeia esse prefixo (mesmo padrão de receipt-types / packagings).
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/input-orders${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input_order (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_input_order (company_id, input_order_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_input_order (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input_order (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_pending_input_items (company_id, input_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/${input_order_id}/pending`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_order_document (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/input-orders/print-order-document`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INPUTS
    async list_inputs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_input (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async inventory_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/inventory`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async putaway_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/putaway`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reverse_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/reverse`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-list`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_skus (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-skus`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_xml (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-xml`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_putaway (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-putaway`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_costs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-costs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_conference (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-conference`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_details (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-details`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_inputs_csv (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/export-csv`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async count_inputs_complete_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-complete/count`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inputs_complete_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-complete`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async count_input_documents_list_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-documents-list/count`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_documents_list_report (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/print-documents-list`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async input_expected_traceability (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/expected-traceability`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async input_conference_divergences (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/conference-divergences`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reparse_input_xml_rastro (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/reparse-xml-rastro`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_input_labels (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/print-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async import_xml (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/inputs/import-xml`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // LOTS
    async list_lots (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/lots${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_lot (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_lot (company_id, lot_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_lot (company_id, lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_lot (company_id, lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // OUTPUT ORDERS
    async list_output_orders (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async summarize_output_orders_simulated_availability (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/simulated-availability-summary`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async search_output_orders (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/search`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_output_order (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_output_order (company_id, output_order_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_output_order (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async approve_output_orders_batch (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/approve-batch`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async mark_output_orders_partial_completed_batch (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/mark-partial-completed-batch`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async approve_input_orders_batch (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/approve-batch`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reject_input_orders_batch (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/reject-batch`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_output_order (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_pending_output_items (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}/pending`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async output_order_pending_eligibility (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}/pending-order-eligibility`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_pending_output_order (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}/create-pending-order`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_pending_output_orders (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/print-pending`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_output_order_document (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/print-order-document`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_output_orders_csv (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/output-orders/export-csv`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async upload_output_order (company_id, formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/upload`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async upload_input_order (company_id, formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/upload`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async preview_input_order_xml (company_id, formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/import-xml/preview`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async confirm_input_order_xml (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-orders/import-xml/confirm`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async order_upload_template (company_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/order-upload/template`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // OUTPUTS
    async list_outputs (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async search_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/search`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_output (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_output (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_output (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_output (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_output (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Consulta checkpoint parcial de conferência enviado pelo ColetorPWA (#MT-E4C0633). */ async get_collector_conference_checkpoint (company_id, output_id) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /** Registra checkpoint parcial de conferência do ColetorPWA (#MT-E4C0633). */ async create_collector_conference_checkpoint (company_id, output_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /** Conferência de Saída Web — endpoint dedicado; não altera fluxo PUT/PATCH legado do Coletor PWA. */ async conference_output (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/conference`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Lista divergências de quantidade registradas na conferência de uma saída. */ async list_output_divergences (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/divergences`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /**
	 * Fase 3 — Pedido Falta: gera um novo Pedido de Saída contendo apenas as
	 * quantidades faltantes de uma conferência parcial.
	 * @param {string} company_id
	 * @param {number} output_order_id  - ID do pedido original (output_order)
	 * @param {{ source_output_id: number, grouping: string }} data
	 */ async create_shortage_order (company_id, output_order_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}/create-shortage`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // ─── Fase 4: Unpicking ────────────────────────────────────────────────────
    /**
	 * Solicita unpicking para um item de saída.
	 * @param {string} company_id
	 * @param {number} output_id
	 * @param {{ output_item_number: number, quantity: number, reason_code: string, reason_note?: string }} data
	 */ async request_output_unpick (company_id, output_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/unpick-request`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
    },
    /**
	 * Aprova uma solicitação de unpicking.
	 * @param {string} company_id
	 * @param {number} output_id
	 * @param {{ request_id: string, approval_note?: string }} data
	 */ async approve_output_unpick (company_id, output_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/unpick-approve`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
    },
    /**
	 * Rejeita uma solicitação de unpicking.
	 * @param {string} company_id
	 * @param {number} output_id
	 * @param {{ request_id: string, rejection_note?: string }} data
	 */ async reject_output_unpick (company_id, output_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/unpick-reject`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
    },
    /** Lista todas as solicitações de unpicking de uma saída. */ async list_output_unpick_requests (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/unpick-requests`;
        let response = await fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
        return response;
    },
    /** Antes do faturamento (status < 70): remove linhas, libera reserva R→L; exige permissão do endpoint dedicado. */ async delete_output_separate_lines (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/delete-separate-lines`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/create`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async close_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/close`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async cancel_outputs (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/cancel`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async reverse_output (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/reverse`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_output_volumes (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/list-volumes`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_pick_control (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-pick-control`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_pallets_overturn (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-pallets-overturn`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_picklists (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-picklists`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_picklist_order (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-picklist-order`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_aviso_remessa (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-aviso-remessa`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_conference (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-conference`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_output_details (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-details`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_balance_trace (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-balance-trace`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_output_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_output_stage_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/list-stage-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_output_stage_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/print-stage-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async sendZplToAgent (zpl, printer, printerKey) {
        const hasKey = printerKey != null && String(printerKey).trim() !== '';
        const hasPrinterAddr = printer && typeof printer === 'object' && String(printer.address || '').trim() !== '';
        if (!hasKey && !hasPrinterAddr) throw new Error('A API n\xe3o retornou impressora (printer_key nem IP). Marque "Usar agente local" e escolha a impressora na lista, ou ajuste o cadastro de Dispositivos. Sem isso o agente usa s\xf3 [printers] default no config.ini (risco de imprimir na impressora errada).');
        const endpoint = `${$73936c209f170d43$var$AGENT_URL}/print`;
        const payload = {
            zpl: zpl
        };
        if (hasKey) payload.printer_key = String(printerKey).trim();
        if (printer && typeof printer === 'object') payload.printer = printer;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        };
        let response;
        try {
            response = await fetch(endpoint, options);
        } catch (e) {
            const msg = e && e.message ? String(e.message) : String(e);
            const netFail = /Failed to fetch|NetworkError|network|load failed|fetch/i.test(msg);
            throw new Error(netFail ? `Print Agent n\xe3o responde em ${$73936c209f170d43$var$AGENT_URL}. Neste PC, inicie o agente (pasta do print-agent: INICIAR.bat ou launch-print-agent.vbs) e tente de novo.` : `Falha ao contatar o Print Agent (${$73936c209f170d43$var$AGENT_URL}): ${msg}`);
        }
        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || `Agente local (${$73936c209f170d43$var$AGENT_URL}) retornou ${response.status}. Verifique se o agente est\xe1 rodando.`);
        }
        return response;
    },
    // STOCKS
    async list_stocks (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stock_durability (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-durability`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stocks_simulated_availability (company_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/simulated-availability${query || ''}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_picking_wave (company_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async insert_stock (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_stock (company_id, stock_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/${stock_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_stock (company_id, stock_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/${stock_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_stock (company_id, stock_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stocks/${stock_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stocks_by_input (company_id, input_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}/stocks`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stocks_by_product (company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/products/${product_id}/stocks`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async move_stock (company_id, lot_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/lots/${lot_id}/move`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_lot_meta_preview (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/lot-meta-preview`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_batch_patch_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/batch-patch-lots`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_change_packaging (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/change-packaging`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_bulk_move (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/bulk-move`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_bulk_block (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/bulk-block`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_bulk_unblock (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/bulk-unblock`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_split_stock (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/split-stock`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async stock_management_unitarize_stock (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stock-management/unitarize-stock`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Move todo estoque disponível (L) da posição para outra (L→L). #MT-8EC3321 */ async move_location_all_available (company_id, warehouse_id, location_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/move-all-available`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_by_sku (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-by-sku`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_by_lot (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-by-lot`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_by_location (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-by-location`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_stocks_balance_blocks (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-balance-blocks`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_lot_labels (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/print-lot-labels`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_stocks_csv (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/stocks/export`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /**
	 * Relatório de SKUs sem movimentação de saída em período.
	 * @param {string} company_id - UUID da empresa
	 * @param {Object} params - { date_from, date_to, warehouse_id?, format?, limit?, offset? }
	 */ async sku_no_output_report (company_id, params) {
        const q = new URLSearchParams();
        if (params.format) q.set('format', params.format);
        if (params.date_from) q.set('date_from', params.date_from);
        if (params.date_to) q.set('date_to', params.date_to);
        if (params.warehouse_id) q.set('warehouse_id', params.warehouse_id);
        if (params.limit != null) q.set('limit', params.limit);
        if (params.offset != null) q.set('offset', params.offset);
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/sku-no-output?${q.toString()}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /** Relatório de saídas para projeção de compras (#MT-3786886). */ async output_purchase_report (company_id, params) {
        const q = new URLSearchParams();
        q.set('format', 'csv');
        if (params.date_from) q.set('date_from', params.date_from);
        if (params.date_to) q.set('date_to', params.date_to);
        if (params.warehouse_id) q.set('warehouse_id', params.warehouse_id);
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/output-purchase?${q.toString()}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    // REPLENISHMENTS
    async list_replenishments (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishments${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_replenishment (company_id, warehouse_id, body = null) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments`;
        let payload = body && typeof body === 'object' && Object.keys(body).length ? body : null;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            ...payload ? {
                body: JSON.stringify(payload)
            } : {}
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_replenishment (company_id, warehouse_id, replenishment_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_replenishment (company_id, warehouse_id, replenishment_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_replenishment (company_id, warehouse_id, replenishment_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async close_replenishments (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishments/close`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_replenishment_orders (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishments/print-orders`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_replenishment_rules (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/replenishment-rules${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_replenishment_rule (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishment-rules`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_replenishment_rule (company_id, warehouse_id, location_id, product_company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/replenishment-rules/${product_company_id}/${product_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_replenishment_rule (company_id, warehouse_id, location_id, product_company_id, product_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/replenishment-rules/${product_company_id}/${product_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_replenishment_rule (company_id, warehouse_id, location_id, product_company_id, product_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/replenishment-rules/${product_company_id}/${product_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INVENTORIES
    async list_inventories (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/inventories${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_inventory (company_id, warehouse_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_inventory (company_id, warehouse_id, inventory_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async check_inventory_item (company_id, warehouse_id, inventory_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/items`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async cancel_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/cancel`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async close_inventory (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/close`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inventory_pending (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-pending`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_inventory_deviation (company_id, warehouse_id, inventory_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-deviation`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // TRANSACTIONS
    async list_transactions (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/transactions${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_transaction (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_transaction (company_id, transaction_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions/${transaction_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_transaction (company_id, transaction_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions/${transaction_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_transaction (company_id, transaction_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/transactions/${transaction_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // BI — KARDEX (#MT-1DB4950)
    // Query: product_id, date_from, date_to, lot_id?, cost_mode?, include_disabled?, limit?, offset?
    async kardex_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/kardex${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async kardex_summary (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/kardex/summary${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Kardex analítico PDF ou CSV — body: product_id, date_from, date_to, lot_id?, cost_mode?, include_disabled?, format: pdf|csv */ async print_kardex (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/kardex/print`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** BI — estoque analítico: query = URLSearchParams ou string com ? (format=json|csv, warehouse_id, program_id, product_id, product_search, lot_search, limit, offset, max_rows) */ async stock_complete_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/stock-complete${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** BI — bloqueios descritivo: query = URLSearchParams (format=json|csv, warehouse_id, program_id, product_id, product_search, lot_search, include_all, limit, offset, max_rows) */ async stock_blocks_descriptive_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/stock-blocks-descriptive${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** BI — Auditoria (XLSX): payload = { theme: 'input'|'output'|'stock', filters: {...}, confirm_over_limit?: boolean } */ async audit_report (company_id, payload) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/audit`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload || {})
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** BI — linhas de saída: query = URLSearchParams (format=json|csv, date_from*, date_to, include_disabled, output_id, output_order_id, product_id, product_search, limit, offset, max_rows) */ async output_lines_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/output-lines${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** BI — produtividade (#MT-D900606): format=json|csv, activity=picking|conference|both, view=detail|summary, date_from*, user_search, … */ async output_productivity_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/output-productivity${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Especial SESSP — Gestão de Faturas (#MT-9B4E512). query: date_from*, date_to, program_id, status, include_canceled, limit, offset */ async especial_sessp_faturas (company_id, query = '') {
        const q = query && !query.startsWith('?') ? `?${query}` : query;
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/especial/sessp/faturas${q}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /** Especial SESSP — itens da saída no dash de faturas. query: output_id* */ async especial_sessp_faturas_itens (company_id, query = '') {
        const q = query && !query.startsWith('?') ? `?${query}` : query;
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/especial/sessp/faturas/itens${q}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /** Especial SESSP — histórico de status da saída. query: output_id* */ async especial_sessp_faturas_historico (company_id, query = '') {
        const q = query && !query.startsWith('?') ? `?${query}` : query;
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/especial/sessp/faturas/historico${q}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /** Posições — catálogo / ocupação: query = URLSearchParams (format=json|csv, warehouse_id, occupancy, …, limit, offset, max_rows; CSV em blocos: format=csv&limit&offset&csv_no_header=1) */ async locations_catalog_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/locations-catalog${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Embalagens — relatório cadastro completo: query = URLSearchParams (format=csv, product_id, level=P|S|T, status=all|active|inactive, max_rows) */ async product_packagings_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/product-packagings${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async products_general_report (company_id, query = '') {
        let q = query && !query.startsWith('?') ? `?${query}` : query;
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/products-general${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INVOICES
    async list_invoices (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_invoice (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_invoice (company_id, invoice_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices/${invoice_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_invoice (company_id, invoice_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices/${invoice_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_invoice (company_id, invoice_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoices/${invoice_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_invoices (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/create`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_invoices_xml (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/update-xml`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_archive (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/archive`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async inutilizar_invoices (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/inutilizar`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_iqvia (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/print-iqvia`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async print_iqvia_excluded (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoices/print-iqvia-excluded`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // INVOICE LOTS
    async list_invoice_lots (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_invoice_lot (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_invoice_lot (company_id, invoice_lot_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_invoice_lot (company_id, invoice_lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_invoice_lot (company_id, invoice_lot_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async create_invoice_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots/create`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async send_invoice_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots/send`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async query_invoice_lots (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/invoice-lots/query`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async nfe_emission_control_count (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/nfe-emission-control/count`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async nfe_emission_control_report (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/nfe-emission-control`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    // CAIXAS DE PICKING (Controle de Caixas no Picking — C1/C2)
    /**
	 * Pesquisa global de caixas de picking com filtros.
	 * @param {string} company_id
	 * @param {object} params - { code, seal_code, output_id, status, user_id, date_from, date_to }
	 */ async search_output_picking_boxes (company_id, params) {
        const qs = new URLSearchParams();
        if (params) {
            for (const [k, v] of Object.entries(params))if (v !== null && v !== undefined && v !== '') qs.set(k, v);
        }
        const q = qs.toString() ? `?${qs.toString()}` : '';
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-picking-boxes${q}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /**
	 * #MT-7546968 — pendências de Countback (BLOQUEADO_AUDITORIA).
	 */ async list_output_countback_pendencies (company_id, params) {
        const qs = new URLSearchParams();
        if (params) {
            for (const [k, v] of Object.entries(params))if (v !== null && v !== undefined && v !== '') qs.set(k, v);
        }
        const q = qs.toString() ? `?${qs.toString()}` : '';
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countback-pendencies${q}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /**
	 * #MT-699B225 — evidência de Countback: histórico de todas as tentativas.
	 * @param {string} company_id Empresa.
	 * @param {object} params Filtros (status, output_id, order_id, sku, lot, location,
	 *   operator, date_from, date_to, only_pendencies, limit, offset, group=count).
	 */ async list_output_countbacks (company_id, params) {
        const qs = new URLSearchParams();
        if (params) {
            for (const [k, v] of Object.entries(params))if (v !== null && v !== undefined && v !== '') qs.set(k, v);
        }
        const q = qs.toString() ? `?${qs.toString()}` : '';
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countbacks${q}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async get_output_countback (company_id, countback_id) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countbacks/${countback_id}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async release_output_countback (company_id, countback_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countbacks/${countback_id}/release`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    async release_output_countback_batch (company_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countbacks/release-batch`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    async cancel_output_countback_batch (company_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countbacks/cancel-batch`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    async report_output_countbacks (company_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/countbacks/report`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    async submit_output_countback (company_id, output_id, item_ref, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/items/${encodeURIComponent(item_ref)}/countback`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /**
	 * Lista caixas de uma saída específica.
	 */ async list_output_picking_boxes (company_id, output_id) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /**
	 * Gera relatório de caixas de picking (PDF ou CSV).
	 * @param {string} company_id
	 * @param {Object} data  { format, code, seal_code, output_id, status, user_id, date_from, date_to }
	 */ async report_output_picking_boxes (company_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-picking-boxes/report`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /**
	 * Cria nova caixa de picking para a saída.
	 */ async create_output_picking_box (company_id, output_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /**
	 * Adiciona ou substitui itens na caixa (UPSERT batch — quantidade consolidada por linha).
	 */ async set_output_picking_box_items (company_id, output_id, box_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes/${box_id}/items`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /**
	 * Lacra uma caixa de picking.
	 */ async close_output_picking_box (company_id, output_id, box_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes/${box_id}/close`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /**
	 * Cancela uma caixa de picking.
	 */ async cancel_output_picking_box (company_id, output_id, box_id, data) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes/${box_id}/cancel`;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    // VERSION
    async version () {
        let endpoint = `${$73936c209f170d43$var$HOST}/version`;
        let response = await fetch(endpoint);
        return response;
    },
    // CENTRAL DE IMPORTAÇÃO
    async import_center_entities () {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/entities`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return fetch(endpoint, options);
    },
    async import_center_validate (formData) {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/validate`;
        let options = {
            method: 'POST',
            body: formData,
            credentials: 'include'
        };
        return fetch(endpoint, options);
    },
    async import_center_import (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/import`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return fetch(endpoint, options);
    },
    async import_center_template (entity_key) {
        let endpoint = `${$73936c209f170d43$var$HOST}/import-center/template/${entity_key}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return fetch(endpoint, options);
    },
    // ── INVENTÁRIO V2 ──────────────────────────────────────────────────────
    async list_inventory_sessions (company_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async create_inventory_session (data) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async select_inventory_session (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async list_inventory_session_items (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/items?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async inventory_session_summary (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/summary?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async list_inventory_item_counts (company_id, session_id, scope_item_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/items/${scope_item_id}/counts?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async freeze_inventory_session (company_id, session_id, scope_filter) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/freeze`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                scope_filter: scope_filter
            })
        });
    },
    async unfreeze_inventory_session (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/unfreeze`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async import_inventory_template (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/import-template`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async import_inventory_spreadsheet (company_id, session_id, rows, filename) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/import`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                rows: rows,
                filename: filename
            })
        });
    },
    async simulate_inventory_close (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/simulate-close`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async print_inventory_simulation (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/print-simulation`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async print_inventory_simulation_by_sku (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/print-simulation-by-sku`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async export_inventory_simulation_by_sku (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/export-simulation-by-sku`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async export_inventory_closure_by_sku (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/export-closure-by-sku`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async print_inventory_progress (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/print-progress`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async print_inventory_divergences (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/print-divergences`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async print_inventory_closure (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/print-closure`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async delete_inventory_count (company_id, session_id, count_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/counts/${count_id}/delete`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async clear_inventory_counts (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/clear-counts`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async close_inventory_session (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/close`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async start_inventory_close_job (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/close/start`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async tick_inventory_close_job (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/close/tick`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async get_inventory_close_job_status (company_id, session_id) {
        const q = encodeURIComponent(company_id);
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/close/status?company_id=${q}`, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async cancel_inventory_session (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/cancel`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id
            })
        });
    },
    async register_inventory_count (company_id, session_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/counts`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                ...data
            })
        });
    },
    async register_inventory_count_web (company_id, session_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/counts`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                ...data
            })
        });
    },
    async list_collector_inventory_sessions (company_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async next_collector_inventory_item (company_id, session_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/next?company_id=${company_id}`, {
            credentials: 'include'
        });
    },
    async find_collector_inventory_items (company_id, session_id, { location_id: location_id = null, sku: sku = null, lot_id: lot_id = null } = {}) {
        const qs = new URLSearchParams();
        qs.set('company_id', company_id);
        if (location_id != null && location_id !== '') qs.set('location_id', location_id);
        if (sku != null && sku !== '') qs.set('sku', sku);
        if (lot_id != null && lot_id !== '') qs.set('lot_id', lot_id);
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/items?${qs.toString()}`, {
            credentials: 'include'
        });
    },
    async skip_collector_inventory_item (company_id, session_id, scope_item_id, justification = '') {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/items/${scope_item_id}/skip`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                justification: justification
            })
        });
    },
    async skip_inventory_item_web (company_id, session_id, scope_item_id, justification = '') {
        return fetch(`${$73936c209f170d43$var$HOST}/inventory-sessions/${session_id}/items/${scope_item_id}/skip`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                justification: justification
            })
        });
    },
    /** Prévia / confirmação — encerrar posição (falta física 1ª rodada). Mesma API do coletor. */ async inventory_close_location_preview (company_id, session_id, location_code) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/close-preview`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code
            })
        });
    },
    async inventory_close_location (company_id, session_id, location_code, idempotency_key = null) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/close`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code,
                origin: 'web',
                idempotency_key: idempotency_key || `web-close-${session_id}-${location_code}-${Date.now()}`
            })
        });
    },
    /** Prévia / confirmação — finalizar achados em posição vazia (multi-SKU → 2ª contagem). */ async inventory_finalize_found_preview (company_id, session_id, location_code) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/finalize-found-preview`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code
            })
        });
    },
    async inventory_finalize_found (company_id, session_id, location_code, idempotency_key = null) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/finalize-found`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code,
                origin: 'web',
                idempotency_key: idempotency_key || `web-finalize-${session_id}-${location_code}-${Date.now()}`
            })
        });
    },
    /** Encerrar posição unificado (falta física e/ou achados). */ async inventory_complete_location_preview (company_id, session_id, location_code) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/complete-preview`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code
            })
        });
    },
    async inventory_complete_location (company_id, session_id, location_code, idempotency_key = null) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/complete`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code,
                origin: 'web',
                idempotency_key: idempotency_key || `web-complete-${session_id}-${location_code}-${Date.now()}`
            })
        });
    },
    /** Confirmar falta física na 2ª/3ª rodada (após encerrar posição). */ async inventory_confirm_shortage (company_id, session_id, location_code, quantity = 0, idempotency_key = null) {
        return fetch(`${$73936c209f170d43$var$HOST}/collector/inventory-sessions/${session_id}/locations/confirm-shortage`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                company_id: company_id,
                location_code: location_code,
                quantity: quantity,
                origin: 'web',
                idempotency_key: idempotency_key || `web-shortage-${session_id}-${location_code}-${Date.now()}`
            })
        });
    },
    // DOCA EXPEDIÇÃO (#MT-14DB846)
    async list_dock_expedition (company_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/dock-expedition/outputs${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_dock_expedition (company_id, output_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/dock-expedition/outputs/${output_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_dock_expedition (company_id, output_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/dock-expedition/outputs/${output_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async advance_dock_expedition (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/dock-expedition/advance`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** #MT-0F84944 — Saídas Faturadas (70) → Doca Expedição (75). ids=[[company_id,id],...] */ async send_outputs_to_dock_expedition (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/send-to-dock-expedition`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return await fetch(endpoint, options);
    },
    async print_dock_romaneio (company_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/dock-expedition/print-romaneio`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async print_dock_aviso_remessa (company_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/dock-expedition/print-aviso-remessa`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    // --- restaurado do api.js 10/09 (f3fa322) apos BKP 13/09 incompleto ---
    async list_user_session_events (user_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}/session-events${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return await fetch(endpoint, options);
    },
    async export_user_session_events (user_id, query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/users/${user_id}/session-events/export${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return await fetch(endpoint, options);
    },
    async list_user_overtime_requests (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/user-overtime-requests${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        return await fetch(endpoint, options);
    },
    async create_user_overtime_request (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/user-overtime-requests`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return await fetch(endpoint, options);
    },
    async decide_user_overtime_request (request_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/user-overtime-requests/${request_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return await fetch(endpoint, options);
    },
    async logout () {
        let endpoint = `${$73936c209f170d43$var$HOST}/auth/logout`;
        let options = {
            method: 'POST',
            credentials: 'include'
        };
        return await fetch(endpoint, options);
    },
    async post_integration_events_vendatus_outbox_process (limit = 100) {
        let endpoint = `${$73936c209f170d43$var$HOST}/integration-events/vendatus-outbox-process?limit=${encodeURIComponent(limit)}`;
        let options = {
            method: 'POST',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_input_cancel_reasons (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/input-cancel-reasons${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_input_cancel_reasons_by_company (company_id, include_disabled = false) {
        const q = include_disabled ? '?include_disabled=1' : '';
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-cancel-reasons${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async cancel_inputs_batch (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/cancel-batch`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async insert_input_cancel_reason (company_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-cancel-reasons`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_input_cancel_reason (company_id, reason_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-cancel-reasons/${reason_id}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async delete_input_cancel_reason (company_id, reason_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-cancel-reasons/${reason_id}`;
        let options = {
            method: 'DELETE',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_input_cancel_reason (company_id, reason_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/input-cancel-reasons/${reason_id}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stock_block_kinds (query = '') {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/stock-block-kinds${query}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async list_stock_block_kinds_by_company (company_id, include_disabled = false) {
        const q = include_disabled ? '?include_disabled=1' : '';
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stock-block-kinds${q}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async update_stock_block_kind (company_id, code, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stock-block-kinds/${encodeURIComponent(code)}`;
        let options = {
            method: 'PUT',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async select_stock_block_kind (company_id, code) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/stock-block-kinds/${encodeURIComponent(code)}`;
        let options = {
            method: 'GET',
            credentials: 'include'
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async patch_input (company_id, input_id, data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/inputs/${input_id}`;
        let options = {
            method: 'PATCH',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async mark_output_order_partial_completed (company_id, output_order_id) {
        let endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/output-orders/${output_order_id}/mark-partial-completed`;
        let options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_outputs_csv (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/export-csv`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    async export_outputs_items_csv (data) {
        let endpoint = `${$73936c209f170d43$var$HOST}/outputs/export-items-csv`;
        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        let response = await fetch(endpoint, options);
        return response;
    },
    /** Cancela checkpoint pending — gestor liberou reconferência no coletor. */ async cancel_collector_conference_checkpoint (company_id, output_id, data = {}) {
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint`;
        return fetch(endpoint, {
            method: 'DELETE',
            body: JSON.stringify(data || {}),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    /**
	 * Controle de movimentações — posições ou Origem×Destino (#MT-D8E2535 / #MT-81A7723).
	 * @param {string} company_id
	 * @param {Object} params - { format, date_from, date_to, warehouse_id?, types?, view?, limit?, offset? }
	 */ async movement_control_report (company_id, params) {
        const q = new URLSearchParams();
        if (params.format) q.set('format', params.format);
        if (params.date_from) q.set('date_from', params.date_from);
        if (params.date_to) q.set('date_to', params.date_to);
        if (params.warehouse_id) q.set('warehouse_id', String(params.warehouse_id));
        if (params.types) q.set('types', params.types);
        if (params.view) q.set('view', params.view);
        if (params.limit != null) q.set('limit', String(params.limit));
        if (params.offset != null) q.set('offset', String(params.offset));
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/movement-control?${q.toString()}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /**
	 * Comercial — Relatório Notas faturadas - Exclusivo (#MT-57E7612).
	 * @param {string} company_id
	 * @param {Object} params - { format, date_from, date_to, customer_id?, customer_name?, cnpj?, status?, sku?, product_name?, limit?, offset? }
	 */ /**
	 * Comercial — Itens a vencer (#MT-D552104).
	 * @param {string} company_id
	 * @param {Object} params - { format, months_ahead?, program_id?, limit? }
	 */ async expiring_items_report (company_id, params) {
        const q = new URLSearchParams();
        if (params.format) q.set('format', params.format);
        if (params.months_ahead) q.set('months_ahead', String(params.months_ahead));
        if (params.program_id) q.set('program_id', String(params.program_id));
        if (params.limit != null) q.set('limit', String(params.limit));
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/expiring-items?${q.toString()}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async invoices_billed_exclusive_report (company_id, params) {
        const q = new URLSearchParams();
        if (params.format) q.set('format', params.format);
        if (params.date_from) q.set('date_from', params.date_from);
        if (params.date_to) q.set('date_to', params.date_to);
        if (params.customer_id) q.set('customer_id', String(params.customer_id));
        if (params.customer_name) q.set('customer_name', params.customer_name);
        if (params.cnpj) q.set('cnpj', params.cnpj);
        if (params.status) q.set('status', params.status);
        if (params.sku) q.set('sku', params.sku);
        if (params.product_name) q.set('product_name', params.product_name);
        if (params.portaria_344) q.set('portaria_344', params.portaria_344);
        if (params.limit != null) q.set('limit', String(params.limit));
        if (params.offset != null) q.set('offset', String(params.offset));
        const endpoint = `${$73936c209f170d43$var$HOST}/companies/${company_id}/reports/invoices-billed-exclusive?${q.toString()}`;
        return fetch(endpoint, {
            method: 'GET',
            credentials: 'include'
        });
    },
    /** #MT-7740432 — Ondas de derrubada */ async list_picking_waves (company_id, query = '') {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves${query}`, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async select_picking_wave (company_id, wave_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/${wave_id}`, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async preview_picking_wave (company_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/preview`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async simulate_picking_wave (company_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/simulate`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async picking_wave_dashboard (company_id) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/dashboard`, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async list_picking_wave_forklift_tasks (company_id, query = '') {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/forklift-tasks${query}`, {
            method: 'GET',
            credentials: 'include'
        });
    },
    async confirm_picking_wave_task (company_id, wave_id, task_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/${wave_id}/forklift-tasks/${task_id}/confirm`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async assign_picking_wave (company_id, wave_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/${wave_id}/assign`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async auto_assign_picking_wave (company_id, wave_id, data) {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/${wave_id}/auto-assign`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    async picking_wave_queue (company_id, wave_id, query = '') {
        return fetch(`${$73936c209f170d43$var$HOST}/companies/${company_id}/picking-waves/${wave_id}/picking-queue${query}`, {
            method: 'GET',
            credentials: 'include'
        });
    }
};
var $73936c209f170d43$export$2e2bcd8739ae039 = $73936c209f170d43$var$API;

});
parcelRegister("fBm2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5bb69350d42022c$export$2e2bcd8739ae039);

var $jUNyh = parcelRequire("jUNyh");
let $b5bb69350d42022c$var$_lastRejectAt = 0;
const $b5bb69350d42022c$var$REJECT_COOLDOWN_MS = 2500;
function $b5bb69350d42022c$var$_friendlyMessage(text, status) {
    if (status === 403) {
        try {
            const data = JSON.parse(text);
            if (data.method && data.path) {
                const hint = data.search_hint ? ` Use a busca em Sistema > Grupos e digite: "${data.search_hint}"` : '';
                return `Acesso negado. Falta permiss\xe3o para: ${data.method} ${data.path}.${hint} Pe\xe7a ao administrador para adicionar esse endpoint ao seu grupo.`;
            }
        } catch (e) {}
        return "Acesso negado. Seu usu\xe1rio n\xe3o tem permiss\xe3o para esta opera\xe7\xe3o. Tente sair e entrar novamente. Se o problema continuar, pe\xe7a ao administrador para verificar as permiss\xf5es do seu grupo. (Erro 403)";
    }
    if (status === 401 && text && (text.includes('desabilitado') || text.includes('bloqueado'))) return text;
    if (status === 401) return "Sess\xe3o expirada ou inv\xe1lida. Fa\xe7a login novamente. (Erro 401)";
    if (status === 404) return "Recurso n\xe3o encontrado. O item pode ter sido removido ou voc\xea n\xe3o tem acesso. (Erro 404)";
    if (status === 405) return "Opera\xe7\xe3o n\xe3o permitida nesta URL (405). Verifique se o sistema est\xe1 atualizado; se o erro for ao listar endere\xe7os de entrega, pe\xe7a deploy do frontend e permiss\xf5es do endpoint ao administrador.";
    if (status >= 500 && text) return `Erro no servidor (${status}): ${text}`;
    if (status >= 500) return "Erro tempor\xe1rio no servidor. Tente novamente em alguns instantes. Se persistir, contate o suporte. (Erro " + status + ')';
    if (text && (text.includes('autorizado') || text.includes('fetch') || text.includes('Failed to fetch'))) return "N\xe3o foi poss\xedvel conectar ao servidor. Verifique sua internet e se a API est\xe1 rodando. Em ambiente de desenvolvimento, execute: python seed_db.py (na pasta src/).";
    return text || 'Ocorreu um erro inesperado. Tente novamente ou contate o suporte.';
}
function $b5bb69350d42022c$var$notifyRejection(text, title = "Aten\xe7\xe3o", status) {
    const now = Date.now();
    if (now - $b5bb69350d42022c$var$_lastRejectAt < $b5bb69350d42022c$var$REJECT_COOLDOWN_MS) return;
    $b5bb69350d42022c$var$_lastRejectAt = now;
    const msg = $b5bb69350d42022c$var$_friendlyMessage(text, status);
    (0, $jUNyh.notify)(msg, title);
}
const $b5bb69350d42022c$var$http = async function(endpoint, ...args) {
    let mb, response;
    try {
        mb = (0, $jUNyh.default)({
            animation: true
        });
        response = await endpoint(...args);
    } catch (e) {
        $b5bb69350d42022c$var$notifyRejection(e.message, "Aten\xe7\xe3o", null);
        console.log(e);
    } finally{
        try {
            mb?.destroy?.();
        } catch (_) {}
    }
    if (!response) return;
    if (!response.ok) {
        const body = await response.text();
        $b5bb69350d42022c$var$notifyRejection(body || `${response.status} ${response.statusText}`, "Aten\xe7\xe3o", response.status);
        return;
    }
    const contentType = (response.headers.get('content-type') || '').split(';')[0].toLowerCase();
    if (contentType === 'application/json') {
        const raw = await response.text();
        if (!raw || !String(raw).trim()) return {
            message: 'Resposta JSON vazia do servidor.'
        };
        try {
            return JSON.parse(raw);
        } catch (e) {
            $b5bb69350d42022c$var$notifyRejection("Resposta inv\xe1lida do servidor (n\xe3o \xe9 JSON).", "Aten\xe7\xe3o", null);
            return null;
        }
    }
    const text = await response.text();
    const head = text.trimStart().toLowerCase();
    if (head.startsWith('<!doctype') || head.startsWith('<html')) {
        $b5bb69350d42022c$var$notifyRejection("O servidor devolveu a p\xe1gina do site (HTML) em vez de dados da API. Em ambientes com nginx na frente da API, inclua o caminho desta rota no bloco de proxy (ex.: packagings).", "Configura\xe7\xe3o / proxy", null);
        return;
    }
    if (text.length > 0) return text;
    return response.ok;
};
var $b5bb69350d42022c$export$2e2bcd8739ae039 = $b5bb69350d42022c$var$http;

});


parcelRegister("5zLFz", function(module, exports) {

$parcel$export(module.exports, "fetchInputCancelReasonsSilent", () => $40f532ca8b5925d0$export$4104f29c1357e62c);
$parcel$export(module.exports, "resolveInputCancelReasonId", () => $40f532ca8b5925d0$export$4dde3fed2744b2b3);
$parcel$export(module.exports, "hydrateInputCancelReasons", () => $40f532ca8b5925d0$export$e55201d082006757);

var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");
async function $40f532ca8b5925d0$export$4104f29c1357e62c(companyId, includeDisabled = false) {
    if (!companyId) return [];
    try {
        const q = includeDisabled ? '?include_disabled=1' : '';
        const res = await fetch(`${(0, $9VcS9.getSialApiHost)()}/companies/${companyId}/input-cancel-reasons${q}`, {
            method: 'GET',
            credentials: 'include'
        });
        if (!res.ok) return [];
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (_) {
        return [];
    }
}
async function $40f532ca8b5925d0$export$4dde3fed2744b2b3(raw, companyId) {
    if (raw == null || String(raw).trim() === '' || !companyId) return null;
    const s = String(raw).trim();
    if (/^\d+$/.test(s)) return Number(s);
    try {
        const range = IDBKeyRange.bound([
            companyId,
            ''
        ], [
            companyId,
            '\uffff'
        ]);
        const rows = await (0, $1cmSR.default).list('input_cancel_reasons', range, 2);
        const hit = (rows || []).find((r)=>String(r.name || '').trim() === s);
        if (hit && hit.id != null) return Number(hit.id);
    } catch (_) {}
    try {
        const rows = await $40f532ca8b5925d0$export$4104f29c1357e62c(companyId, false);
        if (Array.isArray(rows) && rows.length) {
            await (0, $1cmSR.default).set('input_cancel_reasons', rows).catch(()=>{});
            const hit = rows.find((r)=>String(r.name || '').trim() === s && !r.is_disabled);
            if (hit && hit.id != null) return Number(hit.id);
        }
    } catch (_) {}
    return null;
}
async function $40f532ca8b5925d0$export$e55201d082006757(companyId, includeDisabled = false) {
    if (!companyId) return [];
    try {
        const rows = await $40f532ca8b5925d0$export$4104f29c1357e62c(companyId, includeDisabled);
        if (Array.isArray(rows) && rows.length) {
            await (0, $1cmSR.default).set('input_cancel_reasons', rows).catch(()=>{});
            return includeDisabled ? rows : rows.filter((r)=>!r.is_disabled);
        }
    } catch (_) {}
    return [];
}

});


parcelRegister("1Wvh7", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a377ceff31a9ac$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $16a377ceff31a9ac$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: "N\xe3o"
            },
            {
                value: '1',
                label: 'Sim'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("lwpk7", function(module, exports) {

var $h1m6J = parcelRequire("h1m6J");
function $040b19b92f93dc1d$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: ',',
                label: 'E'
            },
            {
                value: ';',
                label: 'Ou'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("1fpKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8b2a0570db9b4e$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $0e8b2a0570db9b4e$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'eq',
                label: 'Igual a'
            },
            {
                value: 'ne',
                label: 'Diferente de'
            },
            {
                value: 'gt',
                label: 'Maior que'
            },
            {
                value: 'lt',
                label: 'Menor que'
            },
            {
                value: 'ge',
                label: 'Maior ou igual a'
            },
            {
                value: 'le',
                label: 'Menor ou igual a'
            },
            {
                value: 'si',
                label: 'Similar a'
            },
            {
                value: 'co',
                label: "Cont\xe9m"
            },
            {
                value: 'nc',
                label: "N\xe3o cont\xe9m"
            },
            {
                value: 'bw',
                label: 'Comece com'
            },
            {
                value: 'nb',
                label: "N\xe3o comece com"
            },
            {
                value: 'ew',
                label: 'Termine com'
            },
            {
                value: 'nd',
                label: "N\xe3o termine com"
            },
            {
                value: 'nu',
                label: "\xc9 nulo"
            },
            {
                value: 'nn',
                label: "N\xe3o \xe9 nulo"
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("9SpSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $730d3c6719ff7827$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $730d3c6719ff7827$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: "Produ\xe7\xe3o"
            },
            {
                value: '2',
                label: "Homologa\xe7\xe3o"
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("fyCkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b537c438f09757c4$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $b537c438f09757c4$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'CIF'
            },
            {
                value: '1',
                label: 'FOB'
            },
            {
                value: '2',
                label: 'Terceiros'
            },
            {
                value: '3',
                label: "Pr\xf3prio/Remetente"
            },
            {
                value: '4',
                label: "Pr\xf3prio/Destinat\xe1rio"
            },
            {
                value: '9',
                label: 'Sem Transporte'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("a5v7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7582832548ac84df$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $7582832548ac84df$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: 'Contribuinte'
            },
            {
                value: '2',
                label: 'Isento'
            },
            {
                value: '9',
                label: "N\xe3o Contribuinte"
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("c7jhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2518aa0319bc23$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $8d2518aa0319bc23$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: '0: Nac'
            },
            {
                value: '1',
                label: '1: Imp Dir'
            },
            {
                value: '2',
                label: '2: Imp Adq Int'
            },
            {
                value: '3',
                label: '3: Nac c/Imp 40%-70%'
            },
            {
                value: '4',
                label: '4: Nac c/Ajustes'
            },
            {
                value: '5',
                label: '5: Nac c/Imp < 40%'
            },
            {
                value: '6',
                label: '6: Imp Dir CAMEX'
            },
            {
                value: '7',
                label: '7: Imp Adq Int CAMEX'
            },
            {
                value: '8',
                label: '8: Nac c/Imp > 70%'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("6R5fG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fdbc437e912097f$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $4fdbc437e912097f$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '01',
                label: 'Dinheiro'
            },
            {
                value: '03',
                label: "Cr\xe9dito"
            },
            {
                value: '04',
                label: "D\xe9bito"
            },
            {
                value: '15',
                label: 'Boleto'
            },
            {
                value: '16',
                label: "Dep\xf3sito"
            },
            {
                value: '17',
                label: 'Pix'
            },
            {
                value: '18',
                label: "Transfer\xeancia"
            },
            {
                value: '90',
                label: 'Sem Pagamento'
            },
            {
                value: '99',
                label: 'Outros'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("k93VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaa7b296a57d850b$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $eaa7b296a57d850b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'F',
                label: 'PF'
            },
            {
                value: 'J',
                label: 'PJ'
            },
            {
                value: 'G',
                label: 'OP'
            },
            {
                value: 'L',
                label: 'LOCAL'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("5rlmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f600b215d7c6f7e$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $3f600b215d7c6f7e$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Nenhum'
            },
            {
                value: '1',
                label: 'Presencial'
            },
            {
                value: '2',
                label: 'Internet'
            },
            {
                value: '3',
                label: 'Teleatendimento'
            },
            {
                value: '4',
                label: "Domic\xedlio"
            },
            {
                value: '5',
                label: 'Externo'
            },
            {
                value: '9',
                label: 'Outros'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("e4pb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e4f853566e7a28$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $a3e4f853566e7a28$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'C',
                label: 'Caixa'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});

parcelRegister("3HbPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0e90bfecbeac43$export$2e2bcd8739ae039);

var $h1m6J = parcelRequire("h1m6J");
function $2b0e90bfecbeac43$export$2e2bcd8739ae039(...args) {
    return {
        /*
		options: [
			{ value: 'AC', label: 'Acre' },
			{ value: 'AL', label: 'Alagoas' },
			{ value: 'AM', label: 'Amazonas' },
			{ value: 'AP', label: 'Amapá' },
			{ value: 'BA', label: 'Bahia' },
			{ value: 'CE', label: 'Ceará' },
			{ value: 'DF', label: 'Distrito Federal' },
			{ value: 'ES', label: 'Espírito Santo' },
			{ value: 'GO', label: 'Goiás' },
			{ value: 'MA', label: 'Maranhão' },
			{ value: 'MT', label: 'Mato Grosso' },
			{ value: 'MS', label: 'Mato Grosso do Sul' },
			{ value: 'MG', label: 'Minas Gerais' },
			{ value: 'PA', label: 'Pará' },
			{ value: 'PB', label: 'Paraíba' },
			{ value: 'PR', label: 'Paraná' },
			{ value: 'PE', label: 'Pernambuco' },
			{ value: 'PI', label: 'Piauí' },
			{ value: 'RN', label: 'Rio Grande do Norte' },
			{ value: 'RS', label: 'Rio Grande do Sul' },
			{ value: 'RJ', label: 'Rio de Janeiro' },
			{ value: 'RO', label: 'Rondônia' },
			{ value: 'RR', label: 'Roraima' },
			{ value: 'SC', label: 'Santa Catarina' },
			{ value: 'SP', label: 'São Paulo' },
			{ value: 'SE', label: 'Sergipe' },
			{ value: 'TO', label: 'Tocantins' },
		],
		*/ options: [
            {
                value: 'AC',
                label: 'AC'
            },
            {
                value: 'AL',
                label: 'AL'
            },
            {
                value: 'AM',
                label: 'AM'
            },
            {
                value: 'AP',
                label: 'AP'
            },
            {
                value: 'BA',
                label: 'BA'
            },
            {
                value: 'CE',
                label: 'CE'
            },
            {
                value: 'DF',
                label: 'DF'
            },
            {
                value: 'ES',
                label: 'ES'
            },
            {
                value: 'GO',
                label: 'GO'
            },
            {
                value: 'MA',
                label: 'MA'
            },
            {
                value: 'MT',
                label: 'MT'
            },
            {
                value: 'MS',
                label: 'MS'
            },
            {
                value: 'MG',
                label: 'MG'
            },
            {
                value: 'PA',
                label: 'PA'
            },
            {
                value: 'PB',
                label: 'PB'
            },
            {
                value: 'PR',
                label: 'PR'
            },
            {
                value: 'PE',
                label: 'PE'
            },
            {
                value: 'PI',
                label: 'PI'
            },
            {
                value: 'RN',
                label: 'RN'
            },
            {
                value: 'RS',
                label: 'RS'
            },
            {
                value: 'RJ',
                label: 'RJ'
            },
            {
                value: 'RO',
                label: 'RO'
            },
            {
                value: 'RR',
                label: 'RR'
            },
            {
                value: 'SC',
                label: 'SC'
            },
            {
                value: 'SP',
                label: 'SP'
            },
            {
                value: 'SE',
                label: 'SE'
            },
            {
                value: 'TO',
                label: 'TO'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}

});


parcelRegister("hWQyW", function(module, exports) {

$parcel$export(module.exports, "updateTypes", () => $d110a042ff114667$export$d41ed26cf4146051);
$parcel$export(module.exports, "resolveFilterIdsToLabels", () => $d110a042ff114667$export$ec9466dda38b89c2);
$parcel$export(module.exports, "resolveFilterLabelsToIds", () => $d110a042ff114667$export$94031f41c18e0637);
$parcel$export(module.exports, "validateResolvedFilterValues", () => $d110a042ff114667$export$fc7031ac93c87bd5);
$parcel$export(module.exports, "resolveFilterFieldName", () => $d110a042ff114667$export$24c603097911c4);
$parcel$export(module.exports, "translate", () => $d110a042ff114667$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "default", () => $d110a042ff114667$export$2e2bcd8739ae039);
$parcel$export(module.exports, "validateLocationsFilterWarehouseRequired", () => $d110a042ff114667$export$337c50f9de056b7);
$parcel$export(module.exports, "translateForLocations", () => $d110a042ff114667$export$f776883aa04b3f15);

var $h1m6J = parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $dZ5S0 = parcelRequire("dZ5S0");

var $8gtbe = parcelRequire("8gtbe");

var $1cmSR = parcelRequire("1cmSR");

var $9VcS9 = parcelRequire("9VcS9");

var $7WMRl = parcelRequire("7WMRl");

var $cMoQp = parcelRequire("cMoQp");

var $b7D1Q = parcelRequire("b7D1Q");
const $d110a042ff114667$var$DATALIST = /(<datalist\s+id="fields"[^>]*>)(.*?)(<\/datalist>)/ims;
const $d110a042ff114667$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Valor datalist multi-empresa: `company_uuid:entity_id` (evita colisão de id entre tenants). */ const $d110a042ff114667$var$COMPANY_ENTITY_KEY = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(\d+)$/i;
function $d110a042ff114667$var$isCompanyEntityKey(val) {
    return $d110a042ff114667$var$COMPANY_ENTITY_KEY.test(String(val ?? '').trim());
}
/** Armazéns ativos para UI (filtros, datalists) — cadastro de armazéns não usa esta lista local. */ function $d110a042ff114667$var$warehousesActiveOnly(rows) {
    return (Array.isArray(rows) ? rows : []).filter((r)=>!(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1'));
}
/** Extrai company_id do formulário de filtro (resolve nick→id se necessário). Usado para escopar todos os campos filhos da empresa. */ const $d110a042ff114667$var$getCompanyIdFromFormData = async function(formData, top, companies = null) {
    companies = companies ?? await (0, $1cmSR.default).list('companies').catch(()=>[]);
    for(let i = 0; i < top; i++)if (formData[`field-${i}`] === 'company_id' && formData[`value-${i}`]) {
        const val = formData[`value-${i}`];
        if ($d110a042ff114667$var$UUID_REGEX.test(String(val))) return val;
        const c = companies.find((x)=>(x.nick || '') === val || (x.name || '') === val || String(x.nick || '') === val || String(x.name || '') === val);
        return c?.id ?? null;
    }
    return null;
};
// 'this' is not standard in these instances of formInit() and formCheck() as they point to the 'filter' object instead of a 'form' object.
// The formset creation requires a descriptor and such descriptor must be modified beforehand to point to our local 'init' and 'check' replacements.
// So these descriptor functions are bound to the 'filter' object which will then hold a pointer to the formset after its creation.
const $d110a042ff114667$var$formInit = function() {
    // MT-596E375: inscrever para carregar opções ao trocar campo ou ao alterar Empresa (para atualizar Armazém)
    const form_node = this.formset.form.node || document.querySelector('#filter');
    if (form_node) form_node.addEventListener('change', (ev)=>{
        const fieldMatch = ev.target?.id?.match(/^field-(\d+)$/);
        if (fieldMatch) {
            const field = this.formset.form.getFieldBySelector(ev.target.id);
            if (field) $d110a042ff114667$export$d41ed26cf4146051.call(this, ev, {
                selector: ev.target.id
            }, field.getValue());
        } else {
            const valueMatch = ev.target?.id?.match(/^value-(\d+)$/);
            if (valueMatch) {
                const idx = valueMatch[1];
                const fieldEl = this.formset.form.getFieldBySelector?.('field-' + idx);
                const fn = fieldEl?.getValue?.();
                if (fn === 'company_id') {
                    // Empresa alterada: recarregar opções de TODOS os campos filhos (Armazém, Posição, Programa, etc.)
                    const formData = this.formset?.form?.getValues?.() || {};
                    const refreshAllCompanyScoped = ()=>{
                        const top = 10;
                        for(let i = 0; i < top; i++){
                            const f = this.formset.form.getFieldBySelector?.('field-' + i);
                            const fName = f?.getValue?.();
                            if (fName && fName !== 'company_id' && this.fields?.some((s)=>s.field === fName && s.store)) $d110a042ff114667$export$d41ed26cf4146051.call(this, ev, {
                                selector: 'field-' + i
                            }, fName);
                        }
                    };
                    if (this.reloadLocations) this.reloadLocations(formData).then(refreshAllCompanyScoped).catch(()=>{});
                    else refreshAllCompanyScoped();
                } else if (fn === 'warehouse_id') {
                    // Armazém alterado: recarregar locations da API e opções de Posição
                    const formData = this.formset?.form?.getValues?.() || {};
                    if (this.reloadLocations) this.reloadLocations(formData).then(()=>{
                        const top = 10;
                        for(let i = 0; i < top; i++){
                            const f = this.formset.form.getFieldBySelector?.('field-' + i);
                            if (f?.getValue?.() === 'location_id') $d110a042ff114667$export$d41ed26cf4146051.call(this, ev, {
                                selector: 'field-' + i
                            }, 'location_id');
                        }
                    }).catch(()=>{});
                    else {
                        const top = 10;
                        for(let i = 0; i < top; i++){
                            const f = this.formset.form.getFieldBySelector?.('field-' + i);
                            if (f?.getValue?.() === 'location_id') $d110a042ff114667$export$d41ed26cf4146051.call(this, ev, {
                                selector: 'field-' + i
                            }, 'location_id');
                        }
                    }
                }
            }
        }
    });
    // Filtro: linhas são adicionadas só pelo botão +. autoRow (padrão de formulários
    // com itens) criava uma linha extra ao editar a última linha e copiava valores da 1ª linha.
    Object.getPrototypeOf(this.formset.form).init.call(this.formset.form, false);
};
const $d110a042ff114667$var$activeFilterIndices = function(form, indices) {
    return indices.filter((i)=>{
        const f = form.getFieldBySelector(`field-${i}`);
        return f && !f.isDisabled() && !f.isEmpty();
    });
};
const $d110a042ff114667$var$formCheck = function() {
    let indices = this.formset.getEnabledRowsIndices();
    const active = $d110a042ff114667$var$activeFilterIndices(this.formset.form, indices);
    if (active.length === 0) {
        Object.getPrototypeOf(this.formset.form).check.call(this.formset.form, this.formset);
        return;
    }
    $d110a042ff114667$var$checkParens.call(this.formset.form, indices);
    $d110a042ff114667$var$checkValues.call(this.formset.form, active);
    $d110a042ff114667$var$checkConnectors.call(this.formset.form, active);
    Object.getPrototypeOf(this.formset.form).check.call(this.formset.form, this.formset);
};
const $d110a042ff114667$var$checkParens = function(indices) {
    let balance = 0;
    indices.forEach((index)=>{
        const openField = this.getFieldBySelector(`open-${index}`);
        const closeField = this.getFieldBySelector(`close-${index}`);
        balance += Number(openField?.getValue?.() ?? 0) || 0;
        balance -= Number(closeField?.getValue?.() ?? 0) || 0;
        if (balance < 0) throw new Error("Falta algum par\xeantese de abertura");
    });
    if (balance > 0) throw new Error("Falta algum par\xeantese de fechamento");
};
const $d110a042ff114667$var$checkValues = function(indices) {
    indices.forEach((index)=>{
        let field = this.getFieldBySelector(`field-${index}`);
        let operator = this.getFieldBySelector(`operator-${index}`);
        let value = this.getFieldBySelector(`value-${index}`);
        if (field.isDisabled() || field.isEmpty()) return;
        if (!operator.isDisabled() && operator.isEmpty()) $d110a042ff114667$var$setErrorState(operator, `Verificar operador da linha ${index + 1}`);
        if (!value.isDisabled() && (value.isEmpty() || !value.checkValue()) && ![
            'nu',
            'nn'
        ].includes(operator.getValue())) $d110a042ff114667$var$setErrorState(value, `Verificar dado da linha ${index + 1}`);
    });
};
const $d110a042ff114667$var$checkConnectors = function(activeIndices) {
    activeIndices.forEach((index, ai)=>{
        let field = this.getFieldBySelector(`connector-${index}`);
        let value = field.getValue();
        let is_last_active = ai === activeIndices.length - 1;
        if (!is_last_active && value != ',' && value != ';' || is_last_active && value !== undefined && value != '' && value != -1) $d110a042ff114667$var$setErrorState(field, `Verificar conector da linha ${index + 1}`);
    });
};
const $d110a042ff114667$var$setErrorState = function(field, message) {
    field.setErrorState(true);
    throw new Error(message);
};
const $d110a042ff114667$var$fmtLocAddr = (a)=>Array.isArray(a) ? a.join('-') : String(a ?? '');
/** ILIKE em location_address — nunca expandir location_id para warehouse_id+location_id com co/bw/ew (ILIKE '%2%' casa 2,12,20…). */ const $d110a042ff114667$var$LOCATION_TEXT_FILTER_OPS = [
    'co',
    'bw',
    'ew',
    'nb',
    'nd',
    'nc'
];
/**
 * Normaliza texto de posição para a API.
 * eq/ne: endereço completo (ex.: 2-2-F-10-2 no SESSP) — não remover o 1º segmento numérico.
 * co/bw/ew: permite prefixo explícito de armazém «N - resto» (espaços) ou «N-rest».
 * @param {string} v
 * @param {string} [operator]
 */ function $d110a042ff114667$var$stripWarehousePrefixFromLocationSearch(v, operator = 'co') {
    const raw = String(v ?? '').trim();
    const s = $d110a042ff114667$var$normalizeLocationAddressText(raw);
    const op = String(operator || 'co').toLowerCase();
    if (op === 'eq' || op === 'ne') return s;
    const explicitWh = raw.match(/^(\d+)\s+-\s+(.+)$/);
    if (explicitWh) return $d110a042ff114667$var$normalizeLocationAddressText(explicitWh[2]);
    const m = s.match(/^(\d+)\s*-\s*(.+)$/);
    const core = m ? m[2].trim() : s;
    return $d110a042ff114667$var$normalizeLocationAddressText(core);
}
const $d110a042ff114667$export$ec9466dda38b89c2 = async function(data, fieldspecs) {
    if (!data || !fieldspecs) return data;
    const [companies, locations] = await Promise.all([
        (0, $1cmSR.default).list('companies').catch(()=>[]),
        (0, $1cmSR.default).list('locations').catch(()=>[])
    ]);
    const top = (0, $b60a2.getTopIndex)(data) + 1;
    const resolved = {
        ...data
    };
    const getCompanyId = ()=>{
        for(let j = 0; j < top; j++)if (data[`field-${j}`] === 'company_id') {
            const v = resolved[`value-${j}`] ?? data[`value-${j}`];
            return v && ($d110a042ff114667$var$UUID_REGEX.test(String(v)) ? v : companies.find((x)=>(x.nick || '') === v || (x.name || '') === v || String(x.nick || '') === v || String(x.name || '') === v)?.id);
        }
        return null;
    };
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        const val = data[`value-${i}`];
        if (!field || val == null || val === '') continue;
        const spec = fieldspecs.find((s)=>s.field === field);
        if (spec?.store === 'companies' && $d110a042ff114667$var$UUID_REGEX.test(String(val))) {
            const c = companies.find((x)=>x.id === val || String(x.id) === val);
            if (c?.[spec.labels?.[0]]) resolved[`value-${i}`] = c[spec.labels[0]];
        } else if (spec?.store && spec.store !== 'companies' && spec.store !== 'locations' && spec.labels?.length && (/^\d+$/.test(String(val)) || $d110a042ff114667$var$isCompanyEntityKey(val))) {
            // Resolução genérica id→label para stores escopados por empresa
            const scope = getCompanyId();
            let opts = await (0, $1cmSR.default).list(spec.store).catch(()=>[]);
            if (spec.store === 'warehouses') opts = $d110a042ff114667$var$warehousesActiveOnly(opts);
            let item = null;
            let companyNick = '';
            if ($d110a042ff114667$var$isCompanyEntityKey(val)) {
                const m = String(val).trim().match($d110a042ff114667$var$COMPANY_ENTITY_KEY);
                item = opts.find((o)=>String(o.company_id) === m[1] && String(o.id) === m[2]);
                const c = companies.find((x)=>String(x.id) === m[1]);
                companyNick = c?.nick || c?.name || '';
            } else item = opts.find((o)=>(!scope || String(o.company_id) === String(scope)) && String(o.id) === String(val));
            if (item) {
                const label = spec.labels.map((k)=>item[k]).filter((v)=>v != null && String(v).trim() !== '').join(' ').trim();
                if (label) resolved[`value-${i}`] = companyNick ? `${companyNick} ${label}`.trim() : label;
            }
        } else if (spec?.store === 'locations' && field === 'location_id' && /^\d+:\d+$/.test(String(val))) {
            const [wh, id] = String(val).split(':');
            const loc = locations.find((l)=>String(l.warehouse_id) === wh && String(l.id) === id);
            if (loc) resolved[`value-${i}`] = `${loc.warehouse_id} - ${$d110a042ff114667$var$fmtLocAddr(loc.address)}`;
        }
    }
    return resolved;
};
const $d110a042ff114667$export$94031f41c18e0637 = async function(data, fieldspecs) {
    if (!data || !fieldspecs) return data;
    let companies = await (0, $1cmSR.default).list('companies').catch(()=>[]);
    // Se companies vazio mas há company_id com label para resolver, buscar da API (db pode estar vazio antes de loadBaseData)
    const needsCompanyResolve = (()=>{
        const top = (0, $b60a2.getTopIndex)(data) + 1;
        for(let i = 0; i < top; i++){
            const f = data[`field-${i}`], v = data[`value-${i}`];
            if (f && v != null && v !== '' && fieldspecs.some((s)=>s.field === f && s.store === 'companies') && !$d110a042ff114667$var$UUID_REGEX.test(String(v).trim())) return true;
        }
        return false;
    })();
    if (companies.length === 0 && needsCompanyResolve && (0, $9VcS9.default).list_companies) {
        companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '').catch(()=>[]);
        if (companies.length) (0, $1cmSR.default).set('companies', companies);
    }
    const locations = await (0, $1cmSR.default).list('locations').catch(()=>[]);
    const top = (0, $b60a2.getTopIndex)(data) + 1;
    const resolved = {
        ...data
    };
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        let val = data[`value-${i}`];
        if (!field || val == null || val === '') continue;
        val = String(val).trim();
        const spec = fieldspecs.find((s)=>s.field === field);
        if (spec?.store === 'companies' && !$d110a042ff114667$var$UUID_REGEX.test(val)) {
            const labelKey = spec.labels?.[0] || 'nick';
            const match = (x)=>(x[labelKey] || '') === val || String(x[labelKey] || '') === val || (x.name || '') === val || String(x.name || '') === val || (x.nick || '') === val || String(x.nick || '') === val;
            const c = companies.find(match);
            if (c?.id) resolved[`value-${i}`] = c.id;
        }
    }
    const getCompanyId = ()=>{
        for(let j = 0; j < top; j++)if (data[`field-${j}`] === 'company_id') {
            const v = resolved[`value-${j}`] ?? data[`value-${j}`];
            return v && ($d110a042ff114667$var$UUID_REGEX.test(String(v)) ? v : companies.find((x)=>(x.nick || '') === v || (x.name || '') === v || String(x.nick || '') === v || String(x.name || '') === v)?.id);
        }
        return null;
    };
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        let val = data[`value-${i}`];
        if (!field || val == null || val === '') continue;
        val = String(val).trim();
        const spec = fieldspecs.find((s)=>s.field === field);
        const opLoc = String(data[`operator-${i}`] || 'eq').toLowerCase();
        if (spec?.store === 'locations' && field === 'location_id' && $d110a042ff114667$var$LOCATION_TEXT_FILTER_OPS.includes(opLoc)) continue;
        // Endereço textual (CSV «2-2-F-10-2»): não resolver para wh:id — translateForLocations usa join do array.
        if (spec?.store === 'locations' && field === 'location_id' && (opLoc === 'eq' || opLoc === 'ne') && /[A-Za-z]/.test(val)) continue;
        if (spec?.store === 'locations' && field === 'location_id' && !/^\d+:\d+$/.test(val)) {
            // Label "warehouse_id - address" ou apenas "address"
            const match = val.match(/^(\d+)\s*-\s*(.+)$/);
            const wh = match ? match[1] : null;
            const addrPart = match ? match[2].trim() : val;
            const addrNorm = addrPart.replace(/\s+/g, '-').toUpperCase();
            const scopeCompany = getCompanyId();
            const loc = locations.find((l)=>{
                const a = $d110a042ff114667$var$fmtLocAddr(l.address ?? l.id);
                const addrMatch = a.replace(/\s+/g, '-').toUpperCase() === addrNorm || a.toUpperCase().includes(addrNorm);
                if (!addrMatch) return false;
                if (scopeCompany && String(l.company_id) !== String(scopeCompany)) return false;
                if (wh && String(l.warehouse_id) !== wh) return false;
                return true;
            });
            if (loc) resolved[`value-${i}`] = `${loc.warehouse_id}:${loc.id}`;
        } else if (spec?.store === 'customers' && field === 'customer_id') {
            const scope = getCompanyId();
            const opts = await (0, $1cmSR.default).list('customers').catch(()=>[]);
            const digits = val.replace(/\D/g, '');
            const normDoc = (d)=>d == null ? '' : String(d).replace(/\D/g, '');
            let item = null;
            if (digits.length === 14) item = opts.find((o)=>(!scope || String(o.company_id) === String(scope)) && normDoc(o.cnpj) === digits);
            if (!item && digits.length === 11) item = opts.find((o)=>(!scope || String(o.company_id) === String(scope)) && normDoc(o.cpf) === digits);
            if (item?.id != null) resolved[`value-${i}`] = item.id;
            else if (!/^\d+$/.test(val)) {
                const labelKey = spec.labels[0];
                item = opts.find((o)=>(!scope || String(o.company_id) === String(scope)) && ((o[labelKey] || '') === val || String(o[labelKey] || '') === val));
                if (item?.id != null) resolved[`value-${i}`] = item.id;
            }
        } else if (spec?.store && spec.store !== 'companies' && $d110a042ff114667$var$isCompanyEntityKey(val)) resolved[`value-${i}`] = val.trim();
        else if (spec?.store && spec.store !== 'companies' && spec.labels?.length && !/^\d+$/.test(val) && !/^\d+:\d+$/.test(val) && field !== 'classes' && field !== 'categoria') {
            // Resolução genérica para stores escopados por empresa (warehouses, programs, units, products, etc.)
            const scope = getCompanyId();
            let opts = await (0, $1cmSR.default).list(spec.store).catch(()=>[]);
            if (spec.store === 'warehouses') opts = $d110a042ff114667$var$warehousesActiveOnly(opts);
            const inScope = (o)=>!scope || String(o.company_id) === String(scope);
            const norm = (t)=>String(t ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const nVal = norm(val);
            const joinLabel = (o)=>spec.labels.map((k)=>o[k]).filter((v)=>v != null && String(v).trim() !== '').join(' ').trim();
            let item = opts.find((o)=>inScope(o) && joinLabel(o) === val);
            if (!item) item = opts.find((o)=>inScope(o) && spec.labels.some((k)=>String(o[k] ?? '') === val));
            // nick/name case-insensitive (ex.: Fabricante "ACCORD" / "accord")
            if (!item && nVal) {
                const exactNorm = opts.filter((o)=>inScope(o) && (spec.labels.some((k)=>norm(o[k]) === nVal) || norm(joinLabel(o)) === nVal));
                if (exactNorm.length === 1) item = exactNorm[0];
            }
            if (!item && (spec.store === 'suppliers' || spec.store === 'customers' || spec.store === 'carriers')) {
                const digits = val.replace(/\D/g, '');
                const normDoc = (d)=>d == null ? '' : String(d).replace(/\D/g, '');
                if (digits.length === 14 || digits.length === 11) {
                    const docMatches = opts.filter((o)=>inScope(o) && (normDoc(o.cnpj) === digits || normDoc(o.cpf) === digits));
                    if (docMatches.length === 1) item = docMatches[0];
                }
            }
            if (item?.id != null) // Sem Empresa no filtro: guardar company:id para não colidir entre tenants
            resolved[`value-${i}`] = !scope && item.company_id ? `${item.company_id}:${item.id}` : item.id;
        }
    }
    return resolved;
};
function $d110a042ff114667$export$fc7031ac93c87bd5(data, fieldspecs) {
    if (!data || !fieldspecs) return;
    const top = (0, $b60a2.getTopIndex)(data) + 1;
    const isNullOp = (op)=>op === 'nu' || op === 'nn';
    const textOps = new Set([
        'co',
        'bw',
        'ew',
        'cc',
        'cb',
        'ce',
        'nc',
        'nb',
        'nd',
        'si'
    ]);
    const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        const op = String(data[`operator-${i}`] || '').toLowerCase();
        const raw = data[`value-${i}`];
        if (!field || isNullOp(op)) continue;
        if (raw == null || String(raw).trim() === '') continue;
        const val = String(raw).trim();
        const spec = fieldspecs.find((s)=>s.field === field);
        const label = spec?.label || field;
        if (val === '-1' || val === '-2') throw new Error(`Valor inv\xe1lido em "${label}". Escolha um item da lista.`);
        if (!spec) continue;
        if (textOps.has(op)) continue;
        if (spec.store === 'companies' || field === 'company_id') {
            if (!UUID_RE.test(val)) throw new Error(`Empresa n\xe3o reconhecida: "${val}". Selecione na lista.`);
            continue;
        }
        // users.id é UUID (ex.: SIALBOT b07c4f2a-…); não exigir id numérico (#MT-8678543).
        const isUserField = spec.store === 'users' || field === 'user_id' || field === 'created_by' || field === 'updated_by' || field === 'recorded_by' || field === 'manager_user_id';
        if (isUserField) {
            if (!UUID_RE.test(val)) throw new Error(`Usu\xe1rio n\xe3o reconhecido: "${val}". Selecione na lista.`);
            continue;
        }
        if (spec.store === 'locations' || field === 'location_id') {
            if (!/^\d+:\d+$/.test(val) && !/^\d+$/.test(val) && !/[A-Za-z]/.test(val)) throw new Error(`Posi\xe7\xe3o inv\xe1lida: "${val}".`);
            if (/[A-Za-z]/.test(val) && !/^\d+:\d+$/.test(val)) continue; // endereço textual (eq/ne tratados no translate)
            continue;
        }
        const expectsId = Boolean(spec.store) || field === 'id' || /_id$/.test(field) || spec.types?.some((t)=>t && typeof t.dp === 'number' && t.dp === 0);
        if (expectsId && !/^\d+$/.test(val) && !/^\d+:\d+$/.test(val) && !$d110a042ff114667$var$isCompanyEntityKey(val)) throw new Error(`Valor "${val}" inv\xe1lido para ${label}. Selecione o item na lista (o filtro precisa do c\xf3digo interno, n\xe3o de texto solto).`);
    }
}
function $d110a042ff114667$export$24c603097911c4(fieldDefs, raw) {
    const s = String(raw ?? '').trim();
    if (!s || !Array.isArray(fieldDefs)) return s;
    const byField = fieldDefs.find((f)=>f.field === s);
    if (byField) return byField.field;
    const norm = (t)=>String(t ?? '').trim().toLowerCase();
    const n = norm(s);
    const byLabel = fieldDefs.find((f)=>f.label && norm(f.label) === n);
    return byLabel?.field || s;
}
/** No filtro, campos date/datetime usam só data + calendário (sem horário). */ function $d110a042ff114667$var$filterValueTypesForFieldspec(fieldspec) {
    const raw = fieldspec?.types || [];
    if (raw.some((t)=>t?.kind === 'date' || t?.kind === 'datetime')) return [
        (0, $b7D1Q.default)()
    ];
    return raw;
}
function $d110a042ff114667$var$fieldspecIsDatetime(fieldspecs, fieldName) {
    const spec = fieldspecs?.find((s)=>s.field === fieldName);
    return spec?.types?.some((t)=>t?.kind === 'datetime');
}
function $d110a042ff114667$var$pad2(n) {
    return String(n).padStart(2, '0');
}
function $d110a042ff114667$var$parseFilterDateOnly(value) {
    const s = String(value ?? '').trim();
    if (!s) return null;
    let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return {
        y: +m[1],
        m: +m[2],
        d: +m[3]
    };
    m = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
    if (m) return {
        y: +m[3],
        m: +m[2],
        d: +m[1]
    };
    return null;
}
function $d110a042ff114667$var$filterValueHasTimeComponent(value) {
    const s = String(value ?? '').trim();
    return /\d{1,2}:\d{2}/.test(s);
}
function $d110a042ff114667$var$dayStartLocal(parts) {
    return `${parts.y}-${$d110a042ff114667$var$pad2(parts.m)}-${$d110a042ff114667$var$pad2(parts.d)}T00:00:00`;
}
function $d110a042ff114667$var$nextDayStartLocal(parts) {
    const dt = new Date(parts.y, parts.m - 1, parts.d);
    dt.setDate(dt.getDate() + 1);
    return `${dt.getFullYear()}-${$d110a042ff114667$var$pad2(dt.getMonth() + 1)}-${$d110a042ff114667$var$pad2(dt.getDate())}T00:00:00`;
}
/** Converte eq/ge/le… em campo timestamp para intervalo do dia quando o valor é só data. */ function $d110a042ff114667$var$expandDatetimeFilterClause(field, operator, value, open, close) {
    const op = String(operator || '').toLowerCase();
    if (op === 'nu' || op === 'nn') return null;
    if ($d110a042ff114667$var$filterValueHasTimeComponent(value)) return null;
    const parts = $d110a042ff114667$var$parseFilterDateOnly(value);
    if (!parts) return null;
    const start = $d110a042ff114667$var$dayStartLocal(parts);
    const next = $d110a042ff114667$var$nextDayStartLocal(parts);
    switch(op){
        case 'eq':
            return `${open}${field}*ge*${start},${field}*lt*${next}${close}`;
        case 'ne':
            return `${open}${field}*lt*${start};${field}*ge*${next}${close}`;
        case 'ge':
            return `${open}${field}*ge*${start}${close}`;
        case 'gt':
            return `${open}${field}*ge*${next}${close}`;
        case 'le':
            return `${open}${field}*lt*${next}${close}`;
        case 'lt':
            return `${open}${field}*lt*${start}${close}`;
        default:
            return null;
    }
}
const $d110a042ff114667$export$d41ed26cf4146051 = async function(ev, publisher, field_name) {
    field_name = $d110a042ff114667$export$24c603097911c4(this.fields, field_name);
    let basespec = (0, $cMoQp.default).rowFieldSpecs?.find((f)=>f.properties.selector === '#value-0') || {
        properties: {
            selector: '#value-0'
        },
        types: []
    };
    let fieldspec = this.fields.find((entry)=>entry.field == field_name); // 'field_name' may be -1 when moving between rows
    let typed_field = (0, $8gtbe.default).create(basespec.properties, basespec.types.concat($d110a042ff114667$var$filterValueTypesForFieldspec(fieldspec)));
    const pubSel = String(publisher?.selector || '').replace(/^#/, '');
    const pubMatch = pubSel.match((0, $dZ5S0.REGEX));
    if (!pubMatch) return;
    let index = pubMatch[3];
    let current_field = this.formset.form.getFieldBySelector((0, $dZ5S0.replaceIndex)('value-0', index));
    if (!current_field) return;
    Object.assign(typed_field, {
        selector: current_field.selector,
        form: this.formset.form
    });
    current_field.releaseEvents();
    typed_field.releaseEvents();
    let node = typed_field.queryNode();
    const formScope = this.formset?.form?.selector;
    const valueTypes = $d110a042ff114667$var$filterValueTypesForFieldspec(fieldspec);
    const usesDateFilter = valueTypes.length === 1 && valueTypes[0]?.kind === 'date';
    if (usesDateFilter && node) {
        node.removeAttribute('placeholder');
        node.setAttribute('title', 'Selecione a data');
    } else {
        if (fieldspec?.placeholder && node) node.setAttribute('placeholder', fieldspec.placeholder);
        if (fieldspec?.title && node) node.setAttribute('title', fieldspec.title);
    }
    if (fieldspec?.store) {
        let options = await (0, $1cmSR.default).list(fieldspec.store);
        if (fieldspec.store === 'warehouses') options = $d110a042ff114667$var$warehousesActiveOnly(options);
        // MT-596E375: filtrar por company_id/warehouse_id, ordenar por address, value = warehouse_id:location_id
        if (fieldspec.store === 'locations' && (fieldspec.field === 'location_id' || field_name === 'location_id')) {
            const formData = this.formset?.form?.getValues?.() || {};
            await $d110a042ff114667$var$loadLocationFilterDatalist(typed_field, formScope, formData, String(node?.value ?? '').trim());
            if (node) $d110a042ff114667$var$bindLocationFilterLiveSearch(node, typed_field, formScope, this.formset);
        } else if (fieldspec.store !== 'companies' && fieldspec.store !== 'locations' && options.length > 0 && (fieldspec.store === 'warehouses' || options[0].company_id != null)) {
            // Stores escopados por empresa: warehouses, programs, units, classes, products, etc.
            const formData = this.formset?.form?.getValues?.() || {};
            const top = (0, $b60a2.getTopIndex)(formData) + 1;
            const companyId = await $d110a042ff114667$var$getCompanyIdFromFormData(formData, top);
            if (companyId) options = options.filter((o)=>String(o.company_id) === String(companyId));
            // Inativos (produtos, etc.): armazém já veio filtrado em warehousesActiveOnly no início.
            if (fieldspec.store !== 'warehouses' && options.length > 0 && options[0].is_disabled != null) options = options.filter((o)=>!o.is_disabled);
            if (!companyId && options.length > 0 && options[0].company_id != null) {
                // Sem Empresa: value = company_id:id (ids colidem entre tenants — ex. id=4 ACCORD vs ANGELUS)
                const companies = await (0, $1cmSR.default).list('companies').catch(()=>[]);
                const nickBy = Object.fromEntries(companies.map((c)=>[
                        String(c.id),
                        c.nick || c.name || ''
                    ]));
                const labels = fieldspec.labels || [
                    'name'
                ];
                const mapped = options.map((o)=>{
                    const parts = labels.map((k)=>o[k]).filter((v)=>v != null && String(v).trim() !== '');
                    const cn = nickBy[String(o.company_id)] || '';
                    return {
                        value: `${o.company_id}:${o.id}`,
                        label: [
                            cn,
                            ...parts
                        ].filter(Boolean).join(' ').trim()
                    };
                });
                (0, $h1m6J.loadOptions)(typed_field.selector, mapped, 'value', [
                    'label'
                ], undefined, formScope);
            } else (0, $h1m6J.loadOptions)(typed_field.selector, options, fieldspec.value || 'id', fieldspec.labels, fieldspec.separator, formScope);
        } else // Empresas: usar id como value (enviar UUID à API), nick como label (exibição)
        if (fieldspec.store === 'companies' && fieldspec.labels?.[0]) {
            const labelKey = fieldspec.labels[0];
            const seen = new Set();
            options = options.filter((o)=>{
                const k = o.id ?? '';
                if (seen.has(k)) return false;
                seen.add(k);
                return true;
            });
            (0, $h1m6J.loadOptions)(typed_field.selector, options, 'id', [
                labelKey
            ], undefined, formScope);
        } else (0, $h1m6J.loadOptions)(typed_field.selector, options, fieldspec.value, fieldspec.labels, fieldspec.separator, formScope);
    } else node?.removeAttribute('list');
    this.formset.form.insertOrUpdateField(typed_field);
    typed_field.captureEvents();
    typed_field.refresh();
};
const $d110a042ff114667$var$LOCATIONS_FIELDS = [
    'company_id',
    'warehouse_id',
    'location_id'
];
const $d110a042ff114667$var$SCOPE_FIELDS = [
    'company_id',
    'warehouse_id'
];
function $d110a042ff114667$var$normalizeLocationAddressText(raw) {
    return String(raw ?? '').trim().replace(/\s*-\s*/g, '-').replace(/\s*,\s*/g, '-').replace(/\s+/g, '-');
}
/** Rótulo «2 - 2-F-10-2» / CSV «2-2-F-10-2» / parcial «2-m-» → armazém + trecho do endereço.
 *  «6-B-4-14» (prefixo legado no array, armazém físico outro) → join completo, sem warehouse_id. */ function $d110a042ff114667$var$parseCombinedLocationAddress(raw) {
    const s = $d110a042ff114667$var$normalizeLocationAddressText(raw);
    const m = s.match(/^(\d+)-(\d+-[A-Za-z].*)$/);
    if (m) return {
        warehouseId: m[1],
        addressJoin: m[2]
    };
    const p = s.match(/^(\d+)-(.+)$/);
    if (p) {
        const wh = p[1];
        const rest = p[2];
        if (/^\d+-/.test(rest)) return {
            warehouseId: wh,
            addressJoin: rest
        };
        if (/^[A-Za-z]/.test(rest)) return {
            addressJoin: s
        };
        return {
            warehouseId: wh,
            addressJoin: rest
        };
    }
    return {
        addressJoin: s
    };
}
/** Endereço «2-2-F-10-2» já traz armazém no prefixo; legado «6-B-4-14» não. */ function $d110a042ff114667$var$combinedLocationAddressImpliesWarehouse(raw) {
    const s = $d110a042ff114667$var$normalizeLocationAddressText(raw);
    return /^\d+-\d+-[A-Za-z]/.test(s);
}
function $d110a042ff114667$var$mayInferWarehouseFromAddress(search, warehouseId, explicitWarehouseOnly) {
    if (!warehouseId) return false;
    if (!explicitWarehouseOnly) return true;
    return $d110a042ff114667$var$combinedLocationAddressImpliesWarehouse(search);
}
function $d110a042ff114667$var$escapeLocationFilterToken(s) {
    return String(s ?? '').replace(/[*,]/g, '');
}
/** Endereços SESSP usam letras maiúsculas (M-1-2); normaliza digitação «2-m-». */ function $d110a042ff114667$var$uppercaseLocationAddressLetters(s) {
    return String(s ?? '').replace(/[a-z]/g, (ch)=>ch.toUpperCase());
}
function $d110a042ff114667$var$filterLocationOptionsBySearch(options, searchTerm) {
    const term = $d110a042ff114667$var$normalizeLocationAddressText(searchTerm);
    if (!term) return options;
    const { warehouseId: whFromTerm, addressJoin: addressJoin } = $d110a042ff114667$var$parseCombinedLocationAddress(term);
    const termUpper = term.toUpperCase();
    const fragUpper = $d110a042ff114667$var$uppercaseLocationAddressLetters(addressJoin || term);
    return options.filter((o)=>{
        if (whFromTerm && String(o.warehouse_id) !== String(whFromTerm)) return false;
        const label = (o._label || '').toUpperCase();
        const addr = (o._addrSort || '').toUpperCase();
        return label.includes(termUpper) || addr.includes(fragUpper);
    });
}
/** Texto incompleto ao digitar (ex.: «2-m-») — não usar match exato cb+ce. */ function $d110a042ff114667$var$isPartialLocationAddress(addressJoin) {
    const a = String(addressJoin ?? '').trim();
    if (!a) return true;
    if (/[-]$/.test(a)) return true;
    return false;
}
async function $d110a042ff114667$var$resolveFilterLocationScope(formData, topIdx) {
    let companyId = null;
    let warehouseId = null;
    const [companies, warehousesRaw] = await Promise.all([
        (0, $1cmSR.default).list('companies').catch(()=>[]),
        (0, $1cmSR.default).list('warehouses').catch(()=>[])
    ]);
    const warehouses = $d110a042ff114667$var$warehousesActiveOnly(warehousesRaw);
    for(let i = 0; i < topIdx; i++){
        if (formData[`field-${i}`] === 'company_id' && formData[`value-${i}`]) {
            const val = formData[`value-${i}`];
            companyId = $d110a042ff114667$var$UUID_REGEX.test(String(val)) ? val : null;
            if (!companyId) {
                const c = companies.find((x)=>(x.nick || '') === val || (x.name || '') === val || String(x.nick || '') === val || String(x.name || '') === val);
                companyId = c?.id;
            }
        } else if (formData[`field-${i}`] === 'warehouse_id' && formData[`value-${i}`] != null && formData[`value-${i}`] !== '') {
            const wval = formData[`value-${i}`];
            warehouseId = /^\d+$/.test(String(wval)) ? typeof wval === 'number' ? wval : parseInt(wval, 10) : null;
            if (warehouseId == null && companyId) {
                const wh = warehouses.find((w)=>String(w.company_id) === String(companyId) && ((w.name || '') === wval || String(w.name || '') === wval));
                if (wh) warehouseId = wh.id;
            }
        }
    }
    return {
        companyId: companyId,
        warehouseId: warehouseId,
        companies: companies,
        warehouses: warehouses
    };
}
function $d110a042ff114667$var$mapLocationFilterOptions(locations, warehouses) {
    const activeWhKeys = new Set(warehouses.map((w)=>`${w.company_id}:${w.id}`));
    let options = (locations || []).map((loc)=>{
        const addr = $d110a042ff114667$var$fmtLocAddr(loc.address ?? loc.id);
        return {
            ...loc,
            _wh_loc: `${loc.warehouse_id}:${loc.id}`,
            _label: `${loc.warehouse_id} - ${addr}`,
            _addrSort: addr
        };
    });
    if (activeWhKeys.size > 0) options = options.filter((l)=>activeWhKeys.has(`${l.company_id}:${l.warehouse_id}`));
    options.sort((a, b)=>(a._addrSort || '').localeCompare(b._addrSort || '', undefined, {
            numeric: true
        }));
    return options;
}
async function $d110a042ff114667$var$loadLocationFilterDatalist(typed_field, formScope, formData, searchTerm = '') {
    const topIdx = (0, $b60a2.getTopIndex)(formData) + 1;
    const { companyId: companyId, warehouseId: warehouseId, warehouses: warehouses } = await $d110a042ff114667$var$resolveFilterLocationScope(formData, topIdx);
    const typed = String(searchTerm ?? '').trim();
    let options = [];
    // Com empresa+armazém e texto: busca na API pelo trecho do endereço (não o prefixo «2-» inteiro).
    if (companyId && warehouseId != null && typed) {
        const parsed = $d110a042ff114667$var$parseCombinedLocationAddress(typed);
        const wh = parsed.warehouseId && String(parsed.warehouseId) === String(warehouseId) ? Number(parsed.warehouseId) : warehouseId;
        const frag = $d110a042ff114667$var$uppercaseLocationAddressLetters(parsed.addressJoin || typed);
        const rows = await (0, $7WMRl.fetchWarehouseLocations)(companyId, wh, {
            search: frag,
            limit: 80,
            silent: true
        });
        options = $d110a042ff114667$var$mapLocationFilterOptions(rows, warehouses);
    } else {
        // Sem texto (ou sem escopo): lista local como antes — datalist nativo + filtro ao digitar.
        let idbRows = await (0, $1cmSR.default).list('locations').catch(()=>[]);
        options = $d110a042ff114667$var$mapLocationFilterOptions(idbRows, warehouses);
        if (companyId) options = options.filter((l)=>String(l.company_id) === String(companyId));
        if (warehouseId != null) options = options.filter((l)=>Number(l.warehouse_id) === Number(warehouseId));
        if (typed) options = $d110a042ff114667$var$filterLocationOptionsBySearch(options, typed);
    }
    (0, $h1m6J.loadOptions)(typed_field.selector, options, '_wh_loc', [
        '_label'
    ], undefined, formScope);
}
function $d110a042ff114667$var$bindLocationFilterLiveSearch(node, typed_field, formScope, formset) {
    if (!node || node.dataset.locFilterLive === '1') return;
    node.dataset.locFilterLive = '1';
    let timer = null;
    node.addEventListener('input', (ev)=>{
        if (ev.inputType === 'insertReplacementText') return;
        clearTimeout(timer);
        const typed = String(ev.target?.value ?? '').trim();
        timer = setTimeout(async ()=>{
            try {
                const formData = formset?.form?.getValues?.() || {};
                await $d110a042ff114667$var$loadLocationFilterDatalist(typed_field, formScope, formData, typed);
                if (node && typed) node.value = typed;
            } catch (err) {
                console.error('location filter live search', err);
            }
        }, 280);
    });
}
/**
 * Monta cláusula de filtro por endereço de posição.
 * Catálogo `/locations` usa `address` (TEXT[]); estoque/movimentações usam `location_address`.
 * @param {string} locationTextField
 * @param {{ explicitWarehouseOnly?: boolean }} [opts]
 */ function $d110a042ff114667$var$appendLocationAddressClause(open, operator, value, close, locationTextField, splitWarehouse = true, opts = {}) {
    const explicitWarehouseOnly = opts.explicitWarehouseOnly === true;
    const opLower = String(operator || 'eq').toLowerCase();
    const search = splitWarehouse ? $d110a042ff114667$var$stripWarehousePrefixFromLocationSearch(value, opLower) : $d110a042ff114667$var$normalizeLocationAddressText(value);
    if (locationTextField === 'address' && (opLower === 'eq' || opLower === 'ne')) {
        if (!splitWarehouse) {
            const addr = $d110a042ff114667$var$uppercaseLocationAddressLetters($d110a042ff114667$var$escapeLocationFilterToken(search));
            if (opLower === 'eq' && $d110a042ff114667$var$isPartialLocationAddress(addr)) return `${open}address*cc*${addr}${close}`;
            const addrClauses = `address*cb*${addr},address*ce*${addr}`;
            return `${open}${addrClauses}${close}`;
        }
        const { warehouseId: warehouseId, addressJoin: addressJoin } = $d110a042ff114667$var$parseCombinedLocationAddress(search);
        if (opLower === 'eq' && $d110a042ff114667$var$isPartialLocationAddress(addressJoin)) {
            const term = $d110a042ff114667$var$uppercaseLocationAddressLetters($d110a042ff114667$var$escapeLocationFilterToken(addressJoin));
            const addrClause = `address*cc*${term}`;
            if ($d110a042ff114667$var$mayInferWarehouseFromAddress(search, warehouseId, explicitWarehouseOnly)) return `${open}warehouse_id*eq*${warehouseId},${addrClause}${close}`;
            return `${open}${addrClause}${close}`;
        }
        const addrClauses = `address*cb*${addressJoin},address*ce*${addressJoin}`;
        if ($d110a042ff114667$var$mayInferWarehouseFromAddress(search, warehouseId, explicitWarehouseOnly)) return `${open}warehouse_id*${operator}*${warehouseId},${addrClauses}${close}`;
        return `${open}${addrClauses}${close}`;
    }
    return `${open}${locationTextField}*${operator}*${search}${close}`;
}
/** OR de endereços no mesmo armazém → address*in* (evita URL > buffer uWSGI 4096).
 * Aceita ramos com ou sem warehouse_id*eq*N, e ignora ramo órfão só de warehouse_id.
 * Também: warehouse_id*eq*N,(addr;addr;…) — forma AND(escopo, OR).
 */ function $d110a042ff114667$var$compactLocationAddressOrExpression(expr) {
    if (!expr || !String(expr).includes(';')) return expr;
    let raw = String(expr).trim();
    const scoped = raw.match(/^warehouse_id\*eq\*(\d+),\((.+)\)$/i);
    if (scoped) {
        const collapsedInner = $d110a042ff114667$var$compactLocationAddressOrExpression(`(${scoped[2]})`);
        if (collapsedInner.startsWith('(warehouse_id*eq*')) return collapsedInner;
        const innerOnly = $d110a042ff114667$var$compactAddressBranches(scoped[2], scoped[1]);
        if (innerOnly) return innerOnly;
        return expr;
    }
    if (raw.startsWith('(') && raw.endsWith(')')) raw = raw.slice(1, -1);
    return $d110a042ff114667$var$compactAddressBranches(raw, null) || expr;
}
function $d110a042ff114667$var$compactAddressBranches(inner, forcedWh) {
    const parts = String(inner).split(';').map((p)=>p.trim()).filter(Boolean);
    if (parts.length < 2) return null;
    const withWhRe = /^\(?warehouse_id\*eq\*(\d+),address\*cb\*([^,]+),address\*ce\*([^,)]+)\)?$/i;
    const addrOnlyRe = /^\(?address\*cb\*([^,]+),address\*ce\*([^,)]+)\)?$/i;
    const whOnlyRe = /^\(?warehouse_id\*eq\*(\d+)\)?$/i;
    let warehouseId = forcedWh;
    const addresses = [];
    for (const part of parts){
        let m = part.match(withWhRe);
        if (m) {
            if (m[2] !== m[3]) return null;
            if (warehouseId == null) warehouseId = m[1];
            else if (String(warehouseId) !== String(m[1])) return null;
            addresses.push(m[2]);
            continue;
        }
        m = part.match(addrOnlyRe);
        if (m) {
            if (m[1] !== m[2]) return null;
            addresses.push(m[1]);
            continue;
        }
        m = part.match(whOnlyRe);
        if (m) {
            if (warehouseId == null) warehouseId = m[1];
            else if (String(warehouseId) !== String(m[1])) return null;
            continue;
        }
        return null;
    }
    if (addresses.length < 2 || warehouseId == null) return null;
    const uniq = [
        ...new Set(addresses)
    ];
    return `(warehouse_id*eq*${warehouseId},address*in*${uniq.join('@')})`;
}
/** Converte valor digitado na máscara pt-BR (ex.: 2.530) para literal numérico da API. */ function $d110a042ff114667$var$normalizeFilterValueForFieldspec(field, raw, fieldspecs) {
    if (raw == null || raw === '' || !fieldspecs) return raw;
    const spec = fieldspecs.find((s)=>s.field === field);
    const numType = spec?.types?.find((t)=>t && typeof t.dp === 'number');
    if (!numType) return raw;
    let s = String(raw).trim().replace(/\s/g, '');
    const dp = numType.dp;
    if (dp === 0) {
        if (/,/.test(s)) return raw;
        const cleaned = s.replace(/\./g, '');
        return /^\d+$/.test(cleaned) ? cleaned : raw;
    }
    if (/,/.test(s)) return s.replace(/\./g, '').replace(',', '.');
    if (/^\d{1,3}(\.\d{3})+$/.test(s.replace(/^-/, ''))) return s.replace(/\./g, '');
    return raw;
}
const $d110a042ff114667$export$d73ee8ef04f5226a = function(data, allowedFields = null, fieldspecs = null, locationTextField = 'location_address', translateOpts = {}) {
    const locClauseOpts = {
        explicitWarehouseOnly: translateOpts.explicitWarehouseOnly === true
    };
    let expression = '';
    let top_index = (0, $b60a2.getTopIndex)(data) + 1;
    let wrapOrGroup = false;
    const isNullOp = (op)=>op === 'nu' || op === 'nn';
    const willOutput = (i)=>{
        const f = data[`field-${i}`];
        const v = data[`value-${i}`];
        const op = data[`operator-${i}`];
        if (!f) return false;
        if (!isNullOp(op) && (v == null || v === '')) return false;
        if (allowedFields && !allowedFields.includes(f)) return false;
        if (f === 'location_id') return typeof v === 'string' && v.trim() !== '';
        return true;
    };
    for(let index = 0; index < top_index; index++){
        if (!willOutput(index)) continue;
        let open = data[`open-${index}`] == 1 ? '(' : '';
        let field = data[`field-${index}`];
        let operator = data[`operator-${index}`];
        let value = isNullOp(operator) ? data[`value-${index}`] != null && String(data[`value-${index}`]).trim() !== '' ? String(data[`value-${index}`]).trim() : '0' : $d110a042ff114667$var$normalizeFilterValueForFieldspec(field, data[`value-${index}`], fieldspecs);
        // Classes (agregada) e categoria: "igual a" funciona como "contém" (ILIKE).
        if (field === 'classes' || field === 'categoria') {
            if (operator === 'eq') operator = 'co';
            else if (operator === 'ne') operator = 'nc';
        }
        let close = data[`close-${index}`] == 1 ? ')' : '';
        let connector = data[`connector-${index}`];
        const hasNext = ()=>{
            for(let j = index + 1; j < top_index; j++)if (willOutput(j)) return true;
            return false;
        };
        const nextActiveIndex = ()=>{
            for(let j = index + 1; j < top_index; j++)if (willOutput(j)) return j;
            return -1;
        };
        const restContainsOr = ()=>{
            for(let j = index; j < top_index - 1; j++){
                if (!willOutput(j)) continue;
                if (String(data[`connector-${j}`] ?? '').trim() === ';') return true;
            }
            return false;
        };
        // Posição: texto (co/bw/ew…) → location_address; igual/diferente com par wh:id → dois campos inteiros; senão → texto no endereço (rótulo não resolvido).
        if (field === 'location_id') {
            const opLower = String(operator || 'eq').toLowerCase();
            if (/^\d+:\d+$/.test(String(value).trim())) {
                const idField = locationTextField === 'address' ? 'id' : 'location_id';
                let [wh, loc] = String(value).split(':');
                expression += `${open}warehouse_id*${operator}*${wh},${idField}*${operator}*${loc}${close}`;
            } else expression += $d110a042ff114667$var$appendLocationAddressClause(open, operator, value, close, locationTextField, true, locClauseOpts);
        } else if (field === 'address') expression += $d110a042ff114667$var$appendLocationAddressClause(open, operator, value, close, 'address', false, locClauseOpts);
        else if ($d110a042ff114667$var$isCompanyEntityKey(value) && (field === 'id' || /_id$/.test(field))) {
            // Multi-empresa no datalist: company_uuid:entity_id → company_id + campo
            const m = String(value).trim().match($d110a042ff114667$var$COMPANY_ENTITY_KEY);
            expression += `${open}company_id*eq*${m[1]},${field}*${operator}*${m[2]}${close}`;
        } else if (fieldspecs && $d110a042ff114667$var$fieldspecIsDatetime(fieldspecs, field)) {
            const expanded = $d110a042ff114667$var$expandDatetimeFilterClause(field, operator, value, open, close);
            expression += expanded ?? `${open}${field}*${operator}*${value}${close}`;
        } else expression += `${open}${field}*${operator}*${value}${close}`;
        if (hasNext()) {
            // Conector vazio entre linhas ativas → AND (evita colar cláusulas e quebrar filtro na API).
            let conn = connector != null && connector !== '' && connector !== -1 && connector !== '-1' ? connector : ',';
            // Posição "igual a" repetida em linhas consecutivas é seleção de múltiplas posições.
            // Força OR para evitar expressão impossível (A e B simultaneamente na mesma linha).
            const nextIdx = nextActiveIndex();
            if (nextIdx >= 0 && field === 'location_id' && String(operator || '').toLowerCase() === 'eq' && data[`field-${nextIdx}`] === 'location_id' && String(data[`operator-${nextIdx}`] || '').toLowerCase() === 'eq' && conn === ',') conn = ';';
            // Empresa/Armazém seguido de cláusulas com "Ou": forçar AND(escopo, OR(resto))
            // Se a próxima linha já traz open-1 (UX de grupos), não duplicar '(' — a API aceita só um nível.
            const nextRowHasOpen = ()=>{
                for(let j = index + 1; j < top_index; j++){
                    if (willOutput(j) && data[`open-${j}`] == 1) return true;
                }
                return false;
            };
            if ($d110a042ff114667$var$SCOPE_FIELDS.includes(field) && restContainsOr() && !wrapOrGroup && !nextRowHasOpen()) {
                const connAfter = String(data[`connector-${index}`] ?? '').trim();
                // Só AND(… OR …) quando o próximo vínculo é E. Se já é OU (;), não inserir ",(".
                if (connAfter === ',') {
                    expression += ',(';
                    wrapOrGroup = true;
                } else expression += conn;
            } else expression += conn;
        } else if (wrapOrGroup) {
            expression += ')';
            wrapOrGroup = false;
        }
    }
    if (wrapOrGroup) expression += ')';
    return expression;
};

const $d110a042ff114667$export$2e2bcd8739ae039 = {
    fields: null,
    formset: null,
    init (fields) {
        this.fields = fields;
        const filterable = (fields || []).filter((f)=>!f.computed);
        let options = (0, $b60a2.makeOptions)(filterable, 'field', [
            'label'
        ]);
        (0, $cMoQp.default).html = (0, $cMoQp.default).html.replace($d110a042ff114667$var$DATALIST, '$1' + options + '$3');
    },
    edit (callback, current_data, options = {}) {
        if (this._uiController?.destroy) try {
            this._uiController.destroy();
        } catch (_) {}
        else if (this.formset?.destroy) {
            try {
                this.formset.destroy();
            } catch (_) {}
            this.formset = null;
        }
        this.reloadLocations = options.reloadLocations || null;
        return (parcelRequire("7McYP")).then(({ openFilterModal: openFilterModal })=>openFilterModal(this, callback, current_data, options));
    }
};
const $d110a042ff114667$export$337c50f9de056b7 = function(data, fieldspecs = null) {
    if (!data) return;
    const top = (0, $b60a2.getTopIndex)(data) + 1;
    let hasWarehouse = false;
    let needsWarehouse = false;
    const isNullOp = (op)=>op === 'nu' || op === 'nn';
    for(let i = 0; i < top; i++){
        const f = data[`field-${i}`];
        const v = data[`value-${i}`];
        const op = String(data[`operator-${i}`] || '').toLowerCase();
        if (!f) continue;
        if (f === 'warehouse_id' && v != null && String(v).trim() !== '') hasWarehouse = true;
        if ((f === 'address' || f === 'location_id') && !isNullOp(op) && v != null && String(v).trim() !== '') {
            const text = String(v).trim();
            if (f === 'location_id' && /^\d+:\d+$/.test(text)) hasWarehouse = true;
            else if ($d110a042ff114667$var$combinedLocationAddressImpliesWarehouse(text)) hasWarehouse = true;
            else needsWarehouse = true;
        }
    }
    if (needsWarehouse && !hasWarehouse) throw new Error("Informe o armaz\xe9m antes de filtrar por posi\xe7\xe3o ou endere\xe7o.");
};
const $d110a042ff114667$export$f776883aa04b3f15 = (data, fieldspecs = null, options = {})=>{
    if (options.strict) $d110a042ff114667$export$337c50f9de056b7(data, fieldspecs);
    const allowed = fieldspecs?.length ? fieldspecs.map((fs)=>fs.field).filter(Boolean) : $d110a042ff114667$var$LOCATIONS_FIELDS;
    return $d110a042ff114667$var$compactLocationAddressOrExpression($d110a042ff114667$export$d73ee8ef04f5226a(data, allowed, fieldspecs, 'address', {
        explicitWarehouseOnly: true
    }));
};
const $d110a042ff114667$export$a7d2a463aa33d240 = {
    filterLocationOptionsBySearch: $d110a042ff114667$var$filterLocationOptionsBySearch,
    normalizeLocationAddressText: $d110a042ff114667$var$normalizeLocationAddressText,
    parseCombinedLocationAddress: $d110a042ff114667$var$parseCombinedLocationAddress,
    uppercaseLocationAddressLetters: $d110a042ff114667$var$uppercaseLocationAddressLetters,
    validateLocationsFilterWarehouseRequired: $d110a042ff114667$export$337c50f9de056b7,
    combinedLocationAddressImpliesWarehouse: $d110a042ff114667$var$combinedLocationAddressImpliesWarehouse
};

});
parcelRegister("7WMRl", function(module, exports) {

$parcel$export(module.exports, "fmtLocAddr", () => $5c93d9a7e9c2dd99$export$1f7cc11911535da6);
$parcel$export(module.exports, "resolveCompanyId", () => $5c93d9a7e9c2dd99$export$eedcb4a6cd9ae5f7);
$parcel$export(module.exports, "resolveWarehouseId", () => $5c93d9a7e9c2dd99$export$5949e8191b0adb6e);
$parcel$export(module.exports, "fetchWarehouseLocations", () => $5c93d9a7e9c2dd99$export$730188790617765b);
$parcel$export(module.exports, "resolveLocationIdForMove", () => $5c93d9a7e9c2dd99$export$3b82772f3064e5a8);
/**
 * Busca e resolução de posições (endereços) — pesquisa case-sensitive na API.
 * Sempre exige `warehouse_id` ativo no filtro (API valida).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");
const $5c93d9a7e9c2dd99$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function $5c93d9a7e9c2dd99$var$warehousesActiveOnly(rows) {
    return (Array.isArray(rows) ? rows : []).filter((r)=>!(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1'));
}
function $5c93d9a7e9c2dd99$var$escapeFilterToken(s) {
    return String(s ?? '').replace(/[*,]/g, '');
}
/** Endereço completo digitado (ex.: 5-O-10-1) — busca exata cb+ce em vez de contém. */ function $5c93d9a7e9c2dd99$var$looksLikeFullLocationAddress(s) {
    const t = String(s ?? '').trim();
    return /^[\dA-Za-z]+(-[\dA-Za-z]+){2,}$/.test(t);
}
function $5c93d9a7e9c2dd99$export$1f7cc11911535da6(a) {
    return Array.isArray(a) ? a.join('-') : String(a ?? '');
}
async function $5c93d9a7e9c2dd99$export$eedcb4a6cd9ae5f7(raw) {
    const v = String(raw ?? '').trim();
    if (!v) return null;
    if ($5c93d9a7e9c2dd99$var$UUID_REGEX.test(v)) return v;
    const companies = await (0, $1cmSR.default).list('companies').catch(()=>[]);
    const c = companies.find((x)=>(x.nick || '') === v || String(x.nick || '') === v || (x.name || '') === v || String(x.name || '') === v);
    const id = c?.id;
    return id && $5c93d9a7e9c2dd99$var$UUID_REGEX.test(String(id)) ? String(id) : null;
}
async function $5c93d9a7e9c2dd99$export$5949e8191b0adb6e(companyId, raw) {
    const v = String(raw ?? '').trim();
    if (!v) return NaN;
    const n = Number(v);
    if (Number.isInteger(n) && n >= 1) return n;
    const warehouses = $5c93d9a7e9c2dd99$var$warehousesActiveOnly(await (0, $1cmSR.default).list('warehouses').catch(()=>[]));
    const scoped = companyId ? warehouses.filter((w)=>String(w.company_id) === String(companyId)) : warehouses;
    const w = scoped.find((x)=>(x.name || '') === v || String(x.name || '') === v || String(x.id) === v);
    return w?.id != null ? Number(w.id) : NaN;
}
async function $5c93d9a7e9c2dd99$export$730188790617765b(companyId, warehouseId, opts = {}) {
    const co = String(companyId ?? '').trim();
    const wh = Number(warehouseId);
    if (!co || !Number.isInteger(wh) || wh < 1) return [];
    const parts = [
        `company_id*eq*${co}`,
        `warehouse_id*eq*${wh}`
    ];
    if (opts.isExpedition === true) parts.push('is_expedition*eq*true');
    const term = String(opts.search ?? '').trim();
    if (term) {
        const tok = $5c93d9a7e9c2dd99$var$escapeFilterToken(term);
        if (opts.exactAddress || $5c93d9a7e9c2dd99$var$looksLikeFullLocationAddress(term)) parts.push(`address*cb*${tok},address*ce*${tok}`);
        else parts.push(`address*cc*${tok}`);
    }
    const params = new URLSearchParams();
    params.append('filter', parts.join(','));
    params.append('sort', '4');
    params.append('limit', String(term ? opts.limit ?? 80 : opts.limit ?? 0));
    const q = `?${params.toString()}`;
    const rows = opts.silent ? await $5c93d9a7e9c2dd99$var$fetchLocationsSilent(q) : await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, q);
    return Array.isArray(rows) ? rows : [];
}
/** Busca posições sem msgbox «Carregando…» (digitação no datalist). */ async function $5c93d9a7e9c2dd99$var$fetchLocationsSilent(query) {
    try {
        const res = await fetch(`${(0, $9VcS9.getSialApiHost)()}/locations${query}`, {
            method: 'GET',
            credentials: 'include'
        });
        if (!res.ok) return [];
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (_) {
        return [];
    }
}
async function $5c93d9a7e9c2dd99$export$3b82772f3064e5a8(companyId, warehouseId, raw, opts = {}) {
    const rawStr = String(raw ?? '').trim();
    if (!rawStr) return NaN;
    const n = Number(rawStr);
    if (Number.isInteger(n) && n >= 1) return n;
    const co = await $5c93d9a7e9c2dd99$export$eedcb4a6cd9ae5f7(companyId) || companyId;
    const wh = await $5c93d9a7e9c2dd99$export$5949e8191b0adb6e(co, warehouseId);
    if (!Number.isInteger(wh) || wh < 1) return NaN;
    const exact = $5c93d9a7e9c2dd99$var$looksLikeFullLocationAddress(rawStr);
    const rows = await $5c93d9a7e9c2dd99$export$730188790617765b(co, wh, {
        search: rawStr,
        limit: 80,
        silent: true,
        exactAddress: exact,
        isExpedition: opts.isExpedition === true
    });
    if (!rows.length) return NaN;
    if (rows.length === 1) return Number(rows[0].id);
    const want = rawStr;
    for (const r of rows){
        if ($5c93d9a7e9c2dd99$export$1f7cc11911535da6(r.address) === want) return Number(r.id);
    }
    return NaN;
}

});

parcelRegister("cMoQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $94dd3d467e908cbc$export$2e2bcd8739ae039);
parcelRequire("93O8T");
var $9PIz7 = parcelRequire("9PIz7");
var $1fpKo = parcelRequire("1fpKo");
var $6Jl4s = parcelRequire("6Jl4s");
var $94dd3d467e908cbc$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#filter.filter-v2 {
				max-width: 52rem; width: 96vw;
				max-height: min(90vh, 48rem);
				display: flex; flex-direction: column;
				overflow: hidden;
				background: var(--color-box, #fff);
				padding: 0.85rem 1rem;
				border-radius: 8px;
				box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
			}
			#filter .filter-v2-header,
			#filter .filter-v2-tabs,
			#filter .filter-v2-compat,
			#filter .filter-v2-footer {
				flex-shrink: 0;
			}
			#filter .filter-v2-panel.active {
				flex: 1 1 auto;
				min-height: 0;
				overflow-x: hidden;
				overflow-y: auto;
				-webkit-overflow-scrolling: touch;
				padding-right: 0.15rem;
			}
			#filter .filter-v2-header {
				display: flex; align-items: center; justify-content: space-between;
				flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.75rem;
			}
			#filter .filter-v2-header h2 { margin: 0; font-size: 1.15rem; font-weight: 600; }
			#filter .filter-v2-header-actions { display: flex; flex-wrap: wrap; gap: 0.4rem; align-items: center; }
			#filter .filter-v2-tabs {
				display: flex; gap: 0; border-bottom: 2px solid var(--color-border, #e0e0e0); margin-bottom: 0.75rem;
			}
			#filter .filter-v2-tab {
				padding: 0.45rem 1rem; border: none; background: transparent; cursor: pointer;
				font: inherit; border-bottom: 2px solid transparent; margin-bottom: -2px;
			}
			#filter .filter-v2-tab.active {
				border-bottom-color: #2563eb; color: #2563eb; font-weight: 600;
			}
			#filter .filter-v2-panel { display: none; }
			#filter .filter-v2-panel.active { display: block; }
			#filter .filter-v2-compat {
				font-size: 0.82rem; color: #92400e; background: #fffbeb; border: 1px solid #fcd34d;
				padding: 0.4rem 0.6rem; border-radius: 4px; margin-bottom: 0.6rem;
			}
			#filter .filter-v2-status {
				font-size: 0.85rem; margin: 0.5rem 0; min-height: 1.2em;
			}
			#filter .filter-v2-status.ok { color: #166534; }
			#filter .filter-v2-status.err { color: var(--color-error, red); }
			#filter .filter-v2-groups { display: flex; flex-direction: column; gap: 0.75rem; }
			#filter .filter-v2-group {
				border: 1px solid var(--color-border, #e0e0e0); border-radius: 8px;
				background: var(--color-secondary, #fafafa); padding: 0.65rem 0.75rem;
			}
			#filter .filter-v2-group.main { border-color: #86efac; background: #f0fdf4; }
			#filter .filter-v2-group.or-group { border-color: #93c5fd; background: #eff6ff; }
			#filter .filter-v2-group-head {
				display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem;
				margin-bottom: 0.5rem; font-size: 0.9rem; font-weight: 600;
			}
			#filter .filter-v2-group-head select {
				font: inherit; padding: 0.2rem 0.4rem; border-radius: 4px;
				border: 1px solid var(--color-border, #e0e0e0);
			}
			#filter .filter-v2-cond {
				display: grid; grid-template-columns: 1.2fr 1.1fr 1.4fr auto;
				gap: 0.35rem; align-items: center; margin-bottom: 0.35rem;
			}
			@media (max-width: 640px) {
				#filter .filter-v2-cond { grid-template-columns: 1fr; }
			}
			#filter .filter-v2-cond input[type="text"],
			#filter .filter-v2-cond input[type="date"] {
				width: 100%; box-sizing: border-box; padding: 0.35rem 0.45rem;
				border: 1px solid var(--color-border, #e0e0e0); border-radius: 4px;
			}
			#filter .filter-v2-cond input[data-error] { border-color: var(--color-error, red); }
			#filter .filter-v2-cond-remove {
				border: none; background: transparent; cursor: pointer; padding: 0.25rem;
				display: flex; align-items: center; justify-content: center;
			}
			#filter .filter-v2-cond-remove img { width: 1.25rem; height: 1.25rem; opacity: 0.75; }
			#filter .filter-v2-group-actions { margin-top: 0.35rem; }
			#filter .filter-v2-btn-text {
				font: inherit; padding: 0.35rem 0.75rem; border-radius: 4px; cursor: pointer;
				border: 1px solid var(--color-border, #e0e0e0); background: var(--color-box, #fff);
			}
			#filter .filter-v2-btn-text.primary {
				background: #2563eb; color: #fff; border-color: #2563eb;
			}
			#filter .filter-v2-btn-text.primary:disabled { opacity: 0.55; cursor: wait; }
			#filter .filter-v2-btn-text.link { border: none; background: transparent; color: #2563eb; text-decoration: underline; }
			#filter .filter-v2-footer {
				display: flex; justify-content: space-between; align-items: center;
				flex-wrap: wrap; gap: 0.5rem; margin-top: 1rem; padding-top: 0.75rem;
				border-top: 1px solid var(--color-border, #e0e0e0);
			}
			#filter .filter-v2-preview {
				font-family: ui-monospace, monospace; font-size: 0.82rem;
				background: #f8fafc; border: 1px solid var(--color-border, #e0e0e0);
				border-radius: 6px; padding: 0.75rem; white-space: pre-wrap; min-height: 8rem;
			}
			#filter .filter-v2-preview-title { font-size: 0.85rem; font-weight: 600; margin: 0.5rem 0 0.25rem; }
			#filter .filter-csv-tools { display: none; }
		</style>
		<form id="filter" class="form filter-v2" autocomplete="off">
			<datalist id="fields"></datalist>
			<datalist id="operators"></datalist>
			<input type="file" id="filter-import-csv" accept=".csv,text/csv,text/plain" style="display:none" />

			<div class="filter-v2-header">
				<h2>Filtros avan\xe7ados</h2>
				<div class="filter-v2-header-actions">
					<button type="button" class="filter-v2-btn-text" id="filter-btn-import-csv">Importar CSV</button>
					<button type="button" class="filter-v2-btn-text link" id="filter-btn-csv-template">Modelo CSV</button>
					<button type="button" class="filter-v2-btn-text bn_Escape" id="filter-btn-close-header">Fechar</button>
				</div>
			</div>

			<div class="filter-v2-tabs" role="tablist">
				<button type="button" class="filter-v2-tab active" data-tab="builder" role="tab">Construtor</button>
				<button type="button" class="filter-v2-tab" data-tab="preview" role="tab">Visualizar express\xe3o</button>
			</div>

			<div id="filter-compat-banner" class="filter-v2-compat" style="display:none">
				Filtro avan\xe7ado carregado em modo compat\xedvel.
			</div>

			<div id="filter-panel-builder" class="filter-v2-panel active" role="tabpanel">
				<div id="filter-groups-root" class="filter-v2-groups"></div>
				<button type="button" class="filter-v2-btn-text" id="filter-btn-add-group">+ Adicionar grupo</button>
				<div id="filter-validation-status" class="filter-v2-status"></div>
			</div>

			<div id="filter-panel-preview" class="filter-v2-panel" role="tabpanel">
				<p class="filter-v2-preview-title">Express\xe3o amig\xe1vel</p>
				<pre id="filter-preview-friendly" class="filter-v2-preview"></pre>
				<p class="filter-v2-preview-title">Express\xe3o t\xe9cnica</p>
				<pre id="filter-preview-technical" class="filter-v2-preview"></pre>
			</div>

			<div class="filter-v2-footer">
				<button type="button" class="filter-v2-btn-text" id="filter-btn-clear-all">Limpar tudo</button>
				<span>
					<button type="button" class="filter-v2-btn-text bn_Escape" id="filter-btn-cancel">Cancelar</button>
					<button type="button" class="filter-v2-btn-text primary bn_Enter" id="filter-btn-apply">Aplicar filtro</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#filter'
    },
    /** Modelos para registro dinâmico de linhas (field-N, operator-N, value-N). */ rowFieldSpecs: [
        {
            properties: {
                selector: '#field-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#operator-0'
            },
            types: [
                $1fpKo.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#value-0'
            },
            types: []
        }
    ]
};

});

parcelRegister("7McYP", function(module, exports) {
module.exports = import("ajQRh").then(()=>parcelRequire('9OPFm'));

});


parcelRegister("9m9G5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cfdaceae8752137$export$2e2bcd8739ae039);
/**
 * Modal de detalhe de caixa de picking.
 *
 * Exibe cabeçalho da caixa (status, lacre, usuários, timestamps, notas)
 * e grade de itens (linha, SKU, produto, lote, quantidade, unidade, embalagem).
 * Permite cancelar caixa quando aplicável.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");

var $jU7Ru = parcelRequire("jU7Ru");
function $6cfdaceae8752137$var$buildItemsTable(items, users) {
    if (!items || !items.length) return '<p style="color:#888;font-style:italic;margin:0.5rem 0">Nenhum item registrado nesta caixa.</p>';
    const rows = items.map((item)=>{
        const createdByName = item.created_by_username || (users || {})[item.created_by] || item.created_by || "\u2014";
        return `<tr>
			<td>${(0, $jU7Ru.escHtml)(item.output_item_number)}</td>
			<td>${(0, $jU7Ru.escHtml)(item.sku || "\u2014")}</td>
			<td>${(0, $jU7Ru.escHtml)(item.product_name || item.product_id || "\u2014")}</td>
			<td>${(0, $jU7Ru.escHtml)(item.lot_code || (item.lot_id ? `#${item.lot_id}` : "\u2014"))}</td>
			<td style="text-align:right">${(0, $jU7Ru.escHtml)(item.quantity)}</td>
			<td>${(0, $jU7Ru.escHtml)(item.unit_name || item.unit_id || "\u2014")}</td>
			<td>${(0, $jU7Ru.escHtml)(item.packaging_name || item.packaging_id || "\u2014")}</td>
			<td>${(0, $jU7Ru.escHtml)(createdByName)}</td>
			<td>${(0, $jU7Ru.fmtDt)(item.created_at)}</td>
		</tr>`;
    }).join('');
    return `
		<table style="width:100%;border-collapse:collapse;font-size:0.88em;margin-top:0.25rem">
			<thead>
				<tr style="background:#f0f0f0">
					<th style="padding:4px 6px;text-align:left">Linha</th>
					<th style="padding:4px 6px;text-align:left">SKU</th>
					<th style="padding:4px 6px;text-align:left">Produto</th>
					<th style="padding:4px 6px;text-align:left">Lote</th>
					<th style="padding:4px 6px;text-align:right">Qtd.</th>
					<th style="padding:4px 6px;text-align:left">Unidade</th>
					<th style="padding:4px 6px;text-align:left">Embalagem</th>
					<th style="padding:4px 6px;text-align:left">Registrado por</th>
					<th style="padding:4px 6px;text-align:left">Registrado em</th>
				</tr>
			</thead>
			<tbody>
				${rows}
			</tbody>
		</table>
	`;
}
async function $6cfdaceae8752137$export$2e2bcd8739ae039(companyId, outputId, boxId, onCancel) {
    // Carrega dados
    let boxData;
    try {
        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId);
        const boxes = resp?.boxes || [];
        boxData = boxes.find((b)=>b.id === boxId || String(b.id) === String(boxId));
    } catch (e) {
        (0, $jUNyh.notify)(e?.message || 'Erro ao carregar dados da caixa.', 'Erro');
        return;
    }
    if (!boxData) {
        (0, $jUNyh.notify)("Caixa n\xe3o encontrada.", 'Detalhe da Caixa');
        return;
    }
    const statusLabel = (0, $jU7Ru.STATUS_BOX_LABEL)[boxData.status] || boxData.status;
    const statusStyle = (0, $jU7Ru.STATUS_BOX_STYLE)[boxData.status] || '';
    const canCancel = boxData.status === 10 || boxData.status === 20;
    const canOperate = boxData.status === 10;
    const items = boxData.items || [];
    const infoRows = [
        [
            'Caixa',
            (0, $jU7Ru.escHtml)(boxData.code)
        ],
        [
            'Lacre',
            (0, $jU7Ru.escHtml)(boxData.seal_code || "\u2014")
        ],
        [
            "Sa\xedda",
            (0, $jU7Ru.escHtml)(boxData.output_id)
        ],
        [
            'Status',
            `<span style="display:inline-block;padding:2px 8px;border-radius:3px;font-weight:600;font-size:0.9em;${statusStyle}">${(0, $jU7Ru.escHtml)(statusLabel)}</span>`
        ],
        [
            'Aberta por',
            (0, $jU7Ru.escHtml)(boxData.opened_by_username || boxData.opened_by || "\u2014")
        ],
        [
            'Aberta em',
            (0, $jU7Ru.fmtDt)(boxData.opened_at)
        ],
        [
            'Lacrada por',
            (0, $jU7Ru.escHtml)(boxData.closed_by_username || boxData.closed_by || "\u2014")
        ],
        [
            'Lacrada em',
            (0, $jU7Ru.fmtDt)(boxData.closed_at)
        ],
        [
            'Cancelada por',
            (0, $jU7Ru.escHtml)(boxData.canceled_by_username || boxData.canceled_by || "\u2014")
        ],
        [
            'Cancelada em',
            (0, $jU7Ru.fmtDt)(boxData.canceled_at)
        ],
        [
            "Observa\xe7\xf5es",
            (0, $jU7Ru.escHtml)(boxData.notes || "\u2014")
        ]
    ].map(([label, val])=>`<tr>
			<td style="padding:3px 8px 3px 0;font-weight:600;white-space:nowrap;color:#555">${label}</td>
			<td style="padding:3px 0">${val}</td>
		</tr>`).join('');
    const cancelButton = canCancel ? `<button type="button" class="button mtl btn-do-cancel">Cancelar Caixa</button>` : '';
    const operateButtons = canOperate ? `<button type="button" class="button mtl btn-do-add-items">Adicionar Itens</button>
		   <button type="button" class="button mtl btn-do-close">Lacrar Caixa</button>` : '';
    const html = `
		<div class="msgbox" style="min-width:520px;max-width:760px">
			<div class="mb-title">Detalhe da Caixa \u{2014} ${(0, $jU7Ru.escHtml)(boxData.code)}</div>
			<div class="mb-text" style="max-height:75vh;overflow-y:auto">

				<table style="border-collapse:collapse;font-size:0.9em;margin-bottom:1rem">
					<tbody>${infoRows}</tbody>
				</table>

				<strong style="display:block;margin-bottom:0.4rem;font-size:0.9em">Itens da Caixa</strong>
				${$6cfdaceae8752137$var$buildItemsTable(items, {})}

			</div>
			${operateButtons}
			${cancelButton}
			<button type="button" class="button mtl bn_N">Fechar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') dlg.destroy();
    }, /Escape|N/);
    const afterBoxOp = async ()=>{
        if (typeof onCancel === 'function') onCancel();
        await $6cfdaceae8752137$export$2e2bcd8739ae039(companyId, outputId, boxId, onCancel);
    };
    if (canOperate) {
        const addBtn = dlg.getNode().querySelector('.btn-do-add-items');
        if (addBtn) addBtn.addEventListener('click', ()=>{
            dlg.destroy();
            (0, $jU7Ru.openAddItemsModal)(companyId, outputId, boxId, boxData.code, afterBoxOp);
        });
        const closeBtn = dlg.getNode().querySelector('.btn-do-close');
        if (closeBtn) closeBtn.addEventListener('click', ()=>{
            dlg.destroy();
            (0, $jU7Ru.openCloseBoxModal)(companyId, outputId, boxId, boxData.code, items.length, afterBoxOp);
        });
    }
    if (canCancel) {
        const cancelBtn = dlg.getNode().querySelector('.btn-do-cancel');
        if (cancelBtn) cancelBtn.addEventListener('click', ()=>{
            dlg.destroy();
            $6cfdaceae8752137$var$openCancelConfirm(companyId, outputId, boxId, boxData.code, onCancel);
        });
    }
}
/** Modal de confirmação do cancelamento da caixa. */ function $6cfdaceae8752137$var$openCancelConfirm(companyId, outputId, boxId, boxCode, onSuccess) {
    (0, $jU7Ru.openCancelBoxModal)(companyId, outputId, boxId, boxCode, onSuccess);
}

});
parcelRegister("jU7Ru", function(module, exports) {

$parcel$export(module.exports, "STATUS_BOX_LABEL", () => $e7d9587498be27e7$export$ea013d6dcd4fc560);
$parcel$export(module.exports, "STATUS_BOX_STYLE", () => $e7d9587498be27e7$export$7b8642852381b09b);
$parcel$export(module.exports, "BOX_CTRL_HINT", () => $e7d9587498be27e7$export$dfb43d8d818491fb);
$parcel$export(module.exports, "escHtml", () => $e7d9587498be27e7$export$63e59f033fa91051);
$parcel$export(module.exports, "fmtDt", () => $e7d9587498be27e7$export$39ad18838a4982c);
$parcel$export(module.exports, "sumQtyByLine", () => $e7d9587498be27e7$export$ce12c46ad3076124);
$parcel$export(module.exports, "openCancelBoxModal", () => $e7d9587498be27e7$export$15c2c7ddbc5a85ed);
$parcel$export(module.exports, "openCreateBoxModal", () => $e7d9587498be27e7$export$6ba48b07ffcf0226);
$parcel$export(module.exports, "openAddItemsModal", () => $e7d9587498be27e7$export$6b3ac45d14c8aed5);
$parcel$export(module.exports, "openCloseBoxModal", () => $e7d9587498be27e7$export$a4eb2582af6677b8);
$parcel$export(module.exports, "renderBoxActionButtons", () => $e7d9587498be27e7$export$1e8bbb6c3229b970);
$parcel$export(module.exports, "openPickingBoxesForOutputModal", () => $e7d9587498be27e7$export$a41b4e6a6f728af0);
/**
 * Operações Web de caixas de picking — módulo compartilhado.
 *
 * Usado pela Gestão de Caixas, tela de Saídas e Conferência de Saída.
 * Controle de caixa picking (out_enable_box_control) é independente do
 * picking otimizado / hierarquia de embalagens (pkg_*).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");
const $e7d9587498be27e7$export$ea013d6dcd4fc560 = {
    10: 'Aberta',
    20: 'Lacrada',
    30: 'Cancelada'
};
const $e7d9587498be27e7$export$7b8642852381b09b = {
    10: 'background:#d4edda;color:#155724',
    20: 'background:#cce5ff;color:#004085',
    30: 'background:#f8d7da;color:#721c24'
};
const $e7d9587498be27e7$export$dfb43d8d818491fb = "O controle de caixas de picking \xe9 independente do picking otimizado e das embalagens secund\xe1rias/terci\xe1rias.";
function $e7d9587498be27e7$export$63e59f033fa91051(v) {
    if (v == null) return '';
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $e7d9587498be27e7$export$39ad18838a4982c(v) {
    if (!v) return "\u2014";
    try {
        const d = new Date(v);
        return d.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (_) {
        return String(v);
    }
}
function $e7d9587498be27e7$export$ce12c46ad3076124(boxes, excludeBoxId = null) {
    const sums = {};
    for (const box of boxes || []){
        if (Number(box.status) === 30) continue;
        if (excludeBoxId && String(box.id) === String(excludeBoxId)) continue;
        for (const item of box.items || []){
            const num = Number(item.output_item_number);
            sums[num] = (sums[num] || 0) + (Number(item.quantity) || 0);
        }
    }
    return sums;
}
function $e7d9587498be27e7$export$15c2c7ddbc5a85ed(companyId, outputId, boxId, boxCode, onSuccess) {
    const html = `
		<div class="msgbox" style="min-width:360px;max-width:520px">
			<div class="mb-title">Cancelar Caixa</div>
			<div class="mb-text">
				<p style="margin:0 0 0.75rem">
					Confirma o cancelamento da caixa <strong>${$e7d9587498be27e7$export$63e59f033fa91051(boxCode)}</strong>?
				</p>
				<p style="margin:0 0 0.5rem;color:#888;font-size:0.92em">
					Os itens ser\xe3o mantidos para auditoria. Esta a\xe7\xe3o n\xe3o pode ser desfeita.
				</p>
				<label style="display:block;font-size:0.9em;margin-top:0.75rem">
					Observa\xe7\xe3o (opcional):
					<textarea id="cancel-box-notes" rows="2"
						style="display:block;width:100%;margin-top:0.25rem;box-sizing:border-box;padding:0.3rem;font-size:0.9em;resize:vertical"
						placeholder="Motivo do cancelamento..."></textarea>
				</label>
			</div>
			<button type="button" class="button mtl bn_N">Voltar</button>
			<button type="button" class="button mtl bn_Y">Confirmar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key === 'Y') {
            const notes = dlg.getNode().querySelector('#cancel-box-notes')?.value?.trim() || null;
            dlg.destroy();
            try {
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).cancel_output_picking_box, companyId, outputId, boxId, {
                    notes: notes
                });
                if (result?.error) {
                    (0, $jUNyh.notify)(result.error, 'Erro ao Cancelar');
                    return;
                }
                (0, $jUNyh.notify)(`Caixa "${$e7d9587498be27e7$export$63e59f033fa91051(boxCode)}" cancelada com sucesso.`, 'Caixa Cancelada');
                if (typeof onSuccess === 'function') onSuccess();
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
        }
    }, /Enter|Escape|N|Y/);
}
function $e7d9587498be27e7$export$6ba48b07ffcf0226(companyId, outputId, onSuccess, opts = {}) {
    const presetOutput = outputId || opts.initialOutputId || '';
    const showOutputField = !presetOutput;
    const html = `
		<div class="msgbox" style="min-width:400px;max-width:560px">
			<div class="mb-title">Abrir Caixa</div>
			<div class="mb-text">
				<p style="margin:0 0 0.75rem;color:#666;font-size:0.88em">${$e7d9587498be27e7$export$63e59f033fa91051($e7d9587498be27e7$export$dfb43d8d818491fb)}</p>
				${showOutputField ? `
				<label style="display:block;font-size:0.9em;margin-bottom:0.6rem">
					Sa\xedda<sup>*</sup>
					<input id="pkbox-create-output" type="number" min="1" step="1"
						style="display:block;width:100%;margin-top:0.25rem;box-sizing:border-box;padding:0.35rem"
						placeholder="N\xfamero da sa\xedda" autocomplete="off">
				</label>` : `<input type="hidden" id="pkbox-create-output" value="${$e7d9587498be27e7$export$63e59f033fa91051(presetOutput)}">`}
				<label style="display:block;font-size:0.9em;margin-bottom:0.6rem">
					C\xf3digo da caixa<sup>*</sup>
					<input id="pkbox-create-code" type="text" maxlength="40"
						style="display:block;width:100%;margin-top:0.25rem;box-sizing:border-box;padding:0.35rem"
						placeholder="Ex.: 00001" autocomplete="off">
				</label>
				<label style="display:block;font-size:0.9em">
					Observa\xe7\xe3o (opcional)
					<textarea id="pkbox-create-notes" rows="2"
						style="display:block;width:100%;margin-top:0.25rem;box-sizing:border-box;padding:0.35rem;font-size:0.9em;resize:vertical"
						placeholder="Observa\xe7\xf5es sobre a caixa..."></textarea>
				</label>
				<p style="margin:0.75rem 0 0;color:#888;font-size:0.82em">
					O n\xfamero do lacre \xe9 opcional e pode ser informado ao lacrar a caixa.
				</p>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Abrir Caixa</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        const node = dlg.getNode();
        const outRaw = node.querySelector('#pkbox-create-output')?.value?.trim();
        const code = node.querySelector('#pkbox-create-code')?.value?.trim();
        const notes = node.querySelector('#pkbox-create-notes')?.value?.trim() || null;
        if (!outRaw) {
            (0, $jUNyh.notify)("Informe o n\xfamero da sa\xedda.", 'Abrir Caixa');
            node.querySelector('#pkbox-create-output')?.focus();
            return;
        }
        if (!code) {
            (0, $jUNyh.notify)("Informe o c\xf3digo da caixa.", 'Abrir Caixa');
            node.querySelector('#pkbox-create-code')?.focus();
            return;
        }
        const outId = parseInt(outRaw, 10);
        if (!Number.isFinite(outId) || outId < 1) {
            (0, $jUNyh.notify)("N\xfamero da sa\xedda inv\xe1lido.", 'Abrir Caixa');
            return;
        }
        try {
            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).create_output_picking_box, companyId, outId, {
                code: code,
                notes: notes
            });
            if (result?.error) {
                (0, $jUNyh.notify)(result.error, 'Erro ao Abrir Caixa');
                return;
            }
            dlg.destroy();
            (0, $jUNyh.notify)(`Caixa "${$e7d9587498be27e7$export$63e59f033fa91051(code)}" aberta com sucesso.`, 'Caixa Aberta');
            if (typeof onSuccess === 'function') onSuccess(result, outId);
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        }
    }, /Enter|Escape|N|Y/);
    const codeInput = dlg.getNode().querySelector('#pkbox-create-code');
    if (codeInput) codeInput.focus();
}
async function $e7d9587498be27e7$export$6b3ac45d14c8aed5(companyId, outputId, boxId, boxCode, onSuccess) {
    let output;
    let boxes;
    try {
        [output, boxes] = await Promise.all([
            (0, $9VcS9.default).call((0, $9VcS9.default).select_output, companyId, outputId),
            (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId).then((r)=>r?.boxes || [])
        ]);
    } catch (e) {
        (0, $jUNyh.notify)(e?.message || "Erro ao carregar dados da sa\xedda.", 'Adicionar Itens');
        return;
    }
    if (!output?.items?.length) {
        (0, $jUNyh.notify)("A sa\xedda n\xe3o possui itens para alocar na caixa.", 'Adicionar Itens');
        return;
    }
    const box = (boxes || []).find((b)=>String(b.id) === String(boxId));
    if (!box || Number(box.status) !== 10) {
        (0, $jUNyh.notify)('Somente caixas abertas permitem adicionar itens.', 'Adicionar Itens');
        return;
    }
    const qtyOthers = $e7d9587498be27e7$export$ce12c46ad3076124(boxes, boxId);
    const qtyInBox = {};
    for (const item of box.items || [])qtyInBox[Number(item.output_item_number)] = Number(item.quantity) || 0;
    const rows = output.items.map((item)=>{
        const num = Number(item.number);
        const required = Number(item.quantity_required) || 0;
        const inOthers = qtyOthers[num] || 0;
        const inBox = qtyInBox[num] || 0;
        const available = Math.max(0, required - inOthers);
        const sku = item.product_sku ? String(item.product_sku).trim() : '';
        const name = item.product_name ? String(item.product_name).trim() : `Produto #${item.product_id}`;
        const lot = item.lot_number ? String(item.lot_number).trim() : "\u2014";
        const disabled = available <= 0 && inBox <= 0;
        return `<tr data-line="${num}"${disabled ? ' style="opacity:0.55"' : ''}>
			<td style="padding:4px 6px">${num}</td>
			<td style="padding:4px 6px">
				<div style="font-size:0.72rem;color:#666">${$e7d9587498be27e7$export$63e59f033fa91051(sku)}</div>
				<div>${$e7d9587498be27e7$export$63e59f033fa91051(name)}</div>
			</td>
			<td style="padding:4px 6px">${$e7d9587498be27e7$export$63e59f033fa91051(lot)}</td>
			<td style="padding:4px 6px;text-align:right">${required}</td>
			<td style="padding:4px 6px;text-align:right">${inOthers}</td>
			<td style="padding:4px 6px;text-align:right;font-weight:600">${available}</td>
			<td style="padding:4px 6px;text-align:right">
				<input type="number" class="pkbox-item-qty" data-line="${num}" data-max="${available + inBox}"
					min="0" max="${available + inBox}" step="1" value="${inBox}"
					${disabled ? 'disabled' : ''}
					style="width:5rem;text-align:right;padding:2px 4px">
			</td>
		</tr>`;
    }).join('');
    const html = `
		<div class="msgbox" style="min-width:640px;max-width:920px">
			<div class="mb-title">Adicionar Itens \u{2014} Caixa ${$e7d9587498be27e7$export$63e59f033fa91051(boxCode)}</div>
			<div class="mb-text" style="max-height:70vh;overflow-y:auto">
				<p style="margin:0 0 0.5rem;color:#666;font-size:0.85em">
					Informe a quantidade consolidada por linha nesta caixa. O saldo dispon\xedvel considera as demais caixas n\xe3o canceladas.
				</p>
				<div style="overflow-x:auto">
					<table style="width:100%;border-collapse:collapse;font-size:0.86em">
						<thead>
							<tr style="background:#f0f0f0">
								<th style="padding:4px 6px;text-align:left">Linha</th>
								<th style="padding:4px 6px;text-align:left">Produto</th>
								<th style="padding:4px 6px;text-align:left">Lote sep.</th>
								<th style="padding:4px 6px;text-align:right">Req.</th>
								<th style="padding:4px 6px;text-align:right">Outras cx.</th>
								<th style="padding:4px 6px;text-align:right">Dispon\xedvel</th>
								<th style="padding:4px 6px;text-align:right">Nesta caixa</th>
							</tr>
						</thead>
						<tbody>${rows}</tbody>
					</table>
				</div>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Salvar Itens</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        const node = dlg.getNode();
        const itemsPayload = [];
        for (const input of node.querySelectorAll('.pkbox-item-qty:not([disabled])')){
            const line = parseInt(input.dataset.line, 10);
            const max = parseInt(input.dataset.max, 10);
            const raw = input.value.trim();
            if (raw === '' || isNaN(Number(raw))) continue;
            const qty = parseInt(raw, 10);
            if (qty <= 0) continue;
            if (qty > max) {
                (0, $jUNyh.notify)(`Linha ${line}: quantidade (${qty}) ultrapassa o saldo dispon\xedvel (${max}).`, 'Adicionar Itens');
                input.focus();
                return;
            }
            const orig = output.items.find((i)=>Number(i.number) === line);
            itemsPayload.push({
                output_item_number: line,
                quantity: qty,
                lot_id: orig?.lot_id ?? null,
                sku: orig?.product_sku ?? null
            });
        }
        if (!itemsPayload.length) {
            (0, $jUNyh.notify)('Informe ao menos uma linha com quantidade maior que zero.', 'Adicionar Itens');
            return;
        }
        try {
            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).set_output_picking_box_items, companyId, outputId, boxId, {
                items: itemsPayload
            });
            if (result?.error) {
                (0, $jUNyh.notify)(result.error, 'Erro ao Salvar Itens');
                return;
            }
            dlg.destroy();
            (0, $jUNyh.notify)('Itens salvos na caixa com sucesso.', 'Adicionar Itens');
            if (typeof onSuccess === 'function') onSuccess(result);
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        }
    }, /Enter|Escape|N|Y/);
}
function $e7d9587498be27e7$export$a4eb2582af6677b8(companyId, outputId, boxId, boxCode, itemCount, onSuccess, opts = {}) {
    const initialSeal = (opts.initialSeal || '').trim();
    const html = `
		<div class="msgbox" style="min-width:380px;max-width:520px">
			<div class="mb-title">Lacrar Caixa</div>
			<div class="mb-text">
				<p style="margin:0 0 0.75rem">
					Lacrar a caixa <strong>${$e7d9587498be27e7$export$63e59f033fa91051(boxCode)}</strong>?
					Ap\xf3s lacrar, n\xe3o ser\xe1 poss\xedvel adicionar ou alterar itens.
				</p>
				${itemCount === 0 ? `<p style="margin:0 0 0.5rem;color:#c00;font-size:0.9em">
					\u{26A0} Esta caixa n\xe3o possui itens \u{2014} o lacre ser\xe1 bloqueado.
				</p>` : ''}
				<label style="display:block;font-size:0.9em;margin-bottom:0.6rem">
					C\xf3digo do lacre (opcional)
					<input id="pkbox-close-seal" type="text" maxlength="40"
						style="display:block;width:100%;margin-top:0.25rem;box-sizing:border-box;padding:0.35rem"
						placeholder="Lacre da caixa" autocomplete="off"
						value="${$e7d9587498be27e7$export$63e59f033fa91051(initialSeal)}">
				</label>
				<label style="display:block;font-size:0.9em">
					Observa\xe7\xe3o (opcional)
					<textarea id="pkbox-close-notes" rows="2"
						style="display:block;width:100%;margin-top:0.25rem;box-sizing:border-box;padding:0.35rem;resize:vertical"
						placeholder="Observa\xe7\xf5es..."></textarea>
				</label>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Lacrar Caixa</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        const node = dlg.getNode();
        const seal_code = node.querySelector('#pkbox-close-seal')?.value?.trim() || null;
        const notes = node.querySelector('#pkbox-close-notes')?.value?.trim() || null;
        try {
            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).close_output_picking_box, companyId, outputId, boxId, {
                seal_code: seal_code,
                notes: notes
            });
            if (result?.error) {
                (0, $jUNyh.notify)(result.error, 'Erro ao Lacrar Caixa');
                return;
            }
            dlg.destroy();
            (0, $jUNyh.notify)(`Caixa "${$e7d9587498be27e7$export$63e59f033fa91051(boxCode)}" lacrada com sucesso.`, 'Caixa Lacrada');
            if (typeof onSuccess === 'function') onSuccess(result);
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        }
    }, /Enter|Escape|N|Y/);
}
function $e7d9587498be27e7$export$1e8bbb6c3229b970(box, dataIdAttr) {
    const status = Number(box.status);
    const parts = [];
    parts.push(`<button type="button" class="btn-pkbox-detail link-detail-box" data-id='${dataIdAttr}' data-code="${$e7d9587498be27e7$export$63e59f033fa91051(box.code)}" style="font-size:0.78em;padding:1px 5px;margin:1px;cursor:pointer">Detalhar</button>`);
    if (status === 10) {
        parts.push(`<button class="btn-pkbox-add-items" data-id='${dataIdAttr}' data-code="${$e7d9587498be27e7$export$63e59f033fa91051(box.code)}" style="font-size:0.78em;padding:1px 5px;margin:1px;cursor:pointer">Adicionar Itens</button>`);
        parts.push(`<button class="btn-pkbox-close" data-id='${dataIdAttr}' data-code="${$e7d9587498be27e7$export$63e59f033fa91051(box.code)}" data-items="${box.items?.length || box.total_items || 0}" style="font-size:0.78em;padding:1px 5px;margin:1px;cursor:pointer">Lacrar Caixa</button>`);
    }
    if (status === 10 || status === 20) parts.push(`<button class="btn-pkbox-cancel" data-id='${dataIdAttr}' data-code="${$e7d9587498be27e7$export$63e59f033fa91051(box.code)}" style="font-size:0.78em;padding:1px 5px;margin:1px;cursor:pointer">Cancelar Caixa</button>`);
    return parts.join(' ') || "\u2014";
}
function $e7d9587498be27e7$export$8bd3869a7a9bdf4e(container, onUpdate) {
    if (!container) return;
    container.querySelectorAll('.btn-pkbox-add-items').forEach((el)=>{
        el.addEventListener('click', async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            try {
                const [companyId, outputId, boxId] = JSON.parse(el.getAttribute('data-id'));
                const boxCode = el.getAttribute('data-code') || boxId;
                await $e7d9587498be27e7$export$6b3ac45d14c8aed5(companyId, outputId, boxId, boxCode, onUpdate);
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
            }
        });
    });
    container.querySelectorAll('.btn-pkbox-close').forEach((el)=>{
        el.addEventListener('click', async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            try {
                const [companyId, outputId, boxId] = JSON.parse(el.getAttribute('data-id'));
                const boxCode = el.getAttribute('data-code') || boxId;
                const itemCount = parseInt(el.getAttribute('data-items') || '0', 10);
                $e7d9587498be27e7$export$a4eb2582af6677b8(companyId, outputId, boxId, boxCode, itemCount, onUpdate);
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
            }
        });
    });
    container.querySelectorAll('.btn-pkbox-cancel, .btn-cancel-box, .pick-box-cancel').forEach((el)=>{
        el.addEventListener('click', async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            try {
                const [companyId, outputId, boxId] = JSON.parse(el.getAttribute('data-id'));
                const boxCode = el.getAttribute('data-code') || el.getAttribute('data-box-code') || boxId;
                $e7d9587498be27e7$export$15c2c7ddbc5a85ed(companyId, outputId, boxId, boxCode, onUpdate);
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
            }
        });
    });
}

async function $e7d9587498be27e7$export$a41b4e6a6f728af0(companyId, outputId, onUpdate, opts = {}) {
    const title = opts.title || `Caixas de Picking \u{2014} Sa\xedda #${outputId}`;
    const showCreate = opts.showCreate !== false;
    async function loadAndRender(container) {
        container.innerHTML = '<p style="color:#888;padding:0.5rem 0">Carregando caixas...</p>';
        try {
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId);
            const boxes = data?.boxes || [];
            const rows = boxes.length ? boxes.map((box)=>{
                const statusLabel = $e7d9587498be27e7$export$ea013d6dcd4fc560[box.status] || box.status;
                const statusStyle = $e7d9587498be27e7$export$7b8642852381b09b[box.status] || '';
                const dataId = $e7d9587498be27e7$export$63e59f033fa91051(JSON.stringify([
                    companyId,
                    outputId,
                    box.id
                ]));
                const itemCount = box.items?.length || box.total_items || 0;
                const qtyTotal = box.total_quantity || box.items?.reduce?.((s, i)=>s + (Number(i.quantity) || 0), 0) || 0;
                const actions = $e7d9587498be27e7$export$1e8bbb6c3229b970({
                    ...box,
                    total_items: itemCount
                }, dataId);
                return `<tr>
						<td><a class="pick-box-link" data-box-id="${$e7d9587498be27e7$export$63e59f033fa91051(box.id)}" href="#" style="cursor:pointer;text-decoration:underline dotted">${$e7d9587498be27e7$export$63e59f033fa91051(box.code)}</a></td>
						<td>${$e7d9587498be27e7$export$63e59f033fa91051(box.seal_code || "\u2014")}</td>
						<td><span style="display:inline-block;padding:2px 7px;border-radius:3px;font-size:0.82em;font-weight:600;${statusStyle}">${statusLabel}</span></td>
						<td>${$e7d9587498be27e7$export$39ad18838a4982c(box.opened_at)}</td>
						<td style="text-align:right">${itemCount}</td>
						<td style="text-align:right">${qtyTotal}</td>
						<td style="white-space:nowrap">${actions}</td>
					</tr>`;
            }).join('') : '';
            container.innerHTML = `
				<p style="margin:0 0 0.5rem;color:#666;font-size:0.85em">${$e7d9587498be27e7$export$63e59f033fa91051($e7d9587498be27e7$export$dfb43d8d818491fb)}</p>
				${boxes.length ? `
				<table style="width:100%;border-collapse:collapse;font-size:0.88em">
					<thead>
						<tr style="background:#f0f0f0">
							<th style="padding:4px 6px;text-align:left">Caixa</th>
							<th style="padding:4px 6px;text-align:left">Lacre</th>
							<th style="padding:4px 6px;text-align:left">Status</th>
							<th style="padding:4px 6px;text-align:left">Aberta em</th>
							<th style="padding:4px 6px;text-align:right">Itens</th>
							<th style="padding:4px 6px;text-align:right">Qtd. Total</th>
							<th style="padding:4px 6px;text-align:left">A\xe7\xf5es</th>
						</tr>
					</thead>
					<tbody>${rows}</tbody>
				</table>` : '<p style="color:#888;font-style:italic">Nenhuma caixa registrada para esta sa\xedda.</p>'}`;
            container.querySelectorAll('.pick-box-link').forEach((el)=>{
                el.addEventListener('click', async (e)=>{
                    e.preventDefault();
                    const boxId = el.getAttribute('data-box-id');
                    const { default: openPickingBoxDetailModal } = await Promise.resolve((parcelRequire("9m9G5")));
                    await openPickingBoxDetailModal(companyId, outputId, boxId, async ()=>{
                        await loadAndRender(container);
                        if (typeof onUpdate === 'function') onUpdate();
                    });
                });
            });
            const refresh = async ()=>{
                await loadAndRender(container);
                if (typeof onUpdate === 'function') onUpdate();
            };
            $e7d9587498be27e7$export$8bd3869a7a9bdf4e(container, refresh);
        } catch (err) {
            container.innerHTML = `<p style="color:#c00">Erro ao carregar: ${$e7d9587498be27e7$export$63e59f033fa91051(err?.message || String(err))}</p>`;
        }
    }
    const createBtn = showCreate ? `<button type="button" class="button mtl btn-pkbox-open-new">Abrir Caixa</button>` : '';
    const html = `
		<div class="msgbox" style="min-width:680px;max-width:960px">
			<div class="mb-title">${$e7d9587498be27e7$export$63e59f033fa91051(title)}</div>
			<div class="mb-text" id="pick-boxes-container" style="max-height:70vh;overflow-y:auto;min-height:60px">
				<p style="color:#888">Carregando...</p>
			</div>
			${createBtn}
			<button type="button" class="button mtl bn_N">Fechar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') dlg.destroy();
    }, /Escape|N/);
    const node = dlg.getNode();
    const container = node.querySelector('#pick-boxes-container');
    if (container) await loadAndRender(container);
    const openBtn = node.querySelector('.btn-pkbox-open-new');
    if (openBtn) openBtn.addEventListener('click', ()=>{
        $e7d9587498be27e7$export$6ba48b07ffcf0226(companyId, outputId, async ()=>{
            if (container) await loadAndRender(container);
            if (typeof onUpdate === 'function') onUpdate();
        });
    });
}

});



var $9VcS9 = parcelRequire("9VcS9");

var $h1m6J = parcelRequire("h1m6J");
parcelRequire("93O8T");
var $jdpN4 = parcelRequire("jdpN4");
var $beaf1c1fae4291ea$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#login .title
			{
				padding-bottom: var(--space-md);
				border-bottom: 1px solid var(--color-border);
			}
			#login label
			{
				display: block;
			}
			#login .tal { width: 70%; margin-left: auto; margin-right: auto; }
			#login #username,
			#login #password {
				width: 100%;
				box-sizing: border-box;
			}
			#login .login-logo-aws {
				display: none;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-partners {
				display: none;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-partners-row {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: center;
				gap: 1.25rem 1.75rem;
				width: 100%;
			}
			#login .login-logo-partners-row img {
				height: auto;
				max-height: 3.25rem;
				max-width: 7.5rem;
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
			}
			#login .login-logo-sial {
				display: block;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-sial img {
				height: auto;
				max-height: 10rem;
				max-width: 100%;
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
			#login .login-logo-aws img {
				height: auto;
				max-height: 5.5rem;
				max-width: min(100%, 28rem);
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
			#login .login-logo-aws .login-aws-subtitle {
				margin: var(--space-sm) 0 0;
				font-size: 0.95rem;
				font-weight: 600;
				color: var(--color-text);
				text-align: center;
				line-height: 1.35;
			}
		</style>
		<form id="login" class="form">
			<div id="login-logo-sial" class="login-logo-sial">
				<img src="/img/logo_sial_grey.png" alt="SIAL">
			</div>
			<div id="login-logo-partners" class="login-logo-partners" aria-label="Clientes">
				<div class="login-logo-partners-row">
					<img src="/img/logo_llt.png" alt="LLT">
					<img src="/img/logo_rvd.png" alt="RVD sa\xfade">
					<img src="/img/logo_amil.png" alt="Amil">
				</div>
			</div>
			<div id="login-logo-aws" class="login-logo-aws">
				<img src="img/logo_sessp_secretaria_saude_sp.png" alt="Secretaria de Sa\xfade do Estado de SP">
				<p class="login-aws-subtitle">Secretaria de Sa\xfade do Estado de SP</p>
			</div>
			<div class="title">
				Autentica\xe7\xe3o
				<span id="login-env-badge"></span>
			</div>
			<div class="tal mtl">
				<label>Usu\xe1rio
					<input id="username" name="username" type="text">
				</label>
				<label>Senha
					<input id="password" name="password" type="password">
				</label>
			</div>
			<div class="fsb mtl">
				<a class='bn_Link link'>Alterar a Senha</a>
				<button class='bn_Enter button'>Acessar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#login',
        init (formset) {
            this.setValues({
                'login.password': null
            });
            const badge = document.getElementById('login-env-badge');
            if (badge) {
                const h = window.location.hostname;
                // QA-VPN: IP interno ou DNS público https://qa.sial.run:1610
                const isQaVpn = h === '10.10.0.219' || h === 'qa.sial.run';
                const isQA = isQaVpn || h === '54.207.230.11' || h === 'qa.sialwms.com.br';
                const isDev = h === 'localhost' && window.location.port === '8001';
                const baseStyle = 'margin-left: 0.5rem; padding: 0.15rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: bold;';
                if (isQaVpn) {
                    badge.textContent = 'Ambiente QA';
                    badge.style.cssText = baseStyle + ' background: #2196f3; color: #fff;';
                } else if (isQA) {
                    badge.textContent = 'AMBIENTE DE TESTE';
                    badge.style.cssText = baseStyle + ' background: #2196f3; color: #fff;';
                } else if (isDev) {
                    badge.textContent = 'AMBIENTE DEV';
                    badge.style.cssText = baseStyle + ' background: #ff9800; color: #000;';
                }
            }
            // Logo SIAL (sempre). Partners LLT/RVD/AMIL (VPN + sial.sialwms.com.br).
            // SESSP: logo Secretaria SP. Palmas descontinuado.
            const h = window.location.hostname;
            const logoAwsEl = document.getElementById('login-logo-aws');
            const logoPartnersEl = document.getElementById('login-logo-partners');
            const isSessp = h === 'sessp.sialwms.com.br' || h === '177.71.248.43' || h.includes('sial.ibl') || h === '54.207.230.11' || h === 'qa.sialwms.com.br';
            const isPartnersHost = h === 'sial.sialwms.com.br' || h === 'sial.run' || h === 'www.sial.run' || h === 'localhost' || h === '127.0.0.1' || h === '10.10.0.203' || h === 'qa.sial.run' || h === '10.10.0.219';
            if (logoAwsEl) logoAwsEl.style.display = isSessp ? 'block' : 'none';
            if (logoPartnersEl) logoPartnersEl.style.display = !isSessp && isPartnersHost ? 'block' : 'none';
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#username'
            }
        },
        {
            properties: {
                selector: '#password'
            },
            types: [
                $jdpN4.default()
            ]
        }
    ]
};


parcelRequire("93O8T");
var $cecdd6f97dca9a20$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#request .title
			{
				padding-bottom: var(--space-md);
				border-bottom: 1px solid var(--color-border);
			}
			#request label
			{
				display: block;
			}
			#request #username	{ width: 14rem; }
			#request #channel 	{ width: 14rem; }
		</style>
		<form id="request" class="form">
			<div class="title">
				Atualiza\xe7\xe3o de Senha
			</div>
			<div class="tal mtl">
				<label>Informe seu usu\xe1rio
					<input id="username" name="username" type="text" required>
				</label>
				<label>Receber token via
					<select id="channel" name="channel" required>
						<option value="1">Email</option>
						<option value="2">WhatsApp</option>
					</select>
				</label>
			</div>
			<div class="mtl">
				<button class='bn_Escape button'>Voltar</button>
				<button class='bn_Enter button'>Enviar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#request'
    },
    fields: [
        {
            properties: {
                selector: '#username'
            }
        },
        {
            properties: {
                selector: '#channel'
            }
        }
    ]
};



var $jUNyh = parcelRequire("jUNyh");
const $ef33fadb70b8678b$var$handler = function(key) {
    switch(key){
        case 'Link':
            $ef33fadb70b8678b$var$auth.request();
            break;
    }
};
const $ef33fadb70b8678b$var$auth = {
    login (callback) {
        let fs = (0, $h1m6J.default).create((0, $beaf1c1fae4291ea$export$2e2bcd8739ae039), async (data)=>{
            if (await (0, $9VcS9.default).call((0, $9VcS9.default).auth, data.username, data.password)) {
                sessionStorage.username = data.username;
                fs.destroy();
                callback?.();
            }
        }, $ef33fadb70b8678b$var$handler);
        fs.init();
    },
    logout () {
        // Limpa #logout antes do diálogo/reload — senão router.init() reabre "Deseja sair?" após novo login.
        location.hash = '';
        (0, $jUNyh.ask)('Deseja sair?', "Confirma\xe7\xe3o", async (answer)=>{
            if (answer == 'Y') {
                try {
                    await (0, $9VcS9.default).call((0, $9VcS9.default).logout);
                } catch (_) {}
                delete sessionStorage.username;
                location.reload();
            }
        });
    },
    request () {
        let fs = (0, $h1m6J.default).create((0, $cecdd6f97dca9a20$export$2e2bcd8739ae039), async (data)=>{
            if (await (0, $9VcS9.default).call((0, $9VcS9.default).request_password, data)) {
                fs.destroy();
                (0, $jUNyh.notify)('Verifique o link recebido', 'Sucesso');
            }
        });
        fs.init();
    }
};
var $ef33fadb70b8678b$export$2e2bcd8739ae039 = $ef33fadb70b8678b$var$auth;


const $a020c0121b2250d6$var$ROUTES = [];
const $a020c0121b2250d6$var$router = {
    init () {
        window.addEventListener('hashchange', this.route);
        if (location.hash) this.route();
    },
    set (hash, callback) {
        let index = $a020c0121b2250d6$var$ROUTES.findIndex((route)=>route.hash == hash);
        $a020c0121b2250d6$var$ROUTES[index < 0 ? $a020c0121b2250d6$var$ROUTES.length : index] = {
            'hash': hash,
            'callback': callback
        };
    },
    route (ev) {
        let hash = ev?.newURL?.slice(ev.newURL.indexOf('#')) || ev || location.hash;
        $a020c0121b2250d6$var$ROUTES.filter((entry)=>entry.hash == hash).forEach((entry)=>entry.callback());
    }
};
var $a020c0121b2250d6$export$2e2bcd8739ae039 = $a020c0121b2250d6$var$router;



var $1cmSR = parcelRequire("1cmSR");
var $a6c3e59798a8ecf3$export$2e2bcd8739ae039 = (username)=>`<div id="header">
	<span class="sial-header-brand">
		<img src="img/logo_h1.png">
		<img src="img/logo_h2.png">
	</span>
	<ul class="menu">
			<li>Organiza\xe7\xe3o
				<ul>
					<li hash="#customers">Clientes</li>
					<li hash="#devices">Dispositivos</li>
					<li hash="#input-docks">Docas&nbsp;Entrada</li>
					<li hash="#companies">Empresas</li>
					<li hash="#suppliers">Fornecedores</li>
					<li hash="#customer-routes">Rotas</li>
					<li hash="#carriers">Transportadores</li>
				</ul>
			</li>
			<li>Cat\xe1logo
				<ul>
					<li hash="#categories">Categorias</li>
					<li hash="#classes">Classes</li>
					<li hash="#product-packagings">Embalagens&nbsp;de&nbsp;Produto</li>
					<li hash="#manufacturers">Fabricantes</li>
					<li hash="#input-cancel-reasons">Motivos&nbsp;Cancelamento&nbsp;Entrada</li>
					<li hash="#stock-block-kinds">Naturezas&nbsp;de&nbsp;Bloqueio</li>
					<li hash="#products">Produtos&nbsp;e&nbsp;Classifica\xe7\xf5es</li>
					<li hash="#programs">Programas</li>
					<li hash="#units">Unidades&nbsp;de&nbsp;Medida</li>
				</ul>
			</li>
			<li>Armazenamento
				<ul>
					<li hash="#warehouses">Armaz\xe9ns</li>
					<li hash="#stocks">Estoques</li>
					<li hash="#stock-management">Gerenciamento&nbsp;de&nbsp;estoques</li>
					<li hash="#inventories">Invent\xe1rios</li>
					<li hash="#locations">Posi\xe7\xf5es</li>
					<li hash="#replenishments">Ressuprimentos</li>
					<li hash="#transactions">Transa\xe7\xf5es</li>
				</ul>
			</li>
			<li>Movimenta\xe7\xe3o
				<ul>
					<li hash="#input-dock-schedules">Agendamento&nbsp;de&nbsp;Docas</li>
					<li hash="#output-picking-boxes">Caixas&nbsp;de&nbsp;Picking</li>
					<li hash="#output-picking-countbacks">Countback&nbsp;Picking</li>
					<li hash="#picking-waves">Derrubada&nbsp;(ondas)</li>
					<li hash="#dock-expedition">Doca&nbsp;Expedi\xe7\xe3o</li>
					<li hash="#inputs">Entradas</li>
					<li hash="#lots">Lotes</li>
					<li hash="#movements">Movimenta\xe7\xf5es</li>
					<li hash="#input-orders">Pedidos&nbsp;de&nbsp;Entrada</li>
					<li hash="#output-orders">Pedidos&nbsp;de&nbsp;Sa\xedda</li>
					<li hash="#outputs">Sa\xeddas</li>
					<li hash="#receipt-types">Tipos&nbsp;de&nbsp;Recebimento</li>
				</ul>
			</li>
			<li>Comercial
				<ul>
					<li hash="#cfops">CFOPs</li>
					<li hash="#payment-terms">Condi\xe7\xf5es&nbsp;de&nbsp;Pagamento</li>
					<li hash="#expiring-items">Itens&nbsp;a&nbsp;vencer</li>
					<li hash="#price-lists">Listas&nbsp;de&nbsp;Pre\xe7os</li>
					<li hash="#invoices-billed-exclusive">Relat\xf3rio&nbsp;Notas&nbsp;faturadas&nbsp;-&nbsp;Exclusivo</li>
				</ul>
			</li>
			<li>Faturamento
				<ul>
					<li hash="#nfe-emission-control">Controle&nbsp;emiss\xe3o&nbsp;NF</li>
					<li hash="#invoice-lots">Lotes&nbsp;de&nbsp;Notas</li>
					<li hash="#invoices">Notas&nbsp;Fiscais</li>
				</ul>
			</li>
			<li>BI
				<ul>
					<li hash="#bi-stock-analytical">Anal\xedtico&nbsp;Estoque</li>
					<li hash="#bi-audit">Auditoria</li>
					<li hash="#bi-stock-blocks-descriptive">Bloqueios&nbsp;descritivo</li>
					<li hash="#bi-kardex">Kardex</li>
					<li hash="#bi-output-lines">Linhas&nbsp;de&nbsp;sa\xedda</li>
					<li hash="#bi-output-productivity">Produtividade&nbsp;por&nbsp;funcion\xe1rio</li>
				</ul>
			</li>
			<li data-especial-root hidden>
				Especial
				<ul>
					<li data-especial-tenant="sessp" hidden>
						SESSP
						<ul>
							<li hash="#especial-sessp-faturas">Gest\xe3o&nbsp;de&nbsp;Faturas</li>
						</ul>
					</li>
				</ul>
			</li>
			<li>Sistema
				<ul>
					<!-- <li hash="#endpoints">Endpoints&nbsp;da&nbsp;API</li> -->
					<li hash="#logs">Auditoria&nbsp;de&nbsp;Eventos</li>
					<li hash="#import-center">Central&nbsp;de&nbsp;Importa\xe7\xe3o</li>
					<li hash="#integration-events">Central&nbsp;de&nbsp;Integra\xe7\xf5es</li>
					<li hash="#groups">Grupos&nbsp;e&nbsp;Permiss\xf5es</li>
					<li hash="#logout">Logout&nbsp;do&nbsp;Usu\xe1rio</li>
					<li hash="#about">Sobre o Sistema</li>
					<li hash="#users">Usu\xe1rios&nbsp;e&nbsp;Associa\xe7\xf5es</li>
				</ul>
			</li>
	</ul>
	<div id="identification">
		Usu\xe1rio: ${username}
	</div>
</div>
<div id="workarea">
</div>`;



var $dx9qz = parcelRequire("dx9qz");
var $8027b5f9052bcf5e$export$2e2bcd8739ae039 = '0.3.97';



var $9VcS9 = parcelRequire("9VcS9");
/**
 * Histórico exibido na tela Sobre — texto para quem usa o SIAL.
 * Padrão e proibições: .cursor/rules/changelog-usuario-sial.mdc
 * Nova entrada: confirmar a data do dia (não confiar na data sugerida por assistente).
 */ var $36a7dfe577885f1c$export$2e2bcd8739ae039 = [
    {
        date: '30/09/2026',
        add: [],
        changes: [],
        bugfix: [
            "**Sa\xeddas \u2014 reserva \xf3rf\xe3 (#MT-5E97436):** ao **cancelar** ou **encerrar** (Dar baixa / ap\xf3s NF), o SIAL n\xe3o deixa mais quantidade presa em **Reservado** sem v\xednculo. Se ainda houver residual no extrato, a opera\xe7\xe3o **libera** o que for poss\xedvel ou **bloqueia** com aviso claro para regularizar."
        ]
    },
    {
        date: '29/09/2026',
        add: [],
        changes: [],
        bugfix: [
            "**Pedidos de Sa\xedda \u2014 Concluir parcial (#MT-2359342 / #MT-B9D1635):** a opera\xe7\xe3o voltou a funcionar (unit\xe1rio e em lote, at\xe9 30). O erro t\xe9cnico ao concluir parcialmente foi corrigido na API."
        ]
    },
    {
        date: '28/09/2026',
        add: [
            "**Sa\xeddas \u2014 Enviar para Doca Expedi\xe7\xe3o (#MT-0F84944):** em **Opera\xe7\xf5es**, com v\xe1rias sa\xeddas selecionadas, d\xe1 para enviar as **Faturadas** (empresa com Doca ativa e pedido canal **Internet**) para a tela **Doca Expedi\xe7\xe3o**, sem baixar estoque. A baixa continua s\xf3 ao **Avan\xe7ar** na Doca."
        ],
        changes: [
            "**Tela de login:** nos ambientes multi-cliente (**sial.run** / **sial.sialwms.com.br**) a marca da Secretaria de Sa\xfade (SESSP) deixa de aparecer; passam a ser exibidos os logos **LLT**, **RVD** e **Amil**. No SESSP AWS a marca da Secretaria de Sa\xfade permanece.",
            "**Doca Expedi\xe7\xe3o \u2014 Romaneio (#MT-0F84944):** a coluna **Carga** passa a se chamar **Pedido** e mostra o n\xfamero do **pedido de sa\xedda** (n\xe3o o da carga/sa\xedda)."
        ],
        bugfix: [
            "**Estoques / Gerenciamento de estoques \u2014 Configurar (#MT-FD0B172):** as **colunas**, ordena\xe7\xe3o e linhas por p\xe1gina do **Configurar** passam a ser lembradas ao reabrir a tela. A op\xe7\xe3o **Preservar grade ao reabrir** mant\xe9m a grade carregada ao sair/voltar. O **Filtrar** continua sempre vazio (n\xe3o guarda crit\xe9rios).",
            "**Integra\xe7\xe3o Vendatus \u2014 consulta de status do pedido:** se uma sa\xedda for cancelada e outra for gerada, o status do topo passa a refletir a sa\xedda ativa (n\xe3o mais \u201CCancelada\u201D). A lista de sa\xeddas continua mostrando todas.",
            "**Doca Expedi\xe7\xe3o \u2014 ap\xf3s NF (#MT-0F84944):** com Doca ativa e canal **Internet**, a autoriza\xe7\xe3o da NF volta a deixar a sa\xedda em **Doca Expedi\xe7\xe3o** (sem baixa). Pedido presencial continua fechando em **Conclu\xedda** com baixa, como antes.",
            "**Vendatus \u2014 Pedido de Sa\xedda:** ao gravar o pedido na tela, o SIAL deixa de apagar o n\xfamero da linha enviado pela Vendatus. Isso evita falha no aviso de sa\xedda conferida (evento com linhas erradas).",
            "**Vendatus \u2014 faturamento:** se o pedido tiver uma sa\xedda **cancelada** e outra **conferida**, o faturamento deixa de ser bloqueado. S\xf3 importa a sa\xedda ativa (como j\xe1 aparece no status do pedido)."
        ]
    },
    {
        date: '24/09/2026',
        changes: [
            "**Integra\xe7\xe3o Vendatus \u2014 consulta de estoque:** o saldo por posi\xe7\xe3o/lote passa a ser o mesmo da tela **Estoques** do SIAL (dispon\xedvel, reservado e em aberto). Posi\xe7\xf5es de staging n\xe3o entram na consulta."
        ],
        bugfix: [
            "**Sa\xeddas \u2014 fim da separa\xe7\xe3o (#MT-F0B9878):** ao concluir a separa\xe7\xe3o no coletor sem informar peso, a sa\xedda permanece em **Separada**. S\xf3 passa para **Conferindo** quando a confer\xeancia come\xe7a de verdade (ou ainda falta volumetria/itens). O peso continua obrigat\xf3rio para marcar como **Conferida**.",
            "**Estoques / Gerenciamento de estoques \u2014 Preservar Filtro Atual (#MT-FD0B172):** com a op\xe7\xe3o marcada em **Configurar**, ao reabrir a tela a grade volta j\xe1 filtrada (antes ficava vazia pedindo Filtrar de novo). Se voc\xea mudar o filtro e Aplicar, o filtro preservado tamb\xe9m \xe9 atualizado.",
            "**Armazenagem \u2014 classes da posi\xe7\xe3o (#MT-10A9877):** com bloqueio por classe ativo na empresa, o produto s\xf3 pode ir para posi\xe7\xe3o que tenha **ao menos uma classe em comum**. Posi\xe7\xe3o classificada (ex. s\xf3 Refrigerado) deixa de aceitar produto sem classe seletiva. Mensagem clara de classes incompat\xedveis. Em **Empresas** aparece o par\xe2metro **Bloquear armazenagem por classe** (o bloqueio de invent\xe1rio tamb\xe9m continua ativando a regra)."
        ]
    },
    {
        date: '23/09/2026',
        bugfix: [
            "**Central de Importa\xe7\xe3o \u2014 Posi\xe7\xf5es (e demais cadastros):** corrigido **502 Bad Gateway** ao clicar em Importar depois de validar planilha grande. O servidor passa a aceitar o JSON grande da importa\xe7\xe3o; a tela envia as linhas em lotes. Pode validar e importar de novo.",
            "**Sa\xeddas \u2014 Gerar sa\xedda / picklist com v\xe1rias embalagens:** ao **n\xe3o** permitir abrir caixa secund\xe1ria, a quantidade reservada em cada posi\xe7\xe3o volta a fechar no **fator da embalagem daquela posi\xe7\xe3o** (ex.: 1X300 s\xf3 em m\xfaltiplos de 300). Antes o sistema usava s\xf3 o fator da embalagem padr\xe3o do produto (ex.: 1X30) e a picklist mostrava \u201C0\xd7 caixas fechadas\u201D em posi\xe7\xf5es 1X300. Tamb\xe9m volta a mensagem clara de bloqueio por regra de embalagem quando o pedido \xe9 menor que o fator da posi\xe7\xe3o."
        ]
    },
    {
        date: '22/09/2026',
        add: [
            "**Comercial \u2014 Relat\xf3rio Notas faturadas Exclusivo (#MT-5311110):** novo filtro **Portaria 344** \u2014 Todos, **Somente Portaria 344** ou **Somente sem Portaria 344**. Usa o cadastro de Produtos (mesmo indicador da ficha do produto). Vale na pr\xe9via e nos arquivos CSV/PDF."
        ],
        bugfix: [
            "**Sa\xeddas \u2014 faturar/baixar com lote da grade errado (#MT-AC86297):** se a reserva (separa\xe7\xe3o) estiver no lote f\xedsico certo e a grade ainda apontar um lote antigo sem estoque na posi\xe7\xe3o, o SIAL passa a **corrigir a grade automaticamente** antes de faturar ou baixar, e tamb\xe9m na **confer\xeancia** (web ou sorter). Evita o bloqueio \u201Clot_id sem estoque na posi\xe7\xe3o\u201D quando o estoque j\xe1 est\xe1 reservado no lote certo."
        ]
    },
    {
        date: '21/09/2026',
        add: [
            "**Sa\xeddas \u2014 op\xe7\xe3o SORTER (#MT-2D61607):** ao **Gerar sa\xeddas**, checkbox **SORTER** prepara o plano de volumes (caixa fechada + fra\xe7\xe3o) para a esteira BHT e enfileira o envio. A confer\xeancia autom\xe1tica da esteira avan\xe7a a sa\xedda para **Conferida** quando o retorno bate com o plano. (Coletor em duas filas: pr\xf3xima entrega.)",
            "**Entradas \u2014 indicador de Agendamento (#MT-0510946):** a grade de **Entradas** mostra o status do agendamento de doca do Pedido vinculado (Sem agenda / Agendado / Em recebimento / etc.), no mesmo padr\xe3o de Pedidos de Entrada. Ao abrir a entrada, o formul\xe1rio exibe o resumo da doca e hor\xe1rio quando houver agenda."
        ],
        bugfix: [
            "**Sa\xeddas \u2014 op\xe7\xe3o SORTER (#MT-2D61607):** marcar **SORTER** reserva o estoque junto. A confer\xeancia da esteira s\xf3 conclui a sa\xedda quando o retorno confere com o plano e grava quem conferiu. Reenviar a onda n\xe3o duplica um envio que ainda est\xe1 pendente. Sa\xedda cancelada n\xe3o \xe9 conferida pela esteira.",
            "**Sa\xeddas \u2014 peso autom\xe1tico (#MT-F0B9878):** na **Confer\xeancia de Sa\xedda**, o campo **Peso total** passa a sugerir o peso calculado das embalagens dos itens (mesmo se o lote n\xe3o tiver embalagem vinculada, usa a embalagem do cadastro do produto). Aparece o texto **Sugerido: X kg**; o valor continua edit\xe1vel.",
            "**Entradas \u2014 data de Recebimento (#MT-4421665):** ao marcar a entrada como **Recebida**, o campo **Recebimento** passa a gravar automaticamente a data e a hora desse momento. Antes o status mudava, mas a data ficava em branco (mesmo depois de concluir a entrada)."
        ]
    },
    {
        date: '18/09/2026',
        add: [
            "**Entradas \u2014 Exportar listagem (CSV) (#MT-E71F113):** em **Entradas \u2192 Imprimir** h\xe1 **Exportar listagem (CSV)**, no mesmo padr\xe3o de Sa\xeddas. Usa os filtros e a ordena\xe7\xe3o da tela (ou exporta tudo, se desmarcar). Uma linha por entrada; arquivo para Excel/LibreOffice com ponto e v\xedrgula.",
            "**Sa\xeddas \u2014 peso autom\xe1tico (#MT-F0B9878):** na **Confer\xeancia de Sa\xedda**, o campo **Peso total** \xe9 preenchido com a soma do peso das embalagens dos itens (quantidade \xf7 fator \xd7 peso). Se o item n\xe3o tiver peso cadastrado, conta **1 kg** por embalagem. O valor continua edit\xe1vel.",
            "**Countback \u2014 evid\xeancia para auditoria (#MT-699B225):** a tela **Movimenta\xe7\xe3o \u2192 Countback Picking** passa a mostrar o **hist\xf3rico de todas as contagens** (inclusive as que deram certo), com filtros por empresa, sa\xedda, pedido, SKU, lote, posi\xe7\xe3o, operador, status e data. Antes a tela listava s\xf3 a pend\xeancia aberta e a linha desaparecia depois da libera\xe7\xe3o. Em **Opera\xe7\xf5es \u2192 Evid\xeancia / s\xf3 pend\xeancias** alterna entre o hist\xf3rico e a fila de auditoria. O arquivo de **Imprimir \u2192 Exportar (PDF/CSV/Excel)** respeita os filtros da tela e traz data/hora **com segundos**, quantidade separada, esperado, informado, diferen\xe7a, operador, quem liberou, quando e a observa\xe7\xe3o \u2014 \xe9 a prova de que o Countback foi feito, sem depender de recontagem.",
            "**Agendamento de Docas (#MT-0510946):** no **Novo agendamento** d\xe1 para **buscar o Pedido de Entrada pela Nota Fiscal** (campo NF + bot\xe3o Buscar por NF) e informar **Volumes**. A lista de pedidos pass\xedveis e a grade passam a mostrar NF e volumes; se j\xe1 existir Entrada com volumes, o campo \xe9 preenchido automaticamente."
        ],
        bugfix: [
            "**Countback na separa\xe7\xe3o:** duas faturas na **mesma posi\xe7\xe3o** deixam de exigir sequ\xeancia. O saldo informado passa a considerar o que j\xe1 foi separado na outra fatura, mesmo se ela ainda n\xe3o foi finalizada. O operador informa s\xf3 o que ainda est\xe1 na c\xe9lula.",
            "**Countback \u2014 contagem repetida na tela e no relat\xf3rio:** posi\xe7\xf5es com o mesmo c\xf3digo em armaz\xe9ns diferentes faziam a mesma contagem aparecer duas vezes na listagem e no arquivo exportado (e o total ficava maior que o real). Cada Countback passa a aparecer uma \xfanica vez. Tamb\xe9m corrige a fila de auditoria, que j\xe1 tinha o mesmo problema.",
            "**Countback \u2014 tela sem registros e sem aviso:** quando a lista de empresas n\xe3o carregava (sess\xe3o derrubada ou falta de permiss\xe3o de Empresas), a tela mostrava a grade vazia como se n\xe3o houvesse Countback nenhum. Agora o sistema tenta carregar de novo e, se n\xe3o conseguir, avisa para entrar novamente ou pedir a permiss\xe3o ao administrador.",
            "**Countback \u2014 nome de produto longo:** SKU/produto muito longo deixava de empurrar Status e Liberar para fora da tela; o texto completo continua no tooltip ao passar o mouse.",
            "**Countback \u2014 filtros e exporta\xe7\xe3o:** digitar letra no campo de limite ou uma data inexistente (ex. 31/02) mostrava mensagem t\xe9cnica; agora aparece aviso claro. Exportar no modo **s\xf3 pend\xeancias** passa a trazer apenas as pend\xeancias. A data/hora na tela agora mostra os segundos, igual ao arquivo. A navega\xe7\xe3o por p\xe1ginas deixa de parar ap\xf3s 500 registros quando h\xe1 uma empresa selecionada.",
            "**SESSP \u2014 status IBL Aguardando expedi\xe7\xe3o (G):** ao concluir a sa\xedda (NF autorizada), o SIAL garante o envio do status **G** \xe0 IBL mesmo se o faturamento n\xe3o tiver enfileirado. Evita a fatura ficar parada em **Separa\xe7\xe3o** na integra\xe7\xe3o depois de conclu\xedda no armaz\xe9m.",
            "**Comercial \u2014 Itens a vencer (#MT-D552104):** o campo **Janela** passa a mostrar o per\xedodo (ex.: 01/10/2026 a 31/10/2026). Ao mudar **Meses \xe0 frente** (1, 2, 3\u2026), o per\xedodo atualiza na hora; na pr\xe9via, a janela vem confirmada pelo servidor."
        ]
    },
    {
        date: '17/09/2026',
        add: [
            "**Comercial \u2014 Itens a vencer (#MT-D552104):** nova tela **Comercial \u2192 Itens a vencer**. Lista lotes **dispon\xedveis para venda** cuja validade cai nos **meses seguintes** (o m\xeas atual n\xe3o entra; padr\xe3o **3 meses**). Colunas: SKU, descri\xe7\xe3o, quantidade dispon\xedvel, lote, validade, fabricante, fornecedor da entrada e custo unit\xe1rio. Pr\xe9via na tela e **CSV** para Excel. Sem aviso e sem download autom\xe1tico no login."
        ],
        bugfix: [
            "**Lotes de NF \u2014 consulta SEFAZ e status da sa\xedda:** a SEFAZ autorizava o lote e a nota, mas a sa\xedda podia ficar em **Faturando**. A consulta passa a gravar o retorno e concluir a baixa; se o lote j\xe1 estiver processado, consultar de novo retoma s\xf3 as sa\xeddas que faltaram (sem chamar a SEFAZ outra vez).",
            "**Coletor / Sa\xeddas \u2014 lentid\xe3o ao gravar:** ao avan\xe7ar a sa\xedda (confer\xeancia no coletor ou na tela), o sistema podia travar ou estourar o tempo enquanto falava com a integra\xe7\xe3o IBL. A grava\xe7\xe3o da sa\xedda termina na hora; o envio \xe0 IBL segue em segundo plano.",
            "**Pedidos de Sa\xedda \u2014 integra\xe7\xe3o IBL:** ao salvar o pedido, o SIAL n\xe3o espera mais a resposta da IBL. O status segue no ciclo autom\xe1tico (alguns minutos)."
        ]
    },
    {
        date: '16/09/2026',
        bugfix: [
            "**Notas Fiscais \u2014 falta f\xedsica autorizada (#MT-247A518):** item conferido com quantidade **0** (falta f\xedsica autorizada) deixa de entrar na NF. A nota fica s\xf3 com o que foi conferido. Antes a linha voltava com a quantidade do pedido e o item era faturado mesmo sem sair do armaz\xe9m.",
            "**Pedidos de Sa\xedda \u2014 Gerar sa\xeddas (#MT-9B20296):** ao marcar v\xe1rios pedidos do mesmo produto e **Reservar estoques**, o segundo podia sair parcial (ex. 8/10) mesmo a simula\xe7\xe3o tendo mostrado 100%. A reserva de um pedido no mesmo clique deixa de contar duas vezes o saldo. Parcial de verdade continua gerando a sa\xedda \u2014 n\xe3o \xe9 preciso cancelar para tentar de novo.",
            "**Pedidos de Sa\xedda \u2014 Arm. Refrigerado (#MT-2F9C150):** SKU com flag **Refrigerado** no cadastro (ex. **040261**) deixava de aparecer como Refrigerado na coluna **Arm.** do pedido (mostrava Climatizado). A coluna passa a usar o cadastro do produto no pr\xf3prio pedido e n\xe3o assume mais Climatizado quando o cache local ainda n\xe3o carregou.",
            "**Sa\xeddas \u2014 Exportar listagem (CSV) (#MT-31D2937):** o menu Imprimir \u2192 Exportar listagem (CSV) avisava que n\xe3o foi poss\xedvel gerar o arquivo. A extra\xe7\xe3o volta a baixar o CSV da listagem (uma linha por sa\xedda). O Exportar itens (CSV) tamb\xe9m volta a gerar."
        ]
    },
    {
        date: '15/09/2026',
        add: [
            "**Especial \u2014 Gest\xe3o de Faturas SESSP (#MT-9B4E512):** a tela deixa de ser s\xf3 um aviso e passa a consultar as **sa\xeddas** do per\xedodo (cria\xe7\xe3o, fuso Bras\xedlia): totais, gr\xe1ficos por m\xeas / status / programa, lista com pedido, refer\xeancia, cliente e valor, bot\xe3o **Itens** e **Exportar lista (CSV)**. Cada linha \xe9 o pedido SES no SIAL \u2014 **n\xe3o \xe9 a NF-e**. Sem SLA de entrega e sem origem Farmanet/GSNET neste recorte. M\xe1ximo **93 dias**. Itens completos tamb\xe9m em **BI \u2192 Linhas de sa\xedda**.",
            "**Gest\xe3o de Faturas \u2014 DRS e SLA no armaz\xe9m (#MT-9B4E512):** filtros e gr\xe1ficos por **DRS** e por **SLA WMS** (dentro / fora / em andamento / sem regra). O prazo vale at\xe9 a **conclus\xe3o no armaz\xe9m** (status Conclu\xedda), em horas corridas desde a cria\xe7\xe3o da sa\xedda \u2014 **n\xe3o** \xe9 entrega na unidade. H\xe1 KPI de sa\xeddas **sem DRS**.",
            "**Gest\xe3o de Faturas \u2014 hist\xf3rico \xd7 turno (#MT-9B4E512):** na lista, **Hist\xf3rico** mostra quando a sa\xedda mudou de status e em qual turno (Bras\xedlia: 07:00\u201311:59 1\xba; 12:00\u201316:49 1\xba e 2\xba, sem somar duas vezes; 16:50\u201321:48 2\xba; 21:49\u201306:59 3\xba). Os gr\xe1ficos de mudan\xe7as por turno e tempo m\xe9dio no status usam esse hist\xf3rico; se ainda n\xe3o houver log gravado, a tela avisa e usa os hor\xe1rios de cria\xe7\xe3o / separa\xe7\xe3o / confer\xeancia / conclus\xe3o."
        ],
        add: [
            "**Movimenta\xe7\xf5es \u2014 filtro por SKU (#MT-11CC373):** na tela Movimenta\xe7\xe3o \u2192 Movimenta\xe7\xf5es \xe9 poss\xedvel filtrar pelo **c\xf3digo SKU** do produto (operador **Cont\xe9m**). A grade e as exporta\xe7\xf5es CSV/Excel/PDF tamb\xe9m exibem a coluna SKU."
        ],
        changes: [
            "**SESSP \u2014 Etiqueta Transporte Padr\xe3o SES (#MT-4888116):** a caixa fechada passa a ser **600** unidades (n\xe3o mais calculada pelos volumes da sa\xedda). A \xfaltima etiqueta fica com a fra\xe7\xe3o. Ex.: **20220** gera **34** vias (**600 de 20220** nas 33 primeiras; **420 de 20220** na \xfaltima), e n\xe3o **29** vias de **700**."
        ],
        bugfix: [
            "**SESSP \u2014 QR da etiqueta Padr\xe3o SES (#MT-4888116):** o QR (fatura|volume|total) e o rodap\xe9 **Sa\xedda** / **Fatura** sa\xedam abaixo do corte da etiqueta 100\xd7150. O QR agora imprime ao lado do destinat\xe1rio, na \xe1rea vis\xedvel.",
            "**Movimenta\xe7\xf5es \u2014 Controle de movimenta\xe7\xf5es (#MT-F25F153):** ao extrair o relat\xf3rio o SIAL avisava que o frontend estava desatualizado. A consulta do relat\xf3rio voltou a existir no sistema (tela, CSV e Excel).",
            "**Devolu\xe7\xe3o de venda \u2014 Pagamento no pedido:** ap\xf3s gerar a **Entrada** da devolu\xe7\xe3o, o pedido de sa\xedda ficava travado sem permitir alterar a **forma de pagamento** (s\xf3 a condi\xe7\xe3o). Isso impedia corrigir o pagamento antes de faturar a NF. Agora **Pagamento** e **Condi\xe7\xe3o** permanecem edit\xe1veis enquanto houver entrada ou sa\xedda ativa vinculada.",
            "**Devolu\xe7\xe3o de compra \u2014 reserva de estoque:** ao registrar a sa\xedda f\xedsica da devolu\xe7\xe3o ao fornecedor (tipo **Entrada**), o sistema n\xe3o reservava o saldo na posi\xe7\xe3o. Na baixa ap\xf3s faturar aparecia *saldo reservado insuficiente (reservado=0)*. A reserva passa a ser feita ao salvar a sa\xedda; na baixa, se ainda faltar reserva de um caso antigo, o sistema tenta ajustar antes de debitar.",
            "**Gerenciamento de estoques \u2014 Lote / datas / programa:** ao marcar uma linha e abrir a opera\xe7\xe3o, o aviso **Sele\xe7\xe3o com mais de uma empresa** ficava na frente do formul\xe1rio e n\xe3o dava para fechar nem editar. A consulta do ajuste de lote voltou a funcionar; o aviso de empresa s\xf3 aparece no pr\xf3prio formul\xe1rio quando a sele\xe7\xe3o realmente mistura empresas.",
            "**Gerenciamento de estoques \u2014 Lote fab. (#MT-FC78762):** lotes como **746E4** ou **606E4** voltam a aparecer exatamente assim. O **E** do lote deixa de ser lido como nota\xe7\xe3o cient\xedfica (ex.: 606E4 virava 6060000).",
            "**BI \u2014 Produtividade:** ao gerar a pr\xe9via ou o CSV aparecia o aviso **is not a function**. A consulta de Separa\xe7\xe3o e Confer\xeancia volta a funcionar.",
            "**Pedidos de Sa\xedda:** ao abrir a lista aparecia o aviso **e is not a function**. A consulta de saldo simulado / pr\xe9-reserva da grade voltou a funcionar (mesmo tipo de falha do Countback).",
            "**Sa\xeddas \u2014 Conferir:** o clique em **Conferir** n\xe3o abria a tela (erro t\xe9cnico na confer\xeancia por embalagem). A confer\xeancia volta a abrir.",
            "**Pedidos de Sa\xedda \u2014 Emergencial:** ao salvar um pedido novo (ou editar) com a op\xe7\xe3o **Emergencial**, o sistema recusava com erro t\xe9cnico. O flag volta a gravar normalmente.",
            "**Countback Picking:** ao abrir a tela o aviso **e is not a function** deixava a lista vazia. A consulta das pend\xeancias voltou a funcionar (Liberar / bloquear em lote / relat\xf3rio tamb\xe9m).",
            "**Gest\xe3o de Faturas (#MT-9B4E512):** quem j\xe1 tem permiss\xe3o **Especial \u2192 SESSP** passa a conseguir consultar a tela. Antes o sistema recusava a consulta mesmo com o menu vis\xedvel."
        ]
    },
    {
        date: '13/09/2026',
        add: [
            "**Agendamento de Docas \u2014 Imprimir (#MT-B2FA396):** no menu **Imprimir** h\xe1 **Controle de Agendamento** (folha A4 da portaria, com colunas de chegada e assinatura) e **Extrato Excel** da lista ou das linhas selecionadas.",
            "**Organiza\xe7\xe3o \u2014 Docas Entrada (#MT-B2FA396):** novo cadastro de **Docas de Entrada** (menu Organiza\xe7\xe3o), com tipo (Seca/Refrigerada/Climatizada/Mista), classes aceitas, hor\xe1rio de funcionamento e ativar/inativar. Prepara o agendamento de recebimento (fase seguinte).",
            "**Agendamento de Docas de Entrada (#MT-B2FA396):** API de disponibilidade e agendamento (criar, consultar, cancelar e reagendar) quando a empresa habilita o par\xe2metro **Agendamento de Docas de Entrada**.",
            "**Movimenta\xe7\xe3o \u2014 Agendamento de Docas (#MT-B2FA396):** nova tela gerencial para consultar disponibilidade, criar, detalhar, cancelar e reagendar agendamentos de docas de entrada (quando a empresa estiver com o par\xe2metro ligado).",
            "**Pedidos de Entrada \u2014 Agendamento de Docas (#MT-B2FA396):** a grade mostra o status do agendamento (Sem agenda / Agendado / Cancelado / etc.); nas opera\xe7\xf5es \xe9 poss\xedvel **Agendar Doca** ou **Ver Agendamento** do pedido selecionado.",
            "**Agendamento de Docas \u2014 Calend\xe1rio (#MT-B2FA396):** em **Opera\xe7\xf5es \u2192 Calend\xe1rio** d\xe1 para ver os agendamentos do m\xeas, da semana ou do dia (data em dd/MM/yyyy). Clique no hor\xe1rio para abrir o detalhe."
        ],
        changes: [
            "**Menu:** os itens dentro de cada menu (Organiza\xe7\xe3o, Cat\xe1logo, Armazenamento, etc.) passam a aparecer em ordem alfab\xe9tica. Os menus principais continuam na mesma ordem.",
            "**Agendamento de Docas (#MT-B2FA396):** armaz\xe9m, tipo e classe sa\xedram do formul\xe1rio de agendamento (s\xe3o da **Doca**). A disponibilidade lista s\xf3 docas compat\xedveis com o pedido. D\xe1 para **escolher um pedido** ou **listar pedidos pass\xedveis** (sem agenda ativa).",
            "**Organiza\xe7\xe3o \u2014 Docas Entrada (#MT-B2FA396):** o formul\xe1rio de cadastro/edi\xe7\xe3o passou a usar o mesmo visual de **Estoques / Embalagens / Produtos** (cabe\xe7alho, cards de resumo e se\xe7\xf5es)."
        ],
        bugfix: [
            "**Doca Expedi\xe7\xe3o:** ao abrir a tela voltava o aviso **endpoint is not a function** e a lista ficava vazia. A consulta, o v\xednculo de doca e o avan\xe7ar em lote voltaram a funcionar.",
            "**Agendamento de Docas \u2014 Calend\xe1rio (#MT-B2FA396):** o m\xeas deixava de mostrar 7 colunas iguais e o dia pintava as linhas no estilo da lista. O calend\xe1rio agora abre fora da grade, com colunas est\xe1veis.",
            "**Agendamento de Docas (#MT-B2FA396):** a tela deixava de listar com a mensagem de banco local sem a store de Docas Entrada. O banco do navegador foi atualizado (vers\xe3o 7) para criar essa store.",
            '**Organiza\xe7\xe3o \u2014 Docas Entrada (#MT-B2FA396):** ao salvar sem informar o **Armaz\xe9m**, o sistema mostra a mensagem **"Armaz\xe9m \xe9 obrigat\xf3rio."** (em vez de erro t\xe9cnico). Filtros da lista (empresa, armaz\xe9m, tipo, classe, status e nome) alinhados \xe0 grade.',
            "**Estoques \u2014 Relat\xf3rio / custo em devolu\xe7\xe3o (#MT-EDB6345):** o **Custo unit\xe1rio** do Relat\xf3rio de Estoque (e export alinhado) passa a usar o valor da movimenta\xe7\xe3o de entrada do lote, e n\xe3o o pre\xe7o da NFD de devolu\xe7\xe3o. Ex.: devolu\xe7\xe3o LLT Entrada **3030** / NFD **12528** / SKU **038801** mostra **15,02** (custo de compra), n\xe3o **22,00**."
        ]
    },
    {
        date: '12/09/2026',
        bugfix: [
            "**Countback Picking (#MT-7546968):** ao marcar linhas na grade e usar **Opera\xe7\xf5es \u2192 Liberar selecionados** (ou bloquear/cancelar), a sele\xe7\xe3o volta a ser reconhecida. Antes o checkbox aparecia marcado, mas o sistema pedia para selecionar um registro.",
            "**Countback Picking \u2014 bot\xe3o Liberar:** o bot\xe3o **Liberar** de cada linha volta a abrir o di\xe1logo de observa\xe7\xe3o e liberar a continuidade. Antes o clique n\xe3o fazia nada."
        ]
    },
    {
        date: '11/09/2026',
        bugfix: [
            "**Sa\xeddas \u2014 encerrar sem deixar reserva presa:** ao concluir/baixar uma sa\xedda, o sistema n\xe3o deixa mais quantidade **Reservada** sem baixa correspondente. Se ainda houver reserva aberta no extrato, ela \xe9 liberada de volta para **Dispon\xedvel** (ou a conclus\xe3o \xe9 barrada com aviso claro). Evita o caso de produto \u201Csumido\u201D na disponibilidade com reserva \xf3rf\xe3."
        ]
    },
    {
        date: '10/09/2026',
        add: [
            "**Comercial \u2014 Relat\xf3rio Notas faturadas Exclusivo (#MT-CA07226):** a pr\xe9via e os arquivos (CSV/PDF) passam a filtrar por **c\xf3digo SKU** e **descri\xe7\xe3o do produto**, e mostram o **subtotal do Vlr total** no final das linhas. A descri\xe7\xe3o sugere os produtos da empresa ao digitar (igual ao nome do cliente).",
            "**Estoques \u2014 SKU sem Sa\xedda (#MT-F314595):** o relat\xf3rio passa a listar **por lote**, com **validade** e **custo unit\xe1rio** da entrada."
        ],
        bugfix: [
            "**Estoques \u2014 SKU sem Sa\xedda (#MT-F314595):** a coluna **Estoque Total** passa a mostrar a quantidade **dispon\xedvel para separa\xe7\xe3o** (igual ao Relat\xf3rio de estoque Completo), e n\xe3o mais o total agregado do cadastro do produto.",
            "**Entradas \u2014 endere\xe7amento (#MT-88D0949):** se o saldo j\xe1 saiu do recebimento (foi para a picking por movimenta\xe7\xe3o), enviar o endere\xe7amento **s\xf3 conclui** a nota \u2014 n\xe3o tenta mover de novo. No Coletor, a origem deixa de ser \u201Cqualquer posi\xe7\xe3o com saldo\u201D (isso recusava o endere\xe7o em que o item j\xe1 estava).",
            "**Derrubada (ondas) \u2014 Gerar onda:** o bot\xe3o **Gerar onda** volta a **gravar** a derrubada (antes s\xf3 a **Simular** respondia; a lista de ondas ficava vazia). Ap\xf3s simular, use **Gerar onda** e confirme no di\xe1logo.",
            "**Derrubada (ondas) \u2014 pesquisa por pedido:** digitar o n\xba com ponto de milhar (ex. **62.094**) n\xe3o quebra mais a pesquisa. Use o n\xfamero do pedido (ex. **62094**).",
            "**Derrubada (ondas) \u2014 confirma\xe7\xe3o ao gerar:** o di\xe1logo de confirma\xe7\xe3o passa a focar em **Sim, gerar onda** (Enter confirma). Antes o foco ia em \xabN\xe3o\xbb e a onda podia n\xe3o gravar sem aviso claro."
        ]
    },
    {
        date: '09/09/2026',
        bugfix: [
            "**Countback na separa\xe7\xe3o (#MT-7546968):** o saldo esperado da posi\xe7\xe3o **n\xe3o conta mais** o que j\xe1 foi separado e ainda n\xe3o faturou (continua como reserva no sistema, mas j\xe1 saiu da posi\xe7\xe3o). O operador informa s\xf3 o que ainda est\xe1 na c\xe9lula."
        ]
    },
    {
        date: '08/09/2026',
        bugfix: [
            "**BI \u2014 Produtividade por funcion\xe1rio (#MT-9C49478):** na **Confer\xeancia**, in\xedcio e fim passam a ser a **data e hora em que a fatura foi conferida**. O tempo gasto dessa atividade fica em branco \u2014 n\xe3o soma mais a espera desde a separa\xe7\xe3o (aquelas \u201C18 horas\u201D no CSV). A **Separa\xe7\xe3o** continua com in\xedcio estimado e tempo at\xe9 o fim da separa\xe7\xe3o.",
            "**Empresas \u2014 Pedidos por onda:** ao salvar, a API recusava o campo **Pedidos por onda (derrubada)** (erro 400). O valor agora grava no cadastro da empresa.",
            "**Vendatus:** se o pedido de sa\xedda for **cancelado na tela** e a Vendatus reenviar o mesmo n\xfamero, o SIAL passa a ligar o ID no pedido novo \u2014 a confer\xeancia volta a mandar o **ID da Vendatus**, em vez de ir vazio e gerar movimenta\xe7\xe3o manual no ERP.",
            "**Derrubada (ondas) \u2014 Nova onda:** o campo **Empresa** passa a listar as empresas num combo. A gera\xe7\xe3o abre uma **pesquisa de pedidos** (filtros de pedido, refer\xeancia, cliente, programa, datas, SLA e emergencial): o operador marca na grade e gera o lote \u2014 n\xe3o digita pedido a pedido. Com **um** armaz\xe9m (ou sem f\xedsico ativo) o sistema usa sozinho \u2014 n\xe3o pede para escolher de novo.",
            "**Pedidos de Sa\xedda \u2014 Gerar derrubada:** em **Opera\xe7\xf5es** h\xe1 **Gerar derrubada**. Marque os pedidos na grade (uma empresa) e gere a onda a partir da sele\xe7\xe3o \u2014 mesmo fluxo de **Gerar sa\xeddas**. Se a API recusar (ex.: pedido ainda n\xe3o aprovado), a tela mostra o aviso e **n\xe3o** quebra.",
            "**Derrubada (ondas) \u2014 Atual:** o bot\xe3o **Atual** da barra voltou a recarregar a lista mesmo quando est\xe1 vazia (P\xe1gina 0/0).",
            "**Derrubada (ondas) \u2014 detalhe:** o modal da onda passou a usar o mesmo visual de **Estoques / Produtos** (cabe\xe7alho, cards e se\xe7\xf5es). Tipo da tarefa, status da onda e papel do operador saem em portugu\xeas. A coluna **Cria\xe7\xe3o** na lista fica **DD/MM/AAAA - HH:MM:SS**.",
            "**BI \u2014 Produtividade por funcion\xe1rio:** o CSV detalhe de v\xe1rios dias deixava de responder (erro 502). A consulta de Separa\xe7\xe3o ficou mais leve e o sistema **bloqueia** per\xedodo acima de **31 dias** no detalhe/pr\xe9via e **93 dias** no resumo, com aviso na tela \u2014 n\xe3o depende de o usu\xe1rio \u201Cadivinhar\u201D o recorte.",
            "**Gerar sa\xeddas:** o sistema **nunca** reserva nem sugere estoque de **outro depositante**. Com armaz\xe9m em branco, s\xf3 entram saldos da empresa escolhida no modal (corrigido o caso em que o mesmo SKU existia em posi\xe7\xe3o de outra empresa e gerava aviso indevido de \u201Cposi\xe7\xe3o restrita\u201D). A gera\xe7\xe3o voltou a gravar a sa\xedda depois do bloqueio entre empresas (erro interno no item). O modal **Gerar sa\xeddas** ficou compacto, sem estourar a tela.",
            "**Produtos \u2014 CST IBS/CBS:** ao informar o **ClassTrib** (ex.: 200004), o campo **CST IBS/CBS** volta a mostrar o c\xf3digo derivado (ex.: **200**) e a descri\xe7\xe3o da tabela oficial, sem sumir ao abrir/salvar o cadastro. O que grava no produto continua sendo o ClassTrib.",
            "**Devolu\xe7\xe3o \u2014 valor no estoque (#MT-EDB6345):** na confer\xeancia da Entrada ligada a Pedido de Sa\xedda com **Devolu\xe7\xe3o**, o valor unit\xe1rio que entra no estoque passa a seguir o **custo de compra do lote** (NF de compra do SKU+lote do pedido original na **Refer\xeancia**), e n\xe3o o pre\xe7o de venda da NFD."
        ],
        add: [
            "**Derrubada em ondas (#MT-7740432):** menu **Movimenta\xe7\xe3o \u2192 Derrubada (ondas)** para selecionar pedidos (teto configur\xe1vel na empresa, padr\xe3o 120), simular ou gerar sa\xeddas com reserva, descer o palete no **ch\xe3o da mesma coluna** e devolver a sobra depois da separa\xe7\xe3o daquele palete. O relat\xf3rio **Derrubada de Pallets** (PDF/CSV) continua dispon\xedvel.",
            "**Derrubada (ondas) \u2014 ajuda:** no detalhe da onda e no **Painel** h\xe1 o bot\xe3o **?** embaixo do \xedcone. Abre a explica\xe7\xe3o de cada dado, no mesmo modelo da ajuda de **Empresas \u2192 Par\xe2metros**.",
            "**Derrubada (ondas) \u2014 Painel:** o painel passou a usar o mesmo visual de **Estoques / Produtos** (cabe\xe7alho, cards e se\xe7\xf5es).",
            "**Empresas:** ao abrir o cadastro (aba Dados / Par\xe2metros) a tela deixava de preparar o formul\xe1rio (`Cannot read properties of undefined`). O campo **Pedidos por onda (derrubada)** estava com tipo de n\xfamero inv\xe1lido.",
            "**Derrubada \u2014 Coletor (#MT-7740432):** no agrupador **Derrubada** d\xe1 para ver **Minhas** tarefas (as atribu\xeddas a voc\xea ou sem dono) ou **Todas** da onda. Sa\xedda **for\xe7ada** para outro operador n\xe3o abre no aparelho."
        ]
    },
    {
        date: '04/09/2026',
        changes: [
            "**Countback na separa\xe7\xe3o (#MT-7546968):** o par\xe2metro **Countback na separa\xe7\xe3o (Coletor)** passou a ser **por produto (SKU)**, na aba **Armazenagem** do cadastro de Produtos (padr\xe3o desligado). Deixa de ser ligado/desligado na empresa. Na **Central de Importa\xe7\xe3o**, a planilha de produtos ganhou a coluna **Countback** (S ou N). S\xf3 os SKUs marcados pedem o saldo restante ap\xf3s confirmar a separa\xe7\xe3o no Coletor."
        ],
        bugfix: [
            "**Sa\xeddas (#MT-7546968):** a listagem de sa\xeddas voltou a abrir ap\xf3s o Countback por SKU (erro interno ao montar os itens).",
            "**BI \u2014 Produtividade por funcion\xe1rio (#MT-D900606):** com **Separa\xe7\xe3o e Confer\xeancia**, a pr\xe9via e o **CSV detalhe** voltavam a mostrar s\xf3 **Confer\xeancia** quando havia muitas linhas. Agora as duas atividades entram no relat\xf3rio (divis\xe3o equilibrada do limite) e a lista ordena pela data de fim da atividade."
        ]
    },
    {
        date: '03/09/2026',
        add: [
            "**Pedidos de Sa\xedda \u2014 Apelido:** no formul\xe1rio h\xe1 o campo **Apelido** ao lado de **Cliente**. D\xe1 para buscar pelo apelido ou pelo nome/CNPJ; ao escolher em um, o outro preenche sozinho.",
            "**Pedidos de Sa\xedda \u2014 Concluir parcial em lote (#MT-2359342):** em **Opera\xe7\xf5es \u2192 Concluir parcial** d\xe1 para selecionar **at\xe9 30 pedidos** de uma vez (antes s\xf3 um). O status passa a **Conclu\xeddo parcialmente**; pedidos com status diferente ou com sa\xedda em andamento s\xe3o ignorados ou reportados no resumo.",
            "**Countback na separa\xe7\xe3o (#MT-7546968):** par\xe2metro **Countback na separa\xe7\xe3o (Coletor)** (padr\xe3o desligado). Com o par\xe2metro ligado no produto, ap\xf3s confirmar a separa\xe7\xe3o no Coletor o operador informa o **saldo restante na posi\xe7\xe3o**. Se divergir, pode tentar de novo (at\xe9 3 vezes); na terceira, bloqueia para auditoria. Em **Movimenta\xe7\xe3o \u2192 Countback Picking** o gestor libera a continuidade com observa\xe7\xe3o.",
            "**BI \u2014 Produtividade por funcion\xe1rio (#MT-D900606):** em **BI \u2192 Produtividade por funcion\xe1rio** h\xe1 relat\xf3rio de **Separa\xe7\xe3o** e/ou **Confer\xeancia** no per\xedodo, com funcion\xe1rio, pedido/sa\xedda, SKU, quantidades requerida e conferida, in\xedcio, fim e tempo gasto. A tela mostra indicadores e resumo por pessoa, com exporta\xe7\xe3o CSV (detalhe ou resumo). O **in\xedcio** no momento \xe9 estimado (cria\xe7\xe3o da sa\xedda / primeira reserva / fim da separa\xe7\xe3o) \u2014 o in\xedcio real no coletor fica para uma etapa futura.",
            "**Sa\xeddas \u2014 Exportar itens (CSV) (#MT-0EC8910):** em **Sa\xeddas \u2192 Imprimir** h\xe1 **Exportar itens (CSV)**. Gera planilha com **uma linha por item** (SKU, descri\xe7\xe3o, lote, validade, quantidades e posi\xe7\xe3o), no esp\xedrito do **Sa\xedda Detalhada**, usando os **filtros da tela**. O **Exportar listagem (CSV)** continua existindo com uma linha por sa\xedda.",
            "**Entradas \u2014 Relat\xf3rio de Confer\xeancia (#MT-0D44565):** o PDF passa a mostrar **rastreabilidade** (quem gerou a pr\xe9-nota, quem registrou o recebimento, quem conferiu, quem endere\xe7ou) e a coluna **POS** com as **posi\xe7\xf5es finais do endere\xe7amento** (n\xe3o s\xf3 a posi\xe7\xe3o de staging)."
        ],
        changes: [
            "**Pedidos de Sa\xedda \u2014 Apelido / Cliente:** ao limpar o **Apelido** para buscar de novo, o **Cliente** escolhido n\xe3o \xe9 apagado. A lista de apelido tamb\xe9m deixa de listar clientes sem apelido cadastrado."
        ],
        bugfix: [
            "**Countback Picking (#MT-7546968):** clique na linha abre **detalhe** (quantidades, resolu\xe7\xe3o e hist\xf3rico). Em **Opera\xe7\xf5es**: liberar ou bloquear/cancelar **selecionados** (em lote, com observa\xe7\xe3o). Em **Imprimir/Exportar**: relat\xf3rio PDF, CSV ou Excel com filtros (status, sa\xedda, per\xedodo ou s\xf3 selecionadas).",
            "**Countback (#MT-7546968):** na tela **Countback Picking** a posi\xe7\xe3o volta a aparecer corretamente. Ap\xf3s o gestor **liberar**, o Coletor passa a aceitar nova contagem sem precisar recarregar a p\xe1gina. A libera\xe7\xe3o **n\xe3o** pula a valida\xe7\xe3o do saldo \u2014 o operador ainda precisa informar o Countback certo antes de gravar a quantidade.",
            "**BI \u2014 Produtividade por funcion\xe1rio:** a pr\xe9via na tela passa a mostrar **carregando** enquanto o relat\xf3rio \xe9 gerado; o detalhe exibe at\xe9 **80 linhas** (amostra) para n\xe3o travar o navegador \u2014 use **CSV detalhe** para o conjunto completo. Corrigido tamb\xe9m indicadores e c\xe9lulas vazias na grade (renderiza\xe7\xe3o com textContent).",
            "**Pedidos de Sa\xedda \u2014 Cliente:** o campo **Cliente** mostra s\xf3 o **nome** (com CNPJ/CPF). O **apelido** fica no campo **Apelido**, sem repetir o mesmo texto duas vezes.",
            "**Pedidos de Sa\xedda \u2014 lista de produtos:** ap\xf3s o ajuste de Programa, a lista de produtos do pedido podia ficar **vazia** (borda vermelha ao digitar SKU). A lista volta a mostrar os produtos da **empresa**; o **Programa** continua valendo no **saldo simulado / pr\xe9-reserva** (estoque do programa), sem esconder o cadastro."
        ]
    },
    {
        date: '02/09/2026',
        add: [
            "**Pedidos de Sa\xedda \u2014 Climatizado / Refrigerado (#MT-3902248):** ao montar o pedido, cada item mostra o tipo de armazenamento (**Arm.**). Se o pedido misturar itens **climatizados** e **refrigerados**, aparece um aviso no formul\xe1rio e, ao salvar, o sistema pede confirma\xe7\xe3o (empresa **RVD** e demais com o flag Refrigerado no cadastro)."
        ],
        bugfix: [
            "**Gerenciamento de estoques \u2014 Programa:** ao alterar o **Programa** do lote, a lista mostra s\xf3 os programas da **mesma empresa** das linhas selecionadas (n\xe3o mistura programas de outros tenants). O sistema tamb\xe9m bloqueia gravar programa de outra empresa.",
            "**Pedidos de Sa\xedda \u2014 Programa / saldo simulado:** com **Programa** no cabe\xe7alho, a lista de produtos fica restrita a esse programa e as colunas **Pr\xe9-reserva** / **Saldo sim.** / **Situa\xe7\xe3o** passam a considerar s\xf3 o estoque daquele programa \u2014 inclusive em pedido **novo** (n\xe3o s\xf3 na edi\xe7\xe3o).",
            "**Movimenta\xe7\xe3o / Coletor \u2014 saldo reservado:** ao mover palete/posi\xe7\xe3o, o sistema **n\xe3o move mais unidades reservadas** para outra sa\xedda. S\xf3 baixa ou cancelamento da sa\xedda liberam o reservado. Evita o caso em que o coletor movimentava o palete inteiro enquanto havia reserva (ex.: fatura/sa\xedda com linha sem reserva na posi\xe7\xe3o).",
            "**BI \u2014 Linhas de sa\xedda / Volumes (#MT-41C6261):** o total de **Volumes** da sa\xedda deixa de se repetir em todas as linhas do pedido. Aparece s\xf3 na **primeira linha** de cada sa\xedda, para a soma no Excel/BI bater com o total real da fatura.",
            "**Gerar sa\xeddas / Motivo (#MT-4B31219):** quando h\xe1 saldo no estoque mas a quantidade pedida \xe9 menor que a embalagem cadastrada (ex.: pediu 50 e a caixa \xe9 de 100), a tela de **Resultados** volta a mostrar **Bloqueado por regra de embalagem (quebra/unitariza\xe7\xe3o)** \u2014 em vez de \xabSem saldo dispon\xedvel\xbb \u2014 para o comercial ajustar o pedido (Amil / Maternidade)."
        ]
    },
    {
        date: '01/09/2026',
        changes: [
            "**Integra\xe7\xe3o Vendatus \u2014 sa\xedda conferida em pedido manual (#MT-A5E3509):** ao **conferir** uma sa\xedda de pedido criado no SIAL (sem origem Vendatus), o sistema passa a avisar o ERP com o **n\xfamero do pedido**, itens, lotes e quantidade conferida \u2014 para a Vendatus poder reservar estoque antes da baixa (empresa **RVD**)."
        ],
        bugfix: [
            "**Integra\xe7\xe3o Vendatus \u2014 linha do item em pedido manual (#MT-A5E3509):** pedidos manuais com linha **0** no pedido deixam de bloquear o aviso de confer\xeancia; o sistema usa a linha da sa\xedda conferida."
        ]
    },
    {
        date: '31/08/2026',
        add: [
            "**Integra\xe7\xe3o Vendatus \u2014 baixa e entrada de saldo (#MT-A5E3509):** ao **baixar** uma sa\xedda (estoque reservado) ou **dar saldo** numa entrada no SIAL, o sistema avisa o ERP Vendatus com o **n\xfamero do pedido no SIAL**, SKU, lote e quantidade \u2014 inclusive em processos manuais que a Vendatus ainda n\xe3o conhece (empresa **RVD**).",
            "**Integra\xe7\xe3o Vendatus \u2014 movimenta\xe7\xe3o de estoque (#MT-A5E3509):** ao transferir saldo entre posi\xe7\xf5es no SIAL (dispon\xedvel ou bloqueado), o sistema passa a avisar o ERP Vendatus com origem, destino, SKU, lote e quantidade (empresa **RVD**)."
        ]
    },
    {
        date: '28/08/2026',
        bugfix: [
            "**Notas Fiscais \u2014 cancelamento de devolu\xe7\xe3o (#MT-4BC6218):** ao gerar **lote de cancelamento** de NF de devolu\xe7\xe3o de compra, o SIAL n\xe3o tenta mais baixar estoque de novo e deixa de exibir \xabQuantidade reservada n\xe3o pode ser negativa\xbb. A baixa na devolu\xe7\xe3o manual (Pedido de Entrada) passa a reservar automaticamente antes de concluir, quando faltava reserva na c\xe9lula.",
            "**Entradas \u2014 Motivo cancelamento (#MT-6BF7122):** ao reabrir uma Entrada j\xe1 **Cancelada**, o **Motivo cancelamento** voltou a aparecer preenchido (antes o campo abria vazio mesmo tendo sido informado no cancelamento).",
            "**Sa\xeddas / Clientes \u2014 alerta de Inscri\xe7\xe3o Estadual:** ao abrir **Sa\xeddas**, o SIAL n\xe3o interrompe mais com \xabVerifique Inscri\xe7\xe3o Estadual\xbb por cliente com IE legada ou refer\xeancia externa. Cadastro manual continua exigindo IE v\xe1lida para **Contribuinte**. Integra\xe7\xe3o **Vendatus** deixa de marcar como contribuinte IE que n\xe3o passa na valida\xe7\xe3o fiscal."
        ]
    },
    {
        date: '27/08/2026',
        changes: [
            "**Notas Fiscais \u2014 devolu\xe7\xe3o de compra (#MT-4BC6218):** o **ClassTrib** (e IBS/CBS) da NF de devolu\xe7\xe3o passa a vir do **cadastro do produto**, e n\xe3o mais do XML da nota de origem do fornecedor. Continua obrigat\xf3rio informar a chave da NF-e de origem (44 d\xedgitos)."
        ],
        bugfix: [
            "**Sa\xeddas \u2014 baixa ap\xf3s estorno (#MT-626F404):** ao estornar uma sa\xedda **Conclu\xedda** de volta para **Faturada** e baixar de novo, o estoque deixa de ficar com reserva presa. A nova baixa volta a baixar o reservado corretamente.",
            "**Sa\xeddas \u2014 baixa parcial (#MT-626F404):** se a baixa parar no meio (ex.: s\xf3 1 item baixado de v\xe1rios), ao tentar de novo o SIAL **completa o restante** em vez de travar com \xabreconcilia\xe7\xe3o manual necess\xe1ria\xbb."
        ]
    },
    {
        date: '25/08/2026',
        bugfix: [
            "**Clientes \u2014 munic\xedpio com ap\xf3strofo:** nomes como **Santana do Livramento** (sem ap\xf3strofo) passam a localizar o munic\xedpio oficial do IBGE (**Sant'Ana do Livramento**). Corrige falha no cadastro manual e na integra\xe7\xe3o Vendatus.",
            "**Clientes \u2014 cadastro (#MT-C721832):** corrigido erro ao gravar cliente novo quando o sistema tentava usar identificador **0** (conflito de chave prim\xe1ria). Cadastro manual e integra\xe7\xe3o voltam a receber o pr\xf3ximo n\xfamero autom\xe1tico da empresa.",
            "**Entradas \u2014 Motivo cancelamento (#MT-6BF7122):** ao marcar Status **Cancelada**, a tela n\xe3o fica mais presa em \xabCarregando\u2026\xbb; a lista de motivos abre normalmente.",
            "**Entradas \u2014 Motivo cancelamento (#MT-6BF7122):** ao marcar Status **Cancelada**, a lista de motivos volta a abrir e permitir a escolha (a atualiza\xe7\xe3o anterior ainda deixava o campo sem op\xe7\xf5es)."
        ]
    },
    {
        date: '24/08/2026',
        bugfix: [
            "**Entradas \u2014 Motivo cancelamento (#MT-6BF7122):** ao colocar Status **Cancelada**, a lista suspens\xf3ria de motivos volta a carregar (nomes cadastrados por empresa). Cadastro ampliado para perfis operacionais em **Cat\xe1logo \u2192 Motivos Cancelamento Entrada**; inclu\xeddo motivo padr\xe3o **Centro de custo incorreto**."
        ]
    },
    {
        date: '21/08/2026',
        changes: [
            "**Entradas \u2014 Cancelar em lote (#MT-8412900):** em **Opera\xe7\xf5es \u2192 Cancelar em lote**, marque na grade as Entradas **Criadas**, escolha **um motivo** de cancelamento e confirme. As que n\xe3o estiverem Criadas s\xe3o ignoradas. Motivos em **Cat\xe1logo \u2192 Motivos Cancelamento Entrada**.",
            "**Entradas \u2014 Motivo de cancelamento (#MT-6BF7122):** ao colocar a Entrada como **Cancelada**, \xe9 obrigat\xf3rio escolher um motivo da lista (por empresa). Cadastro em **Cat\xe1logo \u2192 Motivos Cancelamento Entrada** (Analistas).",
            "**Estoques \u2014 Naturezas de bloqueio (#MT-6BF7122):** cada empresa pode **renomear** ou **desativar** as naturezas (Avaria, Quarentena, etc.) em **Cat\xe1logo \u2192 Naturezas de Bloqueio**, sem precisar de deploy. C\xf3digos novos continuam s\xf3 pelo SIAL (para n\xe3o quebrar BI).",
            "**Notas Fiscais \u2014 devolu\xe7\xe3o (#MT-C5B0668):** em pedido com **Devolu\xe7\xe3o**, se o cliente tiver endere\xe7o de entrega cadastrado, o **Local de entrega** da NF passa a usar o endere\xe7o da **empresa**, n\xe3o o do cliente.",
            "**Pedidos de Sa\xedda \u2014 Concluir parcial (#MT-B9D1635):** em **Opera\xe7\xf5es** h\xe1 **Concluir parcial**. Em pedido **Parcialmente atendido**, confirma e o status passa a **Conclu\xeddo parcialmente** (fim do processo: sem complemento e fora da pr\xe9-reserva). O status **Parcialmente atendido** continua existindo para quem ainda vai atender o restante (ex.: BI Amil).",
            "**Pedidos de Sa\xedda \u2014 Devolu\xe7\xe3o conclu\xedda (#MT-73A5867):** quando a **Entrada** da devolu\xe7\xe3o \xe9 conclu\xedda (mercadoria endere\xe7ada no estoque), o Pedido de Sa\xedda marcado como **Devolu\xe7\xe3o** passa automaticamente para **Conclu\xeddo**.",
            "**Pedidos de Sa\xedda \u2014 Devolu\xe7\xe3o e pr\xe9-reserva (#MT-F0A7552):** pedidos marcados como **Devolu\xe7\xe3o** deixam de entrar no saldo livre simulado / pr\xe9-reserva. Na grade, as colunas de pr\xe9-reserva e saldo simulado ficam vazias nesses pedidos."
        ],
        bugfix: [
            "**Entradas \u2014 Inserir/editar:** corrigido erro ao abrir o formul\xe1rio (`subscribe is not a function`) ap\xf3s o motivo de cancelamento. Volta a abrir Inserir normalmente.",
            "**Pedidos de Sa\xedda \u2014 Devolu\xe7\xe3o (#MT-F0A7552):** ao abrir um pedido marcado como **Devolu\xe7\xe3o**, os **itens voltam a aparecer** (n\xe3o some mais a grade). Pr\xe9-reserva/saldo simulado continuam vazios nesses pedidos, como previsto.",
            "**Sa\xeddas \u2014 gerar sa\xedda:** a quantidade pedida deixa de ser cortada pela embalagem \u201Cpadr\xe3o\u201D do cadastro quando o estoque est\xe1 em outra embalagem (ex.: padr\xe3o 1\xd710 e saldo em 1\xd725). O atendimento passa a respeitar a embalagem **da posi\xe7\xe3o/lote**.",
            "**Gerenciamento de estoques \u2014 detalhe:** os cards de quantidade (Estoque total, Dispon\xedvel, etc.) passam a mostrar o valor **inteiro** com milhar (ex. **5.983**), sem cortar para **5,98**."
        ]
    },
    {
        date: '20/08/2026',
        add: [
            "**Sa\xeddas \u2014 Exportar listagem (CSV) (#MT-EF34932):** em **Sa\xeddas \u2192 Imprimir** h\xe1 **Exportar listagem (CSV)**, no mesmo padr\xe3o de Pedidos de Sa\xedda. Usa os filtros e a ordena\xe7\xe3o da tela (ou exporta tudo, se desmarcar). Uma linha por sa\xedda; arquivo em Excel/LibreOffice com ponto e v\xedrgula."
        ],
        bugfix: [
            "**BI \u2014 Linhas de sa\xedda (#MT-FF64465):** o CSV e a pr\xe9via passam a trazer a coluna **Volumes** (quantidade informada na sa\xedda, na confer\xeancia). Em sa\xeddas com v\xe1rios itens, o mesmo n\xfamero se repete em cada linha.",
            "**Notas Fiscais \u2014 devolu\xe7\xe3o (#MT-E4DE488):** se a NF de origem tiver **s\xf3 um produto** e o c\xf3digo/GTIN do fornecedor n\xe3o bater com o cadastro SIAL, o sistema passa a copiar o **ClassTrib** desse \xfanico item (em vez de bloquear). Com v\xe1rios itens na origem, continua exigindo casamento por c\xf3digo ou GTIN.",
            "**Entradas \u2014 XML da NF (Conclu\xedda):** ao anexar o XML, a tela deixa de mostrar o erro t\xe9cnico `enableDownload` e o link de download da nota volta a funcionar. Caso LLT entrada **2960**.",
            "**Sa\xeddas \u2014 etiqueta Transporte Padr\xe3o SES (#MT-4888116):** o campo **Fatura** e o QR voltam a usar o **n\xfamero da fatura** (NF-e). A **Sa\xedda** continua em campo pr\xf3prio. Sem NF emitida, Fatura/QR mostram **-**.",
            "**Entradas \u2014 XML da NF:** mesmo com a entrada **Conclu\xedda**, d\xe1 para anexar o arquivo XML da nota. Cabe\xe7alho, quantidades e valores continuam bloqueados (para alterar o restante, use **Estornar**).",
            "**BI \u2014 Linhas de sa\xedda / Expedi\xe7\xe3o (SESSP):** datas e hor\xe1rios de cria\xe7\xe3o e separa\xe7\xe3o passam a aparecer no **hor\xe1rio de Bras\xedlia**. Antes, perto das 21h, a data podia parecer o dia seguinte por causa do fuso UTC.",
            "**Clientes \u2014 nome:** o cadastro aceita raz\xe3o social com at\xe9 **120** caracteres (antes 60). Na nota fiscal o nome continua limitado a 60 pelo layout da SEFAZ.",
            "**Integra\xe7\xe3o Vendatus \u2014 sa\xedda conferida:** ao gravar de novo um **Pedido de Sa\xedda** vindo da Vendatus, o sistema deixa de apagar o n\xfamero da linha do item. Sem esse n\xfamero, o aviso de sa\xedda conferida ia com linha 0 e a Vendatus n\xe3o fechava a entrega. Se ainda faltar o n\xfamero, o envio fica bloqueado at\xe9 corre\xe7\xe3o (n\xe3o manda zero de novo).",
            "**Sa\xeddas \u2014 confer\xeancia:** n\xe3o d\xe1 mais para marcar a sa\xedda como **Conferida** com quantidade fornecida **0** pelo formul\xe1rio ou pelo Coletor. Para retirar a linha (falta), use **Opera\xe7\xf5es \u2192 Conferir sa\xedda** e registre a **diverg\xeancia** (ex.: falta f\xedsica)."
        ]
    },
    {
        date: '19/08/2026',
        add: [
            "**Central de Integra\xe7\xe3o \u2014 Vendatus:** em **Opera\xe7\xf5es** h\xe1 **Vendatus \u2014 reprocessar fila de envio**. Reenvia eventos pendentes (ex.: sa\xedda conferida que deu timeout) sem precisar chamar o suporte."
        ],
        bugfix: [
            "**Produtos \u2014 cadastro:** a hierarquia de embalagens (P/S/T) volta a listar as embalagens j\xe1 cadastradas. Os selos **Inativo** e **Refrigerado** no topo passam a seguir os checkboxes (n\xe3o ficam sempre acesos).",
            "**Coletor \u2014 Auditoria / reservas \xf3rf\xe3s (#MT-1CBE799):** se a sa\xedda j\xe1 estiver **Conclu\xedda** (ou cancelada/exclu\xedda), a reserva que sobrou na posi\xe7\xe3o deixa de ser tratada como \u201Cainda vinculada\u201D. A tela passa a permitir **tratar \xf3rf\xe3** em vez de s\xf3 observa\xe7\xe3o. Caso Amil 2: SKU **2000010943**, sa\xedda **2080**.",
            "**Sa\xeddas \u2014 etiqueta Transporte Padr\xe3o SES (#MT-4888116):** o campo **Fatura** e o QR usam o **n\xfamero da sa\xedda** (n\xe3o a NF-e). Quantidade: caixas fechadas de **600** e o \xfaltimo volume s\xf3 a **fra\xe7\xe3o** (ex. 9625 = 16\xd7600 + 25 \u2192 **17** etiquetas)."
        ]
    },
    {
        date: '18/08/2026',
        add: [
            "**Menu Especial (#MT-9B4E512):** novo item **Especial** entre **BI** e **Sistema**. Dentro: **SESSP \u2192 Gest\xe3o de Faturas**, vis\xedvel s\xf3 para quem tem a permiss\xe3o **Especial SESSP**. Os menus passam para a esquerda, ao lado do logo; o usu\xe1rio permanece \xe0 direita."
        ],
        bugfix: [
            "**Pedidos de Sa\xedda \u2014 Pr\xe9-reserva / Saldo livre / Situa\xe7\xe3o estoque:** clicar no t\xedtulo dessas colunas deixa de gerar erro de banco. Elas s\xe3o calculadas na p\xe1gina e n\xe3o ordenam a listagem.",
            "**Menu Especial (SESSP):** o item **Especial** (entre **BI** e **Sistema**) passa a aparecer para quem tem permiss\xe3o. A consulta de acesso n\xe3o chegava na API.",
            "**Menu \u2014 Opera\xe7\xf5es / Imprimir:** os itens desses menus voltam a abrir **na vertical** (n\xe3o mais em linha na barra). Vale para todas as telas de listagem.",
            "**Menu \u2014 BI:** ao abrir o submenu **BI**, a tela deixa de ganhar rolagem lateral. O dropdown abre para dentro da janela.",
            "**Clientes \u2014 Endere\xe7os Adicionais de Entrega (#MT-CE57172):** ao abrir um cliente j\xe1 gravado, a se\xe7\xe3o deixa de ficar s\xf3 com \xabSalve o cliente primeiro\xbb. Passa a listar os endere\xe7os e o bot\xe3o **+ Adicionar Endere\xe7o de Entrega**. Cliente novo continua pedindo para salvar antes."
        ]
    },
    {
        date: '17/08/2026',
        bugfix: [
            "**Sa\xeddas \u2014 Relat\xf3rio de Confer\xeancia (#MT-AEDC375):** o campo **Separador** deixa de mostrar quem gerou a sa\xedda. Passa a mostrar quem separou (ou **\u2014** se a separa\xe7\xe3o ainda n\xe3o aconteceu depois de gerar). Sa\xeddas j\xe1 geradas: reimprimir o PDF depois de publicar.",
            "**Cat\xe1logo \u2014 Categorias:** o cadastro deixa de estourar a largura da tela. A estrutura do SKU e os textos de ajuda passam a caber na janela.",
            "**Estoques \u2014 detalhe do item:** se o saldo da posi\xe7\xe3o estiver 100% bloqueado ou 100% reservado, o **Status** no modal passa a mostrar Bloqueado/Reservado (em vez de Livre).",
            "**Integra\xe7\xe3o Vendatus \u2014 pedido de entrada cancelado:** se a mesma nota/refer\xeancia for reenviada depois de cancelada no SIAL, o pedido e a entrada voltam a ficar ativos. A consulta de andamento deixa de dizer que o pedido n\xe3o existe.",
            "**Sa\xeddas \u2014 etiqueta Transporte Padr\xe3o SES (#MT-4888116):** a quantidade deixa de repetir s\xf3 a primeira linha do pedido (ex. 720 de 720 com o restante conferido). Passa a somar todas as linhas. Com mais de um lote, **Lote** e **Validade** mostram **V\xc1RIOS**."
        ],
        add: [
            "**Integra\xe7\xe3o Vendatus \u2014 excluir para reenviar:** a Vendatus pode excluir um pedido de entrada ou de sa\xedda que ela mesma enviou, com justificativa obrigat\xf3ria. S\xf3 vale se ainda n\xe3o houve recebimento/confer\xeancia no armaz\xe9m. Depois a mesma identifica\xe7\xe3o pode ser enviada de novo.",
            "**Sa\xeddas \u2014 Controle de Picking (#MT-9621705):** o PDF passa a exibir a coluna **Refer\xeancia** (o mesmo n\xfamero da grade de Sa\xeddas), ao lado de Pedido."
        ],
        changes: [
            "**Estoques / Gerenciamento de estoques \u2014 descri\xe7\xe3o do produto (#MT-4F50538):** na grade, a coluna **Produto** passa a mostrar o nome completo (quebra de linha).",
            "**Gerenciamento de estoques \u2014 detalhe do item:** o modal de consulta do produto/lote foi redesenhado (cabe\xe7alho, cards de saldo e se\xe7\xf5es por assunto), mantendo os mesmos dados e sem altera\xe7\xe3o de regra de estoque.",
            "**Cat\xe1logo \u2014 Embalagens:** o cadastro passou a usar o mesmo visual do detalhe de estoque (cabe\xe7alho, cards de resumo e se\xe7\xf5es), sem mudar regras de gravar embalagem.",
            "**Cat\xe1logo \u2014 Produtos:** o cadastro (abas Dados, Armazenagem e Tributa\xe7\xe3o) passou a usar o mesmo visual do detalhe de estoque, sem mudar regras de gravar produto.",
            "**Sa\xeddas \u2014 etiqueta Transporte Padr\xe3o SES (#MT-4888116):** o layout preenche a etiqueta 100\xd7150 mm; o t\xedtulo passa a **IBL LOG\xcdSTICA**; QR maior. O QR do sorter continua **n\xfamero da fatura + volume + volume total** (sem NF: **-**)."
        ]
    },
    {
        date: '14/08/2026',
        bugfix: [
            "**Notas Fiscais \u2014 listagem:** corrigido erro \xabthis.number is not a function\xbb ao abrir a tela quando alguma nota tem Seguro ou Despesas preenchidos. A grade volta a exibir esses valores normalmente.",
            "**Gerar notas \u2014 devolu\xe7\xe3o de compra (ClassTrib):** quando o c\xf3digo do produto na NF de origem \xe9 o do fornecedor (diferente do SKU no SIAL), o sistema passa a localizar o item pelo **GTIN/c\xf3digo de barras** para copiar a ClassTrib. Evita travar a emiss\xe3o (ex. SKU 041827 \xd7 c\xf3digo fornecedor 1882 na mesma NF).",
            "**Gerar notas \u2014 IBS/CBS imunidade (ClassTrib 410):** em devolu\xe7\xe3o (e demais NFs) com ClassTrib de imunidade/n\xe3o incid\xeancia (ex. 410002), o XML deixa de enviar o grupo de c\xe1lculo IBS/CBS indevido. Corrige rejei\xe7\xe3o SEFAZ \xabGrupo IBS/CBS informado indevidamente\xbb."
        ]
    },
    {
        date: '13/08/2026',
        add: [
            "**Pedidos de Sa\xedda \u2014 Pr\xe9-reserva / Saldo livre simulado (#MT-6D9A723):** pedidos aprovados passam a mostrar quanto do estoque j\xe1 est\xe1 comprometido **antes** de gerar a Sa\xedda (sem reservar lote/posi\xe7\xe3o). Na **grade** e no **detalhe do pedido (itens)**: Pr\xe9-reserva, Saldo livre simulado e Situa\xe7\xe3o estoque. Relat\xf3rio Excel **Durabilidade de Estoque** em **Estoques** e tamb\xe9m em **Pedidos de Sa\xedda \u2192 Imprimir**. Ao gerar sa\xedda, aviso informativo se a opera\xe7\xe3o deixar o saldo simulado negativo para outros pedidos. A reserva real e o FEFO continuam iguais.",
            "**Integra\xe7\xe3o Vendatus \u2014 pr\xe9-reserva / saldo livre simulado:** dispon\xedvel `GET /integrations/vendatus/stocks/simulated-availability` (por SKU: pr\xe9-reserva, livre operacional, saldo simulado e situa\xe7\xe3o). Complementa a consulta de estoque por posi\xe7\xe3o; n\xe3o reserva f\xedsico."
        ],
        bugfix: [
            "**Gerar notas \u2014 devolu\xe7\xe3o de compra:** al\xe9m de Notas Fiscais, o sistema passa a usar o XML da NF de origem gravado na **Entrada** (quando a chave referenciada n\xe3o est\xe1 em Notas). Evita bloquear devolu\xe7\xe3o quando a Entrada j\xe1 est\xe1 conclu\xedda e a origem \xe9 NF de fornecedor.",
            "**Gerar notas \u2014 devolu\xe7\xe3o de compra (CFOP 5202/6202):** ao faturar sa\xedda ligada a Pedido de Entrada de devolu\xe7\xe3o, o sistema deixa de falhar com erro interno (`order_type`) e valida o CFOP corretamente.",
            "**Sa\xeddas \u2014 Posi\xe7\xe3o filtrada pelo armaz\xe9m do cabe\xe7alho:** com Armaz\xe9m preenchido (ex. LLT-3), a lista de Posi\xe7\xe3o mostra s\xf3 endere\xe7os daquele armaz\xe9m (busca na API + filtro). Corrige lista vazia no Inserir e a mistura com posi\xe7\xf5es de outros armaz\xe9ns.",
            "**Sa\xeddas \u2014 Inserir com Pedido de Entrada (devolu\xe7\xe3o de compra):** ao informar o n\xba do Pedido de Entrada (Tipo = Entrada), a tela volta a carregar os itens desse pedido \u2014 e n\xe3o mais um Pedido de Sa\xedda com o mesmo n\xfamero. Tipo fica edit\xe1vel (Entrada ou Sa\xedda).",
            "**Integra\xe7\xe3o CEAF \u2014 m\xfaltiplo de distribui\xe7\xe3o:** o campo `multiplo_distribuicao` do snapshot de estoque passa a usar a mesma embalagem que a tela/API de Estoques do SIAL (embalagem do lote; se n\xe3o houver, a padr\xe3o ou a de maior fator). Evita diverg\xeancia (ex. API com 60 e SIAL com 90 no mesmo SKU).",
            "**Gerar sa\xedda \u2014 embalagem da posi\xe7\xe3o:** quando o mesmo produto tem mais de um tipo de caixa no estoque (ex. 1X200 e 1X30) e a empresa n\xe3o permite abrir caixa, a quantidade separada em cada posi\xe7\xe3o passa a respeitar o m\xfaltiplo **da embalagem daquela posi\xe7\xe3o**, e n\xe3o s\xf3 o maior m\xfaltiplo do cadastro do produto. Evita pedir quantidade que n\xe3o fecha em caixas fechadas na picklist.",
            "**Sa\xeddas \u2014 listagem:** corrigido erro \xabEmpresa do armaz\xe9m requerida\u2026\xbb que podia zerar a tela de Sa\xeddas quando algum registro antigo tinha armaz\xe9m sem a empresa do armaz\xe9m preenchida."
        ]
    },
    {
        date: '12/08/2026',
        add: [
            "**Integra\xe7\xe3o Vendatus \u2014 consulta status de entrada:** dispon\xedvel o espelho da consulta de sa\xedda: `GET /integrations/vendatus/input-orders/{externalInputId}/status` para acompanhar o andamento da entrada no WMS (criada \u2192 recebida \u2192 conclu\xedda)."
        ],
        changes: [
            "**Integra\xe7\xe3o Protheus \u2014 descontinuada:** o conector Protheus foi desligado. Na Central de Integra\xe7\xf5es n\xe3o aparece mais o filtro/status Protheus; o ERP RVD passa a operar via **Vendatus**.",
            "**Integra\xe7\xe3o Vendatus \u2014 consulta de estoque (#MT-23DD804):** cada p\xe1gina da API de saldo passa a aceitar at\xe9 **2000** linhas (antes 500). O job que monta a tabela di\xe1ria ainda precisa pedir as p\xe1ginas seguintes enquanto houver mais dados (`hasMore`), sen\xe3o SKUs fora da primeira p\xe1gina ficam de fora."
        ],
        bugfix: [
            "**Integra\xe7\xe3o Vendatus \u2014 cadastro de produto:** ao criar SKU novo, a classifica\xe7\xe3o interna passa a usar o pr\xf3prio **SKU** (evita rejeitar produtos com a mesma descri\xe7\xe3o de outro j\xe1 cadastrado, ex. dois c\xf3digos Dente Delara). Tamb\xe9m cobre o caso de \u201Cduplicidade\u201D falsa sem GTIN.",
            "**Filtros \u2014 Criado Por / Usu\xe1rio:** ao filtrar por **SIALBOT** (ou outro usu\xe1rio) em Pedido de Entrada, Pedido de Sa\xedda e telas semelhantes, o filtro deixa de rejeitar o c\xf3digo interno do usu\xe1rio. Selecione o nome na lista normalmente (#MT-8678543)."
        ]
    },
    {
        date: '11/08/2026',
        add: [
            "**Integra\xe7\xe3o Vendatus \u2014 entrada autom\xe1tica:** ao receber o pedido de compra/NF do ERP, o SIAL passa a criar tamb\xe9m a **Entrada** (n\xe3o s\xf3 o Pedido de Entrada). A confer\xeancia e o estoque seguem o fluxo normal na opera\xe7\xe3o (#MT-3216489)."
        ],
        bugfix: [
            "**Pedido de Sa\xedda \u2014 Endere\xe7o Entrega:** ao escolher o endere\xe7o do cliente, a tela deixa de ficar em \u201CSelecione o endere\xe7o\u201D quando o sistema usa o endere\xe7o principal/faturamento do cadastro. Endere\xe7os adicionais (ex.: outra rua) passam a aparecer corretamente na lista. Quem cadastra clientes tamb\xe9m volta a conseguir **ver** os endere\xe7os adicionais ap\xf3s salvar.",
            "**Sa\xeddas \u2014 etiqueta de volumes SESSP:** o layout SESSP deixa de bloquear a impress\xe3o quando a NF-e ainda n\xe3o foi emitida. Sem n\xfamero de nota, o campo NF e o QR usam **-** (permite etiquetar a partir da separa\xe7\xe3o). Abaixo de **Sa\xedda** passa a exibir **Fatura:** com o n\xba da NF (ou **-** se ainda n\xe3o houver).",
            "**Invent\xe1rio \u2014 validade da contagem:** no cr\xe9dito de sobra do fechamento, a **validade (e o n\xba de lote) contados e validados** passam a ser a verdade \u2014 o SIAL deixa de reaproveitar a validade antiga do cadastro do lote quando a contagem diverge. Evita etiqueta/picking com validade diferente da inventariada.",
            "**Invent\xe1rio \u2014 armaz\xe9m ativo:** ao abrir invent\xe1rio por posi\xe7\xe3o, o SIAL usa s\xf3 **armaz\xe9ns ativos**. Contagens passam a amarrar a posi\xe7\xe3o ao armaz\xe9m certo (mesmo n\xfamero de posi\xe7\xe3o em armaz\xe9ns diferentes n\xe3o se mistura mais), evitando fechamento travado em armaz\xe9m desativado."
        ]
    },
    {
        date: '10/08/2026',
        add: [
            "**Integra\xe7\xe3o CEAF \u2014 contrato v1.2:** cada linha do snapshot de estoque passa a informar **`tipo_armazenamento`** (`CLIMATIZADO`, `REFRIGERADO` ou vazio), conforme a categoria do produto no SIAL \u2014 para a coluna Arm. / climatizado-refrigerado no consumo CEAF/GSnet."
        ],
        changes: [
            "**NF-e (SP) \u2014 incinera\xe7\xe3o/perda (CFOP 5927):** ao faturar, o SIAL preenche automaticamente o c\xf3digo **cBenef SP099999** na nota quando o produto n\xe3o tem esse c\xf3digo no cadastro. Vale s\xf3 para a NF emitida; o cadastro do produto n\xe3o \xe9 alterado."
        ],
        bugfix: [
            "**Integra\xe7\xe3o Vendatus \u2014 bloqueio autom\xe1tico:** o job di\xe1rio de bloqueio por validade volta a avisar o ERP (reserva/bloqueio de estoque) sem falhar por depend\xeancia ausente no servidor.",
            "**Integra\xe7\xe3o Vendatus \u2014 faturamento:** ao confirmar a NF no ERP (`invoice`), o SIAL passa a dar a **baixa de estoque** e encerrar a sa\xedda automaticamente (mesmo fluxo operacional ap\xf3s NF autorizada)."
        ]
    },
    {
        date: '07/08/2026',
        changes: [
            "**Estoque \u2014 bloqueio/desbloqueio:** o campo **Motivo** deixa de ser texto livre. Ao escolher a **Natureza** (Avaria, Vencido, Quarentena etc.), o Motivo \xe9 preenchido automaticamente com o mesmo r\xf3tulo e fica somente leitura. Relat\xf3rios e APIs continuam recebendo o Motivo normalmente."
        ],
        bugfix: [
            "**NF-e de devolu\xe7\xe3o:** se a nota de origem estiver no SIAL mas tiver sido emitida **sem** ClassTrib/IBS/CBS no XML (notas mais antigas), a devolu\xe7\xe3o deixa de travar e usa a classifica\xe7\xe3o do **cadastro do produto**. Quando a origem j\xe1 tem ClassTrib, continua copiando da origem (#MT-E4DE488)."
        ]
    },
    {
        date: '06/08/2026',
        add: [
            "**Comercial \u2014 Relat\xf3rio Notas faturadas - Exclusivo:** filtros de **Status da nota** (Todos, Autorizada, Cancelada, Inutilizada, Pendente, Desabilitada, Rejeitada) e de **Nome do cliente** (lista ao escolher a empresa; tamb\xe9m aceita trecho do nome) (#MT-57E7612).",
            "**Integra\xe7\xe3o Amil \u2014 etiqueta na baixa:** a etiqueta informada na NF de entrada (`etiqueta`) passa a acompanhar o lote (serial) na confer\xeancia e \xe9 enviada na baixa para a Amil no campo `codigoEtiqueta`.",
            "**Central de Importa\xe7\xe3o \u2014 Embalagens:** a planilha passa a usar **SKU do produto** (em vez de ID interno) e **apelido do fabricante**; inclui **peso (kg)** e **altura/largura/comprimento (cm)**, alinhado ao cadastro de embalagens (#MT-F623410)."
        ],
        bugfix: [
            "**Cadastro de Posi\xe7\xf5es \u2014 filtro CSV com muitas posi\xe7\xf5es:** corrigido erro 502 ao importar/aplicar filtro com dezenas de endere\xe7os (OR). O SIAL compacta a lista e o servidor aceita URLs maiores; a grade volta a listar as posi\xe7\xf5es.",
            "**Invent\xe1rio \u2014 achado duplicado:** depois que um item (posi\xe7\xe3o + SKU + lote) j\xe1 foi finalizado, o coletor/web **n\xe3o cria mais** uma segunda linha de \u201Cachado\u201D com o mesmo SKU/lote. Isso evita saldo 2\xd7 no fechamento. Para corrigir quantidade, \xe9 preciso reabrir a contagem do item.",
            "**Relat\xf3rio Cat\xe1logo de posi\xe7\xf5es (CSV):** corrigida lentid\xe3o extrema ao exportar posi\xe7\xf5es vazias em empresas grandes (ex. CAF) \u2014 o download deixava a tela em \u201CCarregando\u2026\u201D por v\xe1rios minutos. A consulta passa a filtrar primeiro e s\xf3 depois buscar estoque/classes das linhas do resultado.",
            "**Filtros \u2014 Fabricante sem Empresa:** ao buscar (ex.: Accord) e escolher na lista, o filtro deixa de trocar pelo fabricante de outra empresa que compartilhe o mesmo c\xf3digo interno. Sem Empresa selecionada, a lista mostra a empresa no r\xf3tulo e o filtro aplica empresa + c\xf3digo juntos.",
            "**Filtros \u2014 Fabricante/Fornecedor:** o campo Fabricante (e Fornecedor) no filtro avan\xe7ado passa a listar c\xf3digo/nome (ou CNPJ+apelido) e s\xf3 aplica depois de selecionar um item v\xe1lido \u2014 evita erro do banco ao enviar texto solto (ex.: `accord`) no lugar do c\xf3digo. Busca do nome/c\xf3digo ignora mai\xfasculas/min\xfasculas quando o cadastro \xe9 \xfanico.",
            "**Filtros / cadastros \u2014 Fabricante e Fornecedor:** ao digitar e escolher na lista, o sistema deixa de gravar outro registro parecido (ex.: v\xe1rias filiais com o mesmo apelido, ou nomes que come\xe7am igual). A lista do filtro de fornecedor mostra CNPJ + apelido; a de fabricante mostra c\xf3digo + nome.",
            "**Comercial \u2014 Relat\xf3rio Notas faturadas - Exclusivo:** corrigido erro ao abrir o relat\xf3rio (consulta ao XML da NF). A listagem por per\xedodo volta a carregar (#MT-57E7612).",
            "**Comercial \u2014 Relat\xf3rio Notas faturadas - Exclusivo (tela):** pr\xe9via com spinner de carregamento; CSV/PDF com barra de progresso; grade no padr\xe3o SIAL (cabe\xe7alho escuro, linhas leg\xedveis). Limite padr\xe3o da pr\xe9via 200.",
            "**Comercial \u2014 Relat\xf3rio Notas faturadas - Exclusivo (pr\xe9via vazia):** corrigido texto das c\xe9lulas da grade (escape com template HTML deixava as linhas em branco mesmo com dados na API).",
            "**Transportadoras \u2014 telefone:** \xe9 poss\xedvel salvar telefone no formato da tela (ex.: +55 (11) 2188-9000), sem erro de valida\xe7\xe3o.",
            "**Transportadoras \u2014 edi\xe7\xe3o de apelido:** corrigido erro de \u201Cduplicidade\u201D ao salvar quando o CNPJ na tela vinha mascarado e outro cadastro tinha o mesmo CNPJ em formato diferente. Trocar s\xf3 o apelido volta a funcionar."
        ]
    },
    {
        date: '05/08/2026',
        add: [
            "**Comercial \u2014 Relat\xf3rio Notas faturadas - Exclusivo:** novo relat\xf3rio com filtro por empresa, cliente/CNPJ e per\xedodo de emiss\xe3o da nota. Pr\xe9via em tela, CSV e PDF, com produto/lote, valores e status (autorizada, cancelada etc.). Acesso pelo grupo **RELATORIOS GERENCIAIS** (e Administradores) (#MT-57E7612).",
            "**IQVIA eCommerce OL (Accord / LLT):** prepara\xe7\xe3o da integra\xe7\xe3o de pedidos do portal OL \u2014 arquivos de pedido, retorno, NF, cancelamento e estoque s\xf3 dos produtos Accord. Pedidos entram no SIAL aguardando aprova\xe7\xe3o. Homologa\xe7\xe3o/FTP com a IQVIA ainda em andamento (#MT-76AD902)."
        ],
        bugfix: [
            "**Invent\xe1rio \u2014 coluna Programa no Excel:** o relat\xf3rio de fechamento passa a mostrar o **nome do programa** do cadastro (ex.: `(3000) IBL CEAF-RE`) em vez do n\xfamero interno `#3`. Itens antigos sem programa no invent\xe1rio usam o programa do lote/produto s\xf3 na exporta\xe7\xe3o, sem alterar o invent\xe1rio fechado. Achados e identifica\xe7\xe3o de posi\xe7\xe3o vazia passam a gravar o programa corretamente.",
            "**Integra\xe7\xe3o Vendatus \u2014 recebimento confirmado:** na conviv\xeancia com notas ainda vindas do Protheus, o SIAL volta a avisar a conclus\xe3o da entrada com n\xfamero/s\xe9rie da NF (a Vendatus localiza a nota por esses campos). Pedidos criados pela API Vendatus seguem com o ID e a linha deles. Corrigido envio quando o n\xfamero da NF vinha com barra (`n\xfamero/s\xe9rie`) no mesmo campo.",
            "**Sa\xeddas \u2014 Confer\xeancia de Sa\xedda:** corrigido erro ao imprimir o relat\xf3rio em sa\xeddas sem separador gravado \u2014 o PDF volta a gerar normalmente.",
            "**Integra\xe7\xe3o Vendatus \u2014 eventos s\xf3 RVD:** o SIAL deixa de enviar webhooks de estoque/sa\xedda/entrada da **LLT** (e GF) para a Vendatus. O envio padr\xe3o fica restrito \xe0 empresa **RVD**, evitando bloqueio indevido de estoque no ERP quando o SKU \xe9 compartilhado entre empresas.",
            "**Invent\xe1rio \u2014 fechamento:** se o fechamento falhar no meio, o SIAL **estorna automaticamente** as entradas/sa\xeddas de ajuste j\xe1 criadas naquela tentativa, evitando estoque duplicado. Tamb\xe9m corrige datas de lote com ano digitado errado (ex.: **0206** vira **2026**) na fabrica\xe7\xe3o/validade.",
            "**Invent\xe1rio \u2014 fechamento (travamento):** o Fechar invent\xe1rio deixa de ficar preso quando outra tela segura o banco. O progresso da barra avan\xe7a por etapas de sobras; se houver conten\xe7\xe3o, o sistema falha com mensagem clara e permite **retomar** sem interven\xe7\xe3o manual no servidor.",
            "**Invent\xe1rio \u2014 simular/fechar exclusivos:** enquanto um usu\xe1rio simula ou fecha o invent\xe1rio, os demais **n\xe3o conseguem** iniciar a mesma a\xe7\xe3o nesse invent\xe1rio (mensagem clara). Evita dois fechamentos ou simula\xe7\xf5es ao mesmo tempo.",
            "**Invent\xe1rio / banco \u2014 prote\xe7\xe3o anti-travamento:** conex\xf5es ociosas com transa\xe7\xe3o aberta no banco passam a ser encerradas automaticamente em poucos minutos, evitando que o Fechar invent\xe1rio fique preso sem progresso."
        ]
    },
    {
        date: '04/08/2026',
        bugfix: [
            "**Controle de Picking / etiqueta de sa\xedda:** a data e hora de **Cria\xe7\xe3o** passam a aparecer no hor\xe1rio de Bras\xedlia (antes sa\xeda cerca de 3 horas adiantada, no hor\xe1rio UTC)."
        ]
    },
    {
        date: '03/08/2026',
        bugfix: [
            "**Invent\xe1rio \u2014 achado na 2\xaa contagem:** se a posi\xe7\xe3o j\xe1 est\xe1 na 2\xaa (ou 3\xaa) e surge um SKU/lote que n\xe3o estava na 1\xaa, o SIAL **n\xe3o volta** as outras linhas para a 1\xaa contagem. O item novo \xe9 registrado e vai para **3\xaa contagem (gestor)**; as demais linhas seguem na fase em que estavam.",
            "**Invent\xe1rio \u2014 lote mai\xfasculas/min\xfasculas:** compara\xe7\xe3o de lote na contagem cega ignora mai\xfasculas (`T` = `t` em todo o alfabeto), evitando tratar o mesmo lote como achado novo s\xf3 por diferen\xe7a de caixa."
        ],
        add: [
            "**Central de Integra\xe7\xe3o \u2014 Vendatus:** na VPN, a Central passa a mostrar o status da integra\xe7\xe3o Vendatus (API de entrada e webhooks de sa\xedda), com filtro **Filtrar integra\xe7\xe3o: Vendatus** e op\xe7\xe3o Vendatus nas a\xe7\xf5es manuais \u2014 para acompanhar pedidos, estoque e eventos sem misturar com Protheus/IQVIA."
        ],
        changes: [
            "**Embalagens \u2014 dimens\xf5es em cm:** altura, largura e comprimento das embalagens passam a ser informados e exibidos em **cent\xedmetros (cm)** (antes constavam como metros). O peso continua em kg.",
            "**Auditoria e Central de Integra\xe7\xe3o:** o hist\xf3rico de requisi\xe7\xf5es e de eventos de integra\xe7\xe3o passa a ser mantido por **at\xe9 30 dias**; registros mais antigos s\xe3o removidos automaticamente para n\xe3o sobrecarregar o banco.",
            "**Impress\xe3o e gera\xe7\xe3o em lote:** a\xe7\xf5es de imprimir, gerar ou processar v\xe1rios registros (entradas, sa\xeddas, pedidos, notas, etiquetas etc.) **exigem marca\xe7\xe3o na grade**. Sem sele\xe7\xe3o, o sistema avisa e n\xe3o segue \u2014 evita processar acidentalmente todo o resultado do filtro.",
            "**Integra\xe7\xe3o Vendatus \u2014 bloqueio/desbloqueio de estoque:** ao bloquear ou desbloquear saldo no SIAL (avaria, quarentena, validade etc.), o ERP recebe o evento correspondente. Troca s\xf3 de posi\xe7\xe3o n\xe3o \xe9 enviada; entradas e sa\xeddas conclu\xeddas seguem nos eventos j\xe1 existentes. Eventos s\xf3 para empresas do escopo Vendatus (**RVD**, **GF**, **LLT**) \u2014 Amil e demais n\xe3o entram."
        ]
    },
    {
        date: '31/07/2026',
        add: [
            "**Integra\xe7\xe3o Vendatus \u2014 FALLBACK:** quando a sa\xedda fica em ajuste operacional (status de diverg\xeancia/unpick), a API informa **fallback** e o faturamento/NF fica bloqueado at\xe9 nova confer\xeancia. A Vendatus recebe o aviso de espera e s\xf3 libera NF ap\xf3s a sa\xedda voltar a **conferida**."
        ],
        changes: [
            "**Integra\xe7\xe3o Vendatus \u2014 consulta de estoque:** a API de estoques passa a devolver nome do produto, armaz\xe9m, posi\xe7\xe3o, lote, datas e quantidades (dispon\xedvel, reservado, bloqueado e total), no detalhe por posi\xe7\xe3o \u2014 adequado para montar invent\xe1rio no Vendatus.",
            "**Integra\xe7\xe3o Amil \u2014 Hospital Santa Helena:** o c\xf3digo de empresa Amil do Hospital passa a ser reconhecido no SIAL (antes s\xf3 Maternidade/Amico), permitindo receber NF/pedido dessa unidade.",
            "**Integra\xe7\xe3o Amil \u2014 nota fiscal/MOV:** ao receber o documento, o SIAL cria o Pedido de Entrada conclu\xeddo e a Entrada j\xe1 faturada, com lote/validade no XML interno, etiqueta no serial, e mant\xe9m a confer\xeancia de entrada obrigat\xf3ria."
        ]
    },
    {
        date: '30/07/2026',
        bugfix: [
            "**Invent\xe1rio \u2014 2\xaa contagem de achado:** ao repetir o mesmo SKU/lote/validade na posi\xe7\xe3o (outro operador), o sistema deixava de reconhecer o item que aguardava 2\xaa contagem e bloqueava com \u201Cj\xe1 foi registrado\u201D. Corrigido \u2014 a 2\xaa contagem grava normalmente.",
            "**Sa\xeddas \u2014 listagem protegida:** pedidos com filtro amplo (ex. expedi\xe7\xe3o desde junho) deixam de puxar **todas** as sa\xeddas de uma vez com itens completos \u2014 isso travava o sistema. A lista em a\xe7\xf5es/etiquetas fica leve e com teto; a grade continua paginada normalmente."
        ]
    },
    {
        date: '29/07/2026',
        bugfix: [
            "**Pedidos de Entrada / Entradas (#MT-3AD0979):** com **Entrada gerada** (n\xe3o cancelada), o Pedido de Entrada trava quantidade, valores e dados principais do cabe\xe7alho (permanecem edit\xe1veis transportador, frete e condi\xe7\xe3o de pagamento). Com Entrada **Conclu\xedda**, a pr\xf3pria Entrada fica somente leitura \u2014 para alterar, use **Estornar**.",
            "**NF-e \u2014 IBS/CBS munic\xedpio (#MT-B5AF625):** produtos com ClassTrib de **redu\xe7\xe3o parcial** (ex. **200030** = 60% Anexo IV) passam a enviar o mesmo **% de redu\xe7\xe3o** no grupo municipal da nota. Antes ia **100%** no munic\xedpio (com al\xedquota municipal 0 em 2026) e a SEFAZ rejeitava com c\xf3digo **1046**. Isen\xe7\xe3o total (redu\xe7\xe3o 100%) continua correta."
        ]
    },
    {
        date: '28/07/2026',
        changes: [
            "**Sa\xeddas \u2014 status no formul\xe1rio:** s\xf3 o perfil **Administradores** pode alterar o status da sa\xedda direto no cadastro. Demais perfis usam **Opera\xe7\xf5es \u2192 Conferir sa\xedda** (e o fluxo de NF/baixa) para avan\xe7ar."
        ],
        add: [
            "**Produtos \u2014 tabela ClassTrib oficial (#MT-6185533):** na aba Tributa\xe7\xe3o o ClassTrib passa a usar a **tabela oficial** IBS/CBS (NT 2025.002). Ao escolher o c\xf3digo, o sistema mostra o **CST** correspondente e a descri\xe7\xe3o. C\xf3digos fora da tabela n\xe3o s\xe3o aceitos. A NF-e continua derivando o CST dos 3 primeiros d\xedgitos do ClassTrib.",
            "**Integra\xe7\xe3o Organon (portal Fidelize) (#MT-5605104):** o monitor passa a cobrir a bateria de homologa\xe7\xe3o Wholesaler \u2014 retorno total/parcial/n\xe3o aceito, cancelamento ap\xf3s retorno, NF (ou NF agrupada), atualiza\xe7\xe3o de NF e consulta de ressarcimento. Em homologa\xe7\xe3o usa a sigla **FAB** (produ\xe7\xe3o continua **ORG** s\xf3 ap\xf3s libera\xe7\xe3o)."
        ],
        bugfix: [
            "**Pedidos de Entrada \u2014 Salvar:** pedidos com **muitos itens** (em geral **13 ou mais**) falhavam ao salvar com a mensagem de dados incorretos (`isEmpty`). Corrigido o conflito com os campos de prazo de pagamento; n\xe3o h\xe1 limite artificial de itens nessa tela.",
            "**NF-e \u2014 devolu\xe7\xe3o (#MT-E4DE488):** na nota de devolu\xe7\xe3o, ClassTrib e al\xedquotas IBS/CBS passam a ser os da **NF de origem** (produto a produto), e n\xe3o os do cadastro atual do item. Evita rejei\xe7\xe3o da SEFAZ quando o cadastro j\xe1 foi atualizado.",
            "**Produtos \u2014 ClassTrib (#MT-6185533):** a lista oficial de ClassTrib deixava de carregar na tela de Produtos (erro na API). Corrigido."
        ]
    },
    {
        date: '27/07/2026',
        add: [
            "**Pedidos de Sa\xedda \u2014 Emergencial (#MT-8EF7902):** no pedido h\xe1 o checkbox **Emergencial**. Pedidos e **sa\xeddas** ligadas a eles aparecem em destaque vermelho nas grades (e nos impressos/CSV). O flag segue na listagem de sa\xeddas para o Coletor priorizar a fila. Pedido Falta n\xe3o herda a marca\xe7\xe3o; o flag pode ser alterado depois da aprova\xe7\xe3o.",
            "**Usu\xe1rios \u2014 Controle de acesso (#MT-48CA418):** nova aba no cadastro com **Ligar controle de acesso**, jornada por dia (Seg\u2013Dom, hor\xe1rios de 30 em 30 min), respons\xe1vel/gestor, libera\xe7\xe3o pontual, solicita\xe7\xe3o/aprova\xe7\xe3o de **horas extras**, e **log de sess\xe3o** (login/logout/tempo) com busca e export CSV/Excel. Fora da jornada o login \xe9 bloqueado (e a sess\xe3o aberta \xe9 encerrada). Ao sair, a sess\xe3o \xe9 invalidada no servidor."
        ],
        bugfix: [
            "**NF-e \u2014 IBS/CBS:** quando o produto tem ClassTrib come\xe7ando com **2** (ex. isen\xe7\xe3o `200009`), a nota passa a enviar o CST **200** e o grupo de **redu\xe7\xe3o de al\xedquota** em UF, munic\xedpio e CBS (antes a SEFAZ rejeitava por CST incompat\xedvel ou por falta do grupo de redu\xe7\xe3o estadual/municipal)."
        ]
    },
    {
        date: '24/07/2026',
        add: [
            "**Produtos \u2014 ClassTrib / IBS / CBS (#MT-68D2168):** no cadastro de produto (aba Tributa\xe7\xe3o) passam a existir **ClassTrib**, base legal e al\xedquotas **IBS** e **CBS**. A NF-e usa esses valores por item (isen\xe7\xe3o 0% e redu\xe7\xe3o de 60% quando cadastrados). O relat\xf3rio completo de produtos tamb\xe9m exporta essas colunas."
        ],
        changes: [
            "**Fabricante \u2014 exibi\xe7\xe3o pelo nome:** nas telas de **Produtos**, **Embalagens**, **Estoques**, **Gerenciamento de estoques**, **Entradas** (resumo/linhas) e nos impressos/exports relacionados, o fabricante passa a aparecer pelo **nome** (raz\xe3o social), e n\xe3o mais pelo c\xf3digo (COD FABRICANTE). O cadastro de Fabricantes mant\xe9m o c\xf3digo e o nome separados."
        ]
    },
    {
        date: '22/07/2026',
        add: [
            "**BI \u2014 Linhas de sa\xedda:** o relat\xf3rio passa a trazer o **nome de quem separou** a sa\xedda (e a data/hora da separa\xe7\xe3o), para medi\xe7\xe3o de produtividade."
        ],
        bugfix: [
            "**Coletor \u2014 confer\xeancia cega em unidades:** com o par\xe2metro \xabcega por embalagem\xbb desligado, o operador informa s\xf3 o total em unidades (sem ver fator nem c\xe1lculo). Vale mesmo se a valida\xe7\xe3o do coletor estiver ligada.",
            "**Integra\xe7\xe3o Vendatus:** no aviso de sa\xedda conferida, o n\xfamero da linha enviado passa a ser o da linha do pedido (como a Vendatus espera), e n\xe3o o sequencial interno da sa\xedda.",
            "**Pedidos (Vendatus / integra\xe7\xe3o):** gerar sa\xedda ou atualizar status de pedido com linhas de n\xfamero alto deixa de falhar com erro de duplicidade.",
            "**Ordem de Endere\xe7amento:** o campo **Fab** passa a usar o fabricante da **embalagem** do lote (quando houver), e s\xf3 cai no cadastro do produto se a embalagem n\xe3o tiver fabricante."
        ]
    },
    {
        date: '21/07/2026',
        add: [
            "**Pedidos de Entrada \u2014 OC Amil (#MT-910C791):** campo opcional **OC Amil** no pedido (ao lado do N\xba empenho), na grade e nos impressos/exports de entradas (PDF do pedido, confer\xeancia, entrada detalhada, listagens e CSV).",
            "**Pedidos de Entrada \u2014 Atendimento (#MT-58DB591):** nova coluna **Atendimento** na grade (Pendente / Parcial / Atendido total), com cores, calculada pela quantidade pedida \xd7 recebida em entradas **conclu\xeddas**. Filtr\xe1vel. O Status operacional (Criado/Aprovado/\u2026) continua separado.",
            "**Pedidos de Entrada \u2014 Condi\xe7\xe3o de pagamento (#MT-741E652):** qtd de parcelas + prazos em dias (estilo GOBI) no pedido; vencimentos calculados na tela. Obrigat\xf3rio ao salvar quando o par\xe2metro da empresa estiver ligado (LLT). Espelho somente leitura na tela Entradas. RVD permanece opcional (integra\xe7\xe3o).",
            "**Pedidos de Entrada \u2014 Aprova\xe7\xe3o (#MT-BD58600):** par\xe2metro por empresa (ligado na LLT) para exigir aprova\xe7\xe3o. Opera\xe7\xf5es **Aprovar selecionados** e **Rejeitar selecionados** (em lote); Status do formul\xe1rio fica bloqueado quando o par\xe2metro est\xe1 ativo \u2014 s\xf3 muda por essas opera\xe7\xf5es. Perfil **Gestor Opera\xe7\xe3o** (e Administradores) recebe a permiss\xe3o.",
            "**Estoques \u2014 nome do fornecedor (#MT-4DF8614):** no export CSV, no BI Anal\xedtico Estoque e nas grades de **Estoques** / **Gerenciamento**, al\xe9m do apelido do fornecedor passa a aparecer a coluna **Fornecedor (nome)** com a raz\xe3o social.",
            "**Pedidos de Entrada \u2014 Importar XML NF-e (#MT-EC62378):** opera\xe7\xe3o **Importar XML NF-e** analisa a nota, casa produtos (EAN/refer\xeancia/SKU e sugest\xf5es semelhantes), permite escolher o fornecedor se o CNPJ n\xe3o estiver cadastrado, e cria o **pedido** (j\xe1 aprovado) + a **Entrada** com o XML. Itens sem v\xednculo podem ficar de fora ap\xf3s confirma\xe7\xe3o parcial.",
            "**Confer\xeancia cega \u2014 unidade m\xednima:** par\xe2metro por empresa **Confer\xeancia cega por embalagem** (ligado = pede caixas \xd7 fator, como hoje; desligado = pede unidade m\xednima, ex. 10.000). Vale s\xf3 na confer\xeancia cega no Coletor e no SIAL. Na SESSP/IBL nasce desligado."
        ],
        changes: [
            "**Gerenciamento de estoques \u2014 Dividir linha (#MT-1D95764):** o modal passa a mostrar o **nome completo do produto**, fabricante, programa, lote fab. e validade, para identificar o item mesmo quando a grade trunca o nome.",
            "**Grupos \u2014 permiss\xf5es por cargo:** os bot\xf5es do cadastro de Grupos passam a ser por **cargo** (Separador, Conferente, Auditor/Invent\xe1rio, Analista Opera\xe7\xe3o, Gestor Opera\xe7\xe3o, Analista Faturamento, Analista Cadastro, Analista BI, Analista Integra\xe7\xe3o, Analista Gente, Gerente, Administrador), em vez de m\xf3dulos do sistema. Cada clique inclui o pacote de permiss\xf5es do perfil (incluindo endpoints do Coletor quando couber). Novos endpoints devem ser liberados tamb\xe9m para o cargo correspondente no cadastro de grupos.",
            "**Invent\xe1rio \u2014 Encerrar posi\xe7\xe3o:** um \xfanico bot\xe3o no Web e no Coletor. O sistema decide sozinho se registra falta f\xedsica, finaliza achados em posi\xe7\xe3o vazia, ou os dois. A pr\xe9via mostra o que ser\xe1 feito antes de confirmar."
        ],
        bugfix: [
            "**Invent\xe1rio \u2014 Skip removido:** n\xe3o d\xe1 mais para \xabpular\xbb item aceitando o saldo do sistema sem contar. Use a contagem ou **Encerrar posi\xe7\xe3o** para falta f\xedsica.",
            "**Pedidos de Entrada \u2014 ordena\xe7\xe3o da grade:** corrigida a ordena\xe7\xe3o das colunas OC Amil, Atendimento, Transportador, NF e demais campos que estavam desalinhados.",
            "**Empresas:** criar empresa n\xe3o quebra mais ao gravar os par\xe2metros operacionais de sa\xedda/confer\xeancia.",
            "**Importar XML NF-e:** pedido e entrada passam a gravar juntos (se a entrada falhar, o pedido n\xe3o fica \xf3rf\xe3o). Match por refer\xeancia do produto mais rigoroso.",
            "**Confer\xeancia de sa\xedda (Web):** com \xabcega por embalagem\xbb ligada, a quantidade segue embalagens \xd7 fator (como no Coletor); desligada, unidade m\xednima."
        ]
    },
    {
        date: '20/07/2026',
        add: [
            "**Embalagens \u2014 peso e medidas:** em cada embalagem (prim\xe1ria/secund\xe1ria/terci\xe1ria) d\xe1 para informar **peso (kg)** e **altura/largura/comprimento (m)**, opcionais. O peso da embalagem passa a sugerir o **peso total na confer\xeancia de sa\xedda** (ainda edit\xe1vel).",
            "**Entradas / Lotes \u2014 Serial:** campo opcional **Serial** (at\xe9 20 letras/n\xfameros) no **pedido de entrada**, na tela **Entradas** (itens) e na **confer\xeancia**, gravado no lote. Tamb\xe9m sai nos impressos/exports da esteira."
        ],
        bugfix: [
            "**Lotes de NF:** a consulta SEFAZ gravava protocolo e j\xe1 disparava baixa de estoque/TechHub para **cada** NF do lote (ex.: 25) na mesma requisi\xe7\xe3o \u2014 isso travava em \xabCarregando\u2026\xbb e gerava 502. Agora grava os protocolos primeiro e s\xf3 depois sincroniza as sa\xeddas, uma a uma.",
            "**Lotes de NF:** consulta/transmiss\xe3o \xe0 SEFAZ n\xe3o segura mais a conex\xe3o do banco aberta durante a chamada \xe0 SEFAZ (isso travava a tela em \xabCarregando\u2026\xbb). Timeout da SEFAZ passa a falhar de forma clara em vez de ficar pendente. Limite de poucos lotes por vez e listagem leve mantidos.",
            "**Lotes de NF \u2014 SEFAZ:** o bloqueio global que gerava o aviso \xabj\xe1 existe transmiss\xe3o/consulta\xbb no faturamento foi **desligado**. Continua o limite de poucos lotes por chamada e a listagem mais leve. Consulta/transmiss\xe3o na tela passam a ir **um lote por vez**.",
            "**Lotes de NF \u2014 lock SEFAZ:** se uma consulta/transmiss\xe3o travar, o bloqueio deixa de ficar preso e impedir o faturamento; o sistema libera lock zumbi e espera alguns segundos antes de avisar que j\xe1 h\xe1 opera\xe7\xe3o em andamento.",
            "**Lotes de NF:** consulta/transmiss\xe3o \xe0 SEFAZ deixa de travar a tela (\xabCarregando\u2026\xbb) quando outra opera\xe7\xe3o j\xe1 est\xe1 em andamento \u2014 o sistema avisa e pede para aguardar; limite de 5 lotes por vez; listagem mais leve.",
            "**IQVIA (#MT-FBF3467):** arquivos do c\xf3d. 847 passam a enviar CNPJ/CPF **s\xf3 com n\xfameros** (sem ponto/barra), para a Codifica\xe7\xe3o identificar o estabelecimento e os clientes.",
            "**Integra\xe7\xe3o AMIL:** o envio de baixas ao HIS passa a se identificar como parceiro **AMIL-SIAL**, evitando bloqueio do firewall da AMIL (regra de bots/bibliotecas HTTP gen\xe9ricas)."
        ],
        changes: [
            "**Serial nos impressos:** o Serial do lote (quando informado na confer\xeancia ou no pedido) passa a sair no **Relat\xf3rio de Confer\xeancia de Entrada**, pedido impresso, entrada detalhada, endere\xe7amento, picklist, etiquetas e exporta\xe7\xf5es de estoque.",
            "**Fabricantes \u2014 COD FABRICANTE:** no cadastro, o campo **Apelido** passa a se chamar **COD FABRICANTE** (o valor continua o mesmo nas APIs). Em impressos e exporta\xe7\xf5es, o fabricante sai com o c\xf3digo e o **nome** (at\xe9 15 caracteres).",
            "**Doca Expedi\xe7\xe3o (#MT-14DB846):** a API fica pronta para o Coletor \u2014 lista com volumes e se j\xe1 tem doca, busca por n\xba da sa\xedda/refer\xeancia, v\xednculo da doca por bip do endere\xe7o e permiss\xf5es alinhadas a quem j\xe1 imprime etiquetas de volume.",
            "**Controle de movimenta\xe7\xf5es (#MT-81A7723):** nova vis\xe3o **Origem \xd7 Destino** \u2014 mostra de qual posi\xe7\xe3o saiu e para qual foi (ex.: `1-P-4-3` \u2192 `1-H-41-1`), em tela, PDF, CSV e Excel. A vis\xe3o por posi\xe7\xe3o (acuracidade) continua dispon\xedvel."
        ]
    },
    {
        date: '17/07/2026',
        bugfix: [
            "**Doca Expedi\xe7\xe3o (#MT-14DB846):** ao abrir a tela com v\xe1rias empresas, o aviso \xabDoca Expedi\xe7\xe3o n\xe3o est\xe1 ativa\u2026\xbb n\xe3o aparece mais para as empresas sem o par\xe2metro \u2014 a lista considera s\xf3 as habilitadas (ex.: LLT).",
            "**Doca Expedi\xe7\xe3o \u2014 Romaneio:** o logo da empresa (ou o logo SIAL) volta a sair corretamente no PDF; antes podia aparecer s\xf3 o texto \xabLogo\xbb quando a imagem do cadastro n\xe3o era PNG.",
            "**Integra\xe7\xe3o VENDATUS:** o aviso de **sa\xedda conferida** para o ERP passa a informar os **lotes** no formato esperado (lista por item), evitando rejei\xe7\xe3o na homologa\xe7\xe3o.",
            "**Sa\xeddas \u2014 itens do modal:** ao abrir uma sa\xedda, o sistema passa a carregar os **produtos** e **lotes** da empresa no navegador \u2014 evita campos s\xf3 com n\xfamero (ID) e o aviso \xabVerificar product\xbb quando o cat\xe1logo local ainda estava vazio (comum no QA).",
            "**Entradas \u2014 cancelar:** d\xe1 para marcar entrada **Criada** como **Cancelada** pelo formul\xe1rio; antes o sistema confundia com o bloqueio de \xabConferida\xbb e impedia o cancelamento."
        ],
        changes: [
            "**Login (homolog QA-VPN):** badge **Ambiente QA** na tela de autentica\xe7\xe3o e t\xedtulo da aba do navegador **QA SIAL**.",
            "**Integra\xe7\xe3o VENDATUS:** envio dos eventos de conclus\xe3o (recebimento/sa\xedda) usa autentica\xe7\xe3o **Bearer** no webhook unificado `/api/sial/events`."
        ]
    },
    {
        date: '16/07/2026',
        add: [
            "**Movimenta\xe7\xf5es \u2014 Controle de movimenta\xe7\xf5es:** novo relat\xf3rio com as **posi\xe7\xf5es que tiveram movimenta\xe7\xe3o** no per\xedodo (\xfatil para acuracidade ap\xf3s separa\xe7\xe3o/derrubadas). Inclui legenda dos tipos L\u2192L, L\u2192R e R\u2192O; formatos Tela (tabela com filtros), PDF (identidade SIAL), CSV e Excel (XLSX), s\xf3 com dados amig\xe1veis em portugu\xeas.",
            "**Estoques \u2014 naturezas de bloqueio (#MT-316C509):** novas op\xe7\xf5es no campo Natureza: **Avaria**, **Falta Fornecedor**, **Falta Armaz\xe9m**, **Recall** e **Desbloqueio** (pr\xe9-selecionada ao desbloquear em lote). Mant\xe9m Falta IBL e as Avarias j\xe1 existentes (Fornecedor/Armaz\xe9m/Transporte).",
            "**Movimenta\xe7\xf5es \u2014 Doca Expedi\xe7\xe3o (#MT-14DB846):** novo status **Doca Expedi\xe7\xe3o (75)** para pedidos canal **Internet**, ap\xf3s NF (sem baixa at\xe9 avan\xe7ar). Par\xe2metro **Doca Expedi\xe7\xe3o ativa** na empresa; flag **Expedi\xe7\xe3o?** nas posi\xe7\xf5es; tela em Movimenta\xe7\xe3o com consulta por transportadora, v\xednculo de posi\xe7\xe3o e **avan\xe7ar em lote**.",
            "**Doca Expedi\xe7\xe3o \u2014 impress\xe3o:** **Romaneio de Transportadora** (PDF no padr\xe3o SIAL, agrupado por transportadora) e **Aviso de Remessa** (mesmo documento das Sa\xeddas) no menu Imprimir."
        ],
        changes: [
            "**Movimenta\xe7\xf5es \u2014 Doca Expedi\xe7\xe3o (#MT-14DB846):** tela no padr\xe3o CRUD do SIAL (grade, filtrar, opera\xe7\xf5es), como Sa\xeddas \u2014 v\xednculo de posi\xe7\xe3o por nome do armaz\xe9m e endere\xe7o (case-sensitive), sem IDs.",
            "**Sa\xeddas \u2014 Etiqueta de Sa\xedda (#MT-4A08587):** a etiqueta volta a mostrar a **data e hora de cria\xe7\xe3o** da sa\xedda.",
            "**Sa\xeddas \u2014 Aviso de Remessa (#MT-8719460):** valores unit\xe1rio, do item e total passam a sair com **6 casas** ap\xf3s a v\xedrgula, **sem arredondamento** (trunca se houver mais casas).",
            "**Sa\xeddas \u2014 Etiqueta de volume SESSP:** layout atualizado com logo IBL, campo **NF** (n\xfamero da fatura), **nome da unidade** no destinat\xe1rio, quantidade no formato \xabN de M\xbb, n\xfamero da sa\xedda e QR alinhado \xe0 direita.",
            "**Entradas \u2014 Entrada Detalhada:** o fornecedor (ou cliente, em devolu\xe7\xe3o) passa a sair com o **nome completo**; a data de **Recebimento** passa a ser a da **confer\xeancia de entrada**.",
            "**Produtos (#MT-60B6998):** o checkbox **Refrigerado** fica em se\xe7\xe3o pr\xf3pria na aba Armazenagem, separado da Portaria 344."
        ],
        bugfix: [
            "**Estoques \u2014 EAN da embalagem (#MT-457F813):** no **Gerenciamento de estoque**, na grade de estoques e no **relat\xf3rio/export CSV**, a coluna EAN passa a exibir o GTIN da **embalagem do lote** (quando cadastrado); se a embalagem n\xe3o tiver GTIN, mant\xe9m o do produto.",
            "**Sa\xeddas / faturamento (#MT-AC86297):** se a grade da sa\xedda ficou com lote/posi\xe7\xe3o diferentes da reserva real da confer\xeancia (L\u2192R), o sistema realinha automaticamente a linha antes de faturar/baixar quando a corre\xe7\xe3o \xe9 inequ\xedvoca \u2014 evita o bloqueio \xablot_id sem estoque na posi\xe7\xe3o\xbb (ex.: lote fabricante errado na grade).",
            "**Telas (Movimenta\xe7\xf5es e outras):** corrigido aviso \xabendpoint is not a function\xbb ao abrir a tela \u2014 o carregamento de empresas/armaz\xe9ns voltou a funcionar.",
            "**Estoques \u2014 etiquetas de lote:** a impress\xe3o passa a sair na **mesma ordem da grade** (ordena\xe7\xe3o/filtro da tela). Antes as etiquetas vinham em ordem interna do banco, diferente da sequ\xeancia exibida no SIAL.",
            "**Sa\xeddas / faturamento (#MT-AC86297):** se a grade da sa\xedda aponta um lote interno antigo (ap\xf3s clone/isolamento) sem estoque na posi\xe7\xe3o, mas o mesmo lote fabricante est\xe1 reservado na mesma posi\xe7\xe3o sob outro ID interno, o sistema corrige automaticamente o lote da linha na confer\xeancia e antes de faturar/baixar \u2014 evita o bloqueio recorrente quando a corre\xe7\xe3o \xe9 inequ\xedvoca."
        ]
    },
    {
        date: '15/07/2026',
        bugfix: [
            "**Sa\xeddas \u2014 armaz\xe9m errado (mesmo endere\xe7o):** se a grade da sa\xedda aponta o lote no armaz\xe9m errado mas o estoque/reserva est\xe1 no mesmo endere\xe7o em outro armaz\xe9m (ex. LLT-1 vs LLT-3), o sistema corrige a posi\xe7\xe3o da linha automaticamente na confer\xeancia e antes de faturar/baixar \u2014 evita o bloqueio recorrente.",
            "**Entradas \u2014 status Conferida:** n\xe3o \xe9 mais poss\xedvel marcar a entrada como Conferida s\xf3 pelo formul\xe1rio, sem concluir a Confer\xeancia de Entrada \u2014 isso evita ficar sem estoque na posi\xe7\xe3o de recebimento e travar o endere\xe7amento.",
            "**Faturamento \u2014 lote de notas (#MT-FDC1773):** ao gerar v\xe1rias NFs de uma vez, o sistema valida todas as sa\xeddas antes de reservar qualquer n\xfamero de nota \u2014 evita saltar a numera\xe7\xe3o quando uma sa\xedda do lote falha (ex.: lot_id sem estoque na posi\xe7\xe3o).",
            "**Sa\xeddas / faturamento:** quando o lot_id da grade n\xe3o tem estoque na posi\xe7\xe3o, a mensagem passa a indicar tamb\xe9m se o mesmo lot_id tem saldo em outra c\xe9lula (ex.: armaz\xe9m errado com o mesmo endere\xe7o)."
        ]
    },
    {
        date: '14/07/2026',
        bugfix: [
            "**Posi\xe7\xf5es \u2014 etiquetas:** corrigido aviso \xabNada para imprimir\xbb ao marcar posi\xe7\xf5es do armaz\xe9m ativo (ex. SES02) cujo endere\xe7o come\xe7a com n\xfamero (ex. `1-T-8-3`) \u2014 a impress\xe3o passa a gerar as etiquetas das linhas selecionadas.",
            "**Coletor / Auditoria \u2014 posi\xe7\xe3o:** corrigido o erro \xabInforme o armaz\xe9m\u2026\xbb ao bipar endere\xe7o (ex. `2-F-14-3`) com o armaz\xe9m j\xe1 selecionado (ex. SES02) \u2014 a busca passa a respeitar o armaz\xe9m escolhido.",
            "**Sa\xeddas / faturamento (#MT-AC86297):** o sistema passa a barrar emiss\xe3o de NF e baixa quando o lot_id da grade da sa\xedda n\xe3o tem estoque na posi\xe7\xe3o \u2014 e sugere o lot_id interno correto quando o mesmo lote fabricante existe sob outro ID (ap\xf3s clone/isolamento). Tamb\xe9m impede isolar lote no gerenciamento enquanto houver sa\xedda aberta nesse lot_id."
        ]
    },
    {
        date: '13/07/2026',
        bugfix: [
            "**NF-e \u2014 lotes:** datas de fabrica\xe7\xe3o/validade fora do padr\xe3o da SEFAZ (ano 2000\u20132099), como validade digitada s\xf3 com dois d\xedgitos do ano, passam a ser barradas com mensagem clara (SKU e lote) antes da transmiss\xe3o \u2014 evita erro t\xe9cnico do schema XML.",
            "**Integra\xe7\xe3o VENDATUS:** nos eventos de entrada conclu\xedda e sa\xedda conferida, os lotes passam a incluir a data de fabrica\xe7\xe3o (`manufacturingDate`), al\xe9m da validade \u2014 o Vendatus recebe as mesmas informa\xe7\xf5es registradas no WMS.",
            "**Integra\xe7\xe3o VENDATUS:** o campo `line` enviado nos itens de pedido de entrada e sa\xedda passa a ser gravado e devolvido nos eventos de recebimento conclu\xeddo e sa\xedda conferida \u2014 o Vendatus recupera o mesmo externalID da linha.",
            "**Integra\xe7\xe3o VENDATUS:** implementados os eventos operacionais (Fase 3) \u2014 o SIAL notifica o Vendatus quando a entrada \xe9 conclu\xedda, a sa\xedda \xe9 conferida ou o pedido \xe9 cancelado.",
            "**Posi\xe7\xf5es \u2014 filtro:** corrigido erro no console ao abrir ou editar o filtro de posi\xe7\xf5es \u2014 o aviso \xabinforme o armaz\xe9m\xbb passa a aparecer s\xf3 ao aplicar, sem travar o modal enquanto voc\xea monta o filtro.",
            "**Posi\xe7\xf5es \u2014 filtro:** para buscar por endere\xe7o ou posi\xe7\xe3o \xe9 obrigat\xf3rio informar o **armaz\xe9m** no filtro (armaz\xe9ns desativados nunca entram na busca). Com o armaz\xe9m correto (ex. SES02), endere\xe7os com prefixo legado (ex. `6-B-4-14`, `5-O-10-1`) voltam a ser encontrados.",
            "**Gerenciamento de estoques \u2014 mover estoque:** corrigido erro \xabVerificar Posi\xe7\xe3o\xbb ao informar destino por endere\xe7o (ex. `5-O-10-1`) com armaz\xe9m SES02 j\xe1 selecionado \u2014 o sistema resolve o endere\xe7o no armaz\xe9m ativo e aceita o formul\xe1rio."
        ]
    },
    {
        date: '12/07/2026',
        bugfix: [
            "**Gerenciamento de estoques \u2014 ajuste de lote fab.:** ao alterar lote, datas ou programa, o sistema passa a trabalhar em linguagem **SKU + lote fab.** (sem identificador t\xe9cnico interno). Se o mesmo SKU e lote existem em v\xe1rios paletes/posi\xe7\xf5es, voc\xea escolhe entre aplicar a **todas** as linhas ou **somente \xe0s marcadas** na grade \u2014 neste \xfaltimo caso o sistema isola automaticamente o lote da linha selecionada. Opera\xe7\xf5es exigem checkbox marcado (n\xe3o usam a p\xe1gina inteira).",
            "**Posi\xe7\xf5es \u2014 grade e etiquetas:** corrigida listagem e impress\xe3o que exibiam endere\xe7os com prefixo de armaz\xe9m desativado (ex. `1-O-38-3` no armaz\xe9m ativo SES02, legado do antigo armaz\xe9m 1 \xabNAO USAR\xbb). Essas posi\xe7\xf5es deixam de aparecer na grade e nas etiquetas.",
            "**Posi\xe7\xf5es \u2014 etiquetas de endere\xe7o:** corrigida impress\xe3o que ignorava a sele\xe7\xe3o na grade quando havia filtro ativo \u2014 passa a imprimir somente as posi\xe7\xf5es marcadas. O di\xe1logo de impress\xe3o mostra a quantidade selecionada. Etiquetas de armaz\xe9m inativo ou posi\xe7\xe3o desabilitada deixam de ser geradas."
        ]
    },
    {
        date: '10/07/2026',
        bugfix: [
            "**Sa\xeddas \u2014 Pick list e confer\xeancia no coletor:** corrigida diverg\xeancia de quantidade quando o operador seguia a ordem impressa da pick list \u2014 a numera\xe7\xe3o da ficha e a sequ\xeancia no coletor passam a usar a mesma rota por endere\xe7o no armaz\xe9m. O QR code de cada item na pick list agora leva o coletor direto para a linha correta ao bipar, sem precisar relacionar manualmente linha do papel com linha do sistema."
        ]
    },
    {
        date: '08/07/2026',
        add: [
            "**Integra\xe7\xe3o AMIL \u2014 pedidos e NF no WMS:** ao receber pedido ou nota fiscal da AMIL (API operador log\xedstico), o sistema passa a criar automaticamente o **pedido de sa\xedda** ou **pedido de entrada** na tela do SIAL, al\xe9m de registrar o recebimento na Central de Integra\xe7\xf5es. Registros antigos na fila podem ser reprocessados via `POST /integrations/amil-oper/inbound/processar`."
        ],
        bugfix: [
            "**Integra\xe7\xe3o VENDATUS \u2014 pedido de entrada:** corrigido erro ao criar pedido via API (`POST /integrations/vendatus/input-orders`) que falhava com mensagem t\xe9cnica interna ao gravar o pedido \u2014 o registro passa a usar o usu\xe1rio t\xe9cnico de automa\xe7\xe3o (SIALBOT), como j\xe1 ocorria nos pedidos de sa\xedda.",
            "**Integra\xe7\xe3o VENDATUS \u2014 atualiza\xe7\xe3o de produto:** corrigido POST (e novo PUT) em `/integrations/vendatus/products` que aceitava o envio mas n\xe3o alterava nome, descri\xe7\xe3o, peso e demais campos quando o SKU j\xe1 existia no SIAL \u2014 em especial ap\xf3s o produto ter movimenta\xe7\xe3o ou pedido vinculado.",
            "**Sa\xeddas \u2014 Controle de Picking (#MT-7C51246):** o PDF passa a exibir a coluna **Cria\xe7\xe3o** com data e hora em que a sa\xedda foi gerada; as linhas continuam ordenadas pela data de cria\xe7\xe3o da sa\xedda.",
            "**NF-e \u2014 consulta de lote ap\xf3s transmiss\xe3o (c\xf3digo 103):** corrigido bloqueio indevido ao consultar recibo logo ap\xf3s transmitir lote ass\xedncrono \u2014 a mensagem \xabAguarde intervalo m\xednimo entre acessos\xbb impedia concluir a autoriza\xe7\xe3o das notas (fluxo transmitir \u2192 consultar). O intervalo de 3 minutos continua valendo apenas para nova transmiss\xe3o do mesmo lote.",
            "**NF-e \u2014 prote\xe7\xe3o contra Consumo Indevido SEFAZ (cStat 656):** corrigido o controle de intervalo entre transmiss\xf5es ao mesmo lote (throttle de 3 minutos n\xe3o estava bloqueando). Ao receber rejei\xe7\xe3o 656, o sistema passa a bloquear automaticamente o CNPJ por 60 minutos, impedindo novas transmiss\xf5es/consultas para o mesmo emitente durante esse per\xedodo com mensagem clara. Ao transmitir v\xe1rios lotes em sequ\xeancia, o sistema passa a aguardar 5 segundos entre cada lote para evitar rajada de chamadas \xe0 SEFAZ."
        ]
    },
    {
        date: '07/07/2026',
        add: [
            "**Automa\xe7\xe3o \u2014 usu\xe1rio SIALBOT:** rotinas autom\xe1ticas do sistema (bloqueio de vencidos, vencimento curto e demais jobs batch) passam a registrar movimenta\xe7\xf5es e auditoria com o usu\xe1rio t\xe9cnico **SIALBOT**, facilitando identificar a\xe7\xf5es autom\xe1ticas nos relat\xf3rios e hist\xf3rico.",
            "**Central de Integra\xe7\xf5es \u2014 reten\xe7\xe3o 30 dias:** rotina autom\xe1tica remove eventos de integra\xe7\xe3o mais antigos que 30 dias (TechHub, GSNET e demais), mantendo a grade utiliz\xe1vel sem milh\xf5es de p\xe1ginas de hist\xf3rico."
        ],
        bugfix: [
            "**Clientes \u2014 cadastro (#MT-E06C166):** corrigido erro ao salvar novo cliente quando o checkbox **Inativo** era enviado pelo formul\xe1rio; integra\xe7\xe3o Protheus passa a reconhecer munic\xedpios como **Santana do Livramento/RS** (nome sem ap\xf3strofo vs. cadastro IBGE).",
            "**Sa\xeddas \u2014 Confer\xeancia Web \xd7 ColetorPWA (#MT-E4C0633):** corrigido **Acesso negado** ao gestor liberar a **\xfaltima linha** do checkpoint para reconfer\xeancia no coletor (bot\xe3o Reconferir) \u2014 faltava permiss\xe3o **DELETE** do checkpoint; GET/POST j\xe1 existiam desde a migra\xe7\xe3o inicial.",
            "**BI \u2014 Kardex resumo:** corrigido erro \xabint() \u2026 NoneType\xbb ao consultar resumo do Kardex quando o produto tinha `quantity` nulo no cadastro \u2014 passa a tratar NULL como zero (saldo f\xedsico continua vindo de `/stocks`).",
            "**Sa\xeddas \u2014 Confer\xeancia Web \xd7 ColetorPWA:** corrigido carregamento do **checkpoint parcial** do coletor na Confer\xeancia de Sa\xedda \u2014 banner \xabConfer\xeancia parcial do ColetorPWA\xbb, itens j\xe1 conferidos pr\xe9-preenchidos (verde) e divergentes destacados (amarelo). Antes a tela abria sem usar os dados salvos pelo coletor.",
            "**Invent\xe1rio V2 \u2014 lote bipado diferente do escopo:** ao contar no coletor um lote que n\xe3o \xe9 o do saldo congelado, o sistema passa a registrar **achado** na posi\xe7\xe3o (n\xe3o fecha mais na linha errada do WMS). Se ainda assim houver diverg\xeancia de lote ou SKU nas contagens, a 2\xaa rodada com mesma quantidade **n\xe3o finaliza** \u2014 exige **3\xaa contagem do gestor**. A simula\xe7\xe3o de fechamento **bloqueia** se restar linha congelada finalizada com lote/SKU bipado diferente do escopo.",
            "**Integra\xe7\xe3o CEAF \u2014 API de estoque (SESSP):** corrigido status de bloqueio enviado \xe0 SES-SP \u2014 saldo **dispon\xedvel** passa a sair sempre como **DISPON\xcdVEL** (alinhado ao BI); vencido/quarentena/bloqueio s\xf3 no saldo **n\xe3o dispon\xedvel**, com o motivo do \xfaltimo bloqueio por data (n\xe3o mais um bloqueio gen\xe9rico antigo sobrepondo vencimento recente)."
        ]
    },
    {
        date: '06/07/2026',
        add: [
            "**Sa\xeddas \u2014 PickList - Ordem:** nova ficha de separa\xe7\xe3o em PDF (menu Sa\xeddas \u2192 Imprimir), com os mesmos dados do Pick List padr\xe3o, **sem QR code**, campo em branco para anotar a **quantidade separada** e assinaturas de **Separador** e **Supervisor** ao final.",
            "**Estoques \u2014 Sa\xeddas para Compras (CSV) (#MT-3786886):** novo relat\xf3rio em **Estoques** e **Gerenciamento de estoque** para o setor de compras \u2014 exporta as baixas de estoque no per\xedodo escolhido com data de sa\xedda, SKU, descri\xe7\xe3o, lote, quantidade, fabricante e fornecedor (da entrada de origem do lote).",
            "**Clientes \u2014 inativar (#MT-690F195):** checkbox **Inativo** no cadastro de clientes; cliente inativo n\xe3o aparece para novos pedidos e a API bloqueia cria\xe7\xe3o/altera\xe7\xe3o de pedido de sa\xedda com mensagem clara. Filtro **Inativo** na grade para localizar e reativar.",
            "**Invent\xe1rio V2 \u2014 Excel saldo por SKU:** planilha com duas abas \u2014 **Detalhe** (uma linha por posi\xe7\xe3o/lote) e **Resumo por SKU** (mesma consolida\xe7\xe3o do PDF de fechamento). Colunas: SKU, descritivo, fator embalagem, programa, saldos, diferen\xe7a, pre\xe7o unit\xe1rio e valor. Dispon\xedvel ap\xf3s **Simular fechamento**.",
            "**Integra\xe7\xe3o AMIL (operador log\xedstico \u2014 fase 1):** API para a AMIL enviar **nota fiscal** e **pedido** ao SIAL (`/integrations/amil-oper/...`), com confirma\xe7\xe3o de recebimento (202) e prote\xe7\xe3o contra duplicidade; base para envio de **baixas** de volta \xe0 AMIL ap\xf3s homologa\xe7\xe3o de rede."
        ],
        bugfix: [
            "**Sa\xeddas \u2014 PickList - Ordem / Estoques \u2014 Sa\xeddas para Compras:** corrigido erro de permiss\xe3o (`endpoint_forbidden`) em bases j\xe1 em produ\xe7\xe3o \u2014 migra\xe7\xe3o **218** registra endpoints e replica permiss\xf5es dos relat\xf3rios j\xe1 liberados no grupo.",
            "**Estoques \u2014 Sa\xeddas para Compras (CSV):** corrigido erro SQL ao exportar (\xabinvalid reference to FROM-clause entry for table products\xbb) \u2014 query alinhada ao padr\xe3o de `stocks.py` (sem alias incompat\xedvel com o lateral de embalagem).",
            "**Estoques \u2014 data de entrada nos relat\xf3rios (#MT-DC02760):** todos os relat\xf3rios de estoque passam a exibir a **data da entrada conclu\xedda** (endere\xe7amento), e n\xe3o mais s\xf3 a data de abertura do documento. Inclui PDF/CSV por SKU, lote e posi\xe7\xe3o, exporta\xe7\xe3o completa por empresa, BI anal\xedtico, bloqueios de saldo e coluna **Data Entrada** na grade.",
            "**Estoques \u2014 Relat\xf3rio completo por empresa (#MT-62EB237):** o **valor unit\xe1rio** passa a vir da **entrada conclu\xedda** (mesma base do relat\xf3rio por lote), e n\xe3o mais do pedido de entrada quando os valores divergem ap\xf3s a confer\xeancia. Vale tamb\xe9m para a grade de Estoques e Gerenciamento de estoque.",
            "**Invent\xe1rio V2 \u2014 Excel saldo por SKU:** corrigido erro ao exportar (\xabN\xe3o foi poss\xedvel acessar o banco de dados\xbb) \u2014 a planilha era gerada ap\xf3s fechar a conex\xe3o com o banco.",
            "**Integra\xe7\xe3o VENDATUS (QA-VPN):** corrigido `POST /partners` com role **supplier** \u2014 erro \xabSuppliers.__init__() takes 2 positional arguments but 3 were given\xbb; endere\xe7o do parceiro passa a resolver munic\xedpio (nome + UF \u2192 IBGE) antes de gravar fornecedor.",
            "**Integra\xe7\xe3o VENDATUS (QA-VPN):** corrigido `GET /stocks` (coluna `lot_number` em vez de `l.code` inexistente); erros 4xx/5xx nas rotas `/integrations/vendatus/*` passam a retornar JSON (`error` + `status`) em vez de p\xe1gina HTML."
        ]
    },
    {
        date: '04/07/2026',
        changes: [
            "**Invent\xe1rio V2 \u2014 PDF de fechamento:** KPIs, fluxo R$ e saldo l\xedquido passam a usar **consolida\xe7\xe3o por SKU** (mesma base da Simula\xe7\xe3o por SKU) \u2014 posi\xe7\xe3o/lote desconsiderados no resumo executivo; detalhamento operacional por posi\xe7\xe3o/lote permanece nas p\xe1ginas seguintes.",
            "**Invent\xe1rio V2 \u2014 PDF de fechamento:** layout executivo redesenhado \u2014 KPIs compactos, **fluxo visual** congelado \u2192 sobras \u2192 faltas \u2192 saldo l\xedquido, barras top 8 SKUs, composi\xe7\xe3o cr\xe9dito/d\xe9bito e tabela resumida (top 10); detalhamento com colunas enxutas e nomes truncados para evitar quebra de p\xe1gina.",
            "**Invent\xe1rio V2 \u2014 PDF de fechamento:** primeira p\xe1gina no formato executivo (KPIs com valores em R$, principais SKUs por valor e quadro resumo); demais p\xe1ginas mant\xeam o detalhamento por item/documento com **pre\xe7o unit\xe1rio** e **valor**; rodap\xe9 com campos de assinatura do **representante da empresa** e do **representante SESSP**."
        ],
        add: [
            "**Invent\xe1rio V2 \u2014 fechamento no servidor:** ao confirmar (c\xf3digo 6 d\xedgitos, a\xe7\xe3o irrevers\xedvel), o SIAL processa o fechamento em background no servidor \u2014 **1 entrada** com todas as sobras e **1 sa\xedda** com todas as faltas, j\xe1 finalizadas. A tela da sess\xe3o exibe apenas o andamento; pode fechar o navegador que o processo continua. Ao concluir, status Fechado e PDF de fechamento dispon\xedveis."
        ],
        bugfix: [
            "**Invent\xe1rio V2 \u2014 PDF de fechamento (502):** corrigido erro **502 Bad Gateway** ao gerar o PDF em invent\xe1rios grandes \u2014 o nginx encerrava a conex\xe3o antes da API concluir (~65 s); timeout do proxy ampliado e relat\xf3rio otimizado (detalhe s\xf3 linhas com ajuste, sem recarregar 1.675 itens).",
            "**Invent\xe1rio V2 \u2014 fechamento (faltas):** corrigido erro de estoque insuficiente quando a posi\xe7\xe3o tinha saldo **bloqueado** ou **j\xe1 reservado** no congelamento (ex.: contagem zero com 1.470 un. reservadas para sa\xedda em andamento) \u2014 o fechamento baixa pelo pool correto e retoma do ponto em que parou ap\xf3s erro.",
            "**Invent\xe1rio V2 \u2014 fechamento (faltas):** corrigido aborto na baixa parcial da sa\xedda \xfanica (\xabBaixa R\u2192O parcial\xbb) quando o fechamento processava faltas em lotes \u2014 t\xedpico de invent\xe1rios grandes (sess\xe3o #126 Refrigerado Jul/2026).",
            "**Invent\xe1rio V2 \u2014 fechamento (sobras):** corrigido erro \xabLote id=\u2026 n\xe3o encontrado\xbb quando o `lot_id` da linha apontava para lote **bloqueado ou desabilitado** no cadastro (ex.: status 2049) \u2014 o fechamento usa os dados do lote ou busca por n\xfamero/validade, sem abortar na 1\xaa etapa.",
            "**Invent\xe1rio V2 \u2014 fechamento (sobras/achados):** corrigido erro \xabLote n\xe3o encontrado\xbb quando a linha de cr\xe9dito tinha n\xfamero e validade do lote informados na contagem mas ainda sem cadastro (`lot_id` nulo) \u2014 t\xedpico de achados em posi\xe7\xe3o; o lote \xe9 localizado ou criado na confer\xeancia da entrada \xfanica.",
            "**Kardex (BI):** colunas **Origem** e **Destino** passam a usar `source_label` / `target_label` da API (endere\xe7o, NF de entrada, ref. de sa\xedda) \u2014 antes a grade ignorava esses campos e exibia \xab\u2014\xbb quando o movimento trazia s\xf3 `warehouse_id` + `location_id`.",
            "**Kardex (BI):** **Saldo ao fim** e \xfaltima linha passam a bater com **SUM(/stocks)** (5.451), n\xe3o com `products.quantity` (8.093). Corrigido quando baixas desabilitadas tinham estorno O\u2192R que repunha o cadastro do produto mas **n\xe3o** todo o estoque em posi\xe7\xf5es. Ajuste fino de arredondamento nos estornos O\u2192R (ex.: 5.452 \u2192 5.451 na \xfaltima linha). Transfer\xeancias L\u2192L continuam sem alterar saldo.",
            "**Kardex (BI):** extrato deixa de exibir endere\xe7amento cancelado e estorno de entrada (I\u2192L desabilitada, L\u2192I, B\u2192I) \u2014 tentativa errada + estorno (ex.: Entrada #1114) n\xe3o aparecem mais, mesmo com \xabIncluir desabilitados\xbb; saldo f\xedsico inalterado."
        ]
    },
    {
        date: '03/07/2026',
        add: [
            "**Invent\xe1rio V2 \u2014 simula\xe7\xe3o por SKU:** novos relat\xf3rios **PDF** e **Excel** com saldo agregado por c\xf3digo de produto (sem posi\xe7\xe3o/lote), colunas traduzidas, totais de cr\xe9dito/d\xe9bito em quantidade e valor \u2014 dispon\xedveis em **Impress\xf5es** na lista de invent\xe1rios e no detalhe da sess\xe3o (ap\xf3s gerar simula\xe7\xe3o)."
        ],
        changes: [
            "**Kardex (BI / portal cliente):** **Entradas no per\xedodo** e **Sa\xeddas / consumos** passam a considerar apenas movimentos conclu\xeddos (endere\xe7amento para posi\xe7\xe3o e baixa de sa\xedda). **Saldo f\xedsico** na grade = saldo inicial + entradas conclu\xeddas \u2212 sa\xeddas conclu\xeddas, linha a linha; **Saldo ao fim** (KPI) = mesma regra na \xfaltima linha. **Estoque atual** (rodap\xe9) vem de `/stocks`. Exclu\xeddas baixas desabilitadas e estornos quando \xabIncluir desabilitados\xbb desmarcado. Removidos **Varia\xe7\xe3o l\xedquida** e coluna **Varia\xe7\xe3o no saldo (+/\u2212)**."
        ],
        bugfix: [
            "**Kardex (BI):** corrigida diverg\xeancia entre saldo final do per\xedodo, saldo f\xedsico na grade e estoque atual quando \xabIncluir movimentos desabilitados\xbb estava marcado \u2014 retornos O\u2192R t\xe9cnicos inflavam o saldo acumulado sem excluir a baixa desabilitada correspondente.",
            "**Kardex (BI):** \xabSaldo ao fim\xbb passa a usar o total de `/stocks` (igual ao rodap\xe9), n\xe3o `products.quantity` (podiam divergir). Consulta a `/locations` no Kardex deixa de exibir popup de permiss\xe3o quando o usu\xe1rio n\xe3o tem \xabPosi\xe7\xf5es\xbb \u2014 o extrato funciona sem o mapa de endere\xe7os.",
            "**Kardex (BI):** corrigido erro 500 no resumo (`column product_id does not exist`) \u2014 agrega\xe7\xe3o de estoque passa a usar `stocks` + `lots`, como no restante do SIAL.",
            "**Kardex (BI) \u2014 vista cliente:** colunas **Entrada (NF)**, **Sa\xedda / consumo (ref.)** e **Motivo bloqueio** passam a vir do enriquecimento da API (`nf_entrada`, `requisicao_his`, `movement_reason`), sem depender de permiss\xe3o GET `/inputs` ou `/outputs` no navegador.",
            "**Kardex (BI) \u2014 vista cliente:** corrigida grade que exibia NF e refer\xeancia de sa\xedda em branco (texto passa a ser renderizado diretamente na c\xe9lula). Consulta exibe anima\xe7\xe3o padr\xe3o **Carregando\u2026** enquanto busca o extrato.",
            "**Kardex (BI):** removido ajuste artificial que deslocava **Saldo f\xedsico** na grade para for\xe7ar igualdade com o rodap\xe9 \u2014 a coluna volta a ser extrato banc\xe1rio (saldo inicial + \u0394 linha a linha); KPI **Saldo ao fim** e rodap\xe9 continuam com estoque atual em posi\xe7\xf5es.",
            "**Kardex (BI):** **Saldo f\xedsico** passa a considerar s\xf3 entradas conclu\xeddas (I\u2192L) e baixas (R\u2192O); estornos O\u2192R, L\u2192I e B\u2192I ficam fora do extrato quando \xabIncluir desabilitados\xbb est\xe1 desmarcado. KPI **Saldo ao fim** = saldo inicial + entradas \u2212 sa\xeddas conclu\xeddas (igual \xe0 \xfaltima linha).",
            "**Invent\xe1rio V2 (coletor):** corrigida a 2\xaa contagem cega quando o mesmo SKU/lote/validade tinha mais de uma linha no escopo (ex.: contagem unificada que fechou uma linha e deixou outra aguardando recontagem). O operador continua bipando posi\xe7\xe3o, SKU, lote e quantidade \u2014 o sistema encaminha para a linha aberta; a 2\xaa contagem segue obrigat\xf3ria por outro operador.",
            "**Invent\xe1rio V2 \u2014 simula\xe7\xe3o de fechamento:** passa a exibir **valores estimados em R$** (pre\xe7o unit\xe1rio m\xe9dio de entrada \xd7 diferen\xe7a), al\xe9m das quantidades de sobra e falta \u2014 no painel da sess\xe3o e no PDF de simula\xe7\xe3o, com saldo l\xedquido em unidades e em valor."
        ]
    },
    {
        date: '02/07/2026',
        changes: [
            "**Invent\xe1rio V2 \u2014 PDF Diverg\xeancias:** relat\xf3rio agrupa 1\xaa e 2\xaa contagem no mesmo item; separa **diverg\xeancias em aberto** (aguardando recontagem) de **diverg\xeancias finalizadas** (hist\xf3rico j\xe1 encerrado)."
        ],
        add: [
            "**Integra\xe7\xe3o CEAF (SESSP):** API HTTPS de consulta de estoque para o sistema CEAF/SES-SP \u2014 snapshot no contrato IBL v1.0, filtro por programa (`projeto_codigo`), pagina\xe7\xe3o e autentica\xe7\xe3o t\xe9cnica (somente leitura).",
            "**Integra\xe7\xe3o CEAF \u2014 contrato v1.1:** campo **`multiplo_distribuicao`** em cada linha do snapshot (fator da embalagem de distribui\xe7\xe3o do produto/lote), alinhado ao relat\xf3rio de estoque completo \u2014 pr\xe9-requisito para o c\xe1lculo de distribui\xe7\xe3o multi-embalagem no CEAF."
        ],
        bugfix: [
            "**Kardex (BI):** corrigido saldo acumulado do per\xedodo \u2014 passa a exibir valores **negativos** quando a matem\xe1tica do extrato (saldo inicial + varia\xe7\xf5es) resultar abaixo de zero, em vez de truncar em zero. Na **vista cliente**, o saldo \xe9 **recalculado** ap\xf3s ocultar movimentos internos, alinhando grade, KPI \xabSaldo ao fim\xbb e exporta\xe7\xe3o CSV/PDF. Ajuste adicional na **grade web**: varia\xe7\xe3o e saldo negativos deixam de aparecer em branco na tela (export CSV j\xe1 estava correto).",
            "**Invent\xe1rio V2 \u2014 Terminei achados:** corrigido bloqueio quando a posi\xe7\xe3o tinha achado na 1\xaa fase e, ao mesmo tempo, falta f\xedsica nas linhas congeladas j\xe1 encaminhada para 2\xaa contagem (Encerrar posi\xe7\xe3o antes de finalizar achados).",
            "**Integra\xe7\xe3o IQVIA e Close-Up:** corre\xe7\xe3o ao montar arquivos de vendas \u2014 o destinat\xe1rio da NF-e passa a ser reconhecido mesmo quando o CNPJ/CPF est\xe1 cadastrado com m\xe1scara e a nota traz s\xf3 d\xedgitos (evita arquivo enviado vazio com cliente j\xe1 existente no SIAL).",
            "**Invent\xe1rio V2 \u2014 excluir contagem:** gestor volta a poder **excluir contagens de linhas finalizadas** (coluna Digitado/Obs.); o item \xe9 reaberto conforme as rodadas restantes.",
            "**Invent\xe1rio V2 \u2014 sobras (achados):** na mesma posi\xe7\xe3o com saldo congelado, SKU com **lote ou validade diferentes** do escopo passa a gerar **nova linha de achado** em vez de erro gen\xe9rico de diverg\xeancia.",
            "**Invent\xe1rio V2 \u2014 multi-SKU na mesma posi\xe7\xe3o:** ao contar outro SKU enquanto um achado aguarda 2\xaa contagem, o sistema **n\xe3o** trata mais esse bip como recontagem do primeiro item.",
            "**Invent\xe1rio V2 (coletor/web):** contagem cega **sem ordem fixa de SKU** \u2014 ap\xf3s diverg\xeancia de um item na posi\xe7\xe3o, o operador pode seguir contando os demais SKUs; a 2\xaa contagem do item divergente continua exigindo **outro operador** no mesmo SKU/lote/validade.",
            "**Invent\xe1rio V2 (coletor):** corrigido aviso falso de \xabsem permiss\xe3o\xbb ao bipar a posi\xe7\xe3o (barra de progresso opcional); a contagem n\xe3o era bloqueada.",
            "**Movimenta\xe7\xf5es (coletor):** corre\xe7\xe3o ao mover saldo **bloqueado** entre posi\xe7\xf5es \u2014 o sistema recusava a opera\xe7\xe3o com erro de tipo de transa\xe7\xe3o."
        ]
    },
    {
        date: '01/07/2026',
        changes: [
            "**Invent\xe1rio V2 \u2014 web = coletor (opera\xe7\xf5es por posi\xe7\xe3o):** no detalhe da sess\xe3o, **Encerrar posi\xe7\xe3o** e **Terminei os achados**, com pr\xe9via antes de confirmar.",
            "**Invent\xe1rio V2 \u2014 Encerrar posi\xe7\xe3o (1\xaa e 2\xaa rodada):** o mesmo bot\xe3o **Encerrar posi\xe7\xe3o** registra falta na 1\xaa contagem e confirma a falta na 2\xaa (outro operador) \u2014 web e coletor.",
            "**Invent\xe1rio V2 \u2014 Cancelar Contagens:** bot\xe3o exige **c\xf3digo de confirma\xe7\xe3o de 6 d\xedgitos** (gerado na hora) em modal de alerta vermelho, evitando exclus\xe3o acidental de todas as contagens do invent\xe1rio.",
            "**Invent\xe1rio V2 \u2014 tabela de acompanhamento:** coluna **A\xe7\xf5es** (Contar / Skip por linha), bot\xe3o **Excluir** na coluna Digitado/Obs. (gestor), layout das linhas reorganizado.",
            "**Invent\xe1rio V2 \u2014 posi\xe7\xe3o vazia multi-achado:** em posi\xe7\xe3o sem saldo congelado, cada SKU/lote/validade vira uma linha; o operador conta v\xe1rios achados e usa **Terminei os achados** para encerrar s\xf3 aquela posi\xe7\xe3o; ent\xe3o cada linha vai para 2\xaa contagem por outro operador (mesmo SKU, lote e validade).",
            "**Invent\xe1rio V2 \u2014 achado em posi\xe7\xe3o vazia:** contagem cega aceita lote e validade informados pelo operador sem exigir cadastro pr\xe9vio no SIAL; bloqueio apenas para SKU sem hist\xf3rico de entrada.",
            "**Movimenta\xe7\xf5es \u2014 saldo bloqueado:** web e coletor passam a permitir mover estoque bloqueado (B\u2192B entre posi\xe7\xf5es ou movimenta\xe7\xe3o unit\xe1ria), com aviso da quantidade bloqueada por SKU e confirma\xe7\xe3o do operador. Saldo **reservado permanece intoc\xe1vel** em qualquer movimenta\xe7\xe3o."
        ],
        add: [
            "**Invent\xe1rio V2 \u2014 coletor (barra de progresso):** ao bipar uma posi\xe7\xe3o, o coletor consulta o progresso cego da 1\xaa contagem (% de SKUs contados) sem revelar saldo esperado; posi\xe7\xe3o vazia no escopo mostra 100% imediato.",
            "**Integra\xe7\xe3o VENDATUS (homologa\xe7\xe3o VPN):** API HTTPS em `/integrations/vendatus/` \u2014 autentica\xe7\xe3o t\xe9cnica, cadastro de produtos e parceiros, pedidos de entrada/sa\xedda, consulta de status, cancelamento, faturamento e estoque, com idempot\xeancia nos POSTs."
        ],
        bugfix: [
            "**Invent\xe1rio V2 \u2014 excluir contagem:** gestor exclui contagens pela coluna Digitado/Obs.; **n\xe3o** \xe9 permitido em linhas j\xe1 **finalizadas**.",
            "**Invent\xe1rio V2 \u2014 achado multi-lote (mesmo SKU):** na mesma posi\xe7\xe3o \xe9 poss\xedvel registrar v\xe1rios lotes/validades do mesmo produto antes de finalizar os achados; o sistema deixa de exigir 2\xaa contagem por outro operador entre lotes distintos.",
            "**NF-e (SP):** notas com CST ICMS 30, 40 ou 41 e CFOP de fiel deposit\xe1rio (5905\u20135907) passam a informar automaticamente o **cBenef** exigido pela SEFAZ-SP (ex.: **SP070030** no retorno simb\xf3lico 5907), evitando rejei\xe7\xf5es 930 e 946 ap\xf3s 01/07/2026, quando o literal **SEM CBENEF** foi desativado. Cadastre o c\xf3digo no produto quando houver benef\xedcio espec\xedfico (ex.: SP010920)."
        ]
    },
    {
        date: '30/06/2026',
        changes: [
            "**Invent\xe1rio V2 \u2014 contagem unificada no coletor (perfil dispon\xedvel):** quando a mesma posi\xe7\xe3o tem mais de uma linha de escopo com o mesmo SKU, lote e validade (somente saldo dispon\xedvel), o operador informa a quantidade f\xedsica uma vez; o sistema reparte internamente entre as linhas sem exibir saldo esperado."
        ],
        add: [],
        bugfix: [
            "**Invent\xe1rio V2 \u2014 contagem cega por endere\xe7o:** posi\xe7\xf5es cujo c\xf3digo come\xe7a com n\xfamero de corredor (ex.: `6-B-2-4` no armaz\xe9m SES02) passam a ser localizadas no armaz\xe9m do invent\xe1rio, sem confundir com armaz\xe9ns desativados no cadastro.",
            "**Sa\xeddas \u2014 Controle de Picking (PDF):** relat\xf3rio passa a listar sa\xeddas na ordem de cria\xe7\xe3o, inclui coluna **Transportador** e abrevia nomes longos de destinat\xe1rio para manter a grade leg\xedvel (#MT-8044505)."
        ]
    },
    {
        date: '27/06/2026',
        changes: [
            "**Pedidos de Sa\xedda \u2014 campo Cliente (27/06):** layout ampliado e destaque visual; release front em PRD-VPN, QA-VPN, SESSP e Palmas.",
            "**PRD-VPN \u2014 release alinhamento (27/06):** deploy completo \u2014 migra\xe7\xf5es 198\u2013209, API Docker rebuild e front bundle `SIAL_DEV.7ce3f534.js` alinhados ao workspace local (Invent\xe1rio V2, export motivo bloqueio, calend\xe1rio de datas). AMIL/Protheus permanecem ativos nesta inst\xe2ncia.",
            "**SESSP \u2014 front alinhado \xe0 VPN (27/06):** deploy frontend com o mesmo pacote de c\xf3digo local da PRD-VPN (Invent\xe1rio V2, calend\xe1rio de datas, export motivo bloqueio).",
            "**Deploy \u2014 prote\xe7\xe3o anti-perda:** scripts oficiais passam a fazer backup no servidor antes de sobrescrever API/front e enviam `src/` s\xf3 via pacote tar (sem `.venv` nem `config.ini`). Valida\xe7\xe3o: `validate-deploy-scripts.ps1`."
        ],
        add: [
            "**Invent\xe1rio V2 \u2014 relat\xf3rio de diverg\xeancias:** novo PDF estruturado (bot\xe3o na sess\xe3o e opera\xe7\xe3o Imprimir na lista) com posi\xe7\xe3o, escopo, dados digitados, operador e motivo de cada diverg\xeancia ou recontagem pendente."
        ],
        bugfix: [
            "**Pedidos de Sa\xedda \u2014 campo Cliente:** campo ampliado na linha superior; Pagamento e Condi\xe7\xe3o movidos para linha pr\xf3pria; texto do cliente em negrito e azul (#475569), igual ao cabe\xe7alho da grade de itens.",
            "**SESSP \u2014 integra\xe7\xf5es:** rotas AMIL e Protheus deixam de ser carregadas nesta inst\xe2ncia (perfil TechHub + GSNET apenas). Limpeza de lixo operacional no servidor (~227 MB de XMLs de debug NFe).",
            "**Gerenciamento de Estoques \u2014 Lote / datas / programa:** campos de fabrica\xe7\xe3o e validade passam a usar o calend\xe1rio nativo do sistema (como no filtro), em vez da m\xe1scara manual que impedia alterar as datas do lote.",
            "**Estoques \u2014 Exportar CSV (Relat\xf3rio Completo):** restaurada coluna **Motivo bloqueio** no export (#MT-F68B743) \u2014 regress\xe3o na SESSP ap\xf3s deploys parciais de invent\xe1rio.",
            "**Lotes e datas (cadastros):** mesma corre\xe7\xe3o do calend\xe1rio nativo em todos os formul\xe1rios que usam data sem hor\xe1rio (cadastro de lotes, confer\xeancia de entrada, etc.).",
            "**Invent\xe1rio V2 \u2014 excluir contagem:** corrigido bot\xe3o \xabExcluir 1\xaa/2\xaa/3\xaa\xbb que sumia ao abrir/atualizar a sess\xe3o (flag de edi\xe7\xe3o era aplicada depois da renderiza\xe7\xe3o da grade).",
            "**Invent\xe1rio V2 \u2014 congelamento de posi\xe7\xe3o:** ao abrir sess\xe3o, o endere\xe7o no escopo passa a ser gravado como `2-B-24-2` (formato leg\xedvel), em vez do array bruto `{2,B,24,2}` do banco.",
            "**Invent\xe1rio V2 \u2014 PDF diverg\xeancias:** posi\xe7\xe3o do escopo `{2,B,24,2}` e digitada `2-B-24-2` tratadas como equivalentes \u2014 o motivo n\xe3o acusa posi\xe7\xe3o errada quando s\xf3 a validade (ou outro campo) divergiu.",
            "**Invent\xe1rio V2 \u2014 PDF diverg\xeancias:** layout reformulado para evitar quebra de texto em colunas estreitas; motivo da diverg\xeancia passa a indicar o campo e os valores digitado vs escopo (ex.: validade), inclusive para contagens j\xe1 registradas com mensagem gen\xe9rica.",
            "**Invent\xe1rio V2 \u2014 operador na contagem:** corrigida exibi\xe7\xe3o do usu\xe1rio que contou (tela e PDF de acompanhamento) \u2014 passa a resolver login/nome via tabela `users` em vez de mostrar UUID bruto.",
            "**Invent\xe1rio V2 \u2014 dados digitados:** lote comparado sem distin\xe7\xe3o mai\xfascula/min\xfascula; validade exibida em DD/MM/AAAA; mensagem de diverg\xeancia indica qual campo divergiu (lote, SKU, posi\xe7\xe3o ou validade).",
            "**Invent\xe1rio V2 \u2014 valor unit\xe1rio do ajuste:** corrigido pre\xe7o absurdo em entradas/sa\xeddas geradas no fechamento \u2014 passa a usar a **m\xe9dia hist\xf3rica** de entradas do produto (exclui ajustes INV-V2), em vez do campo valor do cadastro. Reparo retroativo nas sess\xf5es fechadas #44, #110, #112, #116 e #120 (SESSP)."
        ]
    },
    {
        date: '26/06/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Entradas \u2014 Entrada Detalhada:** relat\xf3rio reformulado (cabe\xe7alho por entrada + tabela de itens/lotes leg\xedvel); corrigido fornecedor em branco em ajustes de invent\xe1rio e colunas desalinhadas no PDF.",
            "**Invent\xe1rio V2 \u2014 PDF Fechamento:** corrigido erro ao gerar PDF ap\xf3s invent\xe1rio encerrado (\xabmissing summary\xbb).",
            "**Entradas \u2014 cancelamento:** corrigido erro ao cancelar entrada quando j\xe1 existia outra entrada ativa com o mesmo n\xfamero de nota e fornecedor (valida\xe7\xe3o de duplicidade bloqueava o cancelamento indevidamente).",
            "**Invent\xe1rio V2 \u2014 acompanhamento:** corrigido erro ao abrir sess\xe3o de invent\xe1rio (resumo e lista de itens) ap\xf3s atualiza\xe7\xe3o da API; painel de acompanhamento e encerramento de posi\xe7\xe3o no coletor restaurados.",
            "**Invent\xe1rio V2 \u2014 fechamento:** corrigido erro \xabCliente da pr\xf3pria empresa (CNPJ) n\xe3o localizado\xbb ao encerrar invent\xe1rio com ajuste de d\xe9bito \u2014 busca do cliente interno tolera CNPJ com ou sem m\xe1scara e usa nome/apelido da empresa como alternativa.",
            "**Invent\xe1rio V2 \u2014 recupera\xe7\xe3o:** restaurados contagem cega no coletor, descongelar, exclus\xe3o de contagens, PDFs de acompanhamento/fechamento e demais rotinas do Invent\xe1rio V2 ap\xf3s regress\xe3o por deploy parcial de API.",
            "**Invent\xe1rio V2 \u2014 tela:** corrigida regress\xe3o que ocultava painel de acompanhamento, barra de progresso na lista e bot\xf5es de PDF/descongelar ap\xf3s deploy com frontend desatualizado.",
            "**Invent\xe1rio V2 \u2014 fechamento CAF:** corrigido erro \xabCliente da pr\xf3pria empresa (CNPJ) n\xe3o localizado\xbb quando o cliente operacional \xe9 outro cadastro (ex. CL1680) \u2014 busca tamb\xe9m por raz\xe3o social contida no nome do cliente, como nos ajustes de invent\xe1rio V1.",
            "**Invent\xe1rio V2 \u2014 abrir/congelar:** corrigido erro ao abrir sess\xe3o (\xabcolumn default_unit_id does not exist\xbb) \u2014 consulta de estoque para invent\xe1rio passou a usar a unidade de compra do produto (`purchasing_unit_id`), coluna existente no cadastro.",
            "**Invent\xe1rio V2 \u2014 contagem cega:** corrigido erro ao salvar contagem (\xabcolumn lot_expiration_date does not exist\xbb); migra\xe7\xe3o 207 e `run-all.py` atualizado com migra\xe7\xf5es 194\u2013207 do invent\xe1rio V2.",
            "**Invent\xe1rio V2 \u2014 2\xaa contagem:** corrigido bloqueio do mesmo operador na 2\xaa rodada \u2014 compara\xe7\xe3o de `counted_by` agora normaliza UUID do Postgres com o usu\xe1rio logado (antes falhava silenciosamente e permitia a mesma pessoa contar de novo).",
            "**Invent\xe1rio V2 \u2014 criar sess\xe3o:** corrigido erro ao salvar/congelar invent\xe1rio (\xab19 placeholders but 18 parameters\xbb) no insert dos itens de escopo."
        ],
        changes: [
            "**Entradas / Sa\xeddas \u2014 relat\xf3rios detalhados:** **Entrada Detalhada** no novo layout; novo **Sa\xedda Detalhada** em **Sa\xeddas \u2192 Imprimir**, no mesmo padr\xe3o (documento + linhas por lote).",
            "**Invent\xe1rio V2 \u2014 PDF Fechamento:** documento final com resumo de cr\xe9ditos/d\xe9bitos agrupados por pedido de entrada ou sa\xedda gerado no fechamento.",
            "**Opera\xe7\xe3o \u2014 deploy SESSP:** deploy somente de API em produ\xe7\xe3o passa a exigir confirma\xe7\xe3o expl\xedcita, para evitar nova regress\xe3o do Invent\xe1rio V2.",
            "**Opera\xe7\xe3o \u2014 deploy frontend:** scripts de deploy validam o `js/` local e o bundle gerado antes de publicar (Invent\xe1rio V2); evita subir front incompleto quando o c\xf3digo validado est\xe1 s\xf3 na m\xe1quina."
        ]
    },
    {
        date: '19/06/2026',
        changes: [
            "**Grupos \u2014 permiss\xf5es:** bot\xf5es \xabPor fun\xe7\xe3o\xbb atualizados (Sa\xeddas, Pedidos, Estoques, Integra\xe7\xf5es, BI etc.); um clique inclui todos os endpoints do m\xf3dulo. Lista \xabDispon\xedveis\xbb organizada em **Consultas**, **Inser\xe7\xe3o**, **A\xe7\xf5es e relat\xf3rios**, **Modifica\xe7\xe3o** e **Exclus\xe3o**."
        ],
        add: [
            "**Sa\xeddas \u2014 Etiqueta de Sa\xedda:** novo item em **Imprimir** com escolha da quantidade de etiquetas; r\xf3tulo 10\xd77 cm com n\xfamero da sa\xedda, empresa, destinat\xe1rio, refer\xeancia do pedido e **QR Code** com o n\xfamero da sa\xedda para leitura no coletor.",
            "**Integra\xe7\xe3o GSNET Entrada (SESSP \u2014 homologa\xe7\xe3o):** preparado teste controlado conforme orienta\xe7\xe3o Prodesp/GSNET (16/06): itens por local 3000/3001/3002 com PMU, tipos de movimenta\xe7\xe3o 71\u201375, CNPJ de homologa\xe7\xe3o e controle de lote N. Migra\xe7\xe3o `192-gsnet-entry-hml-controlled-test.sql`."
        ],
        bugfix: [
            "**Entradas \u2014 Confer\xeancia de Entrada (NF com XML):** corrigido erro que impedia gravar lotes e avan\xe7ar o status (permanecia \xabRecebida\xbb) quando a nota tinha rastreabilidade XML \u2014 a confer\xeancia falhava silenciosamente no servidor. Chamado #MT-48E0144.",
            "**Sa\xeddas \u2014 Etiqueta de Sa\xedda:** modal de impress\xe3o passa a mostrar s\xf3 as sa\xeddas selecionadas (antes apareciam linhas vazias com quantidade 1).",
            "**Logout:** corrigido di\xe1logo \xabDeseja sair?\xbb que reaparecia sozinho ap\xf3s novo login.",
            "**Sa\xeddas \u2014 Etiqueta de Sa\xedda:** corrigido erro ao abrir o modal de impress\xe3o (falha na consulta da grade com filtro ativo); a valida\xe7\xe3o passa a usar apenas as sa\xeddas selecionadas.",
            "**Posi\xe7\xf5es \u2014 filtro com muitas posi\xe7\xf5es (CSV):** corrigido erro \xabInvalid request\xbb ao aplicar filtro com cerca de 30 endere\xe7os ou mais no mesmo armaz\xe9m (condi\xe7\xe3o compacta de posi\xe7\xf5es).",
            "**Invent\xe1rio V2 \u2014 novo invent\xe1rio:** corrigido modal sem fundo (formul\xe1rio transparente sobre o menu); passa a usar o mesmo estilo dos demais modais do SIAL.",
            "**Invent\xe1rio V2 \u2014 salvar sess\xe3o:** corrigido erro \xabDados Incorretos\xbb no campo **Tipo** (valida\xe7\xe3o incompat\xedvel com lista suspensa).",
            "**Invent\xe1rio V2 \u2014 escopo por posi\xe7\xe3o:** filtros de posi\xe7\xe3o passam a aceitar **ID num\xe9rico ou endere\xe7o** (ex.: 2-M-1-2), n\xe3o s\xf3 ID interno.",
            "**Invent\xe1rio V2 \u2014 importa\xe7\xe3o CSV:** corrigida busca de posi\xe7\xe3o na planilha (endere\xe7o com prefixo de armaz\xe9m); coluna **warehouse_code** considerada; linha com posi\xe7\xe3o inv\xe1lida gera erro expl\xedcito.",
            "**Invent\xe1rio V2 \u2014 importa\xe7\xe3o CSV (SKU):** corrigido erro ao importar planilha com SKU num\xe9rico (ex.: 72) \u2014 busca de produto comparava texto com campo SKU do cadastro de forma incorreta.",
            "**Invent\xe1rio V2 \u2014 simula\xe7\xe3o/fechamento:** sess\xf5es sem itens no escopo passam a ser bloqueadas antes da simula\xe7\xe3o ou fechamento; evita encerrar invent\xe1rio vazio por engano.",
            "**Invent\xe1rio V2 \u2014 contagem no coletor/web:** retentativa com a mesma chave de idempot\xeancia passa a retornar o resultado j\xe1 salvo mesmo quando o item foi finalizado, evitando duplicidade e erro indevido ap\xf3s falha de rede.",
            "**Posi\xe7\xf5es \u2014 filtro ao digitar endere\xe7o:** corrigida lista vazia ao digitar parcialmente (ex.: **2-m-**); passa a sugerir posi\xe7\xf5es do armaz\xe9m e aplicar busca parcial no endere\xe7o."
        ]
    },
    {
        date: '18/06/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Movimenta\xe7\xf5es, Estoques e demais telas \u2014 filtro Posi\xe7\xe3o (CSV):** endere\xe7os no formato **2-2-F-10-2** passam a ser filtrados pelo texto completo; antes o sistema cortava um segmento e a grade vinha vazia.",
            "**Posi\xe7\xf5es \u2014 filtro por endere\xe7o/CSV:** corrigido erro \xabInvalid expression: location_address eq \u2026\xbb e grade vazia ao importar endere\xe7os no formato **2-2-F-10-2** (r\xf3tulo \xabarmaz\xe9m + endere\xe7o\xbb); o filtro passa a buscar armaz\xe9m **2** e endere\xe7o **2-F-10-2** como cadastrado no sistema.",
            "**Posi\xe7\xf5es \u2014 importar CSV com muitas posi\xe7\xf5es:** corrigido erro **502 Bad Gateway** ao aplicar filtro com dezenas de endere\xe7os (limite de tamanho da URL no servidor); v\xe1rias posi\xe7\xf5es do mesmo armaz\xe9m passam a ser enviadas em uma \xfanica condi\xe7\xe3o compacta.",
            "**Filtros avan\xe7ados \u2014 importar CSV com muitas posi\xe7\xf5es:** deixa de travar ou exibir erro ao importar dezenas de endere\xe7os; aplica\xe7\xe3o do filtro importado estabilizada.",
            "**Embalagens \u2014 fabricante (GTIN):** o fabricante informado no campo **Fabricante (GTIN)** \xe9 o da embalagem e prevalece quando h\xe1 embalagem cadastrada; **sem embalagem**, estoques e sa\xeddas usam o fabricante legado do produto.",
            "**Integra\xe7\xe3o Protheus \u2014 cadastro de cliente:** corrigido erro ao enviar cliente novo pela integra\xe7\xe3o quando o munic\xedpio n\xe3o era reconhecido (mensagem t\xe9cnica confusa); passa a informar cidade/UF n\xe3o identificados."
        ]
    },
    {
        date: '17/06/2026',
        changes: [
            "**Filtros avan\xe7ados \u2014 campos de data:** filtro por **data apenas** (sem hor\xe1rio); ao escolher um campo de data ou data/hora, o valor abre **calend\xe1rio** para sele\xe7\xe3o. Em colunas com hor\xe1rio, \u201Cigual a\u201D um dia considera o dia inteiro.",
            "**Sa\xeddas \u2014 etiquetas de volumes:** impress\xe3o permitida a partir do status **Separando**; se a sa\xedda ainda n\xe3o foi conferida, o sistema exibe aviso sobre poss\xedvel diverg\xeancia de volumes antes de imprimir."
        ],
        add: [
            "**Movimenta\xe7\xf5es:** coluna **Posi\xe7\xe3o** na grade (endere\xe7o da c\xe9lula, ex.: 1-A-1-1) e filtro por posi\xe7\xe3o no painel Filtrar (lista ou texto parcial)."
        ],
        bugfix: [
            "**Filtros avan\xe7ados (todas as telas):** corrigido conector **OU** entre grupos de condi\xe7\xf5es que era ignorado ao reaplicar o filtro; corrigido agrupamento **Empresa E (\u2026 OU \u2026)** que inseria AND indevido antes de um bloco OU.",
            "**Gerenciamento de Estoques / Estoques \u2014 Exportar CSV (Relat\xf3rio Completo):** relat\xf3rio passa a listar s\xf3 posi\xe7\xf5es com saldo; valores monet\xe1rios exportados com v\xedrgula e at\xe9 4 casas decimais (corre\xe7\xe3o de leitura no Excel).",
            "**Gerenciamento de Estoques / Estoques \u2014 Exportar CSV (Relat\xf3rio Completo):** corrigido valor unit\xe1rio (pre\xe7o da linha do pedido de entrada do lote, n\xe3o m\xe9dia do pedido); valor total passa a considerar a quantidade total do endere\xe7o; embalagem alinhada \xe0 do lote."
        ]
    },
    {
        date: '16/06/2026',
        changes: [
            "**Pedidos de Sa\xedda \u2014 campo Cliente:** busca por CNPJ/CPF (com ou sem m\xe1scara, parcial a partir de 8 d\xedgitos); lista exibe sigla, raz\xe3o social e documento.",
            "**Pedidos de Sa\xedda \u2014 Endere\xe7o Entrega:** lista do pedido exibe tipo do endere\xe7o (faturamento, entrega principal ou nome do CD) junto com logradouro, bairro, cidade/UF e CEP.",
            "**Gerenciamento de Estoques \u2014 Corrigir embalagem do lote:** opera\xe7\xe3o alinhada ao POP \u2014 painel de confer\xeancia no modal (produto, lote, saldos, embalagem atual e pr\xe9via do fator), menu com o nome correto e bloqueio de altera\xe7\xe3o de embalagem fora da rotina dedicada (com auditoria).",
            "**Pedidos de Sa\xedda \u2014 filtro por muitas refer\xeancias:** importa\xe7\xe3o de CSV com grande volume de refer\xeancias passa a usar consulta otimizada (`POST /output-orders/search`), evitando erro 502 ao listar/contar pedidos.",
            "**Pedidos de Entrada, Entradas, Pedidos de Sa\xedda e Sa\xeddas \u2014 modal padr\xe3o:** formul\xe1rios unificados com se\xe7\xf5es Identifica\xe7\xe3o / Fornecedor ou Cliente / Frete, grade de itens com cabe\xe7alho fixo escuro, rolagem interna (~10 linhas) e layout responsivo \u2014 padr\xe3o oficial em todas as inst\xe2ncias SIAL.",
            "**Sa\xeddas \u2014 filtro por muitas refer\xeancias:** importa\xe7\xf5es de filtros com grande volume de refer\xeancias passam a usar consulta otimizada, evitando erro 502 e travamento ao contar/listar resultados.",
            "**Filtros avan\xe7ados (todas as telas CRUD):** \xe9 poss\xedvel clicar em **Aplicar** sem informar nenhum crit\xe9rio para executar busca completa na grade (lista todos os registros permitidos pela credencial)."
        ],
        add: [
            "**Estoques \u2014 bloqueio:** novas naturezas **Vencidos** e **Vencimento Curto** para o job autom\xe1tico de validade e bloqueio manual; hist\xf3rico de bloqueios por validade corrigido no banco.",
            "**Estoques \u2014 bloqueio:** novas naturezas de bloqueio dispon\xedveis ao bloquear estoque: Avaria Fornecedor, Avaria Armaz\xe9m, Avaria Transporte, Quarentena, Vencido e Falta IBL (al\xe9m das naturezas j\xe1 existentes)."
        ],
        bugfix: [
            "**Estoques \u2014 abrir detalhe do estoque:** corrigido erro ao consultar um estoque na grade (falha de SQL no servidor ap\xf3s inclus\xe3o das novas naturezas de bloqueio).",
            "**Pedidos de Sa\xedda / Sa\xeddas \u2014 filtro por muitas refer\xeancias:** corrigido retorno vazio ao importar CSV com operador \xabcont\xe9m\xbb; refer\xeancias compostas (ex.: empenho|n\xfamero) passam a ser encontradas.",
            "**Sa\xeddas \u2014 Gerar notas fiscais:** corrigido modal que aparecia estourado na tela (campos e r\xf3tulos cortados); formul\xe1rio compacto com rolagem interna.",
            "**Pedidos de Sa\xedda \u2014 Previs\xe3o de Entrega (integra\xe7\xe3o):** corrigido acesso \xe0 API `PATCH \u2026/expected-delivery-date` para atualizar a data de previs\xe3o de entrega (antes retornava permiss\xe3o negada para integra\xe7\xf5es).",
            "**Coletor \u2014 endere\xe7amento:** corrigido erro ao finalizar o endere\xe7amento quando a empresa usa bloqueio por classe seletiva (mensagem de coluna inexistente no banco).",
            "**SESSP AWS \u2014 API errada no frontend:** corrigido bundle que chamava `palmas.sialwms.com.br` a partir da tela `sessp.sialwms.com.br` (API_BASE incorreto no JS ap\xf3s deploy paralelo). Novo bundle `SIAL_DEV.4452419a.js`; scripts de deploy AWS validam API_BASE antes de publicar.",
            "**Filtros avan\xe7ados \u2014 busca completa:** corrigido bloqueio ao aplicar filtro vazio quando o campo operador (datalist) mantinha valor interno `-1` \u2014 passa a tratar como vazio e permite busca completa.",
            "**Entradas \u2014 Lista Doc. Entradas (portal-cliente SESSP):** restaurados relat\xf3rio, menu, API PostgreSQL e c\xf3digo versionado no reposit\xf3rio \u2014 o deploy de portais havia removido menu e backend mantendo s\xf3 a p\xe1gina \xf3rf\xe3 no servidor.",
            "**Entradas \u2014 Lista Doc. Entradas (SIAL web):** restaurados relat\xf3rio, rotas de exporta\xe7\xe3o e menu **Entradas \u2192 Relat\xf3rios**.",
            "**Posi\xe7\xe3o de Estoque (portal-cliente SESSP):** colunas **R$ Unit\xe1rio** e **R$ Total** passam a usar o pre\xe7o do item do pedido de entrada (`input_order_items`), alinhado ao relat\xf3rio via API SIAL.",
            "**Integra\xe7\xe3o GSNET Entrada (SESSP):** o total enviado ao GSNET passa a ser calculado por unidade recebida (`QtUnitRecebida \xd7 VlPrecoUnit`) e o controle de lote passa a sair como **N** para todos os itens.",
            "**Integra\xe7\xe3o GSNET Entrada (SESSP):** restaurado envio autom\xe1tico ao concluir o endere\xe7amento da entrada f\xedsica; Central de Integra\xe7\xf5es passa a exibir banner e filtro **GSNET Entrada**, com valida\xe7\xe3o de mapeamento e reenvio manual pela linha selecionada.",
            "**Filtros avan\xe7ados \u2014 Posi\xe7\xe3o:** ao filtrar por v\xe1rias posi\xe7\xf5es com \xabigual a\xbb em linhas consecutivas, o crit\xe9rio passa a usar **OU** entre elas (sele\xe7\xe3o m\xfaltipla), em vez de **E** \u2014 evita resultado vazio quando se escolhem duas ou mais posi\xe7\xf5es.",
            "**Produtos \u2014 listagem:** produto com taxonomia ausente no banco n\xe3o impede mais o carregamento da lista de produtos (ex.: pedidos de entrada).",
            "**Portal-cliente SESSP \u2014 Posi\xe7\xe3o de Estoque:** colunas calcul\xe1veis (embalagem 3\xaa, volumes, peso, \xfaltima movimenta\xe7\xe3o, usu\xe1rio da movimenta\xe7\xe3o e carta de troca) passam a ser preenchidas no relat\xf3rio do portal SESSP, sem alterar o portal BI da AMIL."
        ]
    },
    {
        date: '15/06/2026',
        changes: [],
        add: [
            "**Pedidos de Sa\xedda e Sa\xeddas (#MT-1BCA872 \u2014 Fase 3):** passam a exibir e filtrar pela **Rota** vinculada ao cliente (c\xf3digo na grade; filtro por rota; exporta\xe7\xe3o CSV de pedidos inclui a coluna).",
            "**Etiqueta de expedi\xe7\xe3o SESSP (#MT-1BCA872 \u2014 Fase 2):** a etiqueta de volumes no layout SESSP passa a exibir a **ROTA** vinculada ao cliente (`ROTA: <c\xf3digo>` ou `ROTA: -` quando o cliente n\xe3o tem rota), no lugar do texto fixo \xabGRUPO DE CLIENTES\xbb.",
            "**Organiza\xe7\xe3o \u2014 Rotas (#MT-1BCA872 \u2014 Fase 1.1):** ampliado o m\xf3dulo Rotas com gest\xe3o de clientes vinculados e exporta\xe7\xe3o CSV/XLSX de rotas e clientes por rota. Migra\xe7\xe3o `185-customer-routes-customers-endpoints.sql`.",
            "**Organiza\xe7\xe3o \u2014 Rotas (#MT-1BCA872 \u2014 Fase 1):** criado m\xf3dulo **Rotas** em Organiza\xe7\xe3o e v\xednculo de rota no cadastro de **Clientes**, preparando a exibi\xe7\xe3o de rotas nas etiquetas de expedi\xe7\xe3o e nos filtros operacionais de sa\xedda. Migra\xe7\xf5es `181-customer-routes-table.sql`, `182-customers-route-id.sql` e `183-seed-customer-routes-endpoints.sql`."
        ],
        bugfix: []
    },
    {
        date: '12/06/2026',
        changes: [
            "**Pedidos de Sa\xedda (#MT-01FB218) \u2014 Deploy PRD-VPN 12/06/2026:** coluna **Subtotal** por linha na grade de itens \u2014 atualiza ao informar quantidade, pre\xe7o unit\xe1rio ou % desconto do item (mesma regra do total do pedido).",
            "**Coletor \u2014 polling de fila de sa\xeddas:** novo modo leve `include_items=0` na listagem de sa\xeddas \u2014 reduz drasticamente o volume de dados trafegados no ciclo de polling do coletor (sem itens, sem resumo de SKU). \xcdndice `(company_id, status, id)` aplicado para acelerar o filtro. Migra\xe7\xe3o `180-outputs-polling-index.sql`."
        ],
        add: [],
        bugfix: [
            "**Faturamento \u2014 NF-e \u2014 Deploy PRD-VPN 12/06/2026:** corrigida diverg\xeancia quando a SEFAZ j\xe1 autorizou a nota e um reenvio retorna rejei\xe7\xe3o **204 (duplicidade)** \u2014 o SIAL consulta a situa\xe7\xe3o na SEFAZ e sincroniza o protocolo de autoriza\xe7\xe3o, sem travar a sa\xedda em \xabFaturando\xbb.",
            "**Clientes / Pedidos de Sa\xedda (#MT-A61F144) \u2014 Deploy PRD-VPN 12/06/2026:** corrigido preenchimento autom\xe1tico de **Pagamento** ao selecionar o cliente \u2014 sincroniza\xe7\xe3o via API quando o cache local est\xe1 desatualizado, refor\xe7o no fluxo de condi\xe7\xe3o de pagamento e ao sair do campo Cliente; coluna **Pagamento** na grade de Clientes."
        ]
    },
    {
        date: '11/06/2026',
        changes: [
            "**Gerenciamento de Estoques \u2014 corre\xe7\xe3o de embalagem do lote \u2014 Deploy PRD-VPN 11/06/2026:** opera\xe7\xe3o renomeada (antes \xabTrocar embalagem\xbb); exige justificativa; bloqueia corre\xe7\xe3o com saldo reservado ou sa\xedda aberta no lote; registra auditoria; grade passa a exibir a embalagem do lote (n\xe3o s\xf3 o padr\xe3o do produto). N\xe3o converte quantidade f\xedsica. Migra\xe7\xf5es `176-stock-packaging-change-log.sql` e `177-stock-packaging-change-log-sequences.sql`."
        ],
        add: [
            "**Entradas \u2014 Lista Doc. Entradas \u2014 Portal BI:** mesmo relat\xf3rio dispon\xedvel em **portal-cliente** (Relat\xf3rios \u2192 Lista Doc. Entradas), leitura direta PostgreSQL, exporta\xe7\xe3o CSV e XLSX. Migra\xe7\xe3o `179-bi-input-documents-v1.sql`.",
            "**Recebimento \u2014 rastreabilidade XML (#MT-7CB3235) \u2014 Deploy PRD-VPN 11/06/2026:** ao salvar entrada com XML do fornecedor, o SIAL extrai a tag **RASTRO** (lote, fabrica\xe7\xe3o, validade e quantidade) e registra a expectativa. Na **confer\xeancia de entrada**, diverg\xeancias de quantidade, lote, validade ou fabrica\xe7\xe3o em rela\xe7\xe3o ao XML s\xe3o **registradas para consulta**, sem bloquear recebimento, confer\xeancia ou endere\xe7amento. Consultas **Rastreabilidade esperada** e **Diverg\xeancias de confer\xeancia** no menu Entradas. Migra\xe7\xf5es `174-input-xml-rastro-and-divergences.sql` e `175-input-rastro-divergence-endpoints.sql`.",
            "**Armazenagem (#MT-880E557):** par\xe2metro opcional por empresa **Bloquear armazenagem por classe seletiva** \u2014 quando ativo, impede movimentar produto para posi\xe7\xe3o sem as mesmas classes marcadas como seletivas no cadastro (ex.: climatizado em c\xe9lula refrigerada). Valida\xe7\xe3o no backend em todas as movimenta\xe7\xf5es de endere\xe7amento; par\xe2metro inativo por padr\xe3o. Migra\xe7\xe3o `173-storage-class-blocking.sql`.",
            "**Faturamento \u2014 Controle de emiss\xe3o de NF (#MT-0568870):** novo relat\xf3rio em **Faturamento** para identificar **entradas e sa\xeddas** sem NF SIAL, com NF **pendente na SEFAZ**, **rejeitada**, **autorizada** ou com **diverg\xeancia de status** operacional. Filtros por tipo, per\xedodo, status NF, refer\xeancia, n\xfamero e chave; exporta\xe7\xe3o **CSV**. Somente consulta \u2014 n\xe3o altera movimentos nem transmite \xe0 SEFAZ. Migra\xe7\xe3o `172-nfe-emission-control-report-endpoints.sql`.",
            "**Pedidos de Sa\xedda \u2014 pedido complementar (#MT-833C834):** nova a\xe7\xe3o **Gerar pedido complementar** para pedidos **parcialmente atendidos** com sa\xedda j\xe1 encerrada. Cria um novo pedido com refer\xeancia `PEND-<refer\xeancia original>` contendo somente as quantidades pendentes, vinculado ao pedido original (`shortage_of_order_id`). N\xe3o gera sa\xedda nem reserva estoque \u2014 segue o fluxo normal (aprova\xe7\xe3o \u2192 gerar sa\xedda \u2192 separa\xe7\xe3o \u2192 confer\xeancia \u2192 faturamento). Preserva a regra **1 pedido = 1 sa\xedda** no pedido original. Migra\xe7\xe3o `170-output-orders-create-pending-order.sql`.",
            "**Pedidos de Sa\xedda (#MT-01FB218):** grade de itens com coluna **N\xba item** (1, 2, 3\u2026) e **Total do Pedido** exibido no formul\xe1rio, atualizado ao editar quantidade, pre\xe7o ou desconto da linha.",
            "**Clientes (#MT-A61F144):** novo campo **Pagamento** no cadastro do cliente. Em **novo Pedido de Sa\xedda**, ao escolher o cliente, a forma de pagamento cadastrada \xe9 aplicada automaticamente (sem substituir se voc\xea j\xe1 tiver alterado manualmente); o **Atendimento** inicia como **Televendas** (Teleatendimento). Migra\xe7\xe3o `171-customers-payment-method.sql`."
        ],
        bugfix: [
            "**Entradas \u2014 Lista Doc. Entradas:** datas **Entrada SIAL** e **Entrega** passam a usar conclus\xe3o/recebimento no WMS, com fallback para confer\xeancia ou cria\xe7\xe3o quando o campo principal n\xe3o estiver preenchido; **Processo pagamento** combina observa\xe7\xf5es e refer\xeancia do pedido.",
            "**Entradas \u2014 Lista Doc. Entradas:** quando n\xe3o h\xe1 registros no per\xedodo/filtros, o sistema avisa antes de gerar (sem erro 400); base do per\xedodo padr\xe3o alinhada \xe0 **data de cria\xe7\xe3o** da entrada; mensagem orienta ajustar datas ou desmarcar \xabSomente com empenho informado\xbb.",
            "**Gerenciamento de Estoques \u2014 corre\xe7\xe3o de embalagem:** corrigida grava\xe7\xe3o da auditoria (`stock_packaging_change_logs`) em ambientes com empresas j\xe1 cadastradas. Migra\xe7\xe3o `177-stock-packaging-change-log-sequences.sql`.",
            "**Clientes / Pedidos de Sa\xedda (#MT-A61F144):** corrigido preenchimento autom\xe1tico de **Pagamento** ao selecionar o cliente \u2014 cache local atualizado ap\xf3s salvar o cliente e consulta \xe0 API quando necess\xe1rio; coluna **Pagamento** na grade de Clientes com \xedndice correto na configura\xe7\xe3o de colunas.",
            "**Pedidos de Sa\xedda (#MT-01FB218):** corrigidos erros ao abrir o formul\xe1rio com a nova coluna **N\xba item** e ao preencher **Pagamento** ao selecionar o cliente.",
            "**Pedidos de Sa\xedda \u2014 pedido complementar (#MT-833C834):** modal de confirma\xe7\xe3o passou a usar o padr\xe3o visual do SIAL (caixa `msgbox` com fundo, t\xedtulo e bot\xf5es), corrigindo tela sem diagrama\xe7\xe3o ao gerar pedido complementar.",
            "**Integra\xe7\xe3o GSNET Entrada:** corrigido envio autom\xe1tico ap\xf3s conclus\xe3o do endere\xe7amento \u2014 o sistema n\xe3o criava registro GSNET por erro ao interpretar o tipo do pedido vinculado (`I`). Entradas conclu\xeddas ap\xf3s o deploy passam a integrar normalmente; entradas anteriores reprocessadas em lote.",
            "**Integra\xe7\xe3o GSNET Entrada (homologa\xe7\xe3o):** corrigidos endere\xe7o da API e autentica\xe7\xe3o na URL (`api_key`), conforme orienta\xe7\xe3o Prodesp/GSNET \u2014 elimina resposta HTTP 404 por path incorreto."
        ]
    },
    {
        date: '10/06/2026',
        changes: [
            "**Pedidos de Entrada, Entradas e Pedidos de Sa\xedda \u2014 grade de itens:** formul\xe1rios passam a usar o mesmo padr\xe3o visual da tela Sa\xeddas \u2014 cabe\xe7alho de colunas fixo e destacado, \xe1rea com 10 linhas vis\xedveis (rolagem interna), colunas proporcionais e rodap\xe9 de a\xe7\xf5es separado do cabe\xe7alho do pedido.",
            "**Estoques:** colunas **Valor unit.** e **Valor total** na grade \u2014 pre\xe7o do item no pedido de entrada \xd7 quantidade dispon\xedvel; exporta\xe7\xe3o CSV completa com os mesmos valores."
        ],
        add: [],
        bugfix: [
            "**BI \u2014 Posi\xe7\xe3o de Estoque:** colunas calcul\xe1veis deixam de aparecer como \xabN\xe3o informado\xbb quando h\xe1 dado no SIAL: embalagem 3\xaa por capacidade terci\xe1ria, volumes, peso quando cadastrado, \xfaltima movimenta\xe7\xe3o, usu\xe1rio da movimenta\xe7\xe3o e carta de troca.",
            "**Picking:** PDF de separa\xe7\xe3o passa a exibir **Lote** e **ID Lote SIAL**, evitando confus\xe3o quando dois saldos t\xeam o mesmo lote comercial em posi\xe7\xf5es diferentes.",
            "**Pedidos de Entrada / Entradas / Pedidos de Sa\xedda \u2014 modal e grade:** modal responsivo (cabe na tela, rolagem do overlay quando o formul\xe1rio \xe9 alto); grade de itens com barra de rolagem pr\xf3pria e altura adaptativa \xe0 viewport; cabe\xe7alho do pedido em colunas que se reorganizam em telas menores.",
            "**Pedidos e movimenta\xe7\xf5es \u2014 Cliente / Produto:** campo Cliente (e Fornecedor no pedido de entrada) mais largo no cabe\xe7alho; coluna Produto ampliada na grade; ao passar o mouse, tooltip com o texto completo do cliente ou do produto.",
            "**Sa\xeddas / Entradas \u2014 Gerar notas fiscais:** modal compacto e responsivo (cabe na tela, rolagem interna); sele\xe7\xe3o de CFOP/finalidade e informa\xe7\xf5es complementares sem ocupar a tela inteira; tooltip no CFOP com descri\xe7\xe3o completa.",
            "**Kardex \u2014 Ref. cliente / HIS:** corrigido enriquecimento que repetia a mesma refer\xeancia em todas as linhas; entradas e transfer\xeancias passam a exibir \xab\u2014\xbb na coluna; sa\xeddas e reservas mostram a refer\xeancia vinculada ao movimento correto.",
            "**Estoques / Gerenciamento de estoques \u2014 grade:** colunas de quantidade reunidas (Dispon\xedvel, Reservado, Bloqueado); Valor unit. e Valor total ap\xf3s as quantidades; coluna Bloqueado vis\xedvel novamente no gerenciamento."
        ]
    },
    {
        date: '09/06/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Filtros avan\xe7ados:** \xe9 poss\xedvel clicar em **Aplicar filtro** sem preencher nenhuma condi\xe7\xe3o \u2014 a grade lista todos os registros. Linhas incompletas no construtor s\xe3o ignoradas em vez de bloquear o envio.",
            "**Filtros avan\xe7ados \u2014 importar CSV:** importa\xe7\xe3o com muitas linhas (ex.: dezenas de posi\xe7\xf5es) deixa de demorar dezenas de segundos \u2014 modo r\xe1pido sem recriar datalist por linha; lista de posi\xe7\xf5es compartilhada e cache ao editar manualmente.",
            "**Posi\xe7\xf5es \u2014 filtro por endere\xe7o/CSV:** corrigido erro \xabInvalid expression: location_address eq \u2026\xbb ao aplicar filtro importado ou por endere\xe7o; valores no formato armaz\xe9m-endere\xe7o (ex.: 2-2-C-1-5) passam a filtrar armaz\xe9m 2 + endere\xe7o 2-C-1-5.",
            "**Integra\xe7\xe3o GSNET Entrada:** corre\xe7\xe3o na montagem dos itens da entrada f\xedsica (tabela `input_items` usa `number`, n\xe3o `id`) \u2014 evita falha ao gerar payload."
        ]
    },
    {
        date: '08/06/2026',
        changes: [
            "**Kardex (BI):** tela alinhada ao portal cliente \u2014 vista cliente (extrato simplificado), filtro de staging, enriquecimento NF/ref. cliente/HIS, saldo recalculado no per\xedodo, rodap\xe9 de estoque atual e exporta\xe7\xe3o CSV/PDF com as mesmas colunas.",
            "**Kardex (BI):** corre\xe7\xe3o de layout \u2014 cabe\xe7alhos da grade vis\xedveis, cards de resumo leg\xedveis, colunas monet\xe1rias ocultas quando \xabSem valores monet\xe1rios\xbb, legenda do fluxo I/L/R/O na vista completa.",
            "**Sa\xeddas \u2014 modal de edi\xe7\xe3o:** cabe\xe7alho reorganizado e grade de itens com colunas fixas, cabe\xe7alho destacado, \xe1rea com 10 linhas vis\xedveis (rolagem a partir da 11\xaa; corre\xe7\xe3o do formset que limitava a ~1 linha) e rodap\xe9 separado."
        ],
        add: [
            "**Integra\xe7\xe3o GSNET Entrada (SESSP):** envio autom\xe1tico ao concluir endere\xe7amento da entrada f\xedsica; mapeamento IdItem \u2190 codigo_cliente do produto, IdTpMovimentacao \u2190 c\xf3digo do tipo de recebimento, IdDestinoTedTdd \u2190 c\xf3digo do programa; API Prodesp Entrada.Servico em homologa\xe7\xe3o.",
            "**Central de integra\xe7\xf5es (SESSP):** monitoramento GSNET Entrada no banner da tela Eventos de integra\xe7\xe3o (\xfaltimo evento, falhas no per\xedodo, status operacional) e filtro r\xe1pido **GSNET Entrada**.",
            "**#MT-E4C0633 \u2014 Confer\xeancia de Sa\xedda:** checkpoint parcial via ColetorPWA \u2014 quando uma diverg\xeancia bloqueia a confer\xeancia no coletor, o SIAL preserva os itens j\xe1 conferidos e encaminha a pend\xeancia para tratativa na Confer\xeancia Web (banner, itens pr\xe9-preenchidos, divergente destacado). Migra\xe7\xe3o `166-output-collector-conference-checkpoint.sql`.",
            "**Empresa \u2014 Par\xe2metros:** op\xe7\xe3o **Confer\xeancia de sa\xedda com valida\xe7\xe3o** (`out_conference_collector_validation`) \u2014 ligada: Coletor bloqueia em diverg\xeancia e envia checkpoint; desligada (padr\xe3o): fluxo legado do coletor. Migra\xe7\xe3o `167-out-conference-collector-validation.sql`."
        ],
        bugfix: [
            "**#MT-C203748 \u2014 Sa\xeddas / ColetorPWA:** ao bloquear mudan\xe7a de status sem permiss\xe3o, a API informa o endpoint exato para conceder em Sistema \u2192 Grupos (\xabSa\xeddas \u2014 avan\xe7ar status manual (formul\xe1rio legado)\xbb PUT) e a alternativa da Confer\xeancia Web.",
            "**Kardex (BI):** busca de produto deixou de usar operador inv\xe1lido `sw` na API (`Invalid request`); passa a usar `co`/`eq` em SKU, nome e id.",
            "**Kardex (BI):** ao buscar por SKU \xfanico ou clicar \xabConsultar\xbb com c\xf3digo j\xe1 digitado, o produto \xe9 selecionado automaticamente \u2014 antes era obrigat\xf3rio clicar na lista e o extrato n\xe3o carregava.",
            "**#MT-34A5811 \u2014 NF-e / Lotes:** ajustado fluxo para preservar chave de acesso j\xe1 gerada no envio do lote, sincronizar `invoices.key` com a chave autorizada pela SEFAZ no retorno e localizar a nota correta mesmo quando a chave divergir \u2014 evitando nota \xabn\xe3o autorizada\xbb na tela e falha na baixa da sa\xedda.",
            "**#MT-34A5811 \u2014 opera\xe7\xe3o:** script com dry-run obrigat\xf3rio para sincronizar chaves autorizadas do lote 3027 nas NFs 10392\u201310410 (`scripts/fix_mt_34a5811_invoice_keys_from_lot.py`; ver `doc/operational/MT-34A5811-correcao-chaves-nfe-lote-3027.md`)."
        ]
    },
    {
        date: '06/06/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Sa\xeddas \u2014 Confer\xeancia de Sa\xedda:** campo Validade conferida passa a usar formato DD/MM/AAAA (ano com 4 d\xedgitos), corrigindo rejei\xe7\xe3o de lotes com validade em 2099 ao digitar, por exemplo, 30/12/2099 em vez de 30/12/99."
        ]
    },
    {
        date: '05/06/2026',
        changes: [],
        add: [
            "**Filtro avan\xe7ado:** nova experi\xeancia visual com grupos E/OU (Construtor e Visualizar express\xe3o), mantendo compatibilidade com o filtro t\xe9cnico atual (`filter=`), importa\xe7\xe3o CSV e filtros salvos."
        ],
        bugfix: [
            "**Filtro avan\xe7ado:** importa\xe7\xe3o CSV volta a preencher campo, operador e valor; coluna Valor carrega op\xe7\xf5es do cadastro (empresas, programas, armaz\xe9ns etc.) ao escolher a categoria.",
            "**Filtro avan\xe7ado:** modal com rolagem na \xe1rea de grupos/express\xe3o quando o filtro fica extenso (cabe\xe7alho, abas e bot\xf5es permanecem vis\xedveis).",
            "**Filtro avan\xe7ado \u2014 importa\xe7\xe3o CSV:** convers\xe3o correta de conectores e/ou para grupos visuais; preenchimento de valores ap\xf3s importar; modelo CSV com formato por grupos (colunas grupo e grupo_conector) al\xe9m do legado.",
            "**Filtro avan\xe7ado:** express\xe3o t\xe9cnica com Empresa/Armaz\xe9m + grupo OU deixa de gerar par\xeanteses duplos `((`, que a API rejeitava como filtro inv\xe1lido."
        ]
    },
    {
        date: '04/06/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Estoques / Gerenciamento de estoque (#MT-DBF2985):** filtro no modal (tenant/empresa + SKU ou outro crit\xe9rio) passa a montar a express\xe3o correta para a API \u2014 resolve o r\xf3tulo da empresa (ex.: Maternidade - Amil 2) antes de aplicar, mant\xe9m todos os crit\xe9rios ao reaplicar e usa AND impl\xedcito entre linhas quando o conector estiver vazio.",
            "**Posi\xe7\xf5es / busca de endere\xe7o:** filtro `address*cc*` (case-sensitive) na API de locations deixava de ser aceito (`Invalid request`) \u2014 operadores `cc`/`cb`/`ce` inclu\xeddos na valida\xe7\xe3o do filtro.",
            "**Gerenciamento de estoques \u2014 Posi\xe7\xe3o destino:** ao digitar o endere\xe7o, o texto n\xe3o \xe9 mais apagado ap\xf3s a busca na API; a pesquisa em lote deixa de abrir o overlay \xabCarregando\u2026\xbb a cada tecla.",
            "**Filtros:** modal deixa de clonar listas internas de Operador/Conector a cada linha, evitando IDs duplicados e diverg\xeancia entre o texto exibido e o valor enviado para a API; bot\xf5es de par\xeanteses passam a ser bot\xf5es comuns do formul\xe1rio; desativa linha extra autom\xe1tica ao editar a \xfaltima linha (autoRow) e limpa campos ao inserir linha com +; importa\xe7\xe3o CSV usa contagem real de linhas e preenche a coluna Operador (c\xf3digo interno ex.: eq \u2192 exibe Igual a); limpar todo o filtro: primeiro \xedcone da barra (lixeira), distinto dos demais; bot\xe3o limpar passa a zerar de fato os campos do modal (datalist e clique no \xedcone)."
        ],
        add: [
            "**Sa\xeddas \u2014 confer\xeancia (#MT-C203748):** perfis conferente/auxiliar n\xe3o podem mais avan\xe7ar a sa\xedda alterando o status no formul\xe1rio ao clicar no registro; o avan\xe7o na fase Separada/Conferindo deve ser feito por **Opera\xe7\xf5es \u2192 Conferir sa\xedda** (confer\xeancia web). Migra\xe7\xe3o `165-output-manual-status-advance-permission.sql`.",
            "**Gerenciamento de estoques \u2014 Movimentar / Movimentar (lote):** campo **Posi\xe7\xe3o destino** passa a carregar endere\xe7os do armaz\xe9m via API (lista completa do sistema) e refinar a pesquisa com filtro case-sensitive (`S-1` \u2260 `s-1`)."
        ]
    },
    {
        date: '03/06/2026',
        changes: [],
        add: [
            "**Caixas de Picking \u2014 opera\xe7\xe3o Web:** na gest\xe3o (Movimenta\xe7\xe3o \u2192 Caixas de Picking) e na tela Sa\xeddas \xe9 poss\xedvel abrir caixa, adicionar itens, lacrar, cancelar e consultar detalhes. Na Confer\xeancia de Sa\xedda Web h\xe1 atalhos para ver caixas, abrir a gest\xe3o e lacrar caixa aberta com itens.",
            "**Coletor \u2014 embalagem na sa\xedda:** a consulta da sa\xedda no coletor passa a informar, por linha, o n\xedvel de embalagem (secund\xe1ria, terci\xe1ria etc.) e se a linha conta como volume pr\xf3prio, com base no cadastro de embalagens e no lote."
        ],
        bugfix: [
            "**Caixas de Picking:** linhas de embalagem terci\xe1ria n\xe3o podem mais ser inclu\xeddas em caixa de picking \u2014 s\xe3o tratadas como volume pr\xf3prio.",
            "**Confer\xeancia de Sa\xedda Web:** volumes e quantidades nas caixas lacradas consideram embalagem terci\xe1ria como volume separado, alinhado ao coletor.",
            "**Integra\xe7\xe3o Protheus \u2014 entradas:** o conector deixa de reenviar confirma\xe7\xe3o de recebimento quando o Protheus j\xe1 registrou a opera\xe7\xe3o."
        ]
    },
    {
        date: '02/06/2026',
        changes: [],
        add: [
            "**Invent\xe1rio V2 \u2014 Coletor:** m\xf3dulo de invent\xe1rio com contagens 1\xaa, 2\xaa e 3\xaa dispon\xedvel no coletor m\xf3vel."
        ],
        bugfix: [
            "**Integra\xe7\xe3o Protheus:** consultas ao ERP otimizadas e com limite de tempo, reduzindo travamentos no conector.",
            "**Abertura de telas:** Estoques, Entradas, Sa\xeddas, Transa\xe7\xf5es, Movimenta\xe7\xf5es e Posi\xe7\xf5es deixam de carregar cat\xe1logos inteiros ao abrir \u2014 telas respondem mais r\xe1pido.",
            "**Entradas:** ao abrir um registro na lista, produtos e posi\xe7\xf5es voltam a carregar corretamente no formul\xe1rio.",
            "**Desempenho da API:** ajuste na reciclagem de processos do servidor para evitar consumo excessivo de mem\xf3ria em consultas grandes."
        ]
    },
    {
        date: '01/06/2026',
        changes: [],
        add: [
            "**Invent\xe1rio V2 \u2014 m\xf3dulo reconstru\xeddo:** novo m\xf3dulo de invent\xe1rio com fluxo completo de 1\xaa, 2\xaa e 3\xaa contagem audit\xe1veis, congelamento de saldo, simula\xe7\xe3o em PDF com marca d'\xe1gua e fechamento definitivo via pedido de entrada (cr\xe9dito) e sa\xedda (d\xe9bito). Cada contagem do ColetorPWA \xe9 salva individualmente com `idempotency_key`. Migra\xe7\xf5es `140-inventory-v2-tables.sql` e `141-inventory-v2-endpoints.sql`."
        ],
        bugfix: [
            "**Gerar sa\xeddas \u2014 pedido com lote fixo:** corrigido erro 500 \xabsem teto no pedido\xbb (trigger migra\xe7\xe3o 105) quando o picking fazia fallback FEFO para outro lote enquanto o pedido de sa\xedda exigia lote espec\xedfico; agora s\xf3 aloca lotes autorizados no pedido.",
            "**Invent\xe1rio V2 \u2014 estabiliza\xe7\xe3o de fechamento e contagens:** corrigidos bloqueios cr\xedticos do fechamento (inje\xe7\xe3o de servi\xe7os, cria\xe7\xe3o correta de pedidos/entradas/sa\xeddas e baixa f\xedsica), valida\xe7\xe3o obrigat\xf3ria de 100% dos itens finalizados antes de simular/fechar, valida\xe7\xe3o de 3\xaa contagem por grupo gestor e corre\xe7\xe3o da idempot\xeancia por item na grava\xe7\xe3o das contagens.",
            "**NF-e \u2014 envio SEFAZ (DIFAL / ICMSUFDest):** o campo `pICMSInter` passa a usar a al\xedquota interestadual correta (4%, 7% ou 12%), em vez da al\xedquota do bloco ICMS do item \u2014 que podia ser 0% em CST isento/outros e quebrava a valida\xe7\xe3o XSD no envio do lote.",
            "**Pedido de Sa\xedda \u2014 Endere\xe7o Entrega (#MT-F41E659):** ap\xf3s selecionar o endere\xe7o, o campo passa a exibir o r\xf3tulo leg\xedvel (ex.: *Endere\xe7o de faturamento \u2014 Guarulhos/SP*) em vez do id interno (-1/-2); ids virtuais do cadastro principal continuam sendo gravados corretamente no pedido."
        ]
    },
    {
        date: '30/05/2026',
        changes: [
            "**Pedidos de Sa\xedda / Pedidos de Entrada:** modal de cadastro e detalhamento com largura ampliada (~30%) para melhor visualiza\xe7\xe3o dos campos do cabe\xe7alho e da grade de itens.",
            "**Entradas \u2014 Confer\xeancia (#MT-6707534):** ao informar **data de validade vencida** no campo Data Val, o sistema exibe alerta imediato para o conferente (destaque visual + mensagem), facilitando a revis\xe3o antes de seguir.",
            "**Pedido de Sa\xedda \u2014 Endere\xe7o Entrega (#MT-F41E659):** ao selecionar o cliente, o campo **Endere\xe7o Entrega** passa a listar tamb\xe9m o **endere\xe7o de faturamento** e o **endere\xe7o de entrega** do cadastro principal, al\xe9m dos endere\xe7os adicionais \u2014 conforme solicitado pelo comercial.",
            "**Estoques \u2014 Bloqueios de saldo (#MT-CFE9595):** relat\xf3rio PDF/CSV passa a trazer **valor unit\xe1rio** do item (m\xe9dia da entrada do lote) e a **observa\xe7\xe3o** informada na opera\xe7\xe3o de bloqueio/desbloqueio, facilitando a an\xe1lise financeira e o entendimento de cada caso.",
            '**Portaria 344 \u2014 Filtros e Relat\xf3rios (#MT-AB26625):** o flag **Portaria 344** do cadastro de itens passa a estar dispon\xedvel como filtro nas telas de **Estoques** e **Gerenciamento de Estoques**. Os relat\xf3rios de estoque (por SKU, por Lote, por Posi\xe7\xe3o e CSV completo) passam a exibir a coluna **Portaria 344**, indicando "Sim" para os itens controlados.',
            "**Pedido de Sa\xedda \u2014 Previs\xe3o de Entrega (#MT-50E4699):** novo campo **Prev. Entrega** no pedido de sa\xedda para registrar a data de previs\xe3o de entrega. Dispon\xedvel no formul\xe1rio, na grade (coluna filtr\xe1vel/orden\xe1vel) e via API dedicada `PATCH /output-orders/{id}/expected-delivery-date`. Migra\xe7\xe3o `136-output-orders-expected-delivery-date.sql`."
        ],
        add: [],
        bugfix: [
            "**Estoques / Gerenciamento de Estoques (#MT-AB26625):** coluna **Portaria 344** passa a aparecer na grade (filtro j\xe1 existia; faltava exibi\xe7\xe3o na view compartilhada)."
        ]
    },
    {
        date: '28/05/2026',
        changes: [
            "**Integra\xe7\xe3o AMIL:** usu\xe1rio t\xe9cnico para homologa\xe7\xe3o de consulta de estoque via API."
        ],
        add: [],
        bugfix: []
    },
    {
        date: '28/05/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Sa\xeddas / gera\xe7\xe3o de picking:** o motor passa a considerar saldo livre **por posi\xe7\xe3o**, e n\xe3o descarta o lote inteiro s\xf3 porque outra c\xe9lula do mesmo lote est\xe1 bloqueada. Com atendimento parcial habilitado, o pedido consome o que estiver eleg\xedvel (ex.: 278 un.) e informa a falta residual do item."
        ]
    },
    {
        date: '27/05/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Sa\xeddas \u2014 hierarquia de embalagem / atendimento parcial:** corrigido arredondamento de demanda quando `pkg_allow_secondary_break = false` e o fator secund\xe1rio \xe9 menor que o prim\xe1rio (ex.: 1X10 secund\xe1ria, 1X100 prim\xe1ria). O sistema passava a exigir m\xfaltiplo do fator prim\xe1rio (mais restritivo) em vez do secund\xe1rio, impedindo quantidades v\xe1lidas como 3070 = 307 \xd7 10. Agora respeita o fator secund\xe1rio como granularidade m\xednima quando a restri\xe7\xe3o \xe9 de embalagem secund\xe1ria."
        ]
    },
    {
        date: '26/05/2026',
        changes: [
            "**Pedidos de sa\xedda \u2014 layout do formul\xe1rio:** modal responsivo (altura/largura limitadas \xe0 janela, com rolagem interna), grade de itens sem faixa em branco no meio, campos do cabe\xe7alho com quebra de linha em telas menores e coluna Produto proporcional \xe0 tabela.",
            "**Estoques \u2014 detalhe Produto / Lote:** campo **Motivo bloqueio** exibe o motivo informado na movimenta\xe7\xe3o L\u2192B da c\xe9lula quando h\xe1 saldo bloqueado (prioriza bloqueio manual com natureza BLOQ).",
            "**Sa\xeddas \u2014 Relat\xf3rio de Confer\xeancia:** rodap\xe9 **Separador** volta a exibir nome e data/hora de quem concluiu a separa\xe7\xe3o.",
            "**Sa\xeddas \u2014 Gera\xe7\xe3o de sa\xedda:** c\xe9lula com saldo livre passa a ser eleg\xedvel para picking mesmo quando h\xe1 unidades bloqueadas na mesma c\xe9lula."
        ],
        add: [],
        bugfix: []
    },
    {
        date: '25/05/2026',
        changes: [],
        add: [
            "**Integra\xe7\xe3o Protheus/RVD \u2014 confirma\xe7\xe3o de pedido faturado (#MT-0DB5167):** novo endpoint t\xe9cnico permite que o Protheus informe ao SIAL que uma sa\xedda RVD j\xe1 foi faturada no ERP. O SIAL promove a sa\xedda conferida para **Faturada**, liberando a baixa de estoque pelo fluxo normal do sistema, sem baixa autom\xe1tica e sem afetar outros clientes.",
            "**Integra\xe7\xe3o Protheus/RVD \u2014 aviso em tela (#MT-989C152):** ao abrir um **Pedido de sa\xedda** ou uma **Sa\xedda** vinculada a pedido de sa\xedda, o sistema exibe um banner quando houve falha ou cancelamento parcial registrado pela integra\xe7\xe3o Protheus RVD nos \xfaltimos 30 dias, com link para o evento na Central de Integra\xe7\xf5es."
        ],
        bugfix: [
            "**Sa\xeddas / performance (#cr\xedtico PRD):** grava\xe7\xe3o de sa\xedda deixa de executar consulta pesada (com agrega\xe7\xe3o de todos os itens) antes de cada UPDATE no cabe\xe7alho \u2014 reduz carga no RDS e conten\xe7\xe3o de lock na tabela `outputs` durante picking, confer\xeancia, faturamento e baixa. Atualiza\xe7\xf5es s\xf3 de status ou totais passam a gravar apenas os campos necess\xe1rios, sem reprocessar todas as linhas da grade.",
            "**Pedido de Sa\xedda \u2014 Endere\xe7o Entrega (#MT-F41E659):** corre\xe7\xe3o ao carregar endere\xe7os adicionais do cliente \u2014 uso do id num\xe9rico do datalist (n\xe3o o r\xf3tulo CNPJ/nome), recarga tamb\xe9m no blur do cliente e ao trocar a empresa. Migra\xe7\xe3o `129-customer-delivery-addresses-permissions.sql` concede GET/POST/PUT/PATCH de endere\xe7os de entrega aos grupos que j\xe1 acessam clientes ou pedidos de sa\xedda (antes s\xf3 Administradores)."
        ]
    },
    {
        date: '24/05/2026',
        changes: [],
        add: [
            "**Estoques e Gerenciamento de Estoques \u2014 coluna Categoria:** a coluna **Categoria** do produto passou a estar dispon\xedvel na tela, nos filtros e nos relat\xf3rios consolidados por SKU, lote e posi\xe7\xe3o (PDF e CSV)."
        ],
        bugfix: []
    },
    {
        date: '22/05/2026',
        changes: [],
        add: [
            "**Estoques \u2014 coluna Classes:** a coluna **Classes** do produto passou a estar dispon\xedvel na tela, nos filtros, no exportar CSV e nos relat\xf3rios consolidados por SKU, lote e posi\xe7\xe3o."
        ],
        bugfix: [
            "**Kardex \u2014 saldo incorreto sem `include_disabled` (#bug-interno):** corrigido erro no c\xe1lculo do saldo do Kardex quando havia sa\xeddas canceladas (baixas anuladas). O relat\xf3rio exclu\xeda a baixa desabilitada (`R\u2192O is_disabled=true`) mas mantinha o retorno t\xe9cnico (`O\u2192R is_disabled=false`), inflando o saldo. Agora, ao usar o modo operacional (sem par\xe2metro `include_disabled`), o par inteiro \xe9 exclu\xeddo. O modo de auditoria (`include_disabled=1`) continua exibindo os dois lados do par para rastreabilidade completa.",
            "**Sa\xeddas / Emiss\xe3o de NF \u2014 item com falta f\xedsica autorizada (#MT-AC2B384):** corrigido erro que impedia emitir NF de sa\xedda quando havia item com **falta f\xedsica autorizada** (quantidade conferida = 0 e diverg\xeancia aprovada por usu\xe1rio com permiss\xe3o). O sistema agora reconhece que itens com diverg\xeancia autorizada foram conscientemente retirados da sa\xedda e permite o faturamento normalmente, gerando a NF apenas com os itens que possuem quantidade fornecida.",
            "**Estoques / filtro:** ao abrir **Filtrar** na consulta de estoques, o modal deixa de encher o console com erros \xabNot found\xbb em `#open-N`, `#value-N` e `#close-N` \u2014 os campos indexados passam a ser resolvidos dentro do formul\xe1rio do modal, alinhado ao comportamento j\xe1 corrigido nas tabelas din\xe2micas."
        ]
    },
    {
        date: '21/05/2026',
        changes: [],
        add: [
            "**PACOTE 02 \u2014 Fase 7 (corre\xe7\xf5es de QA):** corrigidos 5 bugs identificados na revis\xe3o est\xe1tica do pacote. (1) **Endere\xe7os adicionais de cliente:** erro de JavaScript corrigido \u2014 a lista de endere\xe7os e os bot\xf5es Editar/Desativar voltam a funcionar corretamente. (2) **Pedido de Sa\xedda \u2014 troca de cliente:** ao alterar o cliente de um pedido e deixar o campo de endere\xe7o de entrega vazio, o sistema agora limpa o endere\xe7o e o snapshot anteriores, evitando que o pedido fique com o endere\xe7o do cliente anterior. (3) **Pedido de Sa\xedda \u2014 seguran\xe7a de endere\xe7os:** a API passou a bloquear tentativas de alterar campos estruturais do endere\xe7o de entrega (identificador, empresa, cliente) via opera\xe7\xe3o de atualiza\xe7\xe3o parcial. (4) **Entrada \u2014 duplicidade via PATCH:** a valida\xe7\xe3o que impede nota duplicada por fornecedor, n\xfamero e s\xe9rie passou a ser aplicada tamb\xe9m em atualiza\xe7\xf5es parciais, n\xe3o apenas na cria\xe7\xe3o ou edi\xe7\xe3o completa. (5) **Pedido de Entrada \u2014 duplicidade via PATCH:** a valida\xe7\xe3o de refer\xeancia duplicada por empresa passou a cobrir tamb\xe9m atualiza\xe7\xf5es parciais.",
            "**Produtos \u2014 Relat\xf3rio Completo de Cadastro com exporta\xe7\xe3o Excel (#MT-7A50355):** o menu de relat\xf3rios da tela **Cadastro \u2192 Produtos** passa a exibir a op\xe7\xe3o **Cadastro Completo (Excel/CSV)**. \xc9 poss\xedvel exportar o cadastro completo de produtos em planilha **.xlsx** (padr\xe3o) ou em CSV. O arquivo Excel inclui cabe\xe7alhos em portugu\xeas, primeira linha congelada, filtros autom\xe1ticos e larguras de coluna ajustadas. Os campos **SKU**, **GTIN/EAN**, **NCM** e **CEST** s\xe3o formatados como texto, preservando zeros \xe0 esquerda. Novos filtros dispon\xedveis: **SKU** (busca parcial), **Nome** (busca parcial), **Situa\xe7\xe3o** (todos/ativos/inativos) e **Programa**. Colunas inclu\xeddas: empresa, categoria, fabricante, hierarquia de taxons, SKU, nome, sin\xf4nimos, descri\xe7\xe3o, refer\xeancias, c\xf3digo cliente, programa, GTIN/EAN, NCM, CEST, origem, tributa\xe7\xe3o, flags ICMS (ST/isento/monof\xe1sico/red. BC), al\xedquota ICMS, cBenef, Portaria 344, vida \xfatil, estoques, valor, unidades de compra/venda, dimens\xf5es de embalagem secund\xe1ria e terci\xe1ria, classes, Anvisa/PMC, inativo.",
            "**Clientes \u2014 m\xfaltiplos endere\xe7os de entrega (#MT-F41E659):** o cadastro de **Cliente** passa a suportar v\xe1rios endere\xe7os de entrega independentes do endere\xe7o principal. Na tela do cliente h\xe1 uma nova se\xe7\xe3o **Endere\xe7os Adicionais de Entrega** onde \xe9 poss\xedvel cadastrar, editar, desativar e reativar endere\xe7os adicionais, cada um com nome de identifica\xe7\xe3o, destinat\xe1rio, CNPJ/CPF, telefone, logradouro completo e campo padr\xe3o. No **Pedido de Sa\xedda**, ao selecionar o cliente, o sistema carrega os endere\xe7os ativos e exibe o campo **Endere\xe7o Entrega**; endere\xe7o padr\xe3o ou \xfanico \xe9 selecionado automaticamente. O pedido grava o ID e um **snapshot imut\xe1vel** do endere\xe7o, garantindo que altera\xe7\xf5es futuras no cadastro n\xe3o afetam pedidos j\xe1 criados. Sa\xeddas e consultas posteriores acessam o endere\xe7o pelo snapshot do pedido. Migra\xe7\xe3o 127.",
            "**Pedido de Entrada \u2014 bloqueio de duplicidade (#MT-F50F165):** o sistema agora impede a cria\xe7\xe3o ou edi\xe7\xe3o de um Pedido de Entrada com refer\xeancia j\xe1 utilizada por outro pedido ativo da mesma empresa. Pedidos cancelados ou exclu\xeddos n\xe3o bloqueiam. O banco passou a ter \xedndice \xfanico parcial para garantir consist\xeancia mesmo em acessos simult\xe2neos. Migra\xe7\xe3o 125.",
            "**Entrada \u2014 bloqueio de nota duplicada (#MT-C947857):** ao criar ou editar uma Entrada, o sistema verifica se j\xe1 existe outra entrada ativa com o mesmo fornecedor, n\xfamero de nota e s\xe9rie. Novo campo **S\xe9rie** dispon\xedvel na tela de Entrada. A compara\xe7\xe3o \xe9 feita via pedido vinculado (o fornecedor vem do Pedido de Entrada). Migra\xe7\xe3o 125.",
            "**Pedido de Entrada e Entrada \u2014 Valor Total por item e Total geral (#MT-AF1F694):** as grades de itens dos formul\xe1rios de **Pedido de Entrada** e **Entrada** passam a exibir uma coluna **Valor Total** por linha (quantidade \xd7 pre\xe7o unit\xe1rio), atualizada em tempo real ao digitar. Abaixo da tabela \xe9 exibido o **Total do Pedido** ou **Total da Entrada** (somat\xf3rio de todos os itens), tamb\xe9m atualizado dinamicamente. Sem altera\xe7\xe3o no banco de dados \u2014 c\xe1lculo derivado exibido apenas no formul\xe1rio.",
            "**Entrada \u2014 Qtd Provisionada, Qtd Faturada e Qtd Pendente (#MT-2B00548):** a grade de itens do formul\xe1rio de **Entrada** passa a exibir tr\xeas novas colunas somente leitura: **Qtd Prov.** (quantidade fechada no Pedido de Entrada vinculado), **Qtd Fat.** (total j\xe1 faturado em todas as entradas ativas do mesmo pedido para o item) e **Qtd Pend.** (provisionada \u2212 faturada). As colunas s\xe3o preenchidas automaticamente ao abrir uma entrada existente ou ao vincular um pedido, e Qtd Faturada e Qtd Pendente s\xe3o atualizadas dinamicamente ao editar a quantidade da linha. Sem altera\xe7\xe3o no banco de dados.",
            "**Entrada \u2014 Importa\xe7\xe3o XML: desconto do item aplicado (#MT-AFDC849):** corrigido o c\xe1lculo do pre\xe7o unit\xe1rio na importa\xe7\xe3o de XML de fornecedor. O valor unit\xe1rio agora considera o desconto do item: `unit_price = (vProd \u2212 vDesc) / qCom`. Quando `vDesc` estiver ausente no XML (n\xedvel de item), o desconto \xe9 tratado como zero. A importa\xe7\xe3o agora bloqueia com mensagem operacional quando o desconto excede o valor bruto do item ou quando `qCom` \xe9 zero. O campo **S\xe9rie** tamb\xe9m passa a ser preenchido automaticamente a partir do XML. Ap\xf3s importar, as colunas **Valor Total** e **Qtd Provisionada/Faturada/Pendente** s\xe3o recalculadas automaticamente."
        ],
        bugfix: [
            "**PACOTE 02 \u2014 revis\xe3o t\xe9cnica:** corrigido o acumulado de **Qtd Fat.** da Entrada para considerar todas as entradas ativas do pedido (incluindo etapas conclu\xeddas), bloqueado o uso de endere\xe7o de entrega desativado em Pedido de Sa\xedda via API e protegido contra HTML indevido na listagem de endere\xe7os adicionais do Cliente."
        ]
    },
    {
        date: '20/05/2026',
        changes: [
            "**Etiqueta de volumes SESSP \u2014 novo layout:** a etiqueta de expedi\xe7\xe3o no layout SESSP foi reformulada para seguir o modelo f\xedsico oficial. Novo cabe\xe7alho com **SIAL** e **TRANSPORTADORA**; campo **Quantidade** (unidades do produto) em destaque na linha de produto; linha de pedido agora com 5 colunas \u2014 Data do Pedido, Pedido, Lote, **Volumes** e Validade; se\xe7\xe3o Destinat\xe1rio preservada; tarja preta **GRUPO DE CLIENTES** no rodap\xe9 (placeholder para expans\xe3o futura). QR Code mantido."
        ],
        add: [
            "**Sa\xeddas \u2014 colunas Cliente e Transportador:** a grade da tela **Movimenta\xe7\xe3o \u2192 Sa\xeddas** passa a exibir o **Cliente** e o **Transportador** do pedido de sa\xedda vinculado, com filtro por apelido nos mesmos crit\xe9rios das demais colunas. Chamado #MT-EDD1287.",
            '**Estoques / SKUs sem Sa\xedda no Per\xedodo:** novo relat\xf3rio dispon\xedvel no menu **Imprimir \u2192 SKUs sem Sa\xedda (Per\xedodo)** na tela de Estoques. Permite identificar produtos com saldo em estoque que n\xe3o tiveram baixa f\xedsica de sa\xedda no intervalo informado. Filtros: empresa (obrigat\xf3rio), per\xedodo De/At\xe9 (obrigat\xf3rio) e armaz\xe9m (opcional). O resultado \xe9 exibido diretamente em tela em uma grade com SKU, Produto, Unidade, Programa, Estoque Total e data/hora da \xfaltima sa\xedda ("Nunca" quando nunca houve). H\xe1 bot\xe3o **Exportar CSV** para download do relat\xf3rio completo em planilha (compat\xedvel com Excel). Migra\xe7\xe3o 124.'
        ],
        bugfix: [
            "**Sa\xeddas \u2014 Cliente e Transportador (#MT-EDD1287):** corrigido retorno da API na listagem; os dados do pedido de sa\xedda j\xe1 eram consultados no SQL, mas n\xe3o eram expostos na entidade da sa\xedda e n\xe3o chegavam \xe0 grade."
        ]
    },
    {
        date: '19/05/2026',
        changes: [],
        add: [
            "**Sa\xeddas / Confer\xeancia de Sa\xedda Web \u2014 Controle de Caixas (Fase C3):** quando o par\xe2metro **Controla caixas na separa\xe7\xe3o/confer\xeancia de sa\xedda** est\xe1 ativo para a empresa, o modal **\xabConferir Sa\xedda\xbb** passa a consultar as caixas de picking da sa\xedda e exibir um painel de resumo com quantidades de caixas abertas, lacradas e canceladas, total de itens e unidades nas lacradas, e lista das caixas com status, c\xf3digo e lacre. O campo **Volumes** \xe9 preenchido automaticamente com o n\xfamero de caixas lacradas e fica bloqueado para edi\xe7\xe3o. A **quantidade conferida** por linha \xe9 preenchida automaticamente com a soma das quantidades nas caixas lacradas para aquele item, tamb\xe9m bloqueada. O sistema bloqueia a conclus\xe3o da confer\xeancia se houver caixa aberta, nenhuma caixa lacrada, caixa lacrada sem itens ou diverg\xeancia entre as quantidades das caixas e as conferidas por linha. Confer\xeancias parciais por quantidade (caixas com menos que o requerido) continuam poss\xedveis se o par\xe2metro **Permite confer\xeancia parcial** estiver ativo \u2014 o motivo de diverg\xeancia continua sendo exigido. Quando o par\xe2metro de controle de caixas estiver inativo, o modal de confer\xeancia funciona exatamente como antes.",
            "**Sa\xeddas / Gest\xe3o de Caixas Picking (Controle de Caixas \u2014 Fase C2):** nova tela **Movimenta\xe7\xe3o \u2192 Caixas de Picking** para consulta e auditoria de caixas operacionais de picking. Permite pesquisar por c\xf3digo, lacre, n\xfamero da sa\xedda, status (Aberta / Lacrada / Cancelada), usu\xe1rio e per\xedodo. A grade exibe status, usu\xe1rio que abriu, timestamps de abertura, lacre e cancelamento, quantidade de itens e quantidade total. O detalhe da caixa mostra cabe\xe7alho completo (c\xf3digo, lacre, sa\xedda, status, respons\xe1veis e datas) e tabela de itens (linha, SKU, produto, lote, quantidade, unidade, embalagem). \xc9 poss\xedvel cancelar caixas abertas ou lacradas diretamente pela tela, desde que a sa\xedda n\xe3o esteja em situa\xe7\xe3o irrevers\xedvel \u2014 os itens s\xe3o mantidos para auditoria. Al\xe9m da tela global, a tela de Sa\xeddas passou a ter a opera\xe7\xe3o **Caixas de Picking** no menu de opera\xe7\xf5es, que abre diretamente as caixas da sa\xedda selecionada. Controle de caixas dispon\xedvel apenas para empresas com o par\xe2metro **Controla caixas na separa\xe7\xe3o/confer\xeancia de sa\xedda** habilitado. Migra\xe7\xf5es 120 e 121.",
            "**Sa\xeddas / Confer\xeancia de Sa\xedda Web \u2014 diverg\xeancia estruturada:** a opera\xe7\xe3o **\xabConferir Sa\xedda\xbb** passa a registrar e controlar diverg\xeancias de quantidade de forma estruturada. Quando a quantidade conferida for menor que a requerida, o conferidor deve indicar o motivo (Falta f\xedsica, Avaria, Erro de picking, Quantidade divergente, Corre\xe7\xe3o operacional ou Outros; observa\xe7\xe3o obrigat\xf3ria para Outros). Os registros ficam na tabela `output_conference_divergences`. O comportamento por empresa \xe9 controlado por dois novos par\xe2metros em **Empresas > Par\xe2metros \u2014 Pedidos de sa\xedda**: (1) **Permite confer\xeancia parcial** \u2014 quando desmarcado, o sistema bloqueia qualquer confer\xeancia com quantidade menor que a requerida; (2) **Exige autoriza\xe7\xe3o para diverg\xeancia** \u2014 quando marcado, somente usu\xe1rios com a permiss\xe3o \xabSa\xeddas \u2014 autorizar diverg\xeancia na confer\xeancia web\xbb podem concluir confer\xeancias com diverg\xeancia de quantidade. Lote e validade divergentes continuam sendo bloqueantes em qualquer cen\xe1rio. Migra\xe7\xf5es 112 e 113.",
            "**Sa\xeddas / Detalhamento:** nova opera\xe7\xe3o **\xabDetalhes da Sa\xedda\xbb** \u2014 abre um painel rico e somente leitura com todas as informa\xe7\xf5es da sa\xedda: cabe\xe7alho completo (empresa, armaz\xe9m, volumes, peso, datas), bloco de confer\xeancia com nome do conferente e data/hora, indica\xe7\xe3o visual de diverg\xeancias (fundo amarelo nos itens parciais, badge de aviso), tabela de itens com SKU, produto, lote, validade, quantidades requerida e conferida, diferen\xe7a e posi\xe7\xe3o, al\xe9m das diverg\xeancias registradas (motivo, observa\xe7\xe3o e flag de autorizado) exibidas como sub-linha inline de cada item divergente. Migra\xe7\xe3o 114.",
            "**Sa\xeddas / Pedido Falta:** nova opera\xe7\xe3o **\xabGerar Pedido Falta\xbb** na tela de Sa\xeddas \u2014 dispon\xedvel para sa\xeddas com status **Conferida (60)** que tiveram ao menos uma linha com quantidade conferida menor que a requerida. Ao acionar a opera\xe7\xe3o, o sistema exibe um resumo das quantidades faltantes por produto e, ap\xf3s confirma\xe7\xe3o do usu\xe1rio, cria automaticamente um novo **Pedido de Sa\xedda** contendo apenas os itens e quantidades faltantes. O novo pedido herda cliente, transportadora, programa, canal de atendimento, forma de pagamento e condi\xe7\xe3o de pagamento do pedido original; recebe a refer\xeancia no formato `FALTA-<refer\xeancia original>` e fica vinculado ao pedido e \xe0 sa\xedda de origem pelos campos `shortage_of_order_id` e `shortage_of_output_id`. O Pedido Falta **n\xe3o reserva estoque automaticamente** \u2014 segue o fluxo normal do SIAL (criado \u2192 aprova\xe7\xe3o \u2192 gera\xe7\xe3o de sa\xedda \u2192 separa\xe7\xe3o \u2192 confer\xeancia). N\xe3o \xe9 poss\xedvel gerar Pedido Falta duplicado para a mesma sa\xedda. Ao final, o sistema exibe o n\xfamero e a refer\xeancia do novo pedido. Migra\xe7\xe3o 115.",
            "**Empresas / Par\xe2metros \u2014 Controle de caixas na separa\xe7\xe3o/confer\xeancia de sa\xedda:** novo par\xe2metro **\xabControla caixas na separa\xe7\xe3o/confer\xeancia de sa\xedda\xbb** em **Empresas > Par\xe2metros > Embalagens e picking**. Quando habilitado, o modal de Confer\xeancia de Sa\xedda Web exibe um aviso informativo de que o fluxo completo de controle por caixa ainda n\xe3o est\xe1 implementado. O fluxo atual de confer\xeancia **n\xe3o \xe9 bloqueado** nesta fase \u2014 o par\xe2metro prepara os fluxos para o controle completo de caixas futuro. Migra\xe7\xe3o 117.",
            "**Sa\xeddas / Confer\xeancia de Sa\xedda Web \u2014 revis\xe3o de integridade:** refor\xe7os de seguran\xe7a e consist\xeancia no pacote de confer\xeancia web: modais de unpicking corrigidos, prote\xe7\xe3o contra HTML em dados exibidos nos modais, op\xe7\xe3o **Solicita\xe7\xf5es de Unpicking** dispon\xedvel no menu de Sa\xeddas, Pedido Falta compat\xedvel com pedidos por SKU parcial e novas travas de banco para evitar duplicidade concorrente em Pedido Falta/unpicking ativo. Migra\xe7\xe3o 118.",
            '**Sa\xeddas / Unpicking \u2014 Solicita\xe7\xe3o e Aprova\xe7\xe3o (Web):** novo fluxo audit\xe1vel de solicita\xe7\xe3o e aprova\xe7\xe3o de unpicking a partir da tela de Sa\xeddas. O operador pode solicitar o unpicking de uma linha espec\xedfica diretamente no modal **\xabConferir Sa\xedda\xbb** (bot\xe3o **\u21A9 Unpick** por linha) ou atrav\xe9s da nova opera\xe7\xe3o **\xabSolicita\xe7\xf5es de Unpicking\xbb** no menu de opera\xe7\xf5es. A solicita\xe7\xe3o registra o usu\xe1rio, data/hora, item, quantidade, motivo (Erro de picking / Lote errado / Item errado / Quantidade errada / Avaria / Cancelamento operacional / Outros; observa\xe7\xe3o obrigat\xf3ria para "Outros") e a sa\xedda fica com status pendente at\xe9 a aprova\xe7\xe3o. Usu\xe1rios autorizados podem aprovar ou rejeitar a solicita\xe7\xe3o diretamente no modal de gerenciamento. O modal de confer\xeancia exibe um badge de status por linha quando h\xe1 solicita\xe7\xe3o ativa (Solicitado / Aprovado / Rejeitado). Dispon\xedvel para sa\xeddas em status **Separada (30)**, **Conferindo (40)**, **Unpick (50)** e **Conferida (60)** \u2014 bloqueado ap\xf3s faturamento. **Nesta fase n\xe3o h\xe1 movimenta\xe7\xe3o de estoque autom\xe1tica** \u2014 a execu\xe7\xe3o f\xedsica do unpicking \xe9 registrada para aprova\xe7\xe3o e execu\xe7\xe3o em fase futura. Migra\xe7\xe3o 116.'
        ],
        bugfix: [
            "**Sa\xeddas / Controle de Caixas Picking:** revis\xe3o de integridade das valida\xe7\xf5es de caixas. O registro de itens em caixa passa a retornar mensagens operacionais para quantidade/lote inv\xe1lidos, e a Confer\xeancia Web com controle de caixas ativo passa a exigir que cada linha envie explicitamente a quantidade conferida no payload, evitando conclus\xe3o por chamada direta com linha omitida.",
            "**Performance (AWS / produ\xe7\xe3o):** corrigido problema que podia travar o banco ao consultar armaz\xe9ns \u2014 o sistema reexecutava cria\xe7\xe3o de gatilho (trigger) da tabela de armaz\xe9ns a cada requisi\xe7\xe3o, gerando conten\xe7\xe3o e lentid\xe3o no RDS. Em produ\xe7\xe3o o gatilho j\xe1 existe via migra\xe7\xe3o; a corre\xe7\xe3o evita DDL repetido."
        ]
    },
    {
        date: '18/05/2026',
        changes: [],
        add: [
            "**Sa\xeddas / Confer\xeancia de Sa\xedda Web:** nova opera\xe7\xe3o **\xabConferir Sa\xedda\xbb** na tela de Sa\xeddas \u2014 abre um modal onde \xe9 poss\xedvel informar as quantidades conferidas por item, o n\xfamero de volumes, o tipo de volume e o peso, e concluir a confer\xeancia diretamente pelo navegador (sem o Coletor PWA). A opera\xe7\xe3o aceita sa\xeddas em status **Separada (30)**, **Conferindo (40)** ou **Unpick (50)**; bloqueia sa\xeddas j\xe1 conferidas (60 ou superior). Ao concluir, a sa\xedda avan\xe7a para **Conferida (60)**, com `checked_by` e `checked_at` preenchidos. O fluxo do Coletor PWA (PUT/PATCH legado) permanece inalterado."
        ],
        bugfix: []
    },
    {
        date: '15/05/2026',
        changes: [
            "**Gerar sa\xeddas / Resultados:** a tela de resultados e o **Exportar CSV** passam a mostrar uma coluna **Motivo** por item, com texto claro do porqu\xea do n\xe3o atendimento (0%) ou do atendimento parcial \u2014 facilita an\xe1lise sem precisar consultar tela a tela. Mensagens cobrem: lote bloqueado por flag, validade abaixo da pol\xedtica do produto (shelf life), posi\xe7\xe3o desabilitada/bloqueada para sa\xedda, posi\xe7\xe3o de staging, posi\xe7\xe3o restrita a grupo, regra de embalagem (quebra/unitariza\xe7\xe3o) e \xabfaltam X UN sem saldo eleg\xedvel\xbb no caso de parcial. Pedidos que n\xe3o passam por picking (devolu\xe7\xe3o de entrada, aguardando aprova\xe7\xe3o, em processamento, cancelado, exclu\xeddo, sem estoque na \xfaltima gera\xe7\xe3o) tamb\xe9m passam a explicar o motivo na linha do item.",
            "**Entradas:** passa a existir a **data e hora de conclus\xe3o** (momento em que o endere\xe7amento encerra e a entrada fica **Conclu\xedda**). O campo aparece na **lista** (com filtro por per\xedodo), no **cadastro** (somente leitura), no **relat\xf3rio completo** (incluindo op\xe7\xe3o de per\xedodo por **data de conclus\xe3o**), na **listagem em PDF**, na **entrada detalhada**, no **relat\xf3rio de confer\xeancia** e no **CSV/Excel** do relat\xf3rio completo. Em **estorno** para status anterior \xe0 conclus\xe3o, o carimbo \xe9 apagado para n\xe3o induzir erro."
        ],
        add: [],
        bugfix: [
            "**Estoque / pedidos de sa\xedda \u2014 bloqueio fantasma de lote:** corrige situa\xe7\xe3o em que o pedido relatava \xabSem estoque ou sem pend\xeancias\xbb mesmo com saldo aparecendo como **Livre** na grade. Quando uma opera\xe7\xe3o de **desbloqueio em lote** zerava o saldo bloqueado, a marca de bloqueado do lote ficava acesa por engano \u2014 o picking ignorava o lote e o pedido sa\xeda com 0% de atendimento. A partir de agora o sistema sincroniza essa marca com o saldo bloqueado real ao desbloquear/bloquear, e quando um item fica sem atendimento o aviso passa a explicar o motivo (ex.: lote bloqueado, validade abaixo do shelf life, posi\xe7\xe3o desabilitada/bloqueada para sa\xedda, posi\xe7\xe3o de staging ou restrita a outro grupo).",
            "**API / autentica\xe7\xe3o (integra\xe7\xe3o AMIL e outros clientes):** o `POST /auth` passa a aceitar credenciais em **JSON** (`application/json`) al\xe9m do formul\xe1rio URL-encoded. Antes, quem enviava s\xf3 JSON recebia 401 com \xabInforme usu\xe1rio e senha\xbb mesmo com usu\xe1rio e senha corretos. A senha (e o usu\xe1rio) passam por normaliza\xe7\xe3o que remove **espa\xe7os s\xf3 no in\xedcio e no fim** (evita falha por espa\xe7o acidental no `.env`). Documenta\xe7\xe3o e script de exemplo AMIL atualizados (`doc/integrations/amil-cliente-script/`)."
        ]
    },
    {
        date: '14/05/2026',
        changes: [],
        add: [
            "**Cadastro / Produtos:** novo **relat\xf3rio geral em CSV** (menu Produtos \u2192 \xabRelat\xf3rio geral (CSV)\xbb) \u2014 exporta por empresa os dados cadastrais e **tribut\xe1rios** dos itens (NCM, CEST, origem, taxa\xe7\xe3o, al\xedquota ICMS, cBenef, Portaria 344, programa, unidades, fabricante, classes, Anvisa quando houver, etc.), para confer\xeancia externa (ex.: contabilidade) e planejamento de atualiza\xe7\xe3o em massa. Chamado #MT-007B282."
        ],
        bugfix: [
            "**Sa\xeddas / etiqueta de expedi\xe7\xe3o (layout IBL\u2013SESSP):** o endere\xe7o do destinat\xe1rio passa a incluir uma **terceira linha** com cidade, UF e **CEP** (m\xe1scara 00000-000 quando o cadastro tem s\xf3 d\xedgitos), exig\xeancia comum dos Correios. No layout padr\xe3o, a linha de cidade/UF/CEP ganha limite maior para n\xe3o cortar o CEP.",
            "**Confer\xeancia de entrada / devolu\xe7\xe3o:** quando o pedido de devolu\xe7\xe3o usa a mesma refer\xeancia do pedido de sa\xedda original com sufixo **-1**, **-2**, etc. (porque o sistema n\xe3o permite repetir a refer\xeancia exata), a confer\xeancia deixa de falhar ao buscar o custo \u2014 o v\xednculo com a sa\xedda original usa s\xf3 o id antes do primeiro h\xedfen.",
            "**Estoque / consultas via API (sial.run):** consultas autenticadas em estoque (incluindo a integra\xe7\xe3o de leitura para AMIL com lote do fabricante e validade) voltam a responder normalmente \u2014 a partir do ajuste de banco, o sistema deixa de reportar erro interno na listagem e passa a retornar lote, fabrica\xe7\xe3o e validade conforme cadastro.",
            "**Sistema / cadastro de usu\xe1rios e telas que carregam a lista (ex.: Pedido de sa\xedda):** deixa de aparecer o aviso \xabNome de usu\xe1rio deve ter entre 4 e 20 caracteres\xbb ao abrir listagens que consultam usu\xe1rios \u2014 o cadastro continua exigindo o intervalo ao **incluir ou alterar** um usu\xe1rio; apenas registros antigos fora da regra deixam de travar a leitura.",
            "**Armazenamento / Cat\xe1logo de posi\xe7\xf5es (CSV):** exporta\xe7\xf5es grandes deixam de falhar com **504 Gateway Time-out** no nginx \u2014 o download passa a ser montado em **v\xe1rios blocos** na API (limite por requisi\xe7\xe3o), com o mesmo filtro e at\xe9 o m\xe1ximo de linhas configurado na tela.",
            "**Estoque / relat\xf3rios consolidados (por SKU, por lote e por posi\xe7\xe3o \u2014 PDF e CSV):** deixam de falhar com **400** e resposta \xabblk\xbb (template SQL: m\xe1scara de lote n\xe3o era aplicada na string inteira) e o filtro por empresa + ids de estoque passa a usar corretamente ``company_id`` com ``ANY(ids)`` no PostgreSQL."
        ]
    },
    {
        date: '13/05/2026',
        changes: [
            "**Integra\xe7\xe3o TechHub / IBL:** rota t\xe9cnica de **reenvio da API 4** (fatura-itens) para sa\xeddas f\xedsicas j\xe1 registradas como enviadas \u2014 permite republicar itens com payload atualizado (ex.: SKU) ap\xf3s corre\xe7\xe3o no sistema, usando o token de gest\xe3o da integra\xe7\xe3o.",
            "**Entradas de NF (Minist\xe9rio da Sa\xfade):** o pre\xe7o unit\xe1rio passa a aceitar e preservar at\xe9 **10 casas decimais** no pedido/entrada e na importa\xe7\xe3o do XML, reduzindo diferen\xe7as acumuladas por arredondamento em notas de alto volume.",
            "**NF-e (incluindo cobertura):** valores unit\xe1rios de item no XML (`vUnCom`/`vUnTrib`) passam a suportar at\xe9 10 casas, conforme o leiaute oficial, sem preencher zeros desnecess\xe1rios."
        ],
        add: [],
        bugfix: [
            "**Integra\xe7\xe3o TechHub / IBL (API 4 \u2014 fatura-itens):** o campo \xabc\xf3digo do item no cliente\xbb passa a ser enviado com o **SKU** do produto, e n\xe3o mais com o id interno quando o c\xf3digo do cliente estava vazio.",
            "**Relat\xf3rios e DANFE de entrada:** exibi\xe7\xe3o de pre\xe7o unit\xe1rio/quantidade deixa de truncar em 4 casas e passa a mostrar s\xf3 os d\xedgitos necess\xe1rios (sem \u201Crastro\u201D de zeros)."
        ]
    },
    {
        date: '05/05/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Impress\xf5es / bloqueios de saldo:** data e hora da transa\xe7\xe3o no PDF e no CSV passam a ser exibidas no hor\xe1rio de Bras\xedlia, alinhando o relat\xf3rio ao rel\xf3gio local e aos alertas por e-mail \u2014 em vez do instante em UTC que parecia \xabadiantado\xbb.",
            "**Central de integra\xe7\xf5es / conector Protheus:** quando a confer\xeancia de sa\xedda no Protheus (WS-DG3) falha de forma repetida, deixa de ser criado um novo registro de erro a cada ciclo do monitor \u2014 o mesmo crit\xe9rio de deduplica\xe7\xe3o usado na entrada (WS-DG2) limita a um evento completo, um de auditoria e depois sil\xeancio at\xe9 a situa\xe7\xe3o normalizar."
        ]
    },
    {
        date: '04/05/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Estoques / grade:** a coluna Armaz\xe9m passa a usar o nome enviado pela API (inclusive para armaz\xe9m inativo), em vez de depender s\xf3 do cat\xe1logo local \u2014 evita texto \xabundefined\xbb quando o navegador n\xe3o mant\xe9m aquele armaz\xe9m na lista.",
            "**Estoques / gerenciamento e consulta:** linhas com dispon\xedvel, reservado e bloqueado todos zerados deixam de aparecer na listagem principal \u2014 reduz p\xe1ginas s\xf3 com saldo zero e alinha a grade ao que h\xe1 de saldo operacional.",
            "**Estoques / etiquetas de lote:** impress\xe3o (incluindo agente local) deixa de falhar com erro de SQL ao montar a consulta dos registros selecionados \u2014 o filtro por empresa e ids de estoque volta a ser aplicado corretamente.",
            "**Integra\xe7\xe3o TechHub / sa\xeddas:** atualiza\xe7\xe3o de status enviada \xe0 IBL deixa de ser disparada na conferida (60); o primeiro marco fiscal passa a ser faturando (65) e faturada (70), com envio autom\xe1tico de itens de fatura (API 4) tamb\xe9m s\xf3 a partir de 65."
        ]
    },
    {
        date: '03/05/2026',
        changes: [],
        add: [],
        bugfix: [
            "**Armazenamento / filtros:** armaz\xe9ns inativos deixam de reaparecer em listas locais (ex.: filtro de Posi\xe7\xf5es) ap\xf3s outras telas terem carregado o cat\xe1logo completo \u2014 o cache do navegador passa a substituir a lista de armaz\xe9ns por completo a cada carga, e o filtro ignora inativos de forma expl\xedcita.",
            "**Armazenamento / combos:** datalists e filtros (incluindo Sa\xeddas e exporta\xe7\xe3o CSV) passam a excluir armaz\xe9m inativo em qualquer ramo da montagem da lista \u2014 n\xe3o s\xf3 quando o primeiro registro traz `company_id` \u2014 e o carregamento por observador (`obs_load_options`) aplica o mesmo crit\xe9rio ao ler o armaz\xe9m local.",
            "**Estoque / gerenciamento e consulta:** a coluna Posi\xe7\xe3o deixa de aparecer como texto \xabundefined\xbb quando o cat\xe1logo local de posi\xe7\xf5es n\xe3o foi carregado; o servidor passa a enviar o endere\xe7o da posi\xe7\xe3o junto da listagem. O filtro s\xf3 por posi\xe7\xe3o volta a aplicar corretamente (cat\xe1logo de posi\xe7\xf5es carregado antes de resolver r\xf3tulos e, sem escopo, todas as posi\xe7\xf5es da credencial).",
            "**Estoque / filtro por posi\xe7\xe3o:** \xabCont\xe9m\xbb e demais operadores de texto deixam de aplicar m\xe1scara ampla em c\xf3digo num\xe9rico de armaz\xe9m/posi\xe7\xe3o (que listava quase todo o estoque); passam a filtrar pelo endere\xe7o (`location_address`) retornado pela API. Crit\xe9rio por posi\xe7\xe3o com texto n\xe3o resolvido para ID tamb\xe9m \xe9 enviado como filtro no endere\xe7o.",
            "**Filtros Versa (tabelas din\xe2micas):** linhas e campos indexados passam a ser resolvidos s\xf3 dentro do formul\xe1rio em uso \u2014 evita erros no console (\xabNot found\xbb em `#open-N`, `#value-N`, etc.) e clones na tabela errada quando a p\xe1gina tem outras linhas com a mesma classe (ex.: gerenciamento de estoques).",
            "**Estoque / grade:** quando o servidor n\xe3o envia texto de posi\xe7\xe3o na linha, o r\xf3tulo deixa de ser obtido s\xf3 pelo cat\xe1logo gravado no navegador (evita endere\xe7o desalinhado com o que a API considera vis\xedvel); usa-se refer\xeancia por armaz\xe9m e id da posi\xe7\xe3o.",
            "**API / filtros (psycopg 3):** operadores de texto \xabcont\xe9m\xbb, \xabcome\xe7a\xbb e \xabtermina\xbb em listagens com subconsulta + binds (`%s`) passam a escapar corretamente o `%` dos padr\xf5es `ILIKE`, evitando erro de SQL ao misturar filtros (ex.: posi\xe7\xe3o por texto + escopo por usu\xe1rio). Corrige consulta de posi\xe7\xf5es no coletor e demais telas que combinam esse tipo de filtro.",
            "**Coletor / auditoria:** libera\xe7\xe3o de reserva \xf3rf\xe3 deixa de falhar com erro interno ao gravar o movimento quando identificadores da empresa v\xeam como UUID nativo do banco \u2014 o registro da transa\xe7\xe3o serializa origem e destino de forma compat\xedvel."
        ]
    },
    {
        date: '30/04/2026',
        changes: [
            "**API / consulta de estoque:** nova rota somente leitura para integra\xe7\xe3o externa, com SKU, lote do fabricante, fabrica\xe7\xe3o, validade e quantidades (dispon\xedvel, reservada e bloqueada) em payload reduzido; permiss\xf5es alinhadas \xe0 consulta de estoque j\xe1 usada pelos fluxos de integra\xe7\xe3o."
        ],
        add: [],
        bugfix: [
            "**Notas fiscais / sa\xeddas:** ao gravar a nota de sa\xedda pela atualiza\xe7\xe3o completa (equivalente ao PUT na API), o sistema passa a aplicar o mesmo encadeamento j\xe1 usado na atualiza\xe7\xe3o parcial (PATCH): quando a NF est\xe1 autorizada e vinculada \xe0 sa\xedda, dispara baixa e encerramento como esperado \u2014 evitando sa\xedda presa em conferida s\xf3 porque o cliente usou outro verbo de grava\xe7\xe3o.",
            "**Pedidos de entrada:** o PDF \xabDocumento do Pedido\xbb passa a seguir o padr\xe3o visual do sistema \u2014 cabe\xe7alho com logo, refer\xeancia em destaque, quadros de emitente e destinat\xe1rio mais leg\xedveis, tabela com larguras fixas e texto que quebra nas descri\xe7\xf5es \u2014 evitando colunas cortadas na margem e nomes de produto truncados.",
            "**Faturamento / sa\xeddas:** se a baixa autom\xe1tica ap\xf3s autoriza\xe7\xe3o da NF falhar, a grava\xe7\xe3o da nota passa a retornar erro em vez de concluir em sil\xeancio \u2014 permitindo retentativa. O encerramento de sa\xedda passa a tentar de novo essa sincroniza\xe7\xe3o quando ainda h\xe1 NF autorizada vinculada e a sa\xedda ainda n\xe3o est\xe1 \xabfaturada\xbb.",
            "**Opera\xe7\xf5es em lote (notas e sa\xeddas):** ap\xf3s erro da API (ex.: falha na baixa ou 5xx), deixam de ser exibidos resultados como \xab0 transmitidos\xbb ou \xab0 lotes\xbb como se a a\xe7\xe3o tivesse conclu\xeddo com sucesso \u2014 o aviso de erro continua e a grade n\xe3o avan\xe7a com mensagem enganosa.",
            "**Sa\xeddas / baixa:** quando a sa\xedda ainda n\xe3o est\xe1 \xabfaturada\xbb (70), a resposta de \xabDar baixa\xbb passa a explicar o motivo (falta de confer\xeancia, NF n\xe3o vinculada ou autorizada no cadastro, etc.) em vez de s\xf3 \xabAguardando faturamento\xbb.",
            "**Sa\xeddas / faturamento:** ao usar \xabGerar notas\xbb (emitir NF) para uma sa\xedda, o sistema passa a marcar a sa\xedda como \xabFaturando\xbb (65); ap\xf3s a autoriza\xe7\xe3o da NF no lote, a sequ\xeancia de baixa no estoque, \xabFaturada\xbb (70) e encerramento (90) continua autom\xe1tica como antes.",
            "**Estoque / NF e lotes:** quando a baixa n\xe3o encontra linha de estoque na posi\xe7\xe3o (reserva\u2192sa\xedda), a mensagem passa a orientar sobre causas prov\xe1veis e mostra SKU e endere\xe7o da posi\xe7\xe3o, em vez de apenas c\xf3digos internos.",
            "**Coletor / auditoria:** corre\xe7\xe3o interna para o cadastro de pend\xeancias n\xe3o falhar ao iniciar quando o modo DDL autom\xe1tica de reposit\xf3rio est\xe1 desligado \u2014 as tabelas continuam obrigat\xf3rias via migra\xe7\xf5es do ambiente."
        ]
    },
    {
        date: '29/04/2026',
        changes: [
            "**Sa\xeddas / integridade:** refor\xe7o de banco impede gerar ou alterar sa\xedda operacional pr\xe9-faturamento com quantidade maior que o pedido por produto, incluindo atendimentos divididos em mais de um lote.",
            "**Opera\xe7\xe3o / batch:** o script `reconcile_output_items_to_order_batch.py` alinha a grade ao pedido: linha \xfanica inflada, remo\xe7\xe3o de linhas excedentes e, quando o excesso n\xe3o fecha em linhas inteiras, corte parcial de quantidade por produto/lote (casos \u201Cdobrados\u201D por bug); `--no-trim-inflation` desliga s\xf3 o primeiro passo; s\xf3 pr\xe9-faturamento.",
            "**Coletor / auditoria:** nova corre\xe7\xe3o auditada permite recompor reserva insuficiente de sa\xedda operacional quando h\xe1 saldo dispon\xedvel na posi\xe7\xe3o/lote, registrando o movimento L\u2192R e a pend\xeancia de auditoria correspondente."
        ],
        add: [],
        bugfix: [
            "**Sa\xeddas / pedido:** a valida\xe7\xe3o na API impede gravar grade cuja soma por produto ultrapassa o pedido mesmo quando o crit\xe9rio por lote n\xe3o fecha sozinho \u2014 prote\xe7\xe3o extra ao lado do bloqueio j\xe1 aplicado no banco.",
            "**Coletor / auditoria:** grava\xe7\xe3o da aprova\xe7\xe3o supervisionada passa a serializar corretamente valores em detalhes da a\xe7\xe3o (evita erro interno ao confirmar com payload complexo).",
            "**Coletor / auditoria:** registro de pend\xeancias e observa\xe7\xf5es na auditoria deixa de retornar permiss\xe3o negada no servidor \u2014 perfis com acesso ao v\xednculo reserva/pedido passam a poder gravar pend\xeancias conforme o cadastro de permiss\xf5es.",
            "**Coletor / auditoria:** a lista de saldos negativos passa a mostrar apenas inconsist\xeancia operacional atual, evitando exibir res\xedduos hist\xf3ricos de sa\xeddas j\xe1 encerradas ou sem reserva negativa real no estoque.",
            "**Grupos / permiss\xf5es:** o perfil Supervisor de auditoria passa a receber explicitamente (por UUID do grupo) os endpoints de pend\xeancias do coletor, para n\xe3o depender do nome exibido no cadastro.",
            "**Sa\xeddas / integridade:** quando o banco bloqueia grava\xe7\xe3o ou estorno porque a grade ultrapassa o pedido (prote\xe7\xe3o por produto ou por lote), a mensagem ao usu\xe1rio passa a ser em portugu\xeas claro, com pedido, produto e quantidades permitidas \u2014 em vez do texto t\xe9cnico do PostgreSQL.",
            "**Gerenciamento de estoque:** divis\xe3o de saldo com isolamento em novo lote passa a criar a linha j\xe1 no lote isolado, evitando erro de duplicidade de c\xe9lula/lote.",
            "**Notas fiscais / lotes:** \xabVer notas do lote\xbb monta o quadro s\xf3 com o JSON do pr\xf3prio lote (sem outras chamadas por NF), usando texto criado no navegador com `createElement`/`textContent` \u2014 assim mensagens ou trechos que lembram marca\xe7\xe3o n\xe3o quebram o HTML do aviso nem deixam o modal em branco."
        ]
    },
    {
        date: '28/04/2026',
        changes: [
            "**Estoque / bloqueios:** novas naturezas de bloqueio para diferenciar produto n\xe3o localizado, quantidade divergente e produto em posi\xe7\xe3o incorreta, permitindo relat\xf3rio e tratativa por motivo.",
            "**Coletor / auditoria:** novas rotas para consultar v\xednculo reserva/pedido, liberar reserva \xf3rf\xe3 com lan\xe7amento compensat\xf3rio e listar casos de extrato negativo para investiga\xe7\xe3o.",
            "**Kardex:** filtro de lote passa a aceitar busca pelo lote do fabricante, e os relat\xf3rios exibem o lote do fabricante nas linhas.",
            "**Notas fiscais:** tela de lotes de NF ganha resumo das notas vinculadas, filtros por NF/chave/retorno e detalhe das notas internas do lote para apoiar tratativas de rejei\xe7\xf5es SEFAZ."
        ],
        add: [
            '**Naturezas de bloqueio:** AUDIT_NAO_LOCALIZADO, AUDIT_QTD_DIVERGENTE, AUDIT_POSICAO_INCORRETA e AUDIT_RESERVA_ORFA.',
            "**Supervisor de auditoria:** perfil e aprova\xe7\xe3o supervisionada para a\xe7\xf5es cr\xedticas do coletor."
        ],
        bugfix: [
            "**Coletor / auditoria:** aprova\xe7\xe3o supervisionada aceita o login do supervisor informado no coletor e corrige falha interna ao liberar reserva \xf3rf\xe3.",
            "**Coletor / auditoria:** libera\xe7\xe3o de reserva \xf3rf\xe3 passa a aceitar aus\xeancia de pedido vinculado, mantendo auditoria da a\xe7\xe3o e bloqueando a opera\xe7\xe3o se existir reserva ativa ligada a sa\xedda.",
            "**Coletor / auditoria:** consulta de v\xednculo reserva/pedido passa a aceitar modo de varredura sem produto/lote/posi\xe7\xe3o, retornando c\xe9lulas com reserva para an\xe1lise de \xf3rf\xe3s."
        ]
    },
    {
        date: '27/04/2026',
        changes: [
            "**Integra\xe7\xe3o (TechHub / fila de faturas):** ajuste para evitar faturas que deixavam de ser reprocessadas quando o contador de tentativas alcan\xe7ava o limite \u2014 a fila volta a tratar o documento de forma previs\xedvel ap\xf3s novos envios da integra\xe7\xe3o ou no processamento agendado."
        ],
        add: [],
        bugfix: [
            "**Integra\xe7\xe3o (TechHub / fila de faturas):** situa\xe7\xe3o em que o pedido n\xe3o era gerado e o registro permanecia preso com status de fila ainda aberto, apesar de novas consultas na origem mostrando a fatura \u2014 fluxo alinhado ao reprocessamento correto."
        ]
    },
    {
        date: '25/04/2026',
        changes: [
            "**Faturamento / sa\xeddas:** depois que a nota de sa\xedda \xe9 autorizada, o sistema aplica a baixa da reserva antes de consolidar os status da sa\xedda, no mesmo sentido do encerramento que a opera\xe7\xe3o j\xe1 utiliza \u2014 reduz diverg\xeancia entre o que consta como faturado e o movimento no acompanhamento de estoque.",
            "**Pedidos de sa\xedda:** no menu de relat\xf3rios, exportar a listagem de pedidos em planilha (CSV), com op\xe7\xe3o de aplicar os mesmos filtros e ordem da tela ou exportar tudo a que o seu usu\xe1rio tem acesso."
        ],
        add: [],
        bugfix: [
            "**Estoque / sa\xeddas faturadas:** situa\xe7\xe3o em que a sa\xedda podia aparecer faturada sem a baixa correspondente no extrato, em fluxos ligados \xe0 nota; sequ\xeancia de processamento alinhada ao encerramento manual.",
            "**Entradas:** ao cancelar ou inativar, o sistema n\xe3o exige mais que o armaz\xe9m de recebimento continue ativo (ex.: ap\xf3s desativar o armaz\xe9m e ainda existir entrada pendente)."
        ]
    },
    {
        date: '24/04/2026',
        changes: [
            "**Banco de dados:** complemento da prote\xe7\xe3o que passa a registrar corretamente no hist\xf3rico as altera\xe7\xf5es em itens de sa\xedda.",
            "**Opera\xe7\xe3o:** ajuste de quantidades em uma sa\xedda ap\xf3s situa\xe7\xe3o irregular de regera\xe7\xe3o de linhas; saldo e movimentos conferidos."
        ],
        add: [],
        bugfix: []
    },
    {
        date: '23/04/2026',
        changes: [
            "**Banco de dados:** hist\xf3rico de altera\xe7\xf5es nos itens da sa\xedda e regra que evita aumentar quantidade al\xe9m do que o estoque comprova para aquela sa\xedda.",
            "**Opera\xe7\xe3o:** corre\xe7\xe3o de saldo dispon\xedvel ap\xf3s cancelamentos que tinham deixado diferen\xe7a residual.",
            "**Confer\xeancia de sa\xedda:** o relat\xf3rio passa a refletir quem conferiu a sa\xedda, e n\xe3o apenas o \xfaltimo usu\xe1rio que alterou o pedido.",
            "**Etiqueta de expedi\xe7\xe3o:** na linha de endere\xe7o, exibi\xe7\xe3o do CEP ap\xf3s cidade e UF.",
            "**Etiqueta de posi\xe7\xe3o:** leitura do c\xf3digo alinhada ao uso no coletor (endere\xe7o compacto, sem dados t\xe9cnicos extras)."
        ],
        add: [],
        bugfix: [
            "**Coletor / sa\xeddas:** ao salvar, o sistema ignora campos de confer\xeancia enviados no retorno da tela, evitando erro ao gravar.",
            "**Autentica\xe7\xe3o:** corre\xe7\xe3o grave em que, em alguns casos de uso simult\xe2neo, o nome do usu\xe1rio gravado em movimentos podia ser o de outra sess\xe3o."
        ]
    },
    {
        date: '22/04/2026',
        changes: [
            "**Relat\xf3rios \u2014 Auditoria:** novo relat\xf3rio em planilha com vis\xe3o de entradas, sa\xeddas ou estoque, filtros e abas de resumo, hist\xf3rico e movimentos.",
            "**Relat\xf3rios \u2014 Bloqueios de saldo:** novo relat\xf3rio que descreve posi\xe7\xf5es e lotes bloqueados ou reservados, com exibi\xe7\xe3o mais clara.",
            "**Tela:** carregamentos longos (exporta\xe7\xf5es grandes) passam a mostrar barra de progresso at\xe9 o fim do processamento.",
            "**Estoque:** colunas e mensagens passam a usar o termo \xabbloqueada\xbb de forma consistente em telas e relat\xf3rios."
        ],
        add: [
            "**Relat\xf3rios de Auditoria e de Bloqueios descritivo,** conforme permiss\xe3o do seu perfil."
        ],
        bugfix: [
            "**Navega\xe7\xe3o:** ap\xf3s login com link direto para uma tela, a \xe1rea de trabalho passa a abrir a tela correta sem precisar clicar de novo no menu.",
            "**Estoque \u2014 gerenciamento:** trava ap\xf3s confirmar a\xe7\xe3o e prote\xe7\xe3o contra envio em duplicidade ao bloquear, desbloquear ou movimentar em lote."
        ]
    },
    {
        date: '21/04/2026',
        changes: [
            "**Pedidos de sa\xedda:** aviso e bloqueio ao tentar reutilizar a mesma refer\xeancia em outro pedido ainda ativo.",
            "**Sa\xeddas:** op\xe7\xe3o e rotina de corre\xe7\xe3o quando, em casos legados, a sa\xedda ficou com o dobro do previsto no pedido.",
            "**Posi\xe7\xf5es:** poss\xedvel alterar o armaz\xe9m de uma posi\xe7\xe3o pelo cadastro, quando regras de estoque permitem.",
            "**Relat\xf3rio (rastreio de saldo):** exibi\xe7\xe3o do endere\xe7o da posi\xe7\xe3o em vez de c\xf3digos internos.",
            "**Estoque:** refor\xe7o contra linhas duplicadas de saldo e contra aloca\xe7\xe3o duplicada na mesma c\xe9lula."
        ],
        add: [],
        bugfix: []
    },
    {
        date: '20/04/2026',
        changes: [
            "**Sa\xeddas:** relat\xf3rio de rastreio de saldo com op\xe7\xe3o de exportar em tabela, al\xe9m do PDF; confer\xeancia ajustada para limites do pedido e totais coerentes.",
            "**Sa\xeddas:** tela de edi\xe7\xe3o deixa de recarregar itens a partir do pedido de entrada no fluxo errado, evitando linhas indevidas.",
            "**Sa\xeddas:** regras de teto do pedido por produto e lote; cancelamento e baixa com melhor alinhamento \xe0 reserva real.",
            "**Faturamento:** ap\xf3s a nota, o processamento da baixa fica em ordem mais segura (evita sa\xedda faturada sem movimento de estoque correspondente).",
            "**Integra\xe7\xe3o (pedido / ERP):** cancelamento coordenado passa a registrar o resultado de forma acompanh\xe1vel; integra\xe7\xf5es diversas com mais mensagens claras em falha."
        ],
        add: [],
        bugfix: [
            "**Kardex:** corre\xe7\xe3o de erro na montagem de consultas em ambiente de banco mais recente."
        ]
    },
    {
        date: '19/04/2026',
        changes: [
            "**Armaz\xe9ns:** poss\xedvel inativar armaz\xe9m vazio; armaz\xe9ns inativos deixam de aparecer em listas de opera\xe7\xe3o e bloqueiam novas movimenta\xe7\xf5es indevidas.",
            "**Formul\xe1rios:** ajuste em que valor num\xe9rico \xab0\xbb n\xe3o marcava op\xe7\xe3o indevidamente no cadastro do armaz\xe9m."
        ],
        add: [],
        bugfix: []
    },
    {
        date: '18/04/2026',
        changes: [
            "**Empresas / Entradas:** par\xe1metro \xabEntrada com coletor\xbb restringe a escolha de destino, armaz\xe9m e posi\xe7\xe3o \xe0 lista.",
            "**Entradas \u2014 grade:** colunas e ordena\xe7\xe3o alinhadas aos dados; melhor suporte a confer\xeancia e programa.",
            "**Kardex:** origem e destino exibem endere\xe7o e nomes, n\xe3o apenas identifica\xe7\xe3o t\xe9cnica.",
            "**Posi\xe7\xf5es:** etiqueta e tela de cat\xe1logo com ajustes de leitura e de carregamento em volumes grandes.",
            "**Movimenta\xe7\xe3o:** op\xe7\xe3o de mover s\xf3 o saldo livre quando houver reserva na posi\xe7\xe3o."
        ],
        add: [],
        bugfix: [
            '**Login:** tela de entrada com logotipo e texto institucional conforme o ambiente do cliente.',
            "**Sa\xeddas \u2014 posi\xe7\xe3o na tela:** lista de endere\xe7os completa e consistente com o remetente e armaz\xe9m escolhidos.",
            "**Sa\xeddas \u2014 mensagens:** textos de erro orientam a corrigir cadastro ou conferir estoque, sem c\xf3digos internos em destaque."
        ]
    },
    {
        date: '17/04/2026',
        changes: [
            "**Pedidos e sa\xeddas:** evita duas sa\xeddas vivas para o mesmo pedido; refor\xe7o de gera\xe7\xe3o e mescla de linhas no mesmo endere\xe7o e lote.",
            "**Confer\xeancia:** na confer\xeancia da sa\xedda, a reserva passa a ir para a posi\xe7\xe3o de expedi\xe7\xe3o padr\xe3o do armaz\xe9m, quando aplic\xe1vel na opera\xe7\xe3o do cliente.",
            "**Faturamento:** leitura do status da nota ap\xf3s a autoriza\xe7\xe3o evita falha intermitente no disparo da baixa."
        ],
        add: [],
        bugfix: [
            "**Posi\xe7\xf5es \u2014 cadastro:** ao trocar de empresa no formul\xe1rio, o endere\xe7o salvo deixa de ir para a URL errada (evitava gravar a posi\xe7\xe3o)."
        ]
    },
    {
        date: '16/04/2026',
        changes: [
            "**Pedidos (entrada e sa\xedda) \u2014 programa, NF no pedido e relat\xf3rios; integra\xe7\xe3o com gera\xe7\xe3o de nota e fiel deposit\xe1rio.**",
            "**Estoque \u2014 Kardex, bloqueios, linhas de sa\xedda, cat\xe1logo de posi\xe7\xf5es e gerenciamento em lote; permiss\xf5es associadas para perfis de estoque e administradores.**",
            "**Movimenta\xe7\xe3o e lotes: bloqueio autom\xe1tico e rotinas de vencimento; NF-e: tributa\xe7\xe3o e inutiliza\xe7\xe3o conforme regras vigentes.**"
        ],
        add: [
            "**Relat\xf3rios e rotinas** citados acima, conforme o que o administrador habilitou para o seu grupo."
        ],
        bugfix: [
            "**Gera\xe7\xe3o de sa\xedda:** c\xe1lculo de atendimento e aloca\xe7\xe3o de estoque mais est\xe1veis; pedido parcial e flags de lote ajustados."
        ]
    },
    {
        date: '10/04/2026',
        changes: [
            "**Embalagens e cadastros:** exporta\xe7\xe3o e relat\xf3rios; consulta e valida\xe7\xe3o de telefone e endere\xe7o em cadastros.",
            "**NF-e e pedidos:** travas e valida\xe7\xf5es de nota, destinat\xe1rio e eventos; melhor apresenta\xe7\xe3o de valores e totais no aviso de remessa.",
            "**Estoque \u2014 grade:** colunas e prefer\xeancias alinhadas ao que o operador v\xea e exporta."
        ],
        add: [],
        bugfix: []
    },
    {
        date: '01/04/2026',
        changes: [
            "**Entradas:** relat\xf3rio completo e fluxo de NF do pedido para a entrada; vincula\xe7\xe3o autom\xe1tica do n\xfamero da nota quando fizer sentido.",
            "**Kardex:** an\xe1lise de movimentos com custo opcional; filtros e desempenho em bases grandes.",
            "**Estoque:** bloquear quantidade com motivo e natureza; mover toda a posi\xe7\xe3o quando n\xe3o h\xe1 reserva; relat\xf3rio anal\xedtico de estoque completo.",
            "**Empresas e NF-e:** textos padr\xe3o no corpo da nota, benef\xedcio fiscal SP em medicamentos, ajuste de sa\xedda em fiel deposit\xe1rio e cancelamento de sa\xedda com baixa j\xe1 registrada."
        ],
        add: [
            "**Relat\xf3rios** ampliados (Kardex, estoque anal\xedtico) e ferramentas de relato em entrada, conforme permiss\xe3o."
        ],
        bugfix: [
            "**Corre\xe7\xf5es** de filtro, produto e tela de Kardex; cancelamento de sa\xedda faturada com estorno de baixa de estoque orquestrado de forma segura."
        ]
    },
    {
        date: '20/03/2026',
        changes: [
            "**Entradas e sa\xeddas \u2014 confer\xeancia:** relat\xf3rios alinhados ao padr\xe3o do picking, mais leg\xedveis e completos.",
            "**DANFE (layout Protheus):** descri\xe7\xe3o e quebras de p\xe1gina melhor em dados longos.",
            "**Derrubada de pallets, etiquetas, picking (FEFO) e lote a vencer:** ajustes de regra, layout e bloqueio de lote indevido na separa\xe7\xe3o."
        ],
        add: [
            "**Rotina autom\xe1tica** (quando o cliente usa) para marcar lotes em janela de vencimento curto, conforme pol\xedtica de estoque."
        ],
        bugfix: [
            "**Confer\xeancia e impress\xf5es:** permiss\xf5es, lista de produto no relat\xf3rio de entrada, endere\xe7o vazio na derrubada de pallets."
        ]
    },
    {
        date: '10/03/2026',
        changes: [
            "**Importa\xe7\xe3o e clientes:** planilha de clientes com mais campos, relat\xf3rio de cadastro e atalhos (CEP, munic\xedpio).",
            "**Pedidos de sa\xedda:** resultados de gera\xe7\xe3o mais completos; desconto e totais; central de importa\xe7\xe3o refor\xe7ada."
        ],
        add: [],
        bugfix: [
            "**Picking e pedidos de sa\xedda:** c\xe1lculo de atendimento com lista de c\xf3digos parciais, lotes e pre\xe7os; v\xe1rias corre\xe7\xf5es de salvamento de linha."
        ]
    },
    {
        date: '25/02/2026',
        changes: [
            "**Aviso de remessa:** assinatura permanece na mesma p\xe1gina do quadro de itens."
        ],
        add: [],
        bugfix: [
            "**Coletor e relat\xf3rios de confer\xeancia** com consultas ajustadas ap\xf3s evolu\xe7\xe3o do cadastro de usu\xe1rio."
        ]
    },
    {
        date: '19/02/2026',
        changes: [
            "**Programa (v\xednculo cont\xe1bil / gest\xe3o):** colunas e filtros em pedidos, entradas, sa\xeddas e estoque; tela Sobre com hist\xf3rico de mudan\xe7as recentes."
        ],
        add: [
            "**Controle** de programa padr\xe3o e normaliza\xe7\xe3o de dados legados, conforme m\xf3dulo e empresa."
        ],
        bugfix: [
            "**Listagens, etiquetas e impressos** vinculados a permiss\xe3o e a cadastro de empresa."
        ]
    },
    {
        date: "At\xe9 18/02/2026 (hist\xf3rico resumido)",
        changes: [
            "**Quando o m\xf3dulo existir no seu contrato:** transportador em modo entrega local, aviso de remessa e pick list reformulados, inutiliza\xe7\xe3o de nota, NF de ativo imobilizado, CFOPs e observa\xe7\xf5es fiscais, etiquetas e entrada detalhada, melhorias no coletor e no fluxo de separa\xe7\xe3o e confer\xeancia."
        ],
        add: [],
        bugfix: [
            "**Corre\xe7\xf5es** gerais de telas, NF-e, coletor e confer\xeancia, descritas nas vers\xf5es anteriores \xe0s acima; consulte a equipe se precisar de detalhe de chamado em arquivo interno."
        ]
    }
];


function $754162cf0396517c$var$formatChangelog(entries) {
    /** Número de blocos (por data) exibidos no Sobre. */ const MAX_DAYS = 10;
    const slice = entries.slice(0, MAX_DAYS);
    return slice.map((e)=>{
        const ch = e.changes && e.changes.length ? e.changes.join('\n') : '-----';
        const ad = e.add && e.add.length ? e.add.join('\n') : '-----';
        const bf = e.bugfix && e.bugfix.length ? e.bugfix.join('\n') : '-----';
        return `${e.date}

ALTERA\xc7\xd5ES
${ch}\n\nNOVIDADES\n${ad}

CORRE\xc7\xd5ES
${bf}`;
    }).join("\n\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n\n");
}
const $754162cf0396517c$var$about = async function() {
    let back = await (0, $9VcS9.default).call((0, $9VcS9.default).version);
    const logText = $754162cf0396517c$var$formatChangelog((0, $36a7dfe577885f1c$export$2e2bcd8739ae039));
    let html = `
		<style>
			#about .about-logos { display: flex; align-items: center; justify-content: center; gap: var(--space-lg); flex-wrap: wrap; }
			#about img.logo-sial { width: 200px; }
			#about img.logo-machadotec { width: 180px; height: auto; }
			#about .about-versions { margin-top: var(--space-md); margin-bottom: var(--space-md); }
			#about .about-changelog {
				margin-top: var(--space-md);
				margin-bottom: var(--space-md);
				max-height: 240px;
				overflow-y: auto;
				padding: var(--space-sm);
				background: var(--bg-secondary, #f8f9fa);
				border: 1px solid var(--border-color, #dee2e6);
				border-radius: 6px;
				font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
				font-size: 0.88rem;
				line-height: 1.5;
				white-space: pre-wrap;
				word-break: break-word;
			}
		</style>
		<div id="about" class="msgbox">
			<div class="about-logos">
				<img src="img/logo_v.png" class="logo-sial" alt="SIAL">
				<img src="img/logo_machadotec.png" class="logo-machadotec" alt="MachadoTec">
			</div>
			<div class="about-versions">
				Frontend: ${(0, $8027b5f9052bcf5e$export$2e2bcd8739ae039)}<br/>
				Backend: ${back}<br/>
				Desenvolvido para LLT Consultoria<br/>
				MachadoTec Software Solutions
			</div>
			<div class="about-changelog" readonly>${logText.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
			<button class="bn_Enter button">Fechar</button>
		</div>`;
    let dlg = (0, $dx9qz.default).create(html, ()=>dlg.destroy(), /Enter|Escape/);
};
var $754162cf0396517c$export$2e2bcd8739ae039 = $754162cf0396517c$var$about;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");

var $1cmSR = parcelRequire("1cmSR");

var $9VcS9 = parcelRequire("9VcS9");


var $h1m6J = parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $hWQyW = parcelRequire("hWQyW");

var $h1m6J = parcelRequire("h1m6J");
parcelRequire("93O8T");
var $5Aed9 = parcelRequire("5Aed9");
var $hubZT = parcelRequire("hubZT");
var $3eqAU = parcelRequire("3eqAU");
var $YermW = parcelRequire("YermW");
var $3OKkn = parcelRequire("3OKkn");
var $c9a703fc1a38021f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#columns
			{
				display: grid;
				grid-template-columns: 1fr 1fr;
			}
			#columns label:nth-child(odd)
			{
				text-align: left;
			}
			#columns label:nth-child(even)
			{
				text-align: right;
			}
			#setup input
			{
				display: inline-block;
			}
			#setup #sort_column { width: 12rem; margin-right: var(--space-lg); }
			#setup #page_length { width: 4rem; text-align: right; }
		</style>
		<form id="setup" class="form">
			<div class="fsb">
				<span>
					<label>Ordenar por&nbsp;
						<select id="sort_column" name="sort_column" required>
						</select>
					</label>
				</span>
				<span>
					<label class="blk tar">
						Ordem Ascendente
						<input class="sort_order" type="radio" name="sort_order" value="0">
					</label>
					<label class="blk">
						Ordem Descendente
						<input class="sort_order" type="radio" name="sort_order" value="1">
					</label>
				</span>
			</div>
			<fieldset>
				<legend>Colunas Vis\xedveis</legend>
				<div id="columns">
				</div>
			</fieldset>
			<div class="fsb">
				<label>
					Linhas&nbsp;por&nbsp;P\xe1gina&nbsp;
					<input id="page_length" name="page_length" type="number" min="1" max="500" required>
				</label>
				<label>
					Preservar grade ao reabrir
					<input id="keep_filter" name="keep_filter" type="checkbox" checked>
				</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" title="Fechar sem altera\xe7\xf5es">Fechar</button>
				<button class="bn_Enter button" title="Aplicar nova configura\xe7\xe3o">Aplicar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#setup'
    },
    fields: [
        {
            properties: {
                selector: '#sort_column'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '.sort_order'
            },
            types: [
                $YermW.default()
            ]
        },
        {
            properties: {
                selector: '.columns'
            },
            types: [
                $hubZT.default()
            ]
        },
        {
            properties: {
                selector: '#page_length'
            },
            types: [
                $3eqAU.default()
            ]
        },
        {
            properties: {
                selector: '#keep_filter'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $b60a2 = parcelRequire("b60a2");
const $94884e046c5d00da$var$SELECT = /(<select[^>]*>)(.*?)(<\/select>)/ims;
const $94884e046c5d00da$var$COLUMNS = /(<div\s+id="columns"[^>]*>)(.*?)(<\/div>)/ims;
const $94884e046c5d00da$var$makeCheckboxes = function(array, value, label, cls) {
    let checkboxes = array.map((entry, index)=>`<label>
			${index % 2 ? entry[label] : ''}
			<input type="checkbox" class="${cls}" value="${entry[value]}" checked>
			${index % 2 ? '' : entry[label]}
		</label>`).join('\n');
    return checkboxes;
};
const $94884e046c5d00da$var$setup = {
    init (columns) {
        const sortable = (columns || []).filter((c)=>!c.computed);
        let options = (0, $b60a2.makeOptions)(sortable.length ? sortable : columns, 'index', [
            'label'
        ]);
        let checkboxes = $94884e046c5d00da$var$makeCheckboxes(columns, 'index', 'label', 'columns');
        (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html = (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html.replace($94884e046c5d00da$var$SELECT, '$1' + options + '$3');
        (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html = (0, $c9a703fc1a38021f$export$2e2bcd8739ae039).html.replace($94884e046c5d00da$var$COLUMNS, '$1' + checkboxes + '$3');
    },
    edit (callback, current_data) {
        let fs = (0, $h1m6J.default).create((0, $c9a703fc1a38021f$export$2e2bcd8739ae039), (updated_data)=>{
            fs.destroy();
            callback?.(updated_data);
        });
        fs.init = (()=>{
            // keep_filter = "Preservar grade ao reabrir" (Configurar). 0 = desmarcado.
            const rawKeep = current_data?.keep_filter;
            const keepFilter = rawKeep === 0 || rawKeep === '0' || rawKeep === false ? 0 : 1;
            fs.form.setValues({
                'sort_column': current_data?.sort_column ?? 1,
                'sort_order': current_data?.sort_order ?? 1,
                'columns': current_data?.columns,
                'page_length': current_data?.page_length ?? 30,
                'keep_filter': keepFilter
            });
            Object.getPrototypeOf(fs).init.call(fs);
        })();
    }
};
var $94884e046c5d00da$export$2e2bcd8739ae039 = $94884e046c5d00da$var$setup;



var $1cmSR = parcelRequire("1cmSR");

var $8gtbe = parcelRequire("8gtbe");

var $aGGTj = parcelRequire("aGGTj");
const $037bce58a5e51361$var$_selectionCache = Object.create(null);
const $037bce58a5e51361$var$grid = {
    id: null,
    view: null,
    node: null,
    visible: [],
    init (id, view, node) {
        this.id = id;
        this.view = view;
        this.node = node;
    },
    async render (records = []) {
        if (this.id) delete $037bce58a5e51361$var$_selectionCache[this.id];
        const list = Array.isArray(records) ? records : [];
        this.node.innerHTML = await this.view.call(this, list);
        const viewEl = this.node.querySelector('.view');
        if (viewEl) viewEl.addEventListener('click', this.flipState.bind(this));
    },
    setVisible (indices) {
        this.visible = indices;
    },
    clearSelection () {
        if (this.id) delete $037bce58a5e51361$var$_selectionCache[this.id];
        this.node?.querySelectorAll('.view input[type="checkbox"]').forEach((node)=>{
            node.checked = false;
        });
    },
    getSelection () {
        return $037bce58a5e51361$var$_selectionCache[this.id] || [];
    },
    setSelection (selection) {
        if (this.id) $037bce58a5e51361$var$_selectionCache[this.id] = selection;
    },
    isChecked (id) {
        return this.getSelection().includes(id) ? ' checked' : '';
    },
    flipState (ev) {
        if (ev.target.nodeName != 'INPUT' || ev.target.type != 'checkbox') return;
        ev.stopPropagation();
        if (ev.target.parentNode.nodeName == 'TH') {
            const table = ev.target.closest('.view');
            const rows = table?.querySelectorAll('tbody tr[data-id]') || [];
            const allIds = Array.from(rows).map((r)=>r.getAttribute('data-id'));
            const selection = this.getSelection();
            const allSelected = allIds.length > 0 && allIds.every((id)=>selection.includes(id));
            const headCb = table?.querySelector('thead input[type="checkbox"]');
            if (allSelected) {
                this.clearSelection();
                if (headCb) headCb.checked = false;
            } else {
                this.setSelection([
                    ...allIds
                ]);
                table?.querySelectorAll('tbody input[type="checkbox"]').forEach((cb)=>{
                    cb.checked = true;
                });
                if (headCb) headCb.checked = true;
            }
            return;
        }
        let id = (0, $aGGTj.findByAttr)(ev.target, 'data-id').getAttribute('data-id');
        let selection = this.getSelection();
        if (ev.target.checked) selection.push(id);
        else selection.splice(selection.indexOf(id), 1);
        this.setSelection(selection);
    },
    async key (store, keys, labels = 'name', separator = ' ') {
        if (!keys || Array.isArray(keys) && (keys.length === 0 || keys.some((v)=>v == null || v === ''))) return;
        let entry = await (0, $1cmSR.default).get(store, keys);
        if (!entry) return;
        return (Array.isArray(labels) ? labels : [
            labels
        ]).map((label)=>entry[label]).join(separator);
    },
    option (object, value) {
        return object.options.find((entry)=>entry.value == value)?.label;
    },
    // TODO: Usar o campo já inicializado para o filtro para formatar o dado ao invés de ficar criando um novo a cada ocorrência
    // Dá erro de "Selector not found" quando sendo criado
    format (type, value) {
        return (0, $8gtbe.default).create({}, [
            type
        ]).format(value);
    }
};
var $037bce58a5e51361$export$2e2bcd8739ae039 = $037bce58a5e51361$var$grid;



var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");
var $9347e9db44a76bf8$export$2e2bcd8739ae039 = (options)=>`<ul class="menu submenu">
	${(options || []).map((option)=>`<li hash="${option.hash}">${option.label}</li>`).join('')}
</ul>`;


var $1c095ea81a245880$export$2e2bcd8739ae039 = (module_name, operations = [], reports = [])=>`<div class="crud fsb fac">
	<ul class="menu submenu">
		<li hash="#insert" title="Inserir"><img src="img/insert.svg"><span>Inserir</span></li>
		<li hash="#filter" title="Filtrar"><img src="img/filter.svg"><span>Filtrar</span></li>
		<li title="Menu de Opera\xe7\xf5es"><img src="img/operations.svg"><span>Opera\xe7\xf5es</span>
			${(0, $9347e9db44a76bf8$export$2e2bcd8739ae039)(operations)}
		</li>
		<li title="Menu de Relat\xf3rios"><img src="img/reports.svg"><span>Imprimir</span>
			${(0, $9347e9db44a76bf8$export$2e2bcd8739ae039)(reports)}
		</li>
		<!--
		<li hash="#export" title="Exportar Registros"><img src="img/export.svg"><span>Exportar</span></li>
		<li hash="#import" title="Importar Registros"><img src="img/import.svg"><span>Importar</span></li>
		-->
		<li hash="#setup" title="Configurar P\xe1gina"><img src="img/setup.svg"><span>Configurar</span></li>
		<li hash="#first" title="Primeira P\xe1gina"><img src="img/first.svg"><span>Primeira</span></li>
		<li hash="#previous" title="P\xe1gina Anterior"><img src="img/previous.svg"><span>Anterior</span></li>
		<li hash="#reload" title="Recarregar P\xe1gina"><img src="img/reload.svg"><span>Atual</span></li>
		<li hash="#next" title="Pr\xf3xima P\xe1gina"><img src="img/next.svg"><span>Pr\xf3xima</span></li>
		<li hash="#last" title="\xdaltima P\xe1gina"><img src="img/last.svg"><span>\xdaltima</span></li>
	</ul>
	<span id="module_name">
		${module_name}
	</span>
	<span id="page_info">
		P\xe1gina&nbsp;<span id="page">&hellip;</span>
	</span>
</div>
<div id="grid">
</div>`;


parcelRequire("93O8T");
var $84MPM = parcelRequire("84MPM");
var $35c39d8de2c7fb54$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#import #file
			{ 
				margin-top: var(--space-lg);	
			}
		</style>
		<form id="import" class="msgbox form">
			<div class="title">
				Importa\xe7\xe3o
			</div>
			<div>
				<input id="file" type="file" accept=".xlsx, application/vnd.ms-excel" required>
			</div>
			<div class="mtl">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Enviar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#import'
    },
    fields: [
        {
            properties: {
                selector: '#file'
            },
            types: [
                $84MPM.default()
            ]
        }
    ]
};


const $623d474b3f9ce8b0$var$crud = {
    module_name: null,
    target_node: null,
    fieldspecs: null,
    record_form: null,
    record_count: 0,
    page_count: 0,
    page_number: 1,
    page_length: 30,
    sort_column: 1,
    sort_order: 1,
    filter: {},
    filterExplicitlyApplied: false,
    create (properties) {
        return Object.assign(Object.create(this), properties);
    },
    async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options = {}) {
        try {
            if (options.default_columns) this.default_columns = options.default_columns;
            this.fieldspecs = fieldspecs;
            this.record_form = record_form;
            this.module_name = module_name;
            this.target_node = (0, $aGGTj.removeEvents)(target_node);
            this.target_node.innerHTML = (0, $1c095ea81a245880$export$2e2bcd8739ae039)(label, operations, reports);
            (0, $hWQyW.default).init(fieldspecs);
            (0, $94884e046c5d00da$export$2e2bcd8739ae039).init(fieldspecs);
            (0, $037bce58a5e51361$export$2e2bcd8739ae039).init(module_name + '.grid', grid_view, this.target_node.querySelector('#grid'));
            this.target_node.addEventListener('click', this.handleEvents.bind(this));
            this.applySetup(this.loadSetup());
            this.setMenuRoutes();
            await this.loadBaseData();
            // Resolver labels→IDs após loadBaseData (db.list('companies') precisa estar populado)
            if (this.filter && Object.keys(this.filter).some((k)=>/^field-\d+$/.test(k))) this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(this.filter, this.fieldspecs);
            if (!options.skipInitialLoad) await this.loadPage();
        } catch (e) {
            (0, $jUNyh.notify)(e.message, 'Falha');
            console.log(e);
        }
    },
    handleEvents (ev) {
        let submenu, header, record;
        if (submenu = (0, $aGGTj.findByAttr)(ev.target, 'hash')) (0, $a020c0121b2250d6$export$2e2bcd8739ae039).route(submenu.getAttribute('hash'));
        else if (header = (0, $aGGTj.findByAttr)(ev.target, 'data-index')) {
            const idx = Number(header.getAttribute('data-index'));
            const spec = (this.fieldspecs || []).find((s)=>Number(s.index) === idx);
            if (spec?.computed) return;
            this.sortPage(idx);
        } else if (record = (0, $aGGTj.findByAttr)(ev.target, 'data-id')) this.loadRecord(record.getAttribute('data-id')).then((data)=>{
            if (data != null) this.editRecord.call(this, data);
        }).catch((e)=>(0, $jUNyh.notify)(e?.message || String(e), "Aten\xe7\xe3o"));
    },
    setMenuRoutes () {
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#insert', this.insertRecord.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#filter', this.editFilter.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#setup', this.editSetup.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export', this.exportFileDialog.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#import', this.importFileDialog.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#first', this.goToFirstPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#previous', this.goToPrevPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reload', this.reloadPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#next', this.goToNextPage.bind(this));
        (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#last', this.goToLastPage.bind(this));
    },
    async addFilter (params) {
        let f = this.filter;
        if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) {
            f = await (0, $hWQyW.resolveFilterLabelsToIds)(f, this.fieldspecs);
            (0, $hWQyW.validateResolvedFilterValues)(f, this.fieldspecs);
        }
        const filter = (0, $hWQyW.translate)(f, null, this.fieldspecs);
        if (filter) params.append('filter', filter);
    },
    async addFilterForLocations (params) {
        let f = this.filter;
        if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $hWQyW.resolveFilterLabelsToIds)(f, this.fieldspecs);
        // Só escopo (empresa/armazém) — nunca critérios de posição (location_address quebra GET /locations).
        const expr = (0, $hWQyW.translate)(f, [
            'company_id',
            'warehouse_id'
        ], this.fieldspecs);
        if (expr) params.append('filter', expr);
    },
    addSort (params) {
        let col = Number(this.sort_column);
        const spec = (this.fieldspecs || []).find((s)=>Number(s.index) === col);
        if (!Number.isFinite(col) || spec?.computed) {
            const rec = this.computeRecencySort();
            col = rec.sort_column;
            this.sort_column = col;
            this.sort_order = rec.sort_order;
        }
        params.append('sort', col * (this.sort_order ? -1 : 1));
    },
    computeRecencySort () {
        const fs = this.fieldspecs || [];
        const pick = (name)=>fs.find((s)=>s.field === name)?.index;
        const col = pick('created_on') ?? pick('updated_on') ?? pick('id') ?? pick('location_id') ?? fs[0]?.index ?? 1;
        return {
            sort_column: col,
            sort_order: 1
        };
    },
    addLimit (params, limit) {
        params.append('limit', limit ?? this.page_length);
    },
    async addListLimit (params) {
        // Sempre paginar: limit 0 omite LIMIT no backend e pode travar a API / o browser.
        params.append('limit', this.page_length);
    },
    addOffset (params) {
        params.append('offset', (this.page_number - 1) * this.page_length);
    },
    addCount (params) {
        params.append('group', 'count');
    },
    queryAll () {
        let params = new URLSearchParams();
        this.addLimit(params, 0);
        return '?' + params.toString();
    },
    async queryPage () {
        let params = new URLSearchParams();
        await this.addFilter(params);
        this.addSort(params);
        await this.addListLimit(params);
        this.addOffset(params);
        return '?' + params.toString();
    },
    async queryFiltered () {
        let params = new URLSearchParams();
        await this.addFilter(params);
        this.addSort(params);
        this.addLimit(params, 0);
        return '?' + params.toString();
    },
    async queryFilteredForLocations () {
        let params = new URLSearchParams();
        await this.addFilterForLocations(params);
        params.append('sort', '4');
        params.append('limit', '0');
        return '?' + params.toString();
    },
    /**
	 * Query de posições somente com filtro company/warehouse no filtro atual.
	 * Retorna null sem escopo — evita GET /locations?limit=0 (~4MB+).
	 */ async queryScopedLocationsOrNull (filterOverride = null) {
        const params = new URLSearchParams();
        const saved = this.filter;
        if (filterOverride != null) this.filter = filterOverride;
        try {
            await this.addFilterForLocations(params);
        } finally{
            if (filterOverride != null) this.filter = saved;
        }
        if (!params.has('filter')) return null;
        params.append('sort', '4');
        params.append('limit', '0');
        return '?' + params.toString();
    },
    /** Grava posições no IndexedDB apenas quando há escopo no filtro. */ async loadScopedLocationsToDb (filterOverride = null) {
        const q = await this.queryScopedLocationsOrNull(filterOverride);
        if (!q) return;
        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, q);
        await (0, $1cmSR.default).set('locations', Array.isArray(data) ? data : []);
    },
    /** Catálogos leves (empresa, armazém, dispositivo) — seguro na abertura da tela. */ loadLightBaseCatalogs () {
        const q = this.queryAll();
        return Promise.all([
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q).then((data)=>(0, $1cmSR.default).set('companies', data)).catch((error)=>(0, $jUNyh.notify)(error)),
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q).then((data)=>(0, $1cmSR.default).set('warehouses', data)).catch((error)=>(0, $jUNyh.notify)(error)),
            (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, q).then((data)=>(0, $1cmSR.default).set('devices', data)).catch(()=>{})
        ]);
    },
    async queryCount () {
        let params = new URLSearchParams();
        await this.addFilter(params);
        this.addLimit(params, 0);
        this.addCount(params);
        return '?' + params.toString();
    },
    async loadBaseData () {
        (0, $9VcS9.default).call((0, $9VcS9.default).list_something, this.queryAll()).then((data)=>(0, $1cmSR.default).set('something', data).catch((error)=>(0, $jUNyh.notify)(error)));
    },
    async queryData (query) {
        return await (0, $9VcS9.default).call((0, $9VcS9.default).list_records, query);
    },
    async queryFilteredData () {
        return await this.queryData(await this.queryFiltered());
    },
    async loadPage (page) {
        if (page) this.page_number = Number(page);
        // Garantir que labels (ex: nick da empresa) sejam convertidos em IDs antes da API
        if (this.filter && Object.keys(this.filter).some((k)=>/^field-\d+$/.test(k))) this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(this.filter, this.fieldspecs);
        const count = await this.queryData(await this.queryCount());
        this.record_count = typeof count === 'number' ? count : 0;
        this.page_count = Math.max(0, Math.ceil(this.record_count / this.page_length));
        if (this.page_count > 0 && this.page_number > this.page_count) this.page_number = this.page_count;
        document.getElementById('page').innerText = this.record_count === 0 ? '0/0' : `${this.page_number}/${this.page_count}`;
        const records = await this.queryData(await this.queryPage());
        await (0, $037bce58a5e51361$export$2e2bcd8739ae039).render(Array.isArray(records) ? records : []);
    },
    sortPage (column) {
        if (this.sort_column == column) this.sort_order = this.sort_order ^ 1;
        else {
            this.sort_column = column;
            this.sort_order = 1;
        }
        this.loadPage();
    },
    insertRecord () {
        this.editRecord();
    },
    async loadRecord (id) {
        let _record1 = await (0, $9VcS9.default).call((0, $9VcS9.default).select_record, ...JSON.parse(id));
        return (0, $b60a2.flatten)(_record1, 'items');
    },
    editRecord (data) {
        (0, $b60a2.default).edit(this.record_form, this.saveRecordWrapper.bind(this), data);
    },
    async saveRecordWrapper (data, old_data) {
        let success = await this.saveRecord(data, old_data);
        this.loadPage();
        return success;
    },
    async saveRecord (data, old_data) {
        data = (0, $b60a2.deepen)(data, 'items');
        if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_record, data.company_id, data.id, _record);
        else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_record, data.company_id, _record);
    },
    editFilter () {
        (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
    },
    async applyFilter (data) {
        this.filter = data;
        this.filterExplicitlyApplied = true;
        await this.loadPage(1);
    },
    loadSetup () {
        return JSON.parse(localStorage.getItem(this.module_name + '.setup') || '{}');
    },
    editSetup () {
        (0, $94884e046c5d00da$export$2e2bcd8739ae039).edit(this.saveSetup.bind(this), this.loadSetup());
    },
    saveSetup (data) {
        const keepOn = data.keep_filter === true || data.keep_filter === 1 || data.keep_filter === '1';
        data.keep_filter = keepOn ? 1 : 0;
        if (keepOn) data.filter = this.filter || {};
        else delete data.filter;
        delete data.filter_applied;
        localStorage.setItem(this.module_name + '.setup', JSON.stringify(data));
        this.applySetup(data);
        this.loadPage();
    },
    applySetup (data) {
        // Respeita Ordenar por / Ordem do Configurar quando informados.
        if (data.sort_column != null && data.sort_column !== '') {
            this.sort_column = Number(data.sort_column);
            this.sort_order = Number(data.sort_order ?? 1);
        } else {
            const rec = this.computeRecencySort();
            this.sort_column = rec.sort_column;
            this.sort_order = 1;
        }
        this.page_length = Number(data.page_length ?? this.page_length);
        this.filter = data.filter ?? this.filter;
        let _default = this.default_columns || '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25';
        let columns = (data.columns || _default).split(',').map((column)=>Number(column));
        (0, $037bce58a5e51361$export$2e2bcd8739ae039).setVisible(this.fieldspecs.map((field)=>columns.includes(field.index) ? 1 : 0));
    },
    async exportFile () {
        let ids = await this.getSelectedIds([
            'company_id',
            'id'
        ]);
        return await (0, $9VcS9.default).call((0, $9VcS9.default).export_endpoint);
    },
    exportFileDialog () {
        if (!this.ensureSelection("Exporta\xe7\xe3o")) return;
        (0, $jUNyh.ask)(`Exportar ${this.getCount()} registros?`, "Exporta\xe7\xe3o", async (answer)=>{
            if (answer == 'Y') {
                let data = await this.exportFile();
                this.clearGridSelection();
                (0, $jUNyh.notify)(`<a href="data:application/vnd.ms-excel;base64,${encodeURI(data.file)}" download="export.xlsx">Clique aqui para obter o arquivo</a>`, 'Download');
            }
        });
    },
    async importFile (data) {
        return await (0, $9VcS9.default).call((0, $9VcS9.default).import_endpoint, {
            file: data.file
        });
    },
    importFileDialog () {
        let fs = (0, $h1m6J.default).create((0, $35c39d8de2c7fb54$export$2e2bcd8739ae039), async (data)=>{
            let response = await this.importFile(data);
            if (response?.text) (0, $jUNyh.notify)(response.text);
            fs.destroy();
        });
        fs.init = (()=>{
            Object.getPrototypeOf(fs).init.call(fs);
            fs.form.eraseValues();
            fs.form.refresh();
        })();
    },
    goToPage (page) {
        if (page > 0 && page <= this.page_count) this.loadPage(page);
    },
    goToFirstPage () {
        if (this.page_number != 1) this.goToPage(1);
    },
    goToPrevPage () {
        this.goToPage(this.page_number - 1);
    },
    reloadPage () {
        // Sempre recarrega: goToPage() ignora se page_count === 0 (lista vazia = Atual morto).
        this.loadPage(this.page_number > 0 ? this.page_number : 1);
    },
    goToNextPage () {
        this.goToPage(this.page_number + 1);
    },
    goToLastPage () {
        if (this.page_number != this.page_count) this.goToPage(this.page_count);
    },
    getSelection () {
        return (0, $037bce58a5e51361$export$2e2bcd8739ae039).getSelection().map((entry)=>JSON.parse(entry));
    },
    clearGridSelection () {
        (0, $037bce58a5e51361$export$2e2bcd8739ae039).clearSelection();
    },
    getCount () {
        // Somente linhas marcadas na grade — nunca o total do filtro (evita ação acidental em milhares).
        return this.getSelection().length;
    },
    /**
	 * Exige seleção explícita antes de imprimir, gerar ou processar em lote.
	 * @param {string} [actionTitle]
	 * @returns {boolean}
	 */ ensureSelection (actionTitle) {
        if (this.getSelection().length) return true;
        (0, $jUNyh.notify)('Selecione ao menos um registro na grade antes de continuar.', actionTitle || "Aten\xe7\xe3o");
        return false;
    },
    getListOf (array, properties) {
        return array.map((entry)=>Array.isArray(properties) ? properties.map((property)=>entry[property]) : entry[properties]);
    },
    async getSelectedIds (properties) {
        const normalize = (entry)=>{
            if (entry == null) return null;
            if (typeof entry === 'string') {
                try {
                    const parsed = JSON.parse(entry);
                    if (Array.isArray(parsed) && Array.isArray(properties) && parsed.length >= properties.length) return properties.map((_, i)=>parsed[i]);
                    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && properties) return properties.map((p)=>parsed[p]);
                } catch (_) {
                    return null;
                }
                return null;
            }
            if (Array.isArray(entry) && Array.isArray(properties) && entry.length >= properties.length) return properties.map((_, i)=>entry[i]);
            if (entry && typeof entry === 'object' && !Array.isArray(entry) && properties) return properties.map((p)=>entry[p]);
            return null;
        };
        const ids = this.getSelection();
        if (!ids.length) return [];
        return ids.map(normalize).filter((row)=>row != null);
    }
};
var $623d474b3f9ce8b0$export$2e2bcd8739ae039 = $623d474b3f9ce8b0$var$crud;



var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");
// Types
function $58102435e51228d8$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^(\d{13}|ISENTO)$/,
        filter: /[]/g
    };
}



var $fY6pa = parcelRequire("fY6pa");

var $h3Uiq = parcelRequire("h3Uiq");

var $gBwx4 = parcelRequire("gBwx4");

var $e3m9R = parcelRequire("e3m9R");

var $9Wik7 = parcelRequire("9Wik7");

var $aYyoz = parcelRequire("aYyoz");
/**
 * Tipo condicional: CNPJ (14 dígitos) ou código GSNet (alfanumérico, 1-10 chars).
 * Quando #type === 'L' (Local), valida como código GSNet.
 * Caso contrário, valida como CNPJ.
 * Usado no cadastro de clientes para atender SESSP/GSNet (MT-59A4923).
 */ const $7df6175fce9b618d$var$CNPJ_REGEX = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
const $7df6175fce9b618d$var$GSNET_REGEX = /^[A-Za-z0-9]{1,10}$/;
function $7df6175fce9b618d$export$2e2bcd8739ae039(formSelector = '#customer') {
    return {
        regex: /^([A-Za-z0-9]{1,10}|(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}))$/,
        filter: /[.\/\-\s]/g,
        store_mask (match, p1) {
            return p1 || '';
        },
        display_mask: '$1',
        checkValue (value = this.getValue()) {
            const form = document.querySelector(formSelector);
            const typeEl = form?.querySelector('#type');
            const type = (typeEl?.value ?? '').trim().toUpperCase();
            const isLocal = type === 'L' || type === 'LOCAL';
            const cleaned = String(value ?? '').replace(this.filter, '').trim();
            if (isLocal) return cleaned.length > 0 && $7df6175fce9b618d$var$GSNET_REGEX.test(cleaned);
            return $7df6175fce9b618d$var$CNPJ_REGEX.test(cleaned);
        },
        format (value = this.getValue(), mask = this.display_mask) {
            if (value == null || value === '') return '';
            const form = document.querySelector(formSelector);
            const typeEl = form?.querySelector('#type');
            const type = (typeEl?.value ?? '').trim().toUpperCase();
            const isLocal = type === 'L' || type === 'LOCAL';
            const cleaned = String(value).replace(this.filter, '').trim();
            if (isLocal) return this.checkValue(value) ? cleaned : '';
            return this.checkValue(value) ? cleaned.replace($7df6175fce9b618d$var$CNPJ_REGEX, '$1.$2.$3/$4-$5') : '';
        }
    };
}



var $gbkt2 = parcelRequire("gbkt2");

var $5Aed9 = parcelRequire("5Aed9");

var $hubZT = parcelRequire("hubZT");

var $9PIz7 = parcelRequire("9PIz7");
parcelRequire("1589n");
var $b7D1Q = parcelRequire("b7D1Q");

var $8IFAz = parcelRequire("8IFAz");
/** Número de empenho: AAAA + NE + sequência (ex.: 2025NE02173). Vazio é permitido. */ function $01514eb1e21db7c4$export$2e2bcd8739ae039() {
    return {
        // Campo usa máscara padrão "$1"; precisa de grupo de captura para não renderizar literal "$1".
        regex: /^$|^(\d{4}NE\d+)$/i,
        filter: /\s+/g
    };
}



var $lVBv9 = parcelRequire("lVBv9");

var $7aGwp = parcelRequire("7aGwp");

var $84MPM = parcelRequire("84MPM");

var $hlPFs = parcelRequire("hlPFs");

var $gF6P4 = parcelRequire("gF6P4");

var $4dbYJ = parcelRequire("4dbYJ");

var $2rQ6E = parcelRequire("2rQ6E");

var $fE2eE = parcelRequire("fE2eE");

var $4KjZQ = parcelRequire("4KjZQ");
function $bba672065f562b52$export$2e2bcd8739ae039(...args) {
    return {
        regex: /^((?:[0-9A-Z]{1,2})(?:[,-][0-9A-Z]{1,2})*)$/,
        getValue (default_value, _this = this) {
            return this.safeProtoCall(default_value, _this)?.split(/[,-]/);
        },
        store_mask (match) {
            return match.split(/[,-]/).join(',');
        },
        display_mask (match, ...args) {
            return match.split(',').join('-');
        }
    };
}



var $74yTJ = parcelRequire("74yTJ");

var $bWgzi = parcelRequire("bWgzi");

var $91trW = parcelRequire("91trW");

var $l0p8O = parcelRequire("l0p8O");

var $5UO7m = parcelRequire("5UO7m");

var $3eqAU = parcelRequire("3eqAU");

var $jdpN4 = parcelRequire("jdpN4");

var $jHqD0 = parcelRequire("jHqD0");
/**
 * Telefone para infRespTec (NF-e): aceita +55/55 + DDD + número (como types.phone)
 * ou formato nacional com zero opcional antes do DDD (ex.: 01930148080), comum em cadastros.
 */ function $ca99afedcb4c666c$export$2e2bcd8739ae039() {
    const ddd = '(?:1[1-9]|2[1247]|3[1234578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])';
    const midSuf = '([2-9]\\d{3,4})(\\d{4})';
    return {
        regex: new RegExp(`^(?:\\+?(55)(${ddd})${midSuf}|0?(${ddd})${midSuf})$`),
        filter: /[\(\)\-\s.]/g,
        store_mask (match, cc, ddd1, mid1, suf1, ddd2, mid2, suf2) {
            if (cc) return `${cc}${ddd1}${mid1}${suf1}`;
            return `${ddd2}${mid2}${suf2}`;
        },
        display_mask (match, cc, ddd1, mid1, suf1, ddd2, mid2, suf2) {
            if (cc) return `+${cc} (${ddd1}) ${mid1}-${suf1}`;
            return `(${ddd2}) ${mid2}-${suf2}`;
        }
    };
}



var $6Jl4s = parcelRequire("6Jl4s");

var $YermW = parcelRequire("YermW");

var $3OKkn = parcelRequire("3OKkn");
function $1fc4b4ad289a0aae$export$2e2bcd8739ae039(...args) {
    const lengths = Array.isArray(args[0]) ? args[0] : args.filter(Number.isInteger);
    const pattern = lengths.length > 1 ? lengths.map((n)=>`[A-NP-Z0-9]{${n}}`).join('|') : `[A-NP-Z0-9]{${lengths[0] || args[0]}}`;
    return {
        type: 'sku',
        regex: new RegExp(`^(${pattern})$`),
        filter: /[]/g
    };
}



var $knytZ = parcelRequire("knytZ");

var $bSPRN = parcelRequire("bSPRN");

var $6lTH5 = parcelRequire("6lTH5");
/**
 * Observer: ao sair do campo CEP (blur), consulta ViaCEP (base dos Correios)
 * e preenche logradouro, bairro, UF e município. O município é resolvido
 * via IndexedDB ou API quando não houver cache local.
 */ 
var $1cmSR = parcelRequire("1cmSR");

var $9VcS9 = parcelRequire("9VcS9");

var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");
const $b99c2345a91aed9b$var$VIACEP_URL = 'https://viacep.com.br/ws';
function $b99c2345a91aed9b$export$2e2bcd8739ae039() {
    return {
        events: [
            'blur'
        ],
        async handleEvents (ev) {
            if (ev.type !== 'blur') return;
            const node = document.querySelector(this.selector);
            if (!node?.form) return;
            const cep = (node.value || '').replace(/\D/g, '');
            if (cep.length !== 8) return;
            const m = this.selector?.match(/#(\w+)_zipcode$/);
            const pre = m ? m[1] : 'address';
            const streetEl = node.form.querySelector(`#${pre}_street`);
            const districtEl = node.form.querySelector(`#${pre}_district`);
            const stateEl = node.form.querySelector(`#${pre}_state`);
            const cityEl = node.form.querySelector(`#${pre}_city_id`);
            try {
                const res = await fetch(`${$b99c2345a91aed9b$var$VIACEP_URL}/${cep}/json/`);
                const data = await res.json();
                if (data?.erro) {
                    (0, $jUNyh.notify)("CEP n\xe3o encontrado na base dos Correios.", 'Consulta CEP');
                    return;
                }
                if (streetEl) streetEl.value = data.logradouro || '';
                if (districtEl) districtEl.value = data.bairro || '';
                if (stateEl) {
                    stateEl.value = data.uf || '';
                    stateEl.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
                if (cityEl && data.localidade && data.uf) await $b99c2345a91aed9b$var$_resolveAndSetCity(this.form, cityEl, data.localidade, data.uf, pre);
                // blur padrão do Field não roda (este tipo substitui handleEvents); grava o CEP
                const zf = this.form?.getFieldBySelector(this.selector);
                if (zf) {
                    zf.setValue(cep);
                    zf.refresh();
                }
            } catch (_) {}
        }
    };
}
async function $b99c2345a91aed9b$var$_resolveAndSetCity(form, cityEl, cityName, uf, prefix) {
    if (!form || !cityEl) return;
    const u = String(uf || '').trim().toUpperCase().slice(0, 2);
    // Alinhado a resolveCityId (companies.js) — compara município sem acentos.
    const norm = (s)=>String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const target = norm(cityName);
    let cities = await (0, $1cmSR.default).list('cities', IDBKeyRange.bound([
        u,
        ''
    ], [
        u,
        '\uffff'
    ]), 2).catch(()=>[]);
    if (!cities?.length && u.length >= 2) {
        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, `?filter=state*eq*${encodeURIComponent(u)}&limit=500`);
        cities = Array.isArray(data) ? data : [];
    }
    const city = (cities || []).find((c)=>norm(c?.city) === target);
    if (city) {
        // Préenche a lista e o texto (padrão carriers/customers: campo `name` + obs_load_cities, não id no input).
        (0, $h1m6J.loadOptions)(`#${prefix}_city_id`, cities, 'id', [
            'city'
        ]);
        const cityField = form.getFieldBySelector?.(`#${prefix}_city_id`);
        if (cityField) {
            cityField.setValue(city.city);
            cityField.refresh?.();
        } else if (cityEl) cityEl.value = city.city;
    } else if (cityName) cityEl.value = cityName;
}



var $h1m6J = parcelRequire("h1m6J");

var $1cmSR = parcelRequire("1cmSR");

var $dZ5S0 = parcelRequire("dZ5S0");
/** CFOPs do cadastro: Entrada → 1/2/3xxx; Saída e Ativo → 5/6/7xxx. */ function $f361d28f145f8e93$var$cfopMatchesIoType(code, ioType) {
    const s = String(code || '').trim();
    if (s.length < 1) return false;
    const f = s[0];
    if (ioType === 'I') return f === '1' || f === '2' || f === '3';
    if (ioType === 'O' || ioType === 'A') return f === '5' || f === '6' || f === '7';
    return true;
}
function $f361d28f145f8e93$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        captureEvents (_this = this) {
            this.hook();
            this.safeProtoCall(_this);
        },
        hook () {
            [
                'company_id',
                'io_type'
            ].forEach((name)=>{
                const id = this.makeId(name);
                const field = this.locate(id);
                if (!field) throw new Error(`obs_cfops_invoice: campo n\xe3o encontrado: ${id}`);
                field.subscribe([
                    'change'
                ], this.actions.bind(this), false);
            });
        },
        makeId (name) {
            const parts = this.getIdParts();
            const form = parts[1];
            const index = parts[3];
            if (name.match((0, $dZ5S0.REGEX)) && index) name = (0, $dZ5S0.replaceIndex)(name, index.substr(1));
            return form + name;
        },
        getIdParts () {
            return this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
        },
        async preventMultiCalls (object, primary_callback, secondary_callback) {
            const listAttr = document.querySelector(this.selector)?.getAttribute('list');
            const is_datalist_indexed = Boolean(listAttr && (0, $dZ5S0.REGEX).test(listAttr));
            const is_action_ongoing = Boolean(object._this);
            if (!is_datalist_indexed && is_action_ongoing) object._this.subscribe([
                'done'
            ], secondary_callback);
            else {
                object._this = this;
                await primary_callback();
                if (!is_datalist_indexed) object._this.publish('done');
                object._this = null;
            }
        },
        async actions () {
            const run = async ()=>{
                let cid = this.locate('company_id')?.getValue?.();
                if (typeof cid === 'string' && /^\d+$/.test(cid)) cid = Number(cid);
                const io = this.locate('io_type')?.getValue?.() || 'O';
                if (!cid) {
                    (0, $h1m6J.loadOptions)(this.selector, [], 'code', [
                        'code',
                        'description'
                    ], ': ');
                    this.refresh();
                    return;
                }
                const range = IDBKeyRange.bound([
                    cid,
                    ''
                ], [
                    cid,
                    '\uffff'
                ]);
                let data = await (0, $1cmSR.default).list('cfops', range, 2);
                data = (data || []).filter((r)=>!r.is_disabled);
                data = data.filter((r)=>$f361d28f145f8e93$var$cfopMatchesIoType(r.code, io));
                (0, $h1m6J.loadOptions)(this.selector, data, 'code', [
                    'code',
                    'description'
                ], ': ');
                this.refresh();
            };
            await this.preventMultiCalls(SHARED, run, ()=>this.refresh());
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
function $89a9d177dbffd6c2$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, customer_id) {
            if (!this.isEmpty()) return;
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !customer_id || customer_id < 0) return;
            let customer = await (0, $1cmSR.default).get('customers', [
                company_id,
                Number(customer_id)
            ]);
            if (!customer || !customer['price_list_id']) return;
            let price_list = await (0, $1cmSR.default).get('price_lists', [
                company_id,
                customer['price_list_id']
            ]);
            if (!price_list || !price_list['discount']) return;
            this.setValue(price_list['discount']);
            this.refresh();
        }
    };
}



var $badq7 = parcelRequire("badq7");
/**
 * Ao digitar no campo município, refaz a busca com q= (aceita sem acento: julio = júlio).
 * Requer obs_load_cities e observer(stateField). stateField = 'billing_address_state' ou 'delivery_address_state'.
 */ 
var $h1m6J = parcelRequire("h1m6J");
/**
 * Carrega cidades da API quando o campo UF (state) muda.
 * Aceita parâmetro q para busca sem acentos (julio = júlio).
 * Uso: types.observer('billing_address_state'), types.obs_load_cities() e types.obs_filter_cities(stateField).
 */ 
var $h1m6J = parcelRequire("h1m6J");

var $9VcS9 = parcelRequire("9VcS9");
const $e0cb16d31f76baa7$var$CITIES_CACHE = {};
function $e0cb16d31f76baa7$export$8723790a11912be0(uf, q) {
    const u = String(uf || '').trim().toUpperCase().slice(0, 2);
    if (!u || u.length < 2) return Promise.resolve([]);
    let query = `?filter=state*eq*${encodeURIComponent(u)}&limit=500`;
    if (q && String(q).trim()) query += `&q=${encodeURIComponent(String(q).trim())}`;
    return (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, query).then((d)=>Array.isArray(d) ? d : []);
}
function $e0cb16d31f76baa7$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        async actions (ev, publisher, state) {
            const action = async (uf)=>{
                const u = String(uf || '').trim().toUpperCase().slice(0, 2);
                if (!u || u.length < 2) {
                    (0, $h1m6J.loadOptions)(this.selector, [], 'id', [
                        'city'
                    ]);
                    this.refresh?.();
                    return;
                }
                const data = await $e0cb16d31f76baa7$export$8723790a11912be0(u, '');
                (0, $h1m6J.loadOptions)(this.selector, data, 'id', [
                    'city'
                ]);
                this.refresh?.();
            };
            const uf = String(state ?? '').trim().toUpperCase().slice(0, 2);
            if (uf.length >= 2) this.preventMultiCalls(SHARED, action, ()=>this.refresh?.(), uf);
            else action(uf);
        }
    };
}


let $201d7a75379b20b7$var$debounceTimer = null;
const $201d7a75379b20b7$var$DEBOUNCE_MS = 200;
function $201d7a75379b20b7$export$2e2bcd8739ae039(stateField) {
    return {
        _source: stateField,
        events: [
            'input'
        ],
        handleEvents (ev) {
            if (ev.type !== 'input') return;
            const node = document.querySelector(this.selector);
            if (!node?.form) return;
            const stateEl = node.form.querySelector(`#${stateField}`);
            const uf = stateEl?.value ? String(stateEl.value).trim().toUpperCase().slice(0, 2) : '';
            const q = (node.value || '').trim();
            clearTimeout($201d7a75379b20b7$var$debounceTimer);
            $201d7a75379b20b7$var$debounceTimer = setTimeout(async ()=>{
                const data = await (0, $e0cb16d31f76baa7$export$8723790a11912be0)(uf, q);
                (0, $h1m6J.loadOptions)(this.selector, data, 'id', [
                    'city'
                ]);
                // Não chamar refresh() quando o valor atual já é um city_id (7 dígitos): evita apagar a seleção que o usuário acabou de fazer
                const currentVal = (node.value || '').trim();
                if (!/^\d{7}$/.test(currentVal)) this.refresh?.();
            }, $201d7a75379b20b7$var$DEBOUNCE_MS);
        }
    };
}




var $dg8P2 = parcelRequire("dg8P2");

var $9VcS9 = parcelRequire("9VcS9");

var $h1m6J = parcelRequire("h1m6J");
function $de971e0b3c51812e$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        async actions (ev, publisher, key) {
            const action = async ()=>{
                const company_id = this.locate('company_id')?.getValue();
                const product_id = key != null && key !== '' && !isNaN(key) ? Number(key) : null;
                this.setValue('');
                this.refresh();
                const gtinField = this.locate(this.makeId('packaging_gtin-0'));
                if (gtinField) {
                    gtinField.setValue('');
                    gtinField.refresh();
                }
                if (!company_id || product_id == null || isNaN(product_id) || product_id < 0) {
                    (0, $h1m6J.loadOptions)(this.selector, [], 'id', [
                        'code',
                        'factor'
                    ], " \xb7 ");
                    this.refresh();
                    return;
                }
                const list = await (0, $9VcS9.default).call((0, $9VcS9.default).list_product_packagings_by_product, company_id, product_id);
                const opts = Array.isArray(list) ? list : [];
                (0, $h1m6J.loadOptions)(this.selector, opts, 'id', [
                    'sku',
                    'code',
                    'factor',
                    'gtin'
                ], " \xb7 ");
                this.refresh();
            };
            await this.preventMultiCalls(SHARED, action, ()=>this.refresh(), []);
        }
    };
}



var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $dZ5S0 = parcelRequire("dZ5S0");
function $78c0baa046d6948e$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        captureEvents (_this = this) {
            this.safeProtoCall(_this);
            this.subscribe([
                'change'
            ], this._onPackagingGtinChange.bind(this), false);
        },
        async preventMultiCalls (object, primary_callback, secondary_callback, ...args) {
            const el = document.querySelector(this.selector);
            const is_datalist_indexed = el && (0, $dZ5S0.REGEX).test(el.getAttribute('list') || '');
            const is_action_ongoing = Boolean(object._this);
            if (!is_datalist_indexed && is_action_ongoing) object._this.subscribe([
                'done'
            ], secondary_callback);
            else {
                object._this = this;
                await primary_callback(...args);
                if (!is_datalist_indexed) object._this.publish('done', ...args);
                object._this = null;
            }
        },
        async _onPackagingGtinChange (_event_name, _publisher, value) {
            const action = async ()=>{
                const raw = (value != null && value !== '' ? String(value) : this.getValue() || '').trim();
                if (!raw) return;
                const company_id = this.locate('company_id')?.getValue();
                if (!company_id) return;
                const pack = await (0, $9VcS9.default).call((0, $9VcS9.default).resolve_packaging_gtin, company_id, raw);
                if (!pack) return;
                const prodSel = this.makeId('product_id-0');
                const pidField = this.locate(prodSel);
                const cur = pidField?.getValue();
                if (cur != null && cur !== '' && Number(cur) !== Number(pack.product_id)) {
                    (0, $jUNyh.notify)("Este GTIN pertence a outro produto. Ajuste o produto ou o c\xf3digo bipado.", "Confer\xeancia");
                    return;
                }
                if (pidField && (cur == null || cur === '')) {
                    pidField.setValue(pack.product_id);
                    pidField.refresh();
                }
                const ppack = this.locate(this.makeId('product_packaging_id-0'));
                if (ppack) {
                    ppack.setValue(pack.id);
                    ppack.refresh();
                }
            };
            await this.preventMultiCalls(SHARED, action, ()=>this.refresh(), []);
        },
        makeId (name) {
            const parts = this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
            const form = parts[1];
            const index = parts[3];
            if (name.match((0, $dZ5S0.REGEX))) name = (0, $dZ5S0.replaceIndex)(name, index.substr(1));
            return form + name;
        }
    };
}


/**
 * Observer: ao sair do campo de validade (blur), alerta se a data estiver vencida.
 * Usado na Conferência de Entrada (inputs-inventory).
 */ 
var $jUNyh = parcelRequire("jUNyh");
/** Interpreta yyyy-mm-dd, dd-mm-yyyy ou dd/mm/yyyy como data local. */ function $06588da92ceea853$var$parseLocalDate(value) {
    if (value == null || value === '') return null;
    const s = String(value).trim();
    let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    m = s.match(/^(\d{2})-(\d{2})-(\d{4})/);
    if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    return null;
}
function $06588da92ceea853$var$todayLocal() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
function $06588da92ceea853$var$formatBr(d) {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
}
function $06588da92ceea853$var$paintExpired(node, expired) {
    if (!node) return;
    if (expired) {
        node.style.borderColor = '#c00';
        node.style.backgroundColor = '#fff5f5';
    } else {
        node.style.removeProperty('border-color');
        node.style.removeProperty('background-color');
    }
}
function $06588da92ceea853$export$2e2bcd8739ae039() {
    return {
        events: [
            'blur'
        ],
        async handleEvents (ev) {
            if (ev.type !== 'blur') return;
            const node = document.querySelector(this.selector);
            if (!node) return;
            const field = this.form?.getFieldBySelector?.(this.selector);
            if (field) {
                field.setValue(node.value);
                field.refresh?.();
            }
            const raw = field?.getValue?.() ?? node.value;
            const exp = $06588da92ceea853$var$parseLocalDate(raw);
            if (!exp) {
                $06588da92ceea853$var$paintExpired(node, false);
                return;
            }
            const expired = exp < $06588da92ceea853$var$todayLocal();
            $06588da92ceea853$var$paintExpired(node, expired);
            if (expired) (0, $jUNyh.notify)(`Aten\xe7\xe3o: a data de validade informada (${$06588da92ceea853$var$formatBr(exp)}) est\xe1 vencida. Confira o produto antes de continuar a confer\xeancia.`, "Confer\xeancia de Entrada");
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
function $d799b5dade42e782$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, lot_id) {
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !lot_id || lot_id < 0) return;
            let lot = await (0, $1cmSR.default).get('lots', [
                company_id,
                Number(lot_id)
            ], 1);
            if (!lot) return;
            if (this.isEmpty()) {
                this.setValue(lot.lot_number);
                this.refresh();
            }
            let product = await (0, $1cmSR.default).get('products', [
                company_id,
                lot.product_id
            ]);
            if (!product) return;
            let sku = this.locate(this.makeId('sku-0'));
            if (sku.isEmpty()) {
                sku.setValue(product.sku.join(''));
                sku.refresh();
            }
            let productName = this.locate(this.makeId('product_name-0'));
            if (productName && productName.isEmpty()) {
                productName.setValue(product.name || '');
                productName.refresh();
            }
            let expiration = this.locate(this.makeId('expiration_date-0'));
            if (expiration && expiration.isEmpty() && lot.expiration_date) {
                const ed = String(lot.expiration_date);
                expiration.setValue(ed.length >= 10 ? ed.slice(0, 10) : ed);
                expiration.refresh();
            }
        }
    };
}



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");
function $57e664762d8187e6$export$2e2bcd8739ae039() {
    return {
        _userTouched: false,
        init () {
            const el = document.querySelector(this.selector);
            el?.addEventListener('input', ()=>{
                this._userTouched = true;
            });
            el?.addEventListener('change', ()=>{
                this._userTouched = true;
            });
        },
        resetAuto () {
            this._userTouched = false;
        },
        async syncFromCustomer (customer_id) {
            try {
                await this.setFromCustomer(customer_id);
            } catch  {
            // Campo opcional: falha de cache/API não deve bloquear edição manual do pedido.
            }
        },
        async actions (ev, publisher, value) {
            if (publisher.selector === '#customer_id') {
                this._userTouched = false;
                await this.setFromCustomer(value);
            }
        },
        async setFromCustomer (customer_id) {
            if (this._userTouched) return;
            const company_id = this.locate?.('company_id')?.getValue?.();
            if (!company_id || !customer_id) return;
            let customer = await (0, $1cmSR.default).get('customers', [
                company_id,
                Number(customer_id)
            ]).catch(()=>null);
            if (!customer || customer.payment_method === undefined) {
                customer = await (0, $9VcS9.default).call((0, $9VcS9.default).select_customer, company_id, Number(customer_id));
                if (customer) await (0, $1cmSR.default).set('customers', [
                    customer
                ]).catch(()=>{});
            }
            if (!customer) return;
            const payment_method = customer.payment_method || '';
            if (payment_method) {
                this.setValue?.(payment_method);
                this.refresh?.();
            }
        }
    };
}


/**
 * Espelha o valor (id) entre dois campos datalist do mesmo cliente.
 * Uso: em `#customer_id` → obs_sync_customer_peer('customer_nick')
 *      em `#customer_nick` → obs_sync_customer_peer('customer_id')
 *
 * - hookPeer adiado (peer pode não estar registrado ainda no pubsub).
 * - Limpar um campo NÃO apaga o outro (evita perder Cliente ao apagar Apelido para rebuscar).
 */ function $b4ac3fdf5db60328$export$2e2bcd8739ae039(peerFieldName) {
    const SHARED = {
        syncing: false
    };
    const normId = (v)=>{
        if (v == null || v === '' || v === -1 || v === '-1') return null;
        const n = Number(v);
        return Number.isFinite(n) && n >= 0 ? n : null;
    };
    return {
        _peer: peerFieldName,
        _peerHooked: false,
        captureEvents (_this = this) {
            queueMicrotask(()=>this.ensurePeerHooked());
            this.safeProtoCall(_this);
        },
        ensurePeerHooked (attempt = 0) {
            if (this._peerHooked) return;
            const peer = this.locate(this._peer);
            if (!peer) {
                if (attempt < 20) setTimeout(()=>this.ensurePeerHooked(attempt + 1), 0);
                else console.error(`obs_sync_customer_peer: peer n\xe3o encontrado: ${this._peer}`);
                return;
            }
            peer.subscribe([
                'change'
            ], this.onPeerChange.bind(this), false);
            this._peerHooked = true;
        },
        onPeerChange (_ev, _publisher, value) {
            if (SHARED.syncing) return;
            const next = normId(value);
            // Limpeza do peer: não espelhar (usuário pode estar limpando para buscar de novo)
            if (next == null) return;
            const cur = normId(this.getValue?.());
            if (cur === next) return;
            SHARED.syncing = true;
            try {
                this.setValue(next);
                this.refresh?.();
            } finally{
                SHARED.syncing = false;
            }
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");

var $1cmSR = parcelRequire("1cmSR");
function $a3bd40443322c074$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    };
    return {
        _customerIsLocal: false,
        isRequired () {
            const pm = this.locate?.('payment_method')?.getValue?.();
            if (pm === '90' || pm === 90) return false; // Sem Pagamento → Condição opcional
            if (this._customerIsLocal) return false; // Cliente tipo Local (entrega) → Condição opcional
            return document.querySelector(this.selector)?.hasAttribute('required') ?? true;
        },
        async actions (ev, publisher, value) {
            switch(publisher.selector){
                case '#company_id':
                    await this.loadPaymentTerms(value);
                    break;
                case '#customer_id':
                    await this.setPaymentTerm(value);
                    break;
            }
        },
        async loadPaymentTerms (company_id) {
            const action = async (company_id)=>{
                let payment_terms = await (0, $1cmSR.default).list('payment_terms', IDBKeyRange.bound([
                    company_id,
                    ''
                ], [
                    company_id,
                    '\uffff'
                ]));
                (0, $h1m6J.loadOptions)(this.selector, payment_terms, 'id', [
                    'name'
                ]);
                this.refresh();
            };
            if (typeof company_id == 'string') this.preventMultiCalls(SHARED, action, ()=>this.refresh(), company_id);
        },
        async setPaymentTerm (customer_id) {
            let company_id = this.locate('company_id')?.getValue?.();
            const el = document.querySelector(this.selector);
            if (!company_id || company_id < 0 || !customer_id || customer_id === '' || customer_id < 0) {
                this._customerIsLocal = false;
                if (el) {
                    el.removeAttribute('readonly');
                    el.setAttribute('required', '');
                }
                return;
            }
            let customer = await (0, $1cmSR.default).get('customers', [
                company_id,
                Number(customer_id)
            ]);
            const isLocal = customer?.type === 'L' || customer?.type?.toUpperCase?.() === 'L';
            if (isLocal) {
                this._customerIsLocal = true;
                this.setValue?.('');
                this.refresh?.();
                this.locate?.('payment_method')?.setValue?.('90');
                this.locate?.('payment_method')?.refresh?.();
                if (el) {
                    el.setAttribute('readonly', '');
                    el.removeAttribute('required');
                }
                this.checkErrorState?.();
                return;
            }
            this._customerIsLocal = false;
            if (el) {
                el.removeAttribute('readonly');
                el.setAttribute('required', '');
            }
            // Sempre preenche com o valor do cadastro do cliente (permite alterar manualmente depois)
            if (customer?.payment_term_id != null && customer.payment_term_id !== '') {
                this.setValue(customer.payment_term_id);
                this.refresh();
            }
            this.checkErrorState?.();
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");

var $9VcS9 = parcelRequire("9VcS9");
function $72c559d121507028$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, value) {
            let company_id = this.locate('company_id')?.getValue?.();
            let customer_id = this.locate('customer_id')?.getValue?.();
            let product_id = this.locate(this.makeId('product_id-0'))?.getValue?.();
            // Só usa value como product_id quando a mudança veio do campo produto (evita usar customer_id em linhas vazias)
            const isProductChange = publisher && String(publisher.selector || '').includes('product_id');
            if (!product_id && isProductChange && value != null && !isNaN(Number(value)) && Number(value) >= 0) product_id = value;
            product_id = Number(product_id);
            if (!company_id || !customer_id || !product_id || product_id <= 0) return;
            // Resolve customer_id (pode ser id numérico ou label)
            let cid = Number(customer_id);
            if (isNaN(cid) || cid < 0) {
                let custField = this.locate('customer_id');
                let node = custField ? document.querySelector(custField.selector) : null;
                let opt = node?.list ? Array.from(node.list.options || []).find((o)=>o.innerText?.trim() === String(customer_id).trim() || o.value == customer_id) : null;
                cid = opt ? Number(opt.value) : -1;
            }
            if (isNaN(cid) || cid < 0) return;
            customer_id = cid;
            // 1) Tabela de preço por cliente (customer_prices)
            let unit_price = null;
            let discount = null;
            try {
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).customer_price_get, company_id, customer_id, product_id);
                if (resp && typeof resp.unit_price === 'number') {
                    unit_price = resp.unit_price;
                    if (resp.discount != null && !isNaN(Number(resp.discount))) discount = Number(resp.discount);
                }
            } catch (_) {}
            // 2) Fallback: lista de preço do cliente (price_list_id)
            if (unit_price == null) {
                let customer = await (0, $1cmSR.default).get('customers', [
                    company_id,
                    customer_id
                ]);
                if (!customer || !customer['price_list_id']) return;
                let price_list = await (0, $1cmSR.default).get('price_lists', [
                    company_id,
                    customer['price_list_id']
                ]);
                if (!price_list || !price_list.prices) return;
                let price = price_list.prices.find((p)=>p.product_id == product_id);
                if (!price) return;
                unit_price = price.unit_price;
                if (price.discount != null) discount = Number(price.discount);
            }
            if (unit_price != null) {
                this.setValue(unit_price);
                this.refresh();
                let discountField = this.locate(this.makeId('discount-0'));
                if (discount != null && discountField) {
                    discountField.setValue(discount);
                    discountField.refresh();
                }
            }
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");

function $e247330830b80775$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, category_id) {
            let company_id = this.locate('company_id').getValue();
            const catId = category_id != null && category_id !== '' ? Number(category_id) : null;
            if (!company_id || company_id === '' || catId == null || catId < 0) return;
            let category = await (0, $1cmSR.default).get('categories', [
                company_id,
                catId
            ], 1);
            if (!category || !category.attributes) return;
            const attr = category.attributes[0];
            const lengths = attr.lengths && attr.lengths.length ? attr.lengths : [
                attr.length
            ];
            this.form.fields[this.getId()].releaseEvents();
            this.form.fields[this.getId()] = (this?.type == 'sku' ? this.scrapeTypes(1) : this).appendType($1fc4b4ad289a0aae$export$2e2bcd8739ae039(lengths));
            this.form.fields[this.getId()].captureEvents();
            this.form.fields[this.getId()].refresh();
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
const $e270bdf959c5d325$var$clearRow = function(row) {
    row.querySelectorAll('TD').forEach((column)=>column.parentNode.removeChild(column));
// Precisa destruir eventuais campos que existam no form também
};
const $e270bdf959c5d325$var$appendColumn = function(row, properties) {
    let td = document.createElement('TD');
    let input = document.createElement('INPUT');
    Object.keys(properties).forEach((key)=>{
        if (key == 'required' && properties[key]) input.setAttribute(key, '');
        else input[key] = properties[key];
    });
    td.appendChild(input);
    row.appendChild(td);
// Precisa criar um campo no form também e vincular ao id do elemento criado
// Atribuir algum tipo ao campo criado?
};
function $e270bdf959c5d325$export$2e2bcd8739ae039(...args) {
    return {
        async actions (ev, publisher, category_id) {
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !category_id || category_id < 0) return;
            let category = await (0, $1cmSR.default).get('categories', [
                company_id,
                Number(category_id)
            ], 1);
            if (!category || !category.attributes) return;
            let sku = document.querySelector(`${args[0]} TR`);
            let taxons = document.querySelector(`${args[1]} TR`);
            if (!sku || !taxons) return;
            $e270bdf959c5d325$var$clearRow(sku);
            $e270bdf959c5d325$var$clearRow(taxons);
            category.attributes.forEach((attribute, index)=>{
                $e270bdf959c5d325$var$appendColumn(sku, {
                    id: args[0].slice(1),
                    type: 'text',
                    size: attribute.length,
                    title: attribute.name,
                    required: !attribute.is_optional
                });
                $e270bdf959c5d325$var$appendColumn(taxons, {
                    id: args[1].slice(1),
                    type: 'text',
                    size: 1,
                    title: attribute.name,
                    required: !attribute.is_optional
                });
            //appendColumn(sku, { id: `${args[0].slice(1)}${index}`, type: 'text', size: attribute.length, title: attribute.name, required: !attribute.is_optional });
            //appendColumn(taxons, { id: `${args[1].slice(1)}${index}`, type: 'text', size: 1, title: attribute.name, required: !attribute.is_optional });
            });
        /*
			if (this.isEmpty())
			{
				this.setValue(lot.lot_number);
				this.refresh();
			}
			let product = await db.get('products', [company_id, lot.product_id]);
			if (!product)
				return;
			let sku = this.locate(this.makeId('sku-0'));
			if (sku.isEmpty())
			{
				sku.setValue(product.sku.join(''));
				sku.refresh();
			}
			*/ }
    };
}


/** Aceita tamanho único (ex: 6) ou múltiplos separados por vírgula (ex: 5,6,10) ou range (ex: 1-12). */ function $6f5d856b9353a912$export$2e2bcd8739ae039() {
    return {
        regex: /^(\d+)([\s,]\s*\d+)*$|^(\d+)\s*-\s*(\d+)$/,
        filter: /[\s]/g,
        store_mask: '$&',
        display_mask: '$&'
    };
}



var $9VcS9 = parcelRequire("9VcS9");
function $d0e5a3fdd77559d6$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    };
    return {
        async actions (ev, publisher, product_id) {
            let node = document.querySelector(this.selector);
            if (!node) return;
            node.setAttribute('placeholder', '');
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !product_id || product_id < 0) return;
            let stocks = await (0, $9VcS9.default).call((0, $9VcS9.default).list_stocks_by_product, company_id, product_id);
            if (!stocks) return;
            let quantity = stocks.reduce((accumulator, entry)=>accumulator + entry.quantity_available, 0);
            node.setAttribute('placeholder', quantity);
        }
    };
}



var $1cmSR = parcelRequire("1cmSR");
/**
 * Tipo de armazenamento no Pedido de Saída (#MT-3902248 / #MT-2F9C150).
 * Refrigerado = flag do produto; Climatizado só com flag explícito falso.
 * Sem produto/flag → vazio (não chutar Climatizado).
 */ /**
 * @param {*} value
 * @returns {boolean|null}
 */ function $bcb7609f0745f2d2$export$37b8590edbca8087(value) {
    if (value === true || value === 1) return true;
    if (value === false || value === 0) return false;
    if (value == null) return null;
    const t = String(value).trim().toLowerCase();
    if (!t) return null;
    if ([
        '1',
        'true',
        't',
        'yes',
        'sim'
    ].includes(t)) return true;
    if ([
        '0',
        'false',
        'f',
        'no',
        'nao',
        "n\xe3o"
    ].includes(t)) return false;
    return null;
}
function $bcb7609f0745f2d2$export$5781af1c3b8a3b6d(product) {
    if (!product || typeof product !== 'object') return null;
    if (!Object.prototype.hasOwnProperty.call(product, 'is_refrigerated')) return null;
    const flag = $bcb7609f0745f2d2$export$37b8590edbca8087(product.is_refrigerated);
    if (flag === true) return 'REFRIGERADO';
    if (flag === false) return 'CLIMATIZADO';
    return null;
}
function $bcb7609f0745f2d2$export$cbad4626cc6dc3d7(item, cachedProduct) {
    if (item && Object.prototype.hasOwnProperty.call(item, 'is_refrigerated') && item.is_refrigerated != null && item.is_refrigerated !== '') {
        const fromItem = $bcb7609f0745f2d2$export$5781af1c3b8a3b6d({
            is_refrigerated: item.is_refrigerated
        });
        if (fromItem) return fromItem;
    }
    return $bcb7609f0745f2d2$export$5781af1c3b8a3b6d(cachedProduct || null);
}
function $bcb7609f0745f2d2$export$e1bcf84451644ca1(code) {
    if (code === 'REFRIGERADO') return 'Refrigerado';
    if (code === 'CLIMATIZADO') return 'Climatizado';
    return '';
}
function $bcb7609f0745f2d2$export$15475d993d93294a(label) {
    const t = String(label || '').trim().toUpperCase();
    if (t === 'REFRIGERADO') return 'REFRIGERADO';
    if (t === 'CLIMATIZADO') return 'CLIMATIZADO';
    return null;
}
function $bcb7609f0745f2d2$export$8157a3e9e1e7c816(codes) {
    let hasRef = false;
    let hasClim = false;
    for (const code of codes || []){
        if (code === 'REFRIGERADO') hasRef = true;
        else if (code === 'CLIMATIZADO') hasClim = true;
        if (hasRef && hasClim) return true;
    }
    return false;
}
function $bcb7609f0745f2d2$export$664750508e555d0a(lines) {
    const codes = [];
    for (const line of lines || []){
        const rawQty = line?.quantity;
        const qty = Number(typeof rawQty === 'string' ? String(rawQty).replace(/\./g, '').replace(',', '.') : rawQty);
        if (!(qty > 0)) continue;
        const code = $bcb7609f0745f2d2$export$15475d993d93294a(line?.storage_arm ?? line?.arm);
        if (code) codes.push(code);
    }
    return codes;
}
function $bcb7609f0745f2d2$export$caf618b7f12558f4(items, productsById) {
    const get = (pid)=>{
        if (!productsById) return null;
        if (typeof productsById.get === 'function') return productsById.get(pid);
        return productsById[pid] ?? productsById[String(pid)] ?? null;
    };
    const codes = [];
    for (const item of items || []){
        const pid = Number(item?.product_id);
        const qty = Number(item?.quantity);
        if (!Number.isInteger(pid) || pid <= 0 || !(qty > 0)) continue;
        const code = $bcb7609f0745f2d2$export$cbad4626cc6dc3d7(item, get(pid));
        if (code) codes.push(code);
    }
    return $bcb7609f0745f2d2$export$8157a3e9e1e7c816(codes);
}
const $bcb7609f0745f2d2$export$acb8caa4174e5384 = "Aten\xe7\xe3o: este pedido mistura itens Climatizados e Refrigerados. Separe em pedidos distintos antes de gerar a sa\xedda, ou confirme o salvamento ciente da mistura.";



var $1cmSR = parcelRequire("1cmSR");

function $c9644a701d51e702$var$_parseSialNum(s) {
    const c = String(s ?? '').replace(/\./g, '').replace(',', '.');
    const n = parseFloat(c);
    return isFinite(n) ? n : 0;
}
function $c9644a701d51e702$var$_resolveCompanyId(root) {
    const el = root?.querySelector?.('#company_id');
    const raw = el?.value ?? '';
    const v = String(raw || '').trim();
    if (/^[0-9a-f-]{36}$/i.test(v)) return v;
    const data = el?.getAttribute?.('data-value');
    if (data && /^[0-9a-f-]{36}$/i.test(String(data).trim())) return String(data).trim();
    return v || null;
}
function $c9644a701d51e702$var$_resolveProductIdFromField(prodEl) {
    if (!prodEl) return null;
    const data = prodEl.getAttribute?.('data-value');
    if (data != null && String(data).trim() !== '') {
        const n = Number(String(data).trim());
        if (Number.isInteger(n) && n > 0) return n;
    }
    const raw = String(prodEl.value || '').trim();
    if (!raw) return null;
    if (/^\d+$/.test(raw)) return Number(raw);
    return null;
}
function $c9644a701d51e702$var$_applyArmCellStyle(armEl, code) {
    if (!armEl) return;
    armEl.classList.remove('oo-arm--clim', 'oo-arm--refrig');
    const td = armEl.closest('td');
    td?.classList.remove('oo-arm--clim', 'oo-arm--refrig');
    if (code === 'REFRIGERADO') {
        armEl.classList.add('oo-arm--refrig');
        td?.classList.add('oo-arm--refrig');
    } else if (code === 'CLIMATIZADO') {
        armEl.classList.add('oo-arm--clim');
        td?.classList.add('oo-arm--clim');
    }
}
function $c9644a701d51e702$export$40834e92d4d6cd46(root) {
    if (!root) return;
    const banner = root.querySelector('#oo-storage-arm-banner');
    const lines = [];
    const tbody = root.querySelector('.sial-items-scroll tbody');
    if (tbody) for (const row of tbody.querySelectorAll('tr.row')){
        const prodEl = row.querySelector('[id^="product_id-"]');
        if (!prodEl) continue;
        const n = (prodEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const armEl = row.querySelector(`#storage_arm-${n}`);
        const armVal = armEl?.value;
        const code = (0, $bcb7609f0745f2d2$export$15475d993d93294a)(armVal);
        $c9644a701d51e702$var$_applyArmCellStyle(armEl, code);
        const qty = $c9644a701d51e702$var$_parseSialNum(row.querySelector(`#quantity-${n}`)?.value);
        lines.push({
            quantity: qty,
            storage_arm: armVal
        });
        row.classList.toggle('oo-row--arm-mixed', false);
    }
    const codes = (0, $bcb7609f0745f2d2$export$664750508e555d0a)(lines);
    const mixed = (0, $bcb7609f0745f2d2$export$8157a3e9e1e7c816)(codes);
    if (tbody && mixed) for (const row of tbody.querySelectorAll('tr.row')){
        const prodEl = row.querySelector('[id^="product_id-"]');
        if (!prodEl) continue;
        const n = (prodEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const qty = $c9644a701d51e702$var$_parseSialNum(row.querySelector(`#quantity-${n}`)?.value);
        const code = (0, $bcb7609f0745f2d2$export$15475d993d93294a)(row.querySelector(`#storage_arm-${n}`)?.value);
        if (qty > 0 && code) row.classList.add('oo-row--arm-mixed');
    }
    if (!banner) return;
    if (!mixed) {
        banner.style.display = 'none';
        banner.textContent = '';
        banner.classList.remove('oo-storage-arm-banner--warn');
        return;
    }
    banner.classList.add('oo-storage-arm-banner--warn');
    banner.style.display = 'block';
    banner.textContent = (0, $bcb7609f0745f2d2$export$acb8caa4174e5384);
}
async function $c9644a701d51e702$export$9852c4e2debabff(companyId, items) {
    if (!companyId || !Array.isArray(items)) return false;
    const map = new Map();
    for (const item of items){
        const pid = Number(item?.product_id);
        const qty = Number(item?.quantity);
        if (!Number.isInteger(pid) || pid <= 0 || !(qty > 0) || map.has(pid)) continue;
        let product = null;
        try {
            product = await (0, $1cmSR.default).get('products', [
                companyId,
                pid
            ]);
        } catch (_e) {
            product = null;
        }
        map.set(pid, product);
    }
    return (0, $bcb7609f0745f2d2$export$caf618b7f12558f4)(items, map);
}
async function $c9644a701d51e702$export$b71af1471a6ba137(root, companyIdOverride = null) {
    if (!root) return;
    const companyId = companyIdOverride || $c9644a701d51e702$var$_resolveCompanyId(root);
    const tbody = root.querySelector('.sial-items-scroll tbody');
    if (!tbody) return;
    for (const row of tbody.querySelectorAll('tr.row')){
        const prodEl = row.querySelector('[id^="product_id-"]');
        if (!prodEl) continue;
        const n = (prodEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const armEl = row.querySelector(`#storage_arm-${n}`);
        if (!armEl) continue;
        const pid = $c9644a701d51e702$var$_resolveProductIdFromField(prodEl);
        if (!companyId || !pid) {
            if (!String(armEl.value || '').trim()) armEl.value = '';
            continue;
        }
        // Recalcula Arm. pelo cache; se o produto ainda não chegou, não sobrescreve o valor da API (#MT-2F9C150)
        let product = null;
        try {
            product = await (0, $1cmSR.default).get('products', [
                companyId,
                pid
            ]);
        } catch (_e) {
            product = null;
        }
        const code = (0, $bcb7609f0745f2d2$export$5781af1c3b8a3b6d)(product);
        if (code) armEl.value = (0, $bcb7609f0745f2d2$export$e1bcf84451644ca1)(code);
        else if (!(0, $bcb7609f0745f2d2$export$15475d993d93294a)(armEl.value)) armEl.value = '';
    }
    $c9644a701d51e702$export$40834e92d4d6cd46(root);
}


function $1c37aa3595c00954$export$2e2bcd8739ae039(..._args) {
    return {
        async actions (_ev, _publisher, product_id) {
            const node = document.querySelector(this.selector);
            const formRoot = node?.closest?.('#order') || document.querySelector('#order');
            const company_id = this.locate('company_id')?.getValue?.();
            const pid = product_id != null && product_id !== '' ? Number(product_id) : NaN;
            if (!company_id || !Number.isInteger(pid) || pid <= 0) {
                this.setValue?.('');
                this.refresh?.();
                (0, $c9644a701d51e702$export$40834e92d4d6cd46)(formRoot);
                return;
            }
            let product = null;
            try {
                product = await (0, $1cmSR.default).get('products', [
                    company_id,
                    pid
                ]);
            } catch (_e) {
                product = null;
            }
            const label = (0, $bcb7609f0745f2d2$export$e1bcf84451644ca1)((0, $bcb7609f0745f2d2$export$5781af1c3b8a3b6d)(product));
            if (label) this.setValue(label);
            else if (!(0, $bcb7609f0745f2d2$export$15475d993d93294a)(this.getValue?.())) this.setValue('');
            this.refresh?.();
            (0, $c9644a701d51e702$export$40834e92d4d6cd46)(formRoot);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");

var $1cmSR = parcelRequire("1cmSR");
function $dfd6e369efbb1d4a$export$2e2bcd8739ae039(..._args) {
    return {
        async actions (_ev, _publisher, _value) {
            const company_id = this.locate('company_id')?.getValue?.();
            const listAttr = document.querySelector(this.selector)?.getAttribute('list') || 'products';
            const clear = ()=>{
                (0, $h1m6J.loadOptions)(`#${listAttr.replace(/^#/, '')}`, [], 'id', [
                    'sku',
                    'name'
                ]);
                this.refresh?.();
            };
            if (company_id == null || company_id === '' || company_id === -1) {
                clear();
                return;
            }
            let data = [];
            try {
                data = await (0, $1cmSR.default).list('products', IDBKeyRange.bound([
                    company_id,
                    ''
                ], [
                    company_id,
                    '\uffff'
                ]), 2) || [];
            } catch (_e) {
                data = [];
            }
            data = data.filter((r)=>!(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1'));
            const dl = listAttr.startsWith('#') ? listAttr : `#${listAttr}`;
            (0, $h1m6J.loadOptions)(dl, data, 'id', [
                'sku',
                'name'
            ]);
            this.refresh?.();
        }
    };
}



var $9VcS9 = parcelRequire("9VcS9");
function $fb0d8610497c39ce$export$be43077e64f2fdff(root) {
    if (!root) return;
    root.querySelectorAll('.sial-items-scroll tr.row').forEach((row)=>{
        const sitEl = row.querySelector('[id^="stock_situation-"]');
        const simEl = row.querySelector('[id^="simulated_available_quantity-"]');
        const sit = String(sitEl?.value || '').trim();
        const cls = sit === 'SALDO_SIMULADO_NEGATIVO' ? 'oo-sim-neg' : sit === 'ATENCAO' || sit === 'VENCIMENTO_CRITICO' ? 'oo-sim-warn' : '';
        row.querySelectorAll('td.oo-col-sim, td.oo-col-sit').forEach((td)=>{
            td.classList.remove('oo-sim-neg', 'oo-sim-warn');
            if (cls) td.classList.add(cls);
        });
        simEl && (simEl.value === '' || simEl.value == null) && sitEl && sit;
    });
}
function $fb0d8610497c39ce$var$_fmtQty(v) {
    if (v == null || v === '') return '';
    const n = Number(v);
    if (!isFinite(n)) return '';
    return String(n);
}
async function $fb0d8610497c39ce$export$523a405869d33195(root, opts = {}) {
    if (!root) return;
    const companyId = opts.companyId || root.querySelector?.('#company_id')?.getAttribute?.('data-value') || null;
    let programId = opts.programId;
    if (programId === undefined) {
        const raw = root.querySelector?.('#program_id')?.getAttribute?.('data-value') ?? root.querySelector?.('#program_id')?.value;
        const n = Number(raw);
        programId = Number.isInteger(n) && n > 0 ? n : null;
    }
    const tbody = root.querySelector('.sial-items-scroll tbody');
    if (!tbody || !companyId) return;
    const productIds = [];
    const rowMeta = [];
    tbody.querySelectorAll('tr.row').forEach((row)=>{
        const prodEl = row.querySelector('[id^="product_id-"]');
        if (!prodEl) return;
        const n = (prodEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const dataVal = prodEl.getAttribute('data-value');
        let pid = dataVal != null && String(dataVal).trim() !== '' ? Number(dataVal) : NaN;
        if (!Number.isInteger(pid) || pid <= 0) {
            const raw = String(prodEl.value || '').trim();
            if (/^\d+$/.test(raw)) pid = Number(raw);
        }
        if (!Number.isInteger(pid) || pid <= 0) return;
        productIds.push(pid);
        rowMeta.push({
            n: n,
            pid: pid
        });
    });
    const unique = [
        ...new Set(productIds)
    ];
    if (!unique.length) {
        rowMeta.forEach(({ n: n })=>{
            const pre = root.querySelector(`#pre_reserved_by_approved_orders-${n}`);
            const sim = root.querySelector(`#simulated_available_quantity-${n}`);
            const sit = root.querySelector(`#stock_situation-${n}`);
            if (pre) pre.value = '';
            if (sim) sim.value = '';
            if (sit) sit.value = '';
        });
        $fb0d8610497c39ce$export$be43077e64f2fdff(root);
        return;
    }
    let q = `?product_ids=${unique.join(',')}&include_zero_stock=1&per_page=${Math.max(100, unique.length)}`;
    if (programId != null) q += `&program_id=${programId}`;
    let avail = null;
    try {
        if (typeof (0, $9VcS9.default).list_stocks_simulated_availability === 'function') avail = await (0, $9VcS9.default).call((0, $9VcS9.default).list_stocks_simulated_availability, companyId, q);
    } catch (_e) {
        avail = null;
    }
    const byPid = new Map();
    for (const row of avail?.items || [])if (row?.product_id != null) byPid.set(Number(row.product_id), row);
    for (const { n: n, pid: pid } of rowMeta){
        const row = byPid.get(pid);
        const pre = root.querySelector(`#pre_reserved_by_approved_orders-${n}`);
        const sim = root.querySelector(`#simulated_available_quantity-${n}`);
        const sit = root.querySelector(`#stock_situation-${n}`);
        if (!row) {
            if (pre) pre.value = '';
            if (sim) sim.value = $fb0d8610497c39ce$var$_fmtQty(0);
            if (sit) sit.value = programId != null ? 'SEM_SALDO_PROGRAMA' : '';
            continue;
        }
        if (pre) pre.value = $fb0d8610497c39ce$var$_fmtQty(row.pre_reserved_by_approved_orders);
        if (sim) sim.value = $fb0d8610497c39ce$var$_fmtQty(row.simulated_available_quantity);
        if (sit) sit.value = row.status || '';
    }
    $fb0d8610497c39ce$export$be43077e64f2fdff(root);
}


function $dff7c2aa429b7f2b$export$2e2bcd8739ae039(..._args) {
    return {
        async actions (_ev, _publisher, _value) {
            const node = document.querySelector(this.selector);
            const formRoot = node?.closest?.('#order') || document.querySelector('#order');
            if (!formRoot) return;
            try {
                await (0, $fb0d8610497c39ce$export$523a405869d33195)(formRoot);
            } catch (_e) {
            /* noop */ }
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");

var $1cmSR = parcelRequire("1cmSR");
function $f7ae7d91f57919c4$export$2e2bcd8739ae039(...args) {
    let SHARED = {
        _this: null
    };
    return {
        _unit: args[0] ? 'purchasing_unit_id' : 'selling_unit_id',
        async actions (ev, publisher, value) {
            switch(true){
                case /^#company_id/.test(publisher.selector):
                    await this.loadUnits(value);
                    break;
                case /^#product_id/.test(publisher.selector):
                    await this.setUnit(value);
                    break;
            }
        },
        async loadUnits (company_id) {
            const action = async (company_id)=>{
                let units = await (0, $1cmSR.default).list('units', IDBKeyRange.bound([
                    company_id,
                    ''
                ], [
                    company_id,
                    '\uffff'
                ]));
                (0, $h1m6J.loadOptions)(this.selector, units, 'id', [
                    'name'
                ]);
                this.refresh();
            };
            if (typeof company_id == 'string') this.preventMultiCalls(SHARED, action, ()=>this.refresh(), company_id);
        },
        async setUnit (product_id) {
            if (!this.isEmpty()) return;
            let company_id = this.locate('company_id').getValue();
            if (!company_id || company_id < 0 || !product_id || product_id < 0) return;
            let product = await (0, $1cmSR.default).get('products', [
                company_id,
                Number(product_id)
            ]);
            if (!product) return;
            let unit = await (0, $1cmSR.default).get('units', [
                company_id,
                product[this._unit]
            ]);
            if (!unit) return;
            this.setValue(unit['id']);
            this.refresh();
            this.checkErrorState();
        }
    };
}



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");

var $h1m6J = parcelRequire("h1m6J");
function $352bac93a0323cb4$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        /** Mesma linha da tabela: #product_packaging_id-N → #manufacturer_display-N (locate com id composto falha às vezes). */ _manufacturerDisplayField () {
            const m = String(this.selector || '').match(/-(\d+)$/);
            const idx = m ? m[1] : '0';
            if (this.form?.getFieldBySelector) {
                const f = this.form.getFieldBySelector(`#manufacturer_display-${idx}`);
                if (f) return f;
            }
            return this.locate(this.makeId('manufacturer_display-0'));
        },
        /** Valor id da embalagem: internal, ou option do datalist quando o rótulo está na caixa. */ _resolvePackagingIdFromUi (opts) {
            const node = document.querySelector(this.selector);
            let v = this.getValue();
            if (v != null && v !== '' && (opts || []).some((p)=>String(p.id) === String(v))) return v;
            if (!node) return v;
            const typed = (node.value || '').trim();
            if (!typed || !node.list) return v;
            const opt = Array.from(node.list.options || []).find((o)=>{
                const t = (o.innerText || '').trim();
                return t === typed || String(o.value) === typed;
            });
            return opt != null ? opt.value : v;
        },
        async _applyManufacturerLabel (company_id, manufacturerId, mfrField) {
            if (!mfrField || !company_id) return;
            const mid = manufacturerId != null && manufacturerId !== '' ? Number(manufacturerId) : NaN;
            if (!Number.isFinite(mid) || mid < 1) {
                mfrField.setValue('');
                mfrField.refresh();
                return;
            }
            try {
                let m = await (0, $1cmSR.default).get('manufacturers', [
                    company_id,
                    mid
                ]);
                if (!m?.nick && !m?.name) {
                    m = await (0, $9VcS9.default).call((0, $9VcS9.default).select_manufacturer, company_id, mid);
                    if (m && typeof m === 'object') await (0, $1cmSR.default).set('manufacturers', [
                        m
                    ]).catch(()=>{});
                }
                mfrField.setValue(m ? m.name || m.nick || '' : '');
                mfrField.refresh();
            } catch (_e) {
                mfrField.setValue('');
                mfrField.refresh();
            }
        },
        async _fillManufacturerFromProduct (company_id, product_id, mfrField) {
            if (!mfrField) return;
            if (!company_id || !product_id || Number(product_id) < 1) {
                mfrField.setValue('');
                mfrField.refresh();
                return;
            }
            try {
                const p = await (0, $1cmSR.default).get('products', [
                    company_id,
                    Number(product_id)
                ]);
                await this._applyManufacturerLabel(company_id, p?.manufacturer_id, mfrField);
            } catch (_e) {
                mfrField.setValue('');
                mfrField.refresh();
            }
        },
        /** Fabricante da embalagem (GTIN); se a embalagem não tiver fabricante, usa o do produto (cadastro de embalagem). */ async _syncMfrFromPackagingList (opts, packagingId, company_id, product_id, mfrField) {
            if (!mfrField) return;
            const ppid = packagingId != null && packagingId !== '' ? Number(packagingId) : NaN;
            if (!Number.isFinite(ppid) || ppid < 1) {
                mfrField.setValue('');
                mfrField.refresh();
                return;
            }
            const row = (opts || []).find((p)=>Number(p.id) === ppid || String(p.id) === String(packagingId));
            const mid = row?.manufacturer_id;
            if (mid != null && mid !== '' && Number(mid) >= 1) {
                await this._applyManufacturerLabel(company_id, Number(mid), mfrField);
                return;
            }
            await this._fillManufacturerFromProduct(company_id, product_id, mfrField);
        },
        async actions () {
            const action = async ()=>{
                const company_id = this.locate('company_id')?.getValue();
                const productField = this.locate(this.makeId('product_id-0'));
                const product_id = productField?.getValue();
                const preserve = this.getValue();
                const mfrField = this._manufacturerDisplayField();
                if (!company_id || !product_id || Number(product_id) < 1) {
                    this._lastPackagingOpts = [];
                    (0, $h1m6J.loadOptions)(this.selector, [], 'id', [
                        'code'
                    ]);
                    this.setValue('');
                    this.refresh();
                    if (mfrField) {
                        mfrField.setValue('');
                        mfrField.refresh();
                    }
                    return;
                }
                const list = await (0, $9VcS9.default).call((0, $9VcS9.default).list_product_packagings_by_product, company_id, Number(product_id));
                const opts = Array.isArray(list) ? list : [];
                this._lastPackagingOpts = opts;
                (0, $h1m6J.loadOptions)(this.selector, opts, 'id', [
                    'code',
                    'level',
                    'factor'
                ], " \xb7 ");
                this.refresh();
                // Decidir id antes de limpar: preserve (edição) ou texto da caixa casando option (rótulo vs id).
                let candidate = this._resolvePackagingIdFromUi(opts);
                if (candidate == null || candidate === '') candidate = preserve;
                if (candidate == null || candidate === '') candidate = this.getValue();
                const stillValid = candidate != null && candidate !== '' && opts.some((p)=>String(p.id) === String(candidate));
                if (!stillValid) {
                    this.setValue('');
                    if (mfrField) {
                        mfrField.setValue('');
                        mfrField.refresh();
                    }
                    return;
                }
                if (String(this.getValue() ?? '') !== String(candidate)) this.setValue(candidate);
                this.refresh();
                await this._syncMfrFromPackagingList(opts, candidate, company_id, product_id, mfrField);
            };
            await this.preventMultiCalls(SHARED, action, ()=>this.refresh(), []);
        },
        captureEvents (_this = this) {
            this.safeProtoCall(_this);
            const node = document.querySelector(this.selector);
            if (!node) return;
            const onPick = ()=>{
                const company_id = this.locate('company_id')?.getValue();
                const product_id = this.locate(this.makeId('product_id-0'))?.getValue();
                const mfrField = this._manufacturerDisplayField();
                const list = this._lastPackagingOpts || [];
                const raw = this._resolvePackagingIdFromUi(list);
                this._syncMfrFromPackagingList(list, raw, company_id, product_id, mfrField);
            };
            node.addEventListener('blur', onPick);
            node.addEventListener('change', onPick);
        }
    };
}


/**
 * Carrega posições do armazém via API no datalist do campo (lista completa do sistema).
 * Ao digitar, refina com filtro no endereço (case-sensitive). No blur, resolve endereço → id.
 */ 
var $h1m6J = parcelRequire("h1m6J");

var $7WMRl = parcelRequire("7WMRl");
function $f0a98998622cf31a$var$findOption(node, value) {
    const opts = Array.from(node?.list?.options ?? []);
    const v = String(value ?? '').trim();
    return opts.find((o)=>String(o.value).trim() === v || o.value == value);
}
function $f0a98998622cf31a$export$2e2bcd8739ae039(opts = {}) {
    const companyKey = opts.companyKey || 'target_warehouse_company_id';
    const warehouseKey = opts.warehouseKey || 'target_warehouse_id';
    const isExpedition = opts.isExpedition === true;
    const debounceMs = opts.debounceMs ?? 280;
    let debounceTimer = null;
    return {
        captureEvents (_this = this) {
            this.safeProtoCall(_this);
            const node = document.querySelector(this.selector);
            if (node) {
                node.addEventListener('input', (ev)=>this._onInput(ev));
                node.addEventListener('blur', (ev)=>{
                    this._onBlur(ev);
                });
            }
        },
        _getScope () {
            const coRaw = this.locate(this.makeId(companyKey))?.getValue?.() ?? document.querySelector(this.makeId(companyKey))?.value;
            const whRaw = this.locate(this.makeId(warehouseKey))?.getValue?.() ?? document.querySelector(this.makeId(warehouseKey))?.value;
            return {
                coRaw: coRaw,
                whRaw: whRaw
            };
        },
        async _resolveScopeIds () {
            const { coRaw: coRaw, whRaw: whRaw } = this._getScope();
            const companyId = await (0, $7WMRl.resolveCompanyId)(coRaw);
            const warehouseId = await (0, $7WMRl.resolveWarehouseId)(companyId, whRaw);
            return {
                companyId: companyId,
                warehouseId: warehouseId
            };
        },
        async _reload (searchText = '') {
            const node = document.querySelector(this.selector);
            const preserve = String(searchText ?? node?.value ?? '').trim();
            const { companyId: companyId, warehouseId: warehouseId } = await this._resolveScopeIds();
            if (!companyId || !Number.isInteger(warehouseId) || warehouseId < 1) {
                (0, $h1m6J.loadOptions)(this.selector, [], 'id', [
                    'address'
                ], '-');
                if (node && preserve) node.value = preserve;
                return;
            }
            const term = preserve;
            const rows = await (0, $7WMRl.fetchWarehouseLocations)(companyId, warehouseId, {
                search: term,
                limit: term ? 80 : 0,
                silent: true,
                exactAddress: term.length > 0 && term.includes('-'),
                isExpedition: isExpedition
            });
            (0, $h1m6J.loadOptions)(this.selector, rows, 'id', [
                'address'
            ], '-');
            if (node && preserve) node.value = preserve;
        },
        async _onBlur () {
            const node = document.querySelector(this.selector);
            if (!node) return;
            const typed = String(node.value ?? '').trim();
            if (!typed) return;
            const current = this.getValue();
            if ($f0a98998622cf31a$var$findOption(node, current)) return;
            await this._reload(typed);
            if ($f0a98998622cf31a$var$findOption(node, this.getValue())) return;
            const { companyId: companyId, warehouseId: warehouseId } = await this._resolveScopeIds();
            if (!companyId || !Number.isInteger(warehouseId) || warehouseId < 1) return;
            const locId = await (0, $7WMRl.resolveLocationIdForMove)(companyId, warehouseId, typed);
            if (!Number.isInteger(locId) || locId < 1) return;
            this.setValue(locId);
            this.checkErrorState?.();
            this.refresh?.();
            const opt = $f0a98998622cf31a$var$findOption(node, locId);
            if (opt) node.value = opt.innerText || (0, $7WMRl.fmtLocAddr)(opt.label);
        },
        _onInput (ev) {
            if (ev.inputType === 'insertReplacementText') return;
            clearTimeout(debounceTimer);
            const typed = String(ev.target?.value ?? '').trim();
            debounceTimer = setTimeout(async ()=>{
                try {
                    await this._reload(typed);
                } catch (err) {
                    console.error('location search reload', err);
                }
            }, debounceMs);
        },
        async actions () {
            clearTimeout(debounceTimer);
            const node = document.querySelector(this.selector);
            const typed = node ? String(node.value ?? '').trim() : '';
            await this._reload(typed);
        }
    };
}



var $1Wvh7 = parcelRequire("1Wvh7");

var $h1m6J = parcelRequire("h1m6J");
function $c064992517a328df$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1202',
                label: "1202: Devolu\xe7\xe3o de venda no estado"
            },
            {
                value: '2202',
                label: "2202: Devolu\xe7\xe3o de venda outros estados"
            },
            {
                value: '1411',
                label: "1411: Devolu\xe7\xe3o de venda sujeita ao ICMS-ST no estado"
            },
            {
                value: '2411',
                label: "2411: Devolu\xe7\xe3o de venda sujeita ao ICMS-ST outros estados"
            },
            {
                value: '1949',
                label: "1949: Outra entrada de mercadoria n\xe3o especificada no estado"
            },
            {
                value: '2949',
                label: "2949: Outra entrada de mercadoria n\xe3o especificada outros estados"
            },
            {
                value: '5102',
                label: '5102: Venda de mercadoria no estado'
            },
            {
                value: '6102',
                label: '6102: Venda de mercadoria outros estados'
            },
            {
                value: '6108',
                label: "6108: Venda de mercadoria a n\xe3o contribuinte outros estados"
            },
            {
                value: '5202',
                label: "5202: Devolu\xe7\xe3o de compra no estado"
            },
            {
                value: '6202',
                label: "6202: Devolu\xe7\xe3o de compra outros estados"
            },
            {
                value: '5405',
                label: '5405: Venda de mercadoria sujeita ao ICMS-ST no estado'
            },
            {
                value: '5411',
                label: "5411: Devolu\xe7\xe3o de compra sujeita ao ICMS-ST no estado"
            },
            {
                value: '6411',
                label: "6411: Devolu\xe7\xe3o de compra sujeita ao ICMS-ST outros estados"
            },
            {
                value: '5910',
                label: "5910: Remessa em bonifica\xe7\xe3o, doa\xe7\xe3o ou brinde no estado"
            },
            {
                value: '6910',
                label: "6910: Remessa em bonifica\xe7\xe3o doa\xe7\xe3o ou brinde outros estados"
            },
            {
                value: '5911',
                label: "5911: Remessa de amostra gr\xe1tis no estado"
            },
            {
                value: '6911',
                label: "6911: Remessa de amostra gr\xe1tis outros estados"
            },
            {
                value: '5927',
                label: "5927: Baixa de estoque decorrente de perda, roubo ou deteriora\xe7\xe3o"
            },
            {
                value: '5949',
                label: "5949: Outra sa\xedda de mercadoria ou servi\xe7o n\xe3o especificado"
            },
            {
                value: '5119',
                label: '5119: Venda de mercadoria entregue por conta e ordem do adquirente'
            },
            {
                value: '6120',
                label: "6120: Venda de mercadoria entregue pelo vendedor em venda \xe0 ordem"
            },
            {
                value: '5923',
                label: '5923: Remessa de mercadoria por conta e ordem de terceiros no estado'
            },
            {
                value: '6923',
                label: '6923: Remessa de mercadoria por conta e ordem de terceiros outros estados'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $lwpk7 = parcelRequire("lwpk7");

var $h1m6J = parcelRequire("h1m6J");
function $6fc24243d89a5cc8$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            //{ value: '1', label: 'Simples' },
            {
                value: '3',
                label: 'Normal'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $409d889ae18b953b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'P',
                label: 'Impressora'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $9SpSV = parcelRequire("9SpSV");

var $fyCkJ = parcelRequire("fyCkJ");

var $h1m6J = parcelRequire("h1m6J");
function $c1af72f481ddf4d0$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'GET',
                label: 'GET'
            },
            {
                value: 'PUT',
                label: 'PUT'
            },
            {
                value: 'POST',
                label: 'POST'
            },
            {
                value: 'PATCH',
                label: 'PATCH'
            },
            {
                value: 'DELETE',
                label: 'DELETE'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $a5v7C = parcelRequire("a5v7C");

var $h1m6J = parcelRequire("h1m6J");
function $b23279d219d3efdd$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: "Autoriza\xe7\xe3o"
            },
            {
                value: '2',
                label: "Corre\xe7\xe3o"
            },
            {
                value: '3',
                label: 'Cancelamento'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $79f43e37b9b6ec01$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criado'
            },
            {
                value: '20',
                label: 'Aprovado'
            },
            {
                value: '30',
                label: 'Pendente'
            },
            {
                value: '40',
                label: "Conclu\xeddo"
            },
            {
                value: '50',
                label: 'Cancelado'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $cabf10de07f42bb1$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'pending',
                label: 'Pendente'
            },
            {
                value: 'partial',
                label: 'Parcial'
            },
            {
                value: 'total',
                label: 'Atendido total'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $02c6004873977d5a$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'DRY',
                label: 'Seca'
            },
            {
                value: 'REFRIGERATED',
                label: 'Refrigerada'
            },
            {
                value: 'CLIMATE_CONTROLLED',
                label: 'Climatizada'
            },
            {
                value: 'MIXED',
                label: 'Mista'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $2d17d508d4f555c6$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criada'
            },
            {
                value: '14',
                label: 'Faturando'
            },
            {
                value: '16',
                label: 'Faturada'
            },
            {
                value: '20',
                label: 'Recebendo'
            },
            {
                value: '30',
                label: 'Recebida'
            },
            {
                value: '40',
                label: 'Conferindo'
            },
            {
                value: '50',
                label: 'Conferida'
            },
            {
                value: '60',
                label: "Endere\xe7ando"
            },
            {
                value: '70',
                label: "Conclu\xedda"
            },
            {
                value: '80',
                label: 'Cancelada'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $d0f482af46bfd35e$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Iniciado'
            },
            {
                value: '20',
                label: 'Encerrado'
            },
            {
                value: '30',
                label: 'Cancelado'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $7090be8ac1a98b2f$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '1',
                label: 'FEFO'
            },
            {
                value: '2',
                label: 'FIFO'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $759a03b3eb0eafb9$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'I',
                label: 'Entrada'
            },
            {
                value: 'O',
                label: "Sa\xedda"
            },
            {
                value: 'A',
                label: 'Ativo Imobilizado'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $6d521c92c25435df$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: "Sem restri\xe7\xe3o de SKUs"
            },
            {
                value: '1',
                label: 'Lotes distintos do SKU'
            },
            {
                value: '2',
                label: 'Apenas mesmo lote'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $2372640607a5ee0b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Livre'
            },
            {
                value: '1',
                label: 'Em uso'
            },
            {
                value: '2',
                label: 'Entrada Bloqueada'
            },
            {
                value: '3',
                label: 'Entrada Bloqueada'
            },
            {
                value: '4',
                label: "Sa\xedda Bloqueada"
            },
            {
                value: '5',
                label: "Sa\xedda Bloqueada"
            },
            {
                value: '6',
                label: 'Toda Bloqueada'
            },
            {
                value: '7',
                label: 'Toda Bloqueada'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $84a270a7f3d1546a$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Pendente'
            },
            {
                value: '1',
                label: 'Verificado'
            },
            {
                value: '3',
                label: 'Etiquetado'
            },
            {
                value: '5',
                label: 'Armazenado'
            },
            {
                value: '7',
                label: 'Armazenado'
            },
            {
                value: '8',
                label: 'Bloqueado'
            },
            {
                value: '9',
                label: 'Bloqueado'
            },
            {
                value: '11',
                label: 'Bloqueado'
            },
            {
                value: '15',
                label: 'Bloqueado'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $1fpKo = parcelRequire("1fpKo");

var $h1m6J = parcelRequire("h1m6J");
function $e3d776cc66101a71$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'I',
                label: 'Entrada'
            },
            {
                value: 'O',
                label: "Sa\xedda"
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $c7jhB = parcelRequire("c7jhB");

var $h1m6J = parcelRequire("h1m6J");
function $05cf4050e889bf62$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criado'
            },
            {
                value: '20',
                label: 'Aprovado'
            },
            {
                value: '30',
                label: 'Parcialmente atendido'
            },
            {
                value: '35',
                label: 'Sem estoque'
            },
            {
                value: '40',
                label: "Conclu\xeddo"
            },
            {
                value: '45',
                label: "Conclu\xeddo parcialmente"
            },
            {
                value: '50',
                label: 'Processando'
            },
            {
                value: '60',
                label: 'Cancelado'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $f08968bc7ef228cb$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Criada'
            },
            {
                value: '20',
                label: 'Separando'
            },
            {
                value: '30',
                label: 'Separada'
            },
            {
                value: '40',
                label: 'Conferindo'
            },
            {
                value: '50',
                label: 'Unpick'
            },
            {
                value: '60',
                label: 'Conferida'
            },
            {
                value: '65',
                label: 'Faturando'
            },
            {
                value: '70',
                label: 'Faturada'
            },
            {
                value: '75',
                label: "Doca Expedi\xe7\xe3o"
            },
            {
                value: '80',
                label: 'Despachando'
            },
            {
                value: '90',
                label: "Conclu\xedda"
            },
            {
                value: '100',
                label: 'Cancelada'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $30182bc541c1e6fe$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '10',
                label: 'Aberta'
            },
            {
                value: '20',
                label: 'Lacrada'
            },
            {
                value: '30',
                label: 'Cancelada'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $6R5fG = parcelRequire("6R5fG");

var $k93VN = parcelRequire("k93VN");

var $5rlmp = parcelRequire("5rlmp");

var $h1m6J = parcelRequire("h1m6J");
function $c539c39a88864005$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: '0',
                label: 'Livre'
            },
            {
                value: '10',
                label: 'Bloqueado'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $bdd84d0eadfe1c66$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'I',
                label: 'Entrada'
            },
            {
                value: 'O',
                label: "Sa\xedda"
            },
            {
                value: 'L',
                label: "Posi\xe7\xe3o"
            },
            {
                value: 'R',
                label: 'Reserva'
            },
            {
                value: 'B',
                label: 'Bloqueio'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $h1m6J = parcelRequire("h1m6J");
function $3dfaf73b973524e9$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'MOV',
                label: "Movimenta\xe7\xe3o"
            },
            {
                value: 'RESUP',
                label: 'Ressuprimento'
            },
            {
                value: 'INV',
                label: "Invent\xe1rio"
            },
            {
                value: 'BLOQ',
                label: 'Bloqueio'
            },
            {
                value: 'DESBLOQ',
                label: 'Desbloqueio'
            },
            {
                value: 'UNPICK',
                label: 'Unpick'
            },
            {
                value: 'AUDIT_NAO_LOCALIZADO',
                label: "Auditoria: produto n\xe3o localizado"
            },
            {
                value: 'AUDIT_QTD_DIVERGENTE',
                label: 'Auditoria: quantidade divergente'
            },
            {
                value: 'AUDIT_POSICAO_INCORRETA',
                label: "Auditoria: posi\xe7\xe3o incorreta"
            },
            {
                value: 'AUDIT_RESERVA_ORFA',
                label: "Auditoria: reserva \xf3rf\xe3"
            },
            {
                value: 'AVARIA',
                label: 'Avaria'
            },
            {
                value: 'AVARIA_FORNECEDOR',
                label: 'Avaria Fornecedor'
            },
            {
                value: 'AVARIA_ARMAZEM',
                label: "Avaria Armaz\xe9m"
            },
            {
                value: 'AVARIA_TRANSPORTE',
                label: 'Avaria Transporte'
            },
            {
                value: 'QUARENTENA',
                label: 'Quarentena'
            },
            {
                value: 'VENCIDO',
                label: 'Vencidos'
            },
            {
                value: 'VENCIMENTO_CURTO',
                label: 'Vencimento Curto'
            },
            {
                value: 'FALTA_IBL',
                label: 'Falta IBL'
            },
            {
                value: 'FALTA_FORNECEDOR',
                label: 'Falta Fornecedor'
            },
            {
                value: 'FALTA_ARMAZEM',
                label: "Falta Armaz\xe9m"
            },
            {
                value: 'RECALL',
                label: 'Recall'
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $3HbPC = parcelRequire("3HbPC");

var $h1m6J = parcelRequire("h1m6J");
function $67779c32de42857b$export$2e2bcd8739ae039(...args) {
    return {
        options: [
            {
                value: 'M',
                label: "Multiplica\xe7\xe3o"
            },
            {
                value: 'D',
                label: "Divis\xe3o"
            }
        ],
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $e4pb7 = parcelRequire("e4pb7");


var $fY6pa = parcelRequire("fY6pa");
var $aYyoz = parcelRequire("aYyoz");
var $gF6P4 = parcelRequire("gF6P4");
var $3eqAU = parcelRequire("3eqAU");
var $a5v7C = parcelRequire("a5v7C");
var $jHqD0 = parcelRequire("jHqD0");
async function $62f41054efe4ec85$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; }
			.view td:nth-child(3)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: right; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Apelido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">CNPJ</th>
					<th data-index="5" data-visible="${this.visible[4]}">IE</th>
					<th data-index="6" data-visible="${this.visible[5]}">Tipo IE</th>
					<th data-index="8" data-visible="${this.visible[6]}">Fone</th>
					<th data-index="10" data-visible="${this.visible[7]}">Invent\xe1rio</th>
					<th data-index="11" data-visible="${this.visible[8]}">CRT</th>
					<th data-index="12" data-visible="${this.visible[9]}">PIS</th>
					<th data-index="13" data-visible="${this.visible[10]}">COFINS</th>
					<th data-index="14" data-visible="${this.visible[11]}">Tributos</th>
					<th data-index="15" data-visible="${this.visible[12]}">S\xe9rie</th>
					<th data-index="16" data-visible="${this.visible[13]}">Autorizados</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${record.nick}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${this.format($aYyoz.default(), record.cnpj)}</td>
					<td data-visible='${this.visible[4]}'>${this.format($gF6P4.default(), record.ie)}</td>
					<td data-visible='${this.visible[5]}'>${this.option($a5v7C.default(), record.ie_type)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($jHqD0.default(), record.phone)}</td>
					<td data-visible='${this.visible[7]}'>${this.option($7090be8ac1a98b2f$export$2e2bcd8739ae039(), record.inventory_strategy)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($6fc24243d89a5cc8$export$2e2bcd8739ae039(), record.crt)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($3eqAU.default(2), record.pis)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($3eqAU.default(2), record.cofins)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($3eqAU.default(2), record.estimated_taxes)}</td>
					<td data-visible='${this.visible[12]}'>${record.invoice_series}</td>
					<td data-visible='${this.visible[13]}'>${this.format($fY6pa.default(), record.authorized_parties)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $fY6pa = parcelRequire("fY6pa");
var $e3m9R = parcelRequire("e3m9R");
var $5Aed9 = parcelRequire("5Aed9");
var $aYyoz = parcelRequire("aYyoz");
var $9PIz7 = parcelRequire("9PIz7");
var $84MPM = parcelRequire("84MPM");
var $gF6P4 = parcelRequire("gF6P4");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6lTH5 = parcelRequire("6lTH5");
var $a5v7C = parcelRequire("a5v7C");
var $3HbPC = parcelRequire("3HbPC");
var $jHqD0 = parcelRequire("jHqD0");
var $6Jl4s = parcelRequire("6Jl4s");

var $jUNyh = parcelRequire("jUNyh");
const $367c2691d157ba2f$var$COMPANY_PARAMS_HELP_HTML = `
<div class="company-params-help-body">
<h4>Invent\xe1rio \u{2014} Permite vencido</h4>
<p>Quando marcado, o sistema pode considerar lotes com validade vencida nas opera\xe7\xf5es de invent\xe1rio desta empresa (caso contr\xe1rio, tende a trat\xe1-los como ineleg\xedveis). Use com alinhamento \xe0 pol\xedtica fiscal e operacional do depositante.</p>
<h4>Invent\xe1rio \u{2014} Exige lote</h4>
<p>Exige identifica\xe7\xe3o de lote nas rotinas de invent\xe1rio: posi\xe7\xf5es e contagens precisam estar vinculadas a um lote v\xe1lido, reduzindo movimenta\xe7\xe3o \u{201C}sem lote\u{201D}.</p>
<h4>Invent\xe1rio \u{2014} Por programa</h4>
<p>O invent\xe1rio passa a respeitar o programa (ex.: aloca\xe7\xe3o por programa de medicamentos): saldos e contagens s\xe3o avaliados no contexto do programa do lote/produto, n\xe3o apenas por SKU e posi\xe7\xe3o.</p>
<h4>Invent\xe1rio \u{2014} Bloqueio por classe</h4>
<p>Aplica restri\xe7\xf5es ligadas \xe0 classe do produto (ex.: classes que exigem tratamento diferenciado no invent\xe1rio ou na confer\xeancia). Complementa regras j\xe1 existentes de produto/classe.</p>
<h4>Invent\xe1rio \u{2014} Toler\xe2ncia confer\xeancia</h4>
<p>Valor inteiro de toler\xe2ncia usado nas regras de confer\xeancia de invent\xe1rio para esta empresa (margem aceit\xe1vel antes de apontar diverg\xeancia). Zero desativa toler\xe2ncia adicional; ajuste conforme acordo operacional.</p>
<h4>Embalagens \u{2014} Hierarquia de embalagens</h4>
<p>Ativa o modelo de embalagens em n\xedveis (prim\xe1ria, secund\xe1ria, terci\xe1ria) cadastradas no produto. Sem isso, o SIAL permanece no comportamento legado (uma unidade de venda / embalagem simples).</p>
<h4>Embalagens \u{2014} Unitariza\xe7\xe3o</h4>
<p>Permite que o picking/opera\xe7\xe3o utilize a <strong>embalagem prim\xe1ria</strong> (unidade fracionada) quando aplic\xe1vel. S\xf3 faz sentido com hierarquia ativa e cadastro correto dos fatores. Clientes legados costumam deixar desmarcado.</p>
<h4>Embalagens \u{2014} Picking otimizado</h4>
<p>O motor de separa\xe7\xe3o tende a escolher combina\xe7\xf5es de embalagem que <strong>minimizem quebra</strong> de fardos/caixas (ex.: priorizar m\xfaltiplos da embalagem maior). Depende de cadastro de embalagens e, quando aplic\xe1vel, capacidade terci\xe1ria.</p>
<h4>Embalagens \u{2014} Quebra terci\xe1ria / secund\xe1ria</h4>
<p><strong>Terci\xe1ria:</strong> autoriza \u{201C}abrir\u{201D} o fardo/paletiza\xe7\xe3o para atender quantidades que n\xe3o fecham m\xfaltiplo da terci\xe1ria.<br>
<strong>Secund\xe1ria:</strong> idem para o n\xedvel da caixa/fechamento secund\xe1rio. Se desmarcado e o pedido exigir fra\xe7\xe3o, o atendimento pode ficar bloqueado ou reduzido conforme a regra de picking.</p>
<h4>Embalagens \u{2014} Valida GTIN (embalagem)</h4>
<p>Passa a validar o GTIN informado nas embalagens cadastradas (confer\xeancia com c\xf3digo de barras / evita diverg\xeancia entre EAN do produto e o da embalagem).</p>
<h4>Embalagens \u{2014} Rollback legado</h4>
<p>For\xe7a caminhos de processamento compat\xedveis com o fluxo anterior do sistema, ignorando extens\xf5es novas de embalagem/picking quando definido pela pol\xedtica de migra\xe7\xe3o ou conting\xeancia.</p>
<h4>Embalagens e Picking \u{2014} Controla caixas na separa\xe7\xe3o/confer\xeancia de sa\xedda</h4>
<p>Quando habilitado, os fluxos de separa\xe7\xe3o e confer\xeancia de sa\xedda poder\xe3o exigir v\xednculo dos itens a caixas operacionais. Mantenha desabilitado para empresas que n\xe3o utilizam controle por caixa. <strong>O fluxo completo de caixas ainda n\xe3o est\xe1 implementado \u{2014} esta flag sinaliza a inten\xe7\xe3o para implementa\xe7\xe3o futura.</strong></p>
<h4>Pedidos de sa\xedda \u{2014} Atendimento</h4>
<p><strong>Parcial (padr\xe3o):</strong> permite gerar sa\xedda com quantidades inferiores ao pendente do pedido, como hoje (v\xe1rias remessas at\xe9 concluir).</p>
<p><strong>Total:</strong> nesta empresa, a gera\xe7\xe3o de sa\xedda s\xf3 prossegue quando <strong>todas</strong> as linhas ainda pendentes forem atendidas <strong>integralmente</strong> na mesma opera\xe7\xe3o; caso contr\xe1rio, o sistema n\xe3o cria a sa\xedda e informa o motivo.</p>
<h4>Pedidos de sa\xedda \u{2014} Permite confer\xeancia parcial</h4>
<p>Quando marcado (padr\xe3o), a confer\xeancia de sa\xedda web aceita quantidade conferida menor que a requerida. O conferidor dever\xe1 indicar o motivo da diverg\xeancia (Falta f\xedsica, Avaria, Erro de picking etc.). Lote e validade divergentes continuam sendo bloqueantes independentemente deste par\xe2metro.</p>
<p>Quando desmarcado, a confer\xeancia s\xf3 \xe9 conclu\xedda se <strong>todas</strong> as linhas forem conferidas na quantidade integral.</p>
<h4>Pedidos de sa\xedda \u{2014} Exige autoriza\xe7\xe3o para diverg\xeancia</h4>
<p>Quando marcado, somente usu\xe1rios com a permiss\xe3o <em>Sa\xeddas \u{2014} autorizar diverg\xeancia na confer\xeancia web</em> podem concluir confer\xeancias com diverg\xeancia de quantidade. O nome do autorizador e o hor\xe1rio ficam registrados na diverg\xeancia. Sem efeito se a confer\xeancia parcial estiver desativada.</p>
<h4>Pedidos de sa\xedda \u{2014} Confer\xeancia de sa\xedda com valida\xe7\xe3o</h4>
<p>Quando <strong>ligado</strong>, o Coletor PWA valida lote, validade e quantidade de forma rigorosa: em diverg\xeancia, envia checkpoint parcial ao SIAL Web e bloqueia a continuidade no coletor at\xe9 tratativa na Confer\xeancia Web. Quando <strong>desligado</strong> (padr\xe3o), o Coletor mant\xe9m o fluxo legado \u{2014} alertas locais, sem bloqueio por checkpoint.</p>
<h4>Pedidos de sa\xedda \u{2014} Confer\xeancia cega por embalagem</h4>
<p>S\xf3 vale na <strong>confer\xeancia cega</strong> (quando a valida\xe7\xe3o acima est\xe1 desligada). Quando <strong>ligado</strong> (padr\xe3o na maioria das empresas), o Coletor pede a quantidade em <strong>embalagens</strong> e multiplica pelo fator (ex.: 100 cx \xd7 100 = 10.000 und). Quando <strong>desligado</strong>, o operador informa a <strong>unidade m\xednima</strong> diretamente (ex.: 10.000), evitando interpreta\xe7\xe3o de caixa/m\xfaltiplo. Na SESSP/IBL o padr\xe3o operacional \xe9 desligado.</p>
<h4>Pedidos de sa\xedda \u{2014} Doca Expedi\xe7\xe3o ativa</h4>
<p>Quando <strong>ligado</strong>, sa\xeddas de pedidos com canal <strong>Internet</strong>, ap\xf3s autoriza\xe7\xe3o da NF-e, passam ao status <strong>Doca Expedi\xe7\xe3o (75)</strong> (aguardando transporte) <strong>sem</strong> baixa de estoque. A baixa (R\u{2192}O) e a conclus\xe3o ocorrem ao <strong>avan\xe7ar em lote</strong> na tela <em>Movimenta\xe7\xe3o \u{2192} Doca Expedi\xe7\xe3o</em>, ap\xf3s vincular uma posi\xe7\xe3o marcada como <strong>Expedi\xe7\xe3o</strong>. Demais canais e par\xe2metro desligado mant\xeam o fluxo atual (NF \u{2192} conclu\xedda com baixa).</p>
<h4>Entradas \u{2014} Coletor</h4>
<p><strong>Entrada com coletor:</strong> quando ativo, na tela de cadastro de entrada os campos <strong>Destino</strong> (empresa do armaz\xe9m), <strong>Armaz\xe9m</strong> e <strong>Posi\xe7\xe3o</strong> n\xe3o aceitam digita\xe7\xe3o livre \u{2014} apenas escolha na lista (datalist), no mesmo esp\xedrito do fluxo do coletor PWA. Desligado, o comportamento permanece o atual do SIAL (texto livre + lista).</p>
</div>`;
var $367c2691d157ba2f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#company #id					{ width: 20rem;		}
			#company #nick					{ width: 10rem; 	}
			#company #name					{ width: 25rem; 	}
			#company #cnpj					{ width: 10rem;		}
			#company #ie					{ width: 10rem;		}
			#company #ie_type				{ width: 10rem;		}
			#company #iest					{ width: 10rem;		}
			#company #phone					{ width: 10rem;		}
			#company #address_street		{ width: 30rem;		}
			#company #address_number		{ width: 5rem;		}
			#company #address_complement	{ width: 20rem;		}
			#company #address_district		{ width: 25rem;		}
			#company #address_state			{ width: 3.5rem;	}
			#company #address_city_id		{ width: 20rem;		}
			#company #address_zipcode		{ width: 6rem;		}
			#company #inventory_strategy	{ width: 6rem;		}
			#company #crt					{ width: 6rem;		}
			#company #pis					{ width: 4rem; text-align: right;	}
			#company #cofins				{ width: 4rem; text-align: right;	}
			#company #estimated_taxes		{ width: 4rem; text-align: right;	}
			#company #invoice_series		{ width: 4rem; text-align: right;	}
			#company #authorized_parties	{ width: 25rem; 	}
			#company #logo					{ width: 14rem; 	}
			#company #fiscal_modality		{ width: 10rem;		}
			#company #custody_warehouse_cnpj{ width: 12rem;		}
			#company #custody_emit_name			{ width: 28rem; }
			#company #custody_emit_ie			{ width: 12rem; }
			#company #custody_emit_phone		{ width: 10rem; }
			#company #custody_emit_crt			{ width: 6rem; }
			#company #custody_emit_address_street		{ width: 28rem; }
			#company #custody_emit_address_number		{ width: 5rem; }
			#company #custody_emit_address_complement	{ width: 18rem; }
			#company #custody_emit_address_district		{ width: 22rem; }
			#company #custody_emit_address_state			{ width: 3.5rem; }
			#company #custody_emit_address_city_id		{ width: 20rem; }
			#company #custody_emit_address_zipcode		{ width: 6rem; }
			#company #custody_emit_nfe_block { display: none; margin-top: 0.75rem; padding: 0.5rem 0; border-top: 1px solid #e5e7eb; }
			#company #custody_emit_nfe_block .custody-emit-title { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: #374151; margin: 0 0 0.5rem 0; }
			#company #inv_conference_tolerance { width: 5rem; text-align: right; }
			#company .company-params-fieldset { min-width: 0; }
			#company .param-block { margin-top: 0.85rem; }
			#company .param-block:first-of-type { margin-top: 0.35rem; }
			#company .param-block-title {
				margin: 0 0 0.5rem 0;
				font-size: 0.75rem;
				font-weight: 700;
				letter-spacing: 0.04em;
				color: #374151;
				text-transform: uppercase;
			}
			#company .param-grid {
				display: grid;
				grid-template-columns: repeat(2, minmax(0, 1fr));
				gap: 0.35rem 1rem;
				align-items: center;
			}
			@media (min-width: 520px) {
				#company .param-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
			}
			#company label.param-check {
				display: grid;
				grid-template-columns: 1.0625rem minmax(0, 1fr);
				column-gap: 0.5rem;
				align-items: center;
				min-height: 1.65rem;
				min-width: 0;
			}
			#company label.param-check input[type="checkbox"] {
				width: 1.0625rem;
				height: 1.0625rem;
				margin: 0;
			}
			#company label.param-check .param-check-text {
				line-height: 1.3;
				font-size: 0.875rem;
			}
			#company label.param-num {
				display: inline-flex;
				align-items: center;
				gap: 0.5rem;
				flex-wrap: wrap;
			}
			#company .param-num-label {
				font-size: 0.875rem;
				white-space: nowrap;
			}
			#company .param-grid .param-num.param-num--row {
				grid-column: 1 / -1;
				margin-bottom: 0.15rem;
			}
			#company .company-params-legend {
				display: flex;
				align-items: center;
				gap: 0.45rem;
				flex-wrap: wrap;
				padding: 0;
				margin: 0 0 0.15rem 0;
				font-size: inherit;
				font-weight: inherit;
			}
			#company .company-params-help {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 1.35rem;
				height: 1.35rem;
				padding: 0;
				border: 1px solid #9ca3af;
				border-radius: 999px;
				background: #f3f4f6;
				color: #374151;
				font-size: 0.85rem;
				font-weight: 700;
				line-height: 1;
				cursor: pointer;
			}
			#company .company-params-help:hover {
				background: #e5e7eb;
			}
			#company .company-params-help:focus {
				outline: 2px solid #2563eb;
				outline-offset: 2px;
			}
			#company .form-tabs { display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem 0.5rem; padding: 0 0 0 0.5rem; background: #f1f5f9; border-radius: 8px 8px 0 0; margin: 0 0 0.75rem 0; flex-shrink: 0; }
			#company .form-tab { padding: 0.65rem 1.1rem; cursor: pointer; font-weight: 600; font-size: 0.88rem; color: #64748b; background: transparent; border: none; border-radius: 6px; transition: all 0.15s ease; }
			#company .form-tab:hover { color: #334155; background: #e2e8f0; }
			#company .form-tab.active { color: #4f46e5; background: white; box-shadow: 0 -1px 3px rgba(0,0,0,0.06); }
			#company .form-tab-panels { min-height: 0; }
			#company .form-tab-panel { display: none; }
			#company .form-tab-panel.active { display: block; }
			#company .company-nfe-hint { font-size: 0.82rem; color: #4b5563; line-height: 1.45; margin: 0 0 0.75rem 0; max-width: 56rem; }
			#company .company-nfe-ph-block { margin-bottom: 0.85rem; max-width: 56rem; }
			#company .company-nfe-ph-label { display: block; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: #374151; margin-bottom: 0.35rem; }
			#company .company-nfe-ph-row { display: flex; flex-wrap: wrap; gap: 0.35rem; align-items: center; }
			#company button.company-inf-cpl-ph {
				font-size: 0.72rem; font-family: ui-monospace, monospace; padding: 0.2rem 0.45rem;
				border: 1px solid #cbd5e1; border-radius: 4px; background: #f8fafc; color: #334155; cursor: pointer;
			}
			#company button.company-inf-cpl-ph:hover { background: #e2e8f0; border-color: #94a3b8; }
			#company .company-nfe-textarea-label { display: block; width: 100%; max-width: 56rem; box-sizing: border-box; }
			#company #nfe_inf_cpl_entrada, #company #nfe_inf_cpl_saida { width: 100%; max-width: none; display: block; font-family: inherit; box-sizing: border-box; }
			#company .company-nfe-rt-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem 1rem; margin-top: 0.75rem; max-width: 48rem; }
			#company .company-nfe-rt-grid .io-span-2 { grid-column: span 2; }
			@media (max-width: 720px) { #company .company-nfe-rt-grid { grid-template-columns: 1fr; } #company .company-nfe-rt-grid .io-span-2 { grid-column: auto; } }
			#company #nfe_inf_resp_tec_cnpj { width: 100%; max-width: 16rem; }
			#company #nfe_inf_resp_tec_contato { width: 100%; max-width: none; }
			#company #nfe_inf_resp_tec_email { width: 100%; max-width: none; }
			#company #nfe_inf_resp_tec_fone { width: 100%; max-width: 14rem; }
			#company #output_orders_require_full_fulfillment { max-width: min(100%, 44rem); width: 100%; }
			#company .param-select-label { display: block; margin-top: 0.5rem; }
			#company .param-select-label .param-block-title { margin-bottom: 0.35rem; }
		</style>
		<style>
			.company-params-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
			.company-params-help-body h4 {
				margin: 0.85rem 0 0.25rem 0;
				font-size: 0.78rem;
				font-weight: 700;
				text-transform: uppercase;
				letter-spacing: 0.03em;
				color: #1f2937;
			}
			.company-params-help-body h4:first-child { margin-top: 0; }
			.company-params-help-body p {
				margin: 0;
				font-size: 0.875rem;
				line-height: 1.45;
				color: #374151;
			}
		</style>
		<form id="company" class="form" autocomplete="off">
			<datalist id="strategies">
			</datalist>
			<datalist id="regimes">
			</datalist>
			<datalist id="cities">
			</datalist>
			<datalist id="states">
			</datalist>
			<div class="form-tabs">
				<button type="button" class="form-tab active" data-tab="dados">Dados</button>
				<button type="button" class="form-tab" data-tab="parametros">Par\xe2metros</button>
				<button type="button" class="form-tab" data-tab="textos">Textos padr\xf5es</button>
			</div>
			<div class="form-tab-panels">
			<div id="tab-dados" class="form-tab-panel active">
			<div class="fsb">
				<label title="Identificador da empresa">Empresa
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome curto da empresa">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ<sup>*</sup>
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
				<label class="file"><a id="download" download="logo.png">Logotipo</a>
					<input id="logo" type="file" accept=".png, image/x-png" title="Logotipo para emiss\xe3o da NFe (~128x128 pixels)">
				</label>
				<!--
				<label title="Inscri\xe7\xe3o Estadual do Substituto Tribut\xe1rio">IEST
					<input id="iest" type="text">
				</label>
				-->
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Logradouro">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="N\xfamero">N\xfamero
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Munic\xedpio">Munic\xedpio
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<label title="Estrat\xe9gia de invent\xe1rio">Invent\xe1rio<sup>*</sup>
					<input id="inventory_strategy" type="text" list="strategies" required>
				</label>
				<label title="C\xf3digo de Regime Tribut\xe1rio">CRT<sup>*</sup>
					<input id="crt" type="text" list="regimes" required>
				</label>
				<label title="Al\xedquota de PIS">PIS<sup>*</sup>
					<input id="pis" type="text" placeholder="0,00" required>
				</label>
				<label title="Al\xedquota de COFINS">COFINS<sup>*</sup>
					<input id="cofins" type="text" placeholder="0,00" required>
				</label>
				<label title="Percentual estimado de tributos federais, estaduais e municipais">Tributos
					<input id="estimated_taxes" type="text" placeholder="0,00">
				</label>
				<label title="S\xe9rie da NFe">S\xe9rie<sup>*</sup>
					<input id="invoice_series" type="text" placeholder="0" required>
				</label>
				<label title="CPF ou CNPJ das pessoas autorizadas a acessar o XML da NFe">Autorizados
					<input id="authorized_parties" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Modalidade fiscal: normal ou fiel deposit\xe1rio">Modalidade Fiscal
					<select id="fiscal_modality">
						<option value="0">Normal</option>
						<option value="1">Fiel deposit\xe1rio</option>
					</select>
				</label>
				<span id="custody_row">
					<label title="CNPJ do armazenador (obrigat\xf3rio quando fiel deposit\xe1rio)">CNPJ armazenador
						<input id="custody_warehouse_cnpj" type="text" placeholder="00.000.000/0000-00">
					</label>
				</span>
			</div>
			<div id="custody_emit_nfe_block">
				<p class="custody-emit-title">Emitente na NF-e (armazenador \u{2014} mesmo CNPJ do certificado A1)</p>
				<p style="font-size:0.8rem;color:#6b7280;margin:0 0 0.5rem 0;">Preencha com os dados cadastrais desse CNPJ na SEFAZ. O depositante continua no cadastro principal acima.</p>
				<div class="fsb">
					<label title="Raz\xe3o social que consta na SEFAZ para o CNPJ armazenador">Raz\xe3o social emitente NF-e<sup>*</sup>
						<input id="custody_emit_name" type="text" placeholder="Nome do armazenador">
					</label>
					<label title="IE v\xe1lida para o CNPJ armazenador (ou ISENTO)">IE emitente NF-e<sup>*</sup>
						<input id="custody_emit_ie" type="text" placeholder="IE ou ISENTO">
					</label>
					<label title="Telefone do emitente (opcional)">Fone emitente
						<input id="custody_emit_phone" type="text" placeholder="+55 (11) 0000-0000">
					</label>
					<label title="CRT do emitente (vazio = mesmo CRT da empresa)">CRT emitente
						<input id="custody_emit_crt" type="text" list="regimes" placeholder="igual empresa">
					</label>
				</div>
				<div class="fsb">
					<input type="hidden" id="custody_emit_address_id">
					<label>Logradouro emitente
						<input id="custody_emit_address_street" type="text">
					</label>
					<label>N\xfamero
						<input id="custody_emit_address_number" type="text">
					</label>
					<label>Complemento
						<input id="custody_emit_address_complement" type="text">
					</label>
				</div>
				<div class="fsb">
					<label>Bairro
						<input id="custody_emit_address_district" type="text">
					</label>
					<label>UF
						<input id="custody_emit_address_state" type="text" list="states">
					</label>
					<label>Munic\xedpio
						<input id="custody_emit_address_city_id" type="text" list="cities">
					</label>
					<label>CEP
						<input id="custody_emit_address_zipcode" type="text" placeholder="00000-000">
					</label>
				</div>
			</div>
			</div>
			<div id="tab-parametros" class="form-tab-panel">
			<fieldset class="mtm company-params-fieldset">
				<legend class="company-params-legend">
					<span>Par\xe2metros operacionais</span>
					<button type="button" class="company-params-help" id="company_params_help" title="Ajuda: significado de cada par\xe2metro" aria-label="Ajuda sobre par\xe2metros operacionais">?</button>
				</legend>
			<div class="param-block">
				<h4 class="param-block-title">Pedidos de sa\xedda</h4>
				<label class="param-select-label" title="Define se a gera\xe7\xe3o de sa\xedda exige atendimento integral de todo o pendente">
					<span class="param-block-title" style="display:block;">Atendimento na gera\xe7\xe3o de sa\xeddas</span>
					<select id="output_orders_require_full_fulfillment">
						<option value="0">Parcial \u{2014} permite sa\xedda com atendimento menor que o pendente (padr\xe3o)</option>
						<option value="1">Total \u{2014} s\xf3 gera sa\xedda se todo o pendente for atendido a 100% nesta opera\xe7\xe3o</option>
					</select>
				</label>
				<div class="param-grid" style="margin-top:0.5rem;">
					<label class="param-check" title="Quando marcado, a confer\xeancia de sa\xedda web aceita quantidade conferida menor que a requerida (diverg\xeancia de quantidade). Lote e validade divergentes continuam bloqueando independentemente deste par\xe2metro.">
						<input id="out_allow_partial_conference" type="checkbox">
						<span class="param-check-text">Permite confer\xeancia parcial de sa\xedda</span>
					</label>
					<label class="param-check" title="Quando marcado, o usu\xe1rio precisa ter a permiss\xe3o &quot;Sa\xeddas \u{2014} autorizar diverg\xeancia na confer\xeancia web&quot; para concluir confer\xeancias com diverg\xeancia de quantidade. Sem efeito se confer\xeancia parcial estiver desativada.">
						<input id="out_require_divergence_auth" type="checkbox">
						<span class="param-check-text">Exige autoriza\xe7\xe3o para diverg\xeancia na confer\xeancia de sa\xedda</span>
					</label>
					<label class="param-check" title="Quando ligado, o Coletor PWA bloqueia em diverg\xeancia de lote/validade/quantidade e envia checkpoint parcial ao SIAL Web. Desligado: fluxo legado do coletor (alertas, sem bloqueio por checkpoint).">
						<input id="out_conference_collector_validation" type="checkbox">
						<span class="param-check-text">Confer\xeancia de sa\xedda com valida\xe7\xe3o</span>
					</label>
					<label class="param-check" title="S\xf3 na confer\xeancia cega (valida\xe7\xe3o desligada). Ligado (padr\xe3o): Coletor pede quantidade em embalagens e multiplica pelo fator. Desligado: pede unidade m\xednima (ex.: 10.000 und). SESSP/IBL nasce desligado.">
						<input id="out_conference_blind_by_packaging" type="checkbox" checked>
						<span class="param-check-text">Confer\xeancia cega por embalagem</span>
					</label>
					<label class="param-check" title="Quando ligado, sa\xeddas de pedidos canal Internet (2), ap\xf3s NF autorizada, ficam em status Doca Expedi\xe7\xe3o (75) aguardando transporte \u{2014} sem baixa de estoque at\xe9 avan\xe7ar na tela Movimenta\xe7\xf5es \u{2192} Doca Expedi\xe7\xe3o. Demais canais mant\xeam o fluxo atual (NF \u{2192} conclu\xedda).">
						<input id="out_dock_expedition_enabled" type="checkbox">
						<span class="param-check-text">Doca Expedi\xe7\xe3o ativa</span>
					</label>
					<label class="param-num param-num--row" title="#MT-7740432 teto de pedidos por onda de derrubada (default 120)">
						<span class="param-num-label">Pedidos por onda (derrubada)</span>
						<input id="max_orders_per_wave" type="text" placeholder="120">
					</label>
				</div>
			</div>
				<div class="param-block">
					<h4 class="param-block-title">Entradas</h4>
					<label class="param-check" title="Destino, Armaz\xe9m e Posi\xe7\xe3o na entrada s\xf3 podem ser escolhidos na lista (sem digita\xe7\xe3o livre), alinhado ao coletor">
						<input id="input_collector_strict" type="checkbox">
						<span class="param-check-text">Entrada com coletor</span>
					</label>
					<label class="param-check" title="Quando marcado, o Pedido de Entrada exige quantidade de parcelas e prazos (dias) ao salvar \u{2014} padr\xe3o estilo GOBI. Recomendado para LLT; mantenha desligado na RVD enquanto a integra\xe7\xe3o n\xe3o enviar o campo.">
						<input id="input_orders_require_payment_condition" type="checkbox">
						<span class="param-check-text">Exige condi\xe7\xe3o de pagamento no Pedido de Entrada</span>
					</label>
					<label class="param-check" title="Quando marcado, o Status do Pedido de Entrada s\xf3 muda pelas opera\xe7\xf5es Aprovar/Rejeitar (em lote). Pedidos manuais ficam em Criado at\xe9 a aprova\xe7\xe3o. Seed padr\xe3o: LLT ligado.">
						<input id="input_orders_require_approval" type="checkbox">
						<span class="param-check-text">Exige aprova\xe7\xe3o no Pedido de Entrada</span>
					</label>
					<label class="param-check" title="Habilita o processo operacional de agendamento de recebimento por doca. O cadastro de Docas Entrada permanece dispon\xedvel mesmo com este par\xe2metro desligado.">
						<input id="in_dock_scheduling_enabled" type="checkbox">
						<span class="param-check-text">Agendamento de Docas de Entrada</span>
					</label>
				</div>
				<div class="param-block">
					<h4 class="param-block-title">Invent\xe1rio</h4>
					<div class="param-grid">
						<label class="param-num param-num--row" title="Toler\xe2ncia de confer\xeancia do invent\xe1rio">
							<span class="param-num-label">Toler\xe2ncia confer\xeancia</span>
							<input id="inv_conference_tolerance" type="text" placeholder="0">
						</label>
						<label class="param-check" title="Permite invent\xe1rio com lote vencido"><input id="inv_allow_expired" type="checkbox"> <span class="param-check-text">Permite vencido</span></label>
						<label class="param-check" title="Exige lote nas opera\xe7\xf5es de invent\xe1rio"><input id="inv_require_lot" type="checkbox"> <span class="param-check-text">Exige lote</span></label>
						<label class="param-check" title="Controla invent\xe1rio por programa"><input id="inv_by_program" type="checkbox"> <span class="param-check-text">Por programa</span></label>
						<label class="param-check" title="Bloqueios por classe no invent\xe1rio (contagens / escopo)"><input id="inv_class_blocking" type="checkbox"> <span class="param-check-text">Bloqueio por classe (invent\xe1rio)</span></label>
						<label class="param-check" title="Impede movimentar/endere\xe7ar produto para posi\xe7\xe3o sem ao menos uma classe em comum (classes seletivas do produto \xd7 classes da posi\xe7\xe3o). Tamb\xe9m \xe9 ativado se Bloqueio por classe (invent\xe1rio) estiver ligado."><input id="storage_class_blocking" type="checkbox"> <span class="param-check-text">Bloquear armazenagem por classe</span></label>
					</div>
				</div>
				<div class="param-block">
					<h4 class="param-block-title">Embalagens e picking</h4>
					<div class="param-grid">
						<label class="param-check" title="Ativa hierarquia de embalagens no cliente"><input id="pkg_use_hierarchy" type="checkbox"> <span class="param-check-text">Hierarquia de embalagens</span></label>
						<label class="param-check" title="Permite atendimento unit\xe1rio (prim\xe1ria)"><input id="pkg_unitarization_enabled" type="checkbox"> <span class="param-check-text">Unitariza\xe7\xe3o</span></label>
						<label class="param-check" title="Motor de picking otimiza escolha de embalagem"><input id="pkg_optimize_picking" type="checkbox"> <span class="param-check-text">Picking otimizado</span></label>
						<label class="param-check" title="Permite quebrar embalagem terci\xe1ria"><input id="pkg_allow_tertiary_break" type="checkbox"> <span class="param-check-text">Quebra terci\xe1ria</span></label>
						<label class="param-check" title="Permite quebrar embalagem secund\xe1ria"><input id="pkg_allow_secondary_break" type="checkbox"> <span class="param-check-text">Quebra secund\xe1ria</span></label>
						<label class="param-check" title="Valida GTIN por embalagem"><input id="pkg_validate_gtin" type="checkbox"> <span class="param-check-text">Valida GTIN (embalagem)</span></label>
						<label class="param-check" title="For\xe7a uso do fluxo legado (rollback)"><input id="pkg_rollback_legacy" type="checkbox"> <span class="param-check-text">Rollback legado</span></label>
					<label class="param-check" title="Quando habilitado, os fluxos de separa\xe7\xe3o e confer\xeancia de sa\xedda poder\xe3o exigir v\xednculo dos itens a caixas operacionais. Mantenha desabilitado para empresas que n\xe3o utilizam controle por caixa.">
						<input id="out_enable_box_control" type="checkbox">
						<span class="param-check-text">Controla caixas na separa\xe7\xe3o/confer\xeancia de sa\xedda</span>
					</label>
					</div>
				</div>
			</fieldset>
			</div>
			<div id="tab-textos" class="form-tab-panel">
				<p class="company-nfe-hint">Modelos de texto para a tag <strong>infCpl</strong> da NF-e (complemento da nota). Definidos <strong>por empresa</strong>; na emiss\xe3o, os par\xe2metros entre colchetes s\xe3o trocados pelos dados do pedido, do cliente/fornecedor e do local de entrega.</p>
				<div class="company-nfe-ph-block">
					<span class="company-nfe-ph-label">Par\xe2metros \u{2014} colar no texto de entrada</span>
					<div class="company-nfe-ph-row">
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[FORNECEDOR]">[FORNECEDOR]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[NUMERO NF]">[NUMERO NF]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[LOCAL DE ENTREGA]">[LOCAL DE ENTREGA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CNPJ EMPRESA (TENNANT)]">[CNPJ EMPRESA (TENNANT)]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CNPJ FIEL DEPOSITARIO]">[CNPJ FIEL DEPOSITARIO]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[RAZAO SOCIAL EMPRESA]">[RAZAO SOCIAL EMPRESA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[RAZAO SOCIAL EMITENTE]">[RAZAO SOCIAL EMITENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CLIENTE]">[CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CNPJ CLIENTE]">[CNPJ CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[PEDIDO ENTRADA]">[PEDIDO ENTRADA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[ENTRADA]">[ENTRADA]</button>
					</div>
				</div>
				<label title="Modelo infCpl para notas de entrada (compra / devolu\xe7\xe3o de venda)" class="company-nfe-textarea-label">Texto padr\xe3o \u{2014} NF entrada
					<textarea id="nfe_inf_cpl_entrada" rows="5" placeholder="Ex.: NF ref. [NUMERO NF] do fornecedor [FORNECEDOR]\u{2026}"></textarea>
				</label>
				<div class="company-nfe-ph-block mtm" style="margin-top:1rem;">
					<span class="company-nfe-ph-label">Par\xe2metros \u{2014} colar no texto de sa\xedda</span>
					<div class="company-nfe-ph-row">
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CLIENTE]">[CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CNPJ CLIENTE]">[CNPJ CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CPF CLIENTE]">[CPF CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[LOCAL DE ENTREGA]">[LOCAL DE ENTREGA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CNPJ FIEL DEPOSITARIO]">[CNPJ FIEL DEPOSITARIO]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CNPJ EMPRESA (TENNANT)]">[CNPJ EMPRESA (TENNANT)]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[NUMERO NF]">[NUMERO NF]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[RAZAO SOCIAL EMPRESA]">[RAZAO SOCIAL EMPRESA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[FORNECEDOR]">[FORNECEDOR]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[PEDIDO SAIDA]">[PEDIDO SAIDA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[SAIDA]">[SAIDA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[REFERENCIA]">[REFERENCIA]</button>
					</div>
				</div>
				<label title="Modelo infCpl para notas de sa\xedda (venda / remessa)" class="company-nfe-textarea-label mtm" style="margin-top:0.5rem;">Texto padr\xe3o \u{2014} NF sa\xedda
					<textarea id="nfe_inf_cpl_saida" rows="5" placeholder="Ex.: Entrega em [LOCAL DE ENTREGA] para [CLIENTE] CNPJ [CNPJ CLIENTE]\u{2026}"></textarea>
				</label>
				<hr style="margin:1.25rem 0; border:0; border-top:1px solid #ccc;" />
				<p class="company-nfe-hint" style="margin-bottom:0.5rem;"><strong>Respons\xe1vel t\xe9cnico (infRespTec)</strong> \u{2014} opcional na NF-e de <strong>entrada</strong>; recomend\xe1vel quando h\xe1 medicamentos / exig\xeancias ANVISA. Preencha <strong>os quatro campos</strong> para o grupo ser inclu\xeddo no XML de entrada. Se vazio, pode ainda ser usado o fallback do <code>config.ini</code> (<code>[nfe]</code>) quando configurado.</p>
				<div class="company-nfe-rt-grid">
					<label title="CNPJ do respons\xe1vel t\xe9cnico (14 d\xedgitos)">CNPJ do RT
						<input id="nfe_inf_resp_tec_cnpj" type="text" placeholder="00.000.000/0001-00" maxlength="18" autocomplete="off">
					</label>
					<label title="Nome do contato (xContato)">Nome do contato (xContato)
						<input id="nfe_inf_resp_tec_contato" type="text" placeholder="Nome completo" maxlength="200" autocomplete="name">
					</label>
					<label title="E-mail do respons\xe1vel t\xe9cnico" class="io-span-2">E-mail
						<input id="nfe_inf_resp_tec_email" type="email" placeholder="suporte@exemplo.com.br" maxlength="200" autocomplete="email">
					</label>
					<label title="Telefone (apenas d\xedgitos no XML)">Telefone
						<input id="nfe_inf_resp_tec_fone" type="text" placeholder="01930148080" maxlength="20" autocomplete="tel">
					</label>
				</div>
			</div>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#company',
        init (formset) {
            this.getFieldByName('logo').subscribe([
                'change'
            ], this.enableDownload.bind(formset), false); // once = false
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>(typeof formset.dialog?.getNode === 'function' ? formset.dialog.getNode() : null) || document.querySelector('#company');
            root()?.addEventListener('click', (ev)=>{
                const btn = ev.target?.closest?.('.company-inf-cpl-ph');
                if (!btn) {
                    const tab = ev.target?.closest?.('.form-tab');
                    if (!tab || !root()) return;
                    ev.preventDefault();
                    const id = tab.getAttribute('data-tab');
                    root().querySelectorAll('.form-tab').forEach((t)=>t.classList.remove('active'));
                    root().querySelectorAll('.form-tab-panel').forEach((p)=>p.classList.remove('active'));
                    tab.classList.add('active');
                    const panel = root().querySelector(`#tab-${id}`);
                    if (panel) panel.classList.add('active');
                    return;
                }
                ev.preventDefault();
                const tid = btn.getAttribute('data-target');
                const ph = btn.getAttribute('data-ph') || '';
                const ta = root()?.querySelector(`#${tid}`);
                if (!ta) return;
                const i = ta.selectionStart ?? ta.value.length;
                const j = ta.selectionEnd ?? ta.value.length;
                ta.value = ta.value.slice(0, i) + ph + ta.value.slice(j);
                ta.focus();
                const pos = i + ph.length;
                ta.setSelectionRange(pos, pos);
            });
            const fiscalEl = document.querySelector('#fiscal_modality');
            const custodyRow = document.querySelector('#custody_row');
            const custodyEmitBlock = document.querySelector('#custody_emit_nfe_block');
            const toggleCustody = ()=>{
                const show = fiscalEl?.value === '1';
                if (custodyRow) custodyRow.style.display = show ? '' : 'none';
                if (custodyEmitBlock) custodyEmitBlock.style.display = show ? 'block' : 'none';
            };
            fiscalEl?.addEventListener('change', toggleCustody);
            if (typeof formset.subscribe === 'function') formset.subscribe([
                'open'
            ], ()=>setTimeout(toggleCustody, 0));
            setTimeout(toggleCustody, 0);
            const helpBtn = document.querySelector('#company_params_help');
            helpBtn?.addEventListener('click', (ev)=>{
                ev.preventDefault();
                let mb;
                mb = (0, $jUNyh.default)({
                    title: "Ajuda \u2014 Par\xe2metros operacionais",
                    text: $367c2691d157ba2f$var$COMPANY_PARAMS_HELP_HTML,
                    buttons: [
                        {
                            label: 'Fechar',
                            cls: 'bn_Enter'
                        }
                    ],
                    callback: ()=>mb.destroy()
                });
            });
        },
        enableDownload (ev, publisher, value) {
            if (value) {
                let anchor = document.querySelector('#download');
                anchor.setAttribute('href', `data:image/x-png;base64,${value}`);
                anchor.removeAttribute('disabled');
            }
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $aYyoz.default()
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $gF6P4.default()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ]
        },
        //{ properties: { selector: '#iest' }, types: [] },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $jHqD0.default()
            ]
        },
        {
            properties: {
                selector: '#address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_district'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $6Jl4s.default(),
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#address_city_id'
            },
            types: [
                $6Jl4s.default(),
                $74yTJ.default(),
                $6lTH5.default('address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('address_state')
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: [
                $e3m9R.default(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inventory_strategy'
            },
            types: [
                $7090be8ac1a98b2f$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#crt'
            },
            types: [
                $6fc24243d89a5cc8$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#pis'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#cofins'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#estimated_taxes'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#invoice_series'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#authorized_parties'
            },
            types: [
                $fY6pa.default()
            ]
        },
        {
            properties: {
                selector: '#logo'
            },
            types: [
                $6Jl4s.default(),
                $84MPM.default()
            ]
        },
        {
            properties: {
                selector: '#fiscal_modality'
            },
            types: []
        },
        {
            properties: {
                selector: '#custody_warehouse_cnpj'
            },
            types: [
                $aYyoz.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_ie'
            },
            types: []
        },
        {
            properties: {
                selector: '#custody_emit_phone'
            },
            types: [
                $jHqD0.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_crt'
            },
            types: [
                $6fc24243d89a5cc8$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#custody_emit_address_street'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_complement'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_district'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_state'
            },
            types: [
                $6Jl4s.default(),
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_city_id'
            },
            types: [
                $6Jl4s.default(),
                $74yTJ.default(),
                $6lTH5.default('custody_emit_address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('custody_emit_address_state')
            ]
        },
        {
            properties: {
                selector: '#custody_emit_address_zipcode'
            },
            types: [
                $e3m9R.default(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#inv_allow_expired'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#inv_require_lot'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#inv_by_program'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#inv_class_blocking'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#storage_class_blocking'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#inv_conference_tolerance'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#pkg_use_hierarchy'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#pkg_unitarization_enabled'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#pkg_optimize_picking'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#pkg_allow_tertiary_break'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#pkg_allow_secondary_break'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#pkg_validate_gtin'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#pkg_rollback_legacy'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_enable_box_control'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#output_orders_require_full_fulfillment'
            },
            types: []
        },
        {
            properties: {
                selector: '#input_collector_strict'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#input_orders_require_payment_condition'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#input_orders_require_approval'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#in_dock_scheduling_enabled'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_allow_partial_conference'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_require_divergence_auth'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_conference_collector_validation'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_conference_blind_by_packaging'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_dock_expedition_enabled'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#max_orders_per_wave'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#nfe_inf_cpl_entrada'
            },
            types: []
        },
        {
            properties: {
                selector: '#nfe_inf_cpl_saida'
            },
            types: []
        },
        {
            properties: {
                selector: '#nfe_inf_resp_tec_cnpj'
            },
            types: [
                $aYyoz.default()
            ]
        },
        {
            properties: {
                selector: '#nfe_inf_resp_tec_contato'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#nfe_inf_resp_tec_email'
            },
            types: []
        },
        {
            properties: {
                selector: '#nfe_inf_resp_tec_fone'
            },
            types: [
                $ca99afedcb4c666c$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $fY6pa = parcelRequire("fY6pa");
var $aYyoz = parcelRequire("aYyoz");
var $9PIz7 = parcelRequire("9PIz7");
var $gF6P4 = parcelRequire("gF6P4");
var $3eqAU = parcelRequire("3eqAU");
var $a5v7C = parcelRequire("a5v7C");
var $jHqD0 = parcelRequire("jHqD0");
const $4e09ec6288da1fd7$var$companies = function() {
    let companies_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            // /companies filtra por grupos do usuário; empresa nova não tem binding e sumiria da lista.
            // Tela de cadastro de empresas lista todas as ativas (igual GET /companies/all).
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_all_companies, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_company, ...JSON.parse(id));
            _record = (0, $b60a2.flatten)(_record, 'address');
            if (_record.address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.address_city_id);
                if (c) {
                    _record['address_state'] = c.state;
                    _record['address_city_id'] = c.city;
                }
            }
            _record = (0, $b60a2.flatten)(_record, 'custody_emit_address');
            if (_record.custody_emit_address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.custody_emit_address_city_id);
                if (c) {
                    _record['custody_emit_address_state'] = c.state;
                    _record['custody_emit_address_city_id'] = c.city;
                }
            }
            _record.output_orders_require_full_fulfillment = _record.output_orders_require_full_fulfillment === true || _record.output_orders_require_full_fulfillment === '1' ? '1' : '0';
            _record.input_collector_strict = _record.input_collector_strict === true || _record.input_collector_strict === '1' ? '1' : '0';
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#company';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            /**
			 * Heurística: quando a UF do formulário está vazia, infere a partir dos 5 primeiros dígitos do CEP
			 * (evita enviar o nome do município em city_id; complementar conforme necessidade operacional).
			 */ const inferUfFromCep = (cep)=>{
                const d = String(cep || '').replace(/\D/g, '');
                if (d.length < 5) return '';
                const n5 = parseInt(d.slice(0, 5), 10);
                if (n5 >= 77000 && n5 <= 77999) return 'TO';
                return '';
            };
            /**
			 * Converte nome de cidade + UF no código IBGE (7 dígitos). Nunca retorna o nome; em falta, notifica e devolve null.
			 * Se a API não tiver municípios da UF (lista vazia), usa ViaCEP pelo CEP (campo ibge), sem depender da tabela cities.
			 */ const VIACEP_BASE = 'https://viacep.com.br/ws';
            const ibgeFromViaCep = async (zipDigits, cityNorm, ufExpected)=>{
                const cep = String(zipDigits || '').replace(/\D/g, '');
                if (cep.length !== 8) return null;
                try {
                    const r = await fetch(`${VIACEP_BASE}/${cep}/json/`);
                    const j = await r.json();
                    if (j?.erro || !j?.ibge) return null;
                    const ibge = String(j.ibge).replace(/\D/g, '');
                    if (!/^\d{7}$/.test(ibge)) return null;
                    const ufv = String(ufExpected || '').toUpperCase().trim().slice(0, 2);
                    if (ufv && j.uf && String(j.uf).toUpperCase().trim().slice(0, 2) !== ufv) return null;
                    const locN = normalize(j.localidade || '');
                    const exp = (cityNorm || '').trim();
                    if (!exp || !locN) return ibge;
                    if (locN === exp || locN.startsWith(exp) || exp.startsWith(locN) || exp.length >= 3 && locN.includes(exp) || locN.length >= 3 && exp.includes(locN)) return ibge;
                    return null;
                } catch (_) {
                    return null;
                }
            };
            const resolveCityId = async (state, cityVal, zipHint)=>{
                if (cityVal == null || String(cityVal).trim() === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d{7}$/.test(v)) return v;
                let u = String(state || '').toUpperCase().trim().slice(0, 2);
                if (!u || u.length < 2) u = inferUfFromCep(zipHint) || '';
                if (!u || u.length < 2) {
                    (0, $jUNyh.notify)("Preencha a UF (estado) do endere\xe7o \u2014 necess\xe1rio para localizar o c\xf3digo IBGE do munic\xedpio.");
                    return null;
                }
                const nv = normalize(v);
                let cities = [];
                try {
                    const res = await (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, `?filter=state*eq*${encodeURIComponent(u)}&limit=500`);
                    cities = Array.isArray(res) ? res : [];
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e));
                    return null;
                }
                let c = cities.length ? cities.find((x)=>normalize(x?.city || '') === nv) : null;
                if (!c && cities.length) c = cities.find((x)=>{
                    const nc = normalize(x?.city || '');
                    return nc.startsWith(nv) || nv.length >= 3 && nc.includes(nv);
                });
                if (c) return String(c.id);
                const via = await ibgeFromViaCep(zipHint, nv, u);
                if (via) return via;
                if (!cities.length) (0, $jUNyh.notify)(`N\xe3o h\xe1 munic\xedpios da UF ${u} dispon\xedveis na base do sistema e o CEP n\xe3o retornou um c\xf3digo IBGE compat\xedvel com \u{201C}${v}\u{201D}. Verifique o CEP ou pe\xe7a a carga da tabela de cidades (IBGE).`, "Aten\xe7\xe3o");
                else (0, $jUNyh.notify)(`Munic\xedpio "${v}" n\xe3o encontrado na UF ${u}. Ajuste o nome ou a UF.`);
                return null;
            };
            const getAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getEmitAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #custody_emit_address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getZipFromDom = ()=>getAddr('zipcode').replace(/\D/g, '');
            const street = (data.address_street || getAddr('street')).trim();
            const number = (data.address_number || getAddr('number')).trim();
            const complement = (data.address_complement || getAddr('complement')).trim() || null;
            const district = (data.address_district || getAddr('district')).trim();
            const zipcode = data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '') || getZipFromDom();
            const stRaw = getAddr('state') || data.address_state || '';
            const state = stRaw ? stRaw.toUpperCase().trim().slice(0, 2) : '';
            let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
            if (cityId != null && String(cityId).trim() !== '') {
                if (!/^\d{7}$/.test(String(cityId).trim())) {
                    const resolved = await resolveCityId(state, cityId, zipcode);
                    if (resolved == null) return false;
                    cityId = resolved;
                } else cityId = String(cityId).trim();
            }
            const rawAddrId = data.address_id;
            const addressIdNum = rawAddrId != null && rawAddrId !== '' && !Number.isNaN(Number(rawAddrId)) ? Number(rawAddrId) : null;
            const emitStreet = (data.custody_emit_address_street || getEmitAddr('street')).trim();
            const emitNumber = (data.custody_emit_address_number || getEmitAddr('number')).trim();
            const emitComplement = (data.custody_emit_address_complement || getEmitAddr('complement')).trim() || null;
            const emitDistrict = (data.custody_emit_address_district || getEmitAddr('district')).trim();
            const emitZip = data.custody_emit_address_zipcode && String(data.custody_emit_address_zipcode).replace(/\D/g, '') || getEmitAddr('zipcode').replace(/\D/g, '');
            const emitStRaw = getEmitAddr('state') || data.custody_emit_address_state || '';
            const emitState = emitStRaw ? emitStRaw.toUpperCase().trim().slice(0, 2) : '';
            let emitCityId = data.custody_emit_address_city_id != null && data.custody_emit_address_city_id !== '' ? data.custody_emit_address_city_id : getEmitAddr('city_id');
            if (emitCityId != null && String(emitCityId).trim() !== '') {
                if (!/^\d{7}$/.test(String(emitCityId).trim())) {
                    const resolvedEm = await resolveCityId(emitState, emitCityId, emitZip);
                    if (resolvedEm == null) return false;
                    emitCityId = resolvedEm;
                } else emitCityId = String(emitCityId).trim();
            }
            const rawEmitAddrId = data.custody_emit_address_id;
            const emitAddrIdNum = rawEmitAddrId != null && rawEmitAddrId !== '' && !Number.isNaN(Number(rawEmitAddrId)) ? Number(rawEmitAddrId) : null;
            let _record = {
                nick: data.nick,
                name: data.name,
                cnpj: data.cnpj,
                ie: data.ie,
                ie_type: data.ie_type,
                phone: data.phone,
                inventory_strategy: data.inventory_strategy,
                crt: data.crt,
                pis: Number(data.pis),
                cofins: Number(data.cofins),
                estimated_taxes: Number(data.estimated_taxes),
                invoice_series: Number(data.invoice_series),
                authorized_parties: data.authorized_parties,
                logo: data.logo,
                fiscal_modality: data.fiscal_modality || '0',
                custody_warehouse_cnpj: data.fiscal_modality === '1' ? data.custody_warehouse_cnpj || null : null,
                custody_emit_name: data.fiscal_modality === '1' ? (data.custody_emit_name || '').trim() || null : null,
                custody_emit_ie: data.fiscal_modality === '1' ? (data.custody_emit_ie || '').trim() || null : null,
                custody_emit_phone: data.fiscal_modality === '1' ? (data.custody_emit_phone || '').trim() || null : null,
                custody_emit_crt: data.fiscal_modality === '1' ? (data.custody_emit_crt || '').trim() || null : null,
                inv_allow_expired: data.inv_allow_expired == '1',
                inv_require_lot: data.inv_require_lot == '1',
                inv_by_program: data.inv_by_program == '1',
                inv_class_blocking: data.inv_class_blocking == '1',
                storage_class_blocking: data.storage_class_blocking == '1',
                inv_conference_tolerance: Number(data.inv_conference_tolerance || 0),
                pkg_use_hierarchy: data.pkg_use_hierarchy == '1',
                pkg_unitarization_enabled: data.pkg_unitarization_enabled == '1',
                pkg_optimize_picking: data.pkg_optimize_picking == '1',
                pkg_allow_tertiary_break: data.pkg_allow_tertiary_break == '1',
                pkg_allow_secondary_break: data.pkg_allow_secondary_break == '1',
                pkg_validate_gtin: data.pkg_validate_gtin == '1',
                pkg_rollback_legacy: data.pkg_rollback_legacy == '1',
                out_enable_box_control: data.out_enable_box_control == '1',
                out_allow_partial_conference: data.out_allow_partial_conference == '1',
                out_require_divergence_auth: data.out_require_divergence_auth == '1',
                out_conference_collector_validation: data.out_conference_collector_validation == '1',
                out_conference_blind_by_packaging: data.out_conference_blind_by_packaging == '1',
                out_dock_expedition_enabled: data.out_dock_expedition_enabled == '1',
                max_orders_per_wave: Number(data.max_orders_per_wave || 120),
                input_orders_require_payment_condition: data.input_orders_require_payment_condition == '1',
                input_orders_require_approval: data.input_orders_require_approval == '1',
                in_dock_scheduling_enabled: data.in_dock_scheduling_enabled == '1',
                output_orders_require_full_fulfillment: data.output_orders_require_full_fulfillment === true || data.output_orders_require_full_fulfillment === '1' || data.output_orders_require_full_fulfillment === 1,
                input_collector_strict: data.input_collector_strict == '1',
                nfe_inf_cpl_entrada: data.nfe_inf_cpl_entrada && String(data.nfe_inf_cpl_entrada).trim() ? String(data.nfe_inf_cpl_entrada).trim() : null,
                nfe_inf_cpl_saida: data.nfe_inf_cpl_saida && String(data.nfe_inf_cpl_saida).trim() ? String(data.nfe_inf_cpl_saida).trim() : null,
                nfe_inf_resp_tec_cnpj: (()=>{
                    const d = String(data.nfe_inf_resp_tec_cnpj || '').replace(/\D/g, '');
                    return d.length === 14 ? d : null;
                })(),
                nfe_inf_resp_tec_contato: data.nfe_inf_resp_tec_contato && String(data.nfe_inf_resp_tec_contato).trim() ? String(data.nfe_inf_resp_tec_contato).trim() : null,
                nfe_inf_resp_tec_email: data.nfe_inf_resp_tec_email && String(data.nfe_inf_resp_tec_email).trim() ? String(data.nfe_inf_resp_tec_email).trim() : null,
                nfe_inf_resp_tec_fone: data.nfe_inf_resp_tec_fone && String(data.nfe_inf_resp_tec_fone).trim() ? String(data.nfe_inf_resp_tec_fone).trim() : null
            };
            if (addressIdNum || street || number || district || zipcode || cityId) _record['address'] = {
                id: addressIdNum,
                street: street || null,
                number: number || null,
                complement: complement,
                district: district || null,
                zipcode: zipcode || null,
                city_id: cityId || null
            };
            if (data.fiscal_modality === '1') _record['custody_emit_address'] = emitAddrIdNum || emitStreet || emitNumber || emitDistrict || emitZip || emitCityId ? {
                id: emitAddrIdNum,
                street: emitStreet || null,
                number: emitNumber || null,
                complement: emitComplement,
                district: emitDistrict || null,
                zipcode: emitZip || null,
                city_id: emitCityId || null
            } : null;
            else _record['custody_emit_address'] = null;
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_company, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_company, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Identificador da empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'nick',
            label: 'Apelido',
            types: [],
            placeholder: '',
            title: 'Nome curto da empresa'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 4,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $aYyoz.default()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 5,
            field: 'ie',
            label: 'IE',
            types: [
                $gF6P4.default()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 6,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        //{ index: 7, field: 'iest', label: 'IEST', types: [], placeholder: '', title: 'Inscrição Estadual do Substituto Tributário' },
        {
            index: 8,
            field: 'phone',
            label: 'Fone',
            types: [
                $jHqD0.default()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 10,
            field: 'inventory_strategy',
            label: "Invent\xe1rio",
            types: [
                $7090be8ac1a98b2f$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Estrat\xe9gia de invent\xe1rio"
        },
        {
            index: 11,
            field: 'crt',
            label: 'CRT',
            types: [
                $6fc24243d89a5cc8$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "C\xf3digo de Regime Tribut\xe1rio"
        },
        {
            index: 12,
            field: 'pis',
            label: 'PIS',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "Al\xedquota de PIS"
        },
        {
            index: 13,
            field: 'cofins',
            label: 'COFINS',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "Al\xedquota de COFINS"
        },
        {
            index: 14,
            field: 'estimated_taxes',
            label: 'Tributos',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Percentual estimado de tributos federais, estaduais e municipais'
        },
        {
            index: 15,
            field: 'invoice_series',
            label: "S\xe9rie",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "S\xe9rie da NFe"
        },
        {
            index: 16,
            field: 'authorized_parties',
            label: 'Autorizados',
            types: [
                $fY6pa.default()
            ],
            placeholder: '',
            title: 'CPF ou CNPJ das pessoas autorizadas a acessar o XML da NFe'
        },
        {
            index: 17,
            field: 'fiscal_modality',
            label: 'Modalidade',
            types: [],
            placeholder: '',
            title: "Modalidade fiscal: Normal ou Fiel deposit\xe1rio"
        },
        {
            index: 18,
            field: 'custody_warehouse_cnpj',
            label: 'CNPJ armazenador',
            types: [
                $aYyoz.default()
            ],
            placeholder: '00.000.000/0000-00',
            title: "CNPJ que armazena (quando fiel deposit\xe1rio)"
        }
    ];
    companies_crud.run('companies', 'Empresas', document.getElementById('workarea'), (0, $62f41054efe4ec85$export$2e2bcd8739ae039), (0, $367c2691d157ba2f$export$2e2bcd8739ae039), fieldspecs);
};
var $4e09ec6288da1fd7$export$2e2bcd8739ae039 = $4e09ec6288da1fd7$var$companies;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $jHqD0 = parcelRequire("jHqD0");
async function $0c33a9bef52e4642$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; max-width: 15rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Fornecedor</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($k93VN.default(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format($gbkt2.default(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($aYyoz.default(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($gF6P4.default(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($a5v7C.default(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($jHqD0.default(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($lVBv9.default(), record.email)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}


parcelRequire("9VcS9");

var $e3m9R = parcelRequire("e3m9R");
var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $9PIz7 = parcelRequire("9PIz7");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6lTH5 = parcelRequire("6lTH5");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $3HbPC = parcelRequire("3HbPC");
var $jHqD0 = parcelRequire("jHqD0");
var $6Jl4s = parcelRequire("6Jl4s");
var $ab5683342c6e6a5e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#supplier #company_id			{ width: 10rem;		}
			#supplier #id					{ width: 5rem; text-align: right;	}
			#supplier #type					{ width: 4rem;		}
			#supplier #nick					{ width: 28rem;		}
			#supplier #name					{ width: 28rem; 	}
			#supplier #email				{ width: 20rem;		}
			#supplier #cpf					{ width: 8rem;		}
			#supplier #cnpj					{ width: 10rem; 	}
			#supplier #ie					{ width: 8rem; 		}
			#supplier #ie_type				{ width: 10rem;		}
			#supplier #phone				{ width: 10rem;		}
			#supplier #address_street		{ width: 26rem;		}
			#supplier #address_number		{ width: 6rem;		}
			#supplier #address_complement	{ width: 15rem;		}
			#supplier #address_district		{ width: 20rem;		}
			#supplier #address_state		{ width: 3.5rem;	}
			#supplier #address_city_id		{ width: 17rem;		}
			#supplier #address_zipcode		{ width: 6rem;		}
		</style>
		<form id="supplier" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do fornecedor">Fornecedor
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jur\xeddica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Nome curto do fornecedor">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Nome da rua ou avenida">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="N\xfamero">N\xfamero
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Munic\xedpio">Munic\xedpio
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<span class="cep-hint" style="font-size:0.85em;color:var(--color-muted,#666);">Digite o CEP e saia do campo para preencher automaticamente (logradouro, bairro, UF, munic\xedpio).</span>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#supplier',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $k93VN.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#cpf'
            },
            types: [
                $gbkt2.default()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $aYyoz.default()
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $gF6P4.default()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $jHqD0.default()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $lVBv9.default()
            ]
        },
        {
            properties: {
                selector: '#address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_district'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $6Jl4s.default(),
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#address_city_id'
            },
            types: [
                $6Jl4s.default(),
                $74yTJ.default(),
                $6lTH5.default('address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('address_state')
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: [
                $e3m9R.default(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        }
    ]
};



var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $9PIz7 = parcelRequire("9PIz7");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $74yTJ = parcelRequire("74yTJ");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $jHqD0 = parcelRequire("jHqD0");
const $b8958290655d6aea$var$suppliers = function() {
    let suppliers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_suppliers, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('suppliers', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_suppliers, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_supplier, ...JSON.parse(id));
            _record = (0, $b60a2.flatten)(_record, 'address');
            if (_record.address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.address_city_id);
                if (c) {
                    _record['address_state'] = c.state;
                    _record['address_city_id'] = c.city;
                }
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#supplier';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d{7}$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getZipFromDom = ()=>getAddr('zipcode').replace(/\D/g, '');
            const street = (data.address_street || getAddr('street')).trim();
            const number = (data.address_number || getAddr('number')).trim();
            const complement = (data.address_complement || getAddr('complement')).trim() || null;
            const district = (data.address_district || getAddr('district')).trim();
            const zipcode = data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '') || getZipFromDom();
            const state = (data.address_state || getAddr('state')).toUpperCase().trim().slice(0, 2);
            let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
            if (state && cityId) cityId = await resolveCityId(state, cityId);
            let _record = {
                type: data.type,
                nick: data.nick,
                name: data.name,
                cpf: data.cpf,
                cnpj: data.cnpj,
                ie: data.ie,
                ie_type: data.ie_type,
                phone: data.phone,
                email: data.email
            };
            if (data.address_id || street || number || district || zipcode || cityId) _record['address'] = {
                id: data.address_id ? Number(data.address_id) : null,
                street: street || null,
                number: number || null,
                complement: complement,
                district: district || null,
                zipcode: zipcode || null,
                city_id: cityId || null
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_supplier, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_supplier, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Fornecedor',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "CNPJ + apelido \u2014 selecione na lista",
            store: 'suppliers',
            labels: [
                'cnpj',
                'nick'
            ]
        },
        {
            index: 3,
            field: 'type',
            label: 'Tipo',
            types: [
                $k93VN.default()
            ],
            placeholder: '',
            title: "Tipo de personalidade jur\xeddica"
        },
        {
            index: 4,
            field: 'nick',
            label: 'Apelido',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome curto do fornecedor'
        },
        {
            index: 5,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 6,
            field: 'cpf',
            label: 'CPF',
            types: [
                $gbkt2.default()
            ],
            placeholder: '000.000.000-00',
            title: "N\xfamero do CPF"
        },
        {
            index: 7,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $aYyoz.default()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 8,
            field: 'ie',
            label: 'IE',
            types: [
                $gF6P4.default()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 9,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        {
            index: 10,
            field: 'phone',
            label: 'Fone',
            types: [
                $jHqD0.default()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 11,
            field: 'email',
            label: 'Email',
            types: [
                $lVBv9.default()
            ],
            placeholder: 'abc@xyz.com',
            title: 'Email'
        }
    ];
    suppliers_crud.run('suppliers', 'Fornecedores', document.getElementById('workarea'), (0, $0c33a9bef52e4642$export$2e2bcd8739ae039), (0, $ab5683342c6e6a5e$export$2e2bcd8739ae039), fieldspecs);
};
var $b8958290655d6aea$export$2e2bcd8739ae039 = $b8958290655d6aea$var$suppliers;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");

parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $jUNyh = parcelRequire("jUNyh");
const $f657162cc87f545e$var$show = function(b64pdf) {
    let _window = window.open();
    if (_window) _window.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${b64pdf}"></iframe>`);
    else (0, $jUNyh.notify)(`<a href="data:application/pdf;base64,${b64pdf}" download="report.pdf">Clique aqui para obter o relat\xf3rio</a>`, 'Download');
};
var $f657162cc87f545e$export$2e2bcd8739ae039 = $f657162cc87f545e$var$show;



var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $a5v7C = parcelRequire("a5v7C");
var $6R5fG = parcelRequire("6R5fG");
var $k93VN = parcelRequire("k93VN");
var $jHqD0 = parcelRequire("jHqD0");
async function $f6400b2fd5d9b801$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; max-width: 15rem; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: left; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: left; }
			.view td:nth-child(17)	{ text-align: left; }
			.view td:nth-child(18)	{ text-align: center; }
			.view td:nth-child(19)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Cliente</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
					<th data-index="14" data-visible="${this.visible[11]}">Prazo Entrega</th>
					<th data-index="15" data-visible="${this.visible[12]}">Condi\xe7\xe3o Pagto</th>
					<th data-index="16" data-visible="${this.visible[13]}">Pagamento</th>
					<th data-index="17" data-visible="${this.visible[14]}">Lista Pre\xe7os</th>
					<th data-index="18" data-visible="${this.visible[15]}">Rota</th>
					<th data-index="21" data-visible="${this.visible[16]}">Consumidor</th>
					<th data-index="22" data-visible="${this.visible[17]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($k93VN.default(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format($gbkt2.default(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($aYyoz.default(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($gF6P4.default(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($a5v7C.default(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($jHqD0.default(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($lVBv9.default(), record.email)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($3eqAU.default(0), record.delivery_term)}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('payment_terms', [
            record.payment_term_id
        ]) ?? ''}</td>
					<td data-visible='${this.visible[13]}'>${this.option($6R5fG.default(), record.payment_method) || ''}</td>
					<td data-visible='${this.visible[14]}'>${await this.key('price_lists', [
            record.price_list_id
        ]) ?? ''}</td>
					<td data-visible='${this.visible[15]}'>${record.route_id ? `${record.route_code || ''}${record.route_name ? ` \u{2014} ${record.route_name}` : ''}`.trim() : ''}</td>
					<td data-visible='${this.visible[16]}'>${this.option($1Wvh7.default(), record.is_end_consumer)}</td>
					<td data-visible='${this.visible[17]}'>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $e3m9R = parcelRequire("e3m9R");
var $5Aed9 = parcelRequire("5Aed9");
var $gbkt2 = parcelRequire("gbkt2");
var $9PIz7 = parcelRequire("9PIz7");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $a5v7C = parcelRequire("a5v7C");
var $6R5fG = parcelRequire("6R5fG");
var $k93VN = parcelRequire("k93VN");
var $3HbPC = parcelRequire("3HbPC");
var $jHqD0 = parcelRequire("jHqD0");
var $6Jl4s = parcelRequire("6Jl4s");
var $5090ba71e405782b$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#customer #company_id					{ width: 10rem;		}
			#customer #id							{ width: 5rem; text-align: right;	}
			#customer #payment_term_id				{ width: 11rem; 	}
			#customer #payment_method				{ width: 11rem; 	}
			#customer #price_list_id				{ width: 11rem; 	}
			#customer #route_id					{ width: 14rem; 	}
			#customer #delivery_term				{ width: 4rem; 		}
			#customer #type							{ width: 4rem;		}
			#customer #nick							{ width: 18rem;		}
			#customer #name							{ width: 20rem; 	}
			#customer #email						{ width: 15rem;		}
			#customer #phone						{ width: 10rem;		}
			#customer #cpf							{ width: 10rem;		}
			#customer #cnpj							{ width: 11rem; 	}
			#customer #ie							{ width: 10rem; 	}
			#customer #ie_type						{ width: 11rem;		}
			#customer #billing_address_street		{ width: 20rem;		}
			#customer #billing_address_number		{ width: 5rem;		}
			#customer #billing_address_complement	{ width: 10rem;		}
			#customer #billing_address_district		{ width: 15rem;		}
			#customer #billing_address_state		{ width: 3.5rem;	}
			#customer #billing_address_city_id		{ width: 15rem;		}
			#customer #billing_address_zipcode		{ width: 6rem;		}
			#customer #delivery_address_street		{ width: 20rem;		}
			#customer #delivery_address_number		{ width: 5rem;		}
			#customer #delivery_address_complement	{ width: 10rem;		}
			#customer #delivery_address_district	{ width: 15rem;		}
			#customer #delivery_address_state		{ width: 3.5rem;	}
			#customer #delivery_address_city_id		{ width: 15rem;		}
			#customer #delivery_address_zipcode		{ width: 6rem;		}
			#customer fieldset						{ display: inline-block; }
			#customer .addr-hint					{ min-height: 2rem; align-items: center; }
			#customer .cep-hint					{ font-size: 0.85em; color: var(--muted, #666); }
			#customer .cda-section fieldset			{ display: block; width: 100%; box-sizing: border-box; margin-top: 1rem; }
			#customer .cda-table					{ width: 100%; font-size: 0.82em; border-collapse: collapse; margin-top: 0.4rem; }
			#customer .cda-table th, #customer .cda-table td { border-bottom: 1px solid var(--border, #ddd); padding: 0.25rem 0.4rem; text-align: left; }
			#customer .cda-table th				{ background: var(--th-bg, #f4f4f4); font-weight: 600; }
			#customer .cda-table tr.cda-disabled td { color: var(--muted, #999); text-decoration: line-through; }
			#customer .cda-form-area				{ padding: 0.75rem 0; margin-top: 0.5rem; border-top: 1px solid var(--border, #ddd); }
			#customer .cda-form-area b				{ display: block; margin-bottom: 0.4rem; }
			#customer .cda-msg					{ font-size: 0.82em; color: var(--muted, #666); margin: 0.4rem 0; }
		</style>
		<form id="customer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="customer_routes">
			</datalist>
			<datalist id="payment_methods">
			</datalist>
			<datalist id="billing_cities">
			</datalist>
			<datalist id="delivery_cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do cliente">Cliente
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jur\xeddica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Condi\xe7\xe3o de pagamento padr\xe3o">Condi\xe7\xe3o de Pagto
					<input id="payment_term_id" type="text" list="payment_terms">
				</label>
				<label title="Forma de pagamento padr\xe3o para novos pedidos de sa\xedda">Pagamento
					<input id="payment_method" type="text" list="payment_methods">
				</label>
				<label title="Lista de pre\xe7os vinculada ao cliente">Lista de Pre\xe7os
					<input id="price_list_id" type="text" list="price_lists">
				</label>
				<label title="Rota de entrega do cliente">Rota
					<input id="route_id" type="text" list="customer_routes">
				</label>
				<label title="Prazo de entrega em dias">Prazo<sup>*</sup>
					<input id="delivery_term" type="text" placeholder="0" required>
				</label>
				<label title="Cliente \xe9 consumidor final?">Consumidor
					<input id="is_end_consumer" type="checkbox" checked>
				</label>
				<label title="Cliente inativo n\xe3o aparece para novos pedidos de sa\xedda">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="Nome curto do cliente">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
			</div>
			<div class="fsb">
				<fieldset>
					<legend>Endere\xe7o de Faturamento</legend>
					<div class="fsb addr-hint">
						<label title="Usar o mesmo endere\xe7o de entrega para faturamento" style="display:flex;align-items:center;gap:0.5rem;">
							<input id="same_billing_delivery" type="checkbox"> Mesmo endere\xe7o de entrega
						</label>
					</div>
					<input type="hidden" id="billing_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="billing_address_street" type="text">
						</label>
						<label title="N\xfamero">N\xfamero
							<input id="billing_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="billing_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="billing_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="billing_address_state" type="text" list="states">
						</label>
						<label title="Munic\xedpio (ou digite CEP antes para preencher automaticamente)">Munic\xedpio
							<input id="billing_address_city_id" type="text" list="billing_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="billing_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
				<fieldset>
					<legend>Endere\xe7o de Entrega</legend>
					<div class="fsb addr-hint">
						<span class="cep-hint" title="Consulta ViaCEP (base dos Correios)">Digite o CEP e saia do campo para preencher automaticamente</span>
					</div>
					<input type="hidden" id="delivery_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="delivery_address_street" type="text">
						</label>
						<label title="N\xfamero">N\xfamero
							<input id="delivery_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="delivery_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="delivery_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="delivery_address_state" type="text" list="states">
						</label>
						<label title="Munic\xedpio (ou digite CEP antes para preencher automaticamente)">Munic\xedpio
							<input id="delivery_address_city_id" type="text" list="delivery_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="delivery_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
			</div>
			<div class="cda-section" style="width:100%;">
				<fieldset>
					<legend>Endere\xe7os Adicionais de Entrega <span id="cda-count" style="font-size:0.82em;color:var(--muted,#666);font-weight:normal;"></span></legend>
					<p id="cda-no-customer-msg" class="cda-msg">Salve o cliente primeiro para gerenciar endere\xe7os de entrega.</p>
					<div id="cda-list-area" style="display:none;">
						<table class="cda-table" id="cda-table">
							<thead>
								<tr>
									<th>Nome/Local</th>
									<th>Destinat\xe1rio</th>
									<th>Logradouro</th>
									<th>Cidade/UF</th>
									<th>CEP</th>
									<th>Padr\xe3o</th>
									<th>Situa\xe7\xe3o</th>
									<th></th>
								</tr>
							</thead>
							<tbody id="cda-tbody"></tbody>
						</table>
						<p id="cda-empty-msg" class="cda-msg" style="display:none;">Nenhum endere\xe7o adicional cadastrado.</p>
					</div>
					<div id="cda-form-area" class="cda-form-area" style="display:none;">
						<b id="cda-form-title">Novo Endere\xe7o</b>
						<div class="fsb">
							<label>Nome/Identifica\xe7\xe3o<sup>*</sup>
								<input id="cda_name" type="text" style="width:18rem;" placeholder="Ex.: CD Campinas, Filial SP">
							</label>
							<label>Destinat\xe1rio
								<input id="cda_receiver_name" type="text" style="width:15rem;">
							</label>
							<label>CNPJ/CPF Dest.
								<input id="cda_document" type="text" style="width:12rem;">
							</label>
							<label>Telefone
								<input id="cda_phone" type="text" style="width:10rem;">
							</label>
						</div>
						<div class="fsb">
							<label>Logradouro<sup>*</sup>
								<input id="cda_street" type="text" style="width:20rem;">
							</label>
							<label>N\xfamero
								<input id="cda_number" type="text" style="width:5rem;">
							</label>
							<label>Complemento
								<input id="cda_complement" type="text" style="width:10rem;">
							</label>
							<label>Bairro
								<input id="cda_district" type="text" style="width:12rem;">
							</label>
						</div>
						<div class="fsb">
							<label>CEP
								<input id="cda_zipcode" type="text" style="width:7rem;" placeholder="00000-000">
							</label>
							<label>Cidade<sup>*</sup>
								<input id="cda_city" type="text" style="width:14rem;">
							</label>
							<label>UF<sup>*</sup>
								<input id="cda_state" type="text" style="width:3.5rem;" maxlength="2" placeholder="SP">
							</label>
							<label>Pa\xeds
								<input id="cda_country" type="text" style="width:8rem;">
							</label>
							<label title="Marcar como endere\xe7o padr\xe3o deste cliente">Padr\xe3o
								<input id="cda_is_default" type="checkbox">
							</label>
						</div>
						<div class="fsb">
							<label>Observa\xe7\xf5es
								<input id="cda_notes" type="text" style="width:34rem;">
							</label>
						</div>
						<div style="display:flex;gap:0.5rem;margin-top:0.4rem;">
							<button type="button" id="cda-save-btn" class="button">Salvar Endere\xe7o</button>
							<button type="button" id="cda-cancel-btn" class="button">Cancelar</button>
						</div>
					</div>
					<div id="cda-add-area" style="display:none;margin-top:0.4rem;">
						<button type="button" id="cda-add-btn" class="button" style="font-size:0.82em;">+ Adicionar Endere\xe7o de Entrega</button>
					</div>
				</fieldset>
			</div>
		<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#customer',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const sel = formset.form.selector;
            const typeEl = document.querySelector(`${sel} #type`);
            const cnpjEl = document.querySelector(`${sel} #cnpj`);
            const cnpjLabel = cnpjEl?.closest('label');
            const toggleCnpjForTypeL = ()=>{
                if (!typeEl || !cnpjEl) return;
                const isLocal = typeEl.value?.trim() === 'L';
                cnpjEl.placeholder = isLocal ? "C\xf3d. GSNet (ex.: 1233)" : '00.000.000/0000-00';
                cnpjEl.title = isLocal ? "C\xf3digo GSNet (alfanum\xe9rico, at\xe9 10 caracteres)" : "N\xfamero do CNPJ";
                if (cnpjLabel) cnpjLabel.title = cnpjEl.title;
            };
            const ieTypeEl = document.querySelector(`${sel} #ie_type`);
            const toggleIeTypeRequired = ()=>{
                const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
                if (ieTypeEl) ieTypeEl.required = !isLocal;
            };
            const ptEl = document.querySelector(`${sel} #payment_term_id`);
            const togglePaymentTermForTypeL = ()=>{
                if (!ptEl) return;
                const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
                if (isLocal) {
                    ptEl.value = '';
                    ptEl.setAttribute('readonly', '');
                } else ptEl.removeAttribute('readonly');
            };
            typeEl?.addEventListener('change', ()=>{
                toggleCnpjForTypeL();
                toggleIeTypeRequired();
                togglePaymentTermForTypeL();
            });
            formset.subscribe?.([
                'open'
            ], ()=>{
                setTimeout(toggleCnpjForTypeL, 0);
                setTimeout(toggleIeTypeRequired, 0);
                setTimeout(togglePaymentTermForTypeL, 0);
                setTimeout(()=>{
                    [
                        'billing_address_state',
                        'delivery_address_state'
                    ].forEach((name)=>{
                        const el = document.querySelector(`${sel} #${name}`);
                        if (el?.value) el.dispatchEvent(new Event('change', {
                            bubbles: true
                        }));
                    });
                    if (sameAddrCb?.checked) copyDeliveryToBilling();
                }, 200);
            });
            setTimeout(toggleCnpjForTypeL, 0);
            setTimeout(toggleIeTypeRequired, 0);
            setTimeout(togglePaymentTermForTypeL, 0);
            const sameAddrCb = document.querySelector(`${sel} #same_billing_delivery`);
            const copyDeliveryToBilling = ()=>{
                if (!sameAddrCb?.checked) return;
                [
                    'street',
                    'number',
                    'complement',
                    'district',
                    'state',
                    'city_id',
                    'zipcode'
                ].forEach((f)=>{
                    const src = document.querySelector(`${sel} #delivery_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
                    const dst = document.querySelector(`${sel} #billing_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
                    if (src && dst) {
                        dst.value = src.value;
                        dst.dispatchEvent(new Event('change', {
                            bubbles: true
                        }));
                    }
                });
            };
            sameAddrCb?.addEventListener('change', copyDeliveryToBilling);
            [
                'street',
                'number',
                'complement',
                'district',
                'state',
                'city_id',
                'zipcode'
            ].forEach((suffix)=>{
                const f = suffix === 'state' ? 'state' : suffix === 'city_id' ? 'city_id' : suffix;
                document.querySelector(`${sel} #delivery_address_${f}`)?.addEventListener('blur', copyDeliveryToBilling);
            });
            // ── Endereços adicionais de entrega ──────────────────────────────────────
            let _cdaData = [];
            let _cdaEditId = null;
            const cda = (id)=>document.querySelector(`${sel} #${id}`);
            const cdaEsc = (v)=>String(v ?? '').replace(/[&<>"']/g, (ch)=>({
                        '&': '&amp;',
                        '<': '&lt;',
                        '>': '&gt;',
                        '"': '&quot;',
                        "'": '&#39;'
                    })[ch]);
            const CDA_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            const cdaParseId = (raw)=>{
                if (raw == null || String(raw).trim() === '') return null;
                const n = Number(String(raw).replace(/\./g, '').replace(',', '.'));
                return Number.isFinite(n) && n > 0 ? Math.trunc(n) : null;
            };
            const cdaResolveCompanyId = (raw)=>{
                if (raw == null || String(raw).trim() === '') return null;
                const s = String(raw).trim();
                if (CDA_UUID.test(s)) return s;
                const list = document.querySelector(`${sel} datalist#companies`);
                const opt = list && [
                    ...list.options
                ].find((o)=>String(o.value).trim() === s || String(o.textContent || '').trim() === s);
                const v = opt?.value?.trim();
                return v && CDA_UUID.test(v) ? v : null;
            };
            const cdaCustomerId = ()=>{
                const vals = formset?.form?.getValues?.() || {};
                return cdaParseId(vals.id) ?? cdaParseId(formset?.form?.getFieldBySelector?.('#id')?.getValue?.()) ?? cdaParseId(cda('id')?.value);
            };
            const cdaCompanyId = ()=>{
                const vals = formset?.form?.getValues?.() || {};
                return cdaResolveCompanyId(vals.company_id) ?? cdaResolveCompanyId(formset?.form?.getFieldBySelector?.('#company_id')?.getValue?.()) ?? cdaResolveCompanyId(cda('company_id')?.value);
            };
            // IDs virtuais do cadastro principal (API) — não entram na grade de adicionais.
            // Inclui legado -1/-2 (antes colidia com “vazio” do datalist no pedido).
            const CDA_VIRTUAL_IDS = new Set([
                2000000001,
                2000000002,
                -1,
                -2
            ]);
            const cdaIsAdditional = (r)=>r && !CDA_VIRTUAL_IDS.has(Number(r.id));
            const cdaShowList = ()=>{
                cda('cda-list-area').style.display = '';
                cda('cda-add-area').style.display = '';
                cda('cda-no-customer-msg').style.display = 'none';
            };
            const cdaShowNeedSave = (msg)=>{
                const el = cda('cda-no-customer-msg');
                if (el) {
                    el.textContent = msg || "Salve o cliente primeiro para gerenciar endere\xe7os de entrega.";
                    el.style.display = '';
                }
                const list = cda('cda-list-area');
                if (list) list.style.display = 'none';
                const add = cda('cda-add-area');
                if (add) add.style.display = 'none';
            };
            const cdaRenderTable = (rows)=>{
                const tbody = cda('cda-tbody');
                const count = cda('cda-count');
                if (!tbody) return;
                tbody.innerHTML = '';
                const active = rows.filter((r)=>!r.is_disabled);
                if (count) count.textContent = rows.length ? `(${rows.length})` : '';
                if (!rows.length) {
                    cda('cda-empty-msg').style.display = '';
                    cda('cda-table').style.display = 'none';
                    return;
                }
                cda('cda-empty-msg').style.display = 'none';
                cda('cda-table').style.display = '';
                rows.forEach((r)=>{
                    const tr = document.createElement('tr');
                    if (r.is_disabled) tr.classList.add('cda-disabled');
                    const addrLine = [
                        r.street,
                        r.number,
                        r.complement
                    ].filter(Boolean).join(', ');
                    const cityUf = [
                        r.city,
                        r.state
                    ].filter(Boolean).join('/');
                    const padrao = r.is_default ? "\u2605" : '';
                    const status = r.is_disabled ? 'Inativo' : 'Ativo';
                    tr.innerHTML = `
						<td>${cdaEsc(r.name)}</td>
						<td>${cdaEsc(r.receiver_name)}</td>
						<td>${cdaEsc(addrLine)}</td>
						<td>${cdaEsc(cityUf)}</td>
						<td>${cdaEsc(r.zipcode)}</td>
						<td style="text-align:center;">${padrao}</td>
						<td>${status}</td>
						<td style="white-space:nowrap;">
							<button type="button" class="button cda-edit-btn" data-id="${r.id}" style="font-size:0.78em;padding:0.1rem 0.4rem;">Editar</button>
							${!r.is_disabled ? `<button type="button" class="button cda-disable-btn" data-id="${r.id}" style="font-size:0.78em;padding:0.1rem 0.4rem;margin-left:0.25rem;">Desativar</button>` : `<button type="button" class="button cda-enable-btn" data-id="${r.id}" style="font-size:0.78em;padding:0.1rem 0.4rem;margin-left:0.25rem;">Ativar</button>`}
						</td>`;
                    tbody.appendChild(tr);
                });
            };
            const cdaLoadAddresses = async ()=>{
                const cid = cdaCustomerId();
                const comId = cdaCompanyId();
                if (!cid || !comId) {
                    cdaShowNeedSave();
                    return;
                }
                try {
                    const result = await (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_delivery_addresses, comId, cid);
                    const rows = Array.isArray(result) ? result : [];
                    _cdaData = rows.filter(cdaIsAdditional);
                    cdaShowList();
                    cdaRenderTable(_cdaData);
                } catch (e) {
                    cdaShowNeedSave("N\xe3o foi poss\xedvel carregar os endere\xe7os adicionais. Verifique a permiss\xe3o de listagem ou tente novamente.");
                }
            };
            const cdaClearForm = ()=>{
                [
                    'name',
                    'receiver_name',
                    'document',
                    'phone',
                    'zipcode',
                    'street',
                    'number',
                    'complement',
                    'district',
                    'city',
                    'state',
                    'notes'
                ].forEach((f)=>{
                    const el = cda(`cda_${f}`);
                    if (el) el.value = '';
                });
                const defEl = cda('cda_is_default');
                if (defEl) defEl.checked = false;
                const countryEl = cda('cda_country');
                if (countryEl) countryEl.value = 'Brasil';
            };
            const cdaOpenForm = (title, addr = {})=>{
                _cdaEditId = addr.id || null;
                cda('cda-form-title').textContent = title;
                cda('cda_name').value = addr.name || '';
                cda('cda_receiver_name').value = addr.receiver_name || '';
                cda('cda_document').value = addr.document || '';
                cda('cda_phone').value = addr.phone || '';
                cda('cda_zipcode').value = addr.zipcode || '';
                cda('cda_street').value = addr.street || '';
                cda('cda_number').value = addr.number || '';
                cda('cda_complement').value = addr.complement || '';
                cda('cda_district').value = addr.district || '';
                cda('cda_city').value = addr.city || '';
                cda('cda_state').value = addr.state || '';
                cda('cda_country').value = addr.country || 'Brasil';
                cda('cda_notes').value = addr.notes || '';
                const defEl = cda('cda_is_default');
                if (defEl) defEl.checked = !!addr.is_default;
                cda('cda-form-area').style.display = '';
                cda('cda-add-btn').style.display = 'none';
                cda('cda_name').focus();
            };
            const cdaCloseForm = ()=>{
                _cdaEditId = null;
                cda('cda-form-area').style.display = 'none';
                cda('cda-add-btn').style.display = '';
                cdaClearForm();
            };
            const cdaSave = async ()=>{
                const cid = cdaCustomerId();
                const comId = cdaCompanyId();
                if (!cid || !comId) {
                    alert("Salve o cliente antes de adicionar endere\xe7os.");
                    return;
                }
                const data = {
                    name: cda('cda_name')?.value?.trim(),
                    receiver_name: cda('cda_receiver_name')?.value?.trim() || null,
                    document: cda('cda_document')?.value?.trim() || null,
                    phone: cda('cda_phone')?.value?.trim() || null,
                    zipcode: cda('cda_zipcode')?.value?.trim() || null,
                    street: cda('cda_street')?.value?.trim(),
                    number: cda('cda_number')?.value?.trim() || null,
                    complement: cda('cda_complement')?.value?.trim() || null,
                    district: cda('cda_district')?.value?.trim() || null,
                    city: cda('cda_city')?.value?.trim(),
                    state: cda('cda_state')?.value?.trim()?.toUpperCase(),
                    country: cda('cda_country')?.value?.trim() || 'Brasil',
                    is_default: cda('cda_is_default')?.checked || false,
                    notes: cda('cda_notes')?.value?.trim() || null
                };
                try {
                    if (_cdaEditId) await (0, $9VcS9.default).call((0, $9VcS9.default).update_customer_delivery_address, comId, cid, _cdaEditId, data);
                    else await (0, $9VcS9.default).call((0, $9VcS9.default).insert_customer_delivery_address, comId, cid, data);
                    cdaCloseForm();
                    await cdaLoadAddresses();
                } catch (e) {
                // erro já exibido pelo notifyRejection via api.call
                }
            };
            // Botões estáticos
            cda('cda-add-btn')?.addEventListener('click', ()=>cdaOpenForm("Novo Endere\xe7o"));
            cda('cda-save-btn')?.addEventListener('click', cdaSave);
            cda('cda-cancel-btn')?.addEventListener('click', cdaCloseForm);
            // Delegação para botões dinâmicos da tabela
            cda('cda-tbody')?.addEventListener('click', async (e)=>{
                const btn = e.target.closest('button');
                if (!btn) return;
                const addrId = Number(btn.dataset.id);
                const cid = cdaCustomerId();
                const comId = cdaCompanyId();
                if (btn.classList.contains('cda-edit-btn')) {
                    const addr = _cdaData.find((a)=>a.id === addrId);
                    if (addr) cdaOpenForm("Editar Endere\xe7o", addr);
                } else if (btn.classList.contains('cda-disable-btn')) {
                    if (!confirm("Desativar este endere\xe7o?")) return;
                    try {
                        await (0, $9VcS9.default).call((0, $9VcS9.default).patch_customer_delivery_address, comId, cid, addrId, {
                            is_disabled: true
                        });
                        await cdaLoadAddresses();
                    } catch (e) {}
                } else if (btn.classList.contains('cda-enable-btn')) try {
                    await (0, $9VcS9.default).call((0, $9VcS9.default).patch_customer_delivery_address, comId, cid, addrId, {
                        is_disabled: false
                    });
                    await cdaLoadAddresses();
                } catch (e) {}
            });
            this._cdaCloseForm = cdaCloseForm;
            this._cdaLoadAddresses = cdaLoadAddresses;
        },
        afterEditSetValues (fs) {
            const form = fs?.form || this;
            form._cdaCloseForm?.();
            const load = ()=>form._cdaLoadAddresses?.();
            load();
            setTimeout(load, 400);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $k93VN.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#cpf'
            },
            types: [
                $gbkt2.default()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $7df6175fce9b618d$export$2e2bcd8739ae039('#customer')
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $gF6P4.default()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $jHqD0.default()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $lVBv9.default()
            ]
        },
        {
            properties: {
                selector: '#billing_address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#billing_address_street'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#billing_address_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#billing_address_complement'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#billing_address_district'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#billing_address_state'
            },
            types: [
                $6Jl4s.default(),
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#billing_address_city_id'
            },
            types: [
                $6Jl4s.default(),
                $74yTJ.default(),
                $6lTH5.default('billing_address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('billing_address_state')
            ]
        },
        {
            properties: {
                selector: '#billing_address_zipcode'
            },
            types: [
                $e3m9R.default(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#delivery_address_street'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_complement'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_district'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_state'
            },
            types: [
                $6Jl4s.default(),
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#delivery_address_city_id'
            },
            types: [
                $6Jl4s.default(),
                $74yTJ.default(),
                $6lTH5.default('delivery_address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('delivery_address_state')
            ]
        },
        {
            properties: {
                selector: '#delivery_address_zipcode'
            },
            types: [
                $e3m9R.default(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#delivery_term'
            },
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            properties: {
                selector: '#payment_term_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('payment_terms')
            ]
        },
        {
            properties: {
                selector: '#payment_method'
            },
            types: [
                $6R5fG.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#price_list_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('price_lists')
            ]
        },
        {
            properties: {
                selector: '#route_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('customer_routes', {
                    labels: [
                        'code',
                        'name'
                    ],
                    sep: " \u2014 ",
                    filter: (r)=>!(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1')
                })
            ]
        },
        {
            properties: {
                selector: '#is_end_consumer'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $h1m6J = parcelRequire("h1m6J");

var $9PIz7 = parcelRequire("9PIz7");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $3HbPC = parcelRequire("3HbPC");
var $6Jl4s = parcelRequire("6Jl4s");
var $01cf9ca6533f8dd0$export$2e2bcd8739ae039 = {
    html: `
		<form id="customers-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="person_types"></datalist>
			<datalist id="ie_types"></datalist>
			<datalist id="states"></datalist>
			<p class="fss">Filtros opcionais. Deixe em branco para imprimir todos os clientes.</p>
			<div class="fsb">
				<label>Empresa
					<input id="company_id" type="text" list="companies">
				</label>
				<label>Estado (UF)
					<input id="billing_state" type="text" list="states" placeholder="ex: SP">
				</label>
				<label>Tipo
					<input id="type" type="text" list="person_types" placeholder="F, J ou L">
				</label>
			</div>
			<div class="fsb">
				<label>Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
				<label>Consumidor
					<select id="is_end_consumer">
						<option value="">Todos</option>
						<option value="1">Sim</option>
						<option value="0">N\xe3o</option>
					</select>
				</label>
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#customers-print-report',
        init (formset) {
            const sel = formset.form?.selector || '#customers-print-report';
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const optPerson = $k93VN.default();
            if (optPerson?.options) (0, $h1m6J.loadOptions)(`${sel} #type`, optPerson.options, 'value', [
                'label'
            ]);
            const optIe = $a5v7C.default();
            if (optIe?.options) (0, $h1m6J.loadOptions)(`${sel} #ie_type`, optIe.options, 'value', [
                'label'
            ]);
            const optUf = $3HbPC.default();
            if (optUf?.options) (0, $h1m6J.loadOptions)(`${sel} #billing_state`, optUf.options, 'value', [
                'label'
            ]);
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#billing_state'
            },
            types: [
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#is_end_consumer'
            },
            types: []
        },
        {
            properties: {
                selector: '#format'
            },
            types: []
        },
        {
            properties: {
                selector: '#count-msg'
            },
            types: []
        }
    ]
};



var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $9PIz7 = parcelRequire("9PIz7");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $a5v7C = parcelRequire("a5v7C");
var $6R5fG = parcelRequire("6R5fG");
var $k93VN = parcelRequire("k93VN");
var $jHqD0 = parcelRequire("jHqD0");
const $814cf36e1b964bdf$var$customers = function() {
    let customers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async addFilter (params) {
            await (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).addFilter.call(this, params);
            if (this.filter && JSON.stringify(this.filter).includes('is_disabled')) params.append('include_disabled', '1');
        },
        editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            try {
                this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
                this.loadPage(1);
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || 'Erro ao aplicar filtro.', 'Filtro');
                console.error('applyFilter', e);
            }
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_payment_terms, this.queryAll()).then((data)=>(0, $1cmSR.default).set('payment_terms', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_price_lists, this.queryAll()).then((data)=>(0, $1cmSR.default).set('price_lists', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_routes, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customer_routes', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_customer, ...JSON.parse(id));
            _record = (0, $b60a2.flatten)(_record, 'billing_address');
            _record = (0, $b60a2.flatten)(_record, 'delivery_address');
            if (_record.billing_address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.billing_address_city_id);
                if (c) {
                    _record['billing_address_state'] = c.state;
                    _record['billing_address_city_id'] = c.city;
                }
            }
            if (_record.delivery_address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.delivery_address_city_id);
                if (c) {
                    _record['delivery_address_state'] = c.state;
                    _record['delivery_address_city_id'] = c.city;
                }
            }
            if (_record.route_id) {
                const key = [
                    _record.company_id,
                    _record.route_id
                ];
                const existing = await (0, $1cmSR.default).get('customer_routes', key).catch(()=>null);
                if (!existing) await (0, $1cmSR.default).set('customer_routes', [
                    {
                        company_id: _record.company_id,
                        id: _record.route_id,
                        code: _record.route_code || String(_record.route_id),
                        name: _record.route_name || '',
                        is_disabled: true
                    }
                ]).catch(()=>{});
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#customer';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d+$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getStateFromDom = (prefix)=>{
                const el = document.querySelector(`${sel} #${prefix}_address_state`);
                return el?.value ? String(el.value).trim().toUpperCase().slice(0, 2) : '';
            };
            const ensureAddress = (addr, copyFrom)=>{
                const base = copyFrom || {};
                const o = {
                    id: addr?.id ?? base.id,
                    street: String(addr?.street ?? base.street ?? '').trim(),
                    number: String(addr?.number ?? base.number ?? '').trim(),
                    complement: String(addr?.complement ?? base.complement ?? '').trim() || null,
                    district: String(addr?.district ?? base.district ?? '').trim(),
                    zipcode: String(addr?.zipcode ?? base.zipcode ?? '').replace(/\D/g, ''),
                    city_id: addr?.city_id ?? base.city_id ?? null,
                    state: String(addr?.state ?? base.state ?? '').trim().toUpperCase().slice(0, 2) || null
                };
                if (!o.state && o.city_id && !/^\d{7}$/.test(String(o.city_id))) o.state = getStateFromDom('delivery') || getStateFromDom('billing');
                const hasData = o.street || o.number || o.district || o.zipcode || o.city_id;
                if (!hasData) return null;
                if (o.id != null) {
                    o.id = Number(o.id);
                    if (!o.id || o.id <= 0) delete o.id;
                }
                return o;
            };
            const sameAddress = document.querySelector(`${sel} #same_billing_delivery`)?.checked;
            if (data.billing_address_state && data.billing_address_city_id) data.billing_address_city_id = await resolveCityId(data.billing_address_state, data.billing_address_city_id);
            if (data.delivery_address_state && data.delivery_address_city_id) data.delivery_address_city_id = await resolveCityId(data.delivery_address_state, data.delivery_address_city_id);
            const getZipFromDom = (prefix)=>{
                const el = document.querySelector(`${sel} #${prefix}_address_zipcode`);
                return el?.value ? String(el.value).replace(/\D/g, '') : '';
            };
            Object.keys(data).forEach((key)=>{
                let parts = key.match(/^((?:billing|delivery)_address)_(\w+)$/);
                if (!parts) return;
                if (!data[parts[1]]) data[parts[1]] = {};
                data[parts[1]][parts[2]] = data[key];
                delete data[key];
            });
            let billing = data.billing_address || {};
            let delivery = data.delivery_address || {};
            if (!delivery.zipcode || String(delivery.zipcode).replace(/\D/g, '') === '') delivery.zipcode = getZipFromDom('delivery');
            if (!billing.zipcode || String(billing.zipcode).replace(/\D/g, '') === '') billing.zipcode = document.querySelector(`${sel} #same_billing_delivery`)?.checked ? getZipFromDom('delivery') : getZipFromDom('billing');
            if (sameAddress) {
                const keys = [
                    'street',
                    'number',
                    'complement',
                    'district',
                    'zipcode',
                    'city_id',
                    'state'
                ];
                const merged = {};
                keys.forEach((k)=>{
                    const vb = delivery?.[k];
                    const va = billing?.[k];
                    merged[k] = vb != null && String(vb).trim() !== '' ? vb : va != null && String(va).trim() !== '' ? va : va ?? vb;
                });
                merged.id = billing?.id ?? delivery?.id;
                billing = merged;
                delivery = merged;
            }
            const billAddr = ensureAddress(billing);
            const delAddr = ensureAddress(delivery);
            data.billing_address = billAddr;
            data.delivery_address = delAddr;
            let company_id = data.company_id;
            let id = data.id;
            delete data['company_id'];
            delete data['id'];
            data.delivery_term = Number(data.delivery_term);
            const isLocal = data.type === 'L' || data.type?.toUpperCase?.() === 'L';
            const pt = Number(data.payment_term_id);
            data.payment_term_id = isLocal || !data.payment_term_id || data.payment_term_id === '' || isNaN(pt) || pt < 1 ? null : pt;
            data.payment_method = data.payment_method ? String(data.payment_method).trim() : null;
            const pl = Number(data.price_list_id);
            data.price_list_id = !data.price_list_id || data.price_list_id === '' || isNaN(pl) || pl < 1 ? null : pl;
            const ri = Number(data.route_id);
            data.route_id = !data.route_id || data.route_id === '' || isNaN(ri) || ri < 1 ? null : ri;
            data.is_end_consumer = data.is_end_consumer == '1'; // Can be: undefined, '0', '1'
            data.is_disabled = data.is_disabled == '1';
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_customer, company_id, id, data);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_customer, company_id, data);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Cliente',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do cliente'
        },
        {
            index: 3,
            field: 'type',
            label: 'Tipo',
            types: [
                $k93VN.default()
            ],
            placeholder: '',
            title: "Tipo de personalidade jur\xeddica"
        },
        {
            index: 4,
            field: 'nick',
            label: 'Apelido',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Nome curto do cliente'
        },
        {
            index: 5,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 6,
            field: 'cpf',
            label: 'CPF',
            types: [
                $gbkt2.default()
            ],
            placeholder: '000.000.000-00',
            title: "N\xfamero do CPF"
        },
        {
            index: 7,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $aYyoz.default()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 8,
            field: 'ie',
            label: 'IE',
            types: [
                $gF6P4.default()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 9,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        {
            index: 10,
            field: 'phone',
            label: 'Fone',
            types: [
                $jHqD0.default()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 11,
            field: 'email',
            label: 'Email',
            types: [
                $lVBv9.default()
            ],
            placeholder: 'abc@xyz.com',
            title: 'Email'
        },
        {
            index: 14,
            field: 'delivery_term',
            label: 'Prazo Entrega',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: 'Prazo de entrega em dias'
        },
        {
            index: 15,
            field: 'payment_term_id',
            label: "Condi\xe7\xe3o Pagto",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Condi\xe7\xe3o de pagamento",
            store: 'payment_terms',
            labels: [
                'name'
            ]
        },
        {
            index: 16,
            field: 'payment_method',
            label: 'Pagamento',
            types: [
                $6R5fG.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Forma de pagamento padr\xe3o"
        },
        {
            index: 17,
            field: 'price_list_id',
            label: "Lista Pre\xe7os",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Lista de pre\xe7os vinculada ao cliente",
            store: 'price_lists',
            labels: [
                'name'
            ]
        },
        {
            index: 18,
            field: 'route_id',
            label: 'Rota',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Rota de entrega do cliente',
            store: 'customer_routes',
            labels: [
                'code',
                'name'
            ]
        },
        {
            index: 21,
            field: 'is_end_consumer',
            label: 'Consumidor',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Indicador de consumidor final'
        },
        {
            index: 22,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Cliente inativo (n\xe3o listado para novos pedidos)"
        }
    ];
    let reports = [
        {
            hash: '#print-customers-report',
            label: "Relat\xf3rio&nbsp;de&nbsp;Clientes"
        }
    ];
    async function buildFilter(data) {
        const parts = [];
        if (data.company_id) {
            const c = await (0, $1cmSR.default).get('companies', data.company_id) || await (0, $1cmSR.default).get('companies', [
                data.company_id
            ]);
            const id = c?.id ?? data.company_id;
            if (id) parts.push(`company_id*eq*${id}`);
        }
        if (data.billing_state) parts.push(`billing_state*eq*${String(data.billing_state).trim().toUpperCase().slice(0, 2)}`);
        if (data.type) parts.push(`type*eq*${String(data.type).trim().toUpperCase().slice(0, 1)}`);
        if (data.ie_type) parts.push(`ie_type*eq*${data.ie_type}`);
        if (data.is_end_consumer !== '' && data.is_end_consumer != null) parts.push(`is_end_consumer*eq*${data.is_end_consumer}`);
        return parts.join(',');
    }
    async function updateCountMsg(formData) {
        const filter = await buildFilter(formData || {});
        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).count_customers_report, {
            filter: filter
        });
        const count = typeof resp === 'number' ? resp : parseInt(resp, 10) || 0;
        const el = document.querySelector('#count-msg');
        if (el) el.textContent = `${count} registro(s) ser\xe3o impressos.`;
    }
    function downloadFile(base64Content, filename, mimeType) {
        const bin = atob(base64Content);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
        const blob = new Blob([
            arr
        ], {
            type: mimeType
        });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename || 'relatorio';
        a.click();
        URL.revokeObjectURL(a.href);
    }
    async function doPrint(data) {
        try {
            const filter = await buildFilter(data);
            const format = (data.format || 'pdf').toLowerCase();
            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_customers_report, {
                filter: filter,
                format: format
            });
            if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            else if (resp?.csv) {
                downloadFile(resp.csv, resp.filename || 'clientes.csv', 'text/csv;charset=utf-8');
                (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
            } else if (resp?.xlsx) {
                downloadFile(resp.xlsx, resp.filename || 'clientes.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
            } else (0, $jUNyh.notify)("Nenhum dado para o relat\xf3rio.", 'Aviso');
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        }
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-customers-report', ()=>{
        const dlg = (0, $b60a2.default).edit((0, $01cf9ca6533f8dd0$export$2e2bcd8739ae039), async (data)=>{
            await doPrint(data);
            dlg.destroy();
        }, {}, false);
        const fs = dlg;
        const formEl = document.querySelector((0, $01cf9ca6533f8dd0$export$2e2bcd8739ae039).form.selector);
        if (formEl) {
            formEl.addEventListener('change', ()=>updateCountMsg(fs.form?.getValues?.()));
            formEl.addEventListener('input', ()=>updateCountMsg(fs.form?.getValues?.()));
        }
        setTimeout(()=>updateCountMsg(fs.form?.getValues?.()), 200);
    });
    customers_crud.run('customers', 'Clientes', document.getElementById('workarea'), (0, $f6400b2fd5d9b801$export$2e2bcd8739ae039), (0, $5090ba71e405782b$export$2e2bcd8739ae039), fieldspecs, [], reports);
};
var $814cf36e1b964bdf$export$2e2bcd8739ae039 = $814cf36e1b964bdf$var$customers;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $b60a2 = parcelRequire("b60a2");

var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");

var $1Wvh7 = parcelRequire("1Wvh7");
async function $922d76c9d91e784d$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(3) { text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Id</th>
					<th data-index="3" data-visible="${this.visible[2]}">C\xf3digo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Nome</th>
					<th data-index="5" data-visible="${this.visible[4]}">Descri\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[5]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.name ?? '').toString()}</td>
					<td data-visible='${this.visible[4]}'>${(record.description ?? '').toString()}</td>
					<td data-visible='${this.visible[5]}'>${this.option($1Wvh7.default(), record.is_disabled)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $450c1bff7d98ea03$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#customer_route #company_id	{ width: 10rem; }
			#customer_route #id			{ width: 5rem; text-align: right; }
			#customer_route #code		{ width: 8rem; }
			#customer_route #name		{ width: 20rem; }
			#customer_route #description	{ width: 28rem; }
			#customer_route .crc-section { width: 100%; margin-top: 1rem; }
			#customer_route .crc-section table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
			#customer_route .crc-section th,
			#customer_route .crc-section td { padding: 0.25rem 0.4rem; border: 1px solid #ddd; }
			#customer_route .crc-section thead th { background: #e5e7eb; }
			#customer_route .crc-toolbar { display: flex; flex-wrap: wrap; gap: 0.4rem; margin-bottom: 0.5rem; }
			#customer_route .crc-disabled-hint { color: #b45309; font-size: 0.82rem; }
		</style>
		<form id="customer_route" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador interno">C\xf3digo interno
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo da rota">C\xf3digo<sup>*</sup>
					<input id="code" type="text" required maxlength="32">
				</label>
				<label title="Nome da rota">Nome<sup>*</sup>
					<input id="name" type="text" required maxlength="120">
				</label>
				<label title="Descri\xe7\xe3o opcional">Descri\xe7\xe3o
					<input id="description" type="text" maxlength="500">
				</label>
				<label title="Rota inativa n\xe3o aparece para novo v\xednculo em clientes">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_customer_route_disable" title="Inativar rota">Inativar</button>
					<button type="button" class="button bn_customer_route_enable" title="Ativar rota">Ativar</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
			<fieldset class="crc-section" id="crc_customers_section" style="display:none">
				<legend>Clientes da rota</legend>
				<p class="crc-disabled-hint" id="crc_inactive_hint" style="display:none">
					Rota inativa: visualiza\xe7\xe3o e exporta\xe7\xe3o permitidas; adi\xe7\xe3o de clientes bloqueada.
				</p>
				<div class="crc-toolbar">
					<button type="button" class="button" id="crc_btn_add">Adicionar clientes</button>
					<button type="button" class="button" id="crc_btn_export_csv">Exportar clientes CSV</button>
					<button type="button" class="button" id="crc_btn_export_xlsx">Exportar clientes XLSX</button>
				</div>
				<table>
					<thead>
						<tr>
							<th>C\xf3digo/CNPJ</th>
							<th>Nick</th>
							<th>Nome</th>
							<th>Cidade</th>
							<th>Status</th>
							<th></th>
						</tr>
					</thead>
					<tbody id="crc_customers_tbody"></tbody>
				</table>
			</fieldset>
		</form>
	`,
    form: {
        selector: '#customer_route',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const root = document.querySelector('#customer_route');
            root?.querySelector('.bn_customer_route_disable')?.addEventListener('click', ()=>{
                const cb = root.querySelector('#is_disabled');
                if (cb) {
                    cb.checked = true;
                    cb.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            });
            root?.querySelector('.bn_customer_route_enable')?.addEventListener('click', ()=>{
                const cb = root.querySelector('#is_disabled');
                if (cb) {
                    cb.checked = false;
                    cb.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            });
            Object.getPrototypeOf(this).init.call(this);
        },
        afterEditSetValues (fs) {
            if (typeof window.__crcRouteCustomersInit === 'function') window.__crcRouteCustomersInit(fs);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#description'
            },
            types: []
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};


var $f440e1b4d73d95bd$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#crc-add-form { min-width: 36rem; }
			#crc-add-form .crc-search { width: 100%; margin-bottom: 0.5rem; }
			#crc-add-results { max-height: 16rem; overflow: auto; border: 1px solid #ccc; }
			#crc-add-results table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
			#crc-add-results th, #crc-add-results td { padding: 0.25rem 0.4rem; border-bottom: 1px solid #eee; }
			#crc-add-results tr:hover td { background: #f5f8ff; }
		</style>
		<form id="crc-add-form" class="form" autocomplete="off">
			<p class="fss">Busque clientes ativos e marque os que deseja vincular \xe0 rota.</p>
			<input id="crc_search" class="crc-search" type="search" placeholder="Buscar por nick, nome, CNPJ/c\xf3digo ou id">
			<div id="crc-add-results">
				<table>
					<thead>
						<tr>
							<th></th>
							<th>C\xf3digo/CNPJ</th>
							<th>Nick</th>
							<th>Nome</th>
							<th>Rota atual</th>
						</tr>
					</thead>
					<tbody id="crc-add-tbody"></tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<button type="button" class="button bn_crc_cancel">Cancelar</button>
				<button type="button" class="button bn_crc_confirm">Adicionar selecionados</button>
			</div>
		</form>
	`,
    form: {
        selector: '#crc-add-form'
    },
    fields: []
};



var $9PIz7 = parcelRequire("9PIz7");
var $1Wvh7 = parcelRequire("1Wvh7");
function $63c95189ff1fc725$var$downloadFile(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'export';
    a.click();
    URL.revokeObjectURL(a.href);
}
function $63c95189ff1fc725$var$customerStatusLabel(isDisabled) {
    return isDisabled === true || isDisabled === 1 || isDisabled === '1' ? 'Inativo' : 'Ativo';
}
function $63c95189ff1fc725$var$routeLabel(code, name) {
    if (!code && !name) return "\u2014";
    return [
        code,
        name
    ].filter(Boolean).join(" \u2014 ");
}
const $63c95189ff1fc725$var$customerRoutes = function() {
    const rt_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        addFilter (params) {
            (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).addFilter.call(this, params);
            if (this.filter && JSON.stringify(this.filter).includes('is_disabled')) params.append('include_disabled', '1');
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_routes, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customer_routes', data).catch((e)=>(0, $jUNyh.notify)(e)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((e)=>(0, $jUNyh.notify)(e)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_routes, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_customer_route, ...JSON.parse(id));
        },
        editRecord (data) {
            (0, $b60a2.default).edit(this.record_form, this.saveRecordWrapper.bind(this), data);
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos uma rota.', 'Rotas');
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $jUNyh.ask)(`Confirma ${action} ${ids.length} rota(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_customer_route, company_id, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $jUNyh.notify)('Falha ao atualizar rota.', 'Rotas');
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async saveRecord (data, old_data) {
            const _record = {
                code: String(data.code || '').trim(),
                name: String(data.name || '').trim(),
                description: String(data.description || '').trim() || null,
                is_disabled: data.is_disabled == '1'
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_customer_route, data.company_id, data.id, _record);
            const { is_disabled: is_disabled, ...insertBody } = _record;
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_customer_route, data.company_id, insertBody);
        },
        async deleteSelected () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos um registro.', 'Rotas');
            (0, $jUNyh.ask)(`Excluir ${ids.length} rota(s)? S\xf3 \xe9 poss\xedvel excluir rotas sem clientes vinculados.`, 'Excluir', async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_customer_route, company_id, id);
                    if (resp === undefined) return;
                }
                this.reloadPage();
            });
        },
        async exportRoutes (format) {
            try {
                const query = this.queryAll();
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_customer_routes, query, format);
                if (resp?.csv) $63c95189ff1fc725$var$downloadFile(resp.csv, resp.filename || 'rotas.csv', 'text/csv;charset=utf-8');
                else if (resp?.xlsx) $63c95189ff1fc725$var$downloadFile(resp.xlsx, resp.filename || 'rotas.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                else {
                    (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                    return;
                }
                (0, $jUNyh.notify)('Download iniciado.', 'Rotas');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
        }
    });
    async function renderRouteCustomers(fs) {
        const root = document.querySelector('#customer_route');
        const section = root?.querySelector('#crc_customers_section');
        const tbody = root?.querySelector('#crc_customers_tbody');
        const hint = root?.querySelector('#crc_inactive_hint');
        const btnAdd = root?.querySelector('#crc_btn_add');
        if (!section || !tbody) return;
        const companyId = fs.form.getValues()?.company_id;
        const routeId = fs.form.getValues()?.id;
        const isDisabled = fs.form.getValues()?.is_disabled == '1';
        if (!companyId || !routeId) {
            section.style.display = 'none';
            return;
        }
        section.style.display = '';
        if (hint) hint.style.display = isDisabled ? '' : 'none';
        if (btnAdd) btnAdd.disabled = !!isDisabled;
        try {
            const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_route_customers, companyId, routeId) || [];
            tbody.innerHTML = rows.map((r)=>`
				<tr data-customer-id="${r.customer_id}">
					<td>${(r.customer_cnpj ?? r.customer_id ?? '').toString()}</td>
					<td>${(r.customer_nick ?? '').toString()}</td>
					<td>${(r.customer_name ?? '').toString()}</td>
					<td>${(r.city_name ?? '').toString()}</td>
					<td>${$63c95189ff1fc725$var$customerStatusLabel(r.is_disabled)}</td>
					<td><button type="button" class="button crc-btn-remove" data-id="${r.customer_id}">Remover</button></td>
				</tr>
			`).join('');
        } catch (e) {
            tbody.innerHTML = '';
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        }
    }
    function bindRouteCustomersPanel(fs) {
        const root = document.querySelector('#customer_route');
        if (!root || root.dataset.crcBound === '1') return;
        root.dataset.crcBound = '1';
        const companyId = ()=>fs.form.getValues()?.company_id;
        const routeId = ()=>fs.form.getValues()?.id;
        const isDisabled = ()=>fs.form.getValues()?.is_disabled == '1';
        root.querySelector('#crc_btn_export_csv')?.addEventListener('click', async ()=>{
            try {
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_customer_route_customers, companyId(), routeId(), 'csv');
                if (resp?.csv) $63c95189ff1fc725$var$downloadFile(resp.csv, resp.filename, 'text/csv;charset=utf-8');
                else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
        });
        root.querySelector('#crc_btn_export_xlsx')?.addEventListener('click', async ()=>{
            try {
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_customer_route_customers, companyId(), routeId(), 'xlsx');
                if (resp?.xlsx) $63c95189ff1fc725$var$downloadFile(resp.xlsx, resp.filename, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
        });
        root.querySelector('#crc_btn_add')?.addEventListener('click', ()=>openAddCustomersModal(fs));
        root.querySelector('#crc_customers_tbody')?.addEventListener('click', async (ev)=>{
            const btn = ev.target.closest('.crc-btn-remove');
            if (!btn) return;
            const customerId = Number(btn.dataset.id);
            (0, $jUNyh.ask)('Remover cliente desta rota?', 'Remover', async (answer)=>{
                if (answer !== 'Y') return;
                try {
                    await (0, $9VcS9.default).call((0, $9VcS9.default).unlink_customer_route_customer, companyId(), routeId(), customerId);
                    (0, $jUNyh.notify)('Cliente removido da rota.', 'Rotas');
                    await renderRouteCustomers(fs);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
        });
        root.querySelector('#is_disabled')?.addEventListener('change', ()=>{
            const hint = root.querySelector('#crc_inactive_hint');
            const btnAdd = root.querySelector('#crc_btn_add');
            const disabled = isDisabled();
            if (hint) hint.style.display = disabled ? '' : 'none';
            if (btnAdd) btnAdd.disabled = disabled;
        });
    }
    function openAddCustomersModal(fs) {
        if (isRouteInactive(fs)) {
            (0, $jUNyh.notify)("Rota inativa n\xe3o permite adicionar clientes.", 'Rotas');
            return;
        }
        const companyId = fs.form.getValues()?.company_id;
        const routeId = fs.form.getValues()?.id;
        let searchTimer = null;
        let availableRows = [];
        const dlg = (0, $h1m6J.default).create((0, $f440e1b4d73d95bd$export$2e2bcd8739ae039), async ()=>dlg.destroy());
        const tbody = document.querySelector('#crc-add-tbody');
        const search = document.querySelector('#crc_search');
        async function refreshSearch() {
            const q = search?.value?.trim() || '';
            try {
                availableRows = await (0, $9VcS9.default).call((0, $9VcS9.default).search_customer_route_available, companyId, routeId, q) || [];
                if (!tbody) return;
                tbody.innerHTML = availableRows.map((r)=>{
                    const onRoute = r.current_route_id === routeId;
                    const otherRoute = r.current_route_id && r.current_route_id !== routeId;
                    const routeTxt = onRoute ? "J\xe1 nesta rota" : otherRoute ? $63c95189ff1fc725$var$routeLabel(r.current_route_code, r.current_route_name) : 'Sem rota';
                    return `
						<tr>
							<td><input type="checkbox" class="crc-pick" value="${r.id}"${onRoute ? ' disabled' : ''}></td>
							<td>${(r.cnpj ?? r.id ?? '').toString()}</td>
							<td>${(r.nick ?? '').toString()}</td>
							<td>${(r.name ?? '').toString()}</td>
							<td>${routeTxt}</td>
						</tr>`;
                }).join('');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
        }
        search?.addEventListener('input', ()=>{
            clearTimeout(searchTimer);
            searchTimer = setTimeout(refreshSearch, 300);
        });
        document.querySelector('.bn_crc_cancel')?.addEventListener('click', ()=>dlg.destroy());
        document.querySelector('.bn_crc_confirm')?.addEventListener('click', async ()=>{
            const picks = [
                ...document.querySelectorAll('#crc-add-tbody .crc-pick:checked')
            ].map((el)=>Number(el.value));
            if (!picks.length) {
                (0, $jUNyh.notify)('Selecione ao menos um cliente.', 'Rotas');
                return;
            }
            const needsMove = picks.filter((id)=>{
                const row = availableRows.find((r)=>r.id === id);
                return row?.current_route_id && row.current_route_id !== routeId;
            });
            const doLink = async (allowMove)=>{
                try {
                    const result = await (0, $9VcS9.default).call((0, $9VcS9.default).link_customer_route_customers, companyId, routeId, {
                        customer_ids: picks,
                        allow_move: allowMove
                    });
                    const msgs = [];
                    if (result.linked) msgs.push(`${result.linked} vinculado(s)`);
                    if (result.already_linked) msgs.push(`${result.already_linked} j\xe1 vinculado(s)`);
                    if (result.moved) msgs.push(`${result.moved} movido(s) para a rota`);
                    if (result.conflicts?.length) {
                        const parts = [];
                        if (result.linked) parts.push(`${result.linked} vinculado(s)`);
                        if (result.already_linked) parts.push(`${result.already_linked} j\xe1 na rota`);
                        if (parts.length) (0, $jUNyh.notify)(parts.join('; '), 'Rotas');
                        (0, $jUNyh.notify)("Cliente pertence a outra rota. Selecione novamente e confirme a movimenta\xe7\xe3o.", 'Rotas');
                        await renderRouteCustomers(fs);
                        return;
                    }
                    if (msgs.length) (0, $jUNyh.notify)(msgs.join('; '), 'Rotas');
                    else (0, $jUNyh.notify)("Cliente j\xe1 vinculado \xe0 rota.", 'Rotas');
                    dlg.destroy();
                    await renderRouteCustomers(fs);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            };
            if (needsMove.length) {
                (0, $jUNyh.ask)(`${needsMove.length} cliente(s) pertence(m) a outra rota. Deseja mov\xea-los para esta rota?`, 'Mover clientes', async (answer)=>{
                    if (answer === 'Y') await doLink(true);
                });
                return;
            }
            await doLink(false);
        });
        setTimeout(refreshSearch, 100);
    }
    function isRouteInactive(fs) {
        return fs.form.getValues()?.is_disabled == '1';
    }
    window.__crcRouteCustomersInit = (fs)=>{
        bindRouteCustomersPanel(fs);
        renderRouteCustomers(fs);
    };
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customer-route-delete', rt_crud.deleteSelected.bind(rt_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customer-route-disable', rt_crud.setDisabled.bind(rt_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customer-route-enable', rt_crud.setDisabled.bind(rt_crud, false));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customer-route-export-csv', ()=>rt_crud.exportRoutes('csv'));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customer-route-export-xlsx', ()=>rt_crud.exportRoutes('xlsx'));
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Id',
            types: [],
            placeholder: '',
            title: 'Identificador'
        },
        {
            index: 3,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: '',
            title: "C\xf3digo da rota"
        },
        {
            index: 4,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: 'Nome da rota'
        },
        {
            index: 5,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o opcional"
        },
        {
            index: 6,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Rota inativa'
        }
    ];
    const operations = [
        {
            hash: '#customer-route-export-csv',
            label: 'Exportar&nbsp;CSV'
        },
        {
            hash: '#customer-route-export-xlsx',
            label: 'Exportar&nbsp;XLSX'
        },
        {
            hash: '#customer-route-disable',
            label: 'Inativar'
        },
        {
            hash: '#customer-route-enable',
            label: 'Ativar'
        },
        {
            hash: '#customer-route-delete',
            label: 'Excluir'
        }
    ];
    rt_crud.run('customer_routes', 'Rotas', document.getElementById('workarea'), (0, $922d76c9d91e784d$export$2e2bcd8739ae039), (0, $450c1bff7d98ea03$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $63c95189ff1fc725$export$2e2bcd8739ae039 = $63c95189ff1fc725$var$customerRoutes;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $jHqD0 = parcelRequire("jHqD0");
async function $26658b175da0a4f4$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; 	}
			.view td:nth-child(4)	{ text-align: center;	}
			.view td:nth-child(5)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
			.view td:nth-child(10)	{ text-align: left; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: left; max-width: 10rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Transportador</th>
					<th data-index="3" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Apelido</th>
					<th data-index="5" data-visible="${this.visible[4]}">Nome</th>
					<th data-index="6" data-visible="${this.visible[5]}">CPF</th>
					<th data-index="7" data-visible="${this.visible[6]}">CNPJ</th>
					<th data-index="8" data-visible="${this.visible[7]}">IE</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo IE</th>
					<th data-index="10" data-visible="${this.visible[9]}">Fone</th>
					<th data-index="11" data-visible="${this.visible[10]}">Email</th>
					<th data-index="12" data-visible="${this.visible[11]}">C\xf3d. Protheus</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option($k93VN.default(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.nick}</td>
					<td data-visible='${this.visible[4]}'>${record.name}</td>
					<td data-visible='${this.visible[5]}'>${this.format($gbkt2.default(), record.cpf)}</td>
					<td data-visible='${this.visible[6]}'>${this.format($aYyoz.default(), record.cnpj)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($gF6P4.default(), record.ie)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($a5v7C.default(), record.ie_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($jHqD0.default(), record.phone)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($lVBv9.default(), record.email)}</td>
					<td data-visible='${this.visible[11]}'>${record.protheus_carrier_code != null && record.protheus_carrier_code !== '' ? String(record.protheus_carrier_code) : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}


parcelRequire("9VcS9");

var $e3m9R = parcelRequire("e3m9R");
var $5Aed9 = parcelRequire("5Aed9");
var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $9PIz7 = parcelRequire("9PIz7");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6lTH5 = parcelRequire("6lTH5");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $3HbPC = parcelRequire("3HbPC");
var $jHqD0 = parcelRequire("jHqD0");
var $6Jl4s = parcelRequire("6Jl4s");
var $0ab567b2ed7663d6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#carrier #company_id			{ width: 10rem;		}
			#carrier #id					{ width: 5rem; text-align: right;	}
			#carrier #type					{ width: 4rem;		}
			#carrier #nick					{ width: 28rem;		}
			#carrier #name					{ width: 28rem; 	}
			#carrier #email					{ width: 20rem;		}
			#carrier #cpf					{ width: 8rem;		}
			#carrier #cnpj					{ width: 10rem; 	}
			#carrier #ie					{ width: 8rem; 		}
			#carrier #ie_type				{ width: 10rem;		}
			#carrier #phone					{ width: 10rem;		}
			#carrier #address_street		{ width: 26rem;		}
			#carrier #address_number		{ width: 6rem;		}
			#carrier #address_complement	{ width: 15rem;		}
			#carrier #address_district		{ width: 20rem;		}
			#carrier #address_state			{ width: 3.5rem;	}
			#carrier #address_city_id		{ width: 17rem;		}
			#carrier #address_zipcode		{ width: 6rem;		}
		</style>
		<form id="carrier" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do transportador">Transp
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jur\xeddica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Nome curto do transportador">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome ou raz\xe3o social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb" id="local_delivery_row">
				<label title="Cadastro simplificado para local de entrega (ex.: departamento)">Modo local de entrega
					<input id="is_local_delivery" type="checkbox" title="Desabilita CPF, CNPJ, IE e Tipo IE; usa Tipo LOCAL">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="N\xfamero do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="N\xfamero do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="C\xf3digo da transportadora no Protheus (SA4010 A4_COD / prioridade RVD na integra\xe7\xe3o SubmeteSaida)">C\xf3d. Protheus / RVD
					<input id="protheus_carrier_code" type="text" maxlength="32" placeholder="ex.: 15030">
				</label>
				<label title="N\xfamero da Inscri\xe7\xe3o Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscri\xe7\xe3o Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Nome da rua ou avenida">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="N\xfamero">N\xfamero
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Munic\xedpio">Munic\xedpio
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<span class="cep-hint" style="font-size:0.85em;color:var(--color-muted,#666);">Digite o CEP e saia do campo para preencher automaticamente (logradouro, bairro, UF, munic\xedpio).</span>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#carrier',
        /** Submit autocontido: lê DOM, valida e chama callback. Não usa formCheck/getValues do formset (evita impacto no resto do sistema). */ submitHandler (formset, ev) {
            ev?.preventDefault();
            const root = document.querySelector('#carrier');
            if (!root) return;
            const val = (id)=>(root.querySelector(`#${id}`)?.value ?? '').trim();
            const chk = root.querySelector('#is_local_delivery');
            const isLocal = !!chk?.checked;
            let typeRaw = (root.querySelector('#type')?.value ?? '').trim().toUpperCase();
            // API espera um caractere: J (PJ), F (PF), G (OP), L (LOCAL)
            const typeMap = {
                'PJ': 'J',
                'PF': 'F',
                'G': 'G',
                'GV': 'G',
                'OP': 'G',
                'L': 'L',
                'LOCAL': 'L'
            };
            const type = isLocal ? 'L' : typeMap[typeRaw] || typeRaw;
            // API espera ie_type como char: 1=Contribuinte, 2=Isento, 9=Não Contribuinte
            let ieTypeRaw = val('ie_type');
            const ieTypeNorm = (s)=>(s || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
            const ieTypeMap = {
                'CONTRIBUINTE': '1',
                'ISENTO': '2',
                'NAO CONTRIBUINTE': '9'
            };
            const ieType = isLocal ? '' : ieTypeMap[ieTypeNorm(ieTypeRaw)] || (/^[129]$/.test(ieTypeRaw) ? ieTypeRaw : ieTypeRaw);
            // Telefone / CPF / CNPJ: enviar store (sem máscara), não o valor da tela
            const phoneRaw = val('phone');
            const phone = phoneRaw ? phoneRaw.replace(/[\(\)\-\s.]/g, '') : '';
            const cpf = val('cpf').replace(/[.\-\s]/g, '');
            const cnpj = val('cnpj').replace(/[.\-\/\s]/g, '');
            const data = {
                company_id: val('company_id'),
                id: val('id'),
                type: type,
                nick: val('nick'),
                name: val('name'),
                email: val('email'),
                phone: phone,
                cpf: cpf,
                cnpj: cnpj,
                protheus_carrier_code: val('protheus_carrier_code') || null,
                ie: val('ie'),
                ie_type: ieType,
                address_id: val('address_id'),
                address_street: val('address_street'),
                address_number: val('address_number'),
                address_complement: val('address_complement'),
                address_district: val('address_district'),
                address_state: val('address_state'),
                address_city_id: val('address_city_id'),
                address_zipcode: val('address_zipcode'),
                is_local_delivery: isLocal
            };
            if (!data.company_id) throw new Error('Verificar Empresa*');
            if (!data.type) throw new Error('Verificar Tipo*');
            if (!data.nick) throw new Error('Verificar Apelido*');
            if (!data.name) throw new Error('Verificar Nome*');
            if (!isLocal && !/^[129]$/.test(data.ie_type)) throw new Error('Verificar Tipo IE*');
            formset.callback?.call(formset, data);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const sel = formset.form.selector;
            const chk = document.querySelector(`${sel} #is_local_delivery`);
            const typeEl = document.querySelector(`${sel} #type`);
            const cpfEl = document.querySelector(`${sel} #cpf`);
            const cnpjEl = document.querySelector(`${sel} #cnpj`);
            const ieEl = document.querySelector(`${sel} #ie`);
            const ieTypeEl = document.querySelector(`${sel} #ie_type`);
            const toggleLocal = ()=>{
                if (!chk) return;
                const on = chk.checked;
                const type = (typeEl?.value || '').trim().toUpperCase();
                if (on) {
                    [
                        cpfEl,
                        cnpjEl,
                        ieEl,
                        ieTypeEl
                    ].forEach((el)=>{
                        if (el) {
                            el.disabled = true;
                            el.required = false;
                            el.value = '';
                        }
                    });
                    if (typeEl) {
                        typeEl.value = 'L';
                        typeEl.disabled = true;
                    }
                } else {
                    if (typeEl) typeEl.disabled = false;
                    // PJ/G: exige CNPJ e IE; PF: exige CPF; não exigir CPF para PJ
                    const isPF = type === 'F';
                    const isPJ = type === 'J' || type === 'G';
                    if (cpfEl) {
                        cpfEl.disabled = !isPF;
                        cpfEl.required = isPF;
                        if (!isPF) cpfEl.value = '';
                    }
                    if (cnpjEl) {
                        cnpjEl.disabled = isPF;
                        cnpjEl.required = isPJ;
                        if (isPF) cnpjEl.value = '';
                    }
                    if (ieEl) {
                        ieEl.disabled = false;
                        ieEl.required = true;
                    }
                    if (ieTypeEl) {
                        ieTypeEl.disabled = false;
                        ieTypeEl.required = true;
                    }
                }
            };
            chk?.addEventListener('change', toggleLocal);
            // Atualiza o valor armazenado do campo checkbox quando alteramos chk.checked no código (sem disparar 'change')
            const syncCheckboxStorage = ()=>{
                const field = formset.form.getFieldBySelector?.('#is_local_delivery');
                if (field && typeof field.setValue === 'function') field.setValue(chk?.checked ? 1 : 0);
            };
            formset.subscribe && formset.subscribe([
                'open'
            ], ()=>{
                setTimeout(()=>{
                    // Só marcar "Modo local" se o tipo for L; caso contrário desmarcar (ex.: novo registro ou PJ)
                    const type = (typeEl?.value || '').trim().toUpperCase();
                    if (type === 'L') chk.checked = true;
                    else chk.checked = false;
                    syncCheckboxStorage();
                    toggleLocal();
                }, 0);
            });
            // Ao mudar o tipo: se escolheu PJ/PF/G, desmarcar "Modo local" e atualizar valor armazenado
            typeEl?.addEventListener('change', ()=>{
                const type = (typeEl?.value || '').trim().toUpperCase();
                if (type && type !== 'L' && chk) {
                    chk.checked = false;
                    syncCheckboxStorage();
                }
                toggleLocal();
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $k93VN.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#cpf'
            },
            types: [
                $gbkt2.default()
            ]
        },
        {
            properties: {
                selector: '#cnpj'
            },
            types: [
                $aYyoz.default()
            ]
        },
        {
            properties: {
                selector: '#ie'
            },
            types: [
                $gF6P4.default()
            ]
        },
        {
            properties: {
                selector: '#ie_type'
            },
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $jHqD0.default()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $lVBv9.default()
            ]
        },
        {
            properties: {
                selector: '#protheus_carrier_code'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_district'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $6Jl4s.default(),
                $3HbPC.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#address_city_id'
            },
            types: [
                $6Jl4s.default(),
                $74yTJ.default(),
                $6lTH5.default('address_state'),
                $e0cb16d31f76baa7$export$2e2bcd8739ae039(),
                $201d7a75379b20b7$export$2e2bcd8739ae039('address_state')
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: [
                $e3m9R.default(),
                $b99c2345a91aed9b$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_local_delivery'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $aYyoz = parcelRequire("aYyoz");
var $gbkt2 = parcelRequire("gbkt2");
var $9PIz7 = parcelRequire("9PIz7");
var $lVBv9 = parcelRequire("lVBv9");
var $gF6P4 = parcelRequire("gF6P4");
var $3eqAU = parcelRequire("3eqAU");
var $a5v7C = parcelRequire("a5v7C");
var $k93VN = parcelRequire("k93VN");
var $jHqD0 = parcelRequire("jHqD0");
const $bf6317b83db2cd5d$var$carriers = function() {
    let carriers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_cities, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cities', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_carriers, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_carrier, ...JSON.parse(id));
            _record = (0, $b60a2.flatten)(_record, 'address');
            if (_record.address_city_id) {
                const c = await (0, $1cmSR.default).get('cities', _record.address_city_id);
                if (c) {
                    _record['address_state'] = c.state;
                    _record['address_city_id'] = c.city;
                }
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const sel = '#carrier';
            const normalize = (s)=>(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
            const resolveCityId = async (state, cityVal)=>{
                if (!state || cityVal == null || cityVal === '') return cityVal;
                const v = String(cityVal).trim();
                if (/^\d{7}$/.test(v)) return v;
                const range = IDBKeyRange.bound([
                    state,
                    ''
                ], [
                    state,
                    '\uffff'
                ]);
                const cities = await (0, $1cmSR.default).list('cities', range, 2).catch(()=>[]);
                const c = (cities || []).find((x)=>normalize(x?.city || '') === normalize(v));
                return c ? c.id : cityVal;
            };
            const getAddr = (suffix)=>{
                const el = document.querySelector(`${sel} #address_${suffix}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getField = (id)=>{
                const el = document.querySelector(`${sel} #${id}`);
                return el?.value != null ? String(el.value).trim() : '';
            };
            const getZipFromDom = ()=>getAddr('zipcode').replace(/\D/g, '');
            // Garante valores do formulário: se data vier vazio, lê do DOM (formset às vezes não serializa todos os campos)
            const street = (data.address_street || getAddr('street')).trim();
            const number = (data.address_number || getAddr('number')).trim();
            const complement = (data.address_complement || getAddr('complement')).trim() || null;
            const district = (data.address_district || getAddr('district')).trim();
            const zipcode = data.address_zipcode && String(data.address_zipcode).replace(/\D/g, '') || getZipFromDom();
            const state = (data.address_state || getAddr('state')).toUpperCase().trim().slice(0, 2);
            let cityId = data.address_city_id != null && data.address_city_id !== '' ? data.address_city_id : getAddr('city_id');
            if (state && cityId) cityId = await resolveCityId(state, cityId);
            // Checkbox: preferir estado do DOM (evita valor antigo no storage ao desmarcar ao trocar para PJ)
            const chkNode = document.querySelector(`${sel} #is_local_delivery`);
            const isLocal = chkNode ? !!chkNode.checked : !!data.is_local_delivery;
            // API espera type como um char (J,F,G,L) e ie_type como char (1,2,9)
            const typeNorm = (t)=>{
                const m = {
                    'PJ': 'J',
                    'PF': 'F',
                    'G': 'G',
                    'L': 'L',
                    'LOCAL': 'L'
                };
                return m[t] || t;
            };
            const ieTypeNorm = (v)=>{
                const m = {
                    'Contribuinte': '1',
                    'Isento': '2',
                    "N\xe3o Contribuinte": '9',
                    'Nao Contribuinte': '9'
                };
                return m[v] || (/^[129]$/.test(v) ? v : v);
            };
            let _record = {
                type: isLocal ? 'L' : typeNorm(data.type),
                nick: data.nick,
                name: data.name,
                cpf: isLocal ? null : data.cpf || getField('cpf') || null,
                cnpj: isLocal ? null : data.cnpj || getField('cnpj') || null,
                protheus_carrier_code: data.protheus_carrier_code != null && String(data.protheus_carrier_code).trim() !== '' ? String(data.protheus_carrier_code).trim() : getField('protheus_carrier_code') || null,
                ie: isLocal ? null : data.ie,
                ie_type: isLocal ? null : ieTypeNorm(data.ie_type),
                phone: data.phone,
                email: data.email,
                is_local_delivery: isLocal
            };
            if (data.address_id || street || number || district || zipcode || cityId) _record['address'] = {
                id: data.address_id ? Number(data.address_id) : null,
                street: street || null,
                number: number || null,
                complement: complement,
                district: district || null,
                zipcode: zipcode || null,
                city_id: cityId || null
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_carrier, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_carrier, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Transportador',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do transportador'
        },
        {
            index: 3,
            field: 'type',
            label: 'Tipo',
            types: [
                $k93VN.default()
            ],
            placeholder: '',
            title: "Tipo de personalidade jur\xeddica"
        },
        {
            index: 4,
            field: 'nick',
            label: 'Apelido',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Nome curto do transportador'
        },
        {
            index: 5,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome ou raz\xe3o social"
        },
        {
            index: 6,
            field: 'cpf',
            label: 'CPF',
            types: [
                $gbkt2.default()
            ],
            placeholder: '000.000.000-00',
            title: "N\xfamero do CPF"
        },
        {
            index: 7,
            field: 'cnpj',
            label: 'CNPJ',
            types: [
                $aYyoz.default()
            ],
            placeholder: '00.000.000/0000-00',
            title: "N\xfamero do CNPJ"
        },
        {
            index: 8,
            field: 'ie',
            label: 'IE',
            types: [
                $gF6P4.default()
            ],
            placeholder: '000.000.000',
            title: "Inscri\xe7\xe3o Estadual"
        },
        {
            index: 9,
            field: 'ie_type',
            label: 'Tipo IE',
            types: [
                $a5v7C.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Tipo de Inscri\xe7\xe3o Estadual"
        },
        {
            index: 10,
            field: 'phone',
            label: 'Fone',
            types: [
                $jHqD0.default()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone'
        },
        {
            index: 11,
            field: 'email',
            label: 'Email',
            types: [
                $lVBv9.default()
            ],
            placeholder: 'abc@xyz.com',
            title: 'Email'
        },
        {
            index: 12,
            field: 'protheus_carrier_code',
            label: "C\xf3d. Protheus",
            types: [],
            placeholder: 'RVD/A4',
            title: "C\xf3digo transportadora Protheus (prioridade SubmeteSaida)"
        }
    ];
    carriers_crud.run('carriers', 'Transportadores', document.getElementById('workarea'), (0, $26658b175da0a4f4$export$2e2bcd8739ae039), (0, $0ab567b2ed7663d6$export$2e2bcd8739ae039), fieldspecs);
};
var $bf6317b83db2cd5d$export$2e2bcd8739ae039 = $bf6317b83db2cd5d$var$carriers;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");

var $4dbYJ = parcelRequire("4dbYJ");
async function $cf36881544852bc3$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: right; }
			.view td:nth-child(8)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Dispositivo</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Tipo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Endere\xe7o</th>
					<th data-index="6" data-visible="${this.visible[5]}">Porta</th>
					<th data-index="7" data-visible="${this.visible[6]}">Timeout</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${this.option($409d889ae18b953b$export$2e2bcd8739ae039(), record.type) || ''}</td>
					<td data-visible='${this.visible[4]}'>${this.format($4dbYJ.default(), record.address)}</td>
					<td data-visible='${this.visible[5]}'>${record.port}</td>
					<td data-visible='${this.visible[6]}'>${record.timeout}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $4dbYJ = parcelRequire("4dbYJ");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $8ab7139e29dfa662$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#device #company_id		{ width: 10rem;		}
			#device #id				{ width: 5rem; text-align: right;	}
			#device #name			{ width: 20rem; 	}
			#device #type			{ width: 10rem;		}
			#device #address		{ width: 10rem;		}
			#device #port			{ width: 7rem; text-align: right;	}
			#device #timeout		{ width: 7rem; text-align: right;	}
		</style>
		<form id="device" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do dispositivo">Dispositivo
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do dispositivo">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<label title="Tipo de dispositivo">Tipo<sup>*</sup>
					<input id="type" type="text" list="types" required>
				</label>
				<label title="Endere\xe7o IP do dispositivo">Endere\xe7o<sup>*</sup>
					<input id="address" type="text" required>
				</label>
				<label title="Porta de conex\xe3o">Porta<sup>*</sup>
					<input id="port" type="text" required>
				</label>
				<label title="Tempo m\xe1ximo de resposta em segundos">Timeout<sup>*</sup>
					<input id="timeout" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#device',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $409d889ae18b953b$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#address'
            },
            types: [
                $4dbYJ.default()
            ]
        },
        {
            properties: {
                selector: '#port'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#timeout'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
const $72c9f6cb63809845$var$devices = function() {
    let devices_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_device, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                type: data.type,
                address: data.address,
                port: Number(data.port),
                timeout: Number(data.timeout)
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_device, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_device, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Dispositivo',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do dispositivo'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: 'Nome do dispositivo'
        },
        {
            index: 4,
            field: 'type',
            label: 'Tipo',
            types: [
                $409d889ae18b953b$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo'
        },
        {
            index: 5,
            field: 'address',
            label: "Endere\xe7o",
            types: [],
            placeholder: '0.0.0.0',
            title: "Endere\xe7o IP do dispositivo"
        },
        {
            index: 6,
            field: 'port',
            label: 'Porta',
            types: [
                $3eqAU.default(0)
            ],
            placeholder: '0',
            title: "Porta de conex\xe3o"
        },
        {
            index: 7,
            field: 'timeout',
            label: 'Timeout',
            types: [
                $3eqAU.default(0)
            ],
            placeholder: '0',
            title: "Tempo m\xe1ximo de resposta em segundos"
        }
    ];
    devices_crud.run('devices', 'Dispositivos', document.getElementById('workarea'), (0, $cf36881544852bc3$export$2e2bcd8739ae039), (0, $8ab7139e29dfa662$export$2e2bcd8739ae039), fieldspecs);
};
var $72c9f6cb63809845$export$2e2bcd8739ae039 = $72c9f6cb63809845$var$devices;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");

var $hWQyW = parcelRequire("hWQyW");
const $205b8ec2c188b4b7$var$DOCK_TYPE_LABELS = {
    DRY: 'Seca',
    REFRIGERATED: 'Refrigerada',
    CLIMATE_CONTROLLED: 'Climatizada',
    MIXED: 'Mista'
};
async function $205b8ec2c188b4b7$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view .idk-badge {
				display: inline-block;
				padding: 0.1rem 0.45rem;
				border-radius: 0.25rem;
				font-size: 0.78rem;
				font-weight: 600;
			}
			.view .idk-badge-ok { background: #e0e7ff; color: #3730a3; }
			.view .idk-badge-off { background: #e5e7eb; color: #4b5563; }
			.view .idk-type { background: #dbeafe; color: #1e3a8a; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Tipo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Classes</th>
					<th data-index="6" data-visible="${this.visible[5]}">Hor\xe1rio</th>
					<th data-index="7" data-visible="${this.visible[6]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>{
        const typeLabel = record.dock_type_label || $205b8ec2c188b4b7$var$DOCK_TYPE_LABELS[record.dock_type] || record.dock_type || '';
        const statusBadge = record.is_disabled ? '<span class="idk-badge idk-badge-off">Inativa</span>' : '<span class="idk-badge idk-badge-ok">Ativa</span>';
        return `<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ], 'name')}</td>
					<td data-visible='${this.visible[2]}'>${(record.name ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'><span class="idk-badge idk-type">${typeLabel}</span></td>
					<td data-visible='${this.visible[4]}'>${(record.classes_label ?? "\u2014").toString()}</td>
					<td data-visible='${this.visible[5]}'>${(record.working_hours_summary ?? "\u2014").toString()}</td>
					<td data-visible='${this.visible[6]}'>${statusBadge}</td>
				</tr>`;
    }))).join('') + `
			</tbody>
		</table>
	`;
}



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $fE2eE = parcelRequire("fE2eE");
var $3eqAU = parcelRequire("3eqAU");
var $badq7 = parcelRequire("badq7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
const $2b581d5d0a882d98$var$ICO_DOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 21h18"/><path d="M5 21V10l7-5 7 5v11"/><path d="M9 21v-6h6v6"/><path d="M10 10h4"/></svg>';
const $2b581d5d0a882d98$var$ICO_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.6 13.4 12 4.8 4 4l.8 8 8.6 8.6a2 2 0 0 0 2.8 0l4.4-4.4a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
const $2b581d5d0a882d98$var$ICO_LAYERS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5"/><path d="m3 17 9 5 9-5"/></svg>';
const $2b581d5d0a882d98$var$ICO_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
const $2b581d5d0a882d98$var$ICO_NOTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/><path d="M8 13h8M8 17h5"/></svg>';
const $2b581d5d0a882d98$var$WEEKDAYS = [
    {
        id: 1,
        label: 'Segunda'
    },
    {
        id: 2,
        label: "Ter\xe7a"
    },
    {
        id: 3,
        label: 'Quarta'
    },
    {
        id: 4,
        label: 'Quinta'
    },
    {
        id: 5,
        label: 'Sexta'
    },
    {
        id: 6,
        label: "S\xe1bado"
    },
    {
        id: 7,
        label: 'Domingo'
    }
];
const $2b581d5d0a882d98$var$DOCK_TYPES = [
    {
        id: 'DRY',
        label: 'Seca'
    },
    {
        id: 'REFRIGERATED',
        label: 'Refrigerada'
    },
    {
        id: 'CLIMATE_CONTROLLED',
        label: 'Climatizada'
    },
    {
        id: 'MIXED',
        label: 'Mista'
    }
];
function $2b581d5d0a882d98$var$defaultHours() {
    return $2b581d5d0a882d98$var$WEEKDAYS.slice(0, 5).map((d)=>({
            weekday: d.id,
            start_time: '08:00',
            end_time: '17:00',
            slot_minutes: 30,
            is_active: true
        }));
}
function $2b581d5d0a882d98$var$renderHoursRows(tbody, hours) {
    if (!tbody) return;
    tbody.innerHTML = '';
    (hours || []).forEach((h, idx)=>{
        const tr = document.createElement('tr');
        tr.dataset.idx = String(idx);
        const dayOpts = $2b581d5d0a882d98$var$WEEKDAYS.map((d)=>`<option value="${d.id}"${Number(h.weekday) === d.id ? ' selected' : ''}>${d.label}</option>`).join('');
        const slotOpts = [
            15,
            30,
            45,
            60
        ].map((s)=>`<option value="${s}"${Number(h.slot_minutes) === s ? ' selected' : ''}>${s} min</option>`).join('');
        tr.innerHTML = `
			<td><select class="idk-wh-weekday">${dayOpts}</select></td>
			<td class="idk-wh-active-cell"><input type="checkbox" class="idk-wh-active"${h.is_active !== false ? ' checked' : ''}></td>
			<td><input type="time" class="idk-wh-start" value="${(h.start_time || '08:00').toString().slice(0, 5)}"></td>
			<td><input type="time" class="idk-wh-end" value="${(h.end_time || '17:00').toString().slice(0, 5)}"></td>
			<td><select class="idk-wh-slot">${slotOpts}</select></td>
			<td><button type="button" class="button idk-wh-remove" title="Remover janela">\u{2715}</button></td>
		`;
        tbody.appendChild(tr);
    });
}
function $2b581d5d0a882d98$var$collectHours(root) {
    const rows = [
        ...root?.querySelectorAll('#idk_wh_tbody tr') || []
    ];
    return rows.map((tr)=>({
            weekday: Number(tr.querySelector('.idk-wh-weekday')?.value || 1),
            is_active: !!tr.querySelector('.idk-wh-active')?.checked,
            start_time: tr.querySelector('.idk-wh-start')?.value || '08:00',
            end_time: tr.querySelector('.idk-wh-end')?.value || '17:00',
            slot_minutes: Number(tr.querySelector('.idk-wh-slot')?.value || 30)
        }));
}
/**
 * Atualiza título, badges e KPIs do painel sial-detail.
 * @param {HTMLElement|null} root
 */ function $2b581d5d0a882d98$var$updateSummary(root) {
    if (!root) return;
    const setText = (sel, text)=>{
        root.querySelectorAll(sel).forEach((el)=>{
            el.textContent = text;
        });
    };
    const name = root.querySelector('#name')?.value?.trim() || '';
    const type = root.querySelector('#dock_type')?.value || '';
    const typeLabel = $2b581d5d0a882d98$var$DOCK_TYPES.find((t)=>t.id === type)?.label || type || "\u2014";
    const company = root.querySelector('#company_id');
    const companyLabel = company?.selectedOptions?.[0]?.text?.trim() || company?.value || "\u2014";
    const warehouse = root.querySelector('#warehouse_id');
    const warehouseLabel = warehouse?.selectedOptions?.[0]?.text?.trim() || warehouse?.value || "\u2014";
    const classesSel = root.querySelector('#classes');
    const classCount = classesSel ? [
        ...classesSel.options
    ].length : 0;
    const hours = $2b581d5d0a882d98$var$collectHours(root);
    const activeDays = [
        ...new Set(hours.filter((h)=>h.is_active).map((h)=>h.weekday))
    ];
    const slots = hours.filter((h)=>h.is_active).map((h)=>h.slot_minutes);
    const commonSlot = slots.length ? slots.sort((a, b)=>slots.filter((v)=>v === a).length - slots.filter((v)=>v === b).length).pop() : null;
    const disabled = root.querySelector('#is_disabled')?.checked;
    setText('[data-sdp="title"]', name || 'Nova doca de entrada');
    setText('[data-sdp="company"]', companyLabel);
    setText('[data-sdp="warehouse"]', warehouseLabel);
    setText('[data-sdp="kpi-type"]', typeLabel);
    setText('[data-sdp="kpi-classes"]', classCount === 0 ? 'Todas' : String(classCount));
    setText('[data-sdp="kpi-days"]', activeDays.length ? String(activeDays.length) : '0');
    setText('[data-sdp="kpi-slot"]', commonSlot == null ? "\u2014" : `${commonSlot} min`);
    const badgeActive = root.querySelector('[data-sdp="badge-active"]');
    const badgeDisabled = root.querySelector('[data-sdp="badge-disabled"]');
    if (badgeActive) badgeActive.hidden = !!disabled;
    if (badgeDisabled) badgeDisabled.hidden = !disabled;
}
function $2b581d5d0a882d98$var$syncHoursField(root) {
    const hidden = root?.querySelector('#working_hours');
    if (hidden) hidden.value = JSON.stringify($2b581d5d0a882d98$var$collectHours(root));
    $2b581d5d0a882d98$var$updateSummary(root);
}
function $2b581d5d0a882d98$var$bindHoursUi(root) {
    const tbody = root.querySelector('#idk_wh_tbody');
    const btnAdd = root.querySelector('#idk_wh_add');
    if (!tbody || tbody.dataset.bound === '1') return;
    tbody.dataset.bound = '1';
    btnAdd?.addEventListener('click', ()=>{
        const hours = $2b581d5d0a882d98$var$collectHours(root);
        hours.push({
            weekday: 1,
            start_time: '08:00',
            end_time: '12:00',
            slot_minutes: 30,
            is_active: true
        });
        $2b581d5d0a882d98$var$renderHoursRows(tbody, hours);
        $2b581d5d0a882d98$var$syncHoursField(root);
    });
    tbody.addEventListener('click', (ev)=>{
        if (!ev.target.classList.contains('idk-wh-remove')) return;
        const tr = ev.target.closest('tr');
        tr?.remove();
        $2b581d5d0a882d98$var$syncHoursField(root);
    });
    tbody.addEventListener('change', ()=>$2b581d5d0a882d98$var$syncHoursField(root));
}
var $2b581d5d0a882d98$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input_dock .idk-keymap-row {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-items: stretch;
				gap: 0.65rem;
				width: 100%;
			}
			#input_dock .idk-keymap-row > label.keymap {
				display: flex;
				flex-direction: column;
				flex: 1 1 0;
				min-width: 0;
				margin: 0;
				width: auto;
			}
			#input_dock .idk-keymap-row > span.keymap {
				display: flex;
				flex-direction: column;
				justify-content: center;
				gap: 0.25rem;
				flex: 0 0 auto;
				align-self: center;
			}
			#input_dock .idk-keymap-row select#classes,
			#input_dock .idk-keymap-row select#available {
				width: 100%;
				min-width: 0;
				min-height: 7.5rem;
				box-sizing: border-box;
			}
			#input_dock .idk-wh-toolbar { margin-bottom: 0.5rem; }
			#input_dock .idk-wh-table {
				width: 100%;
				border-collapse: collapse;
				font-size: 0.85rem;
			}
			#input_dock .idk-wh-table th,
			#input_dock .idk-wh-table td {
				border: 1px solid var(--sial-accent-line, #e9d5ff);
				padding: 0.3rem 0.4rem;
			}
			#input_dock .idk-wh-table thead th {
				background: var(--sial-accent-wash, #f3e8ff);
				color: var(--sial-accent, #4c1d95);
				text-align: left;
			}
			#input_dock .idk-wh-active-cell { text-align: center; }
			#input_dock .idk-wh-table select,
			#input_dock .idk-wh-table input[type="time"] { width: 100%; box-sizing: border-box; }
			#input_dock #notes { min-height: 3.5rem; width: 100%; }
		</style>
		<form id="input_dock" class="form sial-modal-form sial-detail sial-detail--edit" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="warehouses"></datalist>
			<input type="hidden" id="working_hours" value="[]">

			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${$2b581d5d0a882d98$var$ICO_DOCK}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Organiza\xe7\xe3o \xb7 Docas Entrada</p>
						<h2 class="sdp-title" data-sdp="title">Nova doca de entrada</h2>
						<div class="sdp-meta">
							<span>Empresa: <b data-sdp="company">\u{2014}</b></span>
							<span>Armaz\xe9m: <b data-sdp="warehouse">\u{2014}</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="badge-active">Ativa</span>
							<span class="sdp-badge sdp-badge--blocked" data-sdp="badge-disabled" hidden>Inativa</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>

			<section class="sdp-kpis" aria-label="Resumo da doca">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">${$2b581d5d0a882d98$var$ICO_TAG} Tipo</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-type">\u{2014}</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">${$2b581d5d0a882d98$var$ICO_LAYERS} Classes</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-classes">\u{2014}</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">${$2b581d5d0a882d98$var$ICO_CLOCK} Dias ativos</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-days">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--free">
					<div class="sdp-kpi-label">${$2b581d5d0a882d98$var$ICO_CLOCK} Slot comum</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-slot">\u{2014}</span></div>
				</div>
			</section>

			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$2b581d5d0a882d98$var$ICO_TAG} Identifica\xe7\xe3o</h3>
					<div class="sdp-fields">
						<label title="Empresa">Empresa<sup>*</sup>
							<input id="company_id" type="text" list="companies" required>
						</label>
						<label title="Identificador interno">C\xf3digo interno
							<input id="id" type="text" disabled>
						</label>
						<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
							<input id="warehouse_id" type="text" list="warehouses" required>
						</label>
						<label title="Nome da doca">Nome<sup>*</sup>
							<input id="name" type="text" required maxlength="120">
						</label>
						<label title="Tipo da doca">Tipo<sup>*</sup>
							<select id="dock_type" required>
								<option value="DRY">Seca</option>
								<option value="REFRIGERATED">Refrigerada</option>
								<option value="CLIMATE_CONTROLLED">Climatizada</option>
								<option value="MIXED">Mista</option>
							</select>
						</label>
					</div>
					<div class="sdp-check-row">
						<label title="Doca inativa n\xe3o entra na disponibilidade futura">
							<input id="is_disabled" type="checkbox"> Inativa
						</label>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$2b581d5d0a882d98$var$ICO_NOTE} Observa\xe7\xf5es</h3>
					<div class="sdp-fields">
						<label class="sdp-span-2" title="Observa\xe7\xf5es">Observa\xe7\xf5es
							<textarea id="notes" maxlength="2000"></textarea>
						</label>
					</div>
					<p class="sdp-hint">Texto livre para a opera\xe7\xe3o (ex.: restri\xe7\xf5es f\xedsicas da doca).</p>
				</div>
			</section>

			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$2b581d5d0a882d98$var$ICO_LAYERS} Classes aceitas</h3>
					<p class="sdp-hint">Sem classes selecionadas = doca aceita todas as classes.</p>
					<div class="idk-keymap-row">
						<label class="keymap">Classes<select id="classes" multiple size="5"></select></label>
						<span class="keymap">
							<button type="button" class="bn_Left" title="Incluir">&#x1F844;</button>
							<button type="button" class="bn_Right" title="Remover">&#x1F846;</button>
						</span>
						<label class="keymap">Dispon\xedveis<select id="available" multiple size="5"></select></label>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$2b581d5d0a882d98$var$ICO_CLOCK} Hor\xe1rio de funcionamento</h3>
					<p class="sdp-hint">Usado para calcular disponibilidade no agendamento de recebimento.</p>
					<div class="idk-wh-toolbar">
						<button type="button" class="button" id="idk_wh_add">Adicionar janela</button>
					</div>
					<table class="idk-wh-table">
						<thead>
							<tr>
								<th>Dia</th>
								<th>Ativo</th>
								<th>In\xedcio</th>
								<th>Fim</th>
								<th>Slot</th>
								<th></th>
							</tr>
						</thead>
						<tbody id="idk_wh_tbody"></tbody>
					</table>
				</div>
			</div>

			<div class="sdp-foot">
				<button class="bn_Escape button">Fechar</button>
				<button class="bn_Enter button">Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input_dock',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const root = document.querySelector('#input_dock');
            $2b581d5d0a882d98$var$bindHoursUi(root);
            $2b581d5d0a882d98$var$renderHoursRows(root?.querySelector('#idk_wh_tbody'), $2b581d5d0a882d98$var$defaultHours());
            $2b581d5d0a882d98$var$syncHoursField(root);
            root?.querySelector('.bn_Enter')?.addEventListener('click', ()=>$2b581d5d0a882d98$var$syncHoursField(root), true);
            root?.addEventListener('input', ()=>$2b581d5d0a882d98$var$updateSummary(root));
            root?.addEventListener('change', ()=>$2b581d5d0a882d98$var$updateSummary(root));
            Object.getPrototypeOf(this).init.call(this);
            $2b581d5d0a882d98$var$updateSummary(root);
        },
        afterEditSetValues (fs, data) {
            const root = document.querySelector('#input_dock');
            const hours = data?.working_hours?.length ? data.working_hours : $2b581d5d0a882d98$var$defaultHours();
            $2b581d5d0a882d98$var$renderHoursRows(root?.querySelector('#idk_wh_tbody'), hours);
            $2b581d5d0a882d98$var$syncHoursField(root);
            $2b581d5d0a882d98$var$updateSummary(root);
            setTimeout(()=>$2b581d5d0a882d98$var$updateSummary(root), 400);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#dock_type'
            },
            types: []
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: []
        },
        {
            properties: {
                selector: '#working_hours'
            },
            types: []
        },
        {
            properties: {
                selector: '#classes'
            },
            types: [
                $6Jl4s.default(),
                $fE2eE.default('classes', '#available', {
                    values: [
                        'company_id',
                        'id'
                    ]
                }),
                $6lTH5.default('company_id'),
                $badq7.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $1Wvh7 = parcelRequire("1Wvh7");

/**
 * Extrai class_id do filtro Versa e devolve cópia sem essas condições
 * (filtro de classe usa query param + EXISTS no backend).
 * @param {object|null} data
 * @returns {{ filterData: object|null, classId: number|null }}
 */ function $9254eb1bc1602f3c$var$splitClassFilter(data) {
    if (!data || typeof data !== 'object') return {
        filterData: data,
        classId: null
    };
    const top = Object.keys(data).filter((k)=>/^field-\d+$/.test(k)).map((k)=>Number(k.slice(6))).reduce((m, n)=>Number.isFinite(n) && n > m ? n : m, -1) + 1;
    const keep = [];
    let classId = null;
    for(let i = 0; i < top; i++){
        const field = data[`field-${i}`];
        if (!field) continue;
        if (field === 'class_id') {
            const raw = data[`value-${i}`];
            if (raw != null && String(raw).trim() !== '') {
                const text = String(raw).trim();
                // classes: id numérico, "company:id" ou JSON [company, id]
                let n = null;
                if (/^\d+$/.test(text)) n = Number(text);
                else if (/^.+:\d+$/.test(text)) n = Number(text.split(':').pop());
                else try {
                    const parsed = JSON.parse(text);
                    if (Array.isArray(parsed) && parsed.length >= 2) n = Number(parsed[1]);
                } catch  {}
                if (Number.isFinite(n) && classId == null) classId = n;
            }
            continue;
        }
        keep.push(i);
    }
    if (keep.length === top && classId == null) return {
        filterData: data,
        classId: null
    };
    const out = {};
    keep.forEach((src, dst)=>{
        [
            'open',
            'field',
            'operator',
            'value',
            'close',
            'connector'
        ].forEach((p)=>{
            const key = `${p}-${src}`;
            if (Object.prototype.hasOwnProperty.call(data, key)) out[`${p}-${dst}`] = data[key];
        });
    });
    return {
        filterData: Object.keys(out).length ? out : null,
        classId: classId
    };
}
const $9254eb1bc1602f3c$var$inputDocks = function() {
    const rt_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async addFilter (params) {
            let f = this.filter;
            if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) {
                f = await (0, $hWQyW.resolveFilterLabelsToIds)(f, this.fieldspecs);
                (0, $hWQyW.validateResolvedFilterValues)(f, this.fieldspecs);
            }
            const { filterData: filterData, classId: classId } = $9254eb1bc1602f3c$var$splitClassFilter(f);
            const filter = (0, $hWQyW.translate)(filterData, null, this.fieldspecs);
            if (filter) params.append('filter', filter);
            if (classId != null) params.append('class_id', String(classId));
            if (f && JSON.stringify(f).includes('is_disabled')) params.append('include_disabled', '1');
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((e)=>(0, $jUNyh.notify)(e)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((e)=>(0, $jUNyh.notify)(e)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_classes, this.queryAll()).then((data)=>(0, $1cmSR.default).set('classes', data).catch((e)=>(0, $jUNyh.notify)(e)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_docks, query);
        },
        async loadRecord (id) {
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_dock, ...JSON.parse(id));
            if (data && Array.isArray(data.classes)) data.classes = data.classes.map((c)=>typeof c === 'object' ? c : [
                    data.company_id,
                    Number(c)
                ]);
            return data;
        },
        async saveRecord (data, old_data) {
            const parsedClasses = (0, $aGGTj.parse)(data.classes);
            const classes = Array.isArray(parsedClasses) ? parsedClasses.map((entry)=>Number(Array.isArray(entry) ? entry[1] : entry?.id ?? entry)).filter((n)=>Number.isFinite(n)) : [];
            let working_hours = data.working_hours;
            if (typeof working_hours === 'string') try {
                working_hours = JSON.parse(working_hours);
            } catch  {
                working_hours = [];
            }
            const _record = {
                warehouse_id: Number(data.warehouse_id),
                name: String(data.name || '').trim(),
                dock_type: String(data.dock_type || '').trim(),
                notes: data.notes ? String(data.notes).trim() : null,
                is_disabled: data.is_disabled === true || data.is_disabled === '1' || data.is_disabled === 1,
                classes: classes,
                working_hours: Array.isArray(working_hours) ? working_hours : []
            };
            if (!_record.name) return (0, $jUNyh.notify)('Informe o nome da doca.', 'Docas Entrada');
            if (!_record.warehouse_id) return (0, $jUNyh.notify)("Informe o armaz\xe9m.", 'Docas Entrada');
            if (!_record.dock_type) return (0, $jUNyh.notify)('Informe o tipo da doca.', 'Docas Entrada');
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_input_dock, data.company_id, data.id, _record);
            const { is_disabled: is_disabled, ...insertBody } = _record;
            if (is_disabled) insertBody.is_disabled = true;
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_input_dock, data.company_id, insertBody);
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos uma doca.', 'Docas Entrada');
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $jUNyh.ask)(`Confirma ${action} ${ids.length} doca(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_input_dock_disabled, company_id, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $jUNyh.notify)('Falha ao atualizar doca.', 'Docas Entrada');
                        return;
                    }
                }
                this.loadPage();
            });
        }
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-disable', ()=>rt_crud.setDisabled(true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-enable', ()=>rt_crud.setDisabled(false));
    // Ordem = colunas da grade (views/input-docks.js). class_id só no filtro.
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: 'Nome da doca'
        },
        {
            index: 4,
            field: 'dock_type',
            label: 'Tipo',
            types: [
                (0, $02c6004873977d5a$export$2e2bcd8739ae039)(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo da doca'
        },
        {
            index: 5,
            field: 'classes_label',
            label: 'Classes',
            types: [],
            placeholder: '',
            title: 'Classes aceitas (resumo)',
            computed: true
        },
        {
            index: 6,
            field: 'working_hours_summary',
            label: "Hor\xe1rio",
            types: [],
            placeholder: '',
            title: "Resumo de hor\xe1rios",
            computed: true
        },
        {
            index: 7,
            field: 'is_disabled',
            label: 'Status',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Inativa (Sim=Inativa / N\xe3o=Ativa)"
        },
        {
            index: 8,
            field: 'class_id',
            label: 'Classe',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Filtrar docas que aceitam esta classe',
            store: 'classes',
            labels: [
                'name'
            ]
        }
    ];
    const operations = [
        {
            hash: '#input-dock-disable',
            label: 'Inativar'
        },
        {
            hash: '#input-dock-enable',
            label: 'Ativar'
        }
    ];
    rt_crud.run('input_docks', 'Docas&nbsp;Entrada', document.getElementById('workarea'), (0, $205b8ec2c188b4b7$export$2e2bcd8739ae039), (0, $2b581d5d0a882d98$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $9254eb1bc1602f3c$export$2e2bcd8739ae039 = $9254eb1bc1602f3c$var$inputDocks;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");

var $3eqAU = parcelRequire("3eqAU");
async function $5a2011f757a8d53a$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: right; }
			.view td:nth-child(7)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Unidade</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Sigla</th>
					<th data-index="5" data-visible="${this.visible[4]}">Fator</th>
					<th data-index="6" data-visible="${this.visible[5]}">Opera\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${record.unit}</td>
					<td data-visible='${this.visible[4]}'>${this.format($3eqAU.default(3), record.factor)}</td>
					<td data-visible='${this.visible[5]}'>${this.option($67779c32de42857b$export$2e2bcd8739ae039(), record.operation) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $f36ec300bd03665e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#_unit #company_id	{ width: 10rem;	}
			#_unit #id			{ width: 5rem; text-align: right;	}
			#_unit #name		{ width: 15rem;	}
			#_unit #unit		{ width: 5rem;	}
			#_unit #factor		{ width: 5rem; text-align: right;	}
			#_unit #operation	{ width: 8rem; 	}
		</style>
		<form id="_unit" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="operations">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da unidade">Unidade
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da unidade">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Sigla da unidade">Sigla<sup>*</sup>
					<input id="unit" type="text" required>
				</label>
				<label title="Fator de multiplica\xe7\xe3o ou divis\xe3o">Fator<sup>*</sup>
					<input id="factor" type="text" required>
				</label>
				<label title="Opera\xe7\xe3o da unidade">Opera\xe7\xe3o<sup>*</sup>
					<input id="operation" type="text" list="operations" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#_unit',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#unit'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#factor'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#operation'
            },
            types: [
                $67779c32de42857b$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        }
    ]
};



var $gBwx4 = parcelRequire("gBwx4");
var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
const $157d0f4971612fc5$var$units = function() {
    let units_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_units, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_unit, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                unit: data.unit,
                factor: Number(data.factor),
                operation: data.operation
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_unit, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_unit, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Unidade',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da unidade'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome da unidade'
        },
        {
            index: 4,
            field: 'unit',
            label: 'Unidade',
            types: [
                $gBwx4.default()
            ],
            placeholder: '',
            title: 'Sigla da unidade'
        },
        {
            index: 5,
            field: 'factor',
            label: 'Fator',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Fator de multiplica\xe7\xe3o ou divis\xe3o da unidade"
        },
        {
            index: 6,
            field: 'operation',
            label: "Opera\xe7\xe3o",
            types: [
                $67779c32de42857b$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Opera\xe7\xe3o da unidade (multiplica\xe7\xe3o ou divis\xe3o)"
        }
    ];
    units_crud.run('units', 'Unidades', document.getElementById('workarea'), (0, $5a2011f757a8d53a$export$2e2bcd8739ae039), (0, $f36ec300bd03665e$export$2e2bcd8739ae039), fieldspecs);
};
var $157d0f4971612fc5$export$2e2bcd8739ae039 = $157d0f4971612fc5$var$units;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $jUNyh = parcelRequire("jUNyh");

var $1Wvh7 = parcelRequire("1Wvh7");
async function $5f0c9e863466f599$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Classe</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Seletiva</th>
					<th data-index="5" data-visible="${this.visible[4]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${this.option($1Wvh7.default(), record.is_selective)}</td>
					<td data-visible='${this.visible[4]}'>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $f562ed80fb0f5b5d$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#class #company_id	{ width: 10rem;	}
			#class #id			{ width: 5rem; text-align: right;	}
			#class #name		{ width: 25rem;	}
		</style>
		<form id="class" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da classe">Classe
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da classe">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Determina posi\xe7\xf5es poss\xedveis dos produtos?">Seletiva?
					<input id="is_selective" type="checkbox">
				</label>
				<label title="Classifica\xe7\xe3o inativa">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_class_disable" title="Inativar classifica\xe7\xe3o">Inativar</button>
					<button type="button" class="button bn_class_enable" title="Ativar classifica\xe7\xe3o">Ativar</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#class',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>formset.dialog?.getNode?.();
            const getCompanyId = ()=>formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
            const getId = ()=>root()?.querySelector?.('#id')?.value;
            const setDisabled = (v)=>{
                const f = formset.form.getFieldBySelector('#is_disabled');
                if (f) {
                    f.setValue(v ? 1 : 0);
                    f.refresh();
                }
            };
            const doAction = async (payload)=>{
                const company_id = getCompanyId(), id = getId();
                if (!company_id || !id) return;
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_class, company_id, id, payload);
                if (resp != null) setDisabled(payload.is_disabled);
                else (0, $jUNyh.notify)("Falha ao atualizar classifica\xe7\xe3o.", 'Classes');
            };
            root()?.addEventListener?.('click', (ev)=>{
                if (ev.target?.closest?.('.bn_class_disable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: true
                    });
                    return;
                }
                if (ev.target?.closest?.('.bn_class_enable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: false
                    });
                    return;
                }
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#is_selective'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
const $ffea07134e071bfc$var$classes = function() {
    let classes_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        addFilter (params) {
            (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).addFilter.call(this, params);
            if (this.filter && JSON.stringify(this.filter).includes('is_disabled')) params.append('include_disabled', '1');
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_classes, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_class, ...JSON.parse(id));
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)("Selecione ao menos uma classifica\xe7\xe3o.", 'Classes');
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $jUNyh.ask)(`Confirma ${action} ${ids.length} classifica\xe7\xe3o(\xf5es)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_class, company_id, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $jUNyh.notify)("Falha ao atualizar classifica\xe7\xe3o.", 'Classes');
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                is_selective: data.is_selective == '1',
                is_disabled: data.is_disabled == '1'
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_class, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_class, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Classe',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da classe'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome da classe'
        },
        {
            index: 8,
            field: 'is_selective',
            label: 'Seletiva?',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Determina posi\xe7\xf5es poss\xedveis dos produtos?"
        },
        {
            index: 5,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Classifica\xe7\xe3o inativa"
        }
    ];
    let operations = [
        {
            hash: '#class-disable',
            label: 'Inativar'
        },
        {
            hash: '#class-enable',
            label: 'Ativar'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#class-disable', classes_crud.setDisabled.bind(classes_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#class-enable', classes_crud.setDisabled.bind(classes_crud, false));
    classes_crud.run('classes', 'Classes', document.getElementById('workarea'), (0, $5f0c9e863466f599$export$2e2bcd8739ae039), (0, $f562ed80fb0f5b5d$export$2e2bcd8739ae039), fieldspecs, operations, []);
};
var $ffea07134e071bfc$export$2e2bcd8739ae039 = $ffea07134e071bfc$var$classes;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

async function $5ecc6f797889b4f5$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left;	}
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Categoria</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $4208f0a476aca13f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#category {
				box-sizing: border-box;
				width: min(46rem, calc(100vw - 1.5rem));
				max-width: calc(100vw - 1.5rem);
				min-width: 0;
			}
			#category #company_id	{ width: 10rem;		}
			#category #id			{ width: 4.5rem; text-align: right;	}
			#category #name			{ width: 10rem;		}
			#category .name 		{ width: 100%; box-sizing: border-box; }
			#category .length 		{ width: 100%; box-sizing: border-box; text-align: right;	}
			#category .attr-help {
				margin: 0.5rem 0 1rem;
				padding: 0.75rem;
				background: var(--form-hint-bg, #f5f5f5);
				border-radius: 4px;
				font-size: 0.9rem;
				line-height: 1.4;
				max-width: 100%;
			}
			#category .attr-help code { padding: 0.1em 0.4em; background: #e0e0e0; border-radius: 3px; font-size: 0.9em; }
			#category .attr-section { min-width: 0; max-width: 100%; }
			#category .attr-section table {
				width: 100%;
				max-width: 100%;
				table-layout: fixed;
			}
			#category .attr-section th,
			#category .attr-section td {
				white-space: normal;
				vertical-align: top;
				overflow-wrap: anywhere;
			}
			#category .attr-section th:nth-child(1),
			#category .attr-section td:nth-child(1) { width: 2.4rem; }
			#category .attr-section th:nth-child(3),
			#category .attr-section td:nth-child(3) { width: 8.5rem; }
			#category .attr-section th:nth-child(4),
			#category .attr-section td:nth-child(4) { width: 5.5rem; text-align: center; }
			#category .attr-section th small {
				font-weight: normal;
				color: #666;
				display: block;
				margin-top: 0.2rem;
				line-height: 1.3;
				white-space: normal;
			}
		</style>
		<form id="category" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da categoria">Categoria
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da categoria">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="attr-section">
				<p class="attr-help">
					<strong>Estrutura do SKU:</strong> Os atributos definem como o c\xf3digo do produto (SKU) ser\xe1 organizado.
					Cada linha \xe9 um segmento do SKU. O <em>tamanho</em> indica quantos caracteres esse segmento ter\xe1 (1\u{2013}12).
					Use um n\xfamero (ex: 6) ou v\xe1rios separados por v\xedrgula (ex: 5,6,10) quando o segmento puder ter tamanhos diferentes.
					Ex.: <strong>Subst\xe2ncia(3)</strong>, <strong>Concentra\xe7\xe3o(1)</strong>, <strong>Embalagem(1)</strong> \u{2192} SKU como <code>PRD,5,C</code>.
				</p>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Atributo<sup>*</sup><br><small>Nome do segmento (ex: Subst\xe2ncia, Concentra\xe7\xe3o)</small></th>
							<th>Tamanho<sup>*</sup><br><small>Um n\xfamero ou v\xe1rios separados por v\xedrgula (ex: 6 ou 5,6,10)</small></th>
							<th>Opcional<br><small>Pode ficar em branco?</small></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="6">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Nome do atributo exibido no cadastro do produto (ex: Subst\xe2ncia, Fabricante)">
								<input id="name-0" class="name" type="text" required placeholder="ex: Produto">
							</td>
							<td title="Um n\xfamero (ex: 6) ou v\xe1rios separados por v\xedrgula (ex: 5,6,10) para aceitar m\xfaltiplos tamanhos">
								<input id="length-0" class="length" type="text" required placeholder="ex: 6 ou 5,6,10">
							</td>
							<td title="Marcar se este atributo pode ser omitido no SKU">
								<input id="is_optional-0" class="optional" type="checkbox">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#category',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#name-0'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#length-0'
            },
            types: [
                $6f5d856b9353a912$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#is_optional-0'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
const $7113b1f3aa2dbdf1$var$categories = function() {
    let categories_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_categories, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_category, ...JSON.parse(id));
            // Exibir lengths como "5,6,10" no campo length quando houver múltiplos tamanhos
            if (_record?.attributes) _record.attributes = _record.attributes.map((a)=>({
                    ...a,
                    length: a.lengths && a.lengths.length ? a.lengths.join(',') : String(a.length ?? '')
                }));
            return (0, $b60a2.flatten)(_record, 'attributes');
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'attributes');
            const parseLength = (val)=>{
                const s = String(val || '').trim();
                if (!s) return {
                    length: 6,
                    lengths: null
                };
                const parts = s.split(/[,\s]+/).map((p)=>p.trim()).filter(Boolean);
                const nums = [];
                for (const p of parts){
                    const m = p.match(/^(\d+)-(\d+)$/);
                    if (m) {
                        const a = parseInt(m[1], 10), b = parseInt(m[2], 10);
                        for(let i = Math.min(a, b); i <= Math.max(a, b); i++)nums.push(i);
                    } else {
                        const n = parseInt(p, 10);
                        if (!isNaN(n) && n >= 1 && n <= 12) nums.push(n);
                    }
                }
                if (nums.length === 0) return {
                    length: 6,
                    lengths: null
                };
                const unique = [
                    ...new Set(nums)
                ].sort((a, b)=>a - b);
                return {
                    length: unique[0],
                    lengths: unique.length > 1 ? unique : null
                };
            };
            let _record = {
                name: data.name,
                attributes: data.attributes.map((entry, index)=>{
                    const { length: length, lengths: lengths } = parseLength(entry.length);
                    const att = {
                        position: index + 1,
                        name: entry.name,
                        length: length,
                        is_optional: entry.is_optional == '1'
                    };
                    if (lengths) att.lengths = lengths;
                    return att;
                })
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_category, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_category, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Categoria',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da categoria'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome da categoria'
        }
    ];
    categories_crud.run('categories', 'Categorias', document.getElementById('workarea'), (0, $5ecc6f797889b4f5$export$2e2bcd8739ae039), (0, $4208f0a476aca13f$export$2e2bcd8739ae039), fieldspecs);
};
var $7113b1f3aa2dbdf1$export$2e2bcd8739ae039 = $7113b1f3aa2dbdf1$var$categories;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");
async function $15cb3ff7d6a1c0bb$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; max-width: 40rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Fabricante</th>
					<th data-index="3" data-visible="${this.visible[2]}">COD FABRICANTE</th>
					<th data-index="4" data-visible="${this.visible[3]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.nick}</td>
					<td data-visible='${this.visible[3]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $1b5d59a7ca36f0f9$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#manufacturer #company_id	{ width: 10rem;	}
			#manufacturer #id			{ width: 5rem; text-align: right;	}
			#manufacturer #nick			{ width: 10rem;	}
			#manufacturer #name			{ width: 25rem;	}
		</style>
		<form id="manufacturer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do fabricante">Fabricante
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo do fabricante (campo t\xe9cnico nick)">COD FABRICANTE<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Raz\xe3o social do fabricante">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#manufacturer',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#nick'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
const $63ee0a3c4d5a5d51$var$manufacturers = function() {
    let manufacturers_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_manufacturers, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('manufacturers', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_manufacturers, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_manufacturer, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                nick: data.nick,
                name: data.name
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_manufacturer, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_manufacturer, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Fabricante',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "C\xf3digo (nick) ou nome do fabricante \u2014 selecione na lista",
            store: 'manufacturers',
            labels: [
                'nick',
                'name'
            ]
        },
        {
            index: 3,
            field: 'nick',
            label: 'COD FABRICANTE',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo do fabricante (enviado como nick nas APIs)"
        },
        {
            index: 4,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Raz\xe3o social / nome do fabricante (exibido nas telas e relat\xf3rios)"
        }
    ];
    manufacturers_crud.run('manufacturers', 'Fabricantes', document.getElementById('workarea'), (0, $15cb3ff7d6a1c0bb$export$2e2bcd8739ae039), (0, $1b5d59a7ca36f0f9$export$2e2bcd8739ae039), fieldspecs);
};
var $63ee0a3c4d5a5d51$export$2e2bcd8739ae039 = $63ee0a3c4d5a5d51$var$manufacturers;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");

var $9Wik7 = parcelRequire("9Wik7");
var $hlPFs = parcelRequire("hlPFs");
var $bWgzi = parcelRequire("bWgzi");
var $3eqAU = parcelRequire("3eqAU");
async function $db2166c5ef26f5de$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left;	}
			.view td:nth-child(5)	{ text-align: left; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: left; }
			.view td:nth-child(14)	{ text-align: center; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: right; }
			.view td:nth-child(17)	{ text-align: right; }
			.view td:nth-child(18)	{ text-align: right; }
			.view td:nth-child(19)	{ text-align: right; }
			.view td:nth-child(20)	{ text-align: right; }
			.view td:nth-child(21)	{ text-align: left; }
			.view td:nth-child(22)	{ text-align: left; }
			/*
			.view td:nth-child(23)	{ text-align: left; }
			.view td:nth-child(24)	{ text-align: left; }
			.view td:nth-child(25)	{ text-align: right; }
			*/
			.view td:nth-child(23)	{ text-align: right; }
			.view td:nth-child(24)	{ text-align: right; }
			.view td:nth-child(25)	{ text-align: right; }
			.view td:nth-child(26)	{ text-align: right; }
			.view td:nth-child(27)	{ text-align: right; }
			.view td:nth-child(28)	{ text-align: right; }
			.view td:nth-child(29)	{ text-align: right; }
			.view td:nth-child(30)	{ text-align: right; }
			.view td:nth-child(31)	{ text-align: center; }
			.view td:nth-child(32)	{ text-align: left; }
			.view td:nth-child(33)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Produto</th>
					<th data-index="3" data-visible="${this.visible[2]}">Categoria</th>
					<th data-index="6" data-visible="${this.visible[3]}">Fabricante</th>
					<th data-index="7" data-visible="${this.visible[4]}">SKU</th>
					<th data-index="9" data-visible="${this.visible[5]}">Nome</th>
					<th data-index="10" data-visible="${this.visible[6]}">Sin\xf4nimos</th>
					<th data-index="11" data-visible="${this.visible[7]}">Descri\xe7\xe3o</th>
					<th data-index="12" data-visible="${this.visible[8]}">Refer\xeancias</th>
					<th data-index="14" data-visible="${this.visible[9]}">Programa</th>
					<th data-index="15" data-visible="${this.visible[10]}">GTIN</th>
					<th data-index="16" data-visible="${this.visible[11]}">NCM</th>
					<th data-index="17" data-visible="${this.visible[12]}">CEST</th>
					<th data-index="18" data-visible="${this.visible[13]}">Origem</th>
					<th data-index="19" data-visible="${this.visible[14]}">Taxa\xe7\xe3o</th>
					<th data-index="20" data-visible="${this.visible[15]}">ICMS</th>
					<th data-index="21" data-visible="${this.visible[16]}">Vida</th>
					<th data-index="22" data-visible="${this.visible[17]}">Estoque M\xedn</th>
					<th data-index="23" data-visible="${this.visible[18]}">Estoque</th>
					<th data-index="24" data-visible="${this.visible[19]}">Valor</th>
					<th data-index="4" data-visible="${this.visible[20]}">Un Compra</th>
					<th data-index="5" data-visible="${this.visible[21]}">Un Venda</th>
					<!--
					<th data-index="32" data-visible="${this.visible[22]}">Anvisa</th>
					<th data-index="33" data-visible="${this.visible[23]}">Justificativa</th>
					<th data-index="34" data-visible="${this.visible[24]}">PMC</th>
					-->
					<th data-index="25" data-visible="${this.visible[22]}">ES Peso</th>
					<th data-index="26" data-visible="${this.visible[23]}">ES Altura</th>
					<th data-index="27" data-visible="${this.visible[24]}">ES Largura</th>
					<th data-index="28" data-visible="${this.visible[25]}">ES Compr</th>
					<th data-index="29" data-visible="${this.visible[26]}">ET Peso</th>
					<th data-index="30" data-visible="${this.visible[27]}">ET Altura</th>
					<th data-index="31" data-visible="${this.visible[28]}">ET Largura</th>
					<th data-index="32" data-visible="${this.visible[29]}">ET Compr</th>
					<th data-index="33" data-visible="${this.visible[30]}">Imagem</th>
					<th data-index="35" data-visible="${this.visible[32]}">Portaria 344</th>
					<th data-index="36" data-visible="${this.visible[33]}">Refrigerado</th>
					<th data-index="34" data-visible="${this.visible[31]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.category_id != null ? await this.key('categories', [
            record.company_id,
            record.category_id
        ]) : ''}</td>
					<td data-visible='${this.visible[3]}'>${record.manufacturer_id != null ? await this.key('manufacturers', [
            record.company_id,
            record.manufacturer_id
        ], 'name') : ''}</td>
					<td data-visible='${this.visible[4]}'>${record.sku.join('-')}</td>
					<td data-visible='${this.visible[5]}'>${record.name}</td>
					<td data-visible='${this.visible[6]}'>${(record.synonyms || []).join(',')}</td>
					<td data-visible='${this.visible[7]}'>${record.description || ''}</td>
					<td data-visible='${this.visible[8]}'>${(record.reference || []).join(',')}</td>
					<td data-visible='${this.visible[9]}'>${record.program_id != null ? await this.key('programs', [
            record.company_id,
            record.program_id
        ]) : ''}</td>
					<td data-visible='${this.visible[10]}'>${this.format($hlPFs.default(), record.gtin)}</td>
					<td data-visible='${this.visible[11]}'>${this.format($bWgzi.default(), record.ncm)}</td>
					<td data-visible='${this.visible[12]}'>${this.format($9Wik7.default(), record.cest)}</td>
					<td data-visible='${this.visible[13]}'>${record.origin}</td>
					<td data-visible='${this.visible[14]}'>${record.taxation || ''}</td>
					<td data-visible='${this.visible[15]}'>${this.format($3eqAU.default(2), record.icms)}</td>
					<td data-visible='${this.visible[16]}'>${this.format($3eqAU.default(0, 2), record.shelf_life)}</td>
					<td data-visible='${this.visible[17]}'>${this.format($3eqAU.default(0, 2), record.minimum_quantity)}</td>
					<td data-visible='${this.visible[18]}'>${this.format($3eqAU.default(0, 2), record.quantity)}</td>
					<td data-visible='${this.visible[19]}'>${this.format($3eqAU.default(2), record.value)}</td>
					<td data-visible='${this.visible[20]}'>${record.purchasing_unit_id != null ? await this.key('units', [
            record.company_id,
            record.purchasing_unit_id
        ]) : ''}</td>
					<td data-visible='${this.visible[21]}'>${record.selling_unit_id != null ? await this.key('units', [
            record.company_id,
            record.selling_unit_id
        ]) : ''}</td>
					<!--
					<td data-visible='${this.visible[22]}'>${record.drug?.anvisa || ''}</td>
					<td data-visible='${this.visible[23]}'>${record.drug?.exemption || ''}</td>
					<td data-visible='${this.visible[24]}'>${this.format($3eqAU.default(2), record.drug?.max_price)}</td>
					-->
					<td data-visible='${this.visible[22]}'>${this.format($3eqAU.default(3), record.secondary_weight)}</td>
					<td data-visible='${this.visible[23]}'>${this.format($3eqAU.default(3), record.secondary_height)}</td>
					<td data-visible='${this.visible[24]}'>${this.format($3eqAU.default(3), record.secondary_width)}</td>
					<td data-visible='${this.visible[25]}'>${this.format($3eqAU.default(3), record.secondary_length)}</td>
					<td data-visible='${this.visible[26]}'>${this.format($3eqAU.default(3), record.master_weight)}</td>
					<td data-visible='${this.visible[27]}'>${this.format($3eqAU.default(3), record.master_height)}</td>
					<td data-visible='${this.visible[28]}'>${this.format($3eqAU.default(3), record.master_width)}</td>
					<td data-visible='${this.visible[29]}'>${this.format($3eqAU.default(3), record.master_length)}</td>
					<td data-visible='${this.visible[30]}'>${record.image ? '&#10003;' : ''}</td>
					<td data-visible='${this.visible[32]}'>${record.is_portaria_344 ? record.portaria_344_list || 'SIM' : ''}</td>
					<td data-visible='${this.visible[33]}'>${record.is_refrigerated ? 'SIM' : ''}</td>
					<td data-visible='${this.visible[31]}'>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");

var $jUNyh = parcelRequire("jUNyh");

var $fY6pa = parcelRequire("fY6pa");
var $gBwx4 = parcelRequire("gBwx4");
var $9Wik7 = parcelRequire("9Wik7");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $84MPM = parcelRequire("84MPM");
var $hlPFs = parcelRequire("hlPFs");
var $fE2eE = parcelRequire("fE2eE");
var $74yTJ = parcelRequire("74yTJ");
var $bWgzi = parcelRequire("bWgzi");
var $3eqAU = parcelRequire("3eqAU");
var $badq7 = parcelRequire("badq7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $c7jhB = parcelRequire("c7jhB");
var $6Jl4s = parcelRequire("6Jl4s");
var $knytZ = parcelRequire("knytZ");
const $582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS = 'product-help-body';
const $582992a9d521cb7c$var$ICO_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7 12 12l8.7-5M12 22V12"/></svg>';
const $582992a9d521cb7c$var$ICO_BAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M4 12h10M4 17h13"/></svg>';
const $582992a9d521cb7c$var$ICO_SCALE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3v18M5 7h14"/><path d="M5 7 2 13h6L5 7zm14 0-3 6h6l-3-6z"/></svg>';
const $582992a9d521cb7c$var$ICO_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
/**
 * Extrai cClassTrib (6 alfanuméricos) do valor interno ou do rótulo do datalist.
 * @param {unknown} raw
 * @returns {string}
 */ function $582992a9d521cb7c$var$normalizeClassTribCode(raw) {
    const s = String(raw ?? '').trim().toUpperCase();
    if (!s || s === '-1' || s === '-2') return '';
    const m = s.match(/^([A-Z0-9]{6})\b/) || s.match(/^([A-Z0-9]{6})/);
    return m ? m[1] : '';
}
/**
 * Cabeçalho e cards do cadastro de produto.
 * @param {HTMLElement|null} root
 */ function $582992a9d521cb7c$var$syncProductPanel(root) {
    if (!root) return;
    const val = (sel)=>{
        const el = root.querySelector(sel);
        return el ? String(el.value ?? '').trim() : '';
    };
    const setText = (sel, text)=>{
        root.querySelectorAll(sel).forEach((el)=>{
            el.textContent = text;
        });
    };
    setText('[data-sdp="title"]', val('#name') || 'Novo produto');
    setText('[data-sdp="sku"]', val('#sku') || "\u2014");
    setText('[data-sdp="kpi-sku"]', val('#sku') || "\u2014");
    setText('[data-sdp="kpi-qty"]', val('#quantity') || '0');
    setText('[data-sdp="kpi-value"]', val('#value') || '0');
    setText('[data-sdp="kpi-life"]', val('#shelf_life') || '0');
    const badgeOff = root.querySelector('[data-sdp="badge-disabled"]');
    const badgeCold = root.querySelector('[data-sdp="badge-refrigerated"]');
    if (badgeOff) badgeOff.hidden = !root.querySelector('#is_disabled')?.checked;
    if (badgeCold) badgeCold.hidden = !root.querySelector('#is_refrigerated')?.checked;
}
const $582992a9d521cb7c$var$PRODUCT_HELP_DADOS_HTML = `
<div class="${$582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS}">
<h4>Empresa</h4>
<p>Empresa (depositante) \xe0 qual o produto pertence. Define escopo de IDs sequenciais, categorias, unidades e demais cadastros filhos.</p>
<h4>Produto</h4>
<p>Identificador num\xe9rico interno do item; preenchido ap\xf3s a primeira grava\xe7\xe3o.</p>
<h4>Categoria e fabricante</h4>
<p>Categoria regras de SKU/taxonomia e classifica\xe7\xe3o comercial. Fabricante (laborat\xf3rio/fornecedor industrial) usado em cadastro e relat\xf3rios.</p>
<h4>Un Compra / Un Venda</h4>
<p>Unidade de medida padr\xe3o na compra e na venda (ex.: CX, UN). Podem coincidir ou n\xe3o conforme o neg\xf3cio.</p>
<h4>SKU e taxonomia</h4>
<p>SKU \xe9 o c\xf3digo interno do produto (tamanho e formato dependem da categoria). Taxonomia complementa a chave de identifica\xe7\xe3o comercial no SIAL.</p>
<h4>Nome, descri\xe7\xe3o, sin\xf4nimos e refer\xeancias</h4>
<p>Nome exibido e buscas; sin\xf4nimos e refer\xeancias ajudam localiza\xe7\xe3o e integra\xe7\xf5es (c\xf3digos externos).</p>
<h4>C\xf3digo cliente</h4>
<p>C\xf3digo do produto na base do cliente (DE/PARA para integra\xe7\xe3o ou confer\xeancia).</p>
<h4>Programa</h4>
<p>V\xednculo opcional a programa (ex.: programas de sa\xfade): usado quando a empresa controla estoque ou pol\xedticas por programa.</p>
<h4>GTIN, NCM, CEST e origem</h4>
<p>GTIN (EAN) do produto ou \u{201C}SEM GTIN\u{201D} quando n\xe3o houver c\xf3digo de barras (campo legado, ainda usado em NF-e e integra\xe7\xf5es). GTIN por n\xedvel de embalagem (P/S/T) e fabricante vinculado ficam em <strong>Cat\xe1logo \u{2192} Embalagens de produto</strong>; os dois podem coexistir durante a migra\xe7\xe3o.</p>
<h4>Medicamentos (Anvisa, justificativa, PMC)</h4>
<p>Campos opcionais para registro/justificativa junto \xe0 Anvisa e pre\xe7o m\xe1ximo ao consumidor, quando aplic\xe1vel ao item.</p>
<h4>Inativo e imagem</h4>
<p>Inativo impede uso operacional normal do cadastro. Imagem associada ao produto (arquivo PNG) para exibi\xe7\xe3o ou documenta\xe7\xe3o.</p>
</div>`;
const $582992a9d521cb7c$var$PRODUCT_HELP_ARMAZENAGEM_HTML = `
<div class="${$582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS}">
<h4>Vida (prazo de validade m\xednimo)</h4>
<p>Prazo m\xednimo de validade em dias exigido para o produto em opera\xe7\xf5es que respeitam essa regra (ex.: recebimento ou picking).</p>
<h4>Est M\xednimo, Estoque e Valor</h4>
<p><strong>Est M\xednimo:</strong> refer\xeancia de reposi\xe7\xe3o.</p>
<p><strong>Estoque e Valor</strong> no cadastro s\xe3o campos no registro do <em>produto</em> (tabela <code>products</code>): total e valor agregados para a grade e para c\xe1lculos (ex.: custo m\xe9dio em transa\xe7\xf5es). Eles <strong>n\xe3o</strong> geram carga inicial operacional: n\xe3o criam lote, n\xe3o criam posi\xe7\xe3o e n\xe3o gravam na tabela <code>stocks</code>. O saldo \u{201C}de verdade\u{201D} do armaz\xe9m vem de <strong>entradas</strong> (pedido/confer\xeancia/estocagem), <strong>movimenta\xe7\xf5es</strong> e <strong>invent\xe1rio</strong>. Em opera\xe7\xe3o normal, quantidade e valor do produto s\xe3o atualizados pelo servi\xe7o de <strong>transa\xe7\xf5es</strong> quando h\xe1 entrada ou sa\xedda f\xedsica do armaz\xe9m.</p>
<h4>Portaria 344</h4>
<p>Indica se o item se enquadra na Portaria 344/98 e, se sim, a lista (A1, B1, C1\u{2026}). Afeta tratamento de medicamentos controlados.</p>
<h4>Refrigerado</h4>
<p>Marque quando o produto exige armazenamento ou transporte refrigerado. A informa\xe7\xe3o aparece na descri\xe7\xe3o operacional (picking, NF-e) como qualificador \xabREFRIGERADO\xbb.</p>
<h4>Countback na separa\xe7\xe3o (Coletor)</h4>
<p>Quando <strong>ligado</strong>, ap\xf3s o separador confirmar a quantidade deste SKU no <strong>Coletor</strong>, o sistema exige informar o <strong>saldo restante na posi\xe7\xe3o</strong> (o que sobrou, n\xe3o o que foi retirado). O SIAL compara com o saldo esperado. Se divergir, o operador pode tentar de novo (at\xe9 <strong>3</strong> tentativas); na terceira, a linha fica bloqueada para auditoria. O gestor libera em <strong>Movimenta\xe7\xe3o \u{2192} Countback Picking</strong>, com observa\xe7\xe3o obrigat\xf3ria. Quando <strong>desligado</strong> (padr\xe3o), a separa\xe7\xe3o deste produto segue sem essa valida\xe7\xe3o. O par\xe2metro \xe9 <strong>por produto (SKU)</strong>, n\xe3o por empresa.</p>
<h4>Hierarquia de embalagens (P / S / T)</h4>
<p>Tabela somente leitura das embalagens cadastradas em <strong>Embalagens de produto</strong> (n\xedveis prim\xe1rio, secund\xe1rio, terci\xe1rio). Use <strong>Atualizar lista</strong> para recarregar sem fechar o formul\xe1rio. A empresa precisa ter <strong>Hierarquia de embalagens</strong> ativa para o modelo novo nas opera\xe7\xf5es.</p>
<h4>Dimens\xf5es ES / ET (legado)</h4>
<p>Medidas f\xedsicas gravadas no pr\xf3prio produto: ES = secund\xe1ria, ET = terci\xe1ria (campos <code>master_*</code> na API). Complementam \u{2014} n\xe3o substituem \u{2014} o cadastro de embalagens por n\xedvel.</p>
<h4>Classes</h4>
<p>Associa\xe7\xe3o do produto a classes operacionais/fiscais da empresa. Use as setas para incluir ou remover da lista \u{201C}Classes\u{201D} a partir de \u{201C}Dispon\xedveis\u{201D}.</p>
</div>`;
const $582992a9d521cb7c$var$PRODUCT_HELP_TRIBUTACAO_HTML = `
<div class="${$582992a9d521cb7c$var$PRODUCT_HELP_BODY_CLASS}">
<h4>Mono (monof\xe1sico)</h4>
<p>Indica tributa\xe7\xe3o monof\xe1sica quando aplic\xe1vel ao produto (PIS/COFINS ou ICMS conforme parametriza\xe7\xe3o fiscal do ambiente).</p>
<h4>ST (substitui\xe7\xe3o tribut\xe1ria)</h4>
<p>Marcar quando o item estiver sujeito a ST na opera\xe7\xe3o da empresa.</p>
<h4>Isento</h4>
<p>Indica isen\xe7\xe3o de ICMS para o produto nas regras em que o SIAL utiliza esse flag.</p>
<h4>ICMS</h4>
<p>Al\xedquota ou percentual espec\xedfico de ICMS do produto quando houver tratamento diferenciado em rela\xe7\xe3o \xe0 regra padr\xe3o da empresa/nota.</p>
</div>`;
const $582992a9d521cb7c$var$PRODUCT_HELP_BY_TAB = {
    dados: {
        title: "Ajuda \u2014 Dados do produto",
        html: $582992a9d521cb7c$var$PRODUCT_HELP_DADOS_HTML
    },
    armazenagem: {
        title: "Ajuda \u2014 Armazenagem",
        html: $582992a9d521cb7c$var$PRODUCT_HELP_ARMAZENAGEM_HTML
    },
    tributacao: {
        title: "Ajuda \u2014 Tributa\xe7\xe3o",
        html: $582992a9d521cb7c$var$PRODUCT_HELP_TRIBUTACAO_HTML
    }
};
var $582992a9d521cb7c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#product .form-section { margin-bottom: 1.5rem; }
			#product label.checkbox-row { display: flex; align-items: center; gap: 0.5rem; min-height: 2.25rem; }
			#product label.checkbox-row input[type="checkbox"] { width: 1.25rem; height: 1.25rem; min-width: 1.25rem; min-height: 1.25rem; margin: 0; cursor: pointer; accent-color: #6d28d9; }
			#product input[type="checkbox"] { width: 1.25rem; height: 1.25rem; min-width: 1.25rem; min-height: 1.25rem; margin: 0; cursor: pointer; accent-color: #6d28d9; }
			#product .sku					{ width: 25%; 		}
			#product .taxons				{ width: 75%; 		}
			#product #image					{ width: auto; max-width: 18rem; display: inline-block;	}
			#product .product-tab-help {
				display: inline-flex; align-items: center; justify-content: center;
				width: 1.35rem; height: 1.35rem; padding: 0;
				border: 1px solid #c4b5fd; border-radius: 999px;
				background: #fff; color: #6d28d9;
				font-size: 0.85rem; font-weight: 700; line-height: 1;
				cursor: pointer; flex-shrink: 0;
			}
			#product .product-tab-help:hover { background: #f3e8ff; }
			#product .product-tab-help:focus { outline: 2px solid #7c3aed; outline-offset: 2px; }
			#product .product-pkg-hint { font-size: 0.8rem; color: #64748b; line-height: 1.45; max-width: 100%; margin: 0 0 0.5rem 0; }
			#product .product-pkg-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem; margin-top: 0.35rem; }
			#product .product-pkg-actions .button { white-space: nowrap; }
			#product .product-pkg-embed-status { font-size: 0.8rem; color: #64748b; min-height: 1.25rem; margin: 0.25rem 0 0.35rem 0; }
			#product .product-pkg-table-wrap { overflow: auto; max-height: 16rem; border: 1px solid var(--color-border); border-radius: 6px; margin-top: 0.25rem; background: #fff; }
			#product .product-pkg-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
			#product .product-pkg-table th, #product .product-pkg-table td { padding: 0.35rem 0.55rem; text-align: left; border-bottom: 1px solid #e2e8f0; vertical-align: top; }
			#product .product-pkg-table th { background: #f5f3ff; font-weight: 600; white-space: nowrap; position: sticky; top: 0; z-index: 1; }
			#product .product-pkg-table tr:last-child td { border-bottom: none; }
			#product .product-pkg-table td.num { text-align: right; font-variant-numeric: tabular-nums; }
			#product .product-pkg-table .cell-mono { font-family: ui-monospace, monospace; font-size: 0.78rem; }
		</style>
		<style>
			.product-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
			.product-help-body h4 {
				margin: 0.85rem 0 0.25rem 0;
				font-size: 0.78rem; font-weight: 700; text-transform: uppercase;
				letter-spacing: 0.03em; color: #1f2937;
			}
			.product-help-body h4:first-child { margin-top: 0; }
			.product-help-body p {
				margin: 0; font-size: 0.875rem; line-height: 1.45; color: #374151;
			}
		</style>
		<form id="product" class="form sial-modal-form sial-detail sial-detail--edit sial-detail--tabs" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="categories"></datalist>
			<datalist id="units"></datalist>
			<datalist id="manufacturers"></datalist>
			<datalist id="origins"></datalist>
			<datalist id="programs"></datalist>
			<datalist id="class_tribs"></datalist>

			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${$582992a9d521cb7c$var$ICO_BOX}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Cadastro de produto</p>
						<h2 class="sdp-title" data-sdp="title">Novo produto</h2>
						<div class="sdp-meta">
							<span>SKU: <b data-sdp="sku">\u{2014}</b></span>
							<span class="sdp-badge sdp-badge--blocked" data-sdp="badge-disabled" hidden>Inativo</span>
							<span class="sdp-badge sdp-badge--other" data-sdp="badge-refrigerated" hidden>Refrigerado</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>
			<section class="sdp-kpis" aria-label="Resumo do produto">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">${$582992a9d521cb7c$var$ICO_BAR} SKU</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-sku">\u{2014}</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">${$582992a9d521cb7c$var$ICO_BOX} Estoque</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-qty">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">${$582992a9d521cb7c$var$ICO_SCALE} Valor</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-value">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--free">
					<div class="sdp-kpi-label">${$582992a9d521cb7c$var$ICO_CLOCK} Vida</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-life">0</span><span class="sdp-kpi-unit">dias</span></div>
				</div>
			</section>

			<div class="form-tabs">
				<div class="form-tab-wrap">
					<button type="button" class="form-tab active" data-tab="dados">Dados do produto</button>
					<button type="button" class="product-tab-help" data-help="dados" title="Ajuda: campos desta aba" aria-label="Ajuda \u{2014} Dados do produto">?</button>
				</div>
				<div class="form-tab-wrap">
					<button type="button" class="form-tab" data-tab="armazenagem">Armazenagem</button>
					<button type="button" class="product-tab-help" data-help="armazenagem" title="Ajuda: campos desta aba" aria-label="Ajuda \u{2014} Armazenagem">?</button>
				</div>
				<div class="form-tab-wrap">
					<button type="button" class="form-tab" data-tab="tributacao">Tributa\xe7\xe3o</button>
					<button type="button" class="product-tab-help" data-help="tributacao" title="Ajuda: campos desta aba" aria-label="Ajuda \u{2014} Tributa\xe7\xe3o">?</button>
				</div>
			</div>
			<div class="form-tab-panels">
				<div id="tab-dados" class="form-tab-panel active">
					<div class="form-section">
						<div class="form-section-title">Dados b\xe1sicos</div>
						<div class="form-grid form-grid-6">
							<label title="Empresa">Empresa<sup>*</sup><input id="company_id" type="text" list="companies" required></label>
							<label title="Identificador do produto">Produto<input id="id" type="text" disabled></label>
							<label title="Categoria">Categoria<sup>*</sup><input id="category_id" type="text" list="categories" required></label>
							<label title="Fabricante">Fabricante<sup>*</sup><input id="manufacturer_id" type="text" list="manufacturers" required></label>
							<label title="Unidade de compra">Un Compra<sup>*</sup><input id="purchasing_unit_id" type="text" list="units" required></label>
							<label title="Unidade de venda">Un Venda<sup>*</sup><input id="selling_unit_id" type="text" list="units" required></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Identifica\xe7\xe3o e descri\xe7\xe3o</div>
						<div class="fsb">
							<fieldset class="sku"><legend>SKU<sup>*</sup></legend><table><tr><td><input id="sku" type="text" required title="C\xf3digo do produto."></td></tr></table></fieldset>
							<fieldset class="taxons"><legend>Taxonomia<sup>*</sup></legend><table><tr><td><input id="taxons" type="text" required></td></tr></table></fieldset>
						</div>
						<div class="form-grid form-grid-2 mtm">
							<label title="Nome">Nome<sup>*</sup><input id="name" type="text" required></label>
							<label title="Descri\xe7\xe3o">Descri\xe7\xe3o<textarea id="description" rows="2"></textarea></label>
						</div>
						<div class="form-grid form-grid-4 mtm">
							<label title="Sin\xf4nimos">Sin\xf4nimos<input id="synonyms" type="text"></label>
							<label title="Refer\xeancias">Refer\xeancias<input id="reference" type="text"></label>
							<label title="C\xf3digo cliente">C\xf3digo cliente<input id="codigo_cliente" type="text"></label>
							<label title="Programa">Programa<input id="program_id" type="text" list="programs"></label>
						</div>
						<div class="form-grid form-grid-4 mtm">
							<label title="GTIN">GTIN<sup>*</sup><input id="gtin" type="text" required placeholder="SEM GTIN"></label>
							<label title="NCM">NCM<sup>*</sup><input id="ncm" type="text" required></label>
							<label title="CEST">CEST<input id="cest" type="text"></label>
							<label title="Origem">Origem<sup>*</sup><input id="origin" type="text" list="origins" required></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Medicamentos</div>
						<fieldset>
							<label title="Anvisa">Anvisa<input id="drug_anvisa" type="text"></label>
							<label title="Justificativa ISENTO">Justificativa<input id="drug_exemption" type="text"></label>
							<label title="PMC">PMC<input id="drug_max_price" type="text"></label>
							<label title="C\xf3digo de benef\xedcio fiscal NF-e SP (ex.: SP010920 ou SEM CBENEF)">cBenef SP<input id="c_benef" type="text" placeholder="SP010920 / SEM CBENEF" maxlength="12"></label>
						</fieldset>
					</div>
					<div class="form-section">
						<div class="form-section-title">Status</div>
						<div class="status-group">
							<label class="checkbox-row" title="Inativo"><input id="is_disabled" type="checkbox"> Inativo</label>
							<label class="file"><a id="download" download="image.png">Imagem</a><input id="image" type="file" accept=".png, image/x-png" title="Imagem"></label>
						</div>
					</div>
				</div>
				<div id="tab-armazenagem" class="form-tab-panel">
					<div class="form-section">
						<div class="form-section-title">Estoque e validade</div>
						<div class="form-grid form-grid-4">
							<label title="Validade m\xednima em dias">Vida<sup>*</sup><input id="shelf_life" type="text" required></label>
							<label title="Estoque m\xednimo desejado (refer\xeancia)">Est M\xednimo<input id="minimum_quantity" type="text"></label>
							<label title="Total gravado no cadastro do produto (grade). N\xe3o cria estoque por posi\xe7\xe3o/lote \u{2014} use Entrada / movimenta\xe7\xf5es para carga inicial operacional.">Estoque (cadastro)<input id="quantity" type="text"></label>
							<label title="Valor do estoque">Valor<input id="value" type="text"></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Portaria 344</div>
						<div class="status-group">
							<label class="checkbox-row" title="Produto sujeito \xe0 Portaria 344/98"><input id="is_portaria_344" type="checkbox"> Portaria 344</label>
							<label title="Lista 344"><select id="portaria_344_list"><option value="">\u{2014}</option><option value="A1">A1</option><option value="A2">A2</option><option value="B1">B1</option><option value="C1">C1</option><option value="C2">C2</option><option value="C3">C3</option><option value="C4">C4</option><option value="C5">C5</option></select></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Refrigerado</div>
						<div class="status-group">
							<label class="checkbox-row" title="Produto refrigerado \u{2014} armazenamento/transporte; aparece como \xabREFRIGERADO\xbb na descri\xe7\xe3o operacional"><input id="is_refrigerated" type="checkbox"> Refrigerado</label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Countback</div>
						<div class="status-group">
							<label class="checkbox-row" title="Ap\xf3s confirmar a separa\xe7\xe3o deste SKU no Coletor, exige informar o saldo restante na posi\xe7\xe3o (Countback). Ap\xf3s 3 erros, bloqueia para auditoria."><input id="out_enable_countback" type="checkbox"> Countback na separa\xe7\xe3o (Coletor)</label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Hierarquia de embalagens (P / S / T)</div>
						<p class="product-pkg-hint">Embalagens j\xe1 cadastradas para <strong>este produto</strong> aparecem na tabela abaixo (somente leitura). Para <strong>incluir ou alterar</strong> n\xedveis, c\xf3digo, fator, GTIN etc., use depois <strong>Cat\xe1logo \u{2192} Embalagens de produto</strong> \u{2014} voc\xea n\xe3o precisa sair deste modal s\xf3 para consultar a lista. Ative <strong>Hierarquia de embalagens</strong> na empresa para o modelo valer nas opera\xe7\xf5es.</p>
						<div class="product-pkg-actions">
							<button type="button" class="button bn_refresh_product_packagings" title="Recarregar embalagens da API">Atualizar lista</button>
						</div>
						<div class="product-pkg-embed-status" id="product_packagings_embed_status" aria-live="polite"></div>
						<div class="product-pkg-table-wrap">
							<table class="product-pkg-table">
								<thead>
									<tr>
										<th>ID</th>
										<th>SKU</th>
										<th>C\xf3digo</th>
										<th>N\xedvel</th>
										<th class="num">Fator</th>
										<th class="num">Cap. terc.</th>
										<th>Fabricante</th>
										<th>GTIN</th>
										<th>Padr\xe3o</th>
										<th>Inativa</th>
									</tr>
								</thead>
								<tbody id="product_packagings_embed_body"></tbody>
							</table>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Dimens\xf5es f\xedsicas legadas (ES / ET)</div>
						<p class="product-pkg-hint">Medidas no cadastro do <strong>produto</strong> (modelo antigo): <strong>ES</strong> = embalagem secund\xe1ria (n\xedvel S), <strong>ET</strong> = embalagem terci\xe1ria (n\xedvel T). No banco/API os campos da terci\xe1ria continuam nomeados <code>master_*</code> por compatibilidade. N\xe3o substituem o cadastro hier\xe1rquico P/S/T em <strong>Embalagens de produto</strong>.</p>
						<div class="fsb">
							<fieldset><legend>Secund\xe1ria (ES)</legend>
								<label title="Peso da embalagem secund\xe1ria (kg)">Peso<input id="secondary_weight" type="text"></label>
								<label title="Altura da embalagem secund\xe1ria (m)">Altura<input id="secondary_height" type="text"></label>
								<label title="Largura da embalagem secund\xe1ria (m)">Largura<input id="secondary_width" type="text"></label>
								<label title="Comprimento da embalagem secund\xe1ria (m)">Compr<input id="secondary_length" type="text"></label>
							</fieldset>
							<fieldset><legend>Terci\xe1ria (ET)</legend>
								<label title="Peso da embalagem terci\xe1ria (kg)">Peso<input id="master_weight" type="text"></label>
								<label title="Altura da embalagem terci\xe1ria (m)">Altura<input id="master_height" type="text"></label>
								<label title="Largura da embalagem terci\xe1ria (m)">Largura<input id="master_width" type="text"></label>
								<label title="Comprimento da embalagem terci\xe1ria (m)">Compr<input id="master_length" type="text"></label>
							</fieldset>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">Classifica\xe7\xf5es</div>
						<div class="fsb">
							<label class="keymap">Classes<select id="classes" multiple size="4"></select></label>
							<span class="keymap"><button type="button" class="bn_Left" title="Incluir">&#x1F844;</button><button type="button" class="bn_Right" title="Remover">&#x1F846;</button></span>
							<label class="keymap">Dispon\xedveis<select id="available" multiple size="4"></select></label>
						</div>
					</div>
				</div>
				<div id="tab-tributacao" class="form-tab-panel">
					<div class="form-section">
						<div class="form-section-title">Impostos</div>
						<div class="form-grid form-grid-4">
							<label class="checkbox-row" title="Monof\xe1sico"><input id="is_mono" type="checkbox"> Mono</label>
							<label class="checkbox-row" title="Substituto Tribut\xe1rio"><input id="is_st" type="checkbox"> ST</label>
							<label class="checkbox-row" title="Isento de ICMS"><input id="is_exempt" type="checkbox"> Isento</label>
							<label title="Al\xedquota ICMS">ICMS<input id="icms" type="text"></label>
						</div>
					</div>
					<div class="form-section">
						<div class="form-section-title">IBS / CBS (ClassTrib)</div>
						<div class="form-grid form-grid-4">
							<label title="cClassTrib na NF-e \u{2014} tabela oficial NT 2025.002">ClassTrib<input id="class_trib" type="text" maxlength="120" list="class_tribs" placeholder="000001" autocomplete="off"></label>
							<label title="CST IBS/CBS derivado do ClassTrib (tabela oficial; n\xe3o grava \u{2014} s\xf3 exibi\xe7\xe3o)">CST IBS/CBS<input id="class_trib_cst" type="text" maxlength="3" readonly tabindex="-1" placeholder="\u{2014}"></label>
							<label title="Base legal do ClassTrib">Base legal<input id="class_trib_legal_basis" type="text" maxlength="200"></label>
							<label title="Nome / descri\xe7\xe3o do ClassTrib na tabela oficial (n\xe3o grava \u{2014} s\xf3 exibi\xe7\xe3o)">Descri\xe7\xe3o ClassTrib<input id="class_trib_name" type="text" readonly tabindex="-1" placeholder="\u{2014}"></label>
							<label title="Al\xedquota IBS (%)">IBS %<input id="ibs_rate" type="text"></label>
							<label title="Al\xedquota CBS (%)">CBS %<input id="cbs_rate" type="text"></label>
						</div>
					</div>
				</div>
			</div>
			<div class="sdp-foot">
				<button type="button" class="button bn_product_disable btn-product-danger" title="Inativar produto">Inativar</button>
				<button type="button" class="button bn_product_enable" title="Ativar produto">Ativar</button>
				<button type="button" class="bn_Escape button">Fechar</button>
				<button type="button" class="bn_Enter button btn-product-success">Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#product',
        init (formset) {
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>formset.dialog?.getNode?.();
            /**
			 * Garante código ClassTrib (6 chars) no sessionStorage do campo —
			 * evita rótulo do datalist / -1 no Salvar e destrava o CST.
			 * @returns {string}
			 */ const forceClassTribCode = ()=>{
                const field = formset.form?.getFieldBySelector?.('#class_trib');
                const code = $582992a9d521cb7c$var$normalizeClassTribCode(field?.getValue?.()) || $582992a9d521cb7c$var$normalizeClassTribCode(root()?.querySelector?.('#class_trib')?.value);
                if (code && field) {
                    const cur = String(field.getValue?.() ?? '');
                    if (cur !== code) {
                        field.setValue(code);
                        field.refresh?.();
                    }
                }
                return code;
            };
            const syncClassTrib = async ()=>{
                const code = forceClassTribCode();
                const cstEl = root()?.querySelector?.('#class_trib_cst');
                const nameEl = root()?.querySelector?.('#class_trib_name');
                const legalField = formset.form?.getFieldBySelector?.('#class_trib_legal_basis');
                const legalEl = root()?.querySelector?.('#class_trib_legal_basis');
                if (!code) {
                    if (cstEl) cstEl.value = '';
                    if (nameEl) nameEl.value = '';
                    return;
                }
                if (cstEl) cstEl.value = code.slice(0, 3);
                try {
                    const row = await (0, $1cmSR.default).get('class_tribs', code);
                    if (nameEl) nameEl.value = row?.name || '';
                    if (row?.cst && cstEl) cstEl.value = String(row.cst);
                    const legalEmpty = !String(legalField?.getValue?.() ?? legalEl?.value ?? '').trim();
                    if (legalEmpty && row?.name) {
                        if (legalField?.setValue) {
                            legalField.setValue(row.name);
                            legalField.refresh?.();
                        } else if (legalEl) legalEl.value = row.name;
                    }
                } catch (_) {
                    if (nameEl) nameEl.value = '';
                }
            };
            const orig = this.setValues.bind(this);
            this.setValues = (values)=>{
                orig(values);
                $582992a9d521cb7c$var$syncProductPanel(this.node);
                syncClassTrib();
            };
            const origLoadList = formset.loadList.bind(formset);
            formset.loadList = async (datalist, store, options)=>{
                await origLoadList(datalist, store, options);
                if (store === 'class_tribs' || String(datalist) === '#class_tribs') await syncClassTrib();
            };
            const origRefresh = formset.form.refresh.bind(formset.form);
            formset.form.refresh = (...args)=>{
                origRefresh(...args);
                syncClassTrib();
            };
            const origSyncFromDom = formset.form.syncFromDom.bind(formset.form);
            formset.form.syncFromDom = ()=>{
                origSyncFromDom();
                forceClassTribCode();
            };
            const origGetValues = formset.form.getValues.bind(formset.form);
            formset.form.getValues = ()=>{
                const data = origGetValues();
                const code = forceClassTribCode() || $582992a9d521cb7c$var$normalizeClassTribCode(data.class_trib);
                if (code) data.class_trib = code;
                else delete data.class_trib;
                const legalDom = String(root()?.querySelector?.('#class_trib_legal_basis')?.value || '').trim();
                if (legalDom && !data.class_trib_legal_basis) data.class_trib_legal_basis = legalDom;
                return data;
            };
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#class_tribs', 'class_tribs', {
                labels: [
                    'code',
                    'name'
                ],
                value: 'code'
            });
            root()?.addEventListener?.('input', ()=>$582992a9d521cb7c$var$syncProductPanel(root()));
            root()?.addEventListener?.('change', ()=>$582992a9d521cb7c$var$syncProductPanel(root()));
            $582992a9d521cb7c$var$syncProductPanel(this.node);
            root()?.addEventListener?.('change', (ev)=>{
                if (ev.target?.matches?.('#class_trib')) syncClassTrib();
            });
            root()?.addEventListener?.('input', (ev)=>{
                if (ev.target?.matches?.('#class_trib')) syncClassTrib();
            });
            setTimeout(syncClassTrib, 100);
            setTimeout(syncClassTrib, 350);
            const getId = ()=>{
                const stored = formset.form.getFieldBySelector('#id')?.getValue?.();
                const fromField = parseInt(String(stored ?? '').replace(/\D/g, ''), 10);
                if (Number.isFinite(fromField) && fromField > 0) return String(fromField);
                const raw = String(root()?.querySelector?.('#id')?.value || '');
                const fromDom = parseInt(raw.replace(/\D/g, ''), 10);
                return Number.isFinite(fromDom) && fromDom > 0 ? String(fromDom) : '';
            };
            const getCompanyId = ()=>formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
            const loadEmbeddedPackagings = async ()=>{
                const statusEl = root()?.querySelector('#product_packagings_embed_status');
                const tbody = root()?.querySelector('#product_packagings_embed_body');
                if (!statusEl || !tbody) return;
                const company_id = String(getCompanyId() || '').trim();
                const pid = String(getId() || '').replace(/\s/g, '');
                if (!company_id) {
                    statusEl.textContent = 'Selecione a empresa para carregar embalagens.';
                    tbody.innerHTML = '';
                    return;
                }
                if (!pid || !/^\d+$/.test(pid)) {
                    statusEl.textContent = 'Salve o produto ao menos uma vez para exibir as embalagens (P/S/T) vinculadas a ele.';
                    tbody.innerHTML = '';
                    return;
                }
                statusEl.textContent = "Carregando embalagens\u2026";
                tbody.innerHTML = '';
                const host = (0, $9VcS9.getSialApiHost)();
                const path = `/companies/${encodeURIComponent(company_id)}/products/${encodeURIComponent(pid)}/packagings`;
                const url = host && String(host).trim() ? `${String(host).replace(/\/$/, '')}${path}` : path;
                const esc = (x)=>String(x ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                const lvl = (l)=>({
                        P: "P \u2014 Prim\xe1rio",
                        S: "S \u2014 Secund\xe1rio",
                        T: "T \u2014 Terci\xe1rio"
                    })[l] || esc(l);
                try {
                    const r = await fetch(url, {
                        credentials: 'include'
                    });
                    if (!r.ok) {
                        statusEl.textContent = r.status === 403 ? "Sem permiss\xe3o para listar embalagens." : `N\xe3o foi poss\xedvel carregar (${r.status}).`;
                        return;
                    }
                    const list = await r.json();
                    if (!Array.isArray(list)) {
                        statusEl.textContent = "Resposta inv\xe1lida da API.";
                        return;
                    }
                    if (list.length === 0) {
                        statusEl.textContent = 'Nenhuma embalagem cadastrada para este produto.';
                        return;
                    }
                    statusEl.textContent = `${list.length} embalagem(ns) cadastrada(s).`;
                    const fabLabel = async (mid)=>{
                        if (mid == null || mid === '') return "\u2014";
                        try {
                            const rec = await (0, $1cmSR.default).get('manufacturers', [
                                company_id,
                                Number(mid)
                            ]);
                            if (rec && (rec.nick || rec.name)) return esc(`${rec.id} ${rec.nick || rec.name}`);
                        } catch (e) {}
                        return esc(String(mid));
                    };
                    const rowsHtml = await Promise.all(list.map(async (row)=>{
                        const fab = await fabLabel(row.manufacturer_id);
                        return `
						<tr>
							<td class="num">${esc(row.id)}</td>
							<td class="cell-mono">${row.sku != null && String(row.sku).trim() !== '' ? esc(row.sku) : "\u2014"}</td>
							<td><strong>${esc(row.code)}</strong></td>
							<td>${lvl(row.level)}</td>
							<td class="num">${esc(row.factor)}</td>
							<td class="num">${row.tertiary_capacity != null && row.tertiary_capacity !== '' ? esc(row.tertiary_capacity) : "\u2014"}</td>
							<td>${fab}</td>
							<td class="cell-mono">${row.gtin ? esc(row.gtin) : "\u2014"}</td>
							<td>${row.is_default ? 'Sim' : "\u2014"}</td>
							<td>${row.is_disabled ? 'Sim' : "\u2014"}</td>
						</tr>`;
                    }));
                    tbody.innerHTML = rowsHtml.join('');
                } catch (e) {
                    statusEl.textContent = "Falha ao carregar. Verifique a conex\xe3o com a API.";
                    console.warn(e);
                }
            };
            const setDisabled = (v)=>{
                const f = formset.form.getFieldBySelector('#is_disabled');
                if (f) {
                    f.setValue(v ? 1 : 0);
                    f.refresh();
                }
            };
            const doAction = async (payload)=>{
                const company_id = getCompanyId(), id = getId();
                if (!company_id || !id) return;
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_product, company_id, id, payload);
                if (resp != null) setDisabled(payload.is_disabled);
                else (0, $jUNyh.notify)('Falha ao atualizar produto.', 'Produtos');
            };
            root()?.addEventListener?.('click', (ev)=>{
                if (ev.target?.closest?.('.bn_product_disable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: true
                    });
                    return;
                }
                if (ev.target?.closest?.('.bn_product_enable')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    doAction({
                        is_disabled: false
                    });
                    return;
                }
                const helpEl = ev.target?.closest?.('.product-tab-help');
                if (helpEl) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    const key = helpEl.getAttribute('data-help');
                    const pack = $582992a9d521cb7c$var$PRODUCT_HELP_BY_TAB[key];
                    if (!pack) return;
                    let mb;
                    mb = (0, $jUNyh.default)({
                        title: pack.title,
                        text: pack.html,
                        buttons: [
                            {
                                label: 'Fechar',
                                cls: 'bn_Enter'
                            }
                        ],
                        callback: ()=>mb.destroy()
                    });
                    return;
                }
                if (ev.target?.closest?.('.bn_refresh_product_packagings')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    loadEmbeddedPackagings();
                    return;
                }
                const tab = ev.target?.closest?.('.form-tab');
                if (!tab) return;
                ev.preventDefault();
                const id = tab.getAttribute('data-tab');
                root()?.querySelectorAll?.('.form-tab').forEach((t)=>t.classList.remove('active'));
                root()?.querySelectorAll?.('.form-tab-panel').forEach((p)=>p.classList.remove('active'));
                tab.classList.add('active');
                const panel = root()?.querySelector?.(`#tab-${id}`);
                if (panel) panel.classList.add('active');
                if (id === 'armazenagem') loadEmbeddedPackagings();
            });
            const syncPortaria344 = ()=>{
                const cb = root()?.querySelector?.('#is_portaria_344');
                const sel = root()?.querySelector?.('#portaria_344_list');
                if (cb && sel) sel.disabled = !(cb.checked || cb.value === '1');
            };
            root()?.addEventListener?.('change', (ev)=>{
                if (ev.target?.matches?.('#is_portaria_344')) syncPortaria344();
            });
            formset.form?.subscribe?.([
                'load',
                'refresh'
            ], syncPortaria344);
            formset.form?.subscribe?.([
                'load',
                'refresh'
            ], ()=>{
                loadEmbeddedPackagings();
            });
            formset.form?.subscribe?.([
                'load',
                'refresh'
            ], ()=>{
                $582992a9d521cb7c$var$syncProductPanel(this.node);
            });
            setTimeout(syncPortaria344, 100);
            setTimeout(()=>{
                loadEmbeddedPackagings();
            }, 200);
            setTimeout(()=>{
                $582992a9d521cb7c$var$syncProductPanel(this.node);
            }, 400);
        },
        afterEditSetValues (formset) {
            const panel = formset.form.node;
            $582992a9d521cb7c$var$syncProductPanel(panel);
            setTimeout(()=>$582992a9d521cb7c$var$syncProductPanel(panel), 400);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#category_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('categories')
            ]
        },
        {
            properties: {
                selector: '#purchasing_unit_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('units')
            ]
        },
        {
            properties: {
                selector: '#selling_unit_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('units')
            ]
        },
        {
            properties: {
                selector: '#manufacturer_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('manufacturers', {
                    labels: [
                        'nick',
                        'name'
                    ]
                })
            ]
        },
        //{ properties: { selector: '#sku' }, types: [types.pubsub(), types.observer('category_id'), types.obs_sku('.sku', '.taxons')] },
        //{ properties: { selector: '#sku' }, types: [types.sku(6)] },
        {
            properties: {
                selector: '#sku'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('category_id'),
                $e247330830b80775$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#taxons'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#synonyms'
            },
            types: [
                $fY6pa.default(),
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#description'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: [
                $fY6pa.default()
            ]
        },
        {
            properties: {
                selector: '#codigo_cliente'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#gtin'
            },
            types: [
                $hlPFs.default(),
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#ncm'
            },
            types: [
                $bWgzi.default()
            ]
        },
        {
            properties: {
                selector: '#cest'
            },
            types: [
                $9Wik7.default()
            ]
        },
        {
            properties: {
                selector: '#origin'
            },
            types: [
                $c7jhB.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#is_mono'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_st'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_exempt'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#icms'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#c_benef'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#class_trib'
            },
            types: [
                $gBwx4.default(),
                $9PIz7.default()
            ]
        },
        // CST / Descrição: só exibição (derivados do ClassTrib) — fora do formset para form.refresh() não apagar
        {
            properties: {
                selector: '#class_trib_legal_basis'
            },
            types: []
        },
        {
            properties: {
                selector: '#ibs_rate'
            },
            types: [
                $3eqAU.default(4)
            ]
        },
        {
            properties: {
                selector: '#cbs_rate'
            },
            types: [
                $3eqAU.default(4)
            ]
        },
        {
            properties: {
                selector: '#shelf_life'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#minimum_quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#value'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        //{ properties: { selector: '#drug_anvisa' }, types: [types.anvisa(), types.caps()] },
        //{ properties: { selector: '#drug_exemption' }, types: [] },
        //{ properties: { selector: '#drug_max_price' }, types: [types.number(2)] },
        {
            properties: {
                selector: '#secondary_weight'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#secondary_height'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#secondary_width'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#secondary_length'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#master_weight'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#master_height'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#master_width'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#master_length'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#classes'
            },
            types: [
                $6Jl4s.default(),
                $fE2eE.default('classes', '#available', {
                    values: [
                        'company_id',
                        'id'
                    ]
                }),
                $6lTH5.default('company_id'),
                $badq7.default()
            ]
        },
        {
            properties: {
                selector: '#image'
            },
            types: [
                $6Jl4s.default(),
                $84MPM.default()
            ]
        },
        {
            properties: {
                selector: '#is_portaria_344'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_refrigerated'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#out_enable_countback'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#portaria_344_list'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $6cd956745928b800$export$2e2bcd8739ae039 = {
    html: `
		<form id="products-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="programs-prod-report"></datalist>
			<p class="fss">Exporta o cadastro completo de produtos da empresa (dados gerais e tribut\xe1rios).
				CSV: UTF-8 com BOM para abrir no Excel.
				Excel: planilha XLSX com cabe\xe7alhos em portugu\xeas, filtros autom\xe1ticos e primeira linha congelada.
				Chamados #MT-007B282 e #MT-7A50355.</p>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Filtrar por programa">Programa
					<input id="program_id" type="text" list="programs-prod-report" placeholder="opcional">
				</label>
				<label title="Formato do arquivo de sa\xedda">Formato<sup>*</sup>
					<select id="format">
						<option value="xlsx">Excel (.xlsx)</option>
						<option value="csv">CSV (.csv)</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label title="Ativos / inativos no cadastro">Situa\xe7\xe3o
					<select id="status">
						<option value="all">Todos</option>
						<option value="active">Somente ativos</option>
						<option value="inactive">Somente inativos</option>
					</select>
				</label>
				<label title="Filtrar por SKU (parcial)">SKU (cont\xe9m)
					<input id="sku" type="text" placeholder="opcional">
				</label>
				<label title="Filtrar por nome/descri\xe7\xe3o do produto (parcial)">Nome (cont\xe9m)
					<input id="name" type="text" placeholder="opcional">
				</label>
				<label title="Limite de linhas">M\xe1x. linhas
					<input id="max_rows" type="text" value="50000" placeholder="50000">
				</label>
			</div>
			<div class="fsb mtm">
				<span class="fss" style="color:#666;">
					Colunas: empresa, ids, categoria, fabricante, hierarquia (taxons), SKU, nome, sin\xf4nimos,
					descri\xe7\xe3o, refer\xeancias, c\xf3digo cliente, programa, GTIN/EAN, NCM, CEST, origem, tributa\xe7\xe3o,
					flags ICMS (ST/isento/monof\xe1sico/red.BC), al\xedquota ICMS, cBenef, Portaria 344, vida \xfatil,
					estoques, valor, unidades, dimens\xf5es ES/ET, classes, Anvisa/PMC, inativo.
				</span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar Relat\xf3rio</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#products-print-report',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#format'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#max_rows'
            },
            types: [
                $3eqAU.default(0, 0)
            ]
        }
    ]
};



var $fY6pa = parcelRequire("fY6pa");
var $9PIz7 = parcelRequire("9PIz7");
var $hlPFs = parcelRequire("hlPFs");
var $74yTJ = parcelRequire("74yTJ");
var $bWgzi = parcelRequire("bWgzi");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $c7jhB = parcelRequire("c7jhB");
/**
 * Extrai cClassTrib (6 alfanuméricos) para gravar na API.
 * @param {unknown} raw
 * @returns {string|null}
 */ const $3b9ac53687e0fa72$var$normalizeClassTribCode = (raw)=>{
    const s = String(raw ?? '').trim().toUpperCase();
    if (!s || s === '-1' || s === '-2') return null;
    const m = s.match(/^([A-Z0-9]{6})\b/) || s.match(/^([A-Z0-9]{6})/);
    return m ? m[1] : null;
};
const $3b9ac53687e0fa72$var$products = function() {
    let products_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async addFilter (params) {
            await (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).addFilter.call(this, params);
            if (this.filter && JSON.stringify(this.filter).includes('is_disabled')) params.append('include_disabled', '1');
        },
        editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            try {
                this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
                this.loadPage(1);
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || 'Erro ao aplicar filtro.', 'Filtro');
                console.error('applyFilter', e);
            }
        },
        insertRecord () {
            this.editRecord({
                gtin: 'SEM GTIN'
            });
        },
        async loadBaseData () {
            await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_classes, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('classes', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_categories, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('categories', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_units, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('units', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_manufacturers, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('manufacturers', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('programs', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_class_tribs, '?nfe_only=1&limit=500').then((data)=>data && (0, $1cmSR.default).set('class_tribs', data).catch((error)=>(0, $jUNyh.notify)(error))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_products, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('products', data).catch((error)=>(0, $jUNyh.notify)(error)))
            ]);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_products, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_product, ...JSON.parse(id));
            _record.is_st = _record.taxation?.includes('S');
            _record.is_exempt = _record.taxation?.includes('I');
            _record.is_mono = _record.taxation?.includes('M');
            _record.classes = _record.classes?.map((entry)=>[
                    _record.company_id,
                    entry
                ]);
            return (0, $b60a2.flatten)(_record, 'drug');
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos um produto.', 'Produtos');
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $jUNyh.ask)(`Confirma ${action} ${ids.length} produto(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_product, company_id, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $jUNyh.notify)('Falha ao atualizar produto.', 'Produtos');
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async saveRecord (data, old_data) {
            let _record = {
                category_id: Number(data.category_id),
                purchasing_unit_id: Number(data.purchasing_unit_id),
                selling_unit_id: Number(data.selling_unit_id),
                manufacturer_id: Number(data.manufacturer_id),
                sku: [
                    data.sku
                ],
                taxons: [
                    data.taxons
                ],
                name: data.name,
                synonyms: data.synonyms,
                description: data.description,
                reference: data.reference,
                codigo_cliente: data.codigo_cliente && data.codigo_cliente.trim() ? data.codigo_cliente.trim() : null,
                program_id: data.program_id != null && data.program_id !== '' && Number(data.program_id) >= 0 ? Number(data.program_id) : null,
                gtin: data.gtin && data.gtin.trim() ? data.gtin.trim() : 'SEM GTIN',
                ncm: data.ncm,
                cest: data.cest,
                origin: data.origin,
                taxation: (data.is_st == '1' ? 'S' : '') + (data.is_exempt == '1' ? 'I' : '') + (data.is_mono == '1' ? 'M' : ''),
                icms: Number(data.icms),
                shelf_life: Number(data.shelf_life),
                minimum_quantity: Number(data.minimum_quantity),
                quantity: Number(data.quantity),
                value: Number(data.value),
                is_disabled: data.is_disabled == '1',
                is_portaria_344: data.is_portaria_344 == '1',
                is_refrigerated: data.is_refrigerated == '1',
                out_enable_countback: data.out_enable_countback == '1',
                portaria_344_list: data.portaria_344_list && data.portaria_344_list.trim() ? data.portaria_344_list.trim() : null,
                c_benef: data.c_benef && String(data.c_benef).trim() ? String(data.c_benef).trim() : null,
                class_trib: $3b9ac53687e0fa72$var$normalizeClassTribCode(data.class_trib),
                class_trib_legal_basis: data.class_trib_legal_basis && String(data.class_trib_legal_basis).trim() ? String(data.class_trib_legal_basis).trim() : null,
                ibs_rate: data.ibs_rate !== '' && data.ibs_rate != null ? Number(data.ibs_rate) : null,
                cbs_rate: data.cbs_rate !== '' && data.cbs_rate != null ? Number(data.cbs_rate) : null,
                secondary_weight: Number(data.secondary_weight),
                secondary_height: Number(data.secondary_height),
                secondary_width: Number(data.secondary_width),
                secondary_length: Number(data.secondary_length),
                master_weight: Number(data.master_weight),
                master_height: Number(data.master_height),
                master_width: Number(data.master_width),
                master_length: Number(data.master_length),
                image: data.image,
                classes: (0, $aGGTj.parse)(data.classes)?.map((entry)=>Number(entry[1]))
            };
            if (data.drug_anvisa) _record['drug'] = {
                anvisa: data.drug_anvisa,
                exemption: data.drug_exemption,
                max_price: Number(data.drug_max_price)
            };
            // Insert: old_data = { gtin: 'SEM GTIN' } (sem id). Update: old_data veio do loadRecord (tem id).
            const isUpdate = old_data && old_data.id != null && old_data.id !== '';
            if (isUpdate) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_product, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_product, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Posi\xe7\xe3o",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do produto'
        },
        {
            index: 3,
            field: 'category_id',
            label: 'Categoria',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Categoria do produto',
            store: 'categories'
        },
        {
            index: 6,
            field: 'manufacturer_id',
            label: 'Fabricante',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Fabricante do produto',
            store: 'manufacturers',
            labels: [
                'nick',
                'name'
            ]
        },
        {
            index: 7,
            field: 'sku',
            label: 'SKU',
            types: [
                $1fc4b4ad289a0aae$export$2e2bcd8739ae039(12)
            ],
            placeholder: '',
            title: "C\xf3digo do produto. Tamanho definido pela categoria. Use apenas A\u2013N, P\u2013Z e 0\u20139 (sem a letra O)."
        },
        {
            index: 9,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome do produto'
        },
        {
            index: 10,
            field: 'synonyms',
            label: "Sin\xf4nimos",
            types: [
                $fY6pa.default()
            ],
            placeholder: '',
            title: 'Nomes alternativos do produto'
        },
        {
            index: 11,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o do produto"
        },
        {
            index: 12,
            field: 'reference',
            label: "Refer\xeancias",
            types: [
                $fY6pa.default()
            ],
            placeholder: '',
            title: "C\xf3digos de refer\xeancia externos do produto"
        },
        {
            index: 13,
            field: 'codigo_cliente',
            label: "C\xf3d. cliente",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo do produto na base do cliente (DE/PARA)"
        },
        {
            index: 14,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa do produto (estoque por programa)',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 15,
            field: 'gtin',
            label: 'GTIN',
            types: [
                $hlPFs.default()
            ],
            placeholder: '',
            title: 'N\xfamero do c\xf3digo de barras ou "SEM GTIN"'
        },
        {
            index: 16,
            field: 'ncm',
            label: 'NCM',
            types: [
                $bWgzi.default()
            ],
            placeholder: '00000000',
            title: 'Nomenclatura Comum do Mercosul'
        },
        {
            index: 17,
            field: 'cest',
            label: 'CEST',
            types: [
                $bWgzi.default()
            ],
            placeholder: '00.000.00',
            title: "C\xf3digo Especificador da Substitui\xe7\xe3o Tribut\xe1ria"
        },
        {
            index: 18,
            field: 'origin',
            label: 'Origem',
            types: [
                $c7jhB.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Origem do produto'
        },
        {
            index: 19,
            field: 'taxation',
            label: "Taxa\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Indicadores de taxa\xe7\xe3o do produto"
        },
        {
            index: 20,
            field: 'icms',
            label: 'ICMS',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "Al\xedquota espec\xedfica de ICMS do produto, se houver"
        },
        {
            index: 21,
            field: 'shelf_life',
            label: 'Vida',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Prazo de validade m\xednimo do produto em dias"
        },
        {
            index: 22,
            field: 'minimum_quantity',
            label: "Estoque M\xedn",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Estoque m\xednimo desejado do produto em unidades"
        },
        {
            index: 23,
            field: 'quantity',
            label: 'Estoque',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Saldo agregado no cadastro (products.quantity). N\xe3o gera estoque WMS por posi\xe7\xe3o; para carga inicial use entrada ao armaz\xe9m."
        },
        {
            index: 24,
            field: 'value',
            label: 'Valor',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor atual do estoque do produto'
        },
        {
            index: 4,
            field: 'purchasing_unit_id',
            label: 'Un Compra',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Unidade de compra',
            store: 'units'
        },
        {
            index: 5,
            field: 'selling_unit_id',
            label: 'Un Venda',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Unidade de venda',
            store: 'units'
        },
        //{ index: 32, field: 'anvisa', label: 'Anvisa', types: [], placeholder: '', title: 'Número de registro na Anvisa ou "ISENTO"' },
        //{ index: 33, field: 'exemption', label: 'Justificativa', types: [], placeholder: '', title: 'Justificativa caso seja "ISENTO" de registro na Anvisa' },
        //{ index: 34, field: 'max_price', label: 'PMC', types: [types.number(2)], placeholder: '0,00', title: 'Preço Máximo ao Consumidor' },
        {
            index: 25,
            field: 'secondary_weight',
            label: 'ES Peso',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Peso da embalagem secund\xe1ria do produto em quilos"
        },
        {
            index: 26,
            field: 'secondary_height',
            label: 'ES Altura',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Altura da embalagem secund\xe1ria do produto em metros"
        },
        {
            index: 27,
            field: 'secondary_width',
            label: 'ES Largura',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Largura da embalagem secund\xe1ria do produto em metros"
        },
        {
            index: 28,
            field: 'secondary_length',
            label: 'ES Compr',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Comprimento da embalagem secund\xe1ria do produto em metros"
        },
        {
            index: 29,
            field: 'master_weight',
            label: 'ET Peso',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Peso da embalagem terci\xe1ria do produto em quilos (campo master_weight)"
        },
        {
            index: 30,
            field: 'master_height',
            label: 'ET Altura',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Altura da embalagem terci\xe1ria do produto em metros (campo master_height)"
        },
        {
            index: 31,
            field: 'master_width',
            label: 'ET Largura',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Largura da embalagem terci\xe1ria do produto em metros (campo master_width)"
        },
        {
            index: 32,
            field: 'master_length',
            label: 'ET Compr',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Comprimento da embalagem terci\xe1ria do produto em metros (campo master_length)"
        },
        {
            index: 33,
            field: 'image',
            label: 'Imagem',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Indicador de imagem associada ao produto'
        },
        {
            index: 35,
            field: 'is_portaria_344',
            label: 'Portaria 344',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Produto sujeito \xe0 Portaria 344/98 (lista em portaria_344_list)"
        },
        {
            index: 36,
            field: 'is_refrigerated',
            label: 'Refrigerado',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Produto refrigerado (cadastro)'
        },
        {
            index: 37,
            field: 'out_enable_countback',
            label: 'Countback',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Countback na separa\xe7\xe3o (Coletor) \u2014 por SKU"
        },
        {
            index: 34,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Produto inativo (n\xe3o listado para entrada)"
        }
    ];
    let operations = [
        {
            hash: '#product-disable',
            label: 'Inativar'
        },
        {
            hash: '#product-enable',
            label: 'Ativar'
        }
    ];
    const reports = [
        {
            hash: '#print-products-general-report',
            label: 'Cadastro Completo (Excel/CSV)'
        }
    ];
    async function resolveCompanyId(raw) {
        if (raw == null || String(raw).trim() === '') return null;
        const v = String(raw).trim();
        const c = await (0, $1cmSR.default).get('companies', v);
        return c?.id ?? v;
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-products-general-report', ()=>{
        (0, $b60a2.default).edit((0, $6cd956745928b800$export$2e2bcd8739ae039), async (data)=>{
            const companyId = await resolveCompanyId(data.company_id);
            if (!companyId) {
                (0, $jUNyh.notify)('Selecione a empresa.', 'Aviso');
                return false;
            }
            const fmt = data.format || 'xlsx';
            const params = new URLSearchParams();
            params.set('format', fmt);
            const pid = data.program_id != null ? String(data.program_id).trim() : '';
            if (pid !== '') params.set('program_id', pid);
            if (data.status) params.set('status', String(data.status).trim().toLowerCase());
            const skuVal = data.sku != null ? String(data.sku).trim() : '';
            if (skuVal !== '') params.set('sku', skuVal);
            const nameVal = data.name != null ? String(data.name).trim() : '';
            if (nameVal !== '') params.set('name', nameVal);
            const mr = parseInt(data.max_rows, 10);
            if (!isNaN(mr) && mr > 0) params.set('max_rows', String(mr));
            try {
                const res = await (0, $9VcS9.default).products_general_report(companyId, params.toString());
                const blob = await res.blob();
                if (!res.ok) {
                    let msg = await blob.text();
                    try {
                        const j = JSON.parse(msg);
                        msg = j?.message || msg;
                    } catch (_) {}
                    (0, $jUNyh.notify)(msg || res.statusText, 'Erro');
                    return false;
                }
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const ext = fmt === 'xlsx' ? 'xlsx' : 'csv';
                const prefix = fmt === 'xlsx' ? 'produtos-cadastro' : 'produtos-geral';
                a.download = `${prefix}-${String(companyId).slice(0, 8)}.${ext}`;
                a.click();
                URL.revokeObjectURL(url);
                (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                return false;
            }
            return true;
        }, {}, false);
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#product-disable', products_crud.setDisabled.bind(products_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#product-enable', products_crud.setDisabled.bind(products_crud, false));
    products_crud.run('products', 'Produtos', document.getElementById('workarea'), (0, $db2166c5ef26f5de$export$2e2bcd8739ae039), (0, $582992a9d521cb7c$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $3b9ac53687e0fa72$export$2e2bcd8739ae039 = $3b9ac53687e0fa72$var$products;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $3eqAU = parcelRequire("3eqAU");
async function $94935258288968c1$export$2e2bcd8739ae039(records) {
    return `
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th>Empresa</th>
					<th>ID</th>
					<th>SKU</th>
					<th>Produto</th>
					<th>C\xf3digo</th>
					<th>N\xedvel</th>
					<th>Fator</th>
					<th>Cap. Terci\xe1ria</th>
					<th>Peso (kg)</th>
					<th>Altura (cm)</th>
					<th>Largura (cm)</th>
					<th>Compr. (cm)</th>
					<th>Fabricante</th>
					<th>GTIN</th>
					<th>Padr\xe3o</th>
					<th>Inativa</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td>${await this.key('companies', record.company_id, 'nick')}</td>
					<td>${record.id}</td>
					<td>${record.sku != null && String(record.sku).trim() !== '' ? String(record.sku) : "\u2014"}</td>
					<td>${await this.key('products', [
            record.company_id,
            record.product_id
        ], 'name')}</td>
					<td>${record.code || ''}</td>
					<td>${record.level || ''}</td>
					<td>${record.factor ?? ''}</td>
					<td>${record.tertiary_capacity ?? ''}</td>
					<td>${this.format($3eqAU.default(3), record.weight)}</td>
					<td>${this.format($3eqAU.default(3), record.height)}</td>
					<td>${this.format($3eqAU.default(3), record.width)}</td>
					<td>${this.format($3eqAU.default(3), record.length)}</td>
					<td>${record.manufacturer_id != null && record.manufacturer_id !== '' ? await this.key('manufacturers', [
            record.company_id,
            record.manufacturer_id
        ], 'name') || "\u2014" : "\u2014"}</td>
					<td>${record.gtin || ''}</td>
					<td>${record.is_default ? 'SIM' : 'NAO'}</td>
					<td>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $hlPFs = parcelRequire("hlPFs");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
const $4513b7495ab4b07e$var$ICO_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7 12 12l8.7-5M12 22V12"/></svg>';
const $4513b7495ab4b07e$var$ICO_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.6 13.4 12 4.8 4 4l.8 8 8.6 8.6a2 2 0 0 0 2.8 0l4.4-4.4a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
const $4513b7495ab4b07e$var$ICO_LAYERS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5"/><path d="m3 17 9 5 9-5"/></svg>';
const $4513b7495ab4b07e$var$ICO_BAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M4 12h10M4 17h13"/></svg>';
const $4513b7495ab4b07e$var$ICO_RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v5"/></svg>';
/**
 * Atualiza título, badges e cards a partir dos campos do cadastro.
 * @param {HTMLElement|null} root
 */ function $4513b7495ab4b07e$var$syncPackagingPanel(root) {
    if (!root) return;
    const val = (sel)=>{
        const el = root.querySelector(sel);
        return el ? String(el.value ?? '').trim() : '';
    };
    const setText = (sel, text)=>{
        root.querySelectorAll(sel).forEach((el)=>{
            el.textContent = text;
        });
    };
    const code = val('#code');
    setText('[data-sdp="title"]', code || 'Nova embalagem');
    setText('[data-sdp="product"]', val('#product_id') || "\u2014");
    setText('[data-sdp="kpi-factor"]', val('#factor') || '0');
    const level = root.querySelector('#level');
    setText('[data-sdp="kpi-level"]', level?.selectedOptions?.[0]?.text?.trim() || "\u2014");
    setText('[data-sdp="kpi-weight"]', val('#weight') || '0');
    setText('[data-sdp="kpi-gtin"]', val('#gtin') || "\u2014");
    const badgeDefault = root.querySelector('[data-sdp="badge-default"]');
    const badgeDisabled = root.querySelector('[data-sdp="badge-disabled"]');
    if (badgeDefault) badgeDefault.hidden = !root.querySelector('#is_default')?.checked;
    if (badgeDisabled) badgeDisabled.hidden = !root.querySelector('#is_disabled')?.checked;
}
var $4513b7495ab4b07e$export$2e2bcd8739ae039 = {
    html: `
		<form id="product-packaging" class="form sial-modal-form sial-detail sial-detail--edit" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products"></datalist>
			<datalist id="manufacturers"></datalist>
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${$4513b7495ab4b07e$var$ICO_BOX}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Cadastro de embalagem</p>
						<h2 class="sdp-title" data-sdp="title">Nova embalagem</h2>
						<div class="sdp-meta">
							<span>Produto: <b data-sdp="product">\u{2014}</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="badge-default" hidden>Padr\xe3o</span>
							<span class="sdp-badge sdp-badge--blocked" data-sdp="badge-disabled" hidden>Inativa</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>
			<section class="sdp-kpis" aria-label="Resumo da embalagem">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">${$4513b7495ab4b07e$var$ICO_LAYERS} Fator</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-factor">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">${$4513b7495ab4b07e$var$ICO_TAG} N\xedvel</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-level">\u{2014}</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">${$4513b7495ab4b07e$var$ICO_RULER} Peso</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-weight">0</span><span class="sdp-kpi-unit">kg</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--free">
					<div class="sdp-kpi-label">${$4513b7495ab4b07e$var$ICO_BAR} GTIN</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-gtin">\u{2014}</span></div>
				</div>
			</section>
			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$4513b7495ab4b07e$var$ICO_TAG} Identifica\xe7\xe3o</h3>
					<div class="sdp-fields">
						<label title="Empresa">Empresa<sup>*</sup>
							<input id="company_id" type="text" list="companies" required>
						</label>
						<label title="Identificador da embalagem">ID
							<input id="id" type="text" disabled>
						</label>
						<label class="sdp-span-2" title="Produto">Produto<sup>*</sup>
							<input id="product_id" type="text" list="products" required>
						</label>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$4513b7495ab4b07e$var$ICO_LAYERS} Estrutura</h3>
					<div class="sdp-fields">
						<label title="C\xf3digo da embalagem">C\xf3digo<sup>*</sup>
							<input id="code" type="text" placeholder="1X60" required>
						</label>
						<label title="N\xedvel da embalagem">N\xedvel<sup>*</sup>
							<select id="level" required>
								<option value="S">Secund\xe1ria</option>
								<option value="T">Terci\xe1ria</option>
								<option value="P">Prim\xe1ria</option>
							</select>
						</label>
						<label title="Fator de convers\xe3o">Fator<sup>*</sup>
							<input id="factor" type="text" placeholder="60" required>
						</label>
						<label title="Capacidade da embalagem terci\xe1ria">Cap. terci\xe1ria
							<input id="tertiary_capacity" type="text" placeholder="100">
						</label>
					</div>
					<div class="sdp-check-row">
						<label title="Embalagem padr\xe3o do produto para fatores/GTIN"><input id="is_default" type="checkbox"> Padr\xe3o</label>
						<label title="Cadastro inativo (n\xe3o aparece em sele\xe7\xf5es)"><input id="is_disabled" type="checkbox"> Inativa</label>
					</div>
				</div>
			</section>
			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$4513b7495ab4b07e$var$ICO_BAR} Identifica\xe7\xe3o comercial</h3>
					<div class="sdp-fields">
						<label title="Fabricante desta embalagem/GTIN \u{2014} \xe9 o fabricante operacional do item quando esta embalagem \xe9 usada">Fabricante (GTIN)
							<input id="manufacturer_id" type="text" list="manufacturers" placeholder="Fabricante da embalagem">
						</label>
						<label title="EAN da embalagem">GTIN
							<input id="gtin" type="text" placeholder="EAN da embalagem">
						</label>
						<label class="sdp-span-2" title="Conte\xfado ou identificador impresso no QR da etiqueta de embalagem">QR Code (etiqueta)
							<input id="qr_code" type="text" placeholder="Opcional" autocomplete="off">
						</label>
					</div>
					<p class="sdp-hint"><strong>Fabricante (GTIN):</strong> prevalece em estoque, entradas, sa\xeddas e relat\xf3rios quando esta embalagem \xe9 usada. Sem embalagem cadastrada, o sistema usa o fabricante do produto.</p>
					<p class="sdp-hint"><strong>GTIN:</strong> amarra o EAN desta embalagem (P/S/T) ao fabricante. O mesmo EAN pode existir em SKUs diferentes; na confer\xeancia por bip, prioriza a marcada como padr\xe3o.</p>
					<p class="sdp-hint"><strong>QR Code:</strong> payload opcional da etiqueta (c\xf3digo interno, GTIN+lote etc.) para relat\xf3rios, coletor ou gera\xe7\xe3o de etiqueta.</p>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$4513b7495ab4b07e$var$ICO_RULER} Peso e dimens\xf5es</h3>
					<div class="sdp-fields">
						<label title="Peso de uma unidade desta embalagem (kg)">Peso (kg)
							<input id="weight" type="text" placeholder="0,000">
						</label>
						<label title="Altura da embalagem (cm)">Altura (cm)
							<input id="height" type="text" placeholder="0,000">
						</label>
						<label title="Largura da embalagem (cm)">Largura (cm)
							<input id="width" type="text" placeholder="0,000">
						</label>
						<label title="Comprimento da embalagem (cm)">Compr. (cm)
							<input id="length" type="text" placeholder="0,000">
						</label>
					</div>
					<p class="sdp-hint">Opcionais. Peso em <strong>kg</strong>; altura, largura e comprimento em <strong>cm</strong>. O peso alimenta o total na confer\xeancia de sa\xedda; as dimens\xf5es ficam para cubagem.</p>
				</div>
			</div>
			<div class="sdp-foot">
				<button class="bn_Escape button">Fechar</button>
				<button class="bn_Enter button">Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#product-packaging',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const orig = this.setValues.bind(this);
            this.setValues = (values)=>{
                orig(values);
                $4513b7495ab4b07e$var$syncPackagingPanel(this.node);
            };
            this.node?.addEventListener('input', ()=>$4513b7495ab4b07e$var$syncPackagingPanel(this.node));
            this.node?.addEventListener('change', ()=>$4513b7495ab4b07e$var$syncPackagingPanel(this.node));
            $4513b7495ab4b07e$var$syncPackagingPanel(this.node);
        },
        afterEditSetValues (formset) {
            const mfr = formset.form.getFieldBySelector('#manufacturer_id');
            const saved = mfr?.getValue?.();
            if (mfr && saved != null && saved !== '' && saved !== -1 && saved !== '-1') mfr.refresh();
            const root = formset.form.node;
            $4513b7495ab4b07e$var$syncPackagingPanel(root);
            setTimeout(()=>$4513b7495ab4b07e$var$syncPackagingPanel(root), 400);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#manufacturer_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('manufacturers', {
                    labels: [
                        'nick',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#level'
            },
            types: []
        },
        {
            properties: {
                selector: '#factor'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#tertiary_capacity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#gtin'
            },
            types: [
                $hlPFs.default(),
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#qr_code'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#weight'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#height'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#width'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#length'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#is_default'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $abe149d39816edf1$export$2e2bcd8739ae039 = {
    html: `
		<form id="product-packagings-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products-pkg-report"></datalist>
			<p class="fss">Exporta todas as colunas do cadastro de embalagens (CSV). Filtros opcionais.</p>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Filtrar por produto">Produto
					<input id="product_id" type="text" list="products-pkg-report" placeholder="opcional \u{2014} escolha a empresa">
				</label>
			</div>
			<div class="fsb">
				<label title="N\xedvel hier\xe1rquico">N\xedvel
					<select id="level">
						<option value="">Todos</option>
						<option value="P">Prim\xe1ria (P)</option>
						<option value="S">Secund\xe1ria (S)</option>
						<option value="T">Terci\xe1ria (T)</option>
					</select>
				</label>
				<label title="Ativas / inativas no cadastro">Situa\xe7\xe3o
					<select id="status">
						<option value="all">Todas</option>
						<option value="active">Somente ativas</option>
						<option value="inactive">Somente inativas</option>
					</select>
				</label>
				<label title="Limite de linhas">M\xe1x. linhas
					<input id="max_rows" type="text" value="50000" placeholder="50000">
				</label>
			</div>
			<div class="fsb mtm">
				<span class="fss" style="color:#666;">UTF-8 com BOM (Excel). Colunas: empresa, IDs, SKU, nome produto, fabricante, c\xf3digo, n\xedvel, fator, GTIN, QR, capacidade terci\xe1ria, padr\xe3o, inativa.</span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar CSV</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#product-packagings-print-report',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#level'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#max_rows'
            },
            types: [
                $3eqAU.default(0, 0)
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $hlPFs = parcelRequire("hlPFs");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
/** Resolve rótulo ou id do fabricante (GTIN) no escopo da empresa. */ async function $7502d76b32eebada$var$resolvePackagingManufacturerId(companyId, raw) {
    if (raw == null || String(raw).trim() === '') return null;
    const s = String(raw).trim();
    if (/^\d+$/.test(s)) {
        const n = Number(s);
        if (!Number.isFinite(n) || n < 1) return null;
        const scope = companyId != null && String(companyId).trim() !== '' ? String(companyId).trim() : null;
        const opts = await (0, $1cmSR.default).list('manufacturers').catch(()=>[]);
        const match = opts.find((o)=>Number(o.id) === n && (!scope || String(o.company_id) === scope));
        return match?.id != null ? Number(match.id) : null;
    }
    const scope = companyId != null && String(companyId).trim() !== '' ? String(companyId).trim() : null;
    const opts = await (0, $1cmSR.default).list('manufacturers').catch(()=>[]);
    const match = opts.find((o)=>(!scope || String(o.company_id) === scope) && ((o.nick || '') === s || String(o.nick || '') === s || (o.name || '') === s || String(o.name || '') === s));
    return match?.id != null ? Number(match.id) : null;
}
const $7502d76b32eebada$var$product_packagings = function() {
    let product_packagings_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('companies', data) : Promise.resolve()).catch((e)=>(0, $jUNyh.notify)(e?.message || e)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_products, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('products', data) : Promise.resolve()).catch((e)=>(0, $jUNyh.notify)(e?.message || e)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_manufacturers, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('manufacturers', data) : Promise.resolve()).catch((e)=>(0, $jUNyh.notify)(e?.message || e)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_product_packagings, this.queryAll()).then((data)=>data ? (0, $1cmSR.default).set('product_packagings', data) : Promise.resolve()).catch((e)=>(0, $jUNyh.notify)(e?.message || e))
            ]);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_product_packagings, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_product_packaging, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            const companyId = data.company_id;
            const manufacturerId = await $7502d76b32eebada$var$resolvePackagingManufacturerId(companyId, data.manufacturer_id);
            let _record = {
                product_id: Number(data.product_id),
                manufacturer_id: manufacturerId,
                code: data.code,
                level: data.level,
                factor: Number(data.factor),
                tertiary_capacity: data.tertiary_capacity ? Number(data.tertiary_capacity) : null,
                gtin: data.gtin || null,
                qr_code: data.qr_code || null,
                weight: data.weight !== '' && data.weight != null ? Number(data.weight) : null,
                height: data.height !== '' && data.height != null ? Number(data.height) : null,
                width: data.width !== '' && data.width != null ? Number(data.width) : null,
                length: data.length !== '' && data.length != null ? Number(data.length) : null,
                is_default: data.is_default == '1',
                is_disabled: data.is_disabled == '1'
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_product_packaging, data.company_id, data.id, _record);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_product_packaging, data.company_id, _record);
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'ID',
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            index: 3,
            field: 'sku',
            label: 'SKU',
            types: []
        },
        {
            index: 4,
            field: 'product_id',
            label: 'Produto',
            types: [
                $9PIz7.default()
            ],
            store: 'products',
            labels: [
                'name'
            ]
        },
        {
            index: 5,
            field: 'manufacturer_id',
            label: 'Fabricante',
            types: [
                $9PIz7.default()
            ],
            store: 'manufacturers',
            labels: [
                'nick',
                'name'
            ]
        },
        {
            index: 6,
            field: 'code',
            label: "C\xf3digo",
            types: []
        },
        {
            index: 7,
            field: 'level',
            label: "N\xedvel",
            types: []
        },
        {
            index: 8,
            field: 'factor',
            label: 'Fator',
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            index: 9,
            field: 'tertiary_capacity',
            label: "Cap. Terci\xe1ria",
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            index: 10,
            field: 'weight',
            label: 'Peso (kg)',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: 'Peso de uma unidade desta embalagem em quilos'
        },
        {
            index: 11,
            field: 'height',
            label: 'Altura (cm)',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Altura da embalagem em cent\xedmetros"
        },
        {
            index: 12,
            field: 'width',
            label: 'Largura (cm)',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Largura da embalagem em cent\xedmetros"
        },
        {
            index: 13,
            field: 'length',
            label: 'Compr. (cm)',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: "Comprimento da embalagem em cent\xedmetros"
        },
        {
            index: 14,
            field: 'gtin',
            label: 'GTIN',
            types: [
                $hlPFs.default()
            ]
        },
        {
            index: 15,
            field: 'is_default',
            label: "Padr\xe3o",
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ]
        },
        {
            index: 16,
            field: 'is_disabled',
            label: 'Inativa',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ]
        }
    ];
    const reports = [
        {
            hash: '#print-product-packagings-report',
            label: "Relat\xf3rio&nbsp;de&nbsp;Embalagens&nbsp;(CSV)"
        }
    ];
    async function resolveCompanyId(raw) {
        if (raw == null || String(raw).trim() === '') return null;
        const v = String(raw).trim();
        const c = await (0, $1cmSR.default).get('companies', v);
        return c?.id ?? v;
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-product-packagings-report', ()=>{
        (0, $b60a2.default).edit((0, $abe149d39816edf1$export$2e2bcd8739ae039), async (data)=>{
            const companyId = await resolveCompanyId(data.company_id);
            if (!companyId) {
                (0, $jUNyh.notify)('Selecione a empresa.', 'Aviso');
                return false;
            }
            const params = new URLSearchParams();
            params.set('format', 'csv');
            const pid = data.product_id != null ? String(data.product_id).trim() : '';
            if (pid !== '') params.set('product_id', pid);
            if (data.level) params.set('level', String(data.level).trim().toUpperCase());
            if (data.status) params.set('status', String(data.status).trim().toLowerCase());
            const mr = parseInt(data.max_rows, 10);
            if (!isNaN(mr) && mr > 0) params.set('max_rows', String(mr));
            try {
                const res = await (0, $9VcS9.default).product_packagings_report(companyId, params.toString());
                const blob = await res.blob();
                if (!res.ok) {
                    let msg = await blob.text();
                    try {
                        const j = JSON.parse(msg);
                        msg = j?.message || msg;
                    } catch (_) {}
                    (0, $jUNyh.notify)(msg || res.statusText, 'Erro');
                    return false;
                }
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `embalagens-produto-${String(companyId).slice(0, 8)}.csv`;
                a.click();
                URL.revokeObjectURL(url);
                (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                return false;
            }
            return true;
        }, {}, false);
    });
    product_packagings_crud.run('product_packagings', 'Embalagens', document.getElementById('workarea'), (0, $94935258288968c1$export$2e2bcd8739ae039), (0, $4513b7495ab4b07e$export$2e2bcd8739ae039), fieldspecs, [], reports);
};
var $7502d76b32eebada$export$2e2bcd8739ae039 = $7502d76b32eebada$var$product_packagings;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");
async function $0a0e6b947d0ef94b$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 15rem; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">Tipo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[3]}'>${Number(record.warehouse_type) === 2 ? "F\xedsico" : "L\xf3gico"}</td>
					<td data-visible='${this.visible[4]}'>${record.is_disabled ? 'Sim' : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
function $da6d10eb63e74ed0$var$_syncPhysicalBlock(root) {
    if (!root) return;
    const sel = root.querySelector('#warehouse_type');
    const v = sel ? String(sel.value || '1') : '1';
    const block = root.querySelector('#warehouse-physical-fields');
    if (block) block.style.display = v === '2' ? '' : 'none';
}
var $da6d10eb63e74ed0$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#warehouse #company_id	{ width: 10rem;	}
			#warehouse #id			{ width: 5rem; text-align: right;	}
			#warehouse #name		{ width: 15rem;	}
			#warehouse #warehouse_type { width: 22rem; }
			#warehouse .wh-phys-grid { display: grid; grid-template-columns: 9rem 1fr; gap: 0.35rem 0.75rem; align-items: center; max-width: 42rem; }
			#warehouse .wh-phys-grid input { width: 100%; box-sizing: border-box; }
			#warehouse .wh-phys-grid label { justify-self: end; color: #444; font-size: 0.9rem; }
		</style>
		<form id="warehouse" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do armaz\xe9m">Armaz\xe9m
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do armaz\xe9m">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Armaz\xe9m l\xf3gico: comportamento cl\xe1ssico SIAL. Armaz\xe9m f\xedsico: local separado; com f\xedsicos na empresa, a gera\xe7\xe3o de sa\xeddas exige escolher um.">Tipo
					<select id="warehouse_type">
						<option value="1">Armaz\xe9m l\xf3gico (padr\xe3o SIAL)</option>
						<option value="2">Armaz\xe9m f\xedsico (local distinto)</option>
					</select>
				</label>
			</div>
			<div id="warehouse-physical-fields" class="mtm" style="display:none">
				<div class="hint" style="font-size:0.85rem;color:#444;margin-bottom:0.5rem">
					Dados do armaz\xe9m f\xedsico (opcionais \u{2014} \xfateis para identifica\xe7\xe3o do local). Com pelo menos um <strong>f\xedsico ativo</strong> na empresa, <strong>gerar sa\xeddas</strong> passa a exigir a escolha de um armaz\xe9m f\xedsico.
				</div>
				<div class="wh-phys-grid">
					<label for="address_zipcode">CEP</label>
					<input id="address_zipcode" type="text" maxlength="20" autocomplete="postal-code">
					<label for="address_street">Rua</label>
					<input id="address_street" type="text" maxlength="200">
					<label for="address_number">N\xfamero</label>
					<input id="address_number" type="text" maxlength="40">
					<label for="address_complement">Complemento</label>
					<input id="address_complement" type="text" maxlength="120">
					<label for="address_city">Cidade</label>
					<input id="address_city" type="text" maxlength="120">
					<label for="address_state">UF</label>
					<input id="address_state" type="text" maxlength="2" placeholder="SP" title="Sigla UF, 2 letras">
					<label for="phone">Telefone</label>
					<input id="phone" type="text" maxlength="40">
				</div>
			</div>
			<div class="fsb mtm">
				<label title="Armaz\xe9m inativo n\xe3o entra em listas de escolha (entradas, sa\xeddas, estoque, posi\xe7\xf5es, etc.). S\xf3 \xe9 poss\xedvel inativar com estoque zerado em todas as posi\xe7\xf5es.">
					<input id="is_disabled" type="checkbox"> Inativo
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#warehouse',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const root = document.querySelector('#warehouse');
            const sel = root?.querySelector('#warehouse_type');
            if (sel) sel.addEventListener('change', ()=>$da6d10eb63e74ed0$var$_syncPhysicalBlock(root));
            Object.getPrototypeOf(this).init.call(this);
            $da6d10eb63e74ed0$var$_syncPhysicalBlock(root);
        },
        afterEditSetValues () {
            $da6d10eb63e74ed0$var$_syncPhysicalBlock(document.querySelector('#warehouse'));
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#warehouse_type'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#address_zipcode'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_street'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_complement'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_city'
            },
            types: []
        },
        {
            properties: {
                selector: '#address_state'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: []
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
/**
 * Corpo de tipo/endereço para POST/PATCH de armazém.
 * Em modo lógico, zera campos físicos no banco ao salvar.
 */ function $47151db783ea97b2$var$warehouseTypePayload(data) {
    const isPhysical = Number(data.warehouse_type) === 2;
    const t = (v)=>{
        if (!isPhysical) return null;
        if (v == null || String(v).trim() === '') return null;
        return String(v).trim();
    };
    let uf = t(data.address_state);
    if (uf && uf.length > 2) uf = uf.slice(0, 2).toUpperCase();
    else if (uf) uf = uf.toUpperCase();
    return {
        warehouse_type: isPhysical ? 2 : 1,
        address_zipcode: t(data.address_zipcode),
        address_street: t(data.address_street),
        address_number: t(data.address_number),
        address_complement: t(data.address_complement),
        address_city: t(data.address_city),
        address_state: uf && uf.length === 2 ? uf : null,
        phone: t(data.phone)
    };
}
const $47151db783ea97b2$var$warehouses = function() {
    let warehouses_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            let q = query || '';
            if (!/[?&]include_disabled=/.test(q)) q += (q.includes('?') ? '&' : '?') + 'include_disabled=1';
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_warehouse, ...JSON.parse(id));
            if (_record && typeof _record === 'object') {
                _record.is_disabled = _record.is_disabled === true || _record.is_disabled === '1' ? '1' : '0';
                _record.warehouse_type = _record.warehouse_type != null && String(_record.warehouse_type) !== '' ? String(_record.warehouse_type) : '1';
            }
            return _record;
        },
        async saveRecord (data, old_data) {
            const extra = $47151db783ea97b2$var$warehouseTypePayload(data);
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).patch_warehouse, data.company_id, data.id, {
                name: data.name,
                is_disabled: data.is_disabled == '1' || data.is_disabled === true,
                ...extra
            });
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_warehouse, data.company_id, {
                name: data.name,
                ...extra
            });
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Armaz\xe9m",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Identificador do armaz\xe9m"
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome do armaz\xe9m"
        },
        {
            index: 4,
            field: 'warehouse_type',
            label: 'Tipo',
            types: [],
            placeholder: '',
            title: "1=l\xf3gico, 2=f\xedsico"
        },
        {
            index: 5,
            field: 'is_disabled',
            label: 'Inativo',
            types: [],
            placeholder: '',
            title: "Armaz\xe9m inativo (n\xe3o aparece em listagens operacionais)"
        }
    ];
    warehouses_crud.run('warehouses', "Armaz\xe9ns", document.getElementById('workarea'), (0, $0a0e6b947d0ef94b$export$2e2bcd8739ae039), (0, $da6d10eb63e74ed0$export$2e2bcd8739ae039), fieldspecs, undefined, undefined, {
        default_columns: '1,2,3,4,5'
    });
};
var $47151db783ea97b2$export$2e2bcd8739ae039 = $47151db783ea97b2$var$warehouses;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $h1m6J = parcelRequire("h1m6J");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");

var $1Wvh7 = parcelRequire("1Wvh7");
async function $83a15d59aff488df$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left;	}
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Posi\xe7\xe3o</th>
					<th data-index="4" data-visible="${this.visible[3]}">Endere\xe7o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Mix</th>
					<th data-index="6" data-visible="${this.visible[5]}">N\xedvel</th>
					<th data-index="7" data-visible="${this.visible[6]}">Atuante</th>
					<th data-index="8" data-visible="${this.visible[7]}">Staging</th>
					<th data-index="9" data-visible="${this.visible[8]}">Expedi\xe7\xe3o</th>
					<th data-index="11" data-visible="${this.visible[9]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[2]}'>${record.id}</td>
					<td data-visible='${this.visible[3]}'>${record.address.join('-')}</td>
					<td data-visible='${this.visible[4]}'>${this.option($6d521c92c25435df$export$2e2bcd8739ae039(), record.mix)}</td>
					<td data-visible='${this.visible[5]}'>${record.level}</td>
					<td data-visible='${this.visible[6]}'>${this.option($1Wvh7.default(), record.in_reach)}</td>
					<td data-visible='${this.visible[7]}'>${this.option($1Wvh7.default(), record.is_staging)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($1Wvh7.default(), record.is_expedition)}</td>
					<td data-visible='${this.visible[9]}'>${this.option($2372640607a5ee0b$export$2e2bcd8739ae039(), record.status) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $fE2eE = parcelRequire("fE2eE");
var $3eqAU = parcelRequire("3eqAU");
var $badq7 = parcelRequire("badq7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $295f352aa767e7e5$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#location #company_id		{ width: 10rem;		}
			#location #warehouse_id	{ width: 10rem;		}
			#location #id				{ width: 4rem; text-align: right;	}
			#location #address			{ width: 6rem;		}
			#location #mix				{ width: 12rem; display: inline-block;	}
			#location #level			{ width: 3rem; text-align: right;	}
			#location #status	 		{ width: 10rem;		}
		</style>
		<form id="location" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Identificador da posi\xe7\xe3o">Posi\xe7\xe3o
					<input id="id" type="text" disabled>
				</label>
				<label title="Endere\xe7o da posi\xe7\xe3o">Endere\xe7o<sup>*</sup>
					<input id="address" type="text" required>
				</label>
				<label title="N\xedvel da posi\xe7\xe3o (1=mais baixo)">N\xedvel<sup>*</sup>
					<input id="level" type="text" value="1" required>
				</label>
				<label title="Posi\xe7\xe3o ao alcance da m\xe3o?">Atuante?
					<input id="in_reach" type="checkbox" checked>
				</label>
				<label title="Posi\xe7\xe3o de descarga de mercadorias?">Staging?
					<input id="is_staging" type="checkbox">
				</label>
				<label title="Posi\xe7\xe3o de Doca Expedi\xe7\xe3o (e-commerce / aguardando transporte)?">Expedi\xe7\xe3o?
					<input id="is_expedition" type="checkbox">
				</label>
				<label title="Status da posi\xe7\xe3o">Status<sup>*</sup>
					<input id="status" type="text" list="location_status" value="0" required>
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Classes<sup>*</sup>
					<select id="classes" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button type="button" class="bn_Left" title="Incluir classifica\xe7\xf5es selecionadas \xe0 direita"> &#x1F844;</button>
					<button type="button" class="bn_Right" title="Remover classifica\xe7\xf5es selecionadas \xe0 esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Dispon\xedveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			<div class="fsb fae mtm">
				<span>
					<label title="Misturas permitidas na posi\xe7\xe3o">Mix<sup>*</sup>
						<input id="mix" type="text" list="location_mixes" value="0" required>
					</label>
				</span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#location',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#address'
            },
            types: [
                $bba672065f562b52$export$2e2bcd8739ae039(),
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#mix'
            },
            types: [
                $6d521c92c25435df$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#level'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#in_reach'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_staging'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_expedition'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $2372640607a5ee0b$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#classes'
            },
            types: [
                $6Jl4s.default(),
                $fE2eE.default('classes', '#available', {
                    values: [
                        'company_id',
                        'id'
                    ]
                }),
                $6lTH5.default('company_id'),
                $badq7.default()
            ]
        }
    ]
};


parcelRequire("9VcS9");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $66f0ec4106475d51$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-select-printer #company_id	{ width: 15rem;	}
			#stocks-select-printer #device_id	{ width: 15rem;	}
			#stocks-select-printer #label_copies	{ width: 6rem;	}
		</style>
		<form id="stocks-select-printer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;para&nbsp;<span id="count"></span>&nbsp;registros
			</div>
			<div class="mtm">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="Quantas etiquetas id\xeanticas (mesmo lote/design) por linha de estoque selecionada">Qtd. etiquetas / registro<sup>*</sup>
					<input id="label_copies" type="number" min="1" max="200" step="1" value="1" required title="1 a 200 por linha">
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div class="mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-select-printer',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const lc = document.querySelector('#stocks-select-printer #label_copies');
            if (lc) lc.value = '1';
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('devices')
            ]
        },
        {
            properties: {
                selector: '#label_copies'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};


/** Mensagem legível para falhas de API dos relatórios BI (evita JSON de 403 ACL no notify). */ function $c51c1c116667c9de$export$929b0fbc18b1377e(status, raw) {
    if (status === 403 && raw) try {
        const j = JSON.parse(raw);
        if (j.search_hint && j.method && j.path) return `Sem permiss\xe3o para este relat\xf3rio (${j.search_hint}). Solicite ao administrador a inclus\xe3o do endpoint ${j.method} ${j.path} no seu grupo.`;
    } catch (e) {}
    return raw || (status ? `Erro ${status}` : "Falha na requisi\xe7\xe3o");
}



var $gBwx4 = parcelRequire("gBwx4");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
function $2332a4e102178b91$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $2332a4e102178b91$var$filterExprCompany(companyId) {
    return (0, $hWQyW.translate)({
        'field-0': 'company_id',
        'operator-0': 'eq',
        'value-0': companyId
    });
}
async function $2332a4e102178b91$var$lcrLoadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch (e) {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
async function $2332a4e102178b91$var$lcrLoadWarehouses(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const fe = encodeURIComponent($2332a4e102178b91$var$filterExprCompany(companyId));
    const res = await (0, $9VcS9.default).list_warehouses(`?filter=${fe}&limit=0&sort=2`);
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), "Armaz\xe9ns");
        return;
    }
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const w of arr){
        const o = document.createElement('option');
        o.value = String(w.id);
        o.textContent = `${w.name ?? ''} (${w.id})`;
        sel.appendChild(o);
    }
}
async function $2332a4e102178b91$var$lcrLoadClasses(companyId, sel) {
    sel.innerHTML = '<option value="">\u2014 Todas \u2014</option>';
    if (!companyId) return;
    const fe = encodeURIComponent($2332a4e102178b91$var$filterExprCompany(companyId));
    const res = await (0, $9VcS9.default).list_classes(`?filter=${fe}&limit=0&sort=2`);
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Classes');
        return;
    }
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const c of arr){
        const o = document.createElement('option');
        o.value = `${c.company_id}|${c.id}`;
        o.textContent = `${c.name ?? ''} (${c.id})`;
        sel.appendChild(o);
    }
}
function $2332a4e102178b91$var$lcrCollectParams(root, format) {
    const companyId = $2332a4e102178b91$var$$('#lcr-company', root)?.value?.trim();
    if (!companyId) return null;
    const sp = new URLSearchParams();
    sp.set('format', format);
    sp.set('occupancy', $2332a4e102178b91$var$$('#lcr-occupancy', root)?.value || 'all');
    if ($2332a4e102178b91$var$$('#lcr-include-disabled', root)?.checked) sp.set('include_disabled_locations', '1');
    const wh = $2332a4e102178b91$var$$('#lcr-warehouse', root)?.value?.trim();
    if (wh) sp.set('warehouse_id', wh);
    const st = $2332a4e102178b91$var$$('#lcr-staging', root)?.value;
    if (st && st !== 'all') sp.set('staging', st);
    const ir = $2332a4e102178b91$var$$('#lcr-inreach', root)?.value;
    if (ir && ir !== 'all') sp.set('in_reach', ir);
    const mx = $2332a4e102178b91$var$$('#lcr-mix', root)?.value;
    if (mx !== undefined && mx !== null && String(mx).trim() !== '') sp.set('mix', String(mx).trim());
    const cl = $2332a4e102178b91$var$$('#lcr-class', root)?.value?.trim();
    if (cl) {
        const parts = cl.split('|');
        if (parts.length >= 2) {
            sp.set('class_company_id', parts[0]);
            sp.set('class_id', parts[1]);
        }
    }
    if (format === 'json') {
        sp.set('limit', $2332a4e102178b91$var$$('#lcr-limit', root)?.value || '200');
        sp.set('offset', $2332a4e102178b91$var$$('#lcr-offset', root)?.value || '0');
    } else {
        const mxr = $2332a4e102178b91$var$$('#lcr-max-rows', root)?.value?.trim();
        if (mxr) sp.set('max_rows', mxr);
    }
    return {
        companyId: companyId,
        sp: sp
    };
}
function $2332a4e102178b91$var$lcrEsc(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $2332a4e102178b91$var$lcrRenderPreview(container, rows) {
    if (!rows?.length) {
        container.innerHTML = '<p class="muted mts">Nenhuma linha (ajuste filtros).</p>';
        return;
    }
    const keys = Object.keys(rows[0]);
    let html = '<div class="lcr-scroll mts" style="overflow:auto;max-height:65vh"><table class="view fsx"><thead><tr>';
    for (const k of keys)html += `<th>${$2332a4e102178b91$var$lcrEsc(k)}</th>`;
    html += '</tr></thead><tbody>';
    for (const r of rows){
        html += '<tr>';
        for (const k of keys)html += `<td>${$2332a4e102178b91$var$lcrEsc(r[k])}</td>`;
        html += '</tr>';
    }
    html += '</tbody></table></div>';
    container.innerHTML = html;
}
function $2332a4e102178b91$var$lcrDownloadCsv(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'posicoes-catalogo.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
function $2332a4e102178b91$var$lcrCountCsvDataRows(csvText, hasHeaderRow) {
    const t = String(csvText || '').replace(/^\ufeff/, '').trimEnd();
    if (!t) return 0;
    const lines = t.split(/\r?\n/).filter((ln)=>ln.length > 0);
    if (!lines.length) return 0;
    return hasHeaderRow ? Math.max(0, lines.length - 1) : lines.length;
}
/** Exporta CSV em vários GET (limit/offset) para não estourar timeout do nginx em bases grandes. */ async function $2332a4e102178b91$var$lcrExportCsvInChunks(companyId, baseSp) {
    const chunk = 3500;
    const maxRows = Math.min(100000, Math.max(1, parseInt(baseSp.get('max_rows') || '25000', 10) || 25000));
    let offset = 0;
    const parts = [];
    while(offset < maxRows){
        const sp = new URLSearchParams(baseSp);
        sp.set('format', 'csv');
        const step = Math.min(chunk, maxRows - offset);
        sp.set('limit', String(step));
        sp.set('offset', String(offset));
        if (offset > 0) sp.set('csv_no_header', '1');
        const res = await (0, $9VcS9.default).locations_catalog_report(companyId, sp.toString());
        if (!res.ok) {
            const t = await res.text();
            throw new Error((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, t));
        }
        const hdr = res.headers.get('X-Locations-Catalog-Rows');
        const text = await res.text();
        parts.push(text);
        let n = hdr != null && hdr !== '' ? parseInt(hdr, 10) : NaN;
        if (!Number.isFinite(n) || n < 0) n = $2332a4e102178b91$var$lcrCountCsvDataRows(text, offset === 0);
        if (n < step) break;
        if (n === 0) break;
        offset += step;
    }
    return new Blob(parts, {
        type: 'text/csv;charset=utf-8'
    });
}
const $2332a4e102178b91$var$locations = function() {
    let locations_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            const q = this.queryAll();
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_classes, q).then((data)=>(0, $1cmSR.default).set('classes', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, q).then((data)=>(0, $1cmSR.default).set('devices', data).catch(()=>{}));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, query);
        },
        async addFilter (params) {
            let f = this.filter;
            if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $hWQyW.resolveFilterLabelsToIds)(f, this.fieldspecs);
            let filterExpr = '';
            try {
                filterExpr = (0, $hWQyW.translateForLocations)(f, this.fieldspecs, {
                    strict: true
                });
            } catch (_) {}
            if (filterExpr) params.append('filter', filterExpr);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_location, ...JSON.parse(id));
            _record.classes = _record.classes.map((entry)=>[
                    entry.class_company_id,
                    entry.class_id
                ]);
            return _record;
        },
        async editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter, {
                translateFn: (data)=>(0, $hWQyW.translateForLocations)(data, this.fieldspecs),
                validateFlatFilter: (data)=>(0, $hWQyW.validateLocationsFilterWarehouseRequired)(data, this.fieldspecs),
                reloadLocations: async (formData)=>{
                    const resolved = await (0, $hWQyW.resolveFilterLabelsToIds)(formData, this.fieldspecs);
                    const parts = [];
                    const top = 10;
                    for(let i = 0; i < top; i++){
                        const f = resolved[`field-${i}`];
                        const v = resolved[`value-${i}`];
                        if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                        else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                    }
                    if (parts.length === 0) return;
                    const params = new URLSearchParams();
                    params.append('filter', parts.join(','));
                    params.append('sort', '4');
                    params.append('limit', '0');
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, '?' + params.toString());
                    if (data && Array.isArray(data)) await (0, $1cmSR.default).set('locations', data);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            await this.loadPage(1);
        },
        async saveRecord (data, old_data) {
            let _record = {
                address: data.address,
                mix: data.mix,
                level: Number(data.level),
                in_reach: data.in_reach == '1',
                is_staging: data.is_staging == '1',
                is_expedition: data.is_expedition == '1',
                classes: (0, $aGGTj.parse)(data.classes).map((entry)=>({
                        class_company_id: entry[0],
                        class_id: Number(entry[1])
                    }))
            };
            if (data.status !== undefined && data.status !== null && String(data.status).trim() !== '') _record.status = Number(data.status);
            if (old_data) {
                const whNew = Number(data.warehouse_id);
                const whOld = Number(old_data.warehouse_id);
                if (Number.isFinite(whNew) && Number.isFinite(whOld) && whNew !== whOld) _record.warehouse_id = whNew;
            }
            // PUT usa company/warehouse/id na URL: o datalist de armazém pode trocar o valor exibido após `company_id` observer
            // sem refletir o armazém real da posição → 404. Sempre atualizar pela chave do registro aberto (old_data).
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_location, old_data.company_id, old_data.warehouse_id, old_data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_location, data.company_id, data.warehouse_id, _record);
        },
        printLocationLabels () {
            if (!this.ensureSelection("Etiquetas de Posi\xe7\xe3o")) return;
            const sendRequest = async (data)=>{
                const device_id = (0, $aGGTj.resolvePrinterDeviceId)(data.device_id, '#stocks-select-printer #device_id');
                if (device_id == null) {
                    (0, $jUNyh.notify)("Selecione a impressora na lista (clique na op\xe7\xe3o; s\xf3 o texto no campo n\xe3o basta).", "Aten\xe7\xe3o");
                    return false;
                }
                const sortVal = this.sort_column * (this.sort_order ? -1 : 1);
                const selection = this.getSelection();
                const ids = selection.map((entry)=>{
                    if (typeof entry === 'string') try {
                        return JSON.parse(entry);
                    } catch (_) {
                        return null;
                    }
                    return entry;
                }).filter((t)=>Array.isArray(t) && t.length >= 3);
                if (!ids.length) {
                    (0, $jUNyh.notify)("Selecione ao menos uma posi\xe7\xe3o na grade antes de continuar.", "Etiquetas de Posi\xe7\xe3o");
                    return false;
                }
                const payload = {
                    company_id: data.company_id,
                    device_id: device_id,
                    return_zpl: !!data.use_local_agent,
                    sort: sortVal,
                    ids: ids
                };
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).print_location_labels, payload);
                if (result?.zpl) try {
                    await (0, $9VcS9.default).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $jUNyh.notify)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            let fs = (0, $h1m6J.default).create((0, $66f0ec4106475d51$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        openLocationsCatalogReport () {
            const ensureHost = ()=>{
                let el = document.getElementById('lcr-preview-host');
                if (el) return el;
                const wa = document.getElementById('workarea');
                const title = wa?.querySelector('.title');
                el = document.createElement('div');
                el.id = 'lcr-preview-host';
                el.className = 'mts';
                if (title) title.insertAdjacentElement('afterend', el);
                else wa?.appendChild(el);
                return el;
            };
            const dlgHtml = `
<div class="msgbox" style="min-width: min(36rem, 92vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Cat\xe1logo de posi\xe7\xf5es \u{2014} filtros</div>
	<div class="mb-text" style="max-height: none;">
		<p class="muted fsxx" style="margin:0 0 0.5rem;">Lista posi\xe7\xf5es com saldo (estoque ativo) por endere\xe7o. Use <strong>Ocupa\xe7\xe3o</strong> para restringir a vazias ou com saldo.</p>
		<label>Empresa<sup>*</sup><select id="lcr-company"></select></label>
		<label>Armaz\xe9m<select id="lcr-warehouse"></select></label>
		<label>Ocupa\xe7\xe3o
			<select id="lcr-occupancy">
				<option value="all">Todas</option>
				<option value="empty">Somente vazias (sem saldo ativo)</option>
				<option value="occupied">Somente com saldo</option>
			</select>
		</label>
		<label><input type="checkbox" id="lcr-include-disabled"> Incluir posi\xe7\xf5es desabilitadas</label>
		<label>Staging
			<select id="lcr-staging">
				<option value="all">Todos</option>
				<option value="yes">Sim</option>
				<option value="no">N\xe3o</option>
			</select>
		</label>
		<label>Atuante (ao alcance)
			<select id="lcr-inreach">
				<option value="all">Todos</option>
				<option value="yes">Sim</option>
				<option value="no">N\xe3o</option>
			</select>
		</label>
		<label>Mix
			<select id="lcr-mix">
				<option value="">Todos</option>
				<option value="0">Sem restri\xe7\xe3o de SKUs</option>
				<option value="1">Lotes distintos do SKU</option>
				<option value="2">Apenas mesmo lote</option>
			</select>
		</label>
		<label>Classe (opcional)<select id="lcr-class"></select></label>
		<div style="display:flex;flex-wrap:wrap;gap:0.75rem;margin-top:0.5rem;">
			<label>Pr\xe9via: limite<input type="number" id="lcr-limit" value="200" min="1" max="5000" step="1"></label>
			<label>Pr\xe9via: offset<input type="number" id="lcr-offset" value="0" min="0" step="1"></label>
			<label>CSV: m\xe1x. linhas<input type="number" id="lcr-max-rows" value="25000" min="1" max="100000" step="1"></label>
		</div>
	</div>
	<div class="mts" style="display:flex;flex-wrap:wrap;gap:0.5rem;">
		<button type="button" class="button bn_Preview">Pr\xe9via na tela</button>
		<button type="button" class="button bn_ExportCsv">Exportar CSV</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
            const dlg = (0, $dx9qz.default).create(dlgHtml, async (key)=>{
                const root = dlg.getNode();
                if (key === 'Escape') {
                    dlg.destroy();
                    return;
                }
                if (key !== 'Preview' && key !== 'ExportCsv') return;
                const pack = $2332a4e102178b91$var$lcrCollectParams(root, key === 'Preview' ? 'json' : 'csv');
                if (!pack) {
                    (0, $jUNyh.notify)('Selecione a empresa.');
                    return;
                }
                const mbLoad = (0, $jUNyh.default)({
                    animation: true
                });
                try {
                    if (key === 'Preview') {
                        const res = await (0, $9VcS9.default).locations_catalog_report(pack.companyId, pack.sp.toString());
                        const raw = await res.text();
                        if (!res.ok) {
                            (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw), "Cat\xe1logo de posi\xe7\xf5es");
                            return;
                        }
                        let data;
                        try {
                            data = JSON.parse(raw);
                        } catch (e) {
                            (0, $jUNyh.notify)("Resposta n\xe3o \xe9 JSON.", "Cat\xe1logo de posi\xe7\xf5es");
                            return;
                        }
                        if (!Array.isArray(data)) {
                            (0, $jUNyh.notify)('Formato inesperado da API.', "Cat\xe1logo de posi\xe7\xf5es");
                            return;
                        }
                        dlg.destroy();
                        $2332a4e102178b91$var$lcrRenderPreview(ensureHost(), data);
                        (0, $jUNyh.notify)(`Pr\xe9via: ${data.length} linha(s).`, "Cat\xe1logo de posi\xe7\xf5es");
                        return;
                    }
                    const blob = await $2332a4e102178b91$var$lcrExportCsvInChunks(pack.companyId, pack.sp);
                    const fname = `posicoes-catalogo-${pack.companyId.slice(0, 8)}.csv`;
                    $2332a4e102178b91$var$lcrDownloadCsv(blob, fname);
                    dlg.destroy();
                    (0, $jUNyh.notify)('Download do CSV iniciado.', "Cat\xe1logo de posi\xe7\xf5es");
                } catch (e) {
                    console.error(e);
                    (0, $jUNyh.notify)(e?.message || String(e), "Cat\xe1logo de posi\xe7\xf5es");
                } finally{
                    mbLoad.destroy();
                }
            });
            const root = dlg.getNode();
            const selCo = $2332a4e102178b91$var$$('#lcr-company', root);
            const selWh = $2332a4e102178b91$var$$('#lcr-warehouse', root);
            const selCl = $2332a4e102178b91$var$$('#lcr-class', root);
            $2332a4e102178b91$var$lcrLoadCompanies(selCo).then(()=>{});
            selCo.addEventListener('change', async ()=>{
                const id = selCo.value;
                await Promise.all([
                    $2332a4e102178b91$var$lcrLoadWarehouses(id, selWh),
                    $2332a4e102178b91$var$lcrLoadClasses(id, selCl)
                ]);
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m (obrigat\xf3rio antes de filtrar posi\xe7\xe3o/endere\xe7o)",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 3,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o \u2014 informe o armaz\xe9m antes de buscar",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 4,
            field: 'address',
            label: "Endere\xe7o",
            types: [
                $bba672065f562b52$export$2e2bcd8739ae039(),
                $gBwx4.default()
            ],
            placeholder: 'X-Y-Z',
            title: "Endere\xe7o \u2014 informe o armaz\xe9m antes de buscar"
        },
        {
            index: 5,
            field: 'mix',
            label: 'Mix',
            types: [
                $6d521c92c25435df$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Misturas permitidas na posi\xe7\xe3o"
        },
        {
            index: 6,
            field: 'level',
            label: "N\xedvel",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xedvel da posi\xe7\xe3o"
        },
        {
            index: 7,
            field: 'in_reach',
            label: 'Atuante',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o ao alcance da m\xe3o?"
        },
        {
            index: 8,
            field: 'is_staging',
            label: 'Staging',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o de descarga de mercadorias?"
        },
        {
            index: 9,
            field: 'is_expedition',
            label: "Expedi\xe7\xe3o",
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o de Doca Expedi\xe7\xe3o?"
        },
        {
            index: 11,
            field: 'status',
            label: 'Status',
            types: [
                $2372640607a5ee0b$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Status da posi\xe7\xe3o"
        }
    ];
    const reports = [
        {
            hash: '#location-labels',
            label: "Etiquetas&nbsp;de&nbsp;posi\xe7\xe3o"
        },
        {
            hash: '#locations-catalog',
            label: "Cat\xe1logo&nbsp;de&nbsp;posi\xe7\xf5es"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#location-labels', locations_crud.printLocationLabels.bind(locations_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#locations-catalog', locations_crud.openLocationsCatalogReport.bind(locations_crud));
    locations_crud.run('locations', "Posi\xe7\xf5es", document.getElementById('workarea'), (0, $83a15d59aff488df$export$2e2bcd8739ae039), (0, $295f352aa767e7e5$export$2e2bcd8739ae039), fieldspecs, [], reports);
};
var $2332a4e102178b91$export$2e2bcd8739ae039 = $2332a4e102178b91$var$locations;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $aGGTj = parcelRequire("aGGTj");

var $hWQyW = parcelRequire("hWQyW");



var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");


var $b7D1Q = parcelRequire("b7D1Q");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");

var $aGGTj = parcelRequire("aGGTj");
async function $82e5a54bae0b2474$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(n+4):nth-child(-n+20)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(21)	{ text-align: right; }
			.view td:nth-child(n+23):nth-child(-n+25)	{ text-align: right; }
			.view td:nth-child(26)	{ text-align: left; }
			#grid .view th.stock-product-name,
			#grid .view td.stock-product-name {
				max-width: none !important;
				min-width: 22rem;
				white-space: normal !important;
				overflow: visible !important;
				text-overflow: clip !important;
				text-align: left;
				line-height: 1.3;
				vertical-align: middle;
			}
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Estoque</th>
					<th data-index="12" data-visible="${this.visible[2]}">SKU</th>
					<th class="stock-product-name" data-index="13" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="15" data-visible="${this.visible[4]}">Fabricante</th>
					<th data-index="16" data-visible="${this.visible[5]}">NCM</th>
					<th data-index="17" data-visible="${this.visible[6]}">EAN</th>
					<th data-index="18" data-visible="${this.visible[7]}">C\xf3d. cliente</th>
					<th data-index="19" data-visible="${this.visible[8]}">Emb.</th>
					<th data-index="20" data-visible="${this.visible[9]}">Fator</th>
					<th data-index="21" data-visible="${this.visible[10]}">QR Emb.</th>
					<th data-index="23" data-visible="${this.visible[11]}">Programa</th>
					<th data-index="24" data-visible="${this.visible[12]}">Lote fab.</th>
					<th data-index="26" data-visible="${this.visible[13]}">Validade</th>
					<th data-index="25" data-visible="${this.visible[14]}">Fabrica\xe7\xe3o</th>
					<th data-index="28" data-visible="${this.visible[15]}">Data Entrada</th>
					<th data-index="27" data-visible="${this.visible[16]}">Entrada Sial</th>
					<th data-index="29" data-visible="${this.visible[17]}">Nota Entrada</th>
					<th data-index="30" data-visible="${this.visible[18]}">Fornecedor</th>
					<th data-index="39" data-visible="${this.visible[19]}">Fornecedor&nbsp;(nome)</th>
					<th data-index="3" data-visible="${this.visible[20]}">Armaz\xe9m</th>
					<th data-index="4" data-visible="${this.visible[21]}">Posi\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[22]}">Titular</th>
					<th data-index="6" data-visible="${this.visible[23]}">Lote</th>
					<th data-index="7" data-visible="${this.visible[24]}">Dispon\xedvel</th>
					<th data-index="8" data-visible="${this.visible[25]}">Reservado</th>
					<th data-index="9" data-visible="${this.visible[26]}">Bloqueado</th>
					<th data-index="37" data-visible="${this.visible[27]}">Valor unit.</th>
					<th data-index="38" data-visible="${this.visible[28]}">Valor total</th>
				<th data-index="10" data-visible="${this.visible[29]}">Status</th>
			<th data-index="33" data-visible="${this.visible[30]}">Classes</th>
			<th data-index="34" data-visible="${this.visible[31]}">Categoria</th>
			<th data-index="35" data-visible="${this.visible[32]}">Portaria 344</th>
		</tr>
	</thead>
		<tbody>
		` + (await Promise.all(records.map(async (record)=>{
        let posLabel = record.location_address != null && String(record.location_address).trim() !== '' ? String(record.location_address) : '';
        // Não resolver endereço pelo cache local (IDB): catálogo pode ter posições que a API não devolve na listagem.
        if (!posLabel && record.warehouse_id != null && record.location_id != null) posLabel = `${record.warehouse_id}-${record.location_id}`;
        // Nome do armazém vem da API (`warehouse_name`); cache local omite inativos → só key() gerava «undefined».
        let whLabel = record.warehouse_name != null && String(record.warehouse_name).trim() !== '' ? String(record.warehouse_name).trim() : '';
        if (!whLabel) whLabel = await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ]);
        if (!whLabel && record.warehouse_id != null && record.warehouse_id !== '') whLabel = `#${record.warehouse_id}`;
        const productName = (record.product_name ?? '').toString();
        const productNameAttr = productName.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
        return `<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'> <td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.sku ?? '').toString()}</td>
					<td class="stock-product-name" data-visible='${this.visible[3]}' title="${productNameAttr}">${productName}</td>
					<td data-visible='${this.visible[4]}'>${(record.manufacturer_nick ?? '').toString()}</td>
					<td data-visible='${this.visible[5]}'>${(record.ncm ?? '').toString()}</td>
					<td data-visible='${this.visible[6]}'>${(record.gtin ?? '').toString()}</td>
					<td data-visible='${this.visible[7]}'>${(record.codigo_cliente ?? '').toString()}</td>
					<td data-visible='${this.visible[8]}'>${(record.packaging_code ?? '').toString()}</td>
					<td data-visible='${this.visible[9]}'>${this.format($3eqAU.default(0), record.packaging_factor) ?? ''}</td>
					<td data-visible='${this.visible[10]}'>${(record.packaging_qr_code ?? '').toString()}</td>
					<td data-visible='${this.visible[11]}'>${(record.program_name ?? '').toString()}</td>
					<td data-visible='${this.visible[12]}'>${(0, $aGGTj.formatLotNumber)(record.lot_number)}</td>
					<td data-visible='${this.visible[13]}'>${record.expiration_date ?? ''}</td>
					<td data-visible='${this.visible[14]}'>${record.manufacture_date ?? ''}</td>
					<td data-visible='${this.visible[15]}'>${this.format($b7D1Q.default(), record.input_created_on) ?? ''}</td>
					<td data-visible='${this.visible[16]}'>${record.input_id ?? ''}</td>
					<td data-visible='${this.visible[17]}'>${(record.invoice_number ?? '').toString()}</td>
					<td data-visible='${this.visible[18]}'>${(record.supplier_name ?? '').toString()}</td>
					<td data-visible='${this.visible[19]}'>${(record.supplier_legal_name ?? '').toString()}</td>
					<td data-visible='${this.visible[20]}'>${whLabel ?? ''}</td>
					<td data-visible='${this.visible[21]}'>${posLabel}</td>
					<td data-visible='${this.visible[22]}'>${await this.key('companies', record.lot_company_id, 'nick')}</td>
					<td data-visible='${this.visible[23]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[24]}'>${this.format($3eqAU.default(0), record.quantity_available)}</td>
					<td data-visible='${this.visible[25]}'>${this.format($3eqAU.default(0), record.quantity_reserved)}</td>
					<td data-visible='${this.visible[26]}'>${this.format($3eqAU.default(0), record.quantity_unsettled)}</td>
					<td data-visible='${this.visible[27]}'>${this.format($3eqAU.default(4), record.unit_price)}</td>
					<td data-visible='${this.visible[28]}'>${this.format($3eqAU.default(2), record.total_value)}</td>
				<td data-visible='${this.visible[29]}'>${this.option($c539c39a88864005$export$2e2bcd8739ae039(), record.status)}</td>
			<td data-visible='${this.visible[30]}'>${(record.classes ?? '').toString()}</td>
			<td data-visible='${this.visible[31]}'>${(record.categoria ?? '').toString()}</td>
			<td data-visible='${this.visible[32]}'>${this.option($1Wvh7.default(), record.is_portaria_344)}</td>
		</tr>`;
    }))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
/**
 * Painel de detalhe de estoque (Gerenciamento / Estoques).
 * Totais e validade são só apresentação — não altera regra de negócio.
 */ const $7934f87eba130ed0$var$DASH = "\u2014";
function $7934f87eba130ed0$export$8e5fc4a2ee971848(value) {
    if (value == null || value === '') return 0;
    const s = String(value).trim().replace(/\s/g, '');
    if (!s) return 0;
    // BR com milhar + decimal: 5.983,50
    if (s.includes(',') && s.includes('.')) return Number(s.replace(/\./g, '').replace(',', '.')) || 0;
    // Só vírgula decimal: 5,98
    if (s.includes(',')) return Number(s.replace(',', '.')) || 0;
    // Só ponto: milhar BR (5.983 / 1.234.567) — NÃO tratar como decimal US
    // (Number("5.983") === 5.983 gerava KPI "5,98" / total "15,98").
    if (/^\d{1,3}(\.\d{3})+$/.test(s)) return Number(s.replace(/\./g, '')) || 0;
    return Number(s) || 0;
}
function $7934f87eba130ed0$export$13d9f6b55aa45d38(available, reserved, blocked) {
    return $7934f87eba130ed0$export$8e5fc4a2ee971848(available) + $7934f87eba130ed0$export$8e5fc4a2ee971848(reserved) + $7934f87eba130ed0$export$8e5fc4a2ee971848(blocked);
}
function $7934f87eba130ed0$export$99dc69643b057706(available) {
    return $7934f87eba130ed0$export$8e5fc4a2ee971848(available);
}
function $7934f87eba130ed0$export$5e27947d13410e47(qty) {
    const n = $7934f87eba130ed0$export$8e5fc4a2ee971848(qty);
    if (!Number.isFinite(n)) return '0';
    if (Number.isInteger(n)) return n.toLocaleString('pt-BR');
    return n.toLocaleString('pt-BR', {
        maximumFractionDigits: 4
    });
}
function $7934f87eba130ed0$export$740032dac9481334(value) {
    const s = value == null ? '' : String(value).trim();
    if (!s || s === '-' || s === "\u2014") return $7934f87eba130ed0$var$DASH;
    return s;
}
function $7934f87eba130ed0$export$265c7fb91059c9c(value) {
    const s = value == null ? '' : String(value).trim();
    if (!s) return null;
    let y = 0;
    let m = 0;
    let d = 0;
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
        y = Number(iso[1]);
        m = Number(iso[2]);
        d = Number(iso[3]);
    } else {
        const br = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
        if (!br) return null;
        d = Number(br[1]);
        m = Number(br[2]);
        y = Number(br[3]);
    }
    const dt = new Date(y, m - 1, d);
    if (Number.isNaN(dt.getTime()) || dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
    return dt;
}
function $7934f87eba130ed0$export$c5be672fb676f885(value) {
    const dt = $7934f87eba130ed0$export$265c7fb91059c9c(value);
    if (!dt) return $7934f87eba130ed0$export$740032dac9481334(value);
    const dd = String(dt.getDate()).padStart(2, '0');
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${dt.getFullYear()}`;
}
function $7934f87eba130ed0$export$37deb82562363aee(value) {
    const dt = $7934f87eba130ed0$export$265c7fb91059c9c(value);
    if (!dt) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dt.setHours(0, 0, 0, 0);
    return Math.round((dt.getTime() - today.getTime()) / 86400000);
}
function $7934f87eba130ed0$export$15748564aa51dead(days) {
    if (days == null) return null;
    if (days < 0) return 'expired';
    if (days <= 30) return 'danger';
    if (days <= 90) return 'warn';
    return 'ok';
}
function $7934f87eba130ed0$export$49aae678dfed1873(days) {
    if (days == null) return '';
    if (days < 0) return 'vencido';
    if (days === 0) return 'vence hoje';
    if (days === 1) return '1 dia';
    return `${days} dias`;
}
function $7934f87eba130ed0$export$348dc3495f07d294(status) {
    const s = String(status ?? '').trim().toLowerCase();
    if (s === '0' || s === 'livre') return 'free';
    if (s === '10' || s === 'bloqueado') return 'blocked';
    if (s === '20' || s === 'reservado') return 'reserved';
    return 'other';
}
function $7934f87eba130ed0$export$afff2512044263bf(rawStatus) {
    const s = String(rawStatus ?? '').trim();
    if (!s || s === '-' || s === "\u2014") return $7934f87eba130ed0$var$DASH;
    if (s === '0') return 'Livre';
    if (s === '10') return 'Bloqueado';
    if (s === '20') return 'Reservado';
    return s;
}
function $7934f87eba130ed0$export$948646da6bb8244f(available, reserved, blocked, rawStatus) {
    const a = $7934f87eba130ed0$export$8e5fc4a2ee971848(available);
    const r = $7934f87eba130ed0$export$8e5fc4a2ee971848(reserved);
    const b = $7934f87eba130ed0$export$8e5fc4a2ee971848(blocked);
    const total = a + r + b;
    if (total > 0 && a === 0) {
        if (b === total) return {
            label: 'Bloqueado',
            tone: 'blocked'
        };
        if (r === total) return {
            label: 'Reservado',
            tone: 'reserved'
        };
    }
    return {
        label: $7934f87eba130ed0$export$afff2512044263bf(rawStatus),
        tone: $7934f87eba130ed0$export$348dc3495f07d294(rawStatus)
    };
}
function $7934f87eba130ed0$export$3afe5a2dd3d67576(root) {
    if (!root) return;
    const val = (sel)=>{
        const el = root.querySelector(sel);
        return el ? String(el.value ?? '').trim() : '';
    };
    const setText = (sel, text)=>{
        root.querySelectorAll(sel).forEach((el)=>{
            el.textContent = text;
        });
    };
    const product = $7934f87eba130ed0$export$740032dac9481334(val('#stock_product_name'));
    setText('[data-sdp="product"]', product === $7934f87eba130ed0$var$DASH ? "Produto sem descri\xe7\xe3o" : product);
    setText('[data-sdp="sku"]', $7934f87eba130ed0$export$740032dac9481334(val('#stock_sku')));
    setText('[data-sdp="lot-number"]', $7934f87eba130ed0$export$740032dac9481334(val('#stock_lot_number')));
    setText('[data-sdp="manufacturer"]', $7934f87eba130ed0$export$740032dac9481334(val('#stock_manufacturer_nick')));
    const avail = $7934f87eba130ed0$export$8e5fc4a2ee971848(val('#quantity_available'));
    const reserved = $7934f87eba130ed0$export$8e5fc4a2ee971848(val('#quantity_reserved'));
    const blocked = $7934f87eba130ed0$export$8e5fc4a2ee971848(val('#quantity_unsettled'));
    const { label: statusLabel, tone: tone } = $7934f87eba130ed0$export$948646da6bb8244f(avail, reserved, blocked, val('#status'));
    root.querySelectorAll('[data-sdp="status"]').forEach((el)=>{
        el.textContent = statusLabel;
        el.classList.remove('sdp-badge--free', 'sdp-badge--blocked', 'sdp-badge--reserved', 'sdp-badge--other');
        el.classList.add(`sdp-badge--${tone}`);
    });
    const total = $7934f87eba130ed0$export$13d9f6b55aa45d38(avail, reserved, blocked);
    const free = $7934f87eba130ed0$export$99dc69643b057706(avail);
    setText('[data-sdp="kpi-total"]', $7934f87eba130ed0$export$5e27947d13410e47(total));
    setText('[data-sdp="kpi-avail"]', $7934f87eba130ed0$export$5e27947d13410e47(avail));
    setText('[data-sdp="kpi-reserved"]', $7934f87eba130ed0$export$5e27947d13410e47(reserved));
    setText('[data-sdp="kpi-blocked"]', $7934f87eba130ed0$export$5e27947d13410e47(blocked));
    setText('[data-sdp="kpi-free"]', $7934f87eba130ed0$export$5e27947d13410e47(free));
    root.querySelectorAll('[data-sdp-from]').forEach((el)=>{
        const from = el.getAttribute('data-sdp-from');
        const kind = el.getAttribute('data-sdp-kind') || 'text';
        const raw = val(from);
        if (kind === 'date') el.textContent = raw ? $7934f87eba130ed0$export$c5be672fb676f885(raw) : $7934f87eba130ed0$var$DASH;
        else if (kind === 'qty') el.textContent = `${$7934f87eba130ed0$export$5e27947d13410e47(raw)} un`;
        else el.textContent = $7934f87eba130ed0$export$740032dac9481334(raw);
    });
    const days = $7934f87eba130ed0$export$37deb82562363aee(val('#stock_expiration_date'));
    const expEl = root.querySelector('[data-sdp="expiry"]');
    if (expEl) {
        const t = $7934f87eba130ed0$export$15748564aa51dead(days);
        const label = $7934f87eba130ed0$export$49aae678dfed1873(days);
        expEl.hidden = !label;
        expEl.textContent = label;
        expEl.classList.remove('sdp-expiry--expired', 'sdp-expiry--danger', 'sdp-expiry--warn', 'sdp-expiry--ok');
        if (t) expEl.classList.add(`sdp-expiry--${t}`);
    }
}


const $c45260a54a668287$var$ICO_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7 12 12l8.7-5M12 22V12"/></svg>';
const $c45260a54a668287$var$ICO_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12 2.8 2.8L16.5 9"/></svg>';
const $c45260a54a668287$var$ICO_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
const $c45260a54a668287$var$ICO_SCALE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3v18M5 7h14"/><path d="M5 7 2 13h6L5 7zm14 0-3 6h6l-3-6z"/></svg>';
const $c45260a54a668287$var$ICO_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.6 13.4 12 4.8 4 4l.8 8 8.6 8.6a2 2 0 0 0 2.8 0l4.4-4.4a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
const $c45260a54a668287$var$ICO_FLASK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M9 3h6M10 3v6.2L5.2 18a2.8 2.8 0 0 0 2.4 4.2h8.8a2.8 2.8 0 0 0 2.4-4.2L14 9.2V3"/></svg>';
const $c45260a54a668287$var$ICO_IN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3v12"/><path d="m8 11 4 4 4-4"/><path d="M4 19h16"/></svg>';
const $c45260a54a668287$var$ICO_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z"/><circle cx="12" cy="10" r="2.2"/></svg>';
var $c45260a54a668287$export$2e2bcd8739ae039 = {
    html: `
		<form id="stock" class="form sial-modal-form sial-detail stock-detail" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="warehouses"></datalist>
			<datalist id="locations"></datalist>
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${$c45260a54a668287$var$ICO_BOX}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Detalhes do produto / lote</p>
						<h2 class="sdp-title" data-sdp="product">\u{2014}</h2>
						<div class="sdp-meta">
							<span>SKU: <b data-sdp="sku">\u{2014}</b></span>
							<span>Lote: <b data-sdp="lot-number">\u{2014}</b></span>
							<span>Fabricante: <b data-sdp="manufacturer">\u{2014}</b></span>
							<span>Status: <span class="sdp-badge sdp-badge--other" data-sdp="status">\u{2014}</span></span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>
			<section class="sdp-kpis" aria-label="Resumo de saldo">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">${$c45260a54a668287$var$ICO_BOX} Estoque total</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-total">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">${$c45260a54a668287$var$ICO_OK} Dispon\xedvel</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-avail">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">${$c45260a54a668287$var$ICO_LOCK} Reservado</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-reserved">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--blocked">
					<div class="sdp-kpi-label">${$c45260a54a668287$var$ICO_LOCK} Bloqueado</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-blocked">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--free">
					<div class="sdp-kpi-label">${$c45260a54a668287$var$ICO_SCALE} Saldo livre</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-free">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
			</section>
			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$c45260a54a668287$var$ICO_TAG} Dados do produto</h3>
					<dl class="sdp-dl">
						<dt>SKU</dt><dd data-sdp-from="#stock_sku"></dd>
						<dt>Produto</dt><dd data-sdp-from="#stock_product_name"></dd>
						<dt>Fabricante</dt><dd data-sdp-from="#stock_manufacturer_nick"></dd>
						<dt>NCM</dt><dd data-sdp-from="#stock_ncm"></dd>
						<dt>EAN</dt><dd data-sdp-from="#stock_gtin"></dd>
						<dt>Embalagem</dt><dd data-sdp-from="#stock_packaging_code"></dd>
						<dt>Fator de embalagem</dt><dd data-sdp-from="#stock_packaging_factor"></dd>
						<dt>QR Emb.</dt><dd data-sdp-from="#stock_packaging_qr"></dd>
						<dt>Programa</dt><dd data-sdp-from="#stock_program_name"></dd>
						<dt>C\xf3digo do cliente</dt><dd data-sdp-from="#stock_codigo_cliente"></dd>
					</dl>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$c45260a54a668287$var$ICO_FLASK} Dados do lote</h3>
					<dl class="sdp-dl">
						<dt>Lote fabricante</dt><dd data-sdp-from="#stock_lot_number"></dd>
						<dt>Validade</dt>
						<dd>
							<span class="sdp-val-row">
								<span data-sdp-from="#stock_expiration_date" data-sdp-kind="date"></span>
								<span class="sdp-expiry" data-sdp="expiry" hidden></span>
							</span>
						</dd>
						<dt>Fabrica\xe7\xe3o</dt><dd data-sdp-from="#stock_manufacture_date" data-sdp-kind="date"></dd>
						<dt>Data entrada</dt><dd data-sdp-from="#stock_input_created_on" data-sdp-kind="date"></dd>
						<dt>Entrada Sial</dt><dd data-sdp-from="#stock_input_id"></dd>
						<dt>Nota entrada</dt><dd data-sdp-from="#stock_invoice_number"></dd>
					</dl>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${$c45260a54a668287$var$ICO_IN} Origem da entrada</h3>
					<dl class="sdp-dl">
						<dt>Fornecedor</dt><dd data-sdp-from="#stock_supplier_name"></dd>
						<dt>Fornecedor (nome)</dt><dd data-sdp-from="#stock_supplier_legal_name"></dd>
						<dt>Nota entrada</dt><dd data-sdp-from="#stock_invoice_number"></dd>
					</dl>
				</div>
			</section>
			<section class="sdp-loc sdp-block">
				<h3 class="sdp-block-title">${$c45260a54a668287$var$ICO_PIN} Localiza\xe7\xe3o / estoque</h3>
				<div class="sdp-loc-grid">
					<dl class="sdp-dl">
						<dt>Empresa</dt><dd data-sdp-from="#company_id"></dd>
						<dt>Armaz\xe9m</dt><dd data-sdp-from="#warehouse_id"></dd>
						<dt>Titular</dt><dd data-sdp-from="#lot_company_id"></dd>
						<dt>Motivo do bloqueio</dt><dd data-sdp-from="#stock_block_reason"></dd>
					</dl>
					<dl class="sdp-dl">
						<dt>Estoque</dt><dd data-sdp-from="#id"></dd>
						<dt>Estoque total</dt><dd><span data-sdp="kpi-total">0</span> un</dd>
						<dt>Posi\xe7\xe3o</dt><dd data-sdp-from="#location_id"></dd>
						<dt>Lote (posi\xe7\xe3o)</dt><dd data-sdp-from="#lot_id"></dd>
					</dl>
					<dl class="sdp-dl">
						<dt>Status</dt><dd><span class="sdp-badge sdp-badge--other" data-sdp="status">\u{2014}</span></dd>
						<dt>Dispon\xedvel</dt><dd data-sdp-from="#quantity_available" data-sdp-kind="qty"></dd>
						<dt>Reservado</dt><dd data-sdp-from="#quantity_reserved" data-sdp-kind="qty"></dd>
						<dt>Bloqueado</dt><dd data-sdp-from="#quantity_unsettled" data-sdp-kind="qty"></dd>
					</dl>
				</div>
			</section>
			<div class="sdp-foot">
				<button type="button" class="bn_Escape button">Fechar</button>
			</div>
			<div class="sdp-bind" aria-hidden="true">
				<input id="stock_sku" type="text" disabled tabindex="-1">
				<textarea id="stock_product_name" disabled tabindex="-1"></textarea>
				<input id="stock_manufacturer_nick" type="text" disabled tabindex="-1">
				<input id="stock_ncm" type="text" disabled tabindex="-1">
				<input id="stock_gtin" type="text" disabled tabindex="-1">
				<input id="stock_packaging_code" type="text" disabled tabindex="-1">
				<input id="stock_packaging_factor" type="text" disabled tabindex="-1">
				<input id="stock_packaging_qr" type="text" disabled tabindex="-1">
				<input id="stock_lot_number" type="text" disabled tabindex="-1">
				<input id="stock_expiration_date" type="text" disabled tabindex="-1">
				<input id="stock_manufacture_date" type="text" disabled tabindex="-1">
				<input id="stock_program_name" type="text" disabled tabindex="-1">
				<input id="stock_codigo_cliente" type="text" disabled tabindex="-1">
				<input id="stock_input_created_on" type="text" disabled tabindex="-1">
				<input id="stock_input_id" type="text" disabled tabindex="-1">
				<input id="stock_invoice_number" type="text" disabled tabindex="-1">
				<input id="stock_supplier_name" type="text" disabled tabindex="-1">
				<input id="stock_supplier_legal_name" type="text" disabled tabindex="-1">
				<input id="company_id" type="text" list="companies" disabled tabindex="-1">
				<input id="id" type="text" disabled tabindex="-1">
				<input id="warehouse_id" type="text" list="warehouses" disabled tabindex="-1">
				<input id="location_id" type="text" list="locations" disabled tabindex="-1">
				<input id="lot_company_id" type="text" list="companies" disabled tabindex="-1">
				<input id="lot_id" type="text" disabled tabindex="-1">
				<input id="quantity_available" type="text" disabled tabindex="-1">
				<input id="quantity_reserved" type="text" disabled tabindex="-1">
				<input id="quantity_unsettled" type="text" disabled tabindex="-1">
				<input id="stock_block_reason" type="text" disabled tabindex="-1">
				<input id="status" type="text" list="stock_status" disabled tabindex="-1">
			</div>
		</form>
	`,
    form: {
        selector: '#stock',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const orig = this.setValues.bind(this);
            this.setValues = (values)=>{
                orig(values);
                (0, $7934f87eba130ed0$export$3afe5a2dd3d67576)(this.node);
            };
            this.node?.addEventListener('change', ()=>(0, $7934f87eba130ed0$export$3afe5a2dd3d67576)(this.node));
        },
        afterEditSetValues (fs) {
            const root = fs.form.node;
            (0, $7934f87eba130ed0$export$3afe5a2dd3d67576)(root);
            setTimeout(()=>(0, $7934f87eba130ed0$export$3afe5a2dd3d67576)(root), 400);
        }
    },
    fields: [
        {
            properties: {
                selector: '#stock_sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_product_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_manufacturer_nick'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_ncm'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_gtin'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_packaging_code'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_packaging_factor'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_packaging_qr'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_lot_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_expiration_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_manufacture_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_program_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_codigo_cliente'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_input_created_on'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_input_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_invoice_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_supplier_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_supplier_legal_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#lot_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_available'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_reserved'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_unsettled'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#stock_block_reason'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $c539c39a88864005$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $3OKkn = parcelRequire("3OKkn");
var $6c327e0121057f1c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#move-stock #stock_sku		{ width: 9rem;	}
			#move-stock #lot_company_id	{ width: 10rem;	}
			#move-stock #lot_id			{ width: 10rem;	}
			#move-stock #quantity		{ width: 5rem; text-align: right;	}
			#move-stock #output_id		{ width: 5rem; text-align: right;	}
			#move-stock #reason			{ width: 11rem;	}
			#move-stock .company		{ width: 10rem;	}
			#move-stock .warehouse		{ width: 10rem;	}
			#move-stock .location		{ width: 9rem;	}
			#move-stock .stock			{ width: 8rem;	}
		</style>
		<form id="move-stock" class="form" autocomplete="off">
			<datalist id="move-companies">
			</datalist>
			<datalist id="move-products">
			</datalist>
			<datalist id="source-warehouses">
			</datalist>
			<datalist id="target-warehouses">
			</datalist>
			<datalist id="target-locations">
			</datalist>
			<div class="title">
				Mover Estoque
			</div>
			<div class="fsb mtl">
				<label title="SKU do produto (informa\xe7\xe3o, preenchido ao selecionar estoque)">SKU
					<input id="stock_sku" type="text" list="move-products" placeholder="Ex.: Y8GZ5A ou buscar produto">
				</label>
				<label title="Empresa titular do lote">Titular<sup>*</sup>
					<input id="lot_company_id" type="text" list="move-companies" required>
				</label>
				<label title="Lote (identificador do sistema, somente leitura)">Lote<sup>*</sup>
					<input id="lot_id" type="text" required readonly>
				</label>
				<label title="Quantidade a mover">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Identificador da sa\xedda em caso de reserva">Sa\xedda
					<input id="output_id" type="text">
				</label>
				<label title="Justificativa para a opera\xe7\xe3o">Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa de origem">Origem<sup>*</sup>
					<input id="source_warehouse_company_id" class="company" type="text" list="move-companies" required>
				</label>
				<label title="Armaz\xe9m de origem">Armaz\xe9m<sup>*</sup>
					<input id="source_warehouse_id" class="warehouse" type="text" list="source-warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o de origem (somente leitura)">Posi\xe7\xe3o<sup>*</sup>
					<input id="source_location_id" class="location" type="text" required readonly>
				</label>
				<label title="Saldo de origem">De<sup>*</sup>
					<select id="source_stock" class="stock" required>
						<option value="L">Dispon\xedvel</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa de destino">Destino<sup>*</sup>
					<input id="target_warehouse_company_id" class="company" type="text" list="move-companies" required>
				</label>
				<label title="Armaz\xe9m de destino">Armaz\xe9m<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="target-warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o de destino (lista do armaz\xe9m; busca case-sensitive)">Posi\xe7\xe3o<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="target-locations" required placeholder="Ap\xf3s armaz\xe9m destino">
				</label>
				<label title="Saldo de destino">Para<sup>*</sup>
					<select id="target_stock" class="stock" required>
						<option value="L">Dispon\xedvel</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#move-stock',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#move-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#lot_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#stock_sku'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('lot_company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ],
                    value: 'sku'
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $6Jl4s.default(),
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        },
        {
            properties: {
                selector: '#source_warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#source_warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('source_warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('target_warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#source_location_id'
            },
            types: [
                $6Jl4s.default(),
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#target_location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default({
                    caseSensitive: true
                }),
                $6lTH5.default([
                    'target_warehouse_company_id',
                    'target_warehouse_id'
                ]),
                $f0a98998622cf31a$export$2e2bcd8739ae039({
                    companyKey: 'target_warehouse_company_id',
                    warehouseKey: 'target_warehouse_id'
                })
            ]
        },
        {
            properties: {
                selector: '#source_stock'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '#target_stock'
            },
            types: [
                $3OKkn.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");


var $9VcS9 = parcelRequire("9VcS9");
function $ec13f0e1663b8b62$export$d3e27bd7b930882c(code) {
    const c = String(code || '').trim();
    if (!c) return '';
    const opts = $3dfaf73b973524e9$export$2e2bcd8739ae039()?.options || [];
    const hit = opts.find((o)=>o.value === c);
    return hit ? String(hit.label) : c;
}
function $ec13f0e1663b8b62$export$d301f936562b4738(code, kindEl = null) {
    const c = String(code || '').trim();
    if (kindEl?.list?.options) {
        const opts = Array.from(kindEl.list.options);
        const hit = opts.find((o)=>String(o.value).trim() === c);
        if (hit) return String(hit.label || hit.textContent || c).trim() || c;
    }
    return $ec13f0e1663b8b62$export$d3e27bd7b930882c(code);
}
function $ec13f0e1663b8b62$export$c91908577e64ed6a(kindEl) {
    if (!kindEl) return '';
    const raw = String(kindEl.value || '').trim();
    if (!raw) return '';
    const opts = kindEl.list?.options ? Array.from(kindEl.list.options) : $3dfaf73b973524e9$export$2e2bcd8739ae039()?.options || [];
    const byValue = opts.filter((o)=>String(o.value).trim() === raw);
    if (byValue.length === 1) return String(byValue[0].value).trim();
    const byLabel = opts.filter((o)=>String(o.label || o.innerText || o.textContent || '').trim() === raw);
    if (byLabel.length === 1) return String(byLabel[0].value).trim();
    return raw;
}
async function $ec13f0e1663b8b62$export$2112f4a4c45ac6d0(companyId, listEl) {
    if (!listEl || !companyId) return;
    try {
        const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_stock_block_kinds_by_company, companyId, false);
        if (!Array.isArray(rows) || !rows.length) return;
        listEl.innerHTML = '';
        for (const r of rows){
            const opt = document.createElement('option');
            opt.value = String(r.code);
            opt.label = String(r.label || r.code);
            opt.textContent = String(r.label || r.code);
            listEl.appendChild(opt);
        }
    } catch (_) {
    /* mantém options padrão do opt_movement_kind */ }
}
function $ec13f0e1663b8b62$export$3a914ee0d3160d3f(formset, opts = {}) {
    const kindId = opts.kindId || 'movement_kind';
    const reasonId = opts.reasonId || 'reason';
    const root = formset?.form?.node || document.querySelector(formset?.form?.selector || '');
    if (!root) return '';
    const kindEl = root.querySelector(`#${kindId}`);
    const reasonEl = root.querySelector(`#${reasonId}`);
    const code = $ec13f0e1663b8b62$export$c91908577e64ed6a(kindEl);
    const reason = $ec13f0e1663b8b62$export$d301f936562b4738(code, kindEl);
    if (reasonEl) {
        reasonEl.value = reason;
        reasonEl.setAttribute('readonly', 'readonly');
        reasonEl.tabIndex = -1;
    }
    if (formset?.form?.setValues) formset.form.setValues({
        [reasonId]: reason,
        ...code ? {
            [kindId]: code
        } : {}
    });
    return reason;
}
function $ec13f0e1663b8b62$export$4fe6c6811c9e5a0c(formset, opts = {}) {
    const kindId = opts.kindId || 'movement_kind';
    const root = formset?.form?.node || document.querySelector(formset?.form?.selector || '');
    if (!root) return ()=>{};
    const kindEl = root.querySelector(`#${kindId}`);
    const reasonEl = root.querySelector(`#${opts.reasonId || 'reason'}`);
    if (reasonEl) {
        reasonEl.setAttribute('readonly', 'readonly');
        reasonEl.tabIndex = -1;
        reasonEl.removeAttribute('required');
        reasonEl.placeholder = 'Preenchido automaticamente pela Natureza';
    }
    const companyId = root.querySelector('#company_id')?.value || formset?.form?.getFieldBySelector?.('#company_id')?.getValue?.();
    const listEl = kindEl?.list || root.querySelector('#movement_kind_list');
    if (companyId && listEl) $ec13f0e1663b8b62$export$2112f4a4c45ac6d0(companyId, listEl);
    const sync = ()=>$ec13f0e1663b8b62$export$3a914ee0d3160d3f(formset, opts);
    kindEl?.addEventListener('change', sync);
    kindEl?.addEventListener('input', sync);
    sync();
    return ()=>{
        kindEl?.removeEventListener('change', sync);
        kindEl?.removeEventListener('input', sync);
    };
}


var $c8cd8707148527cd$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#block-stock #stock_sku			{ width: 12rem; }
			#block-stock #lot_display			{ width: 14rem; }
			#block-stock #location_display		{ width: 22rem; }
			#block-stock #quantity				{ width: 6rem; text-align: right; }
			#block-stock #reason				{ width: 100%; max-width: 28rem; background: #f3f4f6; cursor: default; }
			#block-stock #movement_kind		{ width: 20rem; }
		</style>
		<form id="block-stock" class="form" autocomplete="off">
			<div class="title">Bloquear estoque</div>
			<p class="mts muted" style="max-width:36rem">Transfere quantidade de <strong>dispon\xedvel (L)</strong> para <strong>bloqueado (B)</strong> na mesma posi\xe7\xe3o. Exige linha selecionada na grade. O <strong>Motivo</strong> \xe9 preenchido pela Natureza (n\xe3o \xe9 texto livre).</p>
			<div class="fsb mtl">
				<label>SKU
					<input id="stock_sku" type="text" disabled>
				</label>
				<label>Titular / Lote
					<input id="lot_display" type="text" disabled>
				</label>
				<label>Armaz\xe9m / Posi\xe7\xe3o
					<input id="location_display" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Quantidade dispon\xedvel a bloquear">Quantidade<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Classifica\xe7\xe3o operacional \u{2014} define o Motivo">Natureza<sup>*</sup>
					<input id="movement_kind" type="text" list="movement_kind_list" required>
				</label>
			</div>
			<div class="fsb mtm">
				<label style="flex:1;max-width:28rem" title="Espelho da Natureza (somente leitura; APIs/relat\xf3rios continuam lendo este campo)">Motivo
					<input id="reason" type="text" readonly tabindex="-1" placeholder="Preenchido automaticamente pela Natureza">
				</label>
			</div>
			<input id="lot_company_id" type="hidden">
			<input id="lot_id" type="hidden">
			<input id="source_warehouse_company_id" type="hidden">
			<input id="source_warehouse_id" type="hidden">
			<input id="source_location_id" type="hidden">
			<input id="target_warehouse_company_id" type="hidden">
			<input id="target_warehouse_id" type="hidden">
			<input id="target_location_id" type="hidden">
			<input id="qty_available_max" type="hidden">
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Bloquear</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#block-stock',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
            (0, $ec13f0e1663b8b62$export$4fe6c6811c9e5a0c)(formset);
        }
    },
    fields: [
        {
            properties: {
                selector: '#stock_sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#lot_display'
            },
            types: []
        },
        {
            properties: {
                selector: '#location_display'
            },
            types: []
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#movement_kind'
            },
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        },
        {
            properties: {
                selector: '#lot_company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#source_warehouse_company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#source_warehouse_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#source_location_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#target_warehouse_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#target_location_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#qty_available_max'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};




var $822dea3bdf7d9d14$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-report-form #format { width: 8rem; }
		</style>
		<form id="stocks-report-form" class="form" autocomplete="off">
			<div class="title" id="report-title">Relat\xf3rio</div>
			<div class="mtm">
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
					</select>
				</label>
			</div>
			<div class="mtm">
				<button type="button" id="btn-filters" class="button">Definir filtros</button>
				<span id="filter-summary" class="mll" style="color:var(--color-muted);font-size:0.9em"></span>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class="bn_Escape button">Fechar</button>
					<button class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-report-form'
    },
    fields: [
        {
            properties: {
                selector: '#format'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $f2e31d0f27d90986$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-export-csv-form #company_id { width: 15rem; }
			#stocks-export-csv-form #warehouse_id { width: 15rem; }
			#stocks-export-csv-form #program_id { width: 15rem; }
			#stocks-export-csv-form #class_name { width: 15rem; }
		</style>
		<form id="stocks-export-csv-form" class="form" autocomplete="off">
			<datalist id="companies-export">
			</datalist>
			<datalist id="warehouses-export">
			</datalist>
			<datalist id="programs-export">
			</datalist>
			<div class="title">Exportar Estoque em CSV</div>
			<p class="mts" style="color:var(--color-muted);font-size:0.9em">
				Relat\xf3rio completo por empresa. O arquivo CSV abre no Excel.
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies-export" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armaz\xe9m (opcional)
					<input id="warehouse_id" type="text" list="warehouses-export">
				</label>
			</div>
			<div class="mtm">
				<label>Programa (opcional)
					<input id="program_id" type="text" list="programs-export">
				</label>
			</div>
			<div class="mtm">
				<label>Classe (cont\xe9m, opcional)
					<input id="class_name" type="text" placeholder="Ex: CONTROLADO">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Exportar CSV</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-export-csv-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies-export', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#warehouses-export', 'warehouses', {
                labels: [
                    'name'
                ]
            });
            formset.loadList('#programs-export', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs')
            ]
        },
        {
            properties: {
                selector: '#class_name'
            },
            types: [
                $6Jl4s.default()
            ]
        }
    ]
};



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $5d0e2de2f4bee2f9$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stocks-print-durability-form #company_id { width: 15rem; }
			#stocks-print-durability-form #warehouse_id { width: 15rem; }
			#stocks-print-durability-form #program_id { width: 15rem; }
		</style>
		<form id="stocks-print-durability-form" class="form" autocomplete="off">
			<datalist id="companies-durability"></datalist>
			<datalist id="warehouses-durability"></datalist>
			<datalist id="programs-durability"></datalist>
			<div class="title">Durabilidade de Estoque</div>
			<p class="mts" style="color:var(--color-muted);font-size:0.9em">
				Excel com saldo f\xedsico, reserva em sa\xeddas, bloqueios, pr\xe9-reserva de pedidos aprovados
				e saldo livre simulado. N\xe3o altera reserva real nem FEFO.
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies-durability" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armaz\xe9m (opcional)
					<input id="warehouse_id" type="text" list="warehouses-durability">
				</label>
			</div>
			<div class="mtm">
				<label>Programa (opcional)
					<input id="program_id" type="text" list="programs-durability">
				</label>
			</div>
			<div class="mtm">
				<label>
					<input id="only_negative" type="checkbox" class="dib">
					Somente saldo simulado negativo
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Gerar Excel</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stocks-print-durability-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies-durability', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#warehouses-durability', 'warehouses', {
                labels: [
                    'name'
                ]
            });
            formset.loadList('#programs-durability', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs')
            ]
        },
        {
            properties: {
                selector: '#only_negative'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $c35a1f71a10bd4ea$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sku-no-output-form #company_id  { width: 15rem; }
			#sku-no-output-form #warehouse_id { width: 15rem; }
			#sku-no-output-form #date_from,
			#sku-no-output-form #date_to     { width: 10rem; }
		</style>
		<form id="sku-no-output-form" class="form" autocomplete="off">
			<datalist id="snor-companies"></datalist>
			<datalist id="snor-warehouses"></datalist>
			<div class="title">SKUs sem Sa\xedda no Per\xedodo</div>
			<p class="mts fss" style="color:var(--color-muted)">
				Lista lotes com quantidade <strong>dispon\xedvel para separa\xe7\xe3o</strong> de produtos
				que n\xe3o tiveram baixa f\xedsica de sa\xedda no per\xedodo. Inclui validade e custo unit\xe1rio da entrada.
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="snor-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>At\xe9<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armaz\xe9m (opcional)
					<input id="warehouse_id" type="text" list="snor-warehouses">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Consultar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sku-no-output-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#snor-companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#snor-warehouses', 'warehouses', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $5fe4dde45e4cd989$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output-purchase-form #company_id  { width: 15rem; }
			#output-purchase-form #warehouse_id { width: 15rem; }
			#output-purchase-form #date_from,
			#output-purchase-form #date_to     { width: 10rem; }
		</style>
		<form id="output-purchase-form" class="form" autocomplete="off">
			<datalist id="opr-companies"></datalist>
			<datalist id="opr-warehouses"></datalist>
			<div class="title">Sa\xeddas para Compras (CSV)</div>
			<p class="mts fss" style="color:var(--color-muted)">
				Exporta baixas f\xedsicas de estoque no per\xedodo (SKU, lote, quantidade, fabricante e fornecedor da entrada de origem).
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="opr-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>At\xe9<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armaz\xe9m (opcional)
					<input id="warehouse_id" type="text" list="opr-warehouses">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Exportar CSV</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#output-purchase-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#opr-companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#opr-warehouses', 'warehouses', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        }
    ]
};


/**
 * Confirmação de movimentação manual — bloqueado movível com aviso; reservado intocável.
 */ /** @returns {string|null} mensagem de erro ou null se permitido */ function $48324c8641eeba48$export$fca310ad3037c0ff(sourceStock, targetStock) {
    if (sourceStock === 'R' || targetStock === 'R') return "Saldo reservado n\xe3o pode ser movimentado. Libere ou baixe a sa\xedda antes de transferir o estoque.";
    return null;
}
function $48324c8641eeba48$export$c1c1b307cca99bce(items) {
    const lines = (items || []).filter((i)=>Number(i.quantity) > 0);
    if (!lines.length) return '';
    const detail = lines.slice(0, 8).map((i)=>{
        const sku = i.sku || '?';
        const lot = i.lot_number != null && i.lot_number !== '' ? ` lote ${i.lot_number}` : '';
        return `${sku}${lot}: ${i.quantity} un. bloqueada(s)`;
    }).join('; ');
    const more = lines.length > 8 ? ` \u{2026} (+${lines.length - 8} SKU(s))` : '';
    const total = lines.reduce((s, i)=>s + Number(i.quantity), 0);
    return `Ser\xe3o movimentadas ${total} unidade(s) bloqueada(s). Detalhe: ${detail}${more}. O saldo reservado n\xe3o ser\xe1 alterado. Confirma?`;
}
function $48324c8641eeba48$export$ea6fa4760ed71ffc(payload) {
    const qFree = payload.quantity_free_total ?? 0;
    const qBlocked = payload.quantity_blocked_total ?? 0;
    const outs = (payload.output_ids || []).filter(Boolean);
    const outTxt = outs.length ? ` Sa\xeddas com reserva nesta posi\xe7\xe3o (refer\xeancia): ${outs.join(', ')}.` : '';
    const lines = payload.lines || [];
    const detail = lines.slice(0, 8).map((l)=>{
        const sku = l.sku || '?';
        const lot = l.lot_number != null && l.lot_number !== '' ? ` lote ${l.lot_number}` : '';
        return `${sku}${lot}: reservado ${l.quantity_reserved ?? 0}, bloqueado ${l.quantity_unsettled ?? 0}, livre ${l.quantity_available ?? 0}`;
    }).join('; ');
    const more = lines.length > 8 ? ` \u{2026} (+${lines.length - 8} linha(s))` : '';
    const hasReserved = lines.some((l)=>(l.quantity_reserved ?? 0) > 0);
    let msg = (payload.message || "Confirma\xe7\xe3o necess\xe1ria para movimentar esta posi\xe7\xe3o.") + outTxt;
    if (detail) msg += ` Detalhe: ${detail}${more}.`;
    if (hasReserved) msg += ' O saldo reservado permanece na origem.';
    if (qFree > 0) msg += ` Saldo livre: ${qFree} unidade(s).`;
    if (qBlocked > 0) msg += ` Saldo bloqueado: ${qBlocked} unidade(s) \u{2014} ser\xe3o movidas ap\xf3s confirma\xe7\xe3o.`;
    if (qFree <= 0 && qBlocked <= 0) msg += " N\xe3o h\xe1 saldo livre nem bloqueado para movimentar.";
    else msg += " Confirma a movimenta\xe7\xe3o?";
    return {
        msg: msg,
        qFree: qFree,
        qBlocked: qBlocked,
        hasReserved: hasReserved
    };
}
function $48324c8641eeba48$export$a234dae7099b11b9(payload) {
    const qFree = payload.quantity_free_total ?? 0;
    const qBlocked = payload.quantity_blocked_total ?? 0;
    const hasReserved = (payload.lines || []).some((l)=>(l.quantity_reserved ?? 0) > 0);
    return {
        move_free_only: hasReserved || Boolean(payload.requires_move_free_only),
        include_blocked: qBlocked > 0 || Boolean(payload.requires_include_blocked),
        canProceed: qFree > 0 || qBlocked > 0
    };
}




var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
function $b94ca141f2d5964b$var$downloadBase64File(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
}
function $b94ca141f2d5964b$var$downloadCsv(base64Content, filename) {
    $b94ca141f2d5964b$var$downloadBase64File(base64Content, filename || 'relatorio.csv', 'text/csv;charset=utf-8');
}

const $b94ca141f2d5964b$var$stocks = function() {
    let stocks_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        default_columns: '1,2,12,13,15,16,17,18,19,20,21,23,24,26,25,28,27,29,30,3,4,5,6,7,8,9,37,38,39,10',
        insertRecord () {
        // Tela de estoque é somente consulta; criação/alteração é feita por entradas, movimentação e inventário
        },
        async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options = {}) {
            // Grade: alinhar colunas/checkboxes (v2=fabricante; v3=ordem/índices + coluna cód. cliente).
            try {
                const raw = localStorage.getItem('stocks.setup');
                if (raw) {
                    const s = JSON.parse(raw);
                    let touch = false;
                    if (!s.stocks_grid_v2) {
                        s.columns = this.default_columns;
                        s.stocks_grid_v2 = true;
                        touch = true;
                    }
                    if (!s.stocks_grid_v3) {
                        s.columns = this.default_columns;
                        s.stocks_grid_v3 = true;
                        touch = true;
                    }
                    // Programa na grade = coluna exibida program_name (23.º campo do SELECT); índice 22 era program_id — desalinhava visibilidade (#MT-880B687).
                    if (!s.stocks_grid_v4_program_col) {
                        if (typeof s.columns === 'string' && /\b22\b/.test(s.columns)) s.columns = s.columns.replace(/\b22\b/g, '23');
                        s.stocks_grid_v4_program_col = true;
                        touch = true;
                    }
                    // v5: coluna Classes (33) adicionada — não inclusa no default; só reset se colunas ainda não existirem.
                    if (!s.stocks_grid_v5_classes) {
                        s.stocks_grid_v5_classes = true;
                        touch = true;
                    }
                    if (!s.stocks_grid_v6_categoria) {
                        s.stocks_grid_v6_categoria = true;
                        touch = true;
                    }
                    if (!s.stocks_grid_v7_values) {
                        s.columns = this.default_columns;
                        s.stocks_grid_v7_values = true;
                        touch = true;
                    }
                    if (touch) localStorage.setItem('stocks.setup', JSON.stringify(s));
                }
            } catch (_) {}
            await Object.getPrototypeOf(this).run.call(this, module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, {
                ...options,
                skipInitialLoad: true
            });
            // Ocultar Inserir (tela somente consulta)
            const insertLi = this.target_node?.querySelector?.('li[hash="#insert"]');
            if (insertLi) insertLi.style.display = 'none';
            // #MT-FD0B172 — Configurar: colunas/ordenação já via applySetup.
            // "Preservar grade ao reabrir" (keep_filter=1) → recarrega grade SEM critérios do Filtrar.
            this.filter = {};
            const setup = this.loadSetup?.() || {};
            if (setup.filter != null || setup.filter_applied != null) {
                delete setup.filter;
                delete setup.filter_applied;
                try {
                    localStorage.setItem('stocks.setup', JSON.stringify(setup));
                } catch (_) {}
            }
            if (setup.keep_filter === 1 || setup.keep_filter === true || setup.keep_filter === '1') {
                this.filterExplicitlyApplied = true;
                await this.loadPage(1);
                return;
            }
            const grid_node = this.target_node?.querySelector?.('#grid');
            if (grid_node) grid_node.innerHTML = '<p class="mtm" style="color:var(--color-muted)">Clique em <strong>Filtrar</strong> e depois <strong>Aplicar</strong> para carregar os dados (ou aplicar filtros para refinar a busca).</p>';
            const page = this.target_node?.querySelector?.('#page');
            if (page) page.innerText = '0/0';
        },
        async resolveFilterData (raw) {
            return await (0, $hWQyW.resolveFilterLabelsToIds)(raw || this.filter || {}, this.fieldspecs);
        },
        normalizeFilterData (raw) {
            const out = {
                ...raw || {}
            };
            Object.keys(out).forEach((k)=>{
                const v = out[k];
                if (v === '-1' || v === -1 || v == null) out[k] = '';
            });
            return out;
        },
        async extractLocationScopeFilterRaw (raw) {
            const parts = [];
            const data = raw || {};
            const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
            let companies = null;
            const resolveCompanyId = async (v)=>{
                if (UUID_REGEX.test(v)) return v;
                companies = companies ?? await (0, $1cmSR.default).list('companies').catch(()=>[]);
                const c = companies.find((x)=>(x.nick || '') === v || String(x.nick || '') === v || (x.name || '') === v || String(x.name || '') === v);
                const id = c?.id;
                return id && UUID_REGEX.test(String(id)) ? String(id) : null;
            };
            for(let i = 0; i < 10; i++){
                const f = data[`field-${i}`];
                let v = data[`value-${i}`];
                if (v == null || v === '' || v === '-1' || v === -1) continue;
                v = String(v).trim();
                if (f === 'company_id' && v) {
                    const cid = await resolveCompanyId(v);
                    if (cid) parts.push(`company_id*eq*${cid}`);
                } else if (f === 'company_id') continue;
                else if (f === 'warehouse_id' && /^\d+$/.test(v)) parts.push(`warehouse_id*eq*${v}`);
                else if (f === 'location_id' && v) {
                    const m = v.match(/^(\d+):(\d+)$/);
                    if (m) {
                        parts.push(`warehouse_id*eq*${m[1]}`);
                        parts.push(`location_id*eq*${m[2]}`);
                    } else if (/^\d+$/.test(v)) parts.push(`location_id*eq*${v}`);
                }
            }
            return parts.length ? parts.join(',') : null;
        },
        async loadScopedLocations (raw) {
            const scopeFilter = await this.extractLocationScopeFilterRaw(raw);
            if (!scopeFilter) return;
            const params = new URLSearchParams();
            params.append('filter', scopeFilter);
            params.append('sort', '4');
            params.append('limit', '0');
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, '?' + params.toString());
            await (0, $1cmSR.default).set('locations', Array.isArray(data) ? data : []);
            return data;
        },
        async loadBaseData () {
            const q = this.queryAll();
            await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q).then((data)=>(0, $1cmSR.default).set('companies', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q).then((data)=>(0, $1cmSR.default).set('warehouses', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, q).then((data)=>(0, $1cmSR.default).set('programs', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, q).then((data)=>(0, $1cmSR.default).set('devices', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_categories, q).then((data)=>(0, $1cmSR.default).set('categories', data)).catch((error)=>(0, $jUNyh.notify)(error))
            ]);
            await this.loadScopedLocations(this.filter);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_stocks, query);
        },
        async loadRecord (id) {
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, ...JSON.parse(id));
            if (data && typeof data === 'object') {
                // Mapear dados enriquecidos para os campos somente leitura do modal
                data.stock_sku = data.sku ?? '';
                data.stock_product_name = data.product_name ?? '';
                data.stock_ncm = data.ncm ?? '';
                data.stock_gtin = data.gtin ?? '';
                data.stock_packaging_code = data.packaging_code ?? '';
                data.stock_packaging_factor = data.packaging_factor ?? '';
                data.stock_packaging_qr = data.packaging_qr_code ?? '';
                data.stock_lot_number = (0, $aGGTj.formatLotNumber)(data.lot_number) ?? '';
                data.stock_expiration_date = data.expiration_date ?? '';
                data.stock_manufacture_date = data.manufacture_date ?? '';
                data.stock_program_name = data.program_name ?? '';
                data.stock_codigo_cliente = data.codigo_cliente ?? '';
                data.stock_input_created_on = data.input_created_on ? (()=>{
                    const d = new Date(data.input_created_on);
                    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
                })() : '';
                data.stock_input_id = data.input_id ?? '';
                data.stock_invoice_number = data.invoice_number ?? '';
                data.stock_supplier_name = data.supplier_name ?? '';
                data.stock_supplier_legal_name = data.supplier_legal_name ?? '';
                data.stock_manufacturer_nick = data.manufacturer_nick ?? '';
                data.stock_block_reason = Number(data.quantity_unsettled || 0) > 0 ? String(data.block_reason || '').trim() : '';
            }
            return data;
        },
        async saveRecord () {
            // Tela de estoque é somente consulta; não persiste alterações por aqui
            return false;
        },
        async editFilter () {
            await this.loadScopedLocations({});
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), {}, {
                reloadLocations: async (formData)=>{
                    await this.loadScopedLocations(formData);
                }
            });
        },
        async applyFilter (data) {
            let resolved = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            resolved = this.normalizeFilterData(resolved);
            await this.loadScopedLocations(resolved);
            this.filter = resolved;
            this.filterExplicitlyApplied = true;
            await this.loadPage(1);
        },
        applySetup (data) {
            if (data.sort_column != null && data.sort_column !== '') {
                this.sort_column = Number(data.sort_column);
                this.sort_order = Number(data.sort_order ?? 1);
            } else {
                const rec = this.computeRecencySort();
                this.sort_column = rec.sort_column;
                this.sort_order = 1;
            }
            this.page_length = Number(data.page_length ?? this.page_length);
            this.filter = {};
            const _default = this.default_columns || '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25';
            const columns = (data.columns || _default).split(',').map((column)=>Number(column));
            (0, $037bce58a5e51361$export$2e2bcd8739ae039).setVisible(this.fieldspecs.map((field)=>columns.includes(field.index) ? 1 : 0));
        },
        saveSetup (data) {
            const keepOn = data.keep_filter === true || data.keep_filter === 1 || data.keep_filter === '1';
            data.keep_filter = keepOn ? 1 : 0;
            delete data.filter;
            delete data.filter_applied;
            const prev = this.loadSetup() || {};
            for (const k of Object.keys(prev))if ((k.startsWith('sm_') || k.startsWith('stocks_grid_')) && data[k] == null) data[k] = prev[k];
            localStorage.setItem(this.module_name + '.setup', JSON.stringify(data));
            this.applySetup(data);
            if (keepOn) {
                this.filterExplicitlyApplied = true;
                this.loadPage();
            } else {
                this.filterExplicitlyApplied = false;
                const grid_node = this.target_node?.querySelector?.('#grid');
                if (grid_node) grid_node.innerHTML = '<p class="mtm" style="color:var(--color-muted)">Clique em <strong>Filtrar</strong> e depois <strong>Aplicar</strong> para carregar os dados (ou aplicar filtros para refinar a busca).</p>';
                const page = this.target_node?.querySelector?.('#page');
                if (page) page.innerText = '0/0';
            }
        },
        moveStock () {
            const showResult = async (success)=>{
                if (success) {
                    this.loadPage(); // Show updated stocks
                    fs.destroy();
                }
            };
            const sendRequest = async (data)=>{
                const reservedErr = (0, $48324c8641eeba48$export$fca310ad3037c0ff)(data.source_stock, data.target_stock);
                if (reservedErr) {
                    (0, $jUNyh.notify)(reservedErr, "Aten\xe7\xe3o");
                    return;
                }
                let params = {
                    'source_company_id': data.source_warehouse_company_id,
                    'source_warehouse_id': Number(data.source_warehouse_id),
                    'source_location_id': Number(data.source_location_id),
                    'source_stock': data.source_stock,
                    'target_company_id': data.target_warehouse_company_id,
                    'target_warehouse_id': Number(data.target_warehouse_id),
                    'target_location_id': Number(data.target_location_id),
                    'target_stock': data.target_stock,
                    'quantity': Number(data.quantity),
                    'reason': data.reason,
                    'output_id': Number(data.output_id)
                };
                const runMove = ()=>{
                    (0, $9VcS9.default).call((0, $9VcS9.default).move_stock, data.lot_company_id, data.lot_id, params).then(showResult);
                };
                if (data.source_stock === 'B') {
                    (0, $jUNyh.ask)((0, $48324c8641eeba48$export$c1c1b307cca99bce)([
                        {
                            sku: data.stock_sku,
                            quantity: Number(data.quantity)
                        }
                    ]), 'Movimentar bloqueado', (key)=>{
                        if (key !== 'Y') return;
                        runMove();
                    });
                    return;
                }
                runMove();
            };
            let fs = (0, $h1m6J.default).create((0, $6c327e0121057f1c$export$2e2bcd8739ae039), sendRequest);
            const crud = this;
            const origInit = fs.init.bind(fs);
            fs.init = async function() {
                origInit();
                // Preencher com estoque selecionado na grid
                const selected = await crud.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (selected?.length === 1) {
                    const [company_id, stock_id] = selected[0];
                    const stock = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, company_id, stock_id);
                    if (stock) {
                        fs.form.setValues({
                            stock_sku: stock.sku ?? '',
                            lot_company_id: stock.lot_company_id,
                            lot_id: stock.lot_id,
                            quantity: stock.quantity_available ?? 1,
                            source_warehouse_company_id: stock.company_id,
                            source_warehouse_id: stock.warehouse_id,
                            source_location_id: stock.location_id
                        });
                        fs.form.refresh();
                    }
                }
            };
            fs.init();
        },
        blockStock () {
            const showResult = async (success)=>{
                if (success) {
                    this.loadPage();
                    fs.destroy();
                }
            };
            const sendRequest = async (data)=>{
                const qty = Number(data.quantity);
                const maxL = Number(data.qty_available_max || 0);
                if (!Number.isFinite(qty) || qty < 1) {
                    (0, $jUNyh.notify)("Informe uma quantidade v\xe1lida.", "Aten\xe7\xe3o");
                    return;
                }
                if (maxL > 0 && qty > maxL) {
                    (0, $jUNyh.notify)(`Quantidade n\xe3o pode exceder o dispon\xedvel (${maxL}).`, "Aten\xe7\xe3o");
                    return;
                }
                const mk = String(data.movement_kind || '').trim();
                if (!mk) {
                    (0, $jUNyh.notify)('Selecione a Natureza do bloqueio.', "Aten\xe7\xe3o");
                    return;
                }
                const reason = (0, $ec13f0e1663b8b62$export$d301f936562b4738)(mk);
                const params = {
                    source_company_id: data.source_warehouse_company_id,
                    source_warehouse_id: Number(data.source_warehouse_id),
                    source_location_id: Number(data.source_location_id),
                    source_stock: 'L',
                    target_company_id: data.target_warehouse_company_id,
                    target_warehouse_id: Number(data.target_warehouse_id),
                    target_location_id: Number(data.target_location_id),
                    target_stock: 'B',
                    quantity: qty,
                    reason: reason,
                    movement_kind: mk
                };
                await (0, $9VcS9.default).call((0, $9VcS9.default).move_stock, data.lot_company_id, data.lot_id, params).then(showResult);
            };
            const fs = (0, $h1m6J.default).create((0, $c8cd8707148527cd$export$2e2bcd8739ae039), sendRequest);
            const crud = this;
            const origInit = fs.init.bind(fs);
            fs.init = async function() {
                const sel = crud.getSelection();
                if (sel.length !== 1) {
                    (0, $jUNyh.notify)('Selecione exatamente uma linha de estoque.', "Aten\xe7\xe3o");
                    return;
                }
                // Seleção da grade: data-id é JSON [company_id, stock_id] — não é objeto { company_id, id }
                const tuple = sel[0];
                const company_id = Array.isArray(tuple) ? tuple[0] : tuple?.company_id;
                const stock_id = Array.isArray(tuple) ? tuple[1] : tuple?.id;
                if (company_id == null || stock_id == null) {
                    (0, $jUNyh.notify)("Sele\xe7\xe3o inv\xe1lida. Marque a caixa da linha e tente de novo.", "Aten\xe7\xe3o");
                    return;
                }
                const stock = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, company_id, stock_id);
                if (!stock) {
                    (0, $jUNyh.notify)("Estoque n\xe3o encontrado.", 'Erro');
                    return;
                }
                const q = Number(stock.quantity_available || 0);
                if (q < 1) {
                    (0, $jUNyh.notify)("N\xe3o h\xe1 quantidade dispon\xedvel (L) para bloquear nesta linha.", "Aten\xe7\xe3o");
                    return;
                }
                origInit();
                fs.form.setValues({
                    stock_sku: stock.sku ?? '',
                    lot_display: `${stock.lot_company_id} \xb7 lote ${stock.lot_id}`,
                    location_display: `Arm. ${stock.warehouse_id} \xb7 pos. ${stock.location_id}`,
                    movement_kind: 'BLOQ',
                    reason: (0, $ec13f0e1663b8b62$export$d301f936562b4738)('BLOQ'),
                    lot_company_id: stock.lot_company_id,
                    lot_id: stock.lot_id,
                    quantity: q,
                    qty_available_max: q,
                    source_warehouse_company_id: stock.company_id,
                    source_warehouse_id: stock.warehouse_id,
                    source_location_id: stock.location_id,
                    target_warehouse_company_id: stock.company_id,
                    target_warehouse_id: stock.warehouse_id,
                    target_location_id: stock.location_id
                });
                fs.form.refresh();
                (0, $ec13f0e1663b8b62$export$3a914ee0d3160d3f)(fs);
            };
            fs.init();
        },
        reportPayload (filterData, extra = {}) {
            const filterExpr = filterData ? (0, $hWQyW.translate)(filterData, null, this.fieldspecs) : '';
            const sortVal = this.sort_column * (this.sort_order ? -1 : 1);
            return {
                filter: filterExpr || undefined,
                sort: sortVal,
                ...extra
            };
        },
        openReportModal (title, apiMethod) {
            let reportFilter = null;
            const crud = this;
            const descriptor = {
                ...(0, $822dea3bdf7d9d14$export$2e2bcd8739ae039)
            };
            descriptor.html = descriptor.html.replace('<div class="title" id="report-title">Relat\xf3rio</div>', `<div class="title" id="report-title">${title}</div>`);
            const fs = (0, $h1m6J.default).create(descriptor, async (data)=>{
                fs.destroy();
                const payload = crud.reportPayload(reportFilter, {
                    format: data.format
                });
                try {
                    const json = await (0, $9VcS9.default).call(apiMethod, payload);
                    if (json?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(json.pdf);
                    else if (json?.csv) {
                        $b94ca141f2d5964b$var$downloadCsv(json.csv, json.filename || 'relatorio.csv');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else (0, $jUNyh.notify)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                const node = fs.dialog?.getNode?.();
                if (node) {
                    const btnFilters = node.querySelector('#btn-filters');
                    const summary = node.querySelector('#filter-summary');
                    const updateSummary = ()=>{
                        summary.textContent = reportFilter ? 'Filtros definidos' : 'Sem filtros (todos os registros)';
                    };
                    btnFilters?.addEventListener('click', async ()=>{
                        await crud.loadScopedLocations(reportFilter || crud.filter);
                        (0, $hWQyW.default).edit(async (data)=>{
                            reportFilter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, crud.fieldspecs);
                            await crud.loadScopedLocations(reportFilter);
                            updateSummary();
                        }, reportFilter, {
                            reloadLocations: async (formData)=>{
                                await crud.loadScopedLocations(formData);
                            }
                        });
                    });
                    updateSummary();
                }
            })();
        },
        printBySKU () {
            this.openReportModal('Estoque Consolidado por SKU', (0, $9VcS9.default).print_stocks_by_sku);
        },
        printByLot () {
            this.openReportModal('Estoque Consolidado por Lote', (0, $9VcS9.default).print_stocks_by_lot);
        },
        printByLocation () {
            this.openReportModal("Estoque Consolidado por Posi\xe7\xe3o", (0, $9VcS9.default).print_stocks_by_location);
        },
        printBalanceBlocks () {
            this.openReportModal('Bloqueios de saldo', (0, $9VcS9.default).print_stocks_balance_blocks);
        },
        exportCsv () {
            const fs = (0, $h1m6J.default).create((0, $f2e31d0f27d90986$export$2e2bcd8739ae039), async (data)=>{
                fs.destroy();
                const payload = {
                    company_id: data.company_id,
                    warehouse_id: data.warehouse_id ? Number(data.warehouse_id) : null,
                    program_id: data.program_id ? Number(data.program_id) : null,
                    class_name: data.class_name ? String(data.class_name).trim() : null
                };
                try {
                    const json = await (0, $9VcS9.default).call((0, $9VcS9.default).export_stocks_csv, payload);
                    if (json?.csv) {
                        $b94ca141f2d5964b$var$downloadCsv(json.csv, json.filename || 'estoque.csv');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        },
        printDurability () {
            const fs = (0, $h1m6J.default).create((0, $5d0e2de2f4bee2f9$export$2e2bcd8739ae039), async (data)=>{
                if (!data.company_id) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Aten\xe7\xe3o");
                    return false;
                }
                const payload = {
                    company_id: data.company_id,
                    warehouse_id: data.warehouse_id ? Number(data.warehouse_id) : null,
                    program_id: data.program_id ? Number(data.program_id) : null,
                    only_negative: Boolean(data?.only_negative)
                };
                try {
                    const json = await (0, $9VcS9.default).call((0, $9VcS9.default).print_stock_durability, payload);
                    if (json?.xlsx) {
                        $b94ca141f2d5964b$var$downloadBase64File(json.xlsx, json.filename || 'durabilidade-estoque.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        (0, $jUNyh.notify)('Download do Excel iniciado.', 'Sucesso');
                        fs.destroy();
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
                return false;
            });
            fs.init();
        },
        skuNoOutput () {
            const fs = (0, $h1m6J.default).create((0, $c35a1f71a10bd4ea$export$2e2bcd8739ae039), async (data)=>{
                const companyId = data.company_id;
                if (!companyId) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Aten\xe7\xe3o");
                    return false;
                }
                const dateFrom = data.date_from;
                const dateTo = data.date_to;
                if (!dateFrom || !dateTo) {
                    (0, $jUNyh.notify)("Informe o per\xedodo (De e At\xe9).", "Aten\xe7\xe3o");
                    return false;
                }
                if (dateTo < dateFrom) {
                    (0, $jUNyh.notify)('A data "At\xe9" deve ser igual ou posterior \xe0 data "De".', "Aten\xe7\xe3o");
                    return false;
                }
                fs.destroy();
                try {
                    // Busca em tela (JSON) e exibe tabela em modal; também oferece CSV.
                    const respJson = await (0, $9VcS9.default).sku_no_output_report(companyId, {
                        format: 'json',
                        date_from: dateFrom,
                        date_to: dateTo,
                        warehouse_id: data.warehouse_id || undefined,
                        limit: 500,
                        offset: 0
                    });
                    if (!respJson.ok) {
                        const err = await respJson.json().catch(()=>({}));
                        (0, $jUNyh.notify)(err?.error || 'Erro ao consultar.', 'Erro');
                        return;
                    }
                    const rows = await respJson.json();
                    if (!rows || rows.length === 0) {
                        (0, $jUNyh.notify)("Nenhum produto sem sa\xedda neste per\xedodo e filtros.", 'Resultado');
                        return;
                    }
                    const esc = (s)=>String(s ?? '').replace(/[&<>"']/g, (ch)=>({
                                '&': '&amp;',
                                '<': '&lt;',
                                '>': '&gt;',
                                '"': '&quot;',
                                "'": '&#39;'
                            })[ch]);
                    const fmtCusto = (v)=>{
                        if (v == null || v === '') return "\u2014";
                        const n = Number(v);
                        if (!Number.isFinite(n)) return esc(v);
                        return n.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 4
                        });
                    };
                    const tbody = rows.map((r)=>`
						<tr>
							<td>${esc(r.sku) || "\u2014"}</td>
							<td>${esc(r.produto) || "\u2014"}</td>
							<td>${esc(r.unidade) || "\u2014"}</td>
							<td>${esc(r.programa) || "\u2014"}</td>
							<td>${esc(r.lote) || "\u2014"}</td>
							<td class="tac">${esc(r.validade) || "\u2014"}</td>
							<td class="tar">${r.estoque_total ?? "\u2014"}</td>
							<td class="tar">${fmtCusto(r.custo_unitario)}</td>
							<td class="tac">${esc(r.ultima_saida) || 'Nunca'}</td>
						</tr>`).join('');
                    const total = rows.length;
                    const avisoMais = total >= 500 ? `<p class="fss" style="color:var(--color-muted)">Exibindo os primeiros 500 registros. Exporte o CSV para ver todos.</p>` : '';
                    const html = `
						<div class="msgbox" style="max-width:90vw;overflow:auto">
							<div class="mb-title">SKUs sem Sa\xedda \u{2014} ${esc(dateFrom)} a ${esc(dateTo)} (${total} linha${total !== 1 ? 's' : ''})</div>
							${avisoMais}
							<div style="max-height:60vh;overflow:auto">
								<table class="fsx bp" style="min-width:960px">
									<thead><tr>
										<th>SKU</th><th>Produto</th><th>Unidade</th>
										<th>Programa</th><th>Lote</th><th class="tac">Validade</th>
										<th class="tar">Estoque</th><th class="tar">Custo unit.</th>
										<th class="tac">\xdaltima Sa\xedda</th>
									</tr></thead>
									<tbody>${tbody}</tbody>
								</table>
							</div>
							<div class="fsb mtm">
								<button type="button" class="button" id="btn-snor-csv">Exportar CSV</button>
								<button type="button" class="button bn_N">Fechar</button>
							</div>
						</div>`;
                    const { default: dialog } = await Promise.resolve((parcelRequire("dx9qz")));
                    const dlg = dialog.create(html, (key)=>{
                        if (key === 'N' || key === 'Escape') dlg.destroy();
                    }, /N|Escape/);
                    // Botão exportar CSV
                    dlg.getNode().querySelector('#btn-snor-csv')?.addEventListener('click', async ()=>{
                        try {
                            const respCsv = await (0, $9VcS9.default).sku_no_output_report(companyId, {
                                format: 'csv',
                                date_from: dateFrom,
                                date_to: dateTo,
                                warehouse_id: data.warehouse_id || undefined
                            });
                            if (!respCsv.ok) {
                                const err2 = await respCsv.json().catch(()=>({}));
                                (0, $jUNyh.notify)(err2?.error || 'Erro ao gerar CSV.', 'Erro');
                                return;
                            }
                            const result = await respCsv.json();
                            if (result?.csv) {
                                $b94ca141f2d5964b$var$downloadCsv(result.csv, result.filename || 'skus-sem-saida.csv');
                                (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                            } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                        } catch (e) {
                            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                        }
                    });
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        },
        outputPurchaseReport () {
            const fs = (0, $h1m6J.default).create((0, $5fe4dde45e4cd989$export$2e2bcd8739ae039), async (data)=>{
                const companyId = data.company_id;
                if (!companyId) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Aten\xe7\xe3o");
                    return false;
                }
                const dateFrom = data.date_from;
                const dateTo = data.date_to;
                if (!dateFrom || !dateTo) {
                    (0, $jUNyh.notify)("Informe o per\xedodo (De e At\xe9).", "Aten\xe7\xe3o");
                    return false;
                }
                if (dateTo < dateFrom) {
                    (0, $jUNyh.notify)('A data "At\xe9" deve ser igual ou posterior \xe0 data "De".', "Aten\xe7\xe3o");
                    return false;
                }
                fs.destroy();
                try {
                    const resp = await (0, $9VcS9.default).output_purchase_report(companyId, {
                        date_from: dateFrom,
                        date_to: dateTo,
                        warehouse_id: data.warehouse_id || undefined
                    });
                    if (!resp.ok) {
                        const err = await resp.json().catch(()=>({}));
                        (0, $jUNyh.notify)(err?.error || 'Erro ao exportar.', 'Erro');
                        return;
                    }
                    const json = await resp.json();
                    if (json?.csv) {
                        $b94ca141f2d5964b$var$downloadCsv(json.csv, json.filename || 'saidas-compras.csv');
                        (0, $jUNyh.notify)(`Download iniciado (${json.rows ?? ''} linha(s)).`, 'Sucesso');
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        },
        printLotLabels () {
            if (!this.ensureSelection('Etiquetas de Lote')) return;
            const sendRequest = async (data)=>{
                const device_id = (0, $aGGTj.resolvePrinterDeviceId)(data.device_id, '#stocks-select-printer #device_id');
                if (device_id == null) {
                    (0, $jUNyh.notify)("Selecione a impressora na lista (clique na op\xe7\xe3o; s\xf3 o texto no campo n\xe3o basta).", "Aten\xe7\xe3o");
                    return false;
                }
                const selected = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (!selected.length) {
                    (0, $jUNyh.notify)('Selecione ao menos um estoque na grade antes de continuar.', 'Etiquetas de Lote');
                    return false;
                }
                const payload = {
                    company_id: data.company_id,
                    device_id: device_id,
                    ids: (0, $aGGTj.splitIdsByCompany)(selected),
                    return_zpl: !!data.use_local_agent
                };
                let lc = parseInt(String(data.label_copies ?? '1'), 10);
                if (!Number.isFinite(lc) || lc < 1) lc = 1;
                if (lc > 200) lc = 200;
                payload.label_copies = lc;
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).print_lot_labels, payload);
                if (result?.zpl) try {
                    await (0, $9VcS9.default).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $jUNyh.notify)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            let fs = (0, $h1m6J.default).create((0, $66f0ec4106475d51$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        }
    });
    // Ordem = colunas da grade (alinhado a js/views/stocks.js). Índice = posição 1-based no SELECT SQL_LIST_BY_CREDENTIAL_ENRICHED (src/repos/stocks.py); «Programa» = coluna 23 (program_name), não 22 (program_id). Coluna 32 extra: `warehouse_name` (só API / introspect; não usada nos fieldspecs da grade).
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Estoque',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do estoque'
        },
        {
            index: 12,
            field: 'sku',
            label: 'SKU',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'SKU do produto'
        },
        {
            index: 13,
            field: 'product_name',
            label: 'Produto',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome/taxonomia do produto'
        },
        {
            index: 15,
            field: 'manufacturer_nick',
            label: 'Fabricante',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Com embalagem no lote: fabricante GTIN da embalagem; sem embalagem cadastrada: fabricante legado do produto'
        },
        {
            index: 16,
            field: 'ncm',
            label: 'NCM',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'NCM do produto'
        },
        {
            index: 17,
            field: 'gtin',
            label: 'EAN',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'GTIN/EAN da embalagem do lote (sem GTIN na embalagem: cadastro do produto)'
        },
        {
            index: 18,
            field: 'codigo_cliente',
            label: "C\xf3d. cliente",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo do cliente no produto"
        },
        {
            index: 19,
            field: 'packaging_code',
            label: 'Embalagem',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo da embalagem padr\xe3o do produto"
        },
        {
            index: 20,
            field: 'packaging_factor',
            label: 'Fator Emb.',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: "Fator da embalagem padr\xe3o"
        },
        {
            index: 21,
            field: 'packaging_qr_code',
            label: 'QR Emb.',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "QR code da embalagem padr\xe3o"
        },
        {
            index: 23,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa do lote',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 24,
            field: 'lot_number',
            label: 'Lote fab.',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "N\xfamero do lote fabricante"
        },
        {
            index: 26,
            field: 'expiration_date',
            label: 'Validade',
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: 'Data de validade do lote'
        },
        {
            index: 25,
            field: 'manufacture_date',
            label: "Fabrica\xe7\xe3o",
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: "Data de fabrica\xe7\xe3o do lote"
        },
        {
            index: 28,
            field: 'input_created_on',
            label: 'Data Entrada',
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: 'Data da entrada referente ao lote'
        },
        {
            index: 27,
            field: 'input_id',
            label: 'Entrada Sial',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: "N\xfamero da entrada SIAL referente ao lote"
        },
        {
            index: 29,
            field: 'invoice_number',
            label: 'Nota Entrada',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "N\xfamero da nota de entrada"
        },
        {
            index: 30,
            field: 'supplier_name',
            label: 'Fornecedor',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Apelido do fornecedor da entrada'
        },
        {
            index: 39,
            field: 'supplier_legal_name',
            label: 'Fornecedor (nome)',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Nome / raz\xe3o social do fornecedor da entrada"
        },
        {
            index: 3,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m do estoque",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o no armaz\xe9m",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 5,
            field: 'lot_company_id',
            label: 'Titular',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Titular do lote',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 6,
            field: 'lot_id',
            label: 'Lote',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 7,
            field: 'quantity_available',
            label: "Dispon\xedvel",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade dispon\xedvel"
        },
        {
            index: 8,
            field: 'quantity_reserved',
            label: 'Reservado',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade reservada'
        },
        {
            index: 9,
            field: 'quantity_unsettled',
            label: 'Bloqueado',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade sob an\xe1lise"
        },
        {
            index: 37,
            field: 'unit_price',
            label: 'Valor unit.',
            types: [
                $3eqAU.default(4, 2)
            ],
            placeholder: '0,0000',
            title: "Valor unit\xe1rio m\xe9dio do item no pedido de entrada"
        },
        {
            index: 38,
            field: 'total_value',
            label: 'Valor total',
            types: [
                $3eqAU.default(2, 2)
            ],
            placeholder: '0,00',
            title: "Valor unit\xe1rio x quantidade dispon\xedvel"
        },
        {
            index: 10,
            field: 'status',
            label: 'Status',
            types: [
                $c539c39a88864005$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status do estoque'
        },
        {
            index: 33,
            field: 'classes',
            label: 'Classes',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Classes do produto (separadas por ;)'
        },
        {
            index: 34,
            field: 'categoria',
            label: 'Categoria',
            types: [
                $74yTJ.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Categoria do produto',
            store: 'categories',
            labels: [
                'name'
            ]
        },
        {
            index: 35,
            field: 'is_portaria_344',
            label: 'Portaria 344',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: "Produto sujeito \xe0 Portaria 344/98"
        }
    ];
    let operations = [
        {
            hash: '#move-stock',
            label: 'Mover&nbsp;estoque'
        },
        {
            hash: '#block-stock',
            label: 'Bloquear&nbsp;estoque'
        }
    ];
    let reports = [
        {
            hash: '#print-by-sku',
            label: 'Estoque&nbsp;Consolidado&nbsp;por&nbsp;SKU'
        },
        {
            hash: '#print-by-lot',
            label: 'Estoque&nbsp;Consolidado&nbsp;por&nbsp;Lote'
        },
        {
            hash: '#print-by-location',
            label: "Estoque&nbsp;Consolidado&nbsp;por&nbsp;Posi\xe7\xe3o"
        },
        {
            hash: '#print-balance-blocks',
            label: 'Bloqueios&nbsp;de&nbsp;saldo'
        },
        {
            hash: '#export-csv',
            label: "Exportar&nbsp;CSV&nbsp;(Relat\xf3rio&nbsp;Completo)"
        },
        {
            hash: '#print-durability',
            label: 'Durabilidade&nbsp;de&nbsp;Estoque&nbsp;(Excel)'
        },
        {
            hash: '#lot-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Lotes'
        },
        {
            hash: '#sku-no-output',
            label: "SKUs&nbsp;sem&nbsp;Sa\xedda&nbsp;(Per\xedodo)"
        },
        {
            hash: '#output-purchase',
            label: "Sa\xeddas&nbsp;para&nbsp;Compras&nbsp;(CSV)"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#move-stock', stocks_crud.moveStock.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#block-stock', stocks_crud.blockStock.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-sku', stocks_crud.printBySKU.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-lot', stocks_crud.printByLot.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-location', stocks_crud.printByLocation.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-balance-blocks', stocks_crud.printBalanceBlocks.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-csv', stocks_crud.exportCsv.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-durability', stocks_crud.printDurability.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#lot-labels', stocks_crud.printLotLabels.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sku-no-output', stocks_crud.skuNoOutput.bind(stocks_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#output-purchase', stocks_crud.outputPurchaseReport.bind(stocks_crud));
    stocks_crud.run('stocks', 'Estoques', document.getElementById('workarea'), (0, $82e5a54bae0b2474$export$2e2bcd8739ae039), (0, $c45260a54a668287$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $b94ca141f2d5964b$export$2e2bcd8739ae039 = $b94ca141f2d5964b$var$stocks;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $aGGTj = parcelRequire("aGGTj");

var $hWQyW = parcelRequire("hWQyW");



var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");

var $b60a2 = parcelRequire("b60a2");










var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $74yTJ = parcelRequire("74yTJ");
var $37672c13343edbe6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sm-lot-meta #lot_number { width: 14rem; }
			#sm-lot-meta #manufacture_date, #sm-lot-meta #expiration_date { width: 10rem; }
			#sm-lot-meta #program_id { width: 18rem; }
			#sm-lot-meta #selected_rows_preview, #sm-lot-meta #selected_lots_preview { width: 40rem; max-width: 100%; }
			#sm-lot-meta #sm-lot-scope-box { max-width: 40rem; }
		</style>
		<form id="sm-lot-meta" class="form" autocomplete="off">
			<div class="title">Lote / datas / programa</div>
			<p id="sm-lot-hint" class="mts muted" style="max-width:40rem"></p>
			<div class="fsb">
				<label>Linhas selecionadas (SKU \xb7 lote fab. \xb7 posi\xe7\xe3o)
					<textarea id="selected_rows_preview" rows="3" disabled></textarea>
				</label>
				<label>Alcance por SKU + lote fab.
					<textarea id="selected_lots_preview" rows="3" disabled></textarea>
				</label>
			</div>
			<div id="sm-lot-scope-box" class="mtm" style="display:none">
				<label class="fsb" style="align-items:flex-start;gap:0.5rem;cursor:pointer">
					<input id="only_selected_lines" type="checkbox" style="margin-top:0.2rem">
					<span><strong>Alterar somente nas linhas selecionadas</strong> \u{2014} o sistema cria um lote interno separado automaticamente quando o mesmo SKU e lote fab. existem em outros paletes (voc\xea n\xe3o precisa informar identificador t\xe9cnico).</span>
				</label>
			</div>
			<div class="fsb mtl">
				<label>Lote fab.
					<input id="lot_number" type="text" placeholder="Deixe em branco para n\xe3o alterar">
				</label>
				<label>Fabrica\xe7\xe3o
					<input id="manufacture_date" type="text" placeholder="aaaa-mm-dd">
				</label>
				<label>Validade
					<input id="expiration_date" type="text" placeholder="aaaa-mm-dd">
				</label>
				<label title="Programas da mesma empresa das linhas selecionadas">Programa
					<input id="program_id" type="text" list="programs_list" placeholder="Selecione o programa">
				</label>
			</div>
			<datalist id="programs_list"></datalist>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Aplicar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sm-lot-meta',
        /** Empresa das linhas — preenchida pelo Gerenciamento antes do init. */ _programsCompanyId: null,
        init (formset) {
            formset.form.eraseValues();
            const companyId = this._programsCompanyId;
            if (companyId) formset.loadList('#programs_list', 'programs', {
                labels: [
                    'name'
                ],
                value: 'id',
                range: IDBKeyRange.bound([
                    companyId,
                    ''
                ], [
                    companyId,
                    '\uffff'
                ]),
                index: 2
            });
            else {
                const node = document.querySelector(`${this.selector} #programs_list`);
                if (node) node.innerHTML = '';
            }
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#selected_rows_preview'
            },
            types: []
        },
        {
            properties: {
                selector: '#selected_lots_preview'
            },
            types: []
        },
        {
            properties: {
                selector: '#only_selected_lines'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#lot_number'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#manufacture_date'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#expiration_date'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $9PIz7.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $3d2aece5aad0127d$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sm-packaging .pkg-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.35rem 1.25rem; max-width: 42rem; }
			#sm-packaging .pkg-grid label { display: flex; flex-direction: column; font-size: 0.9rem; }
			#sm-packaging .pkg-grid input[readonly] { background: #f4f4f4; color: #333; }
			#sm-packaging #product_packaging_id { width: 22rem; }
			#sm-packaging #reason { width: 100%; max-width: 42rem; }
			#sm-packaging #pkg_preview { margin-top: 0.5rem; padding: 0.5rem 0.75rem; background: #f8f8f8; border: 1px solid #ddd; max-width: 42rem; font-size: 0.9rem; }
		</style>
		<form id="sm-packaging" class="form" autocomplete="off">
			<div class="title">Corrigir embalagem do lote</div>
			<p class="mts muted" style="max-width:42rem">
				Use apenas para corrigir embalagem cadastrada incorretamente no lote.
				Esta opera\xe7\xe3o <strong>n\xe3o converte</strong> quantidade f\xedsica de estoque.
			</p>
			<div class="pkg-grid mtl">
				<label>Produto<input id="pkg_product_name" type="text" readonly tabindex="-1"></label>
				<label>Lote (fab.)<input id="pkg_lot_number" type="text" readonly tabindex="-1"></label>
				<label>ID lote SIAL<input id="pkg_lot_id" type="text" readonly tabindex="-1"></label>
				<label>Validade<input id="pkg_expiration" type="text" readonly tabindex="-1"></label>
				<label>Posi\xe7\xe3o<input id="pkg_location" type="text" readonly tabindex="-1"></label>
				<label>Embalagem atual<input id="pkg_current_code" type="text" readonly tabindex="-1"></label>
				<label>Fator atual<input id="pkg_current_factor" type="text" readonly tabindex="-1"></label>
				<label>Saldo total (un.)<input id="pkg_total" type="text" readonly tabindex="-1"></label>
				<label>Dispon\xedvel<input id="pkg_available" type="text" readonly tabindex="-1"></label>
				<label>Reservado<input id="pkg_reserved" type="text" readonly tabindex="-1"></label>
				<label>Bloqueado<input id="pkg_blocked" type="text" readonly tabindex="-1"></label>
			</div>
			<div class="fsb mtl">
				<label>Embalagem de destino<sup>*</sup>
					<input id="product_packaging_id" type="text" list="sm_pkg_list" required placeholder="Escolha na lista">
				</label>
			</div>
			<div id="pkg_preview" class="muted">Selecione a embalagem de destino para ver a pr\xe9via.</div>
			<div class="fsb mtl">
				<label>Justificativa<sup>*</sup>
					<input id="reason" type="text" required minlength="10" maxlength="500" placeholder="Explique o motivo da corre\xe7\xe3o (m\xedn. 10 caracteres, texto objetivo)">
				</label>
			</div>
			<datalist id="sm_pkg_list"></datalist>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Aplicar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sm-packaging',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#product_packaging_id'
            },
            types: [
                $3eqAU.default(0, 2),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $3OKkn = parcelRequire("3OKkn");
var $f39b52413448534f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sm-bulk-move .company { width: 11rem; }
			#sm-bulk-move .warehouse { width: 10rem; }
			#sm-bulk-move .location { width: 10rem; }
			#sm-bulk-move #movement_kind { width: 20rem; }
			#sm-bulk-move #reason { width: 22rem; }
		</style>
		<form id="sm-bulk-move" class="form" autocomplete="off">
			<datalist id="sm-bm-companies"></datalist>
			<datalist id="sm-bm-warehouses-t"></datalist>
			<datalist id="sm-bm-locations-t"></datalist>
			<div class="title">Movimentar sele\xe7\xe3o</div>
			<p class="mts muted" style="max-width:40rem">Para cada linha selecionada, move a quantidade do tipo de origem escolhido (dispon\xedvel ou bloqueado) para o destino informado. Saldo <strong>reservado n\xe3o pode ser movimentado</strong>.</p>
			<div class="fsb mtl">
				<label>De (origem)<sup>*</sup>
					<select id="source_stock" required>
						<option value="L">Dispon\xedvel</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
				<label>Para (destino)<sup>*</sup>
					<select id="target_stock" required>
						<option value="L">Dispon\xedvel</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
				<span></span>
			</div>
			<div class="fsb mtm">
				<label>Empresa destino<sup>*</sup>
					<input id="target_warehouse_company_id" class="company" type="text" list="sm-bm-companies" required>
				</label>
				<label>Armaz\xe9m destino<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="sm-bm-warehouses-t" required>
				</label>
				<label>Posi\xe7\xe3o destino<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="sm-bm-locations-t" required placeholder="Lista do armaz\xe9m; busca respeita mai\xfasculas/min\xfasculas" title="Ap\xf3s escolher empresa e armaz\xe9m, liste ou pesquise o endere\xe7o (S-1 \u{2260} s-1).">
				</label>
			</div>
			<div class="fsb mtm">
				<label>Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
				<label>Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sm-bulk-move',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#sm-bm-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#source_stock'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '#target_stock'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('target_warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#target_location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default({
                    caseSensitive: true
                }),
                $6lTH5.default([
                    'target_warehouse_company_id',
                    'target_warehouse_id'
                ]),
                $f0a98998622cf31a$export$2e2bcd8739ae039({
                    companyKey: 'target_warehouse_company_id',
                    warehouseKey: 'target_warehouse_id'
                })
            ]
        },
        {
            properties: {
                selector: '#movement_kind'
            },
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");

var $e33b3e6660ce1b3d$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sm-reason #movement_kind { width: 20rem; }
			#sm-reason #reason { width: 28rem; background: #f3f4f6; cursor: default; }
		</style>
		<form id="sm-reason" class="form" autocomplete="off">
			<div class="title">Motivo da opera\xe7\xe3o</div>
			<p class="mts muted" style="max-width:36rem">O <strong>Motivo</strong> \xe9 preenchido automaticamente pela <strong>Natureza</strong> (n\xe3o \xe9 texto livre). APIs e relat\xf3rios continuam recebendo o campo Motivo.</p>
			<div class="fsb mtl">
				<label>Natureza<sup>*</sup>
					<input id="movement_kind" type="text" list="movement_kind_list" required>
				</label>
				<label title="Espelho da Natureza (somente leitura)">Motivo
					<input id="reason" type="text" readonly tabindex="-1" placeholder="Preenchido automaticamente pela Natureza">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Confirmar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sm-reason',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
            (0, $ec13f0e1663b8b62$export$4fe6c6811c9e5a0c)(formset);
        }
    },
    fields: [
        {
            properties: {
                selector: '#movement_kind'
            },
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        }
    ]
};



var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $93853730b74ba85e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sm-split #stock_sku { width: 12rem; }
			#sm-split #quantity_first { width: 8rem; text-align: right; }
			#sm-split #stock_id, #sm-split #lot_ref { width: 11rem; }
			#sm-split #product_name {
				width: min(100%, 42rem);
				min-height: 2.6rem;
				resize: vertical;
				font-weight: 600;
			}
			#sm-split #manufacturer_nick,
			#sm-split #program_name { width: 14rem; }
			#sm-split #lot_number, #sm-split #expiration_date { width: 11rem; }
			#sm-split .sm-split-product-block { max-width: 46rem; }
		</style>
		<form id="sm-split" class="form" autocomplete="off">
			<div class="title">Dividir linha de estoque</div>
			<p class="mts muted" style="max-width:46rem">Exige reserva e bloqueio zerados. Informe a quantidade que permanece na linha atual; o restante gera uma nova linha na mesma posi\xe7\xe3o/lote.</p>
			<div class="fsb mtl sm-split-product-block">
				<label title="Nome completo do produto (n\xe3o truncado)">Produto
					<textarea id="product_name" rows="2" disabled></textarea>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Fabricante">Fabricante
					<input id="manufacturer_nick" type="text" disabled>
				</label>
				<label title="Programa do lote">Programa
					<input id="program_name" type="text" disabled>
				</label>
				<label title="Lote do fabricante">Lote fab.
					<input id="lot_number" type="text" disabled>
				</label>
				<label title="Data de validade do lote">Validade
					<input id="expiration_date" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm">
				<label>Estoque ID
					<input id="stock_id" type="text" disabled>
				</label>
				<label>Lote atual
					<input id="lot_ref" type="text" disabled>
				</label>
				<label>SKU
					<input id="stock_sku" type="text" disabled>
				</label>
				<label>Dispon\xedvel (atual)
					<input id="qty_available" type="text" disabled>
				</label>
				<label>Qtde na linha atual ap\xf3s split<sup>*</sup>
					<input id="quantity_first" type="text" required>
				</label>
			</div>
			<div class="mtm">
				<label style="display:flex;align-items:flex-start;gap:0.45rem;max-width:46rem">
					<input id="isolate_new_lot" type="checkbox" style="margin-top:0.15rem">
					<span>Criar <strong>lote independente</strong> para a linha nova (recomendado quando voc\xea quer editar lote/data/programa apenas na linha splitada, sem impactar a linha original).</span>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Dividir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sm-split',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#product_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#manufacturer_nick'
            },
            types: []
        },
        {
            properties: {
                selector: '#program_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#lot_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#expiration_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#lot_ref'
            },
            types: []
        },
        {
            properties: {
                selector: '#stock_sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#qty_available'
            },
            types: []
        },
        {
            properties: {
                selector: '#isolate_new_lot'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#quantity_first'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $295d1e840d9d5714$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#sm-unit #product_sku { width: 14rem; }
			#sm-unit #selling_unit_id { width: 16rem; }
		</style>
		<form id="sm-unit" class="form" autocomplete="off">
			<div class="title">Unidade de medida (produto)</div>
			<p class="mts muted" style="max-width:36rem">Altera a UM de venda/cadastro do produto (PATCH no produto titular). Use com crit\xe9rio operacional/fiscal.</p>
			<div class="fsb mtl">
				<label>SKU
					<input id="product_sku" type="text" disabled>
				</label>
				<label>Unidade<sup>*</sup>
					<input id="selling_unit_id" type="text" list="units_list" required>
				</label>
			</div>
			<datalist id="units_list"></datalist>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#sm-unit',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#units_list', 'units', {
                labels: [
                    'name'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#product_sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#selling_unit_id'
            },
            types: [
                $3eqAU.default(0, 2),
                $9PIz7.default()
            ]
        }
    ]
};



var $7WMRl = parcelRequire("7WMRl");



var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
function $5595bfa8ce07cb50$var$downloadCsv(base64Content, filename) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: 'text/csv;charset=utf-8'
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'relatorio.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
/** Evita duplo clique em «Sim» (bloquear/desbloquear/mover em lote) disparando 2× a API. */ let $5595bfa8ce07cb50$var$_smBulkActionInFlight = false;
const $5595bfa8ce07cb50$var$_PKG_GENERIC_TOKENS = new Set([
    'teste',
    'test',
    'ajuste',
    "corre\xe7\xe3o",
    'correcao',
    'corrigir',
    'ok',
    'n/a',
    'na',
    'xxx'
]);
/**
 * Valida justificativa da correção de embalagem (espelha POP / API).
 * @param {string} reason
 * @returns {string|null} mensagem de erro ou null se ok
 */ function $5595bfa8ce07cb50$var$sm_validate_packaging_reason(reason) {
    const text = String(reason || '').trim();
    if (text.length < 10) return "Informe a justificativa da corre\xe7\xe3o de embalagem (m\xednimo 10 caracteres).";
    const words = text.split(/\s+/).filter(Boolean);
    if (words.length < 2) return "Justificativa muito curta: descreva o motivo da corre\xe7\xe3o com mais detalhe.";
    const low = text.toLowerCase();
    if ($5595bfa8ce07cb50$var$_PKG_GENERIC_TOKENS.has(low)) return "Justificativa gen\xe9rica n\xe3o aceita: descreva o motivo operacional da corre\xe7\xe3o.";
    if (new Set(text).size <= 2) return "Justificativa gen\xe9rica n\xe3o aceita: descreva o motivo operacional da corre\xe7\xe3o.";
    if (words.every((w)=>$5595bfa8ce07cb50$var$_PKG_GENERIC_TOKENS.has(w.toLowerCase().replace(/[.,;:!?]+$/g, '')))) return "Justificativa gen\xe9rica n\xe3o aceita: descreva o motivo operacional da corre\xe7\xe3o.";
    return null;
}
/** Agrega contexto de conferência para o modal de correção de embalagem. */ function $5595bfa8ce07cb50$var$sm_packaging_context(rows) {
    let total = 0;
    let avail = 0;
    let res = 0;
    let block = 0;
    const lots = new Map();
    const locs = new Set();
    for (const s of rows){
        const a = Number(s.quantity_available) || 0;
        const r = Number(s.quantity_reserved) || 0;
        const b = Number(s.quantity_unsettled) || 0;
        total += a + r + b;
        avail += a;
        res += r;
        block += b;
        const k = `${s.lot_company_id}|${s.lot_id}`;
        if (!lots.has(k)) lots.set(k, s);
        if (s.warehouse_id != null && s.location_id != null) locs.add(`${s.warehouse_id}-${s.location_id}`);
    }
    return {
        first: rows[0],
        lots: [
            ...lots.values()
        ],
        total: total,
        avail: avail,
        res: res,
        block: block,
        locs: [
            ...locs
        ]
    };
}
async function $5595bfa8ce07cb50$var$sm_load_selected_stocks(crud) {
    const raw = crud.getSelection();
    if (!raw?.length) {
        (0, $jUNyh.notify)("Marque as linhas desejadas na grade (checkbox). A opera\xe7\xe3o n\xe3o usa a p\xe1gina inteira.", "Aten\xe7\xe3o");
        return null;
    }
    const out = [];
    const seen = new Set();
    for (const entry of raw){
        let row = entry;
        if (typeof row === 'string') try {
            row = JSON.parse(row);
        } catch (_) {
            continue;
        }
        const company_id = Array.isArray(row) ? row[0] : row?.company_id;
        const stock_id = Array.isArray(row) ? row[1] : row?.id;
        if (company_id == null || stock_id == null) continue;
        const k = `${company_id}::${stock_id}`;
        if (seen.has(k)) continue;
        seen.add(k);
        const s = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, company_id, stock_id);
        if (s) out.push(s);
    }
    return out.length ? out : null;
}
/** Rótulo operacional: SKU + lote fab. + posição (sem lot_id interno). */ function $5595bfa8ce07cb50$var$sm_stock_line_label(r) {
    const sku = r?.sku ?? '';
    const lot = (0, $aGGTj.formatLotNumber)(r?.lot_number) || r?.lot_number || "\u2014";
    const pos = r?.location_address || `${r?.warehouse_id ?? '?'}-${r?.location_id ?? '?'}`;
    return `SKU ${sku} \xb7 Lote ${lot} \xb7 Posi\xe7\xe3o ${pos}`;
}
function $5595bfa8ce07cb50$var$sm_lot_group_label(g) {
    const sku = g?.sku ?? '';
    const lot = (0, $aGGTj.formatLotNumber)(g?.lot_number) || g?.lot_number || "\u2014";
    return `SKU ${sku} \xb7 Lote ${lot}`;
}
/** Posição destino: id numérico ou endereço digitado (busca case-sensitive na API). */ async function $5595bfa8ce07cb50$var$sm_resolve_target_location_id(data) {
    let locId = Number(data.target_location_id);
    if (Number.isInteger(locId) && locId >= 1) return locId;
    const companyId = await (0, $7WMRl.resolveCompanyId)(data.target_warehouse_company_id) || data.target_warehouse_company_id;
    const wh = await (0, $7WMRl.resolveWarehouseId)(companyId, data.target_warehouse_id);
    locId = await (0, $7WMRl.resolveLocationIdForMove)(companyId, wh, data.target_location_id);
    return Number.isInteger(locId) && locId >= 1 ? locId : NaN;
}
const $5595bfa8ce07cb50$var$stock_management = function() {
    let sm_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        default_columns: '1,2,12,13,15,16,17,18,19,20,21,22,24,26,25,28,27,29,30,3,4,5,6,7,8,9,37,38,39,10',
        insertRecord () {
        // Tela de estoque é somente consulta; criação/alteração é feita por entradas, movimentação e inventário
        },
        /**
		 * Operações exigem recorte definido: expressão de filtro da API, critérios no formulário,
		 * ou grade já carregada após «Aplicar» (evita falso negativo quando translate() não reproduz o critério).
		 */ smHasActiveFilter () {
            const data = this.filter || {};
            if ((0, $hWQyW.translate)(data, null, this.fieldspecs)) return true;
            const top = (0, $b60a2.getTopIndex)(data) + 1;
            for(let i = 0; i < top; i++){
                const f = data[`field-${i}`];
                const v = data[`value-${i}`];
                if (f && v != null && String(v).trim() !== '') return true;
            }
            return !!(this.filterExplicitlyApplied && this.record_count > 0);
        },
        smNotifyFilterRequired () {
            (0, $jUNyh.notify)("As a\xe7\xf5es de Opera\xe7\xf5es s\xf3 podem ser usadas depois de Filtrar e Aplicar (com ou sem crit\xe9rios). Trabalhe sempre sobre o recorte vis\xedvel na grade.", "Aten\xe7\xe3o");
        },
        /**
		 * @param {string} title
		 * @param {string} message
		 * @param {() => void | Promise<void>} fn
		 */ smWithFilterAndConfirm (title, message, fn) {
            if (!this.smHasActiveFilter()) {
                this.smNotifyFilterRequired();
                return;
            }
            const self = this;
            (0, $jUNyh.ask)(message, title, (key)=>{
                if (key !== 'Y') return;
                Promise.resolve(fn.call(self)).catch((e)=>console.error(e));
            });
        },
        async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options = {}) {
            // Grade: alinhar colunas/checkboxes (v2=fabricante; v3=ordem/índices + coluna cód. cliente).
            try {
                const raw = localStorage.getItem('stock-management.setup');
                if (raw) {
                    const s = JSON.parse(raw);
                    let touch = false;
                    if (!s.sm_stocks_grid_v2) {
                        s.columns = this.default_columns;
                        s.sm_stocks_grid_v2 = true;
                        touch = true;
                    }
                    if (!s.sm_stocks_grid_v3) {
                        s.columns = this.default_columns;
                        s.sm_stocks_grid_v3 = true;
                        touch = true;
                    }
                    if (!s.sm_stocks_grid_v4_classes) {
                        s.sm_stocks_grid_v4_classes = true;
                        touch = true;
                    }
                    if (!s.sm_stocks_grid_v5_categoria) {
                        s.sm_stocks_grid_v5_categoria = true;
                        touch = true;
                    }
                    if (!s.sm_stocks_grid_v6_values) {
                        s.columns = this.default_columns;
                        s.sm_stocks_grid_v6_values = true;
                        touch = true;
                    }
                    if (touch) localStorage.setItem('stock-management.setup', JSON.stringify(s));
                }
            } catch (_) {}
            await Object.getPrototypeOf(this).run.call(this, module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, {
                ...options,
                skipInitialLoad: true
            });
            // Ocultar Inserir (tela somente consulta)
            const insertLi = this.target_node?.querySelector?.('li[hash="#insert"]');
            if (insertLi) insertLi.style.display = 'none';
            // #MT-FD0B172 — Configurar: colunas/ordenação já via applySetup.
            // "Preservar grade ao reabrir" (keep_filter=1) → recarrega grade SEM critérios do Filtrar.
            this.filter = {};
            const setup = this.loadSetup?.() || {};
            // Limpa snapshot antigo de critérios do Filtrar (não deve persistir nesta tela).
            if (setup.filter != null || setup.filter_applied != null) {
                delete setup.filter;
                delete setup.filter_applied;
                try {
                    localStorage.setItem('stock-management.setup', JSON.stringify(setup));
                } catch (_) {}
            }
            if (setup.keep_filter === 1 || setup.keep_filter === true || setup.keep_filter === '1') {
                this.filterExplicitlyApplied = true;
                await this.loadPage(1);
                return;
            }
            const grid_node = this.target_node?.querySelector?.('#grid');
            if (grid_node) grid_node.innerHTML = '<p class="mtm" style="color:var(--color-muted)">Clique em <strong>Filtrar</strong> e depois <strong>Aplicar</strong> para carregar a grade (busca completa sem crit\xe9rios ou refine com filtros). <strong>Opera\xe7\xf5es</strong> (menu superior) s\xf3 funcionam ap\xf3s aplicar e pedem confirma\xe7\xe3o antes de executar.</p>';
            const page = this.target_node?.querySelector?.('#page');
            if (page) page.innerText = '0/0';
        },
        async resolveFilterData (raw) {
            return await (0, $hWQyW.resolveFilterLabelsToIds)(raw || this.filter || {}, this.fieldspecs);
        },
        normalizeFilterData (raw) {
            const out = {
                ...raw || {}
            };
            Object.keys(out).forEach((k)=>{
                const v = out[k];
                if (v === '-1' || v === -1 || v == null) out[k] = '';
            });
            return out;
        },
        /** Escopo para GET /locations — resolve rótulo de Empresa (tenant) para UUID quando necessário. */ async extractLocationScopeFilterRaw (raw) {
            const parts = [];
            const data = raw || {};
            const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
            let companies = null;
            const resolveCompanyId = async (v)=>{
                if (UUID_REGEX.test(v)) return v;
                companies = companies ?? await (0, $1cmSR.default).list('companies').catch(()=>[]);
                const c = companies.find((x)=>(x.nick || '') === v || String(x.nick || '') === v || (x.name || '') === v || String(x.name || '') === v);
                const id = c?.id;
                return id && UUID_REGEX.test(String(id)) ? String(id) : null;
            };
            for(let i = 0; i < 10; i++){
                const f = data[`field-${i}`];
                let v = data[`value-${i}`];
                if (v == null || v === '' || v === '-1' || v === -1) continue;
                v = String(v).trim();
                if (f === 'company_id' && v) {
                    const cid = await resolveCompanyId(v);
                    if (cid) parts.push(`company_id*eq*${cid}`);
                } else if (f === 'company_id') continue;
                else if (f === 'warehouse_id' && /^\d+$/.test(v)) parts.push(`warehouse_id*eq*${v}`);
                else if (f === 'location_id' && v) {
                    const m = v.match(/^(\d+):(\d+)$/);
                    if (m) {
                        parts.push(`warehouse_id*eq*${m[1]}`);
                        parts.push(`location_id*eq*${m[2]}`);
                    } else if (/^\d+$/.test(v)) parts.push(`location_id*eq*${v}`);
                }
            }
            return parts.length ? parts.join(',') : null;
        },
        async loadScopedLocations (raw) {
            const scopeFilter = await this.extractLocationScopeFilterRaw(raw);
            if (!scopeFilter) return;
            const params = new URLSearchParams();
            params.append('filter', scopeFilter);
            params.append('sort', '4');
            params.append('limit', '0');
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, '?' + params.toString());
            await (0, $1cmSR.default).set('locations', Array.isArray(data) ? data : []);
            return data;
        },
        async loadBaseData () {
            const q = this.queryAll();
            await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q).then((data)=>(0, $1cmSR.default).set('companies', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q).then((data)=>(0, $1cmSR.default).set('warehouses', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_classes, q).then((data)=>(0, $1cmSR.default).set('classes', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_categories, q).then((data)=>(0, $1cmSR.default).set('categories', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, q).then((data)=>(0, $1cmSR.default).set('programs', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, q).then((data)=>(0, $1cmSR.default).set('devices', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_units, q).then((data)=>(0, $1cmSR.default).set('units', data)).catch((error)=>(0, $jUNyh.notify)(error))
            ]);
            await this.loadScopedLocations(this.filter);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_stocks, query);
        },
        async loadRecord (id) {
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, ...JSON.parse(id));
            if (data && typeof data === 'object') {
                // Mapear dados enriquecidos para os campos somente leitura do modal
                data.stock_sku = data.sku ?? '';
                data.stock_product_name = data.product_name ?? '';
                data.stock_ncm = data.ncm ?? '';
                data.stock_gtin = data.gtin ?? '';
                data.stock_packaging_code = data.packaging_code ?? '';
                data.stock_packaging_factor = data.packaging_factor ?? '';
                data.stock_packaging_qr = data.packaging_qr_code ?? '';
                data.stock_lot_number = (0, $aGGTj.formatLotNumber)(data.lot_number) ?? '';
                data.stock_expiration_date = data.expiration_date ?? '';
                data.stock_manufacture_date = data.manufacture_date ?? '';
                data.stock_program_name = data.program_name ?? '';
                data.stock_codigo_cliente = data.codigo_cliente ?? '';
                data.stock_input_created_on = data.input_created_on ? (()=>{
                    const d = new Date(data.input_created_on);
                    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
                })() : '';
                data.stock_input_id = data.input_id ?? '';
                data.stock_invoice_number = data.invoice_number ?? '';
                data.stock_supplier_name = data.supplier_name ?? '';
                data.stock_supplier_legal_name = data.supplier_legal_name ?? '';
                data.stock_manufacturer_nick = data.manufacturer_nick ?? '';
                data.stock_block_reason = Number(data.quantity_unsettled || 0) > 0 ? String(data.block_reason || '').trim() : '';
            }
            return data;
        },
        async saveRecord () {
            // Tela de estoque é somente consulta; não persiste alterações por aqui
            return false;
        },
        async editFilter () {
            // Filtrar sempre limpo — preferências de colunas ficam no Configurar.
            await this.loadScopedLocations({});
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), {}, {
                reloadLocations: async (formData)=>{
                    await this.loadScopedLocations(formData);
                }
            });
        },
        async applyFilter (data) {
            let resolved = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            resolved = this.normalizeFilterData(resolved);
            await this.loadScopedLocations(resolved);
            this.filter = resolved;
            this.filterExplicitlyApplied = true;
            await this.loadPage(1);
        },
        applySetup (data) {
            // Colunas / ordenação / page_length do Configurar — sem restaurar Filtrar.
            if (data.sort_column != null && data.sort_column !== '') {
                this.sort_column = Number(data.sort_column);
                this.sort_order = Number(data.sort_order ?? 1);
            } else {
                const rec = this.computeRecencySort();
                this.sort_column = rec.sort_column;
                this.sort_order = 1;
            }
            this.page_length = Number(data.page_length ?? this.page_length);
            this.filter = {};
            const _default = this.default_columns || '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25';
            const columns = (data.columns || _default).split(',').map((column)=>Number(column));
            (0, $037bce58a5e51361$export$2e2bcd8739ae039).setVisible(this.fieldspecs.map((field)=>columns.includes(field.index) ? 1 : 0));
        },
        saveSetup (data) {
            const keepOn = data.keep_filter === true || data.keep_filter === 1 || data.keep_filter === '1';
            data.keep_filter = keepOn ? 1 : 0;
            delete data.filter;
            delete data.filter_applied;
            const prev = this.loadSetup() || {};
            for (const k of Object.keys(prev))if (k.startsWith('sm_') && data[k] == null) data[k] = prev[k];
            localStorage.setItem(this.module_name + '.setup', JSON.stringify(data));
            this.applySetup(data);
            if (keepOn) {
                this.filterExplicitlyApplied = true;
                this.loadPage();
            } else {
                this.filterExplicitlyApplied = false;
                const grid_node = this.target_node?.querySelector?.('#grid');
                if (grid_node) grid_node.innerHTML = '<p class="mtm" style="color:var(--color-muted)">Clique em <strong>Filtrar</strong> e depois <strong>Aplicar</strong> para carregar a grade (busca completa sem crit\xe9rios ou refine com filtros). <strong>Opera\xe7\xf5es</strong> (menu superior) s\xf3 funcionam ap\xf3s aplicar e pedem confirma\xe7\xe3o antes de executar.</p>';
                const page = this.target_node?.querySelector?.('#page');
                if (page) page.innerText = '0/0';
            }
        },
        moveStock () {
            const crudSelf = this;
            this.smWithFilterAndConfirm('Mover estoque', "Confirma abrir a movimenta\xe7\xe3o? Selecione exatamente uma linha na grade (j\xe1 filtrada) antes de preencher o formul\xe1rio.", ()=>{
                crudSelf._moveStockOpenForm();
            });
        },
        _moveStockOpenForm () {
            const showResult = async (success)=>{
                if (success) {
                    this.loadPage(); // Show updated stocks
                    fs.destroy();
                }
            };
            const sendRequest = async (data)=>{
                const reservedErr = (0, $48324c8641eeba48$export$fca310ad3037c0ff)(data.source_stock, data.target_stock);
                if (reservedErr) {
                    (0, $jUNyh.notify)(reservedErr, "Aten\xe7\xe3o");
                    return;
                }
                const targetLocationId = await $5595bfa8ce07cb50$var$sm_resolve_target_location_id(data);
                if (!Number.isInteger(targetLocationId)) {
                    (0, $jUNyh.notify)("Posi\xe7\xe3o de destino inv\xe1lida ou n\xe3o encontrada. Use a lista ou digite o endere\xe7o exatamente (mai\xfasculas/min\xfasculas).", "Aten\xe7\xe3o");
                    return;
                }
                let params = {
                    'source_company_id': data.source_warehouse_company_id,
                    'source_warehouse_id': Number(data.source_warehouse_id),
                    'source_location_id': Number(data.source_location_id),
                    'source_stock': data.source_stock,
                    'target_company_id': data.target_warehouse_company_id,
                    'target_warehouse_id': Number(data.target_warehouse_id),
                    'target_location_id': targetLocationId,
                    'target_stock': data.target_stock,
                    'quantity': Number(data.quantity),
                    'reason': data.reason,
                    'output_id': Number(data.output_id)
                };
                const runMove = ()=>{
                    (0, $jUNyh.ask)("Confirma registrar esta movimenta\xe7\xe3o de estoque com os dados preenchidos?", "Confirmar movimenta\xe7\xe3o", (key)=>{
                        if (key !== 'Y') return;
                        (0, $9VcS9.default).call((0, $9VcS9.default).move_stock, data.lot_company_id, data.lot_id, params).then(showResult);
                    });
                };
                if (data.source_stock === 'B') {
                    const qty = Number(data.quantity);
                    (0, $jUNyh.ask)((0, $48324c8641eeba48$export$c1c1b307cca99bce)([
                        {
                            sku: data.stock_sku,
                            quantity: qty
                        }
                    ]), 'Movimentar bloqueado', (key)=>{
                        if (key !== 'Y') return;
                        runMove();
                    });
                    return;
                }
                runMove();
            };
            let fs = (0, $h1m6J.default).create((0, $6c327e0121057f1c$export$2e2bcd8739ae039), sendRequest);
            const crud = this;
            const origInit = fs.init.bind(fs);
            fs.init = async function() {
                origInit();
                // Preencher com estoque selecionado na grid
                const selected = await crud.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (selected?.length === 1) {
                    const [company_id, stock_id] = selected[0];
                    const stock = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, company_id, stock_id);
                    if (stock) {
                        fs.form.setValues({
                            stock_sku: stock.sku ?? '',
                            lot_company_id: stock.lot_company_id,
                            lot_id: stock.lot_id,
                            quantity: stock.quantity_available ?? 1,
                            source_warehouse_company_id: stock.company_id,
                            source_warehouse_id: stock.warehouse_id,
                            source_location_id: stock.location_id
                        });
                        fs.form.refresh();
                    }
                }
            };
            fs.init();
        },
        blockStock () {
            const crudSelf = this;
            this.smWithFilterAndConfirm('Bloquear estoque', "Confirma abrir o bloqueio de estoque? Ser\xe1 necess\xe1rio ter exatamente uma linha selecionada na grade filtrada.", ()=>{
                crudSelf._blockStockOpenForm();
            });
        },
        _blockStockOpenForm () {
            const showResult = async (success)=>{
                if (success) {
                    this.loadPage();
                    fs.destroy();
                }
            };
            const sendRequest = async (data)=>{
                const qty = Number(data.quantity);
                const maxL = Number(data.qty_available_max || 0);
                if (!Number.isFinite(qty) || qty < 1) {
                    (0, $jUNyh.notify)("Informe uma quantidade v\xe1lida.", "Aten\xe7\xe3o");
                    return;
                }
                if (maxL > 0 && qty > maxL) {
                    (0, $jUNyh.notify)(`Quantidade n\xe3o pode exceder o dispon\xedvel (${maxL}).`, "Aten\xe7\xe3o");
                    return;
                }
                const mk = String(data.movement_kind || '').trim();
                if (!mk) {
                    (0, $jUNyh.notify)('Selecione a Natureza do bloqueio.', "Aten\xe7\xe3o");
                    return;
                }
                const reason = (0, $ec13f0e1663b8b62$export$d301f936562b4738)(mk);
                const params = {
                    source_company_id: data.source_warehouse_company_id,
                    source_warehouse_id: Number(data.source_warehouse_id),
                    source_location_id: Number(data.source_location_id),
                    source_stock: 'L',
                    target_company_id: data.target_warehouse_company_id,
                    target_warehouse_id: Number(data.target_warehouse_id),
                    target_location_id: Number(data.target_location_id),
                    target_stock: 'B',
                    quantity: qty,
                    reason: reason,
                    movement_kind: mk
                };
                (0, $jUNyh.ask)(`Confirma bloquear ${qty} unidade(s) dispon\xedveis nesta posi\xe7\xe3o?`, 'Confirmar bloqueio', (key)=>{
                    if (key !== 'Y') return;
                    (0, $9VcS9.default).call((0, $9VcS9.default).move_stock, data.lot_company_id, data.lot_id, params).then(showResult);
                });
            };
            const fs = (0, $h1m6J.default).create((0, $c8cd8707148527cd$export$2e2bcd8739ae039), sendRequest);
            const crud = this;
            const origInit = fs.init.bind(fs);
            fs.init = async function() {
                const sel = crud.getSelection();
                if (sel.length !== 1) {
                    (0, $jUNyh.notify)('Selecione exatamente uma linha de estoque.', "Aten\xe7\xe3o");
                    return;
                }
                // Seleção da grade: data-id é JSON [company_id, stock_id] — não é objeto { company_id, id }
                const tuple = sel[0];
                const company_id = Array.isArray(tuple) ? tuple[0] : tuple?.company_id;
                const stock_id = Array.isArray(tuple) ? tuple[1] : tuple?.id;
                if (company_id == null || stock_id == null) {
                    (0, $jUNyh.notify)("Sele\xe7\xe3o inv\xe1lida. Marque a caixa da linha e tente de novo.", "Aten\xe7\xe3o");
                    return;
                }
                const stock = await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock, company_id, stock_id);
                if (!stock) {
                    (0, $jUNyh.notify)("Estoque n\xe3o encontrado.", 'Erro');
                    return;
                }
                const q = Number(stock.quantity_available || 0);
                if (q < 1) {
                    (0, $jUNyh.notify)("N\xe3o h\xe1 quantidade dispon\xedvel (L) para bloquear nesta linha.", "Aten\xe7\xe3o");
                    return;
                }
                origInit();
                fs.form.setValues({
                    stock_sku: stock.sku ?? '',
                    lot_display: `${stock.lot_company_id} \xb7 lote ${stock.lot_id}`,
                    location_display: `Arm. ${stock.warehouse_id} \xb7 pos. ${stock.location_id}`,
                    movement_kind: 'BLOQ',
                    reason: (0, $ec13f0e1663b8b62$export$d301f936562b4738)('BLOQ'),
                    lot_company_id: stock.lot_company_id,
                    lot_id: stock.lot_id,
                    quantity: q,
                    qty_available_max: q,
                    source_warehouse_company_id: stock.company_id,
                    source_warehouse_id: stock.warehouse_id,
                    source_location_id: stock.location_id,
                    target_warehouse_company_id: stock.company_id,
                    target_warehouse_id: stock.warehouse_id,
                    target_location_id: stock.location_id
                });
                fs.form.refresh();
                (0, $ec13f0e1663b8b62$export$3a914ee0d3160d3f)(fs);
            };
            fs.init();
        },
        async smEditLotMeta () {
            this.smWithFilterAndConfirm('Lote / datas / programa', 'Confirma abrir o ajuste de lote fab., datas e programa? <strong>Marque</strong> as linhas na grade (checkbox) antes de continuar.', async ()=>{
                await this._smEditLotMetaRun();
            });
        },
        async _smEditLotMetaRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows) return;
            if (typeof (0, $9VcS9.default).stock_management_lot_meta_preview !== 'function') {
                (0, $jUNyh.notify)("Esta vers\xe3o do sistema n\xe3o consegue abrir o ajuste de lote. Atualize a p\xe1gina; se persistir, pe\xe7a o deploy do frontend.", "Aten\xe7\xe3o");
                return;
            }
            let preview;
            try {
                preview = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_lot_meta_preview, {
                    stocks: rows.map((r)=>({
                            stock_company_id: r.company_id,
                            stock_id: r.id
                        }))
                });
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), "Aten\xe7\xe3o");
                return;
            }
            const previewRows = Array.isArray(preview?.rows) ? preview.rows : [];
            const previewGroups = Array.isArray(preview?.groups) ? preview.groups : [];
            if (!previewRows.length) {
                (0, $jUNyh.notify)("N\xe3o foi poss\xedvel carregar as linhas selecionadas para o ajuste de lote. Feche os avisos (Continuar), atualize a p\xe1gina e tente de novo.", "Aten\xe7\xe3o");
                return;
            }
            const companyIds = [
                ...new Set(previewRows.map((r)=>r.lot_company_id || r.stock_company_id).filter(Boolean).map((c)=>String(c)))
            ];
            const programsCompanyId = companyIds.length === 1 ? companyIds[0] : null;
            const multiCompanyHint = companyIds.length > 1 ? "Sele\xe7\xe3o com mais de uma empresa: d\xe1 para alterar lote/datas; para mudar o Programa, selecione linhas de uma \xfanica empresa." : '';
            const sharedLot = previewGroups.some((g)=>(g.lines_with_same_lot || 0) > (g.selected_lines || 0) || (g.lines_with_same_lot || 0) > 1);
            const crud = this;
            (0, $37672c13343edbe6$export$2e2bcd8739ae039).form._programsCompanyId = programsCompanyId;
            const fs = (0, $h1m6J.default).create((0, $37672c13343edbe6$export$2e2bcd8739ae039), async (data)=>{
                const has = data.lot_number != null && String(data.lot_number).trim() !== '' || !!data.manufacture_date || !!data.expiration_date || data.program_id !== '' && data.program_id != null;
                if (!has) {
                    (0, $jUNyh.notify)('Preencha ao menos um campo a alterar.', "Aten\xe7\xe3o");
                    return;
                }
                const onlySelected = !!data.only_selected_lines;
                let programId = null;
                if (data.program_id !== '' && data.program_id != null) {
                    if (!programsCompanyId) {
                        (0, $jUNyh.notify)("Para alterar o programa, selecione linhas de uma \xfanica empresa (tenant).", "Aten\xe7\xe3o");
                        return;
                    }
                    programId = Number(data.program_id);
                    if (!Number.isInteger(programId) || programId <= 0) {
                        (0, $jUNyh.notify)("Selecione um programa v\xe1lido da lista (empresa das linhas).", "Aten\xe7\xe3o");
                        return;
                    }
                }
                const meta = {
                    ...data.lot_number != null && String(data.lot_number).trim() !== '' ? {
                        lot_number: String(data.lot_number).trim()
                    } : {},
                    ...data.manufacture_date ? {
                        manufacture_date: data.manufacture_date
                    } : {},
                    ...data.expiration_date ? {
                        expiration_date: data.expiration_date
                    } : {},
                    ...programId != null ? {
                        program_id: programId
                    } : {}
                };
                const items = [];
                if (onlySelected) for (const pr of previewRows)items.push({
                    scope: 'line',
                    stock_company_id: pr.stock_company_id,
                    stock_id: pr.stock_id,
                    lot_company_id: pr.lot_company_id,
                    lot_id: pr.lot_id,
                    ...meta
                });
                else {
                    const seenLots = new Set();
                    for (const g of previewGroups){
                        const k = `${g.lot_company_id}|${g.lot_id}`;
                        if (seenLots.has(k)) continue;
                        seenLots.add(k);
                        items.push({
                            scope: 'all',
                            lot_company_id: g.lot_company_id,
                            lot_id: g.lot_id,
                            ...meta
                        });
                    }
                }
                const confirmMsg = onlySelected ? `Confirma alterar o lote/datas/programa somente na(s) <strong>${previewRows.length}</strong> linha(s) selecionada(s)? O sistema isola automaticamente quando o mesmo SKU+lote existe em outras posi\xe7\xf5es.` : (()=>{
                    const parts = previewGroups.map((g)=>{
                        const label = $5595bfa8ce07cb50$var$sm_lot_group_label(g);
                        if ((g.lines_with_same_lot || 0) > 1) return `${label} \u{2014} <strong>${g.lines_with_same_lot}</strong> palete(s) em <strong>${g.positions_with_same_lot}</strong> posi\xe7\xe3o(\xf5es)`;
                        return `${label} \u{2014} somente a linha selecionada`;
                    });
                    return `Confirma aplicar a todas as linhas com o mesmo SKU e lote fab.?<br><br>${parts.join('<br>')}`;
                })();
                (0, $jUNyh.ask)(confirmMsg, "Confirmar grava\xe7\xe3o", (key)=>{
                    if (key !== 'Y') return;
                    (async ()=>{
                        const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_batch_patch_lots, {
                            items: items
                        });
                        if (ok && typeof ok.updated === 'number') {
                            const iso = ok.isolated_lines ? ` (${ok.isolated_lines} linha(s) isolada(s))` : '';
                            (0, $jUNyh.notify)(`Lotes atualizados: ${ok.updated}.${iso}`, 'Sucesso');
                            crud.loadPage();
                            fs.destroy();
                        }
                    })();
                });
            });
            const orig = fs.init.bind(fs);
            fs.init = async function() {
                orig();
                const rowsPreview = previewRows.map($5595bfa8ce07cb50$var$sm_stock_line_label).join('\n');
                const groupsPreview = previewGroups.map((g)=>{
                    const base = $5595bfa8ce07cb50$var$sm_lot_group_label(g);
                    if ((g.lines_with_same_lot || 0) <= 1) return `${base} \u{2014} \xfanica linha no sistema`;
                    return `${base} \u{2014} ${g.lines_with_same_lot} palete(s) / ${g.positions_with_same_lot} posi\xe7\xe3o(\xf5es); voc\xea selecionou ${g.selected_lines}`;
                }).join('\n');
                fs.form.setValues({
                    selected_rows_preview: rowsPreview,
                    selected_lots_preview: groupsPreview,
                    only_selected_lines: sharedLot
                });
                if (previewGroups.length === 1 && previewRows.length >= 1) {
                    const pr = previewRows[0];
                    let lot = await (0, $1cmSR.default).get('lots', [
                        pr.lot_company_id,
                        pr.lot_id
                    ]);
                    if (!lot) lot = await (0, $9VcS9.default).call((0, $9VcS9.default).select_lot, pr.lot_company_id, pr.lot_id);
                    if (lot && typeof lot === 'object') {
                        fs.form.setValues({
                            lot_number: (0, $aGGTj.formatLotNumber)(lot.lot_number) || lot.lot_number || '',
                            manufacture_date: lot.manufacture_date || '',
                            expiration_date: lot.expiration_date || '',
                            program_id: lot.program_id != null ? String(lot.program_id) : ''
                        });
                        fs.form.refresh();
                    }
                }
                const node = fs.dialog?.getNode?.();
                const hint = node?.querySelector('#sm-lot-hint');
                const scopeBox = node?.querySelector('#sm-lot-scope-box');
                if (scopeBox) scopeBox.style.display = sharedLot ? '' : 'none';
                if (hint) {
                    const scopeHint = !sharedLot ? "Este SKU e lote fab. existem apenas na(s) linha(s) selecionada(s). A altera\xe7\xe3o n\xe3o afeta outros paletes." : "O mesmo SKU e lote fab. podem existir em v\xe1rios paletes/posi\xe7\xf5es. Escolha se a altera\xe7\xe3o vale para todas ou s\xf3 para as linhas marcadas.";
                    hint.textContent = multiCompanyHint ? `${multiCompanyHint} ${scopeHint}` : scopeHint;
                }
            };
            fs.init();
        },
        async smChangePackaging () {
            this.smWithFilterAndConfirm('Corrigir embalagem', "Confirma corrigir a embalagem dos lotes das linhas <strong>selecionadas</strong>? Todas devem ser do mesmo produto. O sistema valida m\xfaltiplo do fator e registra auditoria.", async ()=>{
                await this._smChangePackagingRun();
            });
        },
        async _smChangePackagingRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows) return;
            const keys = new Map();
            for (const s of rows){
                const k = `${s.lot_company_id}|${s.lot_id}`;
                if (!keys.has(k)) keys.set(k, {
                    lot_company_id: s.lot_company_id,
                    lot_id: s.lot_id,
                    product_id: s.product_id
                });
            }
            const lots = [
                ...keys.values()
            ];
            const pids = new Set(lots.map((L)=>L.product_id));
            if (pids.size !== 1) {
                (0, $jUNyh.notify)("Selecione linhas do mesmo produto (ou um \xfanico lote).", "Aten\xe7\xe3o");
                return;
            }
            const product_id = lots[0].product_id;
            const lot_company_id = lots[0].lot_company_id;
            const ctx = $5595bfa8ce07cb50$var$sm_packaging_context(rows);
            const crud = this;
            const fs = (0, $h1m6J.default).create((0, $3d2aece5aad0127d$export$2e2bcd8739ae039), async (data)=>{
                const pid = Number(data.product_packaging_id);
                if (!Number.isFinite(pid)) {
                    (0, $jUNyh.notify)('Selecione a embalagem de destino.', "Aten\xe7\xe3o");
                    return;
                }
                const reason = String(data.reason || '').trim();
                const reasonErr = $5595bfa8ce07cb50$var$sm_validate_packaging_reason(reason);
                if (reasonErr) {
                    (0, $jUNyh.notify)(reasonErr, "Aten\xe7\xe3o");
                    return;
                }
                (0, $jUNyh.ask)(`Confirma aplicar a embalagem escolhida em ${lots.length} lote(s)? O saldo deve ser m\xfaltiplo do fator e a justificativa ser\xe1 auditada.`, "Confirmar corre\xe7\xe3o de embalagem", (key)=>{
                    if (key !== 'Y') return;
                    (async ()=>{
                        let n = 0;
                        let lastErr = '';
                        for (const L of lots)try {
                            const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_change_packaging, {
                                lot_company_id: L.lot_company_id,
                                lot_id: L.lot_id,
                                product_packaging_id: pid,
                                reason: reason
                            });
                            if (ok) n++;
                        } catch (e) {
                            lastErr = e?.message || String(e);
                        }
                        if (n) {
                            (0, $jUNyh.notify)(n === lots.length ? `Embalagem corrigida em ${n} lote(s).` : `Embalagem corrigida em ${n} de ${lots.length} lote(s).${lastErr ? ' ' + lastErr : ''}`, n === lots.length ? 'Sucesso' : "Aten\xe7\xe3o");
                            crud.loadPage();
                            fs.destroy();
                        } else if (lastErr) (0, $jUNyh.notify)(lastErr, 'Erro');
                    })();
                });
            });
            fs._pkgList = [];
            fs._pkgTotals = {
                total: ctx.total
            };
            const updatePkgPreview = ()=>{
                const node = fs.dialog?.getNode?.();
                const preview = node?.querySelector('#pkg_preview');
                const pid = Number(node?.querySelector('#product_packaging_id')?.value);
                if (!preview) return;
                if (!Number.isFinite(pid)) {
                    preview.textContent = "Selecione a embalagem de destino para ver a pr\xe9via.";
                    return;
                }
                const pkg = (fs._pkgList || []).find((p)=>Number(p.id) === pid);
                if (!pkg) {
                    preview.textContent = "Embalagem n\xe3o encontrada na lista do produto.";
                    return;
                }
                const f = Number(pkg.factor);
                const total = Number(fs._pkgTotals.total) || 0;
                if (!(f > 0)) {
                    preview.textContent = "Fator da embalagem inv\xe1lido.";
                    return;
                }
                if (total % f === 0) preview.textContent = `Pr\xe9via: ${total} un. \xf7 fator ${f} = ${total / f} embalagem(ns) \u{2014} compat\xedvel com o saldo total selecionado.`;
                else preview.textContent = `Saldo total (${total} un.) n\xe3o \xe9 m\xfaltiplo do fator ${f}. A opera\xe7\xe3o ser\xe1 rejeitada pela API.`;
            };
            const orig = fs.init.bind(fs);
            fs.init = async function() {
                orig();
                const node = fs.dialog?.getNode?.();
                const s0 = ctx.first;
                const set = (sel, val)=>{
                    const el = node?.querySelector(sel);
                    if (el) el.value = val ?? '';
                };
                set('#pkg_product_name', s0.product_name || s0.sku || '');
                set('#pkg_lot_number', (0, $aGGTj.formatLotNumber)(s0.lot_number) || s0.lot_number || '');
                set('#pkg_lot_id', lots.length === 1 ? String(s0.lot_id ?? '') : `${lots.length} lotes (${lots.map((L)=>L.lot_id).join(', ')})`);
                set('#pkg_expiration', s0.expiration_date || '');
                set('#pkg_location', ctx.locs.length === 1 ? ctx.locs[0] : ctx.locs.length ? ctx.locs.join(', ') : '');
                set('#pkg_current_code', s0.packaging_code || '');
                set('#pkg_current_factor', s0.packaging_factor != null ? String(s0.packaging_factor) : '');
                set('#pkg_total', String(ctx.total));
                set('#pkg_available', String(ctx.avail));
                set('#pkg_reserved', String(ctx.res));
                set('#pkg_blocked', String(ctx.block));
                const list = await (0, $9VcS9.default).call((0, $9VcS9.default).list_product_packagings_by_product, lot_company_id, product_id) || [];
                fs._pkgList = list.filter((p)=>!p.is_disabled);
                const dl = node?.querySelector('#sm_pkg_list');
                if (dl) dl.innerHTML = fs._pkgList.map((p)=>`<option value="${p.id}">${p.code} \xb7 fator ${p.factor} (${p.level})</option>`).join('');
                const pkgInput = node?.querySelector('#product_packaging_id');
                if (pkgInput) {
                    pkgInput.addEventListener('input', updatePkgPreview);
                    pkgInput.addEventListener('change', updatePkgPreview);
                }
                updatePkgPreview();
            };
            fs.init();
        },
        async smChangeUnit () {
            this.smWithFilterAndConfirm('Trocar UM (produto)', 'Confirma alterar a unidade de medida do produto? Afeta o cadastro do produto (titular + SKU) das linhas <strong>selecionadas</strong> (mesmo produto).', async ()=>{
                await this._smChangeUnitRun();
            });
        },
        async _smChangeUnitRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows) return;
            const keys = new Set(rows.map((s)=>`${s.lot_company_id}|${s.product_id}`));
            if (keys.size !== 1) {
                (0, $jUNyh.notify)('Selecione linhas do mesmo titular e produto.', "Aten\xe7\xe3o");
                return;
            }
            const lot_company_id = rows[0].lot_company_id;
            const product_id = rows[0].product_id;
            const crud = this;
            const fs = (0, $h1m6J.default).create((0, $295d1e840d9d5714$export$2e2bcd8739ae039), async (data)=>{
                const uid = Number(data.selling_unit_id);
                if (!Number.isFinite(uid)) {
                    (0, $jUNyh.notify)('Informe a unidade de medida.', "Aten\xe7\xe3o");
                    return;
                }
                (0, $jUNyh.ask)('Confirma alterar a unidade de medida deste produto no cadastro (titular)?', 'Confirmar UM', (key)=>{
                    if (key !== 'Y') return;
                    (async ()=>{
                        const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_product, lot_company_id, product_id, {
                            selling_unit_id: uid
                        });
                        if (ok !== undefined && ok !== false) {
                            (0, $jUNyh.notify)('Unidade de medida do produto atualizada.', 'Sucesso');
                            crud.loadPage();
                            fs.destroy();
                        }
                    })();
                });
            });
            const orig = fs.init.bind(fs);
            fs.init = async function() {
                orig();
                let prod = await (0, $1cmSR.default).get('products', [
                    lot_company_id,
                    product_id
                ]);
                if (!prod) prod = await (0, $9VcS9.default).call((0, $9VcS9.default).select_product, lot_company_id, product_id);
                if (prod && typeof prod === 'object') {
                    const sku = prod.sku;
                    const skuStr = Array.isArray(sku) ? sku.join('') : sku ?? '';
                    fs.form.setValues({
                        product_sku: skuStr,
                        selling_unit_id: prod.selling_unit_id != null ? String(prod.selling_unit_id) : ''
                    });
                    fs.form.refresh();
                }
            };
            fs.init();
        },
        async smBulkMove () {
            this.smWithFilterAndConfirm('Movimentar (lote)', "Confirma abrir a movimenta\xe7\xe3o em lote? Ser\xe3o movidas as quantidades das linhas <strong>selecionadas</strong> conforme o tipo de saldo escolhido no formul\xe1rio.", async ()=>{
                await this._smBulkMoveRun();
            });
        },
        async _smBulkMoveRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows) return;
            const crud = this;
            const fs = (0, $h1m6J.default).create((0, $f39b52413448534f$export$2e2bcd8739ae039), async (data)=>{
                const moves = [];
                const reason = String(data.reason || '').trim();
                if (!reason) {
                    (0, $jUNyh.notify)('Informe o motivo.', "Aten\xe7\xe3o");
                    return;
                }
                const targetLocationId = await $5595bfa8ce07cb50$var$sm_resolve_target_location_id(data);
                if (!Number.isInteger(targetLocationId)) {
                    (0, $jUNyh.notify)("Posi\xe7\xe3o de destino inv\xe1lida ou n\xe3o encontrada. Use a lista ou digite o endere\xe7o exatamente (mai\xfasculas/min\xfasculas).", "Aten\xe7\xe3o");
                    return;
                }
                const srcT = data.source_stock || 'L';
                const tgtT = data.target_stock || 'L';
                const reservedErr = (0, $48324c8641eeba48$export$fca310ad3037c0ff)(srcT, tgtT);
                if (reservedErr) {
                    (0, $jUNyh.notify)(reservedErr, "Aten\xe7\xe3o");
                    return;
                }
                for (const s of rows){
                    let q = 0;
                    if (srcT === 'L') q = Number(s.quantity_available || 0);
                    else q = Number(s.quantity_unsettled || 0);
                    if (q < 1) continue;
                    moves.push({
                        lot_company_id: s.lot_company_id,
                        lot_id: s.lot_id,
                        source_company_id: s.company_id,
                        source_warehouse_id: s.warehouse_id,
                        source_location_id: s.location_id,
                        source_stock: srcT,
                        target_company_id: data.target_warehouse_company_id,
                        target_warehouse_id: Number(data.target_warehouse_id),
                        target_location_id: targetLocationId,
                        target_stock: tgtT,
                        quantity: q,
                        reason: reason,
                        ...String(data.movement_kind || '').trim() ? {
                            movement_kind: String(data.movement_kind).trim()
                        } : {}
                    });
                }
                if (!moves.length) {
                    (0, $jUNyh.notify)('Nenhuma linha com quantidade na origem escolhida.', "Aten\xe7\xe3o");
                    return;
                }
                const confirmMsg = srcT === 'B' ? (0, $48324c8641eeba48$export$c1c1b307cca99bce)(moves.map((m)=>{
                    const row = rows.find((r)=>r.lot_id === m.lot_id && r.lot_company_id === m.lot_company_id);
                    return {
                        sku: row?.sku,
                        lot_number: row?.lot_number,
                        quantity: m.quantity
                    };
                })) : `Confirma registrar ${moves.length} movimenta\xe7\xe3o(\xf5es) com os dados informados?`;
                (0, $jUNyh.ask)(confirmMsg, srcT === 'B' ? 'Movimentar bloqueado' : "Confirmar movimenta\xe7\xe3o em lote", (key)=>{
                    if (key !== 'Y') return;
                    if ($5595bfa8ce07cb50$var$_smBulkActionInFlight) return;
                    $5595bfa8ce07cb50$var$_smBulkActionInFlight = true;
                    (async ()=>{
                        try {
                            const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_bulk_move, {
                                moves: moves
                            });
                            if (ok?.count >= 0) {
                                (0, $jUNyh.notify)(`Movimenta\xe7\xf5es registradas: ${ok.count}.`, 'Sucesso');
                                crud.loadPage();
                                fs.destroy();
                            }
                        } finally{
                            $5595bfa8ce07cb50$var$_smBulkActionInFlight = false;
                        }
                    })();
                });
            });
            fs.init();
        },
        async smBulkBlock () {
            this.smWithFilterAndConfirm('Bloquear (lote)', "Confirma bloquear o saldo <strong>dispon\xedvel</strong> de todas as linhas <strong>selecionadas</strong> na grade filtrada?", async ()=>{
                await this._smBulkBlockRun();
            });
        },
        async _smBulkBlockRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows) return;
            const crud = this;
            const fs = (0, $h1m6J.default).create((0, $e33b3e6660ce1b3d$export$2e2bcd8739ae039), async (data)=>{
                const mk = String(data.movement_kind || '').trim();
                if (!mk) {
                    (0, $jUNyh.notify)('Selecione a Natureza do bloqueio.', "Aten\xe7\xe3o");
                    return;
                }
                const reason = (0, $ec13f0e1663b8b62$export$d301f936562b4738)(mk);
                const lines = [];
                for (const s of rows){
                    const q = Number(s.quantity_available || 0);
                    if (q < 1) continue;
                    lines.push({
                        stock_company_id: s.company_id,
                        stock_id: s.id,
                        quantity: q,
                        reason: reason,
                        movement_kind: mk
                    });
                }
                if (!lines.length) {
                    (0, $jUNyh.notify)("Nenhuma linha com dispon\xedvel para bloquear.", "Aten\xe7\xe3o");
                    return;
                }
                (0, $jUNyh.ask)(`Confirma bloquear o dispon\xedvel em ${lines.length} linha(s)?`, 'Confirmar bloqueio em lote', (key)=>{
                    if (key !== 'Y') return;
                    if ($5595bfa8ce07cb50$var$_smBulkActionInFlight) return;
                    $5595bfa8ce07cb50$var$_smBulkActionInFlight = true;
                    (async ()=>{
                        try {
                            const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_bulk_block, {
                                lines: lines
                            });
                            if (ok?.count >= 0) {
                                (0, $jUNyh.notify)(`Bloqueios registrados: ${ok.count}.`, 'Sucesso');
                                crud.loadPage();
                                fs.destroy();
                            }
                        } finally{
                            $5595bfa8ce07cb50$var$_smBulkActionInFlight = false;
                        }
                    })();
                });
            });
            const orig = fs.init.bind(fs);
            fs.init = function() {
                orig();
                fs.form.setValues({
                    movement_kind: 'BLOQ',
                    reason: (0, $ec13f0e1663b8b62$export$d301f936562b4738)('BLOQ')
                });
                fs.form.refresh();
                (0, $ec13f0e1663b8b62$export$3a914ee0d3160d3f)(fs);
            };
            fs.init();
        },
        async smBulkUnblock () {
            this.smWithFilterAndConfirm('Desbloquear (lote)', 'Confirma desbloquear o saldo <strong>bloqueado</strong> de todas as linhas <strong>selecionadas</strong> na grade filtrada?', async ()=>{
                await this._smBulkUnblockRun();
            });
        },
        async _smBulkUnblockRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows) return;
            const crud = this;
            const fs = (0, $h1m6J.default).create((0, $e33b3e6660ce1b3d$export$2e2bcd8739ae039), async (data)=>{
                const mk = String(data.movement_kind || '').trim();
                if (!mk) {
                    (0, $jUNyh.notify)('Selecione a Natureza do desbloqueio.', "Aten\xe7\xe3o");
                    return;
                }
                const reason = (0, $ec13f0e1663b8b62$export$d301f936562b4738)(mk);
                const lines = [];
                for (const s of rows){
                    const q = Number(s.quantity_unsettled || 0);
                    if (q < 1) continue;
                    lines.push({
                        stock_company_id: s.company_id,
                        stock_id: s.id,
                        quantity: q,
                        reason: reason,
                        movement_kind: mk
                    });
                }
                if (!lines.length) {
                    (0, $jUNyh.notify)('Nenhuma linha com saldo bloqueado.', "Aten\xe7\xe3o");
                    return;
                }
                (0, $jUNyh.ask)(`Confirma desbloquear o saldo em ${lines.length} linha(s)?`, 'Confirmar desbloqueio em lote', (key)=>{
                    if (key !== 'Y') return;
                    if ($5595bfa8ce07cb50$var$_smBulkActionInFlight) return;
                    $5595bfa8ce07cb50$var$_smBulkActionInFlight = true;
                    (async ()=>{
                        try {
                            const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_bulk_unblock, {
                                lines: lines
                            });
                            if (ok?.count >= 0) {
                                (0, $jUNyh.notify)(`Desbloqueios registrados: ${ok.count}.`, 'Sucesso');
                                crud.loadPage();
                                fs.destroy();
                            }
                        } finally{
                            $5595bfa8ce07cb50$var$_smBulkActionInFlight = false;
                        }
                    })();
                });
            });
            const orig = fs.init.bind(fs);
            fs.init = function() {
                orig();
                fs.form.setValues({
                    movement_kind: 'DESBLOQ',
                    reason: (0, $ec13f0e1663b8b62$export$d301f936562b4738)('DESBLOQ')
                });
                fs.form.refresh();
                (0, $ec13f0e1663b8b62$export$3a914ee0d3160d3f)(fs);
            };
            fs.init();
        },
        async smSplit () {
            this.smWithFilterAndConfirm('Dividir linha', "Confirma dividir a linha de estoque? \xc9 necess\xe1ria <strong>uma</strong> linha selecionada na grade filtrada (reserva e bloqueio zerados).", async ()=>{
                await this._smSplitRun();
            });
        },
        async _smSplitRun () {
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows || rows.length !== 1) {
                (0, $jUNyh.notify)('Selecione exatamente uma linha de estoque.', "Aten\xe7\xe3o");
                return;
            }
            const s = rows[0];
            const crud = this;
            const fs = (0, $h1m6J.default).create((0, $93853730b74ba85e$export$2e2bcd8739ae039), async (data)=>{
                const q1 = Number(data.quantity_first);
                const isolate = !!data.isolate_new_lot;
                (0, $jUNyh.ask)(`Confirma dividir a linha: ${q1} unidade(s) permanecem na linha atual e o restante vira nova linha${isolate ? ' com lote independente' : ''}?`, "Confirmar divis\xe3o", (key)=>{
                    if (key !== 'Y') return;
                    (async ()=>{
                        const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_split_stock, {
                            stock_company_id: s.company_id,
                            stock_id: s.id,
                            quantity_first: q1,
                            isolate_new_lot: isolate
                        });
                        if (ok?.new_stock_id) {
                            (0, $jUNyh.notify)(ok?.new_lot_id ? `Linha dividida. Novo estoque id ${ok.new_stock_id} com lote independente ${ok.new_lot_id}.` : `Linha dividida. Novo estoque id ${ok.new_stock_id}.`, 'Sucesso');
                            crud.loadPage();
                            fs.destroy();
                        }
                    })();
                });
            });
            const orig = fs.init.bind(fs);
            fs.init = function() {
                orig();
                const expRaw = s.expiration_date;
                let expLabel = '';
                if (expRaw != null && String(expRaw).trim() !== '') {
                    const d = new Date(expRaw);
                    expLabel = Number.isNaN(d.getTime()) ? String(expRaw) : d.toLocaleDateString('pt-BR');
                }
                fs.form.setValues({
                    product_name: (s.product_name || '').toString().trim() || "\u2014",
                    manufacturer_nick: (s.manufacturer_nick || '').toString().trim() || "\u2014",
                    program_name: (s.program_name || '').toString().trim() || "\u2014",
                    lot_number: (0, $aGGTj.formatLotNumber)(s.lot_number) || s.lot_number || "\u2014",
                    expiration_date: expLabel || "\u2014",
                    stock_id: String(s.id ?? ''),
                    lot_ref: `SKU ${s.sku ?? ''} \xb7 Lote ${(0, $aGGTj.formatLotNumber)(s.lot_number) || s.lot_number || "\u2014"}`,
                    stock_sku: s.sku ?? '',
                    qty_available: String(s.quantity_available ?? ''),
                    isolate_new_lot: true
                });
                fs.form.refresh();
            };
            fs.init();
        },
        async smUnitarize () {
            if (!this.smHasActiveFilter()) {
                this.smNotifyFilterRequired();
                return;
            }
            const rows = await $5595bfa8ce07cb50$var$sm_load_selected_stocks(this);
            if (!rows || rows.length !== 1) {
                (0, $jUNyh.notify)('Selecione exatamente uma linha de estoque.', "Aten\xe7\xe3o");
                return;
            }
            const s = rows[0];
            const co = await (0, $1cmSR.default).get('companies', s.lot_company_id) || await (0, $1cmSR.default).get('companies', [
                s.lot_company_id
            ]);
            if (!co?.pkg_unitarization_enabled) {
                (0, $jUNyh.notify)("Unitariza\xe7\xe3o n\xe3o est\xe1 habilitada na empresa titular do lote (Organiza\xe7\xe3o > Empresas).", "Aten\xe7\xe3o");
                return;
            }
            const crud = this;
            (0, $jUNyh.ask)("Separar o saldo dispon\xedvel em caixas fechados (m\xfaltiplo do fator prim\xe1rio) e sobra em unidades, em linhas distintas?", 'Unitarizar linha', async (key)=>{
                if (key !== 'Y') return;
                const ok = await (0, $9VcS9.default).call((0, $9VcS9.default).stock_management_unitarize_stock, {
                    stock_company_id: s.company_id,
                    stock_id: s.id
                });
                if (ok && (ok.changed === false || ok.new_stock_id)) {
                    (0, $jUNyh.notify)(ok.message || "Unitariza\xe7\xe3o conclu\xedda.", ok.changed === false ? 'Aviso' : 'Sucesso');
                    crud.loadPage();
                }
            });
        },
        reportPayload (filterData, extra = {}) {
            const filterExpr = filterData ? (0, $hWQyW.translate)(filterData, null, this.fieldspecs) : '';
            const sortVal = this.sort_column * (this.sort_order ? -1 : 1);
            return {
                filter: filterExpr || undefined,
                sort: sortVal,
                ...extra
            };
        },
        openReportModal (title, apiMethod) {
            let reportFilter = null;
            const crud = this;
            const descriptor = {
                ...(0, $822dea3bdf7d9d14$export$2e2bcd8739ae039)
            };
            descriptor.html = descriptor.html.replace('<div class="title" id="report-title">Relat\xf3rio</div>', `<div class="title" id="report-title">${title}</div>`);
            const fs = (0, $h1m6J.default).create(descriptor, async (data)=>{
                fs.destroy();
                const payload = crud.reportPayload(reportFilter, {
                    format: data.format
                });
                try {
                    const json = await (0, $9VcS9.default).call(apiMethod, payload);
                    if (json?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(json.pdf);
                    else if (json?.csv) {
                        $5595bfa8ce07cb50$var$downloadCsv(json.csv, json.filename || 'relatorio.csv');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else (0, $jUNyh.notify)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                const node = fs.dialog?.getNode?.();
                if (node) {
                    const btnFilters = node.querySelector('#btn-filters');
                    const summary = node.querySelector('#filter-summary');
                    const updateSummary = ()=>{
                        summary.textContent = reportFilter ? 'Filtros definidos' : 'Sem filtros (todos os registros)';
                    };
                    btnFilters?.addEventListener('click', async ()=>{
                        await crud.loadScopedLocations(reportFilter || crud.filter);
                        (0, $hWQyW.default).edit(async (data)=>{
                            reportFilter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, crud.fieldspecs);
                            await crud.loadScopedLocations(reportFilter);
                            updateSummary();
                        }, reportFilter, {
                            reloadLocations: async (formData)=>{
                                await crud.loadScopedLocations(formData);
                            }
                        });
                    });
                    updateSummary();
                }
            })();
        },
        printBySKU () {
            this.openReportModal('Estoque Consolidado por SKU', (0, $9VcS9.default).print_stocks_by_sku);
        },
        printByLot () {
            this.openReportModal('Estoque Consolidado por Lote', (0, $9VcS9.default).print_stocks_by_lot);
        },
        printByLocation () {
            this.openReportModal("Estoque Consolidado por Posi\xe7\xe3o", (0, $9VcS9.default).print_stocks_by_location);
        },
        printBalanceBlocks () {
            this.openReportModal('Bloqueios de saldo', (0, $9VcS9.default).print_stocks_balance_blocks);
        },
        exportCsv () {
            const fs = (0, $h1m6J.default).create((0, $f2e31d0f27d90986$export$2e2bcd8739ae039), async (data)=>{
                fs.destroy();
                const payload = {
                    company_id: data.company_id,
                    warehouse_id: data.warehouse_id ? Number(data.warehouse_id) : null,
                    program_id: data.program_id ? Number(data.program_id) : null
                };
                try {
                    const json = await (0, $9VcS9.default).call((0, $9VcS9.default).export_stocks_csv, payload);
                    if (json?.csv) {
                        $5595bfa8ce07cb50$var$downloadCsv(json.csv, json.filename || 'estoque.csv');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        },
        outputPurchaseReport () {
            const fs = (0, $h1m6J.default).create((0, $5fe4dde45e4cd989$export$2e2bcd8739ae039), async (data)=>{
                const companyId = data.company_id;
                if (!companyId) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Aten\xe7\xe3o");
                    return false;
                }
                const dateFrom = data.date_from;
                const dateTo = data.date_to;
                if (!dateFrom || !dateTo) {
                    (0, $jUNyh.notify)("Informe o per\xedodo (De e At\xe9).", "Aten\xe7\xe3o");
                    return false;
                }
                if (dateTo < dateFrom) {
                    (0, $jUNyh.notify)('A data "At\xe9" deve ser igual ou posterior \xe0 data "De".', "Aten\xe7\xe3o");
                    return false;
                }
                fs.destroy();
                try {
                    const resp = await (0, $9VcS9.default).output_purchase_report(companyId, {
                        date_from: dateFrom,
                        date_to: dateTo,
                        warehouse_id: data.warehouse_id || undefined
                    });
                    if (!resp.ok) {
                        const err = await resp.json().catch(()=>({}));
                        (0, $jUNyh.notify)(err?.error || 'Erro ao exportar.', 'Erro');
                        return;
                    }
                    const json = await resp.json();
                    if (json?.csv) {
                        $5595bfa8ce07cb50$var$downloadCsv(json.csv, json.filename || 'saidas-compras.csv');
                        (0, $jUNyh.notify)(`Download iniciado (${json.rows ?? ''} linha(s)).`, 'Sucesso');
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        },
        printLotLabels () {
            if (!this.ensureSelection('Etiquetas de Lote')) return;
            const sendRequest = async (data)=>{
                const device_id = (0, $aGGTj.resolvePrinterDeviceId)(data.device_id, '#stocks-select-printer #device_id');
                if (device_id == null) {
                    (0, $jUNyh.notify)("Selecione a impressora na lista (clique na op\xe7\xe3o; s\xf3 o texto no campo n\xe3o basta).", "Aten\xe7\xe3o");
                    return false;
                }
                const selected = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (!selected.length) {
                    (0, $jUNyh.notify)('Selecione ao menos um estoque na grade antes de continuar.', 'Etiquetas de Lote');
                    return false;
                }
                const payload = {
                    company_id: data.company_id,
                    device_id: device_id,
                    ids: (0, $aGGTj.splitIdsByCompany)(selected),
                    return_zpl: !!data.use_local_agent
                };
                let lc = parseInt(String(data.label_copies ?? '1'), 10);
                if (!Number.isFinite(lc) || lc < 1) lc = 1;
                if (lc > 200) lc = 200;
                payload.label_copies = lc;
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).print_lot_labels, payload);
                if (result?.zpl) try {
                    await (0, $9VcS9.default).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $jUNyh.notify)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            let fs = (0, $h1m6J.default).create((0, $66f0ec4106475d51$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        }
    });
    // Ordem = colunas da grade (alinhado a js/views/stocks.js). Índice = posição no SELECT SQL_LIST_BY_CREDENTIAL_ENRICHED (src/repos/stocks.py). Coluna 32 extra: `warehouse_name` (API). Coluna 33: `classes`. Coluna 34: `categoria`.
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Estoque',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do estoque'
        },
        {
            index: 12,
            field: 'sku',
            label: 'SKU',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'SKU do produto'
        },
        {
            index: 13,
            field: 'product_name',
            label: 'Produto',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome/taxonomia do produto'
        },
        {
            index: 15,
            field: 'manufacturer_nick',
            label: 'Fabricante',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Com embalagem no lote: fabricante GTIN da embalagem; sem embalagem cadastrada: fabricante legado do produto'
        },
        {
            index: 16,
            field: 'ncm',
            label: 'NCM',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'NCM do produto'
        },
        {
            index: 17,
            field: 'gtin',
            label: 'EAN',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'GTIN/EAN da embalagem do lote (sem GTIN na embalagem: cadastro do produto)'
        },
        {
            index: 18,
            field: 'codigo_cliente',
            label: "C\xf3d. cliente",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo do cliente no produto"
        },
        {
            index: 19,
            field: 'packaging_code',
            label: 'Embalagem',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo da embalagem padr\xe3o do produto"
        },
        {
            index: 20,
            field: 'packaging_factor',
            label: 'Fator Emb.',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: "Fator da embalagem padr\xe3o"
        },
        {
            index: 21,
            field: 'packaging_qr_code',
            label: 'QR Emb.',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "QR code da embalagem padr\xe3o"
        },
        {
            index: 22,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa do lote',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 24,
            field: 'lot_number',
            label: 'Lote fab.',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "N\xfamero do lote fabricante"
        },
        {
            index: 26,
            field: 'expiration_date',
            label: 'Validade',
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: 'Data de validade do lote'
        },
        {
            index: 25,
            field: 'manufacture_date',
            label: "Fabrica\xe7\xe3o",
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: "Data de fabrica\xe7\xe3o do lote"
        },
        {
            index: 28,
            field: 'input_created_on',
            label: 'Data Entrada',
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: 'Data da entrada referente ao lote'
        },
        {
            index: 27,
            field: 'input_id',
            label: 'Entrada Sial',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: "N\xfamero da entrada SIAL referente ao lote"
        },
        {
            index: 29,
            field: 'invoice_number',
            label: 'Nota Entrada',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "N\xfamero da nota de entrada"
        },
        {
            index: 30,
            field: 'supplier_name',
            label: 'Fornecedor',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Apelido do fornecedor da entrada'
        },
        {
            index: 39,
            field: 'supplier_legal_name',
            label: 'Fornecedor (nome)',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Nome / raz\xe3o social do fornecedor da entrada"
        },
        {
            index: 3,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m do estoque",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o no armaz\xe9m",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 5,
            field: 'lot_company_id',
            label: 'Titular',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Titular do lote',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 6,
            field: 'lot_id',
            label: 'Lote',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 7,
            field: 'quantity_available',
            label: "Dispon\xedvel",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade dispon\xedvel"
        },
        {
            index: 8,
            field: 'quantity_reserved',
            label: 'Reservado',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade reservada'
        },
        {
            index: 9,
            field: 'quantity_unsettled',
            label: 'Bloqueado',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade sob an\xe1lise"
        },
        {
            index: 37,
            field: 'unit_price',
            label: 'Valor unit.',
            types: [
                $3eqAU.default(4, 2)
            ],
            placeholder: '0,0000',
            title: "Valor unit\xe1rio m\xe9dio do item no pedido de entrada"
        },
        {
            index: 38,
            field: 'total_value',
            label: 'Valor total',
            types: [
                $3eqAU.default(2, 2)
            ],
            placeholder: '0,00',
            title: "Valor unit\xe1rio x quantidade dispon\xedvel"
        },
        {
            index: 10,
            field: 'status',
            label: 'Status',
            types: [
                $c539c39a88864005$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status do estoque'
        },
        {
            index: 33,
            field: 'classes',
            label: 'Classes',
            types: [
                $74yTJ.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Classes do produto (separadas por ;)',
            store: 'classes',
            labels: [
                'name'
            ]
        },
        {
            index: 34,
            field: 'categoria',
            label: 'Categoria',
            types: [
                $74yTJ.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Categoria do produto',
            store: 'categories',
            labels: [
                'name'
            ]
        },
        {
            index: 35,
            field: 'is_portaria_344',
            label: 'Portaria 344',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: "Produto sujeito \xe0 Portaria 344/98"
        }
    ];
    let operations = [
        {
            hash: '#sm-edit-lot',
            label: 'Lote&nbsp;/&nbsp;datas&nbsp;/&nbsp;programa'
        },
        {
            hash: '#sm-change-packaging',
            label: 'Corrigir&nbsp;embalagem&nbsp;do&nbsp;lote'
        },
        {
            hash: '#sm-change-unit',
            label: 'Trocar&nbsp;UM&nbsp;(produto)'
        },
        {
            hash: '#sm-bulk-move',
            label: 'Movimentar&nbsp;(lote)'
        },
        {
            hash: '#sm-bulk-block',
            label: 'Bloquear&nbsp;(lote)'
        },
        {
            hash: '#sm-bulk-unblock',
            label: 'Desbloquear&nbsp;(lote)'
        },
        {
            hash: '#sm-split',
            label: 'Dividir&nbsp;linha'
        },
        {
            hash: '#sm-unitarize',
            label: 'Unitarizar&nbsp;linha'
        },
        {
            hash: '#move-stock',
            label: 'Mover&nbsp;(uma&nbsp;linha)'
        },
        {
            hash: '#block-stock',
            label: 'Bloquear&nbsp;(uma&nbsp;linha)'
        }
    ];
    let reports = [
        {
            hash: '#print-by-sku',
            label: 'Estoque&nbsp;Consolidado&nbsp;por&nbsp;SKU'
        },
        {
            hash: '#print-by-lot',
            label: 'Estoque&nbsp;Consolidado&nbsp;por&nbsp;Lote'
        },
        {
            hash: '#print-by-location',
            label: "Estoque&nbsp;Consolidado&nbsp;por&nbsp;Posi\xe7\xe3o"
        },
        {
            hash: '#print-balance-blocks',
            label: 'Bloqueios&nbsp;de&nbsp;saldo'
        },
        {
            hash: '#export-csv',
            label: "Exportar&nbsp;CSV&nbsp;(Relat\xf3rio&nbsp;Completo)"
        },
        {
            hash: '#output-purchase',
            label: "Sa\xeddas&nbsp;para&nbsp;Compras&nbsp;(CSV)"
        },
        {
            hash: '#lot-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Lotes'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-edit-lot', sm_crud.smEditLotMeta.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-change-packaging', sm_crud.smChangePackaging.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-change-unit', sm_crud.smChangeUnit.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-bulk-move', sm_crud.smBulkMove.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-bulk-block', sm_crud.smBulkBlock.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-bulk-unblock', sm_crud.smBulkUnblock.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-split', sm_crud.smSplit.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#sm-unitarize', sm_crud.smUnitarize.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#move-stock', sm_crud.moveStock.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#block-stock', sm_crud.blockStock.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-sku', sm_crud.printBySKU.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-lot', sm_crud.printByLot.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-by-location', sm_crud.printByLocation.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-balance-blocks', sm_crud.printBalanceBlocks.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-csv', sm_crud.exportCsv.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#output-purchase', sm_crud.outputPurchaseReport.bind(sm_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#lot-labels', sm_crud.printLotLabels.bind(sm_crud));
    sm_crud.run('stock-management', 'Gerenciamento de estoques', document.getElementById('workarea'), (0, $82e5a54bae0b2474$export$2e2bcd8739ae039), (0, $c45260a54a668287$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $5595bfa8ce07cb50$export$2e2bcd8739ae039 = $5595bfa8ce07cb50$var$stock_management;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");

var $jUNyh = parcelRequire("jUNyh");

var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
/**
 * Formata origem/destino de transações para exibição (sem UUID de tenant).
 * Tipos: I Entrada, O Saída, L Posição, R Reserva, B Bloqueio.
 */ 
var $1cmSR = parcelRequire("1cmSR");
function $be9828b1bc8e928d$export$d8ad1b2b62db9372(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'object') return {
        ...raw
    };
    try {
        return JSON.parse(String(raw));
    } catch  {
        return {
            _unparsed: String(raw)
        };
    }
}
function $be9828b1bc8e928d$export$3f2dce9a283bc781(parsed) {
    if (!parsed || typeof parsed !== 'object') return {};
    const o = {
        ...parsed
    };
    delete o.company_id;
    delete o.input_company_id;
    delete o.lot_company_id;
    return o;
}
function $be9828b1bc8e928d$var$extrasSuffix(o) {
    const bits = [];
    if (o.replenishment_id != null) bits.push(`Ressup.#${o.replenishment_id}`);
    if (o.inventory_id != null) bits.push(`Inv.#${o.inventory_id}`);
    return bits.length ? ` \xb7 ${bits.join(" \xb7 ")}` : '';
}
async function $be9828b1bc8e928d$var$inputLinkedLabel(rowCompanyId, inputId) {
    if (inputId == null) return '';
    try {
        const e = await (0, $1cmSR.default).get('inputs', [
            rowCompanyId,
            inputId
        ]);
        if (!e) return '';
        if (e.invoice_number) return ` \xb7 NF ${e.invoice_number}`;
        if (e.order_id) return ` \xb7 Pedido ${e.order_id}`;
        return '';
    } catch  {
        return '';
    }
}
async function $be9828b1bc8e928d$var$outputLinkedLabel(rowCompanyId, outputId) {
    if (outputId == null) return '';
    try {
        const e = await (0, $1cmSR.default).get('outputs', [
            rowCompanyId,
            outputId
        ]);
        if (!e) return '';
        if (e.reference) return String(e.reference).trim();
        if (e.order_id) return `Pedido ${e.order_id}`;
        return '';
    } catch  {
        return '';
    }
}
async function $be9828b1bc8e928d$export$efc0f3f6f7674309(keyFn, rowCompanyId, typeChar, raw) {
    const parsed = $be9828b1bc8e928d$export$d8ad1b2b62db9372(raw);
    if (!parsed) return '';
    if (parsed._unparsed) return parsed._unparsed;
    const scopeCompany = parsed.company_id || rowCompanyId;
    const o = $be9828b1bc8e928d$export$3f2dce9a283bc781(parsed);
    switch(typeChar){
        case 'I':
            {
                if (o.input_id == null) return $be9828b1bc8e928d$var$fallbackObj(o);
                const tail = await $be9828b1bc8e928d$var$inputLinkedLabel(rowCompanyId, o.input_id);
                return tail ? `Entrada${tail}` : 'Entrada';
            }
        case 'O':
            {
                if (o.output_id == null) return $be9828b1bc8e928d$var$fallbackObj(o);
                const ref = await $be9828b1bc8e928d$var$outputLinkedLabel(rowCompanyId, o.output_id);
                return ref ? `Sa\xedda \xb7 ${ref}` : "Sa\xedda";
            }
        case 'L':
        case 'B':
            {
                const wh = o.warehouse_id;
                const loc = o.location_id;
                if (wh == null || loc == null) return $be9828b1bc8e928d$var$fallbackObj(o);
                const whName = keyFn ? await keyFn('warehouses', [
                    scopeCompany,
                    wh
                ], 'name') || `Arm.${wh}` : `Arm.${wh}`;
                const addr = keyFn ? await keyFn('locations', [
                    scopeCompany,
                    wh,
                    loc
                ], 'address') || '' : '';
                const locPart = addr || "(endere\xe7o n\xe3o cadastrado)";
                const inExtra = o.input_id != null ? await $be9828b1bc8e928d$var$inputLinkedLabel(rowCompanyId, o.input_id) : '';
                return `${whName} \xb7 ${locPart}${$be9828b1bc8e928d$var$extrasSuffix(o)}${inExtra}`;
            }
        case 'R':
            {
                const parts = [];
                const wh = o.warehouse_id;
                const loc = o.location_id;
                if (wh != null && loc != null) {
                    const whName = keyFn ? await keyFn('warehouses', [
                        scopeCompany,
                        wh
                    ], 'name') || `Arm.${wh}` : `Arm.${wh}`;
                    const addr = keyFn ? await keyFn('locations', [
                        scopeCompany,
                        wh,
                        loc
                    ], 'address') || '' : '';
                    parts.push(`${whName} \xb7 ${addr || "(endere\xe7o n\xe3o cadastrado)"}`);
                }
                if (o.output_id != null) {
                    const ref = await $be9828b1bc8e928d$var$outputLinkedLabel(rowCompanyId, o.output_id);
                    parts.push(ref ? `Sa\xedda \xb7 ${ref}` : "Sa\xedda");
                }
                let s = parts.join(" \xb7 ") + $be9828b1bc8e928d$var$extrasSuffix(o);
                if (o.input_id != null) s += await $be9828b1bc8e928d$var$inputLinkedLabel(rowCompanyId, o.input_id);
                return s || $be9828b1bc8e928d$var$fallbackObj(o);
            }
        default:
            return $be9828b1bc8e928d$var$fallbackObj(o);
    }
}
function $be9828b1bc8e928d$var$fallbackObj(o) {
    const keys = Object.keys(o);
    if (!keys.length) return '';
    return keys.map((k)=>`${k}: ${o[k]}`).join(', ');
}
function $be9828b1bc8e928d$export$abee749dbcddf014(rowCompanyId, typeChar, raw) {
    const parsed = $be9828b1bc8e928d$export$d8ad1b2b62db9372(raw);
    if (!parsed) return '';
    if (parsed._unparsed) return parsed._unparsed;
    const o = $be9828b1bc8e928d$export$3f2dce9a283bc781(parsed);
    switch(typeChar){
        case 'I':
            return o.input_id != null ? 'Entrada' : $be9828b1bc8e928d$var$fallbackObj(o);
        case 'O':
            return o.output_id != null ? "Sa\xedda" : $be9828b1bc8e928d$var$fallbackObj(o);
        case 'L':
        case 'B':
            {
                const wh = o.warehouse_id;
                const loc = o.location_id;
                if (wh == null || loc == null) return $be9828b1bc8e928d$var$fallbackObj(o);
                return `Arm.${wh} \xb7 (endere\xe7o n\xe3o dispon\xedvel offline)${$be9828b1bc8e928d$var$extrasSuffix(o)}`;
            }
        case 'R':
            {
                const parts = [];
                if (o.warehouse_id != null && o.location_id != null) parts.push(`Arm.${o.warehouse_id} \xb7 (endere\xe7o n\xe3o dispon\xedvel offline)`);
                if (o.output_id != null) parts.push("Sa\xedda");
                let s = parts.join(" \xb7 ");
                if (o.replenishment_id != null) s += `${s ? " \xb7 " : ''}Ressup.#${o.replenishment_id}`;
                if (o.inventory_id != null) s += `${s ? " \xb7 " : ''}Inv.#${o.inventory_id}`;
                return s || $be9828b1bc8e928d$var$fallbackObj(o);
            }
        default:
            return $be9828b1bc8e928d$var$fallbackObj(o);
    }
}


async function $3f6e738e9ca7ec99$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(5)	{ text-align: right; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(12)	{ text-align: center; }
			.view td:nth-child(13)	{ text-align: center; }
			.view td:nth-child(14)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Transa\xe7\xe3o</th>
					<th data-index="3" data-visible="${this.visible[2]}">Produto</th>
					<th data-index="4" data-visible="${this.visible[3]}">Lote</th>
					<th data-index="5" data-visible="${this.visible[4]}">Usu\xe1rio</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data/Hora</th>
					<th data-index="7" data-visible="${this.visible[6]}">Origem Tipo</th>
					<th data-index="8" data-visible="${this.visible[7]}">Destino Tipo</th>
					<th data-index="9" data-visible="${this.visible[8]}">Origem</th>
					<th data-index="10" data-visible="${this.visible[9]}">Destino</th>
					<th data-index="11" data-visible="${this.visible[10]}">Quantidade</th>
					<th data-index="12" data-visible="${this.visible[11]}">Natureza</th>
					<th data-index="13" data-visible="${this.visible[12]}">Valor</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('products', [
            record.company_id,
            record.product_id
        ])}</td>
					<td data-visible='${this.visible[3]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.user_id)}</td>
					<td data-visible='${this.visible[5]}'>${this.format($8IFAz.default(), record.date_time)}</td>
					<td data-visible='${this.visible[6]}'>${this.option($bdd84d0eadfe1c66$export$2e2bcd8739ae039(), record.source_type)}</td>
					<td data-visible='${this.visible[7]}'>${this.option($bdd84d0eadfe1c66$export$2e2bcd8739ae039(), record.target_type)}</td>
					<td data-visible='${this.visible[8]}'>${await (0, $be9828b1bc8e928d$export$efc0f3f6f7674309)(this.key.bind(this), record.company_id, record.source_type, record.source)}</td>
					<td data-visible='${this.visible[9]}'>${await (0, $be9828b1bc8e928d$export$efc0f3f6f7674309)(this.key.bind(this), record.company_id, record.target_type, record.target)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($3eqAU.default(0), record.quantity)}</td>
					<td data-visible='${this.visible[11]}'>${record.movement_kind ? this.option($3dfaf73b973524e9$export$2e2bcd8739ae039(), record.movement_kind) : ''}</td>
					<td data-visible='${this.visible[12]}'>${this.format($3eqAU.default(2), record.value)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}


parcelRequire("9VcS9");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $2rQ6E = parcelRequire("2rQ6E");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $5bf775e5b7c2d7dd$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#transaction #company_id	{ width: 10rem;		}
			#transaction #id			{ width: 6rem; text-align: right;	}
			#transaction #user_id		{ width: 10rem;		}
			#transaction #date_time		{ width: 10rem;		}
			#transaction #product_id	{ width: 32rem; 	}
			#transaction #lot_id		{ width: 10rem;		}
			#transaction #quantity		{ width: 10rem; text-align: right;	}
			#transaction #value			{ width: 10rem; text-align: right;	}
			#transaction #source_type	{ width: 8rem;		}
			#transaction #target_type	{ width: 8rem;		}
			#transaction #source		{ width: 24rem;	}
			#transaction #target		{ width: 24rem;	}
			#transaction #movement_kind	{ width: 20rem; }
		</style>
		<form id="transaction" class="form" autocomplete="off">
			<datalist id="users">
			</datalist>
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="lots">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da transa\xe7\xe3o">Transa\xe7\xe3o
					<input id="id" type="text" disabled>
				</label>
				<label title="Usu\xe1rio autor da transa\xe7\xe3o">Usu\xe1rio
					<input id="user_id" type="text" list="users" disabled>
				</label>
				<label title="Data e hora da transa\xe7\xe3o">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Classifica\xe7\xe3o operacional (opcional)">Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
				<label title="Excluir esta transa\xe7\xe3o">Desabilitar
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="Produto movimentado">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products" required>
				</label>
				<label title="Lote movimentado">Lote<sup>*</sup>
					<input id="lot_id" type="text" list="lots" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo de origem">Origem Tipo<sup>*</sup>
					<input id="source_type" type="text" list="transaction_types" required>
				</label>
				<label title="Origem da movimenta\xe7\xe3o">Origem<sup>*</sup>
					<input id="source" type="text" required>
				</label>
				<label title="Quantidade movimentada">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo de destino">Destino Tipo<sup>*</sup>
					<input id="target_type" type="text" list="transaction_types" required>
				</label>
				<label title="Destino da movimenta\xe7\xe3o">Destino<sup>*</sup>
					<input id="target" type="text" required>
				</label>
				<label title="Pre\xe7o de custo total do lote movimentado">Valor<sup>*</sup>
					<input id="value" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#transaction',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('product_id'),
                $dg8P2.default('lots', {
                    labels: [
                        'lot_number',
                        'id'
                    ],
                    sep: " \xb7 ",
                    key: 'company_id',
                    range: 1
                })
            ]
        },
        {
            properties: {
                selector: '#user_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_time'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#movement_kind'
            },
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#source_type'
            },
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#target_type'
            },
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#source'
            },
            types: [
                $2rQ6E.default()
            ]
        },
        {
            properties: {
                selector: '#target'
            },
            types: [
                $2rQ6E.default()
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#value'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
const $d95b661ee91ff067$var$transactions = function() {
    let transactions_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            await this.loadLightBaseCatalogs();
            (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $jUNyh.notify)(error)));
            await this.loadScopedLocationsToDb();
        },
        async editFilter () {
            await this.loadScopedLocationsToDb(this.filter);
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    await this.loadScopedLocationsToDb(formData);
                }
            });
        },
        async applyFilter (data) {
            this.filter = data;
            this.filterExplicitlyApplied = true;
            await this.loadScopedLocationsToDb(data);
            await this.loadPage(1);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_transactions, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_transaction, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                product_id: Number(data.product_id),
                lot_id: Number(data.lot_id),
                source_type: data.source_type,
                target_type: data.target_type,
                source: JSON.parse(data.source),
                target: JSON.parse(data.target),
                quantity: Number(data.quantity),
                value: Number(data.value)
            };
            if (old_data) _record.movement_kind = data.movement_kind || null;
            else if (data.movement_kind) _record.movement_kind = data.movement_kind;
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_transaction, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_transaction, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Transa\xe7\xe3o",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Identificador da transa\xe7\xe3o"
        },
        {
            index: 3,
            field: 'product_id',
            label: 'Produto',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Produto',
            store: 'products',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'lot_id',
            label: 'Lote',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 5,
            field: 'user_id',
            label: "Usu\xe1rio",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da transa\xe7\xe3o"
        },
        {
            index: 7,
            field: 'source_type',
            label: 'Tipo Origem',
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de origem'
        },
        {
            index: 8,
            field: 'target_type',
            label: 'Tipo Destino',
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de destino'
        },
        {
            index: 9,
            field: 'source',
            label: 'Origem',
            types: [],
            placeholder: '',
            title: "Identifica\xe7\xe3o da origem"
        },
        {
            index: 10,
            field: 'target',
            label: 'Destino',
            types: [],
            placeholder: '',
            title: "Identifica\xe7\xe3o do destino"
        },
        {
            index: 11,
            field: 'quantity',
            label: 'Quantidade',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade'
        },
        {
            index: 12,
            field: 'movement_kind',
            label: 'Natureza',
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "MOV / RESUP / \u2026"
        },
        {
            index: 13,
            field: 'value',
            label: 'Valor',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor'
        }
    ];
    transactions_crud.run('transactions', "Transa\xe7\xf5es", document.getElementById('workarea'), (0, $3f6e738e9ca7ec99$export$2e2bcd8739ae039), (0, $5bf775e5b7c2d7dd$export$2e2bcd8739ae039), fieldspecs);
};
var $d95b661ee91ff067$export$2e2bcd8739ae039 = $d95b661ee91ff067$var$transactions;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");

var $hWQyW = parcelRequire("hWQyW");

var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");

async function $f084953ddb61e33f$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(5)	{ text-align: right; }
			.view td:nth-child(6)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(13)	{ text-align: center; }
			.view td:nth-child(14)	{ text-align: center; }
			.view td:nth-child(15)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Transa\xe7\xe3o</th>
					<th data-index="18" data-visible="${this.visible[2]}">SKU</th>
					<th data-index="3" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="4" data-visible="${this.visible[4]}">Lote</th>
					<th data-index="16" data-visible="${this.visible[5]}">Posi\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[6]}">Usu\xe1rio</th>
					<th data-index="6" data-visible="${this.visible[7]}">Data/Hora</th>
					<th data-index="7" data-visible="${this.visible[8]}">Origem Tipo</th>
					<th data-index="8" data-visible="${this.visible[9]}">Destino Tipo</th>
					<th data-index="9" data-visible="${this.visible[10]}">Origem</th>
					<th data-index="10" data-visible="${this.visible[11]}">Destino</th>
					<th data-index="11" data-visible="${this.visible[12]}">Quantidade</th>
					<th data-index="12" data-visible="${this.visible[13]}">Natureza</th>
					<th data-index="13" data-visible="${this.visible[14]}">Valor</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.sku || ''}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('products', [
            record.company_id,
            record.product_id
        ])}</td>
					<td data-visible='${this.visible[4]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[5]}'>${record.location_address || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.user_id)}</td>
					<td data-visible='${this.visible[7]}'>${this.format($8IFAz.default(), record.date_time)}</td>
					<td data-visible='${this.visible[8]}'>${this.option($bdd84d0eadfe1c66$export$2e2bcd8739ae039(), record.source_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.option($bdd84d0eadfe1c66$export$2e2bcd8739ae039(), record.target_type)}</td>
					<td data-visible='${this.visible[10]}'>${await (0, $be9828b1bc8e928d$export$efc0f3f6f7674309)(this.key.bind(this), record.company_id, record.source_type, record.source)}</td>
					<td data-visible='${this.visible[11]}'>${await (0, $be9828b1bc8e928d$export$efc0f3f6f7674309)(this.key.bind(this), record.company_id, record.target_type, record.target)}</td>
					<td data-visible='${this.visible[12]}'>${this.format($3eqAU.default(0), record.quantity)}</td>
					<td data-visible='${this.visible[13]}'>${record.movement_kind ? this.option($3dfaf73b973524e9$export$2e2bcd8739ae039(), record.movement_kind) : ''}</td>
					<td data-visible='${this.visible[14]}'>${this.format($3eqAU.default(2), record.value)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}




var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $2f6e058b94e63850$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#move-location-bulk .company	{ width: 11rem;	}
			#move-location-bulk .warehouse	{ width: 10rem;	}
			#move-location-bulk .location	{ width: 14rem;	}
			#move-location-bulk #movement_kind { width: 20rem; }
			#move-location-bulk #reason		{ width: 22rem;	}
		</style>
		<form id="move-location-bulk" class="form" autocomplete="off" novalidate>
			<datalist id="mlb-companies">
			</datalist>
			<datalist id="mlb-source-warehouses">
			</datalist>
			<datalist id="mlb-target-warehouses">
			</datalist>
			<datalist id="mlb-source-locations">
			</datalist>
			<datalist id="mlb-target-locations">
			</datalist>
			<div class="title">
				Mover posi\xe7\xe3o inteira
			</div>
			<p class="mts muted">Transfere o saldo <strong>dispon\xedvel</strong> (L\u{2192}L) e, ap\xf3s confirma\xe7\xe3o, o <strong>bloqueado</strong> (B\u{2192}B) de cada lote na posi\xe7\xe3o de origem para o destino, <strong>sempre na mesma empresa</strong>. O saldo <strong>reservado permanece na origem</strong> e n\xe3o pode ser movimentado. Se houver reserva ou bloqueio, o sistema exibe o detalhe por SKU e pede confirma\xe7\xe3o antes de executar.</p>
			<div class="fsb mtl">
				<label title="Depositante \u{2014} origem e destino ficam neste tenant">Empresa<sup>*</sup>
					<input id="warehouse_company_id" class="company" type="text" list="mlb-companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m de origem">Armaz\xe9m origem<sup>*</sup>
					<input id="source_warehouse_id" class="warehouse" type="text" list="mlb-source-warehouses" required placeholder="Lista ap\xf3s empresa">
				</label>
				<label title="Posi\xe7\xe3o de origem (endere\xe7o)">Posi\xe7\xe3o origem<sup>*</sup>
					<input id="source_location_id" class="location" type="text" list="mlb-source-locations" required placeholder="Lista ap\xf3s armaz\xe9m">
				</label>
				<span></span>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m de destino">Armaz\xe9m destino<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="mlb-target-warehouses" required placeholder="Lista ap\xf3s empresa">
				</label>
				<label title="Posi\xe7\xe3o de destino">Posi\xe7\xe3o destino<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="mlb-target-locations" required placeholder="Lista ap\xf3s armaz\xe9m">
				</label>
				<span></span>
			</div>
			<div class="fsb">
				<label title="Motivo / observa\xe7\xe3o (gravado nas transa\xe7\xf5es)">Motivo<sup>*</sup>
					<input id="reason" type="text" required placeholder="Ex.: Relayout corredor">
				</label>
				<label title="Natureza registrada nas transa\xe7\xf5es (padr\xe3o MOV)">Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#move-location-bulk',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#mlb-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#source_warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#target_warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#source_location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'warehouse_company_id',
                    'source_warehouse_id'
                ]),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#target_location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'warehouse_company_id',
                    'target_warehouse_id'
                ]),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#reason'
            },
            types: []
        },
        {
            properties: {
                selector: '#movement_kind'
            },
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var /**
 * Modal — Controle de movimentações (#MT-D8E2535).
 * Formatos: Tela (JSON), PDF, CSV, Excel (XLSX).
 */ $3610432dedc8a6e0$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#movement-control-form #company_id  { width: 15rem; }
			#movement-control-form #warehouse_id { width: 15rem; }
			#movement-control-form #date_from,
			#movement-control-form #date_to     { width: 10rem; }
			#movement-control-form .mc-legend   { font-size: 0.85rem; color: var(--color-muted); line-height: 1.45; }
			#movement-control-form .mc-types label { display: inline-flex; align-items: center; gap: 0.35rem; margin-right: 1rem; cursor: pointer; }
		</style>
		<form id="movement-control-form" class="form" autocomplete="off">
			<datalist id="mc-companies"></datalist>
			<datalist id="mc-warehouses"></datalist>
			<div class="title">Controle de movimenta\xe7\xf5es</div>
			<p class="mts mc-legend">
				<strong>Por posi\xe7\xe3o:</strong> endere\xe7os que tiveram movimenta\xe7\xe3o (acuracidade).<br>
				<strong>Origem \xd7 Destino:</strong> de onde saiu e para onde foi (ex.: <code>1-P-4-3</code> \u{2192} <code>1-H-41-1</code>).
			</p>
			<div class="mtm mc-legend">
				<strong>Legenda dos tipos</strong><br>
				<strong>L\u{2192}L</strong> \u{2014} Transfer\xeancia entre posi\xe7\xf5es (derrubada / reendere\xe7amento)<br>
				<strong>L\u{2192}R</strong> \u{2014} Reserva para picking (posi\xe7\xe3o \u{2192} reserva da sa\xedda)<br>
				<strong>R\u{2192}O</strong> \u{2014} Baixa de sa\xedda (reserva \u{2192} sa\xedda / separa\xe7\xe3o)
			</div>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="mc-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>At\xe9<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armaz\xe9m (opcional)
					<input id="warehouse_id" type="text" list="mc-warehouses">
				</label>
			</div>
			<div class="mtm">
				<label>Vis\xe3o
					<select id="view">
						<option value="positions">Por posi\xe7\xe3o</option>
						<option value="moves" selected>Origem \xd7 Destino</option>
					</select>
				</label>
			</div>
			<div class="mtm mc-types">
				<span style="display:block;margin-bottom:0.35rem">Tipos de movimento</span>
				<label><input type="checkbox" id="type_ll" checked> L\u{2192}L</label>
				<label><input type="checkbox" id="type_lr" checked> L\u{2192}R</label>
				<label><input type="checkbox" id="type_ro" checked> R\u{2192}O</label>
			</div>
			<div class="mtm">
				<label>Formato
					<select id="format">
						<option value="json">Tela</option>
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel (XLSX)</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#movement-control-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#mc-companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#mc-warehouses', 'warehouses', {
                labels: [
                    'name'
                ]
            });
            const today = new Date();
            const iso = today.toISOString().slice(0, 10);
            const elFrom = formset.form.node.querySelector('#date_from');
            const elTo = formset.form.node.querySelector('#date_to');
            if (elFrom && !elFrom.value) elFrom.value = iso;
            if (elTo && !elTo.value) elTo.value = iso;
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#view'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#format'
            },
            types: [
                $6Jl4s.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");


function $6a3c457a33663b1a$var$downloadBase64(base64Content, filename, mime) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mime || 'application/octet-stream'
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(a.href);
}
function $6a3c457a33663b1a$var$escapeHtml(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $6a3c457a33663b1a$var$escapeCsvCell(value) {
    if (value == null || value === '') return '';
    const s = String(value);
    if (/[";\r\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
    return s;
}
/** CSV separado por ; (compatível com Excel PT-BR). */ function $6a3c457a33663b1a$var$toCsvSemicolon(rows, headers) {
    const line = (cells)=>cells.map($6a3c457a33663b1a$var$escapeCsvCell).join(';');
    const h = line(headers.map((h)=>h.label));
    const body = rows.map((row)=>line(headers.map((h)=>{
            const v = row[h.field];
            if (v != null && typeof v === 'object') return JSON.stringify(v);
            return v;
        })));
    return [
        h,
        ...body
    ].join('\r\n');
}
function $6a3c457a33663b1a$var$downloadText(text, filename, mime) {
    const blob = new Blob([
        '\ufeff' + text
    ], {
        type: mime
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
}
/** Mesma resolução de rótulo que a grid (versa/grid.js `key`). */ async function $6a3c457a33663b1a$var$keyForExport(store, keys, labels = 'name', separator = ' ') {
    if (!keys || Array.isArray(keys) && (keys.length === 0 || keys.some((v)=>v == null || v === ''))) return '';
    const entry = await (0, $1cmSR.default).get(store, keys);
    if (!entry) return '';
    return (Array.isArray(labels) ? labels : [
        labels
    ]).map((label)=>entry[label]).join(separator);
}
function $6a3c457a33663b1a$var$formatDateTimeBr(v) {
    if (v == null || v === '') return '';
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
function $6a3c457a33663b1a$var$formatNumberBr(value, minFrac, maxFrac) {
    if (value == null || value === '') return '';
    const n = Number(value);
    if (isNaN(n)) return String(value);
    return n.toLocaleString('pt-BR', {
        minimumFractionDigits: minFrac,
        maximumFractionDigits: maxFrac
    });
}
const $6a3c457a33663b1a$var$_txTypeOpt = $bdd84d0eadfe1c66$export$2e2bcd8739ae039();
const $6a3c457a33663b1a$var$_mkOpt = $3dfaf73b973524e9$export$2e2bcd8739ae039();
function $6a3c457a33663b1a$var$transactionTypeLabel(c) {
    return $6a3c457a33663b1a$var$_txTypeOpt.options.find((x)=>x.value === c)?.label || c || '';
}
function $6a3c457a33663b1a$var$movementKindLabel(k) {
    if (k == null || k === '') return '';
    return $6a3c457a33663b1a$var$_mkOpt.options.find((x)=>x.value === k)?.label || k;
}
/**
 * Uma linha de movimentação com os mesmos textos da tela (nomes, tipos em PT, endereços, números pt-BR).
 */ async function $6a3c457a33663b1a$var$enrichMovementRowForExport(r) {
    const [company, product, userName, lotRec, origem, destino] = await Promise.all([
        $6a3c457a33663b1a$var$keyForExport('companies', r.company_id, 'nick'),
        $6a3c457a33663b1a$var$keyForExport('products', [
            r.company_id,
            r.product_id
        ], 'name'),
        $6a3c457a33663b1a$var$keyForExport('users', r.user_id, 'name'),
        (0, $1cmSR.default).get('lots', [
            r.company_id,
            r.lot_id
        ]),
        (0, $be9828b1bc8e928d$export$efc0f3f6f7674309)($6a3c457a33663b1a$var$keyForExport, r.company_id, r.source_type, r.source),
        (0, $be9828b1bc8e928d$export$efc0f3f6f7674309)($6a3c457a33663b1a$var$keyForExport, r.company_id, r.target_type, r.target)
    ]);
    return {
        ...r,
        _company: company || '',
        _sku: r.sku || '',
        _product: product || '',
        _user: userName || '',
        _lot_fab: lotRec && lotRec.lot_number != null ? String(lotRec.lot_number) : '',
        _position: r.location_address || '',
        _origem_fmt: origem,
        _destino_fmt: destino,
        _date_br: $6a3c457a33663b1a$var$formatDateTimeBr(r.date_time),
        _source_t: $6a3c457a33663b1a$var$transactionTypeLabel(r.source_type),
        _target_t: $6a3c457a33663b1a$var$transactionTypeLabel(r.target_type),
        _q_br: $6a3c457a33663b1a$var$formatNumberBr(r.quantity, 0, 2),
        _v_br: $6a3c457a33663b1a$var$formatNumberBr(r.value, 2, 2),
        _mk: $6a3c457a33663b1a$var$movementKindLabel(r.movement_kind)
    };
}
async function $6a3c457a33663b1a$var$enrichMovementsForExportAll(rows, onProgress = null) {
    const out = [];
    const chunk = 50;
    for(let i = 0; i < rows.length; i += chunk){
        const slice = rows.slice(i, i + chunk);
        const part = await Promise.all(slice.map((r)=>$6a3c457a33663b1a$var$enrichMovementRowForExport(r)));
        out.push(...part);
        if (onProgress) onProgress(out.length, rows.length);
    }
    return out;
}
function $6a3c457a33663b1a$var$normAddressForFilter(s) {
    return String(s ?? '').replace(/[\s\-]+/g, '').toLowerCase();
}
/** Id da posição: número ou endereço (ex.: S-1 / s-1); usa o mesmo critério de filtro `address` na API. */ async function $6a3c457a33663b1a$var$resolveLocationIdForMove(companyId, warehouseId, raw) {
    const rawStr = String(raw ?? '').trim();
    if (!rawStr) return NaN;
    const n = Number(rawStr);
    if (Number.isInteger(n) && n >= 1) return n;
    const term = $6a3c457a33663b1a$var$normAddressForFilter(rawStr);
    if (!term) return NaN;
    const wh = Number(warehouseId);
    if (!companyId || !Number.isInteger(wh) || wh < 1) return NaN;
    const filter = `company_id*eq*${companyId},warehouse_id*eq*${wh},address*co*${term}`;
    const q = `?filter=${encodeURIComponent(filter)}&limit=80&sort=4`;
    const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, q);
    if (!Array.isArray(rows) || rows.length === 0) return NaN;
    if (rows.length === 1) return Number(rows[0].id);
    const want = $6a3c457a33663b1a$var$normAddressForFilter(rawStr);
    for (const r of rows){
        const addr = Array.isArray(r.address) ? r.address.join('-') : String(r.address ?? '');
        if ($6a3c457a33663b1a$var$normAddressForFilter(addr) === want) return Number(r.id);
    }
    return NaN;
}

const $6a3c457a33663b1a$var$movements = function() {
    let movements_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        default_columns: '1,2,18,3,4,16,5,6,7,8,9,10,11,12,13',
        async loadBaseData () {
            await this.loadLightBaseCatalogs();
            (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $jUNyh.notify)(error)));
            await this.loadScopedLocationsToDb();
        },
        async editFilter () {
            await this.loadScopedLocationsToDb(this.filter);
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    await this.loadScopedLocationsToDb(formData);
                }
            });
        },
        async applyFilter (data) {
            this.filter = data;
            this.filterExplicitlyApplied = true;
            await this.loadScopedLocationsToDb(data);
            await this.loadPage(1);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_transactions, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_transaction, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                product_id: Number(data.product_id),
                lot_id: Number(data.lot_id),
                source_type: data.source_type,
                target_type: data.target_type,
                source: JSON.parse(data.source),
                target: JSON.parse(data.target),
                quantity: Number(data.quantity),
                value: Number(data.value)
            };
            if (old_data) _record.movement_kind = data.movement_kind || null;
            else if (data.movement_kind) _record.movement_kind = data.movement_kind;
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_transaction, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_transaction, data.company_id, _record);
        },
        async _exportMovementsDelimited (filename, title) {
            const rows = await this.queryFilteredData();
            if (!rows.length) {
                (0, $jUNyh.notify)('Nenhum registro no filtro.', 'Exportar');
                return;
            }
            const mb = (0, $jUNyh.default)({
                animation: true,
                text: "Preparando exporta\xe7\xe3o\u2026"
            });
            let mapped;
            try {
                mapped = await $6a3c457a33663b1a$var$enrichMovementsForExportAll(rows);
            } finally{
                mb.destroy();
            }
            const headers = [
                {
                    field: '_company',
                    label: 'Empresa'
                },
                {
                    field: 'id',
                    label: "Transa\xe7\xe3o"
                },
                {
                    field: '_sku',
                    label: 'SKU'
                },
                {
                    field: '_product',
                    label: 'Produto'
                },
                {
                    field: 'lot_id',
                    label: 'Lote (id interno)'
                },
                {
                    field: '_lot_fab',
                    label: "Lote n\xba"
                },
                {
                    field: '_position',
                    label: "Posi\xe7\xe3o"
                },
                {
                    field: '_user',
                    label: "Usu\xe1rio"
                },
                {
                    field: '_date_br',
                    label: 'Data/Hora'
                },
                {
                    field: '_source_t',
                    label: 'Origem Tipo'
                },
                {
                    field: '_target_t',
                    label: 'Destino Tipo'
                },
                {
                    field: '_origem_fmt',
                    label: 'Origem'
                },
                {
                    field: '_destino_fmt',
                    label: 'Destino'
                },
                {
                    field: '_q_br',
                    label: 'Quantidade'
                },
                {
                    field: '_mk',
                    label: 'Natureza'
                },
                {
                    field: '_v_br',
                    label: 'Valor'
                }
            ];
            const csv = $6a3c457a33663b1a$var$toCsvSemicolon(mapped, headers);
            $6a3c457a33663b1a$var$downloadText(csv, filename, 'text/csv;charset=utf-8');
            (0, $jUNyh.notify)('Download iniciado.', title);
        },
        async exportMovementsCsv () {
            (0, $jUNyh.ask)(`Exportar todos os registros do filtro atual em CSV (separador ;)?`, 'Exportar CSV', async (answer)=>{
                if (answer !== 'Y') return;
                await this._exportMovementsDelimited(`movimentacoes_${new Date().toISOString().slice(0, 10)}.csv`, 'CSV');
            });
        },
        async exportMovementsExcel () {
            (0, $jUNyh.ask)(`Exportar registros do filtro para Excel (arquivo .xls com separador ;)?`, 'Exportar Excel', async (answer)=>{
                if (answer !== 'Y') return;
                await this._exportMovementsDelimited(`movimentacoes_${new Date().toISOString().slice(0, 10)}.xls`, 'Excel');
            });
        },
        async printMovementsPdf () {
            const rows = await this.queryFilteredData();
            if (!rows.length) {
                (0, $jUNyh.notify)('Nenhum registro no filtro.', 'Imprimir');
                return;
            }
            const w = window.open('', '_blank');
            if (!w) {
                (0, $jUNyh.notify)('Permita pop-ups para gerar o PDF.', 'Imprimir');
                return;
            }
            const slice = rows.slice(0, 2000);
            const mb = (0, $jUNyh.default)({
                animation: true,
                text: "Preparando visualiza\xe7\xe3o\u2026"
            });
            let enriched;
            try {
                enriched = await $6a3c457a33663b1a$var$enrichMovementsForExportAll(slice);
            } finally{
                mb.destroy();
            }
            const h = (s)=>{
                if (s == null || s === '') return '';
                return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            };
            let html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Movimenta\xe7\xf5es</title>
			<style>
				body { font-family: Arial, sans-serif; margin: 1.2rem; }
				h1 { font-size: 1.1rem; }
				table { border-collapse: collapse; width: 100%; font-size: 0.65rem; }
				th, td { border: 1px solid #444; padding: 0.2rem 0.35rem; text-align: left; vertical-align: top; }
				th { background: #eee; }
			</style></head><body><h1>Movimenta\xe7\xf5es (filtrado)</h1><table><thead><tr>
			<th>Empresa</th><th>Transa\xe7\xe3o</th><th>SKU</th><th>Produto</th><th>Lote (id)</th><th>Lote n\xba</th><th>Posi\xe7\xe3o</th><th>Usu\xe1rio</th>
			<th>Data/Hora</th><th>Origem Tipo</th><th>Destino Tipo</th><th>Origem</th><th>Destino</th>
			<th>Quantidade</th><th>Natureza</th><th>Valor</th>
			</tr></thead><tbody>`;
            for (const r of enriched){
                html += '<tr>';
                html += `<td>${h(r._company)}</td>`;
                html += `<td>${h(r.id)}</td>`;
                html += `<td>${h(r._sku)}</td>`;
                html += `<td>${h(r._product)}</td>`;
                html += `<td>${h(r.lot_id)}</td>`;
                html += `<td>${h(r._lot_fab)}</td>`;
                html += `<td>${h(r._position)}</td>`;
                html += `<td>${h(r._user)}</td>`;
                html += `<td>${h(r._date_br)}</td>`;
                html += `<td>${h(r._source_t)}</td>`;
                html += `<td>${h(r._target_t)}</td>`;
                html += `<td>${h(r._origem_fmt)}</td>`;
                html += `<td>${h(r._destino_fmt)}</td>`;
                html += `<td>${h(r._q_br)}</td>`;
                html += `<td>${h(r._mk)}</td>`;
                html += `<td>${h(r._v_br)}</td>`;
                html += '</tr>';
            }
            html += '</tbody></table>';
            if (rows.length > 2000) html += `<p>\u{2026} e mais ${rows.length - 2000} linhas (limite de impress\xe3o). Use exporta\xe7\xe3o CSV completa.</p>`;
            html += '<script>window.onload=function(){window.print();}<\/script></body></html>';
            w.document.write(html);
            w.document.close();
        },
        moveLocationBulk () {
            const crud = this;
            let fs;
            const sendRequest = async (data)=>{
                const co = data.warehouse_company_id;
                if (!co) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Mover posi\xe7\xe3o inteira");
                    return;
                }
                const sw = Number(data.source_warehouse_id);
                const tw = Number(data.target_warehouse_id);
                if (!Number.isInteger(sw) || sw < 1 || !Number.isInteger(tw) || tw < 1) {
                    (0, $jUNyh.notify)("Selecione armaz\xe9m de origem e destino na lista (ap\xf3s escolher a empresa).", "Mover posi\xe7\xe3o inteira");
                    return;
                }
                let sl = Number(data.source_location_id);
                let tl = Number(data.target_location_id);
                if (!Number.isInteger(sl) || sl < 1) sl = await $6a3c457a33663b1a$var$resolveLocationIdForMove(co, sw, data.source_location_id);
                if (!Number.isInteger(tl) || tl < 1) tl = await $6a3c457a33663b1a$var$resolveLocationIdForMove(co, tw, data.target_location_id);
                if (!Number.isInteger(sl) || sl < 1) {
                    (0, $jUNyh.notify)("Posi\xe7\xe3o de origem inv\xe1lida ou amb\xedgua. Use a lista (endere\xe7o ap\xf3s o armaz\xe9m) ou o id num\xe9rico da posi\xe7\xe3o.", "Mover posi\xe7\xe3o inteira");
                    return;
                }
                if (!Number.isInteger(tl) || tl < 1) {
                    (0, $jUNyh.notify)("Posi\xe7\xe3o de destino inv\xe1lida ou amb\xedgua. Use a lista (endere\xe7o ap\xf3s o armaz\xe9m) ou o id num\xe9rico da posi\xe7\xe3o.", "Mover posi\xe7\xe3o inteira");
                    return;
                }
                const payload = {
                    target_warehouse_id: tw,
                    target_location_id: tl,
                    reason: (data.reason || '').trim() || undefined
                };
                if (data.movement_kind && String(data.movement_kind).trim()) payload.movement_kind = String(data.movement_kind).trim();
                const url = `${(0, $9VcS9.getSialApiHost)()}/companies/${co}/warehouses/${sw}/locations/${sl}/move-all-available`;
                const finishMoveOk = (out)=>{
                    const n = out.lines_moved ?? 0;
                    const q = out.quantity_total ?? 0;
                    const qb = out.quantity_blocked_moved ?? 0;
                    const blockedTxt = qb > 0 ? ` (${qb} bloqueada(s))` : '';
                    (0, $jUNyh.notify)(n ? `Movimentadas ${n} transa\xe7\xe3o(\xf5es), ${q} unidade(s)${blockedTxt}.` : "Nenhuma linha com saldo livre ou bloqueado na posi\xe7\xe3o de origem.", "Mover posi\xe7\xe3o inteira");
                    fs.destroy();
                    crud.loadPage();
                };
                const mb = (0, $jUNyh.default)({
                    animation: true
                });
                let res;
                try {
                    res = await fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(payload),
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                } finally{
                    mb.destroy();
                }
                if (res.status === 409) {
                    let j;
                    try {
                        j = await res.json();
                    } catch (e) {
                        (0, $jUNyh.notify)("Resposta inv\xe1lida do servidor (409).", "Mover posi\xe7\xe3o inteira");
                        return;
                    }
                    if (j && j.error === 'move_location_reserve_conflict') {
                        const { msg: msg } = (0, $48324c8641eeba48$export$ea6fa4760ed71ffc)(j);
                        const flags = (0, $48324c8641eeba48$export$a234dae7099b11b9)(j);
                        if (!flags.canProceed) {
                            (0, $jUNyh.notify)(msg, "Mover posi\xe7\xe3o inteira");
                            return;
                        }
                        (0, $jUNyh.ask)(msg, "Mover posi\xe7\xe3o inteira", async (answer)=>{
                            if (answer !== 'Y') return;
                            const mb2 = (0, $jUNyh.default)({
                                animation: true
                            });
                            let res2;
                            try {
                                res2 = await fetch(url, {
                                    method: 'POST',
                                    body: JSON.stringify({
                                        ...payload,
                                        move_free_only: flags.move_free_only,
                                        include_blocked: flags.include_blocked
                                    }),
                                    credentials: 'include',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                });
                            } finally{
                                mb2.destroy();
                            }
                            if (!res2.ok) {
                                const t = await res2.text();
                                (0, $jUNyh.notify)(t || `${res2.status}`, "Mover posi\xe7\xe3o inteira");
                                return;
                            }
                            const out2 = await res2.json();
                            finishMoveOk(out2);
                        });
                        return;
                    }
                    (0, $jUNyh.notify)(j.message || "Conflito na movimenta\xe7\xe3o.", "Mover posi\xe7\xe3o inteira");
                    return;
                }
                if (!res.ok) {
                    const t = await res.text();
                    (0, $jUNyh.notify)(t || `${res.status}`, "Mover posi\xe7\xe3o inteira");
                    return;
                }
                const out = await res.json();
                finishMoveOk(out);
            };
            fs = (0, $h1m6J.default).create((0, $2f6e058b94e63850$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        },
        async deleteMovement () {
            const ids = this.getSelection();
            if (!ids.length) {
                (0, $jUNyh.notify)("Selecione ao menos uma movimenta\xe7\xe3o.", 'Excluir');
                return;
            }
            (0, $jUNyh.ask)(`Excluir ${ids.length} movimenta\xe7\xe3o(\xf5es)?`, 'Confirmar', async (answer)=>{
                if (answer !== 'Y') return;
                for (const raw of ids){
                    const [company_id, id] = JSON.parse(raw);
                    const r = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_transaction, company_id, id);
                    if (r === undefined) return;
                }
                (0, $jUNyh.notify)("Registro(s) exclu\xeddo(s).", 'Excluir');
                this.clearGridSelection();
                this.loadPage();
            });
        },
        movementControl () {
            const fs = (0, $h1m6J.default).create((0, $3610432dedc8a6e0$export$2e2bcd8739ae039), async (data)=>{
                const root = fs.form?.node || document.querySelector('#movement-control-form');
                const types = [];
                if (root?.querySelector('#type_ll')?.checked) types.push('LL');
                if (root?.querySelector('#type_lr')?.checked) types.push('LR');
                if (root?.querySelector('#type_ro')?.checked) types.push('RO');
                const format = (root?.querySelector('#format')?.value || data.format || 'json').toLowerCase();
                const view = (root?.querySelector('#view')?.value || data.view || 'moves').toLowerCase();
                const isMoves = view === 'moves';
                const unitLabel = isMoves ? 'movimento(s)' : "posi\xe7\xe3o(\xf5es)";
                const companyId = data.company_id;
                if (!companyId) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Aten\xe7\xe3o");
                    return false;
                }
                const dateFrom = data.date_from;
                const dateTo = data.date_to;
                if (!dateFrom || !dateTo) {
                    (0, $jUNyh.notify)("Informe o per\xedodo (De e At\xe9).", "Aten\xe7\xe3o");
                    return false;
                }
                if (dateTo < dateFrom) {
                    (0, $jUNyh.notify)('A data "At\xe9" deve ser igual ou posterior \xe0 data "De".', "Aten\xe7\xe3o");
                    return false;
                }
                if (!types.length) {
                    (0, $jUNyh.notify)("Marque ao menos um tipo de movimento (L\u2192L, L\u2192R ou R\u2192O).", "Aten\xe7\xe3o");
                    return false;
                }
                if (typeof (0, $9VcS9.default).movement_control_report !== 'function') {
                    (0, $jUNyh.notify)("Frontend desatualizado: recarregue a p\xe1gina com Ctrl+F5.", "Aten\xe7\xe3o");
                    return false;
                }
                const params = {
                    format: format,
                    view: view,
                    date_from: dateFrom,
                    date_to: dateTo,
                    types: types.join(','),
                    warehouse_id: data.warehouse_id || undefined
                };
                fs.destroy();
                try {
                    if (format === 'json') {
                        params.limit = 2000;
                        params.offset = 0;
                        const resp = await (0, $9VcS9.default).movement_control_report(companyId, params);
                        if (!resp.ok) {
                            const err = await resp.json().catch(()=>({}));
                            (0, $jUNyh.notify)(err?.error || err?.message || `Erro HTTP ${resp.status}`, 'Erro');
                            return;
                        }
                        const payload = await resp.json();
                        const rows = payload?.rows || [];
                        if (!rows.length) {
                            (0, $jUNyh.notify)(isMoves ? "Nenhuma movimenta\xe7\xe3o neste per\xedodo e filtros." : "Nenhuma posi\xe7\xe3o com movimenta\xe7\xe3o neste per\xedodo e filtros.", 'Resultado');
                            return;
                        }
                        const legendHtml = (payload.legend || []).filter((x)=>(payload.types || []).includes(x.key)).map((x)=>`<li><strong>${$6a3c457a33663b1a$var$escapeHtml(x.code)}</strong> \u{2014} ${$6a3c457a33663b1a$var$escapeHtml(x.label)}</li>`).join('');
                        const viewTitle = isMoves ? "Origem \xd7 Destino" : "Por posi\xe7\xe3o";
                        let headersHtml;
                        let filtersHtml;
                        let tbody;
                        if (isMoves) {
                            headersHtml = `
								<th>Data/Hora</th><th>Tipo</th>
								<th>Posi\xe7\xe3o origem</th><th>Posi\xe7\xe3o destino</th>
								<th class="tar">Qtd</th><th>SKU</th><th>Produto</th>`;
                            filtersHtml = [
                                0,
                                1,
                                2,
                                3,
                                4,
                                5,
                                6
                            ].map((i)=>`<th><input type="search" data-col="${i}" placeholder="Filtrar\u{2026}" aria-label="Filtrar coluna ${i}"></th>`).join('');
                            tbody = rows.map((r)=>{
                                const cells = [
                                    r.data_hora || "\u2014",
                                    r.tipo || "\u2014",
                                    r.posicao_origem || "\u2014",
                                    r.posicao_destino || "\u2014",
                                    String(r.quantidade ?? ''),
                                    r.sku || "\u2014",
                                    r.produto || "\u2014"
                                ];
                                const dataAttrs = cells.map((c, i)=>`data-c${i}="${$6a3c457a33663b1a$var$escapeHtml(String(c).toLowerCase())}"`).join(' ');
                                return `<tr class="mc-row" ${dataAttrs}>
									<td class="tac">${$6a3c457a33663b1a$var$escapeHtml(cells[0])}</td>
									<td class="tac">${$6a3c457a33663b1a$var$escapeHtml(cells[1])}</td>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[2])}</td>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[3])}</td>
									<td class="tar">${$6a3c457a33663b1a$var$escapeHtml(cells[4])}</td>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[5])}</td>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[6])}</td>
								</tr>`;
                            }).join('');
                        } else {
                            headersHtml = `
								<th>Armaz\xe9m</th><th>Posi\xe7\xe3o</th>
								<th class="tar">Mov.</th><th class="tac">\xdaltimo</th>
								<th>Tipos</th><th class="tar">SKUs</th><th class="tar">Saldo</th>`;
                            filtersHtml = [
                                0,
                                1,
                                2,
                                3,
                                4,
                                5,
                                6
                            ].map((i)=>`<th><input type="search" data-col="${i}" placeholder="Filtrar\u{2026}" aria-label="Filtrar coluna ${i}"></th>`).join('');
                            tbody = rows.map((r)=>{
                                const pos = r.posicao || r.endereco || "\u2014";
                                const cells = [
                                    r.armazem || "\u2014",
                                    pos,
                                    String(r.qtd_movimentos ?? ''),
                                    r.ultimo_movimento || "\u2014",
                                    r.tipos || "\u2014",
                                    String(r.skus_distintos ?? ''),
                                    String(r.saldo_atual ?? '')
                                ];
                                const dataAttrs = cells.map((c, i)=>`data-c${i}="${$6a3c457a33663b1a$var$escapeHtml(String(c).toLowerCase())}"`).join(' ');
                                return `<tr class="mc-row" ${dataAttrs}>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[0])}</td>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[1])}</td>
									<td class="tar">${$6a3c457a33663b1a$var$escapeHtml(cells[2])}</td>
									<td class="tac">${$6a3c457a33663b1a$var$escapeHtml(cells[3])}</td>
									<td>${$6a3c457a33663b1a$var$escapeHtml(cells[4])}</td>
									<td class="tar">${$6a3c457a33663b1a$var$escapeHtml(cells[5])}</td>
									<td class="tar">${$6a3c457a33663b1a$var$escapeHtml(cells[6])}</td>
								</tr>`;
                            }).join('');
                        }
                        const total = rows.length;
                        const aviso = total >= 2000 ? `<p class="fss" style="color:var(--color-muted);margin:0.4rem 0 0">Exibindo at\xe9 2000 linhas. Exporte CSV/Excel/PDF para o conjunto completo.</p>` : '';
                        const html = `
							<div class="msgbox mc-dialog" style="max-width:96vw;width:1100px">
								<style>
									.mc-dialog .mc-wrap { max-height:62vh; overflow:auto; border:1px solid #cbd5e1; border-radius:4px; }
									.mc-dialog table.mc-tbl { width:100%; min-width:900px; border-collapse:collapse; font-size:0.8rem; }
									.mc-dialog table.mc-tbl thead th {
										position:sticky; top:0; z-index:2;
										background:#1e3a5f; color:#fff; font-weight:600;
										padding:6px 8px; border:1px solid #16304f; white-space:nowrap;
									}
									.mc-dialog table.mc-tbl thead tr.mc-filters th {
										top:2.1rem; background:#f1f5f9; z-index:2; padding:4px 6px;
									}
									.mc-dialog table.mc-tbl thead tr.mc-filters input {
										width:100%; box-sizing:border-box; font-size:0.75rem;
										padding:3px 5px; border:1px solid #94a3b8; border-radius:3px;
									}
									.mc-dialog table.mc-tbl td {
										padding:5px 8px; border:1px solid #e2e8f0; vertical-align:middle;
									}
									.mc-dialog table.mc-tbl tbody tr:nth-child(even) td { background:#f8fafc; }
									.mc-dialog table.mc-tbl tbody tr:hover td { background:#e0f2fe; }
									.mc-dialog table.mc-tbl .tar { text-align:right; }
									.mc-dialog table.mc-tbl .tac { text-align:center; }
									.mc-dialog .mc-legend { margin:0.4rem 0 0.6rem 1.1rem; color:var(--color-muted); }
									.mc-dialog .mc-count { font-size:0.8rem; color:#475569; margin:0.35rem 0 0; }
								</style>
								<div class="mb-title">Controle de movimenta\xe7\xf5es (${$6a3c457a33663b1a$var$escapeHtml(viewTitle)}) \u{2014} ${$6a3c457a33663b1a$var$escapeHtml(dateFrom)} a ${$6a3c457a33663b1a$var$escapeHtml(dateTo)}</div>
								<ul class="fss mc-legend">${legendHtml}</ul>
								${aviso}
								<div class="mc-wrap">
									<table class="mc-tbl" id="mc-table">
										<thead>
											<tr>${headersHtml}</tr>
											<tr class="mc-filters">${filtersHtml}</tr>
										</thead>
										<tbody>${tbody}</tbody>
									</table>
								</div>
								<p class="mc-count" id="mc-count">Exibindo ${total} de ${total} ${unitLabel}</p>
								<div class="fsb mtm">
									<button type="button" class="button" id="btn-mc-csv">CSV</button>
									<button type="button" class="button" id="btn-mc-xlsx">Excel</button>
									<button type="button" class="button" id="btn-mc-pdf">PDF</button>
									<button type="button" class="button bn_N">Fechar</button>
								</div>
							</div>`;
                        const { default: dialog } = await Promise.resolve((parcelRequire("dx9qz")));
                        const dlg = dialog.create(html, (key)=>{
                            if (key === 'N' || key === 'Escape') dlg.destroy();
                        }, /N|Escape/);
                        const dlgRoot = dlg.getNode();
                        const applyFilters = ()=>{
                            const filters = [
                                ...dlgRoot.querySelectorAll('.mc-filters input')
                            ].map((inp)=>(inp.value || '').trim().toLowerCase());
                            let visible = 0;
                            dlgRoot.querySelectorAll('#mc-table tbody tr.mc-row').forEach((tr)=>{
                                const ok = filters.every((f, i)=>{
                                    if (!f) return true;
                                    return (tr.getAttribute(`data-c${i}`) || '').includes(f);
                                });
                                tr.style.display = ok ? '' : 'none';
                                if (ok) visible += 1;
                            });
                            const el = dlgRoot.querySelector('#mc-count');
                            if (el) el.textContent = `Exibindo ${visible} de ${total} ${unitLabel}`;
                        };
                        dlgRoot.querySelectorAll('.mc-filters input').forEach((inp)=>{
                            inp.addEventListener('input', applyFilters);
                        });
                        const exportFmt = async (fmt)=>{
                            try {
                                const r2 = await (0, $9VcS9.default).movement_control_report(companyId, {
                                    ...params,
                                    format: fmt
                                });
                                if (!r2.ok) {
                                    const err2 = await r2.json().catch(()=>({}));
                                    (0, $jUNyh.notify)(err2?.error || err2?.message || `Erro HTTP ${r2.status}`, 'Erro');
                                    return;
                                }
                                const result = await r2.json();
                                if (fmt === 'csv' && result?.csv) {
                                    $6a3c457a33663b1a$var$downloadBase64(result.csv, result.filename || 'controle-movimentacoes.csv', 'text/csv;charset=utf-8');
                                    (0, $jUNyh.notify)('Download CSV iniciado.', 'Sucesso');
                                } else if (fmt === 'xlsx' && result?.xlsx) {
                                    $6a3c457a33663b1a$var$downloadBase64(result.xlsx, result.filename || 'controle-movimentacoes.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                                    (0, $jUNyh.notify)('Download Excel iniciado.', 'Sucesso');
                                } else if (fmt === 'pdf' && result?.pdf) {
                                    $6a3c457a33663b1a$var$downloadBase64(result.pdf, result.filename || 'controle-movimentacoes.pdf', 'application/pdf');
                                    (0, $jUNyh.notify)('Download PDF iniciado.', 'Sucesso');
                                } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                            } catch (e) {
                                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                            }
                        };
                        dlgRoot.querySelector('#btn-mc-csv')?.addEventListener('click', ()=>exportFmt('csv'));
                        dlgRoot.querySelector('#btn-mc-xlsx')?.addEventListener('click', ()=>exportFmt('xlsx'));
                        dlgRoot.querySelector('#btn-mc-pdf')?.addEventListener('click', ()=>exportFmt('pdf'));
                        return;
                    }
                    const resp = await (0, $9VcS9.default).movement_control_report(companyId, params);
                    if (!resp.ok) {
                        const err = await resp.json().catch(()=>({}));
                        (0, $jUNyh.notify)(err?.error || err?.message || `Erro HTTP ${resp.status}`, 'Erro');
                        return;
                    }
                    const result = await resp.json();
                    if (format === 'csv' && result?.csv) {
                        $6a3c457a33663b1a$var$downloadBase64(result.csv, result.filename || 'controle-movimentacoes.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)(`CSV gerado (${result.rows ?? ''} ${unitLabel}).`, 'Sucesso');
                    } else if (format === 'xlsx' && result?.xlsx) {
                        $6a3c457a33663b1a$var$downloadBase64(result.xlsx, result.filename || 'controle-movimentacoes.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        (0, $jUNyh.notify)(`Excel gerado (${result.rows ?? ''} ${unitLabel}).`, 'Sucesso');
                    } else if (format === 'pdf' && result?.pdf) {
                        $6a3c457a33663b1a$var$downloadBase64(result.pdf, result.filename || 'controle-movimentacoes.pdf', 'application/pdf');
                        (0, $jUNyh.notify)(`PDF gerado (${result.rows ?? ''} ${unitLabel}).`, 'Sucesso');
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
            fs.init();
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Movimenta\xe7\xe3o",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador'
        },
        {
            index: 18,
            field: 'sku',
            label: 'SKU',
            types: [
                $74yTJ.default()
            ],
            placeholder: 'trecho do SKU',
            title: "C\xf3digo SKU do produto (operador Cont\xe9m recomendado)"
        },
        {
            index: 3,
            field: 'product_id',
            label: 'Produto',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Produto',
            store: 'products',
            labels: [
                'sku',
                'name'
            ]
        },
        {
            index: 4,
            field: 'lot_id',
            label: 'Lote',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Lote'
        },
        {
            index: 15,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m (escopo do filtro de posi\xe7\xe3o)",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 16,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $9PIz7.default(),
                $74yTJ.default()
            ],
            placeholder: '1-A-1-1',
            title: "Posi\xe7\xe3o no armaz\xe9m (lista ou texto parcial)",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 5,
            field: 'user_id',
            label: "Usu\xe1rio",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $8IFAz.default()
            ],
            placeholder: '',
            title: 'Data e hora'
        },
        {
            index: 7,
            field: 'source_type',
            label: 'Tipo Origem',
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de origem'
        },
        {
            index: 8,
            field: 'target_type',
            label: 'Tipo Destino',
            types: [
                $bdd84d0eadfe1c66$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de destino'
        },
        {
            index: 9,
            field: 'source',
            label: 'Origem',
            types: [],
            placeholder: '',
            title: 'Origem'
        },
        {
            index: 10,
            field: 'target',
            label: 'Destino',
            types: [],
            placeholder: '',
            title: 'Destino'
        },
        {
            index: 11,
            field: 'quantity',
            label: 'Quantidade',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade'
        },
        {
            index: 12,
            field: 'movement_kind',
            label: 'Natureza',
            types: [
                $3dfaf73b973524e9$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'MOV / RESUP / INV / BLOQ / UNPICK'
        },
        {
            index: 13,
            field: 'value',
            label: 'Valor',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor'
        }
    ];
    let operations = [
        {
            hash: '#move-location-bulk',
            label: "Mover&nbsp;posi\xe7\xe3o&nbsp;inteira"
        },
        {
            hash: '#delete-movements',
            label: 'Excluir'
        }
    ];
    let reports = [
        {
            hash: '#export-movements-csv',
            label: 'Exportar&nbsp;CSV'
        },
        {
            hash: '#export-movements-excel',
            label: 'Exportar&nbsp;Excel'
        },
        {
            hash: '#print-movements-pdf',
            label: 'Imprimir&nbsp;(PDF)'
        },
        {
            hash: '#movement-control',
            label: "Controle&nbsp;de&nbsp;movimenta\xe7\xf5es"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#move-location-bulk', movements_crud.moveLocationBulk.bind(movements_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#delete-movements', movements_crud.deleteMovement.bind(movements_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-movements-csv', movements_crud.exportMovementsCsv.bind(movements_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-movements-excel', movements_crud.exportMovementsExcel.bind(movements_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-movements-pdf', movements_crud.printMovementsPdf.bind(movements_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#movement-control', movements_crud.movementControl.bind(movements_crud));
    movements_crud.run('movements', "Movimenta\xe7\xf5es", document.getElementById('workarea'), (0, $f084953ddb61e33f$export$2e2bcd8739ae039), (0, $5bf775e5b7c2d7dd$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $6a3c457a33663b1a$export$2e2bcd8739ae039 = $6a3c457a33663b1a$var$movements;


/**
 * #MT-14DB846 — Doca Expedição (Movimentações).
 * Tela no padrão CRUD SIAL (grade + filtro + operações), como Saídas / Caixas Picking.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $h1m6J = parcelRequire("h1m6J");


var $jUNyh = parcelRequire("jUNyh");

var $8IFAz = parcelRequire("8IFAz");
async function $d957eb086e215cf6$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: left; }
			.dock-pos-ok { color: #166534; }
			.dock-pos-missing { color: #a30; font-style: italic; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="0" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="1" data-visible="${this.visible[1]}">Sa\xedda</th>
					<th data-index="2" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[3]}">Refer\xeancia</th>
					<th data-index="4" data-visible="${this.visible[4]}">Cliente</th>
					<th data-index="5" data-visible="${this.visible[5]}">Transportadora</th>
					<th data-index="6" data-visible="${this.visible[6]}">Armaz\xe9m Expedi\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[7]}">Posi\xe7\xe3o Expedi\xe7\xe3o</th>
					<th data-index="8" data-visible="${this.visible[8]}">Status</th>
					<th data-index="9" data-visible="${this.visible[9]}">Cria\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all((records || []).map(async (record)=>{
        const rowId = JSON.stringify([
            record.company_id,
            record.id
        ]);
        const companyNick = await this.key('companies', record.company_id, 'nick') || '';
        const customerNick = record.customer_nick || await this.key('customers', record.customer_id ? [
            record.company_id,
            record.customer_id
        ] : null, 'nick') || record.customer_name || '';
        const carrierNick = record.carrier_nick || await this.key('carriers', record.carrier_id ? [
            record.company_id,
            record.carrier_id
        ] : null, 'nick') || record.carrier_name || '';
        const whName = record.dock_warehouse_name || (record.dock_warehouse_id ? await this.key('warehouses', [
            record.company_id,
            record.dock_warehouse_id
        ]) || '' : '');
        const addr = record.dock_address || '';
        const hasDock = Boolean(addr || record.dock_warehouse_id && record.dock_location_id);
        return `<tr data-id='${rowId}'>
					<td><input type="checkbox"${this.isChecked(rowId)}></td>
					<td data-visible='${this.visible[0]}'>${companyNick}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id ?? ''}</td>
					<td data-visible='${this.visible[3]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[4]}'>${customerNick}</td>
					<td data-visible='${this.visible[5]}'>${carrierNick}</td>
					<td data-visible='${this.visible[6]}'>${whName}</td>
					<td data-visible='${this.visible[7]}' class="${hasDock ? 'dock-pos-ok' : 'dock-pos-missing'}">${hasDock ? addr || "\u2014" : "Sem posi\xe7\xe3o"}</td>
					<td data-visible='${this.visible[8]}'>${this.option($f08968bc7ef228cb$export$2e2bcd8739ae039(), record.status) || ''}</td>
					<td data-visible='${this.visible[9]}'>${this.format($8IFAz.default(), record.created_on) || ''}</td>
				</tr>`;
    }))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var /**
 * Formulário — vincular posição de Expedição (#MT-14DB846).
 * Padrão SIAL: datalist com nick/nome/endereço; busca case-sensitive; sem IDs na UI.
 */ $c131024afd6dc7db$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#dock-expedition .company { width: 14rem; }
			#dock-expedition .warehouse { width: 14rem; }
			#dock-expedition .location { width: 12rem; }
			#dock-expedition #output_id { width: 6rem; text-align: right; }
			#dock-expedition #order_id { width: 6rem; text-align: right; }
			#dock-expedition #reference { width: 16rem; }
		</style>
		<form id="dock-expedition" class="form" autocomplete="off" novalidate>
			<datalist id="dock-companies"></datalist>
			<datalist id="dock-warehouses"></datalist>
			<datalist id="dock-locations"></datalist>
			<div class="title">Vincular posi\xe7\xe3o de Expedi\xe7\xe3o</div>
			<p class="mts muted" style="max-width:40rem">
				Informe o armaz\xe9m e a posi\xe7\xe3o marcada como <strong>Expedi\xe7\xe3o</strong>.
				A busca do endere\xe7o \xe9 case-sensitive (<code>D-01</code> \u{2260} <code>d-01</code>).
			</p>
			<div class="fsb mtl">
				<label title="Empresa depositante">Empresa<sup>*</sup>
					<input id="company_id" class="company" type="text" list="dock-companies" required readonly>
				</label>
				<label title="N\xfamero da sa\xedda">Sa\xedda
					<input id="output_id" type="text" readonly>
				</label>
				<label title="N\xfamero do pedido">Pedido
					<input id="order_id" type="text" readonly>
				</label>
				<label title="Refer\xeancia do pedido">Refer\xeancia
					<input id="reference" type="text" readonly>
				</label>
			</div>
			<div class="fsb">
				<label title="Armaz\xe9m da posi\xe7\xe3o de Expedi\xe7\xe3o">Armaz\xe9m<sup>*</sup>
					<input id="dock_warehouse_id" class="warehouse" type="text" list="dock-warehouses" required placeholder="Lista ap\xf3s empresa">
				</label>
				<label title="Posi\xe7\xe3o tipo Expedi\xe7\xe3o \u{2014} digite ou escolha o endere\xe7o">Posi\xe7\xe3o Expedi\xe7\xe3o<sup>*</sup>
					<input id="dock_location_id" class="location" type="text" list="dock-locations" required
						placeholder="Ap\xf3s o armaz\xe9m"
						title="Somente posi\xe7\xf5es com Expedi\xe7\xe3o. Busca case-sensitive.">
				</label>
				<span></span>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#dock-expedition',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#dock-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: []
        },
        {
            properties: {
                selector: '#dock_warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#dock_location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default({
                    caseSensitive: true
                }),
                $6lTH5.default([
                    'company_id',
                    'dock_warehouse_id'
                ]),
                $f0a98998622cf31a$export$2e2bcd8739ae039({
                    companyKey: 'company_id',
                    warehouseKey: 'dock_warehouse_id',
                    isExpedition: true
                })
            ]
        }
    ]
};



var /**
 * Formulário de impressão — Romaneio de Transportadora (Doca Expedição).
 * Campos de motorista/placa/data são opcionais (saem em branco no PDF para preenchimento manual).
 */ $d324168d8e485e55$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#dock-romaneio #driver_name { width: 16rem; }
			#dock-romaneio #vehicle_plate { width: 8rem; }
			#dock-romaneio #driver_doc { width: 10rem; }
			#dock-romaneio #operation_nature { width: 10rem; }
			#dock-romaneio #departure_date { width: 8rem; }
			#dock-romaneio #departure_time { width: 6rem; }
			#dock-romaneio #notes { width: 28rem; }
		</style>
		<form id="dock-romaneio" class="form" autocomplete="off" novalidate>
			<div class="title">Romaneio de Transportadora</div>
			<p class="mts muted" style="max-width:36rem">
				Gera o PDF das sa\xeddas selecionadas na Doca Expedi\xe7\xe3o, agrupadas por transportadora.
				Motorista, placa e documentos podem ficar em branco para preenchimento na sa\xedda.
			</p>
			<div class="fsb mtl">
				<label title="Nome do motorista">Motorista
					<input id="driver_name" type="text" placeholder="Opcional">
				</label>
				<label title="Placa do ve\xedculo">Placa
					<input id="vehicle_plate" type="text" placeholder="ABC1D23">
				</label>
				<label title="CPF ou RG do motorista">CPF/RG
					<input id="driver_doc" type="text" placeholder="Opcional">
				</label>
			</div>
			<div class="fsb">
				<label title="Natureza da opera\xe7\xe3o">Natureza
					<input id="operation_nature" type="text" value="VENDA">
				</label>
				<label title="Data de sa\xedda">Data sa\xedda
					<input id="departure_date" type="text" placeholder="dd/mm/aaaa">
				</label>
				<label title="Hora de sa\xedda">Hora
					<input id="departure_time" type="text" placeholder="HH:MM">
				</label>
			</div>
			<div class="fsb">
				<label title="Observa\xe7\xe3o impressa no romaneio">Observa\xe7\xe3o
					<input id="notes" type="text" placeholder="Opcional">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#dock-romaneio',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
            const now = new Date();
            const p = (n)=>String(n).padStart(2, '0');
            formset.form.setValues({
                operation_nature: 'VENDA',
                departure_date: `${p(now.getDate())}/${p(now.getMonth() + 1)}/${now.getFullYear()}`,
                departure_time: `${p(now.getHours())}:${p(now.getMinutes())}`
            });
            formset.form.refresh();
        }
    },
    fields: [
        {
            properties: {
                selector: '#driver_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#vehicle_plate'
            },
            types: []
        },
        {
            properties: {
                selector: '#driver_doc'
            },
            types: []
        },
        {
            properties: {
                selector: '#operation_nature'
            },
            types: []
        },
        {
            properties: {
                selector: '#departure_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#departure_time'
            },
            types: []
        },
        {
            properties: {
                selector: '#notes'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");

var $7WMRl = parcelRequire("7WMRl");
function $ab77588e26c17613$var$isCountQuery(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    return qs.get('group') === 'count';
}
function $ab77588e26c17613$var$pageBounds(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    const limit = Number(qs.get('limit') || 30);
    const offset = Number(qs.get('offset') || 0);
    return {
        limit: Number.isFinite(limit) ? limit : 30,
        offset: Number.isFinite(offset) ? offset : 0
    };
}
function $ab77588e26c17613$var$filtersToParams(filterData) {
    const params = {};
    for(let i = 0; i < 12; i++){
        const field = filterData?.[`field-${i}`];
        const value = filterData?.[`value-${i}`];
        if (!field || value == null || value === '') continue;
        if ([
            'company_id',
            'carrier_id',
            'reference',
            'order_id',
            'id',
            'output_id'
        ].includes(field)) params[field === 'output_id' ? 'id' : field] = value;
    }
    return params;
}
function $ab77588e26c17613$var$normalizeRow(row) {
    const id = Number(row.output_id ?? row.id);
    return {
        ...row,
        id: id,
        output_id: id,
        status: Number(row.status) || 75
    };
}
function $ab77588e26c17613$var$hasDock(row) {
    return Boolean(row?.dock_address || row?.dock_warehouse_id && row?.dock_location_id);
}
const $ab77588e26c17613$var$dockExpedition = function() {
    const dock_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        _lastSearchKey: null,
        _lastSearchRows: null,
        insertRecord () {
            (0, $jUNyh.notify)("Esta tela lista sa\xeddas j\xe1 em Doca Expedi\xe7\xe3o. Use Filtrar / Opera\xe7\xf5es para vincular posi\xe7\xe3o ou avan\xe7ar.", "Doca Expedi\xe7\xe3o");
        },
        async loadBaseData () {
            const q = this.queryAll();
            const [companies, warehouses, carriers, customers] = await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_carriers, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, q)
            ]);
            await Promise.all([
                (0, $1cmSR.default).set('companies', companies || []).catch(()=>{}),
                (0, $1cmSR.default).set('warehouses', warehouses || []).catch(()=>{}),
                (0, $1cmSR.default).set('carriers', carriers || []).catch(()=>{}),
                (0, $1cmSR.default).set('customers', customers || []).catch(()=>{})
            ]);
        },
        async queryData (query) {
            const filterParams = $ab77588e26c17613$var$filtersToParams(this.filter || {});
            let companies = filterParams.company_id ? [
                {
                    id: filterParams.company_id
                }
            ] : await (0, $1cmSR.default).list('companies').catch(()=>[]);
            if (!companies?.length) companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
            // Evita varrer tenants com param OFF (http.js mostra modal «Atenção» em cada 400).
            // Cache IndexedDB antigo sem o campo: ainda consulta (API lista devolve []).
            companies = (companies || []).filter((c)=>{
                if (!c) return false;
                const v = c.out_dock_expedition_enabled;
                if (v === false || v === 0 || v === '0' || v === 'false') return false;
                return true;
            });
            if (!companies.length) return $ab77588e26c17613$var$isCountQuery(query) ? 0 : [];
            const searchKey = JSON.stringify({
                companies: companies.map((c)=>c.id).sort(),
                carrier_id: filterParams.carrier_id || '',
                reference: filterParams.reference || '',
                order_id: filterParams.order_id || '',
                id: filterParams.id || ''
            });
            let rows = this._lastSearchKey === searchKey && Array.isArray(this._lastSearchRows) ? this._lastSearchRows : null;
            if (!rows) {
                const lists = await Promise.all(companies.map(async (company)=>{
                    const q = new URLSearchParams();
                    q.set('limit', '500');
                    if (filterParams.carrier_id) q.set('carrier_id', String(filterParams.carrier_id));
                    if (filterParams.reference) q.set('reference', String(filterParams.reference));
                    try {
                        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_dock_expedition, company.id, `?${q.toString()}`);
                        return (Array.isArray(data) ? data : []).map($ab77588e26c17613$var$normalizeRow);
                    } catch (e) {
                        console.warn('dock-expedition list', company.id, e);
                        return [];
                    }
                }));
                rows = lists.flat();
                if (filterParams.order_id) rows = rows.filter((r)=>Number(r.order_id) === Number(filterParams.order_id));
                if (filterParams.id) rows = rows.filter((r)=>Number(r.id) === Number(filterParams.id));
                this._lastSearchKey = searchKey;
                this._lastSearchRows = rows;
            }
            if ($ab77588e26c17613$var$isCountQuery(query)) return rows.length;
            const { limit: limit, offset: offset } = $ab77588e26c17613$var$pageBounds(query);
            return rows.slice(offset, offset + limit);
        },
        async reloadPage () {
            this._lastSearchKey = null;
            this._lastSearchRows = null;
            return Object.getPrototypeOf(this).reloadPage.call(this);
        },
        async loadRecord (id) {
            const [company_id, output_id] = JSON.parse(id);
            const cached = (this._lastSearchRows || []).find((r)=>String(r.company_id) === String(company_id) && Number(r.id) === Number(output_id));
            if (cached) return {
                company_id: cached.company_id,
                output_id: cached.id,
                order_id: cached.order_id,
                reference: cached.reference || '',
                dock_warehouse_id: cached.dock_warehouse_id || '',
                dock_location_id: cached.dock_location_id || '',
                _dock_address: cached.dock_address || ''
            };
            const row = await (0, $9VcS9.default).call((0, $9VcS9.default).select_dock_expedition, company_id, output_id);
            const n = $ab77588e26c17613$var$normalizeRow(row);
            return {
                company_id: n.company_id,
                output_id: n.id,
                order_id: n.order_id,
                reference: n.reference || '',
                dock_warehouse_id: n.dock_warehouse_id || '',
                dock_location_id: n.dock_location_id || '',
                _dock_address: n.dock_address || ''
            };
        },
        async saveRecord (data) {
            const co = await (0, $7WMRl.resolveCompanyId)(data.company_id) || data.company_id;
            const wh = await (0, $7WMRl.resolveWarehouseId)(co, data.dock_warehouse_id);
            let loc = Number(data.dock_location_id);
            if (!Number.isInteger(loc) || loc < 1) loc = await (0, $7WMRl.resolveLocationIdForMove)(co, wh, data.dock_location_id, {
                isExpedition: true
            });
            if (!co) throw new Error('Selecione a empresa na lista (nick).');
            if (!Number.isInteger(wh) || wh < 1) throw new Error("Selecione o armaz\xe9m na lista (nome).");
            if (!Number.isInteger(loc) || loc < 1) throw new Error("Posi\xe7\xe3o inv\xe1lida. Use um endere\xe7o de Expedi\xe7\xe3o da lista (case-sensitive).");
            await (0, $9VcS9.default).call((0, $9VcS9.default).patch_dock_expedition, co, data.output_id, {
                dock_warehouse_id: wh,
                dock_location_id: loc
            });
            this._lastSearchKey = null;
            this._lastSearchRows = null;
            return {};
        },
        editRecord (data) {
            const initial = {
                ...data
            };
            const addr = data._dock_address;
            delete initial._dock_address;
            const fs = (0, $h1m6J.default).create((0, $c131024afd6dc7db$export$2e2bcd8739ae039), async (formData)=>{
                try {
                    await this.saveRecord(formData);
                    (0, $jUNyh.notify)("Posi\xe7\xe3o de Expedi\xe7\xe3o vinculada.", 'Sucesso');
                    fs.destroy();
                    await this.reloadPage();
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), "Doca Expedi\xe7\xe3o");
                }
            });
            const origInit = fs.init.bind(fs);
            fs.init = function() {
                origInit();
                fs.form.setValues(initial);
                fs.form.refresh();
                if (addr) {
                    const locNode = fs.dialog.getNode().querySelector('#dock_location_id');
                    if (locNode) locNode.value = addr;
                }
            };
            fs.init();
        },
        async dockLink () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente uma sa\xedda para vincular a posi\xe7\xe3o.", "Doca Expedi\xe7\xe3o");
                return;
            }
            const data = await this.loadRecord(JSON.stringify(ids[0]));
            this.editRecord(data);
        },
        async dockAdvance () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) {
                (0, $jUNyh.notify)("Selecione ao menos uma sa\xedda.", "Doca Expedi\xe7\xe3o");
                return;
            }
            const byCompany = new Map();
            for (const [company_id, output_id] of ids){
                const row = (this._lastSearchRows || []).find((r)=>String(r.company_id) === String(company_id) && Number(r.id) === Number(output_id));
                if (!$ab77588e26c17613$var$hasDock(row)) {
                    (0, $jUNyh.notify)(`Sa\xedda ${output_id} sem posi\xe7\xe3o de Expedi\xe7\xe3o. Vincule antes de avan\xe7ar.`, "Aten\xe7\xe3o");
                    return;
                }
                if (!byCompany.has(company_id)) byCompany.set(company_id, []);
                byCompany.get(company_id).push(Number(output_id));
            }
            (0, $jUNyh.ask)(`Confirma avan\xe7ar ${ids.length} sa\xedda(s)? Ser\xe1 feita a baixa de estoque (R\u{2192}O) e a conclus\xe3o.`, "Avan\xe7ar Doca Expedi\xe7\xe3o", (key)=>{
                if (key !== 'Y') return;
                (async ()=>{
                    try {
                        let total = 0;
                        let errN = 0;
                        for (const [company_id, output_ids] of byCompany){
                            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).advance_dock_expedition, company_id, {
                                output_ids: output_ids
                            });
                            total += resp?.count ?? 0;
                            errN += (resp?.errors || []).length;
                            if (resp?.errors?.length) console.warn('dock-expedition advance', resp.errors);
                        }
                        (0, $jUNyh.notify)(`Avan\xe7adas: ${total}.${errN ? ` Falhas: ${errN}.` : ''}`, errN ? "Aten\xe7\xe3o" : 'Sucesso');
                        await this.reloadPage();
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), "Doca Expedi\xe7\xe3o");
                    }
                })();
            });
        },
        async _selectedByCompany () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) {
                (0, $jUNyh.notify)("Selecione ao menos uma sa\xedda.", "Doca Expedi\xe7\xe3o");
                return null;
            }
            const byCompany = new Map();
            for (const [company_id, output_id] of ids){
                if (!byCompany.has(company_id)) byCompany.set(company_id, []);
                byCompany.get(company_id).push(Number(output_id));
            }
            return byCompany;
        },
        printRomaneio () {
            (async ()=>{
                const byCompany = await this._selectedByCompany();
                if (!byCompany) return;
                if (byCompany.size > 1) {
                    (0, $jUNyh.notify)("Selecione sa\xeddas de uma \xfanica empresa por vez para o romaneio.", 'Romaneio');
                    return;
                }
                const [company_id, output_ids] = [
                    ...byCompany.entries()
                ][0];
                const fs = (0, $h1m6J.default).create((0, $d324168d8e485e55$export$2e2bcd8739ae039), async (data)=>{
                    try {
                        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_dock_romaneio, company_id, {
                            output_ids: output_ids,
                            driver_name: data.driver_name || '',
                            vehicle_plate: data.vehicle_plate || '',
                            driver_doc: data.driver_doc || '',
                            operation_nature: data.operation_nature || 'VENDA',
                            departure_date: data.departure_date || '',
                            departure_time: data.departure_time || '',
                            notes: data.notes || ''
                        });
                        if (resp?.pdf) {
                            (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                            fs.destroy();
                        } else (0, $jUNyh.notify)('Nenhum PDF retornado.', 'Romaneio');
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Romaneio');
                    }
                });
                fs.init();
            })();
        },
        printAvisoRemessa () {
            (async ()=>{
                const byCompany = await this._selectedByCompany();
                if (!byCompany) return;
                const n = [
                    ...byCompany.values()
                ].reduce((a, b)=>a + b.length, 0);
                (0, $jUNyh.ask)(`Incluir ${n} sa\xedda(s) no Aviso de Remessa?`, 'Aviso de Remessa', (answer)=>{
                    if (answer !== 'Y') return;
                    (async ()=>{
                        try {
                            for (const [company_id, output_ids] of byCompany){
                                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_dock_aviso_remessa, company_id, {
                                    output_ids: output_ids
                                });
                                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                                else (0, $jUNyh.notify)('Nenhum PDF retornado para a empresa selecionada.', 'Aviso de Remessa');
                            }
                        } catch (e) {
                            (0, $jUNyh.notify)(e?.message || String(e), 'Aviso de Remessa');
                        }
                    })();
                });
            })();
        }
    });
    const fieldspecs = [
        {
            index: 0,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 1,
            field: 'id',
            label: "Sa\xedda",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da sa\xedda"
        },
        {
            index: 2,
            field: 'order_id',
            label: 'Pedido',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero do pedido"
        },
        {
            index: 3,
            field: 'reference',
            label: "Refer\xeancia",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Refer\xeancia do pedido"
        },
        {
            index: 4,
            field: 'customer_id',
            label: 'Cliente',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Cliente',
            store: 'customers',
            labels: [
                'nick'
            ]
        },
        {
            index: 5,
            field: 'carrier_id',
            label: 'Transportadora',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Transportadora',
            store: 'carriers',
            labels: [
                'nick'
            ]
        },
        {
            index: 6,
            field: 'dock_warehouse_id',
            label: "Armaz\xe9m Expedi\xe7\xe3o",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m da doca",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 7,
            field: 'dock_location_id',
            label: "Posi\xe7\xe3o Expedi\xe7\xe3o",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Endere\xe7o da posi\xe7\xe3o de Expedi\xe7\xe3o"
        },
        {
            index: 8,
            field: 'status',
            label: 'Status',
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Status da sa\xedda"
        },
        {
            index: 9,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: '',
            title: "Data/hora de cria\xe7\xe3o"
        }
    ];
    const operations = [
        {
            hash: '#dock-link',
            label: "Vincular&nbsp;posi\xe7\xe3o"
        },
        {
            hash: '#dock-advance',
            label: "Avan\xe7ar&nbsp;selecionadas"
        }
    ];
    const reports = [
        {
            hash: '#dock-print-romaneio',
            label: 'Romaneio&nbsp;de&nbsp;Transportadora'
        },
        {
            hash: '#dock-print-ar',
            label: 'Aviso&nbsp;de&nbsp;Remessa'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#dock-link', ()=>dock_crud.dockLink());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#dock-advance', ()=>dock_crud.dockAdvance());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#dock-print-romaneio', ()=>dock_crud.printRomaneio());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#dock-print-ar', ()=>dock_crud.printAvisoRemessa());
    dock_crud.run('dock-expedition', "Doca Expedi\xe7\xe3o", document.getElementById('workarea'), (0, $d957eb086e215cf6$export$2e2bcd8739ae039), (0, $c131024afd6dc7db$export$2e2bcd8739ae039), fieldspecs, operations, reports, {
        default_columns: '0,1,2,3,4,5,6,7,8,9'
    });
};
var $ab77588e26c17613$export$2e2bcd8739ae039 = $ab77588e26c17613$var$dockExpedition;


/**
 * #MT-B2FA396 — Fase 3B: UI gerencial Agendamento de Docas de Entrada.
 * Menu Movimentação → Agendamento de Docas (#input-dock-schedules).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");

/**
 * Rótulos UI — Agendamento de Docas de Entrada (#MT-B2FA396 Fase 3B).
 */ const $aecc276d35afe90f$export$30c5025b669b92cb = {
    DRY: 'Seca',
    REFRIGERATED: 'Refrigerada',
    CLIMATE_CONTROLLED: 'Climatizada',
    MIXED: 'Mista'
};
const $aecc276d35afe90f$export$4429537025aeeb07 = {
    SCHEDULED: 'Agendado',
    IN_RECEIVING: 'Em recebimento',
    COMPLETED: "Conclu\xeddo",
    CANCELLED: 'Cancelado',
    NO_SHOW: "N\xe3o compareceu"
};
const $aecc276d35afe90f$export$eac44da0b331984b = {
    CREATED: 'Criado',
    CANCELLED: 'Cancelado',
    RESCHEDULED: 'Reagendado',
    STATUS_CHANGED: 'Status alterado',
    OCCURRENCE_ADDED: "Ocorr\xeancia adicionada",
    DOCK_CHANGED: 'Doca alterada'
};
const $aecc276d35afe90f$export$7e93155538a57a64 = {
    no_working_hours: "Sem hor\xe1rio de funcionamento neste dia",
    class_incompatible: "Incompat\xedvel com as classes do pedido",
    thermal_dry: "Pedido refrigerado n\xe3o cabe em doca seca"
};
const $aecc276d35afe90f$export$3717d3ff7ac78338 = new Set([
    'SCHEDULED',
    'IN_RECEIVING'
]);
const $aecc276d35afe90f$export$b1957ca91e18269d = "Agendamento de Docas de Entrada n\xe3o est\xe1 habilitado para esta empresa.";
function $aecc276d35afe90f$export$a954299e2515e375(status) {
    return $aecc276d35afe90f$export$4429537025aeeb07[status] || status || "\u2014";
}
function $aecc276d35afe90f$export$17ff6761b39ffe92(dockType) {
    return $aecc276d35afe90f$export$30c5025b669b92cb[dockType] || dockType || "\u2014";
}
function $aecc276d35afe90f$export$ed661ffc2b635f11(eventType) {
    return $aecc276d35afe90f$export$eac44da0b331984b[eventType] || eventType || "\u2014";
}
function $aecc276d35afe90f$export$7b0fe6d159d434db(reason) {
    if (!reason) return '';
    return $aecc276d35afe90f$export$7e93155538a57a64[reason] || String(reason);
}
function $aecc276d35afe90f$export$3ae94a2503e890a1(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
function $aecc276d35afe90f$export$c5be672fb676f885(iso) {
    if (!iso) return "\u2014";
    const d = iso instanceof Date ? iso : new Date(iso);
    if (Number.isNaN(d.getTime())) {
        const raw = String(iso);
        const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
        return m ? `${m[3]}/${m[2]}/${m[1]}` : raw;
    }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${day}/${m}/${y}`;
}
function $aecc276d35afe90f$export$3203edd9e5edd663(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
        const m = String(iso).match(/T(\d{2}:\d{2})/);
        return m ? m[1] : "\u2014";
    }
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
function $aecc276d35afe90f$export$3db432bf1df9ac80(status) {
    return $aecc276d35afe90f$export$3717d3ff7ac78338.has(status);
}


function $d409cdbc5b061218$var$esc(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $d409cdbc5b061218$var$statusBadge(status) {
    const label = (0, $aecc276d35afe90f$export$a954299e2515e375)(status);
    const cls = {
        SCHEDULED: 'ids-st-scheduled',
        IN_RECEIVING: 'ids-st-receiving',
        COMPLETED: 'ids-st-completed',
        CANCELLED: 'ids-st-cancelled',
        NO_SHOW: 'ids-st-noshow'
    }[status] || 'ids-st-other';
    return `<span class="ids-badge ${cls}">${$d409cdbc5b061218$var$esc(label)}</span>`;
}
async function $d409cdbc5b061218$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view .ids-badge {
				display: inline-block;
				padding: 0.12rem 0.5rem;
				border-radius: 0.3rem;
				font-size: 0.78rem;
				font-weight: 600;
				white-space: nowrap;
			}
			.view .ids-st-scheduled { background: #dbeafe; color: #1e3a8a; }
			.view .ids-st-receiving { background: #ede9fe; color: #5b21b6; }
			.view .ids-st-completed { background: #d1fae5; color: #065f46; }
			.view .ids-st-cancelled { background: #e5e7eb; color: #4b5563; }
			.view .ids-st-noshow { background: #fee2e2; color: #991b1b; }
			.view .ids-st-other { background: #f3f4f6; color: #374151; }
			.view .ids-type { background: #e0e7ff; color: #3730a3; }
			.view .ids-occ { background: #fef3c7; color: #92400e; }
			.view .ids-time { font-variant-numeric: tabular-nums; white-space: nowrap; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Data</th>
					<th data-index="2" data-visible="${this.visible[1]}">Hor\xe1rio</th>
					<th data-index="3" data-visible="${this.visible[2]}">Doca</th>
					<th data-index="4" data-visible="${this.visible[3]}">Tipo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Armaz\xe9m</th>
					<th data-index="6" data-visible="${this.visible[5]}">Pedido Entrada</th>
					<th data-index="7" data-visible="${this.visible[6]}">NF</th>
					<th data-index="8" data-visible="${this.visible[7]}">Volumes</th>
					<th data-index="9" data-visible="${this.visible[8]}">Fornecedor</th>
					<th data-index="10" data-visible="${this.visible[9]}">Respons\xe1vel</th>
					<th data-index="11" data-visible="${this.visible[10]}">Status</th>
					<th data-index="12" data-visible="${this.visible[11]}">Ocorr\xeancia</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>{
        const start = record.scheduled_start;
        const end = record.scheduled_end;
        const timeRange = `${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(start)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(end)}`;
        const dockName = record.dock_name || await this.key('input_docks', [
            record.company_id,
            record.dock_id
        ], 'name') || record.dock_id || "\u2014";
        const typeLabel = record.dock_type_label || (0, $aecc276d35afe90f$export$17ff6761b39ffe92)(record.dock_type) || "\u2014";
        const occ = record.has_occurrence ? '<span class="ids-badge ids-occ">Com ocorr\xeancia</span>' : "\u2014";
        const nf = record.invoice_number ?? '';
        return `<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}' class="ids-time">${$d409cdbc5b061218$var$esc((0, $aecc276d35afe90f$export$3ae94a2503e890a1)(start))}</td>
					<td data-visible='${this.visible[1]}' class="ids-time">${$d409cdbc5b061218$var$esc(timeRange)}</td>
					<td data-visible='${this.visible[2]}'>${$d409cdbc5b061218$var$esc(dockName)}</td>
					<td data-visible='${this.visible[3]}'><span class="ids-badge ids-type">${$d409cdbc5b061218$var$esc(typeLabel)}</span></td>
					<td data-visible='${this.visible[4]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ], 'name')}</td>
					<td data-visible='${this.visible[5]}'>${$d409cdbc5b061218$var$esc(record.input_order_id ?? "\u2014")}</td>
					<td data-visible='${this.visible[6]}'>${$d409cdbc5b061218$var$esc(nf || "\u2014")}</td>
					<td data-visible='${this.visible[7]}'>${$d409cdbc5b061218$var$esc(record.volumes ?? "\u2014")}</td>
					<td data-visible='${this.visible[8]}'>${record.supplier_id != null ? await this.key('suppliers', [
            record.company_id,
            record.supplier_id
        ], 'nick') : "\u2014"}</td>
					<td data-visible='${this.visible[9]}'>${record.responsible_user_id ? await this.key('users', record.responsible_user_id, 'name') : "\u2014"}</td>
					<td data-visible='${this.visible[10]}'>${$d409cdbc5b061218$var$statusBadge(record.status)}</td>
					<td data-visible='${this.visible[11]}'>${occ}</td>
				</tr>`;
    }))).join('') + `
			</tbody>
		</table>
	`;
}


/**
 * Detalhe do agendamento de doca (#MT-B2FA396 Fase 3B).
 */ const $82e8a93ec86d36b7$var$ICO_CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';
var $82e8a93ec86d36b7$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input_dock_schedule_detail .ids-tl {
				list-style: none;
				margin: 0;
				padding: 0;
			}
			#input_dock_schedule_detail .ids-tl li {
				position: relative;
				padding: 0.55rem 0.75rem 0.55rem 1.35rem;
				border-left: 2px solid #c7d2fe;
				margin-left: 0.4rem;
			}
			#input_dock_schedule_detail .ids-tl li::before {
				content: '';
				position: absolute;
				left: -0.4rem;
				top: 0.75rem;
				width: 0.55rem;
				height: 0.55rem;
				border-radius: 50%;
				background: #4c1d95;
			}
			#input_dock_schedule_detail .ids-tl .ids-tl-type {
				font-weight: 600;
				color: #1e3a8a;
			}
			#input_dock_schedule_detail .ids-tl .ids-tl-when {
				font-size: 0.78rem;
				color: #6b7280;
			}
			#input_dock_schedule_detail .ids-kv {
				display: grid;
				grid-template-columns: 8.5rem 1fr;
				gap: 0.25rem 0.75rem;
				font-size: 0.88rem;
			}
			#input_dock_schedule_detail .ids-kv dt { color: #6b7280; }
			#input_dock_schedule_detail .ids-kv dd { margin: 0; color: #111827; }
		</style>
		<form id="input_dock_schedule_detail" class="form sial-modal-form sial-detail" autocomplete="off">
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${$82e8a93ec86d36b7$var$ICO_CAL}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Movimenta\xe7\xe3o \xb7 Agendamento de Docas</p>
						<h2 class="sdp-title" data-sdp="title">Detalhe do agendamento</h2>
						<div class="sdp-meta">
							<span>ID: <b data-sdp="id">\u{2014}</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="status">\u{2014}</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>

			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Dados principais</h3>
					<dl class="ids-kv" id="ids_detail_main"></dl>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">Pedido / fornecedor</h3>
					<dl class="ids-kv" id="ids_detail_order"></dl>
					<p class="sdp-hint" id="ids_detail_notes"></p>
				</div>
			</section>

			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Hist\xf3rico de eventos</h3>
					<ul class="ids-tl" id="ids_detail_events"></ul>
				</div>
				<div class="sdp-block" id="ids_detail_occ_block" hidden>
					<h3 class="sdp-block-title">Ocorr\xeancias</h3>
					<ul class="ids-tl" id="ids_detail_occs"></ul>
				</div>
			</div>

			<div class="sdp-foot">
				<button type="button" class="button" id="ids_detail_cancel">Cancelar agendamento</button>
				<button type="button" class="button" id="ids_detail_reschedule">Reagendar</button>
				<button class="bn_Escape button">Fechar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input_dock_schedule_detail',
        init () {
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: []
};


/**
 * Cancelamento de agendamento de doca (#MT-B2FA396 Fase 3B).
 */ var $be8ea4d1984c1298$export$2e2bcd8739ae039 = {
    html: `
		<form id="input_dock_schedule_cancel" class="form sial-modal-form" autocomplete="off">
			<header style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.75rem;">
				<h2 style="margin:0;font-size:1.1rem;color:#1e3a8a;">Cancelar agendamento</h2>
				<button type="button" class="bn_Escape button" title="Fechar">\xd7</button>
			</header>
			<p style="margin:0 0 0.75rem;color:#4b5563;font-size:0.9rem;">
				Informe o motivo do cancelamento. O agendamento permanece na listagem com status <strong>Cancelado</strong>.
			</p>
			<label title="Motivo">Motivo<sup>*</sup>
				<textarea id="cancel_reason" required maxlength="1000" rows="4" style="width:100%;box-sizing:border-box;"></textarea>
			</label>
			<div style="display:flex;gap:0.5rem;justify-content:flex-end;margin-top:1rem;">
				<button class="bn_Escape button">Voltar</button>
				<button class="bn_Enter button">Confirmar cancelamento</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input_dock_schedule_cancel',
        init () {
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#cancel_reason'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $1Wvh7 = parcelRequire("1Wvh7");


var $h1m6J = parcelRequire("h1m6J");

function $dfcee61d129e0b80$export$2e2bcd8739ae039(...args) {
    return {
        options: Object.entries((0, $aecc276d35afe90f$export$4429537025aeeb07)).map(([value, label])=>({
                value: value,
                label: label
            })),
        captureEvents (_this = this) {
            (0, $h1m6J.loadOptions)(this.selector, this.options);
            this.safeProtoCall(_this);
        }
    };
}



var $7WMRl = parcelRequire("7WMRl");
/**
 * UI compartilhada — Agendamento de Docas (#MT-B2FA396 Fase 3B/4).
 * Usado por Movimentação → Agendamento de Docas e Pedidos de Entrada.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");

var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");
/**
 * Formulário criar/reagendar agendamento de doca (#MT-B2FA396 Fase 3B).
 * UI de availability (cards/chips) montada pelo CRUD via bindAvailabilityUi.
 */ 
var $9PIz7 = parcelRequire("9PIz7");
var $6Jl4s = parcelRequire("6Jl4s");
const $fae83e6021cf6e7f$var$ICO_CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';
var $fae83e6021cf6e7f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input_dock_schedule .ids-av-grid {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
				gap: 0.75rem;
				margin-top: 0.75rem;
			}
			#input_dock_schedule .ids-av-card {
				background: #fff;
				border: 1px solid #e5e7eb;
				border-radius: 0.5rem;
				padding: 0.75rem;
				box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
			}
			#input_dock_schedule .ids-av-card.is-incompat {
				opacity: 0.85;
				border-color: #fca5a5;
				background: #fff7f7;
			}
			#input_dock_schedule .ids-av-card h4 {
				margin: 0 0 0.35rem;
				font-size: 0.95rem;
				color: #1e3a8a;
			}
			#input_dock_schedule .ids-av-meta {
				font-size: 0.78rem;
				color: #6b7280;
				margin-bottom: 0.5rem;
				display: flex;
				flex-wrap: wrap;
				gap: 0.35rem;
			}
			#input_dock_schedule .ids-badge {
				display: inline-block;
				padding: 0.1rem 0.45rem;
				border-radius: 0.25rem;
				font-size: 0.75rem;
				font-weight: 600;
				background: #e0e7ff;
				color: #3730a3;
			}
			#input_dock_schedule .ids-chip-row {
				display: flex;
				flex-wrap: wrap;
				gap: 0.35rem;
			}
			#input_dock_schedule .ids-chip {
				border: 1px solid #cbd5e1;
				background: #f8fafc;
				color: #334155;
				border-radius: 999px;
				padding: 0.2rem 0.55rem;
				font-size: 0.75rem;
				font-variant-numeric: tabular-nums;
				cursor: default;
			}
			#input_dock_schedule .ids-chip.is-available {
				background: #ecfdf5;
				border-color: #6ee7b7;
				color: #065f46;
				cursor: pointer;
			}
			#input_dock_schedule .ids-chip.is-available:hover {
				background: #d1fae5;
			}
			#input_dock_schedule .ids-chip.is-occupied,
			#input_dock_schedule .ids-chip.is-incompatible {
				background: #fee2e2;
				border-color: #fca5a5;
				color: #991b1b;
				opacity: 0.75;
			}
			#input_dock_schedule .ids-chip.is-out {
				background: #f3f4f6;
				border-color: #d1d5db;
				color: #6b7280;
			}
			#input_dock_schedule .ids-chip.is-selected {
				background: #4c1d95;
				border-color: #4c1d95;
				color: #fff;
				box-shadow: 0 0 0 2px rgba(76, 29, 149, 0.25);
			}
			#input_dock_schedule .ids-confirm {
				margin-top: 0.85rem;
				padding: 0.75rem 0.9rem;
				border-radius: 0.5rem;
				background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
				border: 1px solid #c7d2fe;
				font-size: 0.88rem;
			}
			#input_dock_schedule .ids-confirm[hidden] { display: none; }
			#input_dock_schedule .ids-order-box {
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 0.45rem;
				padding: 0.65rem 0.75rem;
				font-size: 0.85rem;
				min-height: 2.5rem;
			}
			#input_dock_schedule .ids-warn {
				color: #92400e;
				background: #fffbeb;
				border: 1px solid #fcd34d;
				border-radius: 0.35rem;
				padding: 0.4rem 0.6rem;
				margin-top: 0.4rem;
				font-size: 0.8rem;
			}
			#input_dock_schedule #ids_availability_empty {
				color: #6b7280;
				font-size: 0.85rem;
				margin-top: 0.5rem;
			}
			#input_dock_schedule .ids-toolbar {
				display: flex;
				flex-wrap: wrap;
				gap: 0.5rem;
				margin-top: 0.5rem;
			}
			#input_dock_schedule .ids-order-pick {
				list-style: none;
				margin: 0.5rem 0 0;
				padding: 0;
				max-height: 12rem;
				overflow: auto;
			}
			#input_dock_schedule .ids-order-pick button {
				display: block;
				width: 100%;
				text-align: left;
				margin: 0 0 0.3rem;
				padding: 0.35rem 0.5rem;
				border: 1px solid #c7d2fe;
				border-radius: 0.35rem;
				background: #fff;
				color: #1e3a8a;
				cursor: pointer;
				font-size: 0.82rem;
			}
			#input_dock_schedule .ids-order-pick button:hover {
				background: #eef2ff;
			}
		</style>
		<form id="input_dock_schedule" class="form sial-modal-form sial-detail sial-detail--edit" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="eligible_input_orders"></datalist>
			<datalist id="users"></datalist>
			<input type="hidden" id="dock_id" value="">
			<input type="hidden" id="scheduled_start" value="">
			<input type="hidden" id="scheduled_end" value="">
			<input type="hidden" id="schedule_id" value="">

			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${$fae83e6021cf6e7f$var$ICO_CAL}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Movimenta\xe7\xe3o \xb7 Agendamento de Docas</p>
						<h2 class="sdp-title" data-sdp="title">Novo agendamento</h2>
						<div class="sdp-meta">
							<span>Empresa: <b data-sdp="company">\u{2014}</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="mode-badge">Criar</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>

			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Pedido e par\xe2metros</h3>
					<p class="sdp-hint">Armaz\xe9m, tipo e classes ficam no cadastro da <strong>Doca</strong>. Aqui s\xf3 se escolhe o pedido; o sistema lista as docas compat\xedveis.</p>
					<div class="sdp-fields">
						<label title="Empresa">Empresa<sup>*</sup>
							<input id="company_id" type="text" list="companies" required>
						</label>
						<label title="Pedido de Entrada">Pedido de Entrada<sup>*</sup>
							<input id="input_order_id" type="text" list="eligible_input_orders" inputmode="numeric" required placeholder="n\xfamero ou escolha na lista">
						</label>
						<label title="Buscar pelo n\xfamero da NF do Pedido de Entrada">Nota Fiscal
							<input id="nf_number" type="text" placeholder="n\xba da NF para buscar">
						</label>
						<label title="Volumes informados no agendamento (portaria)">Volumes
							<input id="volumes" type="number" min="0" step="1" placeholder="qtd. volumes">
						</label>
						<label title="Data desejada">Data<sup>*</sup>
							<input id="date" type="date" required>
						</label>
						<label title="Dura\xe7\xe3o em minutos">Dura\xe7\xe3o (min)<sup>*</sup>
							<input id="duration_minutes" type="number" min="1" step="1" value="60" required>
						</label>
						<label title="Respons\xe1vel">Respons\xe1vel
							<input id="responsible_user_id" type="text" list="users">
						</label>
						<label class="sdp-span-2" title="Observa\xe7\xf5es">Observa\xe7\xf5es
							<textarea id="notes" maxlength="2000"></textarea>
						</label>
					</div>
					<div class="ids-toolbar">
						<button type="button" class="button" id="ids_btn_list_orders">Listar pedidos pass\xedveis</button>
						<button type="button" class="button" id="ids_btn_find_nf">Buscar por NF</button>
						<button type="button" class="button" id="ids_btn_load_order">Carregar pedido</button>
						<button type="button" class="button" id="ids_btn_availability">Buscar disponibilidade</button>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">Resumo do pedido</h3>
					<div class="ids-order-box" id="ids_order_summary">Informe a empresa e o pedido, ou clique em <strong>Listar pedidos pass\xedveis</strong>.</div>
					<div id="ids_order_warn" class="ids-warn" hidden></div>
				</div>
			</section>

			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Disponibilidade</h3>
					<p class="sdp-hint">S\xf3 aparecem docas compat\xedveis com o pedido (classes e refrigera\xe7\xe3o). Tipo e armaz\xe9m s\xe3o da doca escolhida. Clique no hor\xe1rio verde.</p>
					<div id="ids_availability_empty">Nenhuma busca ainda.</div>
					<div class="ids-av-grid" id="ids_availability" hidden></div>
					<div class="ids-confirm" id="ids_confirm" hidden>
						<strong>Confirma\xe7\xe3o:</strong>
						<span id="ids_confirm_text"></span>
					</div>
				</div>
			</div>

			<div class="sdp-foot">
				<button class="bn_Escape button">Fechar</button>
				<button class="bn_Enter button" id="ids_btn_save">Confirmar agendamento</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input_dock_schedule',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#users', 'users', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#input_order_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#nf_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#volumes'
            },
            types: []
        },
        {
            properties: {
                selector: '#date'
            },
            types: []
        },
        {
            properties: {
                selector: '#duration_minutes'
            },
            types: []
        },
        {
            properties: {
                selector: '#responsible_user_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: []
        },
        {
            properties: {
                selector: '#dock_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#scheduled_start'
            },
            types: []
        },
        {
            properties: {
                selector: '#scheduled_end'
            },
            types: []
        },
        {
            properties: {
                selector: '#schedule_id'
            },
            types: []
        }
    ]
};





var $7WMRl = parcelRequire("7WMRl");

function $b8167635cb1083d7$var$escHtml(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $b8167635cb1083d7$var$setText(root, sel, text) {
    root?.querySelectorAll(sel)?.forEach((el)=>{
        el.textContent = text;
    });
}
function $b8167635cb1083d7$var$chipClass(state) {
    if (state === 'AVAILABLE') return 'is-available';
    if (state === 'OCCUPIED') return 'is-occupied';
    if (state === 'OUT_OF_HOURS') return 'is-out';
    if (state === 'INCOMPATIBLE') return 'is-incompatible';
    return 'is-out';
}
function $b8167635cb1083d7$var$formatSlotLabel(startIso, endIso) {
    return `${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(startIso)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(endIso)}`;
}
function $b8167635cb1083d7$var$parseOrderId(raw) {
    const m = String(raw ?? '').trim().match(/^(\d+)/);
    return m ? Number(m[1]) : NaN;
}
function $b8167635cb1083d7$var$normalizeNf(raw) {
    return String(raw ?? '').trim().replace(/^0+(?=\d)/, '');
}
function $b8167635cb1083d7$var$nfMatches(orderNf, queryNf) {
    const a = $b8167635cb1083d7$var$normalizeNf(orderNf);
    const b = $b8167635cb1083d7$var$normalizeNf(queryNf);
    if (!a || !b) return false;
    return a === b || a.includes(b) || b.includes(a);
}
function $b8167635cb1083d7$var$isEligibleOrder(order) {
    const st = Number(order?.status);
    if (!Number.isFinite(st) || st >= 50) return false;
    if ((0, $aecc276d35afe90f$export$3717d3ff7ac78338).has(order?.dock_schedule_status)) return false;
    return true;
}
function $b8167635cb1083d7$var$orderPickLabel(order, supplierNick) {
    const bits = [
        `Pedido ${order.id}`,
        order.reference ? String(order.reference) : null,
        order.nf_number != null && order.nf_number !== '' ? `NF ${order.nf_number}` : null,
        order.volumes != null && order.volumes !== '' ? `${order.volumes} vol.` : null,
        supplierNick || null,
        order.dock_schedule_status ? (0, $aecc276d35afe90f$export$a954299e2515e375)(order.dock_schedule_status) : 'Sem agenda'
    ].filter(Boolean);
    return bits.join(" \xb7 ");
}
async function $b8167635cb1083d7$var$resolveUserId(raw) {
    if (!raw) return null;
    const text = String(raw).trim();
    if (!text) return null;
    if (/^[0-9a-f-]{36}$/i.test(text)) return text;
    const users = await (0, $1cmSR.default).list('users').catch(()=>[]);
    const found = (users || []).find((u)=>u?.name === text || u?.username === text || String(u?.id) === text);
    return found?.id || null;
}
function $b8167635cb1083d7$export$a8fb0eb6f2aae835(record) {
    const id = record?.dock_schedule_id;
    const status = record?.dock_schedule_status;
    if (id == null || !status) return '<span class="io-dock-badge io-dock-none" title="Sem agendamento de doca">Sem agenda</span>';
    const tipParts = [
        record.dock_name ? `Doca ${record.dock_name}` : null,
        record.dock_schedule_start ? `${(0, $aecc276d35afe90f$export$c5be672fb676f885)(record.dock_schedule_start)} ${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(record.dock_schedule_start)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(record.dock_schedule_end)}` : null,
        (0, $aecc276d35afe90f$export$a954299e2515e375)(status)
    ].filter(Boolean);
    const tip = $b8167635cb1083d7$var$escHtml(tipParts.join(" \xb7 "));
    const label = (0, $aecc276d35afe90f$export$a954299e2515e375)(status);
    const cls = {
        SCHEDULED: 'io-dock-scheduled',
        IN_RECEIVING: 'io-dock-receiving',
        COMPLETED: 'io-dock-completed',
        CANCELLED: 'io-dock-cancelled',
        NO_SHOW: 'io-dock-noshow'
    }[status] || 'io-dock-other';
    const occ = record.dock_has_occurrence ? ' <span class="io-dock-badge io-dock-occ" title="Com ocorr\xeancia">Com ocorr\xeancia</span>' : '';
    return `<span class="io-dock-badge ${cls}" title="${tip}">${$b8167635cb1083d7$var$escHtml(label)}</span>${occ}`;
}
function $b8167635cb1083d7$export$f3694d65cc0718f(status) {
    return (0, $aecc276d35afe90f$export$3717d3ff7ac78338).has(status);
}
function $b8167635cb1083d7$export$56563c28d49804f7({ payload: payload, onDone: onDone, onReschedule: onReschedule, onCancel: onCancel } = {}) {
    if (!payload?.schedule) return (0, $jUNyh.notify)("Agendamento n\xe3o encontrado.", 'Agendamento de Docas');
    const schedule = payload.schedule;
    const companyId = schedule.company_id;
    const scheduleId = schedule.id;
    const fs = (0, $h1m6J.default).create((0, $82e8a93ec86d36b7$export$2e2bcd8739ae039), async (ev)=>{
        if (ev === 'Escape') fs.destroy();
    });
    fs.init();
    const root = document.querySelector('#input_dock_schedule_detail');
    if (!root) return;
    $b8167635cb1083d7$var$setText(root, '[data-sdp="id"]', String(schedule.id));
    $b8167635cb1083d7$var$setText(root, '[data-sdp="status"]', (0, $aecc276d35afe90f$export$a954299e2515e375)(schedule.status));
    $b8167635cb1083d7$var$setText(root, '[data-sdp="title"]', `Agendamento #${schedule.id}`);
    const dock = payload.dock || {};
    const main = root.querySelector('#ids_detail_main');
    if (main) main.innerHTML = [
        [
            'Doca',
            dock.name || schedule.dock_id
        ],
        [
            'Tipo',
            (0, $aecc276d35afe90f$export$17ff6761b39ffe92)(dock.dock_type)
        ],
        [
            "Armaz\xe9m",
            schedule.warehouse_id
        ],
        [
            'Data',
            (0, $aecc276d35afe90f$export$3ae94a2503e890a1)(schedule.scheduled_start)
        ],
        [
            "Hor\xe1rio",
            `${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(schedule.scheduled_start)} \u{2013} ${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(schedule.scheduled_end)}`
        ],
        [
            "Dura\xe7\xe3o",
            `${schedule.duration_minutes || "\u2014"} min`
        ],
        [
            "Respons\xe1vel",
            schedule.responsible_user_id || "\u2014"
        ],
        [
            'Status',
            (0, $aecc276d35afe90f$export$a954299e2515e375)(schedule.status)
        ],
        [
            "Ocorr\xeancia",
            schedule.has_occurrence ? "Com ocorr\xeancia" : "Sem ocorr\xeancia"
        ]
    ].map(([k, v])=>`<dt>${$b8167635cb1083d7$var$escHtml(k)}</dt><dd>${$b8167635cb1083d7$var$escHtml(v)}</dd>`).join('');
    const orderBox = root.querySelector('#ids_detail_order');
    const order = payload.input_order || {};
    const supplier = payload.supplier || {};
    if (orderBox) orderBox.innerHTML = [
        [
            'Pedido Entrada',
            schedule.input_order_id
        ],
        [
            'NF',
            schedule.invoice_number || order.nf_number || "\u2014"
        ],
        [
            'Volumes',
            schedule.volumes ?? "\u2014"
        ],
        [
            'Fornecedor',
            supplier.nick || supplier.name || schedule.supplier_id || "\u2014"
        ],
        [
            'Status pedido',
            order.status ?? "\u2014"
        ]
    ].map(([k, v])=>`<dt>${$b8167635cb1083d7$var$escHtml(k)}</dt><dd>${$b8167635cb1083d7$var$escHtml(v)}</dd>`).join('');
    const notesEl = root.querySelector('#ids_detail_notes');
    if (notesEl) notesEl.textContent = schedule.notes ? `Observa\xe7\xf5es: ${schedule.notes}` : '';
    const evUl = root.querySelector('#ids_detail_events');
    const events = Array.isArray(payload.events) ? payload.events : [];
    if (evUl) evUl.innerHTML = events.length ? events.map((ev)=>`
				<li>
					<div class="ids-tl-type">${$b8167635cb1083d7$var$escHtml((0, $aecc276d35afe90f$export$ed661ffc2b635f11)(ev.event_type))}</div>
					<div class="ids-tl-when">${$b8167635cb1083d7$var$escHtml(ev.created_on || '')}</div>
				</li>`).join('') : '<li><div class="ids-tl-type">Sem eventos</div></li>';
    const occs = Array.isArray(payload.occurrences) ? payload.occurrences : [];
    const occBlock = root.querySelector('#ids_detail_occ_block');
    const occUl = root.querySelector('#ids_detail_occs');
    if (occBlock && occUl) {
        if (occs.length) {
            occBlock.hidden = false;
            occUl.innerHTML = occs.map((o)=>`
				<li>
					<div class="ids-tl-type">${$b8167635cb1083d7$var$escHtml(o.occurrence_type || o.type || "Ocorr\xeancia")}</div>
					<div class="ids-tl-when">${$b8167635cb1083d7$var$escHtml(o.notes || o.created_on || '')}</div>
				</li>`).join('');
        } else occBlock.hidden = true;
    }
    const btnCancel = root.querySelector('#ids_detail_cancel');
    const btnReschedule = root.querySelector('#ids_detail_reschedule');
    const mutable = (0, $aecc276d35afe90f$export$3db432bf1df9ac80)(schedule.status);
    if (btnCancel) btnCancel.disabled = !mutable;
    if (btnReschedule) btnReschedule.disabled = !mutable;
    btnCancel?.addEventListener('click', ()=>{
        if (!mutable) return (0, $jUNyh.notify)("Agendamento n\xe3o pode ser cancelado neste status.", 'Agendamento de Docas');
        fs.destroy();
        if (onCancel) onCancel(companyId, scheduleId);
        else $b8167635cb1083d7$export$d55726ab1d6010bb({
            companyId: companyId,
            scheduleId: scheduleId,
            onDone: onDone
        });
    });
    btnReschedule?.addEventListener('click', ()=>{
        if (!mutable) return (0, $jUNyh.notify)("Agendamento n\xe3o pode ser reagendado neste status.", 'Agendamento de Docas');
        fs.destroy();
        const args = {
            mode: 'reschedule',
            companyId: companyId,
            scheduleId: scheduleId,
            schedule: schedule,
            dock: dock,
            onDone: onDone
        };
        if (onReschedule) onReschedule(args);
        else $b8167635cb1083d7$export$bc9d4cb3bb8226a4(args);
    });
}
function $b8167635cb1083d7$export$d55726ab1d6010bb({ companyId: companyId, scheduleId: scheduleId, onDone: onDone } = {}) {
    const fs = (0, $h1m6J.default).create((0, $be8ea4d1984c1298$export$2e2bcd8739ae039), async (data)=>{
        const reason = String(data.cancel_reason || '').trim();
        if (!reason) return (0, $jUNyh.notify)('Informe o motivo do cancelamento.', 'Agendamento de Docas');
        (0, $jUNyh.ask)('Confirma o cancelamento deste agendamento?', 'Cancelar', async (answer)=>{
            if (answer !== 'Y') return;
            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).cancel_input_dock_schedule, companyId, scheduleId, {
                cancel_reason: reason
            });
            if (!resp) return;
            (0, $jUNyh.notify)('Agendamento cancelado.', 'Sucesso');
            fs.destroy();
            if (onDone) await onDone();
        });
    });
    fs.init();
}
function $b8167635cb1083d7$export$bc9d4cb3bb8226a4({ mode: mode = 'create', companyId: companyId, companyNick: companyNick, inputOrderId: inputOrderId, scheduleId: scheduleId, schedule: schedule, dock: dock, useOrderScopedCreate: useOrderScopedCreate = false, onDone: onDone } = {}) {
    const isReschedule = mode === 'reschedule';
    const selection = {
        dock_id: null,
        start: null,
        end: null,
        dock_name: null
    };
    let fs;
    try {
        fs = (0, $h1m6J.default).create((0, $fae83e6021cf6e7f$export$2e2bcd8739ae039), async (data)=>{
            try {
                const company_id = await (0, $7WMRl.resolveCompanyId)(data.company_id) || data.company_id || companyId || schedule?.company_id;
                if (!company_id) return (0, $jUNyh.notify)('Informe a empresa.', 'Agendamento de Docas');
                const input_order_id = $b8167635cb1083d7$var$parseOrderId(data.input_order_id || schedule?.input_order_id || inputOrderId);
                if (!isReschedule && (!Number.isFinite(input_order_id) || input_order_id < 1)) return (0, $jUNyh.notify)('Informe o Pedido de Entrada.', 'Agendamento de Docas');
                const duration_minutes = Number(data.duration_minutes);
                if (!Number.isFinite(duration_minutes) || duration_minutes <= 0) return (0, $jUNyh.notify)("Informe a dura\xe7\xe3o (maior que zero).", 'Agendamento de Docas');
                if (!selection.dock_id || !selection.start) return (0, $jUNyh.notify)("Selecione um hor\xe1rio dispon\xedvel.", 'Agendamento de Docas');
                const responsible_user_id = await $b8167635cb1083d7$var$resolveUserId(data.responsible_user_id);
                const notes = data.notes ? String(data.notes).trim() : null;
                let volumes = null;
                if (data.volumes !== undefined && data.volumes !== null && String(data.volumes).trim() !== '') {
                    const n = Number(data.volumes);
                    if (!Number.isFinite(n) || n < 0 || !Number.isInteger(n)) return (0, $jUNyh.notify)("Volumes deve ser um n\xfamero inteiro \u2265 0.", 'Agendamento de Docas');
                    volumes = n;
                }
                const body = {
                    dock_id: Number(selection.dock_id),
                    scheduled_start: selection.start,
                    duration_minutes: duration_minutes,
                    responsible_user_id: responsible_user_id,
                    notes: notes,
                    volumes: volumes
                };
                let resp;
                if (isReschedule) resp = await (0, $9VcS9.default).call((0, $9VcS9.default).reschedule_input_dock_schedule, company_id, Number(data.schedule_id || scheduleId || schedule?.id), body);
                else if (useOrderScopedCreate || inputOrderId) resp = await (0, $9VcS9.default).call((0, $9VcS9.default).insert_input_order_dock_schedule, company_id, input_order_id, body);
                else {
                    body.input_order_id = input_order_id;
                    resp = await (0, $9VcS9.default).call((0, $9VcS9.default).insert_input_dock_schedule, company_id, body);
                }
                if (!resp) return;
                if (resp.warning) (0, $jUNyh.notify)(String(resp.warning), 'Aviso');
                (0, $jUNyh.notify)(isReschedule ? 'Agendamento reagendado.' : 'Agendamento criado.', 'Sucesso');
                fs.destroy();
                if (onDone) await onDone();
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Agendamento de Docas');
            }
        });
    } catch (e) {
        (0, $jUNyh.notify)(e?.message || String(e), 'Agendamento de Docas');
        console.error(e);
        return;
    }
    fs.init();
    const root = document.querySelector('#input_dock_schedule');
    if (!root) return;
    $b8167635cb1083d7$var$setText(root, '[data-sdp="title"]', isReschedule ? 'Reagendar agendamento' : 'Novo agendamento');
    $b8167635cb1083d7$var$setText(root, '[data-sdp="mode-badge"]', isReschedule ? 'Reagendar' : 'Criar');
    const saveBtn = root.querySelector('#ids_btn_save');
    if (saveBtn) saveBtn.textContent = isReschedule ? 'Confirmar reagendamento' : 'Confirmar agendamento';
    if (isReschedule && schedule) {
        root.querySelector('#company_id').value = companyNick || companyId || schedule.company_id || '';
        root.querySelector('#input_order_id').value = schedule.input_order_id || '';
        root.querySelector('#input_order_id').disabled = true;
        root.querySelector('#company_id').disabled = true;
        root.querySelector('#schedule_id').value = String(scheduleId || schedule.id || '');
        root.querySelector('#duration_minutes').value = schedule.duration_minutes || 60;
        if (schedule.scheduled_start) root.querySelector('#date').value = (0, $aecc276d35afe90f$export$3ae94a2503e890a1)(schedule.scheduled_start);
        if (schedule.responsible_user_id) root.querySelector('#responsible_user_id').value = schedule.responsible_user_id;
        if (schedule.notes) root.querySelector('#notes').value = schedule.notes;
        if (schedule.invoice_number && root.querySelector('#nf_number')) root.querySelector('#nf_number').value = schedule.invoice_number;
        if (schedule.volumes != null && root.querySelector('#volumes')) root.querySelector('#volumes').value = String(schedule.volumes);
        $b8167635cb1083d7$var$setText(root, '[data-sdp="company"]', companyNick || companyId || schedule.company_id || "\u2014");
        const btnList = root.querySelector('#ids_btn_list_orders');
        if (btnList) btnList.hidden = true;
        const btnNf = root.querySelector('#ids_btn_find_nf');
        if (btnNf) btnNf.hidden = true;
        if (root.querySelector('#nf_number')) root.querySelector('#nf_number').disabled = true;
    } else {
        const today = new Date();
        const ymd = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        if (!root.querySelector('#date').value) root.querySelector('#date').value = ymd;
        if (companyId || companyNick) {
            root.querySelector('#company_id').value = companyNick || companyId;
            root.querySelector('#company_id').disabled = !!inputOrderId;
            $b8167635cb1083d7$var$setText(root, '[data-sdp="company"]', companyNick || companyId);
        }
        if (inputOrderId) {
            root.querySelector('#input_order_id').value = String(inputOrderId);
            root.querySelector('#input_order_id').disabled = true;
            const btnList = root.querySelector('#ids_btn_list_orders');
            if (btnList) btnList.hidden = true;
        }
    }
    const updateConfirm = ()=>{
        const box = root.querySelector('#ids_confirm');
        const txt = root.querySelector('#ids_confirm_text');
        if (!box || !txt) return;
        if (!selection.dock_id || !selection.start) {
            box.hidden = true;
            return;
        }
        box.hidden = false;
        txt.textContent = [
            `Doca ${selection.dock_name || selection.dock_id}`,
            `data ${(0, $aecc276d35afe90f$export$3ae94a2503e890a1)(selection.start)}`,
            `${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(selection.start)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(selection.end)}`,
            `${root.querySelector('#duration_minutes')?.value || ''} min`,
            `pedido ${root.querySelector('#input_order_id')?.value || ''}`,
            root.querySelector('#responsible_user_id')?.value ? `respons\xe1vel ${root.querySelector('#responsible_user_id').value}` : null
        ].filter(Boolean).join(" \xb7 ");
        root.querySelector('#dock_id').value = String(selection.dock_id);
        root.querySelector('#scheduled_start').value = selection.start;
        root.querySelector('#scheduled_end').value = selection.end || '';
    };
    const warehouseName = async (company_id, warehouse_id)=>{
        const list = await (0, $1cmSR.default).list('warehouses').catch(()=>[]) || [];
        const wh = list.find((w)=>String(w.company_id) === String(company_id) && Number(w.id) === Number(warehouse_id));
        return wh?.name || wh?.nick || (warehouse_id != null ? String(warehouse_id) : "\u2014");
    };
    const supplierNick = async (company_id, supplier_id)=>{
        if (supplier_id == null) return null;
        const list = await (0, $1cmSR.default).list('suppliers').catch(()=>[]) || [];
        const s = list.find((x)=>String(x.company_id) === String(company_id) && Number(x.id) === Number(supplier_id));
        return s?.nick || s?.name || null;
    };
    const renderAvailability = async (payload)=>{
        const grid = root.querySelector('#ids_availability');
        const empty = root.querySelector('#ids_availability_empty');
        const warn = root.querySelector('#ids_order_warn');
        if (!grid || !empty) return;
        selection.dock_id = null;
        selection.start = null;
        selection.end = null;
        selection.dock_name = null;
        updateConfirm();
        const all = Array.isArray(payload?.docks) ? payload.docks : [];
        const docks = all.filter((d)=>d.compatible !== false);
        const skipped = all.length - docks.length;
        if (warn) {
            const warnings = Array.isArray(payload?.warnings) ? payload.warnings : [];
            if (skipped > 0) warnings.push(`${skipped} doca(s) oculta(s): incompat\xedvel com o pedido.`);
            if (warnings.length) {
                warn.hidden = false;
                warn.textContent = warnings.join(' ');
            }
        }
        if (!docks.length) {
            grid.hidden = true;
            empty.hidden = false;
            empty.textContent = "Nenhuma doca compat\xedvel com este pedido nesta data.";
            return;
        }
        empty.hidden = true;
        grid.hidden = false;
        const company_id = payload?.company_id;
        const cards = await Promise.all(docks.map(async (d)=>{
            const slots = Array.isArray(d.slots) ? d.slots : [];
            const chips = slots.length ? slots.map((s)=>{
                const st = s.state || 'OUT_OF_HOURS';
                const disabled = st !== 'AVAILABLE';
                return `<button type="button" class="ids-chip ${$b8167635cb1083d7$var$chipClass(st)}"
						data-dock-id="${$b8167635cb1083d7$var$escHtml(d.dock_id)}"
						data-dock-name="${$b8167635cb1083d7$var$escHtml(d.name || '')}"
						data-start="${$b8167635cb1083d7$var$escHtml(s.start)}"
						data-end="${$b8167635cb1083d7$var$escHtml(s.end)}"
						data-state="${$b8167635cb1083d7$var$escHtml(st)}"
						${disabled ? 'disabled' : ''}>${$b8167635cb1083d7$var$escHtml($b8167635cb1083d7$var$formatSlotLabel(s.start, s.end))}</button>`;
            }).join('') : '<span class="ids-chip is-out">Sem hor\xe1rio neste dia</span>';
            const whLabel = await warehouseName(company_id, d.warehouse_id);
            return `
				<article class="ids-av-card">
					<h4>${$b8167635cb1083d7$var$escHtml(d.name || `Doca ${d.dock_id}`)}</h4>
					<div class="ids-av-meta">
						<span class="ids-badge">${$b8167635cb1083d7$var$escHtml((0, $aecc276d35afe90f$export$17ff6761b39ffe92)(d.dock_type))}</span>
						<span>${$b8167635cb1083d7$var$escHtml(whLabel)}</span>
						<span>Ocupa\xe7\xe3o ${$b8167635cb1083d7$var$escHtml(d.occupancy_pct ?? 0)}%</span>
					</div>
					<div class="ids-chip-row">${chips}</div>
				</article>`;
        }));
        grid.innerHTML = cards.join('');
        grid.querySelectorAll('.ids-chip.is-available').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                grid.querySelectorAll('.ids-chip.is-selected').forEach((el)=>el.classList.remove('is-selected'));
                btn.classList.add('is-selected');
                selection.dock_id = Number(btn.dataset.dockId);
                selection.start = btn.dataset.start;
                selection.end = btn.dataset.end;
                selection.dock_name = btn.dataset.dockName || '';
                updateConfirm();
            });
        });
    };
    const loadVolumesFromInput = async (company_id, order_id)=>{
        try {
            const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_inputs, `?limit=50`) || [];
            const match = (Array.isArray(rows) ? rows : []).find((inp)=>String(inp.company_id) === String(company_id) && String(inp.order_type || 'I') === 'I' && Number(inp.order_id) === Number(order_id) && inp.volumes != null);
            if (match?.volumes != null && root.querySelector('#volumes') && !root.querySelector('#volumes').value) root.querySelector('#volumes').value = String(Math.trunc(Number(match.volumes)));
        } catch (_) {
        /* opcional */ }
    };
    const loadOrderSummary = async ()=>{
        const company_id = await (0, $7WMRl.resolveCompanyId)(root.querySelector('#company_id')?.value) || root.querySelector('#company_id')?.value;
        const oid = $b8167635cb1083d7$var$parseOrderId(root.querySelector('#input_order_id')?.value);
        const box = root.querySelector('#ids_order_summary');
        const warn = root.querySelector('#ids_order_warn');
        if (warn) warn.hidden = true;
        if (!company_id || !Number.isFinite(oid) || oid < 1) {
            if (box) box.textContent = "Informe a empresa e o Pedido de Entrada, ou liste os pedidos pass\xedveis / busque por NF.";
            return;
        }
        if (root.querySelector('#input_order_id')) root.querySelector('#input_order_id').value = String(oid);
        $b8167635cb1083d7$var$setText(root, '[data-sdp="company"]', companyNick || company_id);
        const order = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order, company_id, oid);
        if (!order) {
            if (box) box.textContent = "Pedido n\xe3o encontrado.";
            return;
        }
        if (!$b8167635cb1083d7$var$isEligibleOrder(order) && !isReschedule) {
            if (box) box.innerHTML = `<div>Pedido ${$b8167635cb1083d7$var$escHtml(oid)} j\xe1 possui agendamento ativo ou est\xe1 cancelado.</div>`;
            return;
        }
        if (order.nf_number != null && order.nf_number !== '' && root.querySelector('#nf_number')) root.querySelector('#nf_number').value = String(order.nf_number);
        await loadVolumesFromInput(company_id, oid);
        const nick = await supplierNick(company_id, order.supplier_id);
        const volField = root.querySelector('#volumes')?.value;
        const lines = [
            `Pedido ${order.id}`,
            order.reference ? `Refer\xeancia: ${order.reference}` : null,
            order.nf_number != null && order.nf_number !== '' ? `NF: ${order.nf_number}` : null,
            volField ? `Volumes: ${volField}` : null,
            nick ? `Fornecedor: ${nick}` : order.supplier_id != null ? `Fornecedor (id): ${order.supplier_id}` : null,
            order.dock_schedule_status ? `Agenda: ${(0, $aecc276d35afe90f$export$a954299e2515e375)(order.dock_schedule_status)}` : 'Agenda: sem agenda ativa'
        ].filter(Boolean);
        if (box) box.innerHTML = lines.map((l)=>`<div>${$b8167635cb1083d7$var$escHtml(l)}</div>`).join('');
    };
    const renderEligibleList = async (company_id, eligible)=>{
        const box = root.querySelector('#ids_order_summary');
        const dl = root.querySelector('#eligible_input_orders');
        if (dl) dl.innerHTML = '';
        if (!eligible.length) {
            if (box) box.textContent = "Nenhum pedido pass\xedvel encontrado com os filtros informados.";
            return;
        }
        const items = await Promise.all(eligible.map(async (o)=>{
            const nick = await supplierNick(company_id, o.supplier_id);
            const label = $b8167635cb1083d7$var$orderPickLabel(o, nick);
            if (dl) {
                const opt = document.createElement('option');
                opt.value = String(o.id);
                opt.label = label;
                dl.appendChild(opt);
            }
            return {
                id: o.id,
                label: label,
                nf: o.nf_number
            };
        }));
        if (box) {
            box.innerHTML = `<div><strong>${items.length} pedido(s) pass\xedvel(is)</strong> \u{2014} clique para selecionar:</div>` + `<ul class="ids-order-pick">${items.map((it)=>`<li><button type="button" data-order-id="${it.id}">${$b8167635cb1083d7$var$escHtml(it.label)}</button></li>`).join('')}</ul>`;
            box.querySelectorAll('[data-order-id]').forEach((btn)=>{
                btn.addEventListener('click', ()=>{
                    root.querySelector('#input_order_id').value = String(btn.dataset.orderId);
                    loadOrderSummary();
                });
            });
        }
    };
    const listEligibleOrders = async ()=>{
        const company_id = await (0, $7WMRl.resolveCompanyId)(root.querySelector('#company_id')?.value) || root.querySelector('#company_id')?.value;
        if (!company_id) return (0, $jUNyh.notify)('Informe a empresa para listar os pedidos.', 'Agendamento de Docas');
        const nfQ = $b8167635cb1083d7$var$normalizeNf(root.querySelector('#nf_number')?.value);
        const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_orders, '?limit=0') || [];
        let eligible = (Array.isArray(rows) ? rows : []).filter((o)=>String(o.company_id) === String(company_id) && $b8167635cb1083d7$var$isEligibleOrder(o));
        if (nfQ) eligible = eligible.filter((o)=>$b8167635cb1083d7$var$nfMatches(o.nf_number, nfQ));
        await renderEligibleList(company_id, eligible);
    };
    const findByNf = async ()=>{
        const company_id = await (0, $7WMRl.resolveCompanyId)(root.querySelector('#company_id')?.value) || root.querySelector('#company_id')?.value;
        const nfQ = $b8167635cb1083d7$var$normalizeNf(root.querySelector('#nf_number')?.value);
        if (!company_id) return (0, $jUNyh.notify)('Informe a empresa.', 'Agendamento de Docas');
        if (!nfQ) return (0, $jUNyh.notify)("Informe o n\xfamero da Nota Fiscal.", 'Agendamento de Docas');
        const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_orders, '?limit=0') || [];
        const eligible = (Array.isArray(rows) ? rows : []).filter((o)=>String(o.company_id) === String(company_id) && $b8167635cb1083d7$var$isEligibleOrder(o) && $b8167635cb1083d7$var$nfMatches(o.nf_number, nfQ));
        if (!eligible.length) return (0, $jUNyh.notify)("Nenhum pedido pass\xedvel com essa NF nesta empresa.", 'Agendamento de Docas');
        if (eligible.length === 1) {
            root.querySelector('#input_order_id').value = String(eligible[0].id);
            await loadOrderSummary();
            return;
        }
        await renderEligibleList(company_id, eligible);
    };
    const searchAvailability = async ()=>{
        const company_id = await (0, $7WMRl.resolveCompanyId)(root.querySelector('#company_id')?.value) || root.querySelector('#company_id')?.value;
        const oid = $b8167635cb1083d7$var$parseOrderId(root.querySelector('#input_order_id')?.value);
        const date = root.querySelector('#date')?.value;
        const duration_minutes = Number(root.querySelector('#duration_minutes')?.value);
        if (!company_id) return (0, $jUNyh.notify)('Informe a empresa.', 'Agendamento de Docas');
        if (!Number.isFinite(oid) || oid < 1) return (0, $jUNyh.notify)("Informe o Pedido de Entrada (ou liste os pass\xedveis).", 'Agendamento de Docas');
        if (!date) return (0, $jUNyh.notify)('Informe a data.', 'Agendamento de Docas');
        if (!Number.isFinite(duration_minutes) || duration_minutes <= 0) return (0, $jUNyh.notify)("Informe a dura\xe7\xe3o (maior que zero).", 'Agendamento de Docas');
        if (root.querySelector('#input_order_id')) root.querySelector('#input_order_id').value = String(oid);
        const q = new URLSearchParams();
        q.set('input_order_id', String(oid));
        q.set('date', date);
        q.set('duration_minutes', String(duration_minutes));
        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_dock_availability, company_id, `?${q.toString()}`);
        if (!data) {
            const empty = root.querySelector('#ids_availability_empty');
            if (empty) {
                empty.hidden = false;
                empty.textContent = (0, $aecc276d35afe90f$export$b1957ca91e18269d);
            }
            return;
        }
        await loadOrderSummary();
        await renderAvailability(data);
    };
    root.querySelector('#ids_btn_list_orders')?.addEventListener('click', ()=>{
        listEligibleOrders();
    });
    root.querySelector('#ids_btn_find_nf')?.addEventListener('click', ()=>{
        findByNf();
    });
    root.querySelector('#ids_btn_load_order')?.addEventListener('click', ()=>{
        loadOrderSummary();
    });
    root.querySelector('#ids_btn_availability')?.addEventListener('click', ()=>{
        searchAvailability();
    });
    if (isReschedule || inputOrderId) loadOrderSummary();
}


/**
 * Calendário operacional de Agendamento de Docas (#MT-B2FA396).
 * Mês / semana / dia — visual SIAL, sem biblioteca externa.
 * Datas exibidas em dd/MM/yyyy.
 */ 
const $1a98e2562fa6dd99$var$WEEKDAYS = [
    'Seg',
    'Ter',
    'Qua',
    'Qui',
    'Sex',
    "S\xe1b",
    'Dom'
];
const $1a98e2562fa6dd99$var$MONTHS = [
    'janeiro',
    'fevereiro',
    "mar\xe7o",
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro'
];
const $1a98e2562fa6dd99$var$STATUS_CLASS = {
    SCHEDULED: 'is-scheduled',
    IN_RECEIVING: 'is-receiving',
    COMPLETED: 'is-completed',
    CANCELLED: 'is-cancelled',
    NO_SHOW: 'is-noshow'
};
function $1a98e2562fa6dd99$var$esc(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $1a98e2562fa6dd99$var$startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
function $1a98e2562fa6dd99$var$addDays(d, n) {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
}
function $1a98e2562fa6dd99$var$ymd(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function $1a98e2562fa6dd99$var$mondayOf(d) {
    const x = $1a98e2562fa6dd99$var$startOfDay(d);
    const dow = x.getDay(); // 0=Dom
    const offset = dow === 0 ? -6 : 1 - dow;
    return $1a98e2562fa6dd99$var$addDays(x, offset);
}
function $1a98e2562fa6dd99$var$monthGridRange(cursor) {
    const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
    const start = $1a98e2562fa6dd99$var$mondayOf(first);
    const last = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0);
    const endMonday = $1a98e2562fa6dd99$var$mondayOf(last);
    const end = $1a98e2562fa6dd99$var$addDays(endMonday, 7);
    return {
        start: start,
        end: end
    };
}
function $1a98e2562fa6dd99$var$weekRange(cursor) {
    const start = $1a98e2562fa6dd99$var$mondayOf(cursor);
    return {
        start: start,
        end: $1a98e2562fa6dd99$var$addDays(start, 7)
    };
}
function $1a98e2562fa6dd99$var$dayRange(cursor) {
    const start = $1a98e2562fa6dd99$var$startOfDay(cursor);
    return {
        start: start,
        end: $1a98e2562fa6dd99$var$addDays(start, 1)
    };
}
function $1a98e2562fa6dd99$var$sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function $1a98e2562fa6dd99$var$eventsOnDay(events, day) {
    const key = $1a98e2562fa6dd99$var$ymd(day);
    return events.filter((ev)=>ev._day === key);
}
function $1a98e2562fa6dd99$var$eventLabel(ev) {
    const dock = ev.dock_name || (ev.dock_id != null ? `Doca ${ev.dock_id}` : '');
    const order = ev.input_order_id != null ? `Ped. ${ev.input_order_id}` : '';
    return [
        (0, $aecc276d35afe90f$export$3203edd9e5edd663)(ev.scheduled_start),
        dock,
        order
    ].filter(Boolean).join(" \xb7 ");
}
function $1a98e2562fa6dd99$var$eventTitle(ev) {
    return [
        `#${ev.id}`,
        (0, $aecc276d35afe90f$export$a954299e2515e375)(ev.status),
        (0, $aecc276d35afe90f$export$c5be672fb676f885)(ev.scheduled_start),
        `${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(ev.scheduled_start)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(ev.scheduled_end)}`,
        ev.dock_name ? `Doca ${ev.dock_name}` : null,
        ev.input_order_id != null ? `Pedido ${ev.input_order_id}` : null,
        ev.has_occurrence ? "Com ocorr\xeancia" : null
    ].filter(Boolean).join(" \xb7 ");
}
const $1a98e2562fa6dd99$var$CSS = `
#ids-cal-panel {
	background: #fff;
	padding: 0.4rem 0.75rem 1.2rem;
	height: 84vh;
	overflow: auto;
	box-sizing: border-box;
}
#ids-cal-panel * { box-sizing: border-box; }
#ids-cal-panel table { display: none !important; }
.ids-cal { font-family: inherit; color: #1f2937; }
.ids-cal-bar {
	display: flex; flex-wrap: wrap; align-items: center; gap: 0.45rem;
	margin: 0 0 0.65rem; padding: 0.5rem 0.65rem;
	background: #eef2ff; border: 1px solid #c7d2fe;
}
.ids-cal-title { font-weight: 700; color: #1e3a8a; font-size: 1.05rem; margin-right: 0.75rem; }
.ids-cal-bar button {
	border: 1px solid #c7d2fe; background: #fff; color: #1e3a8a;
	border-radius: 0.3rem; padding: 0.3rem 0.65rem; cursor: pointer; font-size: 0.85rem;
}
.ids-cal-bar button:hover { background: #e0e7ff; }
.ids-cal-bar button.is-on { background: #4c1d95; border-color: #4c1d95; color: #fff; }
.ids-cal-legend { display: flex; flex-wrap: wrap; gap: 0.7rem; font-size: 0.78rem; color: #374151; margin: 0 0 0.6rem; }
.ids-cal-dot { display: inline-block; width: 0.65rem; height: 0.65rem; border-radius: 2px; margin-right: 0.25rem; vertical-align: -1px; }
.ids-cal-weekgrid {
	display: grid;
	grid-template-columns: repeat(7, minmax(0, 1fr));
	gap: 1px;
	background: #cbd5e1;
	border: 1px solid #cbd5e1;
	width: 100%;
}
.ids-cal-hd {
	background: #1e3a8a;
	color: #fff;
	font-size: 0.75rem;
	font-weight: 600;
	text-align: center;
	padding: 0.4rem 0.2rem;
}
.ids-cal-cell {
	background: #fff;
	min-height: 6.4rem;
	padding: 0.3rem;
	min-width: 0;
	overflow: hidden;
}
.ids-cal-cell.is-week { min-height: 14rem; }
.ids-cal-cell.is-out { background: #f3f4f6; }
.ids-cal-cell.is-today { box-shadow: inset 0 0 0 2px #4c1d95; }
.ids-cal-num { font-size: 0.8rem; font-weight: 700; color: #1e3a8a; cursor: pointer; }
.ids-cal-cell.is-out .ids-cal-num { color: #9ca3af; }
.ids-chip {
	display: block; width: 100%; max-width: 100%;
	text-align: left; margin: 0.18rem 0 0;
	border: 0; border-left: 3px solid #2563eb; border-radius: 0.2rem;
	padding: 0.15rem 0.3rem; font-size: 0.7rem; cursor: pointer;
	background: #dbeafe; color: #1e3a8a;
	white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ids-chip.is-scheduled { background: #dbeafe; color: #1e3a8a; border-left-color: #2563eb; }
.ids-chip.is-receiving { background: #ede9fe; color: #5b21b6; border-left-color: #7c3aed; }
.ids-chip.is-completed { background: #d1fae5; color: #065f46; border-left-color: #059669; }
.ids-chip.is-cancelled { background: #fee2e2; color: #991b1b; border-left-color: #dc2626; }
.ids-chip.is-noshow { background: #fee2e2; color: #7f1d1d; border-left-color: #7f1d1d; }
.ids-chip.is-occ { outline: 1px solid #f59e0b; }
.ids-more { display: block; border: 0; background: transparent; color: #4c1d95; font-size: 0.72rem; font-weight: 600; cursor: pointer; padding: 0.15rem 0; }
.ids-empty { color: #4b5563; padding: 0.75rem; font-size: 0.9rem; }
.ids-cal-daylist { display: flex; flex-direction: column; gap: 0.45rem; max-width: 52rem; }
.ids-cal-dayrow {
	display: flex; align-items: flex-start; gap: 0.75rem;
	padding: 0.55rem 0.7rem;
	background: #f8fafc;
	border: 1px solid #e5e7eb;
	border-radius: 0.4rem;
}
.ids-cal-hour {
	flex: 0 0 4.6rem;
	font-variant-numeric: tabular-nums;
	color: #6b7280;
	font-size: 0.82rem;
	line-height: 1.35;
}
.ids-cal-dayrow .ids-chip { width: auto; max-width: 100%; }
`;
function $1a98e2562fa6dd99$var$decorate(rows) {
    return (Array.isArray(rows) ? rows : []).map((row)=>{
        const start = row.scheduled_start ? new Date(row.scheduled_start) : null;
        return {
            ...row,
            _day: start && !Number.isNaN(start.getTime()) ? $1a98e2562fa6dd99$var$ymd(start) : ''
        };
    });
}
function $1a98e2562fa6dd99$export$57bed8477c502797(target, { fetchRange: fetchRange, onOpen: onOpen, onClose: onClose } = {}) {
    if (!target) return null;
    const state = {
        view: 'month',
        cursor: $1a98e2562fa6dd99$var$startOfDay(new Date()),
        events: [],
        loading: false
    };
    let style = document.getElementById('ids-cal-css');
    if (!style) {
        style = document.createElement('style');
        style.id = 'ids-cal-css';
        document.head.appendChild(style);
    }
    style.textContent = $1a98e2562fa6dd99$var$CSS;
    target.innerHTML = [
        '<div class="ids-cal">',
        '<div class="ids-cal-bar">',
        '<button type="button" data-act="close">Voltar \xe0 lista</button>',
        '<button type="button" data-act="prev">Anterior</button>',
        '<button type="button" data-act="today">Hoje</button>',
        '<button type="button" data-act="next">Pr\xf3ximo</button>',
        '<span class="ids-cal-title"></span>',
        '<button type="button" data-view="month" class="is-on">M\xeas</button>',
        '<button type="button" data-view="week">Semana</button>',
        '<button type="button" data-view="day">Dia</button>',
        '</div>',
        '<div class="ids-cal-legend">',
        '<span><span class="ids-cal-dot" style="background:#2563eb"></span>Agendado</span>',
        '<span><span class="ids-cal-dot" style="background:#7c3aed"></span>Em recebimento</span>',
        '<span><span class="ids-cal-dot" style="background:#059669"></span>Conclu\xeddo</span>',
        '<span><span class="ids-cal-dot" style="background:#dc2626"></span>Cancelado / N\xe3o compareceu</span>',
        '<span><span class="ids-cal-dot" style="background:#f59e0b"></span>Com ocorr\xeancia</span>',
        '</div>',
        '<div class="ids-cal-body"></div>',
        '</div>'
    ].join('');
    const root = target.querySelector('.ids-cal');
    const titleEl = root.querySelector('.ids-cal-title');
    const bodyEl = root.querySelector('.ids-cal-body');
    if (!root || !titleEl || !bodyEl) return null;
    const visibleRange = ()=>{
        if (state.view === 'week') return $1a98e2562fa6dd99$var$weekRange(state.cursor);
        if (state.view === 'day') return $1a98e2562fa6dd99$var$dayRange(state.cursor);
        return $1a98e2562fa6dd99$var$monthGridRange(state.cursor);
    };
    const setTitle = ()=>{
        const c = state.cursor;
        if (state.view === 'day') titleEl.textContent = (0, $aecc276d35afe90f$export$c5be672fb676f885)(c);
        else if (state.view === 'week') {
            const { start: start, end: end } = $1a98e2562fa6dd99$var$weekRange(c);
            titleEl.textContent = `${(0, $aecc276d35afe90f$export$c5be672fb676f885)(start)} \u{2013} ${(0, $aecc276d35afe90f$export$c5be672fb676f885)($1a98e2562fa6dd99$var$addDays(end, -1))}`;
        } else titleEl.textContent = `${$1a98e2562fa6dd99$var$MONTHS[c.getMonth()]} de ${c.getFullYear()}`;
        root.querySelectorAll('[data-view]').forEach((btn)=>{
            btn.classList.toggle('is-on', btn.dataset.view === state.view);
        });
    };
    const chipHtml = (ev)=>{
        const cls = $1a98e2562fa6dd99$var$STATUS_CLASS[ev.status] || 'is-scheduled';
        const occ = ev.has_occurrence ? ' is-occ' : '';
        return `<button type="button" class="ids-chip ${cls}${occ}" data-open="${$1a98e2562fa6dd99$var$esc(JSON.stringify([
            ev.company_id,
            ev.id
        ]))}" title="${$1a98e2562fa6dd99$var$esc($1a98e2562fa6dd99$var$eventTitle(ev))}">${$1a98e2562fa6dd99$var$esc($1a98e2562fa6dd99$var$eventLabel(ev))}</button>`;
    };
    const renderMonth = ()=>{
        const { start: start, end: end } = $1a98e2562fa6dd99$var$monthGridRange(state.cursor);
        const today = $1a98e2562fa6dd99$var$startOfDay(new Date());
        const days = [];
        for(let d = new Date(start); d < end; d = $1a98e2562fa6dd99$var$addDays(d, 1))days.push(new Date(d));
        const head = $1a98e2562fa6dd99$var$WEEKDAYS.map((w)=>`<div class="ids-cal-hd">${w}</div>`).join('');
        const cells = days.map((d)=>{
            const inMonth = d.getMonth() === state.cursor.getMonth();
            const evs = $1a98e2562fa6dd99$var$eventsOnDay(state.events, d);
            const shown = evs.slice(0, 3);
            const extra = evs.length - shown.length;
            const cls = `ids-cal-cell${inMonth ? '' : ' is-out'}${$1a98e2562fa6dd99$var$sameDay(d, today) ? ' is-today' : ''}`;
            return `<div class="${cls}">
				<div class="ids-cal-num" data-day="${$1a98e2562fa6dd99$var$ymd(d)}">${d.getDate()}</div>
				${shown.map(chipHtml).join('')}
				${extra > 0 ? `<button type="button" class="ids-more" data-day="${$1a98e2562fa6dd99$var$ymd(d)}">+${extra} mais</button>` : ''}
			</div>`;
        }).join('');
        bodyEl.innerHTML = `<div class="ids-cal-weekgrid">${head}${cells}</div>`;
    };
    const renderWeek = ()=>{
        const { start: start } = $1a98e2562fa6dd99$var$weekRange(state.cursor);
        const today = $1a98e2562fa6dd99$var$startOfDay(new Date());
        const head = $1a98e2562fa6dd99$var$WEEKDAYS.map((w)=>`<div class="ids-cal-hd">${w}</div>`).join('');
        const cells = [];
        for(let i = 0; i < 7; i++){
            const d = $1a98e2562fa6dd99$var$addDays(start, i);
            const evs = $1a98e2562fa6dd99$var$eventsOnDay(state.events, d);
            const cls = `ids-cal-cell is-week${$1a98e2562fa6dd99$var$sameDay(d, today) ? ' is-today' : ''}`;
            cells.push(`<div class="${cls}">
				<div class="ids-cal-num" data-day="${$1a98e2562fa6dd99$var$ymd(d)}">${(0, $aecc276d35afe90f$export$c5be672fb676f885)(d)}</div>
				${evs.length ? evs.map(chipHtml).join('') : '<div class="ids-empty">Sem agenda</div>'}
			</div>`);
        }
        bodyEl.innerHTML = `<div class="ids-cal-weekgrid">${head}${cells.join('')}</div>`;
    };
    const renderDay = ()=>{
        const evs = $1a98e2562fa6dd99$var$eventsOnDay(state.events, state.cursor).slice().sort((a, b)=>String(a.scheduled_start).localeCompare(String(b.scheduled_start)));
        if (!evs.length) {
            bodyEl.innerHTML = `<div class="ids-cal-daylist"><div class="ids-empty">Nenhum agendamento em ${$1a98e2562fa6dd99$var$esc((0, $aecc276d35afe90f$export$c5be672fb676f885)(state.cursor))}.</div></div>`;
            return;
        }
        bodyEl.innerHTML = `<div class="ids-cal-daylist">${evs.map((ev)=>`
			<div class="ids-cal-dayrow">
				<div class="ids-cal-hour">${$1a98e2562fa6dd99$var$esc((0, $aecc276d35afe90f$export$3203edd9e5edd663)(ev.scheduled_start))}<br>${$1a98e2562fa6dd99$var$esc((0, $aecc276d35afe90f$export$3203edd9e5edd663)(ev.scheduled_end))}</div>
				<div>${chipHtml(ev)}</div>
			</div>`).join('')}</div>`;
    };
    const paint = ()=>{
        try {
            setTitle();
            if (state.view === 'week') renderWeek();
            else if (state.view === 'day') renderDay();
            else renderMonth();
        } catch (e) {
            bodyEl.textContent = `Falha ao montar o calend\xe1rio: ${e?.message || e}`;
        }
    };
    const load = async ()=>{
        const { start: start, end: end } = visibleRange();
        state.loading = true;
        paint();
        try {
            const rows = typeof fetchRange === 'function' ? await fetchRange($1a98e2562fa6dd99$var$ymd(start), $1a98e2562fa6dd99$var$ymd(end)) : [];
            state.events = $1a98e2562fa6dd99$var$decorate(rows);
        } catch (e) {
            state.events = [];
            paint();
            const note = document.createElement('div');
            note.className = 'ids-empty';
            note.textContent = `N\xe3o foi poss\xedvel carregar os agendamentos: ${e?.message || e}`;
            bodyEl.prepend(note);
            state.loading = false;
            return;
        }
        state.loading = false;
        paint();
    };
    const goDay = (iso)=>{
        const [y, m, d] = iso.split('-').map(Number);
        state.cursor = new Date(y, m - 1, d);
        state.view = 'day';
        load();
    };
    root.addEventListener('click', (ev)=>{
        ev.stopPropagation();
        const close = ev.target.closest('[data-act="close"]');
        if (close) {
            onClose?.();
            return;
        }
        const prev = ev.target.closest('[data-act="prev"]');
        const next = ev.target.closest('[data-act="next"]');
        const today = ev.target.closest('[data-act="today"]');
        if (prev || next || today) {
            if (today) state.cursor = $1a98e2562fa6dd99$var$startOfDay(new Date());
            else {
                const dir = prev ? -1 : 1;
                if (state.view === 'day') state.cursor = $1a98e2562fa6dd99$var$addDays(state.cursor, dir);
                else if (state.view === 'week') state.cursor = $1a98e2562fa6dd99$var$addDays(state.cursor, dir * 7);
                else state.cursor = new Date(state.cursor.getFullYear(), state.cursor.getMonth() + dir, 1);
            }
            load();
            return;
        }
        const viewBtn = ev.target.closest('[data-view]');
        if (viewBtn) {
            state.view = viewBtn.dataset.view;
            load();
            return;
        }
        const open = ev.target.closest('[data-open]');
        if (open) {
            try {
                const [company_id, id] = JSON.parse(open.dataset.open);
                const row = state.events.find((e)=>String(e.company_id) === String(company_id) && Number(e.id) === Number(id));
                if (row) onOpen?.(row);
            } catch (_) {}
            return;
        }
        const dayBtn = ev.target.closest('[data-day]');
        if (dayBtn) goDay(dayBtn.dataset.day);
    });
    load();
    return {
        reload: load
    };
}



function $2ab24e4cc07eea21$var$isCountQuery(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    return qs.get('group') === 'count';
}
function $2ab24e4cc07eea21$var$pageBounds(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    const limit = Number(qs.get('limit') || 30);
    const offset = Number(qs.get('offset') || 0);
    return {
        limit: Number.isFinite(limit) ? limit : 30,
        offset: Number.isFinite(offset) ? offset : 0
    };
}
function $2ab24e4cc07eea21$var$filtersToParams(filterData) {
    const params = {};
    for(let i = 0; i < 16; i++){
        const field = filterData?.[`field-${i}`];
        const value = filterData?.[`value-${i}`];
        if (!field || value == null || value === '') continue;
        params[field] = value;
    }
    return params;
}
function $2ab24e4cc07eea21$var$escHtml(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $2ab24e4cc07eea21$var$downloadBase64(b64, filename, mime) {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)bytes[i] = bin.charCodeAt(i);
    const blob = new Blob([
        bytes
    ], {
        type: mime
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
}
function $2ab24e4cc07eea21$var$setText(root, sel, text) {
    root?.querySelectorAll(sel)?.forEach((el)=>{
        el.textContent = text;
    });
}
const $2ab24e4cc07eea21$var$inputDockSchedules = function() {
    const rt_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        _lastSearchKey: null,
        _lastSearchRows: null,
        async loadBaseData () {
            const q = this.queryAll();
            const [companies, warehouses, suppliers, users, docks] = await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_suppliers, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_users, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_input_docks, q)
            ]);
            await Promise.all([
                (0, $1cmSR.default).set('companies', companies || []).catch(()=>{}),
                (0, $1cmSR.default).set('warehouses', warehouses || []).catch(()=>{}),
                (0, $1cmSR.default).set('suppliers', suppliers || []).catch(()=>{}),
                (0, $1cmSR.default).set('users', users || []).catch(()=>{}),
                (0, $1cmSR.default).set('input_docks', docks || []).catch(()=>{})
            ]);
        },
        async queryData (query) {
            const filterParams = $2ab24e4cc07eea21$var$filtersToParams(this.filter || {});
            let companies = filterParams.company_id ? [
                {
                    id: await (0, $7WMRl.resolveCompanyId)(filterParams.company_id) || filterParams.company_id
                }
            ] : await (0, $1cmSR.default).list('companies').catch(()=>[]);
            if (!companies?.length) companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
            companies = (companies || []).filter((c)=>{
                if (!c?.id) return false;
                if (filterParams.company_id && String(c.id) === String(filterParams.company_id)) return true;
                const v = c.in_dock_scheduling_enabled;
                if (v === false || v === 0 || v === '0' || v === 'false') return false;
                // Sem campo no cache: ainda consulta (API decide / 400 flag off).
                return true;
            });
            if (filterParams.company_id && !companies.length) {
                const cid = await (0, $7WMRl.resolveCompanyId)(filterParams.company_id) || filterParams.company_id;
                if (cid) companies = [
                    {
                        id: cid
                    }
                ];
            }
            companies = (companies || []).filter((c)=>c?.id);
            if (!companies.length) return $2ab24e4cc07eea21$var$isCountQuery(query) ? 0 : [];
            const docksCache = await (0, $1cmSR.default).list('input_docks').catch(()=>[]) || [];
            const dockByKey = new Map(docksCache.map((d)=>[
                    `${d.company_id}:${d.id}`,
                    d
                ]));
            let warehouseId = null;
            if (filterParams.warehouse_id) {
                const wh = await (0, $7WMRl.resolveWarehouseId)(companies[0]?.id, filterParams.warehouse_id);
                warehouseId = Number.isFinite(wh) && wh >= 1 ? wh : null;
            }
            let dockId = null;
            if (filterParams.dock_id != null && String(filterParams.dock_id).trim() !== '') {
                const rawDock = String(filterParams.dock_id).trim();
                if (/^\d+$/.test(rawDock)) dockId = Number(rawDock);
                else {
                    const found = docksCache.find((d)=>d.name === rawDock);
                    dockId = found?.id ?? null;
                }
            }
            let supplierId = null;
            if (filterParams.supplier_id != null && String(filterParams.supplier_id).trim() !== '') {
                const rawSup = String(filterParams.supplier_id).trim();
                if (/^\d+$/.test(rawSup)) supplierId = Number(rawSup);
                else {
                    const suppliers = await (0, $1cmSR.default).list('suppliers').catch(()=>[]) || [];
                    const found = suppliers.find((s)=>s.nick === rawSup || s.name === rawSup || String(s.id) === rawSup);
                    supplierId = found?.id != null ? Number(found.id) : null;
                }
            }
            const searchKey = JSON.stringify({
                companies: companies.map((c)=>c.id).sort(),
                date_from: filterParams.date_from || '',
                date_to: filterParams.date_to || '',
                warehouse_id: warehouseId || '',
                dock_id: dockId || '',
                input_order_id: filterParams.input_order_id || '',
                invoice_number: filterParams.invoice_number || '',
                supplier_id: supplierId || '',
                status: filterParams.status || '',
                has_occurrence: filterParams.has_occurrence || ''
            });
            let rows = this._lastSearchKey === searchKey && Array.isArray(this._lastSearchRows) ? this._lastSearchRows : null;
            if (!rows) {
                const lists = await Promise.all(companies.map(async (company)=>{
                    const q = new URLSearchParams();
                    if (filterParams.date_from) q.set('date_from', String(filterParams.date_from));
                    if (filterParams.date_to) q.set('date_to', String(filterParams.date_to));
                    if (warehouseId) q.set('warehouse_id', String(warehouseId));
                    if (dockId) q.set('dock_id', String(dockId));
                    if (filterParams.input_order_id) q.set('input_order_id', String(filterParams.input_order_id));
                    if (filterParams.invoice_number) q.set('invoice_number', String(filterParams.invoice_number));
                    if (filterParams.supplier_id) {
                        if (supplierId != null) q.set('supplier_id', String(supplierId));
                    }
                    if (filterParams.status) q.set('status', String(filterParams.status));
                    if (filterParams.has_occurrence != null && filterParams.has_occurrence !== '') {
                        const ho = filterParams.has_occurrence;
                        const on = ho === true || ho === 1 || ho === '1' || ho === 'true' || ho === 'Sim';
                        q.set('has_occurrence', on ? '1' : '0');
                    }
                    const qs = q.toString() ? `?${q.toString()}` : '';
                    try {
                        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_dock_schedules, company.id, qs);
                        return (Array.isArray(data) ? data : []).map((row)=>{
                            const dock = dockByKey.get(`${row.company_id}:${row.dock_id}`);
                            return {
                                ...row,
                                dock_name: dock?.name || null,
                                dock_type: dock?.dock_type || null,
                                dock_type_label: dock ? (0, $aecc276d35afe90f$export$17ff6761b39ffe92)(dock.dock_type) : null
                            };
                        });
                    } catch (e) {
                        console.warn('input-dock-schedules list', company.id, e);
                        return [];
                    }
                }));
                rows = lists.flat();
                rows.sort((a, b)=>String(b.scheduled_start || '').localeCompare(String(a.scheduled_start || '')));
                this._lastSearchKey = searchKey;
                this._lastSearchRows = rows;
            }
            if ($2ab24e4cc07eea21$var$isCountQuery(query)) return rows.length;
            const { limit: limit, offset: offset } = $2ab24e4cc07eea21$var$pageBounds(query);
            return rows.slice(offset, offset + limit);
        },
        async reloadPage () {
            this._lastSearchKey = null;
            this._lastSearchRows = null;
            return Object.getPrototypeOf(this).reloadPage.call(this);
        },
        async loadRecord (id) {
            const [company_id, schedule_id] = JSON.parse(id);
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_dock_schedule, company_id, schedule_id);
            return data;
        },
        editRecord (data) {
            if (!data?.schedule) return;
            this.showDetail(data);
        },
        insertRecord () {
            this.openScheduleEditor({
                mode: 'create'
            });
        },
        async _fetchSchedulesInRange (dateFrom, dateTo) {
            let companies = await (0, $1cmSR.default).list('companies').catch(()=>[]) || [];
            if (!companies.length) companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
            companies = (companies || []).filter((c)=>{
                if (!c?.id) return false;
                const v = c.in_dock_scheduling_enabled;
                if (v === false || v === 0 || v === '0' || v === 'false') return false;
                return true;
            });
            if (!companies.length) companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
            const docksCache = await (0, $1cmSR.default).list('input_docks').catch(()=>[]) || [];
            const dockByKey = new Map(docksCache.map((d)=>[
                    `${d.company_id}:${d.id}`,
                    d
                ]));
            const lists = await Promise.all((companies || []).filter((c)=>c?.id).map(async (company)=>{
                const q = new URLSearchParams();
                if (dateFrom) q.set('date_from', dateFrom);
                if (dateTo) q.set('date_to', dateTo);
                try {
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_dock_schedules, company.id, `?${q.toString()}`);
                    return (Array.isArray(data) ? data : []).map((row)=>{
                        const dock = dockByKey.get(`${row.company_id}:${row.dock_id}`);
                        return {
                            ...row,
                            dock_name: dock?.name || row.dock_name || null
                        };
                    });
                } catch (e) {
                    console.warn('calendar schedules', company.id, e);
                    return [];
                }
            }));
            return lists.flat();
        },
        async loadPage (...args) {
            if (this._calendarOpen) return;
            return Object.getPrototypeOf(this).loadPage.apply(this, args);
        },
        openCalendar () {
            const work = this.target_node;
            const grid = work?.querySelector('#grid');
            if (!work || !grid) return (0, $jUNyh.notify)("\xc1rea da grade n\xe3o encontrada.", "Calend\xe1rio");
            this._calendarOpen = true;
            grid.style.display = 'none';
            let panel = work.querySelector('#ids-cal-panel');
            if (!panel) {
                panel = document.createElement('div');
                panel.id = 'ids-cal-panel';
                work.appendChild(panel);
            }
            panel.style.display = '';
            try {
                this._calendar = (0, $1a98e2562fa6dd99$export$57bed8477c502797)(panel, {
                    fetchRange: (from, to)=>this._fetchSchedulesInRange(from, to),
                    onOpen: async (row)=>{
                        try {
                            const payload = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_dock_schedule, row.company_id, row.id);
                            if (!payload?.schedule) return (0, $jUNyh.notify)("Agendamento n\xe3o encontrado.", "Calend\xe1rio");
                            (0, $b8167635cb1083d7$export$56563c28d49804f7)({
                                payload: payload,
                                onDone: ()=>this._calendar?.reload?.()
                            });
                        } catch (e) {
                            (0, $jUNyh.notify)(e?.message || String(e), "Calend\xe1rio");
                        }
                    },
                    onClose: ()=>{
                        this._calendar = null;
                        this._calendarOpen = false;
                        panel.remove();
                        grid.style.display = '';
                        this.reloadPage();
                    }
                });
            } catch (e) {
                this._calendar = null;
                this._calendarOpen = false;
                panel.remove();
                grid.style.display = '';
                (0, $jUNyh.notify)(e?.message || String(e), "Calend\xe1rio");
            }
        },
        async openDetail () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)('Selecione exatamente um agendamento.', 'Agendamento de Docas');
            const [company_id, schedule_id] = ids[0];
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_dock_schedule, company_id, schedule_id);
            if (!data?.schedule) return;
            this.showDetail(data);
        },
        showDetail (payload) {
            const schedule = payload.schedule;
            const companyId = schedule.company_id;
            const scheduleId = schedule.id;
            const fs = (0, $h1m6J.default).create((0, $82e8a93ec86d36b7$export$2e2bcd8739ae039), async (ev)=>{
                if (ev === 'Escape') fs.destroy();
            });
            fs.init();
            const root = document.querySelector('#input_dock_schedule_detail');
            if (!root) return;
            $2ab24e4cc07eea21$var$setText(root, '[data-sdp="id"]', String(schedule.id));
            $2ab24e4cc07eea21$var$setText(root, '[data-sdp="status"]', (0, $aecc276d35afe90f$export$a954299e2515e375)(schedule.status));
            $2ab24e4cc07eea21$var$setText(root, '[data-sdp="title"]', `Agendamento #${schedule.id}`);
            const dock = payload.dock || {};
            const main = root.querySelector('#ids_detail_main');
            if (main) main.innerHTML = [
                [
                    'Doca',
                    dock.name || schedule.dock_id
                ],
                [
                    'Tipo',
                    (0, $aecc276d35afe90f$export$17ff6761b39ffe92)(dock.dock_type)
                ],
                [
                    "Armaz\xe9m",
                    schedule.warehouse_id
                ],
                [
                    'Data',
                    (0, $aecc276d35afe90f$export$3ae94a2503e890a1)(schedule.scheduled_start)
                ],
                [
                    "Hor\xe1rio",
                    `${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(schedule.scheduled_start)} \u{2013} ${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(schedule.scheduled_end)}`
                ],
                [
                    "Dura\xe7\xe3o",
                    `${schedule.duration_minutes || "\u2014"} min`
                ],
                [
                    "Respons\xe1vel",
                    schedule.responsible_user_id || "\u2014"
                ],
                [
                    'Status',
                    (0, $aecc276d35afe90f$export$a954299e2515e375)(schedule.status)
                ],
                [
                    "Ocorr\xeancia",
                    schedule.has_occurrence ? "Com ocorr\xeancia" : "Sem ocorr\xeancia"
                ]
            ].map(([k, v])=>`<dt>${$2ab24e4cc07eea21$var$escHtml(k)}</dt><dd>${$2ab24e4cc07eea21$var$escHtml(v)}</dd>`).join('');
            const orderBox = root.querySelector('#ids_detail_order');
            const order = payload.input_order || {};
            const supplier = payload.supplier || {};
            if (orderBox) orderBox.innerHTML = [
                [
                    'Pedido Entrada',
                    schedule.input_order_id
                ],
                [
                    'NF',
                    schedule.invoice_number || order.nf_number || "\u2014"
                ],
                [
                    'Fornecedor',
                    supplier.nick || supplier.name || schedule.supplier_id || "\u2014"
                ],
                [
                    'Status pedido',
                    order.status ?? "\u2014"
                ]
            ].map(([k, v])=>`<dt>${$2ab24e4cc07eea21$var$escHtml(k)}</dt><dd>${$2ab24e4cc07eea21$var$escHtml(v)}</dd>`).join('');
            const notesEl = root.querySelector('#ids_detail_notes');
            if (notesEl) notesEl.textContent = schedule.notes ? `Observa\xe7\xf5es: ${schedule.notes}` : '';
            const evUl = root.querySelector('#ids_detail_events');
            const events = Array.isArray(payload.events) ? payload.events : [];
            if (evUl) evUl.innerHTML = events.length ? events.map((ev)=>`
						<li>
							<div class="ids-tl-type">${$2ab24e4cc07eea21$var$escHtml((0, $aecc276d35afe90f$export$ed661ffc2b635f11)(ev.event_type))}</div>
							<div class="ids-tl-when">${$2ab24e4cc07eea21$var$escHtml(ev.created_on || '')}</div>
						</li>`).join('') : '<li><div class="ids-tl-type">Sem eventos</div></li>';
            const occs = Array.isArray(payload.occurrences) ? payload.occurrences : [];
            const occBlock = root.querySelector('#ids_detail_occ_block');
            const occUl = root.querySelector('#ids_detail_occs');
            if (occBlock && occUl) {
                if (occs.length) {
                    occBlock.hidden = false;
                    occUl.innerHTML = occs.map((o)=>`
						<li>
							<div class="ids-tl-type">${$2ab24e4cc07eea21$var$escHtml(o.occurrence_type || o.type || "Ocorr\xeancia")}</div>
							<div class="ids-tl-when">${$2ab24e4cc07eea21$var$escHtml(o.notes || o.created_on || '')}</div>
						</li>`).join('');
                } else occBlock.hidden = true;
            }
            const btnCancel = root.querySelector('#ids_detail_cancel');
            const btnReschedule = root.querySelector('#ids_detail_reschedule');
            const mutable = (0, $aecc276d35afe90f$export$3db432bf1df9ac80)(schedule.status);
            if (btnCancel) btnCancel.disabled = !mutable;
            if (btnReschedule) btnReschedule.disabled = !mutable;
            btnCancel?.addEventListener('click', ()=>{
                if (!mutable) return (0, $jUNyh.notify)("Agendamento n\xe3o pode ser cancelado neste status.", 'Agendamento de Docas');
                fs.destroy();
                this.openCancel(companyId, scheduleId);
            });
            btnReschedule?.addEventListener('click', ()=>{
                if (!mutable) return (0, $jUNyh.notify)("Agendamento n\xe3o pode ser reagendado neste status.", 'Agendamento de Docas');
                fs.destroy();
                this.openScheduleEditor({
                    mode: 'reschedule',
                    companyId: companyId,
                    scheduleId: scheduleId,
                    schedule: schedule,
                    dock: dock
                });
            });
        },
        async openCancelFromList () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)('Selecione exatamente um agendamento.', 'Agendamento de Docas');
            const [company_id, schedule_id] = ids[0];
            const cached = (this._lastSearchRows || []).find((r)=>String(r.company_id) === String(company_id) && Number(r.id) === Number(schedule_id));
            if (cached && !(0, $aecc276d35afe90f$export$3db432bf1df9ac80)(cached.status)) return (0, $jUNyh.notify)("Agendamento n\xe3o pode ser cancelado neste status.", 'Agendamento de Docas');
            this.openCancel(company_id, schedule_id);
        },
        openCancel (companyId, scheduleId) {
            const fs = (0, $h1m6J.default).create((0, $be8ea4d1984c1298$export$2e2bcd8739ae039), async (data)=>{
                const reason = String(data.cancel_reason || '').trim();
                if (!reason) return (0, $jUNyh.notify)('Informe o motivo do cancelamento.', 'Agendamento de Docas');
                (0, $jUNyh.ask)('Confirma o cancelamento deste agendamento?', 'Cancelar', async (answer)=>{
                    if (answer !== 'Y') return;
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).cancel_input_dock_schedule, companyId, scheduleId, {
                        cancel_reason: reason
                    });
                    if (!resp) return;
                    (0, $jUNyh.notify)('Agendamento cancelado.', 'Sucesso');
                    fs.destroy();
                    await this.reloadPage();
                });
            });
            fs.init();
        },
        async openRescheduleFromList () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)('Selecione exatamente um agendamento.', 'Agendamento de Docas');
            const [company_id, schedule_id] = ids[0];
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_dock_schedule, company_id, schedule_id);
            if (!data?.schedule) return;
            if (!(0, $aecc276d35afe90f$export$3db432bf1df9ac80)(data.schedule.status)) return (0, $jUNyh.notify)("Agendamento n\xe3o pode ser reagendado neste status.", 'Agendamento de Docas');
            this.openScheduleEditor({
                mode: 'reschedule',
                companyId: company_id,
                scheduleId: schedule_id,
                schedule: data.schedule,
                dock: data.dock
            });
        },
        openScheduleEditor ({ mode: mode, companyId: companyId, scheduleId: scheduleId, schedule: schedule, dock: dock } = {}) {
            (0, $b8167635cb1083d7$export$bc9d4cb3bb8226a4)({
                mode: mode,
                companyId: companyId,
                scheduleId: scheduleId,
                schedule: schedule,
                dock: dock,
                onDone: ()=>this.reloadPage()
            });
        },
        async _reportPairs () {
            const selected = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (selected.length) return selected;
            const rows = Array.isArray(this._lastSearchRows) ? this._lastSearchRows : [];
            if (!rows.length) {
                (0, $jUNyh.notify)('Selecione as linhas ou filtre a lista antes de imprimir.', 'Agendamento de Docas');
                return null;
            }
            return rows.map((r)=>[
                    r.company_id,
                    r.id
                ]);
        },
        _groupPairs (pairs) {
            const byCompany = new Map();
            for (const [company_id, id] of pairs){
                if (!byCompany.has(company_id)) byCompany.set(company_id, []);
                byCompany.get(company_id).push(Number(id));
            }
            return byCompany;
        },
        printControlSheet () {
            (async ()=>{
                const pairs = await this._reportPairs();
                if (!pairs) return;
                try {
                    for (const [company_id, schedule_ids] of this._groupPairs(pairs)){
                        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_dock_schedule_control, company_id, {
                            schedule_ids: schedule_ids
                        });
                        if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                        else (0, $jUNyh.notify)('Nenhum PDF retornado.', 'Controle de Agendamento');
                    }
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Controle de Agendamento');
                }
            })();
        },
        exportExcel () {
            (async ()=>{
                const pairs = await this._reportPairs();
                if (!pairs) return;
                try {
                    for (const [company_id, schedule_ids] of this._groupPairs(pairs)){
                        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_input_dock_schedules_xlsx, company_id, {
                            schedule_ids: schedule_ids
                        });
                        if (resp?.xlsx) $2ab24e4cc07eea21$var$downloadBase64(resp.xlsx, resp.filename || 'agendamentos-docas.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        else (0, $jUNyh.notify)('Nenhuma planilha retornada.', 'Extrato Excel');
                    }
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Extrato Excel');
                }
            })();
        }
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedule-calendar', ()=>rt_crud.openCalendar());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedule-detail', ()=>rt_crud.openDetail());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedule-cancel', ()=>rt_crud.openCancelFromList());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedule-reschedule', ()=>rt_crud.openRescheduleFromList());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedule-print-control', ()=>rt_crud.printControlSheet());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedule-export-xlsx', ()=>rt_crud.exportExcel());
    const fieldspecs = [
        {
            index: 1,
            field: 'date_from',
            label: "Per\xedodo inicial",
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: 'Data/hora inicial (scheduled_end > date_from)'
        },
        {
            index: 2,
            field: 'date_to',
            label: "Per\xedodo final",
            types: [
                $b7D1Q.default()
            ],
            placeholder: '',
            title: 'Data/hora final (scheduled_start < date_to)'
        },
        {
            index: 3,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 4,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 5,
            field: 'dock_id',
            label: 'Doca',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Doca (nome ou id)',
            store: 'input_docks',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'status',
            label: 'Status',
            types: [
                (0, $dfcee61d129e0b80$export$2e2bcd8739ae039)(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status do agendamento'
        },
        {
            index: 7,
            field: 'input_order_id',
            label: 'Pedido Entrada',
            types: [],
            placeholder: '',
            title: 'ID do Pedido de Entrada'
        },
        {
            index: 8,
            field: 'invoice_number',
            label: 'NF',
            types: [],
            placeholder: '',
            title: "N\xfamero da NF"
        },
        {
            index: 9,
            field: 'supplier_id',
            label: 'Fornecedor',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Fornecedor',
            store: 'suppliers',
            labels: [
                'nick'
            ]
        },
        {
            index: 10,
            field: 'has_occurrence',
            label: "Com ocorr\xeancia",
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Filtrar com ocorr\xeancia"
        },
        {
            index: 11,
            field: 'dock_type',
            label: 'Tipo',
            types: [
                (0, $02c6004873977d5a$export$2e2bcd8739ae039)(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Tipo (s\xf3 visual/filtro local se usado)",
            computed: true
        }
    ];
    const operations = [
        {
            hash: '#input-dock-schedule-calendar',
            label: "Calend\xe1rio"
        },
        {
            hash: '#input-dock-schedule-detail',
            label: 'Detalhar'
        },
        {
            hash: '#input-dock-schedule-cancel',
            label: 'Cancelar'
        },
        {
            hash: '#input-dock-schedule-reschedule',
            label: 'Reagendar'
        }
    ];
    const reports = [
        {
            hash: '#input-dock-schedule-print-control',
            label: 'Controle&nbsp;de&nbsp;Agendamento'
        },
        {
            hash: '#input-dock-schedule-export-xlsx',
            label: 'Extrato&nbsp;Excel'
        }
    ];
    rt_crud.run('input_dock_schedules', 'Agendamento&nbsp;de&nbsp;Docas', document.getElementById('workarea'), (0, $d409cdbc5b061218$export$2e2bcd8739ae039), null, fieldspecs, operations, reports);
};
var $2ab24e4cc07eea21$export$2e2bcd8739ae039 = $2ab24e4cc07eea21$var$inputDockSchedules;


/**
 * #MT-7740432 — Ondas de derrubada / chamada ativa.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $h1m6J = parcelRequire("h1m6J");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");
function $6479c44d87265103$var$formatWaveCreatedOn(value) {
    if (value == null || value === '') return '';
    let s = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2} /.test(s)) s = s.replace(' ', 'T');
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return String(value);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} - ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
async function $6479c44d87265103$export$2e2bcd8739ae039(records) {
    const rows = Array.isArray(records) ? records : [];
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(3),
			.view td:nth-child(4),
			.view td:nth-child(5),
			.view td:nth-child(6),
			.view td:nth-child(7) { text-align: right; }
			.pw-exc { color: #a30; }
			.view tr[data-id] { cursor: pointer; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="0" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="1" data-visible="${this.visible[1]}">Onda</th>
					<th data-index="2" data-visible="${this.visible[2]}">Pedidos</th>
					<th data-index="3" data-visible="${this.visible[3]}">Descer pend.</th>
					<th data-index="4" data-visible="${this.visible[4]}">Descer ok</th>
					<th data-index="5" data-visible="${this.visible[5]}">Exce\xe7\xf5es</th>
					<th data-index="6" data-visible="${this.visible[6]}">Status</th>
					<th data-index="7" data-visible="${this.visible[7]}">Cria\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
				${rows.map((r)=>`
					<tr data-id='${JSON.stringify([
            r.company_id,
            r.id
        ])}'>
						<td><input type="checkbox"></td>
						<td>${r.company_nick || r.company_id || ''}</td>
						<td>${r.id ?? ''}</td>
						<td>${r.order_count ?? ''}</td>
						<td>${r.descer_pending ?? ''}</td>
						<td>${r.descer_done ?? ''}</td>
						<td class="${Number(r.exception_count) > 0 ? 'pw-exc' : ''}">${r.exception_count ?? ''}</td>
						<td>${({
            DRAFT: 'Rascunho',
            CONFIRMED: 'Confirmada',
            DESCENDING: 'Descendo',
            PICKING: "Separa\xe7\xe3o",
            RETURNING: 'Devolvendo',
            DONE: "Conclu\xedda",
            EXCEPTION: "Exce\xe7\xe3o",
            CANCELLED: 'Cancelada'
        })[r.status] || r.status || ''}</td>
						<td>${$6479c44d87265103$var$formatWaveCreatedOn(r.created_on)}</td>
					</tr>
				`).join('')}
			</tbody>
		</table>
	`;
}



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");

var $dZ5S0 = parcelRequire("dZ5S0");

var $1cmSR = parcelRequire("1cmSR");

var $9VcS9 = parcelRequire("9VcS9");
const $25a6bbdfb2e3c959$var$MAX_WH_ID = 2147483647;
function $25a6bbdfb2e3c959$var$isWarehouseActive(r) {
    return !(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1');
}
/**
 * @param {unknown[]} rows
 * @param {string|number} cid
 */ function $25a6bbdfb2e3c959$var$filterPhysical(rows, cid) {
    return (rows || []).filter((r)=>String(r.company_id) === String(cid) && $25a6bbdfb2e3c959$var$isWarehouseActive(r) && Number(r.warehouse_type ?? 1) === 2).sort((a, b)=>Number(a.id) - Number(b.id));
}
/**
 * Lista armazéns da empresa: GET direto (sem msgbox) para refletir API; IDB só se falhar.
 */ async function $25a6bbdfb2e3c959$var$loadWarehousesForCompany(companyId) {
    const host = (0, $9VcS9.getSialApiHost)();
    const url = `${host}/warehouses?limit=0`;
    try {
        const r = await fetch(url, {
            credentials: 'include'
        });
        if (!r.ok) throw new Error(String(r.status));
        const all = await r.json();
        return (Array.isArray(all) ? all : []).filter((w)=>String(w.company_id) === String(companyId));
    } catch (_) {
        const range = IDBKeyRange.bound([
            companyId,
            0
        ], [
            companyId,
            $25a6bbdfb2e3c959$var$MAX_WH_ID
        ]);
        return await (0, $1cmSR.default).list('warehouses', range, 1) || [];
    }
}
/**
 * UUID do campo empresa + evento publish + valor exibido / datalist (nick).
 */ function $25a6bbdfb2e3c959$var$resolveCompanyId(fieldCtx, key) {
    let _watchKey = fieldCtx._key;
    if (fieldCtx.getId().match((0, $dZ5S0.REGEX)) && _watchKey && _watchKey.match((0, $dZ5S0.REGEX))) _watchKey = (0, $dZ5S0.replaceIndex)(_watchKey, fieldCtx.getId().match((0, $dZ5S0.REGEX)).pop());
    let companyId = _watchKey ? fieldCtx.locate(_watchKey)?.getValue() : null;
    if (companyId === undefined) companyId = null;
    if (companyId != null && companyId !== '' && typeof companyId === 'string' && /^\d+$/.test(companyId)) companyId = Number(companyId);
    if ((companyId == null || companyId === '') && key != null && key !== '' && !Array.isArray(key)) companyId = typeof key === 'string' && /^\d+$/.test(key) ? Number(key) : key;
    const inp = document.querySelector('#create-outputs #company_id') || document.querySelector('#create-derrubada #company_id') || document.querySelector('#picking-wave-create #company_id');
    const raw = inp ? String(inp.value || '').trim() : '';
    if (raw) {
        if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(raw)) companyId = raw;
        else {
            const lid = inp.getAttribute('list');
            const dl = lid ? document.getElementById(lid) : null;
            if (dl) for (const o of dl.options){
                if (String(o.value) === raw) {
                    companyId = o.value;
                    break;
                }
                if ((o.textContent || '').trim() === raw) {
                    companyId = o.value;
                    break;
                }
            }
        }
    }
    return companyId;
}
/**
 * Gerar saídas: &lt;select&gt; apenas com armazéns físicos ativos (warehouse_type=2, não inativo).
 * Obrigatório só quando há mais de um físico. Com um único físico, o backend aplica automaticamente se vier vazio.
 */ function $25a6bbdfb2e3c959$var$fillPhysicalWarehouseSelect(selector, physicalRows) {
    const sel = document.querySelector(selector);
    if (!sel || sel.tagName !== 'SELECT') return;
    const prev = sel.value;
    const n = (physicalRows || []).length;
    const multi = n > 1;
    sel.innerHTML = '';
    const opt0 = document.createElement('option');
    opt0.value = '';
    if (n === 0) {
        opt0.textContent = "\u2014 Picking na empresa (n\xe3o precisa escolher) \u2014";
        sel.appendChild(opt0);
        sel.required = false;
        sel.disabled = true;
    } else if (n === 1) {
        const r = physicalRows[0];
        opt0.textContent = "\u2014 \xdanico f\xedsico (j\xe1 selecionado abaixo) \u2014";
        sel.appendChild(opt0);
        const o = document.createElement('option');
        o.value = String(r.id);
        o.textContent = r.name || `Armaz\xe9m ${r.id}`;
        sel.appendChild(o);
        sel.required = false;
        sel.disabled = false;
        sel.value = String(r.id);
    } else {
        opt0.textContent = "\u2014 Selecione um armaz\xe9m f\xedsico \u2014";
        sel.appendChild(opt0);
        for (const r of physicalRows){
            const o = document.createElement('option');
            o.value = String(r.id);
            o.textContent = r.name || `Armaz\xe9m ${r.id}`;
            sel.appendChild(o);
        }
        sel.required = true;
        sel.disabled = false;
        if (prev && [
            ...sel.options
        ].some((o)=>o.value === prev)) sel.value = prev;
        else sel.value = '';
    }
    const titleEl = document.querySelector('#create-outputs #co-wh-title');
    const hintEl = document.querySelector('#create-outputs #co-wh-hint');
    if (titleEl) {
        if (n === 0) titleEl.textContent = "Armaz\xe9m f\xedsico";
        else if (multi) titleEl.textContent = "Armaz\xe9m f\xedsico (obrigat\xf3rio \u2014 h\xe1 mais de um ativo)";
        else titleEl.textContent = "Armaz\xe9m f\xedsico";
    }
    if (hintEl) {
        if (n === 0) hintEl.innerHTML = "Esta empresa n\xe3o tem <strong>armaz\xe9m f\xedsico ativo</strong>. O picking usa s\xf3 o saldo da <strong>pr\xf3pria empresa</strong> (FEFO), em todos os armaz\xe9ns dela. N\xe3o mistura estoque de outro depositante.<br><strong>Faturamento/NF-e:</strong> uma NF por pedido, salvo cancelamento/inutiliza\xe7\xe3o.";
        else if (multi) hintEl.innerHTML = "H\xe1 <strong>mais de um armaz\xe9m f\xedsico ativo</strong>. \xc9 <strong>obrigat\xf3rio</strong> escolher <strong>exatamente um</strong> na lista. Locais f\xedsicos distintos n\xe3o misturam entradas, sa\xeddas e separa\xe7\xf5es.";
        else hintEl.innerHTML = "S\xf3 existe <strong>um armaz\xe9m f\xedsico ativo</strong> \u2014 ele j\xe1 vem selecionado; voc\xea pode confirmar ou alterar. Se deixar a op\xe7\xe3o \u201C\xfanico\u201D, o sistema usa esse armaz\xe9m no cabe\xe7alho da sa\xedda.";
    }
}
function $25a6bbdfb2e3c959$export$2e2bcd8739ae039() {
    const SHARED = {
        _this: null
    };
    return {
        _store: 'warehouses',
        _key: 'company_id',
        _index: 1,
        async actions (ev, publisher, key) {
            const action = async (companyId)=>{
                const rows = await $25a6bbdfb2e3c959$var$loadWarehousesForCompany(companyId);
                let physical = $25a6bbdfb2e3c959$var$filterPhysical(rows, companyId);
                if (!physical.length) {
                    const active = (rows || []).filter((r)=>String(r.company_id) === String(companyId) && $25a6bbdfb2e3c959$var$isWarehouseActive(r)).sort((a, b)=>Number(a.id) - Number(b.id));
                    if (active.length === 1) physical = active;
                }
                $25a6bbdfb2e3c959$var$fillPhysicalWarehouseSelect(this.selector, physical);
                const selNode = document.querySelector(this.selector);
                if (selNode && typeof this.setValue === 'function') this.setValue(selNode.value || '');
                this.refresh();
            };
            const companyId = $25a6bbdfb2e3c959$var$resolveCompanyId(this, key);
            if (companyId != null && companyId !== '' && (typeof companyId === 'string' || typeof companyId === 'number' && !isNaN(companyId) && companyId >= 0)) this.preventMultiCalls(SHARED, action, ()=>this.refresh(), [
                companyId
            ]);
            else {
                const sel = document.querySelector(this.selector);
                if (sel && sel.tagName === 'SELECT') {
                    sel.innerHTML = '';
                    const o = document.createElement('option');
                    o.value = '';
                    o.textContent = "\u2014 Escolha a empresa primeiro \u2014";
                    sel.appendChild(o);
                    sel.required = false;
                    sel.disabled = true;
                    if (typeof this.setValue === 'function') this.setValue('');
                    this.refresh();
                }
            }
        }
    };
}


var $dd3a4724c4f985d3$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#picking-wave-create.form {
				width: min(72rem, calc(100vw - 1.5rem));
				box-sizing: border-box;
			}
			#picking-wave-create #company_id,
			#picking-wave-create #warehouse_id,
			#picking-wave-create #customer_id,
			#picking-wave-create #program_id,
			#picking-wave-create #reference { width: 100%; max-width: 100%; box-sizing: border-box; }
			#picking-wave-create .hint { font-size: 0.85rem; color: #444; margin: 0.35rem 0 0.75rem; }
			#picking-wave-create .pw-search {
				border: 1px solid #d1d5db;
				background: #f8fafc;
				padding: 0.65rem 0.75rem 0.35rem;
				margin: 0.5rem 0 0.75rem;
			}
			#picking-wave-create .pw-search .title-search {
				font-weight: 700;
				margin: 0 0 0.5rem;
				font-size: 0.95rem;
			}
			#pw-eligible { font-weight: 600; }
			#pw-selected { font-weight: 600; }
			#pw-orders {
				width: 100%;
				font-size: 0.85rem;
				max-height: min(28rem, 52vh);
				overflow: auto;
				display: block;
				border: 1px solid #e5e7eb;
			}
			#pw-orders table.view { width: 100%; }
			#pw-orders tr.pw-on td { background: #ecfdf5; }
			#pw-sim { white-space: pre-wrap; font-size: 0.85rem; max-height: 8rem; overflow: auto; }
			#picking-wave-create .pw-toolbar {
				display: flex;
				flex-wrap: wrap;
				gap: 0.5rem 0.75rem;
				align-items: center;
				margin: 0.4rem 0 0.6rem;
			}
		</style>
		<form id="picking-wave-create" class="form" autocomplete="off">
			<datalist id="pw-customers"></datalist>
			<datalist id="pw-programs"></datalist>
			<div class="title">Nova onda de derrubada</div>
			<p class="hint">Pesquise os pedidos <strong>aprovados sem sa\xedda</strong>, marque os que entram no lote e gere a onda. Teto por lote na empresa (padr\xe3o 120). N\xe3o \xe9 para digitar pedido a pedido.</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<select id="company_id" required>
						<option value="">\u{2014} Carregando empresas \u{2014}</option>
					</select>
				</label>
				<label title="Armaz\xe9m f\xedsico \u{2014} s\xf3 obrigat\xf3rio se houver mais de um f\xedsico ativo">Armaz\xe9m f\xedsico
					<select id="warehouse_id">
						<option value="">\u{2014} Escolha a empresa primeiro \u{2014}</option>
					</select>
				</label>
			</div>
			<div class="pw-search">
				<div class="title-search">Pesquisar pedidos</div>
				<div class="fsb">
					<label title="N\xfamero do pedido no SIAL (s\xf3 d\xedgitos, sem ponto)">Pedido
						<input id="order_id" type="text" inputmode="numeric" placeholder="ex.: 62094" autocomplete="off">
					</label>
					<label title="Refer\xeancia / pedido do cliente">Refer\xeancia
						<input id="reference" type="text" placeholder="cont\xe9m">
					</label>
					<label title="Cliente (apelido)">Cliente
						<input id="customer_id" type="text" list="pw-customers" placeholder="apelido">
					</label>
					<label title="Programa">Programa
						<input id="program_id" type="text" list="pw-programs" placeholder="nome">
					</label>
				</div>
				<div class="fsb">
					<label title="Cria\xe7\xe3o a partir de">De
						<input id="date_from" type="date">
					</label>
					<label title="Cria\xe7\xe3o at\xe9">At\xe9
						<input id="date_to" type="date">
					</label>
					<label title="Previs\xe3o de entrega at\xe9">SLA at\xe9
						<input id="sla_to" type="date">
					</label>
				</div>
				<div class="ckb">
					<label><input id="is_emergency" type="checkbox" class="dib">&nbsp;S\xf3 emergenciais</label>
					<label><input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir estoque expirado na simula\xe7\xe3o/gera\xe7\xe3o</label>
				</div>
				<div class="pw-toolbar">
					<button class="button" type="button" id="pw-preview">Pesquisar</button>
					<button class="button" type="button" id="pw-clear-filters">Limpar filtros</button>
					<button class="button" type="button" id="pw-select-cap">Marcar at\xe9 o teto</button>
					<button class="button" type="button" id="pw-clear-sel">Limpar sele\xe7\xe3o</button>
				</div>
				<p class="hint">
					Eleg\xedveis nesta pesquisa: <span id="pw-eligible">\u{2014}</span>
					&nbsp;\xb7&nbsp; Selecionados: <span id="pw-selected">0</span>
				</p>
			</div>
			<div id="pw-orders"></div>
			<pre id="pw-sim" class="hint"></pre>
			<p class="hint"><strong>Simular</strong> s\xf3 mostra o atendimento (n\xe3o grava). <strong>Gerar onda</strong> cria a derrubada de verdade.</p>
			<div class="ckb">
				<label title="Confirma\xe7\xe3o \u{2014} o di\xe1logo seguinte tamb\xe9m pede confirma\xe7\xe3o"><input id="confirm" type="checkbox" class="dib" checked>&nbsp;Confirmo a gera\xe7\xe3o da derrubada</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" type="button">Cancelar</button>
				<button class="button" type="button" id="pw-simulate">Simular</button>
				<button class="button" type="button" id="pw-generate">Gerar onda</button>
			</div>
		</form>
	`,
    form: {
        selector: '#picking-wave-create',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('company_id'),
                (0, $25a6bbdfb2e3c959$export$2e2bcd8739ae039)()
            ]
        },
        {
            properties: {
                selector: '#order_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#reference'
            },
            types: []
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('customers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: []
        },
        {
            properties: {
                selector: '#sla_to'
            },
            types: []
        },
        {
            properties: {
                selector: '#include_expired'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_emergency'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#confirm'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
function $39d39362129bbd6c$var$isCountQuery(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    return qs.get('group') === 'count';
}
function $39d39362129bbd6c$var$pageBounds(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    const limit = Number(qs.get('limit') || 50);
    const offset = Number(qs.get('offset') || 0);
    return {
        limit: Number.isFinite(limit) ? limit : 50,
        offset: Number.isFinite(offset) ? offset : 0
    };
}
function $39d39362129bbd6c$var$filtersToParams(filterData) {
    const params = {};
    for(let i = 0; i < 12; i++){
        const field = filterData?.[`field-${i}`];
        const value = filterData?.[`value-${i}`];
        if (!field || value == null || value === '') continue;
        if ([
            'company_id',
            'status',
            'id'
        ].includes(field)) params[field] = value;
    }
    return params;
}
function $39d39362129bbd6c$var$esc(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
const $39d39362129bbd6c$var$WAVE_STATUS_PT = {
    DRAFT: 'Rascunho',
    CONFIRMED: 'Confirmada',
    DESCENDING: 'Descendo',
    PICKING: "Separa\xe7\xe3o",
    RETURNING: 'Devolvendo',
    DONE: "Conclu\xedda",
    EXCEPTION: "Exce\xe7\xe3o",
    CANCELLED: 'Cancelada'
};
const $39d39362129bbd6c$var$TASK_KIND_PT = {
    DESCER: 'Descer',
    DEVOLVER: 'Devolver'
};
const $39d39362129bbd6c$var$TASK_STATUS_PT = {
    PENDING: 'Pendente',
    IN_PROGRESS: 'Em andamento',
    DONE: "Conclu\xedda",
    EXCEPTION: "Exce\xe7\xe3o",
    DIVERGENCE: "Diverg\xeancia",
    CANCELLED: 'Cancelada'
};
const $39d39362129bbd6c$var$ITEM_STATUS_PT = {
    SELECTED: 'Selecionado',
    RESERVED: 'Reservado'
};
const $39d39362129bbd6c$var$ROLE_PT = {
    SEPARATOR: 'Separador',
    CHECKER: 'Conferente'
};
const $39d39362129bbd6c$var$ICO_WAVE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 18c2.5-3 4.5-3 7 0s4.5 3 7 0"/><path d="M4 12c2.5-3 4.5-3 7 0s4.5 3 7 0"/><path d="M4 6c2.5-3 4.5-3 7 0s4.5 3 7 0"/></svg>';
const $39d39362129bbd6c$var$WAVE_HELP_HTML = `
<div class="pw-help-body">
<h4>O que \xe9 esta tela</h4>
<p>Aqui o gestor acompanha uma <strong>onda de derrubada</strong>: um lote de pedidos cuja mercadoria ainda est\xe1 no elevado. O empilhador desce o palete no <strong>ch\xe3o da mesma coluna</strong>; o separador pega no ch\xe3o; a sobra volta para o elevado.</p>
<h4>Cabe\xe7alho</h4>
<p><strong>Onda:</strong> n\xfamero da onda nesta empresa.</p>
<p><strong>Cria\xe7\xe3o:</strong> data e hora em que a onda foi gerada (dia/m\xeas/ano e hora).</p>
<p><strong>Armaz\xe9m:</strong> armaz\xe9m da onda (n\xfamero interno do cadastro).</p>
<p><strong>Status da onda:</strong></p>
<ul>
<li><strong>Rascunho</strong> \u{2014} ainda n\xe3o confirmada.</li>
<li><strong>Confirmada</strong> \u{2014} gerada, sem tarefa de descer pendente.</li>
<li><strong>Descendo</strong> \u{2014} h\xe1 palete para descer no ch\xe3o.</li>
<li><strong>Separa\xe7\xe3o</strong> \u{2014} paletes no ch\xe3o; o separador j\xe1 pode trabalhar.</li>
<li><strong>Devolvendo</strong> \u{2014} sobra para devolver ao elevado.</li>
<li><strong>Conclu\xedda</strong> \u{2014} onda encerrada.</li>
<li><strong>Exce\xe7\xe3o</strong> \u{2014} alguma tarefa travou (ch\xe3o ocupado, endere\xe7o divergente, etc.).</li>
</ul>
<h4>Cards do resumo</h4>
<ul>
<li><strong>Pedidos</strong> \u{2014} quantos pedidos entram nesta onda.</li>
<li><strong>Descer pendentes</strong> \u{2014} paletes ainda no elevado, esperando o empilhador.</li>
<li><strong>Descer conclu\xeddas</strong> \u{2014} paletes j\xe1 no ch\xe3o da coluna.</li>
<li><strong>Exce\xe7\xf5es</strong> \u{2014} tarefas com problema (precisam de tratativa).</li>
<li><strong>Devolver pendentes</strong> \u{2014} sobras no ch\xe3o que ainda precisam voltar ao elevado.</li>
</ul>
<h4>Pedidos</h4>
<ul>
<li><strong>Pedido</strong> \u{2014} n\xfamero do Pedido de Sa\xedda no SIAL.</li>
<li><strong>Ref.</strong> \u{2014} refer\xeancia do cliente / documento.</li>
<li><strong>Sa\xedda</strong> \u{2014} n\xfamero da sa\xedda gerada (se ainda n\xe3o houver, aparece tra\xe7o).</li>
<li><strong>Status</strong> \u{2014} <em>Selecionado</em> (na onda) ou <em>Reservado</em> (estoque j\xe1 reservado).</li>
<li><strong>Emerg.</strong> \u{2014} <em>Sim</em> quando o pedido \xe9 emergencial (prioridade).</li>
</ul>
<h4>Tarefas do empilhador</h4>
<ul>
<li><strong>Tipo Descer</strong> \u{2014} levar o palete da origem (elevado) para o destino (ch\xe3o da coluna).</li>
<li><strong>Tipo Devolver</strong> \u{2014} devolver a sobra do ch\xe3o para o elevado, depois da separa\xe7\xe3o daquele palete.</li>
<li><strong>Origem / Destino</strong> \u{2014} endere\xe7os (corredor-coluna-n\xedvel-posi\xe7\xe3o).</li>
<li><strong>Status da tarefa</strong> \u{2014} Pendente, Em andamento, Conclu\xedda, Exce\xe7\xe3o, Diverg\xeancia ou Cancelada.</li>
<li><strong>Confirmar</strong> \u{2014} use s\xf3 quando o empilhador j\xe1 executou o movimento no endere\xe7o determinado. N\xe3o invente destino.</li>
</ul>
<h4>Atribui\xe7\xe3o / for\xe7ar operador</h4>
<ul>
<li><strong>Pedido</strong> \u{2014} n\xfamero do pedido da onda que vai receber o operador.</li>
<li><strong>Papel</strong> \u{2014} Separador (picking) ou Conferente.</li>
<li><strong>Operador</strong> \u{2014} pessoa que assume aquele pedido (for\xe7ar exige motivo).</li>
<li><strong>Distribuir entre</strong> \u{2014} marca v\xe1rias pessoas; o sistema reparte os pedidos (proximidade depois do prazo de entrega).</li>
<li><strong>Motivo</strong> \u{2014} obrigat\xf3rio ao clicar em <em>For\xe7ar operador</em> (fica na auditoria).</li>
</ul>
<h4>Fila, exce\xe7\xf5es e rastreio</h4>
<ul>
<li><strong>Fila da onda</strong> \u{2014} pedidos j\xe1 liberados para o separador (palete no ch\xe3o). Vazia se ainda estiver no elevado ou sem sa\xedda.</li>
<li><strong>Exce\xe7\xf5es</strong> \u{2014} tarefas que n\xe3o puderam concluir (ex.: ch\xe3o da coluna ocupado).</li>
<li><strong>Rastreio</strong> \u{2014} movimentos de estoque gravados nesta derrubada (pedido \u{2192} onda \u{2192} tarefa \u{2192} transa\xe7\xe3o).</li>
</ul>
</div>`;
const $39d39362129bbd6c$var$DASH_HELP_HTML = `
<div class="pw-help-body">
<h4>O que \xe9 este painel</h4>
<p>Resumo da derrubada <strong>da empresa escolhida</strong>: quantas ondas existem, o que est\xe1 aberto, produtividade do empilhador e exce\xe7\xf5es que precisam de tratativa.</p>
<h4>Empresa</h4>
<p>Troque a empresa no combo do cabe\xe7alho. Os n\xfameros e as tabelas passam a ser s\xf3 daquela empresa.</p>
<h4>Cards do resumo</h4>
<ul>
<li><strong>Ondas</strong> \u{2014} total de ondas geradas nesta empresa.</li>
<li><strong>Pedidos</strong> \u{2014} pedidos que entram nessas ondas.</li>
<li><strong>Abertas</strong> \u{2014} ondas ainda em andamento (n\xe3o conclu\xeddas).</li>
<li><strong>Conclu\xeddas</strong> \u{2014} ondas encerradas.</li>
<li><strong>Exce\xe7\xf5es</strong> \u{2014} tarefas com problema (ch\xe3o ocupado, coluna sem ch\xe3o, endere\xe7o divergente).</li>
</ul>
<h4>\xdaltimas ondas</h4>
<p>As ondas mais recentes, com status, quantidade de pedidos, Descer pendente e exce\xe7\xf5es. Status em portugu\xeas (Descendo, Exce\xe7\xe3o, Conclu\xedda, etc.).</p>
<h4>Produtividade do empilhador</h4>
<p>Contagem de tarefas <em>confirmadas</em>: quantos Descer, quantos Devolver e quantas exce\xe7\xf5es por operador.</p>
<h4>Atribui\xe7\xf5es</h4>
<p>Quem est\xe1 como Separador ou Conferente em pedidos da onda. Sem linha = ainda ningu\xe9m foi distribu\xeddo nem for\xe7ado.</p>
<h4>Exce\xe7\xf5es abertas</h4>
<p>Lista o que est\xe1 travado agora (onda, tarefa, tipo Descer/Devolver e o motivo). Trate na onda correspondente.</p>
</div>`;
function $39d39362129bbd6c$var$openPwHelp(title, html) {
    let mb;
    mb = (0, $jUNyh.default)({
        title: title,
        text: html,
        buttons: [
            {
                label: 'Fechar',
                cls: 'bn_Enter'
            }
        ],
        callback: ()=>mb.destroy()
    });
}
const $39d39362129bbd6c$var$PW_DETAIL_CSS = `
	.sial-detail .sdp-icon-col {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.35rem;
		flex-shrink: 0;
	}
	.sial-detail .pw-help {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 1.35rem;
		height: 1.35rem;
		padding: 0;
		border: 1px solid #9ca3af;
		border-radius: 999px;
		background: #f3f4f6;
		color: #374151;
		font-size: 0.85rem;
		font-weight: 700;
		line-height: 1;
		cursor: pointer;
	}
	.sial-detail .pw-help:hover { background: #e5e7eb; }
	.sial-detail .pw-help:focus { outline: 2px solid #7c3aed; outline-offset: 2px; }
	.pw-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
	.pw-help-body h4 {
		margin: 0.85rem 0 0.35rem 0;
		font-size: 0.78rem;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.03em;
		color: #1f2937;
	}
	.pw-help-body h4:first-child { margin-top: 0; }
	.pw-help-body p, .pw-help-body li {
		margin: 0 0 0.35rem 0;
		font-size: 0.875rem;
		line-height: 1.45;
		color: #374151;
	}
	.pw-help-body ul { margin: 0.25rem 0 0.5rem 1.15rem; padding: 0; }
`;
function $39d39362129bbd6c$var$labelOf(map, value) {
    if (value == null || value === '') return "\u2014";
    const key = String(value);
    return map[key] || map[key.toUpperCase()] || key;
}
function $39d39362129bbd6c$var$waveBadgeClass(status) {
    const s = String(status || '').toUpperCase();
    if (s === 'DONE') return 'sdp-badge sdp-badge--free';
    if (s === 'EXCEPTION') return 'sdp-badge sdp-badge--blocked';
    if (s === 'DESCENDING' || s === 'RETURNING' || s === 'PICKING') return 'sdp-badge sdp-badge--reserved';
    return 'sdp-badge sdp-badge--other';
}
function $39d39362129bbd6c$var$formatSummary(rows) {
    if (!rows?.length) return "Nenhuma linha na simula\xe7\xe3o.";
    return rows.map((r)=>`Pedido ${r.order_id}${r.reference ? ' (' + r.reference + ')' : ''}: ${r.fulfillment ?? "\u2014"}% \u{2014} ${r.status || ''}`).join('\n');
}
function $39d39362129bbd6c$var$resolveDatalistId(inp) {
    const raw = String(inp?.value || '').trim();
    if (!raw) return '';
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(raw)) return raw;
    const lid = inp?.getAttribute('list');
    const dl = lid ? document.getElementById(lid) : null;
    if (dl) for (const o of dl.options){
        if (String(o.value) === raw || (o.textContent || '').trim() === raw) return o.value;
    }
    return raw;
}
function $39d39362129bbd6c$var$resolveCompanyIdFromForm(form) {
    return $39d39362129bbd6c$var$resolveDatalistId(form.querySelector('#company_id'));
}
function $39d39362129bbd6c$var$fmtDate(value) {
    if (!value) return '';
    const s = String(value);
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10).split('-').reverse().join('/');
    return s;
}
/** Criação / data-hora na tela: DD/MM/AAAA - HH:MM:SS */ function $39d39362129bbd6c$var$formatDateTimeBr(value) {
    if (value == null || value === '') return "\u2014";
    let s = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2} /.test(s)) s = s.replace(' ', 'T');
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return String(value);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} - ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
async function $39d39362129bbd6c$var$fillCompanySelect(form) {
    const sel = form.querySelector('#company_id');
    if (!sel || sel.tagName !== 'SELECT') return;
    let companies = [];
    try {
        companies = await (0, $1cmSR.default).list('companies') || [];
    } catch (_) {
        companies = [];
    }
    if (!companies.length) try {
        companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
        if (companies.length) await (0, $1cmSR.default).set('companies', companies).catch(()=>{});
    } catch (_) {
        companies = [];
    }
    sel.innerHTML = companies.length ? `<option value="">\u{2014} Selecione a empresa \u{2014}</option>${companies.map((c)=>`<option value="${$39d39362129bbd6c$var$esc(c.id)}">${$39d39362129bbd6c$var$esc(c.nick || c.name || c.id)}</option>`).join('')}` : '<option value="">\u2014 Nenhuma empresa cadastrada \u2014</option>';
    if (companies.length === 1) {
        sel.value = String(companies[0].id);
        sel.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    } else if (!companies.length) (0, $jUNyh.notify)("Nenhuma empresa dispon\xedvel. Recarregue a tela (F5) ap\xf3s a API responder.", 'Derrubada');
}
function $39d39362129bbd6c$var$resolveWarehouseId(form) {
    const sel = form.querySelector('#warehouse_id');
    const n = Number(sel?.value);
    return Number.isInteger(n) && n > 0 ? n : '';
}
function $39d39362129bbd6c$var$warehouseIsRequired(form) {
    const sel = form.querySelector('#warehouse_id');
    return Boolean(sel && !sel.disabled && sel.required);
}
function $39d39362129bbd6c$var$parseOrderIdInput(raw) {
    const s = String(raw ?? '').trim();
    if (!s) return undefined;
    const digits = s.replace(/\D/g, '');
    if (!digits) return undefined;
    const n = Number(digits);
    return Number.isFinite(n) && n > 0 ? n : undefined;
}
function $39d39362129bbd6c$var$collectCreateFilters(form) {
    const company_id = $39d39362129bbd6c$var$resolveCompanyIdFromForm(form);
    const warehouse_id = $39d39362129bbd6c$var$resolveWarehouseId(form);
    const order_id = $39d39362129bbd6c$var$parseOrderIdInput(form.querySelector('#order_id')?.value);
    const reference = form.querySelector('#reference')?.value;
    const customerRaw = $39d39362129bbd6c$var$resolveDatalistId(form.querySelector('#customer_id'));
    const programRaw = $39d39362129bbd6c$var$resolveDatalistId(form.querySelector('#program_id'));
    const date_from = form.querySelector('#date_from')?.value;
    const date_to = form.querySelector('#date_to')?.value;
    const sla_to = form.querySelector('#sla_to')?.value;
    const include_expired = form.querySelector('#include_expired')?.checked;
    const is_emergency = form.querySelector('#is_emergency')?.checked;
    const confirm = form.querySelector('#confirm')?.checked;
    return {
        company_id: company_id,
        warehouse_id: warehouse_id,
        order_id: order_id,
        reference: reference,
        customer_id: customerRaw,
        program_id: programRaw,
        date_from: date_from,
        date_to: date_to,
        sla_to: sla_to,
        include_expired: include_expired,
        is_emergency: is_emergency,
        confirm: confirm
    };
}
function $39d39362129bbd6c$var$filtersPayload(d) {
    const customerId = d.customer_id && /^\d+$/.test(String(d.customer_id)) ? Number(d.customer_id) : undefined;
    const programId = d.program_id && /^\d+$/.test(String(d.program_id)) ? Number(d.program_id) : undefined;
    return {
        order_id: d.order_id || undefined,
        reference: d.reference || undefined,
        customer_id: customerId,
        program_id: programId,
        date_from: d.date_from || undefined,
        date_to: d.date_to || undefined,
        sla_to: d.sla_to || undefined,
        is_emergency: d.is_emergency || undefined
    };
}
function $39d39362129bbd6c$var$renderOrderTable(box, orders, pick) {
    if (!box) return;
    const list = orders || [];
    if (!list.length) {
        box.innerHTML = '<p class="hint">Nenhum pedido eleg\xedvel com estes filtros. S\xf3 entram pedidos <strong>aprovados</strong>, sem sa\xedda ativa e que n\xe3o s\xe3o devolu\xe7\xe3o.</p>';
        return;
    }
    box.innerHTML = `
		<table class="view">
			<thead><tr>
				<th><input type="checkbox" id="pw-ord-all" title="Marcar / desmarcar os da pesquisa"></th>
				<th>Pedido</th><th>Refer\xeancia</th><th>Cliente</th><th>Programa</th>
				<th>Emerg.</th><th>Prev. entrega</th><th>Cria\xe7\xe3o</th>
			</tr></thead>
			<tbody>
				${list.map((o)=>{
        const on = pick.ids.has(Number(o.id));
        return `
					<tr class="${on ? 'pw-on' : ''}" data-oid="${$39d39362129bbd6c$var$esc(o.id)}">
						<td><input type="checkbox" class="pw-ord" value="${$39d39362129bbd6c$var$esc(o.id)}" ${on ? 'checked' : ''}></td>
						<td>${$39d39362129bbd6c$var$esc(o.id)}</td>
						<td>${$39d39362129bbd6c$var$esc(o.reference)}</td>
						<td>${$39d39362129bbd6c$var$esc(o.customer_nick || o.customer_name)}</td>
						<td>${$39d39362129bbd6c$var$esc(o.program_name)}</td>
						<td>${o.is_emergency ? 'Sim' : ''}</td>
						<td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$fmtDate(o.expected_delivery_date))}</td>
						<td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$fmtDate(o.created_on))}</td>
					</tr>`;
    }).join('')}
			</tbody>
		</table>
	`;
}
function $39d39362129bbd6c$var$selectedOrderIds(pick) {
    return [
        ...pick.ids
    ].filter(Boolean);
}
/**
 * Confirmação de geração: botão positivo primeiro (foco + Enter).
 * O ask() padrão foca em «Não» — Enter cancelava em silêncio e o POST create nunca saía.
 */ function $39d39362129bbd6c$var$confirmGenerateWave(orderCount, onYes) {
    let mb;
    mb = (0, $jUNyh.default)({
        title: 'Confirmar derrubada',
        text: `Gerar onda com ${orderCount} pedido(s)? Isso reserva estoque e cria a derrubada de verdade (Simular s\xf3 mostra o atendimento).`,
        buttons: [
            {
                label: 'Sim, gerar onda',
                cls: 'bn_Enter'
            },
            {
                label: 'Cancelar',
                cls: 'bn_Escape'
            }
        ],
        callback: (key)=>{
            mb.destroy();
            if (key === 'Enter' || key === 'Y') onYes();
        }
    });
}
function $39d39362129bbd6c$var$syncPickCount(form, pick) {
    const el = form.querySelector('#pw-selected');
    if (el) el.textContent = String(pick.ids.size);
    form.querySelectorAll('#pw-orders tr[data-oid]').forEach((tr)=>{
        const id = Number(tr.getAttribute('data-oid'));
        const on = pick.ids.has(id);
        tr.classList.toggle('pw-on', on);
        const cb = tr.querySelector('.pw-ord');
        if (cb) cb.checked = on;
    });
}
const $39d39362129bbd6c$var$pickingWaves = function() {
    const waves_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        insertRecord () {
            this.openCreate();
        },
        async loadBaseData () {
            const q = this.queryAll();
            const [companies, warehouses, users, customers, programs] = await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_users, q).catch(()=>[]),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, q).catch(()=>[]),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, q).catch(()=>[])
            ]);
            await Promise.all([
                (0, $1cmSR.default).set('companies', companies || []).catch(()=>{}),
                (0, $1cmSR.default).set('warehouses', warehouses || []).catch(()=>{}),
                (0, $1cmSR.default).set('users', Array.isArray(users) ? users : users?.rows || []).catch(()=>{}),
                (0, $1cmSR.default).set('customers', customers || []).catch(()=>{}),
                (0, $1cmSR.default).set('programs', programs || []).catch(()=>{})
            ]);
            this._usersCache = Array.isArray(users) ? users : users?.rows || [];
        },
        async queryData (query) {
            const filterParams = $39d39362129bbd6c$var$filtersToParams(this.filter || {});
            let companies = filterParams.company_id ? [
                {
                    id: filterParams.company_id
                }
            ] : await (0, $1cmSR.default).list('companies').catch(()=>[]);
            if (!companies?.length) companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
            if (!companies.length) return $39d39362129bbd6c$var$isCountQuery(query) ? 0 : [];
            const nickById = {};
            for (const c of companies)nickById[c.id] = c.nick || c.name || c.id;
            const lists = await Promise.all(companies.map(async (company)=>{
                try {
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_picking_waves, company.id, '?limit=200');
                    const rows = data?.rows || [];
                    return rows.map((r)=>({
                            ...r,
                            company_id: company.id,
                            company_nick: nickById[company.id]
                        }));
                } catch (e) {
                    console.warn('picking-waves list', company.id, e);
                    return [];
                }
            }));
            let rows = lists.flat();
            if (filterParams.status) rows = rows.filter((r)=>String(r.status) === String(filterParams.status));
            if (filterParams.id) rows = rows.filter((r)=>Number(r.id) === Number(filterParams.id));
            rows.sort((a, b)=>Number(b.id) - Number(a.id));
            if ($39d39362129bbd6c$var$isCountQuery(query)) return rows.length;
            const { limit: limit, offset: offset } = $39d39362129bbd6c$var$pageBounds(query);
            return rows.slice(offset, offset + limit);
        },
        async loadRecord (id) {
            const [company_id, wave_id] = JSON.parse(id);
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_picking_wave, company_id, wave_id);
            if (!data?.wave) return null;
            this.showDetail(data, company_id);
            return null;
        },
        showDetail (data, company_id) {
            const w = data?.wave || {};
            const k = data?.kpis || {};
            const items = data?.items || [];
            const tasks = data?.tasks || [];
            const assignments = data?.assignments || [];
            const exceptions = data?.exceptions || [];
            const queue = data?.picking_queue || [];
            const trace = data?.trace || {};
            const users = this._usersCache || [];
            const userOpts = users.map((u)=>`<option value="${$39d39362129bbd6c$var$esc(u.id)}">${$39d39362129bbd6c$var$esc(u.username || u.id)}</option>`).join('');
            const waveId = w.id ?? "\u2014";
            const statusPt = $39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$WAVE_STATUS_PT, w.status);
            const html = `
				<style>${$39d39362129bbd6c$var$PW_DETAIL_CSS}</style>
				<form id="picking-wave-detail" class="form sial-modal-form sial-detail" autocomplete="off">
					<header class="sdp-head">
						<div class="sdp-head-main">
							<div class="sdp-icon-col">
								<div class="sdp-icon">${$39d39362129bbd6c$var$ICO_WAVE}</div>
								<button type="button" class="pw-help" id="pw-wave-help" title="Ajuda: o que cada dado significa" aria-label="Ajuda sobre a onda de derrubada">?</button>
							</div>
							<div class="sdp-head-copy">
								<p class="sdp-kicker">Derrubada \u{2014} onda</p>
								<h2 class="sdp-title">Onda ${$39d39362129bbd6c$var$esc(waveId)}</h2>
								<div class="sdp-meta">
									<span>Cria\xe7\xe3o: <b>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$formatDateTimeBr(w.created_on))}</b></span>
									<span>Armaz\xe9m: <b>${$39d39362129bbd6c$var$esc(w.warehouse_id ?? "\u2014")}</b></span>
									<span>Status: <span class="${$39d39362129bbd6c$var$waveBadgeClass(w.status)}">${$39d39362129bbd6c$var$esc(statusPt)}</span></span>
								</div>
							</div>
						</div>
						<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
					</header>
					<section class="sdp-kpis" aria-label="Resumo da onda">
						<div class="sdp-kpi sdp-kpi--total">
							<div class="sdp-kpi-label">Pedidos</div>
							<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(k.orders ?? items.length)}</span></div>
						</div>
						<div class="sdp-kpi sdp-kpi--reserved">
							<div class="sdp-kpi-label">Descer pendentes</div>
							<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(k.descer_pending ?? 0)}</span></div>
						</div>
						<div class="sdp-kpi sdp-kpi--avail">
							<div class="sdp-kpi-label">Descer conclu\xeddas</div>
							<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(k.descer_done ?? 0)}</span></div>
						</div>
						<div class="sdp-kpi sdp-kpi--blocked">
							<div class="sdp-kpi-label">Exce\xe7\xf5es</div>
							<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(k.descer_exception ?? 0)}</span></div>
						</div>
						<div class="sdp-kpi sdp-kpi--free">
							<div class="sdp-kpi-label">Devolver pendentes</div>
							<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(k.devolver_pending ?? 0)}</span></div>
						</div>
					</section>
					<section class="sdp-stack">
						<div class="sdp-block">
							<h3 class="sdp-block-title">Pedidos</h3>
							${items.some((i)=>i.output_id == null) ? '<p class="sdp-hint">Pedido sem n\xfamero em <strong>Sa\xedda</strong> ainda n\xe3o gerou documento em <strong>Movimenta\xe7\xe3o \u2192 Sa\xeddas</strong>. A onda de verdade gera a sa\xedda na hora (reserva + descer).</p>' : ''}
							<table class="view" style="width:100%">
								<thead><tr><th>Pedido</th><th>Ref.</th><th>Sa\xedda</th><th>Status</th><th>Emerg.</th></tr></thead>
								<tbody>
									${items.map((i)=>`<tr><td>${$39d39362129bbd6c$var$esc(i.output_order_id)}</td><td>${$39d39362129bbd6c$var$esc(i.reference)}</td><td>${$39d39362129bbd6c$var$esc(i.output_id ?? "\u2014")}</td><td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$ITEM_STATUS_PT, i.status))}</td><td>${i.is_emergency ? 'Sim' : ''}</td></tr>`).join('') || '<tr><td colspan="5">Sem itens</td></tr>'}
								</tbody>
							</table>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Tarefas do empilhador</h3>
							<p class="sdp-hint">Origem \u{2192} ch\xe3o da coluna / devolver sobra</p>
							<table class="view" style="width:100%">
								<thead><tr><th>N\xba</th><th>Tipo</th><th>Origem</th><th>Destino</th><th>Status</th><th></th></tr></thead>
								<tbody>
									${tasks.map((t)=>`<tr>
										<td>${$39d39362129bbd6c$var$esc(t.id)}</td><td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_KIND_PT, t.kind))}</td>
										<td>${$39d39362129bbd6c$var$esc(t.source_address || t.source_location_id)}</td>
										<td>${$39d39362129bbd6c$var$esc(t.dest_address || t.dest_location_id || "\u2014")}</td>
										<td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_STATUS_PT, t.status))}${t.exception_reason ? " \u2014 " + $39d39362129bbd6c$var$esc(t.exception_reason) : ''}</td>
										<td>${[
                    'PENDING',
                    'IN_PROGRESS',
                    'DIVERGENCE'
                ].includes(t.status) && t.dest_location_id ? `<button type="button" class="button pw-confirm-task" data-task='${$39d39362129bbd6c$var$esc(JSON.stringify({
                    id: t.id,
                    kind: t.kind,
                    source_location_id: t.source_location_id,
                    dest_location_id: t.dest_location_id,
                    lot_id: t.lot_id
                }))}'>Confirmar</button>` : ''}
										</td>
									</tr>`).join('') || '<tr><td colspan="6">Sem tarefas</td></tr>'}
								</tbody>
							</table>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Atribui\xe7\xe3o / for\xe7ar operador</h3>
							<div class="sdp-fields">
								<label>Pedido <input id="pw-asg-order" type="number"></label>
								<label>Papel
									<select id="pw-asg-role">
										<option value="SEPARATOR">Separador</option>
										<option value="CHECKER">Conferente</option>
									</select>
								</label>
								<label>Operador
									<select id="pw-asg-user">${userOpts}</select>
								</label>
								<label>Distribuir entre
									<select id="pw-asg-users" multiple size="4">${userOpts}</select>
								</label>
								<label class="sdp-span-2">Motivo (obrigat\xf3rio ao for\xe7ar)
									<input id="pw-asg-reason" type="text">
								</label>
							</div>
							<div class="sdp-check-row" style="margin-top:0.75rem">
								<button type="button" class="button" id="pw-asg-force">For\xe7ar operador</button>
								<button type="button" class="button" id="pw-asg-auto">Distribuir (proximidade ap\xf3s SLA)</button>
							</div>
							<p class="sdp-hint">Atribui\xe7\xf5es: ${assignments.map((a)=>`${$39d39362129bbd6c$var$esc(a.output_order_id)} ${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$ROLE_PT, a.role))} \u{2192} ${$39d39362129bbd6c$var$esc(a.username)}${a.forced ? " (for\xe7ado)" : ''}`).join('; ') || "\u2014"}</p>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Fila da onda (separador)</h3>
							<table class="view" style="width:100%">
								<thead><tr><th>Pedido</th><th>Sa\xedda</th><th>Operador</th><th>Linhas</th></tr></thead>
								<tbody>
									${queue.map((q)=>`<tr>
										<td>${$39d39362129bbd6c$var$esc(q.output_order_id)}${q.is_emergency ? ' *' : ''}</td>
										<td>${$39d39362129bbd6c$var$esc(q.output_id)}</td>
										<td>${$39d39362129bbd6c$var$esc(q.assigned_username || q.assigned_user_id || "\u2014")}</td>
										<td>${$39d39362129bbd6c$var$esc((q.lines || []).length)}</td>
									</tr>`).join('') || '<tr><td colspan="4">Fila vazia (terci\xe1ria ainda no elevado ou sem sa\xedda)</td></tr>'}
								</tbody>
							</table>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Exce\xe7\xf5es</h3>
							<ul>${(exceptions.length ? exceptions : []).map((e)=>`<li>Tarefa ${$39d39362129bbd6c$var$esc(e.id)} ${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_KIND_PT, e.kind))} \u{2014} ${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_STATUS_PT, e.status))}: ${$39d39362129bbd6c$var$esc(e.exception_reason || '')}</li>`).join('') || '<li>Nenhuma</li>'}</ul>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Rastreio</h3>
							<p class="sdp-hint">Pedido \u{2192} onda \u{2192} tarefa \u{2192} transa\xe7\xe3o</p>
							<ul>${(trace.transactions || []).slice(0, 20).map((tx)=>`<li>Transa\xe7\xe3o ${$39d39362129bbd6c$var$esc(tx.id)} \xb7 ${$39d39362129bbd6c$var$esc(tx.reason)} \xb7 qtd ${$39d39362129bbd6c$var$esc(tx.quantity)}</li>`).join('') || "<li>Sem transa\xe7\xf5es da derrubada ainda</li>"}</ul>
						</div>
					</section>
					<div class="sdp-foot">
						<button type="button" class="bn_Escape button">Fechar</button>
					</div>
				</form>
			`;
            const dlg = (0, $dx9qz.default).create(html, (key)=>{
                if (key === 'Y' || key === 'Escape') dlg.destroy();
            });
            const root = dlg.node;
            const cid = company_id || w.company_id;
            const wid = w.id;
            root.querySelector('#pw-wave-help')?.addEventListener('click', (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                $39d39362129bbd6c$var$openPwHelp("Ajuda \u2014 Onda de derrubada", $39d39362129bbd6c$var$WAVE_HELP_HTML);
            });
            root.querySelectorAll('.pw-confirm-task').forEach((btn)=>{
                btn.addEventListener('click', ()=>{
                    let payload;
                    try {
                        payload = JSON.parse(btn.getAttribute('data-task'));
                    } catch  {
                        return (0, $jUNyh.notify)("Tarefa inv\xe1lida.", 'Derrubada');
                    }
                    (0, $jUNyh.ask)(`Confirmar ${$39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_KIND_PT, payload.kind)} da tarefa ${payload.id}? O destino tem de ser o endere\xe7o determinado.`, 'Empilhador', async (ok)=>{
                        if (!ok) return;
                        try {
                            await (0, $9VcS9.default).call((0, $9VcS9.default).confirm_picking_wave_task, cid, wid, payload.id, payload);
                            dlg.destroy();
                            (0, $jUNyh.notify)('Tarefa confirmada.', 'Derrubada');
                            this.loadPage();
                        } catch (e) {
                            (0, $jUNyh.notify)(String(e), 'Derrubada');
                        }
                    });
                });
            });
            root.querySelector('#pw-asg-force')?.addEventListener('click', async ()=>{
                const order = Number(root.querySelector('#pw-asg-order')?.value);
                const role = root.querySelector('#pw-asg-role')?.value;
                const user_id = root.querySelector('#pw-asg-user')?.value;
                const reason = (root.querySelector('#pw-asg-reason')?.value || '').trim();
                if (!order || !user_id) return (0, $jUNyh.notify)('Informe pedido e operador.', 'Derrubada');
                try {
                    await (0, $9VcS9.default).call((0, $9VcS9.default).assign_picking_wave, cid, wid, {
                        output_order_id: order,
                        role: role,
                        user_id: user_id,
                        reason: reason,
                        forced: true
                    });
                    (0, $jUNyh.notify)("Operador for\xe7ado (auditoria gravada).", 'Derrubada');
                } catch (e) {
                    (0, $jUNyh.notify)(String(e), 'Derrubada');
                }
            });
            root.querySelector('#pw-asg-auto')?.addEventListener('click', async ()=>{
                const selected = [
                    ...root.querySelectorAll('#pw-asg-users option:checked')
                ].map((o)=>o.value);
                const user_ids = selected.length ? selected : users.map((u)=>u.id).filter(Boolean).slice(0, 8);
                if (!user_ids.length) return (0, $jUNyh.notify)("N\xe3o h\xe1 operadores para distribuir.", 'Derrubada');
                try {
                    const res = await (0, $9VcS9.default).call((0, $9VcS9.default).auto_assign_picking_wave, cid, wid, {
                        user_ids: user_ids,
                        role: root.querySelector('#pw-asg-role')?.value || 'SEPARATOR'
                    });
                    (0, $jUNyh.notify)(`Distribu\xeddos ${res.assigned || 0} pedido(s).`, 'Derrubada');
                } catch (e) {
                    (0, $jUNyh.notify)(String(e), 'Derrubada');
                }
            });
        },
        openCreate () {
            const fs = (0, $h1m6J.default).create((0, $dd3a4724c4f985d3$export$2e2bcd8739ae039), async (ev)=>{
                if (ev === 'Escape') {
                    fs.destroy();
                    return;
                }
            });
            fs.init();
            const form = document.querySelector('#picking-wave-create');
            if (!form) return;
            $39d39362129bbd6c$var$fillCompanySelect(form);
            const pick = {
                ids: new Set(),
                cap: 120,
                lastOrders: []
            };
            const eligible = form.querySelector('#pw-eligible');
            const ordersBox = form.querySelector('#pw-orders');
            const simBox = form.querySelector('#pw-sim');
            if (ordersBox) ordersBox.innerHTML = '<p class="hint">Escolha a empresa (e o armaz\xe9m) e clique em <strong>Pesquisar</strong>. Marque na grade os pedidos da onda.</p>';
            const refreshPickUi = ()=>$39d39362129bbd6c$var$syncPickCount(form, pick);
            form.querySelector('#company_id')?.addEventListener('change', ()=>{
                pick.ids.clear();
                pick.lastOrders = [];
                if (ordersBox) ordersBox.innerHTML = '';
                if (eligible) eligible.textContent = "\u2014";
                refreshPickUi();
            });
            form.querySelector('#pw-preview')?.addEventListener('click', async ()=>{
                const d = $39d39362129bbd6c$var$collectCreateFilters(form);
                if (!d.company_id) return (0, $jUNyh.notify)('Informe a empresa.', 'Derrubada');
                try {
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).preview_picking_wave, d.company_id, {
                        filters: $39d39362129bbd6c$var$filtersPayload(d),
                        limit: 500
                    });
                    pick.cap = data.max_orders_per_wave || 120;
                    pick.lastOrders = data.orders || [];
                    if (eligible) eligible.textContent = `${data.eligible_count} (teto ${pick.cap} / lote; at\xe9 500 nesta lista)`;
                    $39d39362129bbd6c$var$renderOrderTable(ordersBox, pick.lastOrders, pick);
                    refreshPickUi();
                } catch (e) {
                    (0, $jUNyh.notify)(String(e), 'Derrubada');
                }
            });
            form.querySelector('#pw-clear-filters')?.addEventListener('click', ()=>{
                for (const id of [
                    'order_id',
                    'reference',
                    'customer_id',
                    'program_id',
                    'date_from',
                    'date_to',
                    'sla_to'
                ]){
                    const el = form.querySelector(`#${id}`);
                    if (el) el.value = '';
                }
                const em = form.querySelector('#is_emergency');
                if (em) em.checked = false;
            });
            form.querySelector('#pw-select-cap')?.addEventListener('click', ()=>{
                if (!pick.lastOrders.length) return (0, $jUNyh.notify)('Pesquise os pedidos primeiro.', 'Derrubada');
                pick.ids.clear();
                for (const o of pick.lastOrders){
                    if (pick.ids.size >= pick.cap) break;
                    pick.ids.add(Number(o.id));
                }
                refreshPickUi();
            });
            form.querySelector('#pw-clear-sel')?.addEventListener('click', ()=>{
                pick.ids.clear();
                refreshPickUi();
            });
            ordersBox?.addEventListener('change', (ev)=>{
                const all = ev.target.closest('#pw-ord-all');
                if (all) {
                    for (const o of pick.lastOrders)if (all.checked) pick.ids.add(Number(o.id));
                    else pick.ids.delete(Number(o.id));
                    refreshPickUi();
                    return;
                }
                const cb = ev.target.closest('.pw-ord');
                if (!cb) return;
                const id = Number(cb.value);
                if (cb.checked) pick.ids.add(id);
                else pick.ids.delete(id);
                refreshPickUi();
            });
            const runGenerateWave = async ()=>{
                const d = $39d39362129bbd6c$var$collectCreateFilters(form);
                if (!d.company_id) return (0, $jUNyh.notify)('Informe a empresa.', 'Derrubada');
                if ($39d39362129bbd6c$var$warehouseIsRequired(form) && !d.warehouse_id) return (0, $jUNyh.notify)("H\xe1 mais de um armaz\xe9m f\xedsico \u2014 escolha um.", 'Derrubada');
                const order_ids = $39d39362129bbd6c$var$selectedOrderIds(pick);
                if (!order_ids.length) return (0, $jUNyh.notify)("Marque na grade ao menos um pedido (coluna checkbox). \xabSelecionados: 0\xbb n\xe3o gera onda. Use \xabMarcar at\xe9 o teto\xbb ou clique nas linhas. Simular \u2260 Gerar.", 'Derrubada');
                if (!d.confirm) {
                    const box = form.querySelector('#confirm');
                    if (box) box.checked = true;
                }
                const cap = pick.cap || 120;
                const n = Math.min(order_ids.length, cap);
                $39d39362129bbd6c$var$confirmGenerateWave(n, async ()=>{
                    try {
                        const created = await (0, $9VcS9.default).call((0, $9VcS9.default).create_picking_wave, d.company_id, {
                            warehouse_id: d.warehouse_id || null,
                            order_ids: order_ids,
                            include_expired: d.include_expired,
                            reserve_flag: true,
                            confirm: true
                        });
                        // http.js já notifica 4xx/5xx e devolve undefined — não repetir aviso genérico
                        if (created === undefined || created === null) return;
                        if (created.id == null) return (0, $jUNyh.notify)("A API n\xe3o devolveu o n\xfamero da onda. Tente de novo ou avise o suporte.", 'Derrubada');
                        fs.destroy();
                        const extra = (created.remainder_order_ids || []).length ? ` Restante para outro lote: ${created.remainder_order_ids.length}.` : '';
                        const skipped = (created.skipped_order_ids || []).length ? ` Sem sa\xedda: ${created.skipped_order_ids.length}.` : '';
                        const exc = (created.exceptions || []).length ? ` Exce\xe7\xf5es de Descer: ${created.exceptions.length}.` : '';
                        (0, $jUNyh.notify)(`Onda ${created.id} gerada. Pedidos neste lote: ${(created.accepted_order_ids || []).length}.${extra}${skipped}${exc}`, 'Derrubada');
                        this.loadPage(1);
                    } catch (e) {
                        (0, $jUNyh.notify)(String(e), 'Derrubada');
                    }
                });
            };
            form.querySelector('#pw-simulate')?.addEventListener('click', async ()=>{
                const d = $39d39362129bbd6c$var$collectCreateFilters(form);
                if (!d.company_id) return (0, $jUNyh.notify)('Informe a empresa.', 'Derrubada');
                if ($39d39362129bbd6c$var$warehouseIsRequired(form) && !d.warehouse_id) return (0, $jUNyh.notify)("H\xe1 mais de um armaz\xe9m f\xedsico \u2014 escolha um.", 'Derrubada');
                const order_ids = $39d39362129bbd6c$var$selectedOrderIds(pick);
                if (!order_ids.length) return (0, $jUNyh.notify)('Pesquise e marque os pedidos da onda (checkbox na grade).', 'Derrubada');
                try {
                    const sim = await (0, $9VcS9.default).call((0, $9VcS9.default).simulate_picking_wave, d.company_id, {
                        warehouse_id: d.warehouse_id || null,
                        order_ids: order_ids,
                        include_expired: d.include_expired
                    });
                    if (simBox) simBox.textContent = $39d39362129bbd6c$var$formatSummary(sim.summary);
                    (0, $jUNyh.notify)("Simula\xe7\xe3o conclu\xedda (n\xe3o reservou nem gerou sa\xedda). Agora clique em Gerar onda e confirme com \xabSim, gerar onda\xbb.", 'Derrubada');
                } catch (e) {
                    (0, $jUNyh.notify)(String(e), 'Derrubada');
                }
            });
            // type=button (não bn_Enter/submit): o dialog Versa interceptava bn_Enter e o POST create não saía.
            form.querySelector('#pw-generate')?.addEventListener('click', ()=>{
                runGenerateWave();
            });
        },
        async showDashboard () {
            const companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0') || [];
            if (!companies.length) return (0, $jUNyh.notify)('Nenhuma empresa.', 'Derrubada');
            const preferred = companies.find((c)=>/machadotec/i.test(c.nick || c.name || '')) || companies[0];
            const opts = companies.map((c)=>`<option value="${$39d39362129bbd6c$var$esc(c.id)}"${c.id === preferred.id ? ' selected' : ''}>${$39d39362129bbd6c$var$esc(c.nick || c.name)}</option>`).join('');
            const html = `
				<style>${$39d39362129bbd6c$var$PW_DETAIL_CSS}
					#picking-wave-dash #pw-dash-company { min-width: 12rem; }
				</style>
				<form id="picking-wave-dash" class="form sial-modal-form sial-detail" autocomplete="off">
					<header class="sdp-head">
						<div class="sdp-head-main">
							<div class="sdp-icon-col">
								<div class="sdp-icon">${$39d39362129bbd6c$var$ICO_WAVE}</div>
								<button type="button" class="pw-help" id="pw-dash-help" title="Ajuda: o que cada dado significa" aria-label="Ajuda sobre o painel de derrubada">?</button>
							</div>
							<div class="sdp-head-copy">
								<p class="sdp-kicker">Derrubada \u{2014} painel</p>
								<h2 class="sdp-title">Painel de ondas</h2>
								<div class="sdp-meta">
									<label>Empresa
										<select id="pw-dash-company">${opts}</select>
									</label>
								</div>
							</div>
						</div>
						<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
					</header>
					<section class="sdp-kpis" id="pw-dash-kpis" aria-label="Resumo da derrubada">
						<div class="sdp-kpi sdp-kpi--total"><div class="sdp-kpi-label">Ondas</div><div class="sdp-kpi-value"><span>\u{2014}</span></div></div>
						<div class="sdp-kpi sdp-kpi--reserved"><div class="sdp-kpi-label">Pedidos</div><div class="sdp-kpi-value"><span>\u{2014}</span></div></div>
						<div class="sdp-kpi sdp-kpi--avail"><div class="sdp-kpi-label">Abertas</div><div class="sdp-kpi-value"><span>\u{2014}</span></div></div>
						<div class="sdp-kpi sdp-kpi--free"><div class="sdp-kpi-label">Conclu\xeddas</div><div class="sdp-kpi-value"><span>\u{2014}</span></div></div>
						<div class="sdp-kpi sdp-kpi--blocked"><div class="sdp-kpi-label">Exce\xe7\xf5es</div><div class="sdp-kpi-value"><span>\u{2014}</span></div></div>
					</section>
					<section class="sdp-stack" id="pw-dash-body">Carregando\u{2026}</section>
					<div class="sdp-foot">
						<button type="button" class="bn_Escape button">Fechar</button>
					</div>
				</form>
			`;
            const dlg = (0, $dx9qz.default).create(html, (key)=>{
                if (key === 'Y' || key === 'Escape') dlg.destroy();
            });
            dlg.node.querySelector('#pw-dash-help')?.addEventListener('click', (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                $39d39362129bbd6c$var$openPwHelp("Ajuda \u2014 Painel de derrubada", $39d39362129bbd6c$var$DASH_HELP_HTML);
            });
            const fill = async (company_id)=>{
                const body = dlg.node.querySelector('#pw-dash-body');
                const kpis = dlg.node.querySelector('#pw-dash-kpis');
                try {
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).picking_wave_dashboard, company_id);
                    const c = data.consolidated || {};
                    const waves = data.recent_waves || [];
                    const exceptions = data.exceptions || [];
                    const prod = data.productivity || {};
                    if (kpis) kpis.innerHTML = `
							<div class="sdp-kpi sdp-kpi--total">
								<div class="sdp-kpi-label">Ondas</div>
								<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(c.waves ?? 0)}</span></div>
							</div>
							<div class="sdp-kpi sdp-kpi--reserved">
								<div class="sdp-kpi-label">Pedidos</div>
								<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(c.orders ?? 0)}</span></div>
							</div>
							<div class="sdp-kpi sdp-kpi--avail">
								<div class="sdp-kpi-label">Abertas</div>
								<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(c.waves_open ?? 0)}</span></div>
							</div>
							<div class="sdp-kpi sdp-kpi--free">
								<div class="sdp-kpi-label">Conclu\xeddas</div>
								<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(c.waves_done ?? 0)}</span></div>
							</div>
							<div class="sdp-kpi sdp-kpi--blocked">
								<div class="sdp-kpi-label">Exce\xe7\xf5es</div>
								<div class="sdp-kpi-value"><span>${$39d39362129bbd6c$var$esc(c.exceptions ?? 0)}</span></div>
							</div>
						`;
                    body.innerHTML = `
						<div class="sdp-block">
							<h3 class="sdp-block-title">\xdaltimas ondas</h3>
							<table class="view" style="width:100%">
								<thead><tr><th>Onda</th><th>Status</th><th>Pedidos</th><th>Descer pend.</th><th>Exce\xe7\xf5es</th></tr></thead>
								<tbody>
									${waves.map((w)=>`<tr>
										<td>${$39d39362129bbd6c$var$esc(w.id)}</td><td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$WAVE_STATUS_PT, w.status))}</td>
										<td>${$39d39362129bbd6c$var$esc(w.order_count)}</td><td>${$39d39362129bbd6c$var$esc(w.descer_pending)}</td>
										<td>${$39d39362129bbd6c$var$esc(w.exception_count)}</td>
									</tr>`).join('') || '<tr><td colspan="5">Nenhuma</td></tr>'}
								</tbody>
							</table>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Produtividade do empilhador</h3>
							<p class="sdp-hint">Tarefas confirmadas (Descer / Devolver)</p>
							<table class="view" style="width:100%">
								<thead><tr><th>Operador</th><th>Descer</th><th>Devolver</th><th>Exce\xe7\xf5es</th></tr></thead>
								<tbody>
									${(prod.forklift || []).map((p)=>`<tr>
										<td>${$39d39362129bbd6c$var$esc(p.username || "\u2014")}</td><td>${$39d39362129bbd6c$var$esc(p.descer_done)}</td>
										<td>${$39d39362129bbd6c$var$esc(p.devolver_done)}</td><td>${$39d39362129bbd6c$var$esc(p.exceptions)}</td>
									</tr>`).join('') || '<tr><td colspan="4">Sem confirma\xe7\xf5es</td></tr>'}
								</tbody>
							</table>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Atribui\xe7\xf5es (separa\xe7\xe3o / confer\xeancia)</h3>
							<table class="view" style="width:100%">
								<thead><tr><th>Operador</th><th>Papel</th><th>Pedidos</th></tr></thead>
								<tbody>
									${(prod.assignments || []).map((p)=>`<tr>
										<td>${$39d39362129bbd6c$var$esc(p.username)}</td><td>${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$ROLE_PT, p.role))}</td><td>${$39d39362129bbd6c$var$esc(p.orders)}</td>
									</tr>`).join('') || '<tr><td colspan="3">Sem atribui\xe7\xf5es</td></tr>'}
								</tbody>
							</table>
						</div>
						<div class="sdp-block">
							<h3 class="sdp-block-title">Exce\xe7\xf5es abertas</h3>
							<ul>${exceptions.map((e)=>`<li>Onda ${$39d39362129bbd6c$var$esc(e.wave_id)} tarefa ${$39d39362129bbd6c$var$esc(e.id)} ${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_KIND_PT, e.kind))} \u{2014} ${$39d39362129bbd6c$var$esc($39d39362129bbd6c$var$labelOf($39d39362129bbd6c$var$TASK_STATUS_PT, e.status))}: ${$39d39362129bbd6c$var$esc(e.exception_reason || e.source_address || '')}</li>`).join('') || '<li>Nenhuma</li>'}</ul>
						</div>
					`;
                } catch (e) {
                    if (body) body.textContent = String(e);
                }
            };
            const sel = dlg.node.querySelector('#pw-dash-company');
            sel?.addEventListener('change', ()=>fill(sel.value));
            if (sel?.value) fill(sel.value);
        }
    });
    const fieldspecs = [
        {
            index: 0,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 1,
            field: 'id',
            label: 'Onda',
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 2,
            field: 'order_count',
            label: 'Pedidos',
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 3,
            field: 'descer_pending',
            label: 'Descer pend.',
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 4,
            field: 'descer_done',
            label: 'Descer ok',
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 5,
            field: 'exception_count',
            label: "Exce\xe7\xf5es",
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 6,
            field: 'status',
            label: 'Status',
            types: []
        },
        {
            index: 7,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ]
        }
    ];
    const operations = [
        {
            hash: '#picking-wave-dashboard',
            label: 'Painel'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#picking-wave-dashboard', ()=>waves_crud.showDashboard());
    waves_crud.run('picking-waves', "Derrubada \u2014 ondas", document.getElementById('workarea'), (0, $6479c44d87265103$export$2e2bcd8739ae039), (0, $dd3a4724c4f985d3$export$2e2bcd8739ae039), fieldspecs, operations, [], {
        default_columns: '0,1,2,3,4,5,6,7'
    });
    (0, $1cmSR.default).list('users').then((rows)=>{
        waves_crud._usersCache = rows || waves_crud._usersCache || [];
    }).catch(()=>{});
};
var $39d39362129bbd6c$export$2e2bcd8739ae039 = $39d39362129bbd6c$var$pickingWaves;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");

var $8IFAz = parcelRequire("8IFAz");
async function $43f318f53e9d5e8b$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(6)	{ text-align: right; }
			.view td:nth-child(7)	{ text-align: right; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: left; max-width: 12rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Posi\xe7\xe3o</th>
					<th data-index="4" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="5" data-visible="${this.visible[4]}">M\xednimo</th>
					<th data-index="6" data-visible="${this.visible[5]}">M\xe1ximo</th>
					<th data-index="7" data-visible="${this.visible[6]}">Desativada</th>
					<th data-index="8" data-visible="${this.visible[7]}">Cria\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.location_id,
            record.product_company_id,
            record.product_id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.location_id,
            record.product_company_id,
            record.product_id
        ]))}></td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[2]}'>${record.location_id}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('products', [
            record.product_company_id,
            record.product_id
        ])}</td>
					<td data-visible='${this.visible[4]}'>${record.minimum_quantity}</td>
					<td data-visible='${this.visible[5]}'>${record.maximum_quantity}</td>
					<td data-visible='${this.visible[6]}'>${record.is_disabled ? 'Sim' : ''}</td>
					<td data-visible='${this.visible[7]}'>${record.created_on ? this.format($8IFAz.default(), record.created_on) : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $1c4889d650559fee$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#replenishment-rule #company_id		{ width: 11rem; }
			#replenishment-rule #warehouse_id	{ width: 11rem; }
			#replenishment-rule #location_id	{ width: 14rem; }
			#replenishment-rule #product_id		{ width: 28rem; }
			#replenishment-rule #minimum_quantity,
			#replenishment-rule #maximum_quantity { width: 5rem; text-align: right; }
			#replenishment-rule #created_on		{ width: 14rem; }
		</style>
		<form id="replenishment-rule" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o (endere\xe7o)">Posi\xe7\xe3o<sup>*</sup>
					<input id="location_id" type="text" list="locations" required>
				</label>
				<label title="Produto">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products-0" required>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Estoque m\xednimo (deple\xe7\xe3o)">M\xednimo<sup>*</sup>
					<input id="minimum_quantity" type="text" required>
				</label>
				<label title="Estoque alvo (m\xe1ximo)">M\xe1ximo<sup>*</sup>
					<input id="maximum_quantity" type="text" required>
				</label>
				<label title="Regra desativada (motor ignora)">Desativada
					<input id="is_disabled" type="checkbox">
				</label>
				<label title="Cria\xe7\xe3o do registro">Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm fae">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#replenishment-rule',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#minimum_quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#maximum_quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $8IFAz.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");

var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");
function $697f32a542e4bc7b$var$parseIdList(raw) {
    if (raw == null || String(raw).trim() === '') return null;
    const ids = String(raw).split(/[,;\s]+/).map((s)=>s.trim()).filter(Boolean).map((s)=>parseInt(s, 10)).filter((n)=>!Number.isNaN(n) && n >= 1);
    return ids.length ? ids : null;
}
function $697f32a542e4bc7b$export$2e2bcd8739ae039(companyId) {
    return {
        html: `
			<style>
				#replenishment #company_id		{ display: none; }
				#replenishment #warehouse_id	{ width: 16rem; }
				#replenishment #location_ids,
				#replenishment #product_ids,
				#replenishment #class_ids		{ width: 100%; max-width: 36rem; }
				#replenishment .hint				{ font-size: 0.85rem; opacity: 0.85; margin: 0.2rem 0 0; }
			</style>
			<form id="replenishment" class="form" autocomplete="off">
				<input type="hidden" id="company_id" name="company_id">
				<datalist id="warehouses">
				</datalist>
				<datalist id="classes">
				</datalist>
				<div class="title">
					Gerar Novo Ressuprimento
				</div>
				<div class="mtl fsb">
					<label title="Armaz\xe9m">Armaz\xe9m<sup>*</sup>
						<input id="warehouse_id" type="text" list="warehouses" required>
					</label>
				</div>
				<div class="mtm">
					<label title="Limitar a posi\xe7\xf5es (IDs, separados por v\xedrgula)">Posi\xe7\xf5es (opcional)
						<input id="location_ids" type="text" placeholder="ex.: 101, 102">
					</label>
					<p class="hint">Filtra regras apenas nas posi\xe7\xf5es indicadas.</p>
				</div>
				<div class="mtm">
					<label title="Limitar a produtos (IDs)">Produtos (opcional)
						<input id="product_ids" type="text" placeholder="ex.: 5001, 5002">
					</label>
				</div>
				<div class="mtm">
					<label title="Limitar a produtos que possuam alguma destas classes (IDs)">Classes (opcional)
						<input id="class_ids" type="text" list="classes" placeholder="ex.: 1, 2">
					</label>
				</div>
				<div class="mtm">
					<button class='bn_Escape button'>Cancelar</button>
					<button class='bn_Enter button'>Gerar</button>
				</div>
			</form>
		`,
        form: {
            selector: '#replenishment',
            submitHandler (formset, ev) {
                ev?.preventDefault();
                formset.form.syncFromDom();
                const v = formset.form.getValues();
                if (!v.company_id) throw new Error("Empresa (tenant) n\xe3o definida \u2014 use o filtro da grade.");
                if (!v.warehouse_id) throw new Error("Verificar Armaz\xe9m*");
                const body = {};
                const loc = $697f32a542e4bc7b$var$parseIdList(v.location_ids);
                const prod = $697f32a542e4bc7b$var$parseIdList(v.product_ids);
                const cls = $697f32a542e4bc7b$var$parseIdList(v.class_ids);
                if (loc) body.location_ids = loc;
                if (prod) body.product_ids = prod;
                if (cls) body.class_ids = cls;
                formset.callback?.call(formset, {
                    company_id: v.company_id,
                    warehouse_id: v.warehouse_id,
                    _payload: body
                });
            },
            init (formset) {
                formset.form.eraseValues();
                const cidEl = document.querySelector('#replenishment #company_id');
                if (cidEl) cidEl.value = companyId;
                Object.getPrototypeOf(this).init.call(this);
                const q = '?limit=0&filter=' + encodeURIComponent(`company_id*eq*${companyId}`);
                (0, $9VcS9.default).call((0, $9VcS9.default).list_classes, q).then((data)=>{
                    if (data && data.length) (0, $1cmSR.default).set('classes', data);
                    return formset.loadList('#classes', 'classes', {
                        labels: [
                            'name'
                        ]
                    });
                }).catch(()=>{});
            }
        },
        fields: [
            {
                properties: {
                    selector: '#company_id'
                },
                types: [
                    $6Jl4s.default()
                ]
            },
            {
                properties: {
                    selector: '#warehouse_id'
                },
                types: [
                    $6Jl4s.default(),
                    $9PIz7.default(),
                    $6lTH5.default('company_id'),
                    $dg8P2.default('warehouses')
                ]
            },
            {
                properties: {
                    selector: '#location_ids'
                },
                types: [
                    $6Jl4s.default()
                ]
            },
            {
                properties: {
                    selector: '#product_ids'
                },
                types: [
                    $6Jl4s.default()
                ]
            },
            {
                properties: {
                    selector: '#class_ids'
                },
                types: [
                    $6Jl4s.default(),
                    $9PIz7.default()
                ]
            }
        ]
    };
}



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");

var $hWQyW = parcelRequire("hWQyW");
async function $959063c0b01f11ed$export$8ba784e7c90593a1(crud_) {
    if (!crud_) return null;
    let f = crud_.filter;
    if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $hWQyW.resolveFilterLabelsToIds)(f, crud_.fieldspecs);
    for(let i = 0; i < 12; i++){
        if (f[`field-${i}`] === 'company_id' && f[`value-${i}`]) return String(f[`value-${i}`]).trim();
    }
    const sel = crud_.getSelection?.();
    if (sel && sel.length) {
        const parsed = JSON.parse(sel[0]);
        if (parsed[0]) return String(parsed[0]).trim();
    }
    try {
        const rows = await crud_.queryData(await crud_.queryPage());
        if (Array.isArray(rows) && rows.length) {
            const ids = [
                ...new Set(rows.map((r)=>r.company_id).filter(Boolean))
            ];
            if (ids.length === 1) return String(ids[0]).trim();
        }
    } catch (e) {
        console.warn(e);
    }
    return null;
}


const $9433fae8a6136621$var$replenishment_rules = function() {
    let rules_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_replenishment_rules, query);
        },
        async editFilter () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = data;
            (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            this.loadPage(1);
        },
        async loadRecord (id) {
            const [company_id, warehouse_id, location_id, product_company_id, product_id] = JSON.parse(id);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_replenishment_rule, company_id, warehouse_id, location_id, product_company_id, product_id);
        },
        async saveRecord (data, old_data) {
            const _rule = {
                minimum_quantity: Number(data.minimum_quantity),
                maximum_quantity: Number(data.maximum_quantity),
                is_disabled: data.is_disabled == '1'
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_replenishment_rule, old_data.company_id, old_data.warehouse_id, old_data.location_id, old_data.product_company_id, old_data.product_id, _rule);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_replenishment_rule, data.company_id, data.warehouse_id, {
                location_id: Number(data.location_id),
                product_id: Number(data.product_id),
                minimum_quantity: Number(data.minimum_quantity),
                maximum_quantity: Number(data.maximum_quantity),
                is_disabled: data.is_disabled == '1'
            });
        },
        async createReplenishmentOrder () {
            const companyId = await (0, $959063c0b01f11ed$export$8ba784e7c90593a1)(this);
            if (!companyId) {
                (0, $jUNyh.notify)("N\xe3o foi poss\xedvel identificar o tenant: filtre por empresa, selecione uma linha, ou garanta dados na p\xe1gina.", 'Gerar ressuprimento');
                return;
            }
            const showResult = (resp)=>{
                (0, $jUNyh.notify)(resp.id ? 'Ressuprimento criado' : "N\xe3o h\xe1 posi\xe7\xf5es a ressuprir", 'Resultado');
                this.loadPage();
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const payload = data._payload && Object.keys(data._payload).length ? data._payload : null;
                await (0, $9VcS9.default).call((0, $9VcS9.default).insert_replenishment, data.company_id, data.warehouse_id, payload).then(showResult);
            };
            let fs = (0, $h1m6J.default).create((0, $697f32a542e4bc7b$export$2e2bcd8739ae039)(companyId), sendRequest);
            fs.init();
        },
        async deleteRules () {
            const ids = this.getSelection();
            if (!ids.length) {
                (0, $jUNyh.notify)('Selecione ao menos uma regra para excluir.', 'Excluir');
                return;
            }
            (0, $jUNyh.ask)(`Excluir ${ids.length} regra(s) de ressuprimento?`, "Confirmar exclus\xe3o", async (answer)=>{
                if (answer !== 'Y') return;
                for (const raw of ids){
                    const [company_id, warehouse_id, location_id, product_company_id, product_id] = JSON.parse(raw);
                    const r = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_replenishment_rule, company_id, warehouse_id, location_id, product_company_id, product_id);
                    if (r === undefined) return;
                }
                (0, $jUNyh.notify)("Registro(s) exclu\xeddo(s).", 'Excluir');
                this.clearGridSelection();
                this.loadPage();
            });
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 3,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Identificador da posi\xe7\xe3o"
        },
        {
            index: 4,
            field: 'product_id',
            label: 'Produto',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Produto'
        },
        {
            index: 5,
            field: 'minimum_quantity',
            label: "M\xednimo",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade m\xednima"
        },
        {
            index: 6,
            field: 'maximum_quantity',
            label: "M\xe1ximo",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Quantidade m\xe1xima"
        },
        {
            index: 7,
            field: 'is_disabled',
            label: 'Desativada',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: 'Regra desativada'
        },
        {
            index: 8,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: '',
            title: "Data de cria\xe7\xe3o"
        }
    ];
    let operations = [
        {
            hash: '#goto-replenishment-orders',
            label: 'LOG'
        },
        {
            hash: '#run-replenishment-generator',
            label: 'Gerar&nbsp;ordem'
        },
        {
            hash: '#delete-replenishment-rules',
            label: 'Excluir'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#run-replenishment-generator', rules_crud.createReplenishmentOrder.bind(rules_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#delete-replenishment-rules', rules_crud.deleteRules.bind(rules_crud));
    rules_crud.run('replenishment-rules', "Ressuprimentos \u2014 regras min/m\xe1x", document.getElementById('workarea'), (0, $43f318f53e9d5e8b$export$2e2bcd8739ae039), (0, $1c4889d650559fee$export$2e2bcd8739ae039), fieldspecs, operations, []);
};
var $9433fae8a6136621$export$2e2bcd8739ae039 = $9433fae8a6136621$var$replenishment_rules;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $h1m6J = parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");


var $8IFAz = parcelRequire("8IFAz");
async function $88a2283db056a470$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: center; }
			.view td:nth-child(5)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="2" data-visible="${this.visible[1]}">Armaz\xe9m</th>
					<th data-index="3" data-visible="${this.visible[2]}">Ressuprimento</th>
					<th data-index="4" data-visible="${this.visible[3]}">Cria\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Conclus\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.warehouse_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[1]}'>${await this.key('warehouses', [
            record.company_id,
            record.warehouse_id
        ])}</td>
					<td data-visible='${this.visible[2]}'>${record.id}</td>
					<td data-visible='${this.visible[3]}'>${this.format($8IFAz.default(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${this.format($8IFAz.default(), record.completed_on) || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $abe6840daea06ec9$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#replenishment #company_id		{ width: 12rem;		}
			#replenishment #warehouse_id	{ width: 12rem;		}
			#replenishment #id				{ width: 8rem; text-align: right;	}
			#replenishment #created_on		{ width: 12rem;		}
			#replenishment #completed_on	{ width: 12rem;		}
			#replenishment .location 		{ width: 7rem;		}
			#replenishment .lot_company 	{ width: 8rem; 		}
			#replenishment .product		 	{ width: 20rem;		}
			#replenishment .lot 			{ width: 4.5rem; text-align: right;	}
			#replenishment .quantity		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="replenishment" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Armaz\xe9m do ressuprimento">Armaz\xe9m
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
				<label title="Identificador do ressuprimento">Ressuprimento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora de cria\xe7\xe3o do ressuprimento">Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de conclus\xe3o do ressuprimento">Conclus\xe3o
					<input id="completed_on" type="text" disabled>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Origem</th>
							<th>Destino</th>
							<th>Titular</th>
							<th>Produto</th>
							<th>Lote</th>
							<th>Req</th>
							<th>Mov<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Posi\xe7\xe3o de origem">
								<input id="from_location_id-0" class="location" type="text" list="locations" disabled>
							</td>
							<td title="Posi\xe7\xe3o de destino">
								<input id="to_location_id-0" class="location" type="text" list="locations" disabled>
							</td>
							<td title="Empresa titular do lote">
								<input id="lot_company_id-0" class="lot_company" type="text" list="companies" disabled>
							</td>
							<td title="Produto a mover">
								<input id="product_id-0" class="product" list="products-0" type="text" disabled>
							</td>
							<td title="N\xfamero do lote a mover">
								<input id="lot_id-0" class="lot" type="text" disabled>
							</td>
							<td title="Quantidade requerida">
								<input id="quantity_needed-0" class="quantity" type="text" disabled>
							</td>
							<td title="Quantidade movida">
								<input id="quantity_moved-0" class="quantity" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#replenishment',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#completed_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        //{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
        {
            properties: {
                selector: '#from_location_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#to_location_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#lot_company_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('lot_company_id-0'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_needed-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_moved-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};




var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
async function $46eb3da09fc3b5ed$var$companyIdFromGridFilter(crud_) {
    let f = crud_.filter;
    if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await resolveFilterLabelsToIds(f, crud_.fieldspecs);
    for(let i = 0; i < 12; i++){
        if (f[`field-${i}`] === 'company_id' && f[`value-${i}`]) return String(f[`value-${i}`]).trim();
    }
    return null;
}
const $46eb3da09fc3b5ed$var$replenishment_orders = function() {
    let orders_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_replenishments, query);
        },
        insertRecord () {
            this.createReplenishment();
        },
        async editFilter () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = data;
            (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, await this.queryFilteredForLocations()).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            this.loadPage(1);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_replenishment, ...JSON.parse(id));
            return (0, $b60a2.flatten)(_record, 'items');
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'items');
            let _record = {
                items: data.items.map((item)=>({
                        from_location_id: Number(item.from_location_id),
                        to_location_id: Number(item.to_location_id),
                        lot_company_id: item.lot_company_id,
                        lot_id: Number(item.lot_id),
                        product_id: Number(item.product_id),
                        quantity_needed: Number(item.quantity_needed),
                        quantity_moved: Number(item.quantity_moved)
                    }))
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_replenishment, data.company_id, data.warehouse_id, data.id, _record);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_replenishment, data.company_id, data.warehouse_id);
        },
        async createReplenishment () {
            const companyId = await resolveTenantCompanyId(this);
            if (!companyId) {
                (0, $jUNyh.notify)("N\xe3o foi poss\xedvel identificar o tenant: filtre por empresa, selecione uma linha, ou garanta dados na p\xe1gina.", 'Gerar ressuprimento');
                return;
            }
            const showResult = (resp)=>{
                (0, $jUNyh.notify)(resp.id ? 'Ressuprimento criado' : "N\xe3o h\xe1 posi\xe7\xf5es a ressuprir", 'Resultado');
                this.loadPage();
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const payload = data._payload && Object.keys(data._payload).length ? data._payload : null;
                await (0, $9VcS9.default).call((0, $9VcS9.default).insert_replenishment, data.company_id, data.warehouse_id, payload).then(showResult);
            };
            let fs = (0, $h1m6J.default).create((0, $697f32a542e4bc7b$export$2e2bcd8739ae039)(companyId), sendRequest);
            fs.init();
        },
        closeReplenishments () {
            if (!this.ensureSelection('Baixar Ressuprimentos')) return;
            const showResult = (resp)=>{
                (0, $jUNyh.notify)(resp.count ? `Ressuprimentos finalizados: ${resp.count}` : 'Nenhum ressuprimento a finalizar', 'Resultado');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'warehouse_id',
                    'id'
                ]);
                await (0, $9VcS9.default).call((0, $9VcS9.default).close_replenishments, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Encerrar ${this.getCount()} ressuprimentos?`, 'Baixar Ressuprimentos', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printReplenishmentOrders () {
            if (!this.ensureSelection('Ordem de Ressuprimento')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'warehouse_id',
                    'id'
                ]);
                await (0, $9VcS9.default).call((0, $9VcS9.default).print_replenishment_orders, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Gerar ordem para ${this.getCount()} ressuprimentos?`, 'Ordem de Ressuprimento', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m do estoque",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 3,
            field: 'id',
            label: 'Ressuprimento',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do ressuprimento'
        },
        {
            index: 4,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de cria\xe7\xe3o do ressuprimento"
        },
        {
            index: 5,
            field: 'completed_on',
            label: "Conclus\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de conclus\xe3o do ressuprimento"
        }
    ];
    let operations = [
        {
            hash: '#goto-replenishment-rules',
            label: "Regras&nbsp;min/m\xe1x"
        },
        {
            hash: '#close-replenishments',
            label: 'Baixar&nbsp;Ressuprimentos'
        }
    ];
    let reports = [
        {
            hash: '#print-orders',
            label: 'Ordem&nbsp;de&nbsp;Ressuprimento'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#close-replenishments', orders_crud.closeReplenishments.bind(orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-orders', orders_crud.printReplenishmentOrders.bind(orders_crud));
    orders_crud.run('replenishment-orders', "Ressuprimentos \u2014 ordens (LOG)", document.getElementById('workarea'), (0, $88a2283db056a470$export$2e2bcd8739ae039), (0, $abe6840daea06ec9$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $46eb3da09fc3b5ed$export$2e2bcd8739ae039 = $46eb3da09fc3b5ed$var$replenishment_orders;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $jUNyh = parcelRequire("jUNyh");
async function $85514b0bdf9568d6$export$2e2bcd8739ae039(records) {
    const statusLabel = {
        10: 'Criado',
        20: 'Congelado',
        30: 'Em contagem',
        40: 'Pronto p/ fechar',
        50: 'Fechado',
        60: 'Cancelado'
    };
    const statusColor = {
        10: '#64748b',
        20: '#2563eb',
        30: '#d97706',
        40: '#16a34a',
        50: '#6b7280',
        60: '#dc2626'
    };
    const typeLabel = {
        position: "Por posi\xe7\xe3o",
        product: 'Por produto',
        import: 'Por planilha'
    };
    const rows = (records || []).map((r)=>{
        const pct = r.total_items ? Math.round(r.finalized_items / r.total_items * 100) : 0;
        const color = statusColor[r.status] || '#333';
        const label = statusLabel[r.status] || r.status;
        const created = r.created_on ? r.created_on.substring(0, 10) : '';
        const pending = Math.max(0, (r.total_items || 0) - (r.finalized_items || 0));
        return `
		<tr data-id='${JSON.stringify([
            r.company_id,
            r.id
        ])}'>
			<td><input type="checkbox"></td>
			<td>${r.id}</td>
			<td>${r.name || ''}</td>
			<td>${typeLabel[r.session_type] || r.session_type || ''}</td>
			<td style="color:${color}; font-weight:600;">${label}</td>
			<td>
				<div style="font-weight:600;">${pct}%</div>
				<div class="inv-grid-progress"><span style="width:${pct}%;"></span></div>
				<small style="color:#64748b;">${r.finalized_items || 0}/${r.total_items || 0} finalizados \xb7 ${pending} pendentes</small>
			</td>
			<td>${created}</td>
		</tr>`;
    }).join('');
    return `
		<style>
			.view th:nth-child(1) { width:1rem; }
			.view td:nth-child(2) { text-align:right; width:3rem; }
			.view td:nth-child(6) { text-align:center; }
			.view td:nth-child(7) { text-align:center; width:7rem; }
			.inv-grid-progress { height: 7px; background:#e5e7eb; border-radius:999px; overflow:hidden; min-width:7rem; margin:2px auto; }
			.inv-grid-progress span { display:block; height:100%; background:#16a34a; }
			.inv-counts-hint { color:#64748b; font-size:.76rem; margin:4px 0 6px; }
		</style>
		<div class="inv-counts-hint">Para ver as contagens em tela, clique na linha do invent\xe1rio ou use Opera\xe7\xf5es &gt; Ver contagens / acompanhamento.</div>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th>#</th>
					<th>Nome</th>
					<th>Tipo</th>
					<th>Status</th>
					<th>Progresso</th>
					<th>Criado em</th>
				</tr>
			</thead>
			<tbody>${rows}</tbody>
		</table>`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");

var $9PIz7 = parcelRequire("9PIz7");

var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $3OKkn = parcelRequire("3OKkn");
var $knytZ = parcelRequire("knytZ");
const $cf923db1bbff9a34$var$STATUS_LABEL = {
    10: 'Criado',
    20: 'Congelado',
    30: 'Em contagem',
    40: 'Pronto p/ fechar',
    50: 'Fechado',
    60: 'Cancelado'
};
const $cf923db1bbff9a34$var$COUNT_STATUS_LABEL = {
    pending: 'Pendente',
    count1_done: "1\xaa contagem feita",
    count2_needed: "Aguard. 2\xaa contagem",
    count2_done: "2\xaa contagem feita",
    count3_needed: "Aguard. 3\xaa contagem (gestor)",
    finalized: 'Finalizado'
};
/** Prefixo gravado pelo coletor ao encerrar posição (falta física). */ const $cf923db1bbff9a34$var$CLOSE_LOCATION_PREFIX = "[ENCERRAR POSI\xc7\xc3O]";
var $cf923db1bbff9a34$export$2e2bcd8739ae039 = {
    html: `
		<form id="inv-session" class="form sial-modal-form" autocomplete="off">
			<style>
				#inv-session.form.sial-modal-form {
					background-color: var(--color-box, #fff);
					box-sizing: border-box;
				}
				#inv-session { max-width: 68rem; }
				#inv-session fieldset { border: 1px solid #ddd; border-radius: 6px; padding: 10px 14px; margin-bottom: 10px; }
				#inv-session legend { font-weight: 600; color: #1e3a5f; padding: 0 6px; }
				#inv-session .field-row { display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start; margin-bottom: 8px; }
				#inv-session label { display: flex; flex-direction: column; font-size: 0.8rem; }
				#inv-session input, #inv-session select, #inv-session textarea { padding: 4px 6px; border: 1px solid #ccc; border-radius: 4px; font-size: 0.85rem; }
				#inv-session .w-full { width: 100%; }
				#inv-session .w-half { width: calc(50% - 5px); }
				#inv-session .w-third { width: calc(33% - 7px); }
				#inv-session .badge { display: inline-block; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
				.badge-frozen { background: #dbeafe; color: #1e40af; }
				.badge-counting { background: #fef3c7; color: #92400e; }
				.badge-ready { background: #dcfce7; color: #166534; }
				.badge-closed { background: #f3f4f6; color: #6b7280; }
				.badge-cancelled { background: #fee2e2; color: #991b1b; }
				#inv-items-panel { margin-top: 10px; }
				#inv-items-table-container { max-width: 100%; overflow-x: auto; overflow-y: auto; max-height: min(42vh, 24rem); border: 1px solid #e2e8f0; border-radius: 6px; }
				#inv-items-panel table { width: max-content; min-width: 100%; border-collapse: collapse; font-size: 0.78rem; table-layout: auto; }
				#inv-items-panel th { background: #1e3a5f; color: #fff; padding: 4px 6px; text-align: left; }
				#inv-items-panel th { position: sticky; top: 0; z-index: 1; white-space: nowrap; }
				#inv-items-panel td { padding: 3px 6px; border-bottom: 1px solid #e5e7eb; vertical-align: top; }
				#inv-items-panel tr.finalized td { background: #f0fdf4; }
				#inv-items-panel tr.divergent td { background: #fef3c7; }
				.inv-items-toolbar { display:flex; gap:8px; align-items:center; flex-wrap:wrap; margin: 6px 0 8px; }
				.inv-items-search { flex: 1 1 18rem; min-width: min(100%, 14rem); }
				.inv-items-search input { width: 100%; box-sizing: border-box; }
				.inv-items-count { color:#64748b; font-size:.75rem; }
				.inv-col-id { width: 3.2rem; text-align:right; }
				.inv-col-pos { min-width: 7rem; }
				.inv-col-sku { min-width: 5.5rem; }
				.inv-col-prod { min-width: 13rem; max-width: 18rem; }
				.inv-col-lot { min-width: 8rem; }
				.inv-col-num { width: 4.2rem; text-align:right; }
				.inv-col-status { min-width: 7.5rem; }
				.inv-col-count { min-width: 9rem; }
				.inv-col-details { min-width: 14rem; max-width: 22rem; }
				.inv-progress-track { height: 10px; background: #e5e7eb; border-radius: 999px; overflow: hidden; margin: 6px 0 10px; }
				.inv-progress-fill { height: 100%; background: #16a34a; width: 0%; transition: width .2s ease; }
				.inv-summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(8.5rem, 1fr)); gap: 8px; margin: 8px 0; }
				.inv-card { border: 1px solid #e2e8f0; border-radius: 6px; padding: 8px 10px; background: #f8fafc; }
				.inv-card .label { color: #64748b; font-size: .72rem; }
				.inv-card .value { font-size: 1.1rem; font-weight: 700; margin-top: 2px; }
				.inv-card.inv-card-close { border-color: #d97706; background: #fffbeb; }
				.inv-card.inv-card-close .value { color: #b45309; }
				.inv-status-shortage { display: inline-block; padding: 2px 6px; border-radius: 4px; background: #fef3c7; color: #92400e; font-size: .72rem; font-weight: 600; }
				.inv-status-shortage-done { display: inline-block; padding: 2px 6px; border-radius: 4px; background: #dcfce7; color: #166534; font-size: .72rem; font-weight: 600; }
				.inv-close-tag { display: inline-block; margin-top: 2px; padding: 1px 5px; border-radius: 4px; background: #ffedd5; color: #c2410c; font-size: .68rem; font-weight: 600; }
				#inv-close-location-hint { font-size: .76rem; color: #b45309; margin: 4px 0 0; }
				.inv-filter-row { display:flex; gap:6px; flex-wrap:wrap; margin: 6px 0 8px; }
				.inv-filter-row button { border:1px solid #cbd5e1; border-radius:4px; padding:3px 8px; background:#fff; cursor:pointer; font-size:.75rem; }
				.inv-filter-row button.active { background:#1e3a5f; color:#fff; border-color:#1e3a5f; }
				.count-history { font-size:.72rem; line-height:1.35; color:#334155; }
				.count-history div + div { border-top:1px dotted #cbd5e1; margin-top:2px; padding-top:2px; }
				.count-round-cell { min-width: 8rem; font-size:.72rem; line-height:1.35; color:#334155; }
				.count-round-cell .qty { font-size:.88rem; font-weight:700; color:#0f172a; }
				.count-round-cell .meta { color:#64748b; }
				.count-round-cell .empty { color:#94a3b8; }
				.count-details { min-width: 12rem; font-size:.72rem; line-height:1.35; color:#475569; }
				.count-details div + div { border-top:1px dotted #cbd5e1; margin-top:2px; padding-top:2px; }
				.count-form-row { display: flex; gap: 8px; align-items: flex-end; margin-top: 8px; flex-wrap: wrap; }
				.count-form-row input { padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; }
				#inv-location-ops-panel { margin-top: 10px; padding: 10px 12px; border: 1px solid #cbd5e1; border-radius: 6px; background: #f8fafc; }
				#inv-location-ops-panel > strong { display: block; font-size: 0.82rem; color: #1e3a5f; margin-bottom: 6px; }
				.inv-loc-ops-row { display: flex; gap: 8px; align-items: flex-end; flex-wrap: wrap; }
				.inv-loc-ops-row label { font-size: 0.78rem; display: flex; flex-direction: column; gap: 2px; }
				.inv-loc-ops-preview { margin-top: 8px; padding: 8px 10px; border-radius: 6px; border: 1px solid #e2e8f0; background: #fff; font-size: 0.78rem; line-height: 1.4; }
				.inv-loc-ops-preview.warn { border-color: #fcd34d; background: #fffbeb; }
				.inv-loc-ops-preview.info { border-color: #93c5fd; background: #eff6ff; }
				.inv-loc-ops-preview ul { margin: 6px 0 0 1rem; padding: 0; }
				.inv-loc-ops-actions { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 8px; }
				.inv-col-actions { min-width: 5.5rem; width: 5.5rem; }
				.inv-row-actions { display: flex; flex-direction: column; gap: 4px; align-items: stretch; }
				.inv-row-actions .bn-action { padding: 3px 6px; font-size: 0.68rem; font-weight: 600; width: 100%; text-align: center; }
				.inv-btn-ghost { background: #fff; color: #1e3a5f; border: 1px solid #cbd5e1; }
				.count-round-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 4px; }
				.inv-btn-del { padding: 0 5px; font-size: 0.65rem; line-height: 1.35; border: none; border-radius: 3px; background: #fee2e2; color: #b91c1c; cursor: pointer; font-weight: 700; flex-shrink: 0; }
				.inv-btn-del:hover { background: #fecaca; }
				.bn-action { padding: 5px 12px; border: none; border-radius: 4px; cursor: pointer; font-size: 0.82rem; font-weight: 600; }
				.bn-primary { background: #1e3a5f; color: #fff; }
				.bn-success { background: #16a34a; color: #fff; }
				.bn-danger { background: #dc2626; color: #fff; }
				.bn-warn { background: #d97706; color: #fff; }
				.sim-summary { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 10px 14px; margin: 8px 0; font-size: 0.82rem; }
			.sim-credit { color: #16a34a; font-weight: 700; }
			.sim-debit { color: #dc2626; font-weight: 700; }
			#import-panel { border-color: #3b82f6; }
			#import-panel legend { color: #1d4ed8; }
			#import-feedback table { width: 100%; border-collapse: collapse; font-size: 0.76rem; margin-top: 6px; }
			#import-feedback th { background: #1e3a5f; color: #fff; padding: 3px 6px; text-align: left; }
			#import-feedback td { padding: 3px 6px; border-bottom: 1px solid #e5e7eb; }
			#import-feedback .row-ok td { background: #f0fdf4; }
			#import-feedback .row-err td { background: #fef2f2; color: #dc2626; }
			.bn-info { background: #0ea5e9; color: #fff; }
				.inv-clear-counts-msgbox { min-width: min(420px, 92vw); max-width: 540px; padding: 0; overflow: hidden; text-align: left; }
				.inv-clear-counts-alert { background: #dc2626; color: #fff; padding: 18px 20px; }
				.inv-clear-counts-alert-title { font-size: 1.15rem; font-weight: 800; margin-bottom: 8px; letter-spacing: 0.02em; }
				.inv-clear-counts-alert p { margin: 0; line-height: 1.5; font-size: 0.92rem; }
				.inv-clear-counts-body { padding: 16px 20px; background: #fff; }
				.inv-clear-counts-code-display { text-align: center; font-size: 2rem; font-weight: 800; letter-spacing: 0.4em; color: #b91c1c; margin: 10px 0 14px; font-family: ui-monospace, monospace; user-select: all; }
				.inv-clear-counts-input { width: 100%; box-sizing: border-box; padding: 10px 12px; font-size: 1.25rem; letter-spacing: 0.35em; text-align: center; font-family: ui-monospace, monospace; border: 2px solid #fca5a5; border-radius: 6px; }
				.inv-clear-counts-input:focus { outline: none; border-color: #dc2626; box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2); }
				.inv-clear-counts-err { color: #dc2626; font-size: 0.85rem; margin: 8px 0 0; display: none; font-weight: 600; }
				.inv-close-status-panel { background: #fffbeb; border: 1px solid #fcd34d; border-radius: 8px; padding: 12px 14px; margin: 10px 0; }
				.inv-close-status-panel.done { background: #f0fdf4; border-color: #86efac; }
				.inv-close-status-panel.error { background: #fef2f2; border-color: #fca5a5; }
				.inv-close-status-panel h4 { margin: 0 0 6px; font-size: 0.92rem; color: #92400e; }
				.inv-close-status-panel.done h4 { color: #166534; }
				.inv-close-status-panel.error h4 { color: #b91c1c; }
				.inv-close-status-track { height: 12px; background: #e5e7eb; border-radius: 999px; overflow: hidden; margin: 8px 0; }
				.inv-close-status-fill { height: 100%; background: linear-gradient(90deg, #d97706, #f59e0b); width: 0%; transition: width .3s ease; }
				.inv-close-status-panel.done .inv-close-status-fill { background: linear-gradient(90deg, #16a34a, #22c55e); }
				.inv-close-status-meta { font-size: 0.78rem; color: #64748b; }
				.inv-close-status-docs { font-size: 0.78rem; color: #334155; margin-top: 6px; }
				.inv-close-confirm-msgbox { min-width: min(440px, 92vw); max-width: 560px; padding: 0; overflow: hidden; text-align: left; }
		</style>

			<fieldset>
				<legend>Identifica\xe7\xe3o</legend>
				<input type="hidden" id="id">
				<div class="field-row">
					<label class="w-half">Empresa*
						<input id="company_id" list="companies" placeholder="Selecione a empresa">
						<datalist id="companies"></datalist>
					</label>
					<label class="w-half">Nome da Sess\xe3o*
						<input id="name" type="text" maxlength="120" placeholder="Ex: Invent\xe1rio Geral - Jun/2026">
					</label>
				</div>
				<div class="field-row">
					<label class="w-third">Tipo*
						<select id="session_type">
							<option value="position" selected>Por posi\xe7\xe3o / armaz\xe9m</option>
							<option value="product">Por produto</option>
							<option value="import">Importa\xe7\xe3o de planilha</option>
						</select>
					</label>
					<label class="w-half">Observa\xe7\xf5es
						<textarea id="notes" rows="2" style="width:100%;"></textarea>
					</label>
				</div>
			</fieldset>

			<fieldset id="scope-filter-panel">
				<legend>Escopo (filtros de congelamento)</legend>
				<p id="scope-hint" style="font-size:0.78rem; color:#666; margin:0 0 6px 0;">Deixe em branco para inventariar tudo da empresa.</p>
				<p id="scope-import-note" style="font-size:0.82rem; color:#92400e; background:#fef3c7; border-radius:4px; padding:6px 10px; margin:0; display:none;">
					O escopo ser\xe1 definido pela planilha importada abaixo.
				</p>
				<div id="scope-row-location" class="field-row">
					<label class="w-half">Armaz\xe9ns (IDs num\xe9ricos, separados por v\xedrgula, espa\xe7o ou ; )
						<input id="scope_warehouse_ids" type="text" placeholder="Ex: 1, 2">
					</label>
					<label class="w-half" id="scope-label-location">Posi\xe7\xf5es (IDs ou endere\xe7os, separados por v\xedrgula, espa\xe7o ou ; )
						<input id="scope_location_ids" type="text" placeholder="Ex: 3456, 2-M-1-2 ou 2-M-1-2 2-M-1-1">
					</label>
				</div>
				<div id="scope-row-product" class="field-row">
					<label class="w-third">Produtos (IDs ou SKUs)
						<input id="scope_product_ids" type="text" placeholder="Ex: 123, SKU001 ou 2000040981">
					</label>
					<label class="w-third">Categorias (IDs)
						<input id="scope_category_ids" type="text" placeholder="Ex: 10, 11">
					</label>
					<label class="w-third">Classes (IDs)
						<input id="scope_class_ids" type="text" placeholder="Ex: 2, 3">
					</label>
				</div>
			</fieldset>

		<fieldset id="inv-actions-panel" style="display:none;">
			<legend>A\xe7\xf5es</legend>
			<div style="display:flex; gap:8px; flex-wrap:wrap; align-items:center;">
				<span id="inv-status-badge" class="badge">-</span>
				<span id="inv-progress-label" style="font-size:0.8rem; color:#555;"></span>
				<button type="button" id="bn-freeze-inv" class="bn-action bn-primary" style="display:none;">Congelar Invent\xe1rio</button>
				<button type="button" id="bn-unfreeze-inv" class="bn-action bn-warn" style="display:none;">Descongelar Invent\xe1rio</button>
				<button type="button" id="bn-simulate" class="bn-action bn-warn" style="display:none;">Simular Fechamento</button>
				<button type="button" id="bn-print-progress" class="bn-action bn-primary" style="display:none;">PDF Acompanhamento</button>
				<button type="button" id="bn-print-divergences" class="bn-action bn-primary" style="display:none;">PDF Diverg\xeancias</button>
				<button type="button" id="bn-print-sim" class="bn-action bn-primary" style="display:none;">PDF Simula\xe7\xe3o</button>
				<button type="button" id="bn-print-sim-sku" class="bn-action bn-primary" style="display:none;">PDF Simula\xe7\xe3o SKU</button>
				<button type="button" id="bn-export-sim-sku" class="bn-action bn-primary" style="display:none;">Excel Simula\xe7\xe3o SKU</button>
				<button type="button" id="bn-export-closure-sku" class="bn-action bn-primary" style="display:none;">Excel Saldo SKU</button>
				<button type="button" id="bn-print-closure" class="bn-action bn-primary" style="display:none;">PDF Fechamento</button>
				<button type="button" id="bn-close-inv" class="bn-action bn-success" style="display:none;">Fechar Invent\xe1rio</button>
				<button type="button" id="bn-cancel-inv" class="bn-action bn-danger" style="display:none;">Cancelar Invent\xe1rio</button>
				<button type="button" id="bn-clear-counts" class="bn-action bn-danger" style="display:none;">Cancelar Contagens</button>
				<button type="button" id="bn-reload-items" class="bn-action bn-primary" style="display:none;">Atualizar Itens</button>
				<button type="button" id="bn-export-counts" class="bn-action bn-primary" style="display:none;">Exportar Contagens</button>
			</div>
			<div id="inv-summary-panel" style="display:none;">
				<div class="inv-progress-track"><div id="inv-progress-fill" class="inv-progress-fill"></div></div>
				<div id="inv-summary-cards" class="inv-summary-grid"></div>
				<p id="inv-close-location-hint" style="display:none;"></p>
				<p id="inv-last-count" style="font-size:.76rem; color:#64748b; margin:4px 0;"></p>
			</div>
			<div id="sim-summary-panel" class="sim-summary" style="display:none;">
				<strong>Simula\xe7\xe3o:</strong>
				<span id="sim-total"></span> itens \u{2014}
				<span class="sim-credit" id="sim-credit"></span>,
				<span class="sim-debit" id="sim-debit"></span>
				<span id="sim-net" style="font-weight:700; margin-left:6px;"></span>
			</div>
			<div id="inv-close-status-panel" class="inv-close-status-panel" style="display:none;" role="status" aria-live="polite">
				<h4 id="inv-close-status-title">Fechamento em andamento no servidor</h4>
				<p id="inv-close-status-msg" style="margin:0 0 6px;font-size:0.82rem;color:#475569;">Processando ajustes de estoque. Voc\xea pode fechar esta aba \u{2014} o fechamento continua no servidor.</p>
				<div class="inv-close-status-track"><div id="inv-close-status-fill" class="inv-close-status-fill"></div></div>
				<div id="inv-close-status-meta" class="inv-close-status-meta">0%</div>
				<div id="inv-close-status-docs" class="inv-close-status-docs" style="display:none;"></div>
				<div id="inv-close-status-error" style="display:none;color:#dc2626;font-weight:600;font-size:0.82rem;margin-top:6px;"></div>
			</div>
			<div id="count-panel" style="display:none; margin-top:10px;">
				<strong style="font-size:0.82rem;">Registrar Contagem Cega</strong>
				<div class="count-form-row">
					<label style="font-size:0.78rem;">Posi\xe7\xe3o<input id="count-location-code" type="text" style="width:7rem;" placeholder="2-M-1-2"></label>
					<label style="font-size:0.78rem;">SKU<input id="count-sku" type="text" style="width:7rem;"></label>
					<label style="font-size:0.78rem;">Lote<input id="count-lot-number" type="text" style="width:7rem;"></label>
					<label style="font-size:0.78rem;">Validade<input id="count-expiration-date" type="date" style="width:8rem;"></label>
					<label style="font-size:0.78rem;">Quantidade<input id="count-qty" type="number" min="0" style="width:6rem;"></label>
					<label style="font-size:0.78rem;">Observa\xe7\xe3o<input id="count-obs" type="text" style="width:12rem;"></label>
					<button type="button" id="bn-save-count" class="bn-action bn-primary">Salvar Contagem</button>
				</div>
				<p style="font-size:0.75rem; color:#64748b; margin:4px 0;">Invent\xe1rio cego: digite os dados encontrados fisicamente. O programa \xe9 resolvido internamente pelo SKU/produto.</p>
				<p id="count-feedback" style="font-size:0.8rem; min-height:1.4rem; margin:4px 0; color:#16a34a;"></p>
			</div>
			<div id="inv-location-ops-panel" style="display:none;">
				<strong>Opera\xe7\xf5es por posi\xe7\xe3o</strong>
				<span style="font-size:0.72rem; color:#64748b; display:block; margin-bottom:6px;">Um bot\xe3o: o SIAL detecta se h\xe1 falta f\xedsica, achados em posi\xe7\xe3o vazia, ou ambos. 2\xaa rodada de falta exige outro operador.</span>
				<div class="inv-loc-ops-row">
					<label>Posi\xe7\xe3o
						<input id="loc-ops-code" type="text" style="width:7rem;" placeholder="2-A-47-2">
					</label>
					<button type="button" id="bn-loc-complete-preview" class="bn-action bn-warn" title="Encerra a posi\xe7\xe3o: falta f\xedsica e/ou finaliza\xe7\xe3o de achados, conforme o estado.">Encerrar posi\xe7\xe3o</button>
				</div>
				<div id="inv-loc-ops-preview" class="inv-loc-ops-preview" style="display:none;"></div>
			</div>
		</fieldset>

			<fieldset id="inv-import-panel" style="display:none;">
				<legend>Importar Planilha</legend>
				<p id="import-create-note" style="font-size:0.78rem; color:#555; margin:0 0 8px 0; display:none;">
					Se a sess\xe3o ainda n\xe3o foi salva, ela ser\xe1 criada automaticamente ao importar (empresa e nome s\xe3o obrigat\xf3rios).
				</p>
				<div style="display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
					<button type="button" id="bn-download-template-detail" class="bn-action bn-primary" style="font-size:0.78rem;">\u{2B07} Baixar Modelo CSV</button>
					<label style="font-size:0.78rem; cursor:pointer; display:inline-flex; align-items:center; gap:6px;">
						<input type="file" id="import-file-input" accept=".csv,.txt" style="display:none;">
						<span class="bn-action" style="background:#e5e7eb; color:#1f2937; padding:5px 12px; border-radius:4px; font-weight:600; font-size:0.82rem; cursor:pointer;">\u{1F4C2} Selecionar arquivo</span>
						<span id="import-file-name" style="color:#555; font-size:0.78rem; font-style:italic;">Nenhum arquivo selecionado</span>
					</label>
					<button type="button" id="bn-import-spreadsheet" class="bn-action bn-success" style="font-size:0.78rem;" disabled>\u{25B6} Importar</button>
				</div>
				<p id="import-feedback" style="font-size:0.8rem; min-height:1.4rem; margin:6px 0 0; color:#16a34a;"></p>
			</fieldset>

		<div id="inv-items-panel" style="display:none;">
				<h4 style="margin:8px 0 4px; font-size:0.85rem; color:#1e3a5f;">Itens do Escopo</h4>
				<div class="inv-items-toolbar">
					<div id="inv-item-filters" class="inv-filter-row">
						<button type="button" data-filter="all" class="active">Todos</button>
						<button type="button" data-filter="pending">Pendentes</button>
						<button type="button" data-filter="count2">2\xaa contagem</button>
						<button type="button" data-filter="count3">3\xaa contagem</button>
						<button type="button" data-filter="finalized">Finalizados</button>
						<button type="button" data-filter="divergent">Diverg\xeancias</button>
						<button type="button" data-filter="close_location">Falta f\xedsica</button>
					</div>
					<label class="inv-items-search" title="Busca em posi\xe7\xe3o, SKU, produto, lote, status, operador e dados digitados">
						<input id="inv-item-search" type="search" placeholder="Buscar em qualquer coluna...">
					</label>
					<span id="inv-items-count" class="inv-items-count"></span>
				</div>
				<div id="inv-items-table-container"><p style="color:#999; font-size:0.8rem;">Carregando itens...</p></div>
			</div>

			<div style="display:flex; gap:8px; justify-content:flex-end; margin-top:10px;">
				<button type="button" class="bn_Escape button">Fechar</button>
				<button type="button" class="bn_Enter button" id="bn-save-session">Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#inv-session',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = document.querySelector('#inv-session');
            if (root) {
                root.dataset.sessionId = '';
                root.dataset.importBound = '';
                root.dataset.invSessionBound = '';
                const typeEl = root.querySelector('#session_type');
                $cf923db1bbff9a34$var$_adaptScopeByType(typeEl?.value || 'position', root);
                typeEl?.addEventListener('change', ()=>$cf923db1bbff9a34$var$_adaptScopeByType(typeEl.value, root));
            }
        },
        afterEditSetValues (fs) {
            const vals = fs.form.getValues?.() || {};
            const root = document.querySelector('#inv-session');
            const companyId = root ? $cf923db1bbff9a34$var$_resolveDatalistValue(root.querySelector('#company_id')) : vals.company_id;
            const sessionId = vals.id;
            if (root) {
                root.dataset.sessionId = sessionId ? String(sessionId) : '';
                const typeEl = root.querySelector('#session_type');
                $cf923db1bbff9a34$var$_adaptScopeByType(typeEl?.value || 'position', root);
            }
            if (sessionId && companyId) $cf923db1bbff9a34$var$_showSessionDetail({
                ...vals,
                id: sessionId,
                company_id: companyId
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default()
            ]
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#session_type'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#scope_warehouse_ids'
            },
            types: []
        },
        {
            properties: {
                selector: '#scope_location_ids'
            },
            types: []
        },
        {
            properties: {
                selector: '#scope_product_ids'
            },
            types: []
        },
        {
            properties: {
                selector: '#scope_category_ids'
            },
            types: []
        },
        {
            properties: {
                selector: '#scope_class_ids'
            },
            types: []
        }
    ]
};
function $cf923db1bbff9a34$var$_downloadTemplateCsv() {
    const content = 'sku;lot_number;location_code;warehouse_code;quantity_expected\n004212;13620;1-A-01-1;;0\n';
    const blob = new Blob([
        '\uFEFF' + content
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'modelo_inventario.csv';
    a.click();
    URL.revokeObjectURL(url);
}
function $cf923db1bbff9a34$var$_adaptScopeByType(type, root) {
    const panel = root.querySelector('#scope-filter-panel');
    const hint = root.querySelector('#scope-hint');
    const importNote = root.querySelector('#scope-import-note');
    const rowLoc = root.querySelector('#scope-row-location');
    const labelLoc = root.querySelector('#scope-label-location');
    const rowProd = root.querySelector('#scope-row-product');
    const importPanel = root.querySelector('#inv-import-panel');
    const createNote = root.querySelector('#import-create-note');
    if (!panel) return;
    if (type === 'import') {
        if (hint) hint.style.display = 'none';
        if (importNote) importNote.style.display = '';
        if (rowLoc) rowLoc.style.display = 'none';
        if (rowProd) rowProd.style.display = 'none';
        if (importPanel) importPanel.style.display = '';
        if (createNote) createNote.style.display = root.dataset.sessionId ? 'none' : '';
        $cf923db1bbff9a34$var$_bindImportPanel(root);
        return;
    }
    if (importPanel) importPanel.style.display = 'none';
    if (createNote) createNote.style.display = 'none';
    if (hint) hint.style.display = '';
    if (importNote) importNote.style.display = 'none';
    if (type === 'position') {
        if (rowLoc) rowLoc.style.display = '';
        if (labelLoc) labelLoc.style.display = '';
        if (rowProd) rowProd.style.display = '';
    } else if (type === 'product') {
        if (rowLoc) rowLoc.style.display = '';
        if (labelLoc) labelLoc.style.display = 'none';
        if (rowProd) rowProd.style.display = '';
    }
}
function $cf923db1bbff9a34$var$_resolveDatalistValue(node) {
    if (!node) return '';
    const raw = String(node.value || '').trim();
    if (!raw) return '';
    if (!node.list?.options?.length) return raw;
    let option = Array.from(node.list.options).find((opt)=>opt.innerText && opt.innerText.trim() === raw);
    if (!option) option = (0, $9PIz7.findOptionByDocumentDigits)(node.list.options, raw);
    return option?.value || raw;
}
function $cf923db1bbff9a34$var$_readFormBasics(root) {
    const companyId = $cf923db1bbff9a34$var$_resolveDatalistValue(root.querySelector('#company_id'));
    const name = root.querySelector('#name')?.value?.trim() || '';
    const sessionType = root.querySelector('#session_type')?.value || 'position';
    const notes = root.querySelector('#notes')?.value?.trim() || '';
    return {
        companyId: companyId,
        name: name,
        sessionType: sessionType,
        notes: notes
    };
}
async function $cf923db1bbff9a34$var$_ensureSessionForImport(root) {
    let sessionId = root.dataset.sessionId ? parseInt(root.dataset.sessionId, 10) : null;
    const { companyId: companyId, name: name, sessionType: sessionType, notes: notes } = $cf923db1bbff9a34$var$_readFormBasics(root);
    if (!companyId) {
        (0, $jUNyh.notify)('Selecione a empresa antes de importar.');
        return null;
    }
    if (!name) {
        (0, $jUNyh.notify)("Informe o nome da sess\xe3o antes de importar.");
        return null;
    }
    if (sessionType !== 'import') {
        (0, $jUNyh.notify)("Tipo de sess\xe3o deve ser Importa\xe7\xe3o de planilha.");
        return null;
    }
    if (sessionId) return {
        companyId: companyId,
        sessionId: sessionId
    };
    const res = await (0, $9VcS9.default).create_inventory_session({
        company_id: companyId,
        session_type: 'import',
        name: name,
        notes: notes || null,
        scope_filter: null,
        freeze_immediately: false
    });
    if (!res.ok) {
        (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
        return null;
    }
    const created = await res.json();
    sessionId = created.id;
    root.dataset.sessionId = String(sessionId);
    const createNote = root.querySelector('#import-create-note');
    if (createNote) createNote.style.display = 'none';
    (0, $jUNyh.notify)(`Sess\xe3o #${sessionId} criada. Importando planilha...`, 'success');
    return {
        companyId: companyId,
        sessionId: sessionId
    };
}
function $cf923db1bbff9a34$var$_bindImportPanel(root) {
    if (root.dataset.importBound === '1') return;
    root.dataset.importBound = '1';
    const btnTplDetail = root.querySelector('#bn-download-template-detail');
    const fileInput = root.querySelector('#import-file-input');
    const fileName = root.querySelector('#import-file-name');
    const btnImport = root.querySelector('#bn-import-spreadsheet');
    const feedback = root.querySelector('#import-feedback');
    btnTplDetail?.addEventListener('click', $cf923db1bbff9a34$var$_downloadTemplateCsv);
    fileInput?.addEventListener('change', ()=>{
        const f = fileInput.files?.[0];
        if (fileName) fileName.textContent = f ? f.name : 'Nenhum arquivo selecionado';
        if (btnImport) btnImport.disabled = !f;
        if (feedback) feedback.textContent = '';
    });
    btnImport?.addEventListener('click', async ()=>{
        const f = fileInput?.files?.[0];
        if (!f) return;
        if (feedback) {
            feedback.textContent = "Preparando importa\xe7\xe3o...";
            feedback.style.color = '#555';
        }
        btnImport.disabled = true;
        try {
            const ctx = await $cf923db1bbff9a34$var$_ensureSessionForImport(root);
            if (!ctx) return;
            const text = await f.text();
            const rows = $cf923db1bbff9a34$var$_parseCsv(text);
            if (!rows.length) {
                if (feedback) {
                    feedback.textContent = "Arquivo vazio ou sem linhas v\xe1lidas.";
                    feedback.style.color = '#dc2626';
                }
                return;
            }
            if (feedback) feedback.textContent = `Enviando ${rows.length} linhas...`;
            const res = await (0, $9VcS9.default).import_inventory_spreadsheet(ctx.companyId, ctx.sessionId, rows, f.name);
            if (!res.ok) {
                if (feedback) {
                    feedback.textContent = await $cf923db1bbff9a34$var$_apiErrorText(res);
                    feedback.style.color = '#dc2626';
                }
                return;
            }
            const result = await res.json();
            if (feedback) {
                feedback.innerHTML = $cf923db1bbff9a34$var$_buildImportResult(result);
                feedback.style.color = '';
            }
            fileInput.value = '';
            if (fileName) fileName.textContent = 'Nenhum arquivo selecionado';
            if (!root.dataset.invSessionBound) {
                root.dataset.invSessionBound = '1';
                await $cf923db1bbff9a34$var$_showSessionDetail({
                    company_id: ctx.companyId,
                    id: ctx.sessionId,
                    session_type: 'import'
                });
            } else if (typeof root._invRefresh === 'function') await root._invRefresh();
        } catch (e) {
            if (feedback) {
                feedback.textContent = String(e);
                feedback.style.color = '#dc2626';
            }
        } finally{
            if (btnImport) btnImport.disabled = !fileInput?.files?.[0];
        }
    });
}
/**
 * Bloqueia identificação e escopo após a sessão sair do status Criado.
 * @param {HTMLElement} root
 * @param {number} status
 */ function $cf923db1bbff9a34$var$_lockIdentificationFields(root, status) {
    const locked = Number(status) !== 10;
    const selectors = [
        '#company_id',
        '#name',
        '#session_type',
        '#notes',
        '#scope_warehouse_ids',
        '#scope_location_ids',
        '#scope_product_ids',
        '#scope_category_ids',
        '#scope_class_ids'
    ];
    selectors.forEach((sel)=>{
        const el = root.querySelector(sel);
        if (el) el.disabled = locked;
    });
    const saveBtn = root.querySelector('#bn-save-session');
    if (saveBtn) saveBtn.style.display = locked ? 'none' : '';
    let note = root.querySelector('#inv-readonly-note');
    if (locked) {
        if (!note) {
            note = document.createElement('p');
            note.id = 'inv-readonly-note';
            note.style.cssText = 'font-size:0.78rem;color:#64748b;margin:0 0 8px 0;';
            note.textContent = "Sess\xe3o iniciada: identifica\xe7\xe3o e escopo n\xe3o podem mais ser alterados.";
            const firstFieldset = root.querySelector('fieldset');
            if (firstFieldset) firstFieldset.insertBefore(note, firstFieldset.firstChild);
        }
    } else if (note) note.remove();
}
/** Gera código numérico de 6 dígitos para confirmação de ações destrutivas. */ function $cf923db1bbff9a34$var$_generateClearCountsConfirmCode() {
    return String(Math.floor(100000 + Math.random() * 900000));
}
/**
 * Modal de contra-senha — cancelar todas as contagens do inventário.
 * @param {function} onConfirm
 */ function $cf923db1bbff9a34$var$_openClearCountsConfirmModal(onConfirm) {
    const code = $cf923db1bbff9a34$var$_generateClearCountsConfirmCode();
    const html = `
		<div class="msgbox inv-clear-counts-msgbox">
			<div class="inv-clear-counts-alert">
				<div class="inv-clear-counts-alert-title">ATEN\xc7\xc3O \u{2014} A\xe7\xe3o irrevers\xedvel</div>
				<p>
					Ser\xe3o <strong>exclu\xeddas todas as contagens</strong> deste invent\xe1rio.
					O escopo congelado ser\xe1 removido e a sess\xe3o voltar\xe1 para <strong>Criado</strong>,
					permitindo cancelar o invent\xe1rio. Esta a\xe7\xe3o n\xe3o pode ser desfeita.
				</p>
			</div>
			<div class="inv-clear-counts-body">
				<p style="margin:0 0 8px;color:#334155;font-size:0.9rem">
					Para confirmar, digite o c\xf3digo de 6 d\xedgitos abaixo:
				</p>
				<div class="inv-clear-counts-code-display" aria-label="C\xf3digo de confirma\xe7\xe3o">${code}</div>
				<input type="text" id="inv-clear-counts-code" class="inv-clear-counts-input"
					inputmode="numeric" maxlength="6" pattern="[0-9]*" autocomplete="off"
					placeholder="000000" aria-label="Digite o c\xf3digo de confirma\xe7\xe3o">
				<p id="inv-clear-counts-err" class="inv-clear-counts-err">C\xf3digo incorreto.</p>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Confirmar exclus\xe3o</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y' && key !== 'Enter') return;
        const node = dlg.getNode();
        const input = node.querySelector('#inv-clear-counts-code');
        const typed = (input?.value || '').replace(/\D/g, '');
        if (typed !== code) {
            const err = node.querySelector('#inv-clear-counts-err');
            if (err) {
                err.style.display = 'block';
                err.textContent = "C\xf3digo incorreto. Digite exatamente os 6 d\xedgitos exibidos acima.";
            }
            input?.focus();
            input?.select();
            return;
        }
        dlg.destroy();
        if (typeof onConfirm === 'function') onConfirm();
    }, /Enter|Escape|N|Y/);
    setTimeout(()=>dlg.getNode().querySelector('#inv-clear-counts-code')?.focus(), 0);
}
function $cf923db1bbff9a34$var$_openCloseConfirmModal(onConfirm) {
    const code = $cf923db1bbff9a34$var$_generateClearCountsConfirmCode();
    const html = `
		<div class="msgbox inv-close-confirm-msgbox">
			<div class="inv-clear-counts-alert">
				<div class="inv-clear-counts-alert-title">FECHAMENTO DEFINITIVO \u{2014} IRREVERS\xcdVEL</div>
				<p>
					Esta a\xe7\xe3o <strong>n\xe3o pode ser cancelada</strong>. O sistema ir\xe1 gerar
					<strong>1 entrada</strong> com todas as sobras e <strong>1 sa\xedda</strong> com todas as faltas,
					ajustando o estoque real. O processamento continua <strong>no servidor</strong> mesmo se voc\xea fechar o navegador.
				</p>
			</div>
			<div class="inv-clear-counts-body">
				<p style="margin:0 0 8px;color:#334155;font-size:0.9rem">
					Para confirmar o fechamento, digite o c\xf3digo de 6 d\xedgitos:
				</p>
				<div class="inv-clear-counts-code-display" aria-label="C\xf3digo de confirma\xe7\xe3o">${code}</div>
				<input type="text" id="inv-close-confirm-code" class="inv-clear-counts-input"
					inputmode="numeric" maxlength="6" pattern="[0-9]*" autocomplete="off"
					placeholder="000000" aria-label="Digite o c\xf3digo de confirma\xe7\xe3o">
				<p id="inv-close-confirm-err" class="inv-clear-counts-err">C\xf3digo incorreto.</p>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Iniciar fechamento</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y' && key !== 'Enter') return;
        const node = dlg.getNode();
        const input = node.querySelector('#inv-close-confirm-code');
        const typed = (input?.value || '').replace(/\D/g, '');
        if (typed !== code) {
            const err = node.querySelector('#inv-close-confirm-err');
            if (err) {
                err.style.display = 'block';
                err.textContent = "C\xf3digo incorreto. Digite exatamente os 6 d\xedgitos exibidos acima.";
            }
            input?.focus();
            input?.select();
            return;
        }
        dlg.destroy();
        if (typeof onConfirm === 'function') onConfirm();
    }, /Enter|Escape|N|Y/);
    setTimeout(()=>dlg.getNode().querySelector('#inv-close-confirm-code')?.focus(), 0);
}
/** Atualiza painel inline de status do fechamento (somente leitura). */ function $cf923db1bbff9a34$var$_renderCloseJobPanel(root, job) {
    const panel = root.querySelector('#inv-close-status-panel');
    if (!panel) return;
    const fill = panel.querySelector('#inv-close-status-fill');
    const msgEl = panel.querySelector('#inv-close-status-msg');
    const metaEl = panel.querySelector('#inv-close-status-meta');
    const docsEl = panel.querySelector('#inv-close-status-docs');
    const errEl = panel.querySelector('#inv-close-status-error');
    const titleEl = panel.querySelector('#inv-close-status-title');
    const status = job?.status || 'idle';
    if (status === 'idle') {
        panel.style.display = 'none';
        return;
    }
    panel.style.display = '';
    panel.classList.remove('done', 'error');
    const pct = Math.max(0, Math.min(100, Number(job?.progress_percent || 0)));
    if (fill) fill.style.width = `${pct}%`;
    if (status === 'running') {
        titleEl.textContent = 'Fechamento em andamento no servidor';
        if (msgEl) msgEl.textContent = job?.message || "Processando ajustes de estoque\u2026";
    } else if (status === 'simulating') {
        titleEl.textContent = "Simula\xe7\xe3o em andamento";
        const who = job?.started_by_label || job?.started_by;
        if (msgEl) msgEl.textContent = who ? `Simula\xe7\xe3o exclusiva em andamento (iniciada por ${who}). Aguarde\u{2026}` : job?.message || "Simula\xe7\xe3o de fechamento em andamento. Aguarde\u2026";
    } else if (status === 'done') {
        panel.classList.add('done');
        titleEl.textContent = "Invent\xe1rio fechado com sucesso";
        if (msgEl) msgEl.textContent = job?.message || 'Ajustes aplicados. Consulte o PDF de fechamento.';
    } else if (status === 'error') {
        panel.classList.add('error');
        titleEl.textContent = 'Erro no fechamento';
        if (msgEl) msgEl.textContent = job?.message || 'Falha ao processar o fechamento.';
    }
    const step = Number(job?.step_index || 0);
    const total = Number(job?.total_steps || 0);
    if (metaEl) {
        if (status === 'simulating') metaEl.textContent = "A\xe7\xe3o exclusiva \u2014 outros usu\xe1rios n\xe3o podem simular nem fechar agora";
        else metaEl.textContent = total ? `${pct}% \u{2014} etapa ${Math.min(step, total)} / ${total}${job?.phase ? ` (${job.phase})` : ''}` : `${pct}%`;
    }
    if (docsEl) {
        const parts = [];
        if (job?.input_id) parts.push(`Entrada #${job.input_id}`);
        if (job?.output_id) parts.push(`Sa\xedda #${job.output_id}`);
        if (parts.length) {
            docsEl.style.display = '';
            docsEl.textContent = parts.join(" \xb7 ");
        } else docsEl.style.display = 'none';
    }
    if (errEl) {
        if (status === 'error' && job?.error) {
            errEl.style.display = '';
            errEl.textContent = job.error;
        } else errEl.style.display = 'none';
    }
}
/** Polling leve de status — não dirige o fechamento (servidor orquestra). */ function $cf923db1bbff9a34$var$_ensureCloseJobPolling(companyId, sessionId, root) {
    if (root._invClosePollTimer) return;
    root._invClosePollTimer = setInterval(async ()=>{
        try {
            const res = await (0, $9VcS9.default).get_inventory_close_job_status(companyId, sessionId);
            if (!res.ok) return;
            const job = await res.json();
            $cf923db1bbff9a34$var$_renderCloseJobPanel(root, job);
            if (job?.status === 'done') {
                clearInterval(root._invClosePollTimer);
                root._invClosePollTimer = null;
                (0, $jUNyh.notify)("Invent\xe1rio fechado com sucesso.", 'success');
                if (typeof root._invRefresh === 'function') await root._invRefresh();
            } else if (job?.status === 'error') {
                clearInterval(root._invClosePollTimer);
                root._invClosePollTimer = null;
                (0, $jUNyh.notify)(job?.error || job?.message || 'Erro no fechamento.', 'error');
                if (typeof root._invRefresh === 'function') await root._invRefresh();
            } else if (job?.status === 'idle') {
                clearInterval(root._invClosePollTimer);
                root._invClosePollTimer = null;
                if (typeof root._invRefresh === 'function') await root._invRefresh();
            }
        } catch  {
        /* polling silencioso */ }
    }, 2500);
}
async function $cf923db1bbff9a34$var$_startInventoryCloseJob(companyId, sessionId, root) {
    const btnClose = root.querySelector('#bn-close-inv');
    if (btnClose) btnClose.disabled = true;
    try {
        const res = await (0, $9VcS9.default).start_inventory_close_job(companyId, sessionId);
        if (!res.ok) {
            (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res), 'error');
            return;
        }
        const job = await res.json();
        $cf923db1bbff9a34$var$_renderCloseJobPanel(root, job);
        if (job?.status === 'running') $cf923db1bbff9a34$var$_ensureCloseJobPolling(companyId, sessionId, root);
        if (typeof root._invRefresh === 'function') await root._invRefresh();
    } finally{
        if (btnClose) btnClose.disabled = false;
    }
}
function $cf923db1bbff9a34$var$_stopCloseJobPolling(root) {
    if (root._invClosePollTimer) {
        clearInterval(root._invClosePollTimer);
        root._invClosePollTimer = null;
    }
}
async function $cf923db1bbff9a34$var$_showSessionDetail(vals) {
    const root = document.querySelector('#inv-session');
    if (!root) return;
    const companyId = $cf923db1bbff9a34$var$_resolveDatalistValue(root.querySelector('#company_id')) || vals.company_id;
    const sessionId = vals.id || root.dataset.sessionId;
    if (!companyId || !sessionId) return;
    root.dataset.sessionId = String(sessionId);
    root.dataset.invItemFilter = root.dataset.invItemFilter || 'all';
    $cf923db1bbff9a34$var$_bindImportPanel(root);
    const isFirstBind = root.dataset.invSessionBound !== '1';
    root.dataset.invSessionBound = '1';
    const actionsPanel = root.querySelector('#inv-actions-panel');
    const statusBadge = root.querySelector('#inv-status-badge');
    const progressLabel = root.querySelector('#inv-progress-label');
    const btnFreeze = root.querySelector('#bn-freeze-inv');
    const btnUnfreeze = root.querySelector('#bn-unfreeze-inv');
    const btnSimulate = root.querySelector('#bn-simulate');
    const btnPrintProgress = root.querySelector('#bn-print-progress');
    const btnPrintDivergences = root.querySelector('#bn-print-divergences');
    const btnPrintSim = root.querySelector('#bn-print-sim');
    const btnPrintSimSku = root.querySelector('#bn-print-sim-sku');
    const btnExportSimSku = root.querySelector('#bn-export-sim-sku');
    const btnExportClosureSku = root.querySelector('#bn-export-closure-sku');
    const btnPrintClosure = root.querySelector('#bn-print-closure');
    const btnClose = root.querySelector('#bn-close-inv');
    const btnCancel = root.querySelector('#bn-cancel-inv');
    const btnClearCounts = root.querySelector('#bn-clear-counts');
    const btnReload = root.querySelector('#bn-reload-items');
    const btnExportCounts = root.querySelector('#bn-export-counts');
    const summaryPanel = root.querySelector('#inv-summary-panel');
    const countPanel = root.querySelector('#count-panel');
    const simSummary = root.querySelector('#sim-summary-panel');
    const itemsPanel = root.querySelector('#inv-items-panel');
    const scopeFilter = root.querySelector('#scope-filter-panel');
    if (actionsPanel) actionsPanel.style.display = '';
    if (scopeFilter) scopeFilter.style.display = 'none';
    $cf923db1bbff9a34$var$_lockIdentificationFields(root, vals.status ?? 10);
    const sessionType = vals.session_type || '';
    const importPanel = root.querySelector('#inv-import-panel');
    const btnImport = root.querySelector('#bn-import-spreadsheet');
    const fileInput = root.querySelector('#import-file-input');
    const _updateImportPanel = (status)=>{
        if (!importPanel || sessionType !== 'import') return;
        importPanel.style.display = '';
        const canImport = status === 10;
        if (fileInput) fileInput.disabled = !canImport;
        if (btnImport) btnImport.disabled = !canImport || !fileInput?.files?.[0];
        const fb = root.querySelector('#import-feedback');
        if (fb && !canImport && !fb.textContent) fb.textContent = "Sess\xe3o j\xe1 congelada \u2014 n\xe3o \xe9 poss\xedvel importar nova planilha.";
    };
    const refresh = async ()=>{
        try {
            const res = await (0, $9VcS9.default).select_inventory_session(companyId, sessionId);
            if (!res.ok) {
                (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
                return;
            }
            const s = await res.json();
            $cf923db1bbff9a34$var$_lockIdentificationFields(root, s.status);
            const summary = await $cf923db1bbff9a34$var$_loadSummary(companyId, sessionId);
            _updateImportPanel(s.status);
            statusBadge.textContent = $cf923db1bbff9a34$var$STATUS_LABEL[s.status] || s.status;
            statusBadge.className = `badge ${$cf923db1bbff9a34$var$_badgeClass(s.status)}`;
            const pct = summary?.progress_percent ?? (s.total_items ? Math.round(s.finalized_items / s.total_items * 100) : 0);
            progressLabel.textContent = `${summary?.finalized_items ?? s.finalized_items ?? 0} / ${summary?.total_items ?? s.total_items ?? 0} itens finalizados (${pct}%)`;
            const open = [
                20,
                30,
                40
            ].includes(s.status);
            if (summaryPanel) summaryPanel.style.display = '';
            root.dataset.invBlindMode = [
                20,
                30
            ].includes(s.status) ? '1' : '';
            root.dataset.invCountsEditable = ![
                50,
                60
            ].includes(s.status) ? '1' : '';
            if (open || s.status === 50) await $cf923db1bbff9a34$var$_loadItems(companyId, sessionId, root.dataset.invItemFilter || 'all', ![
                50,
                60
            ].includes(s.status));
            else root._invItems = [];
            $cf923db1bbff9a34$var$_renderSummary(summary || {
                status_label: $cf923db1bbff9a34$var$STATUS_LABEL[s.status] || s.status,
                total_items: s.total_items || 0,
                finalized_items: s.finalized_items || 0,
                progress_percent: pct
            }, root._invItems || []);
            btnFreeze.style.display = s.status === 10 && s.session_type !== 'import' ? '' : 'none';
            btnUnfreeze.style.display = s.status === 20 ? '' : 'none';
            btnSimulate.style.display = summary?.can_simulate ?? s.status === 40 ? '' : 'none';
            btnPrintProgress.style.display = (summary?.total_items || 0) > 0 ? '' : 'none';
            btnPrintDivergences.style.display = (summary?.divergent_items || summary?.total_counts || 0) > 0 ? '' : 'none';
            btnPrintSim.style.display = s.simulation_snapshot ? '' : 'none';
            if (btnPrintSimSku) btnPrintSimSku.style.display = s.simulation_snapshot ? '' : 'none';
            if (btnExportSimSku) btnExportSimSku.style.display = s.simulation_snapshot ? '' : 'none';
            if (btnExportClosureSku) btnExportClosureSku.style.display = s.simulation_snapshot ? '' : 'none';
            btnPrintClosure.style.display = s.status === 50 ? '' : 'none';
            const jobBusy = [
                'running',
                'simulating'
            ].includes(s.close_job?.status);
            btnClose.style.display = (summary?.can_close ?? (s.status === 40 && s.simulation_snapshot)) && !jobBusy ? '' : 'none';
            const closeJob = s.close_job || null;
            if (closeJob?.status === 'running' || closeJob?.status === 'error' || closeJob?.status === 'simulating') {
                $cf923db1bbff9a34$var$_renderCloseJobPanel(root, {
                    ...closeJob,
                    progress_percent: closeJob.progress_percent ?? 0,
                    step_index: closeJob.step_index ?? 0,
                    total_steps: closeJob.total_steps ?? 0
                });
                if (closeJob.status === 'running' || closeJob.status === 'simulating') $cf923db1bbff9a34$var$_ensureCloseJobPolling(companyId, sessionId, root);
            } else if (closeJob?.status === 'done') $cf923db1bbff9a34$var$_renderCloseJobPanel(root, closeJob);
            else $cf923db1bbff9a34$var$_renderCloseJobPanel(root, {
                status: 'idle'
            });
            btnCancel.style.display = s.status === 10 ? '' : 'none';
            btnClearCounts.style.display = (summary?.total_counts || 0) > 0 && ![
                50,
                60
            ].includes(s.status) ? '' : 'none';
            btnReload.style.display = open || s.status === 50 ? '' : 'none';
            btnExportCounts.style.display = (summary?.total_counts || 0) > 0 ? '' : 'none';
            countPanel.style.display = [
                20,
                30
            ].includes(s.status) ? '' : 'none';
            const locOpsPanel = root.querySelector('#inv-location-ops-panel');
            if (locOpsPanel) locOpsPanel.style.display = [
                20,
                30
            ].includes(s.status) ? '' : 'none';
            itemsPanel.style.display = open || s.status === 50 ? '' : 'none';
            if (s.simulation_snapshot) {
                simSummary.style.display = '';
                const snap = typeof s.simulation_snapshot === 'string' ? JSON.parse(s.simulation_snapshot) : s.simulation_snapshot;
                const fmtQty = (n)=>Number(n || 0).toLocaleString('pt-BR');
                const fmtMoney = (n)=>{
                    const v = Number(n || 0);
                    const sign = v > 0 ? '+' : v < 0 ? "\u2212" : '';
                    return `${sign}R$ ${Math.abs(v).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`;
                };
                const creditQty = snap.total_credit_qty || 0;
                const debitQty = snap.total_debit_qty || 0;
                const netQty = snap.net_qty ?? creditQty - debitQty;
                const creditVal = snap.total_credit_value || 0;
                const debitVal = snap.total_debit_value || 0;
                const netVal = snap.net_value ?? creditVal - debitVal;
                root.querySelector('#sim-total').textContent = snap.total_items || 0;
                root.querySelector('#sim-credit').textContent = `sobras +${fmtQty(creditQty)} un. (${snap.credit_count || 0}) \xb7 ${fmtMoney(creditVal)}`;
                root.querySelector('#sim-debit').textContent = `faltas \u{2212}${fmtQty(debitQty)} un. (${snap.debit_count || 0}) \xb7 ${fmtMoney(-debitVal)}`;
                const netEl = root.querySelector('#sim-net');
                if (netEl) {
                    const netClass = netQty >= 0 ? 'sim-credit' : 'sim-debit';
                    netEl.className = netClass;
                    netEl.textContent = `Saldo l\xedquido: ${netQty >= 0 ? '+' : "\u2212"}${fmtQty(Math.abs(netQty))} un. \xb7 ${fmtMoney(netVal)}`;
                }
            } else simSummary.style.display = 'none';
        } catch (e) {
            (0, $jUNyh.notify)(String(e));
        }
    };
    root._invRefresh = refresh;
    if (isFirstBind) {
        btnFreeze.addEventListener('click', async ()=>{
            if (!confirm("Congelar este invent\xe1rio?")) return;
            const res = await (0, $9VcS9.default).freeze_inventory_session(companyId, sessionId, vals.scope_filter || null);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            (0, $jUNyh.notify)("Invent\xe1rio congelado com sucesso.", 'success');
            await refresh();
        });
        btnUnfreeze.addEventListener('click', async ()=>{
            if (!confirm("Descongelar este invent\xe1rio? Os itens congelados ser\xe3o removidos.")) return;
            const res = await (0, $9VcS9.default).unfreeze_inventory_session(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            (0, $jUNyh.notify)("Invent\xe1rio descongelado.", 'info');
            await refresh();
        });
        btnSimulate.addEventListener('click', async ()=>{
            if (!confirm("Gerar simula\xe7\xe3o de fechamento?")) return;
            btnSimulate.disabled = true;
            const prevLabel = btnSimulate.textContent;
            btnSimulate.textContent = "Simulando\u2026";
            try {
                const res = await (0, $9VcS9.default).simulate_inventory_close(companyId, sessionId);
                if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res), 'error');
                (0, $jUNyh.notify)("Simula\xe7\xe3o gerada com sucesso.", 'success');
                await refresh();
            } finally{
                btnSimulate.disabled = false;
                btnSimulate.textContent = prevLabel || 'Simular Fechamento';
            }
        });
        btnPrintProgress.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).print_inventory_progress(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, `acompanhamento-inv-${sessionId}.pdf`, 'application/pdf');
        });
        btnPrintDivergences.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).print_inventory_divergences(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, `divergencias-inv-${sessionId}.pdf`, 'application/pdf');
        });
        btnPrintSim.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).print_inventory_simulation(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, `simulacao-inv-${sessionId}.pdf`, 'application/pdf');
        });
        btnPrintSimSku?.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).print_inventory_simulation_by_sku(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, data.filename || `simulacao-sku-inv-${sessionId}.pdf`, data.mime_type || 'application/pdf');
        });
        btnExportSimSku?.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).export_inventory_simulation_by_sku(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, data.filename || `simulacao-sku-inv-${sessionId}.xlsx`, data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        });
        btnExportClosureSku?.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).export_inventory_closure_by_sku(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, data.filename || `saldo-sku-inv-${sessionId}.xlsx`, data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        });
        btnPrintClosure.addEventListener('click', async ()=>{
            const res = await (0, $9VcS9.default).print_inventory_closure(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            const data = await res.json();
            $cf923db1bbff9a34$var$_downloadBase64(data.content_base64, `fechamento-inv-${sessionId}.pdf`, 'application/pdf');
        });
        btnClose.addEventListener('click', ()=>{
            $cf923db1bbff9a34$var$_openCloseConfirmModal(async ()=>{
                await $cf923db1bbff9a34$var$_startInventoryCloseJob(companyId, sessionId, root);
            });
        });
        btnCancel.addEventListener('click', async ()=>{
            if (!confirm("Cancelar este invent\xe1rio?")) return;
            const res = await (0, $9VcS9.default).cancel_inventory_session(companyId, sessionId);
            if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
            (0, $jUNyh.notify)("Invent\xe1rio cancelado.", 'info');
            await refresh();
        });
        btnClearCounts.addEventListener('click', ()=>{
            $cf923db1bbff9a34$var$_openClearCountsConfirmModal(async ()=>{
                const res = await (0, $9VcS9.default).clear_inventory_counts(companyId, sessionId);
                if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
                (0, $jUNyh.notify)("Contagens canceladas. A sess\xe3o voltou para Criado e pode ser cancelada.", 'info');
                await refresh();
            });
        });
        btnReload.addEventListener('click', async ()=>{
            const canDel = root.dataset.invCountsEditable === '1' && root._invCanDeleteCounts !== false;
            await $cf923db1bbff9a34$var$_loadItems(companyId, sessionId, root.dataset.invItemFilter || 'all', canDel);
        });
        btnExportCounts.addEventListener('click', async ()=>$cf923db1bbff9a34$var$_exportInventoryCountsCsv(companyId, sessionId));
        root.querySelector('#inv-item-filters')?.addEventListener('click', async (ev)=>{
            const btn = ev.target.closest('button[data-filter]');
            if (!btn) return;
            root.dataset.invItemFilter = btn.dataset.filter || 'all';
            root.querySelectorAll('#inv-item-filters button').forEach((b)=>b.classList.toggle('active', b === btn));
            $cf923db1bbff9a34$var$_renderItemsFromCache(root);
        });
        root.querySelector('#inv-item-search')?.addEventListener('input', ()=>{
            $cf923db1bbff9a34$var$_renderItemsFromCache(root);
        });
        root.querySelector('#inv-items-table-container')?.addEventListener('click', async (ev)=>{
            const btn = ev.target.closest('button[data-delete-count-id]');
            if (btn) {
                const countId = btn.dataset.deleteCountId;
                if (!countId) return;
                if (!confirm(`Excluir a contagem #${countId}? Rodadas posteriores do mesmo item tamb\xe9m ser\xe3o removidas para manter a sequ\xeancia da contagem.`)) return;
                const res = await (0, $9VcS9.default).delete_inventory_count(companyId, sessionId, countId);
                if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
                const result = await res.json();
                (0, $jUNyh.notify)(result.message || "Contagem exclu\xedda.", "Invent\xe1rio");
                await refresh();
                return;
            }
            const fillBtn = ev.target.closest('button[data-fill-count-item]');
            if (fillBtn) {
                $cf923db1bbff9a34$var$_fillCountFormFromItem(fillBtn.dataset);
                document.querySelector('#inv-session #count-location-code')?.focus();
                return;
            }
            const skipBtn = ev.target.closest('button[data-skip-item-id]');
            if (skipBtn) {
                (0, $jUNyh.notify)("Pulo de item (skip) desativado. Conte o item ou use Encerrar posi\xe7\xe3o.", 'warning');
                return;
            }
        });
        $cf923db1bbff9a34$var$_bindLocationOpsPanel(root, companyId, sessionId, refresh);
        root.querySelector('#bn-save-count').addEventListener('click', async ()=>{
            const locationCode = root.querySelector('#count-location-code')?.value?.trim() || '';
            const sku = root.querySelector('#count-sku')?.value?.trim() || '';
            const lotNumber = root.querySelector('#count-lot-number')?.value?.trim() || '';
            const expirationDate = root.querySelector('#count-expiration-date')?.value || '';
            const qty = parseInt(root.querySelector('#count-qty')?.value || '-1', 10);
            const obs = root.querySelector('#count-obs')?.value || '';
            const feedback = root.querySelector('#count-feedback');
            if (!locationCode || !sku || !lotNumber || !expirationDate || qty < 0) {
                feedback.textContent = "Informe posi\xe7\xe3o, SKU, lote, validade e quantidade (>= 0).";
                feedback.style.color = '#dc2626';
                return;
            }
            const res = await (0, $9VcS9.default).register_inventory_count_web(companyId, sessionId, {
                location_code: locationCode,
                sku: sku,
                lot_number: lotNumber,
                expiration_date: expirationDate,
                quantity: qty,
                observation: obs,
                origin: 'web',
                idempotency_key: `web-${sessionId}-${locationCode}-${sku}-${lotNumber}-${expirationDate}-${qty}-${Date.now()}`
            });
            if (!res.ok) {
                feedback.textContent = await $cf923db1bbff9a34$var$_apiErrorText(res);
                feedback.style.color = '#dc2626';
                return;
            }
            const result = await res.json();
            feedback.textContent = `Salvo - ${result.item_status_label || result.item_status}`;
            feedback.style.color = '#16a34a';
            [
                '#count-location-code',
                '#count-sku',
                '#count-lot-number',
                '#count-expiration-date',
                '#count-qty',
                '#count-obs'
            ].forEach((selector)=>{
                const el = root.querySelector(selector);
                if (el) el.value = '';
            });
            await refresh();
        });
    }
    await refresh();
}
function $cf923db1bbff9a34$var$_badgeClass(status) {
    return ({
        20: 'badge-frozen',
        30: 'badge-counting',
        40: 'badge-ready',
        50: 'badge-closed',
        60: 'badge-cancelled'
    })[status] || '';
}
/**
 * Carrega o resumo operacional da sessão para o painel de acompanhamento.
 * @param {string} companyId
 * @param {number|string} sessionId
 * @returns {Promise<object|null>}
 */ async function $cf923db1bbff9a34$var$_loadSummary(companyId, sessionId) {
    const res = await (0, $9VcS9.default).inventory_session_summary(companyId, sessionId);
    if (!res.ok) return null;
    return await res.json();
}
/**
 * Indica contagem originada do encerramento de posição no coletor.
 * @param {object} count
 */ function $cf923db1bbff9a34$var$_isCloseLocationCount(count) {
    return String(count?.observation || '').startsWith($cf923db1bbff9a34$var$CLOSE_LOCATION_PREFIX);
}
/**
 * Indica item com ao menos uma contagem de encerramento de posição.
 * @param {object} item
 */ function $cf923db1bbff9a34$var$_itemHasCloseLocationCount(item) {
    return (item?.counts || []).some($cf923db1bbff9a34$var$_isCloseLocationCount);
}
/**
 * Estatísticas de encerramento de posição a partir dos itens em cache.
 * @param {object[]} items
 */ function $cf923db1bbff9a34$var$_closeLocationStatsFromItems(items) {
    let counts = 0;
    let recount = 0;
    for (const item of items || []){
        const hasClose = $cf923db1bbff9a34$var$_itemHasCloseLocationCount(item);
        counts += (item.counts || []).filter($cf923db1bbff9a34$var$_isCloseLocationCount).length;
        if (hasClose && (item.count_status === 'count2_needed' || item.count_status === 'count3_needed')) recount += 1;
    }
    return {
        counts: counts,
        recount: recount
    };
}
/**
 * Rótulo de status com destaque para falta física (encerrar posição).
 * @param {object} item
 */ function $cf923db1bbff9a34$var$_formatItemStatusLabel(item) {
    if (!$cf923db1bbff9a34$var$_itemHasCloseLocationCount(item)) return $cf923db1bbff9a34$var$COUNT_STATUS_LABEL[item.count_status] || item.count_status;
    if (item.count_status === 'count2_needed') return '<span class="inv-status-shortage">Falta f\xedsica \u2014 aguard. 2\xaa</span>';
    if (item.count_status === 'count3_needed') return '<span class="inv-status-shortage">Falta f\xedsica \u2014 aguard. 3\xaa</span>';
    if (item.count_status === 'finalized') return '<span class="inv-status-shortage-done">Falta f\xedsica \u2014 finalizado</span>';
    const base = $cf923db1bbff9a34$var$COUNT_STATUS_LABEL[item.count_status] || item.count_status;
    return `<span class="inv-status-shortage">${base}</span>`;
}
/**
 * Renderiza cards e barra percentual do acompanhamento do inventário.
 * @param {object} summary
 * @param {object[]} [items]
 */ function $cf923db1bbff9a34$var$_renderSummary(summary, items = []) {
    const fill = document.querySelector('#inv-session #inv-progress-fill');
    const cards = document.querySelector('#inv-session #inv-summary-cards');
    const last = document.querySelector('#inv-session #inv-last-count');
    const hint = document.querySelector('#inv-session #inv-close-location-hint');
    const pct = Math.max(0, Math.min(100, Number(summary?.progress_percent || 0)));
    const closeStats = summary?.close_location_counts != null ? {
        counts: summary.close_location_counts,
        recount: summary.close_location_recount_items || 0
    } : $cf923db1bbff9a34$var$_closeLocationStatsFromItems(items);
    if (fill) fill.style.width = `${pct}%`;
    if (cards) {
        const cardData = [
            [
                'Status',
                summary?.status_label || '-'
            ],
            [
                'Progresso',
                `${pct}%`
            ],
            [
                'Finalizados',
                `${summary?.finalized_items || 0} / ${summary?.total_items || 0}`
            ],
            [
                'Pendentes',
                summary?.pending_items || 0
            ],
            [
                "2\xaa contagem",
                summary?.count2_needed_items || 0
            ],
            [
                "3\xaa contagem",
                summary?.count3_needed_items || 0
            ],
            [
                "Diverg\xeancias",
                summary?.divergent_items || 0
            ],
            [
                'Contagens',
                summary?.total_counts || 0
            ]
        ];
        if (closeStats.counts > 0) cardData.push([
            "Encerr. posi\xe7\xe3o",
            closeStats.counts
        ]);
        cards.innerHTML = cardData.map(([label, value])=>`
			<div class="inv-card${label === "Encerr. posi\xe7\xe3o" ? ' inv-card-close' : ''}">
				<div class="label">${label}</div>
				<div class="value">${value}</div>
			</div>`).join('');
    }
    if (hint) {
        if (closeStats.recount > 0) {
            hint.style.display = '';
            hint.textContent = `${closeStats.recount} item(ns) com falta f\xedsica registrada \u{2014} aguardam 2\xaa ou 3\xaa contagem por outro operador. Use opera\xe7\xf5es por posi\xe7\xe3o ou contagem cega.`;
        } else if (closeStats.counts > 0) {
            hint.style.display = '';
            hint.textContent = "Encerramento de posi\xe7\xe3o registrado pelo coletor (falta f\xedsica).";
        } else {
            hint.style.display = 'none';
            hint.textContent = '';
        }
    }
    if (last) {
        const c = summary?.latest_count;
        if (!c) last.textContent = 'Nenhuma contagem registrada ainda.';
        else {
            const closeTag = c.is_close_location || $cf923db1bbff9a34$var$_isCloseLocationCount(c) ? " | encerramento de posi\xe7\xe3o (falta f\xedsica)" : '';
            const obs = c.observation ? ` | ${c.observation}` : '';
            last.textContent = `\xdaltima contagem: ${c.counted_by_login || c.counted_by || '-'} | rodada ${c.round} | qtd ${c.quantity}${closeTag} | ${$cf923db1bbff9a34$var$_fmtDateTime(c.counted_on)}${obs}`;
        }
    }
}
/**
 * Carrega itens do escopo aplicando o filtro operacional selecionado.
 * @param {string} companyId
 * @param {number|string} sessionId
 * @param {string} filter
 */ async function $cf923db1bbff9a34$var$_loadItems(companyId, sessionId, filter = 'all', canDeleteCounts = null) {
    const container = document.querySelector('#inv-session #inv-items-table-container');
    if (!container) return;
    container.innerHTML = '<p style="color:#999; font-size:0.8rem;">Carregando...</p>';
    const res = await (0, $9VcS9.default).list_inventory_session_items(companyId, sessionId);
    if (!res.ok) {
        container.innerHTML = '<p style="color:#c00;">Erro ao carregar itens.</p>';
        return;
    }
    const items = await res.json();
    const root = document.querySelector('#inv-session');
    if (root) {
        root._invItems = items;
        root._invCanDeleteCounts = canDeleteCounts;
    }
    $cf923db1bbff9a34$var$_renderItemsFromCache(root, filter);
}
function $cf923db1bbff9a34$var$_renderItemsFromCache(root, filter = null) {
    root = root || document.querySelector('#inv-session');
    const container = root?.querySelector('#inv-items-table-container');
    if (!root || !container) return;
    const currentFilter = filter || root.dataset.invItemFilter || 'all';
    root.dataset.invItemFilter = currentFilter;
    const query = root.querySelector('#inv-item-search')?.value || '';
    const items = root._invItems || [];
    const allowDelete = root.dataset.invCountsEditable === '1' && root._invCanDeleteCounts !== false;
    const canAct = root.dataset.invCountsEditable === '1';
    container.innerHTML = $cf923db1bbff9a34$var$_buildItemsTable(items, currentFilter, root.dataset.invBlindMode === '1', allowDelete, canAct, query);
}
function $cf923db1bbff9a34$var$_fillCountFormFromItem(dataset) {
    const root = document.querySelector('#inv-session');
    if (!root) return;
    const set = (sel, val)=>{
        const el = root.querySelector(sel);
        if (el && val != null && val !== '') el.value = val;
    };
    set('#count-location-code', dataset.locationCode);
    set('#count-sku', dataset.productSku);
    set('#count-lot-number', dataset.lotNumber);
    if (dataset.lotExpiration) {
        const raw = String(dataset.lotExpiration).trim();
        const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
        const br = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
        if (iso) set('#count-expiration-date', `${iso[1]}-${iso[2]}-${iso[3]}`);
        else if (br) set('#count-expiration-date', `${br[3]}-${br[2]}-${br[1]}`);
    }
    set('#loc-ops-code', dataset.locationCode);
    const fb = root.querySelector('#count-feedback');
    if (fb) {
        fb.textContent = 'Campos preenchidos a partir da linha selecionada.';
        fb.style.color = '#64748b';
    }
}
function $cf923db1bbff9a34$var$_buildItemActionsCell(item, canAct) {
    if (!canAct) return '<span style="color:#94a3b8;">\u2014</span>';
    const parts = [];
    const loc = item.location_code || '';
    const exp = item.lot_expiration_date || '';
    const ds = [
        `data-fill-count-item="1"`,
        `data-location-code="${$cf923db1bbff9a34$var$_escAttr(loc)}"`,
        `data-product-sku="${$cf923db1bbff9a34$var$_escAttr(item.product_sku || '')}"`,
        `data-lot-number="${$cf923db1bbff9a34$var$_escAttr(item.lot_number || '')}"`,
        `data-lot-expiration="${$cf923db1bbff9a34$var$_escAttr(exp)}"`
    ].join(' ');
    if ([
        'pending',
        'count2_needed',
        'count3_needed',
        'count1_done'
    ].includes(item.count_status)) parts.push(`<button type="button" class="bn-action bn-primary inv-btn-ghost" ${ds}>Contar</button>`);
    if (!parts.length) return '<span style="color:#94a3b8;">\u2014</span>';
    return `<div class="inv-row-actions">${parts.join('')}</div>`;
}
function $cf923db1bbff9a34$var$_escAttr(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}
function $cf923db1bbff9a34$var$_bindLocationOpsPanel(root, companyId, sessionId, refresh) {
    if (root.dataset.locOpsBound === '1') return;
    root.dataset.locOpsBound = '1';
    const previewEl = root.querySelector('#inv-loc-ops-preview');
    const locInput = root.querySelector('#loc-ops-code');
    let pendingOp = null;
    const hidePreview = ()=>{
        pendingOp = null;
        if (previewEl) {
            previewEl.style.display = 'none';
            previewEl.innerHTML = '';
            previewEl.className = 'inv-loc-ops-preview';
        }
    };
    const showPreview = (html, variant = '')=>{
        if (!previewEl) return;
        previewEl.style.display = '';
        previewEl.className = `inv-loc-ops-preview${variant ? ` ${variant}` : ''}`;
        previewEl.innerHTML = html;
    };
    const locCode = ()=>(locInput?.value || root.querySelector('#count-location-code')?.value || '').trim();
    const buildPreviewLists = (data)=>{
        const missing = data.missing_items || [];
        const recount = data.recount_items || [];
        const found = data.found_items || [];
        const blocks = [];
        if (missing.length) blocks.push(`<p><b>${missing.length}</b> item(ns) pendente(s) como <b>falta f\xedsica</b> (qty 0):</p>` + `<ul>${missing.map((r)=>`<li>SKU ${$cf923db1bbff9a34$var$_escHtml(r.product_sku || "\u2014")}</li>`).join('')}</ul>`);
        if (recount.length) {
            const round = recount[0]?.round || 2;
            blocks.push(`<p><b>${recount.length}</b> item(ns) para <b>confirmar falta</b> na ${round}\xaa contagem:</p>` + `<ul>${recount.slice(0, 8).map((r)=>`<li>SKU ${$cf923db1bbff9a34$var$_escHtml(r.product_sku)}</li>`).join('')}` + `${recount.length > 8 ? `<li>\u{2026} e mais ${recount.length - 8}</li>` : ''}</ul>` + `<p style="color:#b45309;font-size:0.78rem;">Use outro operador que n\xe3o registrou a 1\xaa falta.</p>`);
        }
        if (found.length || data.pending_placeholder) blocks.push(`<p><b>${found.length || 0}</b> achado(s) ir\xe3o para <b>2\xaa contagem</b> por outro operador:</p>` + `<ul>${found.map((r)=>`<li>SKU ${$cf923db1bbff9a34$var$_escHtml(r.product_sku)} \u{2014} lote ${$cf923db1bbff9a34$var$_escHtml(r.lot_number || "\u2014")}</li>`).join('') || "<li>Placeholder de posi\xe7\xe3o vazia</li>"}</ul>`);
        return blocks.join('');
    };
    root.querySelector('#bn-loc-complete-preview')?.addEventListener('click', async ()=>{
        const code = locCode();
        if (!code) return (0, $jUNyh.notify)("Informe a posi\xe7\xe3o.");
        hidePreview();
        const res = await (0, $9VcS9.default).inventory_complete_location_preview(companyId, sessionId, code);
        if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
        const data = await res.json();
        if (data.blocked_reason) {
            showPreview(`<strong>Encerrar posi\xe7\xe3o</strong><p>${$cf923db1bbff9a34$var$_escHtml(data.blocked_reason)}</p>`, 'info');
            return;
        }
        const action = data.action || 'none';
        if (action === 'none') {
            showPreview("<strong>Encerrar posi\xe7\xe3o</strong><p>Nada a encerrar nesta posi\xe7\xe3o.</p>", 'info');
            return;
        }
        pendingOp = {
            type: 'complete',
            code: code,
            action: action
        };
        const variant = (data.missing_items || []).length || (data.recount_items || []).length ? 'warn' : 'info';
        showPreview(`<strong>Encerrar posi\xe7\xe3o ${$cf923db1bbff9a34$var$_escHtml(code)}</strong>
			<p>${$cf923db1bbff9a34$var$_escHtml(data.summary_message || 'Confirme o encerramento.')}</p>
			${buildPreviewLists(data)}
			<div class="inv-loc-ops-actions">
				<button type="button" class="bn-action bn-warn" data-loc-op-confirm="complete">Confirmar encerramento</button>
				<button type="button" class="bn-action inv-btn-ghost" data-loc-op-cancel>Cancelar</button>
			</div>`, variant);
    });
    previewEl?.addEventListener('click', async (ev)=>{
        if (ev.target.closest('[data-loc-op-cancel]')) {
            hidePreview();
            return;
        }
        const btn = ev.target.closest('[data-loc-op-confirm]');
        if (!btn || !pendingOp) return;
        const code = pendingOp.code;
        hidePreview();
        const res = await (0, $9VcS9.default).inventory_complete_location(companyId, sessionId, code);
        if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
        const data = await res.json();
        (0, $jUNyh.notify)(data.message || "Posi\xe7\xe3o encerrada.", 'success');
        await refresh();
    });
}
function $cf923db1bbff9a34$var$_escHtml(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $cf923db1bbff9a34$var$_buildItemsTable(items, filter = 'all', blindMode = false, canDeleteCounts = false, canAct = false, query = '') {
    if (!items || !items.length) return '<p style="color:#999; font-size:0.8rem;">Nenhum item no escopo.</p>';
    const normQuery = $cf923db1bbff9a34$var$_normalizeSearch(query);
    const filtered = items.filter((item)=>$cf923db1bbff9a34$var$_itemMatchesFilter(item, filter) && $cf923db1bbff9a34$var$_itemMatchesSearch(item, normQuery));
    $cf923db1bbff9a34$var$_updateItemsCount(filtered.length, items.length);
    if (!filtered.length) return '<p style="color:#999; font-size:0.8rem;">Nenhum item neste filtro.</p>';
    const rows = filtered.map((item)=>{
        const isDivergent = item.count_status === 'count2_needed' || item.count_status === 'count3_needed';
        const cls = item.count_status === 'finalized' ? 'finalized' : isDivergent ? 'divergent' : '';
        const statusLabel = $cf923db1bbff9a34$var$_formatItemStatusLabel(item);
        const actions = $cf923db1bbff9a34$var$_buildItemActionsCell(item, canAct);
        if (blindMode) return `<tr class="${cls}">
			<td class="inv-col-id">${item.id}</td>
			<td class="inv-col-pos">${item.location_code || '-'}</td>
			<td class="inv-col-status">${statusLabel}</td>
			<td class="inv-col-count">${$cf923db1bbff9a34$var$_buildCountRoundCell(item.counts || [], 1)}</td>
			<td class="inv-col-count">${$cf923db1bbff9a34$var$_buildCountRoundCell(item.counts || [], 2)}</td>
			<td class="inv-col-count">${$cf923db1bbff9a34$var$_buildCountRoundCell(item.counts || [], 3)}</td>
			<td class="inv-col-details">${$cf923db1bbff9a34$var$_buildCountDetails(item.counts || [], canDeleteCounts)}</td>
			<td class="inv-col-actions">${actions}</td>
		</tr>`;
        return `<tr class="${cls}">
			<td class="inv-col-id">${item.id}</td>
			<td class="inv-col-pos">${item.location_code || '-'}</td>
			<td class="inv-col-sku">${item.product_sku || '-'}</td>
			<td class="inv-col-prod">${item.product_name || '-'}</td>
			<td class="inv-col-lot">${item.lot_number || '-'}</td>
			<td class="inv-col-num">${item.frozen_qty_total}</td>
			<td class="inv-col-num">${item.final_qty ?? '-'}</td>
			<td class="inv-col-status">${statusLabel}</td>
			<td class="inv-col-count">${$cf923db1bbff9a34$var$_buildCountRoundCell(item.counts || [], 1)}</td>
			<td class="inv-col-count">${$cf923db1bbff9a34$var$_buildCountRoundCell(item.counts || [], 2)}</td>
			<td class="inv-col-count">${$cf923db1bbff9a34$var$_buildCountRoundCell(item.counts || [], 3)}</td>
			<td class="inv-col-details">${$cf923db1bbff9a34$var$_buildCountDetails(item.counts || [], canDeleteCounts)}</td>
			<td class="inv-col-actions">${actions}</td>
		</tr>`;
    }).join('');
    if (blindMode) return `<p style="font-size:.76rem; color:#64748b; margin:4px 0;">Modo cego ativo: SKU, lote, validade e saldo esperado n\xe3o s\xe3o exibidos durante a contagem.</p>
		<table>
		<thead><tr>
			<th class="inv-col-id">ID</th><th class="inv-col-pos">Posi\xe7\xe3o</th><th class="inv-col-status">Status</th><th class="inv-col-count">1\xaa Contagem</th><th class="inv-col-count">2\xaa Contagem</th><th class="inv-col-count">3\xaa Contagem</th><th class="inv-col-details">Digitado / Obs.</th><th class="inv-col-actions">A\xe7\xf5es</th>
		</tr></thead>
		<tbody>${rows}</tbody>
	</table>`;
    return `<table>
		<thead><tr>
			<th class="inv-col-id">ID</th><th class="inv-col-pos">Posi\xe7\xe3o</th><th class="inv-col-sku">SKU</th><th class="inv-col-prod">Produto</th>
			<th class="inv-col-lot">Lote</th><th class="inv-col-num">Saldo</th><th class="inv-col-num">Final</th><th class="inv-col-status">Status</th><th class="inv-col-count">1\xaa Contagem</th><th class="inv-col-count">2\xaa Contagem</th><th class="inv-col-count">3\xaa Contagem</th><th class="inv-col-details">Digitado / Obs.</th><th class="inv-col-actions">A\xe7\xf5es</th>
		</tr></thead>
		<tbody>${rows}</tbody>
	</table>`;
}
/**
 * Verifica se um item pertence ao filtro visual escolhido pelo gestor.
 * @param {object} item
 * @param {string} filter
 */ function $cf923db1bbff9a34$var$_itemMatchesFilter(item, filter) {
    if (filter === 'pending') return ![
        'finalized',
        'count2_needed',
        'count3_needed'
    ].includes(item.count_status);
    if (filter === 'count2') return item.count_status === 'count2_needed';
    if (filter === 'count3') return item.count_status === 'count3_needed';
    if (filter === 'finalized') return item.count_status === 'finalized';
    if (filter === 'divergent') return item.count_status === 'count2_needed' || item.count_status === 'count3_needed';
    if (filter === 'close_location') return $cf923db1bbff9a34$var$_itemHasCloseLocationCount(item);
    return true;
}
function $cf923db1bbff9a34$var$_itemMatchesSearch(item, normQuery) {
    if (!normQuery) return true;
    return $cf923db1bbff9a34$var$_normalizeSearch($cf923db1bbff9a34$var$_itemSearchText(item)).includes(normQuery);
}
function $cf923db1bbff9a34$var$_itemSearchText(item) {
    const countText = (item.counts || []).map((c)=>[
            c.id,
            c.round,
            c.quantity,
            c.counted_by_login,
            c.counted_by,
            c.counted_on,
            c.origin,
            c.device_id,
            c.observation,
            c.input_location_code,
            c.input_product_sku,
            c.input_lot_number,
            c.input_expiration_date,
            c.validation_status,
            c.validation_message
        ].filter((v)=>v !== null && v !== undefined).join(' ')).join(' ');
    return [
        item.id,
        item.location_code,
        item.product_sku,
        item.product_name,
        item.lot_number,
        item.unit_name,
        item.frozen_qty_available,
        item.frozen_qty_reserved,
        item.frozen_qty_blocked,
        item.frozen_qty_total,
        item.final_qty,
        item.count_status,
        $cf923db1bbff9a34$var$COUNT_STATUS_LABEL[item.count_status],
        countText
    ].filter((v)=>v !== null && v !== undefined).join(' ');
}
function $cf923db1bbff9a34$var$_normalizeSearch(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}
function $cf923db1bbff9a34$var$_updateItemsCount(filtered, total) {
    const el = document.querySelector('#inv-session #inv-items-count');
    if (!el) return;
    el.textContent = filtered === total ? `${total} item(ns)` : `${filtered} de ${total} item(ns)`;
}
/**
 * Monta o histórico de contagens exibido na tabela de acompanhamento.
 * @param {object[]} counts
 * @param {boolean} canDelete
 */ function $cf923db1bbff9a34$var$_buildCountHistory(counts, canDelete = false) {
    if (!counts.length) return '<span style="color:#94a3b8;">Sem contagem</span>';
    return `<div class="count-history">${counts.map((c)=>`
		<div>
			<strong>${c.round}\xaa</strong>: ${c.quantity}
			<span style="color:#64748b;">por ${c.counted_by_login || c.counted_by || '-'} em ${$cf923db1bbff9a34$var$_fmtDateTime(c.counted_on)} (${c.origin || 'web'})</span>
			${canDelete && c.id ? `<button type="button" class="bn-action bn-danger" data-delete-count-id="${c.id}" style="padding:1px 6px; font-size:.68rem; margin-left:6px;">Excluir</button>` : ''}
			${$cf923db1bbff9a34$var$_buildCountTypedData(c)}
			${c.validation_status === 'divergent' ? `<br><span style="color:#b45309;">Diverg\xeancia registrada: ${c.validation_message || 'dados digitados divergentes'}</span>` : ''}
			${c.observation ? `<br><em>${c.observation}</em>` : ''}
		</div>`).join('')}</div>`;
}
function $cf923db1bbff9a34$var$_buildCountRoundCell(counts, roundNumber) {
    const count = (counts || []).find((c)=>Number(c.round) === Number(roundNumber));
    if (!count) return '<div class="count-round-cell"><span class="empty">N\xe3o realizada</span></div>';
    const user = count.counted_by_login || count.counted_by || '-';
    const origin = count.origin || 'web';
    const divergent = count.validation_status === 'divergent' ? `<div class="meta" style="color:#b45309;">${count.validation_message || "Diverg\xeancia"}</div>` : '';
    const closeTag = $cf923db1bbff9a34$var$_isCloseLocationCount(count) ? '<span class="inv-close-tag">Encerrar posi\xe7\xe3o</span>' : '';
    return `<div class="count-round-cell">
		<div class="qty">Qtd ${count.quantity}</div>
		${closeTag}
		<div class="meta">${user}</div>
		<div class="meta">${$cf923db1bbff9a34$var$_fmtDateTime(count.counted_on)} (${origin})</div>
		${divergent}
	</div>`;
}
function $cf923db1bbff9a34$var$_buildCountDetails(counts, canDelete = false) {
    if (!counts?.length) return '<span style="color:#94a3b8;">\u2014</span>';
    return `<div class="count-details">${counts.map((c)=>{
        const typed = $cf923db1bbff9a34$var$_buildCountTypedData(c);
        const divergence = c.validation_status === 'divergent' ? `<br><span style="color:#b45309;">Diverg\xeancia: ${c.validation_message || 'dados divergentes'}</span>` : '';
        const closeTag = $cf923db1bbff9a34$var$_isCloseLocationCount(c) ? '<br><span class="inv-close-tag">Falta f\xedsica (encerrar posi\xe7\xe3o)</span>' : '';
        const observation = c.observation ? `<br><em>${c.observation}</em>` : '';
        const del = canDelete && c.id ? ` <button type="button" class="bn-action bn-danger" data-delete-count-id="${c.id}" style="padding:1px 6px; font-size:.68rem; margin-left:4px;">Excluir</button>` : '';
        return `<div><strong>${c.round}\xaa</strong>${typed || " \u2014"}${del}${divergence}${closeTag}${observation}</div>`;
    }).join('')}</div>`;
}
function $cf923db1bbff9a34$var$_fmtBrDate(value) {
    if (!value) return '';
    const raw = String(value).trim();
    const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
    const br = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (br) return `${br[1]}/${br[2]}/${br[3]}`;
    return raw.substring(0, 10);
}
function $cf923db1bbff9a34$var$_buildCountTypedData(count) {
    const parts = [
        count.input_location_code ? `pos ${count.input_location_code}` : '',
        count.input_product_sku ? `SKU ${count.input_product_sku}` : '',
        count.input_lot_number ? `lote ${count.input_lot_number}` : '',
        count.input_expiration_date ? `validade ${$cf923db1bbff9a34$var$_fmtBrDate(count.input_expiration_date)}` : ''
    ].filter(Boolean);
    return parts.length ? `<br><span style="color:#475569;">Digitado: ${parts.join(' | ')}</span>` : '';
}
/**
 * Formata datas recebidas da API para exibição operacional.
 * @param {string} value
 */ function $cf923db1bbff9a34$var$_fmtDateTime(value) {
    if (!value) return '-';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value).replace('T', ' ').substring(0, 16);
    return d.toLocaleString('pt-BR');
}
async function $cf923db1bbff9a34$var$_exportInventoryCountsCsv(companyId, sessionId) {
    const root = document.querySelector('#inv-session');
    let items = root?._invItems || [];
    if (!items.length) {
        const res = await (0, $9VcS9.default).list_inventory_session_items(companyId, sessionId);
        if (!res.ok) return (0, $jUNyh.notify)(await $cf923db1bbff9a34$var$_apiErrorText(res));
        items = await res.json();
        if (root) root._invItems = items;
    }
    const rows = [];
    for (const item of items)for (const count of item.counts || [])rows.push({
        session_id: sessionId,
        scope_item_id: item.id,
        location_code: item.location_code || '',
        product_sku: item.product_sku || '',
        product_name: item.product_name || '',
        lot_number: item.lot_number || '',
        unit_name: item.unit_name || '',
        frozen_qty_total: item.frozen_qty_total ?? '',
        final_qty: item.final_qty ?? '',
        item_status: $cf923db1bbff9a34$var$COUNT_STATUS_LABEL[item.count_status] || item.count_status || '',
        count_id: count.id ?? '',
        round: count.round ?? '',
        quantity: count.quantity ?? '',
        counted_by: count.counted_by_login || count.counted_by || '',
        counted_on: $cf923db1bbff9a34$var$_fmtCsvDateTime(count.counted_on),
        origin: count.origin || '',
        device_id: count.device_id || '',
        input_location_code: count.input_location_code || '',
        input_product_sku: count.input_product_sku || '',
        input_lot_number: count.input_lot_number || '',
        input_expiration_date: $cf923db1bbff9a34$var$_fmtBrDate(count.input_expiration_date),
        validation_status: count.validation_status || '',
        validation_message: count.validation_message || '',
        observation: count.observation || ''
    });
    if (!rows.length) return (0, $jUNyh.notify)('Nenhuma contagem registrada para exportar.', "Invent\xe1rio");
    const headers = [
        [
            'session_id',
            "Sess\xe3o"
        ],
        [
            'scope_item_id',
            'Item'
        ],
        [
            'location_code',
            "Posi\xe7\xe3o"
        ],
        [
            'product_sku',
            'SKU'
        ],
        [
            'product_name',
            'Produto'
        ],
        [
            'lot_number',
            'Lote'
        ],
        [
            'unit_name',
            'Unidade'
        ],
        [
            'frozen_qty_total',
            'Saldo congelado'
        ],
        [
            'final_qty',
            'Quantidade final'
        ],
        [
            'item_status',
            'Status do item'
        ],
        [
            'count_id',
            'Contagem ID'
        ],
        [
            'round',
            'Rodada'
        ],
        [
            'quantity',
            'Quantidade contada'
        ],
        [
            'counted_by',
            'Operador'
        ],
        [
            'counted_on',
            'Data/hora'
        ],
        [
            'origin',
            'Origem'
        ],
        [
            'device_id',
            'Dispositivo'
        ],
        [
            'input_location_code',
            "Posi\xe7\xe3o digitada"
        ],
        [
            'input_product_sku',
            'SKU digitado'
        ],
        [
            'input_lot_number',
            'Lote digitado'
        ],
        [
            'input_expiration_date',
            'Validade digitada'
        ],
        [
            'validation_status',
            "Valida\xe7\xe3o"
        ],
        [
            'validation_message',
            "Mensagem valida\xe7\xe3o"
        ],
        [
            'observation',
            "Observa\xe7\xe3o"
        ]
    ];
    const csv = [
        headers.map(([, label])=>$cf923db1bbff9a34$var$_csvCell(label)).join(';'),
        ...rows.map((row)=>headers.map(([key])=>$cf923db1bbff9a34$var$_csvCell(row[key])).join(';'))
    ].join('\r\n');
    $cf923db1bbff9a34$var$_downloadTextFile(`\uFEFF${csv}`, `inventario-${sessionId}-contagens.csv`, 'text/csv;charset=utf-8');
}
function $cf923db1bbff9a34$var$_fmtCsvDateTime(value) {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value).replace('T', ' ').substring(0, 19);
    return d.toLocaleString('pt-BR');
}
function $cf923db1bbff9a34$var$_csvCell(value) {
    let text = String(value ?? '');
    if (/^[=+\-@]/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
}
function $cf923db1bbff9a34$var$_downloadTextFile(content, filename, mime) {
    const blob = new Blob([
        content
    ], {
        type: mime
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
function $cf923db1bbff9a34$var$_downloadBase64(b64, filename, mime) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mime
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
/**
 * Extrai uma mensagem operacional legível de respostas de erro da API.
 * @param {Response} response
 * @returns {Promise<string>}
 */ async function $cf923db1bbff9a34$var$_apiErrorText(response) {
    const text = await response.text();
    const clean = String(text || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    return clean || `Falha na API de invent\xe1rio (HTTP ${response.status}).`;
}
/**
 * Faz parsing de CSV com separador ';'.
 * Aceita arquivos com ou sem BOM UTF-8. Retorna array de objetos com as chaves do cabeçalho.
 * @param {string} text
 * @returns {{ sku: string, lot_number: string, location_code: string, warehouse_code: string, quantity_expected: string }[]}
 */ function $cf923db1bbff9a34$var$_parseCsv(text) {
    // Remove BOM caso presente
    const clean = text.replace(/^\uFEFF/, '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    const lines = clean.split('\n').filter((l)=>l.trim() !== '');
    if (lines.length < 2) return [];
    const headers = lines[0].split(';').map((h)=>h.trim().toLowerCase());
    const rows = [];
    for(let i = 1; i < lines.length; i++){
        const cells = lines[i].split(';').map((c)=>c.trim());
        const row = {};
        headers.forEach((h, idx)=>{
            row[h] = cells[idx] ?? '';
        });
        // Garante campos numéricos como string (a API aceita string ou number)
        rows.push(row);
    }
    return rows;
}
/**
 * Monta HTML com o resumo do resultado da importação.
 * @param {{ accepted: number, errors: {row: number, message: string}[], total: number }} result
 */ function $cf923db1bbff9a34$var$_buildImportResult(result) {
    const accepted = result?.accepted ?? result?.rows_imported ?? 0;
    const total = result?.total ?? result?.rows_read ?? 0;
    const errors = result?.errors ?? [];
    let html = `<div style="margin-bottom:6px;">
		<strong style="color:#16a34a;">${accepted} linha(s) aceita(s)</strong>
		${total ? ` de ${total} lidas` : ''}
		${errors.length ? ` \u{2014} <strong style="color:#dc2626;">${errors.length} erro(s)</strong>` : ''}
	</div>`;
    if (errors.length) {
        const rows = errors.map((e)=>`<tr class="row-err"><td>${e.row ?? '-'}</td><td>${e.message || e.error || String(e)}</td></tr>`).join('');
        html += `<table>
			<thead><tr><th>Linha</th><th>Erro</th></tr></thead>
			<tbody>${rows}</tbody>
		</table>`;
    } else html += '<span style="color:#16a34a;">Importa\xe7\xe3o conclu\xedda sem erros.</span>';
    return html;
}



var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
const $a856b19a551476c1$var$inventorySessions = function() {
    const inv_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        _lastRows: null,
        _lastFilterKey: null,
        async loadBaseData () {
            try {
                const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll());
                await (0, $1cmSR.default).set('companies', data);
                await this._bootstrapCompanyFilter();
            } catch (err) {
                (0, $jUNyh.notify)(err);
            }
        },
        async editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = data;
            this._lastRows = null;
            this._lastFilterKey = null;
            const companyId = this._resolveCompanyIdFromFilter();
            if (companyId) this._persistCompanyFilter(companyId);
            await this.loadPage(1);
        },
        _persistCompanyFilter (companyId) {
            try {
                localStorage.setItem('inventory-sessions.company_id', String(companyId));
            } catch (_) {}
        },
        _setCompanyFilter (companyId) {
            if (!companyId) return;
            this.filter = {
                'field-0': 'company_id',
                'operator-0': 'eq',
                'value-0': String(companyId)
            };
            this.filterExplicitlyApplied = true;
            this._persistCompanyFilter(companyId);
            this._lastRows = null;
            this._lastFilterKey = null;
        },
        /** Define filtro de empresa na abertura (última usada ou empresa única). */ async _bootstrapCompanyFilter () {
            if (this._resolveCompanyIdFromFilter()) return;
            let companyId = null;
            try {
                companyId = localStorage.getItem('inventory-sessions.company_id');
            } catch (_) {}
            if (!companyId) {
                const companies = await (0, $1cmSR.default).list('companies') || [];
                const active = companies.filter((c)=>!c.is_disabled);
                if (active.length === 1) companyId = active[0].id;
            }
            if (companyId) this._setCompanyFilter(companyId);
        },
        _resolveCompanyIdFromFilter () {
            for(let i = 0; i < 10; i++)if (this.filter?.[`field-${i}`] === 'company_id') {
                const v = this.filter?.[`value-${i}`];
                return v && String(v).trim() ? String(v).trim() : null;
            }
            return null;
        },
        async _ensureRows () {
            const companyId = this._resolveCompanyIdFromFilter();
            if (!companyId) {
                this._lastRows = [];
                this._lastFilterKey = 'no-company';
                if (!this._notifiedNoCompany) {
                    this._notifiedNoCompany = true;
                    (0, $jUNyh.notify)("Filtre por Empresa para listar as sess\xf5es de invent\xe1rio.", 'info');
                }
                return [];
            }
            const key = `company:${companyId}`;
            if (this._lastRows && this._lastFilterKey === key) return this._lastRows;
            const res = await (0, $9VcS9.default).list_inventory_sessions(companyId);
            if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
            const rows = await res.json();
            this._lastRows = Array.isArray(rows) ? rows : [];
            this._lastFilterKey = key;
            return this._lastRows;
        },
        async queryData (query) {
            const rows = await this._ensureRows();
            const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
            if (qs.get('group') === 'count') return rows.length;
            const limit = Number(qs.get('limit') || 30);
            const offset = Number(qs.get('offset') || 0);
            return rows.slice(offset, offset + limit);
        },
        async loadRecord (id_json) {
            const [companyId, sessionId] = JSON.parse(id_json);
            const res = await (0, $9VcS9.default).select_inventory_session(companyId, sessionId);
            if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
            return await res.json();
        },
        async saveRecord (data) {
            if (data.id) return data.id; // edição é feita por ações no detalhe
            const companyId = data.company_id;
            if (!companyId) throw new Error("Empresa obrigat\xf3ria.");
            if (!data.name || !String(data.name).trim()) throw new Error("Nome da sess\xe3o obrigat\xf3rio.");
            const payload = {
                company_id: companyId,
                session_type: data.session_type || 'position',
                name: String(data.name).trim(),
                notes: data.notes || null,
                scope_filter: $a856b19a551476c1$var$_buildScopeFilter(data),
                freeze_immediately: data.session_type !== 'import'
            };
            const res = await (0, $9VcS9.default).create_inventory_session(payload);
            if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
            const created = await res.json();
            this._setCompanyFilter(companyId);
            (0, $jUNyh.notify)("Sess\xe3o de invent\xe1rio criada com sucesso!", 'success');
            return created.id;
        },
        async saveRecordWrapper (data, oldData) {
            try {
                return await Object.getPrototypeOf(this).saveRecordWrapper.call(this, data, oldData);
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Invent\xe1rio");
                return false;
            }
        },
        setMenuRoutes () {
            Object.getPrototypeOf(this).setMenuRoutes.call(this);
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-view-counts', ()=>this._openSelectedInventoryDetail());
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-print-progress', ()=>this._printSelectedInventoryProgress());
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-print-divergences', ()=>this._printSelectedInventoryDivergences());
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-print-simulation-sku', ()=>this._printSelectedInventorySimulationBySku());
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-export-simulation-sku', ()=>this._exportSelectedInventorySimulationBySku());
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-export-closure-sku', ()=>this._exportSelectedInventoryClosureBySku());
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-freeze', ()=>this._runSelectedInventoryAction({
                    label: 'congelar',
                    confirmMessage: "Congelar invent\xe1rio(s) selecionado(s)?",
                    call: (companyId, sessionId, row)=>(0, $9VcS9.default).freeze_inventory_session(companyId, sessionId, row.scope_filter || null),
                    successMessage: "Invent\xe1rio(s) congelado(s)."
                }));
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-unfreeze', ()=>this._runSelectedInventoryAction({
                    label: 'descongelar',
                    confirmMessage: "Descongelar invent\xe1rio(s) selecionado(s)? Os itens congelados ser\xe3o removidos.",
                    call: (companyId, sessionId)=>(0, $9VcS9.default).unfreeze_inventory_session(companyId, sessionId),
                    successMessage: "Invent\xe1rio(s) descongelado(s)."
                }));
            (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-cancel', ()=>this._runSelectedInventoryAction({
                    label: 'cancelar',
                    confirmMessage: "Cancelar invent\xe1rio(s) selecionado(s) com status Criado?",
                    call: (companyId, sessionId)=>(0, $9VcS9.default).cancel_inventory_session(companyId, sessionId),
                    successMessage: "Invent\xe1rio(s) cancelado(s)."
                }));
        },
        async deleteRecord () {
            return await this._runSelectedInventoryAction({
                label: 'cancelar',
                confirmMessage: "Cancelar invent\xe1rio(s) selecionado(s) com status Criado?",
                call: (companyId, sessionId)=>(0, $9VcS9.default).cancel_inventory_session(companyId, sessionId),
                successMessage: "Invent\xe1rio(s) cancelado(s)."
            });
        },
        /**
		 * Executa uma ação operacional nas sessões selecionadas da grade.
		 * @param {{ label: string, confirmMessage: string, call: Function, successMessage: string }} options
		 * @returns {Promise<boolean>}
		 */ async _runSelectedInventoryAction ({ label: label, confirmMessage: confirmMessage, call: call, successMessage: successMessage }) {
            const selected = this.getSelection();
            if (!selected.length) {
                (0, $jUNyh.notify)("Selecione ao menos um invent\xe1rio na grade.");
                return false;
            }
            if (!confirm(confirmMessage)) return false;
            const errors = [];
            for (const id of selected){
                const [companyId, sessionId] = id;
                try {
                    const row = (this._lastRows || []).find((r)=>String(r.company_id) === String(companyId) && Number(r.id) === Number(sessionId));
                    const res = await call(companyId, sessionId, row || {});
                    if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
                } catch (err) {
                    errors.push(`#${sessionId}: ${err?.message || err}`);
                }
            }
            this._lastRows = null;
            this._lastFilterKey = null;
            await this.loadPage();
            if (errors.length) (0, $jUNyh.notify)(`Falha ao ${label}: ${errors.join(' | ')}`);
            else (0, $jUNyh.notify)(successMessage, 'success');
            return !errors.length;
        },
        /**
		 * Abre o detalhe operacional da sessão selecionada para visualizar itens e histórico de contagens.
		 * @returns {Promise<boolean>}
		 */ async _openSelectedInventoryDetail () {
            const selected = this.getSelection();
            if (selected.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente um invent\xe1rio para ver as contagens.");
                return false;
            }
            try {
                const record = await this.loadRecord(JSON.stringify(selected[0]));
                if (record != null) this.editRecord(record);
                return true;
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Aten\xe7\xe3o");
                return false;
            }
        },
        /**
		 * Gera o PDF de acompanhamento com os itens e o histórico de contagens da sessão selecionada.
		 * @returns {Promise<boolean>}
		 */ async _printSelectedInventoryProgress () {
            const selected = this.getSelection();
            if (selected.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente um invent\xe1rio para imprimir o acompanhamento.");
                return false;
            }
            const [companyId, sessionId] = selected[0];
            try {
                const res = await (0, $9VcS9.default).print_inventory_progress(companyId, sessionId);
                if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
                const data = await res.json();
                $a856b19a551476c1$var$_downloadBase64(data.content_base64, `acompanhamento-inv-${sessionId}.pdf`, 'application/pdf');
                return true;
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Aten\xe7\xe3o");
                return false;
            }
        },
        /**
		 * PDF estruturado de divergências da sessão selecionada.
		 * @returns {Promise<boolean>}
		 */ async _printSelectedInventoryDivergences () {
            const selected = this.getSelection();
            if (selected.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente um invent\xe1rio para imprimir diverg\xeancias.");
                return false;
            }
            const [companyId, sessionId] = selected[0];
            try {
                const res = await (0, $9VcS9.default).print_inventory_divergences(companyId, sessionId);
                if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
                const data = await res.json();
                $a856b19a551476c1$var$_downloadBase64(data.content_base64, `divergencias-inv-${sessionId}.pdf`, 'application/pdf');
                return true;
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Aten\xe7\xe3o");
                return false;
            }
        },
        /**
		 * PDF simulação agregada por SKU (requer simulate-close).
		 * @returns {Promise<boolean>}
		 */ async _printSelectedInventorySimulationBySku () {
            const selected = this.getSelection();
            if (selected.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente um invent\xe1rio para imprimir a simula\xe7\xe3o por SKU.");
                return false;
            }
            const [companyId, sessionId] = selected[0];
            try {
                const res = await (0, $9VcS9.default).print_inventory_simulation_by_sku(companyId, sessionId);
                if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
                const data = await res.json();
                $a856b19a551476c1$var$_downloadBase64(data.content_base64, data.filename || `simulacao-sku-inv-${sessionId}.pdf`, data.mime_type || 'application/pdf');
                return true;
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Aten\xe7\xe3o");
                return false;
            }
        },
        /**
		 * Excel simulação agregada por SKU (requer simulate-close).
		 * @returns {Promise<boolean>}
		 */ async _exportSelectedInventorySimulationBySku () {
            const selected = this.getSelection();
            if (selected.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente um invent\xe1rio para exportar a simula\xe7\xe3o por SKU.");
                return false;
            }
            const [companyId, sessionId] = selected[0];
            try {
                const res = await (0, $9VcS9.default).export_inventory_simulation_by_sku(companyId, sessionId);
                if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
                const data = await res.json();
                $a856b19a551476c1$var$_downloadBase64(data.content_base64, data.filename || `simulacao-sku-inv-${sessionId}.xlsx`, data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                return true;
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Aten\xe7\xe3o");
                return false;
            }
        },
        /**
		 * Excel saldo por SKU + programa (itens finalizados do escopo).
		 * @returns {Promise<boolean>}
		 */ async _exportSelectedInventoryClosureBySku () {
            const selected = this.getSelection();
            if (selected.length !== 1) {
                (0, $jUNyh.notify)("Selecione exatamente um invent\xe1rio para exportar o saldo por SKU.");
                return false;
            }
            const [companyId, sessionId] = selected[0];
            try {
                const res = await (0, $9VcS9.default).export_inventory_closure_by_sku(companyId, sessionId);
                if (!res.ok) throw new Error(await $a856b19a551476c1$var$_apiErrorText(res));
                const data = await res.json();
                $a856b19a551476c1$var$_downloadBase64(data.content_base64, data.filename || `saldo-sku-inv-${sessionId}.xlsx`, data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                return true;
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), "Aten\xe7\xe3o");
                return false;
            }
        }
    });
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: '#',
            types: [
                $3eqAU.default()
            ],
            placeholder: ''
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: ''
        },
        {
            index: 4,
            field: 'session_type',
            label: 'Tipo',
            types: [
                $74yTJ.default()
            ],
            placeholder: ''
        },
        {
            index: 5,
            field: 'status',
            label: 'Status',
            types: [
                $3eqAU.default()
            ],
            placeholder: ''
        },
        {
            index: 6,
            field: 'created_on',
            label: 'Criado',
            types: [
                $b7D1Q.default()
            ],
            placeholder: ''
        }
    ];
    inv_crud.run('inventory-sessions', "Invent\xe1rios V2", document.getElementById('workarea'), (0, $85514b0bdf9568d6$export$2e2bcd8739ae039), (0, $cf923db1bbff9a34$export$2e2bcd8739ae039), fieldspecs, [
        {
            hash: '#inventory-view-counts',
            label: 'Ver contagens / acompanhamento'
        },
        {
            hash: '#inventory-freeze',
            label: 'Congelar selecionados'
        },
        {
            hash: '#inventory-unfreeze',
            label: 'Descongelar selecionados'
        },
        {
            hash: '#inventory-cancel',
            label: 'Cancelar selecionados'
        }
    ], [
        {
            hash: '#inventory-print-progress',
            label: 'Acompanhamento com contagens'
        },
        {
            hash: '#inventory-print-divergences',
            label: "Relat\xf3rio de diverg\xeancias"
        },
        {
            hash: '#inventory-print-simulation-sku',
            label: "Simula\xe7\xe3o por SKU (PDF)"
        },
        {
            hash: '#inventory-export-simulation-sku',
            label: "Simula\xe7\xe3o por SKU (Excel)"
        },
        {
            hash: '#inventory-export-closure-sku',
            label: 'Saldo por SKU (Excel)'
        }
    ]);
};
/**
 * Quebra campos de escopo em tokens aceitando os separadores usados na operação.
 * @param {string} str
 * @returns {string[]}
 */ function $a856b19a551476c1$var$_splitScopeTokens(str) {
    if (!str || !String(str).trim()) return [];
    return String(str).split(/[,\s;]+/).map((s)=>s.trim()).filter((token)=>token && token.toLowerCase() !== 'e');
}
/**
 * Lê uma lista de IDs aceitando vírgula, ponto e vírgula, espaço ou quebra de linha.
 * @param {string} str
 * @returns {number[]|null}
 */ function $a856b19a551476c1$var$_parseIdTokens(str) {
    const nums = $a856b19a551476c1$var$_splitScopeTokens(str).map((s)=>parseInt(s, 10)).filter((n)=>!Number.isNaN(n));
    return nums.length ? nums : null;
}
/**
 * Monta o filtro de congelamento normalizando listas digitadas no formulário.
 * @param {object} data
 * @returns {object|null}
 */ function $a856b19a551476c1$var$_buildScopeFilter(data) {
    const parseLocationScope = (str)=>{
        if (!str || !String(str).trim()) return {
            ids: null,
            codes: null
        };
        const ids = [];
        const codes = [];
        for (const token of $a856b19a551476c1$var$_splitScopeTokens(str))if (/^\d+$/.test(token)) ids.push(parseInt(token, 10));
        else codes.push(token);
        return {
            ids: ids.length ? ids : null,
            codes: codes.length ? codes : null
        };
    };
    const f = {};
    const wi = $a856b19a551476c1$var$_parseIdTokens(data.scope_warehouse_ids);
    const locScope = parseLocationScope(data.scope_location_ids);
    const productTerms = $a856b19a551476c1$var$_splitScopeTokens(data.scope_product_ids);
    const ci = $a856b19a551476c1$var$_parseIdTokens(data.scope_category_ids);
    const cli = $a856b19a551476c1$var$_parseIdTokens(data.scope_class_ids);
    if (wi) f.warehouse_ids = wi;
    if (locScope.ids) f.location_ids = locScope.ids;
    if (locScope.codes) f.location_codes = locScope.codes;
    if (productTerms.length) f.product_terms = productTerms;
    if (ci) f.category_ids = ci;
    if (cli) f.class_ids = cli;
    return Object.keys(f).length ? f : null;
}
var $a856b19a551476c1$export$2e2bcd8739ae039 = $a856b19a551476c1$var$inventorySessions;
/**
 * Extrai uma mensagem operacional legível de respostas de erro da API.
 * @param {Response} response
 * @returns {Promise<string>}
 */ async function $a856b19a551476c1$var$_apiErrorText(response) {
    const text = await response.text();
    const clean = String(text || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    return clean || `Falha na API ao abrir invent\xe1rio (HTTP ${response.status}).`;
}
/**
 * Dispara download de um arquivo retornado pela API em base64.
 * @param {string} b64
 * @param {string} filename
 * @param {string} mime
 */ function $a856b19a551476c1$var$_downloadBase64(b64, filename, mime) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mime
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $dx9qz = parcelRequire("dx9qz");

var $hWQyW = parcelRequire("hWQyW");


var $jUNyh = parcelRequire("jUNyh");

var $b60a2 = parcelRequire("b60a2");


var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $fyCkJ = parcelRequire("fyCkJ");

const $175c09b2e159b26a$var$FULFILLMENT_CLASS = {
    pending: 'io-fulfill-pending',
    partial: 'io-fulfill-partial',
    total: 'io-fulfill-total'
};
function $175c09b2e159b26a$var$fulfillmentBadge(record) {
    const code = (record.fulfillment_status || '').toString();
    const label = $cabf10de07f42bb1$export$2e2bcd8739ae039().options.find((o)=>o.value === code)?.label || code || "\u2014";
    const cls = $175c09b2e159b26a$var$FULFILLMENT_CLASS[code] || 'io-fulfill-pending';
    const ordered = record.qty_ordered != null ? Number(record.qty_ordered) : null;
    const received = record.qty_received != null ? Number(record.qty_received) : null;
    const tip = ordered != null && received != null ? `Recebido ${received} de ${ordered} (entradas conclu\xeddas)` : "Atendimento vs entradas conclu\xeddas";
    return `<span class="io-fulfill-badge ${cls}" title="${tip}">${label}</span>`;
}
async function $175c09b2e159b26a$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(16)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(17)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(18)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(19)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(20)	{ text-align: center; }
			.view td:nth-child(21)	{ text-align: left; }
			.view td:nth-child(22)	{ text-align: center; }
			.view td:nth-child(23)	{ text-align: center; }
			.view td:nth-child(24)	{ text-align: left; }
			.view td:nth-child(25)	{ text-align: left; }
			.view th:nth-child(26),
			.view td:nth-child(26),
			.view th:nth-child(27),
			.view td:nth-child(27)	{ text-align: left; max-width: 12rem; }
			.io-fulfill-badge {
				display: inline-block;
				padding: 2px 8px;
				border-radius: 3px;
				font-size: 0.85em;
				font-weight: 600;
				white-space: nowrap;
			}
			.io-fulfill-pending { background: #e5e7eb; color: #374151; }
			.io-fulfill-partial { background: #fef3c7; color: #92400e; }
			.io-fulfill-total   { background: #d1fae5; color: #065f46; }
			.io-dock-badge {
				display: inline-block;
				padding: 2px 8px;
				border-radius: 3px;
				font-size: 0.85em;
				font-weight: 600;
				white-space: nowrap;
			}
			.io-dock-none { background: #f3f4f6; color: #6b7280; }
			.io-dock-scheduled { background: #dbeafe; color: #1e3a8a; }
			.io-dock-receiving { background: #ede9fe; color: #5b21b6; }
			.io-dock-completed { background: #d1fae5; color: #065f46; }
			.io-dock-cancelled { background: #fee2e2; color: #991b1b; }
			.io-dock-noshow { background: #fee2e2; color: #7f1d1d; }
			.io-dock-other { background: #e5e7eb; color: #374151; }
			.io-dock-occ { background: #fef3c7; color: #92400e; margin-left: 0.25rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Refer\xeancia</th>
					<th data-index="4" data-visible="${this.visible[3]}">Data Cria\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Criado Por</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data Altera\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[6]}">Alterado Por</th>
					<th data-index="8" data-visible="${this.visible[7]}">Fornecedor&nbsp;/&nbsp;Cliente</th>
					<th data-index="10" data-visible="${this.visible[8]}">Transportador</th>
					<th data-index="11" data-visible="${this.visible[9]}">Programa</th>
					<th data-index="12" data-visible="${this.visible[10]}">Tipo Frete</th>
					<th data-index="13" data-visible="${this.visible[11]}">Valor Frete</th>
					<th data-index="14" data-visible="${this.visible[12]}">% Desconto</th>
					<th data-index="15" data-visible="${this.visible[13]}">Valor</th>
					<th data-index="16" data-visible="${this.visible[14]}">Observa\xe7\xf5es</th>
					<th data-index="18" data-visible="${this.visible[15]}">N\xba&nbsp;empenho</th>
					<th data-index="19" data-visible="${this.visible[16]}">OC&nbsp;Amil</th>
					<th data-index="20" data-visible="${this.visible[17]}">Tipo&nbsp;recebimento</th>
					<th data-index="21" data-visible="${this.visible[18]}">Devolu\xe7\xe3o</th>
					<th data-index="17" data-visible="${this.visible[19]}">NF</th>
					<th data-index="28" data-visible="${this.visible[20]}">Atendimento</th>
					<th data-index="32" data-visible="${this.visible[21]}">Agendamento</th>
					<th data-index="22" data-visible="${this.visible[22]}">Status</th>
					<th data-index="23" data-visible="${this.visible[23]}">Qtd&nbsp;parcelas</th>
					<th data-index="30" data-visible="${this.visible[24]}">SKU (itens)</th>
					<th data-index="31" data-visible="${this.visible[25]}">Produto (itens)</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($8IFAz.default(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.created_by)}</td>
					<td data-visible='${this.visible[5]}'>${this.format($8IFAz.default(), record.updated_on) || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.updated_by) || ''}</td>
					<td data-visible='${this.visible[7]}'>${await this.key(record.is_return ? 'customers' : 'suppliers', [
            record.company_id,
            record.is_return ? record.customer_id : record.supplier_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('carriers', [
            record.company_id,
            record.carrier_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[10]}'>${this.option($fyCkJ.default(), record.freight_type) || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.freight_value ? this.format($3eqAU.default(2), record.freight_value) : ''}</td>
					<td data-visible='${this.visible[12]}'>${record.discount ? this.format($3eqAU.default(2), record.discount) : ''}</td>
					<td data-visible='${this.visible[13]}'>${this.format($3eqAU.default(2), record.value)}</td>
					<td data-visible='${this.visible[14]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[15]}'>${record.empenho_number || ''}</td>
					<td data-visible='${this.visible[16]}'>${record.amil_oc || ''}</td>
					<td data-visible='${this.visible[17]}'>${await (async ()=>{
            if (record.receipt_type_id == null || record.receipt_type_id === '') return '';
            const k = [
                record.company_id,
                record.receipt_type_id
            ];
            const c = await this.key('receipt_types', k, 'code');
            const d = await this.key('receipt_types', k, 'description');
            return [
                c,
                d
            ].filter(Boolean).join(" \u2014 ");
        })()}</td>
					<td data-visible='${this.visible[18]}'>${this.option($1Wvh7.default(), record.is_return)}</td>
					<td data-visible='${this.visible[19]}'>${(record.nf_number ?? '').toString()}</td>
					<td data-visible='${this.visible[20]}'>${$175c09b2e159b26a$var$fulfillmentBadge(record)}</td>
					<td data-visible='${this.visible[21]}'>${(0, $b8167635cb1083d7$export$a8fb0eb6f2aae835)(record)}</td>
					<td data-visible='${this.visible[22]}'>${this.option($79f43e37b9b6ec01$export$2e2bcd8739ae039(), record.status) || ''}</td>
					<td data-visible='${this.visible[23]}'>${record.payment_installment_count != null ? record.payment_installment_count : ''}</td>
					<td data-visible='${this.visible[24]}'>${record.lines_sku_summary || ''}</td>
					<td data-visible='${this.visible[25]}'>${record.lines_product_summary || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $fyCkJ = parcelRequire("fyCkJ");
var $6Jl4s = parcelRequire("6Jl4s");
var $knytZ = parcelRequire("knytZ");

var $1cmSR = parcelRequire("1cmSR");
/**
 * Copia o title do label/container para os campos internos.
 *
 * O formset recria linhas dinamicamente; manter o title no input melhora o hover
 * quando a tabela fica rolável e o texto do cabeçalho não está visível.
 */ function $b2411514bdf07434$export$b7c121695885def(root = document) {
    if (!root) return;
    root.querySelectorAll('label[title], td[title], span[title], div[title]').forEach((container)=>{
        const title = container.getAttribute('title');
        if (!title) return;
        container.querySelectorAll('input, select, textarea').forEach((field)=>{
            if (!field.getAttribute('title')) field.setAttribute('title', title);
        });
    });
}
function $b2411514bdf07434$export$c784f48aeddf3f03(root = document) {
    if (!root || root.dataset?.fieldTitleSyncBound === '1') return;
    $b2411514bdf07434$export$b7c121695885def(root);
    if (root.dataset) root.dataset.fieldTitleSyncBound = '1';
    const observer = new MutationObserver(()=>$b2411514bdf07434$export$b7c121695885def(root));
    observer.observe(root, {
        childList: true,
        subtree: true
    });
}



function $c50c847760b2fc91$var$hydrateDockScheduleSummary(root) {
    if (!root) return;
    const box = root.querySelector('#io-dock-schedule-summary');
    if (!box) return;
    const status = root._dockScheduleStatus;
    const dockName = root._dockScheduleDockName;
    const start = root._dockScheduleStart;
    const end = root._dockScheduleEnd;
    const hasOcc = root._dockScheduleHasOccurrence;
    if (!status && !root._dockScheduleId) {
        box.style.display = 'none';
        box.textContent = '';
        return;
    }
    const parts = [
        `<strong>Agendamento de doca:</strong> ${(0, $aecc276d35afe90f$export$a954299e2515e375)(status) || "\u2014"}`,
        dockName ? `Doca ${dockName}` : null,
        start ? `${(0, $aecc276d35afe90f$export$c5be672fb676f885)(start)} ${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(start)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(end)}` : null,
        hasOcc ? "Com ocorr\xeancia" : null
    ].filter(Boolean);
    box.innerHTML = parts.join(" \xb7 ");
    box.style.display = '';
}
function $c50c847760b2fc91$var$_parseSialNum(s) {
    const c = String(s ?? '').replace(/\./g, '').replace(',', '.');
    const n = parseFloat(c);
    return isFinite(n) ? n : 0;
}
function $c50c847760b2fc91$var$_fmtBRL(v) {
    return Number(v).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
function $c50c847760b2fc91$var$recalcOrderTotals(root) {
    if (!root) return;
    const tbody = root.querySelector('.sial-items-scroll tbody');
    const totalEl = root.querySelector('#io-grand-total');
    if (!tbody) return;
    let grand = 0;
    tbody.querySelectorAll('tr.row').forEach((row)=>{
        const qEl = row.querySelector('[id^="quantity-"]');
        if (!qEl) return;
        const n = (qEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const qty = $c50c847760b2fc91$var$_parseSialNum(qEl.value);
        const price = $c50c847760b2fc91$var$_parseSialNum(row.querySelector(`#unit_price-${n}`)?.value);
        const total = qty * price;
        const ti = row.querySelector(`#item_total-${n}`);
        if (ti) ti.value = qty > 0 || price > 0 ? $c50c847760b2fc91$var$_fmtBRL(total) : '';
        grand += total;
    });
    if (totalEl) totalEl.textContent = grand > 0 ? `Total do Pedido: ${$c50c847760b2fc91$var$_fmtBRL(grand)}` : '';
}
async function $c50c847760b2fc91$var$syncStatusApprovalLock(root) {
    if (!root) return;
    const statusEl = root.querySelector('#status');
    const companyEl = root.querySelector('#company_id');
    if (!statusEl) return;
    const companyId = companyEl?.value;
    let requireApproval = false;
    if (companyId) try {
        const company = await (0, $1cmSR.default).get('companies', companyId) || await (0, $1cmSR.default).get('companies', [
            companyId
        ]);
        requireApproval = !!(company && company.input_orders_require_approval);
    } catch (_) {
        requireApproval = false;
    }
    statusEl.readOnly = requireApproval;
    if (requireApproval) {
        statusEl.title = "Status alterado apenas pelas opera\xe7\xf5es Aprovar ou Rejeitar (par\xe2metro da empresa).";
        statusEl.setAttribute('aria-readonly', 'true');
    } else {
        statusEl.title = 'Status do pedido';
        statusEl.removeAttribute('aria-readonly');
    }
}
/** #MT-3AD0979 — trava quando há Entrada ativa: frete/transportador/condição editáveis. */ function $c50c847760b2fc91$var$applyInputOrderEditLock(fs) {
    const form = document.querySelector('#order');
    const banner = document.querySelector('#io-lock-banner');
    if (!form) return;
    const vals = fs.form.getValues();
    const locked = vals.edit_locked_by_input === true || vals.edit_locked_by_input === 1 || vals.edit_locked_by_input === '1' || String(vals.edit_locked_by_input).toLowerCase() === 'true';
    form.classList.toggle('input-order--edit-locked', locked);
    if (banner) banner.style.display = locked ? 'block' : 'none';
    const toolbar = form.querySelector('.io-footer-tools');
    const rowImgs = toolbar ? toolbar.querySelectorAll('img') : [];
    const allowSelectors = [
        '#carrier_id',
        '#freight_type',
        '#freight_value',
        '#payment_installment_count',
        '#payment_base_date',
        '#io_prazo_0',
        '#io_prazo_1',
        '#io_prazo_2',
        '#io_prazo_3',
        '#io_prazo_4',
        '#io_prazo_5',
        '#io_prazo_6',
        '#io_prazo_7',
        '#io_prazo_8',
        '#io_prazo_9',
        '#io_prazo_10',
        '#io_prazo_11'
    ];
    if (!locked) {
        form.querySelectorAll('[data-io-lock-disabled]').forEach((el)=>{
            el.removeAttribute('data-io-lock-disabled');
            el.removeAttribute('disabled');
        });
        rowImgs.forEach((img)=>{
            img.style.pointerEvents = '';
            img.style.opacity = '';
        });
        return;
    }
    form.querySelectorAll('input, select, textarea, button').forEach((el)=>{
        if (el.type === 'hidden') return;
        if (el.tagName === 'BUTTON' && (el.classList.contains('bn_Escape') || el.classList.contains('bn_Enter'))) return;
        if (allowSelectors.some((sel)=>{
            const n = form.querySelector(sel);
            return n && el === n;
        })) return;
        if (el.closest('.io-lock-allow')) return;
        el.setAttribute('data-io-lock-disabled', '1');
        el.setAttribute('disabled', 'disabled');
    });
    rowImgs.forEach((img)=>{
        img.style.pointerEvents = 'none';
        img.style.opacity = '0.45';
    });
}
function $c50c847760b2fc91$var$_parsePaymentPrazos(raw) {
    if (Array.isArray(raw)) return raw.map((x)=>Number(x));
    if (raw == null || raw === '') return [];
    if (typeof raw === 'string') try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.map((x)=>Number(x)) : [];
    } catch (_) {
        return [];
    }
    return [];
}
function $c50c847760b2fc91$var$_fmtDateBR(iso) {
    if (!iso) return '';
    const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return String(iso);
    return `${m[3]}/${m[2]}/${m[1]}`;
}
function $c50c847760b2fc91$var$_addDaysIso(iso, days) {
    const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return '';
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    d.setDate(d.getDate() + Number(days || 0));
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}
function $c50c847760b2fc91$var$syncPaymentPrazosUI(root) {
    if (!root) return;
    const countEl = root.querySelector('#payment_installment_count');
    const baseEl = root.querySelector('#payment_base_date');
    const hidden = root.querySelector('#payment_prazos');
    const created = root.querySelector('#created_on')?.value;
    let count = parseInt(String(countEl?.value || '').replace(/\D/g, ''), 10);
    if (!Number.isFinite(count) || count < 0) count = 0;
    if (count > 12) count = 12;
    const prazos = [];
    for(let i = 0; i < 12; i++){
        const row = root.querySelector(`tr[data-prazo-idx="${i}"]`);
        const inp = root.querySelector(`#io_prazo_${i}`);
        if (row) row.style.display = i < count ? '' : 'none';
        if (i < count) {
            const days = parseInt(String(inp?.value || '').trim(), 10);
            prazos.push(Number.isFinite(days) ? days : 0);
            if (inp && (inp.value === '' || inp.value == null) && days === 0) inp.value = '0';
            const venctoEl = row?.querySelector('.io-vencto');
            const base = (baseEl?.value || '').trim() || created && String(created).match(/^\d{4}-\d{2}-\d{2}/)?.[0] || '';
            if (venctoEl) venctoEl.textContent = base && Number.isFinite(days) ? $c50c847760b2fc91$var$_fmtDateBR($c50c847760b2fc91$var$_addDaysIso(base, days)) : "\u2014";
        }
    }
    if (hidden) hidden.value = count > 0 ? JSON.stringify(prazos) : '';
}
function $c50c847760b2fc91$var$bindPaymentPrazos(root) {
    if (!root || root._ioPaymentBound) return;
    root._ioPaymentBound = true;
    const sync = ()=>$c50c847760b2fc91$var$syncPaymentPrazosUI(root);
    root.querySelector('#payment_installment_count')?.addEventListener('input', sync);
    root.querySelector('#payment_installment_count')?.addEventListener('change', sync);
    root.querySelector('#payment_base_date')?.addEventListener('change', sync);
    for(let i = 0; i < 12; i++){
        root.querySelector(`#io_prazo_${i}`)?.addEventListener('input', sync);
        root.querySelector(`#io_prazo_${i}`)?.addEventListener('change', sync);
    }
    sync();
}
function $c50c847760b2fc91$var$hydratePaymentPrazos(root, prazosRaw) {
    if (!root) return;
    const prazos = $c50c847760b2fc91$var$_parsePaymentPrazos(prazosRaw);
    const countEl = root.querySelector('#payment_installment_count');
    let count = parseInt(String(countEl?.value || '').replace(/\D/g, ''), 10);
    if (!Number.isFinite(count) || count <= 0) count = prazos.length;
    if (countEl && (!countEl.value || countEl.value === '0') && prazos.length) countEl.value = String(prazos.length);
    for(let i = 0; i < 12; i++){
        const inp = root.querySelector(`#io_prazo_${i}`);
        if (inp) inp.value = i < prazos.length && Number.isFinite(prazos[i]) ? String(prazos[i]) : '';
    }
    $c50c847760b2fc91$var$syncPaymentPrazosUI(root);
}
var $c50c847760b2fc91$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#order.io-order-form .io-order-header-scroll {
				flex-shrink: 0;
				overflow-x: hidden;
				padding-right: 0.2rem;
			}
			#order.io-order-form .io-order-tail {
				flex-shrink: 0;
			}
			#order.io-order-form .io-section-title {
				font-size: 0.75rem;
				font-weight: 600;
				letter-spacing: 0.02em;
				text-transform: uppercase;
				color: var(--color-muted, #555);
				margin: 0 0 0.4rem 0;
				grid-column: 1 / -1;
			}
			#order.io-order-form .io-grid {
				display: grid;
				grid-template-columns: repeat(4, minmax(0, 1fr));
				gap: 0.5rem 0.85rem;
				margin-bottom: 0.5rem;
				align-items: start;
			}
			#order.io-order-form .io-grid label,
			#order.io-order-form .io-grid > span {
				display: block;
				min-width: 0;
				margin-right: 0 !important;
				margin-bottom: 0 !important;
			}
			/* block (n\xe3o flex column): evita quebra do <sup>*</sup> em linha separada no Fornecedor/Cliente */
			#order.io-order-form .io-grid > span > label {
				display: block;
				min-width: 0;
				margin: 0 !important;
			}
			#order.io-order-form .io-grid label.io-field--check {
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				gap: 0.35rem 0.5rem;
			}
			#order.io-order-form .io-grid label.io-field--check.io-devolucao-secondary {
				flex-direction: column;
				align-items: flex-start;
				align-self: start;
				gap: 0.35rem;
			}
			#order.io-order-form .io-devolucao-secondary .io-check-slot {
				min-height: 2.15rem;
				display: flex;
				align-items: center;
				box-sizing: border-box;
			}
			#order.io-order-form .io-grid label.io-field--check.io-devolucao-secondary input[type="checkbox"] {
				margin: 0;
			}
			#order.io-order-form .io-grid label.io-field--check input[type="checkbox"] {
				margin: 0;
				width: auto;
				display: inline-block;
			}
			#order.io-order-form .io-grid > span.io-party-wrap {
				display: block;
				min-width: 0;
				align-self: stretch;
			}
			#order.io-order-form .io-grid > span.io-party-wrap .sial-field-party {
				width: 100%;
			}
			#order.io-order-form .io-span-2 { grid-column: span 2; }
			#order.io-order-form .io-span-full { grid-column: 1 / -1; }
			#order.io-order-form .sial-items-scroll .io-col-product { width: 38%; }
			#order.io-order-form .sial-items-scroll .io-col-unit { width: 11%; }
			#order.io-order-form .sial-items-scroll .io-col-qty { width: 8%; }
			#order.io-order-form .sial-items-scroll .io-col-serial { width: 12%; }
			#order.io-order-form .sial-items-scroll .serial {
				min-width: 6.5rem;
				background: #fffbeb;
				border-color: #f59e0b;
			}
			#order.io-order-form .sial-items-scroll .io-col-price { width: 10%; }
			#order.io-order-form .sial-items-scroll .io-col-total { width: 10%; }
			#order.io-order-form .io-grand-total {
				text-align: right; font-weight: 600; font-size: 0.88rem;
				padding: 0.35rem 0.25rem 0; color: var(--color-text, #222);
				flex-shrink: 0;
			}
			#order.io-order-form #freight_value,
			#order.io-order-form #discount { text-align: right; }
			#order.io-order-form label.notes {
				display: flex;
				flex-direction: column;
				width: 100%;
				margin: 0.35rem 0 0 0 !important;
				flex-shrink: 0;
			}
			#order.io-order-form label.notes textarea {
				width: 100%;
				box-sizing: border-box;
			}
			#order.io-order-form .io-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				flex-shrink: 0;
				margin-top: 0.5rem;
				padding-top: 0.75rem;
				border-top: 1px solid var(--color-border, #ccc);
				gap: 0.75rem;
				flex-wrap: wrap;
			}
			#order.io-order-form .io-footer .button { min-width: 5.5rem; }
			#io-lock-banner { margin: 0 0 0.75rem 0; padding: 0.5rem 0.65rem; background: #f1f5f9; border: 1px solid #cbd5e1; border-radius: 4px; color: #475569; }
			#order.io-order-form.input-order--edit-locked label:not(.io-lock-allow) { color: #94a3b8; }
			.io-dock-summary {
				margin: 0 0 0.75rem 0;
				padding: 0.55rem 0.7rem;
				background: #eef2ff;
				border: 1px solid #c7d2fe;
				border-radius: 4px;
				color: #1e3a8a;
				font-size: 0.9rem;
			}
			.io-dock-summary strong { color: #4c1d95; }
		</style>
		<form id="order" class="form io-order-form sial-modal-form" autocomplete="off">
			<input type="hidden" id="edit_locked_by_input" value="0">
			<p id="io-lock-banner" class="fsxx" style="display:none">Este pedido possui Entrada gerada (n\xe3o cancelada): os campos ficam bloqueados, exceto <strong>Transportador</strong>, <strong>Tipo/Valor do frete</strong> e <strong>Condi\xe7\xe3o de pagamento</strong>. A edi\xe7\xe3o plena volta quando todas as Entradas vinculadas forem canceladas.</p>
			<div id="io-dock-schedule-summary" class="io-dock-summary" style="display:none" aria-live="polite"></div>
			<datalist id="companies">
			</datalist>
			<datalist id="suppliers">
			</datalist>
			<datalist id="customers">
			</datalist>
			<datalist id="carriers">
			</datalist>
			<datalist id="programs">
			</datalist>
			<datalist id="receipt_types">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="users">
			</datalist>
			<div class="io-order-header-scroll">
			<div class="io-grid">
				<div class="io-section-title">Identifica\xe7\xe3o</div>
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do pedido">Pedido
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo de refer\xeancia externa">Refer\xeancia
					<input id="reference" type="text">
				</label>
				<label title="N\xfamero/refer\xeancia da NF de entrada (agrupador; consulta/BI)">NF
					<input id="nf_number" type="text" maxlength="120" placeholder="Ex.: 123456 / s\xe9rie-n\xfamero">
				</label>
				<label title="Status do pedido">Status<sup>*</sup>
					<input id="status" type="text" list="order_status" value="10" required>
				</label>
				<label title="Data e hora de cria\xe7\xe3o do pedido">Data cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Usu\xe1rio criador do pedido">Criado por
					<input id="created_by" type="text" list="users" disabled>
				</label>
				<label title="Data e hora de altera\xe7\xe3o do pedido">Data altera\xe7\xe3o
					<input id="updated_on" type="text" disabled>
				</label>
				<label title="\xdaltimo usu\xe1rio a alterar o pedido">Alterado por
					<input id="updated_by" type="text" list="users" disabled>
				</label>
			</div>
			<div class="io-grid">
				<div class="io-section-title">Fornecedor / log\xedstica</div>
				<span id="wrap_supplier_party" class="io-party-wrap io-span-2">
					<label class="sial-field-party" title="Fornecedor do pedido">Fornecedor<sup>*</sup>
						<input id="supplier_id" type="text" list="suppliers" required>
					</label>
				</span>
				<span id="wrap_customer_party" class="io-party-wrap io-span-2" style="display:none">
					<label class="sial-field-party" title="Cliente que devolve (devolu\xe7\xe3o)">Cliente (devolu\xe7\xe3o)<sup>*</sup>
						<input id="customer_id" type="text" list="customers">
					</label>
				</span>
				<label class="io-lock-allow" title="Transportador do pedido">Transportador
					<input id="carrier_id" type="text" list="carriers">
				</label>
				<label title="Programa sugerido para a entrada">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="N\xfamero do empenho (Ano + NE + n\xfamero, ex.: 2025NE02173)">N\xba empenho
					<input id="empenho_number" type="text" placeholder="2025NE02173" maxlength="32">
				</label>
				<label title="Ordem de compra (OC) AMIL para rastreio operacional">OC Amil
					<input id="amil_oc" type="text" placeholder="Ex.: 4000222822" maxlength="60">
				</label>
				<label title="Tipo de recebimento (cadastro Tipos de Recebimento)" class="io-span-2">Tipo recebimento
					<input id="receipt_type_id" type="text" list="receipt_types">
				</label>
				<label title="Este pedido \xe9 uma devolu\xe7\xe3o?" class="io-field--check io-devolucao-secondary">Devolu\xe7\xe3o
					<span class="io-check-slot"><input id="is_return" type="checkbox"></span>
				</label>
			</div>
			<div class="io-grid">
				<div class="io-section-title">Frete</div>
				<label class="io-lock-allow" title="Tipo de frete">Tipo frete
					<input id="freight_type" type="text" list="freight_types">
				</label>
				<label class="io-lock-allow" title="Valor do frete">Valor frete
					<input id="freight_value" type="text">
				</label>
				<label title="Desconto sobre o valor do pedido">% desconto
					<input id="discount" type="text">
				</label>
			</div>
			<div class="io-grid io-payment-block">
				<div class="io-section-title">Condi\xe7\xe3o de pagamento</div>
				<label class="io-lock-allow" title="Quantidade de parcelas (1 a 12)">Qtd parcelas
					<input id="payment_installment_count" type="text" inputmode="numeric" placeholder="Ex.: 3">
				</label>
				<label class="io-lock-allow" title="Data base para calcular os vencimentos (padr\xe3o: data de cria\xe7\xe3o do pedido)">Data base venc.
					<input id="payment_base_date" type="date">
				</label>
				<input id="payment_prazos" type="hidden">
				<div class="io-payment-prazos-wrap" style="grid-column:1/-1;max-width:36rem;">
					<table class="io-payment-prazos" style="width:100%;border-collapse:collapse;font-size:0.85rem;">
						<thead>
							<tr>
								<th style="text-align:left;padding:2px 4px;">Parc.</th>
								<th style="text-align:right;padding:2px 4px;">Prazo (dias)</th>
								<th style="text-align:left;padding:2px 4px;">Vencimento</th>
							</tr>
						</thead>
						<tbody>
							<tr data-prazo-idx="0" style="display:none"><td>01</td><td style="text-align:right"><input id="io_prazo_0" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="1" style="display:none"><td>02</td><td style="text-align:right"><input id="io_prazo_1" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="2" style="display:none"><td>03</td><td style="text-align:right"><input id="io_prazo_2" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="3" style="display:none"><td>04</td><td style="text-align:right"><input id="io_prazo_3" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="4" style="display:none"><td>05</td><td style="text-align:right"><input id="io_prazo_4" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="5" style="display:none"><td>06</td><td style="text-align:right"><input id="io_prazo_5" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="6" style="display:none"><td>07</td><td style="text-align:right"><input id="io_prazo_6" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="7" style="display:none"><td>08</td><td style="text-align:right"><input id="io_prazo_7" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="8" style="display:none"><td>09</td><td style="text-align:right"><input id="io_prazo_8" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="9" style="display:none"><td>10</td><td style="text-align:right"><input id="io_prazo_9" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="10" style="display:none"><td>11</td><td style="text-align:right"><input id="io_prazo_10" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
							<tr data-prazo-idx="11" style="display:none"><td>12</td><td style="text-align:right"><input id="io_prazo_11" type="text" inputmode="numeric" style="width:5rem;text-align:right"></td><td class="io-vencto"></td></tr>
						</tbody>
					</table>
				</div>
			</div>
			</div>
			<div class="sial-items-panel">
				<div class="sial-items-title">Itens do pedido</div>
				<div class="sial-items-scroll">
					<table>
						<thead>
							<tr>
								<th class="sial-col-chk"></th>
								<th class="io-col-product">Produto<sup>*</sup></th>
								<th class="io-col-unit">Unidade<sup>*</sup></th>
								<th class="io-col-qty tar">Qtde<sup>*</sup></th>
								<th class="io-col-serial" title="Opcional \u{2014} letras e n\xfameros, at\xe9 20">Serial</th>
								<th class="io-col-price tar">Pre\xe7o unit.<sup>*</sup></th>
								<th class="io-col-total tar">Valor Total</th>
							</tr>
						</thead>
						<tbody>
							<tr class="row" data-size="10">
								<td class="sial-col-chk">
									<input id="checkbox-0" type="checkbox">
								</td>
								<td title="Produto">
									<input id="product_id-0" class="product" type="text" list="products" required>
								</td>
								<td title="Unidade de venda">
									<input id="unit_id-0" class="unit" type="text" list="units" required>
								</td>
								<td class="tar" title="Quantidade">
									<input id="quantity-0" class="quantity" type="text" required>
								</td>
								<td title="Serial previsto opcional (letras e n\xfameros, at\xe9 20)">
									<input id="serial-0" class="serial" type="text" maxlength="20" pattern="[A-Za-z0-9]*" placeholder="Opcional" autocomplete="off">
								</td>
								<td class="tar" title="Pre\xe7o unit\xe1rio do produto">
									<input id="unit_price-0" class="price" type="text" required>
								</td>
								<td class="tar" title="Valor total do item (qtde \xd7 pre\xe7o unit.)">
									<input id="item_total-0" class="item_total" type="text" readonly tabindex="-1">
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="io-order-tail">
				<div id="io-grand-total" class="io-grand-total"></div>
				<label class="notes" title="Observa\xe7\xf5es sobre o pedido">Observa\xe7\xf5es
					<textarea id="notes" rows="2"></textarea>
				</label>
			</div>
			<div class="io-footer">
				<span class="io-footer-tools">
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span class="io-footer-actions">
					<button class='bn_Escape button' type="button">Fechar</button>
					<button class='bn_Enter button' type="submit">Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#order',
        partyVisibilitySync (formRoot) {
            if (!formRoot) return;
            const ret = formRoot.querySelector('#is_return');
            const ws = formRoot.querySelector('#wrap_supplier_party');
            const wc = formRoot.querySelector('#wrap_customer_party');
            const sup = formRoot.querySelector('#supplier_id');
            const cust = formRoot.querySelector('#customer_id');
            const on = !!(ret && ret.checked);
            if (ws) ws.style.display = on ? 'none' : '';
            if (wc) wc.style.display = on ? '' : 'none';
            if (sup) sup.required = !on;
            if (cust) cust.required = on;
        },
        afterEditSetValues (fs, data) {
            if (fs?.hasTables?.()) fs.setTableHeight(10);
            const root = fs?.dialog?.getNode()?.querySelector(this.selector);
            this.partyVisibilitySync(root);
            $c50c847760b2fc91$var$applyInputOrderEditLock(fs);
            if (root) {
                root._dockScheduleId = data?.dock_schedule_id ?? null;
                root._dockScheduleStatus = data?.dock_schedule_status ?? null;
                root._dockScheduleDockName = data?.dock_name ?? null;
                root._dockScheduleStart = data?.dock_schedule_start ?? null;
                root._dockScheduleEnd = data?.dock_schedule_end ?? null;
                root._dockScheduleHasOccurrence = !!data?.dock_has_occurrence;
                $c50c847760b2fc91$var$hydrateDockScheduleSummary(root);
            }
            setTimeout(()=>{
                const r = root || document.querySelector(this.selector);
                $c50c847760b2fc91$var$recalcOrderTotals(r);
                (0, $b2411514bdf07434$export$b7c121695885def)(r);
                const hidden = r?.querySelector('#payment_prazos');
                $c50c847760b2fc91$var$hydratePaymentPrazos(r, hidden?.value);
                $c50c847760b2fc91$var$bindPaymentPrazos(r);
                $c50c847760b2fc91$var$syncStatusApprovalLock(r);
                $c50c847760b2fc91$var$applyInputOrderEditLock(fs);
            }, 0);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#users', 'users');
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ],
                value: 'id'
            });
            formset.loadList('#receipt_types', 'receipt_types', {
                labels: [
                    'code',
                    'description'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = formset.dialog?.getNode?.()?.querySelector(this.selector) || document.querySelector(this.selector);
            (0, $b2411514bdf07434$export$c784f48aeddf3f03)(root);
            if (root) {
                const ret = root.querySelector('#is_return');
                const sup = root.querySelector('#supplier_id');
                const cust = root.querySelector('#customer_id');
                const companyEl = root.querySelector('#company_id');
                const sync = ()=>{
                    const on = !!(ret && ret.checked);
                    this.partyVisibilitySync(root);
                    if (on && sup) sup.value = '';
                    if (!on && cust) cust.value = '';
                };
                if (ret) ret.addEventListener('change', sync);
                this.partyVisibilitySync(root);
                const tbl = root.querySelector('.sial-items-scroll table');
                if (tbl) tbl.addEventListener('input', ()=>$c50c847760b2fc91$var$recalcOrderTotals(root));
                $c50c847760b2fc91$var$bindPaymentPrazos(root);
                if (companyEl) companyEl.addEventListener('change', ()=>$c50c847760b2fc91$var$syncStatusApprovalLock(root));
                $c50c847760b2fc91$var$syncStatusApprovalLock(root);
            }
        }
    },
    fields: [
        {
            properties: {
                selector: '#edit_locked_by_input'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#nf_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#created_by'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#updated_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#updated_by'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#supplier_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('suppliers', {
                    labels: [
                        'cnpj',
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('customers', {
                    labels: [
                        'nick',
                        'name',
                        'cnpj',
                        'cpf'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#carrier_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('carriers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#empenho_number'
            },
            types: [
                $gBwx4.default(),
                $01514eb1e21db7c4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#amil_oc'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#receipt_type_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('receipt_types', {
                    labels: [
                        'code',
                        'description'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#freight_type'
            },
            types: [
                $fyCkJ.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#freight_value'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#discount'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#payment_installment_count'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#payment_base_date'
            },
            types: []
        },
        {
            properties: {
                selector: '#payment_prazos'
            },
            types: []
        },
        {
            properties: {
                selector: '#io_prazo_0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_1'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_2'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_3'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_4'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_5'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_6'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_7'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_8'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_9'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_10'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_prazo_11'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#is_return'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $79f43e37b9b6ec01$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ],
                    filter: (r)=>!r.is_disabled
                })
            ]
        },
        {
            properties: {
                selector: '#unit_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'company_id',
                    'product_id-0'
                ]),
                $f7ae7d91f57919c4$export$2e2bcd8739ae039(1)
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#serial-0'
            },
            types: [
                $gBwx4.default()
            ]
        },
        // Até 10 casas (MS/SUS), sem completar zeros visuais desnecessários.
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $3eqAU.default(10, 0, ',', '.', false)
            ]
        },
        {
            properties: {
                selector: '#item_total-0'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $84MPM = parcelRequire("84MPM");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $7586a89680f71d54$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input-order-upload #company_id { width: 100%; }
			#input-order-upload #supplier_id { width: 100%; }
			#input-order-upload #program_id { width: 100%; }
			#input-order-upload #file { width: 100%; }
		</style>
		<form id="input-order-upload" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="suppliers"></datalist>
			<datalist id="programs"></datalist>
			<div class="title">Upload de planilha para pedido de entrada</div>
			<p class="mts">Planilha CSV (separador <strong>;</strong> ou <strong>,</strong>) com colunas: <strong>SKU</strong>, <strong>Quantidade</strong> e opcionalmente <strong>Pre\xe7o</strong> ou <strong>Vlr</strong>. XLSX tamb\xe9m \xe9 aceito.</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Fornecedor">Fornecedor<sup>*</sup>
					<input id="supplier_id" type="text" list="suppliers" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Programa">Programa
					<input id="program_id" type="text" list="programs">
				</label>
			</div>
			<div class="fsb">
				<label title="Arquivo CSV ou XLSX">Arquivo<sup>*</sup>
					<input id="file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Processar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input-order-upload',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#suppliers', 'suppliers', {
                labels: [
                    'cnpj',
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init?.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#supplier_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('suppliers')
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs')
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: [
                $6Jl4s.default(),
                $84MPM.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $84MPM = parcelRequire("84MPM");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $d3554f3253075994$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input-order-xml-import #company_id { width: 100%; }
			#input-order-xml-import #program_id { width: 100%; }
			#input-order-xml-import #file { width: 100%; }
		</style>
		<form id="input-order-xml-import" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="programs"></datalist>
			<div class="title">Importar XML NF-e (Pedido + Entrada)</div>
			<p class="mts">
				L\xea a NF-e de compra, cria o <strong>Pedido de Entrada</strong> e j\xe1 gera a <strong>Entrada</strong>
				com o XML gravado. Produtos s\xe3o casados por EAN/GTIN, refer\xeancia ou SKU; itens sem match
				podem usar sugest\xf5es semelhantes ou ficar de fora (parcial).
			</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Programa">Programa
					<input id="program_id" type="text" list="programs">
				</label>
			</div>
			<div class="fsb">
				<label title="Arquivo XML da NF-e">Arquivo XML<sup>*</sup>
					<input id="file" type="file" accept=".xml,text/xml,application/xml" required>
				</label>
			</div>
			<div class="mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Analisar XML</button>
			</div>
		</form>
	`,
    form: {
        selector: '#input-order-xml-import',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init?.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs')
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: [
                $6Jl4s.default(),
                $84MPM.default()
            ]
        }
    ]
};


/**
 * View do resultado do upload de planilha para pedido.
 * Exibe: pedido criado, SKU não encontrado, Lote não encontrado, sem estoque, pendentes.
 */ var $3dc30afed7448525$export$2e2bcd8739ae039 = (result, orderType = 'output')=>{
    const { order_id: order_id, sku_nao_encontrado: sku_nao_encontrado = [], lote_nao_encontrado: lote_nao_encontrado = [], sem_estoque: sem_estoque = [], pendentes: pendentes = [] } = result || {};
    const parts = [];
    if (order_id) parts.push(`<p class="mts"><strong>Pedido #${order_id}</strong> criado.</p>`);
    else if (orderType === 'output' && (sku_nao_encontrado?.length || lote_nao_encontrado?.length || sem_estoque?.length || pendentes?.length)) parts.push(`<p class="mts">Nenhum item p\xf4de ser inclu\xeddo no pedido (todos SKU n\xe3o encontrados, lote n\xe3o encontrado ou sem estoque).</p>`);
    else if (orderType === 'input' && sku_nao_encontrado?.length) parts.push(`<p class="mts">Nenhum item p\xf4de ser inclu\xeddo no pedido (todos SKU n\xe3o encontrados).</p>`);
    if (sku_nao_encontrado?.length) {
        parts.push(`<p class="mtm"><strong>SKU n\xe3o encontrado</strong>:</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Quantidade</th><th>Lote</th><th>Vlr</th></tr></thead><tbody>`);
        sku_nao_encontrado.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.quantidade ?? ''}</td><td>${r.lote ?? ''}</td><td>${r.vlr ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    if (orderType === 'output' && lote_nao_encontrado?.length) {
        parts.push(`<p class="mtm"><strong>Lote n\xe3o encontrado</strong>:</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Quantidade</th><th>Vlr</th></tr></thead><tbody>`);
        lote_nao_encontrado.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.quantidade ?? ''}</td><td>${r.vlr ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    if (sem_estoque?.length) {
        parts.push(`<p class="mtm"><strong>Sem estoque</strong>:</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Solicitado</th><th>Atendido</th><th>Pendente</th></tr></thead><tbody>`);
        sem_estoque.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.solicitado ?? ''}</td><td>${r.atendido ?? 0}</td><td>${r.pendente ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    if (pendentes?.length) {
        parts.push(`<p class="mtm"><strong>Pendente</strong> (parcial):</p>`);
        parts.push(`<table class="bordered mts" style="width:100%"><thead><tr><th>SKU</th><th>Lote</th><th>Solicitado</th><th>Atendido</th><th>Pendente</th></tr></thead><tbody>`);
        pendentes.forEach((r)=>parts.push(`<tr><td>${r.sku || ''}</td><td>${r.lote ?? ''}</td><td>${r.solicitado ?? ''}</td><td>${r.atendido ?? ''}</td><td>${r.pendente ?? ''}</td></tr>`));
        parts.push(`</tbody></table>`);
    }
    return parts.join('') || '<p class="mts">Processamento conclu\xeddo.</p>';
};



var $h1m6J = parcelRequire("h1m6J");

var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $fyCkJ = parcelRequire("fyCkJ");

const $41d7c55d2e4dc43d$var$inputOrders = function() {
    let input_orders_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        // Inclui Atendimento (28) e Agendamento (32) — #MT-B2FA396 Fase 4
        default_columns: '1,2,3,4,5,6,7,8,10,11,12,13,14,15,16,17,18,19,20,21,28,32,22,23',
        async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options = {}) {
            try {
                const raw = localStorage.getItem('input_orders.setup');
                if (raw) {
                    const s = JSON.parse(raw);
                    if (!s.io_grid_dock_schedule_v1) {
                        const cols = String(s.columns || this.default_columns).split(',').map((c)=>c.trim()).filter(Boolean);
                        if (!cols.includes('32')) cols.push('32');
                        if (!cols.includes('28')) cols.push('28');
                        s.columns = cols.join(',');
                        s.io_grid_dock_schedule_v1 = true;
                        localStorage.setItem('input_orders.setup', JSON.stringify(s));
                    }
                }
            } catch (_) {}
            return (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).run.call(this, module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options);
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_receipt_types, this.queryAll()).then((data)=>(0, $1cmSR.default).set('receipt_types', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_suppliers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('suppliers', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_carriers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('carriers', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_units, this.queryAll()).then((data)=>(0, $1cmSR.default).set('units', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_orders, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order, ...JSON.parse(id));
            if (_record && Array.isArray(_record.payment_prazos)) _record.payment_prazos = JSON.stringify(_record.payment_prazos);
            else if (_record && _record.payment_prazos != null && typeof _record.payment_prazos !== 'string') _record.payment_prazos = JSON.stringify(_record.payment_prazos);
            if (_record?.payment_base_date && typeof _record.payment_base_date === 'string' && _record.payment_base_date.length > 10) _record.payment_base_date = _record.payment_base_date.slice(0, 10);
            return (0, $b60a2.flatten)(_record, 'items');
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'items');
            const isReturn = data.is_return == '1';
            let statusVal = Number(data.status);
            try {
                const company = await (0, $1cmSR.default).get('companies', data.company_id) || await (0, $1cmSR.default).get('companies', [
                    data.company_id
                ]);
                if (company?.input_orders_require_approval) {
                    if (old_data) statusVal = Number(old_data.status);
                    else statusVal = 10;
                }
            } catch (_) {}
            let _record = {
                reference: data.reference,
                supplier_id: isReturn ? null : Number(data.supplier_id),
                customer_id: isReturn ? Number(data.customer_id) : null,
                carrier_id: Number(data.carrier_id),
                program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
                freight_type: data.freight_type,
                freight_value: Number(data.freight_value),
                discount: Number(data.discount),
                notes: data.notes?.trim(),
                empenho_number: data.empenho_number && String(data.empenho_number).trim() ? String(data.empenho_number).trim().replace(/\s+/g, '') : null,
                amil_oc: data.amil_oc && String(data.amil_oc).trim() ? String(data.amil_oc).trim().slice(0, 60) : null,
                nf_number: data.nf_number && String(data.nf_number).trim() ? String(data.nf_number).trim().slice(0, 120) : null,
                receipt_type_id: data.receipt_type_id != null && data.receipt_type_id !== '' ? Number(data.receipt_type_id) : null,
                is_return: isReturn,
                status: statusVal,
                payment_installment_count: (()=>{
                    const n = Number(data.payment_installment_count);
                    return Number.isFinite(n) && n > 0 ? n : null;
                })(),
                payment_prazos: (()=>{
                    const count = Number(data.payment_installment_count);
                    const list = [];
                    const n = Number.isFinite(count) && count > 0 ? Math.min(12, count) : 0;
                    for(let i = 0; i < n; i++){
                        const raw = data[`io_prazo_${i}`];
                        const days = Number(raw);
                        list.push(Number.isFinite(days) ? days : 0);
                    }
                    if (list.length) return list;
                    if (typeof data.payment_prazos === 'string' && data.payment_prazos.trim()) try {
                        const parsed = JSON.parse(data.payment_prazos);
                        return Array.isArray(parsed) ? parsed.map((x)=>Number(x) || 0) : null;
                    } catch (_) {
                        return null;
                    }
                    return Array.isArray(data.payment_prazos) ? data.payment_prazos.map((x)=>Number(x) || 0) : null;
                })(),
                payment_base_date: data.payment_base_date && String(data.payment_base_date).trim() ? String(data.payment_base_date).trim().slice(0, 10) : null,
                items: (data.items || []).filter((item)=>item && item.product_id != null && item.product_id !== '' && Number(item.product_id) > 0).map((item)=>({
                        product_id: Number(item.product_id),
                        unit_id: Number(item.unit_id),
                        quantity: Number(item.quantity),
                        unit_price: Number(item.unit_price),
                        serial: item.serial && String(item.serial).trim() ? String(item.serial).trim().slice(0, 20) : null
                    }))
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_input_order, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_input_order, data.company_id, _record);
        },
        editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            this.loadPage(1);
        },
        uploadFromSpreadsheet () {
            const showResult = (result)=>{
                (0, $jUNyh.notify)((0, $3dc30afed7448525$export$2e2bcd8739ae039)(result, 'input'), 'Resultado do upload');
                this.loadPage();
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const formNode = document.querySelector((0, $7586a89680f71d54$export$2e2bcd8739ae039).form.selector);
                const fileInput = formNode?.querySelector('#file');
                const file = fileInput?.files?.[0];
                if (!file) {
                    (0, $jUNyh.notify)('Selecione um arquivo CSV ou XLSX.');
                    return;
                }
                const company_id = data.company_id;
                if (!company_id) {
                    (0, $jUNyh.notify)('Selecione a empresa.');
                    return;
                }
                const fd = new FormData();
                fd.append('file', file);
                fd.append('supplier_id', data.supplier_id);
                fd.append('program_id', data.program_id || '');
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).upload_input_order, company_id, fd);
                if (result) showResult(result);
            };
            const setupTemplateLink = (fs)=>{
                const link = fs.dialog.getNode().querySelector('#download-template');
                if (link) link.onclick = async (e)=>{
                    e.preventDefault();
                    const company_id = fs.form.getValues().company_id;
                    if (!company_id) {
                        (0, $jUNyh.notify)('Selecione a empresa para baixar o modelo.');
                        return;
                    }
                    const csv = await (0, $9VcS9.default).call((0, $9VcS9.default).order_upload_template, company_id);
                    if (csv && typeof csv === 'string') {
                        const blob = new Blob([
                            csv
                        ], {
                            type: 'text/csv;charset=utf-8'
                        });
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = 'modelo_pedido_upload.csv';
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                };
            };
            const fs = (0, $h1m6J.default).create((0, $7586a89680f71d54$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                setupTemplateLink(fs);
            })();
        },
        importFromXml () {
            const crudRef = this;
            const openConfirm = async (company_id, program_id, preview)=>{
                const matched = preview.items_matched || [];
                const unmatched = preview.items_unmatched || [];
                const suppliers = await (0, $1cmSR.default).list('suppliers').catch(()=>[]) || [];
                const companySuppliers = suppliers.filter((s)=>String(s.company_id) === String(company_id));
                const supplierOptions = companySuppliers.map((s)=>`<option value="${s.id}">${(s.cnpj || '').toString()} \u{2014} ${(s.nick || s.name || '').toString()}</option>`).join('');
                const matchedRows = matched.map((it, i)=>`
					<tr data-kind="matched" data-idx="${i}">
						<td>${it.cProd || ''}</td>
						<td>${it.xProd || ''}</td>
						<td>${it.sku || ''}</td>
						<td>${it.name || ''}</td>
						<td>${it.quantity ?? ''}</td>
						<td>${it.unit_price ?? ''}</td>
						<td><input type="hidden" class="io-xml-pid" value="${it.product_id}"></td>
					</tr>`).join('');
                const unmatchedRows = unmatched.map((it, i)=>{
                    const opts = (it.suggestions || []).map((s)=>`<option value="${s.product_id}">${s.sku || ''} \u{2014} ${(s.name || '').toString().slice(0, 60)} (${Math.round((s.score || 0) * 100)}%)</option>`).join('');
                    return `
					<tr data-kind="unmatched" data-idx="${i}">
						<td>${it.cProd || ''}</td>
						<td title="${(it.skip_reason || '').toString()}">${it.xProd || ''}${it.skip_reason ? " \u26A0" : ''}</td>
						<td colspan="2">
							<select class="io-xml-pid" style="width:100%">
								<option value="">\u{2014} sem v\xednculo \u{2014}</option>
								${opts}
							</select>
						</td>
						<td>${it.quantity ?? ''}</td>
						<td>${it.unit_price ?? ''}</td>
						<td></td>
					</tr>`;
                }).join('');
                const html = `
					<div class="msgbox" style="min-width:720px;max-width:960px;max-height:85vh;overflow:auto">
						<div class="mb-title">Confirmar importa\xe7\xe3o XML</div>
						<div class="mb-text">
							<p style="margin:0 0 0.5rem">
								NF <strong>${preview.invoice_number || ''}</strong>
								${preview.invoice_series ? ` s\xe9rie ${preview.invoice_series}` : ''}
								\u{2014} Emitente: ${preview.emit_name || ''} (${preview.emit_cnpj || 'sem CNPJ'})
							</p>
							${preview.duplicate_warning ? `<p style="color:#a60;margin:0 0 0.5rem">${preview.duplicate_warning}</p>` : ''}
							<label style="display:block;margin:0.5rem 0">Fornecedor<sup>*</sup>
								<select id="io-xml-supplier" style="width:100%" required>
									<option value="">\u{2014} selecione \u{2014}</option>
									${supplierOptions}
								</select>
							</label>
							<p class="mts"><strong>Itens casados (${matched.length})</strong></p>
							<table class="bordered" style="width:100%;font-size:0.9em"><thead>
								<tr><th>cProd</th><th>Descri\xe7\xe3o XML</th><th>SKU</th><th>Produto</th><th>Qtd</th><th>Pre\xe7o</th><th></th></tr>
							</thead><tbody>${matchedRows || '<tr><td colspan="7">Nenhum</td></tr>'}</tbody></table>
							<p class="mts"><strong>Sem match / sugest\xf5es (${unmatched.length})</strong></p>
							<table class="bordered" style="width:100%;font-size:0.9em"><thead>
								<tr><th>cProd</th><th>Descri\xe7\xe3o XML</th><th colspan="2">Associar produto</th><th>Qtd</th><th>Pre\xe7o</th><th></th></tr>
							</thead><tbody>${unmatchedRows || '<tr><td colspan="7">Nenhum</td></tr>'}</tbody></table>
							<p style="margin:0.75rem 0 0;color:#666;font-size:0.92em">
								Cria Pedido (j\xe1 aprovado) + Entrada com XML. Itens sem produto ficam de fora se confirmar parcial.
							</p>
						</div>
						<button type="button" class="button mtl bn_N">Cancelar</button>
						<button type="button" class="button mtl bn_Y">Confirmar</button>
					</div>
				`;
                const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                    if (key === 'Escape' || key === 'N') {
                        dlg.destroy();
                        return;
                    }
                    if (key !== 'Y') return;
                    const root = dlg.getNode();
                    const supplier_id = root.querySelector('#io-xml-supplier')?.value;
                    if (!supplier_id) {
                        (0, $jUNyh.notify)('Selecione o fornecedor.', 'Importar XML');
                        return;
                    }
                    const items = [];
                    let stillUnmatched = 0;
                    matched.forEach((it)=>{
                        if (it.product_id && it.quantity > 0) items.push({
                            product_id: it.product_id,
                            quantity: it.quantity,
                            unit_price: it.unit_price
                        });
                    });
                    root.querySelectorAll('tr[data-kind="unmatched"]').forEach((tr, i)=>{
                        const it = unmatched[i];
                        const pid = tr.querySelector('.io-xml-pid')?.value;
                        if (pid && it?.quantity > 0 && !it.skip_reason) items.push({
                            product_id: Number(pid),
                            quantity: it.quantity,
                            unit_price: it.unit_price
                        });
                        else stillUnmatched += 1;
                    });
                    if (!items.length) {
                        (0, $jUNyh.notify)("Nenhum item v\xe1lido para importar.", 'Importar XML');
                        return;
                    }
                    const doConfirm = async (confirm_partial)=>{
                        try {
                            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).confirm_input_order_xml, company_id, {
                                supplier_id: Number(supplier_id),
                                program_id: program_id || null,
                                invoice_number: preview.invoice_number,
                                invoice_series: preview.invoice_series,
                                volumes: preview.volumes,
                                weight: preview.weight,
                                xml_base64: preview.xml_base64,
                                items: items,
                                confirm_partial: confirm_partial,
                                unmatched_count: stillUnmatched
                            });
                            dlg.destroy();
                            (0, $jUNyh.notify)(`Pedido #${result.order_id} e Entrada #${result.input_id} criados` + (result.unmatched_skipped ? ` (${result.unmatched_skipped} item(ns) do XML sem v\xednculo).` : '.'), "Importa\xe7\xe3o XML");
                            crudRef.loadPage();
                        } catch (e) {
                            (0, $jUNyh.notify)(e?.message || String(e), "Erro na importa\xe7\xe3o");
                        }
                    };
                    if (stillUnmatched > 0) (0, $jUNyh.ask)(`H\xe1 ${stillUnmatched} item(ns) do XML sem produto. Confirma importa\xe7\xe3o parcial s\xf3 com os itens vinculados?`, "Importa\xe7\xe3o parcial", async (answer)=>{
                        if (answer === 'Y') await doConfirm(true);
                    });
                    else await doConfirm(false);
                }, /Escape|N|Y/);
                const sel = dlg.getNode()?.querySelector('#io-xml-supplier');
                if (sel && preview.supplier_id) sel.value = String(preview.supplier_id);
            };
            const sendRequest = async (data)=>{
                const formNode = document.querySelector((0, $d3554f3253075994$export$2e2bcd8739ae039).form.selector);
                const fileInput = formNode?.querySelector('#file');
                const file = fileInput?.files?.[0];
                if (!file) {
                    (0, $jUNyh.notify)('Selecione o arquivo XML.');
                    return;
                }
                const company_id = data.company_id;
                if (!company_id) {
                    (0, $jUNyh.notify)('Selecione a empresa.');
                    return;
                }
                const fd = new FormData();
                fd.append('file', file);
                try {
                    const preview = await (0, $9VcS9.default).call((0, $9VcS9.default).preview_input_order_xml, company_id, fd);
                    if (!preview) return;
                    fs.destroy();
                    await openConfirm(company_id, data.program_id || null, preview);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao analisar XML');
                }
            };
            const fs = (0, $h1m6J.default).create((0, $d3554f3253075994$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        printOrderDocument () {
            if (!this.ensureSelection('Documento de Pedido de Entrada')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_order_document, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Gerar documento de ${this.getCount()} pedido(s)?`, 'Documento de Pedido de Entrada', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async approveOrders () {
            const selectedIds = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selectedIds?.length) {
                (0, $jUNyh.notify)('Selecione ao menos um pedido para aprovar.', 'Aprovar Selecionados');
                return;
            }
            const byCompany = {};
            for (const pair of selectedIds){
                const [company_id, id] = pair;
                if (!byCompany[company_id]) byCompany[company_id] = [];
                byCompany[company_id].push(id);
            }
            const totalOrders = selectedIds.length;
            const html = `
				<div class="msgbox" style="min-width:340px;max-width:500px">
					<div class="mb-title">Aprovar Pedidos de Entrada</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">
							Confirma a aprova\xe7\xe3o de <strong>${totalOrders} pedido${totalOrders !== 1 ? 's' : ''}</strong> selecionado${totalOrders !== 1 ? 's' : ''}?
						</p>
						<p style="margin:0;color:#888;font-size:0.92em">
							Apenas pedidos com status <strong>Criado</strong> ser\xe3o aprovados.
							Pedidos em outros status ser\xe3o ignorados.
						</p>
					</div>
					<button type="button" class="button mtl bn_N">Cancelar</button>
					<button type="button" class="button mtl bn_Y">Aprovar</button>
				</div>
			`;
            const crudRef = this;
            const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                if (key === 'Escape' || key === 'N') {
                    dlg.destroy();
                    return;
                }
                if (key === 'Y') {
                    dlg.destroy();
                    try {
                        let totalApproved = 0;
                        let totalSkipped = 0;
                        for (const [company_id, ids] of Object.entries(byCompany)){
                            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).approve_input_orders_batch, company_id, {
                                ids: ids
                            });
                            totalApproved += result?.approved || 0;
                            totalSkipped += result?.skipped || 0;
                        }
                        if (totalApproved > 0) {
                            (0, $jUNyh.notify)(`${totalApproved} pedido${totalApproved !== 1 ? 's' : ''} aprovado${totalApproved !== 1 ? 's' : ''} com sucesso.` + (totalSkipped > 0 ? ` ${totalSkipped} ignorado${totalSkipped !== 1 ? 's' : ''} (status diferente de Criado).` : ''), "Aprova\xe7\xe3o em lote");
                            crudRef.loadPage();
                        } else (0, $jUNyh.notify)("Nenhum pedido foi aprovado. Verifique se os pedidos selecionados est\xe3o com status Criado.", "Aprova\xe7\xe3o em lote");
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao aprovar pedidos');
                    }
                }
            }, /Escape|N|Y/);
        },
        async rejectOrders () {
            const selectedIds = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selectedIds?.length) {
                (0, $jUNyh.notify)('Selecione ao menos um pedido para rejeitar.', 'Rejeitar Selecionados');
                return;
            }
            const byCompany = {};
            for (const pair of selectedIds){
                const [company_id, id] = pair;
                if (!byCompany[company_id]) byCompany[company_id] = [];
                byCompany[company_id].push(id);
            }
            const totalOrders = selectedIds.length;
            const html = `
				<div class="msgbox" style="min-width:360px;max-width:520px">
					<div class="mb-title">Rejeitar Pedidos de Entrada</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">
							Confirma a rejei\xe7\xe3o de <strong>${totalOrders} pedido${totalOrders !== 1 ? 's' : ''}</strong>?
							Pedidos passam para status <strong>Cancelado</strong>.
						</p>
						<p style="margin:0 0 0.5rem;color:#888;font-size:0.92em">
							Apenas pedidos com status <strong>Criado</strong> ser\xe3o rejeitados.
						</p>
						<label style="display:block;margin:0.5rem 0 0.25rem">Motivo (opcional)</label>
						<textarea id="reject_reason" rows="3" style="width:100%;box-sizing:border-box" placeholder="Motivo da rejei\xe7\xe3o"></textarea>
					</div>
					<button type="button" class="button mtl bn_N">Cancelar</button>
					<button type="button" class="button mtl bn_Y">Rejeitar</button>
				</div>
			`;
            const crudRef = this;
            const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                if (key === 'Escape' || key === 'N') {
                    dlg.destroy();
                    return;
                }
                if (key === 'Y') {
                    const reason = dlg.getNode()?.querySelector('#reject_reason')?.value?.trim() || '';
                    dlg.destroy();
                    try {
                        let totalRejected = 0;
                        let totalSkipped = 0;
                        for (const [company_id, ids] of Object.entries(byCompany)){
                            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).reject_input_orders_batch, company_id, {
                                ids: ids,
                                reason: reason || null
                            });
                            totalRejected += result?.rejected || 0;
                            totalSkipped += result?.skipped || 0;
                        }
                        if (totalRejected > 0) {
                            (0, $jUNyh.notify)(`${totalRejected} pedido${totalRejected !== 1 ? 's' : ''} rejeitado${totalRejected !== 1 ? 's' : ''} com sucesso.` + (totalSkipped > 0 ? ` ${totalSkipped} ignorado${totalSkipped !== 1 ? 's' : ''} (status diferente de Criado).` : ''), "Rejei\xe7\xe3o em lote");
                            crudRef.loadPage();
                        } else (0, $jUNyh.notify)("Nenhum pedido foi rejeitado. Verifique se os pedidos selecionados est\xe3o com status Criado.", "Rejei\xe7\xe3o em lote");
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao rejeitar pedidos');
                    }
                }
            }, /Escape|N|Y/);
        },
        /**
		 * #MT-B2FA396 Fase 4 — Agendar Doca a partir do Pedido de Entrada.
		 * Se já houver agenda ativa, abre o detalhe; senão abre o fluxo de criação.
		 */ async openDockSchedule () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)('Selecione exatamente um Pedido de Entrada.', 'Agendar Doca');
            const [company_id, order_id] = ids[0];
            const company = (await (0, $1cmSR.default).list('companies').catch(()=>[]) || []).find((c)=>String(c.id) === String(company_id));
            const flag = company?.in_dock_scheduling_enabled;
            if (flag === false || flag === 0 || flag === '0' || flag === 'false') return (0, $jUNyh.notify)("Agendamento de Docas de Entrada n\xe3o est\xe1 habilitado para esta empresa.", 'Agendar Doca');
            const active = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order_dock_schedule, company_id, order_id);
            if (active?.schedule && (0, $b8167635cb1083d7$export$f3694d65cc0718f)(active.schedule.status)) {
                (0, $b8167635cb1083d7$export$56563c28d49804f7)({
                    payload: active,
                    onDone: ()=>this.reloadPage()
                });
                return;
            }
            const nick = company?.nick || company_id;
            (0, $b8167635cb1083d7$export$bc9d4cb3bb8226a4)({
                mode: 'create',
                companyId: company_id,
                companyNick: nick,
                inputOrderId: Number(order_id),
                useOrderScopedCreate: true,
                onDone: ()=>this.reloadPage()
            });
        },
        /**
		 * #MT-B2FA396 Fase 4 — Ver agendamento (ativo ou último hidratado).
		 */ async openDockScheduleDetail () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)('Selecione exatamente um Pedido de Entrada.', 'Ver Agendamento');
            const [company_id, order_id] = ids[0];
            let payload = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order_dock_schedule, company_id, order_id);
            if (!payload?.schedule) {
                const order = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order, company_id, order_id);
                const sid = order?.dock_schedule_id;
                if (sid) payload = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_dock_schedule, company_id, sid);
            }
            if (!payload?.schedule) return (0, $jUNyh.notify)("Este pedido n\xe3o possui agendamento de doca.", 'Ver Agendamento');
            (0, $b8167635cb1083d7$export$56563c28d49804f7)({
                payload: payload,
                onDone: ()=>this.reloadPage()
            });
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Pedido',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do pedido'
        },
        {
            index: 3,
            field: 'reference',
            label: "Refer\xeancia",
            types: [],
            placeholder: '',
            title: "C\xf3digo de refer\xeancia externa do pedido"
        },
        {
            index: 4,
            field: 'created_on',
            label: "Data Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de cria\xe7\xe3o do pedido"
        },
        {
            index: 5,
            field: 'created_by',
            label: 'Criado Por',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Usu\xe1rio criador do pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'updated_on',
            label: "Data Altera\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima atualiza\xe7\xe3o do pedido"
        },
        {
            index: 7,
            field: 'updated_by',
            label: 'Alterado Por',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "\xdaltimo usu\xe1rio a atualizar o pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 8,
            field: 'supplier_id',
            label: 'Fornecedor',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Fornecedor (CNPJ + apelido)',
            store: 'suppliers',
            labels: [
                'cnpj',
                'nick'
            ]
        },
        // Índices = posição no SQL_BASE_SELECT (repos/input_orders.py). customer_id=9 (sem coluna na grade).
        {
            index: 10,
            field: 'carrier_id',
            label: 'Transportador',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Transportador',
            store: 'carriers',
            labels: [
                'nick'
            ]
        },
        {
            index: 11,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa sugerido para a entrada',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 12,
            field: 'freight_type',
            label: 'Tipo Frete',
            types: [
                $fyCkJ.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de frete'
        },
        {
            index: 13,
            field: 'freight_value',
            label: 'Valor Frete',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor do frete'
        },
        {
            index: 14,
            field: 'discount',
            label: '% Desconto',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Percentual de desconto'
        },
        {
            index: 15,
            field: 'value',
            label: 'Valor',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor do pedido'
        },
        {
            index: 16,
            field: 'notes',
            label: "Observa\xe7\xf5es",
            types: [],
            placeholder: '',
            title: "Observa\xe7\xf5es do pedido"
        },
        {
            index: 18,
            field: 'empenho_number',
            label: "N\xba empenho",
            types: [],
            placeholder: '2025NE02173',
            title: "N\xfamero do empenho (AAAA+NE+n\xfamero)"
        },
        {
            index: 19,
            field: 'amil_oc',
            label: 'OC Amil',
            types: [],
            placeholder: '4000222822',
            title: 'Ordem de compra (OC) AMIL para rastreio'
        },
        {
            index: 20,
            field: 'receipt_type_id',
            label: 'Tipo recebimento',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de recebimento',
            store: 'receipt_types',
            labels: [
                'code',
                'description'
            ]
        },
        {
            index: 21,
            field: 'is_return',
            label: "Devolu\xe7\xe3o",
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Indicador de devolu\xe7\xe3o"
        },
        {
            index: 17,
            field: 'nf_number',
            label: 'NF',
            types: [],
            placeholder: '',
            title: 'NF de entrada do fornecedor (agrupador)'
        },
        {
            index: 28,
            field: 'fulfillment_status',
            label: 'Atendimento',
            types: [
                $cabf10de07f42bb1$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Pendente / Parcial / Atendido total (vs entradas conclu\xeddas)"
        },
        {
            index: 32,
            field: 'dock_schedule_status',
            label: 'Agendamento',
            types: [],
            placeholder: '',
            title: 'Status do agendamento de doca (derivado)',
            computed: true
        },
        {
            index: 22,
            field: 'status',
            label: 'Status',
            types: [
                $79f43e37b9b6ec01$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status do pedido'
        },
        {
            index: 23,
            field: 'payment_installment_count',
            label: 'Qtd parcelas',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '',
            title: "Quantidade de parcelas da condi\xe7\xe3o de pagamento"
        },
        {
            index: 30,
            field: 'lines_sku_summary',
            label: 'SKU (itens)',
            types: [],
            placeholder: 'trecho do SKU',
            title: "Busca nos SKUs das linhas do pedido (operador Cont\xe9m recomendado)"
        },
        {
            index: 31,
            field: 'lines_product_summary',
            label: 'Produto (itens)',
            types: [],
            placeholder: 'nome do produto',
            title: "Busca nos nomes dos produtos das linhas (operador Cont\xe9m recomendado)"
        }
    ];
    let operations = [
        {
            hash: '#upload',
            label: 'Upload&nbsp;planilha'
        },
        {
            hash: '#import-xml',
            label: 'Importar&nbsp;XML&nbsp;NF-e'
        },
        {
            hash: '#approve-orders',
            label: 'Aprovar&nbsp;selecionados'
        },
        {
            hash: '#reject-orders',
            label: 'Rejeitar&nbsp;selecionados'
        },
        {
            hash: '#io-dock-schedule',
            label: 'Agendar&nbsp;Doca'
        },
        {
            hash: '#io-dock-schedule-detail',
            label: 'Ver&nbsp;Agendamento'
        }
    ];
    let reports = [
        {
            hash: '#print-order-doc',
            label: 'Documento&nbsp;do&nbsp;Pedido'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#upload', input_orders_crud.uploadFromSpreadsheet.bind(input_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#import-xml', input_orders_crud.importFromXml.bind(input_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#approve-orders', input_orders_crud.approveOrders.bind(input_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reject-orders', input_orders_crud.rejectOrders.bind(input_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-order-doc', input_orders_crud.printOrderDocument.bind(input_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#io-dock-schedule', ()=>input_orders_crud.openDockSchedule());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#io-dock-schedule-detail', ()=>input_orders_crud.openDockScheduleDetail());
    input_orders_crud.run('input_orders', 'Pedidos&nbsp;Entrada', document.getElementById('workarea'), (0, $175c09b2e159b26a$export$2e2bcd8739ae039), (0, $c50c847760b2fc91$export$2e2bcd8739ae039), fieldspecs, operations, reports, {
        default_columns: input_orders_crud.default_columns
    });
};
var $41d7c55d2e4dc43d$export$2e2bcd8739ae039 = $41d7c55d2e4dc43d$var$inputOrders;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $dx9qz = parcelRequire("dx9qz");

var $hWQyW = parcelRequire("hWQyW");


var $h1m6J = parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");


var $b7D1Q = parcelRequire("b7D1Q");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $fyCkJ = parcelRequire("fyCkJ");
var $6R5fG = parcelRequire("6R5fG");
var $5rlmp = parcelRequire("5rlmp");
async function $86c74365004cd66c$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(13)	{ text-align: left; }
			.view td:nth-child(14)	{ text-align: left; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: right; }
			.view td:nth-child(17)	{ text-align: right; }
			.view td:nth-child(18)	{ text-align: right; }
			.view td:nth-child(19)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(20)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(21)	{ text-align: left; }
			.view td:nth-child(22)	{ text-align: center; }
			.view td:nth-child(23)	{ text-align: left; }
			.view th:nth-child(24),
			.view td:nth-child(24),
			.view th:nth-child(25),
			.view td:nth-child(25)	{ text-align: left; max-width: 14rem; }
			.view th:nth-child(26),
			.view td:nth-child(26)	{ text-align: center; }
			.view th:nth-child(27),
			.view td:nth-child(27)	{ text-align: center; font-weight: 700; }
			.view th:nth-child(28),
			.view td:nth-child(28)	{ text-align: right; }
			.view th:nth-child(29),
			.view td:nth-child(29)	{ text-align: right; }
			.view th:nth-child(30),
			.view td:nth-child(30)	{ text-align: center; }
			.view tr.oo-row-emergency td { background: #fee2e2 !important; font-weight: 700; }
			.view td.oo-sim-neg { background: #fecaca !important; font-weight: 700; }
			.view td.oo-sim-warn { background: #fef08a !important; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Refer\xeancia</th>
					<th data-index="4" data-visible="${this.visible[3]}">Data Cria\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Criado Por</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data Altera\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[6]}">Alterado Por</th>
					<th data-index="8" data-visible="${this.visible[7]}">Cliente</th>
					<th data-index="30" data-visible="${this.visible[8]}">Rota</th>
					<th data-index="9" data-visible="${this.visible[9]}">Transportador</th>
					<th data-index="10" data-visible="${this.visible[10]}">Programa</th>
					<th data-index="11" data-visible="${this.visible[11]}">Atendimento</th>
					<th data-index="12" data-visible="${this.visible[12]}">Pagamento</th>
					<th data-index="13" data-visible="${this.visible[13]}">Condi\xe7\xe3o</th>
					<th data-index="14" data-visible="${this.visible[14]}">Tipo Frete</th>
					<th data-index="15" data-visible="${this.visible[15]}">Valor Frete</th>
					<th data-index="16" data-visible="${this.visible[16]}">% Desconto</th>
					<th data-index="17" data-visible="${this.visible[17]}">Valor</th>
					<th data-index="18" data-visible="${this.visible[18]}">Observa\xe7\xf5es</th>
					<th data-index="19" data-visible="${this.visible[19]}">Obs. livro eletr\xf4nico</th>
					<th data-index="20" data-visible="${this.visible[20]}">Devolu\xe7\xe3o</th>
				<th data-index="21" data-visible="${this.visible[21]}">Status</th>
				<th data-index="25" data-visible="${this.visible[22]}">Prev. Entrega</th>
				<th data-index="23" data-visible="${this.visible[23]}">SKU (itens)</th>
				<th data-index="24" data-visible="${this.visible[24]}">Produto (itens)</th>
				<th data-index="26" data-visible="${this.visible[25]}">Emergencial</th>
				<th data-visible="${this.visible[26]}" title="Calculado na p\xe1gina \u{2014} n\xe3o ordena pelo servidor">Pr\xe9-reserva pendente</th>
				<th data-visible="${this.visible[27]}" title="Calculado na p\xe1gina \u{2014} n\xe3o ordena pelo servidor">Saldo livre simulado</th>
				<th data-visible="${this.visible[28]}" title="Calculado na p\xe1gina \u{2014} n\xe3o ordena pelo servidor">Situa\xe7\xe3o estoque</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr class="${record.is_emergency ? 'oo-row-emergency' : ''}" data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($8IFAz.default(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.created_by)}</td>
					<td data-visible='${this.visible[5]}'>${this.format($8IFAz.default(), record.updated_on) || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.updated_by) || ''}</td>
					<td data-visible='${this.visible[7]}'>${await this.key('customers', [
            record.company_id,
            record.customer_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}' title="${record.route_name || ''}">${record.route_code || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('carriers', [
            record.company_id,
            record.carrier_id
        ], 'nick') || ''}</td>
					<td data-visible='${this.visible[10]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[11]}'>${this.option($5rlmp.default(), record.service_channel)}</td>
					<td data-visible='${this.visible[12]}'>${this.option($6R5fG.default(), record.payment_method)}</td>
					<td data-visible='${this.visible[13]}'>${await this.key('payment_terms', [
            record.company_id,
            record.payment_term_id
        ]) || ''}</td>
					<td data-visible='${this.visible[14]}'>${this.option($fyCkJ.default(), record.freight_type) || ''}</td>
					<td data-visible='${this.visible[15]}'>${record.freight_value ? this.format($3eqAU.default(2), record.freight_value) : ''}</td>
					<td data-visible='${this.visible[16]}'>${record.discount != null ? this.format($3eqAU.default(2), record.discount) : ''}</td>
					<td data-visible='${this.visible[17]}'>${this.format($3eqAU.default(2), record.value)}</td>
					<td data-visible='${this.visible[18]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[19]}'>${record.book_observation || ''}</td>
					<td data-visible='${this.visible[20]}'>${this.option($1Wvh7.default(), record.is_return)}</td>
				<td data-visible='${this.visible[21]}'>${this.option($05cf4050e889bf62$export$2e2bcd8739ae039(), record.status) || ''}</td>
				<td data-visible='${this.visible[22]}'>${this.format($b7D1Q.default(), record.expected_delivery_date) || ''}</td>
				<td data-visible='${this.visible[23]}'>${record.lines_sku_summary || ''}</td>
				<td data-visible='${this.visible[24]}'>${record.lines_product_summary || ''}</td>
				<td data-visible='${this.visible[25]}'>${record.is_emergency ? 'SIM' : 'NAO'}</td>
				<td data-visible='${this.visible[26]}'>${record.pre_reserved_pending == null ? "\u2014" : record.pre_reserved_pending}</td>
				<td data-visible='${this.visible[27]}' class="${record.stock_situation === 'SALDO_SIMULADO_NEGATIVO' ? 'oo-sim-neg' : record.stock_situation === 'ATENCAO' || record.stock_situation === 'VENCIMENTO_CRITICO' ? 'oo-sim-warn' : ''}">${record.simulated_available_quantity == null ? "\u2014" : record.simulated_available_quantity}</td>
				<td data-visible='${this.visible[28]}' class="${record.stock_situation === 'SALDO_SIMULADO_NEGATIVO' ? 'oo-sim-neg' : record.stock_situation === 'ATENCAO' || record.stock_situation === 'VENCIMENTO_CRITICO' ? 'oo-sim-warn' : ''}">${record.stock_situation || "\u2014"}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $fyCkJ = parcelRequire("fyCkJ");
var $6R5fG = parcelRequire("6R5fG");
var $5rlmp = parcelRequire("5rlmp");
var $6Jl4s = parcelRequire("6Jl4s");
var $knytZ = parcelRequire("knytZ");

var $9VcS9 = parcelRequire("9VcS9");
/**
 * Avisos de integração (falha/parcial) em formulários de pedido e saída (#MT-989C152).
 */ 
var $9VcS9 = parcelRequire("9VcS9");
const $408fd6d1f7aad081$var$BANNER_STYLE = `
	margin: 0 0 0.75rem 0;
	padding: 0.55rem 0.7rem;
	background: #fff7ed;
	border: 1px solid #fdba74;
	border-radius: 4px;
	color: #9a3412;
	font-size: 0.9em;
	line-height: 1.35;
`;
const $408fd6d1f7aad081$var$TITLE_STYLE = 'font-weight: 600; margin: 0 0 0.35rem 0;';
const $408fd6d1f7aad081$var$LIST_STYLE = 'margin: 0.25rem 0 0 1rem; padding: 0;';
const $408fd6d1f7aad081$var$LINK_STYLE = 'margin-top: 0.35rem; font-size: 0.92em;';
function $408fd6d1f7aad081$var$esc(s) {
    if (s == null || s === '') return '';
    const t = String(s);
    return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $408fd6d1f7aad081$var$formatDateTime(iso) {
    if (!iso) return "\u2014";
    try {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return String(iso);
        return d.toLocaleString('pt-BR', {
            dateStyle: 'short',
            timeStyle: 'short'
        });
    } catch (e) {
        return String(iso);
    }
}
function $408fd6d1f7aad081$var$centralUrlForEvent(eventId) {
    const base = '#integration-events';
    if (eventId == null || eventId === '') return base;
    return `${base}?open=${encodeURIComponent(eventId)}`;
}
async function $408fd6d1f7aad081$export$376b532903f2d911(opts) {
    const { formSelector: formSelector, bannerId: bannerId, companyId: companyId, entityType: entityType, entityId: entityId, integrationKeys: integrationKeys = [
        'vendatus'
    ] } = opts || {};
    const banner = document.querySelector(`${formSelector} #${bannerId}`);
    if (!banner) return;
    const hide = ()=>{
        banner.style.display = 'none';
        banner.innerHTML = '';
    };
    if (!companyId || entityId == null || entityId === '' || !entityType) {
        hide();
        return;
    }
    const params = new URLSearchParams({
        company_id: String(companyId),
        entity_type: String(entityType),
        entity_id: String(entityId),
        integration_keys: integrationKeys.join(','),
        days: '30',
        limit: '5'
    });
    try {
        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).integration_events_entity_alerts, `?${params.toString()}`);
        const alerts = Array.isArray(data?.alerts) ? data.alerts : [];
        if (!alerts.length) {
            hide();
            return;
        }
        const items = alerts.map((a)=>{
            const detail = a.detail || '';
            const statusPt = a.status === 'partial' ? 'parcial' : 'falha';
            return `<li><strong>${$408fd6d1f7aad081$var$esc(a.integration_label || a.integration_key)}</strong> (${statusPt}, ${$408fd6d1f7aad081$var$formatDateTime(a.date_time)}): ${$408fd6d1f7aad081$var$esc(a.message)}${detail ? `<br><span style="font-weight:normal">${$408fd6d1f7aad081$var$esc(detail)}</span>` : ''} \u{2014} <a href="${$408fd6d1f7aad081$var$centralUrlForEvent(a.id)}">ver na Central</a></li>`;
        });
        if (!items.length) {
            hide();
            return;
        }
        banner.style.cssText = $408fd6d1f7aad081$var$BANNER_STYLE;
        banner.style.display = 'block';
        banner.innerHTML = `
			<p style="${$408fd6d1f7aad081$var$TITLE_STYLE}">Integra\xe7\xe3o \u{2014} aten\xe7\xe3o operacional</p>
			<p style="margin:0">O ERP solicitou a\xe7\xe3o neste registro e o SIAL registrou falha ou resultado parcial nos \xfaltimos ${data?.days ?? 30} dias:</p>
			<ul style="${$408fd6d1f7aad081$var$LIST_STYLE}">${items.join('')}</ul>
			<p style="${$408fd6d1f7aad081$var$LINK_STYLE}"><a href="#integration-events">Abrir Central de Integra\xe7\xf5es</a></p>
		`;
    } catch (e) {
        hide();
    }
}





/** Código fiscal de atendimento Televendas (#MT-A61F144) — label NF-e: Teleatendimento */ const $3df4715102edd156$var$OO_DEFAULT_SERVICE_CHANNEL = '3';
function $3df4715102edd156$var$_parseSialNum(s) {
    const c = String(s ?? '').replace(/\./g, '').replace(',', '.');
    const n = parseFloat(c);
    return isFinite(n) ? n : 0;
}
function $3df4715102edd156$var$_fmtBRL(v) {
    return Number(v).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
function $3df4715102edd156$var$recalcOutputOrderLineNumbers(root) {
    if (!root) return;
    const tbody = root.querySelector('.sial-items-scroll tbody');
    if (!tbody) return;
    let seq = 0;
    tbody.querySelectorAll('tr.row').forEach((row)=>{
        const prodEl = row.querySelector('[id^="product_id-"]');
        if (!prodEl) return;
        const n = (prodEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const itemNoEl = row.querySelector(`#item_no-${n}`);
        if (!itemNoEl) return;
        seq += 1;
        const numHidden = row.querySelector(`#number-${n}`);
        let display = seq;
        if (numHidden && numHidden.value !== '' && numHidden.value != null) {
            const internal = parseInt(numHidden.value, 10);
            if (!isNaN(internal)) display = internal + 1;
        }
        itemNoEl.value = String(display);
    });
}
function $3df4715102edd156$var$recalcOutputOrderTotals(root) {
    if (!root) return;
    $3df4715102edd156$var$recalcOutputOrderLineNumbers(root);
    const tbody = root.querySelector('.sial-items-scroll tbody');
    const totalEl = root.querySelector('#oo-grand-total');
    if (!tbody) return;
    let grand = 0;
    tbody.querySelectorAll('tr.row').forEach((row)=>{
        const qEl = row.querySelector('[id^="quantity-"]');
        if (!qEl) return;
        const n = (qEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const qty = $3df4715102edd156$var$_parseSialNum(qEl.value);
        const price = $3df4715102edd156$var$_parseSialNum(row.querySelector(`#unit_price-${n}`)?.value);
        const disc = $3df4715102edd156$var$_parseSialNum(row.querySelector(`#discount-${n}`)?.value);
        const lineTotal = qty * price * (1 - disc / 100);
        const ti = row.querySelector(`#item_total-${n}`);
        if (ti) ti.value = qty > 0 || price > 0 ? $3df4715102edd156$var$_fmtBRL(lineTotal) : '';
        grand += lineTotal;
    });
    if (totalEl) totalEl.textContent = grand > 0 ? `Total do Pedido: ${$3df4715102edd156$var$_fmtBRL(grand)}` : '';
}
function $3df4715102edd156$var$applyNewOutputOrderDefaults(formset) {
    const vals = formset?.form?.getValues?.() || {};
    if (vals.id != null && vals.id !== '') return;
    const sc = formset?.form?.getFieldBySelector?.('#service_channel');
    if (sc && (sc.getValue?.() == null || sc.getValue?.() === '')) {
        sc.setValue($3df4715102edd156$var$OO_DEFAULT_SERVICE_CHANNEL);
        sc.refresh?.();
    }
    const pm = formset?.form?.getFieldBySelector?.('#payment_method');
    pm?.eraseValue?.();
    pm?.resetAuto?.();
    pm?.refresh?.();
}
/** Travamento quando há saída ativa: só transportador, condição, tipo/valor frete editáveis. */ function $3df4715102edd156$var$applyOutputOrderEditLock(fs) {
    const form = document.querySelector('#order');
    const banner = document.querySelector('#oo-lock-banner');
    if (!form) return;
    const vals = fs.form.getValues();
    const locked = vals.edit_locked_by_output === true || vals.edit_locked_by_output === 1 || vals.edit_locked_by_output === '1' || String(vals.edit_locked_by_output).toLowerCase() === 'true';
    form.classList.toggle('output-order--edit-locked', locked);
    if (banner) banner.style.display = locked ? 'block' : 'none';
    const toolbar = form.querySelector('.oo-footer span:first-child');
    const rowImgs = toolbar ? toolbar.querySelectorAll('img') : [];
    const allowSelectors = [
        '#carrier_id',
        '#payment_method',
        '#payment_term_id',
        '#freight_type',
        '#freight_value'
    ];
    if (!locked) {
        form.querySelectorAll('[data-oo-lock-disabled]').forEach((el)=>{
            el.removeAttribute('data-oo-lock-disabled');
            el.removeAttribute('disabled');
        });
        rowImgs.forEach((img)=>{
            img.style.pointerEvents = '';
            img.style.opacity = '';
        });
        return;
    }
    form.querySelectorAll('input, select, textarea, button').forEach((el)=>{
        if (el.type === 'hidden') return;
        if (el.tagName === 'BUTTON' && (el.classList.contains('bn_Escape') || el.classList.contains('bn_Enter'))) return;
        if (allowSelectors.some((sel)=>{
            const n = form.querySelector(sel);
            return n && el === n;
        })) return;
        if (el.closest('.oo-lock-allow')) return;
        el.setAttribute('data-oo-lock-disabled', '1');
        el.setAttribute('disabled', 'disabled');
    });
    rowImgs.forEach((img)=>{
        img.style.pointerEvents = 'none';
        img.style.opacity = '0.45';
    });
}
var $3df4715102edd156$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#order.oo-order-form .oo-order-header-scroll {
				flex-shrink: 0;
				overflow-x: hidden;
				padding-right: 0.2rem;
			}
			#order.oo-order-form .oo-order-tail {
				flex-shrink: 0;
			}
			#order.oo-order-form .oo-form-row {
				display: flex;
				flex-wrap: wrap;
				gap: 0.45rem 0.75rem;
				align-items: flex-end;
				margin-bottom: 0.45rem;
			}
			#order.oo-order-form .oo-form-row label {
				margin-right: 0 !important;
				margin-bottom: 0 !important;
			}
			#order.oo-order-form #company_id		{ width: 9rem; }
			#order.oo-order-form #id				{ width: 5rem; text-align: right; }
			#order.oo-order-form #reference		{ width: 8rem; }
			#order.oo-order-form #created_on,
			#order.oo-order-form #created_by,
			#order.oo-order-form #updated_on,
			#order.oo-order-form #updated_by		{ width: 9.5rem; }
			#order.oo-order-form label.sial-field-address {
				flex: 1 1 24rem;
				min-width: min(100%, 18rem);
				max-width: 100%;
			}
			#order.oo-order-form label.sial-field-address input {
				width: 100% !important;
			}
			#order.oo-order-form label.sial-field-party-customer {
				flex: 1 1 22rem;
				min-width: min(100%, 16rem);
				max-width: 100%;
			}
			#order.oo-order-form label.sial-field-party-customer input {
				width: 100% !important;
				font-weight: 700;
				color: #475569;
			}
			#order.oo-order-form label.sial-field-party-customer input:disabled {
				color: #64748b;
				opacity: 0.85;
			}
			#order.oo-order-form label.sial-field-party-nick {
				flex: 1 1 14rem;
				min-width: min(100%, 11rem);
				max-width: 100%;
			}
			#order.oo-order-form label.sial-field-party-nick input {
				width: 100% !important;
			}
			#order.oo-order-form #carrier_id		{ width: 12rem; }
			#order.oo-order-form .oo-delivery-info { font-size: 0.82em; color: var(--muted,#666); margin-top: 0.2rem; }
			#order.oo-order-form #program_id		{ width: 11rem; }
			#order.oo-order-form #service_channel,
			#order.oo-order-form #payment_method,
			#order.oo-order-form #freight_type,
			#order.oo-order-form #status			{ width: 9rem; }
			#order.oo-order-form #payment_term_id	{ width: 7rem; }
			#order.oo-order-form #freight_value,
			#order.oo-order-form #discount			{ width: 5rem; text-align: right; }
			#order.oo-order-form #expected_delivery_date { width: 9rem; }
			#order.oo-order-form .sial-items-scroll .oo-col-item-no { width: 3.2rem; text-align: center; }
			#order.oo-order-form .sial-items-scroll .oo-col-item-no input { text-align: center; }
			#order.oo-order-form .sial-items-scroll .oo-col-product { width: 22%; }
			#order.oo-order-form .sial-items-scroll .oo-col-arm { width: 8.5%; }
			#order.oo-order-form .sial-items-scroll .oo-col-arm input {
				font-size: 0.78rem;
				font-weight: 600;
				text-align: center;
				padding-left: 0.15rem;
				padding-right: 0.15rem;
			}
			#order.oo-order-form .sial-items-scroll td.oo-arm--clim,
			#order.oo-order-form .sial-items-scroll td.oo-arm--clim input.oo-arm--clim {
				background: #ecfdf5 !important;
				color: #065f46;
			}
			#order.oo-order-form .sial-items-scroll td.oo-arm--refrig,
			#order.oo-order-form .sial-items-scroll td.oo-arm--refrig input.oo-arm--refrig {
				background: #e0f2fe !important;
				color: #075985;
			}
			#order.oo-order-form .sial-items-scroll tr.oo-row--arm-mixed {
				outline: 1px solid #f59e0b;
				outline-offset: -1px;
			}
			#order.oo-order-form .sial-items-scroll .oo-col-lot { width: 8%; }
			#order.oo-order-form .sial-items-scroll .oo-col-unit { width: 7%; }
			#order.oo-order-form .sial-items-scroll .oo-col-qty { width: 6%; }
			#order.oo-order-form .sial-items-scroll .oo-col-sim { width: 7%; }
			#order.oo-order-form .sial-items-scroll .oo-col-sim input { text-align: right; }
			#order.oo-order-form .sial-items-scroll .oo-col-sit { width: 11%; }
			#order.oo-order-form .sial-items-scroll td.oo-sim-neg input,
			#order.oo-order-form .sial-items-scroll td.oo-sim-neg { background: #fecaca !important; font-weight: 700; }
			#order.oo-order-form .sial-items-scroll td.oo-sim-warn input,
			#order.oo-order-form .sial-items-scroll td.oo-sim-warn { background: #fef08a !important; }
			#order.oo-order-form .sial-items-scroll .oo-col-disc { width: 6%; }
			#order.oo-order-form .sial-items-scroll .oo-col-price { width: 8%; }
			#order.oo-order-form .sial-items-scroll .oo-col-total { width: 8%; }
			#order.oo-order-form label.notes {
				display: flex;
				flex-direction: column;
				width: 100%;
				margin: 0.4rem 0 0 0 !important;
			}
			#order.oo-order-form label.notes textarea {
				width: 100%;
				box-sizing: border-box;
			}
			#order.oo-order-form #book_observation { min-height: 2.5rem; }
			#order.oo-order-form .oo-grand-total {
				text-align: right; font-weight: 600; font-size: 0.88rem;
				padding: 0.35rem 0.25rem 0; color: var(--color-text, #222);
				flex-shrink: 0;
			}
			#order.oo-order-form .oo-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-shrink: 0;
				margin-top: 0.45rem;
				padding-top: 0.65rem;
				border-top: 1px solid var(--color-border, #ccc);
				gap: 0.75rem;
				flex-wrap: wrap;
			}
			#oo-lock-banner { margin: 0 0 0.75rem 0; padding: 0.5rem 0.65rem; background: #f1f5f9; border: 1px solid #cbd5e1; border-radius: 4px; color: #475569; }
			#oo-integration-alert-banner { display: none; }
			#oo-storage-arm-banner { display: none; margin: 0 0 0.5rem 0; padding: 0.55rem 0.7rem; border-radius: 4px; font-size: 0.88rem; line-height: 1.35; }
			#oo-storage-arm-banner.oo-storage-arm-banner--warn { background: #fef3c7; border: 1px solid #f59e0b; color: #92400e; font-weight: 600; }
			#order.oo-order-form.output-order--edit-locked label:not(.oo-lock-allow) { color: #94a3b8; }
		</style>
		<form id="order" class="form oo-order-form sial-modal-form" autocomplete="off">
			<input type="hidden" id="edit_locked_by_output" value="0">
			<p id="oo-lock-banner" class="fsxx" style="display:none">Este pedido possui sa\xedda gerada ou entrada de devolu\xe7\xe3o ativa (n\xe3o cancelada): os campos ficam bloqueados, exceto <strong>Pagamento</strong>, <strong>Condi\xe7\xe3o</strong>, <strong>Transportador</strong>, <strong>Tipo de frete</strong> e <strong>Valor do frete</strong>. A edi\xe7\xe3o plena volta quando todas as sa\xeddas/entradas vinculadas forem canceladas.</p>
			<div id="oo-integration-alert-banner" role="status" aria-live="polite"></div>
			<datalist id="companies">
			</datalist>
			<datalist id="customers">
			</datalist>
			<datalist id="customers_nick">
			</datalist>
			<datalist id="carriers">
			</datalist>
			<datalist id="programs">
			</datalist>
			<datalist id="payment_terms">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="users">
			</datalist>
			<datalist id="delivery_addresses">
			</datalist>
			<div class="oo-order-header-scroll">
			<div class="oo-form-row">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do pedido">Pedido
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo de refer\xeancia externa">Refer\xeancia
					<input id="reference" type="text">
				</label>
				<label title="Data e hora de cria\xe7\xe3o do pedido">Data Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Usu\xe1rio criador do pedido">Criado Por
					<input id="created_by" type="text" list="users" disabled>
				</label>
				<label title="Data e hora de altera\xe7\xe3o do pedido">Data Altera\xe7\xe3o
					<input id="updated_on" type="text" disabled>
				</label>
				<label title="\xdaltimo usu\xe1rio a alterar o pedido">Alterado Por
					<input id="updated_by" type="text" list="users" disabled>
				</label>
				<label title="Status do pedido">Status<sup>*</sup>
					<input id="status" type="text" list="order_status" value="10" required>
				</label>
				<label title="Este pedido \xe9 uma devolu\xe7\xe3o?">Devolu\xe7\xe3o
					<input id="is_return" type="checkbox">
				</label>
				<label title="Pedido emergencial (destaque operacional)">Emergencial
					<input id="is_emergency" type="checkbox">
				</label>
			</div>
			<div class="oo-form-row oo-form-row-party">
				<label class="sial-field-party sial-field-party-nick" title="Apelido do cliente \u{2014} preenche o Cliente ao selecionar">Apelido
					<input id="customer_nick" type="text" list="customers_nick" placeholder="Buscar por apelido">
				</label>
				<label class="sial-field-party sial-field-party-customer" title="Cliente do pedido \u{2014} nome / CNPJ / CPF">Cliente<sup>*</sup>
					<input id="customer_id" type="text" list="customers" required>
				</label>
				<label class="sial-field-party sial-field-address" title="Endere\xe7o de entrega para este pedido">Endere\xe7o Entrega
					<input id="delivery_address_id" type="text" list="delivery_addresses" placeholder="Selecione o endere\xe7o">
				</label>
				<label title="Canal de atendimento do cliente">Atendimento<sup>*</sup>
					<input id="service_channel" type="text" list="service_channels" required>
				</label>
				<label class="oo-lock-allow" title="Transportador do pedido">Transportador
					<input id="carrier_id" type="text" list="carriers">
				</label>
				<label title="Programa (estrutura de estoque a considerar)">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label class="oo-lock-allow" title="Tipo de frete">Tipo Frete
					<input id="freight_type" type="text" list="freight_types">
				</label>
				<label class="oo-lock-allow" title="Valor do frete">Valor Frete
					<input id="freight_value" type="text">
				</label>
				<label title="Desconto sobre o valor do pedido">% Desc
					<input id="discount" type="text">
				</label>
				<label title="Data de previs\xe3o de entrega do pedido">Prev. Entrega
					<input id="expected_delivery_date" type="date">
				</label>
			</div>
			<div class="oo-form-row oo-form-row-payment">
				<label class="oo-lock-allow" title="Forma de pagamento">Pagamento<sup>*</sup>
					<input id="payment_method" type="text" list="payment_methods" required>
				</label>
				<label class="oo-lock-allow" title="Condi\xe7\xe3o de pagamento">Condi\xe7\xe3o<sup>*</sup>
					<input id="payment_term_id" type="text" list="payment_terms" required>
				</label>
			</div>
			</div>
			<div class="sial-items-panel">
				<div class="sial-items-title">Itens do pedido</div>
				<div id="oo-storage-arm-banner" role="status" aria-live="polite"></div>
				<div class="sial-items-scroll">
					<table>
						<thead>
							<tr>
								<th class="sial-col-chk"></th>
								<th class="oo-col-item-no">N\xba item</th>
								<th class="oo-col-product">Produto<sup>*</sup></th>
								<th class="oo-col-arm" title="Tipo de armazenamento do produto (cadastro: Refrigerado ou climatizado)">Arm.</th>
								<th class="oo-col-lot">Lote</th>
								<th class="oo-col-unit">Unidade<sup>*</sup></th>
								<th class="oo-col-qty tar">Qtde<sup>*</sup></th>
								<th class="oo-col-sim tar" title="Pr\xe9-reserva de pedidos aprovados neste SKU (n\xe3o \xe9 reserva f\xedsica)">Pr\xe9-reserva</th>
								<th class="oo-col-sim tar" title="Saldo livre operacional menos pr\xe9-reservas (SKU)">Saldo sim.</th>
								<th class="oo-col-sit" title="Situa\xe7\xe3o do saldo simulado do SKU">Situa\xe7\xe3o estoque</th>
								<th class="oo-col-disc tar">% Desc</th>
								<th class="oo-col-price tar">Pre\xe7o Un<sup>*</sup></th>
								<th class="oo-col-total tar">Subtotal</th>
							</tr>
						</thead>
						<tbody>
							<tr class="row" data-size="10">
								<td class="sial-col-chk">
									<input type="hidden" id="number-0" value="">
									<input id="checkbox-0" type="checkbox">
								</td>
								<td class="oo-col-item-no" title="N\xfamero sequencial do item">
									<input id="item_no-0" class="item_no" type="text" readonly tabindex="-1">
								</td>
								<td title="Produto">
									<input id="product_id-0" class="product" type="text" list="products" required>
								</td>
								<td class="oo-col-arm" title="Tipo de armazenamento (Climatizado = sem flag Refrigerado no cadastro)">
									<input id="storage_arm-0" class="storage_arm" type="text" readonly tabindex="-1" aria-label="Tipo de armazenamento">
								</td>
								<td title="Lote do produto">
									<input id="lot_id-0" class="lot" type="text" list="lots-0">
								</td>
								<td title="Unidade de venda">
									<input id="unit_id-0" class="unit" type="text" list="units" required>
								</td>
								<td class="tar" title="Quantidade">
									<input id="quantity-0" class="quantity" type="text" required>
								</td>
								<td class="tar oo-col-sim" title="Pr\xe9-reserva de pedidos aprovados neste SKU (n\xe3o \xe9 reserva f\xedsica)">
									<input id="pre_reserved_by_approved_orders-0" class="pre_reserved" type="text" readonly tabindex="-1">
								</td>
								<td class="tar oo-col-sim" title="Saldo livre operacional menos pr\xe9-reservas (SKU)">
									<input id="simulated_available_quantity-0" class="sim_available" type="text" readonly tabindex="-1">
								</td>
								<td class="oo-col-sit" title="Situa\xe7\xe3o do saldo simulado do SKU">
									<input id="stock_situation-0" class="stock_situation" type="text" readonly tabindex="-1">
								</td>
								<td class="tar" title="Desconto adicional sobre o valor deste item">
									<input id="discount-0" class="discount" type="text">
								</td>
								<td class="tar" title="Pre\xe7o unit\xe1rio do produto">
									<input id="unit_price-0" class="price" type="text" required>
								</td>
								<td class="tar oo-col-total" title="Subtotal da linha (qtde \xd7 pre\xe7o unit., com % desc. do item)">
									<input id="item_total-0" class="item_total" type="text" readonly tabindex="-1">
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="oo-order-tail">
				<div id="oo-grand-total" class="oo-grand-total"></div>
				<label class="notes" title="Observa\xe7\xf5es sobre o pedido">Observa\xe7\xf5es
					<textarea id="notes" rows="2"></textarea>
				</label>
				<label class="notes" title="Texto para livro eletr\xf4nico / NF-e quando aplic\xe1vel">Obs. livro eletr\xf4nico (NF-e)
					<textarea id="book_observation" rows="2"></textarea>
				</label>
			</div>
			<div class="oo-footer">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#order',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            formset.loadList('#users', 'users');
            Object.getPrototypeOf(this).init.call(this);
            // ── Endereço de entrega: carrega ao mudar customer_id ─────────────────
            const sel = '#order';
            const formRoot = formset.dialog?.getNode?.()?.querySelector(sel) || document.querySelector(sel);
            (0, $b2411514bdf07434$export$c784f48aeddf3f03)(formRoot);
            let _deliveryAddrs = [];
            const ooGet = (id)=>document.querySelector(`${sel} #${id}`);
            const _formatDeliveryAddrLabel = (a)=>{
                const tipo = String(a?.name || '').trim();
                const logradouro = [
                    a?.street,
                    a?.number,
                    a?.complement
                ].filter(Boolean).join(', ');
                const bairro = a?.district ? String(a.district).trim() : '';
                const cityUf = [
                    a?.city,
                    a?.state
                ].filter(Boolean).join('/');
                const cep = a?.zipcode ? String(a.zipcode).trim() : '';
                const parts = [];
                if (tipo) parts.push(tipo);
                if (logradouro) parts.push(logradouro);
                if (bairro) parts.push(bairro);
                if (cityUf) parts.push(cityUf);
                if (cep) parts.push(`CEP ${cep}`);
                return parts.join(" \u2014 ") || tipo || "Endere\xe7o";
            };
            const _getDeliveryAddressField = ()=>formset?.form?.getFieldBySelector?.('#delivery_address_id');
            const _populateDeliveryDl = (addresses)=>{
                _deliveryAddrs = addresses || [];
                const dl = ooGet('delivery_addresses');
                if (!dl) return;
                dl.innerHTML = '';
                _deliveryAddrs.forEach((a)=>{
                    const opt = document.createElement('option');
                    opt.value = String(a.id);
                    opt.textContent = _formatDeliveryAddrLabel(a);
                    dl.appendChild(opt);
                });
                _getDeliveryAddressField()?.refresh?.();
            };
            const _setDeliveryAddressId = (addressId)=>{
                const field = _getDeliveryAddressField();
                if (!field) return;
                if (addressId == null || addressId === '') field.setValue(-1);
                else field.setValue(Number(addressId));
                field.refresh();
            };
            const _autoSelectDeliveryAddr = (currentId)=>{
                // Aceita id legado -1/-2 (API normaliza; front ainda pode receber de pedidos antigos).
                const normId = (id)=>{
                    if (id == null || id === '') return id;
                    const n = Number(id);
                    if (n === -1) return 2000000001;
                    if (n === -2) return 2000000002;
                    return n;
                };
                if (currentId != null && currentId !== '') {
                    const want = normId(currentId);
                    const found = _deliveryAddrs.find((a)=>Number(a.id) === Number(want));
                    if (found) {
                        _setDeliveryAddressId(found.id);
                        return;
                    }
                }
                const field = _getDeliveryAddressField();
                const cur = field?.getValue?.();
                if (cur != null && cur !== '' && cur !== -1 && cur !== '-1') return;
                const def = _deliveryAddrs.find((a)=>a.is_default);
                if (def) {
                    _setDeliveryAddressId(def.id);
                    return;
                }
                if (_deliveryAddrs.length === 1) _setDeliveryAddressId(_deliveryAddrs[0].id);
            };
            const _resolveCompanyId = ()=>{
                const v = formset?.form?.getFieldByName?.('company_id')?.getValue?.();
                return v != null && String(v).trim() !== '' ? String(v).trim() : null;
            };
            /** Id numérico do cliente (datalist), não o rótulo CNPJ/nome exibido no input. */ const _resolveCustomerId = ()=>{
                const v = formset?.form?.getFieldByName?.('customer_id')?.getValue?.();
                if (v == null || v === '' || v === -1 || v === '-1') return null;
                const n = Number(v);
                return Number.isInteger(n) && n > 0 ? n : null;
            };
            const _loadDeliveryAddresses = async (companyId, customerId, currentAddressId = null)=>{
                if (!companyId || !customerId) {
                    _populateDeliveryDl([]);
                    _setDeliveryAddressId(null);
                    return;
                }
                try {
                    const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_delivery_addresses, companyId, customerId, true);
                    _populateDeliveryDl(Array.isArray(rows) ? rows : []);
                    _autoSelectDeliveryAddr(currentAddressId);
                } catch (_) {
                    _populateDeliveryDl([]);
                }
            };
            const _scheduleLoadDeliveryAddresses = (resetSelection = true)=>{
                if (resetSelection) _setDeliveryAddressId(null);
                const compId = _resolveCompanyId();
                const custId = _resolveCustomerId();
                if (custId) _loadDeliveryAddresses(compId, custId, null);
                else _populateDeliveryDl([]);
            };
            // Recarregar endereços ao mudar empresa ou cliente (change + blur após datalist)
            ooGet('company_id')?.addEventListener('change', ()=>_scheduleLoadDeliveryAddresses(true));
            ooGet('customer_id')?.addEventListener('change', ()=>_scheduleLoadDeliveryAddresses(true));
            ooGet('customer_id')?.addEventListener('blur', ()=>{
                setTimeout(()=>_scheduleLoadDeliveryAddresses(false), 0);
                setTimeout(()=>{
                    formset?.form?.getFieldBySelector?.('#payment_method')?.syncFromCustomer?.();
                }, 0);
            });
            // Expor para afterEditSetValues
            this._loadDeliveryAddresses = _loadDeliveryAddresses;
            const ooRoot = formRoot;
            if (ooRoot) {
                const tbl = ooRoot.querySelector('.sial-items-scroll table');
                if (tbl) tbl.addEventListener('input', ()=>{
                    $3df4715102edd156$var$recalcOutputOrderTotals(ooRoot);
                    (0, $c9644a701d51e702$export$40834e92d4d6cd46)(ooRoot);
                });
                setTimeout(()=>{
                    $3df4715102edd156$var$applyNewOutputOrderDefaults(formset);
                    $3df4715102edd156$var$recalcOutputOrderTotals(ooRoot);
                    (0, $c9644a701d51e702$export$b71af1471a6ba137)(ooRoot);
                    (0, $fb0d8610497c39ce$export$523a405869d33195)(ooRoot);
                }, 350);
            }
        },
        afterEditSetValues (fs) {
            if (fs?.hasTables?.()) fs.setTableHeight(10);
            const root = fs?.dialog?.getNode?.()?.querySelector(this.selector);
            setTimeout(()=>{
                const formRoot = root || document.querySelector(this.selector);
                $3df4715102edd156$var$recalcOutputOrderTotals(formRoot);
                (0, $fb0d8610497c39ce$export$be43077e64f2fdff)(formRoot);
                (0, $b2411514bdf07434$export$b7c121695885def)(formRoot);
                const valsEarly = fs.form.getValues?.() || {};
                (0, $c9644a701d51e702$export$b71af1471a6ba137)(formRoot, valsEarly.company_id || null);
                (0, $fb0d8610497c39ce$export$523a405869d33195)(formRoot, {
                    companyId: valsEarly.company_id || null,
                    programId: valsEarly.program_id != null && valsEarly.program_id !== '' ? Number(valsEarly.program_id) : null
                });
            }, 0);
            $3df4715102edd156$var$applyOutputOrderEditLock(fs);
            // Carregar endereços do cliente do pedido que está sendo editado
            const vals = fs.form.getValues?.() || {};
            const compId = vals.company_id;
            const custId = vals.customer_id ? Number(vals.customer_id) : null;
            const addrId = vals.delivery_address_id ? Number(vals.delivery_address_id) : null;
            // Espelhar Apelido ← Cliente (datalists podem carregar após setValues)
            if (custId != null && !Number.isNaN(custId) && custId >= 0) setTimeout(()=>{
                const nick = fs.form.getFieldByName?.('customer_nick');
                if (!nick) return;
                const cur = nick.getValue?.();
                if (Number(cur) === custId) {
                    nick.refresh?.();
                    return;
                }
                nick.setValue(custId);
                nick.refresh?.();
            }, 50);
            if (this._loadDeliveryAddresses && custId) this._loadDeliveryAddresses(compId, custId, addrId);
            const orderId = vals.id;
            if (compId && orderId != null && orderId !== '') (0, $408fd6d1f7aad081$export$376b532903f2d911)({
                formSelector: '#order',
                bannerId: 'oo-integration-alert-banner',
                companyId: compId,
                entityType: 'output_order',
                entityId: orderId
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#edit_locked_by_output'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#created_by'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#updated_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#updated_by'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#customer_nick'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('customers', {
                    labels: [
                        'nick',
                        'cnpj',
                        'cpf'
                    ],
                    filter: (r)=>Boolean(r?.nick && String(r.nick).trim())
                }),
                $b4ac3fdf5db60328$export$2e2bcd8739ae039('customer_id')
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('customers', {
                    labels: [
                        'name',
                        'cnpj',
                        'cpf'
                    ]
                }),
                $b4ac3fdf5db60328$export$2e2bcd8739ae039('customer_nick')
            ]
        },
        {
            properties: {
                selector: '#delivery_address_id'
            },
            types: [
                $9PIz7.default(),
                $3eqAU.default(0)
            ]
        },
        {
            properties: {
                selector: '#carrier_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('carriers', {
                    labels: [
                        'nick'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#service_channel'
            },
            types: [
                $5rlmp.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#payment_method'
            },
            types: [
                $6Jl4s.default(),
                $6R5fG.default(),
                $9PIz7.default(),
                $6lTH5.default('customer_id'),
                $57e664762d8187e6$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#payment_term_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'company_id',
                    'customer_id'
                ]),
                $a3bd40443322c074$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#freight_type'
            },
            types: [
                $fyCkJ.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#freight_value'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#discount'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('customer_id'),
                $89a9d177dbffd6c2$export$2e2bcd8739ae039(),
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#expected_delivery_date'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#notes'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#book_observation'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#is_return'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#is_emergency'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $05cf4050e889bf62$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#number-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#item_no-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#storage_arm-0'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('product_id-0'),
                $1c37aa3595c00954$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('product_id-0'),
                $dg8P2.default('lots', {
                    labels: [
                        'lot_number',
                        'id'
                    ],
                    sep: " \xb7 ",
                    key: 'company_id',
                    range: 1
                })
            ]
        },
        {
            properties: {
                selector: '#unit_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'company_id',
                    'product_id-0'
                ]),
                $f7ae7d91f57919c4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('product_id-0'),
                $d0e5a3fdd77559d6$export$2e2bcd8739ae039(),
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#pre_reserved_by_approved_orders-0'
            },
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            properties: {
                selector: '#simulated_available_quantity-0'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default([
                    'product_id-0',
                    'program_id'
                ]),
                $dff7c2aa429b7f2b$export$2e2bcd8739ae039(),
                $3eqAU.default(0)
            ]
        },
        {
            properties: {
                selector: '#stock_situation-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#discount-0'
            },
            types: [
                $6Jl4s.default(),
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default([
                    'product_id-0',
                    'customer_id'
                ]),
                $72c559d121507028$export$2e2bcd8739ae039(),
                $3eqAU.default(4)
            ]
        },
        {
            properties: {
                selector: '#item_total-0'
            },
            types: []
        }
    ]
};





var $1cmSR = parcelRequire("1cmSR");
function $dbf2976f1c084be6$var$escapeHtml(s) {
    if (s == null) return '';
    const t = document.createElement('div');
    t.textContent = String(s);
    return t.innerHTML;
}
function $dbf2976f1c084be6$var$toCsvValue(value) {
    const raw = value == null ? '' : String(value);
    return `"${raw.replace(/"/g, '""')}"`;
}
function $dbf2976f1c084be6$var$buildStatsCsv(rows) {
    const headers = [
        'Empresa',
        'Cliente',
        'Pedido',
        'Referencia',
        'Transportador',
        'Programa',
        '% total de atendimento',
        'Posicoes atendidas',
        'Status',
        'Observacao reserva',
        'SKU',
        'Nome',
        'Lote Fabricante',
        'Unidade',
        'Solicitado',
        'Atendido',
        '%',
        'Posicao',
        'Embalagem sugerida',
        'Motivo'
    ];
    const lines = [
        headers.map($dbf2976f1c084be6$var$toCsvValue).join(';')
    ];
    for (const row of rows)lines.push(row.map($dbf2976f1c084be6$var$toCsvValue).join(';'));
    return '\ufeff' + lines.join('\n');
}
function $dbf2976f1c084be6$var$downloadTextFile(content, filename, mimeType = 'text/csv;charset=utf-8') {
    const blob = new Blob([
        content
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
var $dbf2976f1c084be6$export$2e2bcd8739ae039 = async (results)=>{
    if (!results || typeof results !== 'object') return "<p>Nenhum resultado dispon\xedvel.</p>";
    /** 0% atendido = vermelho; parcial (<100%) = amarelo; 100% sem fundo. Pedido não aprovado = neutro. */ function itemRowStyle(it) {
        if (!it || it.stock_evaluated === false) return 'background-color: #f3f4f6;';
        const ord = Number(it.quantity_ordered) || 0;
        const sup = Number(it.quantity_supplied) || 0;
        if (ord <= 0) return '';
        if (sup <= 0) return 'background-color: #fecaca;';
        const pct = Number(it.fulfillment_pct);
        if (Number.isFinite(pct) && pct < 100) return 'background-color: #fef08a;';
        return '';
    }
    const rows = [];
    const exportRows = [];
    for (const company_id of Object.keys(results)){
        const company_nick = (await (0, $1cmSR.default).get('companies', company_id))?.nick ?? company_id;
        for (const order_id of Object.keys(results[company_id] || {})){
            const rec = results[company_id][order_id];
            const items = rec?.items ?? [];
            const baseCols = [
                company_nick,
                rec?.customer_nick ?? '',
                order_id,
                rec?.reference ?? '',
                rec?.carrier_nick ?? '',
                rec?.program_name ?? '',
                rec?.fulfillment ?? 0,
                rec?.positions_count ?? 0,
                rec?.status ?? '',
                rec?.reservation_note ?? ''
            ];
            if (items.length === 0) exportRows.push([
                ...baseCols,
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                ''
            ]);
            for (const it of items)exportRows.push([
                ...baseCols,
                it?.sku ?? '',
                it?.product_name ?? '',
                it?.lot_number ?? '',
                it?.unit_symbol ?? '',
                it?.quantity_ordered ?? 0,
                it?.quantity_supplied ?? 0,
                it?.fulfillment_pct ?? 0,
                it?.position ?? '',
                it?.packaging_plan ?? '',
                it?.fail_reason ?? ''
            ]);
            rows.push(`
				<tr><td class="tal" colspan="2"><strong>${company_nick}</strong></td></tr>
				<tr><td class="tal" style="width: 140px;">Cliente</td><td class="tal">${$dbf2976f1c084be6$var$escapeHtml(rec?.customer_nick ?? '')}</td></tr>
				<tr><td class="tal">Pedido</td><td class="tal">${order_id}</td></tr>
				<tr><td class="tal">Refer\xeancia</td><td class="tal">${$dbf2976f1c084be6$var$escapeHtml(rec?.reference ?? '')}</td></tr>
				<tr><td class="tal">Transportador</td><td class="tal">${$dbf2976f1c084be6$var$escapeHtml(rec?.carrier_nick ?? '')}</td></tr>
				<tr><td class="tal">Programa</td><td class="tal">${$dbf2976f1c084be6$var$escapeHtml(rec?.program_name ?? '')}</td></tr>
				<tr><td class="tal">% total de atendimento</td><td class="tal"><strong>${rec?.fulfillment ?? 0}%</strong></td></tr>
				<tr><td class="tal">Posi\xe7\xf5es atendidas</td><td class="tal">${rec?.positions_count ?? 0}</td></tr>
				<tr><td class="tal" colspan="2" style="padding-top: var(--space-md);">${rec?.status ?? ''}</td></tr>
				${rec?.reservation_note ? `
				<tr><td class="tal" colspan="2" style="padding: var(--space-md); background: #fff7ed; border: 1px solid #fdba74; border-radius: 6px;">
					${$dbf2976f1c084be6$var$escapeHtml(rec.reservation_note)}
				</td></tr>
				` : ''}
				${Array.isArray(rec?.pre_reservation_warnings) && rec.pre_reservation_warnings.length ? `
				<tr><td class="tal" colspan="2" style="padding: var(--space-md); background: #fef2f2; border: 1px solid #fca5a5; border-radius: 6px;">
					<strong>Pr\xe9-reserva / saldo simulado</strong>
					<ul style="margin:0.4rem 0 0;padding-left:1.2rem">
					${rec.pre_reservation_warnings.map((w)=>`
						<li>${$dbf2976f1c084be6$var$escapeHtml(w.message || '')}</li>
					`).join('')}
					</ul>
				</td></tr>
				` : ''}
				${items.length > 0 ? `
				<tr><td colspan="2" style="padding-top: var(--space-sm);">
					<table class="stats-items" style="width: 100%; border-collapse: collapse; font-size: 0.9em;">
						<thead><tr>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">SKU</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Nome</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Lote Fabricante</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Unidade</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Solicitado</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Atendido</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">%</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Posi\xe7\xe3o</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Embalagem sugerida</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Motivo</th>
						</tr></thead>
						<tbody>
						${items.map((it)=>`
							<tr style="${itemRowStyle(it)}">
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${$dbf2976f1c084be6$var$escapeHtml(it.sku)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${$dbf2976f1c084be6$var$escapeHtml(it.product_name)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${$dbf2976f1c084be6$var$escapeHtml(it.lot_number)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${$dbf2976f1c084be6$var$escapeHtml(it.unit_symbol)}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_ordered ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_supplied ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.fulfillment_pct ?? 0}%</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.position ?? ''}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${$dbf2976f1c084be6$var$escapeHtml(it.packaging_plan || '')}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px; color: #b91c1c;">${$dbf2976f1c084be6$var$escapeHtml(it.fail_reason || '')}</td>
							</tr>
						`).join('')}
						</tbody>
					</table>
				</td></tr>
				` : ''}
			`);
        }
    }
    window.__sialExportOutputOrderStatsCsv = ()=>{
        const stamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
        const csv = $dbf2976f1c084be6$var$buildStatsCsv(exportRows);
        $dbf2976f1c084be6$var$downloadTextFile(csv, `geracao-saidas-resultados-${stamp}.csv`);
    };
    return `<style>
		#stats { width: 100%; border-collapse: collapse; }
		#stats td { padding: var(--space-sm); }
		.stats-items th, .stats-items td { font-weight: normal; }
		.stats-items tbody tr { transition: background-color 0.15s ease; }
		.stats-toolbar { display: flex; justify-content: flex-end; margin-bottom: 0.5rem; }
		.stats-toolbar button { padding: 0.35rem 0.6rem; }
	</style>
	<div class="stats-toolbar">
		<button type="button" class="button" onclick="window.__sialExportOutputOrderStatsCsv && window.__sialExportOutputOrderStatsCsv()">Exportar CSV</button>
	</div>
	<table id="stats">${rows.join('')}</table>`;
};



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");

var $92e29c504550aca2$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#create-outputs.form {
				width: min(32rem, calc(100vw - 1.5rem));
				max-width: 32rem;
				box-sizing: border-box;
				overflow-x: hidden;
			}
			#create-outputs .title { word-break: break-word; }
			#create-outputs #co-wh-hint {
				margin: 0.35rem 0 0.75rem;
				font-size: 0.85rem;
				line-height: 1.35;
				color: #444;
				max-width: 100%;
			}
			#create-outputs .co-field {
				display: block;
				width: 100%;
				max-width: 100%;
				box-sizing: border-box;
				margin-right: 0;
			}
			#create-outputs #company_id,
			#create-outputs #warehouse_id {
				width: 100%;
				max-width: 100%;
				box-sizing: border-box;
			}
			#create-outputs .ckb {
				display: flex;
				flex-wrap: wrap;
				gap: 0.75rem 1.25rem;
				align-items: center;
			}
			#create-outputs .ckb label { margin-bottom: 0; margin-right: 0; }
		</style>
		<form id="create-outputs" class="form sial-create-outputs-form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="title" id="co-wh-title">
				Armaz\xe9m f\xedsico
			</div>
			<p id="co-wh-hint" class="hint"></p>
			<div class="mtl fsb">
				<label class="co-field" title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label class="co-field" title="Somente armaz\xe9ns f\xedsicos ativos; obrigat\xf3rio se houver mais de um" id="co-wh-label">Armaz\xe9m f\xedsico (lista)
					<select id="warehouse_id" disabled>
						<option value="">\u{2014} Escolha a empresa primeiro \u{2014}</option>
					</select>
				</label>
			</div>
			<div class="ckb">
				<label title="Incluir itens com validade vencida na busca?">
					<input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir expirados
				</label>
				<label title="Reservar estoques ou apenas estimar percentuais de atendimento?">
					Reservar estoques <input id="reserve_flag" type="checkbox" class="dib">
				</label>
				<label title="Gerar sa\xedda para esteira Sorter BHT (plano CLOSED/FRACTION + envio WCS). #MT-2D61607">
					<input id="sorter_mode" type="checkbox" class="dib">&nbsp;SORTER
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar <span id="count"></span> sa\xeddas</button>
			</div>
		</form>
	`,
    form: {
        selector: '#create-outputs',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const root = document.querySelector('#create-outputs');
            const sorter = root?.querySelector('#sorter_mode');
            const reserve = root?.querySelector('#reserve_flag');
            if (sorter && reserve) {
                sorter.addEventListener('change', ()=>{
                    if (sorter.checked) reserve.checked = true;
                });
                reserve.addEventListener('change', ()=>{
                    if (!reserve.checked) sorter.checked = false;
                });
            }
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('company_id'),
                (0, $25a6bbdfb2e3c959$export$2e2bcd8739ae039)()
            ]
        },
        {
            properties: {
                selector: '#include_expired'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#reserve_flag'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#sorter_mode'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $5Aed9 = parcelRequire("5Aed9");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");

var $96ebc1fc711c59d8$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#create-derrubada.form {
				width: min(32rem, calc(100vw - 1.5rem));
				max-width: 32rem;
				box-sizing: border-box;
			}
			#create-derrubada .hint { font-size: 0.85rem; color: #444; margin: 0.35rem 0 0.75rem; }
			#create-derrubada #company_id,
			#create-derrubada #warehouse_id { width: 100%; max-width: 100%; box-sizing: border-box; }
		</style>
		<form id="create-derrubada" class="form" autocomplete="off">
			<div class="title">Gerar derrubada</div>
			<p class="hint">Gera a onda com os <strong><span id="cd-count">0</span></strong> pedido(s) marcados: sa\xeddas com reserva e tarefas do empilhador. Pedido j\xe1 com sa\xedda n\xe3o entra.</p>
			<div class="mtl fsb">
				<label title="Empresa dos pedidos marcados">Empresa
					<select id="company_id" required></select>
				</label>
			</div>
			<div class="fsb">
				<label title="S\xf3 escolha se houver mais de um armaz\xe9m f\xedsico">Armaz\xe9m f\xedsico
					<select id="warehouse_id">
						<option value="">\u{2014} Picking na empresa (n\xe3o precisa escolher) \u{2014}</option>
					</select>
				</label>
			</div>
			<div class="ckb">
				<label><input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir estoque expirado</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" type="button">Cancelar</button>
				<button class="bn_Enter button" type="submit">Gerar derrubada</button>
			</div>
		</form>
	`,
    form: {
        selector: '#create-derrubada',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('company_id'),
                (0, $25a6bbdfb2e3c959$export$2e2bcd8739ae039)()
            ]
        },
        {
            properties: {
                selector: '#include_expired'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $84MPM = parcelRequire("84MPM");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $1a09accc903138ab$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output-order-upload #company_id { width: 100%; }
			#output-order-upload #customer_id { width: 100%; }
			#output-order-upload #program_id { width: 100%; }
			#output-order-upload #file { width: 100%; }
		</style>
		<form id="output-order-upload" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="customers"></datalist>
			<datalist id="programs"></datalist>
			<div class="title">Upload de planilha para pedido de sa\xedda</div>
			<p class="mts">Planilha CSV (separador <strong>;</strong> ou <strong>,</strong>) com colunas: <strong>SKU</strong>, <strong>Quantidade</strong> e opcionalmente <strong>Lote</strong>, <strong>Pre\xe7o</strong> ou <strong>Vlr</strong>. XLSX tamb\xe9m \xe9 aceito.</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Cliente">Cliente<sup>*</sup>
					<input id="customer_id" type="text" list="customers" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Programa">Programa
					<input id="program_id" type="text" list="programs">
				</label>
			</div>
			<div class="fsb">
				<label title="Arquivo CSV ou XLSX">Arquivo<sup>*</sup>
					<input id="file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Processar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-order-upload',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#customers', 'customers', {
                labels: [
                    'name',
                    'cnpj',
                    'cpf'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ]
            });
            Object.getPrototypeOf(this).init?.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('customers', {
                    labels: [
                        'name',
                        'cnpj',
                        'cpf'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs')
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: [
                $6Jl4s.default(),
                $84MPM.default()
            ]
        }
    ]
};



var $0193384d45a66173$export$2e2bcd8739ae039 = {
    html: `
		<form id="output-orders-print-pending-form" class="form" autocomplete="off">
			<p class="fss">Escolha o formato do Relat\xf3rio de Pend\xeancias.</p>
			<div class="fsb mtm">
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="xlsx">Excel</option>
						<option value="csv">CSV</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-orders-print-pending-form'
    },
    fields: [
        {
            properties: {
                selector: '#format'
            },
            types: []
        }
    ]
};


var $147f6f786e30f448$export$2e2bcd8739ae039 = {
    html: `
		<form id="output-orders-print-mirror-form" class="form" autocomplete="off">
			<p class="fss">Escolha o formato do espelho do pedido de sa\xedda.</p>
			<div class="fsb mtm">
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="xlsx">Excel</option>
						<option value="csv">CSV</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-orders-print-mirror-form'
    },
    fields: [
        {
            properties: {
                selector: '#format'
            },
            types: []
        }
    ]
};



var $d663ef699b44118a$export$2e2bcd8739ae039 = {
    html: `
		<form id="output-orders-export-csv-form" class="form" autocomplete="off">
			<p class="fss">Gera um arquivo CSV com os mesmos cabe\xe7alhos da listagem
				(uma linha por pedido; separador ponto e v\xedrgula, UTF-8).</p>
			<div class="fsb mtm">
				<label class="fss" style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
					<input type="checkbox" id="use_list_filter" value="1" checked
						onchange="(function(c){var h=document.getElementById('export-csv-hint-bare');if(h)h.style.display=c.checked?'none':'block';})(this)">
					Aplicar os filtros e a ordena\xe7\xe3o <strong>atuais</strong> da tela
				</label>
			</div>
			<p class="fss" id="export-csv-hint-bare" style="display:none">
				<strong>Aten\xe7\xe3o:</strong> sem filtro, todos os pedidos a que voc\xea tem acesso ser\xe3o
				inclu\xeddos. Arquivos muito grandes podem demorar.
			</p>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Exportar CSV</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-orders-export-csv-form'
    },
    fields: [
        {
            properties: {
                selector: '#use_list_filter'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $fyCkJ = parcelRequire("fyCkJ");
var $6R5fG = parcelRequire("6R5fG");
var $5rlmp = parcelRequire("5rlmp");
/**
 * Filtro avançado com muitas referências — usa POST /search em vez de GET com URL gigante.
 */ 
var $b60a2 = parcelRequire("b60a2");
function $31661fef13ba0ec6$export$beeabf868970df99(filterData, minRefs = 20) {
    if (!filterData) return null;
    const references = [];
    const operators = new Set();
    const top = (0, $b60a2.getTopIndex)(filterData);
    for(let i = 0; i <= top; i++){
        const field = filterData[`field-${i}`];
        const value = String(filterData[`value-${i}`] ?? '').trim();
        if (!field && !value) continue;
        if (field !== 'reference') return null;
        const operator = String(filterData[`operator-${i}`] || 'eq').toLowerCase();
        if (![
            'eq',
            'co'
        ].includes(operator) || !value) return null;
        references.push(value);
        operators.add(operator);
    }
    const uniqueReferences = [
        ...new Set(references)
    ];
    if (uniqueReferences.length < minRefs) return null;
    // CSV importado usa «contém» (co); referências SESSP costumam ser «empenho|número» (ex.: 1379262|2956609).
    // Não forçar eq só por ser numérico — isso zera o resultado.
    if (operators.has('co') && operators.has('eq')) return null;
    return {
        references: uniqueReferences,
        operator: operators.has('co') ? 'co' : 'eq'
    };
}
function $31661fef13ba0ec6$export$74ba1cf3ebf85a39(filterData, query, minRefs = 20) {
    const bulk = $31661fef13ba0ec6$export$beeabf868970df99(filterData, minRefs);
    if (!bulk) return null;
    const params = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    return {
        ...bulk,
        group: params.get('group') === 'count' ? 'count' : undefined,
        sort: params.get('sort') || undefined,
        limit: params.get('limit') || undefined,
        offset: params.get('offset') || undefined
    };
}


function $b31c53df218c817e$var$downloadFile(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(url);
}
const $b31c53df218c817e$var$escapeHtml = (value)=>String(value ?? '').replace(/[&<>"']/g, (ch)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[ch]);
const $b31c53df218c817e$var$outputOrders = function() {
    let output_orders_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_units, this.queryAll()).then((data)=>(0, $1cmSR.default).set('units', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).then(()=>{
                    const root = document.querySelector('#order');
                    if (root) (0, $c9644a701d51e702$export$b71af1471a6ba137)(root);
                }).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_lots, this.queryAll()).then((data)=>(0, $1cmSR.default).set('lots', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_price_lists, this.queryAll()).then((data)=>(0, $1cmSR.default).set('price_lists', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_payment_terms, this.queryAll()).then((data)=>(0, $1cmSR.default).set('payment_terms', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_routes, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customer_routes', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_carriers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('carriers', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            const searchPayload = (0, $31661fef13ba0ec6$export$74ba1cf3ebf85a39)(this.filter, query);
            let records = searchPayload ? await (0, $9VcS9.default).call((0, $9VcS9.default).search_output_orders, searchPayload) : await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_orders, query);
            if (!Array.isArray(records) || records.length === 0) return records;
            // #MT-6D9A723 — enrich pré-reserva / saldo simulado (não trava a grade se falhar)
            try {
                const ids = records.filter((r)=>r && r.company_id != null && r.id != null).map((r)=>[
                        r.company_id,
                        r.id
                    ]);
                if (ids.length === 0) return records;
                if (typeof (0, $9VcS9.default).summarize_output_orders_simulated_availability !== 'function') return records;
                const summary = await (0, $9VcS9.default).call((0, $9VcS9.default).summarize_output_orders_simulated_availability, {
                    ids: ids
                });
                if (!summary || typeof summary !== 'object') return records;
                for (const r of records){
                    const key = `${r.company_id}:${r.id}`;
                    const s = summary[key];
                    if (!s || s.applicable === false) {
                        r.pre_reserved_pending = null;
                        r.simulated_available_quantity = null;
                        r.stock_situation = null;
                        continue;
                    }
                    r.pre_reserved_pending = s.pre_reserved_pending;
                    r.operational_available_quantity = s.operational_available_quantity;
                    r.simulated_available_quantity = s.simulated_available_quantity;
                    r.stock_situation = s.stock_situation;
                }
            } catch (_e) {
            /* grade segue sem colunas de simulação */ }
            return records;
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_output_order, ...JSON.parse(id));
            // #MT-6D9A723 — enriquecer itens com pré-reserva / saldo simulado (detalhe)
            // #MT-F0A7552 — pedido Devolução não participa; não enriquecer colunas
            // (sempre flatten: sem isso os itens não aparecem no formulário)
            try {
                const items = Array.isArray(_record?.items) ? _record.items : [];
                if (_record?.company_id && items.length) for (const it of items){
                    const pid = Number(it?.product_id);
                    if (!Number.isInteger(pid) || pid <= 0) {
                        it.storage_arm = '';
                        continue;
                    }
                    let product = null;
                    try {
                        product = await (0, $1cmSR.default).get('products', [
                            _record.company_id,
                            pid
                        ]);
                    } catch (_e) {
                        product = null;
                    }
                    it.storage_arm = (0, $bcb7609f0745f2d2$export$e1bcf84451644ca1)((0, $bcb7609f0745f2d2$export$cbad4626cc6dc3d7)(it, product));
                }
                if (!_record?.is_return) {
                    const productIds = [
                        ...new Set(items.map((it)=>Number(it?.product_id)).filter((pid)=>Number.isInteger(pid) && pid > 0))
                    ];
                    if (_record?.company_id && productIds.length && typeof (0, $9VcS9.default).list_stocks_simulated_availability === 'function') {
                        let q = `?product_ids=${productIds.join(',')}&include_zero_stock=1&per_page=${Math.max(100, productIds.length)}`;
                        const prog = Number(_record.program_id);
                        if (Number.isInteger(prog) && prog > 0) q += `&program_id=${prog}`;
                        const avail = await (0, $9VcS9.default).call((0, $9VcS9.default).list_stocks_simulated_availability, _record.company_id, q);
                        const byPid = new Map();
                        for (const row of avail?.items || [])if (row?.product_id != null) byPid.set(Number(row.product_id), row);
                        for (const it of items){
                            const row = byPid.get(Number(it.product_id));
                            if (!row) {
                                it.pre_reserved_by_approved_orders = null;
                                it.simulated_available_quantity = null;
                                it.stock_situation = null;
                                continue;
                            }
                            it.pre_reserved_by_approved_orders = row.pre_reserved_by_approved_orders;
                            it.simulated_available_quantity = row.simulated_available_quantity;
                            it.stock_situation = row.status || null;
                        }
                    }
                }
            } catch (_e) {
            /* detalhe segue sem colunas de simulação */ }
            return (0, $b60a2.flatten)(_record, 'items');
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'items');
            let _record = {
                reference: data.reference,
                customer_id: Number(data.customer_id),
                delivery_address_id: data.delivery_address_id != null && data.delivery_address_id !== '' && !isNaN(Number(data.delivery_address_id)) ? Number(data.delivery_address_id) : null,
                carrier_id: Number(data.carrier_id),
                program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
                service_channel: data.service_channel,
                payment_method: data.payment_method,
                payment_term_id: (()=>{
                    if (data.payment_method === '90' || data.payment_method === 90) return null;
                    const raw = data.payment_term_id;
                    if (raw == null || raw === '') return null;
                    const n = Number(raw);
                    return Number.isFinite(n) && n > 0 ? n : null;
                })(),
                freight_type: data.freight_type,
                freight_value: Number(data.freight_value),
                discount: data.discount != null && data.discount !== '' ? Number(data.discount) : null,
                notes: data.notes?.trim(),
                book_observation: data.book_observation != null && String(data.book_observation).trim() !== '' ? String(data.book_observation).trim() : null,
                is_return: data.is_return == '1',
                is_emergency: data.is_emergency == '1',
                status: Number(data.status),
                expected_delivery_date: data.expected_delivery_date && data.expected_delivery_date !== '' ? data.expected_delivery_date : null,
                items: (data.items || []).filter((item)=>item.product_id != null && item.product_id !== '' && !isNaN(Number(item.product_id))).map((item)=>{
                    const row = {
                        product_id: Number(item.product_id),
                        lot_id: item.lot_id != null && item.lot_id !== '' && !isNaN(Number(item.lot_id)) && Number(item.lot_id) >= 0 ? Number(item.lot_id) : null,
                        unit_id: Number(item.unit_id),
                        quantity: Number(item.quantity),
                        discount: item.discount != null && item.discount !== '' ? Number(item.discount) : null,
                        unit_price: Number(item.unit_price)
                    };
                    // Vendatus: `number` = ID da linha (ex. 649280). Não omitir no save —
                    // senão o backend renumerava 0,1,2… e o shipment.checked quebrava.
                    const rawNum = item.number;
                    if (rawNum != null && rawNum !== '') {
                        const n = Number(rawNum);
                        if (Number.isFinite(n) && n > 0) row.number = n;
                    }
                    return row;
                })
            };
            // #MT-3902248 — mistura Climatizado × Refrigerado: alerta + confirmação (não bloqueia)
            if (data.company_id && await (0, $c9644a701d51e702$export$9852c4e2debabff)(data.company_id, _record.items)) {
                const ok = await new Promise((resolve)=>{
                    (0, $jUNyh.ask)("Este pedido mistura itens Climatizados e Refrigerados.\n\nSepare em pedidos distintos antes de gerar a sa\xedda, ou confirme se deseja salvar mesmo assim.", 'Mistura de armazenamento', (answer)=>resolve(answer === 'Y'));
                });
                if (!ok) return false;
            }
            let resp;
            if (old_data) {
                // Alerta ao marcar como Concluído (40) quando ainda há pendências: altera como o pedido é informado no BI
                if (Number(data.status) === 40) {
                    const pending = await (0, $9VcS9.default).call((0, $9VcS9.default).select_pending_output_items, data.company_id, data.id);
                    if (Array.isArray(pending) && pending.some((item)=>(item.quantity_needed || 0) > 0)) (0, $jUNyh.notify)("Este pedido n\xe3o foi totalmente atendido. Marcar como Conclu\xeddo altera o formato como o pedido \xe9 informado no BI.", "Aten\xe7\xe3o");
                }
                resp = await (0, $9VcS9.default).call((0, $9VcS9.default).update_output_order, data.company_id, data.id, _record);
            } else resp = await (0, $9VcS9.default).call((0, $9VcS9.default).insert_output_order, data.company_id, _record);
            const dup = resp?.duplicate_reference;
            if (dup) {
                const orderId = typeof dup === 'object' && dup != null && dup.id != null ? dup.id : dup;
                const company_nick = typeof dup === 'object' && dup != null ? dup.company_nick : null;
                const tenant = company_nick ? ` (empresa ${company_nick})` : '';
                (0, $jUNyh.notify)(`J\xe1 existe o pedido de sa\xedda n\xba ${orderId}${tenant} com a mesma refer\xeancia. Altere a refer\xeancia e salve novamente; nada foi gravado.`, "Aten\xe7\xe3o");
                return false;
            }
            return resp;
        },
        editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            this.loadPage(1);
        },
        createOutputs () {
            if (!this.ensureSelection("Gerar Sa\xeddas")) return;
            let createOutputsInFlight = false;
            const showResult = async (results)=>{
                if (results == null || results === undefined) return; // Erro já tratado pelo http/notify
                (0, $jUNyh.notify)(await (0, $dbf2976f1c084be6$export$2e2bcd8739ae039)(results), 'Resultados');
                this.loadPage(); // Show updated order status
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                if (createOutputsInFlight) return;
                createOutputsInFlight = true;
                try {
                    const parsedWarehouseId = Number(data.warehouse_id);
                    const sorterMode = Boolean(data?.sorter_mode);
                    const reserveFlag = Boolean(data?.reserve_flag) || sorterMode;
                    let params = {
                        'warehouse_company_id': data.company_id,
                        'warehouse_id': Number.isInteger(parsedWarehouseId) && parsedWarehouseId > 0 ? parsedWarehouseId : null,
                        'reserve_flag': reserveFlag,
                        'include_expired': Boolean(data?.include_expired),
                        'sorter_mode': sorterMode,
                        'ids': await this.getSelectedIds([
                            'company_id',
                            'id'
                        ])
                    };
                    let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_outputs, params);
                    if (resp != null) await showResult(resp);
                } finally{
                    createOutputsInFlight = false;
                }
            };
            let fs = (0, $h1m6J.default).create((0, $92e29c504550aca2$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        async createDerrubada () {
            if (!this.ensureSelection('Gerar derrubada')) return;
            const pairs = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            const byCompany = (0, $aGGTj.splitIdsByCompany)(pairs);
            const companyIds = Object.keys(byCompany);
            if (companyIds.length !== 1) {
                (0, $jUNyh.notify)("Marque pedidos de uma \xfanica empresa para gerar a derrubada.", 'Gerar derrubada');
                return;
            }
            const company_id = companyIds[0];
            const order_ids = (byCompany[company_id] || []).map((id)=>Number(id)).filter(Boolean);
            if (!order_ids.length) {
                (0, $jUNyh.notify)("Nenhum pedido v\xe1lido na sele\xe7\xe3o.", 'Gerar derrubada');
                return;
            }
            const crud = this;
            let inFlight = false;
            const sendRequest = async (data)=>{
                if (inFlight) return;
                const cid = data?.company_id || company_id;
                if (String(cid) !== String(company_id)) {
                    (0, $jUNyh.notify)("A empresa do formul\xe1rio deve ser a mesma dos pedidos marcados.", 'Gerar derrubada');
                    return;
                }
                const whRaw = Number(data?.warehouse_id);
                const warehouse_id = Number.isInteger(whRaw) && whRaw > 0 ? whRaw : null;
                inFlight = true;
                try {
                    (0, $jUNyh.ask)(`Gerar derrubada com ${order_ids.length} pedido(s)?`, 'Gerar derrubada', async (answer)=>{
                        if (answer !== 'Y') {
                            inFlight = false;
                            return;
                        }
                        try {
                            const created = await (0, $9VcS9.default).call((0, $9VcS9.default).create_picking_wave, company_id, {
                                warehouse_id: warehouse_id,
                                order_ids: order_ids,
                                include_expired: Boolean(data?.include_expired),
                                reserve_flag: true,
                                confirm: true
                            });
                            if (!created || created.id == null) {
                                inFlight = false;
                                return;
                            }
                            fs.destroy();
                            const extra = (created.remainder_order_ids || []).length ? ` Restante para outro lote: ${created.remainder_order_ids.length}.` : '';
                            const skipped = (created.skipped_order_ids || []).length ? ` Sem sa\xedda: ${created.skipped_order_ids.length}.` : '';
                            (0, $jUNyh.notify)(`Onda ${created.id} gerada. Pedidos neste lote: ${(created.accepted_order_ids || []).length}.${extra}${skipped}`, 'Gerar derrubada');
                            crud.loadPage();
                        } catch (e) {
                            (0, $jUNyh.notify)(String(e), 'Gerar derrubada');
                            inFlight = false;
                        }
                    });
                } catch (e) {
                    (0, $jUNyh.notify)(String(e), 'Gerar derrubada');
                    inFlight = false;
                }
            };
            const fs = (0, $h1m6J.default).create((0, $96ebc1fc711c59d8$export$2e2bcd8739ae039), sendRequest);
            fs.init();
            const countEl = document.querySelector('#create-derrubada #cd-count');
            if (countEl) countEl.textContent = String(order_ids.length);
            const sel = document.querySelector('#create-derrubada #company_id');
            if (sel) {
                let nick = company_id;
                try {
                    const companies = await (0, $1cmSR.default).list('companies') || [];
                    const row = companies.find((c)=>String(c.id) === String(company_id));
                    if (row) nick = row.nick || row.name || company_id;
                } catch (_) {}
                sel.innerHTML = `<option value="${$b31c53df218c817e$var$escapeHtml(company_id)}" selected>${$b31c53df218c817e$var$escapeHtml(nick)}</option>`;
                sel.disabled = true;
                sel.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
        },
        uploadFromSpreadsheet () {
            const showResult = (result)=>{
                (0, $jUNyh.notify)((0, $3dc30afed7448525$export$2e2bcd8739ae039)(result, 'output'), 'Resultado do upload');
                this.loadPage();
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const formNode = document.querySelector((0, $1a09accc903138ab$export$2e2bcd8739ae039).form.selector);
                const fileInput = formNode?.querySelector('#file');
                const file = fileInput?.files?.[0];
                if (!file) {
                    (0, $jUNyh.notify)('Selecione um arquivo CSV ou XLSX.');
                    return;
                }
                const company_id = data.company_id;
                if (!company_id) {
                    (0, $jUNyh.notify)('Selecione a empresa.');
                    return;
                }
                const fd = new FormData();
                fd.append('file', file);
                fd.append('customer_id', data.customer_id);
                fd.append('program_id', data.program_id || '');
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).upload_output_order, company_id, fd);
                if (result) showResult(result);
            };
            const setupTemplateLink = (fs)=>{
                const link = fs.dialog.getNode().querySelector('#download-template');
                if (link) link.onclick = async (e)=>{
                    e.preventDefault();
                    const company_id = fs.form.getValues().company_id;
                    if (!company_id) {
                        (0, $jUNyh.notify)('Selecione a empresa para baixar o modelo.');
                        return;
                    }
                    const csv = await (0, $9VcS9.default).call((0, $9VcS9.default).order_upload_template, company_id);
                    if (csv && typeof csv === 'string') {
                        const blob = new Blob([
                            csv
                        ], {
                            type: 'text/csv;charset=utf-8'
                        });
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = 'modelo_pedido_upload.csv';
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }
                };
            };
            const fs = (0, $h1m6J.default).create((0, $1a09accc903138ab$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                Object.getPrototypeOf(fs).init.call(fs);
                setupTemplateLink(fs);
            })();
        },
        async printPendingOrders () {
            const crud = this;
            const ids = (0, $aGGTj.splitIdsByCompany)(await crud.getSelectedIds([
                'company_id',
                'id'
            ]));
            const count = Object.values(ids).reduce((s, arr)=>s + (arr?.length || 0), 0);
            if (!count) {
                (0, $jUNyh.notify)("Selecione ao menos um pedido para gerar o relat\xf3rio.", "Relat\xf3rio de Pend\xeancias");
                return;
            }
            (0, $b60a2.default).edit((0, $0193384d45a66173$export$2e2bcd8739ae039), async (data)=>{
                try {
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_pending_output_orders, {
                        ids: ids,
                        format: data.format || 'pdf'
                    });
                    crud.clearGridSelection();
                    if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                    else if (resp?.csv) {
                        $b31c53df218c817e$var$downloadFile(resp.csv, resp.filename || 'pendencias.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else if (resp?.xlsx) {
                        $b31c53df218c817e$var$downloadFile(resp.xlsx, resp.filename || 'pendencias.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else (0, $jUNyh.notify)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        },
        printOrderDocument () {
            const count = this.getCount();
            if (!count) {
                (0, $jUNyh.notify)('Selecione ao menos um pedido para gerar o espelho.', 'Espelho de Pedido');
                return;
            }
            (0, $b60a2.default).edit((0, $147f6f786e30f448$export$2e2bcd8739ae039), async (data)=>{
                try {
                    const ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                        'company_id',
                        'id'
                    ]));
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_output_order_document, {
                        ids: ids,
                        format: data.format || 'pdf'
                    });
                    this.clearGridSelection();
                    if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                    else if (resp?.csv) {
                        $b31c53df218c817e$var$downloadFile(resp.csv, resp.filename || 'espelho-pedido-saida.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else if (resp?.xlsx) {
                        $b31c53df218c817e$var$downloadFile(resp.xlsx, resp.filename || 'espelho-pedido-saida.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                    } else (0, $jUNyh.notify)('Nenhum dado para o espelho.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        },
        printDurability () {
            const fs = (0, $h1m6J.default).create((0, $5d0e2de2f4bee2f9$export$2e2bcd8739ae039), async (data)=>{
                if (!data.company_id) {
                    (0, $jUNyh.notify)('Selecione a empresa.', "Aten\xe7\xe3o");
                    return false;
                }
                const payload = {
                    company_id: data.company_id,
                    warehouse_id: data.warehouse_id ? Number(data.warehouse_id) : null,
                    program_id: data.program_id ? Number(data.program_id) : null,
                    only_negative: Boolean(data?.only_negative)
                };
                try {
                    const json = await (0, $9VcS9.default).call((0, $9VcS9.default).print_stock_durability, payload);
                    if (json?.xlsx) {
                        $b31c53df218c817e$var$downloadFile(json.xlsx, json.filename || 'durabilidade-estoque.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        (0, $jUNyh.notify)('Download do Excel iniciado.', 'Sucesso');
                        fs.destroy();
                    } else (0, $jUNyh.notify)('Nenhum dado para exportar.', 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
                return false;
            });
            fs.init();
        },
        async approveOrders () {
            const selectedIds = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selectedIds?.length) {
                (0, $jUNyh.notify)('Selecione ao menos um pedido para aprovar.', 'Aprovar Selecionados');
                return;
            }
            // Agrupa por empresa (pedidos de empresas diferentes vão em chamadas separadas)
            const byCompany = {};
            for (const pair of selectedIds){
                const [company_id, id] = pair;
                if (!byCompany[company_id]) byCompany[company_id] = [];
                byCompany[company_id].push(id);
            }
            const totalOrders = selectedIds.length;
            const html = `
				<div class="msgbox" style="min-width:340px;max-width:500px">
					<div class="mb-title">Aprovar Pedidos de Sa\xedda</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">
							Confirma a aprova\xe7\xe3o de <strong>${totalOrders} pedido${totalOrders !== 1 ? 's' : ''}</strong> selecionado${totalOrders !== 1 ? 's' : ''}?
						</p>
						<p style="margin:0;color:#888;font-size:0.92em">
							Apenas pedidos com status <strong>Criado</strong> ser\xe3o aprovados.
							Pedidos em outros status ser\xe3o ignorados.
						</p>
					</div>
					<button type="button" class="button mtl bn_N">Cancelar</button>
					<button type="button" class="button mtl bn_Y">Aprovar</button>
				</div>
			`;
            const crudRef = this;
            const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                if (key === 'Escape' || key === 'N') {
                    dlg.destroy();
                    return;
                }
                if (key === 'Y') {
                    dlg.destroy();
                    try {
                        let totalApproved = 0;
                        let totalSkipped = 0;
                        for (const [company_id, ids] of Object.entries(byCompany)){
                            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).approve_output_orders_batch, company_id, {
                                ids: ids
                            });
                            totalApproved += result?.approved || 0;
                            totalSkipped += result?.skipped || 0;
                        }
                        if (totalApproved > 0) {
                            (0, $jUNyh.notify)(`${totalApproved} pedido${totalApproved !== 1 ? 's' : ''} aprovado${totalApproved !== 1 ? 's' : ''} com sucesso.` + (totalSkipped > 0 ? ` ${totalSkipped} ignorado${totalSkipped !== 1 ? 's' : ''} (status diferente de Criado).` : ''), "Aprova\xe7\xe3o em lote");
                            crudRef.loadPage();
                        } else (0, $jUNyh.notify)("Nenhum pedido foi aprovado. Verifique se os pedidos selecionados est\xe3o com status Criado.", "Aprova\xe7\xe3o em lote");
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao aprovar pedidos');
                    }
                }
            }, /Escape|N|Y/);
        },
        async createPendingOrder () {
            const selectedIds = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selectedIds?.length) {
                (0, $jUNyh.notify)('Selecione um pedido parcialmente atendido.', 'Pedido complementar');
                return;
            }
            if (selectedIds.length !== 1) {
                (0, $jUNyh.notify)('Selecione apenas um pedido por vez para gerar complemento.', 'Pedido complementar');
                return;
            }
            const [company_id, id] = selectedIds[0];
            try {
                const info = await (0, $9VcS9.default).call((0, $9VcS9.default).output_order_pending_eligibility, company_id, id);
                if (!info?.eligible) {
                    (0, $jUNyh.notify)(info?.reason || "Pedido n\xe3o eleg\xedvel para complemento.", 'Pedido complementar');
                    return;
                }
                const items = Array.isArray(info.pending_items) ? info.pending_items : [];
                const qty = items.reduce((sum, item)=>sum + Number(item.quantity_needed || 0), 0);
                const ref = $b31c53df218c817e$var$escapeHtml(info.reference);
                const html = `
					<div class="msgbox" style="min-width:360px;max-width:560px">
						<div class="mb-title">Gerar pedido complementar</div>
						<div class="mb-text">
							<p style="margin:0 0 0.75rem">Confirma gerar o pedido <strong>${ref}</strong>?</p>
							<p style="margin:0;color:#666">Itens pendentes: <strong>${items.length}</strong> &nbsp; Quantidade total: <strong>${qty}</strong></p>
							<p style="margin:0.75rem 0 0;color:#888;font-size:0.92em">O pedido complementar n\xe3o gera sa\xedda nem reserva estoque automaticamente.</p>
						</div>
						<button type="button" class="button mtl bn_N">Cancelar</button>
						<button type="button" class="button mtl bn_Y">Gerar</button>
					</div>
				`;
                const crudRef = this;
                const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                    if (key === 'Escape' || key === 'N') {
                        dlg.destroy();
                        return;
                    }
                    if (key === 'Y') {
                        dlg.destroy();
                        try {
                            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_pending_output_order, company_id, id);
                            (0, $jUNyh.notify)(`Pedido complementar ${resp?.reference || ''} gerado com sucesso.`, 'Pedido complementar');
                            crudRef.clearGridSelection();
                            crudRef.loadPage();
                        } catch (e) {
                            (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao gerar complemento');
                        }
                    }
                }, /Escape|N|Y/);
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Pedido complementar');
            }
        },
        async markPartialCompleted () {
            const BATCH_MAX = 30;
            const selectedIds = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selectedIds?.length) {
                (0, $jUNyh.notify)('Selecione ao menos um pedido parcialmente atendido.', 'Concluir parcial');
                return;
            }
            if (selectedIds.length > BATCH_MAX) {
                (0, $jUNyh.notify)(`M\xe1ximo de ${BATCH_MAX} pedidos por vez. Selecionados: ${selectedIds.length}.`, 'Concluir parcial');
                return;
            }
            const byCompany = {};
            for (const pair of selectedIds){
                const [company_id, id] = pair;
                if (!byCompany[company_id]) byCompany[company_id] = [];
                byCompany[company_id].push(id);
            }
            const totalOrders = selectedIds.length;
            const idsPreview = selectedIds.slice(0, 8).map(([, id])=>`#${id}`).join(', ');
            const more = totalOrders > 8 ? ` \u{2026} (+${totalOrders - 8})` : '';
            const html = `
				<div class="msgbox" style="min-width:360px;max-width:560px">
					<div class="mb-title">Concluir parcial</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">Confirma concluir parcialmente <strong>${totalOrders} pedido${totalOrders !== 1 ? 's' : ''}</strong>?</p>
						<p style="margin:0 0 0.75rem;color:#666;font-size:0.92em">${idsPreview}${more}</p>
						<p style="margin:0;color:#666">O status passar\xe1 para <strong>Conclu\xeddo parcialmente</strong>. N\xe3o ser\xe1 poss\xedvel gerar pedido complementar nem nova sa\xedda nestes pedidos.</p>
						<p style="margin:0.75rem 0 0;color:#888;font-size:0.92em">Pedidos que n\xe3o estejam <strong>Parcialmente atendido</strong> ou com sa\xedda em andamento ser\xe3o ignorados ou reportados.</p>
					</div>
					<button type="button" class="button mtl bn_N">Cancelar</button>
					<button type="button" class="button mtl bn_Y">Confirmar</button>
				</div>
			`;
            const crudRef = this;
            const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                if (key === 'Escape' || key === 'N') {
                    dlg.destroy();
                    return;
                }
                if (key === 'Y') {
                    dlg.destroy();
                    try {
                        let totalCompleted = 0;
                        let totalAlready = 0;
                        let totalSkipped = 0;
                        let totalFailed = 0;
                        const failSamples = [];
                        for (const [company_id, ids] of Object.entries(byCompany)){
                            const result = await (0, $9VcS9.default).call((0, $9VcS9.default).mark_output_orders_partial_completed_batch, company_id, {
                                ids: ids
                            });
                            totalCompleted += result?.completed || 0;
                            totalAlready += result?.already || 0;
                            totalSkipped += result?.skipped || 0;
                            totalFailed += result?.failed || 0;
                            const fails = Array.isArray(result?.failed_detail) ? result.failed_detail : [];
                            for (const f of fails)if (failSamples.length < 5) failSamples.push(`#${f.id}: ${f.error || 'erro'}`);
                        }
                        const parts = [];
                        if (totalCompleted > 0) parts.push(`${totalCompleted} conclu\xeddo${totalCompleted !== 1 ? 's' : ''} parcialmente`);
                        if (totalAlready > 0) parts.push(`${totalAlready} j\xe1 estava${totalAlready !== 1 ? 'm' : ''} conclu\xeddo${totalAlready !== 1 ? 's' : ''} parcialmente`);
                        if (totalSkipped > 0) parts.push(`${totalSkipped} ignorado${totalSkipped !== 1 ? 's' : ''} (status diferente)`);
                        if (totalFailed > 0) parts.push(`${totalFailed} com erro`);
                        let msg = parts.length ? parts.join('. ') + '.' : 'Nenhum pedido foi alterado.';
                        if (failSamples.length) msg += '\n' + failSamples.join('\n');
                        (0, $jUNyh.notify)(msg, 'Concluir parcial');
                        if (totalCompleted > 0 || totalAlready > 0) {
                            crudRef.clearGridSelection();
                            crudRef.loadPage();
                        }
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao concluir parcial');
                    }
                }
            }, /Escape|N|Y/);
        },
        async exportListCsv () {
            const crud = this;
            await (0, $b60a2.default).edit((0, $d663ef699b44118a$export$2e2bcd8739ae039), async ()=>{
                const box = document.querySelector(`${(0, $d663ef699b44118a$export$2e2bcd8739ae039).form.selector} #use_list_filter`);
                const useList = box ? box.checked : true;
                const payload = {};
                if (useList) {
                    const params = new URLSearchParams();
                    await crud.addFilter(params);
                    crud.addSort(params);
                    const f = params.get('filter');
                    const s = params.get('sort');
                    if (f) payload.filter = f;
                    if (s) payload.sort = s;
                }
                try {
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_output_orders_csv, payload);
                    if (resp?.csv) {
                        $b31c53df218c817e$var$downloadFile(resp.csv, resp.filename || 'pedidos-saida.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)('Download iniciado.', 'Exportar listagem (CSV)');
                    } else (0, $jUNyh.notify)("N\xe3o foi poss\xedvel gerar o arquivo.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Pedido',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do pedido'
        },
        {
            index: 3,
            field: 'reference',
            label: "Refer\xeancia",
            types: [],
            placeholder: '',
            title: "C\xf3digo de refer\xeancia externa do pedido"
        },
        {
            index: 4,
            field: 'created_on',
            label: "Data Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de cria\xe7\xe3o do pedido"
        },
        {
            index: 5,
            field: 'created_by',
            label: 'Criado Por',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Autor da cria\xe7\xe3o do pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 6,
            field: 'updated_on',
            label: "Data Altera\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima atualiza\xe7\xe3o do pedido"
        },
        {
            index: 7,
            field: 'updated_by',
            label: 'Alterado Por',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Autor da \xfaltima atualiza\xe7\xe3o do pedido",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 8,
            field: 'customer_id',
            label: 'Cliente',
            types: [
                $9PIz7.default()
            ],
            placeholder: 'Apelido, id ou CNPJ/CPF',
            title: "Cliente (apelido, c\xf3digo ou documento CNPJ/CPF)",
            store: 'customers',
            labels: [
                'nick'
            ]
        },
        {
            index: 30,
            field: 'route_id',
            label: 'Rota',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Rota de entrega do cliente',
            store: 'customer_routes',
            labels: [
                'code',
                'name'
            ]
        },
        {
            index: 9,
            field: 'carrier_id',
            label: 'Transportador',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Transportador',
            store: 'carriers',
            labels: [
                'nick'
            ]
        },
        {
            index: 10,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa (estrutura de estoque)',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 11,
            field: 'service_channel',
            label: 'Atendimento',
            types: [
                $5rlmp.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Canal de atendimento'
        },
        {
            index: 12,
            field: 'payment_method',
            label: 'Pagamento',
            types: [
                $6R5fG.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Forma de pagamento'
        },
        {
            index: 13,
            field: 'payment_term_id',
            label: "Condi\xe7\xe3o",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Condi\xe7\xe3o de pagamento",
            store: 'payment_terms',
            labels: [
                'name'
            ]
        },
        {
            index: 14,
            field: 'freight_type',
            label: 'Tipo Frete',
            types: [
                $fyCkJ.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de frete'
        },
        {
            index: 15,
            field: 'freight_value',
            label: 'Valor Frete',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor do frete'
        },
        {
            index: 16,
            field: 'discount',
            label: '% Desconto',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Percentual de desconto'
        },
        {
            index: 17,
            field: 'value',
            label: 'Valor',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor do pedido'
        },
        {
            index: 18,
            field: 'notes',
            label: "Observa\xe7\xf5es",
            types: [],
            placeholder: '',
            title: "Observa\xe7\xf5es do pedido"
        },
        {
            index: 19,
            field: 'book_observation',
            label: "Obs.&nbsp;livro&nbsp;eletr\xf4nico",
            types: [],
            placeholder: '',
            title: "Observa\xe7\xe3o para livro eletr\xf4nico / NF-e"
        },
        {
            index: 20,
            field: 'is_return',
            label: "Devolu\xe7\xe3o",
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Indicador de devolu\xe7\xe3o"
        },
        {
            index: 21,
            field: 'status',
            label: 'Status',
            types: [
                $05cf4050e889bf62$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status do pedido'
        },
        {
            index: 25,
            field: 'expected_delivery_date',
            label: 'Prev.&nbsp;Entrega',
            types: [
                $b7D1Q.default()
            ],
            placeholder: 'dd/mm/aaaa',
            title: "Data de previs\xe3o de entrega do pedido"
        },
        {
            index: 23,
            field: 'lines_sku_summary',
            label: 'SKU (itens)',
            types: [],
            placeholder: 'trecho do SKU',
            title: "Busca nos SKUs / SKU parcial das linhas (operador Cont\xe9m recomendado)"
        },
        {
            index: 24,
            field: 'lines_product_summary',
            label: 'Produto (itens)',
            types: [],
            placeholder: 'nome do produto',
            title: "Busca nos nomes dos produtos das linhas (operador Cont\xe9m recomendado)"
        },
        {
            index: 26,
            field: 'is_emergency',
            label: 'Emergencial',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Pedido emergencial'
        },
        {
            index: 40,
            field: 'pre_reserved_pending',
            label: "Pr\xe9-reserva&nbsp;pendente",
            types: [
                $3eqAU.default(0)
            ],
            placeholder: '',
            title: "Quantidade ainda comprometida por este pedido aprovado (n\xe3o \xe9 reserva f\xedsica)",
            computed: true
        },
        {
            index: 41,
            field: 'simulated_available_quantity',
            label: 'Saldo&nbsp;livre&nbsp;simulado',
            types: [
                $3eqAU.default(0)
            ],
            placeholder: '',
            title: "Saldo livre operacional menos pr\xe9-reservas de pedidos aprovados (pior SKU do pedido)",
            computed: true
        },
        {
            index: 42,
            field: 'stock_situation',
            label: "Situa\xe7\xe3o&nbsp;estoque",
            types: [],
            placeholder: '',
            title: "Situa\xe7\xe3o do saldo simulado (OK / ATEN\xc7\xc3O / negativo / sem livre)",
            computed: true
        }
    ];
    let operations = [
        {
            hash: '#create-outputs',
            label: "Gerar&nbsp;sa\xeddas"
        },
        {
            hash: '#create-derrubada',
            label: 'Gerar&nbsp;derrubada'
        },
        {
            hash: '#upload',
            label: 'Upload&nbsp;planilha'
        },
        {
            hash: '#approve-orders',
            label: 'Aprovar&nbsp;selecionados'
        },
        {
            hash: '#create-pending-order',
            label: 'Gerar&nbsp;pedido&nbsp;complementar'
        },
        {
            hash: '#mark-partial-completed',
            label: 'Concluir&nbsp;parcial'
        }
    ];
    let reports = [
        {
            hash: '#print-pending',
            label: "Relat\xf3rio&nbsp;de&nbsp;Pend\xeancias"
        },
        {
            hash: '#print-order-doc',
            label: 'Espelho&nbsp;de&nbsp;Pedido'
        },
        {
            hash: '#print-durability',
            label: 'Durabilidade&nbsp;de&nbsp;Estoque&nbsp;(Excel)'
        },
        {
            hash: '#export-list-csv',
            label: 'Exportar&nbsp;listagem&nbsp;(CSV)'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-outputs', output_orders_crud.createOutputs.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-derrubada', output_orders_crud.createDerrubada.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#upload', output_orders_crud.uploadFromSpreadsheet.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#approve-orders', output_orders_crud.approveOrders.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-pending-order', output_orders_crud.createPendingOrder.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#mark-partial-completed', output_orders_crud.markPartialCompleted.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-pending', output_orders_crud.printPendingOrders.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-order-doc', output_orders_crud.printOrderDocument.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-durability', output_orders_crud.printDurability.bind(output_orders_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-list-csv', output_orders_crud.exportListCsv.bind(output_orders_crud));
    output_orders_crud.run('output_orders', "Pedidos&nbsp;Sa\xedda", document.getElementById('workarea'), (0, $86c74365004cd66c$export$2e2bcd8739ae039), (0, $3df4715102edd156$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $b31c53df218c817e$export$2e2bcd8739ae039 = $b31c53df218c817e$var$outputOrders;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $h1m6J = parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");

var $aGGTj = parcelRequire("aGGTj");

var $5zLFz = parcelRequire("5zLFz");


var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");

async function $44077aa73868f7f8$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: center; }
			.view td:nth-child(13)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: right; }
			.view td:nth-child(16)	{ text-align: left; }
			.view td:nth-child(17)	{ text-align: center; }
			.view td:nth-child(18)	{ text-align: center; }
			.view td:nth-child(19),
			.view td:nth-child(20),
			.view td:nth-child(21),
			.view td:nth-child(22)	{ text-align: left; max-width: 14rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Entrada</th>
					<th data-index="4" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[3]}">Origem</th>
					<th data-index="13" data-visible="${this.visible[4]}">Nota</th>
					<th data-index="14" data-visible="${this.visible[5]}">XML</th>
					<th data-index="5" data-visible="${this.visible[6]}">Cria\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[7]}">Recebimento</th>
					<th data-index="9" data-visible="${this.visible[8]}">Destinat\xe1ria</th>
					<th data-index="10" data-visible="${this.visible[9]}">Armaz\xe9m</th>
					<th data-index="12" data-visible="${this.visible[10]}">Programa</th>
					<th data-index="11" data-visible="${this.visible[11]}">Posi\xe7\xe3o</th>
					<th data-index="15" data-visible="${this.visible[12]}">Volumes</th>
					<th data-index="16" data-visible="${this.visible[13]}">Peso</th>
					<th data-index="17" data-visible="${this.visible[14]}">Status</th>
					<th data-index="29" data-visible="${this.visible[15]}">Agendamento</th>
					<th data-index="18" data-visible="${this.visible[16]}">Conclus\xe3o</th>
					<th data-index="20" data-visible="${this.visible[17]}">Embalagem (itens)</th>
					<th data-index="21" data-visible="${this.visible[18]}">Fabricante (itens)</th>
					<th data-index="22" data-visible="${this.visible[19]}">SKU (itens)</th>
					<th data-index="23" data-visible="${this.visible[20]}">Produto (itens)</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id}</td>
					<td data-visible='${this.visible[3]}'>${this.option($e3d776cc66101a71$export$2e2bcd8739ae039(), record.order_type)}</td>
					<td data-visible='${this.visible[4]}'>${record.invoice_number || ''}</td>
					<td data-visible='${this.visible[5]}'>${record.invoice_xml != null && String(record.invoice_xml).trim() ? '&#10003;' : ''}</td>
					<td data-visible='${this.visible[6]}'>${this.format($8IFAz.default(), record.created_on) || ''}</td>
					<td data-visible='${this.visible[7]}'>${this.format($8IFAz.default(), record.received_on) || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('companies', record.warehouse_company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('warehouses', [
            record.warehouse_company_id,
            record.warehouse_id
        ]) || ''}</td>
					<td data-visible='${this.visible[10]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[11]}'>${await this.key('locations', [
            record.warehouse_company_id,
            record.warehouse_id,
            record.location_id
        ], 'address') || ''}</td>
					<td data-visible='${this.visible[12]}'>${record.volumes ? this.format($3eqAU.default(0), record.volumes) : ''}</td>
					<td data-visible='${this.visible[13]}'>${record.weight ? this.format($3eqAU.default(3), record.weight) : ''}</td>
					<td data-visible='${this.visible[14]}'>${this.option($2d17d508d4f555c6$export$2e2bcd8739ae039(), record.status) || ''}</td>
					<td data-visible='${this.visible[15]}'>${(0, $b8167635cb1083d7$export$a8fb0eb6f2aae835)(record)}</td>
					<td data-visible='${this.visible[16]}'>${this.format($8IFAz.default(), record.completed_at) || ''}</td>
					<td data-visible='${this.visible[17]}'>${record.lines_packaging_summary || ''}</td>
					<td data-visible='${this.visible[18]}'>${record.lines_manufacturer_summary || ''}</td>
					<td data-visible='${this.visible[19]}'>${record.lines_sku_summary || ''}</td>
					<td data-visible='${this.visible[20]}'>${record.lines_product_summary || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}
 //<td data-visible='${this.visible[10]}'>${(await this.key('locations', [record.warehouse_company_id, record.warehouse_id, record.location_id], 'address'))?.join('-') || ''}</td>



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");

var $b60a2 = parcelRequire("b60a2");

var $h1m6J = parcelRequire("h1m6J");

var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $84MPM = parcelRequire("84MPM");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");


var $5zLFz = parcelRequire("5zLFz");

var $jUNyh = parcelRequire("jUNyh");

/** #MT-0510946 — resumo de agendamento de doca (somente leitura). */ function $54d2d9a3c0d3ddd6$var$hydrateDockScheduleSummary(root) {
    if (!root) return;
    const box = root.querySelector('#in-dock-schedule-summary');
    if (!box) return;
    const status = root._dockScheduleStatus;
    const dockName = root._dockScheduleDockName;
    const start = root._dockScheduleStart;
    const end = root._dockScheduleEnd;
    const hasOcc = root._dockScheduleHasOccurrence;
    if (!status && !root._dockScheduleId) {
        box.style.display = 'none';
        box.textContent = '';
        return;
    }
    const parts = [
        `<strong>Agendamento de doca:</strong> ${(0, $aecc276d35afe90f$export$a954299e2515e375)(status) || "\u2014"}`,
        dockName ? `Doca ${dockName}` : null,
        start ? `${(0, $aecc276d35afe90f$export$c5be672fb676f885)(start)} ${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(start)}\u{2013}${(0, $aecc276d35afe90f$export$3203edd9e5edd663)(end)}` : null,
        hasOcc ? "Com ocorr\xeancia" : null
    ].filter(Boolean);
    box.innerHTML = parts.join(" \xb7 ");
    box.style.display = '';
}
function $54d2d9a3c0d3ddd6$var$_parseSialNumInput(s) {
    const c = String(s ?? '').replace(/\./g, '').replace(',', '.');
    const n = parseFloat(c);
    return isFinite(n) ? n : 0;
}
function $54d2d9a3c0d3ddd6$var$_fmtBRLInput(v) {
    return Number(v).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
/** Retorna o elemento raiz do formulário #input, seja o próprio elemento ou o dialog que o contém. */ function $54d2d9a3c0d3ddd6$var$_inputFormRoot(root) {
    if (!root) return document.querySelector('#input');
    return root.id === 'input' ? root : root.querySelector('#input') || root;
}
function $54d2d9a3c0d3ddd6$var$_formatOrderPaymentSummary(src) {
    const count = Number(src?.payment_installment_count);
    let prazos = src?.payment_prazos;
    if (typeof prazos === 'string') try {
        prazos = JSON.parse(prazos);
    } catch (_) {
        prazos = null;
    }
    if (!Number.isFinite(count) || count <= 0 || !Array.isArray(prazos) || !prazos.length) return '';
    const parts = prazos.slice(0, count).map((d, i)=>`${String(i + 1).padStart(2, '0')}:${d}d`);
    return `${count} parc. \u{2014} ${parts.join(" \xb7 ")}`;
}
function $54d2d9a3c0d3ddd6$var$_togglePaymentBlock(root, show) {
    const fr = $54d2d9a3c0d3ddd6$var$_inputFormRoot(root);
    const block = fr?.querySelector('#in_payment_block');
    if (block) block.style.display = show ? '' : 'none';
}
/** #MT-6BF7122 — mostra/exige motivo quando status = Cancelada (80). */ async function $54d2d9a3c0d3ddd6$var$_syncCancelReasonVisibility(formset, options = {}) {
    const root = $54d2d9a3c0d3ddd6$var$_inputFormRoot(formset?.dialog?.getNode?.() || formset?.form?.node || document.querySelector('#input'));
    if (!root) return;
    const statusEl = root.querySelector('#status');
    const wrap = root.querySelector('#cancel_reason_wrap');
    const reasonEl = root.querySelector('#cancel_reason_id');
    const reasonField = formset?.form?.getFieldByName?.('cancel_reason_id');
    const companyField = formset?.form?.getFieldByName?.('company_id');
    const statusField = formset?.form?.getFieldByName?.('status');
    const companyId = companyField?.getValue?.() ?? root.querySelector('#company_id')?.value;
    const statusRaw = String(statusEl?.value || '').trim();
    const statusVal = statusField?.getValue?.();
    const isCanceled = String(statusVal ?? '') === '80' || statusRaw === '80' || /^cancelad/i.test(statusRaw);
    const savedReasonId = reasonField?.getValue?.();
    const displayNameHint = options.cancelReasonName || null;
    if (wrap) wrap.style.display = isCanceled ? '' : 'none';
    if (reasonEl) {
        if (isCanceled) reasonEl.setAttribute('required', 'required');
        else {
            reasonEl.removeAttribute('required');
            reasonEl.value = '';
            try {
                reasonField?.setValue?.(-1);
            } catch (_) {}
        }
    }
    if (!isCanceled || !companyId) return;
    // Popula a datalist direto (escopo do formulário), sem api.call/msgbox
    // e sem republicar company_id (isso reabria «Carregando...» e podia travar a tela).
    const inputId = formset?.form?.getFieldByName?.('id')?.getValue?.();
    const includeDisabled = inputId != null && inputId !== '' && Number(inputId) > 0;
    const rows = await (0, $5zLFz.hydrateInputCancelReasons)(companyId, includeDisabled);
    const formSel = formset?.form?.selector || '#input';
    (0, $h1m6J.loadOptions)('#cancel_reason_id', rows, 'id', [
        'name'
    ], undefined, formSel);
    const rid = savedReasonId != null && savedReasonId !== '' && savedReasonId !== -1 ? savedReasonId : null;
    if (rid != null) try {
        reasonField?.setValue?.(rid);
        reasonField?.refresh?.();
    } catch (_) {}
    if (reasonEl && isCanceled && !String(reasonEl.value || '').trim()) {
        const hit = rows.find((r)=>Number(r.id) === Number(rid));
        const name = hit?.name || displayNameHint;
        if (name) reasonEl.value = name;
    }
    if (!rows.length) (0, $jUNyh.notify)("N\xe3o h\xe1 motivos de cancelamento ativos para esta empresa. Cadastre em Cat\xe1logo \u2192 Motivos Cancelamento Entrada.", 'Motivo cancelamento');
}
function $54d2d9a3c0d3ddd6$var$_resolveCancelReasonId(root) {
    const el = root?.querySelector('#cancel_reason_id');
    if (!el) return null;
    const raw = String(el.value || '').trim();
    if (!raw) return null;
    if (/^\d+$/.test(raw)) return Number(raw);
    const opts = el.list?.options ? Array.from(el.list.options) : [];
    const byLabel = opts.find((o)=>String(o.label || o.textContent || '').trim() === raw);
    if (byLabel && /^\d+$/.test(String(byLabel.value))) return Number(byLabel.value);
    const byText = opts.find((o)=>String(o.textContent || '').trim() === raw);
    if (byText && /^\d+$/.test(String(byText.value))) return Number(byText.value);
    return null;
}
function $54d2d9a3c0d3ddd6$var$recalcInputTotals(root) {
    if (!root) return;
    const fr = $54d2d9a3c0d3ddd6$var$_inputFormRoot(root);
    const tbody = fr?.querySelector('.sial-items-scroll tbody');
    const totalEl = fr?.querySelector('#in-grand-total');
    if (!tbody) return;
    let grand = 0;
    tbody.querySelectorAll('tr.row').forEach((row)=>{
        const qEl = row.querySelector('[id^="quantity-"]');
        if (!qEl) return;
        const n = (qEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const qty = $54d2d9a3c0d3ddd6$var$_parseSialNumInput(qEl.value);
        const price = $54d2d9a3c0d3ddd6$var$_parseSialNumInput(row.querySelector(`#unit_price-${n}`)?.value);
        const total = qty * price;
        const ti = row.querySelector(`#item_total-${n}`);
        if (ti) ti.value = qty > 0 || price > 0 ? $54d2d9a3c0d3ddd6$var$_fmtBRLInput(total) : '';
        grand += total;
    });
    if (totalEl) totalEl.textContent = grand > 0 ? `Total da Entrada: ${$54d2d9a3c0d3ddd6$var$_fmtBRLInput(grand)}` : '';
}
function $54d2d9a3c0d3ddd6$var$_enableInvoiceXmlDownload(b64) {
    if (!b64) return;
    const anchor = document.querySelector('#download');
    if (!anchor) return;
    anchor.setAttribute('href', `data:text/xml;base64,${b64}`);
    anchor.removeAttribute('disabled');
}
/** #MT-3AD0979 — Entrada Concluída: formulário somente leitura (exceto Fechar e anexar XML). */ function $54d2d9a3c0d3ddd6$var$_inputIsCompletedLocked(fs) {
    const vals = fs?.form?.getValues?.() || {};
    return vals.edit_locked_by_completed === true || vals.edit_locked_by_completed === 1 || vals.edit_locked_by_completed === '1' || String(vals.edit_locked_by_completed).toLowerCase() === 'true';
}
function $54d2d9a3c0d3ddd6$var$applyInputCompletedEditLock(fs) {
    const form = $54d2d9a3c0d3ddd6$var$_inputFormRoot(fs?.dialog?.getNode?.()) || document.querySelector('#input');
    const banner = form?.querySelector('#in-lock-banner');
    if (!form) return;
    const locked = $54d2d9a3c0d3ddd6$var$_inputIsCompletedLocked(fs);
    form.classList.toggle('input--edit-locked', locked);
    if (banner) banner.style.display = locked ? 'block' : 'none';
    const toolbar = form.querySelector('.in-footer span:first-child');
    const rowImgs = toolbar ? toolbar.querySelectorAll('img') : [];
    const saveBtn = form.querySelector('.bn_Enter');
    if (!locked) {
        form.querySelectorAll('[data-in-lock-disabled]').forEach((el)=>{
            el.removeAttribute('data-in-lock-disabled');
            el.removeAttribute('disabled');
        });
        rowImgs.forEach((img)=>{
            img.style.pointerEvents = '';
            img.style.opacity = '';
        });
        if (saveBtn) saveBtn.style.display = '';
        return;
    }
    form.querySelectorAll('input, select, textarea, button').forEach((el)=>{
        if (el.type === 'hidden') return;
        if (el.tagName === 'BUTTON' && el.classList.contains('bn_Escape')) return;
        // XML da NF: permitido anexar mesmo com entrada concluída
        if (el.id === 'invoice_xml') return;
        el.setAttribute('data-in-lock-disabled', '1');
        el.setAttribute('disabled', 'disabled');
    });
    rowImgs.forEach((img)=>{
        img.style.pointerEvents = 'none';
        img.style.opacity = '0.45';
    });
    if (saveBtn) {
        saveBtn.setAttribute('data-in-lock-disabled', '1');
        saveBtn.setAttribute('disabled', 'disabled');
        saveBtn.style.display = 'none';
    }
}
// Provisionado × Faturado × Pendente — dados do Pedido de Entrada vinculado
let $54d2d9a3c0d3ddd6$var$_prov = {}; // product_id (str) → { ordered: int, received: int }
let $54d2d9a3c0d3ddd6$var$_initialQty = {}; // row index (str) → qty salva no banco (edit mode)
function $54d2d9a3c0d3ddd6$var$captureInitialQty(root) {
    $54d2d9a3c0d3ddd6$var$_initialQty = {};
    $54d2d9a3c0d3ddd6$var$_inputFormRoot(root)?.querySelectorAll('.sial-items-scroll tbody tr.row [id^="quantity-"]').forEach((el)=>{
        const n = (el.id.match(/\d+$/) || [
            '0'
        ])[0];
        $54d2d9a3c0d3ddd6$var$_initialQty[n] = $54d2d9a3c0d3ddd6$var$_parseSialNumInput(el.value);
    });
}
function $54d2d9a3c0d3ddd6$var$recalcProvisionedTotals(root) {
    const fr = $54d2d9a3c0d3ddd6$var$_inputFormRoot(root);
    if (!fr) return;
    const tbody = fr.querySelector('.sial-items-scroll tbody');
    if (!tbody) return;
    const idVal = fr.querySelector('#id')?.value?.trim();
    const isEdit = !!(idVal && parseInt(idVal, 10) > 0);
    tbody.querySelectorAll('tr.row').forEach((row)=>{
        const qEl = row.querySelector('[id^="quantity-"]');
        if (!qEl) return;
        const n = (qEl.id.match(/\d+$/) || [
            '0'
        ])[0];
        const pid = String(parseInt(row.querySelector(`#product_id-${n}`)?.value || '0', 10));
        const provEl = row.querySelector(`#prov_qty-${n}`);
        const billEl = row.querySelector(`#billed_qty-${n}`);
        const pendEl = row.querySelector(`#pend_qty-${n}`);
        const provData = parseInt(pid, 10) > 0 ? $54d2d9a3c0d3ddd6$var$_prov[pid] : null;
        if (!provData) {
            if (provEl) provEl.value = '';
            if (billEl) billEl.value = '';
            if (pendEl) pendEl.value = '';
            return;
        }
        const ordered = provData.ordered;
        const received_api = provData.received;
        const current_qty = $54d2d9a3c0d3ddd6$var$_parseSialNumInput(qEl.value);
        let faturada;
        if (isEdit) {
            // received_api já inclui este registro salvo; subtrai a qty original e adiciona a atual
            const initial_qty = $54d2d9a3c0d3ddd6$var$_initialQty[n] ?? 0;
            const from_others = Math.max(0, received_api - initial_qty);
            faturada = from_others + current_qty;
        } else // nova entrada: received_api conta outras entradas; soma a quantidade atual do form
        faturada = received_api + current_qty;
        const pendente = Math.max(0, ordered - faturada);
        if (provEl) provEl.value = ordered >= 0 ? String(ordered) : '';
        if (billEl) billEl.value = faturada >= 0 ? String(faturada) : '';
        if (pendEl) pendEl.value = String(pendente);
    });
}
function $54d2d9a3c0d3ddd6$var$_populateProvFromData(data) {
    $54d2d9a3c0d3ddd6$var$_prov = {};
    if (data?.items) {
        for (const item of data.items)if (item.product_id != null) $54d2d9a3c0d3ddd6$var$_prov[String(item.product_id)] = {
            ordered: item.quantity_ordered ?? 0,
            received: item.quantity_received ?? 0
        };
    }
}
/** Destino / armazém / posição: só escolha na lista quando o tenant tem «Entrada com coletor». */ function $54d2d9a3c0d3ddd6$var$applyInputCollectorDestinationReadonly(formset) {
    const root = formset.dialog?.getNode?.() || document.querySelector('#input');
    if (!root) return;
    const dest = root.querySelector('#warehouse_company_id');
    const wh = root.querySelector('#warehouse_id');
    const loc = root.querySelector('#location_id');
    if (!dest || !wh || !loc) return;
    const cid = formset.form?.getFieldByName('company_id')?.getValue();
    const titles = {
        warehouse_company_id: "Empresa do armaz\xe9m de recebimento",
        warehouse_id: "Armaz\xe9m de recebimento",
        location_id: "Posi\xe7\xe3o de recebimento no armaz\xe9m"
    };
    const setReadonly = (on)=>{
        const hint = on ? "Selecione um item da lista (par\xe2metro \xabEntrada com coletor\xbb ativo para esta empresa)." : '';
        for (const el of [
            dest,
            wh,
            loc
        ]){
            el.readOnly = !!on;
            const base = titles[el.id] || '';
            el.title = hint ? `${base}. ${hint}` : base;
        }
    };
    if (cid == null || cid === '' || Number(cid) < 0) {
        setReadonly(false);
        return;
    }
    Promise.resolve((0, $1cmSR.default).get('companies', cid)).then((c)=>{
        const on = c && (c.input_collector_strict === true || c.input_collector_strict === '1' || c.input_collector_strict === 1);
        setReadonly(!!on);
    }).catch(()=>setReadonly(false));
}
/** Após carregar registro: recarrega datalist de embalagem por linha e fabricante. */ async function $54d2d9a3c0d3ddd6$var$resyncInputLinePackagings(formset) {
    const root = formset.dialog?.getNode?.() || document.querySelector('#input');
    const form = formset.form;
    if (!root || !form) return;
    const company_id = form.getFieldByName('company_id')?.getValue();
    if (!company_id) return;
    const nodes = root.querySelectorAll('[id^="product_packaging_id-"]');
    for (const node of nodes){
        const m = node.id.match(/(\d+)$/);
        if (!m) continue;
        const sel = `#product_packaging_id-${m[1]}`;
        const field = form.getFieldBySelector(sel);
        if (field && typeof field.actions === 'function') await field.actions();
    }
}



var $54d2d9a3c0d3ddd6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input.in-input-form .in-input-tail {
				flex-shrink: 0;
			}
			#input.in-input-form .in-input-header-scroll {
				flex-shrink: 0;
				overflow-x: hidden;
				padding-right: 0.2rem;
			}
			#input.in-input-form #company_id				{ width: 10rem;		}
			#input.in-input-form #id						{ width: 5rem; text-align: right;	}
			#input.in-input-form #order_id				{ width: 5rem; text-align: right;	}
			#input.in-input-form #order_type				{ width: 7rem; 		}
			#input.in-input-form #created_on				{ width: 9rem;		}
			#input.in-input-form #received_on				{ width: 9rem;		}
			#input.in-input-form #completed_at			{ width: 9rem;		}
			#input.in-input-form #warehouse_company_id	{ width: 10rem;		}
			#input.in-input-form #warehouse_id			{ width: 10rem;		}
			#input.in-input-form #location_id				{ width: 5rem;		}
			#input.in-input-form #program_id				{ width: 10rem;		}
			#input.in-input-form #invoice_number			{ width: 7.5rem;	}
			#input.in-input-form #invoice_series			{ width: 5rem;		}
			#input.in-input-form #invoice_xml				{ width: 13rem;		}
			#input.in-input-form #volumes					{ width: 5rem; text-align: right;	}
			#input.in-input-form #weight					{ width: 5rem; text-align: right;	}
			#input.in-input-form #status	 				{ width: 10rem;		}
			#input.in-input-form .in-grand-total {
				text-align: right; font-weight: 600; font-size: 0.88rem;
				padding: 0.3rem 0.25rem 0; color: var(--color-text, #222);
				flex-shrink: 0;
			}
			#input.in-input-form .sial-items-scroll .in-col-product { width: 20%; }
			#input.in-input-form .sial-items-scroll .in-col-pack { width: 8%; }
			#input.in-input-form .sial-items-scroll .in-col-mfr { width: 7%; }
			#input.in-input-form .sial-items-scroll .in-col-unit { width: 6%; }
			#input.in-input-form .sial-items-scroll .in-col-qty { width: 5%; }
			#input.in-input-form .sial-items-scroll .in-col-serial { width: 8%; }
			#input.in-input-form .sial-items-scroll .in-col-prov,
			#input.in-input-form .sial-items-scroll .in-col-bill,
			#input.in-input-form .sial-items-scroll .in-col-pend { width: 4%; }
			#input.in-input-form .sial-items-scroll .in-col-price { width: 7%; }
			#input.in-input-form .sial-items-scroll .in-col-total { width: 7%; }
			#input.in-input-form .sial-items-scroll .serial {
				min-width: 5.5rem;
				background: #fffbeb;
				border-color: #f59e0b;
			}
			#input.in-input-form .in-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-shrink: 0;
				margin-top: 0.45rem;
				padding-top: 0.65rem;
				border-top: 1px solid var(--color-border, #ccc);
				gap: 0.75rem;
				flex-wrap: wrap;
			}
			#in-lock-banner { margin: 0 0 0.75rem 0; padding: 0.5rem 0.65rem; background: #f1f5f9; border: 1px solid #cbd5e1; border-radius: 4px; color: #475569; }
			#input.in-input-form.input--edit-locked label { color: #94a3b8; }
			.in-dock-summary {
				margin: 0 0 0.75rem 0;
				padding: 0.55rem 0.7rem;
				background: #eef2ff;
				border: 1px solid #c7d2fe;
				border-radius: 4px;
				color: #1e3a8a;
				font-size: 0.9rem;
			}
			.in-dock-summary strong { color: #4c1d95; }
		</style>
		<form id="input" class="form in-input-form sial-modal-form" autocomplete="off">
			<input type="hidden" id="edit_locked_by_completed" value="0">
			<p id="in-lock-banner" class="fsxx" style="display:none">Esta Entrada est\xe1 <strong>Conclu\xedda</strong>: n\xe3o \xe9 poss\xedvel alterar cabe\xe7alho, quantidades nem valores. Ainda \xe9 poss\xedvel <strong>anexar o XML da NF</strong>. Para reabrir os demais campos, use a opera\xe7\xe3o <strong>Estornar</strong>.</p>
			<div id="in-dock-schedule-summary" class="in-dock-summary" style="display:none" aria-live="polite"></div>
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="in-input-header-scroll">
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero do pedido vinculado">Pedido<sup>*</sup>
					<input id="order_id" type="text" required>
				</label>
				<label title="Tipo do pedido vinculado">Tipo<sup>*</sup>
					<input id="order_type" type="text" list="order_types" value="I" required>
				</label>
				<label title="Data e hora de cria\xe7\xe3o da entrada">Cria\xe7\xe3o
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de recebimento da mercadoria">Recebimento
					<input id="received_on" type="text" disabled>
				</label>
				<label title="Data e hora em que a entrada foi conclu\xedda (endere\xe7amento)">Conclus\xe3o
					<input id="completed_at" type="text" disabled>
				</label>
				<label title="Status da entrada">Status<sup>*</sup>
					<input id="status" type="text" list="input_status" value="10" required
						title="N\xe3o use Conferida/Conclu\xedda aqui: Conferida vem da Confer\xeancia de Entrada; Conclu\xedda do Endere\xe7amento. Alterar s\xf3 estes status no formul\xe1rio \xe9 bloqueado pela API.">
				</label>
				<label id="cancel_reason_wrap" title="Obrigat\xf3rio quando Status = Cancelada" style="display:none">Motivo cancelamento<sup>*</sup>
					<datalist id="input_cancel_reasons"></datalist>
					<input id="cancel_reason_id" type="text" list="input_cancel_reasons" autocomplete="off">
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa do armaz\xe9m de recebimento">Destino
					<input id="warehouse_company_id" type="text" list="companies">
				</label>
				<label title="Armaz\xe9m de recebimento">Armaz\xe9m
					<input id="warehouse_id" type="text" list="warehouses">
				</label>
				<label title="Posi\xe7\xe3o de recebimento no armaz\xe9m">Posi\xe7\xe3o
					<input id="location_id" type="text" list="locations">
				</label>
				<label title="Programa da entrada (todos os lotes desta entrada ficar\xe3o nesse programa)">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="N\xfamero da nota fiscal">Nota Fiscal
					<input id="invoice_number" type="text">
				</label>
				<label title="S\xe9rie da nota fiscal (ex.: 1, A)">S\xe9rie
					<input id="invoice_series" type="text" maxlength="10" placeholder="1">
				</label>
				<label class="file" ><a id="download" download="invoice.xml">XML</a>
					<input id="invoice_xml" type="file" accept=".xml, text/xml" title="Importar XML da nota fiscal">
				</label>
				<label title="N\xfamero de volumes">Volumes
					<input id="volumes" type="text">
				</label>
				<label title="Peso total dos volumes">Peso
					<input id="weight" type="text">
				</label>
			</div>
			<div class="fsb in-payment-from-order" id="in_payment_block" style="display:none;max-width:48rem;">
				<label title="Condi\xe7\xe3o de pagamento do Pedido de Entrada (somente leitura)">Cond. pagamento (pedido)
					<input id="order_payment_summary" type="text" disabled style="min-width:28rem;">
				</label>
			</div>
			</div>
			<div class="sial-items-panel">
				<div class="sial-items-title">Itens da entrada</div>
				<div class="sial-items-scroll">
					<table>
						<thead>
							<tr>
								<th class="sial-col-chk"></th>
								<th class="in-col-product">Produto<sup>*</sup></th>
								<th class="in-col-pack">Embalagem</th>
								<th class="in-col-mfr">Fabricante</th>
								<th class="in-col-unit">Unidade<sup>*</sup></th>
								<th class="in-col-qty tar">Qtde<sup>*</sup></th>
								<th class="in-col-serial" title="Opcional \u{2014} letras e n\xfameros, at\xe9 20">Serial</th>
								<th class="in-col-prov tar" title="Quantidade fechada no Pedido de Entrada">Qtd Prov.</th>
								<th class="in-col-bill tar" title="Quantidade j\xe1 faturada (acumulado de todas as entradas ativas)">Qtd Fat.</th>
								<th class="in-col-pend tar" title="Quantidade pendente de entrega (Provisionada - Faturada)">Qtd Pend.</th>
								<th class="in-col-price tar">Pre\xe7o Unit<sup>*</sup></th>
								<th class="in-col-total tar">Valor Total</th>
							</tr>
						</thead>
						<tbody>
							<tr class="row" data-size="10">
								<td class="sial-col-chk">
									<input id="checkbox-0" type="checkbox">
								</td>
								<td title="Produto">
									<input id="product_id-0" class="product" type="text" list="products">
								</td>
								<td title="Embalagem (P/S/T do produto)">
									<datalist id="packagings-0"></datalist>
									<input id="product_packaging_id-0" class="packaging" type="text" list="packagings-0" placeholder="\u{2014}" autocomplete="off">
								</td>
								<td title="Fabricante da embalagem (autom\xe1tico)">
									<input id="manufacturer_display-0" class="manufacturer_display" type="text" readonly tabindex="-1" autocomplete="off">
								</td>
								<td title="Unidade de compra">
									<input id="unit_id-0" class="unit" type="text" list="units" required>
								</td>
								<td class="tar" title="Quantidade">
									<input id="quantity-0" class="quantity" type="text" required>
								</td>
								<td title="Serial opcional (letras e n\xfameros, at\xe9 20)">
									<input id="serial-0" class="serial" type="text" maxlength="20" pattern="[A-Za-z0-9]*" placeholder="Opcional" autocomplete="off">
								</td>
								<td class="tar" title="Quantidade provisionada no Pedido de Entrada">
									<input id="prov_qty-0" class="prov_qty" type="text" readonly tabindex="-1">
								</td>
								<td class="tar" title="Quantidade j\xe1 faturada (acumulado de todas as entradas ativas do pedido)">
									<input id="billed_qty-0" class="billed_qty" type="text" readonly tabindex="-1">
								</td>
								<td class="tar" title="Quantidade pendente de entrega (Provisionada - Faturada)">
									<input id="pend_qty-0" class="pend_qty" type="text" readonly tabindex="-1">
								</td>
								<td class="tar" title="Pre\xe7o unit\xe1rio de compra">
									<input id="unit_price-0" class="price" type="text" required>
								</td>
								<td class="tar" title="Valor total do item (qtde \xd7 pre\xe7o unit.)">
									<input id="item_total-0" class="item_total" type="text" readonly tabindex="-1">
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="in-input-tail">
				<div id="in-grand-total" class="in-grand-total"></div>
			</div>
			<div class="in-footer">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#input',
        afterEditSetValues (formset, currentData) {
            if (formset?.hasTables?.()) formset.setTableHeight(10);
            $54d2d9a3c0d3ddd6$var$applyInputCompletedEditLock(formset);
            setTimeout(()=>(0, $b2411514bdf07434$export$b7c121695885def)($54d2d9a3c0d3ddd6$var$_inputFormRoot(formset.dialog?.getNode?.())), 50);
            // Dispara observers de destino/armazém para popular datalist de posição (como em Saídas).
            const whCo = formset.form.getFieldBySelector('#warehouse_company_id');
            const wh = formset.form.getFieldBySelector('#warehouse_id');
            const whCoVal = whCo?.getValue?.();
            if (whCo && typeof whCo.publish === 'function' && whCoVal != null && whCoVal !== '') whCo.publish('change', whCoVal);
            const whVal = wh?.getValue?.();
            if (wh && typeof wh.publish === 'function' && whVal != null && whVal !== '') wh.publish('change', whVal);
            setTimeout(()=>{
                $54d2d9a3c0d3ddd6$var$resyncInputLinePackagings(formset).catch(()=>{});
            }, 80);
            setTimeout(()=>$54d2d9a3c0d3ddd6$var$applyInputCollectorDestinationReadonly(formset), 0);
            const root = formset.dialog?.getNode?.() || document.querySelector('#input');
            const formRoot = $54d2d9a3c0d3ddd6$var$_inputFormRoot(root);
            if (formRoot) {
                formRoot._dockScheduleId = currentData?.dock_schedule_id ?? null;
                formRoot._dockScheduleStatus = currentData?.dock_schedule_status ?? null;
                formRoot._dockScheduleDockName = currentData?.dock_name ?? null;
                formRoot._dockScheduleStart = currentData?.dock_schedule_start ?? null;
                formRoot._dockScheduleEnd = currentData?.dock_schedule_end ?? null;
                formRoot._dockScheduleHasOccurrence = !!currentData?.dock_has_occurrence;
                $54d2d9a3c0d3ddd6$var$hydrateDockScheduleSummary(formRoot);
            }
            setTimeout(()=>{
                $54d2d9a3c0d3ddd6$var$recalcInputTotals(root);
                $54d2d9a3c0d3ddd6$var$applyInputCompletedEditLock(formset);
                $54d2d9a3c0d3ddd6$var$_syncCancelReasonVisibility(formset, {
                    cancelReasonName: currentData?.cancel_reason_name
                });
            }, 0);
            // Carregar provisionado/faturado ao editar entrada existente (#MT-2B00548)
            const fr = $54d2d9a3c0d3ddd6$var$_inputFormRoot(root);
            const company_id = fr?.querySelector('#company_id')?.value;
            const order_id = fr?.querySelector('#order_id')?.value;
            const order_type = fr?.querySelector('#order_type')?.value;
            if (company_id && order_id && order_type === 'I') (0, $9VcS9.default).call((0, $9VcS9.default).select_pending_input_items, company_id, Number(order_id)).then((data)=>{
                $54d2d9a3c0d3ddd6$var$_populateProvFromData(data);
                $54d2d9a3c0d3ddd6$var$captureInitialQty(root);
                $54d2d9a3c0d3ddd6$var$recalcProvisionedTotals(root);
                const summary = $54d2d9a3c0d3ddd6$var$_formatOrderPaymentSummary(data);
                const sumEl = fr?.querySelector('#order_payment_summary');
                if (sumEl && summary) sumEl.value = summary;
                $54d2d9a3c0d3ddd6$var$_togglePaymentBlock(fr, !!summary || !!(sumEl && sumEl.value));
                $54d2d9a3c0d3ddd6$var$applyInputCompletedEditLock(formset);
            }).catch(()=>{});
            else $54d2d9a3c0d3ddd6$var$_togglePaymentBlock(fr, false);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            this.getFieldByName('order_id').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('order_type').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('company_id').subscribe([
                'change'
            ], ()=>$54d2d9a3c0d3ddd6$var$applyInputCollectorDestinationReadonly(formset), false);
            this.getFieldByName('invoice_xml').subscribe([
                'change'
            ], this.enableDownload.bind(formset), false); // once = false
            // status precisa de types.pubsub() nos fields — senão getFieldByName devolve objeto sem subscribe
            const statusField = this.getFieldByName('status');
            if (statusField && typeof statusField.subscribe === 'function') statusField.subscribe([
                'change'
            ], ()=>$54d2d9a3c0d3ddd6$var$_syncCancelReasonVisibility(formset), false);
            this.getFieldByName('company_id').subscribe([
                'change'
            ], ()=>$54d2d9a3c0d3ddd6$var$_syncCancelReasonVisibility(formset), false);
            document.querySelector('#invoice_xml').addEventListener('change', this.fillItemsFromXML.bind(formset));
            Object.getPrototypeOf(this).init.call(this);
            setTimeout(()=>$54d2d9a3c0d3ddd6$var$applyInputCollectorDestinationReadonly(formset), 0);
            setTimeout(()=>$54d2d9a3c0d3ddd6$var$_syncCancelReasonVisibility(formset), 0);
            const root = formset.dialog?.getNode?.()?.querySelector('#input') || document.querySelector('#input');
            (0, $b2411514bdf07434$export$c784f48aeddf3f03)(root);
            if (root) {
                const tbl = root.querySelector('.sial-items-scroll table');
                if (tbl) tbl.addEventListener('input', ()=>{
                    $54d2d9a3c0d3ddd6$var$recalcInputTotals(root);
                    $54d2d9a3c0d3ddd6$var$recalcProvisionedTotals(root);
                });
            }
        },
        checkCondition (ev, publisher, value) {
            let company_id = this.form.getFieldByName('company_id').getValue();
            let order_id = this.form.getFieldByName('order_id').getValue();
            let order_type = this.form.getFieldByName('order_type').getValue();
            let key = String([
                company_id,
                order_type,
                order_id
            ]);
            if (company_id < 0 || order_type < 0 || !order_id || key == this.last_key) return;
            let is_edit = this.form.getFieldByName('id').getValue();
            if (!is_edit || is_edit && this.last_key) this.form.fillItems.call(this, company_id, order_type, order_id);
            this.last_key = key;
        },
        async fillItems (company_id, order_type, order_id) {
            let items;
            let invoice_number;
            let paymentSummary = '';
            switch(order_type){
                case 'I':
                    {
                        const pending = await (0, $9VcS9.default).call((0, $9VcS9.default).select_pending_input_items, company_id, order_id);
                        if (pending && typeof pending === 'object' && !Array.isArray(pending) && pending.items) {
                            items = pending.items;
                            invoice_number = pending.nf_number;
                            $54d2d9a3c0d3ddd6$var$_populateProvFromData(pending);
                            $54d2d9a3c0d3ddd6$var$_initialQty = {};
                            paymentSummary = $54d2d9a3c0d3ddd6$var$_formatOrderPaymentSummary(pending);
                        } else {
                            items = pending;
                            $54d2d9a3c0d3ddd6$var$_prov = {};
                        }
                    }
                    break;
                case 'O':
                    let order = await (0, $9VcS9.default).call((0, $9VcS9.default).select_output_order, company_id, order_id);
                    items = order.items;
                    break;
            }
            if (items) {
                this.clearAllRows();
                let record = (0, $b60a2.flatten)({
                    'items': items
                }, 'items');
                if (order_type === 'I' && invoice_number != null && String(invoice_number).trim()) {
                    const cur = this.form.getFieldByName('invoice_number')?.getValue();
                    if (cur == null || String(cur).trim() === '') record.invoice_number = String(invoice_number).trim();
                }
                if (order_type === 'I') record.order_payment_summary = paymentSummary;
                this.appendRows((0, $b60a2.getTopIndex)(record) - this.getEnabledRowsIndices().length + 1);
                this.form.setValues(record);
                this.form.refresh();
                const fillRoot = this.dialog?.getNode?.() || document.querySelector('#input');
                $54d2d9a3c0d3ddd6$var$_togglePaymentBlock(fillRoot, order_type === 'I' && !!paymentSummary);
                setTimeout(()=>$54d2d9a3c0d3ddd6$var$recalcProvisionedTotals(fillRoot), 50);
            }
        },
        enableDownload (ev, publisher, value) {
            $54d2d9a3c0d3ddd6$var$_enableInvoiceXmlDownload(value);
        },
        fillItemsFromXML (ev) {
            const file = ev?.target?.files?.[0];
            if (!file) return;
            const locked = $54d2d9a3c0d3ddd6$var$_inputIsCompletedLocked(this);
            let reader = new FileReader();
            reader.onloadend = async ()=>{
                const b64 = reader.result.slice(reader.result.indexOf(',') + 1);
                if (locked) {
                    const companyId = this.form.getFieldByName('company_id').getValue();
                    const inputId = this.form.getFieldByName('id').getValue();
                    if (!companyId || !inputId) {
                        const { notify: notify } = await Promise.resolve((parcelRequire("jUNyh")));
                        notify('Salve a entrada antes de anexar o XML.', 'Aviso');
                        return;
                    }
                    try {
                        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_input, companyId, inputId, {
                            invoice_xml: b64
                        });
                        if (resp == null) return;
                        $54d2d9a3c0d3ddd6$var$_enableInvoiceXmlDownload(b64);
                        // Atualiza nº/série na tela se a API preencheu (campos desabilitados)
                        try {
                            const fresh = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input, companyId, inputId);
                            if (fresh) {
                                const num = fresh.invoice_number;
                                const ser = fresh.invoice_series;
                                const numEl = document.querySelector('#invoice_number');
                                const serEl = document.querySelector('#invoice_series');
                                if (numEl && num != null && String(num).trim() !== '') numEl.value = String(num);
                                if (serEl && ser != null && String(ser).trim() !== '') serEl.value = String(ser);
                            }
                        } catch (_) {}
                        const { notify: notify } = await Promise.resolve((parcelRequire("jUNyh")));
                        notify("XML da NF anexado na entrada conclu\xedda.", 'Entrada');
                    } catch (e) {
                        const { notify: notify } = await Promise.resolve((parcelRequire("jUNyh")));
                        notify(e?.message || String(e), 'Erro');
                    }
                    return;
                }
                let data = {
                    'company_id': this.form.getFieldByName('company_id').getValue(),
                    'order_type': this.form.getFieldByName('order_type').getValue(),
                    'order_id': this.form.getFieldByName('order_id').getValue(),
                    'file': b64
                };
                let result = await (0, $9VcS9.default).call((0, $9VcS9.default).import_xml, data);
                if (!result) return;
                $54d2d9a3c0d3ddd6$var$_enableInvoiceXmlDownload(b64);
                this.form.setValues((0, $b60a2.flatten)(result, 'items'));
                this.form.refresh();
                // Recalcular totais e colunas derivadas após importação XML (#MT-AFDC849 / #MT-2B00548)
                const xmlRoot = this.dialog?.getNode?.() || document.querySelector('#input');
                setTimeout(()=>{
                    $54d2d9a3c0d3ddd6$var$recalcInputTotals(xmlRoot);
                    $54d2d9a3c0d3ddd6$var$recalcProvisionedTotals(xmlRoot);
                }, 50);
            };
            reader.readAsDataURL(file);
        }
    },
    fields: [
        {
            properties: {
                selector: '#edit_locked_by_completed'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id'
            },
            types: [
                $6Jl4s.default(),
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_type'
            },
            types: [
                $6Jl4s.default(),
                $e3d776cc66101a71$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#received_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#completed_at'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#invoice_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#invoice_series'
            },
            types: []
        },
        {
            properties: {
                selector: '#invoice_xml'
            },
            types: [
                $6Jl4s.default(),
                $84MPM.default()
            ]
        },
        {
            properties: {
                selector: '#volumes'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#weight'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#order_payment_summary'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $6Jl4s.default(),
                $2d17d508d4f555c6$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#cancel_reason_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('input_cancel_reasons', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#product_packaging_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'company_id',
                    'product_id-0'
                ]),
                $352bac93a0323cb4$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#manufacturer_display-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#unit_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'company_id',
                    'product_id-0'
                ]),
                $f7ae7d91f57919c4$export$2e2bcd8739ae039(1)
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#serial-0'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#prov_qty-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#billed_qty-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#pend_qty-0'
            },
            types: []
        },
        // Até 10 casas (MS/SUS), sem completar zeros visuais desnecessários.
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $3eqAU.default(10, 0, ',', '.', false)
            ]
        },
        {
            properties: {
                selector: '#item_total-0'
            },
            types: []
        }
    ]
};


parcelRequire("9VcS9");

var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $hlPFs = parcelRequire("hlPFs");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $1370eb70a282d012$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inventory.inv-conf-form .inv-header {
				display: flex;
				flex-wrap: wrap;
				gap: 0.45rem 0.75rem;
				align-items: flex-end;
				margin-bottom: 0.35rem;
			}
			#inventory.inv-conf-form .inv-header label {
				margin: 0;
			}
			#inventory.inv-conf-form #company_id				{ width: 13rem;		}
			#inventory.inv-conf-form #input_id				{ width: 5rem; text-align: right;	}
			#inventory.inv-conf-form #warehouse_company_id	{ width: 13rem;		}
			#inventory.inv-conf-form #warehouse_id			{ width: 13rem;		}
			#inventory.inv-conf-form #location_id			{ width: 7.5rem;	}
			#inventory.inv-conf-form #program_id				{ width: 14rem;		}
			#inventory.inv-conf-form .sial-items-scroll .inv-col-product { width: 22%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-gtin { width: 11%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-pack { width: 12%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-lot { width: 10%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-serial { width: 11%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-date { width: 9%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-qty { width: 7%; }
			#inventory.inv-conf-form .sial-items-scroll .inv-col-block { width: 6%; }
			#inventory.inv-conf-form .sial-items-scroll .serial {
				min-width: 6.5rem;
				background: #fffbeb;
				border-color: #f59e0b;
			}
			#inventory.inv-conf-form .inv-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				flex-shrink: 0;
				margin-top: 0.5rem;
				padding-top: 0.75rem;
				border-top: 1px solid var(--color-border, #ccc);
				gap: 0.75rem;
				flex-wrap: wrap;
			}
			#inventory.inv-conf-form .inv-footer .button { min-width: 5.5rem; }
		</style>
		<form id="inventory" class="form inv-conf-form sial-modal-form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="title">
				Confer\xeancia&nbsp;de&nbsp;Entrada
			</div>
			<div class="inv-header">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="input_id" type="text" disabled>
				</label>
				<label title="Empresa do armaz\xe9m de recebimento">Destino<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" required>
				</label>
				<label title="Armaz\xe9m de recebimento">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Posi\xe7\xe3o de recebimento no armaz\xe9m">Posi\xe7\xe3o<sup>*</sup>
					<input id="location_id" type="text" list="locations" required>
				</label>
				<label title="Programa da entrada (todos os produtos desta entrada ficar\xe3o nesse programa)">Programa<sup>*</sup>
					<input id="program_id" type="text" list="programs" required>
				</label>
			</div>
			<div class="sial-items-panel">
				<div class="sial-items-title">Lotes da confer\xeancia \u{2014} Serial opcional (at\xe9 20 letras/n\xfameros)</div>
				<div class="sial-items-scroll">
					<table>
						<thead>
							<tr>
								<th class="sial-col-chk"></th>
								<th class="inv-col-product">Produto<sup>*</sup></th>
								<th class="inv-col-gtin">GTIN emb.</th>
								<th class="inv-col-pack">Embalagem</th>
								<th class="inv-col-lot">Lote<sup>*</sup></th>
								<th class="inv-col-serial" title="Opcional \u{2014} letras e n\xfameros, at\xe9 20">Serial</th>
								<th class="inv-col-date">Data Fab<sup>*</sup></th>
								<th class="inv-col-date">Data Val<sup>*</sup></th>
								<th class="inv-col-qty tar">Qtde<sup>*</sup></th>
								<th class="inv-col-block">Bloquear</th>
							</tr>
						</thead>
						<tbody>
							<tr class="row" data-size="10">
								<input id="id-0" type="hidden">
								<td class="sial-col-chk">
									<input id="checkbox-0" type="checkbox">
								</td>
								<td title="Produto">
									<input id="product_id-0" class="product" type="text" list="products" required>
								</td>
								<td title="GTIN da embalagem (bip no coletor preenche embalagem)">
									<input id="packaging_gtin-0" class="packaging_gtin" type="text" placeholder="Bipar">
								</td>
								<td title="Embalagem do produto (cadastro)">
									<input id="product_packaging_id-0" class="packaging" type="text" list="packagings-0">
								</td>
								<td title="Numera\xe7\xe3o do lote">
									<input id="lot_number-0" class="lot" type="text" required>
								</td>
								<td title="Serial opcional (letras e n\xfameros, at\xe9 20)">
									<input id="serial-0" class="serial" type="text" maxlength="20" pattern="[A-Za-z0-9]*" placeholder="Opcional" autocomplete="off">
								</td>
								<td title="Data de fabrica\xe7\xe3o">
									<input id="manufacture_date-0" class="date" type="text" required>
								</td>
								<td title="Data de validade">
									<input id="expiration_date-0" class="date" type="text" required>
								</td>
								<td class="tar" title="Quantidade">
									<input id="quantity-0" class="quantity" type="text" required>
								</td>
								<td title="Direcionar lote para quarentena?">
									<input id="is_blocked-0" type="checkbox">
								</td>
								<input id="status-0" type="hidden">
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="inv-footer">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#inventory',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#location_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('programs', {
                    labels: [
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#packaging_gtin-0'
            },
            types: [
                $6Jl4s.default(),
                $hlPFs.default(),
                $78c0baa046d6948e$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#product_packaging_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('product_id-0'),
                $de971e0b3c51812e$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#lot_number-0'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#serial-0'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#manufacture_date-0'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#expiration_date-0'
            },
            types: [
                $b7D1Q.default(),
                $06588da92ceea853$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#is_blocked-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#status-0'
            },
            types: []
        }
    ]
};


parcelRequire("9VcS9");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $2e208f3196f713a1$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#putaway #company_id			{ width: 11rem;		}
			#putaway #input_id				{ width: 5rem; text-align: right;	}
			#putaway #warehouse_company_id	{ width: 11rem;		}
			#putaway #warehouse_id			{ width: 11rem;		}
			#putaway .lot_id				{ width: 5rem; text-align: right;	}
			#putaway .lot					{ width: 9rem;		}
			#putaway .sku					{ width: 9rem;		}
			#putaway .product_name			{ width: 16rem;		}
			#putaway .expiration_date		{ width: 7rem;		}
			#putaway .location				{ width: 8rem;		}
			#putaway .quantity				{ width: 4.5rem; text-align: right;	}
			#putaway .putaway-hint {
				font-size: 0.85rem;
				color: #444;
				max-width: 52rem;
				margin: 0.35rem 0 0.75rem 0;
				line-height: 1.35;
			}
		</style>
		<form id="putaway" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<div class="title">
				Endere\xe7amento&nbsp;de&nbsp;Lotes
			</div>
			<p class="putaway-hint">
				Linhas v\xeam da confer\xeancia (estoque na posi\xe7\xe3o de recebimento da entrada). Preencha <strong>Posi\xe7\xe3o</strong> com o endere\xe7o final.
				Para <strong>dividir</strong> o mesmo lote em v\xe1rios endere\xe7os, use o bot\xe3o <strong>+</strong>: repita o mesmo Id Lote e distribua as quantidades (a soma por SKU deve fechar com o pedido).
				Se o saldo j\xe1 saiu do recebimento (movimenta\xe7\xe3o), enviar o endere\xe7amento <strong>s\xf3 conclui</strong> a entrada \u{2014} n\xe3o move de novo.
			</p>
			<div class="fsb mtm">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="input_id" type="text" disabled>
				</label>
				<label title="Empresa do armaz\xe9m de recebimento">Destino<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" disabled>
				</label>
				<label title="Armaz\xe9m de recebimento">Armaz\xe9m<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Id Lote<sup>*</sup></th>
							<th>Lote</th>
							<th>SKU</th>
							<th>Produto</th>
							<th>Validade</th>
							<th>Posi\xe7\xe3o destino<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<!-- <input id="id-0" type="hidden"> -->
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Identificador do lote">
								<input id="lot_id-0" class="lot_id" type="text" required>
							</td>
							<td title="Numera\xe7\xe3o do lote">
								<input id="lot_number-0" class="lot" type="text" disabled>
							</td>
							<td title="SKU do produto">
								<input id="sku-0" class="sku" type="text" disabled>
							</td>
							<td title="Nome do produto">
								<input id="product_name-0" class="product_name" type="text" disabled>
							</td>
							<td title="Validade do lote">
								<input id="expiration_date-0" class="expiration_date" type="text" disabled>
							</td>
							<td title="Endere\xe7o final no armaz\xe9m">
								<input id="location_id-0" class="location" list="locations" type="text" required>
							</td>
							<td title="Quantidade depositada na posi\xe7\xe3o">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#putaway',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        //{ properties: { selector: '#id-0' }, types: [] },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#lot_number-0'
            },
            types: [
                $6Jl4s.default(),
                $6lTH5.default('lot_id-0'),
                $d799b5dade42e782$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#sku-0'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#product_name-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#expiration_date-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#location_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_id'),
                $dg8P2.default('locations', {
                    labels: [
                        'address'
                    ],
                    sep: '-',
                    key: 'warehouse_company_id'
                })
            ]
        },
        {
            properties: {
                selector: '#quantity-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};



var $5Aed9 = parcelRequire("5Aed9");
var $3OKkn = parcelRequire("3OKkn");
var $knytZ = parcelRequire("knytZ");
/** Opções fixas de finalidade (valor 1–7) para entradas — enviadas como `purpose` na API. */ const $bbd1a845e6487967$var$PURPOSE_OPTIONS_INPUT = `
						<option value="1" selected>Compra ou recebimento para comercializa\xe7\xe3o</option>
						<option value="2">Devolu\xe7\xe3o de compra ou venda</option>
						<option value="3">Outra entrada (baixa / n\xe3o especificada \u{2014} CFOP 1949/2949)</option>
						<option value="4">Bonifica\xe7\xe3o, doa\xe7\xe3o ou brinde (entrada \u{2014} CFOP 1949/2949)</option>
						<option value="5">Amostra gr\xe1tis (entrada \u{2014} CFOP 1949/2949)</option>
						<option value="6">Por conta e ordem de terceiros (entrada \u{2014} CFOP 1949/2949)</option>
						<option value="7">Recebimento para dep\xf3sito em armaz\xe9m (entrada \u{2014} CFOP 1905/2905)</option>`;
/** Saídas: somente finalidades padrão (sem CFOPs 5xxx da empresa). */ const $bbd1a845e6487967$var$PURPOSE_OPTIONS_OUTPUT_LEGACY = `
						<option value="1" selected>Venda de mercadoria</option>
						<option value="2">Devolu\xe7\xe3o de compra ou venda</option>
						<option value="3">Baixa de estoque</option>
						<option value="4">Remessa em bonifica\xe7\xe3o</option>
						<option value="5">Remessa de amostra gr\xe1tis</option>
						<option value="6">Remessa por conta e ordem de terceiros</option>`;
function $bbd1a845e6487967$var$escapeHtml(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $bbd1a845e6487967$var$cfopDigits(code) {
    return String(code ?? '').replace(/\D/g, '');
}
/** API / Postgres podem enviar venda como boolean, 0/1 ou string. */ function $bbd1a845e6487967$var$cfopIsVenda(c) {
    const v = c?.venda;
    return v === true || v === 1 || v === '1' || v === 'true';
}
/** CFOP elegível no modal de gerar NF de saída: 5xxx, 6xxx ou marcado como venda no cadastro. */ function $bbd1a845e6487967$var$isOutputCfopChoice(c) {
    const d = $bbd1a845e6487967$var$cfopDigits(c.code);
    if (d.startsWith('5') || d.startsWith('6')) return true;
    return $bbd1a845e6487967$var$cfopIsVenda(c);
}
function $bbd1a845e6487967$export$dd3b5e98da1289c8(cfopRows) {
    const filtered = (cfopRows || []).filter($bbd1a845e6487967$var$isOutputCfopChoice).sort((a, b)=>$bbd1a845e6487967$var$cfopDigits(a.code).localeCompare($bbd1a845e6487967$var$cfopDigits(b.code)));
    const parts = [];
    if (filtered.length) {
        parts.push('<optgroup label="CFOP cadastrado (5xxx, 6xxx ou marcado como venda)">');
        filtered.forEach((c, i)=>{
            const d = $bbd1a845e6487967$var$cfopDigits(c.code);
            const sel = i === 0 ? ' selected' : '';
            parts.push(`<option value="${d}"${sel}>${d} \u{2014} ${$bbd1a845e6487967$var$escapeHtml(c.description)}</option>`);
        });
        parts.push('</optgroup>');
    }
    parts.push('<optgroup label="Finalidades padr\xe3o (CFOP calculado pelo sistema)">');
    const leg = $bbd1a845e6487967$var$PURPOSE_OPTIONS_OUTPUT_LEGACY.replace('<option value="1" selected>', filtered.length ? '<option value="1">' : '<option value="1" selected>');
    parts.push(leg);
    parts.push('</optgroup>');
    return parts.join('\n');
}
function $bbd1a845e6487967$export$2e2bcd8739ae039(isInput, outputPurposeInnerHtml = null) {
    const purposeBlock = isInput ? $bbd1a845e6487967$var$PURPOSE_OPTIONS_INPUT : outputPurposeInnerHtml != null ? outputPurposeInnerHtml : $bbd1a845e6487967$var$PURPOSE_OPTIONS_OUTPUT_LEGACY;
    const purposeLabel = isInput ? 'Finalidade' : 'Finalidade / CFOP';
    const purposeTitle = isInput ? "Finalidade da emiss\xe3o (define o CFOP)" : "CFOP cadastrado (5xxx, 6xxx ou venda) ou finalidade padr\xe3o do sistema";
    const nfHintOutput = !isInput ? `<p class="hint nf-hint">
				<strong>Sa\xeddas:</strong> a NF-e usa os itens da <strong>sa\xedda selecionada</strong>. Por pedido, admita-se <strong>uma NF autorizada</strong>; com sa\xedda consolidada, o faturamento fica alinhado ao pedido.
			</p>` : '';
    return {
        html: `
		<form id="create-invoices" class="form sial-modal-form sial-create-invoices-form" autocomplete="off">
			<div class="title">
				Gerar notas para <span id="count"></span> <span id="io-noun">sa\xeddas</span>
			</div>
			${nfHintOutput}
			<div class="mtl">
				<label class="purpose" title="${purposeTitle}">${purposeLabel}
					<select id="purpose" required title="${purposeTitle}">
						${purposeBlock}
					</select>
				</label>
			</div>
			<div>
				<label title="Informa\xe7\xf5es complementares de interesse do contribuinte">Informa\xe7\xf5es Complementares
					<textarea id="info" rows="4" placeholder="Opcional"></textarea>
				</label>
			</div>
			<div class="tal">
				<label title="Incluir observa\xe7\xf5es dos pedidos nas informa\xe7\xf5es complementares das notas">
					<input id="include" type="checkbox" checked>
					Incluir observa\xe7\xf5es dos pedidos
				</label>
			</div>
			<div class="mtm sial-create-invoices-actions">
				<button type="button" class='bn_Escape button'>Cancelar</button>
				<button type="submit" class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,
        form: {
            selector: '#create-invoices',
            init (formset) {
                formset.form.eraseValues();
                Object.getPrototypeOf(this).init.call(this);
                const root = formset.form.getNode?.() || document.querySelector(this.selector);
                const sel = root?.querySelector('#purpose');
                if (sel) {
                    const syncTitle = ()=>{
                        const opt = sel.options[sel.selectedIndex];
                        sel.title = opt && opt.text ? opt.text.trim() : purposeTitle;
                    };
                    sel.addEventListener('change', syncTitle);
                    syncTitle();
                }
            }
        },
        fields: [
            {
                properties: {
                    selector: '#purpose'
                },
                types: [
                    $3OKkn.default()
                ]
            },
            {
                properties: {
                    selector: '#info'
                },
                types: [
                    $knytZ.default()
                ]
            },
            {
                properties: {
                    selector: '#include'
                },
                types: [
                    $5Aed9.default()
                ]
            }
        ]
    };
}


parcelRequire("9VcS9");

var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $eb194eabe879d7c6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input-labels #company_id	{ width: 14rem;		}
			#input-labels #device_id	{ width: 30rem;		}
			#input-labels .product		{ width: 20rem;		}
			#input-labels .lot			{ width: 8rem;		}
			#input-labels .date			{ width: 7rem;		}
			#input-labels .labels		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="input-labels" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;de&nbsp;Lotes
			</div>
			<div class="fsb mtm">
				<input id="company_id" type="hidden">
				<input id="input_id" type="hidden">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="device_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Produto</th>
							<th>Lote</th>
							<th>Fabrica\xe7\xe3o</th>
							<th>Validade</th>
							<th>Etiquetas<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" disabled>
							</td>
							<td title="Numera\xe7\xe3o do lote">
								<input id="lot_number-0" class="lot" type="text" disabled>
							</td>
							<td title="Data de fabrica\xe7\xe3o">
								<input id="manufacture_date-0" class="date" type="text" disabled>
							</td>
							<td title="Data de validade">
								<input id="expiration_date-0" class="date" type="text" disabled>
							</td>
							<td title="Etiquetas">
								<input id="labels-0" class="labels" type="number" min="0" max="99" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#input-labels',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#device_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('device_company_id'),
                $dg8P2.default('devices')
            ]
        },
        //{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_number-0'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#manufacture_date-0'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#expiration_date-0'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#labels-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $c9f6850858a9a613$export$2e2bcd8739ae039 = {
    html: `
		<style>
		</style>
		<form id="reverse-input" class="form" autocomplete="off">
			<div class="title">
				Estorno de entrada
			</div>
			<div class="mtl">
				<input id="company_id" type="hidden">
				<input id="input_id" type="hidden">
				<label title="Selecione status abaixo do atual para revers\xe3o das opera\xe7\xf5es">Status desejado:
					<input id="status" type="text" list="input_status" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Estornar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#reverse-input',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $2d17d508d4f555c6$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $6Jl4s = parcelRequire("6Jl4s");
var $472dfc2c3e29d1c0$export$2e2bcd8739ae039 = {
    html: `
		<form id="inputs-print-complete-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<p class="fss">Filtros por empresa e per\xedodo. CSV e Excel trazem todas as colunas; o PDF resume chaves e SEFAZ (use exporta\xe7\xe3o para an\xe1lise completa).</p>
			<div class="fsb">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label>Data inicial<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Data final<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="fsb">
				<label>Base do per\xedodo
					<select id="date_basis">
						<option value="created">Data de cria\xe7\xe3o da entrada</option>
						<option value="received">Data de recebimento</option>
						<option value="completed">Data de conclus\xe3o (endere\xe7amento)</option>
					</select>
				</label>
				<label>Armaz\xe9m (opcional)
					<select id="warehouse_id"><option value="">Todos</option></select>
				</label>
				<label>Status (opcional)
					<select id="status">
						<option value="">Todos</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label>Origem do pedido (opcional)
					<select id="order_type">
						<option value="">Todos</option>
						<option value="I">Pedido de entrada</option>
						<option value="O">Pedido de sa\xedda</option>
					</select>
				</label>
				<label>Formato
					<select id="format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="ic-count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#inputs-print-complete-report',
        init (formset) {
            const root = formset.form?.selector || '#inputs-print-complete-report';
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const stSel = document.querySelector(`${root} #status`);
            const st = $2d17d508d4f555c6$export$2e2bcd8739ae039();
            if (stSel && st?.options) for (const o of st.options){
                const opt = document.createElement('option');
                opt.value = o.value;
                opt.textContent = o.label;
                stSel.appendChild(opt);
            }
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_basis'
            },
            types: []
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#order_type'
            },
            types: []
        },
        {
            properties: {
                selector: '#format'
            },
            types: []
        },
        {
            properties: {
                selector: '#ic-count-msg'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $6Jl4s = parcelRequire("6Jl4s");
var $7045621166dad360$export$2e2bcd8739ae039 = {
    html: `
		<form id="inputs-print-documents-list" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<p class="fss">Controle documental por empenho e NF. Exporte em <strong>Excel</strong>, <strong>CSV</strong> ou <strong>PDF</strong> (campo Formato abaixo).</p>
			<div class="fsb">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label>Data inicial<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Data final<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="fsb">
				<label>Base do per\xedodo
					<select id="date_basis">
						<option value="created">Data de cria\xe7\xe3o da entrada</option>
						<option value="received">Data de recebimento</option>
						<option value="completed">Data de conclus\xe3o (endere\xe7amento)</option>
					</select>
				</label>
				<label>Armaz\xe9m (opcional)
					<select id="warehouse_id"><option value="">Todos</option></select>
				</label>
				<label>Status (opcional)
					<select id="status">
						<option value="">Todos</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label>
					<input id="empenho_only" type="checkbox" value="1">
					Somente com empenho informado
				</label>
				<label>Exportar como<sup>*</sup>
					<select id="format" name="format">
						<option value="xlsx">Excel (.xlsx)</option>
						<option value="csv">CSV (texto separado por ;)</option>
						<option value="pdf">PDF</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="idl-count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#inputs-print-documents-list',
        init (formset) {
            const root = formset.form?.selector || '#inputs-print-documents-list';
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            const stSel = document.querySelector(`${root} #status`);
            const st = $2d17d508d4f555c6$export$2e2bcd8739ae039();
            if (stSel && st?.options) for (const o of st.options){
                const opt = document.createElement('option');
                opt.value = o.value;
                opt.textContent = o.label;
                stSel.appendChild(opt);
            }
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_basis'
            },
            types: []
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#empenho_only'
            },
            types: []
        },
        {
            properties: {
                selector: '#format'
            },
            types: []
        },
        {
            properties: {
                selector: '#idl-count-msg'
            },
            types: []
        }
    ]
};


var $e8a0406a1c7aa80c$export$2e2bcd8739ae039 = {
    html: `
		<form id="inputs-export-csv-form" class="form" autocomplete="off">
			<p class="fss">Gera um arquivo CSV com os mesmos cabe\xe7alhos da listagem
				(uma linha por entrada; separador ponto e v\xedrgula, UTF-8).</p>
			<div class="fsb mtm">
				<label class="fss" style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
					<input type="checkbox" id="use_list_filter" value="1" checked
						onchange="(function(c){var h=document.getElementById('export-csv-hint-bare-inputs');if(h)h.style.display=c.checked?'none':'block';})(this)">
					Aplicar os filtros e a ordena\xe7\xe3o <strong>atuais</strong> da tela
				</label>
			</div>
			<p class="fss" id="export-csv-hint-bare-inputs" style="display:none">
				<strong>Aten\xe7\xe3o:</strong> sem filtro, todas as entradas a que voc\xea tem acesso ser\xe3o
				inclu\xeddas. Arquivos muito grandes podem demorar.
			</p>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Exportar CSV</button>
			</div>
		</form>
	`,
    form: {
        selector: '#inputs-export-csv-form'
    },
    fields: [
        {
            properties: {
                selector: '#use_list_filter'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
const $ee2c059f60a8fc19$var$inputs = function() {
    let inputs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async run (module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options) {
            try {
                const raw = localStorage.getItem('inputs.setup');
                if (raw) {
                    const s = JSON.parse(raw);
                    if (!s.in_grid_dock_schedule_v1) {
                        const cols = String(s.columns || this.default_columns || options?.default_columns || '').split(',').map((c)=>c.trim()).filter(Boolean);
                        if (!cols.includes('29')) cols.push('29');
                        s.columns = cols.join(',');
                        s.in_grid_dock_schedule_v1 = true;
                        localStorage.setItem('inputs.setup', JSON.stringify(s));
                    }
                }
            } catch (_) {}
            return (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).run.call(this, module_name, label, target_node, grid_view, record_form, fieldspecs, operations, reports, options);
        },
        async loadScopedLocationsToDb (filterOverride = null) {
            const saved = this.filter;
            try {
                if (filterOverride != null) this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(filterOverride, this.fieldspecs);
                const q = await this.queryFilteredForLocations();
                if (!/[?&]filter=/.test(q)) return;
                const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, q);
                await (0, $1cmSR.default).set('locations', Array.isArray(data) ? data : []);
            } finally{
                if (filterOverride != null) this.filter = saved;
            }
        },
        async safeGetJson (endpointFn, fallbackPath) {
            if (typeof endpointFn === 'function') return await (0, $9VcS9.default).call(endpointFn);
            const endpoint = `${(0, $9VcS9.default).HOST}${fallbackPath}`;
            const response = await fetch(endpoint, {
                method: 'GET',
                credentials: 'include'
            });
            if (!response.ok) throw new Error(`Falha ao consultar API (${response.status})`);
            const contentType = (response.headers.get('content-type') || '').toLowerCase();
            if (!contentType.includes('application/json')) throw new Error("Resposta inv\xe1lida da API (esperado JSON).");
            return await response.json();
        },
        async loadCompanyProductsToDb (company_id) {
            if (company_id == null || company_id === '') return;
            const qs = new URLSearchParams({
                filter: `company_id*eq*${company_id}`,
                sort: '2',
                limit: '0'
            });
            const data = await this.safeGetJson(typeof (0, $9VcS9.default).list_products === 'function' ? ()=>(0, $9VcS9.default).list_products('?' + qs.toString()) : null, `/products?${qs.toString()}`);
            if (Array.isArray(data)) await (0, $1cmSR.default).set('products', data);
        },
        async loadLocationsForCompanyToDb (company_id, warehouse_id = null) {
            if (company_id == null || company_id === '') return;
            const parts = [
                `company_id*eq*${company_id}`
            ];
            if (warehouse_id != null && warehouse_id !== '') parts.push(`warehouse_id*eq*${warehouse_id}`);
            const qs = new URLSearchParams({
                filter: parts.join(','),
                sort: '4',
                limit: '0'
            });
            const data = await this.safeGetJson(typeof (0, $9VcS9.default).list_locations === 'function' ? ()=>(0, $9VcS9.default).list_locations('?' + qs.toString()) : null, `/locations?${qs.toString()}`);
            if (Array.isArray(data)) await (0, $1cmSR.default).set('locations', data);
        },
        async loadBaseData () {
            const q = this.queryAll();
            await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, q).then((data)=>data && (0, $1cmSR.default).set('companies', data)).catch((err)=>(0, $jUNyh.notify)(err?.message || String(err))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, q).then((data)=>data && (0, $1cmSR.default).set('warehouses', data)).catch((err)=>(0, $jUNyh.notify)(err?.message || String(err))),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, q).then((data)=>data && (0, $1cmSR.default).set('devices', data)).catch(()=>{}),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, q).then((data)=>data && (0, $1cmSR.default).set('programs', data)).catch(()=>{}),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_units, q).then((data)=>data && (0, $1cmSR.default).set('units', data)).catch((err)=>(0, $jUNyh.notify)(err?.message || String(err)))
            ]);
            await this.loadScopedLocationsToDb();
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_inputs, query);
        },
        async loadRecord (id) {
            const [company_id, input_id] = JSON.parse(id);
            const _record = await this.safeGetJson(typeof (0, $9VcS9.default).select_input === 'function' ? ()=>(0, $9VcS9.default).select_input(company_id, input_id) : null, `/companies/${company_id}/inputs/${input_id}`);
            if (!_record) return null;
            try {
                await this.loadCompanyProductsToDb(_record.company_id);
            } catch (_) {}
            try {
                const whCo = _record.warehouse_company_id ?? _record.company_id;
                await this.loadLocationsForCompanyToDb(whCo, _record.warehouse_id);
            } catch (_) {}
            if (_record.order_type === 'I' && _record.order_id) try {
                const order = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order, _record.company_id, _record.order_id);
                if (order) {
                    const count = Number(order.payment_installment_count);
                    let prazos = order.payment_prazos;
                    if (typeof prazos === 'string') try {
                        prazos = JSON.parse(prazos);
                    } catch (_) {
                        prazos = null;
                    }
                    if (Number.isFinite(count) && count > 0 && Array.isArray(prazos) && prazos.length) {
                        const parts = prazos.slice(0, count).map((d, i)=>`${String(i + 1).padStart(2, '0')}:${d}d`);
                        _record.order_payment_summary = `${count} parc. \u{2014} ${parts.join(" \xb7 ")}`;
                    }
                }
            } catch (_) {}
            try {
                const isCanceled = Number(_record.status) === 80;
                await (0, $5zLFz.hydrateInputCancelReasons)(_record.company_id, isCanceled);
            } catch (_) {}
            return (0, $b60a2.flatten)(_record, 'items');
        },
        async editFilter () {
            await this.loadScopedLocationsToDb(this.filter);
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    await this.loadScopedLocationsToDb(formData);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            await this.loadScopedLocationsToDb(this.filter);
            await this.loadPage(1);
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'items');
            let _record = {
                order_type: data.order_type,
                order_id: Number(data.order_id),
                warehouse_company_id: data.warehouse_company_id,
                warehouse_id: Number(data.warehouse_id),
                location_id: Number(data.location_id),
                program_id: data.program_id != null && data.program_id !== '' && Number(data.program_id) >= 0 ? Number(data.program_id) : null,
                invoice_number: data.invoice_number,
                invoice_series: data.invoice_series || null,
                invoice_xml: data.invoice_xml,
                volumes: Number(data.volumes),
                weight: Number(data.weight),
                status: Number(data.status),
                items: data.items.filter((item)=>item && item.product_id != null && item.product_id !== '' && Number(item.product_id) > 0).map((item)=>{
                    const pp = item.product_packaging_id;
                    const packaging_id = pp != null && pp !== '' && Number(pp) > 0 ? Number(pp) : null;
                    return {
                        product_id: Number(item.product_id),
                        unit_id: Number(item.unit_id),
                        quantity: Number(item.quantity),
                        unit_price: Number(item.unit_price),
                        product_packaging_id: packaging_id,
                        serial: item.serial && String(item.serial).trim() ? String(item.serial).trim().slice(0, 20) : null
                    };
                })
            };
            if (Number(data.status) === 80) {
                const rid = await (0, $5zLFz.resolveInputCancelReasonId)(data.cancel_reason_id, data.company_id);
                if (!rid || !Number.isFinite(rid)) throw new Error('Informe o Motivo de cancelamento ao definir a Entrada como Cancelada.');
                _record.cancel_reason_id = rid;
            } else _record.cancel_reason_id = null;
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_input, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_input, data.company_id, _record);
        },
        async inventory () {
            const sendRequest = async (data)=>{
                data = (0, $b60a2.deepen)(data, 'lots');
                let _record = {
                    warehouse_company_id: data.warehouse_company_id,
                    warehouse_id: Number(data.warehouse_id),
                    location_id: Number(data.location_id),
                    program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
                    lots: data.lots.map((lot)=>{
                        const pp = lot.product_packaging_id;
                        const packaging_id = pp != null && pp !== '' && Number(pp) > 0 ? Number(pp) : null;
                        const rawId = lot.id;
                        const lotId = rawId != null && rawId !== '' ? Number(rawId) : null;
                        return {
                            id: Number.isFinite(lotId) && lotId > 0 ? lotId : null,
                            product_id: Number(lot.product_id),
                            product_packaging_id: packaging_id,
                            lot_number: lot.lot_number,
                            serial: lot.serial && String(lot.serial).trim() ? String(lot.serial).trim().slice(0, 20) : null,
                            manufacture_date: lot.manufacture_date,
                            expiration_date: lot.expiration_date,
                            quantity: Number(lot.quantity),
                            status: Number(lot.status),
                            is_blocked: lot.is_blocked == '1' // Can be: undefined, '0', '1'
                        };
                    })
                };
                if (await (0, $9VcS9.default).call((0, $9VcS9.default).inventory_input, data.company_id, data.input_id, _record)) {
                    (0, $9VcS9.default).call((0, $9VcS9.default).list_lots, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('lots', data)).catch((err)=>(0, $jUNyh.notify)(err?.message || String(err)));
                    this.loadPage(); // Show updated input status
                    return true;
                }
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $jUNyh.notify)("Selecione apenas uma entrada para confer\xeancia", "Confer\xeancia de Entrada");
            let input = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input, ids[0][0], ids[0][1]);
            // Alinhado a entities/input_.py: inventory() exige status >= ST_RECEIVED (30); >= ST_VERIFIED (50) já concluiu.
            const INPUT_ST_RECEIVED = 30;
            const INPUT_ST_VERIFIED = 50;
            const st = Number(input.status);
            if (st < INPUT_ST_RECEIVED) return (0, $jUNyh.notify)('Conclua o recebimento desta entrada antes da confer\xeancia (status "Recebida" ou superior, por exemplo ap\xf3s registrar data de recebimento na edi\xe7\xe3o da entrada).', "Confer\xeancia de Entrada");
            if (st >= INPUT_ST_VERIFIED) return (0, $jUNyh.notify)("Esta entrada j\xe1 foi conferida.", "Confer\xeancia de Entrada");
            let lots = await (0, $9VcS9.default).call((0, $9VcS9.default).list_lots, `?filter=company_id*eq*${input.company_id},input_id*eq*${input.id}&limit=0`);
            if (!lots || lots.length === 0) {
                const seedItems = input.items && input.items.length ? input.items : null;
                if (seedItems) lots = seedItems.filter((it)=>it && it.product_id).map((it)=>({
                        id: null,
                        product_id: it.product_id,
                        product_packaging_id: it.product_packaging_id || null,
                        lot_number: '',
                        serial: it.serial || '',
                        manufacture_date: '',
                        expiration_date: '',
                        quantity: it.quantity || '',
                        status: 0,
                        is_blocked: false
                    }));
                else if (input.order_id) try {
                    const order = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order, input.company_id, input.order_id);
                    const items = order?.items || [];
                    lots = items.filter((it)=>it && it.product_id).map((it)=>({
                            id: null,
                            product_id: it.product_id,
                            product_packaging_id: null,
                            lot_number: '',
                            serial: it.serial || '',
                            manufacture_date: '',
                            expiration_date: '',
                            quantity: it.quantity || '',
                            status: 0,
                            is_blocked: false
                        }));
                } catch (_) {
                /* pedido opcional — conferência segue em branco */ }
            }
            let _record = {
                'company_id': input.company_id,
                'input_id': input.id,
                'warehouse_company_id': input.warehouse_company_id,
                'warehouse_id': input.warehouse_id,
                'location_id': input.location_id,
                'program_id': input.program_id ?? '',
                'lots': (lots || []).map((lot)=>{
                    lot.is_blocked = Boolean(lot.status & 8);
                    return lot;
                })
            };
            await (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, this.queryAll()).then((data)=>data && (0, $1cmSR.default).set('programs', data)).catch(()=>{});
            (0, $b60a2.default).edit((0, $1370eb70a282d012$export$2e2bcd8739ae039), sendRequest, (0, $b60a2.flatten)(_record, 'lots'));
        },
        async putAway () {
            const fmtExp = (d)=>{
                if (d == null || d === '') return '';
                const s = String(d);
                return s.length >= 10 ? s.slice(0, 10) : s;
            };
            /** Uma linha por lote na posição de recebimento; quantidades somadas se houver mais de um stock_id. */ const buildPutawayRows = (stocks, input)=>{
                const stagingId = Number(input.location_id);
                let cand = (stocks || []).filter((s)=>Number(s.location_id) === stagingId && Number(s.quantity_available) > 0);
                if (cand.length === 0) cand = (stocks || []).filter((s)=>Number(s.quantity_available) > 0);
                const byLot = new Map();
                for (const s of cand){
                    const lid = Number(s.lot_id);
                    if (!byLot.has(lid)) byLot.set(lid, {
                        lot_id: lid,
                        lot_number: s.lot_number || '',
                        sku: s.sku || '',
                        product_name: s.product_name || '',
                        expiration_date: fmtExp(s.expiration_date),
                        location_id: '',
                        quantity: 0
                    });
                    const row = byLot.get(lid);
                    row.quantity += Number(s.quantity_available || 0);
                    if (!row.lot_number && s.lot_number) row.lot_number = s.lot_number;
                    if (!row.sku && s.sku) row.sku = s.sku;
                    if (!row.product_name && s.product_name) row.product_name = s.product_name;
                    if (!row.expiration_date && s.expiration_date) row.expiration_date = fmtExp(s.expiration_date);
                }
                return [
                    ...byLot.values()
                ];
            };
            const sendRequest = async (data)=>{
                data = (0, $b60a2.deepen)(data, 'puts');
                const puts = (data.puts || []).filter((put)=>put && put.lot_id != null && put.lot_id !== '' && put.location_id != null && put.location_id !== '' && Number(put.quantity) > 0).map((put)=>({
                        lot_id: Number(put.lot_id),
                        location_id: Number(put.location_id),
                        quantity: Number(put.quantity)
                    }));
                if (puts.length === 0) {
                    (0, $jUNyh.notify)("Informe ao menos uma linha com posi\xe7\xe3o de destino e quantidade.", "Endere\xe7amento de Lotes");
                    return false;
                }
                const _record = {
                    puts: puts
                };
                if (await (0, $9VcS9.default).call((0, $9VcS9.default).putaway_input, data.company_id, data.input_id, _record)) {
                    this.loadPage();
                    return true;
                }
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $jUNyh.notify)("Selecione apenas uma entrada para endere\xe7amento", "Endere\xe7amento de Lotes");
            let input = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input, ids[0][0], ids[0][1]);
            let stocks = await (0, $9VcS9.default).call((0, $9VcS9.default).list_stocks_by_input, input.company_id, input.id);
            const putawayRows = buildPutawayRows(stocks, input);
            if (putawayRows.length === 0) return (0, $jUNyh.notify)("N\xe3o h\xe1 estoque dispon\xedvel na posi\xe7\xe3o de recebimento desta entrada. Conclua a confer\xeancia ou verifique a posi\xe7\xe3o da entrada.", "Endere\xe7amento de Lotes");
            let _record = {
                'company_id': input.company_id,
                'input_id': input.id,
                'warehouse_company_id': input.warehouse_company_id,
                'warehouse_id': input.warehouse_id,
                'stocks': putawayRows
            };
            (0, $b60a2.default).edit((0, $2e208f3196f713a1$export$2e2bcd8739ae039), sendRequest, (0, $b60a2.flatten)(_record, 'stocks'));
        },
        printInputs () {
            if (!this.ensureSelection('Listagem de Entradas')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, 'Listagem de Entradas');
            };
            const sendRequest = async ()=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_inputs, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} entradas no relat\xf3rio?`, 'Listagem de Entradas', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async exportListCsv () {
            const crud = this;
            await (0, $b60a2.default).edit((0, $e8a0406a1c7aa80c$export$2e2bcd8739ae039), async ()=>{
                const box = document.querySelector(`${(0, $e8a0406a1c7aa80c$export$2e2bcd8739ae039).form.selector} #use_list_filter`);
                const useList = box ? box.checked : true;
                const payload = {};
                if (useList) {
                    const params = new URLSearchParams();
                    await crud.addFilter(params);
                    crud.addSort(params);
                    const f = params.get('filter');
                    const s = params.get('sort');
                    if (f) payload.filter = f;
                    if (s) payload.sort = s;
                }
                try {
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_inputs_csv, payload);
                    if (resp?.csv) {
                        downloadInputsCompleteFile(resp.csv, resp.filename || 'entradas.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)('Download iniciado.', 'Exportar listagem (CSV)');
                    } else (0, $jUNyh.notify)("N\xe3o foi poss\xedvel gerar o arquivo.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        },
        printInputSKUs () {
            if (!this.ensureSelection('Listagem de Nota Fiscal')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, 'Cruzamento de Nota Fiscal');
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_skus, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} entradas na listagem?`, 'Listagem de Nota Fiscal', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printXML () {
            if (!this.ensureSelection('Espelho da Nota Fiscal')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, 'Espelho da Nota Fiscal');
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_xml, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Gerar espelho da nota de ${this.getCount()} entradas?`, 'Espelho da Nota Fiscal', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPutAwayOrder () {
            if (!this.ensureSelection("Ordem de Endere\xe7amento")) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, "Ordem de Endere\xe7amento");
            };
            const sendRequest = async ()=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_putaway, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} entradas no relat\xf3rio?`, "Ordem de Endere\xe7amento", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async printLabels () {
            const sendRequest = async (data)=>{
                data = (0, $b60a2.deepen)(data, 'lots');
                const device_id = (0, $aGGTj.resolvePrinterDeviceId)(data.device_id, '#input-labels #device_id');
                if (device_id == null) {
                    (0, $jUNyh.notify)("Selecione a impressora na lista (clique na op\xe7\xe3o; s\xf3 o texto no campo n\xe3o basta).", "Aten\xe7\xe3o");
                    return false;
                }
                let _record = {
                    device_company_id: data.device_company_id,
                    device_id: device_id,
                    return_zpl: !!data.use_local_agent,
                    lots: data.lots.map((lot)=>({
                            lot_id: Number(lot.id),
                            labels: Number(lot.labels)
                        }))
                };
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_labels, data.company_id, data.input_id, _record);
                if (result?.zpl) try {
                    await (0, $9VcS9.default).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $jUNyh.notify)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $jUNyh.notify)("Selecione apenas uma entrada para impress\xe3o", 'Etiquetas de Lotes');
            let input = await (0, $9VcS9.default).call((0, $9VcS9.default).select_input, ids[0][0], ids[0][1]);
            let lots = await (0, $9VcS9.default).call((0, $9VcS9.default).list_lots, `?filter=company_id*eq*${input.company_id},input_id*eq*${input.id}&limit=0`);
            let _record = {
                'company_id': input.company_id,
                'input_id': input.id,
                'lots': lots.map((lot)=>{
                    lot.labels = 1;
                    return lot;
                })
            };
            (0, $b60a2.default).edit((0, $eb194eabe879d7c6$export$2e2bcd8739ae039), sendRequest, (0, $b60a2.flatten)(_record, 'lots'));
        },
        printCosts () {
            if (!this.ensureSelection("Relat\xf3rio de Custos")) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, "Relat\xf3rio de Custos");
            };
            const sendRequest = async ()=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_costs, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} entradas no relat\xf3rio?`, "Relat\xf3rio de Custos", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printConference () {
            if (!this.ensureSelection("Relat\xf3rio de Confer\xeancia")) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, "Confer\xeancia");
            };
            const sendRequest = async ()=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_conference, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} entradas no relat\xf3rio de confer\xeancia?`, "Relat\xf3rio de Confer\xeancia", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printDetails () {
            if (!this.ensureSelection('Entrada Detalhada')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, 'Entrada detalhada');
            };
            const sendRequest = async ()=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_details, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} entradas no relat\xf3rio detalhado?`, 'Entrada Detalhada', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        createInvoices () {
            if (!this.ensureSelection('Gerar Notas')) return;
            const showResult = (resp)=>{
                this.clearGridSelection();
                (0, $jUNyh.notify)(`Notas criadas: ${resp?.count || 0}`, 'Resultado');
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_invoices, Object.assign(data, {
                    'io_type': 'I',
                    'ids': ids
                })).then(showResult);
            };
            let fs = (0, $h1m6J.default).create((0, $bbd1a845e6487967$export$2e2bcd8739ae039)(true), sendRequest);
            fs.init = (()=>{
                const n = this.getCount();
                document.querySelector(`${fs.form.selector} #count`).innerHTML = n;
                const noun = document.querySelector(`${fs.form.selector} #io-noun`);
                if (noun) noun.textContent = n === 1 ? 'entrada' : 'entradas';
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        async reverseInput () {
            const sendRequest = async (data)=>{
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).reverse_input, data.company_id, data.input_id, {
                    status: Number(data.status)
                });
                if (resp) this.loadPage(); // Show updated status
                return resp;
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $jUNyh.notify)('Selecione apenas uma entrada para estornar', 'Estorno de Entrada');
            (0, $b60a2.default).edit((0, $c9f6850858a9a613$export$2e2bcd8739ae039), sendRequest, {
                company_id: ids[0][0],
                input_id: ids[0][1]
            });
        },
        /** #MT-8412900 — Cancelar Entradas Criadas em lote (checkbox + um motivo). */ async cancelBatch () {
            const selectedIds = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selectedIds?.length) {
                (0, $jUNyh.notify)('Marque na grade as Entradas Criadas que deseja cancelar.', 'Cancelar em lote');
                return;
            }
            const companies = [
                ...new Set(selectedIds.map(([c])=>String(c)))
            ];
            if (companies.length !== 1) {
                (0, $jUNyh.notify)("Selecione Entradas de uma \xfanica empresa por vez.", 'Cancelar em lote');
                return;
            }
            const company_id = companies[0];
            const ids = selectedIds.map(([, id])=>Number(id)).filter((n)=>Number.isInteger(n) && n > 0);
            if (!ids.length) {
                (0, $jUNyh.notify)("Nenhuma Entrada v\xe1lida selecionada.", 'Cancelar em lote');
                return;
            }
            let reasons = [];
            try {
                const rows = await (0, $5zLFz.fetchInputCancelReasonsSilent)(company_id, false);
                reasons = Array.isArray(rows) ? rows.filter((r)=>r && !r.is_disabled) : [];
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao carregar motivos');
                return;
            }
            if (!reasons.length) {
                (0, $jUNyh.notify)("N\xe3o h\xe1 motivos de cancelamento ativos para esta empresa. Cadastre em Cat\xe1logo \u2192 Motivos Cancelamento Entrada.", 'Cancelar em lote');
                return;
            }
            const esc = (s)=>String(s ?? '').replace(/[&<>"']/g, (ch)=>({
                        '&': '&amp;',
                        '<': '&lt;',
                        '>': '&gt;',
                        '"': '&quot;',
                        "'": '&#39;'
                    })[ch]);
            const options = reasons.map((r)=>`<option value="${esc(r.id)}">${esc(r.name)}</option>`).join('');
            const total = ids.length;
            const html = `
				<div class="msgbox" style="min-width:380px;max-width:560px">
					<div class="mb-title">Cancelar Entradas em lote</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">
							Confirma o cancelamento de <strong>${total} entrada${total !== 1 ? 's' : ''}</strong> selecionada${total !== 1 ? 's' : ''}?
						</p>
						<p style="margin:0 0 0.75rem;color:#888;font-size:0.92em">
							Somente Entradas com status <strong>Criada</strong> ser\xe3o canceladas.
							As demais ser\xe3o ignoradas. Um \xfanico motivo vale para todo o lote.
						</p>
						<label style="display:block;margin:0.5rem 0 0.25rem">Motivo cancelamento<sup>*</sup></label>
						<select id="cancel_reason_id" required style="width:100%;box-sizing:border-box;min-height:2rem">
							<option value="">Selecione\u{2026}</option>
							${options}
						</select>
					</div>
					<button type="button" class="button mtl bn_N">Voltar</button>
					<button type="button" class="button mtl bn_Y">Cancelar entradas</button>
				</div>
			`;
            const crudRef = this;
            const dlg = (0, $dx9qz.default).create(html, async (key)=>{
                if (key === 'Escape' || key === 'N') {
                    dlg.destroy();
                    return;
                }
                if (key !== 'Y') return;
                const sel = dlg.getNode()?.querySelector('#cancel_reason_id');
                const cancel_reason_id = sel?.value != null ? String(sel.value).trim() : '';
                if (!cancel_reason_id) {
                    (0, $jUNyh.notify)('Selecione o Motivo de cancelamento.', 'Cancelar em lote');
                    return;
                }
                dlg.destroy();
                try {
                    const result = await (0, $9VcS9.default).call((0, $9VcS9.default).cancel_inputs_batch, company_id, {
                        ids: ids,
                        cancel_reason_id: Number(cancel_reason_id)
                    });
                    const canceled = Number(result?.canceled || 0);
                    const skipped = Number(result?.skipped || 0);
                    const failed = Number(result?.failed || 0);
                    if (canceled > 0) {
                        (0, $jUNyh.notify)(`${canceled} entrada${canceled !== 1 ? 's' : ''} cancelada${canceled !== 1 ? 's' : ''}.` + (skipped > 0 ? ` ${skipped} ignorada${skipped !== 1 ? 's' : ''} (n\xe3o estavam Criadas).` : '') + (failed > 0 ? ` ${failed} com erro.` : ''), 'Cancelar em lote');
                        crudRef.loadPage?.();
                    } else {
                        const firstFail = (result?.failed_items || [])[0]?.error || (result?.skipped_items || [])[0]?.error || "Nenhuma Entrada Criada foi cancelada. Confira a sele\xe7\xe3o e o status.";
                        (0, $jUNyh.notify)(firstFail, 'Cancelar em lote');
                    }
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao cancelar em lote');
                }
            }, /Escape|N|Y/);
        }
    });
    // Index = ordem 1-based das colunas do SELECT em repos/inputs.SQL_BASE_SELECT (verified_at/by, program_id)
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Entrada',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da entrada'
        },
        {
            index: 4,
            field: 'order_id',
            label: 'Pedido',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero do pedido vinculado"
        },
        {
            index: 3,
            field: 'order_type',
            label: 'Origem',
            types: [
                $e3d776cc66101a71$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Origem do pedido vinculado'
        },
        {
            index: 13,
            field: 'invoice_number',
            label: 'Nota',
            types: [],
            placeholder: '',
            title: "N\xfamero da nota fiscal"
        },
        {
            index: 14,
            field: 'invoice_xml',
            label: 'XML',
            types: [],
            placeholder: '',
            title: 'XML da nota fiscal'
        },
        {
            index: 5,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da cria\xe7\xe3o da entrada"
        },
        {
            index: 6,
            field: 'received_on',
            label: 'Recebimento',
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: 'Data e hora de recebimento da mercadoria'
        },
        {
            index: 9,
            field: 'warehouse_company_id',
            label: "Destinat\xe1ria",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Empresa do armaz\xe9m de recebimento",
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 10,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m de recebimento",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 12,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa da entrada',
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 11,
            field: 'location_id',
            label: "Posi\xe7\xe3o",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Posi\xe7\xe3o no armaz\xe9m",
            store: 'locations',
            labels: [
                'address'
            ],
            separator: '-'
        },
        {
            index: 15,
            field: 'volumes',
            label: 'Volumes',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero de volumes"
        },
        {
            index: 16,
            field: 'weight',
            label: 'Peso',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: 'Peso total dos volumes'
        },
        {
            index: 17,
            field: 'status',
            label: 'Status',
            types: [
                $2d17d508d4f555c6$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status da entrada'
        },
        {
            index: 29,
            field: 'dock_schedule_status',
            label: 'Agendamento',
            types: [],
            placeholder: '',
            title: 'Status do agendamento de doca do Pedido vinculado (#MT-0510946)',
            computed: true
        },
        {
            index: 18,
            field: 'completed_at',
            label: "Conclus\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora em que a entrada foi conclu\xedda (endere\xe7amento)"
        },
        {
            index: 20,
            field: 'lines_packaging_summary',
            label: 'Embalagem (itens)',
            types: [],
            placeholder: '',
            title: 'Resumo das embalagens informadas nas linhas da entrada'
        },
        {
            index: 21,
            field: 'lines_manufacturer_summary',
            label: 'Fabricante (itens)',
            types: [],
            placeholder: '',
            title: 'Resumo dos fabricantes das embalagens nas linhas da entrada'
        },
        {
            index: 22,
            field: 'lines_sku_summary',
            label: 'SKU (itens)',
            types: [],
            placeholder: 'trecho do SKU',
            title: "Busca nos SKUs das linhas da entrada (operador Cont\xe9m recomendado)"
        },
        {
            index: 23,
            field: 'lines_product_summary',
            label: 'Produto (itens)',
            types: [],
            placeholder: 'nome do produto',
            title: "Busca nos nomes dos produtos das linhas (operador Cont\xe9m recomendado)"
        },
        {
            index: 26,
            field: 'cancel_reason_name',
            label: 'Motivo&nbsp;cancelamento',
            types: [],
            placeholder: '',
            title: "Motivo quando a Entrada est\xe1 Cancelada (#MT-6BF7122)"
        }
    ];
    let operations = [
        {
            hash: '#inventory-input',
            label: "Confer\xeancia&nbsp;de&nbsp;Entrada"
        },
        {
            hash: '#submit-putaway',
            label: "Endere\xe7amento&nbsp;de&nbsp;Lotes"
        },
        {
            hash: '#create-invoices',
            label: 'Gerar&nbsp;Notas&nbsp;Fiscais'
        },
        {
            hash: '#cancel-inputs-batch',
            label: 'Cancelar&nbsp;em&nbsp;lote'
        },
        {
            hash: '#reverse-input',
            label: 'Estornar&nbsp;Entrada'
        },
        {
            hash: '#input-xml-rastro',
            label: 'Rastreabilidade&nbsp;XML'
        },
        {
            hash: '#input-divergences',
            label: "Diverg\xeancias&nbsp;confer\xeancia"
        },
        {
            hash: '#input-reparse-rastro',
            label: 'Reprocessar&nbsp;RASTRO'
        }
    ];
    let reports = [
        {
            hash: '#print-inputs',
            label: 'Listagem&nbsp;de&nbsp;Entradas'
        },
        {
            hash: '#export-list-csv',
            label: 'Exportar&nbsp;listagem&nbsp;(CSV)'
        },
        {
            hash: '#print-skus',
            label: 'Cruzamento&nbsp;de&nbsp;Nota&nbsp;Fiscal'
        },
        {
            hash: '#print-xml',
            label: 'Espelho&nbsp;da&nbsp;Nota&nbsp;Fiscal'
        },
        {
            hash: '#print-putaway',
            label: "Ordem&nbsp;de&nbsp;Endere\xe7amento"
        },
        {
            hash: '#print-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Lotes'
        },
        {
            hash: '#print-costs',
            label: "Relat\xf3rio&nbsp;de&nbsp;Custos"
        },
        {
            hash: '#print-conference',
            label: "Relat\xf3rio&nbsp;de&nbsp;Confer\xeancia"
        },
        {
            hash: '#print-details',
            label: 'Entrada&nbsp;Detalhada'
        },
        {
            hash: '#print-inputs-complete',
            label: "Relat\xf3rio&nbsp;completo&nbsp;(status&nbsp;/&nbsp;NF)"
        },
        {
            hash: '#print-inputs-documents-list',
            label: 'Lista&nbsp;Doc.&nbsp;Entradas'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventory-input', inputs_crud.inventory.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#submit-putaway', inputs_crud.putAway.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-invoices', inputs_crud.createInvoices.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cancel-inputs-batch', inputs_crud.cancelBatch.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reverse-input', inputs_crud.reverseInput.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-xml-rastro', async ()=>{
        await showInputJson('Rastreabilidade XML esperada', (0, $9VcS9.default).input_expected_traceability);
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-divergences', async ()=>{
        await showInputJson("Diverg\xeancias de confer\xeancia", (0, $9VcS9.default).input_conference_divergences);
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-reparse-rastro', async ()=>{
        await showInputJson('Reprocessamento XML RASTRO', (0, $9VcS9.default).reparse_input_xml_rastro);
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-inputs', inputs_crud.printInputs.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-list-csv', inputs_crud.exportListCsv.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-skus', inputs_crud.printInputSKUs.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-xml', inputs_crud.printXML.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-putaway', inputs_crud.printPutAwayOrder.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-labels', inputs_crud.printLabels.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-costs', inputs_crud.printCosts.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-conference', inputs_crud.printConference.bind(inputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-details', inputs_crud.printDetails.bind(inputs_crud));
    async function showInputJson(title, endpoint) {
        const ids = await inputs_crud.getSelectedIds([
            'company_id',
            'id'
        ]);
        if (ids.length !== 1) {
            (0, $jUNyh.notify)('Selecione uma entrada.', title);
            return;
        }
        try {
            const data = await (0, $9VcS9.default).call(endpoint, ids[0][0], ids[0][1]);
            const text = JSON.stringify(data ?? {}, null, 2);
            (0, $jUNyh.notify)(`<pre style="white-space:pre-wrap;max-width:70vw;max-height:70vh;overflow:auto;">${text.replace(/[&<>"']/g, (ch)=>({
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#39;'
                })[ch])}</pre>`, title);
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), title);
        }
    }
    async function resolveCompanyIdForReport(raw) {
        if (!raw || String(raw).trim() === '') return '';
        const id = String(raw).trim();
        const c = await (0, $1cmSR.default).get('companies', id) || await (0, $1cmSR.default).get('companies', [
            id
        ]);
        return c?.id ?? id;
    }
    async function buildInputsCompletePayload(formData) {
        const company_id = await resolveCompanyIdForReport(formData.company_id);
        const o = {
            company_id: company_id,
            date_from: formData.date_from,
            date_to: formData.date_to,
            date_basis: formData.date_basis || 'created',
            format: (formData.format || 'pdf').toLowerCase()
        };
        if (formData.warehouse_id) o.warehouse_id = Number(formData.warehouse_id);
        if (formData.status) o.status = Number(formData.status);
        if (formData.order_type) o.order_type = formData.order_type;
        return o;
    }
    async function reloadWarehousesCompleteModal(companyRaw) {
        const sel = document.querySelector('#inputs-print-complete-report #warehouse_id');
        if (!sel) return;
        sel.innerHTML = '<option value="">Todos</option>';
        const company_id = await resolveCompanyIdForReport(companyRaw);
        if (!company_id) return;
        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, `?filter=company_id*eq*${company_id}&limit=0&sort=2`);
        if (!Array.isArray(data)) return;
        for (const w of data){
            const opt = document.createElement('option');
            opt.value = String(w.id);
            opt.textContent = `${w.name ?? ''} (${w.id})`;
            sel.appendChild(opt);
        }
    }
    function downloadInputsCompleteFile(base64Content, filename, mimeType) {
        const bin = atob(base64Content);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
        const blob = new Blob([
            arr
        ], {
            type: mimeType
        });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename || 'relatorio';
        a.click();
        URL.revokeObjectURL(a.href);
    }
    async function updateInputsCompleteCountMsg(getValues) {
        const el = document.querySelector('#ic-count-msg');
        if (!el) return;
        const formData = getValues?.() || {};
        if (!formData.date_from || !formData.date_to) {
            el.textContent = 'Informe as datas para estimar a quantidade de registros.';
            return;
        }
        const company_id = await resolveCompanyIdForReport(formData.company_id);
        if (!company_id) {
            el.textContent = 'Selecione a empresa para contar.';
            return;
        }
        const payload = await buildInputsCompletePayload(formData);
        delete payload.format;
        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).count_inputs_complete_report, payload);
        const n = resp?.count;
        el.textContent = typeof n === 'number' ? `${n} entrada(s) no per\xedodo com os filtros atuais.` : "\u2014";
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-inputs-complete', ()=>{
        const dlg = (0, $b60a2.default).edit((0, $472dfc2c3e29d1c0$export$2e2bcd8739ae039), async (data)=>{
            try {
                const payload = await buildInputsCompletePayload(data);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_inputs_complete_report, payload);
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.csv) {
                    downloadInputsCompleteFile(resp.csv, resp.filename || 'entradas-completas.csv', 'text/csv;charset=utf-8');
                    (0, $jUNyh.notify)('Download iniciado.', 'Entradas');
                } else if (resp?.xlsx) {
                    downloadInputsCompleteFile(resp.xlsx, resp.filename || 'entradas-completas.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    (0, $jUNyh.notify)('Download iniciado.', 'Entradas');
                } else (0, $jUNyh.notify)(resp?.message || "Nenhum dado para o relat\xf3rio.", 'Entradas');
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
            dlg.destroy();
        }, {}, false);
        const formEl = document.querySelector((0, $472dfc2c3e29d1c0$export$2e2bcd8739ae039).form.selector);
        const refreshCount = ()=>updateInputsCompleteCountMsg(()=>dlg.form?.getValues?.());
        if (formEl) {
            formEl.querySelector('#company_id')?.addEventListener('change', async ()=>{
                await reloadWarehousesCompleteModal(formEl.querySelector('#company_id')?.value);
                refreshCount();
            });
            formEl.addEventListener('change', refreshCount);
            formEl.addEventListener('input', refreshCount);
        }
        setTimeout(refreshCount, 300);
    });
    async function buildInputDocumentsListPayload(formData, formEl = null) {
        const company_id = await resolveCompanyIdForReport(formData.company_id);
        const root = formEl || document.querySelector('#inputs-print-documents-list');
        const empenhoCb = root?.querySelector('#empenho_only');
        const o = {
            company_id: company_id,
            date_from: formData.date_from,
            date_to: formData.date_to,
            date_basis: formData.date_basis || 'created',
            format: (formData.format || 'xlsx').toLowerCase()
        };
        if (formData.warehouse_id) o.warehouse_id = Number(formData.warehouse_id);
        if (formData.status) o.status = Number(formData.status);
        if (empenhoCb ? empenhoCb.checked : formData.empenho_only) o.empenho_only = true;
        return o;
    }
    async function reloadWarehousesDocumentsListModal(companyRaw) {
        const sel = document.querySelector('#inputs-print-documents-list #warehouse_id');
        if (!sel) return;
        sel.innerHTML = '<option value="">Todos</option>';
        const company_id = await resolveCompanyIdForReport(companyRaw);
        if (!company_id) return;
        const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, `?filter=company_id*eq*${company_id}&limit=0&sort=2`);
        if (!Array.isArray(data)) return;
        for (const w of data){
            const opt = document.createElement('option');
            opt.value = String(w.id);
            opt.textContent = `${w.name ?? ''} (${w.id})`;
            sel.appendChild(opt);
        }
    }
    async function updateInputDocumentsListCountMsg(getValues) {
        const el = document.querySelector('#idl-count-msg');
        if (!el) return;
        const formData = getValues?.() || {};
        if (!formData.date_from || !formData.date_to) {
            el.textContent = 'Informe as datas para estimar a quantidade de registros.';
            return;
        }
        const company_id = await resolveCompanyIdForReport(formData.company_id);
        if (!company_id) {
            el.textContent = 'Selecione a empresa para contar.';
            return;
        }
        const formEl = document.querySelector('#inputs-print-documents-list');
        const payload = await buildInputDocumentsListPayload(formData, formEl);
        delete payload.format;
        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).count_input_documents_list_report, payload);
        const n = resp?.count;
        el.textContent = typeof n === 'number' ? n === 0 ? "Nenhuma entrada no per\xedodo. Ajuste as datas, a base do per\xedodo ou desmarque \xabSomente com empenho informado\xbb." : `${n} entrada(s) no per\xedodo com os filtros atuais.` : "\u2014";
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-inputs-documents-list', ()=>{
        const dlg = (0, $b60a2.default).edit((0, $7045621166dad360$export$2e2bcd8739ae039), async (data)=>{
            const formEl = document.querySelector((0, $7045621166dad360$export$2e2bcd8739ae039).form.selector);
            try {
                const formatSel = formEl?.querySelector('#format');
                const payload = await buildInputDocumentsListPayload(data, formEl);
                if (formatSel?.value) payload.format = String(formatSel.value).toLowerCase();
                const countPayload = {
                    ...payload
                };
                delete countPayload.format;
                const cntResp = await (0, $9VcS9.default).call((0, $9VcS9.default).count_input_documents_list_report, countPayload);
                if (cntResp?.count === 0) {
                    (0, $jUNyh.notify)("Nenhuma entrada no per\xedodo com os filtros informados. Ajuste as datas, a base do per\xedodo ou desmarque \xabSomente com empenho informado\xbb.", 'Lista Doc. Entradas');
                    return;
                }
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_input_documents_list_report, payload);
                if (resp?.xlsx) {
                    downloadInputsCompleteFile(resp.xlsx, resp.filename || 'lista-doc-entradas.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    (0, $jUNyh.notify)('Download Excel iniciado.', 'Lista Doc. Entradas');
                } else if (resp?.csv) {
                    downloadInputsCompleteFile(resp.csv, resp.filename || 'lista-doc-entradas.csv', 'text/csv;charset=utf-8');
                    (0, $jUNyh.notify)('Download CSV iniciado.', 'Lista Doc. Entradas');
                } else if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else (0, $jUNyh.notify)(resp?.message || "Nenhum dado para o relat\xf3rio.", 'Lista Doc. Entradas');
                dlg.destroy();
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
            }
        }, {}, false);
        const formEl = document.querySelector((0, $7045621166dad360$export$2e2bcd8739ae039).form.selector);
        const refreshCount = ()=>updateInputDocumentsListCountMsg(()=>dlg.form?.getValues?.());
        if (formEl) {
            formEl.querySelector('#company_id')?.addEventListener('change', async ()=>{
                await reloadWarehousesDocumentsListModal(formEl.querySelector('#company_id')?.value);
                refreshCount();
            });
            formEl.addEventListener('change', refreshCount);
            formEl.addEventListener('input', refreshCount);
        }
        setTimeout(refreshCount, 300);
    });
    inputs_crud.run('inputs', 'Entradas', document.getElementById('workarea'), (0, $44077aa73868f7f8$export$2e2bcd8739ae039), (0, $54d2d9a3c0d3ddd6$export$2e2bcd8739ae039), fieldspecs, operations, reports, {
        default_columns: '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,17,29,18,20,21,22,23'
    });
};
var $ee2c059f60a8fc19$export$2e2bcd8739ae039 = $ee2c059f60a8fc19$var$inputs;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");

var $b7D1Q = parcelRequire("b7D1Q");
var $3eqAU = parcelRequire("3eqAU");

var $aGGTj = parcelRequire("aGGTj");
async function $7620a66f512a3069$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: right; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: left; max-width: 14rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lote</th>
					<th data-index="3" data-visible="${this.visible[2]}">Entrada</th>
					<th data-index="4" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="5" data-visible="${this.visible[4]}">Programa</th>
					<th data-index="6" data-visible="${this.visible[5]}">Numera\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[6]}">Serial</th>
					<th data-index="8" data-visible="${this.visible[7]}">Fabrica\xe7\xe3o</th>
					<th data-index="9" data-visible="${this.visible[8]}">Validade</th>
					<th data-index="10" data-visible="${this.visible[9]}">Quantidade</th>
					<th data-index="11" data-visible="${this.visible[10]}">Status</th>
					<th data-index="13" data-visible="${this.visible[11]}">Endere\xe7o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.input_id}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('products', [
            record.company_id,
            record.product_id
        ])}</td>
					<td data-visible='${this.visible[4]}'>${record.program_id != null ? await this.key('programs', [
            record.company_id,
            record.program_id
        ]) || record.program_id : "\u2014"}</td>
					<td data-visible='${this.visible[5]}'>${(0, $aGGTj.formatLotNumber)(record.lot_number)}</td>
					<td data-visible='${this.visible[6]}'>${record.serial ? String(record.serial) : ''}</td>
					<td data-visible='${this.visible[7]}'>${this.format($b7D1Q.default(), record.manufacture_date)}</td>
					<td data-visible='${this.visible[8]}'>${this.format($b7D1Q.default(), record.expiration_date)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($3eqAU.default(0), record.quantity)}</td>
					<td data-visible='${this.visible[10]}'>${this.option($84a270a7f3d1546a$export$2e2bcd8739ae039(), record.status) || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.location_address ? String(record.location_address) : "\u2014"}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $64c577998e25bd04$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#lot #company_id		{ width: 10rem;		}
			#lot #id				{ width: 5rem; text-align: right;	}
			#lot #input_id			{ width: 5rem; text-align: right;	}
			#lot #product_id		{ width: 20rem;		}
			#lot #lot_number		{ width: 10rem;		}
			#lot #serial			{ width: 10rem;		}
			#lot #manufacture_date	{ width: 7rem;		}
			#lot #expiration_date	{ width: 7rem;		}
			#lot #quantity			{ width: 5rem; text-align: right;	}
			#lot #status			{ width: 10rem;		}
		</style>
		<form id="lot" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="products">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do lote">Lote
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero da entrada">Entrada<sup>*</sup>
					<input id="input_id" type="text" required>
				</label>
				<label title="Produto">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products" required>
				</label>
			</div>
			<div>
				<label title="Numera\xe7\xe3o do lote">Numera\xe7\xe3o<sup>*</sup>
					<input id="lot_number" type="text" required>
				</label>
				<label title="Serial opcional (letras e n\xfameros, at\xe9 20)">Serial
					<input id="serial" type="text" maxlength="20" pattern="[A-Za-z0-9]*" autocomplete="off">
				</label>
				<label title="Data de fabrica\xe7\xe3o">Fabrica\xe7\xe3o<sup>*</sup>
					<input id="manufacture_date" type="text" required>
				</label>
				<label title="Data de validade">Validade<sup>*</sup>
					<input id="expiration_date" type="text" required>
				</label>
				<label title="Quantidade">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Status do lote">Status<sup>*</sup>
					<input id="status" type="text" list="lot_status" value="10" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#lot',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#input_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#product_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#serial'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#manufacture_date'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#expiration_date'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#quantity'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $84a270a7f3d1546a$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $3eqAU = parcelRequire("3eqAU");
const $a9f17bf16ff5b79a$var$lots = function() {
    let lots_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_products, this.queryAll()).then((data)=>(0, $1cmSR.default).set('products', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_lots, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_lot, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                input_id: Number(data.input_id),
                product_id: Number(data.product_id),
                lot_number: data.lot_number,
                serial: data.serial && String(data.serial).trim() ? String(data.serial).trim().slice(0, 20) : null,
                manufacture_date: data.manufacture_date,
                expiration_date: data.expiration_date,
                quantity: Number(data.quantity),
                status: Number(data.status)
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_lot, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_lot, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Lote',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 3,
            field: 'input_id',
            label: 'Entrada',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da entrada de lote"
        },
        {
            index: 4,
            field: 'product_id',
            label: 'Produto',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Produto',
            store: 'products',
            labels: [
                'name'
            ]
        },
        {
            index: 5,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Programa (somente leitura)',
            store: 'programs',
            labels: [
                'name'
            ],
            readOnly: true
        },
        {
            index: 6,
            field: 'lot_number',
            label: "Numera\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Numera\xe7\xe3o do lote"
        },
        {
            index: 7,
            field: 'serial',
            label: 'Serial',
            types: [],
            placeholder: '',
            title: "Serial opcional do lote (at\xe9 20 caracteres)"
        },
        {
            index: 8,
            field: 'manufacture_date',
            label: "Fabrica\xe7\xe3o",
            types: [
                $b7D1Q.default()
            ],
            placeholder: 'dd/mm/aaaa',
            title: "Data de fabrica\xe7\xe3o do lote"
        },
        {
            index: 9,
            field: 'expiration_date',
            label: 'Validade',
            types: [
                $b7D1Q.default()
            ],
            placeholder: 'dd/mm/aaaa',
            title: 'Data de validade do lote'
        },
        {
            index: 10,
            field: 'quantity',
            label: 'Quantidade',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade do lote'
        },
        {
            index: 11,
            field: 'status',
            label: 'Status',
            types: [
                $84a270a7f3d1546a$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status do lote'
        },
        {
            index: 13,
            field: 'location_address',
            label: "Endere\xe7o",
            types: [],
            placeholder: '',
            title: "Endere\xe7o da posi\xe7\xe3o (estoque) \u2014 ex.: 1-a-1-1; v\xe1rias posi\xe7\xf5es separadas por |"
        }
    ];
    lots_crud.run('lots', 'Lotes', document.getElementById('workarea'), (0, $7620a66f512a3069$export$2e2bcd8739ae039), (0, $64c577998e25bd04$export$2e2bcd8739ae039), fieldspecs, undefined, undefined, {
        default_columns: '1,2,3,4,5,6,7,8,9,10,12'
    });
};
var $a9f17bf16ff5b79a$export$2e2bcd8739ae039 = $a9f17bf16ff5b79a$var$lots;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $hWQyW = parcelRequire("hWQyW");


var $h1m6J = parcelRequire("h1m6J");

var $b60a2 = parcelRequire("b60a2");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");


var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $e4pb7 = parcelRequire("e4pb7");
async function $8263a0b89abdc114$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: right; }
			.view td:nth-child(16)	{ text-align: left; }
			.view td:nth-child(17)	{ text-align: left; }
			.view td:nth-child(18),
			.view td:nth-child(19),
			.view td:nth-child(20)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(21)	{ text-align: center; font-weight: 700; }
			.view td:nth-child(22),
			.view td:nth-child(23)	{ text-align: left; max-width: 14rem; }
			.view tr.out-row-emergency td { background: #fee2e2 !important; font-weight: 700; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Sa\xedda</th>
					<th data-index="4" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="15" data-visible="${this.visible[3]}">Programa</th>
					<th data-index="16" data-visible="${this.visible[4]}">Refer\xeancia</th>
					<th data-index="20" data-visible="${this.visible[5]}">Cliente</th>
					<th data-index="26" data-visible="${this.visible[6]}">Rota</th>
					<th data-index="21" data-visible="${this.visible[7]}">Transportador</th>
					<th data-index="3" data-visible="${this.visible[8]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[9]}">Cria\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[10]}">Expedi\xe7\xe3o</th>
					<th data-index="7" data-visible="${this.visible[11]}">Remetente</th>
					<th data-index="8" data-visible="${this.visible[12]}">Armaz\xe9m</th>
					<th data-index="9" data-visible="${this.visible[13]}">Tipo Volumes</th>
					<th data-index="10" data-visible="${this.visible[14]}">Volumes</th>
					<th data-index="11" data-visible="${this.visible[15]}">Peso</th>
					<th data-index="12" data-visible="${this.visible[16]}">Custo Total</th>
					<th data-index="13" data-visible="${this.visible[17]}">Pre\xe7o Total</th>
					<th data-index="14" data-visible="${this.visible[18]}">Status</th>
					<th data-index="25" data-visible="${this.visible[19]}">Emergencial</th>
					<th data-index="18" data-visible="${this.visible[20]}">SKU (itens)</th>
					<th data-index="19" data-visible="${this.visible[21]}">Produto (itens)</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr class="${record.is_emergency ? 'out-row-emergency' : ''}" data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('programs', record.program_id ? [
            record.company_id,
            record.program_id
        ] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[4]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[5]}'>${await this.key('customers', record.customer_id ? [
            record.company_id,
            record.customer_id
        ] : null, 'nick') || ''}</td>
					<td data-visible='${this.visible[6]}' title="${record.route_name || ''}">${record.route_code || '-'}</td>
					<td data-visible='${this.visible[7]}'>${await this.key('carriers', record.carrier_id ? [
            record.company_id,
            record.carrier_id
        ] : null, 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}'>${this.option($e3d776cc66101a71$export$2e2bcd8739ae039(), record.order_type)}</td>
					<td data-visible='${this.visible[9]}'>${this.format($8IFAz.default(), record.created_on)}</td>
					<td data-visible='${this.visible[10]}'>${this.format($8IFAz.default(), record.expedited_on) || ''}</td>
					<td data-visible='${this.visible[11]}'>${await this.key('companies', record.warehouse_company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('warehouses', [
            record.warehouse_company_id,
            record.warehouse_id
        ]) || ''}</td>
					<td data-visible='${this.visible[13]}'>${this.option($e4pb7.default(), record.volume_type) || ''}</td>
					<td data-visible='${this.visible[14]}'>${record.volumes ? this.format($3eqAU.default(0), record.volumes) : ''}</td>
					<td data-visible='${this.visible[15]}'>${record.weight ? this.format($3eqAU.default(3), record.weight) : ''}</td>
					<td data-visible='${this.visible[16]}'>${record.total_cost ? this.format($3eqAU.default(2), record.total_cost) : ''}</td>
					<td data-visible='${this.visible[17]}'>${record.total_price ? this.format($3eqAU.default(2), record.total_price) : ''}</td>
					<td data-visible='${this.visible[18]}'>${this.option($f08968bc7ef228cb$export$2e2bcd8739ae039(), record.status) || ''}</td>
					<td data-visible='${this.visible[19]}'>${record.is_emergency ? 'SIM' : 'NAO'}</td>
					<td data-visible='${this.visible[20]}'>${record.lines_sku_summary || ''}</td>
					<td data-visible='${this.visible[21]}'>${record.lines_product_summary || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $b60a2 = parcelRequire("b60a2");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $e4pb7 = parcelRequire("e4pb7");
var $6Jl4s = parcelRequire("6Jl4s");

var $jUNyh = parcelRequire("jUNyh");


var $6c379cd70cdf065a$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output.oo-output-form .oo-output-header-scroll {
				flex-shrink: 0;
				overflow-x: hidden;
				padding-right: 0.2rem;
			}
			#output.oo-output-form .oo-form-row {
				display: flex;
				flex-wrap: wrap;
				gap: 0.45rem 0.75rem;
				align-items: flex-end;
				margin-bottom: 0.45rem;
			}
			#output.oo-output-form .oo-form-row label {
				margin-right: 0 !important;
				margin-bottom: 0 !important;
			}
			#output.oo-output-form #company_id		{ width: 9rem; }
			#output.oo-output-form #id,
			#output.oo-output-form #order_id		{ width: 5.5rem; text-align: right; }
			#output.oo-output-form #order_type,
			#output.oo-output-form #program_id		{ width: 9rem; }
			#output.oo-output-form #reference		{ width: 8rem; }
			#output.oo-output-form #created_on,
			#output.oo-output-form #expedited_on	{ width: 9.5rem; }
			#output.oo-output-form #warehouse_company_id,
			#output.oo-output-form #warehouse_id	{ width: 9rem; }
			#output.oo-output-form #volume_type,
			#output.oo-output-form #status			{ width: 9rem; }
			#output.oo-output-form #volumes		{ width: 5rem; text-align: right; }
			#output.oo-output-form #weight			{ width: 6rem; text-align: right; }
			#output #output-status-lock-hint {
				display: none;
				font-size: 0.82rem;
				color: #92400e;
				background: #fef3c7;
				border: 1px solid #fcd34d;
				border-radius: 4px;
				padding: 0.35rem 0.5rem;
				margin: 0 0 0.5rem 0;
			}
			#output.oo-output-form .sial-items-scroll .oo-col-loc { width: 12%; }
			#output.oo-output-form .sial-items-scroll .oo-col-product { width: 42%; }
			#output.oo-output-form .sial-items-scroll .oo-col-lot { width: 12%; }
			#output.oo-output-form .sial-items-scroll .oo-col-qty-req { width: 9%; }
			#output.oo-output-form .sial-items-scroll .oo-col-qty-sup { width: 9%; }
			#output.oo-output-form .sial-items-scroll .oo-col-disc { width: 8%; }
			#output.oo-output-form .oo-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-shrink: 0;
				margin-top: 0.45rem;
				padding-top: 0.65rem;
				border-top: 1px solid var(--color-border, #ccc);
				gap: 0.75rem;
				flex-wrap: wrap;
			}
			#output-integration-alert-banner { display: none; }
		</style>
		<form id="output" class="form oo-output-form sial-modal-form" autocomplete="off">
			<div id="output-integration-alert-banner" role="status" aria-live="polite"></div>
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="oo-output-header-scroll">
				<div class="oo-form-row">
					<label title="Empresa detentora do registro">Empresa<sup>*</sup>
						<input id="company_id" type="text" list="companies" required>
					</label>
					<label title="Identificador da sa\xedda">Sa\xedda
						<input id="id" type="text" disabled>
					</label>
					<label title="N\xfamero do pedido vinculado (Entrada = Pedido de Entrada; Sa\xedda = Pedido de Sa\xedda)">Pedido<sup>*</sup>
						<input id="order_id" type="text" required>
					</label>
					<label title="Tipo do pedido vinculado: Entrada (devolu\xe7\xe3o de compra) ou Sa\xedda">Tipo<sup>*</sup>
						<input id="order_type" type="text" list="order_types" value="I" required>
					</label>
					<label title="Programa da sa\xedda (do pedido)">Programa
						<input id="program_id" type="text" list="programs" disabled>
					</label>
					<label title="Refer\xeancia do pedido">Refer\xeancia
						<input id="reference" type="text" disabled>
					</label>
					<label title="Data e hora de cria\xe7\xe3o da sa\xedda">Cria\xe7\xe3o
						<input id="created_on" type="text" disabled>
					</label>
					<label title="Data e hora de expedi\xe7\xe3o da sa\xedda">Expedi\xe7\xe3o
						<input id="expedited_on" type="text" disabled>
					</label>
				</div>
				<div class="oo-form-row">
					<label title="Empresa do armaz\xe9m de coleta">Remetente<sup>*</sup>
						<input id="warehouse_company_id" type="text" list="companies" required>
					</label>
					<label title="Armaz\xe9m de coleta">Armaz\xe9m<sup>*</sup>
						<input id="warehouse_id" type="text" list="warehouses" required>
					</label>
					<label title="Tipo de volumes">Tipo Volumes
						<input id="volume_type" type="text" list="volume_types" value="C">
					</label>
					<label title="N\xfamero de volumes">Volumes
						<input id="volumes" type="text">
					</label>
					<label title="Peso total dos volumes">Peso
						<input id="weight" type="text">
					</label>
					<label title="Status da sa\xedda">Status<sup>*</sup>
						<input id="status" type="text" list="output_status" value="10" required>
					</label>
				</div>
				<p id="output-status-lock-hint" role="status">
					Status bloqueado para o seu perfil: use <strong>Opera\xe7\xf5es \u{2192} Conferir sa\xedda</strong> (confer\xeancia web).
				</p>
				<input type="hidden" id="allow_manual_status_advance" value="1">
			</div>
			<div class="sial-items-panel">
				<div class="sial-items-title">Itens da sa\xedda</div>
				<div class="sial-items-scroll">
					<table>
						<thead>
							<tr>
								<th class="sial-col-chk"></th>
								<th class="oo-col-loc">Posi\xe7\xe3o<sup>*</sup></th>
								<th class="oo-col-product">Produto<sup>*</sup></th>
								<th class="oo-col-lot">Lote<sup>*</sup></th>
								<th class="oo-col-qty-req tar">Qt Req<sup>*</sup></th>
								<th class="oo-col-qty-sup tar">Qt Forn</th>
								<th class="oo-col-disc tar">% Desc</th>
							</tr>
						</thead>
						<tbody>
							<tr class="row" data-size="10">
								<td class="sial-col-chk">
									<input type="hidden" id="number-0" value="">
									<input id="checkbox-0" type="checkbox">
								</td>
								<td title="Posi\xe7\xe3o de coleta no armaz\xe9m">
									<input id="location_id-0" class="location" type="text" list="locations" required>
								</td>
								<td title="Produto">
									<input id="product_id-0" class="product" type="text" list="products" required>
								</td>
								<td title="Lote do produto">
									<input id="lot_id-0" class="lot" type="text" list="lots-0" required>
								</td>
								<td class="tar" title="Quantidade pendente para envio">
									<input id="quantity_required-0" class="quantity" type="text" required>
								</td>
								<td class="tar" title="Quantidade fornecida nesta sa\xedda">
									<input id="quantity_supplied-0" class="quantity" type="text">
								</td>
								<td class="tar" title="Desconto atribu\xeddo ao produto">
									<input id="discount-0" class="discount" type="text" disabled>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="oo-footer">
				<span>
					<button type="button" class="button" id="bn-delete-separate-output-lines" style="display:none" title="Remove linhas antes do faturamento (status menor que 70), libera reserva (R\u{2192}L) e renumerar.">
						Remover linhas selecionadas (at\xe9 Conferida)
					</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#output',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#programs', 'programs', {
                labels: [
                    'name'
                ],
                value: 'id'
            });
            this.getFieldByName('company_id').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('order_id').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false); // once = false
            this.getFieldByName('order_type').subscribe([
                'change'
            ], this.checkCondition.bind(formset), false);
            Object.getPrototypeOf(this).init.call(this);
            const outRoot = formset.dialog?.getNode?.()?.querySelector('#output') || document.querySelector('#output');
            (0, $b2411514bdf07434$export$c784f48aeddf3f03)(outRoot);
        },
        checkCondition (ev, publisher, value) {
            let company_id = this.form.getFieldByName('company_id').getValue();
            let order_id = this.form.getFieldByName('order_id').getValue();
            let order_type = String(this.form.getFieldByName('order_type').getValue() || 'I').trim().toUpperCase();
            let key = String([
                company_id,
                order_type,
                order_id
            ]);
            if (typeof company_id != 'string' || !order_id || key == this.last_key) return;
            let is_edit = this.form.getFieldByName('id').getValue();
            // Saída já gravada: nunca repopular itens a partir do pedido.
            // Evita sobrescrever a grade no modo edição (#MT-ghost-output-lines).
            if (is_edit) {
                this.last_key = key;
                return;
            }
            this.form.fillItems.call(this, company_id, order_id, order_type);
            this.last_key = key;
        },
        async fillItems (company_id, order_id, order_type) {
            // Tipo Entrada (I) = Pedido de Entrada (devolução de compra).
            // Tipo Saída (O) = Pedido de Saída (fluxo normal).
            const tipo = String(order_type || this.form.getFieldByName('order_type')?.getValue?.() || 'I').trim().toUpperCase();
            const keep = {
                company_id: company_id,
                order_id: order_id,
                order_type: tipo === 'O' ? 'O' : 'I'
            };
            let record;
            try {
                record = tipo === 'O' ? await (0, $9VcS9.default).call((0, $9VcS9.default).select_output_order, company_id, order_id) : await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_order, company_id, order_id);
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Pedido');
                return;
            }
            if (!record) {
                (0, $jUNyh.notify)(tipo === 'O' ? `Pedido de Sa\xedda ${order_id} n\xe3o encontrado nesta empresa.` : `Pedido de Entrada ${order_id} n\xe3o encontrado nesta empresa.`, 'Pedido');
                return;
            }
            if (tipo !== 'O' && !record.is_return) (0, $jUNyh.notify)("Para gerar Sa\xedda a partir de Pedido de Entrada, o pedido precisa estar marcado como Devolu\xe7\xe3o e aprovado.", "Aten\xe7\xe3o");
            record.items = (record.items || []).map((item)=>{
                item.quantity_required = item.quantity != null ? item.quantity : item.quantity_required;
                return item;
            });
            record = (0, $b60a2.flatten)(record, 'items');
            // Não copiar identidade/status do pedido para a Saída nova
            delete record.id;
            delete record.status;
            delete record.created_on;
            delete record.created_by;
            delete record.updated_on;
            delete record.updated_by;
            delete record.is_return;
            this.clearAllRows();
            this.appendRows((0, $b60a2.getTopIndex)(record) - this.getEnabledRowsIndices().length + 1);
            this.form.setValues(record);
            // setValues do pedido não pode sobrescrever vínculo da saída
            this.form.setValues(keep);
            this.form.refresh();
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id'
            },
            types: [
                $6Jl4s.default(),
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_type'
            },
            types: [
                $6Jl4s.default(),
                $e3d776cc66101a71$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#program_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#reference'
            },
            types: []
        },
        {
            properties: {
                selector: '#created_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#expedited_on'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#warehouse_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('warehouse_company_id'),
                $dg8P2.default('warehouses')
            ]
        },
        {
            properties: {
                selector: '#volume_type'
            },
            types: [
                $e4pb7.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#volumes'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#weight'
            },
            types: [
                $3eqAU.default(3)
            ]
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#allow_manual_status_advance'
            },
            types: []
        },
        {
            properties: {
                selector: '#number-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#location_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default([
                    'warehouse_company_id',
                    'warehouse_id'
                ]),
                $dg8P2.default('locations', {
                    key: 'warehouse_company_id',
                    compositeWhLoc: true
                })
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#lot_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('product_id-0'),
                $dg8P2.default('lots', {
                    labels: [
                        'lot_number',
                        'id'
                    ],
                    sep: " \xb7 ",
                    key: 'company_id',
                    range: 1
                })
            ]
        },
        {
            properties: {
                selector: '#quantity_required-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#quantity_supplied-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#discount-0'
            },
            types: [
                $3eqAU.default(2)
            ]
        }
    ]
};




var $9PIz7 = parcelRequire("9PIz7");
var $84MPM = parcelRequire("84MPM");
var $3eqAU = parcelRequire("3eqAU");
var $a074d6080f330759$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#import #company_id	{ width: 10rem;	}
			#import #output_id	{ width: 5rem; text-align: right;	}
			#import #file		{ width: 15.5rem;	}
		</style>
		<form id="import" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="title">
				Importar Pick List
			</div>
			<div class="mtl">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="N\xfamero da sa\xedda">Sa\xedda<sup>*</sup>
					<input id="output_id" type="text" required>
				</label>
			</div>
			<div>
				<label class="file" title="Planilha contendo picking list">Arquivo
					<input id="file" type="file" accept=".xlsx, application/vnd.ms-excel" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Importar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#import',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#file'
            },
            types: [
                $84MPM.default()
            ]
        }
    ]
};


parcelRequire("9VcS9");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $b50b0cd1ea086803$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output-labels #company_id	{ width: 14rem;		}
			#output-labels #device_id	{ width: 25rem;		}
			#output-labels .company		{ width: 8rem;		}
			#output-labels .output		{ width: 4rem; text-align: right;	}
			#output-labels .order_id	{ width: 4rem; text-align: right;	}
			#output-labels .order_type	{ width: 5rem;		}
			#output-labels .name		{ width: 14rem;		}
			#output-labels .volume		{ width: 3rem; text-align: right;	}
		</style>
		<form id="output-labels" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;de&nbsp;Volumes
			</div>
			<input id="label_layout" type="hidden" value="default">
			<div class="fsb mtm">
				<input id="company_id" type="hidden">
				<input id="output_id" type="hidden">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="device_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Empresa</th>
							<th>Sa\xedda</th>
							<th>Pedido</th>
							<th>Origem</th>
							<th>Cliente/Fornecedor</th>
							<th>Vol Ini<sup>*</sup></th>
							<th>Vol Fin<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Empresa titular da sa\xedda">
								<input id="company_id-0" class="company" type="text" list="companies" disabled>
							</td>
							<td title="Identificador da sa\xedda">
								<input id="output_id-0" class="output" type="text" disabled>
							</td>
							<td title="Identificador do pedido">
								<input id="order_id-0" class="order_id" type="text" disabled>
							</td>
							<td title="Origem do pedido">
								<input id="order_type-0" class="order_type" type="text" disabled>
							</td>
							<td title="Nome do cliente ou fornecedor">
								<input id="name-0" class="name" type="text" disabled>
							</td>
							<td title="Volume inicial a imprimir">
								<input id="first_volume-0" class="volume" type="number" min="0" max="99" required>
							</td>
							<td title="Volume final a imprimir">
								<input id="last_volume-0" class="volume" type="number" min="0" max="99" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#output-labels',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            // Definir minimos e máximos dos volumes com base nos dados recebidos?
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#label_layout'
            },
            types: []
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#device_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('device_company_id'),
                $dg8P2.default('devices')
            ]
        },
        //{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#company_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#output_id-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_id-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#order_type-0'
            },
            types: [
                $6Jl4s.default(),
                $e3d776cc66101a71$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#name-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#first_volume-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#last_volume-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};


parcelRequire("9VcS9");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $0a66add6b28f4509$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#output-stage-labels #company_id	{ width: 14rem;		}
			#output-stage-labels #device_id	{ width: 25rem;		}
			#output-stage-labels .company		{ width: 8rem;		}
			#output-stage-labels .output		{ width: 4rem; text-align: right;	}
			#output-stage-labels .customer	{ width: 14rem;		}
			#output-stage-labels .reference	{ width: 10rem;		}
			#output-stage-labels .quantity	{ width: 4rem; text-align: right;	}
		</style>
		<form id="output-stage-labels" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiqueta&nbsp;de&nbsp;Sa\xedda
			</div>
			<input id="company_id" type="hidden">
			<input id="output_id" type="hidden">
			<div class="fsb mtm">
				<label title="Empresa para sele\xe7\xe3o da impressora">Empresa<sup>*</sup>
					<input id="device_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th>Empresa</th>
							<th>Sa\xedda</th>
							<th>Destinat\xe1rio</th>
							<th>Refer\xeancia</th>
							<th>Qtd<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<input id="id-0" type="hidden">
							<input id="company_id-0" type="hidden">
							<td title="Empresa titular da sa\xedda (nick)">
								<input id="company_nick-0" class="company" type="text" disabled>
							</td>
							<td title="Identificador da sa\xedda">
								<input id="output_id-0" class="output" type="text" disabled>
							</td>
							<td title="Nome do cliente">
								<input id="customer_name-0" class="customer" type="text" disabled>
							</td>
							<td title="Refer\xeancia do pedido (coletor)">
								<input id="reference-0" class="reference" type="text" disabled>
							</td>
							<td title="Quantidade de etiquetas iguais a imprimir">
								<input id="label_count-0" class="quantity" type="number" min="1" max="99" value="1" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#output-stage-labels',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default()
            ]
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#device_company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#use_local_agent'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#device_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('device_company_id'),
                $dg8P2.default('devices')
            ]
        },
        {
            properties: {
                selector: '#id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#company_id-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#company_nick-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#output_id-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#customer_name-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#reference-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#label_count-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        }
    ]
};


var $67075ee75b8cab41$export$2e2bcd8739ae039 = {
    html: `
		<form id="outputs-export-csv-form" class="form" autocomplete="off">
			<p class="fss">Gera um arquivo CSV com os mesmos cabe\xe7alhos da listagem
				(uma linha por sa\xedda; separador ponto e v\xedrgula, UTF-8).</p>
			<div class="fsb mtm">
				<label class="fss" style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
					<input type="checkbox" id="use_list_filter" value="1" checked
						onchange="(function(c){var h=document.getElementById('export-csv-hint-bare-outputs');if(h)h.style.display=c.checked?'none':'block';})(this)">
					Aplicar os filtros e a ordena\xe7\xe3o <strong>atuais</strong> da tela
				</label>
			</div>
			<p class="fss" id="export-csv-hint-bare-outputs" style="display:none">
				<strong>Aten\xe7\xe3o:</strong> sem filtro, todas as sa\xeddas a que voc\xea tem acesso ser\xe3o
				inclu\xeddas. Arquivos muito grandes podem demorar.
			</p>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Exportar CSV</button>
			</div>
		</form>
	`,
    form: {
        selector: '#outputs-export-csv-form'
    },
    fields: [
        {
            properties: {
                selector: '#use_list_filter'
            },
            types: []
        }
    ]
};


var $28b1bd1eb4b661a0$export$2e2bcd8739ae039 = {
    html: `
		<form id="outputs-export-items-csv-form" class="form" autocomplete="off">
			<p class="fss">Gera um CSV <strong>por linha de item</strong> (SKU, produto, lote, validade,
				quantidades e posi\xe7\xe3o), no mesmo esp\xedrito do relat\xf3rio <strong>Sa\xedda Detalhada</strong>
				\u{2014} separador ponto e v\xedrgula, UTF-8.</p>
			<div class="fsb mtm">
				<label class="fss" style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
					<input type="checkbox" id="use_list_filter" value="1" checked
						onchange="(function(c){var h=document.getElementById('export-items-csv-hint-bare');if(h)h.style.display=c.checked?'none':'block';})(this)">
					Aplicar os filtros e a ordena\xe7\xe3o <strong>atuais</strong> da tela
				</label>
			</div>
			<p class="fss" id="export-items-csv-hint-bare" style="display:none">
				<strong>Aten\xe7\xe3o:</strong> sem filtro, todas as sa\xeddas a que voc\xea tem acesso ser\xe3o
				expandidas em itens. Arquivos muito grandes podem demorar.
			</p>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Exportar CSV</button>
			</div>
		</form>
	`,
    form: {
        selector: '#outputs-export-items-csv-form'
    },
    fields: [
        {
            properties: {
                selector: '#use_list_filter'
            },
            types: []
        }
    ]
};



var $1cmSR = parcelRequire("1cmSR");
var $8930cf174b3182ba$export$2e2bcd8739ae039 = async (results)=>`<style>
	#results 
	{ 
		width: 100%; 
		border-collapse: collapse; 
	}
	#results td 
	{ 
		border: 1px solid lightgray;
		padding: var(--space-sm); 
	}
</style>
<table id="results" style="width: 100%;">` + (await Promise.all(Object.keys(results).map(async (company_id)=>`<tr>` + `<td class="tac" colspan="3">${(await (0, $1cmSR.default).get('companies', company_id)).nick}</td>` + `</tr>` + Object.keys(results[company_id]).map((output)=>`<tr>` + `<td class="tal">Sa\xedda&nbsp;${output}</td>` + `<td class="tal">${results[company_id][output]['status']}</td>` + `</tr>`).join('')))).join('') + `</table>`;



var $9PIz7 = parcelRequire("9PIz7");
var $b86df1d299d2d5ba$export$2e2bcd8739ae039 = {
    html: `
		<style>
		</style>
		<form id="reverse-output" class="form" autocomplete="off">
			<div class="title">
				Estorno de sa\xedda
			</div>
			<div class="mtl">
				<input id="company_id" type="hidden">
				<input id="output_id" type="hidden">
				<label title="Selecione status abaixo do atual para revers\xe3o das opera\xe7\xf5es">Status desejado:
					<input id="status" type="text" list="output_status" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Estornar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#reverse-output',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        }
    ]
};


/**
 * Modal de Conferência de Saída Web — Fase 2.
 *
 * Por linha: lote esperado (exibição), validade esperada (exibição),
 *            campo "Lote conferido" (obrigatório, deve bater com lote separado),
 *            campo "Validade conferida" (obrigatório, deve bater com validade do lote),
 *            campo "Quantidade conferida" (obrigatório),
 *            campo "Motivo" (obrigatório quando qty_conf < qty_req),
 *            campo "Observação" (obrigatório quando motivo = OUTROS).
 *
 * Parâmetros do tenant (carregados de GET /companies/<id>):
 *   out_allow_partial_conference — quando false, bloqueia conferência parcial
 *   out_require_divergence_auth  — quando true, avisa que permissão de autorização é exigida
 *
 * Aceita saídas em status 30 (Separada), 40 (Conferindo) ou 50 (Unpick).
 * Bloqueia status 60 ou superior.
 * Não altera o contrato PUT/PATCH legado do Coletor PWA.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");
/**
 * Modal de Confirmação — Pedido Falta (Fase 3, Conferência de Saída Web)
 *
 * Exibe o resumo dos itens faltantes de uma conferência parcial e permite
 * o usuário confirmar a geração de um novo Pedido de Saída ("Pedido Falta").
 *
 * Regras:
 *  • Somente para saídas com status 60 (Conferida) e qtd_sup < qtd_req em ≥ 1 linha.
 *  • O novo pedido NÃO reserva estoque automaticamente.
 *  • Não é possível gerar Pedido Falta duplicado para a mesma origem.
 *
 * Uso:
 *   import { openShortageModal } from './outputs-shortage.js';
 *   openShortageModal(companyId, outputId, outputOrderId, outputItems);
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");
function $8656f794cefc5b7a$var$escapeHtml(value) {
    if (value == null) return '';
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
/**
 * Calcula os itens faltantes de uma saída.
 * @param {Array} items - itens do output (com quantity_required / quantity_supplied)
 * @returns {Array} itens com shortage > 0
 */ function $8656f794cefc5b7a$var$calcShortageItems(items) {
    return (items || []).filter((item)=>{
        const req = parseInt(item.quantity_required ?? 0, 10);
        const sup = parseInt(item.quantity_supplied ?? req, 10);
        return req - sup > 0;
    }).map((item)=>{
        const req = parseInt(item.quantity_required ?? 0, 10);
        const sup = parseInt(item.quantity_supplied ?? req, 10);
        return {
            ...item,
            shortage: req - sup
        };
    });
}
function $8656f794cefc5b7a$export$68061872c81cf454(companyId, outputId, outputOrderId, outputItems, onCreated) {
    const shortageItems = $8656f794cefc5b7a$var$calcShortageItems(outputItems);
    if (!shortageItems.length) {
        (0, $jUNyh.notify)("Esta sa\xedda n\xe3o possui itens faltantes. Nenhum Pedido Falta necess\xe1rio.", 'info');
        return;
    }
    // ─── Tabela de itens faltantes ────────────────────────────────────────────
    const rows = shortageItems.map((item)=>{
        const sku = item.product_sku ? Array.isArray(item.product_sku) ? item.product_sku.join(' ') : item.product_sku : '';
        const name = item.product_name || `Produto #${item.product_id}`;
        const lot = item.lot_number || "\u2014";
        const req = parseInt(item.quantity_required ?? 0, 10);
        const sup = parseInt(item.quantity_supplied ?? req, 10);
        return `
			<tr>
				<td style="padding:6px 10px;border-bottom:1px solid #eee;font-size:13px">
					<span style="color:#666;font-size:11px">${$8656f794cefc5b7a$var$escapeHtml(sku)}</span><br>
					<strong>${$8656f794cefc5b7a$var$escapeHtml(name)}</strong>
				</td>
				<td style="padding:6px 10px;border-bottom:1px solid #eee;text-align:center;font-size:13px">${$8656f794cefc5b7a$var$escapeHtml(lot)}</td>
				<td style="padding:6px 10px;border-bottom:1px solid #eee;text-align:center;font-size:13px">${$8656f794cefc5b7a$var$escapeHtml(req)}</td>
				<td style="padding:6px 10px;border-bottom:1px solid #eee;text-align:center;font-size:13px;color:#1a7a3c">${$8656f794cefc5b7a$var$escapeHtml(sup)}</td>
				<td style="padding:6px 10px;border-bottom:1px solid #eee;text-align:center;font-weight:bold;color:#c0392b;font-size:13px">${$8656f794cefc5b7a$var$escapeHtml(item.shortage)}</td>
			</tr>`;
    }).join('');
    const tableHtml = `
		<table style="width:100%;border-collapse:collapse;margin-top:8px">
			<thead>
				<tr style="background:#f5f5f5">
					<th style="padding:7px 10px;text-align:left;font-size:12px;font-weight:600;color:#555">Produto</th>
					<th style="padding:7px 10px;text-align:center;font-size:12px;font-weight:600;color:#555">Lote</th>
					<th style="padding:7px 10px;text-align:center;font-size:12px;font-weight:600;color:#555">Req.</th>
					<th style="padding:7px 10px;text-align:center;font-size:12px;font-weight:600;color:#555">Conf.</th>
					<th style="padding:7px 10px;text-align:center;font-size:12px;font-weight:600;color:#c0392b">Falta</th>
				</tr>
			</thead>
			<tbody>${rows}</tbody>
		</table>`;
    const totalShortage = shortageItems.reduce((s, i)=>s + i.shortage, 0);
    const html = `
		<div class="msgbox" style="max-width:700px;min-width:400px">
			<div class="mb-title">Pedido Falta \u{2014} Sa\xedda #${$8656f794cefc5b7a$var$escapeHtml(outputId)}</div>
			<div class="mb-text">
				<div style="background:#fff8e1;border-left:4px solid #f0a500;padding:12px 16px;border-radius:4px;margin-bottom:16px">
					<strong style="color:#7a5200">Confirma\xe7\xe3o \u{2014} Gerar Pedido Falta</strong><br>
					<span style="color:#555;font-size:13px">
						Ser\xe1 criado um novo Pedido de Sa\xedda contendo apenas as quantidades faltantes
						da sa\xedda <strong>#${$8656f794cefc5b7a$var$escapeHtml(outputId)}</strong> (pedido <strong>#${$8656f794cefc5b7a$var$escapeHtml(outputOrderId)}</strong>).
						O novo pedido <strong>n\xe3o reservar\xe1 estoque automaticamente</strong>;
						seguir\xe1 o fluxo normal de aprova\xe7\xe3o \u{2192} gera\xe7\xe3o \u{2192} separa\xe7\xe3o \u{2192} confer\xeancia.
					</span>
				</div>
				${tableHtml}
				<div style="margin-top:12px;text-align:right;font-size:13px;color:#555">
					Total de unidades faltantes: <strong style="color:#c0392b">${$8656f794cefc5b7a$var$escapeHtml(totalShortage)}</strong>
				</div>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Gerar Pedido Falta</button>
		</div>`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        // api.call mostra spinner, trata erros e retorna o JSON parseado (ou undefined em erro)
        const result = await (0, $9VcS9.default).call((0, $9VcS9.default).create_shortage_order, companyId, outputOrderId, {
            source_output_id: outputId,
            grouping: 'by_original_order'
        });
        if (!result) // api.call já exibiu a notificação de erro; apenas manter o modal aberto
        return;
        dlg.destroy();
        (0, $jUNyh.notify)(`Pedido Falta criado com sucesso!\nPedido #${result.id} \u{2014} Refer\xeancia: ${result.reference}`, 'Pedido Falta');
        if (typeof onCreated === 'function') onCreated(result);
    }, /Escape|N|Y/);
}
function $8656f794cefc5b7a$export$b0c4e35941b023ed(items) {
    return $8656f794cefc5b7a$var$calcShortageItems(items).length > 0;
}


/**
 * Modal de Solicitação de Unpicking (Fase 4, Conferência de Saída Web)
 *
 * Permite ao usuário solicitar o unpicking de uma linha específica de saída.
 * Campos: quantidade, motivo e observação.
 *
 * Regras:
 *  • Disponível para saídas em status 30/40/50/60 (antes da baixa/NF-e).
 *  • Não movimenta estoque — apenas registra a solicitação.
 *  • Bloqueia nova solicitação se já existe uma REQUESTED ou APPROVED para o mesmo item.
 *
 * Uso:
 *   import { openUnpickRequestModal } from './outputs-unpick.js';
 *   openUnpickRequestModal(companyId, outputId, item, onSuccess);
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");
function $0b3ff9ab82e775f7$var$escapeHtml(value) {
    if (value == null) return '';
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
const $0b3ff9ab82e775f7$export$4090a335a9da2d6 = {
    ERRO_PICKING: 'Erro de picking',
    LOTE_ERRADO: 'Lote errado',
    ITEM_ERRADO: 'Item errado',
    QUANTIDADE_ERRADA: 'Quantidade errada',
    AVARIA: 'Avaria',
    CANCELAMENTO_OPERACIONAL: 'Cancelamento operacional',
    OUTROS: 'Outros'
};
const $0b3ff9ab82e775f7$export$94e183fb4cd5e8a3 = {
    REQUESTED: {
        label: 'Solicitado',
        badge: 'warning'
    },
    APPROVED: {
        label: 'Aprovado',
        badge: 'success'
    },
    REJECTED: {
        label: 'Rejeitado',
        badge: 'danger'
    },
    CANCELED: {
        label: 'Cancelado',
        badge: 'secondary'
    },
    EXECUTED: {
        label: 'Executado',
        badge: 'info'
    }
};
function $0b3ff9ab82e775f7$export$1a3e75f6cb6d19fd(status) {
    const info = $0b3ff9ab82e775f7$export$94e183fb4cd5e8a3[status];
    if (!info) return '';
    return `<span class="badge badge-${info.badge}" title="Unpicking ${info.label}">${info.label}</span>`;
}
function $0b3ff9ab82e775f7$export$da77a8bd334cda15(companyId, outputId, item, outputStatus, onSuccess) {
    const itemNumber = item.number;
    const productLabel = item.product_name ? `${item.product_sku || ''} \u{2014} ${item.product_name}`.trim().replace(/^—\s*/, '') : `Item ${itemNumber}`;
    // Limite de quantidade: pós-conferência (60) usa quantity_supplied; demais usam quantity_required
    const maxQty = parseInt(outputStatus === 60 || outputStatus === '60' ? item.quantity_supplied ?? item.quantity_required ?? 1 : item.quantity_required ?? 1, 10);
    const reasonOptions = Object.entries($0b3ff9ab82e775f7$export$4090a335a9da2d6).map(([code, label])=>`<option value="${code}">${label}</option>`).join('');
    const html = `
		<div class="msgbox" style="max-width:560px;min-width:360px">
		<div class="mb-title">Solicitar Unpicking \u{2014} Linha ${$0b3ff9ab82e775f7$var$escapeHtml(itemNumber)}</div>
		<div class="mb-text">
		<div class="form-group">
			<div class="form-row mb-2">
				<label class="col-form-label col-12 text-muted small">Item</label>
				<div class="col-12"><strong>${$0b3ff9ab82e775f7$var$escapeHtml(productLabel)}</strong> (linha ${$0b3ff9ab82e775f7$var$escapeHtml(itemNumber)})</div>
			</div>
			<div class="form-row mb-2">
				<div class="form-group col-12">
					<label class="col-form-label">Quantidade a desabonar
						<span class="text-muted small">(m\xe1x. ${$0b3ff9ab82e775f7$var$escapeHtml(maxQty)})</span>
					</label>
					<input id="unpick-qty" type="number" class="form-control"
						min="1" max="${$0b3ff9ab82e775f7$var$escapeHtml(maxQty)}" value="${$0b3ff9ab82e775f7$var$escapeHtml(maxQty)}" />
				</div>
			</div>
			<div class="form-row mb-2">
				<div class="form-group col-12">
					<label class="col-form-label">Motivo <span class="text-danger">*</span></label>
					<select id="unpick-reason" class="form-control">
						<option value="">\u{2014} selecione \u{2014}</option>
						${reasonOptions}
					</select>
				</div>
			</div>
			<div class="form-row mb-2" id="unpick-note-row">
				<div class="form-group col-12">
					<label class="col-form-label">Observa\xe7\xe3o
						<span id="unpick-note-required" class="text-danger d-none">*</span>
					</label>
					<textarea id="unpick-note" class="form-control" rows="2"
						placeholder="Descreva o motivo da solicita\xe7\xe3o"></textarea>
				</div>
			</div>
		</div>
		</div>
		<div class="modal-footer px-0">
			<button type="button" class="button mtl bn_N" id="unpick-cancel-btn">Cancelar</button>
			<button type="button" class="button mtl bn_Y" id="unpick-submit-btn">Solicitar Unpicking</button>
		</div>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        const node = dlg.getNode();
        const reasonSel = node.querySelector('#unpick-reason');
        const submitBtn = node.querySelector('#unpick-submit-btn');
        const qtyInput = node.querySelector('#unpick-qty');
        const noteInput = node.querySelector('#unpick-note');
        const qty = parseInt(qtyInput.value, 10);
        const reasonCode = reasonSel.value;
        const reasonNote = noteInput.value.trim();
        if (!qty || qty <= 0) {
            (0, $jUNyh.notify)('Informe uma quantidade maior que zero.', 'warning');
            return;
        }
        if (qty > maxQty) {
            (0, $jUNyh.notify)(`Quantidade m\xe1xima permitida: ${maxQty}.`, 'warning');
            return;
        }
        if (!reasonCode) {
            (0, $jUNyh.notify)('Selecione um motivo.', 'warning');
            return;
        }
        if (reasonCode === 'OUTROS' && !reasonNote) {
            (0, $jUNyh.notify)('Observa\xe7\xe3o \xe9 obrigat\xf3ria quando o motivo for "Outros".', 'warning');
            return;
        }
        submitBtn.disabled = true;
        submitBtn.textContent = "Aguarde\u2026";
        const result = await (0, $9VcS9.default).call((0, $9VcS9.default).request_output_unpick, companyId, outputId, {
            output_item_number: itemNumber,
            quantity: qty,
            reason_code: reasonCode,
            reason_note: reasonNote || undefined
        });
        if (!result) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Solicitar Unpicking';
            return;
        }
        dlg.destroy();
        (0, $jUNyh.notify)("Solicita\xe7\xe3o de unpicking registrada com sucesso.", 'success');
        if (typeof onSuccess === 'function') onSuccess(result.id);
    }, /Escape|N|Y/);
    const node = dlg.getNode();
    const reasonSel = node.querySelector('#unpick-reason');
    const noteReq = node.querySelector('#unpick-note-required');
    const noteInput = node.querySelector('#unpick-note');
    // Exibe asterisco no campo observação quando motivo é OUTROS.
    reasonSel.addEventListener('change', ()=>{
        if (reasonSel.value === 'OUTROS') {
            noteReq.classList.remove('d-none');
            noteInput.placeholder = 'Obrigat\xf3rio para o motivo "Outros"';
        } else {
            noteReq.classList.add('d-none');
            noteInput.placeholder = "Descreva o motivo da solicita\xe7\xe3o";
        }
    });
}



var $jU7Ru = parcelRequire("jU7Ru");
/** Mapa de status para rótulo legível */ const $2904a5446a687563$var$STATUS_LABEL = {
    10: 'Criada',
    20: 'Picking',
    30: 'Separada',
    40: 'Conferindo',
    50: 'Unpick',
    60: 'Conferida',
    65: 'Faturando',
    70: 'Faturada',
    80: "Expedi\xe7\xe3o",
    90: 'Encerrada',
    100: 'Cancelada',
    999: "Exclu\xedda"
};
const $2904a5446a687563$var$VOLUME_TYPES = [
    {
        value: 'C',
        label: 'Caixa'
    }
];
/** Motivos de divergência — espelha DIVERGENCE_REASON_CODES do backend */ const $2904a5446a687563$var$DIVERGENCE_REASONS = [
    {
        value: 'FALTA_FISICA',
        label: "Falta f\xedsica"
    },
    {
        value: 'AVARIA',
        label: 'Avaria'
    },
    {
        value: 'ERRO_PICKING',
        label: 'Erro de picking'
    },
    {
        value: 'QUANTIDADE_DIVERGENTE',
        label: 'Quantidade divergente'
    },
    {
        value: 'CORRECAO_OPERACIONAL',
        label: "Corre\xe7\xe3o operacional"
    },
    {
        value: 'OUTROS',
        label: 'Outros'
    }
];
/**
 * Normaliza string de lote para comparação:
 * remove espaços nas pontas, converte para minúsculas.
 * @param {string|null|undefined} s
 * @returns {string}
 */ function $2904a5446a687563$var$normalizeLot(s) {
    return s != null ? String(s).trim().toLowerCase() : '';
}
function $2904a5446a687563$var$escapeHtml(value) {
    if (value == null) return '';
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
/**
 * Converte data digitada pelo usuário para YYYY-MM-DD.
 * Formato principal: DD/MM/AAAA (produzido pela máscara).
 * Aceita também YYYY-MM-DD para compatibilidade.
 * Retorna null se não reconhecer o formato.
 * @param {string} raw
 * @returns {string|null}
 */ function $2904a5446a687563$var$parseInputDate(raw) {
    if (!raw) return null;
    const s = String(raw).trim();
    // YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        const [y, m, d] = s.split('-');
        const dt = new Date(`${y}-${m}-${d}T00:00:00`);
        return isNaN(dt.getTime()) ? null : `${y}-${m}-${d}`;
    }
    // DD/MM/AAAA
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
        const [d, m, y] = s.split('/');
        const dt = new Date(`${y}-${m}-${d}T00:00:00`);
        return isNaN(dt.getTime()) ? null : `${y}-${m}-${d}`;
    }
    return null;
}
/**
 * Formata data ISO (YYYY-MM-DD) como DD/MM/AAAA, ou retorna '—'.
 * @param {string|null} iso
 * @returns {string}
 */ function $2904a5446a687563$var$fmtDate(iso) {
    if (!iso) return "\u2014";
    const s = String(iso);
    // suporta 'YYYY-MM-DD' e 'YYYY-MM-DDTHH:...'
    const [y, m, d] = s.split('T')[0].split('-');
    return `${d}/${m}/${y}`;
}
/**
 * Marca input com borda vermelha (erro) ou remove a marcação.
 * @param {HTMLElement} el
 * @param {boolean} hasError
 */ function $2904a5446a687563$var$markError(el, hasError) {
    el.style.outline = hasError ? '2px solid #c00' : '';
    el.style.background = hasError ? '#fff0f0' : '';
}
/**
 * Aplica máscara DD/MM/AAAA no input de validade.
 * O usuário digita apenas números; as barras são inseridas automaticamente.
 * @param {HTMLInputElement} input
 */ function $2904a5446a687563$var$applyDateMask(input) {
    const digits = input.value.replace(/\D/g, '').slice(0, 8);
    let masked = digits.slice(0, 2);
    if (digits.length > 2) masked += '/' + digits.slice(2, 4);
    if (digits.length > 4) masked += '/' + digits.slice(4, 8);
    input.value = masked;
}
/**
 * Mostra ou oculta a sub-linha de motivo/obs (conf-div-row) abaixo da linha principal.
 * @param {HTMLElement} mainRow - <tr data-number="..."> (linha principal)
 * @param {boolean} show
 * @param {boolean} allowPartial - quando false, realça a linha em vermelho
 */ function $2904a5446a687563$var$toggleDivergenceFields(mainRow, show, allowPartial) {
    const tbody = mainRow.parentElement;
    const num = mainRow.dataset.number;
    const divRow = tbody?.querySelector(`.conf-div-row[data-number="${num}"]`);
    if (!divRow) return;
    divRow.style.display = show ? '' : 'none';
    if (!allowPartial && show) mainRow.querySelectorAll('td').forEach((td)=>{
        td.style.background = '#fff0f0';
    });
    else mainRow.querySelectorAll('td').forEach((td)=>{
        td.style.background = '';
    });
}
async function $2904a5446a687563$export$2e2bcd8739ae039(companyId, outputId, onSuccess) {
    // Carregar dados da saída, parâmetros da empresa, checkpoint do coletor e unpicking em paralelo
    const [output, companyRaw, unpickRespRaw, checkpointRaw] = await Promise.all([
        (0, $9VcS9.default).call((0, $9VcS9.default).select_output, companyId, outputId),
        (0, $9VcS9.default).call((0, $9VcS9.default).select_company, companyId),
        fetch(`${(0, $9VcS9.default).HOST}/companies/${companyId}/outputs/${outputId}/unpick-requests`, {
            method: 'GET',
            credentials: 'include'
        }).then((r)=>r.ok ? r.json() : []).catch(()=>[]),
        (0, $9VcS9.default).call((0, $9VcS9.default).get_collector_conference_checkpoint, companyId, outputId).then((r)=>r.ok ? r.json() : null).catch(()=>null)
    ]);
    if (!output) return;
    /** @type {object|null} checkpoint parcial pending do ColetorPWA */ const collectorCheckpoint = checkpointRaw && checkpointRaw.status === 'pending' ? checkpointRaw : null;
    const checkpointByNumber = {};
    if (collectorCheckpoint) {
        for (const it of collectorCheckpoint.items_ok || [])checkpointByNumber[it.output_item_number] = {
            ...it,
            origin: 'ok'
        };
        for (const it of collectorCheckpoint.divergent_items || [])checkpointByNumber[it.output_item_number] = {
            ...it,
            origin: 'divergent'
        };
    }
    // Mapa de item_number → solicitação de unpicking ativa (REQUESTED ou APPROVED)
    const unpickByItem = {};
    for (const req of unpickRespRaw || [])if (req.status === 'REQUESTED' || req.status === 'APPROVED') unpickByItem[req.output_item_number] = req;
    // Parâmetros do tenant (default = comportamento legado / permissivo)
    const allowPartial = companyRaw?.out_allow_partial_conference !== false; // true por padrão
    const requireAuth = companyRaw?.out_require_divergence_auth === true; // false por padrão
    const enableBoxCtrl = companyRaw?.out_enable_box_control === true; // false por padrão
    const packagingActive = !!(companyRaw?.pkg_use_hierarchy && companyRaw?.pkg_optimize_picking && companyRaw?.pkg_rollback_legacy !== true);
    /** Cega por embalagem (default true). false = unidade mínima na UI. */ const blindByPackaging = companyRaw?.out_conference_blind_by_packaging !== false;
    /** @param {object} item @returns {number} */ function packFactor(item) {
        const f = Number(item?.packaging_factor) || 1;
        return f > 1 ? f : 1;
    }
    /**
	 * UI em embalagens (como Coletor) quando flag ligada, fator > 1,
	 * qtd requerida divisível pelo fator e linha sem caixa lacrada controlando a qtd.
	 * @param {object} item
	 * @returns {boolean}
	 */ function usePackagingQtyUi(item) {
        if (!blindByPackaging) return false;
        if (enableBoxCtrl && itemRequiresPickingBox(item)) return false;
        const f = packFactor(item);
        if (f <= 1) return false;
        const req = parseInt(item.quantity_required, 10) || 0;
        return req > 0 && req % f === 0;
    }
    /** @param {object} item @param {number} units @returns {number} */ function unitsToUiQty(item, units) {
        const u = parseInt(units, 10) || 0;
        if (!usePackagingQtyUi(item)) return u;
        return Math.floor(u / packFactor(item));
    }
    /** @param {object} item @param {number} uiQty @returns {number} */ function uiQtyToUnits(item, uiQty) {
        const q = parseInt(uiQty, 10) || 0;
        if (!usePackagingQtyUi(item)) return q;
        return q * packFactor(item);
    }
    const qtyUnitLabel = blindByPackaging ? ' (emb)' : ' (und)';
    const qtyHintExtra = blindByPackaging ? " \xb7 Com <strong>confer\xeancia cega por embalagem</strong> ligada: informe n\xba de embalagens quando houver fator (a API recebe unidades = emb \xd7 fator)." : " \xb7 Quantidades em <strong>unidade m\xednima</strong> (n\xe3o em caixas/embalagens). Embalagem/fator s\xf3 como apoio.";
    /** @param {object} item @returns {boolean} */ function itemRequiresPickingBox(item) {
        if (!enableBoxCtrl) return false;
        if (!packagingActive) return true;
        return !item.is_tertiary_volume;
    }
    /** @param {object} item @param {number} qtySup @returns {number} */ function tertiaryVolumeUnits(item, qtySup) {
        if (!item?.is_tertiary_volume) return 0;
        const supplied = Number(qtySup) || 0;
        if (supplied <= 0) return 0;
        const factor = Number(item.packaging_factor) || 1;
        if (factor > 1) return Math.floor(supplied / factor);
        return 1;
    }
    /** @returns {number} */ function countTertiaryVolumes() {
        return (items || []).reduce((sum, item)=>{
            const qtySup = parseInt(item.quantity_supplied ?? item.quantity_required ?? 0, 10);
            return sum + tertiaryVolumeUnits(item, qtySup);
        }, 0);
    }
    /** @returns {number} */ function expectedConferenceVolumes() {
        if (!enableBoxCtrl) return 0;
        return boxClosedCount + (packagingActive ? countTertiaryVolumes() : 0);
    }
    /** @returns {boolean} */ function needsSealedBoxesForConference() {
        if (!enableBoxCtrl) return false;
        return (items || []).some((item)=>{
            if (!itemRequiresPickingBox(item)) return false;
            const qtySup = parseInt(item.quantity_supplied ?? item.quantity_required ?? 0, 10);
            return qtySup > 0;
        });
    }
    // ── Controle de caixas: carregar dados se parâmetro ativo ────────────────
    let pickingBoxes = null;
    let boxSumByLine = {}; // output_item_number → qty somada de caixas lacradas
    let boxOpenCount = 0;
    let boxClosedCount = 0;
    let boxCanceledCount = 0;
    let boxClosedTotalItems = 0;
    let boxClosedTotalQty = 0;
    function recomputeBoxTotals() {
        boxSumByLine = {};
        boxOpenCount = 0;
        boxClosedCount = 0;
        boxCanceledCount = 0;
        boxClosedTotalItems = 0;
        boxClosedTotalQty = 0;
        for (const box of pickingBoxes || []){
            const boxStatus = Number(box.status);
            if (boxStatus === 10) boxOpenCount++;
            else if (boxStatus === 20) {
                boxClosedCount++;
                const bItems = Array.isArray(box.items) ? box.items : [];
                boxClosedTotalItems += bItems.length;
                for (const bi of bItems){
                    const qty = Number(bi.quantity) || 0;
                    boxClosedTotalQty += qty;
                    const num = bi.output_item_number;
                    boxSumByLine[num] = (boxSumByLine[num] || 0) + qty;
                }
            } else if (boxStatus === 30) boxCanceledCount++;
        }
    }
    if (enableBoxCtrl) {
        try {
            const boxData = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId);
            pickingBoxes = boxData?.boxes || [];
        } catch (_) {
            pickingBoxes = null;
        }
        if (!pickingBoxes) {
            (0, $jUNyh.notify)("Controle de caixas ativo: n\xe3o foi poss\xedvel carregar os itens das caixas.", "Confer\xeancia de Sa\xedda");
            return;
        }
        recomputeBoxTotals();
    }
    const ALLOWED = [
        30,
        40,
        50
    ];
    if (!ALLOWED.includes(output.status)) {
        (0, $jUNyh.notify)(output.status >= 60 ? `Sa\xedda ${outputId} j\xe1 foi conferida (status ${output.status} \u{2014} ${$2904a5446a687563$var$STATUS_LABEL[output.status] || output.status}). Edi\xe7\xe3o n\xe3o permitida.` : `Status ${output.status} (${$2904a5446a687563$var$STATUS_LABEL[output.status] || '?'}) n\xe3o permite confer\xeancia web.`, "Confer\xeancia de Sa\xedda");
        return;
    }
    const items = output.items || [];
    // Opções do select de motivo de divergência
    const reasonOptions = $2904a5446a687563$var$DIVERGENCE_REASONS.map((r)=>`<option value="${r.value}">${r.label}</option>`).join('');
    const itemRows = items.map((item)=>{
        const sku = item.product_sku ? String(item.product_sku).trim() : '';
        const name = item.product_name ? String(item.product_name).trim() : `Produto #${item.product_id}`;
        const lotNum = item.lot_number ? String(item.lot_number).trim() : null;
        const validISO = item.expiration_date ? String(item.expiration_date).split('T')[0] : null;
        const validFmt = $2904a5446a687563$var$fmtDate(validISO);
        // Colorir validade quando próxima (≤90 dias) ou vencida
        let validStyle = 'color:#555';
        if (validISO) {
            const daysLeft = (new Date(validISO) - new Date()) / 86400000;
            if (daysLeft < 0) validStyle = 'color:#c00;font-weight:bold';
            else if (daysLeft <= 90) validStyle = 'color:#c80';
        }
        // Saídas sem lote (item.lot_id null): não exige lote/validade
        const hasLot = item.lot_id != null;
        // Caixas: quantidade pré-preenchida e diff inicial quando controle ativo
        const requiresBox = enableBoxCtrl && itemRequiresPickingBox(item);
        const packUi = usePackagingQtyUi(item);
        const factor = packFactor(item);
        const qtySupSep = parseInt(item.quantity_supplied ?? item.quantity_required ?? 0, 10);
        const bQtyUnits = enableBoxCtrl ? requiresBox ? boxSumByLine[item.number] || 0 : qtySupSep : 0;
        const bQtyReqUnits = parseInt(item.quantity_required, 10) || 0;
        const bQtyReq = packUi ? Math.floor(bQtyReqUnits / factor) : bQtyReqUnits;
        const bQty = packUi ? unitsToUiQty(item, bQtyUnits) : bQtyUnits;
        const bDiff = bQty - bQtyReq;
        const cpItem = checkpointByNumber[item.number];
        const cpOrigin = cpItem?.origin;
        // Com controle de caixas, qty da linha com caixa vem das caixas lacradas (validação no submit).
        const boxQtyWins = enableBoxCtrl && requiresBox;
        const prefQtyUnits = boxQtyWins ? bQtyUnits : cpItem != null ? parseInt(cpItem.quantity_supplied ?? 0, 10) : enableBoxCtrl ? bQtyUnits : NaN;
        const prefQtyVal = !isNaN(prefQtyUnits) ? packUi ? unitsToUiQty(item, prefQtyUnits) : prefQtyUnits : NaN;
        const prefQty = boxQtyWins ? String(bQty) : cpItem != null ? String(packUi ? unitsToUiQty(item, parseInt(cpItem.quantity_supplied ?? 0, 10)) : cpItem.quantity_supplied ?? '') : enableBoxCtrl ? String(bQty) : '';
        const prefLot = cpItem?.lot_confirmed ? $2904a5446a687563$var$escapeHtml(String(cpItem.lot_confirmed)) : '';
        const prefExp = cpItem?.expiration_confirmed ? $2904a5446a687563$var$fmtDate(cpItem.expiration_confirmed) : '';
        const diffQty = !isNaN(prefQtyVal) ? prefQtyVal - bQtyReq : bDiff;
        const bDiffStr = !isNaN(diffQty) ? diffQty === 0 ? "\u2713" : String(diffQty) : bDiff === 0 ? "\u2713" : String(bDiff);
        const bDiffColor = !isNaN(diffQty) ? diffQty === 0 ? '#2a7' : diffQty < 0 ? '#c80' : '#c00' : bDiff === 0 ? '#2a7' : bDiff < 0 ? '#c80' : '#c00';
        const originBadge = cpOrigin === 'ok' ? '<div style="font-size:0.68rem;color:#1a6e38;font-weight:600;margin-top:2px">Conferido no Coletor</div>' : cpOrigin === 'divergent' ? '<div style="font-size:0.68rem;color:#b45309;font-weight:600;margin-top:2px">Divergente no Coletor</div>' : collectorCheckpoint && !cpItem ? '<div style="font-size:0.68rem;color:#888;margin-top:2px">N\xe3o conferido</div>' : '';
        const packHint = packUi ? `<div style="font-size:0.7rem;color:#888;margin-top:2px">Informe embalagens (fator ${$2904a5446a687563$var$escapeHtml(factor)} \u{2192} ${$2904a5446a687563$var$escapeHtml(bQtyReqUnits)} und)</div>` : !blindByPackaging && factor > 1 ? `<div style="font-size:0.7rem;color:#888;margin-top:2px">Apoio: fator embalagem ${$2904a5446a687563$var$escapeHtml(item.packaging_factor)}${item.packaging_plan ? ` \xb7 ${$2904a5446a687563$var$escapeHtml(item.packaging_plan)}` : ''}</div>` : '';
        const rowBg = cpOrigin === 'divergent' ? 'background:#fff8e6!important;' : cpOrigin === 'ok' ? 'background:#f0faf4!important;' : '';
        const initDivShow = cpOrigin === 'divergent' && !isNaN(prefQtyVal) && prefQtyVal < bQtyReq;
        // Coluna de unpicking: exibe badge se houver solicitação ativa, ou botão para solicitar
        const activeUnpick = unpickByItem[item.number];
        const unpickCell = activeUnpick ? `<div class="text-center" style="font-size:0.8rem">${(0, $0b3ff9ab82e775f7$export$1a3e75f6cb6d19fd)(activeUnpick.status)}</div>` : `<button class="btn btn-sm btn-outline-warning conf-unpick-btn" data-number="${$2904a5446a687563$var$escapeHtml(item.number)}"
					style="font-size:0.75rem;padding:2px 6px;white-space:nowrap" title="Solicitar unpicking para esta linha">
					\u{21A9} Unpick
				</button>`;
        return `
			<tr data-number="${$2904a5446a687563$var$escapeHtml(item.number)}" data-cp-origin="${cpOrigin || ''}" style="${rowBg}">
				<td style="padding:5px 8px;white-space:nowrap;color:#888;font-size:0.8rem;vertical-align:middle;${rowBg}">${$2904a5446a687563$var$escapeHtml(item.number)}</td>
				<td style="padding:5px 8px;min-width:160px;vertical-align:middle;${rowBg}">
					<div style="font-size:0.72rem;color:#666;line-height:1.2">${$2904a5446a687563$var$escapeHtml(sku)}</div>
					<div style="font-size:0.85rem;line-height:1.3">${$2904a5446a687563$var$escapeHtml(name)}</div>
					${packHint}
					${originBadge}
				</td>
				<td style="padding:5px 8px;white-space:nowrap;font-size:0.8rem;vertical-align:middle">
					${hasLot ? `<div style="font-weight:500">${$2904a5446a687563$var$escapeHtml(lotNum)}</div>
						   <div style="${validStyle};font-size:0.75rem">${validFmt}</div>` : '<span style="color:#aaa;font-size:0.75rem">sem lote</span>'}
				</td>
				<td style="padding:5px 8px;vertical-align:middle">
					<input
						type="text"
						class="conf-lot"
						data-number="${$2904a5446a687563$var$escapeHtml(item.number)}"
						data-expected-lot="${hasLot ? $2904a5446a687563$var$escapeHtml(lotNum || '') : ''}"
						data-has-lot="${hasLot ? '1' : '0'}"
						value="${prefLot}"
						${!hasLot ? 'disabled placeholder="\u2014"' : 'placeholder="Digite o lote"'}
						style="width:7rem;padding:2px 4px${!hasLot ? ';color:#aaa' : ''}"
						autocomplete="off"
					>
				</td>
				<td style="padding:5px 8px;vertical-align:middle">
					<input
						type="text"
						class="conf-expiry"
						data-number="${$2904a5446a687563$var$escapeHtml(item.number)}"
						data-expected-expiry="${$2904a5446a687563$var$escapeHtml(validISO || '')}"
						data-has-lot="${hasLot ? '1' : '0'}"
						value="${prefExp}"
						${!hasLot ? 'disabled placeholder="\u2014"' : 'placeholder="DD/MM/AAAA" maxlength="10"'}
						style="width:7.5rem;padding:2px 4px${!hasLot ? ';color:#aaa' : ''}"
						autocomplete="off"
					>
				</td>
				<td style="padding:5px 8px;text-align:right;white-space:nowrap;font-weight:500;vertical-align:middle">${$2904a5446a687563$var$escapeHtml(bQtyReq)}</td>
			<td style="padding:5px 8px;vertical-align:middle">
				<input
					type="number"
					class="conf-qty"
					data-number="${$2904a5446a687563$var$escapeHtml(item.number)}"
					data-required="${$2904a5446a687563$var$escapeHtml(bQtyReq)}"
					data-required-units="${$2904a5446a687563$var$escapeHtml(bQtyReqUnits)}"
					data-factor="${$2904a5446a687563$var$escapeHtml(factor)}"
					data-pack-ui="${packUi ? '1' : '0'}"
					value="${prefQty}"
					min="0"
					max="${$2904a5446a687563$var$escapeHtml(bQtyReq)}"
					step="1"
					${enableBoxCtrl && requiresBox ? 'readonly title="Preenchido automaticamente pelas caixas lacradas"' : ''}
					style="width:5.5rem;text-align:right;padding:2px 4px${enableBoxCtrl && requiresBox ? ';background:#f0f7ff;color:#333' : ''}"
					autocomplete="off"
				>
			</td>
			<td class="conf-diff" data-number="${$2904a5446a687563$var$escapeHtml(item.number)}" style="padding:5px 8px;text-align:right;white-space:nowrap;color:${enableBoxCtrl ? bDiffColor : '#888'};vertical-align:middle">${enableBoxCtrl ? bDiffStr : "\u2014"}</td>
			<td style="padding:5px 8px;text-align:center;vertical-align:middle;white-space:nowrap">
				${unpickCell}
			</td>
			</tr>
		<tr class="conf-div-row" data-number="${$2904a5446a687563$var$escapeHtml(item.number)}" style="${initDivShow || enableBoxCtrl && bDiff < 0 ? '' : 'display:none'}">
			<td colspan="9" style="padding:4px 8px 8px 2rem;background:#fff8e6;border-bottom:1px solid #f0c04d">
					<div style="display:flex;align-items:flex-start;gap:0.5rem;font-size:0.8rem;color:#92600a;margin-bottom:4px">
						<span>\u{26A0}</span>
						<span>Quantidade divergente \u{2014} informe o motivo:</span>
					</div>
					<div style="display:flex;gap:0.5rem;flex-wrap:wrap;align-items:flex-start">
						<select
							class="conf-reason-select"
							data-number="${$2904a5446a687563$var$escapeHtml(item.number)}"
							style="padding:3px 6px;font-size:0.82rem;min-width:200px"
						>
							<option value="">\u{2014} selecione o motivo \u{2014}</option>
							${reasonOptions}
						</select>
						<textarea
							class="conf-reason-note"
							data-number="${$2904a5446a687563$var$escapeHtml(item.number)}"
							placeholder="Observa\xe7\xe3o obrigat\xf3ria para Outros"
							style="display:none;padding:3px 6px;font-size:0.8rem;resize:vertical;min-height:2rem;min-width:240px;flex:1"
						></textarea>
					</div>
				</td>
			</tr>
		`;
    }).join('');
    const checkpointVolumeType = collectorCheckpoint?.volume_type || null;
    const vtOptions = $2904a5446a687563$var$VOLUME_TYPES.map((o)=>{
        // Caixas ativo → Caixa; senão checkpoint do coletor; senão valor da saída
        const effectiveVt = enableBoxCtrl ? 'C' : checkpointVolumeType || output.volume_type;
        const sel = effectiveVt === o.value ? ' selected' : '';
        return `<option value="${o.value}"${sel}>${o.label}</option>`;
    }).join('');
    const statusStr = `${output.status} \u{2014} ${$2904a5446a687563$var$STATUS_LABEL[output.status] || output.status}`;
    // Painel de caixas de picking (quando controle ativo)
    const _BOX_ST_LBL = {
        10: 'Aberta',
        20: 'Lacrada',
        30: 'Cancelada'
    };
    const _BOX_ST_STYLE = {
        10: 'background:#fff7e6;color:#b45309;border:1px solid #f0c04d',
        20: 'background:#e6f9ee;color:#1a6e38;border:1px solid #6bcf8b',
        30: 'background:#f5f5f5;color:#888;border:1px solid #ccc'
    };
    function buildBoxPanelInnerHtml() {
        const expVolumes = expectedConferenceVolumes();
        const tertiaryCount = packagingActive ? countTertiaryVolumes() : 0;
        const warningBar = boxOpenCount > 0 ? `<div class="conf-box-warning" style="background:#fff3cd;border:1px solid #ffc107;border-radius:3px;padding:5px 10px;font-size:0.8rem;color:#856404;margin-bottom:0.5rem">
					\u{26A0} <strong>${boxOpenCount} caixa(s) ainda em aberto</strong> \u{2014} lacre todas antes de concluir, ou use Ver Caixas para ajustar.
				</div>` : needsSealedBoxesForConference() && boxClosedCount === 0 ? `<div class="conf-box-warning" style="background:#f8d7da;border:1px solid #f5c2c7;border-radius:3px;padding:5px 10px;font-size:0.8rem;color:#842029;margin-bottom:0.5rem">
					\u{2715} <strong>Nenhuma caixa lacrada</strong> \u{2014} n\xe3o ser\xe1 poss\xedvel concluir a confer\xeancia.
				</div>` : '';
        const boxRowsHtml = (pickingBoxes || []).map((box)=>{
            const boxStatus = Number(box.status);
            const bItems = Array.isArray(box.items) ? box.items : [];
            const bQtyTotal = bItems.reduce((s, i)=>s + (Number(i.quantity) || 0), 0);
            const sealCell = boxStatus === 10 ? bItems.length > 0 ? `<button type="button" class="conf-box-seal" data-box-id="${$2904a5446a687563$var$escapeHtml(box.id)}" data-box-code="${$2904a5446a687563$var$escapeHtml(box.code || '')}" data-items="${bItems.length}" style="font-size:0.72rem;padding:1px 5px;cursor:pointer">Lacrar Caixa</button>` : `<span style="font-size:0.72rem;color:#888" title="Adicione itens antes de lacrar">sem itens</span>` : "\u2014";
            return `<tr style="border-bottom:1px solid #eee">
				<td style="padding:3px 6px;font-size:0.8rem;white-space:nowrap">${$2904a5446a687563$var$escapeHtml(box.code || "\u2014")}</td>
				<td style="padding:3px 6px;font-size:0.8rem;white-space:nowrap;color:#555">${$2904a5446a687563$var$escapeHtml(box.seal_code || "\u2014")}</td>
				<td style="padding:3px 6px;text-align:center">
					<span style="font-size:0.72rem;padding:1px 6px;border-radius:10px;${_BOX_ST_STYLE[boxStatus] || ''}">${$2904a5446a687563$var$escapeHtml(_BOX_ST_LBL[boxStatus] || box.status)}</span>
				</td>
				<td style="padding:3px 6px;text-align:right;font-size:0.8rem">${bItems.length}</td>
				<td style="padding:3px 6px;text-align:right;font-size:0.8rem">${bQtyTotal}</td>
				<td style="padding:3px 6px;text-align:center">${sealCell}</td>
			</tr>`;
        }).join('');
        const statsHtml = `
			<div class="conf-box-stats" style="display:flex;gap:1.2rem;flex-wrap:wrap;font-size:0.8rem;margin-bottom:0.5rem">
				<span>Abertas: <strong style="color:${boxOpenCount > 0 ? '#b45309' : '#888'}">${boxOpenCount}</strong></span>
				<span>Lacradas: <strong style="color:${boxClosedCount > 0 ? '#1a6e38' : '#888'}">${boxClosedCount}</strong></span>
				${tertiaryCount > 0 ? `<span>Terci\xe1rios: <strong style="color:#6c3483">${tertiaryCount}</strong></span>` : ''}
				${expVolumes > 0 ? `<span>Volumes totais: <strong>${expVolumes}</strong></span>` : ''}
				<span>Canceladas: <strong style="color:#888">${boxCanceledCount}</strong></span>
				<span>Itens nas lacradas: <strong>${boxClosedTotalItems}</strong></span>
				<span>Unidades nas lacradas: <strong>${boxClosedTotalQty}</strong></span>
			</div>`;
        const tableHtml = (pickingBoxes || []).length > 0 ? `<div style="overflow-x:auto;max-height:120px;overflow-y:auto">
				<table style="width:100%;border-collapse:collapse;font-size:0.82rem">
					<thead>
						<tr style="background:#e8f0fb">
							<th style="padding:3px 6px;text-align:left;font-weight:500">Caixa</th>
							<th style="padding:3px 6px;text-align:left;font-weight:500">Lacre</th>
							<th style="padding:3px 6px;text-align:center;font-weight:500">Status</th>
							<th style="padding:3px 6px;text-align:right;font-weight:500">Itens</th>
							<th style="padding:3px 6px;text-align:right;font-weight:500">Qtd</th>
							<th style="padding:3px 6px;text-align:center;font-weight:500">A\xe7\xe3o</th>
						</tr>
					</thead>
					<tbody>${boxRowsHtml}</tbody>
				</table>
			</div>` : '<div style="font-size:0.8rem;color:#888">Nenhuma caixa encontrada para esta sa\xedda.</div>';
        return `${statsHtml}${warningBar}${tableHtml}`;
    }
    let boxCtrlBanner = '';
    if (enableBoxCtrl) boxCtrlBanner = `
			<div id="conf-box-panel" style="background:#f8fbff;border:1px solid #b3d1f5;border-radius:4px;padding:8px 10px;margin-bottom:0.75rem">
				<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:0.5rem;flex-wrap:wrap;margin-bottom:0.35rem">
					<div style="font-weight:600;font-size:0.85rem;color:#1a4a8a">Caixas de Picking</div>
					<div style="display:flex;gap:0.35rem;flex-wrap:wrap">
						<button type="button" class="button conf-btn-view-boxes" style="font-size:0.78rem;padding:2px 8px">Ver Caixas</button>
						<button type="button" class="button conf-btn-gestao-boxes" style="font-size:0.78rem;padding:2px 8px">Abrir Gest\xe3o de Caixas</button>
					</div>
				</div>
				<p style="margin:0 0 0.5rem;color:#666;font-size:0.78rem">${(0, $jU7Ru.escHtml)((0, $jU7Ru.BOX_CTRL_HINT))}</p>
				<div id="conf-box-panel-inner">${buildBoxPanelInnerHtml()}</div>
			</div>`;
    const checkpointBanner = collectorCheckpoint ? `
		<div style="background:#e8f4fd;border:1px solid #90caf9;border-radius:4px;padding:8px 10px;font-size:0.82rem;margin-bottom:0.75rem;color:#0d47a1">
			<strong>Confer\xeancia parcial do ColetorPWA</strong><br>
			Esta sa\xedda possui confer\xeancia parcial enviada pelo ColetorPWA. Os itens j\xe1 conferidos foram preservados
			e existe diverg\xeancia pendente de tratativa.
			${collectorCheckpoint.device_id ? `<br><span style="font-size:0.75rem;color:#555">Dispositivo: ${$2904a5446a687563$var$escapeHtml(collectorCheckpoint.device_id)}</span>` : ''}
			${collectorCheckpoint.operator_id ? `<span style="font-size:0.75rem;color:#555"> \xb7 Operador: ${$2904a5446a687563$var$escapeHtml(collectorCheckpoint.operator_id)}</span>` : ''}
		</div>
	` : '';
    const paramBanner = !allowPartial || requireAuth ? `
		<div style="background:#fff7e6;border:1px solid #f0c04d;border-radius:4px;padding:6px 10px;font-size:0.8rem;margin-bottom:0.75rem;display:flex;gap:0.5rem;align-items:flex-start">
			<span style="font-size:1rem">\u{26A0}</span>
			<span>
				${!allowPartial ? "<strong>Confer\xeancia parcial n\xe3o permitida</strong> para esta empresa \u2014 todas as linhas devem ser conferidas integralmente.<br>" : ''}
				${requireAuth ? "<strong>Autoriza\xe7\xe3o exigida:</strong> confer\xeancias com diverg\xeancia de quantidade precisam de um usu\xe1rio com permiss\xe3o de autoriza\xe7\xe3o." : ''}
			</span>
		</div>
	` : '';
    // #MT-F0B9878 — prefill: Coletor → suggested (status < Conferida) → weight gravado
    let confWeightValue = '';
    let confWeightTitle = "Soma autom\xe1tica dos pesos das embalagens dos itens (edit\xe1vel). Sem cadastro = 1 kg por embalagem.";
    let confWeightHintHtml = '';
    {
        const fromCollector = collectorCheckpoint?.weight;
        const sug = output.suggested_weight;
        const st = Number(output.status);
        if (fromCollector != null && fromCollector !== '') confWeightValue = $2904a5446a687563$var$escapeHtml(fromCollector);
        else if (sug != null && sug !== '' && (Number.isNaN(st) || st < 60)) confWeightValue = $2904a5446a687563$var$escapeHtml(sug);
        else if (output.weight != null && output.weight !== '') confWeightValue = $2904a5446a687563$var$escapeHtml(output.weight);
        else if (sug != null && sug !== '') confWeightValue = $2904a5446a687563$var$escapeHtml(sug);
        if (sug != null && sug !== '') {
            confWeightTitle = `Sugerido: ${$2904a5446a687563$var$escapeHtml(sug)} kg (edit\xe1vel). Sem cadastro = 1 kg por embalagem.`;
            confWeightHintHtml = `<span class="conf-hint" style="display:block;margin-top:0.25rem">Sugerido: <strong>${$2904a5446a687563$var$escapeHtml(sug)}</strong> kg</span>`;
        }
    }
    const html = `
		<style>
			.conf-modal { min-width: 740px; max-width: 98vw; max-height: 92vh; overflow-y: auto; }
			.conf-modal table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }
			.conf-modal thead th {
				background: #f0f0f0; padding: 6px 8px; text-align: left;
				position: sticky; top: 0; border-bottom: 1px solid #ddd; white-space: nowrap;
			}
			.conf-modal tbody tr:nth-child(even) td { background: #f9f9f9; }
			.conf-modal tbody tr:hover td { background: #eef4ff; }
			.conf-modal .conf-footer {
				display: flex; gap: 1rem; flex-wrap: wrap; align-items: flex-end; margin-top: 1rem;
			}
			.conf-modal .conf-footer label { display: flex; flex-direction: column; gap: 4px; font-size: 0.875rem; }
			.conf-modal .conf-footer input,
			.conf-modal .conf-footer select { padding: 3px 6px; }
			.conf-modal .conf-hint { font-size: 0.75rem; color: #888; margin-top: 6px; }
		</style>
		<div class="msgbox conf-modal">
			<div class="mb-title">Confer\xeancia de Sa\xedda</div>
			<div class="mb-text">
				<div style="display:flex;gap:2rem;flex-wrap:wrap;margin-bottom:0.75rem;font-size:0.875rem">
					<span>Sa\xedda: <strong>${$2904a5446a687563$var$escapeHtml(output.id)}</strong></span>
					<span>Pedido: <strong>${$2904a5446a687563$var$escapeHtml(output.order_id)}</strong></span>
					<span>Status: <strong>${$2904a5446a687563$var$escapeHtml(statusStr)}</strong></span>
				</div>
				${boxCtrlBanner}
				${checkpointBanner}
				${paramBanner}
				<div style="overflow-x:auto;max-height:42vh;overflow-y:auto">
					<table>
						<thead>
							<tr>
								<th style="text-align:left;width:2rem">#</th>
								<th style="text-align:left">SKU / Produto</th>
								<th style="text-align:left">Lote sep. / Validade sep.</th>
								<th style="text-align:left">Lote conferido<sup>*</sup></th>
								<th style="text-align:left">Validade conferida<sup>*</sup></th>
								<th style="text-align:right">Req.${qtyUnitLabel}</th>
								<th style="text-align:right">Conf.${qtyUnitLabel}</th>
								<th style="text-align:right">Dif.</th>
								<th style="text-align:center;white-space:nowrap">Unpicking</th>
							</tr>
						</thead>
						<tbody id="conf-items-body">
							${itemRows || '<tr><td colspan="9" style="padding:8px;color:#888">Nenhum item encontrado.</td></tr>'}
						</tbody>
					</table>
				</div>
				<p class="conf-hint">Validade: DD/MM/AAAA (ex: 30/12/2099) \u{2014} as barras s\xe3o inseridas automaticamente \xb7 Lote: sem diferenciar mai\xfasculas/min\xfasculas \xb7 Quando conferido &lt; requerido aparece o campo de motivo abaixo da linha.${qtyHintExtra}</p>
				<div class="conf-footer">
					<label>Tipo Volume<sup>*</sup>
						<select id="conf-volume-type" required>
							<option value="">(selecione)</option>
							${vtOptions}
						</select>
					</label>
				<label>Volumes<sup>*</sup>
					<input id="conf-volumes" type="number" min="1" step="1"
						value="${collectorCheckpoint?.volumes != null ? $2904a5446a687563$var$escapeHtml(collectorCheckpoint.volumes) : enableBoxCtrl ? expectedConferenceVolumes() || boxClosedCount : output.volumes != null ? $2904a5446a687563$var$escapeHtml(output.volumes) : ''}"
						style="width:6rem;text-align:right${enableBoxCtrl ? ';background:#f0f7ff;color:#333' : ''}"
						${enableBoxCtrl ? `readonly title="${packagingActive && countTertiaryVolumes() > 0 ? `Caixas lacradas (${boxClosedCount}) + volumes terci\xe1rios (${countTertiaryVolumes()})` : "Preenchido automaticamente \u2014 igual ao n\xfamero de caixas lacradas"}"` : ''}
						required>
				</label>
					<label>Peso total (kg)<sup>*</sup>
						<input id="conf-weight" type="number" min="0" step="0.001"
							value="${confWeightValue}"
							style="width:8rem;text-align:right"
							title="${confWeightTitle}"
							required>
						${confWeightHintHtml}
					</label>
				</div>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Conferir Sa\xedda</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        const node = dlg.getNode();
        // Limpar marcações de erro anteriores
        node.querySelectorAll('.conf-lot,.conf-expiry,.conf-qty,.conf-reason-select,.conf-reason-note').forEach((el)=>$2904a5446a687563$var$markError(el, false));
        const itemsPayload = [];
        let valid = true;
        // Apenas linhas principais (excluir sub-linhas de motivo)
        const rows = Array.from(node.querySelectorAll('tr[data-number]:not(.conf-div-row)'));
        for (const row of rows){
            const number = parseInt(row.dataset.number, 10);
            const lotInput = row.querySelector('.conf-lot');
            const expiryInput = row.querySelector('.conf-expiry');
            const qtyInput = row.querySelector('.conf-qty');
            const hasLot = lotInput && lotInput.dataset.hasLot === '1';
            const requiredUi = parseInt(qtyInput.dataset.required, 10);
            const packUi = qtyInput.dataset.packUi === '1';
            const factor = parseInt(qtyInput.dataset.factor, 10) || 1;
            const origItem = items.find((i)=>i.number === number);
            // ── Quantidade ─────────────────────────────────────────────────
            const rawQty = qtyInput.value.trim();
            if (rawQty === '' || isNaN(Number(rawQty))) {
                $2904a5446a687563$var$markError(qtyInput, true);
                (0, $jUNyh.notify)(`Informe a quantidade conferida para a linha ${number}.`, "Confer\xeancia de Sa\xedda");
                qtyInput.focus();
                valid = false;
                break;
            }
            const qtyUi = parseInt(rawQty, 10);
            if (qtyUi < 0) {
                $2904a5446a687563$var$markError(qtyInput, true);
                (0, $jUNyh.notify)(`Quantidade conferida n\xe3o pode ser negativa (linha ${number}).`, "Confer\xeancia de Sa\xedda");
                qtyInput.focus();
                valid = false;
                break;
            }
            if (qtyUi > requiredUi) {
                $2904a5446a687563$var$markError(qtyInput, true);
                (0, $jUNyh.notify)(packUi ? `Embalagens conferidas (${qtyUi}) excedem as requeridas (${requiredUi}) na linha ${number}.` : `Quantidade conferida (${qtyUi}) excede a requerida (${requiredUi}) na linha ${number}.`, "Confer\xeancia de Sa\xedda");
                qtyInput.focus();
                valid = false;
                break;
            }
            const qty = origItem ? uiQtyToUnits(origItem, qtyUi) : packUi ? qtyUi * factor : qtyUi;
            const requiredUnits = parseInt(qtyInput.dataset.requiredUnits, 10);
            if (!isNaN(requiredUnits) && qty > requiredUnits) {
                $2904a5446a687563$var$markError(qtyInput, true);
                (0, $jUNyh.notify)(`Quantidade em unidades (${qty}) excede a requerida (${requiredUnits}) na linha ${number}.`, "Confer\xeancia de Sa\xedda");
                qtyInput.focus();
                valid = false;
                break;
            }
            const itemEntry = {
                number: number,
                quantity_supplied: qty
            };
            // ── Lote e Validade (só para linhas com lote separado) ─────────
            if (hasLot) {
                const expectedLot = lotInput.dataset.expectedLot || '';
                const expectedExpiry = expiryInput.dataset.expectedExpiry || '';
                // Lote conferido — obrigatório
                const rawLot = lotInput.value.trim();
                if (!rawLot) {
                    $2904a5446a687563$var$markError(lotInput, true);
                    (0, $jUNyh.notify)(`Informe o lote conferido para a linha ${number}.`, "Confer\xeancia de Sa\xedda");
                    lotInput.focus();
                    valid = false;
                    break;
                }
                if ($2904a5446a687563$var$normalizeLot(rawLot) !== $2904a5446a687563$var$normalizeLot(expectedLot)) {
                    $2904a5446a687563$var$markError(lotInput, true);
                    (0, $jUNyh.notify)(`Lote conferido n\xe3o confere com o lote separado na linha ${number}.\n` + `Esperado: "${expectedLot}" \u{2014} Digitado: "${rawLot}"`, "Confer\xeancia de Sa\xedda");
                    lotInput.focus();
                    valid = false;
                    break;
                }
                // Validade conferida — obrigatória
                const rawExpiry = expiryInput.value.trim();
                if (!rawExpiry) {
                    $2904a5446a687563$var$markError(expiryInput, true);
                    (0, $jUNyh.notify)(`Informe a validade conferida para a linha ${number}.`, "Confer\xeancia de Sa\xedda");
                    expiryInput.focus();
                    valid = false;
                    break;
                }
                const parsedExpiry = $2904a5446a687563$var$parseInputDate(rawExpiry);
                if (!parsedExpiry) {
                    $2904a5446a687563$var$markError(expiryInput, true);
                    (0, $jUNyh.notify)(`Formato de validade inv\xe1lido na linha ${number}. Use DD/MM/AAAA (ex: 30/12/2099).`, "Confer\xeancia de Sa\xedda");
                    expiryInput.focus();
                    valid = false;
                    break;
                }
                if (parsedExpiry !== expectedExpiry) {
                    $2904a5446a687563$var$markError(expiryInput, true);
                    (0, $jUNyh.notify)(`Validade conferida n\xe3o confere com a validade do lote separado na linha ${number}.\n` + `Esperada: "${$2904a5446a687563$var$fmtDate(expectedExpiry)}" \u{2014} Digitada: "${$2904a5446a687563$var$fmtDate(parsedExpiry)}"`, "Confer\xeancia de Sa\xedda");
                    expiryInput.focus();
                    valid = false;
                    break;
                }
                itemEntry.lot_confirmed = rawLot;
                itemEntry.expiration_confirmed = parsedExpiry;
            }
            // ── Divergência de quantidade ───────────────────────────────────
            if (qtyUi < requiredUi) {
                // Tenant não permite parcial → bloquear no frontend (backend também bloqueia)
                if (!allowPartial) {
                    $2904a5446a687563$var$markError(qtyInput, true);
                    (0, $jUNyh.notify)(`Esta empresa n\xe3o permite confer\xeancia parcial.
` + `Linha ${number}: requerido ${requiredUi}, conferido ${qtyUi}.\n` + `Confira todas as linhas integralmente.`, "Confer\xeancia de Sa\xedda");
                    qtyInput.focus();
                    valid = false;
                    break;
                }
                // Buscar campos na sub-linha (conf-div-row) correspondente
                const divRow = node.querySelector(`.conf-div-row[data-number="${number}"]`);
                const reasonSelect = divRow?.querySelector('.conf-reason-select');
                const reasonNote = divRow?.querySelector('.conf-reason-note');
                const reasonCode = reasonSelect ? reasonSelect.value.trim() : '';
                const reasonNoteVal = reasonNote ? reasonNote.value.trim() : '';
                if (!reasonCode) {
                    $2904a5446a687563$var$markError(reasonSelect, true);
                    (0, $jUNyh.notify)(`Informe o motivo da diverg\xeancia para a linha ${number} ` + `(conferido ${qtyUi} de ${requiredUi}).`, "Confer\xeancia de Sa\xedda");
                    reasonSelect?.focus();
                    valid = false;
                    break;
                }
                if (reasonCode === 'OUTROS' && !reasonNoteVal) {
                    $2904a5446a687563$var$markError(reasonNote, true);
                    (0, $jUNyh.notify)(`A observa\xe7\xe3o \xe9 obrigat\xf3ria quando o motivo for "Outros" (linha ${number}).`, "Confer\xeancia de Sa\xedda");
                    reasonNote?.focus();
                    valid = false;
                    break;
                }
                itemEntry.reason_code = reasonCode;
                if (reasonNoteVal) itemEntry.reason_note = reasonNoteVal;
            }
            itemsPayload.push(itemEntry);
        }
        if (!valid) return;
        // ── Cabeçalho ──────────────────────────────────────────────────────
        const volumeType = node.querySelector('#conf-volume-type').value;
        const volumesRaw = node.querySelector('#conf-volumes').value.trim();
        const weightRaw = node.querySelector('#conf-weight').value.trim();
        if (!volumeType) {
            (0, $jUNyh.notify)('Selecione o tipo de volume.', "Confer\xeancia de Sa\xedda");
            node.querySelector('#conf-volume-type').focus();
            return;
        }
        const volumes = parseInt(volumesRaw, 10);
        if (!volumesRaw || isNaN(volumes) || volumes < 1) {
            (0, $jUNyh.notify)("Informe o n\xfamero de volumes (m\xednimo 1).", "Confer\xeancia de Sa\xedda");
            node.querySelector('#conf-volumes').focus();
            return;
        }
        const weight = parseFloat(weightRaw);
        if (!weightRaw || isNaN(weight) || weight < 0) {
            (0, $jUNyh.notify)('Informe o peso total dos volumes.', "Confer\xeancia de Sa\xedda");
            node.querySelector('#conf-weight').focus();
            return;
        }
        const payload = {
            items: itemsPayload,
            volume_type: volumeType,
            volumes: volumes,
            weight: weight
        };
        // ── Validações de caixas de picking (guarda defensiva antes do backend) ──
        if (enableBoxCtrl) {
            if (!pickingBoxes) {
                (0, $jUNyh.notify)("Controle de caixas ativo: n\xe3o foi poss\xedvel carregar os itens das caixas.", "Confer\xeancia de Sa\xedda");
                return;
            }
            if (needsSealedBoxesForConference() && boxClosedCount === 0) {
                (0, $jUNyh.notify)("Controle de caixas ativo: n\xe3o h\xe1 caixas lacradas para esta sa\xedda.", "Confer\xeancia de Sa\xedda");
                return;
            }
            if (boxOpenCount > 0) {
                (0, $jUNyh.notify)(`Controle de caixas ativo: lacre todas as caixas antes de concluir a confer\xeancia (${boxOpenCount} caixa(s) em aberto).`, "Confer\xeancia de Sa\xedda");
                return;
            }
            const closedWithoutItems = pickingBoxes.filter((b)=>Number(b.status) === 20 && (!Array.isArray(b.items) || b.items.length === 0));
            if (closedWithoutItems.length > 0) {
                (0, $jUNyh.notify)(`Controle de caixas ativo: ${closedWithoutItems.length} caixa(s) lacrada(s) sem itens registrados.`, "Confer\xeancia de Sa\xedda");
                return;
            }
            const expVolumes = expectedConferenceVolumes();
            if (volumes !== expVolumes) {
                const tertiaryCount = packagingActive ? countTertiaryVolumes() : 0;
                (0, $jUNyh.notify)(tertiaryCount > 0 ? `Controle de caixas ativo: volumes (${volumes}) deve ser igual a caixas lacradas (${boxClosedCount}) + terci\xe1rios (${tertiaryCount}) = ${expVolumes}.` : `Controle de caixas ativo: volumes (${volumes}) deve ser igual ao n\xfamero de caixas lacradas (${boxClosedCount}).`, "Confer\xeancia de Sa\xedda");
                return;
            }
            for (const entry of itemsPayload){
                const origItem = items.find((i)=>i.number === entry.number);
                if (origItem && !itemRequiresPickingBox(origItem)) continue;
                const boxQty = boxSumByLine[entry.number] || 0;
                if (boxQty !== entry.quantity_supplied) {
                    (0, $jUNyh.notify)(`Controle de caixas ativo: a quantidade nas caixas diverge da quantidade conferida (linha ${entry.number}: caixas=${boxQty}, conferido=${entry.quantity_supplied}).`, "Confer\xeancia de Sa\xedda");
                    return;
                }
            }
        }
        const result = await (0, $9VcS9.default).call((0, $9VcS9.default).conference_output, companyId, outputId, payload);
        if (result) {
            dlg.destroy();
            if (onSuccess) onSuccess();
            // Verificar se houve falta em alguma linha — oferecer Pedido Falta.
            // itemsPayload só tem {number, quantity_supplied, ...}; a quantity_required vem de items[].
            const enrichedItems = items.map((orig)=>{
                const supplied = itemsPayload.find((i)=>i.number === orig.number);
                return {
                    ...orig,
                    quantity_supplied: supplied?.quantity_supplied ?? orig.quantity_required
                };
            });
            const shortageDetected = enrichedItems.some((i)=>{
                const req = parseInt(i.quantity_required ?? 0, 10);
                const sup = parseInt(i.quantity_supplied ?? req, 10);
                return req - sup > 0;
            });
            if (shortageDetected && output.order_id) (0, $8656f794cefc5b7a$export$68061872c81cf454)(companyId, parseInt(outputId, 10), output.order_id, enrichedItems);
            else (0, $jUNyh.notify)(`Sa\xedda ${outputId} conferida com sucesso.`, "Confer\xeancia de Sa\xedda");
        }
    }, /Escape|N|Y/);
    // ── Listeners em tempo real ────────────────────────────────────────────
    const node = dlg.getNode();
    // Diferença em tempo real + exibição de campos de motivo/divergência
    // Quando box ctrl ativo, os inputs são readOnly e não precisam de listener
    node.querySelectorAll('.conf-qty:not([readonly])').forEach((input)=>{
        input.addEventListener('input', ()=>{
            $2904a5446a687563$var$markError(input, false);
            const number = input.dataset.number;
            const required = parseInt(input.dataset.required, 10);
            const qty = parseInt(input.value, 10);
            const diffCell = node.querySelector(`.conf-diff[data-number="${number}"]`);
            const row = input.closest('tr');
            if (!diffCell) return;
            if (isNaN(qty)) {
                diffCell.textContent = "\u2014";
                diffCell.style.color = '#888';
                if (row) $2904a5446a687563$var$toggleDivergenceFields(row, false, allowPartial);
            } else {
                const diff = qty - required;
                diffCell.textContent = diff === 0 ? "\u2713" : String(diff);
                diffCell.style.color = diff === 0 ? '#2a7' : diff < 0 ? '#c80' : '#c00';
                // Mostrar campos de motivo somente quando há divergência
                if (row) $2904a5446a687563$var$toggleDivergenceFields(row, diff < 0, allowPartial);
            }
        });
    });
    // Exibir/ocultar textarea de observação conforme motivo selecionado
    node.querySelectorAll('.conf-reason-select').forEach((sel)=>{
        sel.addEventListener('change', ()=>{
            $2904a5446a687563$var$markError(sel, false);
            const divRow = sel.closest('.conf-div-row');
            const note = divRow?.querySelector('.conf-reason-note');
            if (note) {
                note.style.display = sel.value === 'OUTROS' ? '' : 'none';
                $2904a5446a687563$var$markError(note, false);
            }
        });
    });
    // Máscara DD/MM/AAAA nos campos de validade
    node.querySelectorAll('.conf-expiry:not([disabled])').forEach((input)=>{
        input.addEventListener('input', ()=>{
            $2904a5446a687563$var$applyDateMask(input);
            $2904a5446a687563$var$markError(input, false);
        });
        input.addEventListener('keydown', (e)=>{
            // Permite: backspace, delete, tab, setas, home, end
            const allowed = [
                'Backspace',
                'Delete',
                'Tab',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ];
            if (allowed.includes(e.key)) return;
            // Bloqueia qualquer tecla que não seja dígito
            if (!/^\d$/.test(e.key)) e.preventDefault();
        });
    });
    // Limpar marcação de erro ao digitar nos campos de lote/obs
    node.querySelectorAll('.conf-lot,.conf-reason-note').forEach((input)=>{
        input.addEventListener('input', ()=>$2904a5446a687563$var$markError(input, false));
    });
    // ── Botões de unpicking por linha ──────────────────────────────────────
    node.querySelectorAll('.conf-unpick-btn').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const num = parseInt(btn.dataset.number, 10);
            const item = items.find((i)=>i.number === num);
            if (!item) return;
            (0, $0b3ff9ab82e775f7$export$da77a8bd334cda15)(companyId, outputId, item, output.status, (newRequestId)=>{
                // Atualizar a célula na linha para exibir badge REQUESTED
                const cell = btn.closest('td');
                if (cell) cell.innerHTML = `<div class="text-center" style="font-size:0.8rem">
							${(0, $0b3ff9ab82e775f7$export$1a3e75f6cb6d19fd)('REQUESTED')}
						</div>`;
                // Registrar no mapa para evitar nova solicitação na sessão
                unpickByItem[num] = {
                    status: 'REQUESTED',
                    id: newRequestId
                };
            });
        });
    });
    // ── Caixas de picking: ações auxiliares e atualização do painel ─────────
    if (enableBoxCtrl) {
        async function refreshConferenceBoxes() {
            try {
                const boxData = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId);
                pickingBoxes = boxData?.boxes || [];
            } catch (_) {
                (0, $jUNyh.notify)("N\xe3o foi poss\xedvel atualizar as caixas de picking.", "Confer\xeancia de Sa\xedda");
                return;
            }
            recomputeBoxTotals();
            const inner = node.querySelector('#conf-box-panel-inner');
            if (inner) inner.innerHTML = buildBoxPanelInnerHtml();
            const volInput = node.querySelector('#conf-volumes');
            if (volInput) volInput.value = expectedConferenceVolumes() || boxClosedCount;
            for (const row of node.querySelectorAll('tr[data-number]:not(.conf-div-row)')){
                const num = parseInt(row.dataset.number, 10);
                const origItem = items.find((i)=>i.number === num);
                const qtyInput = row.querySelector('.conf-qty');
                const diffCell = row.querySelector('.conf-diff');
                if (!qtyInput || !diffCell) continue;
                const bQtyReq = parseInt(qtyInput.dataset.required, 10) || 0;
                const requiresBox = origItem && itemRequiresPickingBox(origItem);
                const bQty = requiresBox ? boxSumByLine[num] || 0 : parseInt(origItem?.quantity_supplied ?? origItem?.quantity_required ?? 0, 10) || 0;
                if (requiresBox) qtyInput.value = bQty;
                const bDiff = bQty - bQtyReq;
                diffCell.textContent = bDiff === 0 ? "\u2713" : String(bDiff);
                diffCell.style.color = bDiff === 0 ? '#2a7' : bDiff < 0 ? '#c80' : '#c00';
                const divRow = node.querySelector(`.conf-div-row[data-number="${num}"]`);
                if (divRow) divRow.style.display = bDiff < 0 ? '' : 'none';
            }
        }
        const boxPanel = node.querySelector('#conf-box-panel');
        if (boxPanel && !boxPanel.dataset.bound) {
            boxPanel.dataset.bound = '1';
            boxPanel.addEventListener('click', (ev)=>{
                if (ev.target.closest('.conf-btn-view-boxes')) {
                    ev.preventDefault();
                    (0, $jU7Ru.openPickingBoxesForOutputModal)(companyId, outputId, refreshConferenceBoxes);
                    return;
                }
                if (ev.target.closest('.conf-btn-gestao-boxes')) {
                    ev.preventDefault();
                    location.hash = '#output-picking-boxes';
                    return;
                }
                const sealBtn = ev.target.closest('.conf-box-seal');
                if (sealBtn) {
                    ev.preventDefault();
                    const boxId = sealBtn.getAttribute('data-box-id');
                    const boxCode = sealBtn.getAttribute('data-box-code') || boxId;
                    const itemCount = parseInt(sealBtn.getAttribute('data-items') || '0', 10);
                    (0, $jU7Ru.openCloseBoxModal)(companyId, outputId, boxId, boxCode, itemCount, refreshConferenceBoxes);
                }
            });
        }
    }
}


/**
 * Modal de Detalhamento de Saída — visão rica e read-only.
 *
 * Exibe: cabeçalho, informações de conferência (conferente, data, divergências),
 * itens com indicação visual de status e, quando houver, registro estruturado
 * de divergências com motivo e observação.
 *
 * Performance:
 *  • select_output e list_output_divergences são disparados em paralelo.
 *  • checked_by_name já vem no payload (subquery em SQL_BASE_SELECT).
 *  • Labels (empresa, armazém) resolvidas via cache local do versa/db.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");

var $dx9qz = parcelRequire("dx9qz");
parcelRequire("jUNyh");
// ─── Mapeamentos ──────────────────────────────────────────────────────────────
const $2de1ab652f37f03b$var$STATUS_LABEL = {
    10: 'Criada',
    20: 'Picking',
    30: 'Separada',
    40: 'Conferindo',
    50: 'Unpick',
    60: 'Conferida',
    65: 'Faturando',
    70: 'Faturada',
    75: "Doca Expedi\xe7\xe3o",
    80: "Expedi\xe7\xe3o",
    90: 'Encerrada',
    100: 'Cancelada',
    999: "Exclu\xedda"
};
const $2de1ab652f37f03b$var$BOX_STATUS_LABEL = {
    10: 'Aberta',
    20: 'Lacrada',
    30: 'Cancelada'
};
const $2de1ab652f37f03b$var$BOX_STATUS_COLOR = {
    10: '#3b82f6',
    20: '#22c55e',
    30: '#dc2626'
};
const $2de1ab652f37f03b$var$STATUS_COLOR = {
    10: '#9ca3af',
    20: '#3b82f6',
    30: '#06b6d4',
    40: '#f97316',
    50: '#ef4444',
    60: '#22c55e',
    65: '#14b8a6',
    70: '#0ea5e9',
    75: '#8b5cf6',
    80: '#6366f1',
    90: '#6b7280',
    100: '#dc2626',
    999: '#7f1d1d'
};
const $2de1ab652f37f03b$var$DIVERGENCE_REASON_LABEL = {
    FALTA_FISICA: "Falta f\xedsica",
    AVARIA: 'Avaria',
    ERRO_PICKING: 'Erro de picking',
    QUANTIDADE_DIVERGENTE: 'Quantidade divergente',
    CORRECAO_OPERACIONAL: "Corre\xe7\xe3o operacional",
    OUTROS: 'Outros'
};
// ─── Helpers ──────────────────────────────────────────────────────────────────
function $2de1ab652f37f03b$var$esc(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $2de1ab652f37f03b$var$fmtQty(v, dec = 0) {
    if (v == null || v === '') return "\u2014";
    const n = parseFloat(v);
    return isNaN(n) ? "\u2014" : n.toLocaleString('pt-BR', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
    });
}
function $2de1ab652f37f03b$var$fmtDatetime(iso) {
    if (!iso) return "\u2014";
    try {
        const d = new Date(iso);
        const p = (n)=>String(n).padStart(2, '0');
        return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
    } catch  {
        return iso;
    }
}
function $2de1ab652f37f03b$var$fmtDate(iso) {
    if (!iso) return "\u2014";
    try {
        const [y, m, d] = iso.split('T')[0].split('-');
        return `${d}/${m}/${y}`;
    } catch  {
        return iso;
    }
}
/** Resolve label de um registro no cache IndexedDB do versa. */ async function $2de1ab652f37f03b$var$dbLabel(store, key) {
    if (!key) return null;
    try {
        const rec = await (0, $1cmSR.default).get(store, key);
        if (!rec) return null;
        // versa armazena o label no índice 2 — é o primeiro campo "label" da store
        // Para companies, o campo é 'nick'; para warehouses, é 'name'
        return rec.nick || rec.name || rec.label || null;
    } catch  {
        return null;
    }
}
// ─── CSS ──────────────────────────────────────────────────────────────────────
const $2de1ab652f37f03b$var$CSS = `<style>
.odet                    { max-width:880px; width:95vw; }
.odet-hdr                { display:flex; align-items:center; gap:.6rem; flex-wrap:wrap; margin-bottom:.8rem; }
.odet-badge-status       { border-radius:4px; color:#fff; font-size:.76rem; font-weight:700;
                           padding:.2rem .55rem; white-space:nowrap; }
.odet-hdr-id             { font-size:1.05rem; font-weight:700; }
.odet-hdr-sep            { color:#bbb; }
.odet-hdr-sub            { color:#666; font-size:.9rem; }
.odet-grid               { display:flex; flex-wrap:wrap; gap:.4rem .8rem; }
.odet-cell               { display:flex; flex-direction:column; min-width:8.5rem; }
.odet-cell.wide          { min-width:16rem; }
.odet-lbl                { font-size:.69rem; color:#999; text-transform:uppercase; letter-spacing:.05em; }
.odet-val                { font-size:.86rem; font-weight:500; color:#1a1a1a; }
.odet-divider            { border:none; border-top:1px solid #e5e7eb; margin:.75rem 0 .6rem; }
.odet-sec-title          { font-size:.72rem; font-weight:700; text-transform:uppercase;
                           letter-spacing:.07em; color:#666; margin-bottom:.45rem; }
.odet-conf-box           { background:#f0fdf4; border:1px solid #bbf7d0; border-radius:6px;
                           padding:.6rem .85rem; margin:.7rem 0; }
.odet-conf-box.has-div   { background:#fffbeb; border-color:#fde68a; }
.odet-badge-conf         { display:inline-flex; align-items:center; gap:.3rem; border-radius:4px;
                           font-size:.8rem; font-weight:600; padding:.22rem .55rem; margin-top:.4rem; }
.odet-badge-conf.ok      { background:#dcfce7; color:#15803d; }
.odet-badge-conf.warn    { background:#fef3c7; color:#92400e; }
.odet-tbl-wrap           { overflow-x:auto; margin-top:.5rem; }
.odet-tbl                { border-collapse:collapse; width:100%; font-size:.81rem; min-width:560px; }
.odet-tbl th             { background:#f3f4f6; border:1px solid #e0e0e0; padding:.28rem .48rem;
                           font-size:.7rem; text-transform:uppercase; letter-spacing:.04em;
                           white-space:nowrap; position:sticky; top:0; }
.odet-tbl td             { border:1px solid #eee; padding:.28rem .48rem; vertical-align:middle; }
.odet-tbl .r             { text-align:right; white-space:nowrap; }
.odet-tbl .c             { text-align:center; }
.odet-row-ok td          { background:#f0fdf4; }
.odet-row-partial td     { background:#fffbeb; }
.odet-row-unchecked td   { background:#fafafa; color:#aaa; }
.odet-qty-ok             { color:#15803d; font-weight:700; }
.odet-qty-partial        { color:#b45309; font-weight:700; }
.odet-div-row td         { background:#fef9ec; border-top:none !important;
                           font-size:.78rem; padding:.18rem .48rem .3rem 1.4rem; color:#555; }
.odet-div-icon           { color:#f97316; margin-right:.2rem; }
.odet-div-reason         { font-weight:600; color:#92400e; }
.odet-div-sep            { color:#d1d5db; margin:0 .22rem; }
.odet-div-note           { font-style:italic; color:#6b7280; }
.odet-div-auth           { color:#15803d; font-weight:600; font-size:.75rem;
                           background:#dcfce7; border-radius:3px; padding:.1rem .3rem; }
.odet-sub                { font-size:.74rem; color:#888; display:block; }
.odet-footer             { display:flex; justify-content:flex-end; margin-top:.9rem; }
.odet-box-badge          { display:inline-block; border-radius:3px; color:#fff; font-size:.72rem;
                           font-weight:700; padding:.15rem .4rem; white-space:nowrap; }
</style>`;
// ─── Construção de HTML ───────────────────────────────────────────────────────
function $2de1ab652f37f03b$var$buildHeader(o, companyNick, whCompNick, whNick) {
    const color = $2de1ab652f37f03b$var$STATUS_COLOR[o.status] || '#9ca3af';
    const label = $2de1ab652f37f03b$var$STATUS_LABEL[o.status] || o.status;
    const refBlock = o.reference ? `<div class="odet-cell wide"><span class="odet-lbl">Refer\xeancia</span><span class="odet-val">${$2de1ab652f37f03b$var$esc(o.reference)}</span></div>` : '';
    return `
		<div class="odet-hdr">
			<span class="odet-badge-status" style="background:${color}">${$2de1ab652f37f03b$var$esc(label)}</span>
			<span class="odet-hdr-id">Sa\xedda #${$2de1ab652f37f03b$var$esc(String(o.id))}</span>
			<span class="odet-hdr-sep">\xb7</span>
			<span class="odet-hdr-sub">Pedido #${$2de1ab652f37f03b$var$esc(String(o.order_id))}</span>
		</div>
		<div class="odet-grid">
			<div class="odet-cell"><span class="odet-lbl">Empresa</span><span class="odet-val">${$2de1ab652f37f03b$var$esc(companyNick || o.company_id)}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Remetente</span><span class="odet-val">${$2de1ab652f37f03b$var$esc(whCompNick || o.warehouse_company_id || "\u2014")}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Armaz\xe9m</span><span class="odet-val">${$2de1ab652f37f03b$var$esc(whNick || o.warehouse_id || "\u2014")}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Tipo Vol.</span><span class="odet-val">${$2de1ab652f37f03b$var$esc(o.volume_type || "\u2014")}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Volumes</span><span class="odet-val">${o.volumes != null ? $2de1ab652f37f03b$var$esc(String(o.volumes)) : "\u2014"}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Peso (kg)</span><span class="odet-val">${$2de1ab652f37f03b$var$fmtQty(o.weight, 3)}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Cria\xe7\xe3o</span><span class="odet-val">${$2de1ab652f37f03b$var$fmtDatetime(o.created_on)}</span></div>
			<div class="odet-cell"><span class="odet-lbl">Expedi\xe7\xe3o</span><span class="odet-val">${$2de1ab652f37f03b$var$fmtDatetime(o.expedited_on)}</span></div>
			${refBlock}
			${o.total_price != null ? `<div class="odet-cell"><span class="odet-lbl">Pre\xe7o total</span><span class="odet-val">R$ ${$2de1ab652f37f03b$var$fmtQty(o.total_price, 2)}</span></div>` : ''}
		</div>`;
}
function $2de1ab652f37f03b$var$buildConferenceBox(o, divs) {
    if (!o.checked_at) return '';
    const hasDivs = divs && divs.length > 0;
    const confName = o.checked_by_name || o.checked_by || "\u2014";
    const badge = hasDivs ? `<span class="odet-badge-conf warn">\u{26A0} ${divs.length} diverg\xeancia${divs.length > 1 ? 's' : ''} de quantidade</span>` : `<span class="odet-badge-conf ok">\u{2713} Conferida sem diverg\xeancias de quantidade</span>`;
    return `
		<div class="odet-conf-box${hasDivs ? ' has-div' : ''}">
			<div class="odet-sec-title">Confer\xeancia</div>
			<div class="odet-grid">
				<div class="odet-cell"><span class="odet-lbl">Conferida por</span><span class="odet-val">${$2de1ab652f37f03b$var$esc(confName)}</span></div>
				<div class="odet-cell"><span class="odet-lbl">Conferida em</span><span class="odet-val">${$2de1ab652f37f03b$var$fmtDatetime(o.checked_at)}</span></div>
			</div>
			${badge}
		</div>`;
}
function $2de1ab652f37f03b$var$buildItems(items, divs) {
    if (!items || items.length === 0) return `<p style="color:#aaa;font-style:italic;margin:.5rem 0">Nenhum item encontrado.</p>`;
    const divMap = {};
    if (divs) divs.forEach((d)=>{
        divMap[d.output_item_number] = d;
    });
    const rows = items.map((item)=>{
        const req = parseFloat(item.quantity_required);
        const sup = item.quantity_supplied != null ? parseFloat(item.quantity_supplied) : null;
        const hasConf = sup !== null;
        const isDivergent = hasConf && sup < req;
        const rowCls = !hasConf ? 'odet-row-unchecked' : isDivergent ? 'odet-row-partial' : 'odet-row-ok';
        let supCell, diffCell;
        if (!hasConf) {
            supCell = `<td class="r" title="N\xe3o conferido">\u{2014}</td>`;
            diffCell = `<td class="r">\u{2014}</td>`;
        } else {
            const diff = sup - req;
            const qCls = isDivergent ? 'odet-qty-partial' : 'odet-qty-ok';
            supCell = `<td class="r ${qCls}" title="Fornecido">${$2de1ab652f37f03b$var$fmtQty(sup)}</td>`;
            diffCell = diff === 0 ? `<td class="r odet-qty-ok">0</td>` : `<td class="r ${qCls}">${diff > 0 ? '+' : ''}${$2de1ab652f37f03b$var$fmtQty(diff)}</td>`;
        }
        const main = `
			<tr class="${rowCls}">
				<td class="c">${$2de1ab652f37f03b$var$esc(String(item.number))}</td>
				<td>${item.product_sku ? `<span style="font-weight:600">${$2de1ab652f37f03b$var$esc(item.product_sku)}</span>` : ''}
					${item.product_name ? `<span class="odet-sub">${$2de1ab652f37f03b$var$esc(item.product_name)}</span>` : ''}</td>
				<td>${$2de1ab652f37f03b$var$esc(item.lot_number || item.lot_id || "\u2014")}</td>
				<td class="c">${$2de1ab652f37f03b$var$fmtDate(item.expiration_date)}</td>
				<td class="r">${$2de1ab652f37f03b$var$fmtQty(req)}</td>
				${supCell}
				${diffCell}
				<td>${$2de1ab652f37f03b$var$esc(item.location_code || item.location_id || "\u2014")}</td>
			</tr>`;
        const div = divMap[item.number];
        if (!div) return main;
        const reasonLabel = $2de1ab652f37f03b$var$DIVERGENCE_REASON_LABEL[div.reason_code] || div.reason_code;
        const authBadge = div.authorized_by ? `<span class="odet-div-sep">\xb7</span><span class="odet-div-auth">\u{2713} Autorizado</span>` : '';
        const noteBlock = div.reason_note ? `<span class="odet-div-sep">\xb7</span><span class="odet-div-note">${$2de1ab652f37f03b$var$esc(div.reason_note)}</span>` : '';
        const sub = `
			<tr class="odet-div-row">
				<td></td>
				<td colspan="7">
					<span class="odet-div-icon">\u{21B3}</span>
					<span class="odet-div-reason">${$2de1ab652f37f03b$var$esc(reasonLabel)}</span>
					${noteBlock}${authBadge}
				</td>
			</tr>`;
        return main + sub;
    });
    return `
		<hr class="odet-divider">
		<div class="odet-sec-title">Itens (${items.length})</div>
		<div class="odet-tbl-wrap">
			<table class="odet-tbl">
				<thead>
					<tr>
						<th class="c">#</th>
						<th>SKU / Produto</th>
						<th>Lote</th>
						<th class="c">Validade</th>
						<th class="r" title="Quantidade requerida">Qt Req</th>
						<th class="r" title="Quantidade conferida / fornecida">Qt Conf</th>
						<th class="r" title="Diferen\xe7a (Conf \u{2212} Req)">Dif</th>
						<th>Posi\xe7\xe3o</th>
					</tr>
				</thead>
				<tbody>${rows.join('')}</tbody>
			</table>
		</div>`;
}
function $2de1ab652f37f03b$var$buildPickingBoxes(boxes) {
    if (!boxes || boxes.length === 0) return '';
    const rows = boxes.map((b)=>{
        const st = Number(b.status);
        const color = $2de1ab652f37f03b$var$BOX_STATUS_COLOR[st] || '#9ca3af';
        const label = $2de1ab652f37f03b$var$BOX_STATUS_LABEL[st] || st;
        return `
			<tr>
				<td>${$2de1ab652f37f03b$var$esc(b.code || "\u2014")}</td>
				<td>${$2de1ab652f37f03b$var$esc(b.seal_code || "\u2014")}</td>
				<td class="c"><span class="odet-box-badge" style="background:${color}">${$2de1ab652f37f03b$var$esc(label)}</span></td>
				<td>${$2de1ab652f37f03b$var$esc(b.opened_by_username || b.opened_by || "\u2014")}</td>
				<td class="c">${$2de1ab652f37f03b$var$fmtDatetime(b.opened_at)}</td>
				<td>${$2de1ab652f37f03b$var$esc(b.closed_by_username || b.closed_by || "\u2014")}</td>
				<td class="c">${$2de1ab652f37f03b$var$fmtDatetime(b.closed_at)}</td>
				<td class="c">${b.total_items ?? "\u2014"}</td>
				<td class="r">${b.total_quantity ?? "\u2014"}</td>
			</tr>`;
    }).join('');
    return `
		<hr class="odet-divider">
		<div class="odet-sec-title">Caixas de Picking (${boxes.length})</div>
		<div class="odet-tbl-wrap">
			<table class="odet-tbl">
				<thead>
					<tr>
						<th>N\xba Caixa</th>
						<th>N\xba Lacre</th>
						<th class="c">Status</th>
						<th>Aberta por</th>
						<th class="c">Aberta em</th>
						<th>Lacrada por</th>
						<th class="c">Lacrada em</th>
						<th class="c">Itens</th>
						<th class="r">Qtd. Total</th>
					</tr>
				</thead>
				<tbody>${rows}</tbody>
			</table>
		</div>`;
}
async function $2de1ab652f37f03b$export$2e2bcd8739ae039(companyId, outputId) {
    // Carrega output, divergências e caixas em paralelo
    const [output, divergences, boxesResp] = await Promise.all([
        (0, $9VcS9.default).call((0, $9VcS9.default).select_output, companyId, outputId),
        (0, $9VcS9.default).call((0, $9VcS9.default).list_output_divergences, companyId, outputId),
        (0, $9VcS9.default).list_output_picking_boxes(companyId, outputId).then((r)=>r.json()).catch(()=>null)
    ]);
    if (!output) return;
    const divs = Array.isArray(divergences) ? divergences : [];
    const boxes = boxesResp?.boxes || (Array.isArray(boxesResp) ? boxesResp : []);
    // Resolve labels do cache local (IndexedDB do versa) — não dispara requests extras
    const [companyNick, whCompNick, whNick] = await Promise.all([
        $2de1ab652f37f03b$var$dbLabel('companies', output.company_id),
        $2de1ab652f37f03b$var$dbLabel('companies', output.warehouse_company_id),
        $2de1ab652f37f03b$var$dbLabel('warehouses', [
            output.warehouse_company_id,
            output.warehouse_id
        ])
    ]);
    const html = `
		${$2de1ab652f37f03b$var$CSS}
		<div class="msgbox odet">
			<div class="mb-title">Detalhamento \u{2014} Sa\xedda #${$2de1ab652f37f03b$var$esc(String(outputId))}</div>
			<div class="mb-text">
				${$2de1ab652f37f03b$var$buildHeader(output, companyNick, whCompNick, whNick)}
				${$2de1ab652f37f03b$var$buildConferenceBox(output, divs)}
				${$2de1ab652f37f03b$var$buildItems(output.items, divs)}
				${$2de1ab652f37f03b$var$buildPickingBoxes(boxes)}
				<div class="odet-footer">
					<button class="button bn_N">Fechar</button>
				</div>
			</div>
		</div>`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') dlg.destroy();
    }, /Escape|N/);
}



/**
 * Modal de Gerenciamento de Solicitações de Unpicking (Fase 4)
 *
 * Lista todas as solicitações de unpicking de uma saída.
 * Usuários autorizados podem aprovar ou rejeitar solicitações REQUESTED.
 *
 * Uso:
 *   import { openUnpickRequestsModal } from './outputs-unpick-requests.js';
 *   openUnpickRequestsModal(companyId, outputId);
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");

const $f14ab0cf2acf9706$var$HOST = (0, $9VcS9.default).HOST;
function $f14ab0cf2acf9706$var$escapeHtml(value) {
    if (value == null) return '';
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
/**
 * Formata uma data ISO para exibição amigável.
 * @param {string|null} iso
 */ function $f14ab0cf2acf9706$var$fmtDate(iso) {
    if (!iso) return "\u2014";
    try {
        return new Date(iso).toLocaleString('pt-BR');
    } catch  {
        return iso;
    }
}
/**
 * Renderiza o badge de status da solicitação.
 * @param {string} status
 */ function $f14ab0cf2acf9706$var$statusBadge(status) {
    const colors = {
        REQUESTED: '#e6a817',
        APPROVED: '#2a7a3b',
        REJECTED: '#c0392b',
        CANCELED: '#888',
        EXECUTED: '#0e7490'
    };
    const info = (0, $0b3ff9ab82e775f7$export$94e183fb4cd5e8a3)[status] || {
        label: status
    };
    const color = colors[status] || '#888';
    return `<span style="display:inline-block;background:${color};color:#fff;border-radius:3px;padding:1px 7px;font-size:0.78rem;font-weight:600">${$f14ab0cf2acf9706$var$escapeHtml(info.label || status)}</span>`;
}
/**
 * Modal de confirmação de aprovação ou rejeição.
 */ function $f14ab0cf2acf9706$var$openActionModal(companyId, outputId, req, action, onDone) {
    const isApprove = action === 'approve';
    const title = isApprove ? "Aprovar Solicita\xe7\xe3o" : "Rejeitar Solicita\xe7\xe3o";
    const btnLabel = isApprove ? "Confirmar Aprova\xe7\xe3o" : "Confirmar Rejei\xe7\xe3o";
    const noteLabel = isApprove ? "Nota de aprova\xe7\xe3o (opcional)" : "Motivo da rejei\xe7\xe3o (opcional)";
    const noteId = 'unpick-action-note';
    const btnColor = isApprove ? '#2a7a3b' : '#c0392b';
    const html = `
		<div class="msgbox" style="min-width:420px;max-width:90vw">
			<div class="mb-title">${$f14ab0cf2acf9706$var$escapeHtml(title)}</div>
			<div class="mb-text">
				<p style="margin-bottom:0.75rem;font-size:0.9rem">
					<strong>Linha:</strong> ${$f14ab0cf2acf9706$var$escapeHtml(req.output_item_number)} &nbsp;
					<strong>Qtd:</strong> ${$f14ab0cf2acf9706$var$escapeHtml(req.quantity)} &nbsp;
					<strong>Motivo:</strong> ${$f14ab0cf2acf9706$var$escapeHtml((0, $0b3ff9ab82e775f7$export$4090a335a9da2d6)[req.reason_code] || req.reason_code)}
					${req.reason_note ? `<br><span style="color:#888;font-style:italic;font-size:0.82rem">${$f14ab0cf2acf9706$var$escapeHtml(req.reason_note)}</span>` : ''}
				</p>
				<label style="display:flex;flex-direction:column;gap:4px;font-size:0.875rem">
					${$f14ab0cf2acf9706$var$escapeHtml(noteLabel)}
					<textarea id="${noteId}" rows="2"
						style="padding:4px 6px;font-size:0.875rem;resize:vertical;min-height:2.5rem"
						placeholder="Deixe em branco se n\xe3o houver observa\xe7\xe3o"></textarea>
				</label>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y" style="background:${btnColor};color:#fff;border-color:${btnColor}">${$f14ab0cf2acf9706$var$escapeHtml(btnLabel)}</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key !== 'Y') return;
        const node = dlg.getNode();
        const note = node.querySelector(`#${noteId}`).value.trim();
        const confirmEl = node.querySelector('.bn_Y');
        confirmEl.disabled = true;
        confirmEl.textContent = "Aguarde\u2026";
        const payload = isApprove ? {
            request_id: req.id,
            approval_note: note || undefined
        } : {
            request_id: req.id,
            rejection_note: note || undefined
        };
        const apiFn = isApprove ? (0, $9VcS9.default).approve_output_unpick : (0, $9VcS9.default).reject_output_unpick;
        const result = await (0, $9VcS9.default).call(apiFn, companyId, outputId, payload);
        if (!result) {
            confirmEl.disabled = false;
            confirmEl.textContent = btnLabel;
            return;
        }
        dlg.destroy();
        (0, $jUNyh.notify)(isApprove ? "Solicita\xe7\xe3o aprovada com sucesso." : "Solicita\xe7\xe3o rejeitada.", isApprove ? 'Unpicking' : 'Unpicking');
        if (typeof onDone === 'function') onDone();
    }, /Escape|N|Y/);
}
async function $f14ab0cf2acf9706$export$2bae321498b90267(companyId, outputId) {
    const html = `
		<div class="msgbox" style="min-width:700px;max-width:96vw;max-height:90vh;overflow-y:auto">
			<div class="mb-title">Solicita\xe7\xf5es de Unpicking \u{2014} Sa\xedda #${$f14ab0cf2acf9706$var$escapeHtml(outputId)}</div>
			<div class="mb-text" style="overflow-x:auto">
				<div id="unpick-requests-list">
					<p style="color:#888;margin:0.5rem 0">Carregando\u{2026}</p>
				</div>
			</div>
			<button type="button" class="button mtl bn_N">Fechar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') dlg.destroy();
    }, /Escape|N/);
    const node = dlg.getNode();
    const listContainer = node.querySelector('#unpick-requests-list');
    async function renderList() {
        listContainer.innerHTML = '<p style="color:#888;margin:0.5rem 0">Carregando\u2026</p>';
        let rows;
        try {
            const resp = await fetch(`${$f14ab0cf2acf9706$var$HOST}/companies/${companyId}/outputs/${outputId}/unpick-requests`, {
                method: 'GET',
                credentials: 'include'
            });
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
            rows = await resp.json();
        } catch (err) {
            listContainer.innerHTML = `<p style="color:#c0392b">Erro ao carregar solicita\xe7\xf5es: ${$f14ab0cf2acf9706$var$escapeHtml(err.message)}</p>`;
            return;
        }
        if (!rows || rows.length === 0) {
            listContainer.innerHTML = '<p style="color:#888;margin:0.5rem 0">Nenhuma solicita\xe7\xe3o de unpicking registrada para esta sa\xedda.</p>';
            return;
        }
        const rowsHtml = rows.map((r, idx)=>{
            const canAct = r.status === 'REQUESTED';
            const approveBtn = canAct ? `<button class="button unpick-approve-btn" data-idx="${idx}"
					style="font-size:0.78rem;padding:2px 8px;background:#2a7a3b;color:#fff;border-color:#2a7a3b;margin-right:4px">Aprovar</button>` : '';
            const rejectBtn = canAct ? `<button class="button unpick-reject-btn" data-idx="${idx}"
					style="font-size:0.78rem;padding:2px 8px;background:#c0392b;color:#fff;border-color:#c0392b">Rejeitar</button>` : '';
            // reason_note = observação do solicitante → exibe sob o motivo
            const reasonNote = r.reason_note ? `<div style="color:#888;font-style:italic;font-size:0.78rem;margin-top:2px">${$f14ab0cf2acf9706$var$escapeHtml(r.reason_note)}</div>` : '';
            // approval_note / rejection_note → exibe sob o status
            const statusNote = r.approval_note || r.rejection_note ? `<div style="color:#888;font-size:0.78rem;margin-top:2px">${$f14ab0cf2acf9706$var$escapeHtml(r.approval_note || r.rejection_note)}</div>` : '';
            return `
				<tr>
					<td style="padding:6px 10px;text-align:center;white-space:nowrap;vertical-align:middle">${$f14ab0cf2acf9706$var$escapeHtml(r.output_item_number)}</td>
					<td style="padding:6px 10px;text-align:right;white-space:nowrap;vertical-align:middle">${$f14ab0cf2acf9706$var$escapeHtml(r.quantity)}</td>
					<td style="padding:6px 10px;vertical-align:middle">
						${$f14ab0cf2acf9706$var$escapeHtml((0, $0b3ff9ab82e775f7$export$4090a335a9da2d6)[r.reason_code] || r.reason_code)}
						${reasonNote}
					</td>
					<td style="padding:6px 10px;vertical-align:middle;white-space:nowrap">
						${$f14ab0cf2acf9706$var$statusBadge(r.status)}
						${statusNote}
					</td>
					<td style="padding:6px 10px;color:#888;font-size:0.8rem;white-space:nowrap;vertical-align:middle">${$f14ab0cf2acf9706$var$escapeHtml($f14ab0cf2acf9706$var$fmtDate(r.requested_at))}</td>
					<td style="padding:6px 10px;text-align:right;white-space:nowrap;vertical-align:middle">${approveBtn}${rejectBtn}</td>
				</tr>
			`;
        }).join('');
        listContainer.innerHTML = `
			<table style="width:100%;border-collapse:collapse;font-size:0.875rem">
				<thead>
					<tr style="background:#f0f0f0">
						<th style="padding:6px 10px;text-align:center;white-space:nowrap;border-bottom:1px solid #ddd">Linha</th>
						<th style="padding:6px 10px;text-align:right;white-space:nowrap;border-bottom:1px solid #ddd">Qtd</th>
						<th style="padding:6px 10px;text-align:left;border-bottom:1px solid #ddd">Motivo / Observa\xe7\xe3o</th>
						<th style="padding:6px 10px;text-align:left;border-bottom:1px solid #ddd">Status</th>
						<th style="padding:6px 10px;text-align:left;white-space:nowrap;border-bottom:1px solid #ddd">Solicitado em</th>
						<th style="padding:6px 10px;border-bottom:1px solid #ddd"></th>
					</tr>
				</thead>
				<tbody>
					${rowsHtml}
				</tbody>
			</table>
		`;
        listContainer.querySelectorAll('.unpick-approve-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const r = rows[parseInt(btn.dataset.idx, 10)];
                $f14ab0cf2acf9706$var$openActionModal(companyId, outputId, r, 'approve', renderList);
            });
        });
        listContainer.querySelectorAll('.unpick-reject-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const r = rows[parseInt(btn.dataset.idx, 10)];
                $f14ab0cf2acf9706$var$openActionModal(companyId, outputId, r, 'reject', renderList);
            });
        });
    }
    renderList();
}



var $jU7Ru = parcelRequire("jU7Ru");
/**
 * Modal de Picking (Separação) via SIAL Web — Opção 2 (sistema).
 *
 * Com controle de caixas: operador pode registrar itens na caixa atual, lacrar,
 * abrir outra caixa e continuar no mesmo modal (persistência incremental).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $dx9qz = parcelRequire("dx9qz");

var $jUNyh = parcelRequire("jUNyh");

var $jU7Ru = parcelRequire("jU7Ru");
/** Rótulos de status da saída. */ const $54eda3acee877046$var$STATUS_LABEL = {
    10: 'Criada',
    20: 'Separando',
    30: 'Separada',
    40: 'Conferindo',
    50: 'Unpick',
    60: 'Conferida',
    65: 'Faturando',
    70: 'Faturada',
    75: "Doca Expedi\xe7\xe3o",
    80: "Expedi\xe7\xe3o",
    90: 'Encerrada',
    100: 'Cancelada'
};
/** Status da saída que permitem separação web. */ const $54eda3acee877046$var$ALLOWED_STATUS = new Set([
    10,
    20,
    30,
    40,
    50
]);
async function $54eda3acee877046$export$2e2bcd8739ae039(companyId, outputId, onSuccess) {
    let output, companyRaw, boxes;
    try {
        [output, companyRaw] = await Promise.all([
            (0, $9VcS9.default).call((0, $9VcS9.default).select_output, companyId, outputId),
            (0, $9VcS9.default).call((0, $9VcS9.default).select_company, companyId)
        ]);
    } catch (e) {
        (0, $jUNyh.notify)(e?.message || "Erro ao carregar dados da sa\xedda.", 'Picking');
        return;
    }
    if (!output) {
        (0, $jUNyh.notify)(`Sa\xedda ${outputId} n\xe3o encontrada.`, 'Picking');
        return;
    }
    if (!$54eda3acee877046$var$ALLOWED_STATUS.has(output.status)) {
        (0, $jUNyh.notify)(output.status >= 60 ? `Sa\xedda ${outputId} j\xe1 conferida (status ${output.status} \u{2014} ${$54eda3acee877046$var$STATUS_LABEL[output.status] || output.status}). Separa\xe7\xe3o n\xe3o permitida.` : `Status ${output.status} (${$54eda3acee877046$var$STATUS_LABEL[output.status] || '?'}) n\xe3o permite separa\xe7\xe3o web.`, 'Picking');
        return;
    }
    const enableBoxCtrl = companyRaw?.out_enable_box_control === true;
    if (enableBoxCtrl) try {
        const boxData = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId);
        boxes = boxData?.boxes || [];
    } catch (_) {
        boxes = [];
    }
    let items = output.items || [];
    let selectedBoxId = null;
    function openBoxes() {
        return (boxes || []).filter((b)=>Number(b.status) === 10);
    }
    function getSelectedBoxId() {
        return selectedBoxId;
    }
    function getSelectedBox() {
        const id = getSelectedBoxId();
        if (!id) return null;
        return (boxes || []).find((b)=>String(b.id) === String(id)) || null;
    }
    async function reloadBoxes() {
        const boxData = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_picking_boxes, companyId, outputId);
        boxes = boxData?.boxes || [];
    }
    function buildRowsHtml() {
        if (!items.length) return `<tr><td colspan="8" style="padding:1rem;text-align:center;color:#888">Esta sa\xedda n\xe3o possui itens.</td></tr>`;
        return items.map((item)=>{
            const num = Number(item.number);
            const sku = item.product_sku ? String(item.product_sku).trim() : '';
            const name = item.product_name ? String(item.product_name).trim() : `Produto #${item.product_id}`;
            const lot = item.lot_number ? String(item.lot_number).trim() : "\u2014";
            const location = item.location_code ? String(item.location_code).trim() : "\u2014";
            const required = Number(item.quantity_required) || 0;
            const supplied = Number(item.quantity_supplied) || 0;
            const pending = Math.max(0, required - supplied);
            const isTertiary = !!item.is_tertiary_volume;
            const tertiaryBadge = isTertiary ? `<span style="display:inline-block;font-size:0.7rem;background:#ddf;color:#449;border-radius:2px;padding:1px 4px;margin-left:4px">sem caixa</span>` : '';
            const boxHint = enableBoxCtrl && isTertiary ? `<div style="font-size:0.7rem;color:#888;margin-top:2px">N\xe3o entra em caixa \u{2014} informe em Separar agora e clique Salvar.</div>` : '';
            const inputDisabled = pending <= 0;
            return `
				<tr data-num="${num}" style="${inputDisabled ? 'opacity:0.6' : ''}">
					<td style="padding:5px 7px;color:#888;font-size:0.82rem;white-space:nowrap;vertical-align:middle">${num}</td>
					<td style="padding:5px 7px;font-size:0.8rem;white-space:nowrap;vertical-align:middle">${(0, $jU7Ru.escHtml)(location)}</td>
					<td style="padding:5px 7px;min-width:160px;vertical-align:middle">
						<div style="font-size:0.7rem;color:#666">${(0, $jU7Ru.escHtml)(sku)}</div>
						<div style="font-size:0.84rem">${(0, $jU7Ru.escHtml)(name)}${tertiaryBadge}</div>
						${boxHint}
					</td>
					<td style="padding:5px 7px;white-space:nowrap;font-size:0.82rem;vertical-align:middle">${(0, $jU7Ru.escHtml)(lot)}</td>
					<td style="padding:5px 7px;text-align:right;font-weight:500;vertical-align:middle">${required}</td>
					<td style="padding:5px 7px;text-align:right;color:#555;vertical-align:middle" class="pick-col-supplied">${supplied}</td>
					<td style="padding:5px 7px;text-align:right;color:${pending > 0 ? '#c80' : '#2a7'};font-weight:500;vertical-align:middle" class="pick-col-pending">${pending}</td>
					<td style="padding:5px 7px;vertical-align:middle">
						<input type="number"
							class="pick-qty-input"
							data-num="${num}"
							data-pending="${pending}"
							data-supplied="${supplied}"
							data-required="${required}"
							data-is-tertiary="${isTertiary ? '1' : '0'}"
							min="0" max="${pending}" step="1" value="0"
							${inputDisabled ? 'disabled' : ''}
							style="width:5rem;text-align:right;padding:2px 5px;${inputDisabled ? 'background:#f5f5f5' : ''}">
					</td>
				</tr>`;
        }).join('');
    }
    function buildBoxPanelHtml() {
        if (!enableBoxCtrl) return '';
        const openList = openBoxes();
        const boxOpts = openList.map((b)=>`<option value="${(0, $jU7Ru.escHtml)(b.id)}"${String(b.id) === String(selectedBoxId) ? ' selected' : ''}>${(0, $jU7Ru.escHtml)(b.code)}</option>`).join('');
        if (!selectedBoxId && openList.length === 1) selectedBoxId = String(openList[0].id);
        const summaryRows = (boxes || []).length ? (boxes || []).map((box)=>{
            const st = Number(box.status);
            const label = (0, $jU7Ru.STATUS_BOX_LABEL)[st] || st;
            const style = (0, $jU7Ru.STATUS_BOX_STYLE)[st] || '';
            const itemCount = box.items?.length || 0;
            const qtyTotal = box.items?.reduce?.((s, i)=>s + (Number(i.quantity) || 0), 0) || 0;
            return `<tr>
					<td style="padding:3px 6px">${(0, $jU7Ru.escHtml)(box.code)}</td>
					<td style="padding:3px 6px"><span style="display:inline-block;padding:1px 6px;border-radius:3px;font-size:0.78em;${style}">${label}</span></td>
					<td style="padding:3px 6px;text-align:right">${itemCount}</td>
					<td style="padding:3px 6px;text-align:right">${qtyTotal}</td>
				</tr>`;
        }).join('') : `<tr><td colspan="4" style="padding:6px;color:#888;font-style:italic">Nenhuma caixa nesta sa\xedda.</td></tr>`;
        const selId = selectedBoxId || '';
        return `
			<div id="pick-box-panel" style="margin-top:1rem;padding:0.75rem;background:#f0f4ff;border:1px solid #c0cff0;border-radius:4px">
				<div style="font-weight:600;font-size:0.88rem;margin-bottom:0.5rem">Caixas de Picking</div>
				<p style="margin:0 0 0.5rem;font-size:0.78rem;color:#668">
					Fluxo: informe as quantidades \u{2192} <strong>Registrar nesta caixa</strong> \u{2192} <strong>Lacrar</strong> quando encher \u{2192} <strong>Abrir nova caixa</strong> e continue.
					Itens marcados <strong>sem caixa</strong> usam <strong>Separar agora</strong> e o bot\xe3o <strong>Salvar</strong>.
					Quando tudo j\xe1 estiver registrado nas caixas, clique <strong>Salvar</strong> para concluir.
				</p>
				<div style="display:flex;align-items:flex-end;gap:0.5rem;flex-wrap:wrap;margin-bottom:0.5rem">
					<label style="font-size:0.87rem">
						Caixa ativa:
						<select id="pick-box-select" style="margin-left:4px;padding:3px 6px;min-width:8rem">
							<option value="">\u{2014} selecione \u{2014}</option>
							${boxOpts}
						</select>
					</label>
					<label style="font-size:0.87rem">
						N\xba lacre (opcional):
						<input id="pick-box-seal-input" type="text" maxlength="40"
							style="display:block;margin-top:2px;padding:3px 6px;min-width:9rem;box-sizing:border-box"
							placeholder="Lacre da caixa" autocomplete="off">
					</label>
					<button type="button" id="pick-box-register-btn" class="button" style="padding:4px 10px;font-size:0.82rem">Registrar nesta caixa</button>
					<button type="button" id="pick-box-seal-btn" class="button" style="padding:4px 10px;font-size:0.82rem">Lacrar caixa atual</button>
					<button type="button" id="pick-box-new-btn" class="button" style="padding:4px 10px;font-size:0.82rem">Abrir nova caixa</button>
				</div>
				<div style="overflow-x:auto;max-height:120px;overflow-y:auto">
					<table style="width:100%;border-collapse:collapse;font-size:0.8em">
						<thead>
							<tr style="background:#e8eeff">
								<th style="padding:3px 6px;text-align:left">Caixa</th>
								<th style="padding:3px 6px;text-align:left">Status</th>
								<th style="padding:3px 6px;text-align:right">Itens</th>
								<th style="padding:3px 6px;text-align:right">Qtd.</th>
							</tr>
						</thead>
						<tbody id="pick-box-summary-body">${summaryRows}</tbody>
					</table>
				</div>
			</div>`;
    }
    function refreshTable(node) {
        const tbody = node.querySelector('#pick-items-table tbody');
        if (tbody) tbody.innerHTML = buildRowsHtml();
    }
    function refreshBoxPanel(node) {
        const panel = node.querySelector('#pick-box-panel');
        if (!panel || !enableBoxCtrl) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = buildBoxPanelHtml();
        const newPanel = tmp.firstElementChild;
        if (newPanel) {
            panel.replaceWith(newPanel);
            bindBoxPanelEvents(node);
        }
    }
    function collectEntries(node) {
        const inputs = Array.from(node.querySelectorAll('.pick-qty-input:not([disabled])'));
        const entries = [];
        for (const inp of inputs){
            const raw = inp.value.trim();
            if (!raw || raw === '0') continue;
            const qty = parseInt(raw, 10);
            if (isNaN(qty) || qty <= 0) continue;
            const num = parseInt(inp.dataset.num, 10);
            const pending = parseInt(inp.dataset.pending, 10);
            if (qty > pending) return {
                error: `Linha ${num}: quantidade ${qty} ultrapassa o pendente (${pending}).`,
                inp: inp
            };
            const supplied = parseInt(inp.dataset.supplied, 10);
            const required = parseInt(inp.dataset.required, 10);
            entries.push({
                num: num,
                qty: qty,
                newSupplied: supplied + qty,
                required: required,
                isTertiary: inp.dataset.isTertiary === '1'
            });
        }
        return {
            entries: entries
        };
    }
    function applySuppliedLocally(entries) {
        for (const e of entries){
            const item = items.find((i)=>Number(i.number) === e.num);
            if (item) item.quantity_supplied = e.newSupplied;
        }
        if (output.status === 10) output.status = 20;
    }
    function clearPickInputs(node) {
        for (const inp of node.querySelectorAll('.pick-qty-input:not([disabled])'))inp.value = '0';
    }
    function getPickBoxSealCode(node) {
        return node?.querySelector('#pick-box-seal-input')?.value?.trim() || null;
    }
    function clearPickBoxSealInput(node) {
        const sealInp = node?.querySelector('#pick-box-seal-input');
        if (sealInp) sealInp.value = '';
    }
    async function sealCurrentBox(node, boxId) {
        const box = getSelectedBox();
        const itemCount = box?.items?.length || 0;
        if (itemCount === 0) {
            (0, $jUNyh.notify)("A caixa n\xe3o possui itens \u2014 n\xe3o \xe9 poss\xedvel lacrar.", 'Lacrar Caixa');
            return false;
        }
        const sealRes = await (0, $9VcS9.default).call((0, $9VcS9.default).close_output_picking_box, companyId, outputId, boxId, {
            seal_code: getPickBoxSealCode(node)
        });
        if (sealRes?.error) {
            (0, $jUNyh.notify)(sealRes.error, 'Erro ao lacrar');
            return false;
        }
        selectedBoxId = null;
        clearPickBoxSealInput(node);
        (0, $jUNyh.notify)(`Caixa "${(0, $jU7Ru.escHtml)(box?.code || '')}" lacrada. Pode abrir outra caixa e continuar.`, 'Caixa Lacrada');
        return true;
    }
    async function patchOutputSupplied(entries) {
        const itemsUpdated = items.map((item)=>{
            const entry = entries.find((e)=>e.num === Number(item.number));
            return {
                number: item.number,
                location_id: item.location_id,
                warehouse_id: item.warehouse_id,
                product_id: item.product_id,
                lot_id: item.lot_id,
                quantity_required: item.quantity_required,
                quantity_supplied: entry ? entry.newSupplied : item.quantity_supplied ?? null,
                discount: item.discount ?? 0,
                unit_cost: 0,
                unit_price: 0
            };
        });
        const patchPayload = {
            order_type: output.order_type,
            order_id: output.order_id,
            warehouse_company_id: output.warehouse_company_id,
            warehouse_id: output.warehouse_id,
            volume_type: output.volume_type,
            volumes: output.volumes,
            weight: output.weight,
            status: output.status === 10 ? 20 : output.status,
            items: itemsUpdated
        };
        const patchRes = await (0, $9VcS9.default).call((0, $9VcS9.default).patch_output, companyId, outputId, patchPayload);
        if (patchRes?.error) throw new Error(patchRes.error);
    }
    function validateBoxCaps(boxId, nonTertiaryEntries) {
        const box = (boxes || []).find((b)=>String(b.id) === String(boxId));
        const qtyInBox = {};
        for (const bi of box?.items || [])qtyInBox[Number(bi.output_item_number)] = Number(bi.quantity) || 0;
        const sums = (0, $jU7Ru.sumQtyByLine)(boxes || [], boxId);
        for (const e of nonTertiaryEntries){
            const newInBox = (qtyInBox[e.num] || 0) + e.qty;
            const others = sums[e.num] || 0;
            if (others + newInBox > e.required) {
                const avail = e.required - others - (qtyInBox[e.num] || 0);
                return `Linha ${e.num}: quantidade ${e.qty} ultrapassa o saldo dispon\xedvel para esta caixa (${Math.max(0, avail)} un. restantes).`;
            }
        }
        return null;
    }
    /**
	 * Registra quantidades na caixa ativa e na saída; opcionalmente lacra em seguida.
	 * @param {HTMLElement} node
	 * @param {{ sealAfter?: boolean }} opts
	 */ async function registerToCurrentBox(node, { sealAfter: sealAfter = false } = {}) {
        const collected = collectEntries(node);
        if (collected.error) {
            (0, $jUNyh.notify)(collected.error, 'Picking');
            collected.inp?.focus();
            return;
        }
        const { entries: entries = [] } = collected;
        const nonTertiary = entries.filter((e)=>!e.isTertiary);
        const boxId = getSelectedBoxId();
        if (sealAfter && !boxId) {
            (0, $jUNyh.notify)('Selecione a caixa aberta que deseja lacrar.', 'Picking');
            return;
        }
        if (nonTertiary.length > 0 && !boxId) {
            (0, $jUNyh.notify)('Selecione ou abra uma caixa para registrar os itens.', 'Picking');
            node.querySelector('#pick-box-select')?.focus();
            return;
        }
        if (!entries.length && !sealAfter) {
            (0, $jUNyh.notify)('Informe ao menos uma linha com quantidade maior que zero.', 'Picking');
            return;
        }
        if (nonTertiary.length > 0 && boxId) {
            const capErr = validateBoxCaps(boxId, nonTertiary);
            if (capErr) {
                (0, $jUNyh.notify)(capErr, 'Picking');
                return;
            }
        }
        const registerBtn = node.querySelector('#pick-box-register-btn');
        const sealBtn = node.querySelector('#pick-box-seal-btn');
        if (registerBtn) registerBtn.disabled = true;
        if (sealBtn) sealBtn.disabled = true;
        try {
            if (nonTertiary.length > 0 && boxId) {
                const box = getSelectedBox();
                const qtyInBox = {};
                for (const bi of box?.items || [])qtyInBox[Number(bi.output_item_number)] = Number(bi.quantity) || 0;
                const itemsPayload = nonTertiary.map((e)=>({
                        output_item_number: e.num,
                        quantity: (qtyInBox[e.num] || 0) + e.qty,
                        lot_id: items.find((i)=>Number(i.number) === e.num)?.lot_id ?? null,
                        sku: items.find((i)=>Number(i.number) === e.num)?.product_sku ?? null
                    }));
                const boxRes = await (0, $9VcS9.default).call((0, $9VcS9.default).set_output_picking_box_items, companyId, outputId, boxId, {
                    items: itemsPayload
                });
                if (boxRes?.error) {
                    (0, $jUNyh.notify)(boxRes.error, 'Erro ao registrar na caixa');
                    return;
                }
            }
            if (entries.length > 0) {
                await patchOutputSupplied(entries);
                applySuppliedLocally(entries);
                clearPickInputs(node);
                refreshTable(node);
            }
            if (sealAfter && boxId) {
                if (!await sealCurrentBox(node, boxId)) return;
            } else if (entries.length > 0) {
                const boxCode = getSelectedBox()?.code || '';
                (0, $jUNyh.notify)(`Quantidades registradas na sa\xedda${boxCode ? ` e na caixa ${boxCode}` : ''}.`, 'Picking');
            }
            await reloadBoxes();
            refreshBoxPanel(node);
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        } finally{
            if (registerBtn) registerBtn.disabled = false;
            if (sealBtn) sealBtn.disabled = false;
        }
    }
    function bindBoxPanelEvents(node) {
        const boxSelect = node.querySelector('#pick-box-select');
        if (boxSelect) {
            if (selectedBoxId) boxSelect.value = selectedBoxId;
            boxSelect.addEventListener('change', ()=>{
                selectedBoxId = boxSelect.value || null;
            });
        }
        node.querySelector('#pick-box-register-btn')?.addEventListener('click', async ()=>{
            await registerToCurrentBox(node, {
                sealAfter: false
            });
        });
        node.querySelector('#pick-box-seal-btn')?.addEventListener('click', async ()=>{
            const boxId = getSelectedBoxId();
            if (!boxId) {
                (0, $jUNyh.notify)('Selecione a caixa aberta que deseja lacrar.', 'Picking');
                return;
            }
            const box = getSelectedBox();
            const collected = collectEntries(node);
            if (collected.error) {
                (0, $jUNyh.notify)(collected.error, 'Picking');
                return;
            }
            const hasPendingQty = (collected.entries || []).some((e)=>!e.isTertiary);
            if (hasPendingQty) {
                await registerToCurrentBox(node, {
                    sealAfter: true
                });
                return;
            }
            const sealed = await sealCurrentBox(node, boxId);
            if (sealed) {
                await reloadBoxes();
                refreshBoxPanel(node);
            }
        });
        node.querySelector('#pick-box-new-btn')?.addEventListener('click', ()=>{
            (0, $jU7Ru.openCreateBoxModal)(companyId, outputId, async (result)=>{
                try {
                    await reloadBoxes();
                    if (result?.id) selectedBoxId = String(result.id);
                    else {
                        const openList = openBoxes();
                        if (openList.length > 0) selectedBoxId = String(openList[openList.length - 1].id);
                    }
                    refreshBoxPanel(node);
                    (0, $jUNyh.notify)('Nova caixa aberta e selecionada como caixa ativa.', 'Picking');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            });
        });
    }
    const statusLabel = $54eda3acee877046$var$STATUS_LABEL[output.status] || String(output.status);
    const pickerInfo = output.picked_by ? `<span style="color:#555;font-size:0.8rem">Separador: <strong>${(0, $jU7Ru.escHtml)(output.picked_by)}</strong></span>` : '';
    const html = `
		<div class="msgbox" style="min-width:700px;max-width:1000px">
			<div class="mb-title">Picking \u{2014} Sa\xedda #${(0, $jU7Ru.escHtml)(String(outputId))}</div>
			<div class="mb-text" style="max-height:80vh;overflow-y:auto">
				<div style="display:flex;flex-wrap:wrap;gap:1rem;margin-bottom:0.6rem;font-size:0.85rem;color:#444">
					<span>Pedido: <strong>${(0, $jU7Ru.escHtml)(String(output.order_id || "\u2014"))}</strong></span>
					<span>Status: <strong>${(0, $jU7Ru.escHtml)(statusLabel)}</strong></span>
					${output.reference ? `<span>Ref.: <strong>${(0, $jU7Ru.escHtml)(output.reference)}</strong></span>` : ''}
					${pickerInfo}
				</div>
				<p style="margin:0 0 0.4rem;font-size:0.8rem;color:#888">
					Informe a quantidade em <strong>Separar agora</strong>. Os campos <strong>Pendente</strong> atualizam ap\xf3s cada registro.
					${enableBoxCtrl ? " Use os bot\xf5es da se\xe7\xe3o de caixas para registrar, lacrar e abrir nova caixa durante o picking." : ''}
				</p>
				<div style="overflow-x:auto">
					<table id="pick-items-table" style="width:100%;border-collapse:collapse;font-size:0.86em">
						<thead>
							<tr style="background:#f0f0f0">
								<th style="padding:5px 7px;text-align:left">Linha</th>
								<th style="padding:5px 7px;text-align:left">Posi\xe7\xe3o</th>
								<th style="padding:5px 7px;text-align:left">Produto</th>
								<th style="padding:5px 7px;text-align:left">Lote sep.</th>
								<th style="padding:5px 7px;text-align:right">Req.</th>
								<th style="padding:5px 7px;text-align:right">J\xe1 sep.</th>
								<th style="padding:5px 7px;text-align:right">Pendente</th>
								<th style="padding:5px 7px;text-align:right">Separar agora</th>
							</tr>
						</thead>
						<tbody>${buildRowsHtml()}</tbody>
					</table>
				</div>
				${enableBoxCtrl ? buildBoxPanelHtml() : ''}
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y" id="pick-save-btn">Salvar</button>
		</div>`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') dlg.destroy();
    }, /Escape|N/);
    const node = dlg.getNode();
    if (enableBoxCtrl) bindBoxPanelEvents(node);
    node.querySelector('#pick-save-btn')?.addEventListener('click', async ()=>{
        const collected = collectEntries(node);
        if (collected.error) {
            (0, $jUNyh.notify)(collected.error, 'Picking');
            collected.inp?.focus();
            return;
        }
        const { entries: entries = [] } = collected;
        if (!entries.length) {
            dlg.destroy();
            if (typeof onSuccess === 'function') onSuccess();
            return;
        }
        if (enableBoxCtrl) {
            const nonTertiary = entries.filter((e)=>!e.isTertiary);
            if (nonTertiary.length > 0) {
                (0, $jUNyh.notify)("Itens que entram em caixa devem ser registrados com \xabRegistrar nesta caixa\xbb (e lacrar quando necess\xe1rio), n\xe3o por este bot\xe3o.", 'Picking');
                return;
            }
        }
        const saveBtn = node.querySelector('#pick-save-btn');
        saveBtn.disabled = true;
        saveBtn.textContent = "Salvando\u2026";
        try {
            await patchOutputSupplied(entries);
            applySuppliedLocally(entries);
            dlg.destroy();
            (0, $jUNyh.notify)(`Separa\xe7\xe3o da sa\xedda #${outputId} registrada com sucesso.`, 'Picking');
            if (typeof onSuccess === 'function') onSuccess();
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
        } finally{
            saveBtn.disabled = false;
            saveBtn.textContent = 'Salvar';
        }
    });
}



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $e4pb7 = parcelRequire("e4pb7");


/** Status mínimo para etiquetas de volumes (Separando). */ const $9bfec621929b0c49$var$OUTPUT_ST_PICKING = 20;
const $9bfec621929b0c49$var$OUTPUT_ST_CHECKED = 60;
const $9bfec621929b0c49$var$OUTPUT_ST_CANCELED = 100;
const $9bfec621929b0c49$var$OUTPUT_ST_DISABLED = 999;
const $9bfec621929b0c49$var$VOLUME_LABEL_PRE_CONFERENCE_MSG = "Alguma sa\xedda selecionada ainda n\xe3o foi conferida.\n\nImprimir etiquetas de volumes antes da confer\xeancia pode gerar diverg\xeancia entre a quantidade de volumes etiquetados e a quantidade conferida na expedi\xe7\xe3o.\n\nDeseja continuar mesmo assim?";
/** Modal: escolhe layout padrão (QR JSON) ou SESSP (QR nNF|vol|total). */ function $9bfec621929b0c49$var$pickVolumeLabelLayout(onPick) {
    const html = `
		<div class="msgbox">
			<div class="mb-title">Layout da etiqueta</div>
			<div class="mb-text">
				<p style="margin-bottom:0.75rem">Escolha o modelo de impress\xe3o.</p>
				<label class="volume-label-layout-opt" style="display:flex;align-items:flex-start;gap:0.5rem;margin:0.5rem 0;cursor:pointer">
					<input type="radio" name="volume_label_layout" value="default" checked style="margin-top:0.2rem">
					<span><strong>Padr\xe3o</strong> \u{2014} mesmo layout visual de sempre; QR em JSON (empresa, sa\xedda e volume).</span>
				</label>
				<label class="volume-label-layout-opt" style="display:flex;align-items:flex-start;gap:0.5rem;margin:0.5rem 0;cursor:pointer">
					<input type="radio" name="volume_label_layout" value="sessp" style="margin-top:0.2rem">
					<span><strong>SESSP</strong> \u{2014} modelo IBL (produto/lote do 1\xba item, destinat\xe1rio, rota) e QR <code>n\xba&nbsp;NF|volume|total</code> (ex.: <code>2925194|2|10</code>). Sem NF emitida, o n\xba fica como <code>-</code> (permite etiquetar na separa\xe7\xe3o).</span>
				</label>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Continuar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key === 'Y') {
            const r = dlg.getNode().querySelector('input[name="volume_label_layout"]:checked');
            const layout = r && r.value ? r.value : 'default';
            dlg.destroy();
            onPick(layout);
        }
    }, /Enter|Escape|N|Y/);
}
/** Saídas elegíveis para etiqueta de volumes entre as linhas da grade. */ function $9bfec621929b0c49$var$selectedOutputsForVolumeLabels(crud, ids, rows) {
    const idSet = new Set(ids.map(([c, id])=>`${c}:${id}`));
    return (rows || []).filter((r)=>idSet.has(`${r.company_id}:${r.id}`));
}
function $9bfec621929b0c49$var$outputAllowsVolumeLabels(status) {
    const st = Number(status);
    return st >= $9bfec621929b0c49$var$OUTPUT_ST_PICKING && st !== $9bfec621929b0c49$var$OUTPUT_ST_CANCELED && st !== $9bfec621929b0c49$var$OUTPUT_ST_DISABLED;
}
function $9bfec621929b0c49$var$outputVolumeLabelsPreConference(status) {
    const st = Number(status);
    return st >= $9bfec621929b0c49$var$OUTPUT_ST_PICKING && st < $9bfec621929b0c49$var$OUTPUT_ST_CHECKED;
}
function $9bfec621929b0c49$var$downloadPalletsExport(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(url);
}
/** Modal: filtros opcionais (período no extrato, estornos) para rastreio de saldo. */ function $9bfec621929b0c49$var$pickBalanceTraceFilters(selectedCount, onPick) {
    const html = `
		<div class="msgbox">
			<div class="mb-title">Rastreio de saldo</div>
			<div class="mb-text">
				<p style="margin-bottom:0.75rem"><strong>${selectedCount}</strong> sa\xedda(\xf5es) selecionada(s).</p>
				<p style="margin-bottom:0.5rem;font-size:0.9rem">Filtrar por <strong>data da movimenta\xe7\xe3o</strong> no extrato (opcional):</p>
				<div style="display:flex;gap:1rem;flex-wrap:wrap;margin-bottom:0.75rem">
					<label>De <input type="date" id="bt-date-from" autocomplete="off"></label>
					<label>At\xe9 <input type="date" id="bt-date-to" autocomplete="off"></label>
				</div>
				<label style="display:flex;align-items:flex-start;gap:0.5rem;cursor:pointer;margin-top:0.5rem">
					<input type="checkbox" id="bt-include-estornos" checked style="margin-top:0.2rem">
					<span>Incluir movimentos <strong>estornados</strong> (linhas desativadas no extrato e a inversa do estorno)</span>
				</label>
				<p style="margin-top:0.75rem;margin-bottom:0.35rem;font-size:0.9rem">Formato:</p>
				<label style="display:flex;align-items:flex-start;gap:0.5rem;margin:0.35rem 0;cursor:pointer">
					<input type="radio" name="bt-format" value="pdf" checked style="margin-top:0.2rem">
					<span><strong>PDF</strong> \u{2014} visualiza\xe7\xe3o</span>
				</label>
				<label style="display:flex;align-items:flex-start;gap:0.5rem;margin:0.35rem 0;cursor:pointer">
					<input type="radio" name="bt-format" value="csv" style="margin-top:0.2rem">
					<span><strong>CSV</strong> \u{2014} separador <code>;</code> (UTF-8), colunas empresa, CNPJ, pedido, transa\xe7\xe3o, origem/destino, etc.</span>
				</label>
				<p style="margin-top:0.75rem;font-size:0.85rem;color:#444">O relat\xf3rio lista reservas (L\u{2192}R), transfer\xeancias entre posi\xe7\xf5es (L\u{2192}L, ex.: SS-01), baixa (R\u{2192}O) e demais v\xednculos ao <code>output_id</code> no JSON da transa\xe7\xe3o.</p>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Gerar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key === 'Y') {
            const node = dlg.getNode();
            const df = node.querySelector('#bt-date-from')?.value?.trim() || '';
            const dt = node.querySelector('#bt-date-to')?.value?.trim() || '';
            const incl = node.querySelector('#bt-include-estornos')?.checked !== false;
            const rf = node.querySelector('input[name="bt-format"]:checked');
            const format = rf && rf.value ? rf.value : 'pdf';
            dlg.destroy();
            onPick({
                date_from: df || undefined,
                date_to: dt || undefined,
                include_estornos: incl,
                format: format
            });
        }
    }, /Enter|Escape|N|Y/);
}
/** Modal: PDF em grade (atual) ou tabela CSV/Excel com filtro de data opcional. */ function $9bfec621929b0c49$var$pickPalletsOverturnFormat(count, onPick) {
    const html = `
		<div class="msgbox">
			<div class="mb-title">Derrubada de Pallets</div>
			<div class="mb-text">
				<p style="margin-bottom:0.75rem"><strong>${count}</strong> sa\xedda(\xf5es) selecionada(s).</p>
				<p style="margin-bottom:0.5rem">Formato do relat\xf3rio:</p>
				<label style="display:flex;align-items:flex-start;gap:0.5rem;margin:0.5rem 0;cursor:pointer">
					<input type="radio" name="po_layout" value="grade" checked style="margin-top:0.2rem">
					<span><strong>GRADE \u{2014} PDF</strong> \u{2014} grade de posi\xe7\xf5es fora de alcance (comportamento atual).</span>
				</label>
				<label style="display:flex;align-items:flex-start;gap:0.5rem;margin:0.5rem 0;cursor:pointer">
					<input type="radio" name="po_layout" value="tabela" style="margin-top:0.2rem">
					<span><strong>Tabela \u{2014} CSV ou Excel</strong> \u{2014} linhas por item (posi\xe7\xe3o, categoria t\xe9rmica/SKU/produto/lote, fatura, quantidade).</span>
				</label>
				<div id="pallets-overturn-table-opts" style="display:none;margin-top:0.75rem;padding-top:0.75rem;border-top:1px solid #ddd">
					<p style="margin-bottom:0.5rem;font-size:0.9rem"><strong>Filtro de data</strong> (opcional \u{2014} data de cria\xe7\xe3o da sa\xedda; deixe em branco para todas as selecionadas)</p>
					<div style="display:flex;gap:1rem;flex-wrap:wrap;margin-bottom:0.75rem">
						<label>De <input type="date" id="po-date-from" autocomplete="off"></label>
						<label>At\xe9 <input type="date" id="po-date-to" autocomplete="off"></label>
					</div>
					<p style="margin-bottom:0.35rem">Arquivo:</p>
					<label style="margin-right:0.75rem;cursor:pointer"><input type="radio" name="po_export_fmt" value="csv" checked> CSV</label>
					<label style="cursor:pointer"><input type="radio" name="po_export_fmt" value="xlsx"> Excel (.xlsx)</label>
				</div>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Gerar</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key === 'Y') {
            const node = dlg.getNode();
            const lr = node.querySelector('input[name="po_layout"]:checked');
            const layout = lr && lr.value ? lr.value : 'grade';
            let dateFrom = '';
            let dateTo = '';
            let format = 'csv';
            if (layout === 'tabela') {
                dateFrom = (node.querySelector('#po-date-from') || {}).value || '';
                dateTo = (node.querySelector('#po-date-to') || {}).value || '';
                if (dateFrom && dateTo && dateFrom > dateTo) {
                    (0, $jUNyh.notify)("Data inicial n\xe3o pode ser maior que a final.", 'Filtro de data');
                    return;
                }
                const rf = node.querySelector('input[name="po_export_fmt"]:checked');
                format = rf && rf.value ? rf.value : 'csv';
            }
            dlg.destroy();
            onPick({
                layout: layout,
                format: format,
                date_from: dateFrom || undefined,
                date_to: dateTo || undefined
            });
        }
    }, /Enter|Escape|N|Y/);
    const node = dlg.getNode();
    const box = node.querySelector('#pallets-overturn-table-opts');
    const syncOpts = ()=>{
        const r = node.querySelector('input[name="po_layout"]:checked');
        const layout = r && r.value ? r.value : 'grade';
        if (box) box.style.display = layout === 'tabela' ? 'block' : 'none';
    };
    node.querySelectorAll('input[name="po_layout"]').forEach((el)=>el.addEventListener('change', syncOpts));
    syncOpts();
}
const $9bfec621929b0c49$var$outputs = function() {
    let outputs_crud;
    function bindOutputStatusFieldLock(fs) {
        const hint = fs.dialog?.getNode?.()?.querySelector('#output-status-lock-hint');
        const statusField = fs.form.getFieldBySelector('#status');
        const allowRaw = fs.form.getFieldBySelector('#allow_manual_status_advance')?.getValue?.();
        const allow = allowRaw !== false && allowRaw !== 'false' && allowRaw !== '0' && allowRaw !== 0;
        const stRaw = statusField?.getValue?.();
        const st = stRaw != null && stRaw !== '' ? Number(stRaw) : NaN;
        const lock = !allow && Number.isFinite(st) && st >= 30 && st < 65;
        const statusNode = statusField?.queryNode?.() || statusField?.node;
        if (statusNode) {
            if (lock) {
                statusNode.setAttribute('disabled', 'disabled');
                statusNode.setAttribute('title', "Use Opera\xe7\xf5es \u2192 Conferir sa\xedda (confer\xeancia web)");
            } else {
                statusNode.removeAttribute('disabled');
                statusNode.removeAttribute('title');
            }
        }
        if (hint) hint.style.display = lock ? 'block' : 'none';
    }
    function bindDeleteSeparateLinesUI(fs) {
        const root = fs.dialog.getNode();
        const btn = root.querySelector('#bn-delete-separate-output-lines');
        const statusEl = root.querySelector('#status');
        if (!btn) return;
        const syncVisibility = ()=>{
            const raw = fs.form.getFieldBySelector('#status')?.getValue?.();
            const st = raw != null && raw !== '' ? Number(raw) : NaN;
            const ok = Number.isFinite(st) && st >= 10 && st < 70;
            btn.style.display = ok ? 'inline-block' : 'none';
            btn.disabled = !ok;
        };
        syncVisibility();
        if (statusEl) statusEl.addEventListener('change', syncVisibility);
        btn.onclick = async ()=>{
            const indices = fs.getSelectedIndices('.row');
            if (!indices.length) {
                (0, $jUNyh.notify)("Marque as linhas a remover (checkbox \xe0 esquerda).", "Sa\xeddas");
                return;
            }
            const company_id = fs.form.getFieldBySelector('#company_id').getValue();
            const output_id = Number(fs.form.getFieldBySelector('#id').getValue());
            if (!company_id || !output_id) {
                (0, $jUNyh.notify)("Sa\xedda ou empresa inv\xe1lida.", "Sa\xeddas");
                return;
            }
            const nums = [];
            for (const idx of indices){
                const el = root.querySelector(`#number-${idx}`);
                const n = el && el.value;
                if (n != null && String(n).trim() !== '' && Number.isFinite(Number(n))) nums.push(Number(n));
            }
            if (!nums.length) {
                (0, $jUNyh.notify)("N\xe3o foi poss\xedvel ler o n\xfamero das linhas (feche e abra o registro novamente).", "Sa\xeddas");
                return;
            }
            (0, $jUNyh.ask)(`Remover ${nums.length} linha(s) no servidor (${nums.join(', ')})? Se houver reserva, ela volta ao estoque livre (R\u{2192}L).`, "Confirmar remo\xe7\xe3o", async (answer)=>{
                if (answer !== 'Y') return;
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_output_separate_lines, company_id, output_id, {
                    item_numbers: nums
                });
                if (!resp) return;
                (0, $jUNyh.notify)(`Linhas removidas: ${nums.join(', ')}.`, "Sa\xeddas");
                const flat = await outputs_crud.loadRecord(JSON.stringify([
                    company_id,
                    output_id
                ]));
                const top = (0, $b60a2.getTopIndex)(flat);
                let have = fs.getTableSize();
                while(have > top + 1){
                    fs.removeRows([
                        have - 1
                    ], '.row');
                    have--;
                }
                while(have < top + 1){
                    fs.appendRows(1, '.row');
                    have++;
                }
                fs.form.setValues(flat);
                fs.form.refresh();
                setTimeout(()=>fs.form.refresh(), 200);
                syncVisibility();
            });
        };
    }
    const record_output_form = {
        ...(0, $6c379cd70cdf065a$export$2e2bcd8739ae039),
        form: {
            ...(0, $6c379cd70cdf065a$export$2e2bcd8739ae039).form,
            afterEditSetValues (fs) {
                if (fs.hasTables?.()) fs.setTableHeight(10);
                bindOutputStatusFieldLock(fs);
                bindDeleteSeparateLinesUI(fs);
                // Dispara observers de remetente/armazém para popular o datalist de posição (IDB) após loadRecord,
                // sem depender de clique do usuário — evita valor cru "wh:loc" sem rótulo de endereço.
                const rem = fs.form.getFieldBySelector('#warehouse_company_id');
                const wh = fs.form.getFieldBySelector('#warehouse_id');
                const remVal = rem?.getValue?.();
                if (rem && typeof rem.publish === 'function' && remVal != null && remVal !== '') rem.publish('change', rem, remVal);
                const whVal = wh?.getValue?.();
                if (wh && typeof wh.publish === 'function' && whVal != null && whVal !== '') wh.publish('change', wh, whVal);
                setTimeout(()=>fs.form.refresh(), 250);
                const vals = fs.form.getValues?.() || {};
                const compId = vals.company_id;
                const orderId = vals.order_id;
                const orderType = String(vals.order_type || '').trim().toUpperCase();
                if (compId && orderId != null && orderId !== '' && orderType === 'O') (0, $408fd6d1f7aad081$export$376b532903f2d911)({
                    formSelector: '#output',
                    bannerId: 'output-integration-alert-banner',
                    companyId: compId,
                    entityType: 'output_order',
                    entityId: orderId
                });
            }
        }
    };
    outputs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        /** Posições no IndexedDB por empresa do remetente (todas as filiais), para rótulo `endereço · arm. N` em linhas multi-armazém. */ async queryLocationsWideForIndexedDb () {
            const params = new URLSearchParams();
            let f = this.filter;
            if (f && Object.keys(f).some((k)=>/^field-\d+$/.test(k))) f = await (0, $hWQyW.resolveFilterLabelsToIds)(f, this.fieldspecs);
            let expr = (0, $hWQyW.translate)(f, [
                'company_id'
            ], this.fieldspecs);
            if (!expr) expr = (0, $hWQyW.translateForLocations)(f, this.fieldspecs);
            // Sem filtro de escopo: GET /locations sem WHERE puxava todo o cadastro → lento e inútil para o datalist.
            // O modal de saída hidrata posições via loadRecord (empresa do remetente) e filtros explícitos recarregam aqui.
            if (!expr) return null;
            params.append('filter', expr);
            params.append('sort', '4');
            params.append('limit', '0');
            return '?' + params.toString();
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customer_routes, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customer_routes', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_carriers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('carriers', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, this.queryAll()).then((data)=>(0, $1cmSR.default).set('programs', data).catch(()=>{}));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_warehouses, this.queryAll()).then((data)=>(0, $1cmSR.default).set('warehouses', data).catch((error)=>(0, $jUNyh.notify)(error)));
            const locQ = await this.queryLocationsWideForIndexedDb();
            if (locQ) (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, locQ).then((data)=>(0, $1cmSR.default).set('locations', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_devices, this.queryAll()).then((data)=>(0, $1cmSR.default).set('devices', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            const searchPayload = (0, $31661fef13ba0ec6$export$74ba1cf3ebf85a39)(this.filter, query);
            if (searchPayload) return await (0, $9VcS9.default).call((0, $9VcS9.default).search_outputs, searchPayload);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_outputs, query);
        },
        /**
		 * Listagem filtrada sem paginação (ações em massa / etiquetas).
		 * Usa lista leve + teto — evita GET /outputs?limit=0 com itens aninhados (uWSGI).
		 */ async queryFiltered () {
            const params = new URLSearchParams();
            await this.addFilter(params);
            this.addSort(params);
            this.addLimit(params, 500);
            params.set('include_items', '0');
            return '?' + params.toString();
        },
        /**
		 * Carrega produtos da empresa no IndexedDB para o datalist do modal de itens.
		 * Mesmo padrão de Entradas (`loadCompanyProductsToDb`) — Saídas não fazia isso
		 * e no QA (IDB vazio) o campo mostrava só o ID + «Verificar product».
		 */ async loadCompanyProductsToDb (company_id) {
            if (company_id == null || company_id === '') return;
            const qs = new URLSearchParams({
                filter: `company_id*eq*${company_id}`,
                sort: '2',
                limit: '0'
            });
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_products, '?' + qs.toString());
            if (Array.isArray(data)) await (0, $1cmSR.default).set('products', data);
        },
        /**
		 * Lotes da empresa para datalist (observer product_id + company_id).
		 * Escopo por empresa — evita depender de o usuário ter aberto Cadastro → Lotes.
		 */ async loadCompanyLotsToDb (company_id) {
            if (company_id == null || company_id === '') return;
            const qs = new URLSearchParams({
                filter: `company_id*eq*${company_id}`,
                limit: '0'
            });
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_lots, '?' + qs.toString());
            if (Array.isArray(data)) await (0, $1cmSR.default).set('lots', data);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_output, ...JSON.parse(id));
            const flat = (0, $b60a2.flatten)(_record, 'items');
            const hdrWh = _record.warehouse_id;
            const top = (0, $b60a2.getTopIndex)(flat);
            for(let i = 0; i <= top; i++){
                const lid = flat[`location_id-${i}`];
                const wline = flat[`warehouse_id-${i}`] ?? hdrWh;
                if (lid != null && lid !== '' && wline != null && wline !== '' && !String(lid).includes(':')) flat[`location_id-${i}`] = `${Number(wline)}:${Number(lid)}`;
            }
            try {
                await this.loadCompanyProductsToDb(_record.company_id);
            } catch (_) {}
            try {
                await this.loadCompanyLotsToDb(_record.company_id);
            } catch (_) {}
            const rem = _record.warehouse_company_id;
            if (rem) {
                const qs = new URLSearchParams({
                    filter: `company_id*eq*${rem}`,
                    sort: '4',
                    limit: '0'
                }).toString();
                try {
                    const locs = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, '?' + qs);
                    if (Array.isArray(locs) && locs.length) await (0, $1cmSR.default).set('locations', locs);
                } catch (_) {}
            }
            flat.allow_manual_status_advance = _record.allow_manual_status_advance !== false;
            return flat;
        },
        editRecord (data) {
            (0, $b60a2.default).edit(record_output_form, this.saveRecordWrapper.bind(this), data, false); // false = turn off autorow for this module
        },
        async editFilter () {
            const locQf = await this.queryLocationsWideForIndexedDb();
            if (locQf) (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, locQf).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter, {
                reloadLocations: async (formData)=>{
                    const resolved = await (0, $hWQyW.resolveFilterLabelsToIds)(formData, this.fieldspecs);
                    const parts = [];
                    for(let i = 0; i < 10; i++){
                        const f = resolved[`field-${i}`];
                        const v = resolved[`value-${i}`];
                        if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
                        else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
                        else if (f === 'warehouse_company_id' && v) parts.push(`company_id*eq*${v}`);
                    }
                    if (parts.length === 0) return;
                    const params = new URLSearchParams();
                    params.append('filter', parts.join(','));
                    params.append('sort', '4');
                    params.append('limit', '0');
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, '?' + params.toString());
                    if (data && Array.isArray(data)) (0, $1cmSR.default).set('locations', data);
                }
            });
        },
        async applyFilter (data) {
            this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            this.filterExplicitlyApplied = true;
            const locQf = await this.queryLocationsWideForIndexedDb();
            if (locQf) (0, $9VcS9.default).call((0, $9VcS9.default).list_locations, locQf).then((data)=>(0, $1cmSR.default).set('locations', data)).catch(()=>{});
            await this.loadPage(1);
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'items');
            if (!data.items) return;
            let _record = {
                order_type: data.order_type,
                order_id: Number(data.order_id),
                warehouse_company_id: data.warehouse_company_id,
                warehouse_id: Number(data.warehouse_id),
                volume_type: data.volume_type ?? null,
                volumes: Number(data.volumes),
                weight: Number(data.weight),
                status: Number(data.status),
                items: data.items.filter((item)=>item && item.product_id != null && item.product_id !== '' && Number(item.product_id) > 0).map((item)=>{
                    let locRaw = item.location_id;
                    let whLine = item.warehouse_id;
                    const locStr = String(locRaw ?? '').trim();
                    if (/^\d+:\d+$/.test(locStr)) {
                        const [a, b] = locStr.split(':').map(Number);
                        whLine = whLine ?? a;
                        locRaw = b;
                    }
                    if (whLine == null || whLine === '') whLine = data.warehouse_id;
                    const numRaw = item.number;
                    const out = {
                        location_id: Number(locRaw),
                        warehouse_id: whLine != null && whLine !== '' ? Number(whLine) : null,
                        product_id: Number(item.product_id),
                        lot_id: item.lot_id > 0 ? Number(item.lot_id) : null,
                        quantity_required: Number(item.quantity_required),
                        quantity_supplied: Number(item.quantity_supplied),
                        discount: Number(item.discount),
                        unit_cost: 0,
                        unit_price: 0
                    };
                    if (numRaw != null && String(numRaw).trim() !== '' && Number.isFinite(Number(numRaw))) out.number = Number(numRaw);
                    return out;
                })
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_output, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_output, data.company_id, _record);
        },
        cancelOutputs () {
            if (!this.ensureSelection("Cancelar Sa\xeddas")) return;
            const showResult = async (results)=>{
                (0, $jUNyh.notify)(await (0, $8930cf174b3182ba$export$2e2bcd8739ae039)(results), 'Resultados');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).cancel_outputs, {
                    'ids': ids
                });
                if (resp != null) await showResult(resp);
            };
            (0, $jUNyh.ask)(`Cancelar reservas de ${this.getCount()} sa\xeddas?`, "Cancelar Sa\xeddas", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async createInvoices () {
            if (!this.ensureSelection('Gerar Notas')) return;
            const showResult = (resp)=>{
                this.clearGridSelection();
                (0, $jUNyh.notify)(`Notas criadas: ${resp?.count || 0}`, 'Resultado');
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const purposeRaw = String(data.purpose ?? '').trim();
                const payload = {
                    io_type: 'O',
                    ids: ids,
                    info: data.info,
                    include: data.include
                };
                if (/^[1-6]$/.test(purposeRaw)) payload.purpose = purposeRaw;
                else if (purposeRaw) payload.cfop = purposeRaw;
                else throw new Error('Selecione uma finalidade ou um CFOP cadastrado.');
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_invoices, payload);
                if (resp != null) showResult(resp);
            };
            let formDef;
            try {
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const companies = new Set(ids.map((r)=>r[0]));
                if (companies.size === 1) {
                    const companyId = [
                        ...companies
                    ][0];
                    const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_cfops_by_company, companyId);
                    formDef = (0, $bbd1a845e6487967$export$2e2bcd8739ae039)(false, (0, $bbd1a845e6487967$export$dd3b5e98da1289c8)(rows));
                } else formDef = (0, $bbd1a845e6487967$export$2e2bcd8739ae039)(false);
            } catch (e) {
                (0, $jUNyh.notify)(String(e.message || e), 'Erro');
                return;
            }
            let fs = (0, $h1m6J.default).create(formDef, sendRequest);
            fs.init = (()=>{
                const n = this.getCount();
                document.querySelector(`${fs.form.selector} #count`).innerHTML = n;
                const noun = document.querySelector(`${fs.form.selector} #io-noun`);
                if (noun) noun.textContent = n === 1 ? "sa\xedda" : "sa\xeddas";
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        closeOutputs () {
            if (!this.ensureSelection('Baixar Estoques')) return;
            const showResult = async (results)=>{
                (0, $jUNyh.notify)(await (0, $8930cf174b3182ba$export$2e2bcd8739ae039)(results), 'Resultados');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).close_outputs, {
                    'ids': ids
                });
                if (resp != null) await showResult(resp);
            };
            (0, $jUNyh.ask)(`Dar baixa de ${this.getCount()} sa\xeddas?`, 'Baixar Estoques', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        /** #MT-0F84944 — multi-select → Doca Expedição (status 70 → 75, sem baixa). */ sendToDockExpedition () {
            if (!this.ensureSelection("Enviar para Doca Expedi\xe7\xe3o")) return;
            const showResult = async (resp)=>{
                const sent = resp?.count ?? 0;
                const already = (resp?.already || []).length;
                const errs = resp?.errors || [];
                let msg = `Enviadas \xe0 Doca: ${sent}`;
                if (already) msg += ` \xb7 J\xe1 estavam na Doca: ${already}`;
                if (errs.length) msg += `\nFalhas (${errs.length}): ` + errs.slice(0, 8).map((e)=>`sa\xedda ${e.output_id}: ${e.error}`).join('; ');
                (0, $jUNyh.notify)(msg, errs.length ? "Aten\xe7\xe3o" : "Doca Expedi\xe7\xe3o");
                this.loadPage();
            };
            const sendRequest = async ()=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).send_outputs_to_dock_expedition, {
                    ids: ids
                });
                if (resp != null) await showResult(resp);
            };
            (0, $jUNyh.ask)(`Enviar ${this.getCount()} sa\xedda(s) para Doca Expedi\xe7\xe3o?
` + `Somente Faturadas (70), empresa com Doca ativa e pedido canal Internet.`, "Enviar para Doca Expedi\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async exportListCsv () {
            const crud = this;
            await (0, $b60a2.default).edit((0, $67075ee75b8cab41$export$2e2bcd8739ae039), async ()=>{
                const box = document.querySelector(`${(0, $67075ee75b8cab41$export$2e2bcd8739ae039).form.selector} #use_list_filter`);
                const useList = box ? box.checked : true;
                const payload = {};
                if (useList) {
                    const params = new URLSearchParams();
                    await crud.addFilter(params);
                    crud.addSort(params);
                    const f = params.get('filter');
                    const s = params.get('sort');
                    if (f) payload.filter = f;
                    if (s) payload.sort = s;
                }
                try {
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_outputs_csv, payload);
                    if (resp?.csv) {
                        $9bfec621929b0c49$var$downloadPalletsExport(resp.csv, resp.filename || 'saidas.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)('Download iniciado.', 'Exportar listagem (CSV)');
                    } else (0, $jUNyh.notify)("N\xe3o foi poss\xedvel gerar o arquivo.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        },
        async exportItemsCsv () {
            const crud = this;
            await (0, $b60a2.default).edit((0, $28b1bd1eb4b661a0$export$2e2bcd8739ae039), async ()=>{
                const box = document.querySelector(`${(0, $28b1bd1eb4b661a0$export$2e2bcd8739ae039).form.selector} #use_list_filter`);
                const useList = box ? box.checked : true;
                const payload = {};
                if (useList) {
                    const params = new URLSearchParams();
                    await crud.addFilter(params);
                    crud.addSort(params);
                    const f = params.get('filter');
                    const s = params.get('sort');
                    if (f) payload.filter = f;
                    if (s) payload.sort = s;
                }
                try {
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).export_outputs_items_csv, payload);
                    if (resp?.csv) {
                        $9bfec621929b0c49$var$downloadPalletsExport(resp.csv, resp.filename || 'saidas-itens.csv', 'text/csv;charset=utf-8');
                        (0, $jUNyh.notify)('Download iniciado.', 'Exportar itens (CSV)');
                    } else (0, $jUNyh.notify)("N\xe3o foi poss\xedvel gerar o arquivo.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            }, {}, false);
        },
        printPickControl () {
            if (!this.ensureSelection('Controle de Picking')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_pick_control, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio?`, 'Controle de Picking', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPalletsOverturn () {
            if (!this.ensureSelection('Derrubada de Pallets')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.csv) $9bfec621929b0c49$var$downloadPalletsExport(resp.csv, resp.filename || 'derrubada-pallets.csv', 'text/csv;charset=utf-8');
                else if (resp?.xlsx) $9bfec621929b0c49$var$downloadPalletsExport(resp.xlsx, resp.filename || 'derrubada-pallets.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            };
            const sendRequest = async (opts)=>{
                let ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                const body = {
                    ids: ids,
                    layout: opts.layout || 'grade'
                };
                if (body.layout === 'tabela') {
                    body.format = opts.format || 'csv';
                    if (opts.date_from) body.date_from = opts.date_from;
                    if (opts.date_to) body.date_to = opts.date_to;
                }
                await (0, $9VcS9.default).call((0, $9VcS9.default).print_pallets_overturn, body).then(showResult);
            };
            $9bfec621929b0c49$var$pickPalletsOverturnFormat(this.getCount(), (opts)=>{
                sendRequest.call(this, opts);
            });
        },
        printPickLists () {
            if (!this.ensureSelection('Pick List')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_picklists, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio?`, 'Pick List', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printPickListOrder () {
            if (!this.ensureSelection('PickList - Ordem')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                await (0, $9VcS9.default).call((0, $9VcS9.default).print_picklist_order, {
                    ids: ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xedda(s) no PickList - Ordem?`, 'PickList - Ordem', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printAvisoRemessa () {
            if (!this.ensureSelection('Aviso de Remessa')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_aviso_remessa, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xeddas no Aviso de Remessa?`, 'Aviso de Remessa', (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printConference () {
            if (!this.ensureSelection("Confer\xeancia de Sa\xedda")) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_conference, {
                    'ids': ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio de confer\xeancia?`, "Confer\xeancia de Sa\xedda", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printDetails () {
            if (!this.ensureSelection("Sa\xedda Detalhada")) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.message) (0, $jUNyh.notify)(resp.message, "Sa\xedda detalhada");
            };
            const sendRequest = async ()=>{
                const ids = (0, $aGGTj.splitIdsByCompany)(await this.getSelectedIds([
                    'company_id',
                    'id'
                ]));
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_output_details, {
                    ids: ids
                }).then(showResult);
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xeddas no relat\xf3rio detalhado?`, "Sa\xedda Detalhada", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        printBalanceTrace () {
            if (!this.ensureSelection('Rastreio de saldo')) return;
            const showResult = async (resp)=>{
                this.clearGridSelection();
                if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                else if (resp?.csv) $9bfec621929b0c49$var$downloadPalletsExport(resp.csv, resp.filename || 'rastreio-saldo.csv', 'text/csv;charset=utf-8');
            };
            const sendRequest = async (opts)=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const body = {
                    ids: ids
                };
                if (opts?.date_from) body.date_from = opts.date_from;
                if (opts?.date_to) body.date_to = opts.date_to;
                if (opts && typeof opts.include_estornos === 'boolean') body.include_estornos = opts.include_estornos;
                const fmt = opts?.format && String(opts.format).toLowerCase() === 'csv' ? 'csv' : 'pdf';
                body.format = fmt;
                await (0, $9VcS9.default).call((0, $9VcS9.default).print_balance_trace, body).then(showResult);
            };
            $9bfec621929b0c49$var$pickBalanceTraceFilters(this.getCount(), (opts)=>{
                sendRequest.call(this, opts);
            });
        },
        async printLabels () {
            if (!this.ensureSelection('Etiquetas de Volumes')) return;
            const sendRequest = async (data)=>{
                data = (0, $b60a2.deepen)(data, 'outputs');
                const device_id = (0, $aGGTj.resolvePrinterDeviceId)(data.device_id, '#output-labels #device_id');
                if (device_id == null) {
                    (0, $jUNyh.notify)("Selecione a impressora na lista (clique na op\xe7\xe3o; s\xf3 o texto no campo n\xe3o basta).", "Aten\xe7\xe3o");
                    return false;
                }
                let layout = data.label_layout != null && String(data.label_layout).trim() !== '' ? String(data.label_layout).trim().toLowerCase() : 'default';
                if (layout !== 'default' && layout !== 'sessp') layout = 'default';
                let _record = {
                    device_company_id: data.device_company_id,
                    device_id: device_id,
                    return_zpl: !!data.use_local_agent,
                    label_layout: layout,
                    outputs: data.outputs.map((output)=>({
                            company_id: output.company_id,
                            output_id: Number(output.output_id),
                            first_volume: Number(output.first_volume),
                            last_volume: Number(output.last_volume)
                        }))
                };
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).print_output_labels, _record);
                if (result?.zpl) try {
                    await (0, $9VcS9.default).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $jUNyh.notify)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            const editVolumes = async (data, labelLayout)=>{
                this.clearGridSelection();
                let _record = {
                    orders: data,
                    label_layout: labelLayout && String(labelLayout).trim() !== '' ? String(labelLayout).trim().toLowerCase() : 'default'
                };
                (0, $b60a2.default).edit((0, $b50b0cd1ea086803$export$2e2bcd8739ae039), sendRequest, (0, $b60a2.flatten)(_record, 'orders'));
            };
            const getVolumes = async (labelLayout)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_volumes, {
                    ids: ids
                }).then((d)=>editVolumes(d, labelLayout));
            };
            const proceedToLayout = ()=>{
                $9bfec621929b0c49$var$pickVolumeLabelLayout((layout)=>{
                    getVolumes(layout);
                });
            };
            const confirmPreConferenceIfNeeded = (selected)=>{
                if (selected.some((r)=>$9bfec621929b0c49$var$outputVolumeLabelsPreConference(r.status))) {
                    (0, $jUNyh.ask)($9bfec621929b0c49$var$VOLUME_LABEL_PRE_CONFERENCE_MSG, "Etiquetas antes da confer\xeancia", (answer)=>{
                        if (answer === 'Y') proceedToLayout();
                    });
                    return;
                }
                proceedToLayout();
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xeddas na impress\xe3o?`, 'Etiquetas de Volumes', async (answer)=>{
                if (answer !== 'Y') return;
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const rows = await this.queryFilteredData();
                const selected = $9bfec621929b0c49$var$selectedOutputsForVolumeLabels(this, ids, rows);
                if (selected.some((r)=>!$9bfec621929b0c49$var$outputAllowsVolumeLabels(r.status))) {
                    (0, $jUNyh.notify)("Etiquetas de volumes dispon\xedveis a partir do status Separando (n\xe3o para sa\xeddas Criada, Cancelada ou Exclu\xedda).", 'Etiquetas de Volumes');
                    return;
                }
                confirmPreConferenceIfNeeded(selected);
            });
        },
        async printStageLabels () {
            if (!this.ensureSelection("Etiqueta de Sa\xedda")) return;
            const sendRequest = async (data)=>{
                data = (0, $b60a2.deepen)(data, 'outputs');
                const device_id = (0, $aGGTj.resolvePrinterDeviceId)(data.device_id, '#output-stage-labels #device_id');
                if (device_id == null) {
                    (0, $jUNyh.notify)("Selecione a impressora na lista (clique na op\xe7\xe3o; s\xf3 o texto no campo n\xe3o basta).", "Aten\xe7\xe3o");
                    return false;
                }
                const outputs = (data.outputs || []).filter((output)=>output?.output_id != null && String(output.output_id).trim() !== '');
                if (!outputs.length) {
                    (0, $jUNyh.notify)("Nenhuma sa\xedda v\xe1lida para imprimir.", "Etiqueta de Sa\xedda");
                    return false;
                }
                const _record = {
                    device_company_id: data.device_company_id,
                    device_id: device_id,
                    return_zpl: !!data.use_local_agent,
                    outputs: outputs.map((output)=>({
                            company_id: output.company_id,
                            output_id: Number(output.output_id),
                            label_count: Number(output.label_count) || 1
                        }))
                };
                const result = await (0, $9VcS9.default).call((0, $9VcS9.default).print_output_stage_labels, _record);
                if (result?.zpl) try {
                    await (0, $9VcS9.default).sendZplToAgent(result.zpl, result.printer, result.printer_key);
                    (0, $jUNyh.notify)('Etiquetas enviadas ao agente local.', "Impress\xe3o");
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Agente local');
                    return false;
                }
                return result;
            };
            const editLabels = async (data)=>{
                this.clearGridSelection();
                (0, $b60a2.default).edit((0, $0a66add6b28f4509$export$2e2bcd8739ae039), sendRequest, (0, $b60a2.flatten)({
                    outputs: data
                }, 'outputs'), false);
            };
            const getData = async ()=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (!ids.length) {
                    (0, $jUNyh.notify)("Selecione ao menos uma sa\xedda.", "Etiqueta de Sa\xedda");
                    return;
                }
                try {
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_stage_labels, {
                        ids: ids
                    });
                    await editLabels(data);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), "Etiqueta de Sa\xedda");
                }
            };
            (0, $jUNyh.ask)(`Incluir ${this.getCount()} sa\xedda(s) na impress\xe3o de Etiqueta de Sa\xedda?`, "Etiqueta de Sa\xedda", async (answer)=>{
                if (answer !== 'Y') return;
                await getData();
            });
        },
        async reverseOutput () {
            const sendRequest = async (data)=>{
                let resp = await (0, $9VcS9.default).call((0, $9VcS9.default).reverse_output, data.company_id, data.output_id, {
                    status: Number(data.status)
                });
                if (resp) this.loadPage(); // Show updated status
                return resp;
            };
            let ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length != 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para estornar", "Estorno de Sa\xedda");
            (0, $b60a2.default).edit((0, $b86df1d299d2d5ba$export$2e2bcd8739ae039), sendRequest, {
                company_id: ids[0][0],
                output_id: ids[0][1]
            });
        },
        async conferirSaida () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para conferir.", "Confer\xeancia de Sa\xedda");
            const [companyId, outputId] = ids[0];
            await (0, $2904a5446a687563$export$2e2bcd8739ae039)(companyId, outputId, ()=>this.loadPage());
        },
        async verDetalhesSaida () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para ver os detalhes.", "Detalhamento de Sa\xedda");
            const [companyId, outputId] = ids[0];
            await (0, $2de1ab652f37f03b$export$2e2bcd8739ae039)(companyId, outputId);
        },
        async gerarPedidoFalta () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para gerar o Pedido Falta.", 'Pedido Falta');
            const [companyId, outputId] = ids[0];
            // Carregar dados completos da saída para validar status e obter itens
            const output = await (0, $9VcS9.default).call((0, $9VcS9.default).select_output, companyId, outputId);
            if (!output) return;
            if (output.status !== 60) return (0, $jUNyh.notify)(`A sa\xedda #${outputId} precisa estar com status Conferida (60) para gerar Pedido Falta.\n` + `Status atual: ${output.status}.`, 'Pedido Falta');
            if (!output.order_id) return (0, $jUNyh.notify)(`A sa\xedda #${outputId} n\xe3o est\xe1 vinculada a um Pedido de Sa\xedda. Opera\xe7\xe3o n\xe3o dispon\xedvel.`, 'Pedido Falta');
            if (!(0, $8656f794cefc5b7a$export$b0c4e35941b023ed)(output.items)) return (0, $jUNyh.notify)(`A sa\xedda #${outputId} foi conferida sem faltas (todas as quantidades foram atendidas).\n` + `Pedido Falta n\xe3o \xe9 necess\xe1rio.`, 'Pedido Falta');
            (0, $8656f794cefc5b7a$export$68061872c81cf454)(companyId, parseInt(outputId, 10), output.order_id, output.items, ()=>this.loadPage());
        },
        async verSolicitacoesUnpicking () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para ver as solicita\xe7\xf5es de unpicking.", 'Unpicking');
            const [companyId, outputId] = ids[0];
            await (0, $f14ab0cf2acf9706$export$2bae321498b90267)(companyId, outputId);
        },
        async verCaixasPicking () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para ver as caixas de picking.", 'Caixas de Picking');
            const [companyId, outputId] = ids[0];
            await (0, $jU7Ru.openPickingBoxesForOutputModal)(companyId, outputId, ()=>this.loadPage());
        },
        async pickingSaida () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (ids.length !== 1) return (0, $jUNyh.notify)("Selecione apenas uma sa\xedda para realizar a separa\xe7\xe3o.", 'Picking');
            const [companyId, outputId] = ids[0];
            await (0, $54eda3acee877046$export$2e2bcd8739ae039)(companyId, outputId, ()=>this.loadPage());
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Sa\xedda",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "ID da sa\xedda f\xedsica (coluna Sa\xedda na grade). Para filtrar v\xe1rias sa\xeddas use este campo com Ou \u2014 n\xe3o confundir com Pedido."
        },
        {
            index: 4,
            field: 'order_id',
            label: 'Pedido',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "ID do pedido de sa\xedda (output_orders.id \u2014 coluna Pedido na grade). Valor num\xe9rico: 10545 ou 10.545 (vira 10545). N\xfamero externo do cliente vai em Refer\xeancia."
        },
        {
            index: 15,
            field: 'program_id',
            label: 'Programa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Programa da sa\xedda",
            store: 'programs',
            labels: [
                'name'
            ]
        },
        {
            index: 16,
            field: 'reference',
            label: "Refer\xeancia",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Refer\xeancia do pedido"
        },
        {
            index: 20,
            field: 'customer_id',
            label: 'Cliente',
            types: [
                $9PIz7.default()
            ],
            placeholder: 'Apelido ou CNPJ/CPF',
            title: "Cliente do pedido de sa\xedda",
            store: 'customers',
            labels: [
                'nick'
            ]
        },
        {
            index: 22,
            field: 'route_id',
            label: 'Rota',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Rota de entrega do cliente',
            store: 'customer_routes',
            labels: [
                'code',
                'name'
            ]
        },
        {
            index: 21,
            field: 'carrier_id',
            label: 'Transportador',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Transportador do pedido de sa\xedda",
            store: 'carriers',
            labels: [
                'nick'
            ]
        },
        {
            index: 3,
            field: 'order_type',
            label: 'Origem',
            types: [
                $e3d776cc66101a71$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: 'Origem do pedido vinculado'
        },
        {
            index: 5,
            field: 'created_on',
            label: "Cria\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da cria\xe7\xe3o da sa\xedda"
        },
        {
            index: 6,
            field: 'expedited_on',
            label: "Expedi\xe7\xe3o",
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora de expedi\xe7\xe3o da sa\xedda"
        },
        {
            index: 7,
            field: 'warehouse_company_id',
            label: 'Remetente',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Empresa do armaz\xe9m de coleta",
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 8,
            field: 'warehouse_id',
            label: "Armaz\xe9m",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Armaz\xe9m de coleta",
            store: 'warehouses',
            labels: [
                'name'
            ]
        },
        {
            index: 9,
            field: 'volume_type',
            label: 'Tipo Volume',
            types: [
                $e4pb7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de volume'
        },
        {
            index: 10,
            field: 'volumes',
            label: 'Volumes',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero de volumes"
        },
        {
            index: 11,
            field: 'weight',
            label: 'Peso',
            types: [
                $3eqAU.default(3)
            ],
            placeholder: '0,000',
            title: 'Peso total dos volumes'
        },
        {
            index: 12,
            field: 'total_cost',
            label: 'Custo Total',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "Custo total da sa\xedda"
        },
        {
            index: 13,
            field: 'total_price',
            label: "Pre\xe7o Total",
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "Pre\xe7o total da sa\xedda"
        },
        {
            index: 14,
            field: 'status',
            label: 'Status',
            types: [
                $f08968bc7ef228cb$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Status da sa\xedda"
        },
        {
            index: 25,
            field: 'is_emergency',
            label: 'Emergencial',
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Sa\xedda de pedido emergencial (#MT-8EF7902)"
        },
        {
            index: 18,
            field: 'lines_sku_summary',
            label: 'SKU (itens)',
            types: [],
            placeholder: 'trecho do SKU',
            title: "Busca nos SKUs das linhas da sa\xedda (operador Cont\xe9m recomendado)"
        },
        {
            index: 19,
            field: 'lines_product_summary',
            label: 'Produto (itens)',
            types: [],
            placeholder: 'nome do produto',
            title: "Busca nos nomes dos produtos das linhas (operador Cont\xe9m recomendado)"
        }
    ];
    let operations = [
        {
            hash: '#ver-detalhes-saida',
            label: "Detalhes&nbsp;da&nbsp;Sa\xedda"
        },
        {
            hash: '#gerar-pedido-falta',
            label: 'Gerar&nbsp;Pedido&nbsp;Falta'
        },
        {
            hash: '#ver-unpick-requests',
            label: "Solicita\xe7\xf5es&nbsp;de&nbsp;Unpicking"
        },
        {
            hash: '#ver-caixas-picking',
            label: 'Caixas&nbsp;de&nbsp;Picking'
        },
        {
            hash: '#picking-saida',
            label: 'Picking'
        },
        {
            hash: '#cancel-outputs',
            label: 'Cancelar&nbsp;Reservas'
        },
        {
            hash: '#create-invoices',
            label: 'Gerar&nbsp;notas&nbsp;fiscais'
        },
        {
            hash: '#close-outputs',
            label: 'Baixar&nbsp;Estoques'
        },
        {
            hash: '#send-to-dock-expedition',
            label: "Enviar&nbsp;para&nbsp;Doca&nbsp;Expedi\xe7\xe3o"
        },
        {
            hash: '#reverse-output',
            label: "Estornar&nbsp;Sa\xedda"
        },
        {
            hash: '#conferir-saida',
            label: "Conferir&nbsp;Sa\xedda"
        }
    ];
    let reports = [
        {
            hash: '#export-list-csv',
            label: 'Exportar&nbsp;listagem&nbsp;(CSV)'
        },
        {
            hash: '#export-items-csv',
            label: 'Exportar&nbsp;itens&nbsp;(CSV)'
        },
        {
            hash: '#print-control',
            label: 'Controle&nbsp;de&nbsp;Picking'
        },
        {
            hash: '#print-pallets',
            label: 'Derrubada&nbsp;de&nbsp;Pallets'
        },
        {
            hash: '#print-picklists',
            label: 'Pick&nbsp;Lists'
        },
        {
            hash: '#print-picklist-order',
            label: 'PickList&nbsp;-&nbsp;Ordem'
        },
        {
            hash: '#print-ar',
            label: 'Aviso&nbsp;de&nbsp;Remessa'
        },
        {
            hash: '#print-conference',
            label: "Confer\xeancia&nbsp;de&nbsp;Sa\xedda"
        },
        {
            hash: '#print-details',
            label: "Sa\xedda&nbsp;Detalhada"
        },
        {
            hash: '#print-balance-trace',
            label: 'Rastreio&nbsp;de&nbsp;Saldo'
        },
        {
            hash: '#print-labels',
            label: 'Etiquetas&nbsp;de&nbsp;Volumes'
        },
        {
            hash: '#print-stage-labels',
            label: "Etiqueta&nbsp;de&nbsp;Sa\xedda"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cancel-outputs', outputs_crud.cancelOutputs.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-invoices', outputs_crud.createInvoices.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#close-outputs', outputs_crud.closeOutputs.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#send-to-dock-expedition', outputs_crud.sendToDockExpedition.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#reverse-output', outputs_crud.reverseOutput.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#conferir-saida', outputs_crud.conferirSaida.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#ver-detalhes-saida', outputs_crud.verDetalhesSaida.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#gerar-pedido-falta', outputs_crud.gerarPedidoFalta.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#ver-unpick-requests', outputs_crud.verSolicitacoesUnpicking.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#ver-caixas-picking', outputs_crud.verCaixasPicking.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#picking-saida', outputs_crud.pickingSaida.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-list-csv', outputs_crud.exportListCsv.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-items-csv', outputs_crud.exportItemsCsv.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-control', outputs_crud.printPickControl.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-pallets', outputs_crud.printPalletsOverturn.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-picklists', outputs_crud.printPickLists.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-picklist-order', outputs_crud.printPickListOrder.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-ar', outputs_crud.printAvisoRemessa.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-conference', outputs_crud.printConference.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-details', outputs_crud.printDetails.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-balance-trace', outputs_crud.printBalanceTrace.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-labels', outputs_crud.printLabels.bind(outputs_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-stage-labels', outputs_crud.printStageLabels.bind(outputs_crud));
    outputs_crud.run('outputs', "Sa\xeddas", document.getElementById('workarea'), (0, $8263a0b89abdc114$export$2e2bcd8739ae039), record_output_form, fieldspecs, operations, reports);
};
var $9bfec621929b0c49$export$2e2bcd8739ae039 = $9bfec621929b0c49$var$outputs;


/**
 * Gestão de Caixas Picking — consulta, operação e auditoria.
 *
 * Permite abrir caixa, adicionar itens, lacrar, cancelar e detalhar.
 * Não movimenta estoque. Não altera PUT/PATCH legado nem ColetorPWA.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

/**
 * View (tabela de resultados) para a tela Gestão de Caixas Picking.
 */ 
var $jU7Ru = parcelRequire("jU7Ru");
const $b6a2e41359105336$var$STATUS_CLASS = {
    10: 'badge-open',
    20: 'badge-closed',
    30: 'badge-canceled'
};
async function $b6a2e41359105336$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)  { width: 1rem; }
			.view td:nth-child(2)  { text-align: left; max-width: 10rem; }
			.view td:nth-child(3)  { text-align: left; }
			.view td:nth-child(4)  { text-align: left; }
			.view td:nth-child(5)  { text-align: right; }
			.view td:nth-child(6)  { text-align: center; }
			.view td:nth-child(7)  { text-align: left; max-width: 10rem; }
			.view td:nth-child(8)  { text-align: center; }
			.view td:nth-child(9)  { text-align: center; }
			.view td:nth-child(10) { text-align: center; }
			.view td:nth-child(11) { text-align: right; }
			.view td:nth-child(12) { text-align: right; }
			.view td:nth-child(13) { text-align: center; }
			.badge-box { display:inline-block; padding:2px 7px; border-radius:3px;
				font-size:0.82em; font-weight:600; }
			.badge-open     { background:#d4edda; color:#155724; }
			.badge-closed   { background:#cce5ff; color:#004085; }
			.badge-canceled { background:#f8d7da; color:#721c24; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="0" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="1" data-visible="${this.visible[1]}">N\xba Caixa</th>
					<th data-index="2" data-visible="${this.visible[2]}">N\xba Lacre</th>
					<th data-index="3" data-visible="${this.visible[3]}">Sa\xedda</th>
					<th data-index="4" data-visible="${this.visible[4]}">Status</th>
					<th data-index="5" data-visible="${this.visible[5]}">Aberta por</th>
					<th data-index="8" data-visible="${this.visible[8]}">Aberta em</th>
					<th data-index="9" data-visible="${this.visible[9]}">Lacrada em</th>
					<th data-index="10" data-visible="${this.visible[10]}">Cancelada em</th>
					<th data-index="11" data-visible="${this.visible[11]}">Qtd.&nbsp;Itens</th>
					<th data-index="12" data-visible="${this.visible[12]}">Qtd.&nbsp;Total</th>
					<th>A\xe7\xf5es</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>{
        const rowId = JSON.stringify([
            record.company_id,
            record.output_id,
            record.id
        ]);
        const statusLabel = (0, $jU7Ru.STATUS_BOX_LABEL)[record.status] || record.status;
        const statusCls = $b6a2e41359105336$var$STATUS_CLASS[record.status] || '';
        const companyNick = await this.key('companies', record.company_id, 'nick') || '';
        const openedBy = record.opened_by_username || (record.opened_by ? await this.key('users', record.opened_by, 'username') || record.opened_by : '');
        const dataId = (0, $jU7Ru.escHtml)(JSON.stringify([
            record.company_id,
            record.output_id,
            record.id
        ]));
        const actionBtns = (0, $jU7Ru.renderBoxActionButtons)(record, dataId);
        return `<tr data-id='${(0, $jU7Ru.escHtml)(rowId)}'>
					<td><input type="checkbox"${this.isChecked(rowId)}></td>
					<td data-visible='${this.visible[0]}'>${(0, $jU7Ru.escHtml)(companyNick)}</td>
					<td data-visible='${this.visible[1]}'><a class="link-detail-box" data-id='${(0, $jU7Ru.escHtml)(rowId)}' href="#" style="cursor:pointer;color:inherit;text-decoration:underline dotted">${(0, $jU7Ru.escHtml)(record.code)}</a></td>
					<td data-visible='${this.visible[2]}'>${(0, $jU7Ru.escHtml)(record.seal_code || '')}</td>
					<td data-visible='${this.visible[3]}'>${record.output_id}</td>
					<td data-visible='${this.visible[4]}'><span class="badge-box ${statusCls}">${statusLabel}</span></td>
					<td data-visible='${this.visible[5]}'>${(0, $jU7Ru.escHtml)(openedBy)}</td>
					<td data-visible='${this.visible[8]}'>${(0, $jU7Ru.fmtDt)(record.opened_at)}</td>
					<td data-visible='${this.visible[9]}'>${(0, $jU7Ru.fmtDt)(record.closed_at)}</td>
					<td data-visible='${this.visible[10]}'>${(0, $jU7Ru.fmtDt)(record.canceled_at)}</td>
					<td data-visible='${this.visible[11]}'>${record.total_items}</td>
					<td data-visible='${this.visible[12]}'>${record.total_quantity}</td>
					<td style="white-space:nowrap">${actionBtns}</td>
				</tr>`;
    }))).join('') + `
			</tbody>
		</table>
	`;
}



var $9m9G5 = parcelRequire("9m9G5");
/**
 * Modal de geração do Relatório de Controle de Caixas de Picking.
 * Permite selecionar o formato (PDF / CSV) e aplicar filtros.
 */ var $113a3a97c5c59349$export$2e2bcd8739ae039 = {
    html: `
		<form id="picking-boxes-report-form" class="form" autocomplete="off">
			<p class="fss">Gera o relat\xf3rio de caixas de picking com os filtros selecionados abaixo.</p>

			<div class="fsb mtm">
				<label>Formato
					<select id="pkbox-rpt-format">
						<option value="pdf">PDF</option>
						<option value="csv">CSV (separador ;)</option>
					</select>
				</label>
			</div>

			<hr style="margin:1rem 0 0.75rem">
			<p class="fss" style="margin:0 0 0.5rem 0"><strong>Filtros</strong> (todos opcionais)</p>

			<div style="display:grid;grid-template-columns:1fr 1fr;gap:0.5rem 1rem;">
				<label class="fss">N\xba Caixa
					<input type="text" id="pkbox-rpt-code" maxlength="60" placeholder="parcial ou completo">
				</label>
				<label class="fss">N\xba Lacre
					<input type="text" id="pkbox-rpt-seal" maxlength="60" placeholder="parcial ou completo">
				</label>
				<label class="fss">N\xba Sa\xedda
					<input type="number" id="pkbox-rpt-output" min="1" step="1" placeholder="ID da sa\xedda">
				</label>
				<label class="fss">Status
					<select id="pkbox-rpt-status">
						<option value="">Todos</option>
						<option value="10">Aberta</option>
						<option value="20">Lacrada</option>
						<option value="30">Cancelada</option>
					</select>
				</label>
				<label class="fss">Abertura \u{2014} de
					<input type="date" id="pkbox-rpt-from">
				</label>
				<label class="fss">Abertura \u{2014} at\xe9
					<input type="date" id="pkbox-rpt-to">
				</label>
			</div>

			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#picking-boxes-report-form'
    },
    fields: [
        {
            properties: {
                selector: '#pkbox-rpt-format'
            },
            types: []
        },
        {
            properties: {
                selector: '#pkbox-rpt-code'
            },
            types: []
        },
        {
            properties: {
                selector: '#pkbox-rpt-seal'
            },
            types: []
        },
        {
            properties: {
                selector: '#pkbox-rpt-output'
            },
            types: []
        },
        {
            properties: {
                selector: '#pkbox-rpt-status'
            },
            types: []
        },
        {
            properties: {
                selector: '#pkbox-rpt-from'
            },
            types: []
        },
        {
            properties: {
                selector: '#pkbox-rpt-to'
            },
            types: []
        }
    ]
};



var $jU7Ru = parcelRequire("jU7Ru");

var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $8IFAz = parcelRequire("8IFAz");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
function $f810a2183d631f22$var$downloadFile(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(url);
}
function $f810a2183d631f22$var$isCountQuery(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    return qs.get('group') === 'count';
}
function $f810a2183d631f22$var$pageBounds(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    const limit = Number(qs.get('limit') || 30);
    const offset = Number(qs.get('offset') || 0);
    return {
        limit: Number.isFinite(limit) ? limit : 30,
        offset: Number.isFinite(offset) ? offset : 0
    };
}
function $f810a2183d631f22$var$filtersToParams(filterData) {
    const params = {};
    const top = 10;
    for(let i = 0; i < top; i++){
        const field = filterData?.[`field-${i}`];
        const value = filterData?.[`value-${i}`];
        if (!field || value == null || value === '') continue;
        if ([
            'company_id',
            'code',
            'seal_code',
            'output_id',
            'status',
            'user_id',
            'date_from',
            'date_to'
        ].includes(field)) params[field] = value;
    }
    return params;
}
const $f810a2183d631f22$var$outputPickingBoxes = function() {
    const boxes_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        _lastSearchKey: null,
        _lastSearchRows: null,
        async loadBaseData () {
            const [companies, users] = await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll())
            ]);
            await Promise.all([
                (0, $1cmSR.default).set('companies', companies || []).catch(()=>{}),
                (0, $1cmSR.default).set('users', users || []).catch(()=>{})
            ]);
        },
        async queryData (query) {
            const filterParams = $f810a2183d631f22$var$filtersToParams(this.filter || {});
            const companies = filterParams.company_id ? [
                {
                    id: filterParams.company_id
                }
            ] : await (0, $1cmSR.default).list('companies').catch(()=>[]);
            if (!companies.length) return $f810a2183d631f22$var$isCountQuery(query) ? 0 : [];
            const params = {
                code: filterParams.code || '',
                seal_code: filterParams.seal_code || '',
                output_id: filterParams.output_id || '',
                status: filterParams.status || '',
                user_id: filterParams.user_id || '',
                date_from: filterParams.date_from || '',
                date_to: filterParams.date_to || ''
            };
            const searchKey = JSON.stringify({
                companies: companies.map((c)=>c.id).sort(),
                params: params
            });
            let rows = this._lastSearchKey === searchKey && Array.isArray(this._lastSearchRows) ? this._lastSearchRows : null;
            if (!rows) {
                const lists = await Promise.all(companies.map(async (company)=>{
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).search_output_picking_boxes, company.id, params);
                    return data?.boxes || [];
                }));
                rows = lists.flat();
                this._lastSearchKey = searchKey;
                this._lastSearchRows = rows;
            }
            if ($f810a2183d631f22$var$isCountQuery(query)) return rows.length;
            const { limit: limit, offset: offset } = $f810a2183d631f22$var$pageBounds(query);
            return rows.slice(offset, offset + limit);
        },
        async loadRecord () {
            return {};
        },
        async saveRecord () {
            return {};
        },
        async reloadPage () {
            this._lastSearchKey = null;
            this._lastSearchRows = null;
            return Object.getPrototypeOf(this).reloadPage.call(this);
        },
        findBoxInCache (company_id, output_id, box_id) {
            return (this._lastSearchRows || []).find((r)=>String(r.company_id) === String(company_id) && Number(r.output_id) === Number(output_id) && String(r.id) === String(box_id)) || null;
        },
        async getSingleSelectedBox () {
            const ids = await this.getSelectedIds([
                'company_id',
                'output_id',
                'id'
            ]);
            if (ids.length !== 1) {
                (0, $jUNyh.notify)('Selecione exatamente uma caixa.', 'Caixas de Picking');
                return null;
            }
            const [company_id, output_id, id] = ids[0];
            const row = this.findBoxInCache(company_id, output_id, id);
            return {
                company_id: company_id,
                output_id: output_id,
                box_id: id,
                code: row?.code || String(id),
                status: row?.status != null ? Number(row.status) : null,
                total_items: row?.total_items ?? 0
            };
        },
        async pkboxDetail () {
            const sel = await this.getSingleSelectedBox();
            if (!sel) return;
            await (0, $9m9G5.default)(sel.company_id, sel.output_id, sel.box_id, ()=>this.reloadPage());
        },
        async pkboxAddItems () {
            const sel = await this.getSingleSelectedBox();
            if (!sel) return;
            if (sel.status !== 10) {
                (0, $jUNyh.notify)('Somente caixas abertas permitem adicionar itens.', 'Adicionar Itens');
                return;
            }
            await (0, $jU7Ru.openAddItemsModal)(sel.company_id, sel.output_id, sel.box_id, sel.code, ()=>this.reloadPage());
        },
        async pkboxClose () {
            const sel = await this.getSingleSelectedBox();
            if (!sel) return;
            if (sel.status !== 10) {
                (0, $jUNyh.notify)('Somente caixas abertas podem ser lacradas.', 'Lacrar Caixa');
                return;
            }
            (0, $jU7Ru.openCloseBoxModal)(sel.company_id, sel.output_id, sel.box_id, sel.code, Number(sel.total_items) || 0, ()=>this.reloadPage());
        },
        async pkboxCancel () {
            const sel = await this.getSingleSelectedBox();
            if (!sel) return;
            if (sel.status !== 10 && sel.status !== 20) {
                (0, $jUNyh.notify)('Somente caixas abertas ou lacradas podem ser canceladas.', 'Cancelar Caixa');
                return;
            }
            (0, $jU7Ru.openCancelBoxModal)(sel.company_id, sel.output_id, sel.box_id, sel.code, ()=>this.reloadPage());
        },
        async handleEvents (ev) {
            const detail = ev.target.closest?.('.link-detail-box, .btn-pkbox-detail');
            if (detail) {
                ev.preventDefault();
                try {
                    const [company_id, output_id, box_id] = JSON.parse(detail.getAttribute('data-id'));
                    await (0, $9m9G5.default)(company_id, output_id, box_id, ()=>boxes_crud.reloadPage());
                } catch (err) {
                    (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
                }
                return;
            }
            const addItems = ev.target.closest?.('.btn-pkbox-add-items');
            if (addItems) {
                ev.preventDefault();
                ev.stopPropagation();
                try {
                    const [company_id, output_id, box_id] = JSON.parse(addItems.getAttribute('data-id'));
                    const boxCode = addItems.getAttribute('data-code') || box_id;
                    await (0, $jU7Ru.openAddItemsModal)(company_id, output_id, box_id, boxCode, ()=>boxes_crud.reloadPage());
                } catch (err) {
                    (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
                }
                return;
            }
            const closeBox = ev.target.closest?.('.btn-pkbox-close');
            if (closeBox) {
                ev.preventDefault();
                ev.stopPropagation();
                try {
                    const [company_id, output_id, box_id] = JSON.parse(closeBox.getAttribute('data-id'));
                    const boxCode = closeBox.getAttribute('data-code') || box_id;
                    const itemCount = parseInt(closeBox.getAttribute('data-items') || '0', 10);
                    (0, $jU7Ru.openCloseBoxModal)(company_id, output_id, box_id, boxCode, itemCount, ()=>boxes_crud.reloadPage());
                } catch (err) {
                    (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
                }
                return;
            }
            const cancel = ev.target.closest?.('.btn-cancel-box, .btn-pkbox-cancel');
            if (cancel) {
                ev.preventDefault();
                ev.stopPropagation();
                try {
                    const [company_id, output_id, box_id] = JSON.parse(cancel.getAttribute('data-id'));
                    const row = cancel.closest('tr');
                    const boxCode = cancel.getAttribute('data-code') || row?.querySelector('.link-detail-box')?.textContent?.trim() || box_id;
                    (0, $jU7Ru.openCancelBoxModal)(company_id, output_id, box_id, boxCode, ()=>boxes_crud.reloadPage());
                } catch (err) {
                    (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
                }
                return;
            }
            if (ev.target.closest?.('tr[data-id]') && !ev.target.closest?.('input[type="checkbox"]')) return;
            const hashEl = ev.target.closest?.('[hash]');
            if (hashEl && hashEl.getAttribute('hash') === '#insert') return;
            Object.getPrototypeOf(this).handleEvents.call(this, ev);
        }
    });
    const fieldspecs = [
        {
            index: 0,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 1,
            field: 'code',
            label: "N\xba Caixa",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo da caixa"
        },
        {
            index: 2,
            field: 'seal_code',
            label: "N\xba Lacre",
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "C\xf3digo do lacre"
        },
        {
            index: 3,
            field: 'output_id',
            label: "N\xba Sa\xedda",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "ID da sa\xedda"
        },
        {
            index: 4,
            field: 'status',
            label: 'Status',
            types: [
                $30182bc541c1e6fe$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Status da caixa'
        },
        {
            index: 5,
            field: 'user_id',
            label: "Usu\xe1rio Picking",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Usu\xe1rio que abriu a caixa",
            store: 'users',
            labels: [
                'username'
            ]
        },
        {
            index: 6,
            field: 'date_from',
            label: 'Data inicial',
            types: [
                $b7D1Q.default()
            ],
            placeholder: 'dd/mm/aaaa',
            title: 'Abertura a partir de'
        },
        {
            index: 7,
            field: 'date_to',
            label: 'Data final',
            types: [
                $b7D1Q.default()
            ],
            placeholder: 'dd/mm/aaaa',
            title: "Abertura at\xe9"
        },
        {
            index: 8,
            field: 'opened_at',
            label: 'Aberta em',
            types: [
                $8IFAz.default()
            ],
            placeholder: '',
            title: 'Abertura da caixa'
        },
        {
            index: 9,
            field: 'closed_at',
            label: 'Lacrada em',
            types: [
                $8IFAz.default()
            ],
            placeholder: '',
            title: 'Lacre da caixa'
        },
        {
            index: 10,
            field: 'canceled_at',
            label: 'Cancelada em',
            types: [
                $8IFAz.default()
            ],
            placeholder: '',
            title: 'Cancelamento da caixa'
        },
        {
            index: 11,
            field: 'total_items',
            label: 'Qtd. Itens',
            types: [
                $3eqAU.default(0)
            ],
            placeholder: '0',
            title: 'Linhas na caixa'
        },
        {
            index: 12,
            field: 'total_quantity',
            label: 'Qtd. Total',
            types: [
                $3eqAU.default(0)
            ],
            placeholder: '0',
            title: 'Quantidade total na caixa'
        }
    ];
    const operations = [
        {
            hash: '#pkbox-detail',
            label: 'Detalhar&nbsp;Caixa'
        },
        {
            hash: '#pkbox-add-items',
            label: 'Adicionar&nbsp;Itens'
        },
        {
            hash: '#pkbox-close',
            label: 'Lacrar&nbsp;Caixa'
        },
        {
            hash: '#pkbox-cancel',
            label: 'Cancelar&nbsp;Caixa'
        },
        {
            hash: '#open-picking-box',
            label: 'Abrir&nbsp;Caixa'
        }
    ];
    const reports = [
        {
            hash: '#print-picking-boxes',
            label: 'Controle&nbsp;Caixas&nbsp;Picking'
        }
    ];
    function openPickingBoxFromGestao() {
        const parsedFilter = $f810a2183d631f22$var$filtersToParams(boxes_crud.filter || {});
        const companyId = parsedFilter.company_id;
        if (!companyId) {
            (0, $jUNyh.notify)('Selecione a empresa no filtro da tela antes de abrir uma caixa.', 'Abrir Caixa');
            return;
        }
        (0, $jU7Ru.openCreateBoxModal)(companyId, parsedFilter.output_id || null, ()=>boxes_crud.reloadPage(), {
            initialOutputId: parsedFilter.output_id || null
        });
    }
    function printPickingBoxes() {
        const parsedFilter = $f810a2183d631f22$var$filtersToParams(boxes_crud.filter || {});
        const companyId = parsedFilter.company_id;
        if (!companyId) {
            (0, $jUNyh.notify)("Selecione a empresa no filtro da tela antes de gerar o relat\xf3rio.", "Relat\xf3rio");
            return;
        }
        const f = parsedFilter;
        const initial = {
            'pkbox-rpt-format': 'pdf',
            'pkbox-rpt-code': f.code || '',
            'pkbox-rpt-seal': f.seal_code || '',
            'pkbox-rpt-output': f.output_id || '',
            'pkbox-rpt-status': f.status || '',
            'pkbox-rpt-from': f.date_from || '',
            'pkbox-rpt-to': f.date_to || ''
        };
        (0, $b60a2.default).edit((0, $113a3a97c5c59349$export$2e2bcd8739ae039), async (data)=>{
            const fmt = data['pkbox-rpt-format'] || 'pdf';
            const payload = {
                format: fmt,
                code: data['pkbox-rpt-code'] || null,
                seal_code: data['pkbox-rpt-seal'] || null,
                output_id: data['pkbox-rpt-output'] || null,
                status: data['pkbox-rpt-status'] || null,
                date_from: data['pkbox-rpt-from'] || null,
                date_to: data['pkbox-rpt-to'] || null
            };
            try {
                const resp = await (0, $9VcS9.default).report_output_picking_boxes(companyId, payload);
                const result = await resp.json();
                if (!resp.ok) {
                    (0, $jUNyh.notify)(result?.error || "Erro ao gerar relat\xf3rio.", 'Erro');
                    return;
                }
                if (fmt === 'pdf' && result.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(result.pdf);
                else if (fmt === 'csv' && result.csv) {
                    $f810a2183d631f22$var$downloadFile(result.csv, result.filename || 'caixas-picking.csv', 'text/csv;charset=utf-8');
                    (0, $jUNyh.notify)('Download iniciado.', 'Sucesso');
                } else (0, $jUNyh.notify)("Nenhum dado para o relat\xf3rio.", 'Aviso');
            } catch (err) {
                (0, $jUNyh.notify)(err?.message || String(err), 'Erro');
            }
        }, initial, false);
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#pkbox-detail', ()=>boxes_crud.pkboxDetail());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#pkbox-add-items', ()=>boxes_crud.pkboxAddItems());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#pkbox-close', ()=>boxes_crud.pkboxClose());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#pkbox-cancel', ()=>boxes_crud.pkboxCancel());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#open-picking-box', openPickingBoxFromGestao);
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-picking-boxes', printPickingBoxes);
    boxes_crud.run('output-picking-boxes', "Gest\xe3o de Caixas Picking", document.getElementById('workarea'), (0, $b6a2e41359105336$export$2e2bcd8739ae039), null, fieldspecs, operations, reports, {
        default_columns: '0,1,2,3,4,5,8,9,10,11,12'
    });
};
var $f810a2183d631f22$export$2e2bcd8739ae039 = $f810a2183d631f22$var$outputPickingBoxes;


/**
 * #MT-7546968 — Countback Picking: detalhe, liberação/cancelamento em lote e relatórios.
 * #MT-699B225 — evidência: a grade lista o histórico completo (todos os status).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $dx9qz = parcelRequire("dx9qz");

var $b60a2 = parcelRequire("b60a2");


var $jUNyh = parcelRequire("jUNyh");
/**
 * #MT-7546968 — view listagem Countback.
 * #MT-699B225 — evidência: histórico de todos os status (data/hora, posição, qtd,
 * operador, SKU, status) e quem liberou no saneamento.
 */ const $1c3e4e25b7fb317a$var$STATUS_CLASS = {
    OK: 'cb-ok',
    DIVERGENTE: 'cb-div',
    BLOQUEADO_AUDITORIA: 'cb-blk',
    LIBERADO_GESTOR: 'cb-lib',
    CANCELADO: 'cb-can'
};
function $1c3e4e25b7fb317a$var$esc(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $1c3e4e25b7fb317a$var$fmtDt(v) {
    if (!v) return '';
    try {
        const d = new Date(v);
        if (Number.isNaN(d.getTime())) return String(v);
        // Evidência de auditoria: mesmo segundo exibido no relatório.
        return d.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    } catch (_) {
        return String(v);
    }
}
async function $1c3e4e25b7fb317a$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view td { vertical-align: top; }
			.cb-badge { display:inline-block; padding:2px 7px; border-radius:3px;
				font-size:0.82em; font-weight:600; background:#e2e3e5; color:#383d41; }
			.cb-badge.cb-ok { background:#d4edda; color:#155724; }
			.cb-badge.cb-div { background:#fff3cd; color:#856404; }
			.cb-badge.cb-blk { background:#f8d7da; color:#721c24; }
			.cb-badge.cb-lib { background:#d1ecf1; color:#0c5460; }
			.cb-badge.cb-can { background:#e2e3e5; color:#383d41; }
			.bn_release_countback { cursor:pointer; }
			.view tr[data-id] { cursor:pointer; }
			.cb-prod { display:inline-block; max-width:16rem; overflow:hidden;
				text-overflow:ellipsis; white-space:nowrap; vertical-align:bottom; }
			.cb-note { max-width:18rem; white-space:normal; word-break:break-word; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th>Empresa</th>
					<th>Sa\xedda</th>
					<th>Pedido</th>
					<th>SKU / Produto</th>
					<th>Lote</th>
					<th>Posi\xe7\xe3o</th>
					<th>Qtd sep.</th>
					<th>Esperado</th>
					<th>Informado</th>
					<th>Dif.</th>
					<th>Tent.</th>
					<th>Operador</th>
					<th>Data/hora</th>
					<th>Status</th>
					<th>Resolvido por</th>
					<th>Resolvido em</th>
					<th>Observa\xe7\xe3o</th>
					<th>A\xe7\xf5es</th>
				</tr>
			</thead>
			<tbody>
			` + (records || []).map((r)=>{
        const companyNick = r.company_nick || r.company_id || '';
        const sku = r.product_sku || '';
        const pname = r.product_name || '';
        const prodText = sku ? `${sku} \u{2014} ${pname}` : pname || String(r.product_id || '');
        const prod = $1c3e4e25b7fb317a$var$esc(prodText);
        const blocked = r.status === 'BLOQUEADO_AUDITORIA';
        const badgeClass = $1c3e4e25b7fb317a$var$STATUS_CLASS[r.status] || '';
        // data-id sem esc() em aspas — JSON.parse no crud exige aspas literais
        const dataId = JSON.stringify([
            String(r.company_id),
            Number(r.id)
        ]);
        return `
				<tr data-id='${dataId.replace(/'/g, '&#39;')}'>
					<td><input type="checkbox"${this.isChecked(dataId)}></td>
					<td>${$1c3e4e25b7fb317a$var$esc(companyNick)}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.output_id)}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.order_id ?? '')}</td>
					<td><span class="cb-prod" title="${prod}">${prod}</span></td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.lot_number || r.lot_id || '')}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.location_code || r.location_id || '')}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.picked_quantity)}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.expected_remaining_quantity)}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.informed_remaining_quantity)}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.difference_quantity ?? '')}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.attempt_number)}</td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.operator_name || '')}</td>
					<td>${$1c3e4e25b7fb317a$var$esc($1c3e4e25b7fb317a$var$fmtDt(r.created_on))}</td>
					<td><span class="cb-badge ${badgeClass}">${$1c3e4e25b7fb317a$var$esc(r.status)}</span></td>
					<td>${$1c3e4e25b7fb317a$var$esc(r.resolved_by_name || '')}</td>
					<td>${$1c3e4e25b7fb317a$var$esc($1c3e4e25b7fb317a$var$fmtDt(r.resolved_at))}</td>
					<td class="cb-note">${$1c3e4e25b7fb317a$var$esc(r.resolution_note || '')}</td>
					<td>${blocked ? `
						<button type="button" class="button bn_release_countback"
							data-company-id="${$1c3e4e25b7fb317a$var$esc(r.company_id)}"
							data-countback-id="${$1c3e4e25b7fb317a$var$esc(r.id)}"
							title="Liberar continuidade"
							onclick="event.stopPropagation();window.__sialReleaseCountback&&window.__sialReleaseCountback(this.getAttribute('data-company-id'),this.getAttribute('data-countback-id'))">Liberar</button>
					` : ''}</td>
				</tr>`;
    }).join('') + `
			</tbody>
		</table>
	`;
}


/**
 * #MT-7546968 — modal detalhe Countback (consulta, padrão sial-detail).
 */ function $cdc1f56e3b342dde$var$syncCountbackDetail(root) {
    if (!root) return;
    root.querySelectorAll('[data-sdp-from]').forEach((dd)=>{
        const sel = dd.getAttribute('data-sdp-from');
        const el = root.querySelector(sel);
        let v = el ? el.value || el.textContent || '' : '';
        dd.textContent = v || "\u2014";
    });
    const title = root.querySelector('[data-sdp="product"]');
    const skuEl = root.querySelector('#cb_product_sku');
    const nameEl = root.querySelector('#cb_product_name');
    if (title) {
        const sku = skuEl?.value || '';
        const name = nameEl?.value || '';
        title.textContent = sku ? `${sku} \u{2014} ${name || "\u2014"}` : name || "\u2014";
    }
    const badge = root.querySelector('[data-sdp="status"]');
    const st = root.querySelector('#cb_status')?.value || '';
    if (badge) {
        badge.textContent = st || "\u2014";
        badge.className = 'sdp-badge';
        if (st === 'BLOQUEADO_AUDITORIA') badge.classList.add('sdp-badge--blocked');
        else if (st === 'LIBERADO_GESTOR' || st === 'OK') badge.classList.add('sdp-badge--free');
        else badge.classList.add('sdp-badge--other');
    }
    [
        'picked',
        'expected',
        'informed',
        'diff'
    ].forEach((k)=>{
        const src = root.querySelector(`#cb_${k === 'picked' ? 'picked_quantity' : k === 'expected' ? 'expected_remaining_quantity' : k === 'informed' ? 'informed_remaining_quantity' : 'difference_quantity'}`);
        const dst = root.querySelector(`[data-sdp="kpi-${k}"]`);
        if (dst) dst.textContent = src?.value ?? '0';
    });
    const histRaw = root.querySelector('#cb_history_json')?.value || '[]';
    const tbody = root.querySelector('#cb_history_body');
    if (!tbody) return;
    let hist = [];
    try {
        hist = JSON.parse(histRaw);
    } catch (_) {
        hist = [];
    }
    if (!Array.isArray(hist) || !hist.length) {
        tbody.innerHTML = '<tr><td colspan="6">Sem hist\xf3rico</td></tr>';
        return;
    }
    tbody.innerHTML = hist.map((h)=>{
        const dt = h.created_on ? new Date(h.created_on).toLocaleString('pt-BR') : '';
        return `<tr>
			<td>${h.attempt_number ?? ''}</td>
			<td>${h.status ?? ''}</td>
			<td>${h.picked_quantity ?? ''}</td>
			<td>${h.expected_remaining_quantity ?? ''}</td>
			<td>${h.informed_remaining_quantity ?? ''}</td>
			<td>${dt}</td>
		</tr>`;
    }).join('');
}
var $cdc1f56e3b342dde$export$2e2bcd8739ae039 = {
    html: `
		<form id="output-picking-countback-detail" class="form sial-modal-form sial-detail" autocomplete="off">
			<input type="hidden" id="company_id" class="sdp-bind">
			<input type="hidden" id="id" class="sdp-bind">
			<input type="hidden" id="cb_product_sku" class="sdp-bind">
			<input type="hidden" id="cb_product_name" class="sdp-bind">
			<input type="hidden" id="cb_status" class="sdp-bind">
			<input type="hidden" id="cb_picked_quantity" class="sdp-bind">
			<input type="hidden" id="cb_expected_remaining_quantity" class="sdp-bind">
			<input type="hidden" id="cb_informed_remaining_quantity" class="sdp-bind">
			<input type="hidden" id="cb_difference_quantity" class="sdp-bind">
			<input type="hidden" id="cb_output_id" class="sdp-bind">
			<input type="hidden" id="cb_order_id" class="sdp-bind">
			<input type="hidden" id="cb_lot_number" class="sdp-bind">
			<input type="hidden" id="cb_location_code" class="sdp-bind">
			<input type="hidden" id="cb_operator_name" class="sdp-bind">
			<input type="hidden" id="cb_created_on" class="sdp-bind">
			<input type="hidden" id="cb_attempt_number" class="sdp-bind">
			<input type="hidden" id="cb_resolution_note" class="sdp-bind">
			<input type="hidden" id="cb_resolved_by_name" class="sdp-bind">
			<input type="hidden" id="cb_resolved_at" class="sdp-bind">
			<input type="hidden" id="cb_company_nick" class="sdp-bind">
			<input type="hidden" id="cb_history_json" class="sdp-bind">
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon" aria-hidden="true">CB</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Detalhe Countback</p>
						<h2 class="sdp-title" data-sdp="product">\u{2014}</h2>
						<div class="sdp-meta">
							<span>Empresa: <b data-sdp-from="#cb_company_nick">\u{2014}</b></span>
							<span>Sa\xedda: <b data-sdp-from="#cb_output_id">\u{2014}</b></span>
							<span>Pedido: <b data-sdp-from="#cb_order_id">\u{2014}</b></span>
							<span>Status: <span class="sdp-badge sdp-badge--other" data-sdp="status">\u{2014}</span></span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">\xd7</button>
			</header>
			<section class="sdp-kpis" aria-label="Resumo Countback">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">Qtd. separada</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-picked">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">Esperado restante</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-expected">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">Informado</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-informed">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--blocked">
					<div class="sdp-kpi-label">Diferen\xe7a</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-diff">0</span></div>
				</div>
			</section>
			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Ocorr\xeancia</h3>
					<dl class="sdp-dl">
						<dt>Tentativa</dt><dd data-sdp-from="#cb_attempt_number"></dd>
						<dt>Lote</dt><dd data-sdp-from="#cb_lot_number"></dd>
						<dt>Posi\xe7\xe3o</dt><dd data-sdp-from="#cb_location_code"></dd>
						<dt>Operador</dt><dd data-sdp-from="#cb_operator_name"></dd>
						<dt>Data/hora</dt><dd data-sdp-from="#cb_created_on"></dd>
					</dl>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">Resolu\xe7\xe3o</h3>
					<dl class="sdp-dl">
						<dt>Resolvido por</dt><dd data-sdp-from="#cb_resolved_by_name"></dd>
						<dt>Resolvido em</dt><dd data-sdp-from="#cb_resolved_at"></dd>
						<dt>Observa\xe7\xe3o</dt><dd data-sdp-from="#cb_resolution_note"></dd>
					</dl>
				</div>
			</section>
			<section class="sdp-block" style="margin-top:0.75rem">
				<h3 class="sdp-block-title">Hist\xf3rico de tentativas</h3>
				<table class="view" style="width:100%;font-size:0.9em">
					<thead>
						<tr>
							<th>Tent.</th><th>Status</th><th>Sep.</th><th>Esp.</th><th>Inf.</th><th>Quando</th>
						</tr>
					</thead>
					<tbody id="cb_history_body"></tbody>
				</table>
			</section>
			<div class="sdp-foot">
				<button type="button" class="bn_Escape button">Fechar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#output-picking-countback-detail',
        async afterEditSetValues () {
            const root = document.querySelector('#output-picking-countback-detail');
            $cdc1f56e3b342dde$var$syncCountbackDetail(root);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_product_sku'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_product_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_status'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_picked_quantity'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_expected_remaining_quantity'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_informed_remaining_quantity'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_difference_quantity'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_order_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_lot_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_location_code'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_operator_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_created_on'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_attempt_number'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_resolution_note'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_resolved_by_name'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_resolved_at'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_company_nick'
            },
            types: []
        },
        {
            properties: {
                selector: '#cb_history_json'
            },
            types: []
        }
    ]
};


/**
 * #MT-7546968 — modal gerar relatório Countback (PDF / CSV / Excel).
 */ var $f37e53040ab61200$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#countback-report-form label { display:block; margin-top:0.55rem; }
			#countback-report-form input, #countback-report-form select { width:100%; max-width:16rem; }
			#countback-report-form .row2 { display:flex; gap:1rem; flex-wrap:wrap; }
			#countback-report-form .row2 label { flex:1; min-width:10rem; }
		</style>
		<form id="countback-report-form" class="form" autocomplete="off">
			<div class="title">Relat\xf3rio Countback</div>
			<p class="fss">Escolha formato e filtros. Os filtros da grade (SKU, lote, posi\xe7\xe3o, operador, pedido, datas) tamb\xe9m s\xe3o aplicados. Se houver linhas selecionadas na grade, use a op\xe7\xe3o abaixo.</p>
			<label>Formato
				<select id="format">
					<option value="pdf">PDF</option>
					<option value="csv">CSV</option>
					<option value="xlsx">Excel</option>
				</select>
			</label>
			<label>Status
				<select id="status">
					<option value="">Todos</option>
					<option value="BLOQUEADO_AUDITORIA">Bloqueado (auditoria)</option>
					<option value="LIBERADO_GESTOR">Liberado</option>
					<option value="CANCELADO">Cancelado</option>
					<option value="DIVERGENTE">Divergente</option>
					<option value="OK">OK</option>
				</select>
			</label>
			<label>Sa\xedda (n\xba)
				<input type="number" id="output_id" min="1" step="1" placeholder="Opcional">
			</label>
			<div class="row2">
				<label>Data de
					<input type="date" id="date_from">
				</label>
				<label>Data at\xe9
					<input type="date" id="date_to">
				</label>
			</div>
			<label class="mtm" style="display:flex;align-items:center;gap:0.5rem;max-width:none">
				<input type="checkbox" id="use_selection" style="width:auto">
				<span>Usar apenas linhas selecionadas na grade</span>
			</label>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#countback-report-form'
    },
    fields: [
        {
            properties: {
                selector: '#format'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#output_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: []
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: []
        },
        {
            properties: {
                selector: '#use_selection'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
/** Teto de registros que a grade consegue juntar/ordenar com várias empresas. */ const $94df30eeff58fec0$var$MAX_MERGE = 500;
function $94df30eeff58fec0$var$isCountQuery(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    return qs.get('group') === 'count';
}
function $94df30eeff58fec0$var$pageBounds(query) {
    const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
    const limit = Number(qs.get('limit') || 50);
    const offset = Number(qs.get('offset') || 0);
    return {
        limit: Number.isFinite(limit) ? limit : 50,
        offset: Number.isFinite(offset) ? offset : 0
    };
}
function $94df30eeff58fec0$var$downloadFile(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'arquivo';
    a.click();
    URL.revokeObjectURL(a.href);
}
/** Campo do filtro (fieldspec) → parâmetro da API de evidência. */ const $94df30eeff58fec0$var$FILTER_FIELD_TO_PARAM = {
    output_id: 'output_id',
    order_id: 'order_id',
    product_sku: 'sku',
    lot_number: 'lot',
    location_code: 'location',
    operator_name: 'operator',
    status: 'status'
};
/**
 * Converte o filtro da grade ({field-N, operator-N, value-N}) em filtros da API.
 * @param {object} f Filtro do crud.
 * @returns {{company_id: string, params: object}}
 */ function $94df30eeff58fec0$var$filtersFromCrudFilter(f) {
    const params = {};
    let company_id = '';
    for (const key of Object.keys(f || {})){
        const match = /^field-(\d+)$/.exec(key);
        if (!match) continue;
        const idx = match[1];
        const field = f[`field-${idx}`];
        const operator = f[`operator-${idx}`] || 'eq';
        const value = String(f[`value-${idx}`] ?? '').trim();
        if (!field || !value) continue;
        if (field === 'company_id') {
            company_id = value;
            continue;
        }
        if (field === 'created_on') {
            if (operator === 'ge' || operator === 'gt') params.date_from = value;
            else if (operator === 'le' || operator === 'lt') params.date_to = value;
            else if (operator === 'eq') {
                params.date_from = value;
                params.date_to = value;
            }
            continue;
        }
        const param = $94df30eeff58fec0$var$FILTER_FIELD_TO_PARAM[field];
        if (param) params[param] = value;
    }
    return {
        company_id: company_id,
        params: params
    };
}
function $94df30eeff58fec0$var$groupIdsByCompany(selected) {
    const map = new Map();
    for (const row of selected || []){
        const cid = Array.isArray(row) ? row[0] : row?.company_id;
        const id = Number(Array.isArray(row) ? row[1] : row?.id);
        if (!cid || !Number.isFinite(id)) continue;
        if (!map.has(cid)) map.set(cid, []);
        map.get(cid).push(id);
    }
    return map;
}
function $94df30eeff58fec0$var$askNoteDialog({ title: title, help: help, confirmLabel: confirmLabel, onConfirm: onConfirm }) {
    const html = `
		<div class="msgbox" style="min-width:360px;max-width:520px">
			<div class="mb-title">${title}</div>
			<div class="mb-text">
				<p style="margin:0 0 0.75rem">${help}</p>
				<label>Observa\xe7\xe3o (obrigat\xf3ria)
					<textarea id="cb_batch_note" rows="3" style="width:100%"></textarea>
				</label>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">${confirmLabel}</button>
		</div>
	`;
    const dlg = (0, $dx9qz.default).create(html, async (key)=>{
        if (key === 'Escape' || key === 'N') {
            dlg.destroy();
            return;
        }
        if (key === 'Y') {
            const note = (document.getElementById('cb_batch_note')?.value || '').trim();
            if (!note) {
                (0, $jUNyh.notify)("Informe a observa\xe7\xe3o.", 'Countback');
                return;
            }
            dlg.destroy();
            await onConfirm(note);
        }
    }, /Escape|N|Y/);
}
const $94df30eeff58fec0$var$outputPickingCountbacks = function() {
    // #MT-699B225 — padrão: evidência (histórico). Alterna para fila de auditoria.
    let only_pendencies = false;
    const countbacks_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            const companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll());
            await (0, $1cmSR.default).set('companies', companies || []).catch(()=>{});
        },
        /** Empresas no escopo do filtro (todas quando sem filtro de empresa). */ async scopedCompanies (company_id) {
            let companies = await (0, $1cmSR.default).list('companies').catch(()=>[]);
            if (!companies?.length) {
                // Sem a lista de empresas não há como consultar o histórico (a rota é por
                // empresa). Tenta de novo e avisa — senão a grade fica vazia sem explicação.
                companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).catch(()=>[]);
                if (companies?.length) await (0, $1cmSR.default).set('companies', companies).catch(()=>{});
            }
            if (!companies?.length) {
                (0, $jUNyh.notify)("N\xe3o foi poss\xedvel carregar as empresas. Entre novamente no sistema; se continuar, pe\xe7a ao administrador a permiss\xe3o de Empresas.", 'Countback');
                return [];
            }
            if (!company_id) return companies;
            return companies.filter((c)=>String(c.id) === String(company_id));
        },
        async queryData (query) {
            const { company_id: company_id, params: params } = $94df30eeff58fec0$var$filtersFromCrudFilter(this.filter);
            const companies = await this.scopedCompanies(company_id);
            if (!companies.length) return $94df30eeff58fec0$var$isCountQuery(query) ? 0 : [];
            const base = {
                ...params
            };
            if (only_pendencies) base.only_pendencies = 1;
            if ($94df30eeff58fec0$var$isCountQuery(query)) {
                let total = 0;
                for (const c of companies)try {
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_countbacks, c.id, {
                        ...base,
                        group: 'count'
                    });
                    total += Number(resp?.count || 0);
                } catch (_) {
                /* empresa sem ACL / sem Countback — ignora */ }
                return total;
            }
            const { limit: limit, offset: offset } = $94df30eeff58fec0$var$pageBounds(query);
            // Uma empresa: pagina no servidor. Várias: junta as páginas e ordena aqui,
            // o que só é possível até MAX_MERGE registros.
            const single = companies.length === 1;
            if (!single && offset + limit > $94df30eeff58fec0$var$MAX_MERGE) {
                (0, $jUNyh.notify)(`Para navegar al\xe9m de ${$94df30eeff58fec0$var$MAX_MERGE} registros, filtre por empresa.`, 'Countback');
                return [];
            }
            const all = [];
            for (const c of companies)try {
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).list_output_countbacks, c.id, {
                    ...base,
                    limit: single ? limit : Math.min(offset + limit, $94df30eeff58fec0$var$MAX_MERGE),
                    offset: single ? offset : 0
                });
                const items = Array.isArray(resp?.items) ? resp.items : [];
                for (const it of items)all.push({
                    ...it,
                    company_id: c.id,
                    company_nick: c.nick || c.name || c.id
                });
            } catch (e) {
                // empresa sem ACL / sem Countback — não interrompe as demais
                console.warn('Countback: falha ao listar empresa', c.nick || c.id, e);
            }
            all.sort((a, b)=>String(b.created_on || '').localeCompare(String(a.created_on || '')));
            return single ? all : all.slice(offset, offset + limit);
        },
        async loadRecord (rawId) {
            try {
                const [companyId, countbackId] = JSON.parse(rawId);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).get_output_countback, companyId, countbackId);
                const item = resp?.item || {};
                const history = Array.isArray(resp?.history) ? resp.history : [];
                if (!item.id) {
                    (0, $jUNyh.notify)("Ocorr\xeancia n\xe3o encontrada.", 'Countback');
                    return null;
                }
                return {
                    company_id: companyId,
                    id: item.id,
                    cb_company_nick: item.company_nick || '',
                    cb_product_sku: item.product_sku || '',
                    cb_product_name: item.product_name || '',
                    cb_status: item.status || '',
                    cb_picked_quantity: item.picked_quantity ?? '',
                    cb_expected_remaining_quantity: item.expected_remaining_quantity ?? '',
                    cb_informed_remaining_quantity: item.informed_remaining_quantity ?? '',
                    cb_difference_quantity: item.difference_quantity ?? '',
                    cb_output_id: item.output_id ?? '',
                    cb_order_id: item.order_id ?? '',
                    cb_lot_number: item.lot_number || '',
                    cb_location_code: item.location_code || '',
                    cb_operator_name: item.operator_name || '',
                    cb_created_on: item.created_on ? new Date(item.created_on).toLocaleString('pt-BR') : '',
                    cb_attempt_number: item.attempt_number ?? '',
                    cb_resolution_note: item.resolution_note || '',
                    cb_resolved_by_name: item.resolved_by_name || '',
                    cb_resolved_at: item.resolved_at ? new Date(item.resolved_at).toLocaleString('pt-BR') : '',
                    cb_history_json: JSON.stringify(history)
                };
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao abrir detalhe Countback');
                return null;
            }
        },
        async saveRecord () {
            return false;
        },
        async afterLoad () {
            window.__sialReleaseCountback = (companyId, countbackId)=>{
                this.releaseCountback(companyId, countbackId);
            };
        },
        releaseCountback (companyId, countbackId) {
            $94df30eeff58fec0$var$askNoteDialog({
                title: 'Liberar Countback',
                help: "Libera a continuidade da separa\xe7\xe3o no Coletor para esta ocorr\xeancia. N\xe3o altera estoque.",
                confirmLabel: 'Liberar',
                onConfirm: async (note)=>{
                    try {
                        await (0, $9VcS9.default).call((0, $9VcS9.default).release_output_countback, companyId, countbackId, {
                            resolution_note: note
                        });
                        (0, $jUNyh.notify)('Countback liberado.', 'Countback');
                        this.loadPage();
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro ao liberar Countback');
                    }
                }
            });
        },
        async releaseSelectedBatch () {
            if (!this.ensureSelection('Liberar selecionados')) return;
            const selected = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selected.length) return;
            if (selected.length > 50) {
                (0, $jUNyh.notify)("Selecione no m\xe1ximo 50 linhas por vez.", 'Countback');
                return;
            }
            $94df30eeff58fec0$var$askNoteDialog({
                title: 'Liberar selecionados',
                help: `Aprova\xe7\xe3o em lote de <b>${selected.length}</b> pend\xeancia(s). O Coletor poder\xe1 retomar o Countback nesses itens.`,
                confirmLabel: 'Liberar lote',
                onConfirm: async (note)=>{
                    const byCompany = $94df30eeff58fec0$var$groupIdsByCompany(selected);
                    let ok = 0;
                    let skip = 0;
                    let fail = 0;
                    try {
                        for (const [companyId, ids] of byCompany.entries()){
                            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).release_output_countback_batch, companyId, {
                                ids: ids,
                                resolution_note: note
                            });
                            ok += Number(resp?.released_count || 0);
                            skip += Number(resp?.skipped_count || 0);
                            fail += Number(resp?.failed_count || 0);
                        }
                        (0, $jUNyh.notify)(`Liberados: ${ok}. Ignorados: ${skip}. Falhas: ${fail}.`, "Countback \u2014 libera\xe7\xe3o em lote");
                        this.clearGridSelection?.();
                        this.loadPage();
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), "Erro na libera\xe7\xe3o em lote");
                    }
                }
            });
        },
        async cancelSelectedBatch () {
            if (!this.ensureSelection('Bloquear / cancelar selecionados')) return;
            const selected = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!selected.length) return;
            if (selected.length > 50) {
                (0, $jUNyh.notify)("Selecione no m\xe1ximo 50 linhas por vez.", 'Countback');
                return;
            }
            $94df30eeff58fec0$var$askNoteDialog({
                title: 'Bloquear / cancelar selecionados',
                help: `Encerra <b>${selected.length}</b> pend\xeancia(s) como <b>CANCELADO</b> (n\xe3o libera o Coletor). Use quando a auditoria decide n\xe3o autorizar continuidade.`,
                confirmLabel: 'Cancelar lote',
                onConfirm: async (note)=>{
                    const byCompany = $94df30eeff58fec0$var$groupIdsByCompany(selected);
                    let ok = 0;
                    let skip = 0;
                    let fail = 0;
                    try {
                        for (const [companyId, ids] of byCompany.entries()){
                            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).cancel_output_countback_batch, companyId, {
                                ids: ids,
                                resolution_note: note
                            });
                            ok += Number(resp?.cancelled_count || 0);
                            skip += Number(resp?.skipped_count || 0);
                            fail += Number(resp?.failed_count || 0);
                        }
                        (0, $jUNyh.notify)(`Cancelados: ${ok}. Ignorados: ${skip}. Falhas: ${fail}.`, "Countback \u2014 bloqueio em lote");
                        this.clearGridSelection?.();
                        this.loadPage();
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro no cancelamento em lote');
                    }
                }
            });
        },
        async openReportModal () {
            const crudRef = this;
            (0, $b60a2.default).edit((0, $f37e53040ab61200$export$2e2bcd8739ae039), async (data)=>{
                const format = data.format || 'pdf';
                const useSelection = data.use_selection === true || data.use_selection === '1' || data.use_selection === 'on';
                let byCompany = new Map();
                if (useSelection) {
                    const selected = await crudRef.getSelectedIds([
                        'company_id',
                        'id'
                    ]);
                    if (!selected.length) {
                        (0, $jUNyh.notify)("Marque linhas na grade ou desmarque \xabusar selecionadas\xbb.", 'Countback');
                        return false;
                    }
                    byCompany = $94df30eeff58fec0$var$groupIdsByCompany(selected);
                } else {
                    const companies = await (0, $1cmSR.default).list('companies').catch(()=>[]);
                    for (const c of companies || [])byCompany.set(c.id, null);
                }
                // #MT-699B225 — o export herda os filtros da grade; o modal sobrepõe.
                const { params: gridParams } = $94df30eeff58fec0$var$filtersFromCrudFilter(crudRef.filter);
                try {
                    let generated = 0;
                    let emptyCompanies = 0;
                    for (const [companyId, ids] of byCompany.entries()){
                        const body = {
                            ...gridParams,
                            format: format,
                            only_pendencies: only_pendencies ? 1 : '',
                            status: data.status || gridParams.status || '',
                            output_id: data.output_id || gridParams.output_id || '',
                            date_from: data.date_from || gridParams.date_from || '',
                            date_to: data.date_to || gridParams.date_to || ''
                        };
                        if (ids) body.ids = ids;
                        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).report_output_countbacks, companyId, body);
                        if (resp?.empty) {
                            emptyCompanies += 1;
                            continue;
                        }
                        if (resp?.pdf) {
                            (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                            generated += 1;
                        } else if (resp?.csv) {
                            $94df30eeff58fec0$var$downloadFile(resp.csv, resp.filename || 'countback.csv', 'text/csv;charset=utf-8');
                            generated += 1;
                        } else if (resp?.xlsx) {
                            $94df30eeff58fec0$var$downloadFile(resp.xlsx, resp.filename || 'countback.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            generated += 1;
                        }
                    }
                    if (generated > 0) {
                        (0, $jUNyh.notify)(generated === 1 ? "Relat\xf3rio gerado." : `${generated} relat\xf3rios gerados.`, 'Countback');
                        return true;
                    }
                    (0, $jUNyh.notify)(emptyCompanies ? 'Nenhum registro de Countback para os filtros informados.' : "N\xe3o foi poss\xedvel gerar o relat\xf3rio.", 'Countback');
                    return false;
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), "Erro ao gerar relat\xf3rio");
                    return false;
                }
            }, {}, false);
        }
    });
    const fieldspecs = [
        {
            index: 0,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 1,
            field: 'output_id',
            label: "Sa\xedda",
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 2,
            field: 'status',
            label: 'Status',
            types: [],
            title: 'OK, DIVERGENTE, BLOQUEADO_AUDITORIA, LIBERADO_GESTOR ou CANCELADO'
        },
        {
            index: 3,
            field: 'order_id',
            label: 'Pedido',
            types: [
                $3eqAU.default(0)
            ]
        },
        {
            index: 4,
            field: 'product_sku',
            label: 'SKU',
            types: [
                $74yTJ.default()
            ],
            title: "C\xf3digo SKU do produto (Cont\xe9m)"
        },
        {
            index: 5,
            field: 'lot_number',
            label: 'Lote',
            types: [
                $74yTJ.default()
            ]
        },
        {
            index: 6,
            field: 'location_code',
            label: "Posi\xe7\xe3o",
            types: [
                $74yTJ.default()
            ],
            title: "Endere\xe7o da posi\xe7\xe3o (ex.: 1-C-20-4)"
        },
        {
            index: 7,
            field: 'operator_name',
            label: 'Operador',
            types: [
                $74yTJ.default()
            ]
        },
        {
            index: 8,
            field: 'created_on',
            label: 'Data/hora',
            types: [
                $8IFAz.default()
            ],
            title: 'Data do Countback'
        }
    ];
    const operations = [
        {
            hash: '#release-countback-batch',
            label: 'Liberar&nbsp;selecionados'
        },
        {
            hash: '#cancel-countback-batch',
            label: 'Bloquear&nbsp;/&nbsp;cancelar&nbsp;selecionados'
        },
        {
            hash: '#toggle-countback-pendencies',
            label: "Evid\xeancia&nbsp;/&nbsp;s\xf3&nbsp;pend\xeancias"
        }
    ];
    const reports = [
        {
            hash: '#export-countbacks',
            label: 'Exportar&nbsp;(PDF/CSV/Excel)'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#release-countback-batch', ()=>countbacks_crud.releaseSelectedBatch());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cancel-countback-batch', ()=>countbacks_crud.cancelSelectedBatch());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#export-countbacks', ()=>countbacks_crud.openReportModal());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#toggle-countback-pendencies', ()=>{
        only_pendencies = !only_pendencies;
        (0, $jUNyh.notify)(only_pendencies ? "Mostrando s\xf3 as pend\xeancias abertas de auditoria." : "Mostrando a evid\xeancia: hist\xf3rico de todos os Countbacks.", 'Countback');
        countbacks_crud.page_number = 1;
        countbacks_crud.clearGridSelection?.();
        countbacks_crud.loadPage();
    });
    countbacks_crud.run('output-picking-countbacks', 'Countback Picking', document.getElementById('workarea'), (0, $1c3e4e25b7fb317a$export$2e2bcd8739ae039), (0, $cdc1f56e3b342dde$export$2e2bcd8739ae039), fieldspecs, operations, reports, {
        default_columns: '0,1,2'
    });
    window.__sialReleaseCountback = (companyId, countbackId)=>{
        countbacks_crud.releaseCountback(companyId, countbackId);
    };
};
var $94df30eeff58fec0$export$2e2bcd8739ae039 = $94df30eeff58fec0$var$outputPickingCountbacks;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $aGGTj = parcelRequire("aGGTj");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $3eqAU = parcelRequire("3eqAU");
async function $561045a268ce7b0e$export$2e2bcd8739ae039(records) {
    const dataId = (r)=>r._source === 'customer' ? JSON.stringify([
            r.company_id,
            r.id,
            'customer'
        ]) : JSON.stringify([
            r.company_id,
            r.id
        ]);
    const listCol = (r)=>r._source === 'customer' ? r.lista_display || r.name : r.id;
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: right; }
			.view td:nth-child(6)	{ text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lista</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="5" data-visible="${this.visible[4]}">Qtd SKUs</th>
					<th data-index="4" data-visible="${this.visible[3]}">% Desconto</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${dataId(record)}'>
					<td><input type="checkbox"${this.isChecked(dataId(record))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${listCol(record)}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
					<td data-visible='${this.visible[4]}'>${record.sku_count ?? ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($3eqAU.default(2), record.avg_discount ?? record.discount)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $dg8P2 = parcelRequire("dg8P2");
var $6lTH5 = parcelRequire("6lTH5");
var $6Jl4s = parcelRequire("6Jl4s");
var $d8f38d8e6e0f5615$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#price-list #company_id		{ width: 10rem;	}
			#price-list #customer_id		{ width: 15rem;	}
			#price-list #id				{ width: 4.5rem; text-align: right;	}
			#price-list #name			{ width: 25rem;	}
			#price-list #discount		{ width: 4.5rem; text-align: right;	}
			#price-list .product 		{ width: 35rem; }
			#price-list .discount		{ width: 4.5rem; text-align: right;	}
			#price-list .unit_price		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="price-list" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="customers"></datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Cliente (tabela por cliente)">Cliente
					<input id="customer_id" type="text" list="customers">
				</label>
				<label title="Identificador da lista de pre\xe7os">Lista
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da lista de pre\xe7os">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Desconto geral sobre o pedido">% Desc
					<input id="discount" type="text">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>% Desc</th>
							<th>Pre\xe7o<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Desconto espec\xedfico sobre o item">
								<input id="discount-0" class="discount" type="text">
							</td>
							<td title="Pre\xe7o unit\xe1rio do produto">
								<input id="unit_price-0" class="unit_price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#price-list',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            formset.loadList('#customers', 'customers', {
                labels: [
                    'name',
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#customer_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#discount'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#product_id-0'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $6lTH5.default('company_id'),
                $dg8P2.default('products', {
                    labels: [
                        'sku',
                        'name'
                    ]
                })
            ]
        },
        {
            properties: {
                selector: '#discount-0'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#unit_price-0'
            },
            types: [
                $3eqAU.default(2)
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
const $5f8cf8bc5abf9d48$var$price_lists = function() {
    let price_lists_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, this.queryAll()).then((data)=>(0, $1cmSR.default).set('customers', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            const q = (query || '').includes('?') ? `${query}&combined=1` : `${query || ''}?combined=1`;
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_price_lists, q);
        },
        async loadRecord (id) {
            const arr = JSON.parse(id);
            if (arr[2] === 'customer') return null;
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_price_list, arr[0], arr[1]);
            return (0, $b60a2.flatten)(_record, 'prices');
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'prices');
            let _record = {
                name: data.name,
                discount: Number(data.discount),
                prices: data.prices.map((entry)=>({
                        product_id: Number(entry.product_id),
                        discount: Number(entry.discount),
                        unit_price: Number(entry.unit_price)
                    }))
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_price_list, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_price_list, data.company_id, _record);
        },
        handleEvents (ev) {
            let submenu, header, record;
            if (submenu = (0, $aGGTj.findByAttr)(ev.target, 'hash')) (0, $a020c0121b2250d6$export$2e2bcd8739ae039).route(submenu.getAttribute('hash'));
            else if (header = (0, $aGGTj.findByAttr)(ev.target, 'data-index')) this.sortPage(header.getAttribute('data-index'));
            else if (record = (0, $aGGTj.findByAttr)(ev.target, 'data-id')) {
                ev.stopPropagation(); // Evita que handlers de outros cruds na workarea (ex: grupos) tratem o clique
                try {
                    const id = JSON.parse(record.getAttribute('data-id'));
                    if (id[2] === 'customer') {
                        $5f8cf8bc5abf9d48$var$_showCustomerPriceDetail(id[0], id[1], this);
                        return;
                    }
                } catch (_) {}
                this.loadRecord(record.getAttribute('data-id')).then((data)=>data != null && this.editRecord.call(this, data));
            }
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Lista',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador da lista'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome da lista'
        },
        {
            index: 4,
            field: 'avg_discount',
            label: '% Desconto',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "M\xe9dia percentual de desconto"
        },
        {
            index: 5,
            field: 'sku_count',
            label: 'Qtd SKUs',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade de SKUs'
        }
    ];
    const workarea = document.getElementById('workarea');
    workarea.innerHTML = '';
    const wrapper = document.createElement('div');
    wrapper.className = 'price-lists-wrapper';
    const panel = document.createElement('div');
    panel.className = 'customer-prices-panel fsb fac mtm mbm';
    panel.innerHTML = `
		<fieldset class="customer-prices-fieldset">
			<legend>Tabela de pre\xe7o por cliente</legend>
			<label>Empresa <input id="cp_company_id" type="text" list="cp_companies"></label>
			<label>Cliente <input id="cp_customer_id" type="text" list="cp_customers"></label>
			<datalist id="cp_companies"></datalist>
			<datalist id="cp_customers"></datalist>
			<button type="button" class="bn_cp_download button">Baixar modelo CSV</button>
			<button type="button" class="bn_cp_import button">Importar CSV</button>
			<input type="file" id="cp_file_input" accept=".csv" style="display:none">
		</fieldset>
	`;
    wrapper.appendChild(panel);
    const crudContainer = document.createElement('div');
    wrapper.appendChild(crudContainer);
    workarea.appendChild(wrapper);
    let operations = [
        {
            hash: '#apagar-tabela',
            label: 'Apagar&nbsp;tabela'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#apagar-tabela', ()=>$5f8cf8bc5abf9d48$var$_apagarTabela(price_lists_crud));
    price_lists_crud.run('price_lists', "Listas de Pre\xe7os", crudContainer, (0, $561045a268ce7b0e$export$2e2bcd8739ae039), (0, $d8f38d8e6e0f5615$export$2e2bcd8739ae039), fieldspecs, operations).then(()=>{
        $5f8cf8bc5abf9d48$var$_setupCustomerPrices(panel, price_lists_crud);
    }).catch((e)=>{
        console.error('price-lists run:', e);
    });
};
async function $5f8cf8bc5abf9d48$var$_showCustomerPriceDetail(companyId, customerId, crudRef) {
    const [pricesResp, companiesResp, customersResp] = await Promise.all([
        (0, $9VcS9.default).call((0, $9VcS9.default).customer_prices_list, companyId, customerId),
        (0, $1cmSR.default).list('companies').catch(()=>[]),
        (0, $1cmSR.default).list('customers').catch(()=>[])
    ]);
    const rows = Array.isArray(pricesResp) ? pricesResp : [];
    const prices = rows.map((r)=>({
            product_id: r.product_id,
            discount: r.discount ?? 0,
            unit_price: r.unit_price
        }));
    const data = {
        company_id: companyId,
        id: customerId,
        customer_id: customerId,
        name: 'Tabela por cliente',
        discount: '',
        prices: prices
    };
    const flat = (0, $b60a2.flatten)(data, 'prices');
    const fs = (0, $b60a2.default).edit((0, $d8f38d8e6e0f5615$export$2e2bcd8739ae039), async (updated_data, old_data)=>{
        if (!old_data?.customer_id) return false;
        const deep = (0, $b60a2.deepen)(updated_data, 'prices');
        const headerVal = deep.discount;
        const headerFilled = headerVal != null && String(headerVal).trim() !== '' && !isNaN(Number(headerVal));
        const headerDiscount = headerFilled ? Math.min(100, Math.max(0, Math.round(Number(headerVal) * 100) / 100)) : null;
        const clampDiscount = (v)=>Math.min(100, Math.max(0, Math.round((v || 0) * 100) / 100));
        const pr = (deep.prices || []).map((p)=>{
            const rawItem = p.discount != null && String(p.discount).trim() !== '' && !isNaN(Number(p.discount)) ? Number(p.discount) : null;
            const itemDiscount = headerFilled ? headerDiscount : rawItem !== null ? clampDiscount(rawItem) : 0;
            return {
                product_id: Number(p.product_id),
                unit_id: p.unit_id != null ? Number(p.unit_id) : undefined,
                unit_price: Number(p.unit_price),
                discount: itemDiscount
            };
        }).filter((p)=>p.product_id && !isNaN(p.unit_price));
        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).customer_prices_replace, companyId, customerId, pr);
        (0, $jUNyh.notify)(`${resp?.count ?? 0} pre\xe7o(s) salvo(s).`);
        await crudRef.loadPage();
        return true;
    }, flat);
    setTimeout(()=>{
        const n = document.querySelector('#price-list');
        if (n) {
            const ec = n.querySelector('#company_id');
            const cc = n.querySelector('#customer_id');
            if (ec) ec.disabled = true;
            if (cc) cc.disabled = true;
        }
    }, 150);
}
async function $5f8cf8bc5abf9d48$var$_apagarTabela(crudRef) {
    const selection = crudRef.getSelection();
    const customerIds = selection.filter((a)=>Array.isArray(a) && a[2] === 'customer');
    if (!customerIds.length) {
        (0, $jUNyh.notify)('Selecione tabela(s) por cliente para apagar.');
        return;
    }
    (0, $jUNyh.ask)(`Apagar ${customerIds.length} tabela(s) de pre\xe7o por cliente?`, 'Confirmar', async (key)=>{
        if (key !== 'Y') return;
        for (const [companyId, customerId] of customerIds)await (0, $9VcS9.default).call((0, $9VcS9.default).customer_prices_delete, companyId, customerId);
        (0, $jUNyh.notify)('Tabela(s) apagada(s).');
        await crudRef.loadPage();
    });
}

async function $5f8cf8bc5abf9d48$var$_setupCustomerPrices(panel, crudRef) {
    const db = (await Promise.resolve((parcelRequire("1cmSR")))).default;
    const inpCompany = panel.querySelector('#cp_company_id');
    const inpCustomer = panel.querySelector('#cp_customer_id');
    const dlCompanies = panel.querySelector('#cp_companies');
    const dlCustomers = panel.querySelector('#cp_customers');
    const fileInput = panel.querySelector('#cp_file_input');
    if (!inpCompany || !inpCustomer || !fileInput) return;
    let companies = [];
    try {
        companies = await db.list('companies') || [];
    } catch (_) {}
    companies = Array.isArray(companies) ? companies : [];
    dlCompanies.innerHTML = companies.map((c)=>`<option value="${c.id || ''}">${c.nick || c.name || c.id || ''}</option>`).join('');
    function resolveCompanyId(val) {
        if (!val) return null;
        const c = companies.find((x)=>x.id === val || x.nick === val || x.name && x.name.includes && x.name.includes(val));
        return c?.id || null;
    }
    function getCompanyCustomerIds() {
        const companyId = resolveCompanyId(inpCompany.value);
        let customerId = inpCustomer.value?.trim();
        if (customerId && /^\d+$/.test(customerId)) customerId = parseInt(customerId, 10);
        else {
            const opt = Array.from(inpCustomer.list?.options || []).find((o)=>o.value === customerId || o.textContent && o.textContent.trim() === customerId);
            if (opt) customerId = parseInt(opt.value, 10);
        }
        return [
            companyId,
            customerId
        ];
    }
    inpCompany.addEventListener('change', async ()=>{
        const companyId = resolveCompanyId(inpCompany.value);
        if (!companyId) {
            dlCustomers.innerHTML = '';
            inpCustomer.value = '';
            crudRef.filter = {};
        } else {
            const q = `?filter=company_id*eq*${companyId}&limit=0`;
            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).list_customers, q);
            if (resp && Array.isArray(resp)) {
                db.set('customers', resp);
                dlCustomers.innerHTML = resp.map((c)=>`<option value="${c.id}" data-company="${c.company_id}">${c.nick || c.name || c.id}</option>`).join('');
            }
            inpCustomer.value = '';
            crudRef.filter = {
                'field-0': 'company_id',
                'value-0': companyId,
                'operator-0': 'eq'
            };
        }
        await crudRef.loadPage(1);
    });
    panel.querySelector('.bn_cp_download')?.addEventListener('click', async ()=>{
        const [companyId, customerId] = getCompanyCustomerIds();
        if (!companyId || !customerId) {
            (0, $jUNyh.notify)('Selecione Empresa e Cliente.');
            return;
        }
        const csv = await (0, $9VcS9.default).call((0, $9VcS9.default).customer_prices_template, companyId, customerId);
        if (typeof csv !== 'string') return;
        const blob = new Blob([
            csv
        ], {
            type: 'text/csv;charset=utf-8'
        });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'tabela_preco_cliente.csv';
        a.click();
        URL.revokeObjectURL(a.href);
        (0, $jUNyh.notify)('Modelo CSV baixado.');
    });
    panel.querySelector('.bn_cp_import')?.addEventListener('click', ()=>fileInput.click());
    fileInput.addEventListener('change', async (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        const [companyId, customerId] = getCompanyCustomerIds();
        if (!companyId || !customerId) {
            (0, $jUNyh.notify)('Selecione Empresa e Cliente.');
            fileInput.value = '';
            return;
        }
        const csv = await file.text();
        const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).customer_prices_import, companyId, customerId, csv);
        if (resp) {
            (0, $jUNyh.notify)(`${resp.count || 0} pre\xe7o(s) importado(s).`);
            await crudRef.loadPage();
        }
        fileInput.value = '';
    });
}
var $5f8cf8bc5abf9d48$export$2e2bcd8739ae039 = $5f8cf8bc5abf9d48$var$price_lists;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");
async function $0cec2748ac32fa3b$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 30rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Condi\xe7\xe3o</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}


parcelRequire("9VcS9");
parcelRequire("b60a2");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $d1603a6d78788fea$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#term #company_id	{ width: 10rem;		}
			#term #id			{ width: 4.5rem; text-align: right;	}
			#term #name		 	{ width: 10rem; 	}
			#term .days 		{ width: 14rem; text-align: right;	}
			#term .percentage 	{ width: 10rem; text-align: right;	}
		</style>
		<form id="term" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da condi\xe7\xe3o">Condi\xe7\xe3o
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da condi\xe7\xe3o">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Dias<sup>*</sup></th>
							<th>Percentual<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="4">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Dias at\xe9 o vencimento">
								<input id="days-0" class="days" type="text" required>
							</td>
							<td title="Percentual do total devido na data">
								<input id="percentage-0" class="percentage" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de sele\xe7\xe3o">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conte\xfado das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#term',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#days-0'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#percentage-0'
            },
            types: [
                $3eqAU.default(2)
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
const $e5cbae575b333663$var$payment_terms = function() {
    let payment_terms_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_payment_terms, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_payment_term, ...JSON.parse(id));
            return (0, $b60a2.flatten)(_record, 'installments');
        },
        editRecord (data) {
            (0, $b60a2.default).edit(this.record_form, this.saveRecordWrapper.bind(this), data);
        },
        async saveRecord (data, old_data) {
            data = (0, $b60a2.deepen)(data, 'installments');
            let _record = {
                name: data.name,
                installments: data.installments.map((installment)=>({
                        days: Number(installment.days),
                        percentage: Number(installment.percentage)
                    }))
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_payment_term, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_payment_term, data.company_id, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: "Sa\xedda",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Identificador da condi\xe7\xe3o de pagamento"
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: "Nome da condi\xe7\xe3o de pagamento"
        }
    ];
    payment_terms_crud.run('payment_terms', "Condi\xe7\xf5es&nbsp;Pagamento", document.getElementById('workarea'), (0, $0cec2748ac32fa3b$export$2e2bcd8739ae039), (0, $d1603a6d78788fea$export$2e2bcd8739ae039), fieldspecs);
};
var $e5cbae575b333663$export$2e2bcd8739ae039 = $e5cbae575b333663$var$payment_terms;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");

async function $5d73bb38edf16993$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(6)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">CFOP</th>
					<th data-index="3" data-visible="${this.visible[2]}">C\xf3digo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Descri\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Venda</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.code}</td>
					<td data-visible='${this.visible[3]}'>${record.description}</td>
					<td data-visible='${this.visible[4]}'>${record.venda ? 'Sim' : "N\xe3o"}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}


parcelRequire("9VcS9");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $91ad1c97f3a51d7e$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#cfop #company_id		{ width: 10rem;		}
			#cfop #id				{ width: 4rem; text-align: right;	}
			#cfop #code				{ width: 5rem;		}
			#cfop #description		{ width: 35rem;		}
			#cfop #venda			{ width: 4rem;		}
			#cfop #icms				{ width: 4rem;		}
			#cfop #ipi				{ width: 4rem;		}
			#cfop #pis				{ width: 4rem;		}
			#cfop #cofins			{ width: 4rem;		}
			#cfop #operacao			{ width: 4rem;		}
			#cfop #destino			{ width: 4rem;		}
			#cfop #finalidade		{ width: 4rem;		}
		</style>
		<form id="cfop" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do CFOP">CFOP
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo (4 d\xedgitos)">C\xf3digo<sup>*</sup>
					<input id="code" type="text" placeholder="5102" required maxlength="4">
				</label>
				<label title="Descri\xe7\xe3o">Descri\xe7\xe3o<sup>*</sup>
					<input id="description" type="text" required>
				</label>
				<label title="Opera\xe7\xe3o de venda?">Venda
					<input id="venda" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="CST ICMS">ICMS<sup>*</sup>
					<input id="icms" type="text" placeholder="00" required>
				</label>
				<label title="CST IPI">IPI
					<input id="ipi" type="text" placeholder="">
				</label>
				<label title="CST PIS">PIS
					<input id="pis" type="text" placeholder="">
				</label>
				<label title="CST COFINS">COFINS
					<input id="cofins" type="text" placeholder="">
				</label>
				<label title="Opera\xe7\xe3o">Opera\xe7\xe3o
					<input id="operacao" type="text" placeholder="">
				</label>
				<label title="Destino">Destino
					<input id="destino" type="text" placeholder="">
				</label>
				<label title="Finalidade">Finalidade
					<input id="finalidade" type="text" placeholder="">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#cfop',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: []
        },
        {
            properties: {
                selector: '#description'
            },
            types: []
        },
        {
            properties: {
                selector: '#venda'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#icms'
            },
            types: []
        },
        {
            properties: {
                selector: '#ipi'
            },
            types: []
        },
        {
            properties: {
                selector: '#pis'
            },
            types: []
        },
        {
            properties: {
                selector: '#cofins'
            },
            types: []
        },
        {
            properties: {
                selector: '#operacao'
            },
            types: []
        },
        {
            properties: {
                selector: '#destino'
            },
            types: []
        },
        {
            properties: {
                selector: '#finalidade'
            },
            types: []
        }
    ]
};



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
const $d5d475eb438dd51e$var$cfops = function() {
    let cfops_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_cfops, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_cfop, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                code: String(data.code).trim(),
                description: String(data.description).trim(),
                venda: !!data.venda,
                icms: String(data.icms || '').trim(),
                ipi: data.ipi ? String(data.ipi).trim() : null,
                pis: data.pis ? String(data.pis).trim() : null,
                cofins: data.cofins ? String(data.cofins).trim() : null,
                operacao: data.operacao ? String(data.operacao).trim() : null,
                destino: data.destino ? String(data.destino).trim() : null,
                finalidade: data.finalidade ? String(data.finalidade).trim() : null
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_cfop, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_cfop, data.company_id, _record);
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'CFOP',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do CFOP'
        },
        {
            index: 3,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: '5102',
            title: "C\xf3digo CFOP (4 d\xedgitos)"
        },
        {
            index: 4,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o"
        },
        {
            index: 5,
            field: 'venda',
            label: 'Venda',
            types: [
                $5Aed9.default()
            ],
            placeholder: '',
            title: "Opera\xe7\xe3o de venda"
        }
    ];
    cfops_crud.run('cfops', 'CFOPs', document.getElementById('workarea'), (0, $5d73bb38edf16993$export$2e2bcd8739ae039), (0, $91ad1c97f3a51d7e$export$2e2bcd8739ae039), fieldspecs);
};
var $d5d475eb438dd51e$export$2e2bcd8739ae039 = $d5d475eb438dd51e$var$cfops;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $jUNyh = parcelRequire("jUNyh");

async function $e6f60a5193f12519$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(6)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Programa</th>
					<th data-index="3" data-visible="${this.visible[2]}">Nome</th>
					<th data-index="4" data-visible="${this.visible[3]}">C\xf3digo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Padr\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.name ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[4]}'>${record.is_default ? 'Sim' : "N\xe3o"}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $eee431dd3ba3bb8f$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#program #company_id		{ width: 10rem;		}
			#program #id				{ width: 5rem; text-align: right;	}
			#program #name				{ width: 25rem;		}
			#program #code				{ width: 10rem;		}
			#program #is_default		{ width: 4rem;		}
		</style>
		<form id="program" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do programa">Programa
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do programa">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="C\xf3digo (opcional)">C\xf3digo
					<input id="code" type="text" placeholder="PADRAO">
				</label>
				<label title="Programa padr\xe3o da empresa">Padr\xe3o
					<input id="is_default" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_program_delete" title="Excluir programa">Excluir</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#program',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
            const root = ()=>formset.dialog?.getNode?.();
            const getCompanyId = ()=>formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
            const getId = ()=>root()?.querySelector?.('#id')?.value;
            const deleteProgram = async ()=>{
                const company_id = getCompanyId(), id = getId();
                if (!company_id || !id) return;
                (0, $jUNyh.ask)("Excluir este programa? S\xf3 \xe9 poss\xedvel excluir programas sem registros vinculados (produtos, lotes, pedidos, entradas).", 'Excluir', async (answer)=>{
                    if (answer !== 'Y') return;
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_program, company_id, id);
                    if (resp !== undefined) {
                        formset.destroy();
                        document.dispatchEvent(new CustomEvent('programs:reload'));
                    }
                });
            };
            root()?.addEventListener?.('click', (ev)=>{
                if (ev.target?.closest?.('.bn_program_delete')) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    deleteProgram();
                    return;
                }
            });
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: []
        },
        {
            properties: {
                selector: '#code'
            },
            types: []
        },
        {
            properties: {
                selector: '#is_default'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
const $e7e1d1109d9bcdea$var$programs = function() {
    let programs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async deleteProgram () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos um programa.', 'Programas');
            (0, $jUNyh.ask)(`Excluir ${ids.length} programa(s)? S\xf3 \xe9 poss\xedvel excluir programas sem registros vinculados (produtos, lotes, pedidos, entradas).`, 'Excluir', async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_program, company_id, id);
                    if (resp === undefined) return;
                }
                this.reloadPage();
            });
        },
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_programs, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_program, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: String(data.name || '').trim(),
                code: data.code && data.code.trim() ? data.code.trim() : null,
                is_default: !!data.is_default
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_program, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_program, data.company_id, _record);
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Programa',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do programa'
        },
        {
            index: 3,
            field: 'name',
            label: 'Nome',
            types: [],
            placeholder: '',
            title: 'Nome do programa'
        },
        {
            index: 4,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: 'PADRAO',
            title: "C\xf3digo (opcional)"
        },
        {
            index: 5,
            field: 'is_default',
            label: "Padr\xe3o",
            types: [
                $5Aed9.default()
            ],
            placeholder: '',
            title: "Programa padr\xe3o da empresa"
        }
    ];
    let operations = [
        {
            hash: '#program-delete',
            label: 'Excluir'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#program-delete', programs_crud.deleteProgram.bind(programs_crud));
    document.addEventListener('programs:reload', ()=>programs_crud.reloadPage());
    programs_crud.run('programs', 'Programas', document.getElementById('workarea'), (0, $e6f60a5193f12519$export$2e2bcd8739ae039), (0, $eee431dd3ba3bb8f$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $e7e1d1109d9bcdea$export$2e2bcd8739ae039 = $e7e1d1109d9bcdea$var$programs;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $jUNyh = parcelRequire("jUNyh");
async function $d52df07a3dbea82f$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(3) { text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Id</th>
					<th data-index="3" data-visible="${this.visible[2]}">C\xf3digo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Descri\xe7\xe3o</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.description ?? '').toString()}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $c90b1d5127c69154$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#receipt_type #company_id	{ width: 10rem; }
			#receipt_type #id			{ width: 5rem; text-align: right; }
			#receipt_type #code		{ width: 8rem; }
			#receipt_type #description	{ width: 28rem; }
		</style>
		<form id="receipt_type" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador interno">C\xf3digo interno
					<input id="id" type="text" disabled>
				</label>
				<label title="C\xf3digo do tipo (ex.: 71)">C\xf3digo<sup>*</sup>
					<input id="code" type="text" required maxlength="32">
				</label>
				<label title="Descri\xe7\xe3o">Descri\xe7\xe3o<sup>*</sup>
					<input id="description" type="text" required maxlength="120">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#receipt_type',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#description'
            },
            types: []
        }
    ]
};


const $fddcf708043881a5$var$receiptTypes = function() {
    const rt_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((e)=>(0, $jUNyh.notify)(e)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_receipt_types, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_receipt_type, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            const _record = {
                code: String(data.code || '').trim(),
                description: String(data.description || '').trim()
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_receipt_type, data.company_id, data.id, _record);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_receipt_type, data.company_id, _record);
        },
        async deleteSelected () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos um registro.', 'Tipos de recebimento');
            (0, $jUNyh.ask)(`Excluir ${ids.length} tipo(s)? S\xf3 \xe9 poss\xedvel excluir tipos sem pedidos de entrada vinculados.`, 'Excluir', async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_receipt_type, company_id, id);
                    if (resp === undefined) return;
                }
                this.reloadPage();
            });
        }
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#receipt-type-delete', rt_crud.deleteSelected.bind(rt_crud));
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Id',
            types: [],
            placeholder: '',
            title: 'Identificador'
        },
        {
            index: 3,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: '',
            title: "C\xf3digo"
        },
        {
            index: 4,
            field: 'description',
            label: "Descri\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Descri\xe7\xe3o"
        }
    ];
    const operations = [
        {
            hash: '#receipt-type-delete',
            label: 'Excluir'
        }
    ];
    rt_crud.run('receipt_types', 'Tipos&nbsp;de&nbsp;Recebimento', document.getElementById('workarea'), (0, $d52df07a3dbea82f$export$2e2bcd8739ae039), (0, $c90b1d5127c69154$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $fddcf708043881a5$export$2e2bcd8739ae039 = $fddcf708043881a5$var$receiptTypes;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $jUNyh = parcelRequire("jUNyh");
async function $eb484fc9da394d66$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(3) { text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Id</th>
					<th data-index="3" data-visible="${this.visible[2]}">Motivo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.name ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${record.is_disabled ? 'Sim' : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $74yTJ = parcelRequire("74yTJ");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $8f47086bc8a5e539$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#input_cancel_reason #company_id	{ width: 10rem; }
			#input_cancel_reason #id			{ width: 5rem; text-align: right; }
			#input_cancel_reason #name		{ width: 28rem; }
		</style>
		<form id="input_cancel_reason" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador interno">C\xf3digo interno
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do motivo (aparece na lista ao cancelar Entrada)">Motivo<sup>*</sup>
					<input id="name" type="text" required maxlength="120">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#input_cancel_reason',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        }
    ]
};



var $1Wvh7 = parcelRequire("1Wvh7");
const $8a1291ff72b4a75f$var$inputCancelReasons = function() {
    const icr_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((e)=>(0, $jUNyh.notify)(e)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_input_cancel_reasons, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_input_cancel_reason, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            const _record = {
                name: String(data.name || '').trim()
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_input_cancel_reason, data.company_id, data.id, _record);
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_input_cancel_reason, data.company_id, _record);
        },
        async deleteSelected () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)('Selecione ao menos um registro.', 'Motivos de cancelamento');
            (0, $jUNyh.ask)(`Desativar ${ids.length} motivo(s)? Motivos j\xe1 usados em Entradas ficam inativos (n\xe3o s\xe3o apagados).`, 'Desativar', async (answer)=>{
                if (answer !== 'Y') return;
                for (const [company_id, id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).delete_input_cancel_reason, company_id, id);
                    if (resp === undefined) return;
                }
                this.reloadPage();
            });
        }
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-cancel-reason-delete', icr_crud.deleteSelected.bind(icr_crud));
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Id',
            types: [],
            placeholder: '',
            title: 'Identificador'
        },
        {
            index: 3,
            field: 'name',
            label: 'Motivo',
            types: [],
            placeholder: '',
            title: 'Motivo'
        },
        {
            index: 4,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: 'Inativo'
        }
    ];
    const operations = [
        {
            hash: '#input-cancel-reason-delete',
            label: 'Desativar'
        }
    ];
    icr_crud.run('input_cancel_reasons', 'Motivos&nbsp;Cancelamento&nbsp;Entrada', document.getElementById('workarea'), (0, $eb484fc9da394d66$export$2e2bcd8739ae039), (0, $8f47086bc8a5e539$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $8a1291ff72b4a75f$export$2e2bcd8739ae039 = $8a1291ff72b4a75f$var$inputCancelReasons;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");
async function $6feea2fb00f5c21e$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(5) { text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">C\xf3digo</th>
					<th data-index="3" data-visible="${this.visible[2]}">R\xf3tulo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Ordem</th>
					<th data-index="5" data-visible="${this.visible[4]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.code
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.code
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[2]}'>${(record.label ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${record.sort_order ?? ''}</td>
					<td data-visible='${this.visible[4]}'>${record.is_disabled ? 'Sim' : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $gBwx4 = parcelRequire("gBwx4");
var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $f292b7a32a94b28c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#stock_block_kind #company_id	{ width: 10rem; }
			#stock_block_kind #code		{ width: 12rem; }
			#stock_block_kind #label		{ width: 22rem; }
			#stock_block_kind #sort_order	{ width: 5rem; text-align: right; }
		</style>
		<form id="stock_block_kind" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<p class="fsxx" style="max-width:42rem">
				C\xf3digos s\xe3o fixos (seed). Aqui voc\xea <strong>renomeia o r\xf3tulo</strong> ou <strong>desativa</strong> a natureza para o tenant.
				Novos c\xf3digos exigem inclus\xe3o pelo SIAL (n\xe3o quebram BI).
			</p>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="C\xf3digo interno (n\xe3o edit\xe1vel)">C\xf3digo
					<input id="code" type="text" disabled>
				</label>
				<label title="R\xf3tulo exibido no bloqueio/desbloqueio">R\xf3tulo<sup>*</sup>
					<input id="label" type="text" required maxlength="80">
				</label>
				<label title="Ordem na lista">Ordem
					<input id="sort_order" type="text">
				</label>
				<label title="Desativado some da lista operacional">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#stock_block_kind',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#code'
            },
            types: [
                $gBwx4.default()
            ]
        },
        {
            properties: {
                selector: '#label'
            },
            types: []
        },
        {
            properties: {
                selector: '#sort_order'
            },
            types: [
                $3eqAU.default(0, 0)
            ]
        },
        {
            properties: {
                selector: '#is_disabled'
            },
            types: [
                $5Aed9.default()
            ]
        }
    ]
};



var $1Wvh7 = parcelRequire("1Wvh7");
const $61dd04bf6ff4dd5e$var$stockBlockKinds = function() {
    const sbk_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((e)=>(0, $jUNyh.notify)(e)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_stock_block_kinds, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_stock_block_kind, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            if (!old_data) {
                (0, $jUNyh.notify)("N\xe3o \xe9 permitido criar c\xf3digo novo. Pe\xe7a inclus\xe3o ao SIAL.", 'Naturezas de bloqueio');
                return undefined;
            }
            const _record = {
                label: String(data.label || '').trim(),
                is_disabled: data.is_disabled == '1' || data.is_disabled === true,
                sort_order: data.sort_order === '' || data.sort_order == null ? undefined : Number(data.sort_order)
            };
            return await (0, $9VcS9.default).call((0, $9VcS9.default).update_stock_block_kind, data.company_id, data.code, _record);
        }
    });
    const fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'code',
            label: "C\xf3digo",
            types: [],
            placeholder: '',
            title: "C\xf3digo"
        },
        {
            index: 3,
            field: 'label',
            label: "R\xf3tulo",
            types: [],
            placeholder: '',
            title: "R\xf3tulo"
        },
        {
            index: 4,
            field: 'sort_order',
            label: 'Ordem',
            types: [],
            placeholder: '',
            title: 'Ordem'
        },
        {
            index: 5,
            field: 'is_disabled',
            label: 'Inativo',
            types: [
                $1Wvh7.default()
            ],
            placeholder: '',
            title: 'Inativo'
        }
    ];
    sbk_crud.run('stock_block_kinds', 'Naturezas&nbsp;de&nbsp;Bloqueio', document.getElementById('workarea'), (0, $6feea2fb00f5c21e$export$2e2bcd8739ae039), (0, $f292b7a32a94b28c$export$2e2bcd8739ae039), fieldspecs, []);
};
var $61dd04bf6ff4dd5e$export$2e2bcd8739ae039 = $61dd04bf6ff4dd5e$var$stockBlockKinds;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $h1m6J = parcelRequire("h1m6J");


var $b60a2 = parcelRequire("b60a2");

var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");

var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
async function $2aa875d7e8eae51f$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: right; }
			.view td:nth-child(8)	{ text-align: right; }
			.view td:nth-child(9)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 25rem; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: center; }
			.view td:nth-child(14)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(15)	{ text-align: center; }
			.view td:nth-child(16)	{ text-align: left; max-width: 18rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Nota</th>
					<th data-index="3" data-visible="${this.visible[2]}">E/S</th>
					<th data-index="4" data-visible="${this.visible[3]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[4]}">CFOP</th>
					<th data-index="6" data-visible="${this.visible[5]}">Seguro</th>
					<th data-index="7" data-visible="${this.visible[6]}">Despesas</th>
					<th data-index="8" data-visible="${this.visible[7]}">Informa\xe7\xf5es</th>
					<th data-index="9" data-visible="${this.visible[8]}">Chave</th>
					<th data-index="10" data-visible="${this.visible[9]}">Referenciada</th>
					<th data-index="12" data-visible="${this.visible[10]}">Anota\xe7\xe3o</th>
					<th data-index="13" data-visible="${this.visible[11]}">C\xf3digo</th>
					<th data-index="14" data-visible="${this.visible[12]}">Mensagem</th>
					<th data-index="15" data-visible="${this.visible[13]}">Data/Hora</th>
					<th data-index="16" data-visible="${this.visible[14]}">Inutilizada</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.io_id}</td>
					<td data-visible='${this.visible[3]}'>${this.option($759a03b3eb0eafb9$export$2e2bcd8739ae039(), record.io_type)}</td>
					<td data-visible='${this.visible[4]}'>${record.cfop}</td>
					<td data-visible='${this.visible[5]}'>${record.insurance ? this.format($3eqAU.default(2), record.insurance) : ''}</td>
					<td data-visible='${this.visible[6]}'>${record.expenses ? this.format($3eqAU.default(2), record.expenses) : ''}</td>
					<td data-visible='${this.visible[7]}'>${record.info || ''}</td>
					<td data-visible='${this.visible[8]}'>${record.key || ''}</td>
					<td data-visible='${this.visible[9]}'>${record.ref_key || ''}</td>
					<td data-visible='${this.visible[10]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.last_code || ''}</td>
					<td data-visible='${this.visible[12]}'>${record.last_text || ''}</td>
					<td data-visible='${this.visible[13]}'>${this.format($8IFAz.default(), record.last_datetime) || ''}</td>
					<td data-visible='${this.visible[14]}'>${record.inutilizacao_protocolo || ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $5Aed9 = parcelRequire("5Aed9");
var $9PIz7 = parcelRequire("9PIz7");
var $l0p8O = parcelRequire("l0p8O");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $knytZ = parcelRequire("knytZ");
var $091512228dc59c17$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#invoice #company_id		{ width: 10rem;		}
			#invoice #id				{ width: 5rem; text-align: right;	}
			#invoice #io_id				{ width: 5rem; text-align: right;	}
			#invoice #io_type			{ width: 8rem; 		}
			#invoice #cfop				{ width: 30rem;		}
			#invoice #insurance			{ width: 5rem; text-align: right;	}
			#invoice #expenses			{ width: 5rem; text-align: right;	}
			#invoice .info		 		{ width: 70%;		}
			#invoice .note		 		{ width: 29%;		}
			#invoice .type 				{ width: 10rem;		}
			#invoice .number 			{ width: 10rem; text-align: center;	}
			#invoice .code 				{ width: 4rem; text-align: center;	}
			#invoice .message 			{ width: 20rem;		}
			#invoice .datetime 			{ width: 10rem; text-align: center;	}
			#invoice #ref_key			{ width: 30rem;		}
		</style>
		<form id="invoice" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="N\xfamero da nota fiscal">Nota
					<input id="id" type="text" disabled>
				</label>
				<label title="N\xfamero da entrada/sa\xedda vinculada">E/S<sup>*</sup>
					<input id="io_id" type="text" required>
				</label>
				<label title="Tipo do movimento vinculado">Tipo<sup>*</sup>
					<input id="io_type" type="text" list="io_types" value="O" disabled>
				</label>
				<label title="C\xf3digo Fiscal de Opera\xe7\xf5es e Presta\xe7\xf5es">CFOP<sup>*</sup>
					<input id="cfop" type="text" list="cfops" required>
				</label>
				<label title="Valor do seguro">Seguro
					<input id="insurance" type="text">
				</label>
				<label title="Outras despesas acess\xf3rias">Despesas
					<input id="expenses" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="info" title="Informa\xe7\xf5es complementares de interesse do contribuinte">Informa\xe7\xf5es Complementares
					<textarea id="info" rows="8"></textarea>
				</label>
				<label class="note" title="Corre\xe7\xe3o ou justificativa de cancelamento">Anota\xe7\xe3o
					<textarea id="note" rows="8"></textarea>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Tipo</th>
							<th>Protocolo</th>
							<th>C\xf3digo</th>
							<th>Mensagem</th>
							<th>Data/Hora</th>
							<th>Conting\xeancia</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox" disabled>
							</td>
							<td title="Tipo de protocolo">
								<select id="type-0" class="type" disabled>
									<option value="1">Autoriza\xe7\xe3o</option>
									<option value="2">Corre\xe7\xe3o</option>
									<option value="3">Cancelamento</option>
									<option value="4">Inutiliza\xe7\xe3o</option>
								</select>
							</td>
							<td title="N\xfamero do protocolo">
								<input id="number-0" class="number" type="text" disabled>
							</td>
							<td title="C\xf3digo de retorno">
								<input id="result_code-0" class="code" type="text" disabled>
							</td>
							<td title="Mensagem de retorno">
								<input id="result_text-0" class="message" type="text" disabled>
							</td>
							<td title="Data/hora do retorno">
								<input id="result_datetime-0" class="datetime" type="text" disabled>
							</td>
							<td title="Uso de ambiente de conting\xeancia">
								<input id="contingency-0" class="contingency" type="checkbox" disabled>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<label title="Chave da nota fiscal referenciada em devolu\xe7\xf5es">Nota Referenciada
						<input id="ref_key" type="text">
					</label>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#invoice',
        afterEditSetValues (fs) {
            setTimeout(()=>{
                const io = fs.form.getFieldBySelector('#io_type');
                if (io && typeof io.publish === 'function') io.publish('change', io, io.getValue());
            }, 50);
        },
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_id'
            },
            types: [
                $6Jl4s.default(),
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#io_type'
            },
            types: [
                $6Jl4s.default(),
                $759a03b3eb0eafb9$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#cfop'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default(),
                $f361d28f145f8e93$export$2e2bcd8739ae039()
            ]
        },
        {
            properties: {
                selector: '#ref_key'
            },
            types: [
                $l0p8O.default()
            ]
        },
        {
            properties: {
                selector: '#insurance'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#expenses'
            },
            types: [
                $3eqAU.default(2)
            ]
        },
        {
            properties: {
                selector: '#info'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#note'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#checkbox-0'
            },
            types: [
                $5Aed9.default()
            ]
        },
        {
            properties: {
                selector: '#type-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#number-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#result_code-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#result_text-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#result_datetime-0'
            },
            types: []
        },
        {
            properties: {
                selector: '#contingency-0'
            },
            types: []
        }
    ]
};



var $3OKkn = parcelRequire("3OKkn");
var $dd161bc297361199$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#create-lots .type	{ width: 100%;	}
			#create-lots #note	{ width: 30rem;	}
		</style>
		<form id="create-lots" class="form" autocomplete="off">
			<div class="title">
				Gerar lotes para <span id="count"></span> notas
			</div>
			<div class="mtl">
				<label class="type" title="Finalidade do lote">Tipo de lote
					<select id="type" required>
						<option value="-1"></option>
						<option value="1">Autoriza\xe7\xe3o</option>
						<option value="2">Corre\xe7\xe3o</option>
						<option value="3">Cancelamento</option>
					</select>
				</label>
			</div>
			<div>
				<label>Corre\xe7\xe3o ou justificativa do cancelamento
					<textarea id="note" rows="4" placeholder="Cancelamento: m\xednimo 15 caracteres (SEFAZ). Carta de corre\xe7\xe3o: texto da corre\xe7\xe3o."></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#create-lots',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#type'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '#note'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $3eqAU = parcelRequire("3eqAU");
var $50ee6dc3eb293ba0$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#inutilizar-nf .serie,
			#inutilizar-nf #nNFIni,
			#inutilizar-nf #nNFFin	{ width: 6rem;	}
			#inutilizar-nf #xJust	{ width: 100%; min-height: 4rem; }
		</style>
		<form id="inutilizar-nf" class="form" autocomplete="off">
			<div class="title">Inutilizar numera\xe7\xe3o de NF-e</div>
			<div class="mtl">
				<label>Empresa
					<input id="company_id" list="inutilizar-companies" required placeholder="Selecione a empresa">
					<datalist id="inutilizar-companies"></datalist>
				</label>
			</div>
			<div class="mtl">
				<label>S\xe9rie
					<input id="serie" type="number" min="0" max="999" required placeholder="Ex: 2">
				</label>
			</div>
			<div class="mtl">
				<label>Nota inicial
					<input id="nNFIni" type="number" min="1" required placeholder="Ex: 8529">
				</label>
			</div>
			<div class="mtl">
				<label>Nota final
					<input id="nNFFin" type="number" min="1" required placeholder="Ex: 8537">
				</label>
			</div>
			<div class="mtl">
				<label>Justificativa (m\xedn. 15 caracteres)
					<textarea id="xJust" rows="3" required minlength="15" placeholder="Ex: Salto na sequ\xeancia devido \xe0 emiss\xe3o por script de venda de ativo imobilizado"></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Inutilizar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#inutilizar-nf',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#inutilizar-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#serie'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#nNFIni'
            },
            types: [
                $3eqAU.default(0, 0)
            ]
        },
        {
            properties: {
                selector: '#nNFFin'
            },
            types: [
                $3eqAU.default(0, 0)
            ]
        },
        {
            properties: {
                selector: '#xJust'
            },
            types: []
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $b7D1Q = parcelRequire("b7D1Q");
var $708b7eb6d2224859$export$2e2bcd8739ae039 = {
    html: `
		<form id="iqvia-report-form" class="form" autocomplete="off">
			<div class="title">Relat\xf3rio IQVIA \u{2014} Vendas e Devolu\xe7\xf5es</div>
			<div class="mtl">
				<label>Empresa
					<input id="company_id" list="iqvia-companies" required placeholder="Selecione a empresa">
					<datalist id="iqvia-companies"></datalist>
				</label>
			</div>
			<div class="mtl">
				<label>Data in\xedcio
					<input id="date_from" type="text" required placeholder="dd/mm/aaaa">
				</label>
			</div>
			<div class="mtl">
				<label>Data fim (opcional)
					<input id="date_to" type="text" placeholder="dd/mm/aaaa">
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Imprimir</button>
			</div>
		</form>
	`,
    form: {
        selector: '#iqvia-report-form',
        init (formset) {
            formset.form.eraseValues();
            formset.loadList('#iqvia-companies', 'companies', {
                labels: [
                    'nick'
                ],
                value: 'id'
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#date_from'
            },
            types: [
                $b7D1Q.default()
            ]
        },
        {
            properties: {
                selector: '#date_to'
            },
            types: [
                $b7D1Q.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $l0p8O = parcelRequire("l0p8O");
var $3eqAU = parcelRequire("3eqAU");
const $e8c0107621152558$var$invoices = function() {
    let invoices_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_cfops, this.queryAll()).then((data)=>(0, $1cmSR.default).set('cfops', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_invoices, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_invoice, ...JSON.parse(id));
            return (0, $b60a2.flatten)(_record, 'protocols');
        },
        async saveRecord (data, old_data) {
            let _record = {
                io_type: data.io_type,
                io_id: Number(data.io_id),
                cfop: data.cfop,
                insurance: Number(data.insurance),
                expenses: Number(data.expenses),
                info: data.info?.trim(),
                note: data.note?.trim(),
                ref_key: data.ref_key
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_invoice, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_invoice, data.company_id, _record);
        },
        updateXML () {
            if (!this.ensureSelection('Atualizar XML')) return;
            const showResult = (resp)=>{
                (0, $jUNyh.notify)(`Notas atualizadas: ${resp?.count || 0}`, 'Resultado');
                this.loadPage();
            };
            const sendRequest = async ()=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).update_invoices_xml, {
                    'ids': ids
                });
                if (resp != null) showResult(resp);
            };
            (0, $jUNyh.ask)(`Atualizar XML de ${this.getCount()} notas?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        createLots () {
            if (!this.ensureSelection('Gerar lotes de notas')) return;
            const showResult = (resp)=>{
                (0, $jUNyh.notify)(`Lotes criados: ${resp?.count || 0}`, 'Resultado');
                this.loadPage(); // Required on corrections and cancelations
                fs.destroy();
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                let lots = (0, $aGGTj.splitIdsByCompany)(ids);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_invoice_lots, Object.assign(data, {
                    'lots': lots
                }));
                if (resp != null) showResult(resp);
            };
            let fs = (0, $h1m6J.default).create((0, $dd161bc297361199$export$2e2bcd8739ae039), sendRequest);
            fs.init = (()=>{
                document.querySelector(`${fs.form.selector} #count`).innerHTML = this.getCount();
                Object.getPrototypeOf(fs).init.call(fs);
            })();
        },
        createArchive () {
            if (!this.ensureSelection('Baixar XML e DANFE')) return;
            const showResult = (resp)=>{
                this.clearGridSelection();
                if (resp) (0, $jUNyh.notify)(`<a href="data:application/x-zip-compressed;base64,${resp.zip}" download="invoices.zip">Clique aqui para obter o arquivo</a>`, 'Download');
            };
            const sendRequest = async (data)=>{
                let ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_archive, {
                    'ids': ids
                });
                if (resp != null) showResult(resp);
            };
            (0, $jUNyh.ask)(`Baixar XML e DANFE de ${this.getCount()} notas?`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        inutilizarNF () {
            const showResult = (data)=>{
                if (data?.ok) (0, $jUNyh.notify)(`Inutiliza\xe7\xe3o homologada. Protocolo: ${data.protocolo || ''}`, 'Resultado');
                else if (data) (0, $jUNyh.notify)(`${data?.mensagem || 'Erro'} (${data?.codigo || ''})`, 'Erro');
                fs.destroy();
                this.loadPage();
            };
            const sendRequest = async (data)=>{
                const body = {
                    company_id: data.company_id,
                    serie: Number(data.serie),
                    nNFIni: Number(data.nNFIni),
                    nNFFin: Number(data.nNFFin),
                    xJust: data.xJust?.trim()
                };
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).inutilizar_invoices, body);
                if (resp) showResult(resp);
                else {
                    fs.destroy();
                    this.loadPage();
                }
            };
            let fs = (0, $h1m6J.default).create((0, $50ee6dc3eb293ba0$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        },
        printIqvia () {
            const sendRequest = async (data)=>{
                fs.destroy();
                try {
                    const payload = {
                        company_id: data.company_id,
                        date_from: data.date_from
                    };
                    if (data.date_to && String(data.date_to).trim()) payload.date_to = data.date_to;
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).print_iqvia, payload);
                    if (resp?.pdf) (0, $f657162cc87f545e$export$2e2bcd8739ae039)(resp.pdf);
                    else (0, $jUNyh.notify)("Nenhum dado para o relat\xf3rio.", 'Aviso');
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                }
            };
            let fs = (0, $h1m6J.default).create((0, $708b7eb6d2224859$export$2e2bcd8739ae039), sendRequest);
            fs.init();
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Nota',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da nota fiscal"
        },
        {
            index: 3,
            field: 'io_id',
            label: 'E/S',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "N\xfamero da entrada/sa\xedda vinculada"
        },
        {
            index: 4,
            field: 'io_type',
            label: 'Origem',
            types: [
                $759a03b3eb0eafb9$export$2e2bcd8739ae039()
            ],
            placeholder: '',
            title: "Origem da entrada/sa\xedda vinculada"
        },
        {
            index: 5,
            field: 'cfop',
            label: 'CFOP',
            types: [
                $c064992517a328df$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "C\xf3digo Fiscal de Opera\xe7\xf5es e Presta\xe7\xf5es"
        },
        {
            index: 6,
            field: 'insurance',
            label: 'Seguro',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: 'Valor do seguro'
        },
        {
            index: 7,
            field: 'expenses',
            label: 'Despesas',
            types: [
                $3eqAU.default(2)
            ],
            placeholder: '0,00',
            title: "Valor das despesas acess\xf3rias"
        },
        {
            index: 8,
            field: 'info',
            label: "Informa\xe7\xf5es",
            types: [],
            placeholder: '',
            title: "Informa\xe7\xf5es complementares"
        },
        {
            index: 9,
            field: 'key',
            label: 'Chave',
            types: [
                $l0p8O.default()
            ],
            placeholder: '0000 0000 0000 0000 0000 0000 0000 0000 0000 0000',
            title: 'Chave da nota fiscal'
        },
        {
            index: 10,
            field: 'ref_key',
            label: 'Referenciada',
            types: [
                $l0p8O.default()
            ],
            placeholder: '0000 0000 0000 0000 0000 0000 0000 0000 0000 0000',
            title: 'Chave da nota referenciada'
        },
        {
            index: 12,
            field: 'note',
            label: "Anota\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Anota\xe7\xf5es de corre\xe7\xf5es ou cancelamento"
        },
        {
            index: 13,
            field: 'last_code',
            label: "C\xf3digo",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "C\xf3digo de retorno da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 14,
            field: 'last_text',
            label: 'Mensagem',
            types: [],
            placeholder: '',
            title: "Mensagem de retorno da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 15,
            field: 'last_datetime',
            label: 'Data/Hora',
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 16,
            field: 'inutilizacao_protocolo',
            label: 'Inutilizada',
            types: [],
            placeholder: '',
            title: "Protocolo da inutiliza\xe7\xe3o na SEFAZ (vazio se n\xe3o inutilizada)"
        }
    ];
    let operations = [
        {
            hash: '#update-xml',
            label: 'Atualizar&nbsp;XML'
        },
        {
            hash: '#create-lots',
            label: 'Gerar&nbsp;lotes&nbsp;de&nbsp;notas'
        },
        {
            hash: '#create-archive',
            label: 'Baixar&nbsp;XML&nbsp;e&nbsp;DANFE'
        },
        {
            hash: '#inutilizar-nf',
            label: 'Inutilizar&nbsp;NF'
        }
    ];
    let reports = [
        {
            hash: '#print-iqvia',
            label: "Relat\xf3rio&nbsp;IQVIA"
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#update-xml', invoices_crud.updateXML.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-lots', invoices_crud.createLots.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#create-archive', invoices_crud.createArchive.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inutilizar-nf', invoices_crud.inutilizarNF.bind(invoices_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#print-iqvia', invoices_crud.printIqvia.bind(invoices_crud));
    invoices_crud.run('invoices', 'Notas&nbsp;Fiscais', document.getElementById('workarea'), (0, $2aa875d7e8eae51f$export$2e2bcd8739ae039), (0, $091512228dc59c17$export$2e2bcd8739ae039), fieldspecs, operations, reports);
};
var $e8c0107621152558$export$2e2bcd8739ae039 = $e8c0107621152558$var$invoices;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $jUNyh = parcelRequire("jUNyh");

var $8IFAz = parcelRequire("8IFAz");
var $1Wvh7 = parcelRequire("1Wvh7");
var $9SpSV = parcelRequire("9SpSV");
var $3HbPC = parcelRequire("3HbPC");
async function $708f028c2d9a84ab$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: center; }
			.view td:nth-child(5)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: center; }
			.view td:nth-child(12)	{ text-align: center; }
			.view td:nth-child(13)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lote</th>
					<th data-index="15" data-visible="${this.visible[2]}">Notas</th>
					<th data-index="19" data-visible="${this.visible[3]}">NFs</th>
					<th data-index="4" data-visible="${this.visible[4]}">Tipo</th>
					<th data-index="6" data-visible="${this.visible[5]}">Recibo</th>
					<th data-index="8" data-visible="${this.visible[6]}">C\xf3digo</th>
					<th data-index="9" data-visible="${this.visible[7]}">Mensagem</th>
					<th data-index="10" data-visible="${this.visible[8]}">Data/Hora</th>
					<th data-index="5" data-visible="${this.visible[9]}">Estado</th>
					<th data-index="3" data-visible="${this.visible[10]}">Ambiente</th>
					<th data-index="12" data-visible="${this.visible[11]}">Conting\xeancia</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.company_id,
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.company_id,
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.invoice_count || 0} \xb7 ok ${record.invoice_authorized_count || 0} \xb7 erro ${record.invoice_error_count || 0} \xb7 pend ${record.invoice_pending_count || 0}</td>
					<td data-visible='${this.visible[3]}' title="${record.invoice_numbers || ''}">${record.invoice_numbers || ''}</td>
					<td data-visible='${this.visible[4]}'>${this.option($b23279d219d3efdd$export$2e2bcd8739ae039(), record.type)}</td>
					<td data-visible='${this.visible[5]}'>${record.receipt || ''}</td>
					<td data-visible='${this.visible[6]}'>${record.result_code || ''}</td>
					<td data-visible='${this.visible[7]}'>${record.result_text || ''}</td>
					<td data-visible='${this.visible[8]}'>${this.format($8IFAz.default(), record.result_datetime) || ''}</td>
					<td data-visible='${this.visible[9]}'>${this.option($3HbPC.default(), record.state)}</td>
					<td data-visible='${this.visible[10]}'>${this.option($9SpSV.default(), record.environment)}</td>
					<td data-visible='${this.visible[11]}'>${this.option($1Wvh7.default(), record.in_contingency)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $91trW = parcelRequire("91trW");
var $3eqAU = parcelRequire("3eqAU");
var $6Jl4s = parcelRequire("6Jl4s");
var $3OKkn = parcelRequire("3OKkn");
var $88d370256d2b3a0d$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#invoice-lot #company_id	{ width: 10rem;	}
			#invoice-lot #id			{ width: 5rem; text-align: right;	}
			#invoice-lot #type			{ width: 14rem;	}
			#invoice-lot #invoices		{ width: 30rem;	}
		</style>
		<form id="invoice-lot" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do lote">Lote
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de lote">Tipo<sup>*</sup>
					<select id="type" required>
						<option value="-1"></option>
						<option value="1">Autoriza\xe7\xe3o</option>
						<option value="2">Corre\xe7\xe3o</option>
						<option value="3">Cancelamento</option>
					</select>
				</label>
			</div>
			<div>
				<label title="N\xfameros das notas">Notas
					<textarea id="invoices" rows="6"></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Salvar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#invoice-lot',
        init (formset) {
            formset.loadList('#companies', 'companies', {
                labels: [
                    'nick'
                ]
            });
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $6Jl4s.default(),
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#type'
            },
            types: [
                $3OKkn.default()
            ]
        },
        {
            properties: {
                selector: '#invoices'
            },
            types: [
                $91trW.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $5UO7m = parcelRequire("5UO7m");
var $3eqAU = parcelRequire("3eqAU");
var $1Wvh7 = parcelRequire("1Wvh7");
var $9SpSV = parcelRequire("9SpSV");
var $3HbPC = parcelRequire("3HbPC");
/** IDs das notas no lote: array JSON, string JSON (driver legado) ou texto agregado. */ const $c15275aa38f8683d$var$extractLotInvoiceIds = function(lot) {
    let rawInv = lot.invoices;
    if (typeof rawInv === 'string' && rawInv.trim()) try {
        rawInv = JSON.parse(rawInv);
    } catch (e) {
        rawInv = null;
    }
    if (Array.isArray(rawInv) && rawInv.length) return rawInv.map((x)=>Number(x));
    const raw = lot.invoice_numbers;
    if (raw != null && String(raw).trim()) return String(raw).trim().split(/\s+/).map(Number);
    return [];
};
const $c15275aa38f8683d$var$splitAligned = function(seq, n) {
    if (seq == null || String(seq).trim() === '') return Array.from({
        length: n
    }, ()=>'');
    const parts = String(seq).trim().split(/\s+/);
    return Array.from({
        length: n
    }, (_, i)=>parts[i] ?? '');
};
/** Mensagens agregadas no SQL com ` | ` entre notas. */ const $c15275aa38f8683d$var$splitInvoiceLastTextsAgg = function(s, n) {
    if (s == null || String(s).trim() === '') return Array.from({
        length: n
    }, ()=>'');
    const parts = String(s).split(/\s*\|\s*/).map((p)=>p.trim());
    return Array.from({
        length: n
    }, (_, i)=>parts[i] ?? '');
};
/** Corpo do detalhe montado em DOM (textContent): imune a `</…>` em dados da API. */ const $c15275aa38f8683d$var$buildLotInvoicesPanel = function(lot, invoiceIds, lotIdFromGrid) {
    const root = document.createElement('div');
    root.className = 'lot-inv-detail';
    const meta = document.createElement('p');
    meta.className = 'lot-inv-detail__meta';
    const labelLot = lot.id != null ? lot.id : lotIdFromGrid;
    const b1 = document.createElement('strong');
    b1.textContent = 'Lote:';
    meta.appendChild(b1);
    meta.appendChild(document.createTextNode(' ' + String(labelLot) + ' \u00a0 '));
    const b2 = document.createElement('strong');
    b2.textContent = 'Notas:';
    meta.appendChild(b2);
    meta.appendChild(document.createTextNode(' ' + String(invoiceIds.length)));
    root.appendChild(meta);
    const head = document.createElement('div');
    head.className = 'lot-inv-detail__grid lot-inv-detail__grid--head';
    [
        'NF',
        'Origem',
        'Chave',
        "C\xf3digo",
        'Status',
        'Mensagem'
    ].forEach((lab)=>{
        const sp = document.createElement('span');
        sp.textContent = lab;
        head.appendChild(sp);
    });
    root.appendChild(head);
    const n = invoiceIds.length;
    const keys = $c15275aa38f8683d$var$splitAligned(lot.invoice_keys, n);
    const ioIds = $c15275aa38f8683d$var$splitAligned(lot.invoice_io_ids, n);
    const codes = $c15275aa38f8683d$var$splitAligned(lot.invoice_last_codes, n);
    const texts = $c15275aa38f8683d$var$splitInvoiceLastTextsAgg(lot.invoice_last_texts, n);
    for(let i = 0; i < n; i++){
        const row = document.createElement('div');
        row.className = 'lot-inv-detail__grid lot-inv-detail__row';
        const code = codes[i] ?? '';
        const ok100 = String(code) === '100';
        const status = ok100 ? 'Autorizada' : code ? 'Com retorno' : 'Pendente';
        const cells = [
            String(invoiceIds[i]),
            String(ioIds[i] ?? ''),
            String(keys[i] ?? ''),
            String(code),
            status,
            String(texts[i] ?? '')
        ];
        cells.forEach((txt)=>{
            const sp = document.createElement('span');
            sp.textContent = txt;
            row.appendChild(sp);
        });
        root.appendChild(row);
    }
    return root;
};
const $c15275aa38f8683d$var$invoiceLots = function() {
    let invoice_lots_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_invoice_lots, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_invoice_lot, ...JSON.parse(id));
            _record['invoices'] = _record['invoices'].map((invoice)=>String(invoice)).join(' ');
            return _record;
        },
        async saveRecord (data, old_data) {
            let _record = {
                type: data.type,
                invoices: data.invoices.split(' ').map((invoice)=>Number(invoice))
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_invoice_lot, data.company_id, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_invoice_lot, data.company_id, _record);
        },
        sendLots () {
            if (!this.ensureSelection("Transmiss\xe3o SEFAZ")) return;
            const sendRequest = async ()=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (!ids.length) {
                    (0, $jUNyh.notify)('Selecione ao menos um lote.', "Transmiss\xe3o SEFAZ");
                    return;
                }
                const pauseMs = 2500;
                let total = 0;
                let failed = 0;
                for(let i = 0; i < ids.length; i++){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).send_invoice_lots, {
                        ids: [
                            ids[i]
                        ]
                    });
                    if (resp == null) {
                        failed++;
                        break;
                    }
                    total += resp.count || 0;
                    if (i + 1 < ids.length) await new Promise((r)=>setTimeout(r, pauseMs));
                }
                const extra = failed ? ` (interrompeu ap\xf3s falha; ${failed} lote(s) n\xe3o transmitido(s))` : '';
                (0, $jUNyh.notify)(`Lotes transmitidos: ${total}${extra}`, 'Resultado');
                this.loadPage();
            };
            (0, $jUNyh.ask)(`Transmitir ${this.getCount()} lote(s) para a Sefaz? (um por vez)`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        queryLots () {
            if (!this.ensureSelection('Consulta SEFAZ')) return;
            const sendRequest = async ()=>{
                const ids = await this.getSelectedIds([
                    'company_id',
                    'id'
                ]);
                if (!ids.length) {
                    (0, $jUNyh.notify)('Selecione ao menos um lote.', 'Consulta SEFAZ');
                    return;
                }
                // Um lote por vez: evita estourar workers/SEFAZ e permite vários 103 pendentes.
                const pauseMs = 2500;
                let total = 0;
                let failed = 0;
                for(let i = 0; i < ids.length; i++){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).query_invoice_lots, {
                        ids: [
                            ids[i]
                        ]
                    });
                    if (resp == null) {
                        failed++;
                        break;
                    }
                    total += resp.count || 0;
                    if (i + 1 < ids.length) await new Promise((r)=>setTimeout(r, pauseMs));
                }
                const extra = failed ? ` (interrompeu ap\xf3s falha; ${failed} lote(s) n\xe3o consultado(s))` : '';
                (0, $jUNyh.notify)(`Lotes consultados: ${total}${extra}`, 'Resultado');
                this.loadPage();
            };
            (0, $jUNyh.ask)(`Consultar ${this.getCount()} lote(s) com a Sefaz? (um por vez)`, "Confirma\xe7\xe3o", (answer)=>{
                if (answer == 'Y') sendRequest();
            });
        },
        async showLotInvoices () {
            const ids = await this.getSelectedIds([
                'company_id',
                'id'
            ]);
            if (!ids.length) {
                (0, $jUNyh.notify)('Selecione um lote de notas.', 'Notas do lote');
                return;
            }
            if (ids.length > 1) {
                (0, $jUNyh.notify)('Selecione apenas um lote para detalhar.', 'Notas do lote');
                return;
            }
            const [companyId, lotId] = ids[0];
            const lot = await (0, $9VcS9.default).call((0, $9VcS9.default).select_invoice_lot, companyId, lotId);
            if (!lot) return;
            const invoiceIds = $c15275aa38f8683d$var$extractLotInvoiceIds(lot);
            if (!invoiceIds.length) {
                (0, $jUNyh.notify)('Nenhuma nota vinculada a este lote.', 'Notas do lote');
                return;
            }
            const panel = $c15275aa38f8683d$var$buildLotInvoicesPanel(lot, invoiceIds, lotId);
            (0, $jUNyh.notifyElement)(panel, 'Notas do lote');
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 2,
            field: 'id',
            label: 'Lote',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do lote'
        },
        {
            index: 15,
            field: 'invoice_count',
            label: 'Qtd. notas',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Quantidade de notas vinculadas ao lote'
        },
        {
            index: 19,
            field: 'invoice_numbers',
            label: 'NFs',
            types: [],
            placeholder: '',
            title: "N\xfameros das notas vinculadas ao lote"
        },
        {
            index: 4,
            field: 'type',
            label: 'Tipo',
            types: [
                $b23279d219d3efdd$export$2e2bcd8739ae039(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Tipo de lote'
        },
        {
            index: 6,
            field: 'receipt',
            label: 'Recibo',
            types: [
                $5UO7m.default()
            ],
            placeholder: '0',
            title: "N\xfamero do recibo do lote"
        },
        {
            index: 8,
            field: 'result_code',
            label: "C\xf3digo lote",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "C\xf3digo de retorno do lote"
        },
        {
            index: 9,
            field: 'result_text',
            label: 'Mensagem lote',
            types: [],
            placeholder: '',
            title: 'Mensagem de retorno do lote'
        },
        {
            index: 10,
            field: 'result_datetime',
            label: 'Data/Hora',
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: "Data e hora da \xfaltima opera\xe7\xe3o"
        },
        {
            index: 5,
            field: 'state',
            label: 'Estado',
            types: [
                $3HbPC.default,
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Unidade Federativa'
        },
        {
            index: 3,
            field: 'environment',
            label: 'Ambiente',
            types: [
                $9SpSV.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Ambiente de envio'
        },
        {
            index: 12,
            field: 'in_contingency',
            label: "Conting\xeancia",
            types: [
                $1Wvh7.default(),
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Envio em conting\xeancia"
        },
        {
            index: 20,
            field: 'invoice_keys',
            label: 'Chave NF',
            types: [],
            placeholder: '',
            title: 'Chave de acesso de uma nota do lote'
        },
        {
            index: 21,
            field: 'invoice_io_ids',
            label: "Entrada/Sa\xedda NF",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "Entrada ou sa\xedda vinculada \xe0 nota"
        },
        {
            index: 22,
            field: 'invoice_last_codes',
            label: "C\xf3digo NF",
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: "C\xf3digo de retorno das notas do lote"
        },
        {
            index: 23,
            field: 'invoice_last_texts',
            label: 'Mensagem NF',
            types: [],
            placeholder: '',
            title: 'Mensagem de retorno das notas do lote'
        }
    ];
    let operations = [
        {
            hash: '#show-lot-invoices',
            label: 'Ver&nbsp;notas&nbsp;do&nbsp;lote'
        },
        {
            hash: '#send-lots',
            label: 'Transmitir&nbsp;lotes&nbsp;para&nbsp;Sefaz'
        },
        {
            hash: '#query-lots',
            label: 'Consultar&nbsp;lotes&nbsp;pendentes'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#show-lot-invoices', invoice_lots_crud.showLotInvoices.bind(invoice_lots_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#send-lots', invoice_lots_crud.sendLots.bind(invoice_lots_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#query-lots', invoice_lots_crud.queryLots.bind(invoice_lots_crud));
    invoice_lots_crud.run('invoice_lots', 'Lotes&nbsp;Notas', document.getElementById('workarea'), (0, $708f028c2d9a84ab$export$2e2bcd8739ae039), (0, $88d370256d2b3a0d$export$2e2bcd8739ae039), fieldspecs, operations);
};
var $c15275aa38f8683d$export$2e2bcd8739ae039 = $c15275aa38f8683d$var$invoiceLots;



var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");
const $2a8fd6eadff71f40$var$esc = (value)=>String(value ?? '').replace(/[&<>"']/g, (ch)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[ch]);
/**
 * Faz download de conteúdo base64 retornado pela API.
 */ function $2a8fd6eadff71f40$var$downloadBase64(base64Content, filename, mimeType) {
    const bin = atob(base64Content);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
    const blob = new Blob([
        arr
    ], {
        type: mimeType
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'controle-emissao-nf.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $2a8fd6eadff71f40$export$2e2bcd8739ae039() {
    const workarea = document.getElementById('workarea');
    if (!workarea) return;
    workarea.innerHTML = `
		<h2>Controle de emiss\xe3o de NF</h2>
		<form id="nfe-emission-control" class="form" style="margin-bottom:1rem;">
			<div class="fsb">
				<label>Empresa<sup>*</sup><select id="company_id" required style="width:14rem;"></select></label>
				<label>Data inicial<input id="date_from" type="date"></label>
				<label>Data final<input id="date_to" type="date"></label>
				<label>Status NF<input id="nf_status" type="text" placeholder="Ex.: SEM_NF" style="width:12rem;"></label>
				<label>Refer\xeancia<input id="reference" type="text" style="width:12rem;"></label>
				<label>N\xfamero NF<input id="invoice_number" type="text" style="width:8rem;"></label>
			</div>
			<div class="fsb mtm">
				<button type="button" class="button" id="btn-search">Consultar</button>
				<button type="button" class="button" id="btn-csv">Exportar CSV</button>
				<span id="nfe-count" style="margin-left:1rem;color:#666;"></span>
			</div>
		</form>
		<div id="nfe-result"></div>
	`;
    const companies = await (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, '?limit=0');
    const select = workarea.querySelector('#company_id');
    (companies || []).forEach((company)=>{
        const opt = document.createElement('option');
        opt.value = company.id;
        opt.textContent = company.nick || company.name || company.id;
        select.appendChild(opt);
    });
    const payload = (format = 'json')=>{
        const get = (id)=>workarea.querySelector(`#${id}`)?.value?.trim() || '';
        const data = {
            format: format
        };
        [
            'date_from',
            'date_to',
            'nf_status',
            'reference',
            'invoice_number'
        ].forEach((key)=>{
            const v = get(key);
            if (v) data[key] = v;
        });
        return data;
    };
    const renderRows = (result)=>{
        const rows = Array.isArray(result) ? result : result?.rows || [];
        if (!Array.isArray(rows) || !rows.length) {
            workarea.querySelector('#nfe-result').innerHTML = '<p>Nenhum registro encontrado.</p>';
            return;
        }
        workarea.querySelector('#nfe-result').innerHTML = `
			<table class="view">
				<thead><tr>
					<th>Tipo</th><th>Refer\xeancia</th><th>NF</th><th>Status NF</th><th>Motivo</th><th>A\xe7\xe3o recomendada</th>
				</tr></thead>
				<tbody>${rows.map((row)=>`
					<tr>
						<td>${$2a8fd6eadff71f40$var$esc(row.type || row.io_type)}</td>
						<td>${$2a8fd6eadff71f40$var$esc(row.reference)}</td>
						<td>${$2a8fd6eadff71f40$var$esc(row.invoice_number)}</td>
						<td>${$2a8fd6eadff71f40$var$esc(row.nf_status_label || row.nf_status)}</td>
						<td>${$2a8fd6eadff71f40$var$esc(row.motivo_provavel || row.reason || row.motivo)}</td>
						<td>${$2a8fd6eadff71f40$var$esc(row.acao_recomendada || row.recommended_action)}</td>
					</tr>`).join('')}</tbody>
			</table>`;
    };
    workarea.querySelector('#btn-search')?.addEventListener('click', async ()=>{
        try {
            const company_id = select.value;
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).nfe_emission_control_report, company_id, payload());
            renderRows(data);
            const count = await (0, $9VcS9.default).call((0, $9VcS9.default).nfe_emission_control_count, company_id, payload());
            workarea.querySelector('#nfe-count').textContent = `${count?.count ?? 0} registro(s)`;
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), "Controle de emiss\xe3o de NF");
        }
    });
    workarea.querySelector('#btn-csv')?.addEventListener('click', async ()=>{
        try {
            const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).nfe_emission_control_report, select.value, payload('csv'));
            if (resp?.csv) $2a8fd6eadff71f40$var$downloadBase64(resp.csv, resp.filename, 'text/csv;charset=utf-8');
            else (0, $jUNyh.notify)('Nenhum CSV retornado.', "Controle de emiss\xe3o de NF");
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || String(e), "Controle de emiss\xe3o de NF");
        }
    });
}



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");
async function $e903493e9845218c$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; }
			.view td:nth-child(3)	{ text-align: left; max-width: 20rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Grupo</th>
					<th data-index="2" data-visible="${this.visible[1]}">Nome</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${record.name}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $fE2eE = parcelRequire("fE2eE");
var $4KjZQ = parcelRequire("4KjZQ");
var $74yTJ = parcelRequire("74yTJ");

var $1cmSR = parcelRequire("1cmSR");

var $jUNyh = parcelRequire("jUNyh");

var $aGGTj = parcelRequire("aGGTj");
/**
 * Agrupamento de endpoints por tipo de operação HTTP (modal Grupos → Disponíveis).
 */ /** POST operacionais (impressão, integração, aprovação…) — separados de POST CRUD. */ const $c321f797d97260f9$var$ACTION_POST_HINTS = [
    'print',
    'export',
    'import',
    'upload',
    'approve',
    'reject',
    'cancel',
    'close',
    'reverse',
    'confer',
    'pick',
    'unpick',
    'send',
    'query',
    'validate',
    'retry',
    'flush',
    'pull',
    'inutilizar',
    'report',
    'search-references',
    'list-stage',
    'list_output',
    'move-all',
    'create-invoices',
    'create-lots',
    'create-archive',
    'create-outputs',
    'complete',
    'putaway',
    'inventory',
    'repair',
    'dispatch',
    'mappings',
    'overturn',
    'balance-trace',
    'count-report',
    'print-report',
    'create-pending',
    'manual-status',
    'collector'
];
const $c321f797d97260f9$export$e256071e4004c42c = [
    {
        id: 'consultas',
        label: 'Consultas (GET)'
    },
    {
        id: 'insercao',
        label: "Inser\xe7\xe3o (POST)"
    },
    {
        id: 'acoes',
        label: "A\xe7\xf5es e relat\xf3rios (POST)"
    },
    {
        id: 'modificacao',
        label: "Modifica\xe7\xe3o (PUT/PATCH)"
    },
    {
        id: 'exclusao',
        label: "Exclus\xe3o (DELETE)"
    },
    {
        id: 'outros',
        label: 'Outros'
    }
];
function $c321f797d97260f9$export$6ea412b11c9a3aef(ep) {
    const method = String(ep?.method || '').toUpperCase();
    const path = String(ep?.endpoint || '').toLowerCase();
    if (method === 'GET') return 'consultas';
    if (method === 'DELETE') return 'exclusao';
    if (method === 'PUT' || method === 'PATCH') return 'modificacao';
    if (method === 'POST') {
        if ($c321f797d97260f9$var$ACTION_POST_HINTS.some((hint)=>path.includes(hint))) return 'acoes';
        return 'insercao';
    }
    return 'outros';
}


/**
 * Presets de endpoints por cargo (modal Grupos → «Por cargo»).
 * Um clique inclui todos os endpoints do cargo ainda não atribuídos ao grupo.
 *
 * Fonte única também para migrações: ver `migrationGroups` + `doc/migrations/MAPA-CARGOS-PERMISSOES.md`.
 *
 * Campos:
 * - patterns: substring em path (`endpoint`) ou nome — inclui (qualquer método)
 * - getPatterns: mesma lógica, somente GET (consultas)
 * - excludePatterns: remove matches (útil em all / pacotes amplos)
 *   Prefixo `^` = só path exato ou path que começa com o prefixo + `/`
 *   (evita `/auth` excluir `/integrations/ceaf/auth`)
 *   Prefixo `=` = path exatamente igual (ex.: `=/companies`)
 * - all: true → todos os endpoints (respeitando excludePatterns)
 * - migrationGroups: nomes em `groups.name` para SQL de permissão (primary + aliases legados)
 */ const $1fac238c462a9741$var$cargoPresets = [
    {
        label: 'Separador',
        hint: "Somente picking (web + coletor): separa\xe7\xe3o, caixas, picklists e etiquetas de volume/stage.",
        migrationGroups: [
            'Separador',
            "Operadores de Sa\xedda",
            'Op. Empilhadeira'
        ],
        patterns: [
            '/output-picking',
            'output-picking-boxes',
            'countback',
            'print-picklists',
            'print-picklist-order',
            'print-pick-control',
            'print-pallets-overturn',
            'picking-waves',
            'print-stage-labels',
            'list-stage-labels',
            'list-volumes',
            'volume-labels',
            'print-labels',
            'picked-by',
            'outputs/search',
            '/outputs/list-'
        ],
        getPatterns: [
            '/outputs',
            '/output-orders',
            '/output-picking',
            'output-picking-boxes'
        ],
        excludePatterns: [
            'conference',
            'conferenc',
            'create-invoices',
            'reverse',
            'unpick-approve',
            'unpick-reject',
            'manual-status',
            'approve-orders',
            'reject-orders',
            'input-orders/approve-batch',
            'input-orders/reject-batch',
            'dock-expedition/advance',
            'print-conference',
            'print-aviso',
            'print-romaneio',
            'print-iqvia',
            'print-details',
            'print-balance-trace',
            'delete-separate',
            'repair-'
        ]
    },
    {
        label: 'Conferente',
        hint: "Confer\xeancia de entrada e sa\xedda (web + coletor), checkpoints e diverg\xeancias.",
        migrationGroups: [
            'Conferente',
            'Operadores de Entrada'
        ],
        patterns: [
            'output-conference',
            '/conference',
            'collector-conference',
            'print-conference',
            'divergences',
            '/inputs/',
            '/inputs',
            'inputs-complete',
            'inputs-coletor',
            'inputs/<input_id>/inventory',
            'putaway',
            'input-rastro',
            'verified-at',
            'resolve-gtin',
            'checked-by'
        ],
        getPatterns: [
            '/outputs',
            '/output-orders',
            '/inputs',
            '/input-orders',
            '/products',
            '/lots',
            '/stocks'
        ],
        excludePatterns: [
            '/output-picking',
            'print-picklists',
            'print-picklist-order',
            'reverse',
            'unpick-approve',
            'approve-orders',
            'reject-orders',
            'input-orders/approve-batch',
            'input-orders/reject-batch',
            'manual-status',
            'create-invoices',
            '/collector/inventory',
            '/inventory-sessions',
            'bulk-block',
            'bulk-unblock'
        ]
    },
    {
        label: "Auditor/Invent\xe1rio",
        hint: "Invent\xe1rio V2 (web + coletor), auditoria de estoque/reserva e ACTION audit:*.",
        migrationGroups: [
            "Auditor/Invent\xe1rio",
            "Operadores de Invent\xe1rio",
            "Gestores de Invent\xe1rio",
            "Invent\xe1rio - Contagem",
            "Invent\xe1rio - Gestor",
            'SUPERVISOR_AUDITORIA'
        ],
        patterns: [
            '/inventory-sessions',
            '/collector/inventory',
            '/inventories',
            '/audit/',
            'audit:',
            'audit-pending',
            'audit-report',
            'bi-audit',
            '/stock/reservation-link',
            '/stock/release-orphan',
            '/stock/negative-balance',
            'print-divergences',
            'print-progress',
            'print-simulation',
            'print-closure',
            'simulate-close',
            '/close/start',
            '/close/tick',
            '/close/status',
            'unfreeze',
            'clear-counts',
            'finalize-found',
            'close-preview',
            'confirm-shortage',
            'location-progress',
            'complete-preview',
            '/locations/complete',
            '/locations/close'
        ]
    },
    {
        label: "Analista Opera\xe7\xe3o",
        hint: "Opera\xe7\xe3o do dia a dia no SIAL web (sem aprovar, estornar, params ou integra\xe7\xf5es).",
        migrationGroups: [
            "Analista Opera\xe7\xe3o",
            "Gestores de Armaz\xe9m",
            "Operadores de Sa\xedda",
            "Operadores de Pedido de Sa\xedda"
        ],
        patterns: [
            '/outputs',
            '/output-orders',
            '/output-picking',
            '/output-unpick',
            '/output-conference',
            '/inputs',
            '/input-orders',
            '/receipt-types',
            '/stocks',
            '/stock-management',
            '/transactions',
            '/movements',
            'movement-kind',
            'movement-control',
            '/lots',
            '/warehouses',
            '/locations',
            '/replenishment',
            '/devices',
            '/customers',
            '/customer-routes',
            '/customer-delivery',
            '/products',
            '/packagings',
            '/product-packagings',
            'print-',
            'resolve-gtin',
            'putaway',
            'order-upload',
            'import-xml',
            'search-references',
            'espelho-pedido',
            'export-list-csv',
            '/outputs/export-csv',
            '/inputs/export-csv',
            'expected-delivery',
            'create-pending-order',
            'shortage-link',
            'dock-expedition',
            'input-dock-schedules',
            'picking-waves',
            'collector-conference',
            'unpick-request',
            'location-move',
            'locations-catalog',
            'sku-no-output',
            'expiring-items',
            'output-purchase',
            'storage-class',
            'stock-packaging',
            'balance-blocks',
            'print-balance',
            // logística / SESSP operação
            '/shipments',
            '/vehicles',
            '/drivers',
            '/cte-documents',
            '/delivery-proofs',
            '/returns',
            '/exchange-letters',
            '/sessp/drs-regions',
            '/sessp/sla-rules',
            '/sla-rules',
            '/transport-events'
        ],
        getPatterns: [
            '=/companies'
        ],
        excludePatterns: [
            'approve-orders',
            'reject-orders',
            'input-orders/approve-batch',
            'input-orders/reject-batch',
            'reverse',
            'unpick-approve',
            'unpick-reject',
            'manual-status-advance',
            'dock-expedition/advance',
            'bulk-block',
            'bulk-unblock',
            '^/endpoints',
            '^/auth',
            '^/groups',
            '^/users',
            '/techhub',
            '/gsnet',
            '/amil/',
            'vendatus',
            'iqvia',
            'closeup',
            'forced-pull',
            'forced-flush',
            '/integration-events',
            '/integrations/ceaf',
            '/inventory-sessions',
            '/collector/inventory',
            '/audit/',
            'audit:',
            '/invoices',
            '/invoice-lots',
            'nfe-emission',
            'inutilizar',
            'create-invoices',
            '/reports/',
            'kardex',
            'bi-',
            '/bi/',
            '/import-center',
            '/logs',
            '/version',
            '/sessp/billing',
            '/billing-tariffs',
            '/billing-periods'
        ]
    },
    {
        label: "Gestor Opera\xe7\xe3o",
        hint: "Opera\xe7\xe3o + supervis\xe3o: aprovar, estornar, doca, bloqueios, reparos e exce\xe7\xf5es.",
        migrationGroups: [
            "Gestor Opera\xe7\xe3o",
            "Gestores de Armaz\xe9m"
        ],
        patterns: [
            '/outputs',
            '/output-orders',
            '/output-picking',
            '/output-unpick',
            '/output-conference',
            '/inputs',
            '/input-orders',
            '/receipt-types',
            '/stocks',
            '/stock-management',
            '/transactions',
            '/movements',
            'movement-kind',
            'movement-control',
            '/lots',
            '/warehouses',
            '/locations',
            '/replenishment',
            '/devices',
            '/customers',
            '/customer-routes',
            '/customer-delivery',
            '/products',
            '/packagings',
            '/product-packagings',
            'print-',
            'resolve-gtin',
            'putaway',
            'order-upload',
            'import-xml',
            'search-references',
            'espelho-pedido',
            'export-list-csv',
            '/outputs/export-csv',
            '/inputs/export-csv',
            'expected-delivery',
            'create-pending-order',
            'shortage-link',
            'dock-expedition',
            'input-dock-schedules',
            'picking-waves',
            'collector-conference',
            'unpick-request',
            'unpick-approve',
            'unpick-reject',
            'approve-orders',
            'reject-orders',
            'input-orders/approve-batch',
            'input-orders/reject-batch',
            'reverse',
            'manual-status-advance',
            'repair-',
            'delete-separate',
            'bulk-block',
            'bulk-unblock',
            'bulk-move',
            'batch-patch',
            'change-packaging',
            'split-stock',
            'unitarize',
            'lot-meta-preview',
            'location-move',
            'locations-catalog',
            'sku-no-output',
            'expiring-items',
            'output-purchase',
            'storage-class',
            'stock-packaging',
            'balance-blocks',
            '/audit/approve',
            'audit:release_block',
            'audit:release_reservation',
            'audit:approve_bulk',
            '/stock/reservation-link',
            '/stock/release-orphan',
            '/stock/negative-balance',
            '/shipments',
            '/vehicles',
            '/drivers',
            '/cte-documents',
            '/delivery-proofs',
            '/returns',
            '/exchange-letters',
            '/sessp/drs-regions',
            '/sessp/sla-rules',
            '/sla-rules',
            '/transport-events'
        ],
        getPatterns: [
            '=/companies'
        ],
        excludePatterns: [
            '^/endpoints',
            '^/auth',
            '^/groups',
            '^/users',
            '/techhub',
            '/gsnet',
            '/amil/',
            'vendatus',
            'iqvia',
            'closeup',
            'forced-pull',
            'forced-flush',
            '/integration-events',
            '/integrations/ceaf',
            '/inventory-sessions',
            '/collector/inventory',
            '/invoices',
            '/invoice-lots',
            'nfe-emission',
            'inutilizar',
            'create-invoices',
            '/reports/',
            'kardex',
            'bi-',
            '/bi/',
            '/import-center',
            '/sessp/billing',
            '/billing-tariffs',
            '/billing-periods'
        ]
    },
    {
        label: 'Analista Faturamento',
        hint: "100% do m\xf3dulo de faturamento (NFs) + consultas gerais operacionais (GET).",
        migrationGroups: [
            'Analista Faturamento',
            'Administrativo'
        ],
        patterns: [
            '/invoices',
            '/invoice-lots',
            'nfe-emission',
            'inutilizar',
            'create-invoices',
            'create-lots',
            'create-archive',
            'update-xml',
            'print-iqvia',
            '/cfops',
            '/sessp/billing',
            '/billing-tariffs',
            '/billing-periods'
        ],
        getPatterns: [
            '/outputs',
            '/output-orders',
            '/inputs',
            '/input-orders',
            '/stocks',
            '/lots',
            '/products',
            '/class-tribs',
            '/customers',
            '/suppliers',
            '/carriers',
            '/warehouses',
            '/locations',
            '/programs',
            '/payment-terms',
            '/price-lists',
            '/customer-prices',
            '/reports/',
            '=/companies'
        ]
    },
    {
        label: 'Analista Cadastro',
        hint: "Cadastros e consultas de cat\xe1logo, comercial, organiza\xe7\xe3o e armazenamento (sem invent\xe1rio/params).",
        migrationGroups: [
            'Analista Cadastro'
        ],
        patterns: [
            '/products',
            '/packagings',
            '/product-packagings',
            '/categories',
            '/manufacturers',
            '/units',
            '/classes',
            '/programs',
            '/customers',
            '/customer-routes',
            '/customer-prices',
            '/customer-delivery',
            '/payment-terms',
            '/price-lists',
            '/cfops',
            '/suppliers',
            '/carriers',
            '/warehouses',
            '/locations',
            '/lots',
            '/receipt-types',
            '/input-docks',
            '/devices',
            '/replenishment',
            'count-report',
            'print-report',
            'locations-catalog',
            'resolve-gtin',
            'expiring-items',
            '/import-center',
            '/states',
            '/cities',
            '=/companies',
            '/sessp/drs-regions',
            '/sessp/sla-rules',
            '/sla-rules'
        ],
        excludePatterns: [
            '/inventory-sessions',
            '/collector/inventory',
            '/inventories',
            '/audit/',
            'audit:',
            '^/endpoints',
            '^/auth',
            '^/groups',
            '^/users',
            '/techhub',
            '/gsnet',
            '/amil/',
            '/invoices',
            '/invoice-lots',
            'bulk-block',
            'bulk-unblock',
            'reverse',
            'approve-orders',
            'reject-orders',
            'input-orders/approve-batch',
            'input-orders/reject-batch'
        ]
    },
    {
        label: 'Analista BI',
        hint: "Todas as fun\xe7\xf5es de BI e relat\xf3rios anal\xedticos.",
        migrationGroups: [
            'Analista BI',
            'Bi'
        ],
        patterns: [
            '/reports/',
            '/companies/<company_id>/reports',
            'kardex',
            'stock-complete',
            'stock-blocks-descriptive',
            'output-lines',
            'output-productivity',
            'audit-report',
            'products-general',
            'product-packagings',
            'movement-control',
            'output-purchase',
            'expiring-items',
            'locations-catalog',
            'bi-',
            '/bi/',
            'nfe-emission-control',
            'ceaf-stock',
            'input-documents',
            'inputs-complete'
        ]
    },
    {
        label: "Analista Integra\xe7\xe3o",
        hint: "TechHub, GSNET, AMIL, Vendatus, IQVIA, Close-Up e eventos de integra\xe7\xe3o.",
        migrationGroups: [
            "Analista Integra\xe7\xe3o",
            'IBL Tech Sistemas',
            'Sessp'
        ],
        patterns: [
            '/integration-events',
            '/integrations/',
            '/techhub',
            '/gsnet',
            '/amil/',
            'amil-',
            'iqvia',
            'closeup',
            'vendatus',
            'entity-alerts',
            'forced-pull',
            'forced-flush',
            'print-iqvia',
            '/integrations/ceaf'
        ]
    },
    {
        label: 'Analista Gente',
        hint: "Manuten\xe7\xe3o de usu\xe1rios e grupos.",
        migrationGroups: [
            'Analista Gente'
        ],
        patterns: [
            '^/users',
            '^/groups'
        ],
        excludePatterns: [
            '^/endpoints',
            '^/auth',
            '/import-center',
            '/integration-events',
            '/techhub',
            '/logs'
        ]
    },
    {
        label: 'Gerente',
        hint: "Quase tudo no SIAL, exceto par\xe2metros sist\xeamicos (endpoints e auth). Inclui usu\xe1rios, grupos, BI e integra\xe7\xf5es.",
        migrationGroups: [
            'Gerente'
        ],
        all: true,
        excludePatterns: [
            '^/endpoints',
            '^/auth'
        ]
    },
    {
        label: 'Administrador',
        hint: 'Tudo que existe no SIAL.',
        migrationGroups: [
            'Administrador',
            'Administradores'
        ],
        all: true
    }
];
var $1fac238c462a9741$export$2e2bcd8739ae039 = $1fac238c462a9741$var$cargoPresets;
/**
 * @param {{ endpoint?: string, name?: string, method?: string }} ep
 * @param {string} pat
 */ function $1fac238c462a9741$var$_matchesPat(ep, pat) {
    const path = String(ep?.endpoint || '').toLowerCase();
    const name = String(ep?.name || '').toLowerCase();
    let p = String(pat || '').toLowerCase();
    if (!p) return false;
    // Prefixo de path estrito: ^/auth casa /auth e /auth/login, mas NÃO /integrations/ceaf/auth
    if (p.startsWith('^')) {
        const prefix = p.slice(1);
        if (!prefix) return false;
        return path === prefix || path.startsWith(`${prefix}/`);
    }
    // Path exatamente igual
    if (p.startsWith('=')) {
        const exact = p.slice(1);
        return path === exact;
    }
    return path.includes(p) || name.includes(p.replace(/\//g, ' ').trim());
}
function $1fac238c462a9741$export$424037a17a85ceaa(ep, functionGroup) {
    const exclude = functionGroup.excludePatterns || [];
    if (exclude.some((pat)=>$1fac238c462a9741$var$_matchesPat(ep, pat))) return false;
    if (functionGroup.all) return true;
    const patterns = functionGroup.patterns || [];
    if (patterns.some((pat)=>$1fac238c462a9741$var$_matchesPat(ep, pat))) return true;
    const method = String(ep?.method || '').toUpperCase();
    if (method === 'GET') {
        const getPatterns = functionGroup.getPatterns || [];
        if (getPatterns.some((pat)=>$1fac238c462a9741$var$_matchesPat(ep, pat))) return true;
    }
    return false;
}
function $1fac238c462a9741$export$a2c55b59189d0cec() {
    return $1fac238c462a9741$var$cargoPresets.map((g)=>({
            label: g.label,
            groups: [
                ...g.migrationGroups || [
                    g.label
                ]
            ],
            hint: g.hint || ''
        }));
}
function $1fac238c462a9741$export$b660dfc2d9191b58(cargoLabels, opts = {}) {
    const labels = Array.isArray(cargoLabels) ? cargoLabels : [
        cargoLabels
    ];
    const names = new Set();
    for (const label of labels){
        const g = $1fac238c462a9741$var$cargoPresets.find((x)=>x.label === label);
        for (const n of g?.migrationGroups || [
            label
        ])names.add(n);
    }
    if (opts.includeAdmin !== false) {
        names.add('Administradores');
        names.add('Administrador');
    }
    return [
        ...names
    ];
}


const $52653ea3be5fe7ab$var$compareByLabel = (a, b)=>String(a.name || '').localeCompare(String(b.name || ''), 'pt-BR', {
        sensitivity: 'base'
    }) || String(a.method || '').localeCompare(String(b.method || ''));
function $52653ea3be5fe7ab$export$bbcc4ade1da37929(endpoints, keymapField) {
    const buckets = Object.fromEntries((0, $c321f797d97260f9$export$e256071e4004c42c).map((c)=>[
            c.id,
            []
        ]));
    for (const ep of endpoints || []){
        const cat = (0, $c321f797d97260f9$export$6ea412b11c9a3aef)(ep);
        (buckets[cat] ?? buckets.outros).push(ep);
    }
    const parts = [];
    for (const cat of (0, $c321f797d97260f9$export$e256071e4004c42c)){
        const list = (buckets[cat.id] || []).sort($52653ea3be5fe7ab$var$compareByLabel);
        if (!list.length) continue;
        parts.push(`<optgroup label="${cat.label}">`);
        for (const ep of list){
            const value = (0, $aGGTj.stringify)(keymapField._values.map((key)=>ep[key]));
            const label = keymapField._labels.map((key)=>ep[key]).join(' ');
            parts.push(`<option value="${value}">${label}</option>`);
        }
        parts.push('</optgroup>');
    }
    return parts.join('\n');
}
function $52653ea3be5fe7ab$export$606e4b4eb5494594(availableSelect, query) {
    const q = (query || '').toLowerCase().trim();
    availableSelect.querySelectorAll('optgroup').forEach((og)=>{
        let visible = 0;
        og.querySelectorAll('option').forEach((opt)=>{
            const show = !q || opt.textContent.toLowerCase().includes(q);
            opt.hidden = !show;
            if (show) visible++;
        });
        og.hidden = visible === 0;
    });
}
async function $52653ea3be5fe7ab$export$2017d73745bd8fb4({ db: db, keymapField: keymapField, selectedSelect: selectedSelect, functionGroup: functionGroup }) {
    const all = await db.list('endpoints') || [];
    const selected = new Set((keymapField.getValue() || []).map(String));
    const toAdd = all.filter((ep)=>(0, $1fac238c462a9741$export$424037a17a85ceaa)(ep, functionGroup) && !selected.has(String(ep.id))).sort($52653ea3be5fe7ab$var$compareByLabel);
    for (const ep of toAdd){
        const html = await keymapField.makeOption(ep);
        if (html) selectedSelect.insertAdjacentHTML('beforeend', html);
    }
    if (toAdd.length) selectedSelect.dispatchEvent(new CustomEvent('move'));
    return toAdd.length;
}


var $d82290fc064f7de6$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#group-form-wrapper { min-width: 52rem; max-width: 90vw; }
			#group #id { width: 20rem; }
			#group #name { width: 20rem; }
			#group .endpoints-section { display: flex; gap: var(--space-md); align-items: flex-start; margin-bottom: var(--space-md); }
			#group .endpoints-keymap { flex: 1; display: flex; gap: var(--space-sm); align-items: stretch; }
			#group .endpoints-keymap .keymap:not(:has(button)) { min-width: 14rem; }
			#group .endpoints-keymap select { min-height: 14rem; }
			#group .endpoint-search { margin-bottom: var(--space-sm); }
			#group .endpoint-search input { width: 100%; max-width: 24rem; }
			#group .function-groups { display: flex; flex-wrap: wrap; gap: var(--space-xs); margin-bottom: var(--space-md); }
			#group .function-groups button { font-size: 0.85em; padding: 0.25rem 0.5rem; }
			#group .function-groups-title { font-size: 0.9em; color: var(--color-muted); margin-bottom: 0.25rem; }
			#group .function-groups-hint { font-size: 0.82em; color: var(--color-muted); margin: 0 0 0.35rem; max-width: 42rem; }
			#group .keymap-transfer { display: flex; flex-direction: column; gap: 0.25rem; justify-content: center; }
			#group .keymap-transfer button { min-width: 2.25rem; min-height: 2rem; font-size: 1.1rem; font-weight: bold; padding: 0.25rem; }
			#group #available_endpoints optgroup { font-weight: 600; font-style: normal; }
		</style>
		<div id="group-form-wrapper">
		<form id="group" class="form" autocomplete="off">
			<div class="fsb">
				<label title="Identificador do grupo">Grupo
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do grupo">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="endpoints-section">
				<div>
					<div class="function-groups-title">Por cargo (adicionar todos de uma vez)</div>
					<p class="function-groups-hint">Clique no <strong>cargo</strong> para incluir de uma vez todos os endpoints desse perfil que ainda n\xe3o est\xe3o no grupo. A lista \xabDispon\xedveis\xbb abaixo continua agrupada por tipo de opera\xe7\xe3o (consulta, inser\xe7\xe3o, a\xe7\xf5es\u{2026}).</p>
					<div class="function-groups" id="function-groups"></div>
					<div class="endpoint-search">
						<label>Buscar endpoints
							<input id="endpoint_search" type="text" placeholder="Digite para filtrar...">
						</label>
					</div>
					<div class="fsb endpoints-keymap">
						<label class="keymap">Endpoints<sup>*</sup>
							<select id="endpoints" multiple size="10" required>
							</select>
						</label>
						<span class="keymap keymap-transfer">
							<button type="button" class="bn_Left" title="Incluir endpoints selecionados">&#8592; Incluir</button>
							<button type="button" class="bn_Right" title="Remover endpoints selecionados">Remover &#8594;</button>
						</span>
						<label class="keymap">Dispon\xedveis
							<select id="available_endpoints" multiple size="10">
							</select>
						</label>
					</div>
				</div>
			</div>
			<div class="fsb">
				<label class="keymap">Empresas<sup>*</sup>
					<select id="companies" multiple size="6" required>
					</select>
				</label>
				<span class="keymap keymap-transfer">
					<button type="button" class="bn_Left" title="Incluir empresas">&#8592; Incluir</button>
					<button type="button" class="bn_Right" title="Remover empresas">Remover &#8594;</button>
				</span>
				<label class="keymap">Dispon\xedveis
					<select id="available_companies" multiple size="6">
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
		</div>
	`,
    form: {
        selector: '#group',
        init (formset) {
            const form = formset.form;
            const root = formset.dialog?.getNode?.();
            const endpointsField = form.getFieldBySelector('#endpoints');
            const refreshGroupedAvailable = async ()=>{
                if (!root) return;
                const availableSelect = root.querySelector('#available_endpoints');
                const searchInput = root.querySelector('#endpoint_search');
                const all = await (0, $1cmSR.default).list('endpoints') || [];
                const selected = new Set((endpointsField.getValue() || []).map(String));
                const available = all.filter((ep)=>!selected.has(String(ep.id)));
                availableSelect.innerHTML = (0, $52653ea3be5fe7ab$export$bbcc4ade1da37929)(available, endpointsField);
                (0, $52653ea3be5fe7ab$export$606e4b4eb5494594)(availableSelect, searchInput?.value || '');
            };
            endpointsField.fill = refreshGroupedAvailable;
            const originalMove = endpointsField.move.bind(endpointsField);
            endpointsField.move = async (ev)=>{
                originalMove(ev);
                await refreshGroupedAvailable();
            };
            Object.getPrototypeOf(this).init.call(this);
            if (!root) return;
            const searchInput = root.querySelector('#endpoint_search');
            const availableSelect = root.querySelector('#available_endpoints');
            const fnGroupsEl = root.querySelector('#function-groups');
            (0, $1fac238c462a9741$export$2e2bcd8739ae039).forEach((fg)=>{
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'button';
                btn.textContent = fg.label;
                btn.title = fg.hint || `Incluir todos os endpoints do cargo ${fg.label}`;
                btn.addEventListener('click', async ()=>{
                    try {
                        const count = await (0, $52653ea3be5fe7ab$export$2017d73745bd8fb4)({
                            db: $1cmSR.default,
                            keymapField: endpointsField,
                            selectedSelect: root.querySelector('#endpoints'),
                            functionGroup: fg
                        });
                        await refreshGroupedAvailable();
                        if (!count) (0, $jUNyh.notify)(`Nenhum endpoint novo para \xab${fg.label}\xbb (j\xe1 inclu\xeddos ou inexistentes).`, 'Grupos');
                        else (0, $jUNyh.notify)(`${count} endpoint(s) do cargo \xab${fg.label}\xbb inclu\xeddo(s).`, 'Grupos');
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Grupos');
                    }
                });
                fnGroupsEl?.appendChild(btn);
            });
            searchInput?.addEventListener('input', ()=>{
                (0, $52653ea3be5fe7ab$export$606e4b4eb5494594)(availableSelect, searchInput.value || '');
            });
            refreshGroupedAvailable().catch((e)=>(0, $jUNyh.notify)(e?.message || String(e), 'Grupos'));
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#endpoints'
            },
            types: [
                $fE2eE.default('endpoints', '#available_endpoints', {
                    labels: [
                        'name',
                        'method'
                    ]
                }),
                $4KjZQ.default()
            ]
        },
        {
            properties: {
                selector: '#companies'
            },
            types: [
                $fE2eE.default('all_companies', '#available_companies', {
                    labels: [
                        'nick'
                    ]
                }),
                $4KjZQ.default()
            ]
        }
    ]
};



var $74yTJ = parcelRequire("74yTJ");
const $f9ccb4979589756b$var$groups = function() {
    let groups_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            const [endpoints, companies] = await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_endpoints, this.queryAll()),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_all_companies, this.queryAll())
            ]);
            if (endpoints) await (0, $1cmSR.default).set('endpoints', endpoints).catch((e)=>(0, $jUNyh.notify)(e));
            if (companies) await (0, $1cmSR.default).set('all_companies', companies).catch((e)=>(0, $jUNyh.notify)(e));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_groups, query);
        },
        async loadRecord (id) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).select_group, ...JSON.parse(id));
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                endpoints: data.endpoints,
                companies: data.companies
            };
            if (old_data) return await (0, $9VcS9.default).call((0, $9VcS9.default).update_group, data.id, _record);
            else return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_group, _record);
        }
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Grupo',
            types: [],
            placeholder: '',
            title: 'Identificador do grupo'
        },
        {
            index: 2,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: 'Nome do grupo'
        }
    ];
    groups_crud.run('groups', 'Grupos', document.getElementById('workarea'), (0, $e903493e9845218c$export$2e2bcd8739ae039), (0, $d82290fc064f7de6$export$2e2bcd8739ae039), fieldspecs);
};
var $f9ccb4979589756b$export$2e2bcd8739ae039 = $f9ccb4979589756b$var$groups;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");



var $h1m6J = parcelRequire("h1m6J");

var $jUNyh = parcelRequire("jUNyh");

var $jHqD0 = parcelRequire("jHqD0");
async function $6c2838c21d5bc54c$export$2e2bcd8739ae039(records) {
    function statusLabel(record) {
        if (record.is_disabled) return 'Inativo';
        if (record.is_blocked) return 'Bloqueado';
        return 'Ativo';
    }
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; }
			.view td:nth-child(3)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(4)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(5)	{ text-align: left;	}
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Usu\xe1rio</th>
					<th data-index="2" data-visible="${this.visible[1]}">Nome</th>
					<th data-index="3" data-visible="${this.visible[2]}">Email</th>
					<th data-index="4" data-visible="${this.visible[3]}">Fone</th>
					<th data-index="5" data-visible="${this.visible[4]}">Username</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
					<th data-index="7" data-visible="${this.visible[6]}">Bloqueado</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${record.name}</td>
					<td data-visible='${this.visible[2]}'>${record.email || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format($jHqD0.default(), record.phone)}</td>
					<td data-visible='${this.visible[4]}'>${record.username}</td>
					<td data-visible='${this.visible[5]}'>${statusLabel(record)}</td>
					<td data-visible='${this.visible[6]}'>${record.is_blocked ? 'SIM' : 'NAO'}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $lVBv9 = parcelRequire("lVBv9");
var $fE2eE = parcelRequire("fE2eE");
var $4KjZQ = parcelRequire("4KjZQ");
var $74yTJ = parcelRequire("74yTJ");
var $jHqD0 = parcelRequire("jHqD0");
var $bSPRN = parcelRequire("bSPRN");
function $de5ba539ecb71508$var$lockoutExpirationIso() {
    const d = new Date();
    d.setDate(d.getDate() + 30);
    return d.toISOString();
}
const $de5ba539ecb71508$var$WEEKDAYS = [
    {
        key: 'mon',
        label: 'Seg'
    },
    {
        key: 'tue',
        label: 'Ter'
    },
    {
        key: 'wed',
        label: 'Qua'
    },
    {
        key: 'thu',
        label: 'Qui'
    },
    {
        key: 'fri',
        label: 'Sex'
    },
    {
        key: 'sat',
        label: "S\xe1b"
    },
    {
        key: 'sun',
        label: 'Dom'
    }
];
function $de5ba539ecb71508$var$timeOptionsHtml(selected) {
    const parts = [];
    for(let h = 0; h < 24; h += 1)for (const m of [
        0,
        30
    ]){
        const v = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
        parts.push(`<option value="${v}"${v === selected ? ' selected' : ''}>${v}</option>`);
    }
    return parts.join('');
}
function $de5ba539ecb71508$var$scheduleRowsHtml() {
    return $de5ba539ecb71508$var$WEEKDAYS.map(({ key: key, label: label })=>`
		<div class="uac-day" data-day="${key}">
			<label class="uac-day-check">
				<input type="checkbox" class="uac-enabled" data-day="${key}">
				<span>${label}</span>
			</label>
			<select class="uac-start" data-day="${key}" disabled>${$de5ba539ecb71508$var$timeOptionsHtml('08:00')}</select>
			<span class="uac-until">at\xe9</span>
			<select class="uac-end" data-day="${key}" disabled>${$de5ba539ecb71508$var$timeOptionsHtml('18:00')}</select>
		</div>
	`).join('');
}
function $de5ba539ecb71508$var$eventLabel(type) {
    return ({
        login: 'Login',
        logout: 'Logout',
        login_denied: 'Login negado',
        session_end: "Fim de sess\xe3o"
    })[type] || type || '';
}
function $de5ba539ecb71508$var$formatDuration(sec) {
    if (sec == null || sec === '') return "\u2014";
    const s = Number(sec);
    if (!Number.isFinite(s) || s < 0) return "\u2014";
    const h = Math.floor(s / 3600);
    const m = Math.floor(s % 3600 / 60);
    if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
    return `${m}m`;
}
function $de5ba539ecb71508$var$formatWhen(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
var $de5ba539ecb71508$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#user .form-tabs { display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem 0.5rem; padding: 0 0 0 0.5rem; background: #f1f5f9; border-radius: 8px 8px 0 0; margin: 0 0 0.75rem 0; }
			#user .form-tab { padding: 0.65rem 1.1rem; cursor: pointer; font-weight: 600; font-size: 0.88rem; color: #64748b; background: transparent; border: none; border-radius: 6px; }
			#user .form-tab:hover { color: #334155; background: #e2e8f0; }
			#user .form-tab.active { color: #4f46e5; background: white; box-shadow: 0 -1px 3px rgba(0,0,0,0.06); }
			#user .form-tab-panel { display: none; }
			#user .form-tab-panel.active { display: block; }
			#user #id { width: 20rem; }
			#user #name { width: 20rem; }
			#user #email { width: 20rem; }
			#user #phone { width: 10rem; }
			#user #username { width: 10rem; }
			#user #user_status { width: 10rem; }
			#user #manager_user_id { width: 22rem; }
			#user #access_override_until { width: 14rem; }
			#user .uac-master { display: flex; align-items: center; gap: 0.5rem; margin: 0.5rem 0 1rem; font-weight: 600; }
			#user .uac-schedule { display: flex; flex-direction: column; gap: 0.35rem; max-width: 36rem; }
			#user .uac-day { display: grid; grid-template-columns: 5.5rem 7rem auto 7rem; gap: 0.4rem; align-items: center; }
			#user .uac-day-check { display: flex; align-items: center; gap: 0.35rem; margin: 0; }
			#user .uac-until { color: #64748b; font-size: 0.85rem; }
			#user .uac-actions { margin: 0.6rem 0 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; }
			#user .uac-hint { font-size: 0.82rem; color: #64748b; margin: 0 0 0.75rem; }
			#user .uac-section { border-top: 1px solid #e2e8f0; margin-top: 1rem; padding-top: 0.75rem; }
			#user .uac-section h4 { margin: 0 0 0.5rem; font-size: 0.9rem; }
			#user .uac-log-filters { display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: end; margin-bottom: 0.5rem; }
			#user .uac-log-filters label { margin: 0; }
			#user .uac-log-table-wrap { max-height: 14rem; overflow: auto; border: 1px solid #e2e8f0; border-radius: 6px; }
			#user .uac-log-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
			#user .uac-log-table th, #user .uac-log-table td { border-bottom: 1px solid #f1f5f9; padding: 0.3rem 0.45rem; text-align: left; }
			#user .uac-log-table th { background: #f8fafc; position: sticky; top: 0; }
			#user .uac-he-row { display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: end; margin-bottom: 0.5rem; }
			#user .uac-disabled { opacity: 0.45; pointer-events: none; }
		</style>
		<form id="user" class="form" autocomplete="off">
			<div class="form-tabs">
				<button type="button" class="form-tab active" data-tab="dados">Dados</button>
				<button type="button" class="form-tab" data-tab="acesso">Controle de acesso</button>
			</div>
			<div class="form-tab-panels">
			<div id="tab-dados" class="form-tab-panel active">
			<div class="fsb">
				<label title="Status do usu\xe1rio no sistema">Status
					<input id="user_status" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Identificador do usu\xe1rio">Usu\xe1rio
					<input id="id" type="text" disabled>
				</label>
				<label title="Usu\xe1rio de acesso ao sistema">Username<sup>*</sup>
					<input id="username" type="text" required>
				</label>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
			</div>
			<div class="fsb">
				<label title="Nome do usu\xe1rio">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Grupos<sup>*</sup>
					<select id="groups" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button class="bn_Left" title="Incluir grupos selecionados \xe0 direita"> &#x1F844;</button>
					<button class="bn_Right" title="Remover grupos selecionados \xe0 esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Dispon\xedveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			</div>

			<div id="tab-acesso" class="form-tab-panel">
				<label class="uac-master">
					<input id="access_control_enabled" type="checkbox">
					Ligar controle de acesso
				</label>
				<p class="uac-hint">Fuso: America/Sao_Paulo. Dia desmarcado = sem acesso. Hor\xe1rios de 30 em 30 minutos.</p>
				<div id="uac_body">
					<div class="uac-schedule">
						${$de5ba539ecb71508$var$scheduleRowsHtml()}
					</div>
					<div class="uac-actions">
						<button type="button" class="button bn_uac_copy_mon">Copiar Seg \u{2192} dias \xfateis</button>
					</div>
					<div class="fsb">
						<label title="Gestor respons\xe1vel pela aprova\xe7\xe3o de horas extras">Respons\xe1vel (gestor)
							<input id="manager_user_id" type="text" list="users_managers" placeholder="Selecione o gestor">
						</label>
						<label title="Usu\xe1rio destinado ao Coletor">
							<input id="collector_only" type="checkbox"> Somente Coletor
						</label>
					</div>
					<div class="fsb">
						<label title="Libera\xe7\xe3o pontual at\xe9 data/hora (ISO local)">Libera\xe7\xe3o at\xe9
							<input id="access_override_until" type="datetime-local">
						</label>
					</div>
					<datalist id="users_managers"></datalist>

					<div class="uac-section">
						<h4>Horas extras</h4>
						<div class="uac-he-row">
							<label>De
								<input id="he_from" type="datetime-local">
							</label>
							<label>At\xe9
								<input id="he_to" type="datetime-local">
							</label>
							<label>Motivo
								<input id="he_reason" type="text" style="width:14rem">
							</label>
							<button type="button" class="button bn_he_create">Solicitar HE</button>
						</div>
						<div class="uac-log-table-wrap">
							<table class="uac-log-table">
								<thead>
									<tr><th>Per\xedodo</th><th>Status</th><th>Motivo</th><th></th></tr>
								</thead>
								<tbody id="he_tbody"></tbody>
							</table>
						</div>
					</div>

					<div class="uac-section">
						<h4>Log de sess\xe3o</h4>
						<div class="uac-log-filters">
							<label>De
								<input id="sess_from" type="date">
							</label>
							<label>At\xe9
								<input id="sess_to" type="date">
							</label>
							<button type="button" class="button bn_sess_search">Buscar</button>
							<button type="button" class="button bn_sess_csv">Exportar CSV</button>
							<button type="button" class="button bn_sess_xlsx">Exportar Excel</button>
						</div>
						<div class="uac-log-table-wrap">
							<table class="uac-log-table">
								<thead>
									<tr>
										<th>Data/hora</th>
										<th>Evento</th>
										<th>Origem</th>
										<th>IP</th>
										<th>Dura\xe7\xe3o</th>
										<th>Detalhe</th>
									</tr>
								</thead>
								<tbody id="sess_tbody"></tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			</div>

			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_user_disable" title="Impede login at\xe9 reativar">Inativar</button>
					<button type="button" class="button bn_user_enable" title="Permite login novamente">Ativar</button>
					<button type="button" class="button bn_user_block" title="Bloqueia login temporariamente">Bloquear</button>
					<button type="button" class="button bn_user_unblock" title="Remove bloqueio">Desbloquear</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
    form: {
        selector: '#user',
        init (formset) {
            const root = ()=>formset.dialog?.getNode?.();
            const formEl = ()=>root()?.querySelector?.('#user');
            const getId = ()=>formEl()?.querySelector?.('#id')?.value;
            const setStatus = (s)=>{
                const el = formEl()?.querySelector?.('#user_status');
                if (el) el.value = s;
            };
            const doAction = async (payload, statusLabel)=>{
                const id = getId();
                if (!id) return;
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).update_user, id, payload);
                if (resp != null) setStatus(statusLabel);
                else (0, $jUNyh.notify)("Falha ao atualizar usu\xe1rio.", "Usu\xe1rios");
            };
            const syncAccessEnabled = ()=>{
                const form = formEl();
                if (!form) return;
                const on = !!form.querySelector('#access_control_enabled')?.checked;
                const body = form.querySelector('#uac_body');
                if (body) body.classList.toggle('uac-disabled', !on);
                form.querySelectorAll('.uac-day').forEach((row)=>{
                    const en = row.querySelector('.uac-enabled');
                    const start = row.querySelector('.uac-start');
                    const end = row.querySelector('.uac-end');
                    const dayOn = on && !!en?.checked;
                    if (start) start.disabled = !dayOn;
                    if (end) end.disabled = !dayOn;
                    if (en) en.disabled = !on;
                });
            };
            const dialogNode = root();
            if (dialogNode) {
                dialogNode.addEventListener('click', (ev)=>{
                    const tab = ev.target?.closest?.('.form-tab');
                    if (tab && formEl()?.contains(tab)) {
                        ev.preventDefault();
                        const id = tab.getAttribute('data-tab');
                        formEl().querySelectorAll('.form-tab').forEach((t)=>t.classList.remove('active'));
                        formEl().querySelectorAll('.form-tab-panel').forEach((p)=>p.classList.remove('active'));
                        tab.classList.add('active');
                        formEl().querySelector(`#tab-${id}`)?.classList.add('active');
                        return;
                    }
                    const t = ev.target?.closest?.('.bn_user_disable');
                    if (t) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        doAction({
                            is_disabled: true
                        }, 'Inativo');
                        return;
                    }
                    const e = ev.target?.closest?.('.bn_user_enable');
                    if (e) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        doAction({
                            is_disabled: false
                        }, 'Ativo');
                        return;
                    }
                    const b = ev.target?.closest?.('.bn_user_block');
                    if (b) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        doAction({
                            lockout_expiration: $de5ba539ecb71508$var$lockoutExpirationIso()
                        }, 'Bloqueado');
                        return;
                    }
                    const u = ev.target?.closest?.('.bn_user_unblock');
                    if (u) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        doAction({
                            lockout_expiration: null
                        }, 'Ativo');
                        return;
                    }
                    const copy = ev.target?.closest?.('.bn_uac_copy_mon');
                    if (copy) {
                        ev.preventDefault();
                        const form = formEl();
                        const mon = form?.querySelector('.uac-day[data-day="mon"]');
                        if (!mon) return;
                        const en = mon.querySelector('.uac-enabled')?.checked;
                        const st = mon.querySelector('.uac-start')?.value;
                        const ed = mon.querySelector('.uac-end')?.value;
                        [
                            'tue',
                            'wed',
                            'thu',
                            'fri'
                        ].forEach((day)=>{
                            const row = form.querySelector(`.uac-day[data-day="${day}"]`);
                            if (!row) return;
                            const c = row.querySelector('.uac-enabled');
                            if (c) c.checked = !!en;
                            const s = row.querySelector('.uac-start');
                            const e2 = row.querySelector('.uac-end');
                            if (s && st) s.value = st;
                            if (e2 && ed) e2.value = ed;
                        });
                        syncAccessEnabled();
                        return;
                    }
                    const search = ev.target?.closest?.('.bn_sess_search');
                    if (search) {
                        ev.preventDefault();
                        loadSessionLog();
                        return;
                    }
                    const csv = ev.target?.closest?.('.bn_sess_csv');
                    if (csv) {
                        ev.preventDefault();
                        exportSession('csv');
                        return;
                    }
                    const xlsx = ev.target?.closest?.('.bn_sess_xlsx');
                    if (xlsx) {
                        ev.preventDefault();
                        exportSession('xlsx');
                        return;
                    }
                    const he = ev.target?.closest?.('.bn_he_create');
                    if (he) {
                        ev.preventDefault();
                        createHe();
                        return;
                    }
                    const appr = ev.target?.closest?.('.bn_he_approve');
                    if (appr) {
                        ev.preventDefault();
                        decideHe(appr.getAttribute('data-id'), 'approved');
                        return;
                    }
                    const rej = ev.target?.closest?.('.bn_he_reject');
                    if (rej) {
                        ev.preventDefault();
                        decideHe(rej.getAttribute('data-id'), 'rejected');
                        return;
                    }
                });
                dialogNode.addEventListener('change', (ev)=>{
                    if (ev.target?.id === 'access_control_enabled' || ev.target?.classList?.contains('uac-enabled')) syncAccessEnabled();
                });
            }
            const loadManagers = async ()=>{
                const form = formEl();
                const dl = form?.querySelector('#users_managers');
                if (!dl) return;
                try {
                    const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_users, '');
                    const list = Array.isArray(data) ? data : [];
                    dl.innerHTML = list.map((u)=>`<option value="${u.id}">${u.name || u.username || u.id}</option>`).join('');
                } catch (_) {}
            };
            const loadSessionLog = async ()=>{
                const id = getId();
                const form = formEl();
                const tbody = form?.querySelector('#sess_tbody');
                if (!id || !tbody) return;
                const from = form.querySelector('#sess_from')?.value;
                const to = form.querySelector('#sess_to')?.value;
                let q = '?limit=200';
                if (from) q += `&from=${encodeURIComponent(from + 'T00:00:00')}`;
                if (to) q += `&to=${encodeURIComponent(to + 'T23:59:59')}`;
                const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_user_session_events, id, q);
                const items = data?.items || [];
                tbody.innerHTML = items.length ? items.map((r)=>`<tr>
						<td>${$de5ba539ecb71508$var$formatWhen(r.occurred_at)}</td>
						<td>${$de5ba539ecb71508$var$eventLabel(r.event_type)}</td>
						<td>${r.origin || ''}</td>
						<td>${r.ip || ''}</td>
						<td>${$de5ba539ecb71508$var$formatDuration(r.duration_seconds)}</td>
						<td>${r.detail || ''}</td>
					</tr>`).join('') : '<tr><td colspan="6">Sem eventos no per\xedodo.</td></tr>';
            };
            const exportSession = async (format)=>{
                const id = getId();
                const form = formEl();
                if (!id) return (0, $jUNyh.notify)("Salve o usu\xe1rio antes de exportar.", "Usu\xe1rios");
                const from = form.querySelector('#sess_from')?.value;
                const to = form.querySelector('#sess_to')?.value;
                let q = `?format=${encodeURIComponent(format)}`;
                if (from) q += `&from=${encodeURIComponent(from + 'T00:00:00')}`;
                if (to) q += `&to=${encodeURIComponent(to + 'T23:59:59')}`;
                try {
                    const resp = await (0, $9VcS9.default).export_user_session_events(id, q);
                    if (!resp || !resp.ok) {
                        (0, $jUNyh.notify)("Falha ao exportar log de sess\xe3o.", "Usu\xe1rios");
                        return;
                    }
                    const blob = await resp.blob();
                    const cd = resp.headers.get('Content-Disposition') || '';
                    const m = cd.match(/filename="?([^"]+)"?/i);
                    const filename = m?.[1] || `sessoes.${format === 'xlsx' ? 'xlsx' : 'csv'}`;
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    URL.revokeObjectURL(url);
                } catch (err) {
                    (0, $jUNyh.notify)(err?.message || 'Falha ao exportar.', "Usu\xe1rios");
                }
            };
            const loadHe = async ()=>{
                const id = getId();
                const tbody = formEl()?.querySelector('#he_tbody');
                if (!id || !tbody) return;
                const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_user_overtime_requests, `?user_id=${encodeURIComponent(id)}&limit=50`);
                const items = Array.isArray(data) ? data : [];
                tbody.innerHTML = items.length ? items.map((r)=>{
                    const period = `${$de5ba539ecb71508$var$formatWhen(r.from_at)} \u{2192} ${$de5ba539ecb71508$var$formatWhen(r.to_at)}`;
                    const actions = r.status === 'pending' ? `<button type="button" class="button bn_he_approve" data-id="${r.id}">Aprovar</button>
							   <button type="button" class="button bn_he_reject" data-id="${r.id}">Rejeitar</button>` : '';
                    return `<tr>
							<td>${period}</td>
							<td>${r.status || ''}</td>
							<td>${r.reason || ''}</td>
							<td>${actions}</td>
						</tr>`;
                }).join('') : '<tr><td colspan="4">Nenhuma solicita\xe7\xe3o.</td></tr>';
            };
            const createHe = async ()=>{
                const id = getId();
                const form = formEl();
                if (!id) return (0, $jUNyh.notify)("Salve o usu\xe1rio antes de solicitar HE.", "Usu\xe1rios");
                const from = form.querySelector('#he_from')?.value;
                const to = form.querySelector('#he_to')?.value;
                const reason = form.querySelector('#he_reason')?.value;
                if (!from || !to) return (0, $jUNyh.notify)("Informe in\xedcio e fim da HE.", "Usu\xe1rios");
                const managerRaw = form.querySelector('#manager_user_id')?.value;
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).create_user_overtime_request, {
                    user_id: id,
                    from_at: new Date(from).toISOString(),
                    to_at: new Date(to).toISOString(),
                    reason: reason,
                    manager_user_id: managerRaw || null
                });
                if (resp == null) (0, $jUNyh.notify)("Falha ao criar solicita\xe7\xe3o.", "Usu\xe1rios");
                else {
                    (0, $jUNyh.notify)("Solicita\xe7\xe3o de HE criada.", "Usu\xe1rios");
                    loadHe();
                }
            };
            const decideHe = async (requestId, status)=>{
                if (!requestId) return;
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).decide_user_overtime_request, requestId, {
                    status: status
                });
                if (resp == null) (0, $jUNyh.notify)('Falha ao decidir HE.', "Usu\xe1rios");
                else {
                    (0, $jUNyh.notify)(status === 'approved' ? 'HE aprovada.' : 'HE rejeitada.', "Usu\xe1rios");
                    loadHe();
                }
            };
            formset._uac = {
                syncAccessEnabled: syncAccessEnabled,
                loadSessionLog: loadSessionLog,
                loadHe: loadHe,
                loadManagers: loadManagers,
                applySchedule (schedule) {
                    const form = formEl();
                    if (!form || !schedule) return;
                    $de5ba539ecb71508$var$WEEKDAYS.forEach(({ key: key })=>{
                        const day = schedule[key] || {};
                        const row = form.querySelector(`.uac-day[data-day="${key}"]`);
                        if (!row) return;
                        const en = row.querySelector('.uac-enabled');
                        const st = row.querySelector('.uac-start');
                        const ed = row.querySelector('.uac-end');
                        if (en) en.checked = !!day.enabled;
                        if (st && day.start) st.value = day.start;
                        if (ed && day.end) ed.value = day.end;
                    });
                    syncAccessEnabled();
                },
                readSchedule () {
                    const form = formEl();
                    const out = {};
                    $de5ba539ecb71508$var$WEEKDAYS.forEach(({ key: key })=>{
                        const row = form?.querySelector(`.uac-day[data-day="${key}"]`);
                        out[key] = {
                            enabled: !!row?.querySelector('.uac-enabled')?.checked,
                            start: row?.querySelector('.uac-start')?.value || '08:00',
                            end: row?.querySelector('.uac-end')?.value || '18:00'
                        };
                    });
                    return out;
                },
                readAccessFields () {
                    const form = formEl();
                    const overrideLocal = form?.querySelector('#access_override_until')?.value;
                    let access_override_until = null;
                    if (overrideLocal) access_override_until = new Date(overrideLocal).toISOString();
                    const managerRaw = (form?.querySelector('#manager_user_id')?.value || '').trim();
                    return {
                        access_control_enabled: !!form?.querySelector('#access_control_enabled')?.checked,
                        work_timezone: 'America/Sao_Paulo',
                        work_schedule: this.readSchedule(),
                        manager_user_id: managerRaw || null,
                        collector_only: !!form?.querySelector('#collector_only')?.checked,
                        access_override_until: access_override_until
                    };
                },
                applyAccessFields (data) {
                    const form = formEl();
                    if (!form || !data) return;
                    const ac = form.querySelector('#access_control_enabled');
                    if (ac) ac.checked = !!data.access_control_enabled;
                    const co = form.querySelector('#collector_only');
                    if (co) co.checked = !!data.collector_only;
                    const mgr = form.querySelector('#manager_user_id');
                    if (mgr) mgr.value = data.manager_user_id || '';
                    const ov = form.querySelector('#access_override_until');
                    if (ov && data.access_override_until) {
                        const d = new Date(data.access_override_until);
                        if (!Number.isNaN(d.getTime())) {
                            const pad = (n)=>String(n).padStart(2, '0');
                            ov.value = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
                        }
                    } else if (ov) ov.value = '';
                    this.applySchedule(data.work_schedule || {});
                    syncAccessEnabled();
                    if (data.id) {
                        loadSessionLog();
                        loadHe();
                    }
                }
            };
            loadManagers();
            syncAccessEnabled();
            Object.getPrototypeOf(this).init?.call(this, formset);
        },
        afterEditSetValues (fs) {
            const data = fs?._uac_pending_data;
            if (data) fs._uac?.applyAccessFields?.(data);
            else fs._uac?.syncAccessEnabled?.();
        }
    },
    fields: [
        {
            properties: {
                selector: '#user_status'
            },
            types: []
        },
        {
            properties: {
                selector: '#id'
            },
            types: []
        },
        {
            properties: {
                selector: '#name'
            },
            types: [
                $74yTJ.default()
            ]
        },
        {
            properties: {
                selector: '#email'
            },
            types: [
                $lVBv9.default()
            ]
        },
        {
            properties: {
                selector: '#phone'
            },
            types: [
                $jHqD0.default()
            ]
        },
        {
            properties: {
                selector: '#username'
            },
            types: [
                $bSPRN.default()
            ]
        },
        {
            properties: {
                selector: '#groups'
            },
            types: [
                $fE2eE.default('groups', '#available'),
                $4KjZQ.default()
            ]
        }
    ]
};



var $lVBv9 = parcelRequire("lVBv9");
var $74yTJ = parcelRequire("74yTJ");
var $jHqD0 = parcelRequire("jHqD0");
var $bSPRN = parcelRequire("bSPRN");
const $fd46b4f29c53dd9f$var$LOCKOUT_DAYS = 30;
function $fd46b4f29c53dd9f$var$lockoutExpirationIso() {
    const d = new Date();
    d.setDate(d.getDate() + $fd46b4f29c53dd9f$var$LOCKOUT_DAYS);
    return d.toISOString();
}
const $fd46b4f29c53dd9f$var$users = function() {
    let users_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_groups, this.queryAll()).then((data)=>(0, $1cmSR.default).set('groups', data).catch((error)=>(0, $jUNyh.notify)(error)));
            (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch(()=>{}));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_users, query);
        },
        async loadRecord (id) {
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).select_user, ...JSON.parse(id));
            if (data && typeof data === 'object') data.user_status = data.is_disabled ? 'Inativo' : data.is_blocked ? 'Bloqueado' : 'Ativo';
            return data;
        },
        editRecord (data) {
            const self = this;
            const descriptor = {
                html: (0, $de5ba539ecb71508$export$2e2bcd8739ae039).html,
                fields: (0, $de5ba539ecb71508$export$2e2bcd8739ae039).fields,
                form: {
                    ...(0, $de5ba539ecb71508$export$2e2bcd8739ae039).form,
                    afterEditSetValues (fs) {
                        fs._uac_pending_data = data || null;
                        (0, $de5ba539ecb71508$export$2e2bcd8739ae039).form.afterEditSetValues?.(fs);
                    }
                }
            };
            let fs = (0, $h1m6J.default).create(descriptor, async (updated_data)=>{
                const access = fs._uac?.readAccessFields?.() || {};
                Object.assign(updated_data, access);
                if (await self.saveRecordWrapper(updated_data, data)) fs.destroy();
            });
            fs.init = (()=>{
                fs.form.eraseValues();
                Object.getPrototypeOf(fs).init.call(fs, true);
                if (data) {
                    fs.form.setValues(data);
                    fs.form.refresh();
                    setTimeout(()=>{
                        fs.form.refresh();
                        descriptor.form.afterEditSetValues?.(fs);
                    }, 300);
                } else {
                    fs.form.refresh();
                    descriptor.form.afterEditSetValues?.(fs);
                }
            })();
        },
        async saveRecord (data, old_data) {
            let _record = {
                name: data.name,
                email: data.email,
                phone: data.phone,
                username: data.username,
                groups: data.groups,
                access_control_enabled: !!data.access_control_enabled,
                work_timezone: data.work_timezone || 'America/Sao_Paulo',
                work_schedule: data.work_schedule || {},
                manager_user_id: data.manager_user_id || null,
                collector_only: !!data.collector_only,
                access_override_until: data.access_override_until || null
            };
            if (old_data) {
                const current = await (0, $9VcS9.default).call((0, $9VcS9.default).select_user, data.id);
                if (current && typeof current === 'object') {
                    if ('is_disabled' in current) _record.is_disabled = current.is_disabled;
                    if ('lockout_expiration' in current) _record.lockout_expiration = current.lockout_expiration;
                }
                return await (0, $9VcS9.default).call((0, $9VcS9.default).update_user, data.id, _record);
            }
            return await (0, $9VcS9.default).call((0, $9VcS9.default).insert_user, _record);
        },
        async setDisabled (disabled) {
            const ids = await this.getSelectedIds([
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)("Selecione ao menos um usu\xe1rio.", "Usu\xe1rios");
            const action = disabled ? 'Inativar' : 'Ativar';
            (0, $jUNyh.ask)(`Confirma ${action} ${ids.length} usu\xe1rio(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                for (const [id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).update_user, id, {
                        is_disabled: !!disabled
                    });
                    if (resp == null) {
                        (0, $jUNyh.notify)("Falha ao atualizar usu\xe1rio.", "Usu\xe1rios");
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async setBlocked (blocked) {
            const ids = await this.getSelectedIds([
                'id'
            ]);
            if (!ids.length) return (0, $jUNyh.notify)("Selecione ao menos um usu\xe1rio.", "Usu\xe1rios");
            const action = blocked ? 'Bloquear' : 'Desbloquear';
            (0, $jUNyh.ask)(`Confirma ${action} ${ids.length} usu\xe1rio(s)?`, action, async (answer)=>{
                if (answer !== 'Y') return;
                const payload = blocked ? {
                    lockout_expiration: $fd46b4f29c53dd9f$var$lockoutExpirationIso()
                } : {
                    lockout_expiration: null
                };
                for (const [id] of ids){
                    const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).update_user, id, payload);
                    if (resp == null) {
                        (0, $jUNyh.notify)("Falha ao atualizar usu\xe1rio.", "Usu\xe1rios");
                        return;
                    }
                }
                this.loadPage();
            });
        },
        async openMyOvertime () {
            const data = await (0, $9VcS9.default).call((0, $9VcS9.default).list_user_overtime_requests, '?mine=1&status=pending&limit=100');
            const items = Array.isArray(data) ? data : [];
            if (!items.length) return (0, $jUNyh.notify)("Nenhuma HE pendente para voc\xea como gestor.", 'Horas extras');
            const lines = items.map((r)=>`\u{2022} ${r.user_name || r.user_username}: ${r.from_at} \u{2192} ${r.to_at} (${r.reason || 'sem motivo'})`).join('\n');
            (0, $jUNyh.ask)(`Pendentes (${items.length}):\n${lines}\n\nAprovar a primeira da lista?`, 'Horas extras', async (answer)=>{
                if (answer !== 'Y') return;
                const first = items[0];
                const resp = await (0, $9VcS9.default).call((0, $9VcS9.default).decide_user_overtime_request, first.id, {
                    status: 'approved'
                });
                if (resp == null) (0, $jUNyh.notify)('Falha ao aprovar.', 'Horas extras');
                else (0, $jUNyh.notify)("HE aprovada. Abra o usu\xe1rio para gerenciar as demais.", 'Horas extras');
            });
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: "Usu\xe1rio",
            types: [],
            placeholder: '',
            title: "Identificador do usu\xe1rio"
        },
        {
            index: 2,
            field: 'name',
            label: 'Nome',
            types: [
                $74yTJ.default()
            ],
            placeholder: '',
            title: "Nome do usu\xe1rio"
        },
        {
            index: 3,
            field: 'email',
            label: 'Email',
            types: [
                $lVBv9.default()
            ],
            placeholder: '',
            title: 'Email para reset de senha'
        },
        {
            index: 4,
            field: 'phone',
            label: 'Fone',
            types: [
                $jHqD0.default()
            ],
            placeholder: '+00 (00) 0000-0000',
            title: 'Telefone de contato'
        },
        {
            index: 5,
            field: 'username',
            label: 'Username',
            types: [
                $bSPRN.default()
            ],
            placeholder: '',
            title: "Nome de usu\xe1rio para acesso ao sistema"
        },
        {
            index: 6,
            field: 'user_status',
            label: 'Status',
            types: [],
            placeholder: '',
            title: "Status do usu\xe1rio"
        },
        {
            index: 7,
            field: 'is_blocked',
            label: 'Bloqueado',
            types: [],
            placeholder: '',
            title: "Usu\xe1rio bloqueado (SIM/NAO)"
        }
    ];
    let operations = [
        {
            hash: '#user-disable',
            label: 'Inativar'
        },
        {
            hash: '#user-enable',
            label: 'Ativar'
        },
        {
            hash: '#user-block',
            label: 'Bloquear'
        },
        {
            hash: '#user-unblock',
            label: 'Desbloquear'
        },
        {
            hash: '#user-overtime',
            label: 'HE pendentes (gestor)'
        }
    ];
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-disable', users_crud.setDisabled.bind(users_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-enable', users_crud.setDisabled.bind(users_crud, false));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-block', users_crud.setBlocked.bind(users_crud, true));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-unblock', users_crud.setBlocked.bind(users_crud, false));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#user-overtime', users_crud.openMyOvertime.bind(users_crud));
    users_crud.run('users', "Usu\xe1rios", document.getElementById('workarea'), (0, $6c2838c21d5bc54c$export$2e2bcd8739ae039), (0, $de5ba539ecb71508$export$2e2bcd8739ae039), fieldspecs, operations, []);
};
var $fd46b4f29c53dd9f$export$2e2bcd8739ae039 = $fd46b4f29c53dd9f$var$users;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $jUNyh = parcelRequire("jUNyh");

var $8IFAz = parcelRequire("8IFAz");
async function $ca63d0d98a968fdb$export$2e2bcd8739ae039(records) {
    return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: right; }
			.view td:nth-child(3)	{ text-align: center; }
			.view td:nth-child(4)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 5rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(9)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Evento</th>
					<th data-index="2" data-visible="${this.visible[1]}">Data/Hora</th>
					<th data-index="3" data-visible="${this.visible[2]}">Usu\xe1rio</th>
					<th data-index="4" data-visible="${this.visible[3]}">Origem</th>
					<th data-index="5" data-visible="${this.visible[4]}">Agente</th>
					<th data-index="6" data-visible="${this.visible[5]}">M\xe9todo</th>
					<th data-index="7" data-visible="${this.visible[6]}">URL</th>
					<th data-index="8" data-visible="${this.visible[7]}">Dados</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${record.id}'>
					<td><input type="checkbox"${this.isChecked(record.id)}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${this.format($8IFAz.default(), record.date_time)}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('users', record.user_id) || ''}</td>
					<td data-visible='${this.visible[3]}'>${record.origin}</td>
					<td data-visible='${this.visible[4]}'>${record.agent}</td>
					<td data-visible='${this.visible[5]}'>${record.method}</td>
					<td data-visible='${this.visible[6]}'>${record.path}</td>
					<td data-visible='${this.visible[7]}'>${record.body ? '&#10003;' : ''}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $knytZ = parcelRequire("knytZ");
var $8d14789de03340ac$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#log #id		{ width: 6rem; text-align: right;	}
			#log #date_time	{ width: 10rem;	}
			#log #user_id	{ width: 12rem;	}
			#log #origin	{ width: 6rem;	}
			#log #method	{ width: 5rem;	}
			#log .agent		{ width: 100%;	}
			#log .path		{ width: 100%;	}
			#log .body		{ width: 100%;	}
		</style>
		<form id="log" class="form" autocomplete="off">
			<datalist id="users">
			</datalist>
			<div class="fsb">
				<label title="Identificador do evento">Evento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora do registro">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Usu\xe1rio">Usu\xe1rio
					<input id="user_id" type="text" list="users" disabled>
				</label>
				<label title="Endere\xe7o IP de Origem">Origem
					<input id="origin" type="text" disabled>
				</label>
				<label title="M\xe9todo HTTP">M\xe9todo
					<input id="method" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="agent" title="User-Agent">Agente
					<input id="agent" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="path" title="Caminho">URL
					<input id="path" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="body" title="Corpo da requisi\xe7\xe3o">Dados
					<textarea id="body" rows="8" disabled></textarea>
				</label>
			</div>
			<div class="tar">
				<button class='bn_Escape button'>Fechar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#log',
        init (formset) {
            formset.loadList('#users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#date_time'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#user_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#origin'
            },
            types: []
        },
        {
            properties: {
                selector: '#agent'
            },
            types: []
        },
        {
            properties: {
                selector: '#method'
            },
            types: []
        },
        {
            properties: {
                selector: '#path'
            },
            types: []
        },
        {
            properties: {
                selector: '#body'
            },
            types: [
                $knytZ.default()
            ]
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
const $307409da5029dbc2$var$auditLogs = function() {
    let audit_logs_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data).catch((error)=>(0, $jUNyh.notify)(error)));
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_logs, query);
        },
        async loadRecord (id) {
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_log, id);
            _record['body'] = _record['body'] ? JSON.stringify(_record['body']) : '';
            return _record;
        },
        async saveRecord (data, old_data) {}
    });
    // Index = position in the backend's SELECT
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Evento',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador do evento'
        },
        {
            index: 2,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: 'Data e hora de registro'
        },
        {
            index: 3,
            field: 'user_id',
            label: "Usu\xe1rio",
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 4,
            field: 'origin',
            label: 'Origem',
            types: [],
            placeholder: '0.0.0.0',
            title: 'IP de origem'
        },
        {
            index: 5,
            field: 'agent',
            label: 'Agente',
            types: [],
            placeholder: '',
            title: 'User-Agent'
        },
        {
            index: 6,
            field: 'method',
            label: "M\xe9todo",
            types: [],
            placeholder: '',
            title: "M\xe9todo HTTP"
        },
        {
            index: 7,
            field: 'path',
            label: 'URL',
            types: [],
            placeholder: '',
            title: 'URL'
        },
        {
            index: 8,
            field: 'body',
            label: 'Dados',
            types: [],
            placeholder: '',
            title: "Corpo da requisi\xe7\xe3o"
        }
    ];
    audit_logs_crud.run('audit_logs', 'Eventos', document.getElementById('workarea'), (0, $ca63d0d98a968fdb$export$2e2bcd8739ae039), (0, $8d14789de03340ac$export$2e2bcd8739ae039), fieldspecs);
};
var $307409da5029dbc2$export$2e2bcd8739ae039 = $307409da5029dbc2$var$auditLogs;



var $9VcS9 = parcelRequire("9VcS9");

var $1cmSR = parcelRequire("1cmSR");


var $h1m6J = parcelRequire("h1m6J");

var $hWQyW = parcelRequire("hWQyW");


var $jUNyh = parcelRequire("jUNyh");

var $8IFAz = parcelRequire("8IFAz");

var $9VcS9 = parcelRequire("9VcS9");
function $25a9432000c4705b$var$esc(s) {
    if (s == null || s === '') return '';
    const t = String(s);
    return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $25a9432000c4705b$var$_dirPt(d) {
    if (d === 'inbound') return 'Entrada';
    if (d === 'outbound') return "Sa\xedda";
    return d ? String(d) : "\u2014";
}
/** Coluna Integradas: inbound só com fetched > 0; outbound só se sent/picked/failure tiver algum > 0 (texto vem da API). */ /** Prévia curta na grade para request/response (obj ou string truncada na API) ou stack. */ function $25a9432000c4705b$var$payloadCellPreview(value) {
    if (value == null || value === '') return "\u2014";
    if (typeof value === 'string') {
        const t = value.length > 100 ? `${value.slice(0, 100)}\u{2026}` : value;
        return $25a9432000c4705b$var$esc(t);
    }
    try {
        const s = JSON.stringify(value);
        const t = s.length > 100 ? `${s.slice(0, 100)}\u{2026}` : s;
        return $25a9432000c4705b$var$esc(t);
    } catch (e) {
        return $25a9432000c4705b$var$esc(String(value));
    }
}
function $25a9432000c4705b$var$formatPortalIntegradas(record) {
    const d = String(record.direction || '').toLowerCase();
    if (d === 'outbound') {
        const s = record.outbound_stats;
        return s ? $25a9432000c4705b$var$esc(String(s)) : '';
    }
    const f = record.fetched;
    if (f != null && Number(f) > 0) return $25a9432000c4705b$var$esc(String(f));
    return '';
}
/** ID da inbox TechHub ligado ao evento (para processar fila por checkbox). */ function $25a9432000c4705b$var$_techhubInboxId(record) {
    const et = String(record.entity_type || '').toLowerCase();
    if (et !== 'techhub_inbox') return null;
    const v = record.entity_id;
    if (v == null || v === '') return null;
    const s = String(v).trim();
    return /^\d+$/.test(s) ? s : null;
}
/** Legenda de status WMS (SESSP) — referência para correlacionar códigos enviados/recebidos na integração. */ const $25a9432000c4705b$var$SESSP_WMS_STATUS_LEGEND = [
    [
        '1',
        'WMS',
        'Integrado API',
        'Fatura recepcionada pela API do WMS'
    ],
    [
        'I',
        'WMS',
        'Checando Saldo',
        'Checando saldo de estoque.'
    ],
    [
        'A',
        'WMS',
        'Reservado',
        'Pedido registrado e itens reservados no estoque.'
    ],
    [
        'O',
        'WMS',
        'Onda Gerada',
        "Onda de separa\xe7\xe3o gerada."
    ],
    [
        'S',
        'WMS',
        "Separa\xe7\xe3o",
        "Itens est\xe3o sendo separados para envio."
    ],
    [
        'F',
        'WMS',
        "Confer\xeancia",
        "Pedido em confer\xeancia."
    ],
    [
        'X',
        'WMS',
        'Etiquetagem de volumes',
        'Em processo de etiquetagem de volumes'
    ],
    [
        'G',
        'WMS',
        "Aguardando Expedi\xe7\xe3o",
        "Pronto para envio, aguardando libera\xe7\xe3o da expedi\xe7\xe3o"
    ],
    [
        'C',
        'WMS',
        'Cancelado',
        "Pedido cancelado e n\xe3o ser\xe1 processado."
    ]
];
function $25a9432000c4705b$var$_sesspWmsStatusLegendHtml() {
    const rows = $25a9432000c4705b$var$SESSP_WMS_STATUS_LEGEND.map(([id, sys, name, desc])=>`<tr>
				<td><code>${$25a9432000c4705b$var$esc(id)}</code></td>
				<td>${$25a9432000c4705b$var$esc(sys)}</td>
				<td>${$25a9432000c4705b$var$esc(name)}</td>
				<td>${$25a9432000c4705b$var$esc(desc)}</td>
			</tr>`).join('');
    return `
			<div style="margin-top:0.65rem;">
				<div style="font-weight:600;font-size:0.88rem;margin-bottom:0.4rem;">Legenda \u{2014} status WMS</div>
				<div style="overflow-x:auto;">
					<table class="integration-wms-status-legend" style="width:100%;border-collapse:collapse;font-size:0.82rem;border:1px solid var(--color-border,#ccc);">
						<thead>
							<tr style="background:var(--color-muted-bg,rgba(0,0,0,0.06));text-align:left;">
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);white-space:nowrap;">id_origem</th>
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);white-space:nowrap;">Sistema</th>
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);">nome_status</th>
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);">descricao_status</th>
							</tr>
						</thead>
						<tbody>${rows}</tbody>
					</table>
				</div>
			</div>`;
}
/** Cabeçalho SESSP (TechHub/IBL + GSNET Entrada) — ativado pela API quando INTEGRATION_CENTRAL_BANNER=sessp */ function $25a9432000c4705b$var$_bannerAggLines(agg, labelFn) {
    if (!agg || !agg.length) return `<div style="margin-top:0.25rem;color:var(--color-muted,#444);">Nenhum evento ${$25a9432000c4705b$var$esc(labelFn(''))} neste per\xedodo.</div>`;
    return agg.map((a)=>{
        const key = labelFn(a.integration_key || "\u2014");
        const fails = a.fail_period ?? 0;
        const last = a.last_at != null ? $25a9432000c4705b$var$esc(String(a.last_at)) : "\u2014";
        const failTxt = fails === 0 ? "nenhuma falha no per\xedodo" : `${fails} falha(s) no per\xedodo`;
        return `<div style="margin-top:0.2rem;">\u{2022} <strong>${$25a9432000c4705b$var$esc(key)}</strong> \u{2014} ${$25a9432000c4705b$var$_dirPt(a.direction)}: \xfaltimo evento <code style="font-size:0.85em;">${last}</code> \xb7 ${failTxt}</div>`;
    }).join('');
}
function $25a9432000c4705b$var$_gsnetHealthHtml(summary) {
    const h = summary.gsnet_health;
    if (!h || typeof h !== 'object') return '';
    const counts = h.counts && typeof h.counts === 'object' ? h.counts : {};
    const parts = Object.keys(counts).sort().map((k)=>`${$25a9432000c4705b$var$esc(k)}: ${$25a9432000c4705b$var$esc(String(counts[k]))}`);
    const dry = h.dry_run ? " \xb7 <em>dry-run</em>" : '';
    return `<div style="margin-top:0.35rem;font-size:0.82rem;color:var(--color-muted,#555);">Fila GSNET (todas empresas): ${parts.length ? parts.join(" \xb7 ") : "\u2014"}${dry}</div>`;
}
function $25a9432000c4705b$var$_healthBannerSesspHtml(summary) {
    const thAgg = summary.banner_aggregates != null ? summary.banner_aggregates : (summary.aggregates || []).filter((a)=>String(a.integration_key || '').toLowerCase().startsWith('techhub'));
    const gsAgg = summary.banner_aggregates_gsnet || (summary.aggregates || []).filter((a)=>String(a.integration_key || '').toLowerCase() === 'gsnet_entry');
    const thLines = $25a9432000c4705b$var$_bannerAggLines(thAgg, (k)=>String(k).toLowerCase() === 'techhub_ibl' ? "TechHub \u2014 IBL" : String(k || 'TechHub'));
    const gsLines = $25a9432000c4705b$var$_bannerAggLines(gsAgg, ()=>'GSNET Entrada');
    const notes = (summary.notes || []).map((n)=>`<div style="margin-top:0.25rem;">${$25a9432000c4705b$var$esc(n)}</div>`).join('');
    return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Integra\xe7\xe3o SESSP</div>
			<div style="color:var(--color-muted,#444);font-size:0.88rem;">Resumo das \xfaltimas <strong>${$25a9432000c4705b$var$esc(String(summary.period_hours ?? 24))}</strong> horas.</div>
			<div style="margin-top:0.65rem;font-weight:600;font-size:0.88rem;">TechHub / IBL</div>
			${$25a9432000c4705b$var$_sesspWmsStatusLegendHtml()}
			${thLines}
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#555);">Use <strong>Filtrar integra\xe7\xe3o: TechHub (IBL)</strong> para ver s\xf3 <code>techhub_ibl</code>.</div>
			<div style="margin-top:0.65rem;font-weight:600;font-size:0.88rem;">GSNET Entrada (Prodesp)</div>
			${gsLines}
			${$25a9432000c4705b$var$_gsnetHealthHtml(summary)}
			<div style="margin-top:0.35rem;font-size:0.82rem;color:var(--color-muted,#555);">Use <strong>Filtrar integra\xe7\xe3o: GSNET Entrada</strong>. Envio autom\xe1tico ap\xf3s conclus\xe3o do endere\xe7amento; reenvio manual pela linha selecionada.</div>
			<div style="margin-top:0.5rem;font-size:0.82rem;color:var(--color-muted,#666);border-top:1px solid var(--color-border,#ddd);padding-top:0.45rem;">
				${notes}
			</div>
		</div>`;
}
function $25a9432000c4705b$var$_vendatusHealthHtml(summary) {
    const v = summary.vendatus;
    if (!v || typeof v !== 'object') return '';
    const inbound = v.inbound_enabled ? 'ativo' : 'desligado';
    const outbound = v.outbound_enabled ? 'ativo' : 'desligado';
    const base = v.webhook_base_url ? $25a9432000c4705b$var$esc(String(v.webhook_base_url)) : "\u2014";
    return `<div style="margin-top:0.35rem;font-size:0.82rem;color:var(--color-muted,#555);">
		Inbound API: <strong>${inbound}</strong> \xb7 Outbound webhook: <strong>${outbound}</strong> \xb7 Base: <code style="font-size:0.85em;">${base}</code>
	</div>`;
}
function $25a9432000c4705b$var$_healthBannerHtml(summary) {
    if (!summary) return '';
    if (summary.banner_mode === 'sessp') return $25a9432000c4705b$var$_healthBannerSesspHtml(summary);
    const vendAgg = summary.banner_aggregates_vendatus || (summary.aggregates || []).filter((a)=>String(a.integration_key || '').toLowerCase() === 'vendatus');
    const vendLines = $25a9432000c4705b$var$_bannerAggLines(vendAgg, ()=>'Vendatus');
    const otherAgg = (summary.aggregates || []).filter((a)=>String(a.integration_key || '').toLowerCase() !== 'vendatus');
    const rows = otherAgg.map((a)=>`${a.integration_key} ${a.direction || "\u2014"}: \xfaltimo ${a.last_at || "\u2014"} (${a.fail_period ?? 0} falhas no per\xedodo)`).join(" \xb7 ");
    return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Sa\xfade das integra\xe7\xf5es</div>
			<div style="margin-top:0.15rem;font-weight:600;font-size:0.88rem;">Vendatus</div>
			${$25a9432000c4705b$var$_vendatusHealthHtml(summary)}
			${vendLines}
			<div style="margin-top:0.35rem;font-size:0.82rem;color:var(--color-muted,#555);">Use <strong>Filtrar integra\xe7\xe3o: Vendatus</strong> para ver s\xf3 <code>vendatus</code> (inbound API + outbound webhook/outbox).</div>
			<div style="margin-top:0.25rem;"><strong>Espelho inbound (API)</strong> \u{2014} ${summary.mirror_inbound_enabled ? 'ativo' : 'desligado (env)'}</div>
			<div style="margin-top:0.35rem;color:var(--color-muted,#444);">${$25a9432000c4705b$var$esc(rows || "Sem outros eventos no per\xedodo.")}</div>
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#666);">${$25a9432000c4705b$var$esc((summary.notes || []).join(' '))}</div>
		</div>
		<style>
			.integration-health-ok { color: #0a6e0a; font-weight: 600; }
			.integration-health-warn { color: #a65f00; font-weight: 600; }
			.integration-health-bad { color: #b00020; font-weight: 600; }
		</style>`;
}
async function $25a9432000c4705b$export$2e2bcd8739ae039(records) {
    let banner = '';
    try {
        const base = (0, $9VcS9.getSialApiHost)();
        const r = await fetch(`${base}/integration-events/summary?hours=24&stale_minutes=12`, {
            credentials: 'include'
        });
        if (r.ok) banner = $25a9432000c4705b$var$_healthBannerHtml(await r.json());
    } catch (e) {}
    return banner + `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: right; }
			.view td:nth-child(3)	{ text-align: center; }
			.view td:nth-child(4)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(5)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(6)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(8)	{ text-align: center; max-width: 6rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(13)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(14)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(15)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(16)	{ text-align: left; max-width: 10rem; font-size: 0.82rem; }
			.view td:nth-child(17)	{ text-align: left; max-width: 10rem; font-size: 0.82rem; }
			.view td:nth-child(18)	{ text-align: left; max-width: 10rem; font-size: 0.82rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar sele\xe7\xf5es"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Evento</th>
					<th data-index="2" data-visible="${this.visible[1]}">Data/Hora</th>
					<th data-index="3" data-visible="${this.visible[2]}">Empresa</th>
					<th data-index="4" data-visible="${this.visible[3]}">Integra\xe7\xe3o</th>
					<th data-index="5" data-visible="${this.visible[4]}">Dire\xe7\xe3o</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
					<th data-index="7" data-visible="${this.visible[6]}">Resumo</th>
					<th data-index="8" data-visible="${this.visible[7]}">Integradas</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo</th>
					<th data-index="10" data-visible="${this.visible[9]}">ID entidade</th>
					<th data-index="11" data-visible="${this.visible[10]}">Erro</th>
					<th data-index="12" data-visible="${this.visible[11]}">Correla\xe7\xe3o</th>
					<th data-index="13" data-visible="${this.visible[12]}">Origem</th>
					<th data-index="14" data-visible="${this.visible[13]}">Registrado por</th>
					<th data-index="15" data-visible="${this.visible[14]}">Request</th>
					<th data-index="16" data-visible="${this.visible[15]}">Response</th>
					<th data-index="17" data-visible="${this.visible[16]}">Stack</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record)=>`<tr data-id='${JSON.stringify([
            record.id,
            $25a9432000c4705b$var$_techhubInboxId(record)
        ])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([
            record.id,
            $25a9432000c4705b$var$_techhubInboxId(record)
        ]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${this.format($8IFAz.default(), record.date_time)}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('companies', record.company_id) || ''}</td>
					<td data-visible='${this.visible[3]}'>${$25a9432000c4705b$var$esc(record.integration_key)}</td>
					<td data-visible='${this.visible[4]}'>${$25a9432000c4705b$var$esc(record.direction)}</td>
					<td data-visible='${this.visible[5]}'>${$25a9432000c4705b$var$esc(record.status)}</td>
					<td data-visible='${this.visible[6]}'>${$25a9432000c4705b$var$esc(record.summary)}</td>
					<td data-visible='${this.visible[7]}'>${$25a9432000c4705b$var$formatPortalIntegradas(record)}</td>
					<td data-visible='${this.visible[8]}'>${$25a9432000c4705b$var$esc(record.entity_type)}</td>
					<td data-visible='${this.visible[9]}'>${$25a9432000c4705b$var$esc(record.entity_id)}</td>
					<td data-visible='${this.visible[10]}'>${$25a9432000c4705b$var$esc(record.error_message)}</td>
					<td data-visible='${this.visible[11]}'>${$25a9432000c4705b$var$esc(record.correlation_id)}</td>
					<td data-visible='${this.visible[12]}'>${$25a9432000c4705b$var$esc(record.source)}</td>
					<td data-visible='${this.visible[13]}'>${await this.key('users', record.recorded_by) || ''}</td>
					<td data-visible='${this.visible[14]}'>${$25a9432000c4705b$var$payloadCellPreview(record.request_payload)}</td>
					<td data-visible='${this.visible[15]}'>${$25a9432000c4705b$var$payloadCellPreview(record.response_payload)}</td>
					<td data-visible='${this.visible[16]}'>${$25a9432000c4705b$var$payloadCellPreview(record.error_stack)}</td>
				</tr>`))).join('') + `
			</tbody>
		</table>
	`;
}



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
var $knytZ = parcelRequire("knytZ");
var $a91ff1aa595c2c0c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#integration_event #id		{ width: 6rem; text-align: right;	}
			#integration_event #date_time	{ width: 10rem;	}
			#integration_event #company_id	{ width: 12rem;	}
			#integration_event #integration_key	{ width: 14rem;	}
			#integration_event #direction	{ width: 8rem;	}
			#integration_event #status	{ width: 8rem;	}
			#integration_event .summary	{ width: 100%;	}
			#integration_event #entity_type	{ width: 12rem;	}
			#integration_event #entity_id	{ width: 14rem;	}
			#integration_event .error_message	{ width: 100%;	}
			#integration_event #correlation_id	{ width: 20rem;	}
			#integration_event #source	{ width: 14rem;	}
			#integration_event #recorded_by	{ width: 12rem;	}
			#integration_event .payload	{ width: 100%;	}
		</style>
		<form id="integration_event" class="form" autocomplete="off">
			<datalist id="iev_companies">
			</datalist>
			<datalist id="iev_users">
			</datalist>
			<div class="fsb">
				<label title="Identificador">Evento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Empresa">Empresa
					<input id="company_id" type="text" list="iev_companies" disabled>
				</label>
				<label title="Chave da integra\xe7\xe3o">Integra\xe7\xe3o
					<input id="integration_key" type="text" disabled>
				</label>
				<label title="Dire\xe7\xe3o">Dire\xe7\xe3o
					<input id="direction" type="text" disabled>
				</label>
				<label title="Status">Status
					<input id="status" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="summary" title="Resumo">Resumo
					<input id="summary" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo da entidade">Tipo entidade
					<input id="entity_type" type="text" disabled>
				</label>
				<label title="ID da entidade">ID entidade
					<input id="entity_id" type="text" disabled>
				</label>
				<label title="UUID de correla\xe7\xe3o">Correla\xe7\xe3o
					<input id="correlation_id" type="text" disabled>
				</label>
				<label title="Origem">Origem
					<input id="source" type="text" disabled>
				</label>
				<label title="Usu\xe1rio">Registrado por
					<input id="recorded_by" type="text" list="iev_users" disabled>
				</label>
			</div>
			<div>
				<label class="error_message" title="Mensagem de erro">Erro
					<textarea id="error_message" rows="3" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Request (JSON)">Request
					<textarea id="request_payload" rows="6" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Response (JSON)">Response
					<textarea id="response_payload" rows="6" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Stack trace">Stack
					<textarea id="error_stack" rows="6" disabled></textarea>
				</label>
			</div>
			<div class="tar">
				<button class='bn_Escape button'>Fechar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#integration_event',
        init (formset) {
            formset.loadList('#iev_companies', 'companies');
            formset.loadList('#iev_users', 'users');
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#id'
            },
            types: [
                $3eqAU.default(0, 2)
            ]
        },
        {
            properties: {
                selector: '#date_time'
            },
            types: [
                $8IFAz.default()
            ]
        },
        {
            properties: {
                selector: '#company_id'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#integration_key'
            },
            types: []
        },
        {
            properties: {
                selector: '#direction'
            },
            types: []
        },
        {
            properties: {
                selector: '#status'
            },
            types: []
        },
        {
            properties: {
                selector: '#summary'
            },
            types: []
        },
        {
            properties: {
                selector: '#entity_type'
            },
            types: []
        },
        {
            properties: {
                selector: '#entity_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#correlation_id'
            },
            types: []
        },
        {
            properties: {
                selector: '#source'
            },
            types: []
        },
        {
            properties: {
                selector: '#recorded_by'
            },
            types: [
                $9PIz7.default()
            ]
        },
        {
            properties: {
                selector: '#error_message'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#request_payload'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#response_payload'
            },
            types: [
                $knytZ.default()
            ]
        },
        {
            properties: {
                selector: '#error_stack'
            },
            types: [
                $knytZ.default()
            ]
        }
    ]
};


var $d895e3e6330b9667$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#manual-action-form #ma_company_id { width: 24rem; }
			#manual-action-form #ma_integration_key { width: 12rem; }
			#manual-action-form #ma_action_key { width: 18rem; }
			#manual-action-form #ma_date_from,
			#manual-action-form #ma_date_to { width: 10rem; }
			#manual-action-form #ma_notes { width: 100%; }
		</style>
		<form id="manual-action-form" class="form" autocomplete="off">
			<div class="title">Registrar a\xe7\xe3o manual de integra\xe7\xe3o</div>
			<p class="mtm" style="max-width:44rem;font-size:0.9rem;color:var(--color-muted,#555);">
				Use este registro para conting\xeancia operacional (falhas/reprocessamento manual). A a\xe7\xe3o fica audit\xe1vel na Central.
			</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa
					<input id="ma_company_id" type="text" list="manual_action_companies" required placeholder="UUID da empresa">
				</label>
				<label title="Integra\xe7\xe3o">Integra\xe7\xe3o
					<select id="ma_integration_key" required>
						<option value="">Selecione</option>
						<option value="vendatus">Vendatus</option>
						<option value="iqvia">IQVIA</option>
						<option value="closeup">Close-up</option>
					</select>
				</label>
				<label title="Tipo da a\xe7\xe3o manual">A\xe7\xe3o
					<input id="ma_action_key" type="text" required placeholder="ex.: reprocessar_lote">
				</label>
			</div>
			<div class="mtm fsb">
				<label title="Data inicial (opcional)">De
					<input id="ma_date_from" type="date">
				</label>
				<label title="Data final (opcional)">At\xe9
					<input id="ma_date_to" type="date">
				</label>
			</div>
			<div class="mtm">
				<label title="Observa\xe7\xf5es da a\xe7\xe3o">Observa\xe7\xf5es
					<textarea id="ma_notes" rows="5" placeholder="Descreva o motivo e o que deve ser executado manualmente"></textarea>
				</label>
			</div>
			<datalist id="manual_action_companies"></datalist>
			<div class="mtm">
				<button class='bn_Escape button' type="button">Cancelar</button>
				<button class='bn_Enter button' type="submit">Registrar a\xe7\xe3o</button>
			</div>
		</form>
	`,
    form: {
        selector: '#manual-action-form',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#ma_company_id'
            },
            types: [],
            placeholder: '',
            title: 'Empresa'
        },
        {
            properties: {
                selector: '#ma_integration_key'
            },
            types: [],
            placeholder: '',
            title: "Integra\xe7\xe3o"
        },
        {
            properties: {
                selector: '#ma_action_key'
            },
            types: [],
            placeholder: 'reprocessar_lote',
            title: "A\xe7\xe3o"
        },
        {
            properties: {
                selector: '#ma_date_from'
            },
            types: [],
            placeholder: '',
            title: 'Data inicial'
        },
        {
            properties: {
                selector: '#ma_date_to'
            },
            types: [],
            placeholder: '',
            title: 'Data final'
        },
        {
            properties: {
                selector: '#ma_notes'
            },
            types: [],
            placeholder: '',
            title: "Observa\xe7\xf5es"
        }
    ]
};


var $5ec9602c4a2efd0c$export$2e2bcd8739ae039 = {
    html: `
		<style>
			#techhub-pull-form #tp_company_id	{ width: 22rem; }
			#techhub-pull-form #tp_cd_local_origem	{ width: 10rem; }
		</style>
		<form id="techhub-pull-form" class="form" autocomplete="off">
			<div class="title">Buscar faturas na IBL (local espec\xedfico)</div>
			<p class="mtm" style="max-width:36rem;font-size:0.9rem;color:var(--color-muted,#555);">
				Empresa: <strong>UUID</strong> ou <strong>apelido</strong> (lista/autocompletar).
				<code>cd_local_origem</code> como na IBL (ex.: 3006). N\xe3o exige linha em
				<code>techhub_ibl_local_origins</code> \u{2014} mesmo uso em QA e PRD AWS.
			</p>
			<div class="mtl">
				<label title="Empresa">Empresa
					<input id="tp_company_id" type="text" list="techhub_pull_companies" required placeholder="UUID ou apelido">
				</label>
				<label title="C\xf3digo local de origem na IBL">cd_local_origem
					<input id="tp_cd_local_origem" type="number" required min="0" step="1" placeholder="3006">
				</label>
			</div>
			<datalist id="techhub_pull_companies"></datalist>
			<div class="mtm">
				<button class='bn_Escape button' type="button">Cancelar</button>
				<button class='bn_Enter button' type="submit">Buscar</button>
			</div>
		</form>
	`,
    form: {
        selector: '#techhub-pull-form',
        init (formset) {
            formset.form.eraseValues();
            Object.getPrototypeOf(this).init.call(this);
        }
    },
    fields: [
        {
            properties: {
                selector: '#tp_company_id'
            },
            types: [],
            placeholder: '',
            title: 'Empresa'
        },
        {
            properties: {
                selector: '#tp_cd_local_origem'
            },
            types: [],
            placeholder: '3006',
            title: 'cd_local_origem'
        }
    ]
};



var $9PIz7 = parcelRequire("9PIz7");
var $8IFAz = parcelRequire("8IFAz");
var $3eqAU = parcelRequire("3eqAU");
/** Operações exclusivas SESSP (AWS) — só com API em modo banner sessp (INTEGRATION_CENTRAL_BANNER=sessp). */ const $0a73b38866ec3649$var$OPERATIONS_SESSP = [
    {
        hash: '#integration-filter-techhub',
        label: "Filtrar integra\xe7\xe3o: TechHub (IBL)"
    },
    {
        hash: '#integration-filter-gsnet',
        label: "Filtrar integra\xe7\xe3o: GSNET Entrada"
    },
    {
        hash: '#integration-filter-clear',
        label: "Limpar filtro de integra\xe7\xe3o"
    },
    {
        hash: '#techhub-portal-toggle',
        label: "Ligar / desligar integra\xe7\xe3o TechHub (portal)"
    },
    {
        hash: '#techhub-pull-company-local',
        label: 'Buscar faturas na IBL (empresa + cd local)'
    },
    {
        hash: '#techhub-forced-pull',
        label: "Pull for\xe7ado (TechHub) \u2014 requer mapeamento ativo"
    },
    {
        hash: '#techhub-forced-list',
        label: "Listar for\xe7ado (IBL, sem enfileirar)"
    },
    {
        hash: '#techhub-forced-flush',
        label: "Enviar status for\xe7ado (IBL)"
    },
    {
        hash: '#gsnet-mappings-validate',
        label: "GSNET \u2014 validar mapeamento IdItem"
    },
    {
        hash: '#gsnet-validate-selected',
        label: "GSNET \u2014 validar payload (linha selecionada)"
    },
    {
        hash: '#gsnet-retry-selected',
        label: "GSNET \u2014 reenviar (linha selecionada)"
    }
];
/** Operações PRD-VPN (RVD, LLT, GF, AMIL, etc.) — Vendatus / IQVIA / Close-up (Protheus descontinuado). */ const $0a73b38866ec3649$var$OPERATIONS_VPN = [
    {
        hash: '#integration-filter-vendatus',
        label: "Filtrar integra\xe7\xe3o: Vendatus"
    },
    {
        hash: '#integration-filter-iqvia',
        label: "Filtrar integra\xe7\xe3o: IQVIA"
    },
    {
        hash: '#integration-filter-closeup',
        label: "Filtrar integra\xe7\xe3o: Close-up"
    },
    {
        hash: '#integration-filter-clear',
        label: "Limpar filtro de integra\xe7\xe3o"
    },
    {
        hash: '#vendatus-outbox-process',
        label: "Vendatus \u2014 reprocessar fila de envio"
    },
    {
        hash: '#integration-manual-action',
        label: "Registrar a\xe7\xe3o manual (conting\xeancia)"
    }
];
const $0a73b38866ec3649$var$integrationEvents = async function() {
    let summaryBannerMode = null;
    try {
        const r = await fetch(`${(0, $9VcS9.getSialApiHost)()}/integration-events/summary?hours=24&stale_minutes=12`, {
            credentials: 'include'
        });
        if (r.ok) {
            const j = await r.json();
            summaryBannerMode = j?.banner_mode ?? null;
        }
    } catch (_) {
    /* falha na leitura: assumir VPN (não exibir TechHub) */ }
    const isSesspCentral = summaryBannerMode === 'sessp';
    const operations = isSesspCentral ? $0a73b38866ec3649$var$OPERATIONS_SESSP : $0a73b38866ec3649$var$OPERATIONS_VPN;
    let integration_events_crud = (0, $623d474b3f9ce8b0$export$2e2bcd8739ae039).create({
        async loadBaseData () {
            await Promise.all([
                (0, $9VcS9.default).call((0, $9VcS9.default).list_users, this.queryAll()).then((data)=>(0, $1cmSR.default).set('users', data)).catch((error)=>(0, $jUNyh.notify)(error)),
                (0, $9VcS9.default).call((0, $9VcS9.default).list_companies, this.queryAll()).then((data)=>(0, $1cmSR.default).set('companies', data)).catch((error)=>(0, $jUNyh.notify)(error))
            ]);
        },
        async queryData (query) {
            return await (0, $9VcS9.default).call((0, $9VcS9.default).list_integration_events, query);
        },
        async loadRecord (id) {
            let evId = id;
            try {
                const p = JSON.parse(id);
                if (Array.isArray(p) && p.length >= 1) evId = p[0];
            } catch (_) {}
            let _record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_integration_event, evId);
            _record.request_payload = _record.request_payload ? JSON.stringify(_record.request_payload, null, 2) : '';
            _record.response_payload = _record.response_payload ? JSON.stringify(_record.response_payload, null, 2) : '';
            return _record;
        },
        async saveRecord () {},
        editFilter () {
            (0, $hWQyW.default).edit(this.applyFilter.bind(this), this.filter);
        },
        async applyFilter (data) {
            this.filter = await (0, $hWQyW.resolveFilterLabelsToIds)(data, this.fieldspecs);
            this.loadPage(1);
        },
        /** Filtro rápido por integration_key (formato que o translate do filtro entende). */ applyIntegrationFilter (integrationKey) {
            this.filter = {
                'field-0': 'integration_key',
                'operator-0': 'eq',
                'value-0': String(integrationKey || '').trim().toLowerCase()
            };
            this.loadPage(1);
        },
        clearIntegrationFilter () {
            this.filter = {};
            this.loadPage(1);
        },
        async vendatusOutboxProcess () {
            (0, $jUNyh.ask)("Reenviar \xe0 Vendatus os eventos da fila que ainda est\xe3o pendentes (confer\xeancia, fallback, cancelamento, etc.)? Use isso quando a Central mostrar falha de envio (timeout) e a sa\xedda j\xe1 estiver conferida.", "Vendatus \u2014 reprocessar fila", async (k)=>{
                if (k !== 'Y') return;
                let res;
                try {
                    res = await (0, $9VcS9.default).post_integration_events_vendatus_outbox_process(100);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                    return;
                }
                const tx = await res.text();
                if (!res.ok) {
                    (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                    return;
                }
                let j;
                try {
                    j = JSON.parse(tx);
                } catch (_) {
                    (0, $jUNyh.notify)(tx.slice(0, 500), 'Vendatus');
                    return;
                }
                if (j.ok === false) {
                    (0, $jUNyh.notify)(j.reason || "Envio \xe0 Vendatus desabilitado neste ambiente.", 'Vendatus');
                    return;
                }
                const processed = j.processed != null ? j.processed : '?';
                const sent = j.sent != null ? j.sent : '?';
                const failed = j.failed != null ? j.failed : '?';
                (0, $jUNyh.notify)(`Fila processada: ${processed} item(ns), enviados ${sent}, falha ${failed}. Atualize a grade (filtro Vendatus, dire\xe7\xe3o outbound).`, 'Vendatus');
                this.loadPage(1);
            });
        },
        registerManualAction () {
            let fs;
            const submit = async (data)=>{
                const company_id = String(data.ma_company_id || '').trim();
                const integration_key = String(data.ma_integration_key || '').trim().toLowerCase();
                const action_key = String(data.ma_action_key || '').trim();
                const date_from = String(data.ma_date_from || '').trim();
                const date_to = String(data.ma_date_to || '').trim();
                const notes = String(data.ma_notes || '').trim();
                if (!company_id || !integration_key || !action_key) {
                    (0, $jUNyh.notify)("Informe Empresa, Integra\xe7\xe3o e A\xe7\xe3o.", "Aten\xe7\xe3o");
                    return;
                }
                const summary = `A\xe7\xe3o manual solicitada: ${integration_key} / ${action_key}`;
                const request_payload = {
                    action_key: action_key,
                    date_from: date_from || null,
                    date_to: date_to || null,
                    notes: notes || null
                };
                await (0, $9VcS9.default).call((0, $9VcS9.default).insert_integration_event, {
                    company_id: company_id,
                    integration_key: integration_key,
                    status: 'partial',
                    direction: 'outbound',
                    summary: summary,
                    entity_type: 'manual_action',
                    entity_id: action_key,
                    request_payload: request_payload,
                    source: 'integration-center/manual'
                });
                (0, $jUNyh.notify)("A\xe7\xe3o manual registrada na Central de Integra\xe7\xf5es.", 'Sucesso');
                fs.destroy();
                this.loadPage(1);
            };
            (0, $1cmSR.default).list('companies').then((rows)=>{
                fs = (0, $h1m6J.default).create((0, $d895e3e6330b9667$export$2e2bcd8739ae039), submit);
                fs.init();
                const dl = fs.dialog.getNode().querySelector('#manual_action_companies');
                if (dl) dl.innerHTML = (rows || []).map((c)=>{
                    const id = String(c.id || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
                    const lab = String(c.nick || c.name || c.id || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                    return `<option value="${id}" label="${lab}"></option>`;
                }).join('');
            }).catch((e)=>(0, $jUNyh.notify)(e.message || String(e), 'Falha'));
        },
        async techhubPortalToggle () {
            let r;
            try {
                r = await (0, $9VcS9.default).get_integration_events_techhub_runtime_config();
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'TechHub');
                return;
            }
            if (!r.ok) {
                (0, $jUNyh.notify)(await r.text() || `HTTP ${r.status}`, 'TechHub');
                return;
            }
            let j;
            try {
                j = await r.json();
            } catch (e) {
                (0, $jUNyh.notify)("Resposta inv\xe1lida do servidor.", 'TechHub');
                return;
            }
            const next = !j.portal_enabled;
            const cds = Array.isArray(j.allowed_cd_local_origems) && j.allowed_cd_local_origems.length ? j.allowed_cd_local_origems.join(', ') : String(j.allowed_cd_local_origem ?? '');
            const msg = `Ambiente (servidor): ${j.env_techhub_enabled ? 'habilitado' : 'desabilitado'}.\n` + `Integra\xe7\xe3o efetiva agora: ${j.effective_enabled ? 'ligada' : 'desligada'}.\n` + `Interruptor do portal: ${j.portal_enabled ? 'ligado' : 'desligado'} \u{2192} passar\xe1 a ${next ? 'ligado' : 'desligado'}.\n` + `cd_local_origem permitidos: ${cds}.\n\n` + `Confirma a altera\xe7\xe3o?`;
            (0, $jUNyh.ask)(msg, "TechHub \u2014 portal", async (k)=>{
                if (k !== 'Y') return;
                let pr;
                try {
                    pr = await (0, $9VcS9.default).put_integration_events_techhub_runtime_config(next);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'TechHub');
                    return;
                }
                const tx = await pr.text();
                if (!pr.ok) {
                    (0, $jUNyh.notify)(tx || `HTTP ${pr.status}`, 'Erro');
                    return;
                }
                (0, $jUNyh.notify)(next ? "Integra\xe7\xe3o TechHub habilitada no portal." : "Integra\xe7\xe3o TechHub desabilitada no portal.", 'Sucesso');
                this.loadPage(1);
            });
        },
        /** Pull pontual: mesmo fluxo de QA — empresa (UUID ou apelido) + cd_local_origem (sem techhub_ibl_local_origins). */ techhubPullCompanyLocal () {
            (0, $1cmSR.default).list('companies').then((rows)=>{
                let fs;
                const submit = async (data)=>{
                    const company_id = String(data.tp_company_id || '').trim();
                    const cdRaw = data.tp_cd_local_origem;
                    if (!company_id || cdRaw == null || String(cdRaw).trim() === '') {
                        (0, $jUNyh.notify)('Informe empresa e cd_local_origem.', "Aten\xe7\xe3o");
                        return;
                    }
                    const cd_local_origem = parseInt(String(cdRaw).trim(), 10);
                    if (Number.isNaN(cd_local_origem)) {
                        (0, $jUNyh.notify)("cd_local_origem deve ser num\xe9rico.", "Aten\xe7\xe3o");
                        return;
                    }
                    let res;
                    try {
                        res = await (0, $9VcS9.default).post_integration_events_techhub_pull({
                            company_id: company_id,
                            cd_local_origem: cd_local_origem
                        });
                    } catch (e) {
                        (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                        return;
                    }
                    const tx = await res.text();
                    if (!res.ok) {
                        (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                        return;
                    }
                    let j;
                    try {
                        j = JSON.parse(tx);
                    } catch (_) {
                        (0, $jUNyh.notify)(tx.slice(0, 500), 'TechHub');
                        return;
                    }
                    const r = j.result || {};
                    const fetched = r.fetched != null ? r.fetched : '?';
                    const enq = r.enqueued != null ? r.enqueued : '?';
                    const prev = r.preview_external_ids && r.preview_external_ids.length ? ` Ex.: ${r.preview_external_ids.slice(0, 6).join(', ')}${r.preview_external_ids.length > 6 ? "\u2026" : ''}` : '';
                    (0, $jUNyh.notify)(`Pull IBL conclu\xeddo: ${fetched} retornados, ${enq} enfileirados.${prev}`, 'TechHub');
                    fs.destroy();
                    this.loadPage(1);
                };
                fs = (0, $h1m6J.default).create((0, $5ec9602c4a2efd0c$export$2e2bcd8739ae039), submit);
                fs.init();
                const dl = fs.dialog.getNode().querySelector('#techhub_pull_companies');
                if (dl) dl.innerHTML = (rows || []).map((c)=>{
                    const id = String(c.id || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
                    const lab = String(c.nick || c.name || c.id || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                    return `<option value="${id}" label="${lab}"></option>`;
                }).join('');
            }).catch((e)=>(0, $jUNyh.notify)(e.message || String(e), 'Falha'));
        },
        async techhubForcedPull () {
            (0, $jUNyh.ask)("Executar pull for\xe7ado na IBL (buscar faturas integradas e enfileirar) para o(s) mapeamento(s) permitidos nesta fase?", "Pull for\xe7ado \u2014 TechHub", async (k)=>{
                if (k !== 'Y') return;
                let res;
                try {
                    res = await (0, $9VcS9.default).post_integration_events_techhub_pull({});
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                    return;
                }
                const tx = await res.text();
                if (!res.ok) {
                    (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                    return;
                }
                (0, $jUNyh.notify)("Pull for\xe7ado conclu\xeddo. Atualize a grade.", 'TechHub');
                this.loadPage(1);
            });
        },
        async techhubForcedList () {
            (0, $jUNyh.ask)("Listar for\xe7ado: consultar a IBL sem enfileirar itens (apenas visualiza\xe7\xe3o dos retornos).", "Listar for\xe7ado \u2014 TechHub", async (k)=>{
                if (k !== 'Y') return;
                let res;
                try {
                    res = await (0, $9VcS9.default).post_integration_events_techhub_list_integrated({});
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                    return;
                }
                const tx = await res.text();
                if (!res.ok) {
                    (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                    return;
                }
                let data;
                try {
                    data = JSON.parse(tx);
                } catch (_) {
                    (0, $jUNyh.notify)(tx.slice(0, 500), 'TechHub');
                    return;
                }
                const n = data.total_fetched != null ? data.total_fetched : data.result && data.result.fetched != null ? data.result.fetched : null;
                const pre = data.result && data.result.preview_external_ids || [];
                const extra = pre.length ? ` Ex.: ${pre.slice(0, 8).join(', ')}${pre.length > 8 ? "\u2026" : ''}` : '';
                (0, $jUNyh.notify)(`Listagem: ${n != null ? n : '?'} item(ns) retornados (sem enfileirar).${extra}`, 'TechHub');
            });
        },
        async techhubForcedFlush () {
            (0, $jUNyh.ask)("Enviar status for\xe7ado: enviar \xe0 IBL as atualiza\xe7\xf5es pendentes na fila de sa\xedda (outbox)?", "Status for\xe7ado \u2014 TechHub", async (k)=>{
                if (k !== 'Y') return;
                let res;
                try {
                    res = await (0, $9VcS9.default).post_integration_events_techhub_flush_status(200);
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'Erro');
                    return;
                }
                const tx = await res.text();
                if (!res.ok) {
                    (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                    return;
                }
                (0, $jUNyh.notify)("Envio de status conclu\xeddo. Atualize a grade.", 'TechHub');
                this.loadPage(1);
            });
        },
        async _gsnetSelectedEvent () {
            const sel = this.getSelection();
            if (sel.length !== 1) {
                (0, $jUNyh.notify)('Selecione exatamente um evento na grade.', 'GSNET Entrada');
                return null;
            }
            let evId = sel[0];
            try {
                const p = JSON.parse(sel[0]);
                if (Array.isArray(p) && p.length >= 1) evId = p[0];
            } catch (_) {}
            let record;
            try {
                record = await (0, $9VcS9.default).call((0, $9VcS9.default).select_integration_event, evId);
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'GSNET Entrada');
                return null;
            }
            if (String(record.integration_key || '').toLowerCase() !== 'gsnet_entry') {
                (0, $jUNyh.notify)("Selecione um evento da integra\xe7\xe3o GSNET Entrada (integration_key = gsnet_entry).", 'GSNET Entrada');
                return null;
            }
            if (!record.entity_id) {
                (0, $jUNyh.notify)("Evento sem ID de integra\xe7\xe3o GSNET (entity_id).", 'GSNET Entrada');
                return null;
            }
            return record;
        },
        async gsnetMappingsValidate () {
            const companies = await (0, $1cmSR.default).list('companies');
            if (!companies || !companies.length) {
                (0, $jUNyh.notify)("Nenhuma empresa na sess\xe3o.", 'GSNET Entrada');
                return;
            }
            const company_id = companies.length === 1 ? companies[0].id : null;
            let cid = company_id;
            if (!cid) {
                (0, $jUNyh.notify)("Valida\xe7\xe3o de mapeamento usa a primeira empresa da lista quando h\xe1 v\xe1rias \u2014 refine por filtro de empresa na grade.", 'GSNET Entrada');
                cid = companies[0].id;
            }
            let res;
            try {
                res = await (0, $9VcS9.default).post_integration_events_gsnet_mappings_validate({
                    company_id: cid
                });
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'GSNET Entrada');
                return;
            }
            const tx = await res.text();
            if (!res.ok) {
                (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                return;
            }
            let j;
            try {
                j = JSON.parse(tx);
            } catch (_) {
                (0, $jUNyh.notify)(tx.slice(0, 500), 'GSNET Entrada');
                return;
            }
            const n = j.count != null ? j.count : j.missing_mappings ? j.missing_mappings.length : 0;
            (0, $jUNyh.notify)(n === 0 ? "Todos os produtos ativos t\xeam mapeamento IdItem GSNET." : `${n} produto(s) sem mapeamento IdItem GSNET.`, 'GSNET Entrada');
        },
        async gsnetValidateSelected () {
            const record = await this._gsnetSelectedEvent();
            if (!record) return;
            let res;
            try {
                res = await (0, $9VcS9.default).post_integration_events_gsnet_validate({
                    company_id: record.company_id,
                    id: record.entity_id
                });
            } catch (e) {
                (0, $jUNyh.notify)(e?.message || String(e), 'GSNET Entrada');
                return;
            }
            const tx = await res.text();
            if (!res.ok) {
                (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                return;
            }
            let j;
            try {
                j = JSON.parse(tx);
            } catch (_) {
                (0, $jUNyh.notify)(tx.slice(0, 800), 'GSNET Entrada');
                return;
            }
            if (j.ok) {
                (0, $jUNyh.notify)("Payload v\xe1lido (valida\xe7\xe3o local).", 'GSNET Entrada');
                return;
            }
            const errs = Array.isArray(j.errors) ? j.errors : [];
            const msg = errs.slice(0, 5).map((e)=>e.message || e.field || JSON.stringify(e)).join('\n');
            (0, $jUNyh.notify)(msg || "Valida\xe7\xe3o falhou.", 'GSNET Entrada');
        },
        async gsnetRetrySelected () {
            const record = await this._gsnetSelectedEvent();
            if (!record) return;
            (0, $jUNyh.ask)(`Reenviar integra\xe7\xe3o GSNET #${record.entity_id} ao Prodesp/GSNET?`, 'GSNET Entrada', async (k)=>{
                if (k !== 'Y') return;
                let res;
                try {
                    res = await (0, $9VcS9.default).post_integration_events_gsnet_send({
                        company_id: record.company_id,
                        id: record.entity_id,
                        force: true
                    });
                } catch (e) {
                    (0, $jUNyh.notify)(e?.message || String(e), 'GSNET Entrada');
                    return;
                }
                const tx = await res.text();
                if (!res.ok) {
                    (0, $jUNyh.notify)(tx || `HTTP ${res.status}`, 'Erro');
                    return;
                }
                (0, $jUNyh.notify)('Reenvio GSNET solicitado. Atualize a grade.', 'GSNET Entrada');
                this.loadPage(1);
            });
        }
    });
    let fieldspecs = [
        {
            index: 1,
            field: 'id',
            label: 'Evento',
            types: [
                $3eqAU.default(0, 2)
            ],
            placeholder: '0',
            title: 'Identificador'
        },
        {
            index: 2,
            field: 'date_time',
            label: 'Data/Hora',
            types: [
                $8IFAz.default()
            ],
            placeholder: 'dd/mm/aaaa hh:mm:ss',
            title: 'Data e hora'
        },
        {
            index: 3,
            field: 'company_id',
            label: 'Empresa',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: 'Empresa',
            store: 'companies',
            labels: [
                'nick'
            ]
        },
        {
            index: 4,
            field: 'integration_key',
            label: "Integra\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "Chave da integra\xe7\xe3o"
        },
        {
            index: 5,
            field: 'direction',
            label: "Dire\xe7\xe3o",
            types: [],
            placeholder: '',
            title: 'inbound / outbound'
        },
        {
            index: 6,
            field: 'status',
            label: 'Status',
            types: [],
            placeholder: '',
            title: 'success / failure / partial'
        },
        {
            index: 7,
            field: 'summary',
            label: 'Resumo',
            types: [],
            placeholder: '',
            title: 'Resumo'
        },
        {
            index: 8,
            field: 'fetched',
            label: 'Integradas',
            types: [
                $3eqAU.default()
            ],
            placeholder: '',
            title: "Inbound: s\xf3 exibe se retorno > 0. Outbound: env./sep./fal. (flush) ou HTTP c\xf3digo (IBL / API4)."
        },
        {
            index: 9,
            field: 'entity_type',
            label: 'Tipo entidade',
            types: [],
            placeholder: '',
            title: 'Tipo da entidade'
        },
        {
            index: 10,
            field: 'entity_id',
            label: 'ID entidade',
            types: [],
            placeholder: '',
            title: 'Identificador da entidade'
        },
        {
            index: 11,
            field: 'error_message',
            label: 'Erro',
            types: [],
            placeholder: '',
            title: 'Mensagem de erro'
        },
        {
            index: 12,
            field: 'correlation_id',
            label: "Correla\xe7\xe3o",
            types: [],
            placeholder: '',
            title: "UUID de correla\xe7\xe3o"
        },
        {
            index: 13,
            field: 'source',
            label: 'Origem',
            types: [],
            placeholder: '',
            title: 'Origem do registro'
        },
        {
            index: 14,
            field: 'recorded_by',
            label: 'Registrado por',
            types: [
                $9PIz7.default()
            ],
            placeholder: '',
            title: "Usu\xe1rio",
            store: 'users',
            labels: [
                'name'
            ]
        },
        {
            index: 15,
            field: 'request_payload',
            label: 'Request',
            types: [],
            placeholder: "trecho no JSON de requisi\xe7\xe3o",
            title: "Cont\xe9m texto no payload de request (JSON)"
        },
        {
            index: 16,
            field: 'response_payload',
            label: 'Response',
            types: [],
            placeholder: 'trecho no JSON de resposta',
            title: "Cont\xe9m texto no payload de response (JSON)"
        },
        {
            index: 17,
            field: 'error_stack',
            label: 'Stack',
            types: [],
            placeholder: 'trecho no stack trace',
            title: "Cont\xe9m texto no stack de erro"
        }
    ];
    integration_events_crud.run('integration_events', "Eventos de integra\xe7\xe3o", document.getElementById('workarea'), (0, $25a9432000c4705b$export$2e2bcd8739ae039), (0, $a91ff1aa595c2c0c$export$2e2bcd8739ae039), fieldspecs, operations, [], {
        default_columns: '1,2,3,4,5,6,7,8,9,10,11,12,13,14'
    });
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-filter-vendatus', ()=>integration_events_crud.applyIntegrationFilter('vendatus'));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-filter-iqvia', ()=>integration_events_crud.applyIntegrationFilter('iqvia'));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-filter-closeup', ()=>integration_events_crud.applyIntegrationFilter('closeup'));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-filter-clear', integration_events_crud.clearIntegrationFilter.bind(integration_events_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-manual-action', integration_events_crud.registerManualAction.bind(integration_events_crud));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#vendatus-outbox-process', ()=>integration_events_crud.vendatusOutboxProcess());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-filter-techhub', ()=>integration_events_crud.applyIntegrationFilter('techhub_ibl'));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-filter-gsnet', ()=>integration_events_crud.applyIntegrationFilter('gsnet_entry'));
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-portal-toggle', ()=>integration_events_crud.techhubPortalToggle());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-pull-company-local', ()=>integration_events_crud.techhubPullCompanyLocal());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-forced-pull', ()=>integration_events_crud.techhubForcedPull());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-forced-list', ()=>integration_events_crud.techhubForcedList());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#techhub-forced-flush', ()=>integration_events_crud.techhubForcedFlush());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#gsnet-mappings-validate', ()=>integration_events_crud.gsnetMappingsValidate());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#gsnet-validate-selected', ()=>integration_events_crud.gsnetValidateSelected());
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#gsnet-retry-selected', ()=>integration_events_crud.gsnetRetrySelected());
};
var $0a73b38866ec3649$export$2e2bcd8739ae039 = $0a73b38866ec3649$var$integrationEvents;


/**
 * Central de Importação - Sistema > Central de Importação
 * Fluxo: 1) Selecionar entidade, 2) Upload e validação, 3) Importação
 * Layout alinhado ao sistema (msgbox, notify, ajuda ? como cadastro de produto)
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");
const $4858a4427bfed1ff$var$IMPORT_HELP_CLASS = 'import-help-body';
const $4858a4427bfed1ff$var$IMPORT_HELP_1 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Vis\xe3o geral</h4>
<p>A central carrega da API a lista de tipos de cadastro que podem ser importados por planilha. O fluxo \xe9: <strong>escolher entidade</strong> \u{2192} <strong>enviar arquivo</strong> \u{2192} <strong>validar</strong> \u{2192} <strong>importar</strong> s\xf3 as linhas aprovadas.</p>
<h4>Organiza\xe7\xe3o</h4>
<p>Cadastros ligados \xe0 empresa depositante (ex.: fornecedores, clientes, transportadores), conforme habilitado no servidor.</p>
<h4>Cat\xe1logo</h4>
<p>Itens de cat\xe1logo (ex.: produtos, categorias, unidades), conforme a configura\xe7\xe3o de importa\xe7\xe3o.</p>
<h4>Armazenamento</h4>
<p>Dados de armaz\xe9m/estoque quando expostos para importa\xe7\xe3o em massa.</p>
<p><strong>Permiss\xf5es:</strong> seu grupo de usu\xe1rio precisa ter os endpoints da central de importa\xe7\xe3o liberados; caso contr\xe1rio a lista pode vir vazia ou a API retorna erro.</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_2 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Arquivo</h4>
<p>Formatos aceitos: <strong>CSV</strong> ou <strong>XLSX</strong>. A primeira linha deve conter os cabe\xe7alhos exatamente como no modelo.</p>
<h4>Colunas esperadas</h4>
<p>A tela mostra a lista de colunas obrigat\xf3rias/opcionais para a entidade escolhida. Desvios de nome ou ordem podem gerar erro na valida\xe7\xe3o.</p>
<h4>Baixar modelo</h4>
<p>Use o link <strong>Baixar modelo da planilha</strong> para obter um CSV de exemplo com os cabe\xe7alhos corretos.</p>
<h4>Validar</h4>
<p>O bot\xe3o <strong>Validar</strong> envia o arquivo ao servidor <strong>sem gravar</strong> ainda: voc\xea v\xea erros por linha e quantas linhas est\xe3o prontas para importar.</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_3 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Resultado da valida\xe7\xe3o</h4>
<p>Se houver erros, cada item indica a <strong>linha</strong>, o <strong>campo</strong> (quando aplic\xe1vel) e a <strong>mensagem</strong>. Corrija o arquivo e volte \xe0 etapa anterior para reenviar.</p>
<h4>Linhas v\xe1lidas</h4>
<p>Somente as linhas sem bloqueio entram em <strong>rows_valid</strong>. O bot\xe3o <strong>Importar</strong> s\xf3 aparece quando existe ao menos uma linha v\xe1lida.</p>
<h4>Voltar</h4>
<p>Retorna \xe0 sele\xe7\xe3o de entidade e descarta o arquivo atual da mem\xf3ria do assistente (n\xe3o altera o que j\xe1 foi gravado no banco em importa\xe7\xf5es anteriores).</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_4 = `
<div class="${$4858a4427bfed1ff$var$IMPORT_HELP_CLASS}">
<h4>Importa\xe7\xe3o conclu\xedda</h4>
<p>O n\xfamero exibido \xe9 a quantidade de registros gravados com sucesso nesta execu\xe7\xe3o.</p>
<h4>Falhas parciais</h4>
<p>Se algumas linhas falharem no insert, elas aparecem listadas com linha e mensagem. As demais podem ter sido gravadas normalmente.</p>
<h4>Nova importa\xe7\xe3o</h4>
<p>Reinicia o fluxo na primeira tela para outro arquivo ou outra entidade.</p>
</div>`;
const $4858a4427bfed1ff$var$IMPORT_HELP_BY_STEP = {
    1: {
        title: "Ajuda \u2014 Central de Importa\xe7\xe3o (passo 1)",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_1
    },
    2: {
        title: "Ajuda \u2014 Envio e valida\xe7\xe3o do arquivo",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_2
    },
    3: {
        title: "Ajuda \u2014 Resultado da valida\xe7\xe3o",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_3
    },
    4: {
        title: "Ajuda \u2014 Ap\xf3s importar",
        html: $4858a4427bfed1ff$var$IMPORT_HELP_4
    }
};
function $4858a4427bfed1ff$var$openImportHelp(step) {
    const pack = $4858a4427bfed1ff$var$IMPORT_HELP_BY_STEP[step];
    if (!pack) return;
    let mb;
    mb = (0, $jUNyh.default)({
        title: pack.title,
        text: pack.html,
        buttons: [
            {
                label: 'Fechar',
                cls: 'bn_Enter'
            }
        ],
        callback: ()=>mb.destroy()
    });
}
const $4858a4427bfed1ff$var$CATEGORIAS = {
    "organiza\xe7\xe3o": "Organiza\xe7\xe3o",
    "cat\xe1logo": "Cat\xe1logo",
    armazenamento: 'Armazenamento'
};
let $4858a4427bfed1ff$var$entities = {};
let $4858a4427bfed1ff$var$selectedEntity = null;
let $4858a4427bfed1ff$var$validationResult = null;
function $4858a4427bfed1ff$var$$(sel, ctx = document) {
    return ctx.querySelector(sel);
}
function $4858a4427bfed1ff$var$renderEntitySelector(container) {
    const groups = {};
    for (const [key, schema] of Object.entries($4858a4427bfed1ff$var$entities)){
        const cat = schema.category || 'outros';
        if (!groups[cat]) groups[cat] = [];
        groups[cat].push({
            key: key,
            ...schema
        });
    }
    const order = [
        "organiza\xe7\xe3o",
        "cat\xe1logo",
        'armazenamento'
    ];
    let html = '<div class="import-entity-list">';
    for (const cat of order){
        if (!groups[cat]) continue;
        html += `<div class="import-category mtm">`;
        html += `<div class="import-cat-title">${$4858a4427bfed1ff$var$CATEGORIAS[cat] || cat}</div>`;
        html += '<div class="import-cat-items">';
        for (const e of groups[cat])html += `<button type="button" data-entity="${e.key}" class="import-entity-btn button">${e.label}</button>`;
        html += '</div></div>';
    }
    html += '</div>';
    container.innerHTML = html;
}
function $4858a4427bfed1ff$var$renderStep1(container) {
    container.innerHTML = `
		<div class="msgbox import-step" data-step="1">
			<div class="import-title-row">
				<div class="title">Central de Importa\xe7\xe3o</div>
				<button type="button" class="import-help-btn" data-import-help="1" title="Ajuda desta etapa" aria-label="Ajuda passo 1">?</button>
			</div>
			<p class="mts">Selecione o tipo de cadastro para importar:</p>
			<div id="import-entity-list"></div>
		</div>`;
    $4858a4427bfed1ff$var$renderEntitySelector($4858a4427bfed1ff$var$$('#import-entity-list', container));
}
function $4858a4427bfed1ff$var$renderStep2(container, entityKey) {
    const schema = $4858a4427bfed1ff$var$entities[entityKey];
    const cols = (schema?.cols || []).join(', ');
    container.innerHTML = `
		<div class="form import-step" data-step="2">
			<div class="import-title-row">
				<div class="title">Importar ${schema?.label || entityKey}</div>
				<button type="button" class="import-help-btn" data-import-help="2" title="Ajuda desta etapa" aria-label="Ajuda passo 2">?</button>
			</div>
			<p class="mts">Colunas esperadas: <strong>${cols}</strong></p>
			<div class="mtl fsb">
				<label>Arquivo (CSV ou XLSX)<sup>*</sup>
					<input id="import-file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="import-download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm fsb import-actions">
				<button type="button" id="import-back" class="button import-btn-muted">Voltar</button>
				<button type="button" id="import-validate" class="button import-btn-success">Validar</button>
			</div>
		</div>`;
}
function $4858a4427bfed1ff$var$renderStep3(container, result) {
    const ok = result?.ok === true;
    const errors = result?.errors || [];
    const rowsValid = result?.rows_valid || [];
    const total = result?.total || 0;
    let errorsHtml = '';
    if (errors.length > 0) {
        errorsHtml = '<div class="import-errors mtm"><strong>Problemas encontrados:</strong><ul>';
        for (const e of errors.slice(0, 20))errorsHtml += `<li>Linha ${e.linha}: ${e.campo ? e.campo + " \u2013 " : ''}${e.mensagem}</li>`;
        if (errors.length > 20) errorsHtml += `<li>... e mais ${errors.length - 20} erro(s)</li>`;
        errorsHtml += '</ul></div>';
    }
    let successHtml = '';
    if (ok && rowsValid.length > 0) successHtml = `<div class="import-success mts"><strong>Valida\xe7\xe3o OK.</strong> ${rowsValid.length} de ${total} linha(s) prontas para importar.</div>`;
    else if (ok && rowsValid.length === 0) successHtml = '<div class="import-warning mts">Nenhuma linha v\xe1lida encontrada.</div>';
    container.innerHTML = `
		<div class="msgbox import-step" data-step="3">
			<div class="import-title-row">
				<div class="title">Resultado da valida\xe7\xe3o</div>
				<button type="button" class="import-help-btn" data-import-help="3" title="Ajuda desta etapa" aria-label="Ajuda passo 3">?</button>
			</div>
			${successHtml}
			${errorsHtml}
			<div class="mtm fsb import-actions">
				<button type="button" id="import-back2" class="button import-btn-muted">Voltar</button>
				${ok && rowsValid.length > 0 ? '<button type="button" id="import-do" class="button import-btn-success">Importar</button>' : ''}
			</div>
		</div>`;
}
function $4858a4427bfed1ff$var$renderStep4(container, result) {
    const imported = result?.imported || 0;
    const failed = result?.failed || [];
    let failedHtml = '';
    if (failed.length > 0) {
        failedHtml = '<div class="import-errors mtm"><strong>Falhas:</strong><ul>';
        for (const f of failed.slice(0, 10))failedHtml += `<li>Linha ${f.linha}: ${f.mensagem}</li>`;
        if (failed.length > 10) failedHtml += `<li>... e mais ${failed.length - 10}</li>`;
        failedHtml += '</ul></div>';
    }
    container.innerHTML = `
		<div class="msgbox import-step" data-step="4">
			<div class="import-title-row">
				<div class="title">Importa\xe7\xe3o conclu\xedda</div>
				<button type="button" class="import-help-btn" data-import-help="4" title="Ajuda desta etapa" aria-label="Ajuda passo 4">?</button>
			</div>
			<div class="import-success mts"><strong>${imported}</strong> registro(s) importado(s) com sucesso.</div>
			${failedHtml}
			<div class="mtm import-actions">
				<button type="button" id="import-new" class="button import-btn-success">Nova importa\xe7\xe3o</button>
			</div>
		</div>`;
}
async function $4858a4427bfed1ff$var$loadEntities() {
    const r = await (0, $9VcS9.default).import_center_entities();
    if (!r.ok) throw new Error('Erro ao carregar entidades');
    $4858a4427bfed1ff$var$entities = await r.json();
}
async function $4858a4427bfed1ff$var$downloadTemplate(entityKey) {
    const r = await (0, $9VcS9.default).import_center_template(entityKey);
    if (!r.ok) throw new Error('Erro ao baixar modelo');
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `modelo_${entityKey}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $4858a4427bfed1ff$var$validate(entityKey, file) {
    const fd = new FormData();
    fd.append('entity_key', entityKey);
    fd.append('file', file);
    const r = await (0, $9VcS9.default).import_center_validate(fd);
    if (!r.ok) {
        const text = await r.text();
        throw new Error(text || "Erro na valida\xe7\xe3o");
    }
    return r.json();
}
/** Lotes no POST /import — evita 502 (body JSON grande derruba uWSGI sem post-buffering). */ const $4858a4427bfed1ff$var$IMPORT_BATCH_SIZE = 150;
async function $4858a4427bfed1ff$var$doImport(entityKey, rowsValid) {
    const rows = Array.isArray(rowsValid) ? rowsValid : [];
    if (rows.length === 0) return {
        imported: 0,
        failed: [],
        total: 0
    };
    let imported = 0;
    let failed = [];
    for(let i = 0; i < rows.length; i += $4858a4427bfed1ff$var$IMPORT_BATCH_SIZE){
        const chunk = rows.slice(i, i + $4858a4427bfed1ff$var$IMPORT_BATCH_SIZE);
        const r = await (0, $9VcS9.default).import_center_import({
            entity_key: entityKey,
            rows_valid: chunk
        });
        if (!r.ok) {
            const text = await r.text();
            throw new Error(text || `Erro na importa\xe7\xe3o (lote ${Math.floor(i / $4858a4427bfed1ff$var$IMPORT_BATCH_SIZE) + 1})`);
        }
        const part = await r.json();
        imported += Number(part?.imported || 0);
        if (Array.isArray(part?.failed) && part.failed.length) failed = failed.concat(part.failed);
    }
    return {
        imported: imported,
        failed: failed,
        total: rows.length
    };
}
function $4858a4427bfed1ff$var$showError(msg) {
    (0, $jUNyh.notify)(String(msg || 'Erro'), "Central de Importa\xe7\xe3o");
}
const $4858a4427bfed1ff$var$import_center = async function() {
    const workarea = document.getElementById('workarea');
    if (!workarea) return;
    const styles = `
		#import-center-wrap {
			display: flex;
			justify-content: center;
			align-items: flex-start;
			padding: var(--space-lg);
			min-height: 100%;
			background-color: var(--color-secondary);
		}
		#import-center { max-width: 42rem; width: 100%; }
		#import-center .import-title-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 0.75rem;
			flex-wrap: wrap;
		}
		#import-center .import-title-row .title { margin: 0; flex: 1; min-width: 0; }
		#import-center .import-help-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 1.35rem;
			height: 1.35rem;
			padding: 0;
			border: 1px solid #9ca3af;
			border-radius: 999px;
			background: #f3f4f6;
			color: #374151;
			font-size: 0.85rem;
			font-weight: 700;
			line-height: 1;
			cursor: pointer;
			flex-shrink: 0;
		}
		#import-center .import-help-btn:hover { background: #e5e7eb; }
		#import-center .import-help-btn:focus { outline: 2px solid #2563eb; outline-offset: 2px; }
		#import-center .import-actions { justify-content: flex-end; gap: 0.5rem; flex-wrap: wrap; }
		#import-center .import-btn-success {
			background: linear-gradient(180deg, #4ade80 0%, #22c55e 100%);
			color: #fff;
			border: 1px solid #15803d;
			font-weight: 600;
			box-shadow: 0 1px 2px rgba(22, 163, 74, 0.25);
		}
		#import-center .import-btn-success:hover {
			filter: brightness(1.05);
			box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
		}
		#import-center .import-btn-muted {
			background: #f8fafc;
			color: #334155;
			border: 1px solid var(--color-border);
			font-weight: 500;
		}
		#import-center .import-btn-muted:hover { background: #f1f5f9; }
		#import-center .import-cat-title {
			font-weight: 600;
			margin-bottom: var(--space-sm);
			color: var(--color-text);
		}
		#import-center .import-cat-items {
			display: flex;
			flex-wrap: wrap;
			gap: var(--space-sm);
		}
		#import-center .import-entity-btn {
			display: inline-block;
			text-align: center;
			margin: 0;
			text-decoration: none;
		}
		#import-center .import-errors {
			color: var(--color-error);
			padding: var(--space-sm);
			background-color: var(--color-secondary);
			border: 1px solid var(--color-border);
			border-radius: 4px;
		}
		#import-center .import-errors ul { margin: var(--space-sm) 0 0; padding-left: var(--space-lg); }
		#import-center .import-success {
			color: #0a6b0a;
			padding: var(--space-sm);
			background-color: #f0f9f0;
			border: 1px solid #c8e6c8;
			border-radius: 4px;
		}
		#import-center .import-warning {
			color: #8a6d00;
			padding: var(--space-sm);
			background-color: #fffbe6;
			border: 1px solid #e6d68a;
			border-radius: 4px;
		}
	`;
    const helpBodyStyles = `
		.import-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
		.import-help-body h4 {
			margin: 0.85rem 0 0.25rem 0;
			font-size: 0.78rem;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.03em;
			color: #1f2937;
		}
		.import-help-body h4:first-child { margin-top: 0; }
		.import-help-body p {
			margin: 0;
			font-size: 0.875rem;
			line-height: 1.45;
			color: #374151;
		}
	`;
    workarea.innerHTML = `<style>${styles}</style><style>${helpBodyStyles}</style><div id="import-center-wrap"><div id="import-center"></div></div>`;
    const container = $4858a4427bfed1ff$var$$('#import-center');
    try {
        await $4858a4427bfed1ff$var$loadEntities();
    } catch (e) {
        $4858a4427bfed1ff$var$showError(e.message);
        return;
    }
    container.addEventListener('click', async (ev)=>{
        const helpBtn = ev.target.closest('.import-help-btn');
        if (helpBtn) {
            ev.preventDefault();
            const step = Number(helpBtn.getAttribute('data-import-help') || '0');
            if (step >= 1 && step <= 4) $4858a4427bfed1ff$var$openImportHelp(step);
            return;
        }
        const entityBtn = ev.target.closest('.import-entity-btn');
        if (entityBtn) {
            ev.preventDefault();
            $4858a4427bfed1ff$var$selectedEntity = entityBtn.dataset.entity;
            $4858a4427bfed1ff$var$renderStep2(container, $4858a4427bfed1ff$var$selectedEntity);
            $4858a4427bfed1ff$var$$('#import-file').value = '';
            return;
        }
        if (ev.target.id === 'import-download-template') {
            ev.preventDefault();
            try {
                await $4858a4427bfed1ff$var$downloadTemplate($4858a4427bfed1ff$var$selectedEntity);
            } catch (e) {
                $4858a4427bfed1ff$var$showError(e.message);
            }
            return;
        }
        if (ev.target.id === 'import-back' || ev.target.id === 'import-back2') {
            $4858a4427bfed1ff$var$renderStep1(container);
            $4858a4427bfed1ff$var$selectedEntity = null;
            $4858a4427bfed1ff$var$validationResult = null;
            return;
        }
        if (ev.target.id === 'import-validate') {
            const fileInput = $4858a4427bfed1ff$var$$('#import-file');
            const file = fileInput?.files?.[0];
            if (!file) {
                $4858a4427bfed1ff$var$showError('Selecione um arquivo.');
                return;
            }
            try {
                $4858a4427bfed1ff$var$validationResult = await $4858a4427bfed1ff$var$validate($4858a4427bfed1ff$var$selectedEntity, file);
                $4858a4427bfed1ff$var$renderStep3(container, $4858a4427bfed1ff$var$validationResult);
            } catch (e) {
                $4858a4427bfed1ff$var$showError(e.message);
            }
            return;
        }
        if (ev.target.id === 'import-do') {
            const rows = $4858a4427bfed1ff$var$validationResult?.rows_valid || [];
            if (rows.length === 0) return;
            try {
                const result = await $4858a4427bfed1ff$var$doImport($4858a4427bfed1ff$var$selectedEntity, rows);
                $4858a4427bfed1ff$var$renderStep4(container, result);
            } catch (e) {
                $4858a4427bfed1ff$var$showError(e.message);
            }
            return;
        }
        if (ev.target.id === 'import-new') {
            $4858a4427bfed1ff$var$renderStep1(container);
            $4858a4427bfed1ff$var$selectedEntity = null;
            $4858a4427bfed1ff$var$validationResult = null;
            return;
        }
    });
    $4858a4427bfed1ff$var$renderStep1(container);
};
var $4858a4427bfed1ff$export$2e2bcd8739ae039 = $4858a4427bfed1ff$var$import_center;


/**
 * BI > Kardex — paridade com portal cliente (kardex.php).
 * API: GET .../reports/kardex e .../reports/kardex/summary
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $hWQyW = parcelRequire("hWQyW");

var $jUNyh = parcelRequire("jUNyh");
/**
 * Regras de apresentação do Kardex alinhadas ao portal BI (kardex.php + kardex_api.php).
 * O cálculo de saldo permanece na API SIAL; aqui: filtros pós-API, enriquecimento e colunas.
 */ 
var $hWQyW = parcelRequire("hWQyW");

var $9VcS9 = parcelRequire("9VcS9");
const $4783b3c4a628f45b$export$3441ba3706a9c8cf = 'S-1';
const $4783b3c4a628f45b$export$bb2f65263c9a11b7 = "Aguardando Endere\xe7amento";
const $4783b3c4a628f45b$export$35d7b145f10171ae = {
    reserva_na_posicao: "Reserva na posi\xe7\xe3o",
    liberacao_reserva: "Libera\xe7\xe3o de reserva",
    "libera\xe7\xe3o_reserva": "Libera\xe7\xe3o de reserva",
    entrada: 'Entrada',
    saida: "Sa\xedda",
    "sa\xedda": "Sa\xedda",
    saida_expedicao: "Sa\xedda expedi\xe7\xe3o",
    "sa\xedda_expedi\xe7\xe3o": "Sa\xedda expedi\xe7\xe3o",
    transferencia: "Transfer\xeancia",
    "transfer\xeancia": "Transfer\xeancia",
    ajuste: 'Ajuste',
    ajuste_saldo: 'Ajuste de saldo',
    ressuprimento: 'Ressuprimento',
    consumo: 'Consumo',
    devolucao: "Devolu\xe7\xe3o",
    "devolu\xe7\xe3o": "Devolu\xe7\xe3o",
    baixa: 'Baixa',
    baixa_saida: "Baixa sa\xedda",
    "baixa_sa\xedda": "Baixa sa\xedda",
    entrada_para_posicao: "Entrada para posi\xe7\xe3o",
    "entrada_para_posi\xe7\xe3o": "Entrada para posi\xe7\xe3o",
    transferencia_entre_posicoes: "Transfer\xeancia entre posi\xe7\xf5es",
    "transfer\xeancia_entre_posi\xe7\xf5es": "Transfer\xeancia entre posi\xe7\xf5es",
    bloqueio: 'Bloqueio',
    bloqueio_estoque: 'Bloqueio de estoque',
    desbloqueio: 'Desbloqueio',
    avaria_fornecedor: 'Avaria Fornecedor',
    avaria_armazem: "Avaria Armaz\xe9m",
    avaria_transporte: 'Avaria Transporte',
    quarentena: 'Quarentena',
    vencido: 'Vencidos',
    vencimento_curto: 'Vencimento Curto',
    falta_ibl: 'Falta IBL'
};
const $4783b3c4a628f45b$export$608e776bd8cff403 = [
    {
        key: '__num',
        label: '#',
        align: 'center'
    },
    {
        key: 'date_time',
        label: 'Data/Hora',
        align: 'left'
    },
    {
        key: '__nf_entrada',
        label: 'NF entrada',
        align: 'left'
    },
    {
        key: '__req_his',
        label: 'Ref. cliente / HIS',
        align: 'left'
    },
    {
        key: '__bloqueio_motivo',
        label: 'Motivo bloqueio',
        align: 'left'
    },
    {
        key: '__lote',
        label: 'Lote',
        align: 'left'
    },
    {
        key: '__lote_atendido',
        label: 'Lote atendido',
        align: 'left'
    },
    {
        key: 'movement_kind',
        label: 'Tipo de movimento',
        align: 'left'
    },
    {
        key: '__tipo',
        label: "Fluxo (origem\u2192destino)",
        align: 'center'
    },
    {
        key: 'source',
        label: 'Origem',
        align: 'left'
    },
    {
        key: 'target',
        label: 'Destino',
        align: 'left'
    },
    {
        key: 'quantity',
        label: 'Qtd do movimento',
        align: 'end'
    },
    {
        key: 'balance_qty',
        label: "Saldo f\xedsico",
        align: 'end'
    },
    {
        key: '__valor_sinal',
        label: 'Valor sinal',
        align: 'end'
    },
    {
        key: 'balance_value',
        label: 'Saldo valor',
        align: 'end'
    }
];
const $4783b3c4a628f45b$export$d77013a5e5502a93 = [
    {
        key: '__num',
        label: '#',
        align: 'center'
    },
    {
        key: 'date_time',
        label: 'Data/Hora',
        align: 'left'
    },
    {
        key: 'movement_kind',
        label: 'Tipo de movimento',
        align: 'left'
    },
    {
        key: '__nf_entrada',
        label: 'Entrada (NF)',
        align: 'left'
    },
    {
        key: '__req_his',
        label: "Sa\xedda / consumo (ref.)",
        align: 'left'
    },
    {
        key: '__bloqueio_motivo',
        label: 'Motivo bloqueio',
        align: 'left'
    },
    {
        key: 'quantity',
        label: 'Qtd do movimento',
        align: 'end'
    },
    {
        key: 'balance_qty',
        label: "Saldo f\xedsico",
        align: 'end'
    }
];
function $4783b3c4a628f45b$export$b7de1105ecdc796e(dateFimInclusive) {
    if (!dateFimInclusive) return '';
    const d = new Date(`${dateFimInclusive}T12:00:00`);
    if (Number.isNaN(d.getTime())) return '';
    d.setDate(d.getDate() + 1);
    return d.toISOString().slice(0, 10);
}
function $4783b3c4a628f45b$export$127c5aa7df60a221({ productId: productId, dateFrom: dateFrom, dateFim: dateFim, lotText: lotText, costMode: costMode, includeDisabled: includeDisabled, limit: limit, offset: offset }) {
    const params = {
        product_id: productId,
        date_from: dateFrom,
        date_to: $4783b3c4a628f45b$export$b7de1105ecdc796e(dateFim),
        cost_mode: costMode || 'none'
    };
    const lot = String(lotText || '').trim();
    if (lot) {
        if (/^\d+$/.test(lot)) params.lot_id = lot;
        else params.lot_number = lot;
    }
    if (includeDisabled) params.include_disabled = '1';
    if (limit != null) params.limit = String(limit);
    if (offset != null) params.offset = String(offset);
    return params;
}
function $4783b3c4a628f45b$export$b0d742c8d9101930(vistaCliente, costMode = 'none') {
    const cols = vistaCliente ? $4783b3c4a628f45b$export$d77013a5e5502a93 : $4783b3c4a628f45b$export$608e776bd8cff403;
    if (!vistaCliente && costMode === 'none') return cols.filter((c)=>c.key !== '__valor_sinal' && c.key !== 'balance_value');
    return cols;
}
const $4783b3c4a628f45b$var$KDX_REF_COL_KEYS = new Set([
    '__nf_entrada',
    '__req_his',
    '__bloqueio_motivo',
    '__lote',
    '__lote_atendido',
    'source',
    'target',
    'movement_kind',
    '__nf_entrada_html',
    '__req_his_html',
    '__bloqueio_motivo_html'
]);
function $4783b3c4a628f45b$var$escHtml(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $4783b3c4a628f45b$export$3d7a2d69182e565e(n) {
    if (n === null || n === undefined || n === '') return "\u2014";
    const x = Number(n);
    if (Number.isNaN(x)) return String(n);
    return x.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 6
    });
}
function $4783b3c4a628f45b$export$e63787c689315163(n) {
    if (n === null || n === undefined || n === '') return "\u2014";
    const x = Number(n);
    if (Number.isNaN(x)) return String(n);
    return x.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
}
function $4783b3c4a628f45b$export$a8be67f60e9fba44(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    if (!Number.isNaN(d.getTime())) return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
    const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}:${m[6]}`;
    return String(iso);
}
function $4783b3c4a628f45b$export$e69a9da2fc3aa0ca(v) {
    if (!v) return "\u2014";
    const s = String(v);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString('pt-BR');
}
function $4783b3c4a628f45b$var$movementKindLower(row) {
    return String(row?.movement_kind ?? '').trim().toLowerCase();
}
function $4783b3c4a628f45b$var$movementKindNormalized(row) {
    return $4783b3c4a628f45b$var$movementKindLower(row).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $4783b3c4a628f45b$export$cc6e44de1c2d5363(row) {
    if (!row || typeof row !== 'object') return false;
    const st = String(row.source_type ?? row.sourceType ?? '').toUpperCase();
    const tt = String(row.target_type ?? row.targetType ?? '').toUpperCase();
    if (st === 'L' && tt === 'I') return true;
    if (st === 'B' && tt === 'I') return true;
    if (st === 'I' && tt === 'L' && (row.is_disabled || row.isDisabled)) return true;
    const mk = $4783b3c4a628f45b$var$movementKindNormalized(row);
    if (mk.includes('estorno') && mk.includes('entrada')) return true;
    return false;
}
function $4783b3c4a628f45b$export$19956727355d0bdf(rows) {
    return (rows || []).filter((r)=>!$4783b3c4a628f45b$export$cc6e44de1c2d5363(r));
}
function $4783b3c4a628f45b$export$548b6337e8121783(row) {
    if ($4783b3c4a628f45b$export$cc6e44de1c2d5363(row)) return true;
    const mk = $4783b3c4a628f45b$var$movementKindNormalized(row);
    if (!mk) return false;
    if (mk.includes('bloqueio') || mk.includes('desbloqueio') || mk.includes('bloquear')) return false;
    if (mk.includes('transfer')) return true;
    if (mk.includes('reserva') && mk.includes('posicao')) return true;
    if (mk.includes('liberacao') && mk.includes('reserva')) return true;
    if (mk.includes('estorno')) return true;
    return false;
}
function $4783b3c4a628f45b$export$e00eaf6dc1814243(rows) {
    return (rows || []).filter((r)=>!$4783b3c4a628f45b$export$548b6337e8121783(r));
}
function $4783b3c4a628f45b$var$parseBalanceBr(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    const s = String(v).trim().replace(/\s/g, '');
    if (!s) return 0;
    const n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
}
function $4783b3c4a628f45b$var$parseQtyDelta(row) {
    if (!row || typeof row !== 'object') return 0;
    const raw = row.qty_delta != null && row.qty_delta !== '' ? row.qty_delta : row.qtyDelta;
    if (raw == null || raw === '') return 0;
    if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
    let s = String(raw).trim().replace(/\s/g, '');
    let neg = false;
    if (s.startsWith('-')) {
        neg = true;
        s = s.slice(1);
    } else if (s.startsWith('+')) s = s.slice(1);
    const n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    if (Number.isFinite(n)) return neg ? -n : n;
    return 0;
}
/** Δ que alimenta o saldo físico: I→L (+), R→O (−); transferências/reservas/estornos = 0. */ function $4783b3c4a628f45b$var$parseBalanceDelta(row) {
    if (!row || typeof row !== 'object') return 0;
    if (row.is_disabled || row.isDisabled) return 0;
    const raw = row.balance_delta != null && row.balance_delta !== '' ? row.balance_delta : row.balanceDelta;
    if (raw != null && raw !== '') {
        if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
        return $4783b3c4a628f45b$var$parseQtyDelta({
            qty_delta: raw
        });
    }
    const st = String(row.source_type || row.sourceType || '').toUpperCase();
    const tt = String(row.target_type || row.targetType || '').toUpperCase();
    const q = Number(row.quantity);
    if (!Number.isFinite(q)) return 0;
    if (st === 'I' && tt === 'L') return q;
    if (st === 'R' && tt === 'O') return -q;
    return 0;
}
function $4783b3c4a628f45b$var$rowBalanceQtyRaw(row) {
    if (!row || typeof row !== 'object') return null;
    for (const k of [
        'balance_qty',
        'balanceQty',
        'balance_quantity'
    ]){
        if (row[k] !== undefined && row[k] !== null && row[k] !== '') return row[k];
    }
    return null;
}
function $4783b3c4a628f45b$var$rowDateMs(row) {
    return new Date(row?.date_time || 0).getTime() || 0;
}
function $4783b3c4a628f45b$export$66e829a91de98c2b(rows, summary, { fullSequence: fullSequence = false } = {}) {
    if (!rows?.length) return;
    if (fullSequence && summary?.opening_qty != null && summary.opening_qty !== '') {
        const opening = typeof summary.opening_qty === 'number' ? summary.opening_qty : $4783b3c4a628f45b$var$parseBalanceBr(summary.opening_qty);
        if (Number.isFinite(opening)) {
            const sorted = rows.slice().sort((a, b)=>$4783b3c4a628f45b$var$rowDateMs(a) - $4783b3c4a628f45b$var$rowDateMs(b));
            let running = opening;
            const byRef = new WeakMap();
            for (const r of sorted){
                running += $4783b3c4a628f45b$var$parseBalanceDelta(r);
                byRef.set(r, running);
            }
            for (const r of rows)r._sialbi_balance_qty = byRef.has(r) ? byRef.get(r) : $4783b3c4a628f45b$var$parseBalanceBr($4783b3c4a628f45b$var$rowBalanceQtyRaw(r));
            return;
        }
    }
    for (const r of rows)r._sialbi_balance_qty = $4783b3c4a628f45b$var$parseBalanceBr($4783b3c4a628f45b$var$rowBalanceQtyRaw(r));
}
function $4783b3c4a628f45b$export$b657ffc6effe4fb1(rows, summary, fullSequence) {
    $4783b3c4a628f45b$export$66e829a91de98c2b(rows, summary, {
        fullSequence: !!fullSequence
    });
}
function $4783b3c4a628f45b$export$b3b7c28014638fc9(summary, stockTotals) {
    if (!summary || typeof summary !== 'object') return summary;
    const out = {
        ...summary
    };
    const tot = stockTotals?.qty_total ?? summary.current_stock_qty;
    if (tot != null && Number.isFinite(Number(tot))) out.closing_qty = Number(tot);
    return out;
}
function $4783b3c4a628f45b$export$7b4b843582bcc3e1(summary, visibleRows) {
    if (!summary || typeof summary !== 'object') return summary;
    const rows = visibleRows || [];
    if (!rows.length) return {
        ...summary,
        line_count: 0
    };
    return {
        ...summary,
        line_count: rows.length
    };
}
function $4783b3c4a628f45b$var$rowDisplayBalance(row) {
    const adj = row?._sialbi_balance_qty;
    if (adj != null && Number.isFinite(Number(adj))) return Number(adj);
    return $4783b3c4a628f45b$var$parseBalanceBr($4783b3c4a628f45b$var$rowBalanceQtyRaw(row));
}
function $4783b3c4a628f45b$export$fcd719b0119d4ab0(row, key) {
    if (key === 'qty_delta') {
        const n = $4783b3c4a628f45b$var$parseQtyDelta(row);
        return {
            text: $4783b3c4a628f45b$export$3d7a2d69182e565e(row?.qty_delta),
            tone: n < 0 ? 'out' : n > 0 ? 'in' : null
        };
    }
    if (key === 'balance_qty') {
        const n = $4783b3c4a628f45b$var$rowDisplayBalance(row);
        return {
            text: $4783b3c4a628f45b$export$3d7a2d69182e565e(n),
            tone: n < 0 ? 'out' : null
        };
    }
    return null;
}
function $4783b3c4a628f45b$var$locationIsAwaitingAddressing(loc) {
    const code = String(loc?.code ?? '').trim();
    const name = String(loc?.name ?? '').trim();
    return code.toUpperCase() === $4783b3c4a628f45b$export$3441ba3706a9c8cf || name.toUpperCase() === $4783b3c4a628f45b$export$3441ba3706a9c8cf;
}
function $4783b3c4a628f45b$export$b6c526396f55a8cb(locations) {
    const stagingIds = {};
    const awaitingIds = {};
    for (const loc of locations || []){
        if (!loc?.id) continue;
        const sid = String(loc.id);
        if (loc.is_staging) stagingIds[sid] = true;
        if ($4783b3c4a628f45b$var$locationIsAwaitingAddressing(loc)) awaitingIds[sid] = true;
    }
    return {
        stagingIds: stagingIds,
        awaitingIds: awaitingIds
    };
}
function $4783b3c4a628f45b$export$4d9662e377a77edb(locationId, stagingIds, awaitingIds) {
    if (locationId == null || locationId === '') return false;
    const lid = String(locationId);
    if (!stagingIds[lid]) return false;
    return !awaitingIds[lid];
}
function $4783b3c4a628f45b$var$primaryLocationId(row, isSource) {
    const flatKeys = isSource ? [
        'from_location_id',
        'source_location_id',
        'beginning_location_id',
        'origin_location_id',
        'fromLocationId',
        'sourceLocationId',
        'originLocationId',
        'locationSourceId'
    ] : [
        'to_location_id',
        'target_location_id',
        'end_location_id',
        'destination_location_id',
        'toLocationId',
        'targetLocationId',
        'destinationLocationId',
        'locationTargetId'
    ];
    for (const k of flatKeys){
        const v = row[k];
        if (v != null && String(v).trim() !== '') return String(v).trim();
    }
    const objKey = isSource ? 'source' : 'target';
    const o = row[objKey];
    if (o && typeof o === 'object') for (const ik of [
        'location_id',
        'locationId',
        'stock_location_id',
        'position_id',
        'id'
    ]){
        if (o[ik] != null && String(o[ik]).trim() !== '') return String(o[ik]).trim();
    }
    return null;
}
function $4783b3c4a628f45b$export$43e2019d7de8de73(rows, stagingIds, awaitingIds) {
    return (rows || []).filter((r)=>{
        const s = $4783b3c4a628f45b$var$primaryLocationId(r, true);
        const t = $4783b3c4a628f45b$var$primaryLocationId(r, false);
        if (!s || !t) return true;
        return !($4783b3c4a628f45b$export$4d9662e377a77edb(s, stagingIds, awaitingIds) && $4783b3c4a628f45b$export$4d9662e377a77edb(t, stagingIds, awaitingIds));
    });
}
function $4783b3c4a628f45b$var$locationAddressString(loc) {
    const addr = loc?.address;
    if (Array.isArray(addr)) {
        const parts = addr.map(String).map((p)=>p.trim()).filter(Boolean);
        return parts.length ? parts.join('-') : '';
    }
    if (typeof addr === 'string' && addr.trim()) return addr.trim();
    return '';
}
function $4783b3c4a628f45b$export$5829166a51a56def(locationId, locById, awaitingIds) {
    if (locationId == null || locationId === '') return "\u2014";
    const lid = String(locationId);
    if (awaitingIds[lid]) return $4783b3c4a628f45b$export$bb2f65263c9a11b7;
    const loc = locById[lid];
    if (!loc) return lid;
    const addr = $4783b3c4a628f45b$var$locationAddressString(loc);
    if (addr) return addr;
    const code = String(loc.code ?? '').trim();
    const name = String(loc.name ?? '').trim();
    if (code) return code;
    if (name) return name;
    return lid;
}
async function $4783b3c4a628f45b$export$1fa5187460609f25(companyId, listLocationsFn) {
    const fe = (0, $hWQyW.translate)({
        'field-0': 'company_id',
        'operator-0': 'eq',
        'value-0': companyId
    });
    const batch = 500;
    const all = [];
    async function fetchPageSilent(q) {
        if (listLocationsFn) {
            const chunk = await listLocationsFn(q);
            if (Array.isArray(chunk)) return chunk;
        }
        try {
            const res = await fetch(`${(0, $9VcS9.getSialApiHost)()}/locations${q}`, {
                method: 'GET',
                credentials: 'include'
            });
            if (!res.ok) return [];
            const data = await res.json();
            return Array.isArray(data) ? data : [];
        } catch  {
            return [];
        }
    }
    for(let offset = 0;; offset += batch){
        const q = `?filter=${encodeURIComponent(fe)}&limit=${batch}&offset=${offset}`;
        const chunk = await fetchPageSilent(q);
        if (!chunk.length) break;
        all.push(...chunk);
        if (chunk.length < batch) break;
    }
    const byId = {};
    for (const loc of all){
        if (!loc?.id) continue;
        byId[String(loc.id)] = loc;
    }
    const { stagingIds: stagingIds, awaitingIds: awaitingIds } = $4783b3c4a628f45b$export$b6c526396f55a8cb(all);
    const labels = {};
    for (const loc of all){
        if (loc?.id == null) continue;
        labels[String(loc.id)] = $4783b3c4a628f45b$export$5829166a51a56def(loc.id, byId, awaitingIds);
    }
    return {
        labels: labels,
        locations: all,
        awaitingIds: awaitingIds,
        stagingIds: stagingIds
    };
}
function $4783b3c4a628f45b$var$translateMovKind(k) {
    if (!k) return "\u2014";
    const s = String(k).trim();
    const low = s.toLowerCase();
    if ($4783b3c4a628f45b$export$35d7b145f10171ae[low]) return $4783b3c4a628f45b$export$35d7b145f10171ae[low];
    return s.replace(/_/g, ' ').replace(/\b\w/g, (ch)=>ch.toUpperCase());
}
function $4783b3c4a628f45b$var$fmtLote(row) {
    if (!row) return "\u2014";
    for (const k of [
        'batch_number',
        'batch',
        'lot_code',
        'lot_label',
        'lot_number'
    ]){
        const v = row[k];
        if (v != null && String(v).trim() !== '') return String(v).trim();
    }
    if (row.lot?.lot_number) return String(row.lot.lot_number).trim();
    const lid = row.lot_id;
    if (lid != null && lid !== '' && /^\d{1,12}$/.test(String(lid))) return String(lid);
    return "\u2014";
}
function $4783b3c4a628f45b$var$tipoFlow(row) {
    const a = String(row?.source_type ?? '').trim().charAt(0).toUpperCase();
    const b = String(row?.target_type ?? '').trim().charAt(0).toUpperCase();
    if (!a && !b) return "\u2014";
    if (!a) return b;
    if (!b) return a;
    return `${a} -> ${b}`;
}
function $4783b3c4a628f45b$var$isGarbageMetadataObject(o) {
    if (!o || typeof o !== 'object' || Array.isArray(o)) return true;
    const keys = Object.keys(o);
    if (!keys.length) return true;
    const hasPoint = [
        'location_id',
        'locationId',
        'warehouse_id',
        'input_id',
        'output_id',
        'display_name',
        'name',
        'label',
        'position_label'
    ].some((k)=>o[k] != null && String(o[k]).trim() !== '');
    return !hasPoint && keys.every((k)=>[
            'reason',
            'replenishment_id',
            'inventory_id',
            'company_id'
        ].includes(k));
}
function $4783b3c4a628f45b$var$fmtEndpointObject(o) {
    if (!o || typeof o !== 'object' || $4783b3c4a628f45b$var$isGarbageMetadataObject(o)) return '';
    for (const p of [
        'display_name',
        'name',
        'label',
        'position_label',
        'reference',
        'code',
        'title'
    ]){
        if (o[p] != null && String(o[p]).trim() !== '') return String(o[p]).trim();
    }
    return '';
}
function $4783b3c4a628f45b$var$mergePointExtra(base, extra) {
    const e = String(extra ?? '').trim();
    if (!e) return base;
    const b = String(base ?? '').trim();
    if (!b || b === "\u2014") return e;
    if (b.includes(e)) return b;
    return `${e} \xb7 ${b}`;
}
function $4783b3c4a628f45b$var$fmtStockPoint(row, role, labelMap) {
    if (!row) return "\u2014";
    const isSource = role === 'source';
    const apiLabel = String(row[isSource ? 'source_label' : 'target_label'] ?? '').trim();
    const flatIdKeys = isSource ? [
        'source_id',
        'source_location_id',
        'from_location_id',
        'origin_location_id',
        'fromLocationId',
        'sourceLocationId'
    ] : [
        'target_id',
        'target_location_id',
        'to_location_id',
        'destination_location_id',
        'toLocationId',
        'targetLocationId'
    ];
    let id = $4783b3c4a628f45b$var$primaryLocationId(row, isSource) || '';
    if (!id) for (const fk of flatIdKeys){
        const v = row[fk];
        if (v != null && String(v).trim() !== '') {
            id = String(v).trim();
            break;
        }
    }
    const o = $4783b3c4a628f45b$var$endpointObj(row, role);
    if (!id && o?.id != null) id = String(o.id).trim();
    const lb = id && labelMap?.[id] ? labelMap[id] : '';
    const objLabel = $4783b3c4a628f45b$var$fmtEndpointObject(o);
    let out = "\u2014";
    if (apiLabel && apiLabel !== "\u2014") out = apiLabel;
    else if (id && lb) out = lb;
    else if (objLabel) out = objLabel;
    else if (id && lb) out = `ID ${id} \xb7 ${lb}`;
    else if (id) out = `ID ${id}`;
    else if (lb) out = lb;
    const extra = isSource ? String(row._sialbi_origem_extra ?? '').trim() : String(row._sialbi_destino_extra ?? '').trim();
    return $4783b3c4a628f45b$var$mergePointExtra(out, extra);
}
function $4783b3c4a628f45b$var$endpointObj(row, role) {
    let o = role === 'source' ? row?.source : row?.target;
    if (typeof o === 'string') try {
        o = JSON.parse(o);
    } catch  {
        o = null;
    }
    return o && typeof o === 'object' ? o : null;
}
function $4783b3c4a628f45b$var$extractEntradaNfFromLabel(label) {
    const s = String(label ?? '').trim();
    const m = s.match(/^Entrada\s*·\s*NF\s+(.+)$/i);
    return m ? m[1].trim() : '';
}
function $4783b3c4a628f45b$var$extractSaidaRefFromLabel(label) {
    const s = String(label ?? '').trim();
    const m = s.match(/Saída\s*·\s*(.+)$/i) || s.match(/Saida\s*·\s*(.+)$/i);
    if (!m) return '';
    const ref = m[1].trim();
    return ref && ref.toLowerCase() !== "sa\xedda" && ref.toLowerCase() !== 'saida' ? ref : '';
}
function $4783b3c4a628f45b$var$fmtNfEntrada(row) {
    const bi = String(row?._sialbi_nf_entrada ?? row?.nf_entrada ?? '').trim();
    if (bi) return bi;
    const st = String(row?.source_type ?? '').toUpperCase();
    const tt = String(row?.target_type ?? '').toUpperCase();
    if (st === 'I') {
        const fromLabel = $4783b3c4a628f45b$var$extractEntradaNfFromLabel(row?.source_label);
        if (fromLabel) return fromLabel;
    }
    if (tt === 'I') {
        const fromLabel = $4783b3c4a628f45b$var$extractEntradaNfFromLabel(row?.target_label);
        if (fromLabel) return fromLabel;
    }
    for (const k of [
        'invoice_number',
        'nf_number',
        'nfe_number',
        'document_number',
        'numero_nf'
    ]){
        const v = row?.[k];
        if (v != null && String(v).trim() !== '') return String(v).trim();
    }
    for (const role of [
        'source',
        'target'
    ]){
        const o = $4783b3c4a628f45b$var$endpointObj(row, role);
        const iid = o?.input_id;
        if (iid != null && String(iid).trim() !== '') return `Entrada #${iid}`;
    }
    const iid = row?.input_id ?? $4783b3c4a628f45b$var$endpointObj(row, 'source')?.input_id;
    if (iid) return `Entrada #${iid}`;
    return "\u2014";
}
function $4783b3c4a628f45b$var$fmtReqHis(row) {
    const bi = String(row?._sialbi_requisicao_his ?? row?.requisicao_his ?? '').trim();
    if (bi) return bi;
    const st = String(row?.source_type ?? '').toUpperCase();
    const tt = String(row?.target_type ?? '').toUpperCase();
    if (st === 'R') {
        const ref = $4783b3c4a628f45b$var$extractSaidaRefFromLabel(row?.source_label);
        if (ref) return ref;
    }
    if (tt === 'O') {
        const ref = $4783b3c4a628f45b$var$extractSaidaRefFromLabel(row?.target_label);
        if (ref) return ref;
    }
    for (const k of [
        'reference',
        'customer_reference',
        'his_number',
        'requisition_number',
        'order_reference'
    ]){
        const v = row?.[k];
        if (v != null && String(v).trim() !== '') return String(v).trim();
    }
    for (const role of [
        'source',
        'target'
    ]){
        const o = $4783b3c4a628f45b$var$endpointObj(row, role);
        const oid = o?.output_id;
        if (oid != null && String(oid).trim() !== '') return `Sa\xedda #${oid}`;
    }
    return "\u2014";
}
function $4783b3c4a628f45b$var$fmtBloqueio(row) {
    const v = row?._sialbi_bloqueio_motivo ?? row?.bloqueio_motivo ?? row?.movement_reason;
    return v != null && String(v).trim() !== '' ? String(v).trim() : "\u2014";
}
function $4783b3c4a628f45b$var$fmtLoteAtendido(row) {
    const bi = String(row?._sialbi_lote_atendido ?? '').trim();
    if (bi) return bi;
    return "\u2014";
}
function $4783b3c4a628f45b$export$3f0ae574393da7cf(row, key, rowNum, labelMap, { html: html = false } = {}) {
    if (key === '__num') return String(rowNum);
    if (key === '__nf_entrada_html') return `<span class="kdx-kardex-destaque kdx-kardex-nf">${$4783b3c4a628f45b$var$escHtml($4783b3c4a628f45b$var$fmtNfEntrada(row))}</span>`;
    if (key === '__req_his_html') return `<span class="kdx-kardex-destaque kdx-kardex-his">${$4783b3c4a628f45b$var$escHtml($4783b3c4a628f45b$var$fmtReqHis(row))}</span>`;
    if (key === '__nf_entrada') return $4783b3c4a628f45b$var$fmtNfEntrada(row);
    if (key === '__req_his') return $4783b3c4a628f45b$var$fmtReqHis(row);
    if (key === '__lote') return $4783b3c4a628f45b$var$fmtLote(row);
    if (key === '__lote_atendido') return $4783b3c4a628f45b$var$fmtLoteAtendido(row);
    if (key === '__tipo') return $4783b3c4a628f45b$var$tipoFlow(row);
    if (key === '__bloqueio_motivo' || key === '__bloqueio_motivo_html') return $4783b3c4a628f45b$var$fmtBloqueio(row);
    if (key === '__valor_sinal') {
        const vs = row?.value_signed;
        return vs == null || vs === '' ? "\u2014" : $4783b3c4a628f45b$export$e63787c689315163(vs);
    }
    if (key === 'qty_delta') return $4783b3c4a628f45b$export$3d7a2d69182e565e(row?.qty_delta);
    if (key === 'balance_qty') return $4783b3c4a628f45b$export$3d7a2d69182e565e($4783b3c4a628f45b$var$rowDisplayBalance(row));
    if (key === 'date_time') return $4783b3c4a628f45b$export$a8be67f60e9fba44(row?.date_time);
    if (key === 'movement_kind') return $4783b3c4a628f45b$var$translateMovKind(row?.movement_kind);
    if (key === 'source' || key === 'target') return $4783b3c4a628f45b$var$fmtStockPoint(row, key, labelMap);
    if (key === 'quantity' || key === 'qty_delta') return $4783b3c4a628f45b$export$3d7a2d69182e565e(row?.[key]);
    if (key === 'balance_value' || key === 'value_signed') return $4783b3c4a628f45b$export$e63787c689315163(row?.[key]);
    return row?.[key] == null ? "\u2014" : String(row[key]);
}
function $4783b3c4a628f45b$export$46f883db0563aa8f(row, col, rowNum, labelMap) {
    if (!col) return '';
    const k = col.key;
    if (k.endsWith('_html')) {
        const plainKey = k.replace(/_html$/, '');
        return $4783b3c4a628f45b$export$3f0ae574393da7cf(row, plainKey === '__nf_entrada' ? '__nf_entrada' : plainKey === '__req_his' ? '__req_his' : '__bloqueio_motivo', rowNum, labelMap);
    }
    if (k === 'qty_delta') return $4783b3c4a628f45b$export$3f0ae574393da7cf(row, 'qty_delta', rowNum, labelMap);
    return $4783b3c4a628f45b$export$3f0ae574393da7cf(row, k, rowNum, labelMap);
}
function $4783b3c4a628f45b$var$referenceFromOrderLike(rec) {
    for (const k of [
        'reference',
        'order_reference',
        'external_reference',
        'customer_reference',
        'client_reference',
        'buyer_reference',
        'his_number',
        'requisition_number'
    ]){
        const v = String(rec?.[k] ?? '').trim();
        if (v) return v;
    }
    return '';
}
function $4783b3c4a628f45b$var$collectIdsFromRow(node, inputIds, outputIds, ooIds, depth = 0) {
    if (depth > 18 || !node || typeof node !== 'object') return;
    for (const [k, v] of Object.entries(node)){
        if (Array.isArray(v)) {
            for (const item of v)$4783b3c4a628f45b$var$collectIdsFromRow(item, inputIds, outputIds, ooIds, depth + 1);
            continue;
        }
        if (v && typeof v === 'object') {
            const kl = k.toLowerCase();
            if (kl === 'output' && v.id) outputIds.add(Number(v.id));
            if ((kl === 'input' || kl === 'entrada') && v.id) inputIds.add(Number(v.id));
            if (kl.includes('output_order') && v.id) ooIds.add(Number(v.id));
            $4783b3c4a628f45b$var$collectIdsFromRow(v, inputIds, outputIds, ooIds, depth + 1);
            continue;
        }
        const id = parseInt(v, 10);
        if (!id) continue;
        const kl = k.toLowerCase();
        if (/output_order/.test(kl)) ooIds.add(id);
        else if (/output_id|saida_id|outputid/.test(kl)) outputIds.add(id);
        else if (/input_id|entrada_id|inputid|nf_entrada/.test(kl)) inputIds.add(id);
    }
}
async function $4783b3c4a628f45b$var$fetchListSilent(path, query) {
    try {
        const res = await fetch(`${(0, $9VcS9.getSialApiHost)()}${path}${query}`, {
            method: 'GET',
            credentials: 'include'
        });
        if (!res.ok) return [];
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch  {
        return [];
    }
}
async function $4783b3c4a628f45b$var$fetchEntitiesByIds(listFn, ids, companyId, endpoint) {
    const byId = {};
    const unique = [
        ...new Set(ids.filter((i)=>i > 0))
    ];
    for(let i = 0; i < unique.length; i += 12){
        const chunk = unique.slice(i, i + 12);
        const f = `company_id*eq*${companyId},${chunk.map((id)=>`id*eq*${id}`).join(';')}`;
        const q = `?limit=50&filter=${encodeURIComponent(f)}`;
        let rows;
        try {
            rows = listFn ? await listFn(q) : await $4783b3c4a628f45b$var$fetchListSilent(`/${endpoint}`, q);
        } catch  {
            rows = endpoint ? await $4783b3c4a628f45b$var$fetchListSilent(`/${endpoint}`, q) : [];
        }
        if (!Array.isArray(rows)) rows = endpoint ? await $4783b3c4a628f45b$var$fetchListSilent(`/${endpoint}`, q) : [];
        for (const row of rows)if (row?.id) byId[String(row.id)] = row;
    }
    return byId;
}
function $4783b3c4a628f45b$var$entityContainsProduct(entity, productId) {
    const pid = parseInt(productId, 10);
    if (!pid || !Array.isArray(entity?.items) || !entity.items.length) return true;
    return entity.items.some((item)=>Number(item?.product_id) === pid);
}
function $4783b3c4a628f45b$var$applyRowEnrichment(row, inputById, outputById, ooById, productId) {
    const pid = parseInt(productId, 10);
    const mk = $4783b3c4a628f45b$var$movementKindLower(row);
    const st = String(row.source_type ?? '').toUpperCase();
    const tt = String(row.target_type ?? '').toUpperCase();
    const isEntrada = mk.includes('entrada') || st === 'I';
    const isSaida = mk.includes('baixa') || mk.includes('saida') || mk.includes("sa\xedda") || tt === 'O';
    const reservaOuSep = mk.includes('reserva') || mk.includes('picking');
    const inputIds = new Set();
    const outputIds = new Set();
    const ooIds = new Set();
    $4783b3c4a628f45b$var$collectIdsFromRow(row, inputIds, outputIds, ooIds);
    const orderedInputIds = [
        ...inputIds
    ].map(Number).filter(Boolean);
    const orderedOutputIds = [
        ...outputIds
    ].map(Number).filter(Boolean);
    const orderedOoIds = [
        ...ooIds
    ].map(Number).filter(Boolean);
    if (isEntrada && !row.nf_entrada && !row._sialbi_nf_entrada) {
        for (const iid of orderedInputIds){
            const inp = inputById[String(iid)];
            if (inp && !$4783b3c4a628f45b$var$entityContainsProduct(inp, pid)) continue;
            if (inp) {
                const inv = String(inp.invoice_number ?? inp.document_number ?? inp.nf_number ?? '').trim();
                row._sialbi_nf_entrada = inv || `Entrada #${iid}`;
                row._sialbi_origem_extra = inv ? `Entrada #${iid} \xb7 NF ${inv}` : row._sialbi_nf_entrada;
            } else {
                row._sialbi_nf_entrada = `Entrada #${iid}`;
                row._sialbi_origem_extra = row._sialbi_nf_entrada;
            }
            break;
        }
        if (!row._sialbi_nf_entrada) {
            const fromLabel = $4783b3c4a628f45b$var$extractEntradaNfFromLabel(row?.source_label) || $4783b3c4a628f45b$var$extractEntradaNfFromLabel(row?.target_label);
            if (fromLabel) row._sialbi_nf_entrada = fromLabel;
        }
    }
    for (const oid of orderedOutputIds){
        const out = outputById[String(oid)];
        if (!out || !$4783b3c4a628f45b$var$entityContainsProduct(out, pid)) continue;
        const ref = $4783b3c4a628f45b$var$referenceFromOrderLike(out);
        if ((isSaida || reservaOuSep) && !row.requisicao_his && !row._sialbi_requisicao_his) {
            row._sialbi_requisicao_his = ref || `Sa\xedda #${oid}`;
            row._sialbi_destino_extra = `Sa\xedda #${oid}${ref ? ` \xb7 ${ref}` : ''}`;
        }
        if (isSaida && Array.isArray(out.items)) {
            const it = out.items.find((x)=>!pid || Number(x.product_id) === pid);
            if (it?.lot_number) row._sialbi_lote_atendido = String(it.lot_number).trim();
        }
        break;
    }
    if (!row._sialbi_requisicao_his && (isSaida || reservaOuSep)) {
        for (const ooId of orderedOoIds){
            const oo = ooById[String(ooId)];
            if (!oo || !$4783b3c4a628f45b$var$entityContainsProduct(oo, pid)) continue;
            const ref = $4783b3c4a628f45b$var$referenceFromOrderLike(oo);
            row._sialbi_requisicao_his = ref || `Pedido #${ooId}`;
            break;
        }
        if (!row._sialbi_requisicao_his) {
            const ref = $4783b3c4a628f45b$var$extractSaidaRefFromLabel(row?.source_label) || $4783b3c4a628f45b$var$extractSaidaRefFromLabel(row?.target_label);
            if (ref) row._sialbi_requisicao_his = ref;
            else {
                const oid = $4783b3c4a628f45b$var$endpointObj(row, 'source')?.output_id ?? $4783b3c4a628f45b$var$endpointObj(row, 'target')?.output_id;
                if (oid) row._sialbi_requisicao_his = `Sa\xedda #${oid}`;
            }
        }
    }
    if ((mk.includes('bloqueio') || mk.includes('bloquear')) && !row._sialbi_bloqueio_motivo) for (const bk of [
        'block_reason',
        'motivo_bloqueio',
        'reason',
        'motivo'
    ]){
        const v = String(row[bk] ?? '').trim();
        if (v) {
            row._sialbi_bloqueio_motivo = v;
            break;
        }
    }
}
async function $4783b3c4a628f45b$export$3a08e86f124740dc(rows, companyId, productId, { listInputs: listInputs, listOutputs: listOutputs, listOutputOrders: listOutputOrders }) {
    if (!rows?.length) return;
    const inputIds = new Set();
    const outputIds = new Set();
    const ooIds = new Set();
    for (const r of rows)$4783b3c4a628f45b$var$collectIdsFromRow(r, inputIds, outputIds, ooIds);
    const [inputById, outputById, ooById] = await Promise.all([
        $4783b3c4a628f45b$var$fetchEntitiesByIds(listInputs, [
            ...inputIds
        ], companyId, 'inputs'),
        $4783b3c4a628f45b$var$fetchEntitiesByIds(listOutputs, [
            ...outputIds
        ], companyId, 'outputs'),
        $4783b3c4a628f45b$var$fetchEntitiesByIds(listOutputOrders, [
            ...ooIds
        ], companyId, 'output-orders')
    ]);
    for (const r of rows)$4783b3c4a628f45b$var$applyRowEnrichment(r, inputById, outputById, ooById, productId);
}
function $4783b3c4a628f45b$var$stockDedupeKey(s) {
    if (s?.id != null && String(s.id).trim() !== '') return `id:${s.id}`;
    return `lot:${s.lot_id ?? ''}|loc:${s.location_id ?? ''}|wh:${s.warehouse_id ?? ''}`;
}
async function $4783b3c4a628f45b$var$mergeStocksFilter(companyId, filter, listStocksFn, byKey, maxPages = 40) {
    let offset = 0;
    const limit = 500;
    for(let p = 0; p < maxPages; p++){
        const q = `?sort=1&limit=${limit}&offset=${offset}&filter=${encodeURIComponent(filter)}`;
        const chunk = await listStocksFn(q);
        if (!Array.isArray(chunk) || !chunk.length) break;
        for (const s of chunk){
            if (!s || typeof s !== 'object') continue;
            const rowCid = String(s.company_id ?? '').trim();
            if (rowCid && rowCid !== companyId) continue;
            byKey[$4783b3c4a628f45b$var$stockDedupeKey(s)] = s;
        }
        if (chunk.length < limit) break;
        offset += limit;
    }
}
async function $4783b3c4a628f45b$var$lotIdsForProduct(companyId, productId, listLotsFn) {
    const seen = new Set();
    let offset = 0;
    const limit = 500;
    const f = `company_id*eq*${companyId},product_id*eq*${productId}`;
    for(let page = 0; page < 80; page++){
        const q = `?sort=1&limit=${limit}&offset=${offset}&filter=${encodeURIComponent(f)}`;
        const chunk = await listLotsFn(q);
        if (!Array.isArray(chunk) || !chunk.length) break;
        for (const lot of chunk)if (lot?.id != null) seen.add(String(lot.id));
        if (chunk.length < limit) break;
        offset += limit;
    }
    return [
        ...seen
    ];
}
async function $4783b3c4a628f45b$export$69202fa12ff4552(companyId, productId, { listStocks: listStocks, listLots: listLots }) {
    const byKey = {};
    await $4783b3c4a628f45b$var$mergeStocksFilter(companyId, `company_id*eq*${companyId},product_id*eq*${productId}`, listStocks, byKey);
    const lotIds = await $4783b3c4a628f45b$var$lotIdsForProduct(companyId, productId, listLots);
    for(let i = 0; i < lotIds.length; i += 28){
        const chunk = lotIds.slice(i, i + 28);
        const parts = chunk.map((lid)=>`lot_id*eq*${lid}`).join(';');
        await $4783b3c4a628f45b$var$mergeStocksFilter(companyId, `company_id*eq*${companyId},${parts}`, listStocks, byKey);
    }
    let livre = 0;
    let bloq = 0;
    let total = 0;
    for (const s of Object.values(byKey)){
        const qa = Number(s.quantity_available) || 0;
        const qr = Number(s.quantity_reserved) || 0;
        const qu = Number(s.quantity_unsettled) || 0;
        if (qa <= 0 && qr <= 0 && qu <= 0) continue;
        livre += qa;
        bloq += qu;
        total += qa + qr + qu;
    }
    return {
        qty_livre: livre,
        qty_bloqueado: bloq,
        qty_total: total
    };
}
function $4783b3c4a628f45b$export$eeb2bd00ce2d0988(summary, { companyName: companyName, productLabel: productLabel, dateFimInclusive: dateFimInclusive } = {}) {
    if (!summary || typeof summary !== 'object') return [];
    const items = [];
    const add = (label, value)=>{
        if (value === null || value === undefined || value === '') return;
        items.push({
            label: label,
            value: String(value)
        });
    };
    if (companyName) add('Empresa', companyName);
    if (productLabel) add('Produto', productLabel);
    if (summary.date_from != null) add("Data inicial do per\xedodo", $4783b3c4a628f45b$export$e69a9da2fc3aa0ca(summary.date_from));
    if (dateFimInclusive) add("Data final do per\xedodo (inclusiva)", $4783b3c4a628f45b$export$e69a9da2fc3aa0ca(dateFimInclusive));
    else if (summary.date_to_exclusive != null) add("Data final do per\xedodo", $4783b3c4a628f45b$export$e69a9da2fc3aa0ca(summary.date_to_exclusive));
    const keys = [
        [
            'period_entries_qty',
            "Entradas no per\xedodo (un.)"
        ],
        [
            'period_exits_qty',
            "Sa\xeddas / consumos no per\xedodo (un.)"
        ],
        [
            'line_count',
            'Linhas no extrato'
        ],
        [
            'opening_qty',
            "Saldo no in\xedcio do per\xedodo"
        ],
        [
            'closing_qty',
            "Saldo ao fim do per\xedodo"
        ]
    ];
    for (const [k, label] of keys)if (summary[k] != null && summary[k] !== '') add(label, $4783b3c4a628f45b$export$3d7a2d69182e565e(summary[k]));
    return items;
}
function $4783b3c4a628f45b$export$422e4c802fb8adea(colKey) {
    return $4783b3c4a628f45b$var$KDX_REF_COL_KEYS.has(colKey) ? 'kx-cell-ref' : '';
}



const $f56259f2fdff9c56$var$KDX_PAGE_LIMIT = 300;
const $f56259f2fdff9c56$var$KDX_FETCH_CHUNK = 200;
function $f56259f2fdff9c56$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $f56259f2fdff9c56$var$esc(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $f56259f2fdff9c56$var$buildQuery(params) {
    const sp = new URLSearchParams();
    for (const [k, v] of Object.entries(params)){
        if (v === undefined || v === null || v === '') continue;
        sp.set(k, String(v));
    }
    return sp.toString();
}
function $f56259f2fdff9c56$var$skuLabel(p) {
    if (!p?.sku) return '';
    return Array.isArray(p.sku) ? p.sku.join('') : String(p.sku);
}
async function $f56259f2fdff9c56$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    const list = await res.json();
    if (!Array.isArray(list)) {
        (0, $jUNyh.notify)('Lista de empresas em formato inesperado.', 'Empresas');
        return;
    }
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
/**
 * Busca produtos na API SIAL (operadores válidos: co/bw/eq — não existe sw).
 * Paridade com portal: termo no SKU, nome ou id.
 */ async function $f56259f2fdff9c56$var$searchProducts(companyId, term) {
    const needle = String(term || '').trim();
    if (!companyId || !needle) return [];
    const base = {
        'field-0': 'company_id',
        'operator-0': 'eq',
        'value-0': companyId,
        'connector-1': 'e'
    };
    const filters = [
        (0, $hWQyW.translate)({
            ...base,
            'field-1': 'name',
            'operator-1': 'co',
            'value-1': needle
        }),
        (0, $hWQyW.translate)({
            ...base,
            'field-1': 'sku',
            'operator-1': 'co',
            'value-1': needle
        })
    ];
    if (/^\d+$/.test(needle)) {
        filters.unshift((0, $hWQyW.translate)({
            ...base,
            'field-1': 'sku',
            'operator-1': 'eq',
            'value-1': needle
        }));
        // id interno costuma ser curto; SKU numérico longo não deve filtrar por id
        if (needle.length <= 7) filters.unshift((0, $hWQyW.translate)({
            ...base,
            'field-1': 'id',
            'operator-1': 'eq',
            'value-1': needle
        }));
    }
    const seen = new Set();
    const out = [];
    for (const fe of filters){
        const q = `?filter=${encodeURIComponent(fe)}&limit=20&include_disabled=1`;
        try {
            const rows = await (0, $9VcS9.default).call((0, $9VcS9.default).list_products, q);
            if (!Array.isArray(rows)) continue;
            for (const p of rows){
                if (p?.id == null || seen.has(p.id)) continue;
                seen.add(p.id);
                out.push(p);
            }
            if (out.length >= 20) break;
        } catch (e) {
            console.warn('Kardex busca produto', e);
        }
    }
    return out;
}
async function $f56259f2fdff9c56$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.kdx-wrap { max-width: 96rem; margin: 0 auto; }
			.kdx-header { background: #1e3a5f; color: #fff; padding: 14px 18px; border-radius: 0 0 10px 10px; margin-bottom: 1rem; }
			.kdx-header h1 { font-size: 1.15rem; margin: 0; }
			.kdx-header .sub { font-size: 0.8rem; opacity: 0.92; margin-top: 4px; }
			.kdx-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px; margin-bottom: 1rem; box-shadow: 0 1px 3px rgba(0,0,0,0.06); }
			.kdx-filter-title { font-size: 0.7rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; margin-bottom: 8px; }
			.kdx-filters { display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: flex-end; }
			.kdx-filters label { display: flex; flex-direction: column; font-size: 0.85rem; gap: 2px; }
			.kdx-filters input, .kdx-filters select { padding: 4px 8px; font-size: 0.85rem; min-height: 2rem; }
			.kdx-prod-pick { max-height: 220px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px; margin-top: 4px; display: none; }
			.kdx-prod-pick button { display: block; width: 100%; text-align: left; border: 0; border-bottom: 1px solid #f1f5f9; padding: 8px 12px; background: #fff; cursor: pointer; font-size: 0.85rem; }
			.kdx-prod-pick button:hover { background: #f0f9ff; }
			.kdx-qty-in { color: #047857; font-weight: 700; }
			.kdx-qty-out { color: #c2410c; font-weight: 700; }
			#workarea table.kdx-table td.kdx-qty-in,
			#workarea table.kdx-table td.kdx-qty-out {
				font-size: inherit;
				font-variant-numeric: tabular-nums;
			}
			#workarea table.kdx-table td.kdx-kardex-nf { color: #0369a1; font-weight: 600; }
			#workarea table.kdx-table td.kdx-kardex-his { color: #b45309; font-weight: 600; }
			.kdx-legenda { font-size: 0.78rem; color: #475569; background: #f1f5f9; border-radius: 8px; padding: 10px 12px; border: 1px solid #e2e8f0; margin-top: 10px; line-height: 1.45; }
			.kdx-alert { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; padding: 8px 12px; border-radius: 8px; margin-bottom: 1rem; display: none; }
			.kdx-actions { display: flex; gap: 0.5rem; flex-wrap: wrap; align-items: center; margin-top: 0.75rem; }
			.kdx-meta { font-size: 0.8rem; color: #64748b; padding: 10px 14px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; flex-wrap: wrap; gap: 8px; background: #fafafa; }
		</style>
		<div class="kdx-wrap">
			<div class="kdx-header">
				<h1>Kardex / Movimenta\xe7\xf5es</h1>
				<div class="sub">Extrato no per\xedodo \xb7 saldo na grade \xe9 acumulado no per\xedodo (n\xe3o \xe9 estoque f\xedsico de hoje \u{2014} ver rodap\xe9 \xabEstoque atual\xbb).</div>
			</div>
			<div class="kdx-card">
				<div class="kdx-filter-title">Filtros</div>
				<div class="kdx-filters">
					<label style="min-width:14rem">Empresa<sup>*</sup><select id="kdx-company"></select></label>
					<label style="min-width:16rem">C\xf3digo item / descri\xe7\xe3o
						<div style="display:flex;gap:4px">
							<input type="search" id="kdx-busca-prod" placeholder="Digite e busque\u{2026}" autocomplete="off">
							<button type="button" class="button" id="kdx-btn-buscar-prod">Buscar</button>
						</div>
					</label>
					<label>Data inicial<sup>*</sup><input type="date" id="kdx-df"></label>
					<label>Data final (inclui)<sup>*</sup><input type="date" id="kdx-dt"></label>
					<label>Lote (opcional)<input type="text" id="kdx-lot" placeholder="Filtrar por lote"></label>
					<label>Valores
						<select id="kdx-cost">
							<option value="none" selected>Sem valores monet\xe1rios</option>
							<option value="transaction">Valores por movimento</option>
						</select>
					</label>
					<label style="align-self:center"><input type="checkbox" id="kdx-dis" checked> Incluir movimentos desabilitados</label>
					<label style="align-self:center"><input type="checkbox" id="kdx-vista-cliente"> Vista cliente (extrato simplificado)</label>
					<button type="button" class="button" id="kdx-consultar">Consultar</button>
				</div>
				<div id="kdx-prod-pick" class="kdx-prod-pick"></div>
				<div id="kdx-prod-sel" class="mts" style="color:#0369a1;font-weight:600"></div>
				<input type="hidden" id="kdx-product-id" value="">
				<div class="kdx-legenda" id="kdx-legenda"></div>
			</div>
			<div id="kdx-alert" class="kdx-alert"></div>
			<div id="kdx-summary" class="kdx-summary" style="display:none"></div>
			<div class="kdx-card" style="padding:0">
				<div class="kdx-meta">
					<span>Gerado em <strong id="kdx-gerado">\u{2014}</strong> \xb7 <span id="kdx-rows-meta"></span></span>
					<span id="kdx-pager" style="display:none">
						<button type="button" class="button" id="kdx-prev" disabled>Anterior</button>
						<button type="button" class="button" id="kdx-next" disabled>Pr\xf3xima</button>
					</span>
				</div>
				<div class="kdx-table-scroll">
					<table class="kardex-table kdx-table" id="kdx-table">
						<thead><tr><th colspan="20" style="color:#64748b;background:#f8fafc;font-weight:500">Use \xabConsultar\xbb para carregar o extrato</th></tr></thead>
						<tbody></tbody>
					</table>
				</div>
			</div>
			<div id="kdx-stock-footer" class="kdx-card" style="display:none">
				<div class="kdx-filter-title">Estoque atual do produto <span style="font-weight:normal;color:#64748b">(livre + bloqueado)</span></div>
				<p class="mts" style="font-size:0.8rem;color:#64748b">Fonte: API <code>/stocks</code> \u{2014} deve coincidir com \xabSaldo ao fim do per\xedodo\xbb e \xfaltima linha do extrato.</p>
				<div class="kdx-summary" id="kdx-stock-kpis"></div>
			</div>
			<div class="kdx-actions">
				<button type="button" class="button" id="kdx-pdf" disabled>PDF</button>
				<button type="button" class="button" id="kdx-csv" disabled>CSV</button>
			</div>
		</div>
	`;
    const state = {
        companyId: '',
        companyName: '',
        productId: '',
        productLabel: '',
        offset: 0,
        total: null,
        lastSummary: null,
        lastStock: null,
        labelMap: {},
        locations: [],
        stagingIds: {},
        awaitingIds: {}
    };
    function defaultDates() {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        $f56259f2fdff9c56$var$$('#kdx-dt', work).value = `${y}-${m}-${d}`;
        $f56259f2fdff9c56$var$$('#kdx-df', work).value = `${y}-${m}-01`;
    }
    function syncLegenda() {
        const vista = $f56259f2fdff9c56$var$$('#kdx-vista-cliente', work).checked;
        const pager = $f56259f2fdff9c56$var$$('#kdx-pager', work);
        if (pager) pager.style.display = vista ? 'none' : '';
        const leg = $f56259f2fdff9c56$var$$('#kdx-legenda', work);
        if (!leg) return;
        leg.innerHTML = vista ? "<strong>Vista cliente</strong> \u2014 extrato simplificado com NF na entrada e ref. cliente nas sa\xeddas. Oculta transfer\xeancias internas, reserva na posi\xe7\xe3o e estornos. Saldo recalculado no per\xedodo completo." : '<strong>Vista completa</strong> \u2014 NF entrada, ref. cliente/HIS, bloqueio, lote atendido. Oculta endere\xe7amento cancelado/estorno de entrada e movimentos s\xf3 entre staging gen\xe9rico. Pagina\xe7\xe3o de at\xe9 300 linhas.<div style="margin-top:8px"><strong>Fluxo (origem\u2192destino):</strong> <strong>I</strong> Entrada \xb7 <strong>L</strong> Lote \xb7 <strong>R</strong> Ressuprimento \xb7 <strong>O</strong> Sa\xedda \xb7 <strong>B</strong> Ajuste. Ex.: L \u2192 R = lote para picking.</div>';
    }
    function showErr(msg) {
        const el = $f56259f2fdff9c56$var$$('#kdx-alert', work);
        el.textContent = msg;
        el.style.display = msg ? '' : 'none';
        if (msg) el.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
        });
    }
    function findExactSkuMatch(products, term) {
        const n = String(term || '').trim();
        if (!n) return null;
        return products.find((p)=>{
            if (!p?.sku) return false;
            const skus = Array.isArray(p.sku) ? p.sku : [
                p.sku
            ];
            return skus.some((s)=>String(s) === n);
        }) || null;
    }
    function applyProductSelection(p, { hidePick: hidePick = true } = {}) {
        const sku = $f56259f2fdff9c56$var$skuLabel(p);
        $f56259f2fdff9c56$var$$('#kdx-product-id', work).value = String(p.id);
        state.productId = String(p.id);
        state.productLabel = `${sku} \u{2014} ${p.name || ''}`;
        $f56259f2fdff9c56$var$$('#kdx-prod-sel', work).textContent = `Selecionado: ${state.productLabel}`;
        if (hidePick) $f56259f2fdff9c56$var$$('#kdx-prod-pick', work).style.display = 'none';
    }
    function renderPickList(products) {
        const box = $f56259f2fdff9c56$var$$('#kdx-prod-pick', work);
        box.replaceChildren();
        if (!products.length) {
            box.innerHTML = '<div style="padding:8px;color:#64748b;font-size:0.85rem">Nenhum produto encontrado.</div>';
            box.style.display = '';
            return;
        }
        const hint = document.createElement('div');
        hint.style.cssText = 'padding:6px 12px;font-size:0.78rem;color:#64748b;background:#f8fafc;border-bottom:1px solid #e2e8f0';
        hint.textContent = products.length === 1 ? "Um produto encontrado \u2014 clique para confirmar ou use \xabConsultar\xbb." : `${products.length} produtos \u{2014} clique no item correto.`;
        box.appendChild(hint);
        for (const p of products){
            const b = document.createElement('button');
            const sku = $f56259f2fdff9c56$var$skuLabel(p);
            b.innerHTML = `<strong>${$f56259f2fdff9c56$var$esc(sku)}</strong> \xb7 ${$f56259f2fdff9c56$var$esc(p.name || '')}`;
            b.addEventListener('click', ()=>applyProductSelection(p));
            box.appendChild(b);
        }
        box.style.display = '';
    }
    async function resolveProductSelection() {
        let pid = $f56259f2fdff9c56$var$$('#kdx-product-id', work).value.trim();
        if (pid) return pid;
        const cid = $f56259f2fdff9c56$var$$('#kdx-company', work).value;
        const term = $f56259f2fdff9c56$var$$('#kdx-busca-prod', work).value.trim();
        if (!cid || !term) return '';
        const products = await $f56259f2fdff9c56$var$searchProducts(cid, term);
        const exact = findExactSkuMatch(products, term);
        const pick = exact || (products.length === 1 ? products[0] : null);
        if (pick) {
            applyProductSelection(pick);
            return String(pick.id);
        }
        if (products.length > 1) {
            renderPickList(products);
            showErr("V\xe1rios produtos encontrados \u2014 escolha um na lista abaixo.");
            return '';
        }
        showErr("Produto n\xe3o encontrado. Ajuste o c\xf3digo ou descri\xe7\xe3o e busque novamente.");
        return '';
    }
    async function handleBuscarProd() {
        const cid = $f56259f2fdff9c56$var$$('#kdx-company', work).value;
        const term = $f56259f2fdff9c56$var$$('#kdx-busca-prod', work).value.trim();
        const box = $f56259f2fdff9c56$var$$('#kdx-prod-pick', work);
        if (!cid || !term) {
            box.style.display = 'none';
            if (!cid) showErr('Selecione a empresa.');
            return false;
        }
        showErr('');
        const products = await $f56259f2fdff9c56$var$searchProducts(cid, term);
        const exact = findExactSkuMatch(products, term);
        if (exact || products.length === 1) {
            applyProductSelection(exact || products[0]);
            return true;
        }
        renderPickList(products);
        return false;
    }
    function commonParams() {
        return {
            productId: state.productId,
            dateFrom: $f56259f2fdff9c56$var$$('#kdx-df', work).value,
            dateFim: $f56259f2fdff9c56$var$$('#kdx-dt', work).value,
            lotText: $f56259f2fdff9c56$var$$('#kdx-lot', work).value,
            costMode: $f56259f2fdff9c56$var$$('#kdx-cost', work).value,
            includeDisabled: $f56259f2fdff9c56$var$$('#kdx-dis', work).checked
        };
    }
    async function ensureLocationMap() {
        if (!state.companyId) return;
        const { labels: labels, locations: locations, stagingIds: stagingIds, awaitingIds: awaitingIds } = await (0, $4783b3c4a628f45b$export$1fa5187460609f25)(state.companyId, null);
        state.labelMap = labels;
        state.locations = locations;
        state.stagingIds = stagingIds;
        state.awaitingIds = awaitingIds;
    }
    async function fetchKardexPage(offset, limit) {
        const q = $f56259f2fdff9c56$var$buildQuery((0, $4783b3c4a628f45b$export$127c5aa7df60a221)({
            ...commonParams(),
            limit: limit,
            offset: offset
        }));
        const res = await (0, $9VcS9.default).kardex_report(state.companyId, q);
        const raw = await res.text();
        if (!res.ok) throw new Error((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw));
        return JSON.parse(raw);
    }
    async function fetchAllRows(onProgress) {
        const out = [];
        let off = 0;
        let batch = 0;
        while(out.length < 50000){
            batch += 1;
            if (onProgress) onProgress(batch, off, out.length);
            const payload = await fetchKardexPage(off, $f56259f2fdff9c56$var$KDX_FETCH_CHUNK);
            const rows = payload.rows || [];
            out.push(...rows);
            if (rows.length < $f56259f2fdff9c56$var$KDX_FETCH_CHUNK) break;
            off += $f56259f2fdff9c56$var$KDX_FETCH_CHUNK;
        }
        return out;
    }
    async function processRows(rawRows, { vistaCliente: vistaCliente }) {
        let rows = (0, $4783b3c4a628f45b$export$43e2019d7de8de73)(rawRows, state.stagingIds, state.awaitingIds);
        rows = (0, $4783b3c4a628f45b$export$19956727355d0bdf)(rows);
        await (0, $4783b3c4a628f45b$export$3a08e86f124740dc)(rows, state.companyId, state.productId, {
            listInputs: null,
            listOutputs: null,
            listOutputOrders: null
        });
        if (vistaCliente) rows = (0, $4783b3c4a628f45b$export$e00eaf6dc1814243)(rows);
        return rows;
    }
    function renderSummary(summary) {
        const wrap = $f56259f2fdff9c56$var$$('#kdx-summary', work);
        const items = (0, $4783b3c4a628f45b$export$eeb2bd00ce2d0988)(summary, {
            companyName: state.companyName,
            productLabel: state.productLabel,
            dateFimInclusive: $f56259f2fdff9c56$var$$('#kdx-dt', work).value
        });
        if (!items.length) {
            wrap.style.display = 'none';
            return;
        }
        wrap.replaceChildren();
        for (const { label: label, value: value } of items){
            const div = document.createElement('div');
            div.className = 'kdx-kpi';
            const lbl = document.createElement('div');
            lbl.className = 'kpi-lbl';
            lbl.textContent = label;
            const val = document.createElement('div');
            val.className = 'kpi-val';
            val.textContent = value;
            div.appendChild(lbl);
            div.appendChild(val);
            wrap.appendChild(div);
        }
        const hint = document.createElement('div');
        hint.className = 'kdx-summary-hint';
        hint.textContent = "Entradas: I\u2192L conclu\xeddas. Sa\xeddas: efeito f\xedsico no per\xedodo. Endere\xe7amento cancelado/estorno de entrada (I\u2192L desabilitada, L\u2192I) n\xe3o aparece no extrato. Saldo ao fim = SUM(/stocks).";
        wrap.appendChild(hint);
        wrap.style.display = '';
    }
    function renderStockFooter(totals) {
        const box = $f56259f2fdff9c56$var$$('#kdx-stock-footer', work);
        const kpis = $f56259f2fdff9c56$var$$('#kdx-stock-kpis', work);
        if (!totals) {
            box.style.display = 'none';
            return;
        }
        kpis.replaceChildren();
        for (const [lbl, key] of [
            [
                'Total livre',
                'qty_livre'
            ],
            [
                'Total bloqueado',
                'qty_bloqueado'
            ],
            [
                'Total geral',
                'qty_total'
            ]
        ]){
            const div = document.createElement('div');
            div.className = 'kdx-kpi';
            const l = document.createElement('div');
            l.className = 'kpi-lbl';
            l.textContent = lbl;
            const v = document.createElement('div');
            v.className = 'kpi-val';
            v.textContent = (0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(totals[key]);
            div.appendChild(l);
            div.appendChild(v);
            kpis.appendChild(div);
        }
        box.style.display = '';
    }
    function kardexClientHighlightClass(colKey) {
        if (colKey === '__nf_entrada' || colKey === '__nf_entrada_html') return 'kdx-kardex-nf';
        if (colKey === '__req_his' || colKey === '__req_his_html') return 'kdx-kardex-his';
        return '';
    }
    function renderTableLoading(vistaCliente) {
        const costMode = $f56259f2fdff9c56$var$$('#kdx-cost', work).value;
        const spec = (0, $4783b3c4a628f45b$export$b0d742c8d9101930)(vistaCliente, costMode);
        const thead = $f56259f2fdff9c56$var$$('#kdx-table thead', work);
        const tbody = $f56259f2fdff9c56$var$$('#kdx-table tbody', work);
        thead.replaceChildren();
        tbody.replaceChildren();
        const headTr = document.createElement('tr');
        for (const c of spec){
            const th = document.createElement('th');
            th.textContent = c.label;
            if (c.align === 'end') th.classList.add('kdx-end');
            else if (c.align === 'center') th.classList.add('kdx-center');
            headTr.appendChild(th);
        }
        thead.appendChild(headTr);
        const tr = document.createElement('tr');
        const td = document.createElement('td');
        td.colSpan = Math.max(spec.length, 1);
        td.textContent = "Carregando movimenta\xe7\xf5es\u2026";
        td.style.cssText = 'color:#64748b;background:#f8fafc;font-weight:500;text-align:center;padding:1rem';
        tr.appendChild(td);
        tbody.appendChild(tr);
    }
    function renderTable(rows, vistaCliente) {
        const costMode = $f56259f2fdff9c56$var$$('#kdx-cost', work).value;
        const spec = (0, $4783b3c4a628f45b$export$b0d742c8d9101930)(vistaCliente, costMode);
        const thead = $f56259f2fdff9c56$var$$('#kdx-table thead', work);
        const tbody = $f56259f2fdff9c56$var$$('#kdx-table tbody', work);
        tbody.replaceChildren();
        if (!rows.length) {
            thead.replaceChildren();
            const tr = document.createElement('tr');
            const th = document.createElement('th');
            th.colSpan = Math.max(spec.length, 8);
            th.textContent = "Nenhuma movimenta\xe7\xe3o no per\xedodo";
            th.style.cssText = 'color:#64748b;background:#f8fafc;font-weight:500';
            tr.appendChild(th);
            thead.appendChild(tr);
            return;
        }
        thead.replaceChildren();
        const headTr = document.createElement('tr');
        for (const c of spec){
            const th = document.createElement('th');
            th.textContent = c.label;
            if (c.align === 'end') th.classList.add('kdx-end');
            else if (c.align === 'center') th.classList.add('kdx-center');
            headTr.appendChild(th);
        }
        thead.appendChild(headTr);
        const baseNum = vistaCliente ? 0 : state.offset;
        rows.forEach((r, idx)=>{
            const tr = document.createElement('tr');
            const n = baseNum + idx + 1;
            for (const c of spec){
                const td = document.createElement('td');
                const alignCls = c.align === 'end' ? 'kdx-end' : c.align === 'center' ? 'kdx-center' : '';
                const refCls = (0, $4783b3c4a628f45b$export$422e4c802fb8adea)(c.key);
                const hiCls = kardexClientHighlightClass(c.key);
                td.className = [
                    alignCls,
                    refCls,
                    hiCls
                ].filter(Boolean).join(' ');
                const numericCell = (0, $4783b3c4a628f45b$export$fcd719b0119d4ab0)(r, c.key);
                if (numericCell) {
                    td.textContent = numericCell.text;
                    if (numericCell.tone === 'out') td.classList.add('kdx-qty-out');
                    else if (numericCell.tone === 'in') td.classList.add('kdx-qty-in');
                } else td.textContent = (0, $4783b3c4a628f45b$export$3f0ae574393da7cf)(r, c.key, n, state.labelMap, {
                    html: false
                });
                tr.appendChild(td);
            }
            tbody.appendChild(tr);
        });
    }
    async function loadStockTotals() {
        state.lastStock = await (0, $4783b3c4a628f45b$export$69202fa12ff4552)(state.companyId, state.productId, {
            listStocks: (q)=>(0, $9VcS9.default).call((0, $9VcS9.default).list_stocks, q),
            listLots: (q)=>(0, $9VcS9.default).call((0, $9VcS9.default).list_lots, q)
        });
        renderStockFooter(state.lastStock);
    }
    async function runConsult() {
        showErr('');
        state.companyId = $f56259f2fdff9c56$var$$('#kdx-company', work).value;
        state.productId = await resolveProductSelection();
        const coOpt = $f56259f2fdff9c56$var$$('#kdx-company', work).selectedOptions?.[0];
        state.companyName = coOpt?.textContent || '';
        if (!state.companyId) {
            showErr('Selecione a empresa.');
            return;
        }
        if (!state.productId) return;
        const df = $f56259f2fdff9c56$var$$('#kdx-df', work).value;
        const dt = $f56259f2fdff9c56$var$$('#kdx-dt', work).value;
        if (!df || !dt) {
            showErr('Informe data inicial e final.');
            return;
        }
        const btn = $f56259f2fdff9c56$var$$('#kdx-consultar', work);
        btn.disabled = true;
        $f56259f2fdff9c56$var$$('#kdx-pdf', work).disabled = true;
        $f56259f2fdff9c56$var$$('#kdx-csv', work).disabled = true;
        const vista = $f56259f2fdff9c56$var$$('#kdx-vista-cliente', work).checked;
        renderTableLoading(vista);
        const mb = (0, $jUNyh.default)({
            animation: true,
            text: "Carregando Kardex\u2026"
        });
        try {
            await ensureLocationMap();
            const sumQ = $f56259f2fdff9c56$var$buildQuery((0, $4783b3c4a628f45b$export$127c5aa7df60a221)(commonParams()));
            const sumRes = await (0, $9VcS9.default).kardex_summary(state.companyId, sumQ);
            const sumRaw = await sumRes.text();
            if (!sumRes.ok) throw new Error((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(sumRes.status, sumRaw));
            state.lastSummary = JSON.parse(sumRaw);
            state.offset = 0;
            let rows;
            if (vista) {
                const raw = await fetchAllRows();
                rows = await processRows(raw, {
                    vistaCliente: true
                });
                state.total = rows.length;
                const dropped = raw.length - rows.length;
                $f56259f2fdff9c56$var$$('#kdx-rows-meta', work).textContent = `Vista cliente: ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(rows.length)} movimenta\xe7\xe3o(\xf5es)${dropped > 0 ? ` (${dropped} interna(s) oculta(s))` : ''} \xb7 per\xedodo completo`;
            } else {
                const payload = await fetchKardexPage(state.offset, $f56259f2fdff9c56$var$KDX_PAGE_LIMIT);
                const raw = payload.rows || [];
                state.total = payload.total_rows_in_period ?? raw.length;
                rows = await processRows(raw, {
                    vistaCliente: false
                });
                $f56259f2fdff9c56$var$$('#kdx-rows-meta', work).textContent = `Total: ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.total)} \xb7 p\xe1gina a partir de ${state.offset + 1}`;
                $f56259f2fdff9c56$var$$('#kdx-prev', work).disabled = state.offset <= 0;
                $f56259f2fdff9c56$var$$('#kdx-next', work).disabled = raw.length < $f56259f2fdff9c56$var$KDX_PAGE_LIMIT || state.total != null && state.offset + raw.length >= state.total;
            }
            $f56259f2fdff9c56$var$$('#kdx-gerado', work).textContent = new Date().toLocaleString('pt-BR', {
                hour12: false
            });
            await loadStockTotals();
            renderTable(rows, vista);
            const summaryView = vista ? (0, $4783b3c4a628f45b$export$7b4b843582bcc3e1)(state.lastSummary, rows) : state.lastSummary;
            renderSummary((0, $4783b3c4a628f45b$export$b3b7c28014638fc9)(summaryView, state.lastStock));
            $f56259f2fdff9c56$var$$('#kdx-pdf', work).disabled = false;
            $f56259f2fdff9c56$var$$('#kdx-csv', work).disabled = false;
        } catch (e) {
            console.error(e);
            showErr(e?.message || 'Falha ao consultar o Kardex.');
            renderTable([], false);
        } finally{
            mb.destroy();
            btn.disabled = false;
        }
    }
    async function buildExportRows() {
        await ensureLocationMap();
        const vista = $f56259f2fdff9c56$var$$('#kdx-vista-cliente', work).checked;
        const raw = await fetchAllRows();
        return processRows(raw, {
            vistaCliente: vista
        });
    }
    function downloadCsv(rows) {
        const spec = (0, $4783b3c4a628f45b$export$b0d742c8d9101930)($f56259f2fdff9c56$var$$('#kdx-vista-cliente', work).checked, $f56259f2fdff9c56$var$$('#kdx-cost', work).value);
        let csv = '\uFEFF';
        csv += `${spec.map((c)=>`"${c.label.replace(/"/g, '""')}"`).join(';')}\n`;
        rows.forEach((r, idx)=>{
            csv += `${spec.map((c)=>`"${String((0, $4783b3c4a628f45b$export$46f883db0563aa8f)(r, c, idx + 1, state.labelMap)).replace(/"/g, '""')}"`).join(';')}\n`;
        });
        if (state.lastStock) {
            csv += '\n';
            csv += `"Estoque atual \u{2014} total livre";"${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.lastStock.qty_livre)}"\n`;
            csv += `"Estoque atual \u{2014} total bloqueado";"${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.lastStock.qty_bloqueado)}"\n`;
            csv += `"Estoque atual \u{2014} total geral";"${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.lastStock.qty_total)}"\n`;
        }
        const blob = new Blob([
            csv
        ], {
            type: 'text/csv;charset=utf-8'
        });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `kardex_${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(a.href);
    }
    function downloadPdf(rows) {
        const spec = (0, $4783b3c4a628f45b$export$b0d742c8d9101930)($f56259f2fdff9c56$var$$('#kdx-vista-cliente', work).checked, $f56259f2fdff9c56$var$$('#kdx-cost', work).value);
        const head = spec.map((c)=>`<th>${$f56259f2fdff9c56$var$esc(c.label)}</th>`).join('');
        let body = '';
        rows.forEach((r, idx)=>{
            body += '<tr>';
            for (const c of spec){
                const v = (0, $4783b3c4a628f45b$export$46f883db0563aa8f)(r, c, idx + 1, state.labelMap);
                const cls = c.align === 'end' ? ' class="num"' : '';
                body += `<td${cls}>${$f56259f2fdff9c56$var$esc(v)}</td>`;
            }
            body += '</tr>';
        });
        const stock = state.lastStock ? `<p>Estoque atual: ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.lastStock.qty_livre)} / ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.lastStock.qty_bloqueado)} / ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.lastStock.qty_total)}</p>` : '';
        const html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"><title>Kardex</title>
			<style>body{font-family:Segoe UI,sans-serif;font-size:11px;padding:16px}table{border-collapse:collapse;width:100%}
			th,td{border:1px solid #333;padding:4px 6px}.num{text-align:right}</style></head><body>
			<h1>Kardex</h1><p><strong>Empresa:</strong> ${$f56259f2fdff9c56$var$esc(state.companyName)}</p>
			<p><strong>Produto:</strong> ${$f56259f2fdff9c56$var$esc(state.productLabel)}</p>
			<p><strong>Per\xedodo:</strong> ${$f56259f2fdff9c56$var$esc($f56259f2fdff9c56$var$$('#kdx-df', work).value)} a ${$f56259f2fdff9c56$var$esc($f56259f2fdff9c56$var$$('#kdx-dt', work).value)}</p>${stock}
			<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></body></html>`;
        const w = window.open('', '_blank');
        if (!w) {
            (0, $jUNyh.notify)('Permita pop-up para gerar o PDF.', 'Kardex');
            return;
        }
        w.document.write(html);
        w.document.close();
        w.onload = ()=>{
            w.focus();
            w.print();
        };
    }
    await $f56259f2fdff9c56$var$loadCompanies($f56259f2fdff9c56$var$$('#kdx-company', work));
    defaultDates();
    syncLegenda();
    $f56259f2fdff9c56$var$$('#kdx-company', work).addEventListener('change', ()=>{
        $f56259f2fdff9c56$var$$('#kdx-product-id', work).value = '';
        $f56259f2fdff9c56$var$$('#kdx-prod-sel', work).textContent = '';
        state.productId = '';
        state.productLabel = '';
    });
    $f56259f2fdff9c56$var$$('#kdx-btn-buscar-prod', work).addEventListener('click', ()=>{
        handleBuscarProd();
    });
    $f56259f2fdff9c56$var$$('#kdx-busca-prod', work).addEventListener('keydown', async (e)=>{
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const ok = await handleBuscarProd();
        if (ok) await runConsult();
    });
    $f56259f2fdff9c56$var$$('#kdx-vista-cliente', work).addEventListener('change', ()=>{
        syncLegenda();
        if (state.productId) runConsult();
    });
    $f56259f2fdff9c56$var$$('#kdx-consultar', work).addEventListener('click', runConsult);
    $f56259f2fdff9c56$var$$('#kdx-prev', work).addEventListener('click', async ()=>{
        state.offset = Math.max(0, state.offset - $f56259f2fdff9c56$var$KDX_PAGE_LIMIT);
        try {
            const payload = await fetchKardexPage(state.offset, $f56259f2fdff9c56$var$KDX_PAGE_LIMIT);
            const raw = payload.rows || [];
            const rows = await processRows(raw, {
                vistaCliente: false
            });
            renderTable(rows, false);
            $f56259f2fdff9c56$var$$('#kdx-rows-meta', work).textContent = `Total: ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.total)} \xb7 p\xe1gina a partir de ${state.offset + 1}`;
            $f56259f2fdff9c56$var$$('#kdx-prev', work).disabled = state.offset <= 0;
            $f56259f2fdff9c56$var$$('#kdx-next', work).disabled = raw.length < $f56259f2fdff9c56$var$KDX_PAGE_LIMIT;
        } catch (e) {
            showErr(e?.message || "Falha na pagina\xe7\xe3o.");
        }
    });
    $f56259f2fdff9c56$var$$('#kdx-next', work).addEventListener('click', async ()=>{
        state.offset += $f56259f2fdff9c56$var$KDX_PAGE_LIMIT;
        try {
            const payload = await fetchKardexPage(state.offset, $f56259f2fdff9c56$var$KDX_PAGE_LIMIT);
            const raw = payload.rows || [];
            const rows = await processRows(raw, {
                vistaCliente: false
            });
            renderTable(rows, false);
            $f56259f2fdff9c56$var$$('#kdx-rows-meta', work).textContent = `Total: ${(0, $4783b3c4a628f45b$export$3d7a2d69182e565e)(state.total)} \xb7 p\xe1gina a partir de ${state.offset + 1}`;
            $f56259f2fdff9c56$var$$('#kdx-prev', work).disabled = false;
            $f56259f2fdff9c56$var$$('#kdx-next', work).disabled = raw.length < $f56259f2fdff9c56$var$KDX_PAGE_LIMIT;
        } catch (e) {
            showErr(e?.message || "Falha na pagina\xe7\xe3o.");
        }
    });
    async function runExport(kind) {
        if (!state.productId) {
            showErr('Selecione um produto antes de exportar.');
            return;
        }
        const btn = kind === 'pdf' ? $f56259f2fdff9c56$var$$('#kdx-pdf', work) : $f56259f2fdff9c56$var$$('#kdx-csv', work);
        btn.disabled = true;
        try {
            const rows = await buildExportRows();
            if (kind === 'pdf') downloadPdf(rows);
            else downloadCsv(rows);
        } catch (e) {
            showErr(e?.message || "Falha na exporta\xe7\xe3o.");
        } finally{
            btn.disabled = false;
        }
    }
    $f56259f2fdff9c56$var$$('#kdx-pdf', work).addEventListener('click', ()=>runExport('pdf'));
    $f56259f2fdff9c56$var$$('#kdx-csv', work).addEventListener('click', ()=>runExport('csv'));
}


/**
 * BI > Analítico Estoque — modal de filtros e exportação CSV / prévia JSON.
 * Base: doc/queries/relatorio-estoque-completo.sql
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $hWQyW = parcelRequire("hWQyW");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");

function $88786ec43c4e99d0$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $88786ec43c4e99d0$var$skuLabel(p) {
    if (!p?.sku) return '';
    return Array.isArray(p.sku) ? p.sku.join('') : String(p.sku);
}
function $88786ec43c4e99d0$var$filterExprCompany(companyId) {
    return (0, $hWQyW.translate)({
        'field-0': 'company_id',
        'operator-0': 'eq',
        'value-0': companyId
    });
}
async function $88786ec43c4e99d0$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch (e) {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
async function $88786ec43c4e99d0$var$loadWarehouses(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const fe = encodeURIComponent($88786ec43c4e99d0$var$filterExprCompany(companyId));
    const res = await (0, $9VcS9.default).list_warehouses(`?filter=${fe}&limit=0&sort=2`);
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), "Armaz\xe9ns");
        return;
    }
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const w of arr){
        const o = document.createElement('option');
        o.value = String(w.id);
        o.textContent = `${w.name ?? ''} (${w.id})`;
        sel.appendChild(o);
    }
}
async function $88786ec43c4e99d0$var$loadPrograms(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const res = await (0, $9VcS9.default).list_programs_by_company(companyId);
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Programas');
        return;
    }
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const p of arr){
        const o = document.createElement('option');
        o.value = String(p.id);
        o.textContent = p.name || String(p.id);
        sel.appendChild(o);
    }
}
async function $88786ec43c4e99d0$var$loadProductsForCompany(companyId, selectEl, searchInput) {
    selectEl.innerHTML = '';
    if (!companyId) {
        selectEl.innerHTML = '<option value="">\u2014 Escolha a empresa \u2014</option>';
        return;
    }
    const fe = $88786ec43c4e99d0$var$filterExprCompany(companyId);
    const batch = 500;
    const products = [];
    const seen = new Set();
    for(let offset = 0;; offset += batch){
        const q = `?filter=${encodeURIComponent(fe)}&limit=${batch}&offset=${offset}&sort=7&include_disabled=1`;
        const res = await (0, $9VcS9.default).list_products(q);
        if (!res.ok) {
            (0, $jUNyh.notify)(await res.text(), 'Produtos');
            selectEl.innerHTML = '<option value="">\u2014 Erro \u2014</option>';
            return;
        }
        const chunk = await res.json();
        if (!Array.isArray(chunk) || chunk.length === 0) break;
        for (const p of chunk){
            const id = p?.id;
            if (id == null || seen.has(id)) continue;
            seen.add(id);
            products.push(p);
        }
        if (chunk.length < batch) break;
    }
    selectEl.innerHTML = '<option value="">\u2014 Todos (ou filtre SKU/nome) \u2014</option>';
    for (const p of products){
        const sku = $88786ec43c4e99d0$var$skuLabel(p);
        const name = (p.name || '').trim() || '(sem nome)';
        const o = document.createElement('option');
        o.value = String(p.id);
        const dis = p.is_disabled ? ' [inativo]' : '';
        o.textContent = `${sku} \u{2014} ${name} (id ${p.id})${dis}`;
        selectEl.appendChild(o);
    }
    if (searchInput) $88786ec43c4e99d0$var$applyProductSearch(selectEl, searchInput.value);
}
function $88786ec43c4e99d0$var$applyProductSearch(selectEl, needle) {
    const n = (needle || '').trim().toLowerCase();
    if (!n) {
        for (const o of selectEl.options)o.hidden = false;
        return;
    }
    for (const o of selectEl.options){
        if (!o.value) {
            o.hidden = false;
            continue;
        }
        o.hidden = !String(o.textContent || '').toLowerCase().includes(n);
    }
}
function $88786ec43c4e99d0$var$collectParams(node, format) {
    const companyId = $88786ec43c4e99d0$var$$('#bisa-company', node)?.value?.trim();
    if (!companyId) return null;
    const sp = new URLSearchParams();
    sp.set('format', format);
    const wh = $88786ec43c4e99d0$var$$('#bisa-warehouse', node)?.value?.trim();
    if (wh) sp.set('warehouse_id', wh);
    const prog = $88786ec43c4e99d0$var$$('#bisa-program', node)?.value?.trim();
    if (prog) sp.set('program_id', prog);
    const prod = $88786ec43c4e99d0$var$$('#bisa-product', node)?.value?.trim();
    if (prod) sp.set('product_id', prod);
    else {
        const ps = $88786ec43c4e99d0$var$$('#bisa-product-search', node)?.value?.trim();
        if (ps) sp.set('product_search', ps);
    }
    const lot = $88786ec43c4e99d0$var$$('#bisa-lot', node)?.value?.trim();
    if (lot) sp.set('lot_search', lot);
    if (format === 'json') {
        sp.set('limit', $88786ec43c4e99d0$var$$('#bisa-limit', node)?.value || '200');
        sp.set('offset', $88786ec43c4e99d0$var$$('#bisa-offset', node)?.value || '0');
    } else {
        const mx = $88786ec43c4e99d0$var$$('#bisa-max-rows', node)?.value?.trim();
        if (mx) sp.set('max_rows', mx);
    }
    return sp;
}
function $88786ec43c4e99d0$var$escCell(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $88786ec43c4e99d0$var$renderPreviewTable(container, rows) {
    if (!rows?.length) {
        container.innerHTML = '<p class="muted mts">Nenhuma linha (ajuste filtros ou permiss\xf5es).</p>';
        return;
    }
    const keys = Object.keys(rows[0]);
    let html = '<div class="bisa-scroll mts"><table class="view fsx"><thead><tr>';
    for (const k of keys)html += `<th>${$88786ec43c4e99d0$var$escCell(k)}</th>`;
    html += '</tr></thead><tbody>';
    for (const r of rows){
        html += '<tr>';
        for (const k of keys)html += `<td>${$88786ec43c4e99d0$var$escCell(r[k])}</td>`;
        html += '</tr>';
    }
    html += '</tbody></table></div>';
    container.innerHTML = html;
}
function $88786ec43c4e99d0$var$downloadCsv(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'estoque-analitico.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $88786ec43c4e99d0$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.bisa-hint { color: #555; font-size: 0.9rem; max-width: 48rem; }
			.bisa-scroll { overflow: auto; max-height: 65vh; }
			.bisa-modal label { display: block; margin-top: 0.65rem; }
			.bisa-modal .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; margin-top: 0.35rem; }
			.bisa-modal .row > label { flex: 1 1 14rem; }
			.bisa-product-select { width: 100%; min-height: 11rem; margin-top: 0.35rem; font-size: 0.88rem; }
			.bisa-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
		</style>
		<div class="title">Anal\xedtico Estoque (BI)</div>
		<p class="mts bisa-hint">Abra o formul\xe1rio para filtrar por empresa, programa, armaz\xe9m, produto (lista por SKU/nome) e trecho do lote. Exporte <strong>CSV</strong> (Excel) ou gere uma <strong>pr\xe9via</strong> na tela. Crit\xe9rios alinhados a <code>doc/queries/relatorio-estoque-completo.sql</code>.</p>
		<p class="mts"><button type="button" class="button" id="bisa-open-modal">Filtros e gera\xe7\xe3o</button></p>
		<div id="bisa-preview-host" class="mts"></div>
	`;
    const previewHost = $88786ec43c4e99d0$var$$('#bisa-preview-host', work);
    const openModal = ()=>{
        const dlgHtml = `
<div class="msgbox bisa-modal" style="min-width: min(40rem, 92vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Anal\xedtico Estoque \u{2014} filtros</div>
	<div class="mb-text" style="max-height: none;">
		<label>Empresa<sup>*</sup><select id="bisa-company"></select></label>
		<div class="row">
			<label>Programa<select id="bisa-program"></select></label>
			<label>Armaz\xe9m<select id="bisa-warehouse"></select></label>
		</div>
		<label>Filtrar lista de produtos (SKU ou nome)<input type="search" id="bisa-prod-filter" placeholder="opcional" autocomplete="off"></label>
		<label>Produto<select id="bisa-product" class="bisa-product-select" size="10"></select></label>
		<p class="muted fsxx" style="margin:0.25rem 0 0;">Deixe produto em \xabTodos\xbb e use o campo abaixo para buscar por SKU/nome no servidor, ou escolha um item na lista.</p>
		<label>Busca produto (servidor, se n\xe3o escolheu na lista)<input type="text" id="bisa-product-search" placeholder="trecho SKU ou nome" autocomplete="off"></label>
		<label>Lote (cont\xe9m)<input type="text" id="bisa-lot" placeholder="opcional" autocomplete="off"></label>
		<div class="row">
			<label>Pr\xe9via: limite<input type="number" id="bisa-limit" value="200" min="1" max="5000" step="1"></label>
			<label>Pr\xe9via: offset<input type="number" id="bisa-offset" value="0" min="0" step="1"></label>
			<label>CSV: m\xe1x. linhas<input type="number" id="bisa-max-rows" value="50000" min="1" max="200000" step="1"></label>
		</div>
	</div>
	<div class="bisa-actions">
		<button type="button" class="button bn_Preview">Pr\xe9via na tela</button>
		<button type="button" class="button bn_ExportCsv">Exportar CSV</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
        const dlg = (0, $dx9qz.default).create(dlgHtml, async (key)=>{
            const root = dlg.getNode();
            if (key === 'Escape') {
                dlg.destroy();
                return;
            }
            if (key !== 'Preview' && key !== 'ExportCsv') return;
            const sp = $88786ec43c4e99d0$var$collectParams(root, key === 'Preview' ? 'json' : 'csv');
            if (!sp) {
                (0, $jUNyh.notify)('Selecione a empresa.');
                return;
            }
            const companyId = $88786ec43c4e99d0$var$$('#bisa-company', root).value.trim();
            try {
                if (key === 'Preview') {
                    const res = await (0, $9VcS9.default).stock_complete_report(companyId, sp.toString());
                    const raw = await res.text();
                    if (!res.ok) {
                        (0, $jUNyh.notify)(raw || res.statusText, "Anal\xedtico Estoque");
                        return;
                    }
                    let data;
                    try {
                        data = JSON.parse(raw);
                    } catch (e) {
                        (0, $jUNyh.notify)("Resposta n\xe3o \xe9 JSON.", "Anal\xedtico Estoque");
                        return;
                    }
                    if (!Array.isArray(data)) {
                        (0, $jUNyh.notify)('Formato inesperado da API.', "Anal\xedtico Estoque");
                        return;
                    }
                    dlg.destroy();
                    $88786ec43c4e99d0$var$renderPreviewTable(previewHost, data);
                    (0, $jUNyh.notify)(`Pr\xe9via: ${data.length} linha(s).`, "Anal\xedtico Estoque");
                    return;
                }
                const res = await (0, $9VcS9.default).stock_complete_report(companyId, sp.toString());
                if (!res.ok) {
                    const t = await res.text();
                    (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, t), "Anal\xedtico Estoque");
                    return;
                }
                const blob = await res.blob();
                const cd = res.headers.get('Content-Disposition');
                let fname = 'estoque-analitico.csv';
                if (cd) {
                    const m = cd.match(/filename="?([^";]+)"?/i);
                    if (m) fname = m[1];
                }
                $88786ec43c4e99d0$var$downloadCsv(blob, fname);
                dlg.destroy();
                (0, $jUNyh.notify)('Download do CSV iniciado.', "Anal\xedtico Estoque");
            } catch (e) {
                console.error(e);
                (0, $jUNyh.notify)(e?.message || String(e), "Anal\xedtico Estoque");
            }
        });
        const root = dlg.getNode();
        const selCo = $88786ec43c4e99d0$var$$('#bisa-company', root);
        const selWh = $88786ec43c4e99d0$var$$('#bisa-warehouse', root);
        const selPr = $88786ec43c4e99d0$var$$('#bisa-program', root);
        const selProd = $88786ec43c4e99d0$var$$('#bisa-product', root);
        const inpFilt = $88786ec43c4e99d0$var$$('#bisa-prod-filter', root);
        $88786ec43c4e99d0$var$loadCompanies(selCo).then(()=>{});
        selCo.addEventListener('change', async ()=>{
            const id = selCo.value;
            await Promise.all([
                $88786ec43c4e99d0$var$loadWarehouses(id, selWh),
                $88786ec43c4e99d0$var$loadPrograms(id, selPr),
                $88786ec43c4e99d0$var$loadProductsForCompany(id, selProd, inpFilt)
            ]);
        });
        inpFilt.addEventListener('input', ()=>$88786ec43c4e99d0$var$applyProductSearch(selProd, inpFilt.value));
        selProd.addEventListener('change', ()=>$88786ec43c4e99d0$var$applyProductSearch(selProd, inpFilt.value));
    };
    $88786ec43c4e99d0$var$$('#bisa-open-modal', work).addEventListener('click', openModal);
}


/**
 * BI — Bloqueios descritivo — modal de filtros, prévia e CSV.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $hWQyW = parcelRequire("hWQyW");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");

var $dx9qz = parcelRequire("dx9qz");
/**
 * Caixa de progresso reutilizável (carregamentos PESADOS).
 *
 * Padrões de uso no SIAL:
 *   - Carregamento PADRÃO/RÁPIDO (< 2 s, sem percentual): use
 *       msgbox({ animation: true, text: 'Carregando produtos…' })
 *     que mostra o spinner padrão do SIAL.
 *   - Carregamento PESADO (export grande, geração de XLSX/CSV, download
 *     volumoso, processamento server-side longo): use ESTE componente.
 *
 * API:
 *   const p = progress({ title, text, indeterminate, cancellable, onCancel });
 *   p.set(fraction)        // 0..1 (ignorado se indeterminate)
 *   p.setText(text)
 *   p.setTitle(text)
 *   p.markStage(stageName) // texto auxiliar abaixo da barra
 *   p.destroy()
 */ const $dd3b449d8cadbeb3$export$2e2bcd8739ae039 = function(args) {
    args = args || {};
    const ind = !!args.indeterminate;
    const cancellable = !!args.cancellable;
    const html = `
		<div class="msgbox msgbox--progress" role="alertdialog" aria-live="polite" aria-busy="true">
			<div class="mb-title pg-title">${$dd3b449d8cadbeb3$var$escHtml(args.title || "Processando\u2026")}</div>
			<div class="mb-text pg-text">${$dd3b449d8cadbeb3$var$escHtml(args.text || '')}</div>
			<div class="pg-bar-wrap">
				<div class="pg-bar pg-bar--${ind ? 'indeterminate' : 'determinate'}">
					<div class="pg-bar-fill"></div>
				</div>
			</div>
			<div class="pg-meta">
				<span class="pg-stage" aria-live="polite"></span>
				<span class="pg-percent" aria-live="polite">${ind ? '' : '0%'}</span>
			</div>
			${cancellable ? '<button type="button" class="button bn_PgCancel mtl">Cancelar</button>' : ''}
		</div>`;
    const dlg = (0, $dx9qz.default).create(html, (key)=>{
        if (key === 'PgCancel' && typeof args.onCancel === 'function') args.onCancel();
    }, /^$/);
    const node = dlg.getNode();
    const fill = node.querySelector('.pg-bar-fill');
    const bar = node.querySelector('.pg-bar');
    const pct = node.querySelector('.pg-percent');
    const txt = node.querySelector('.pg-text');
    const ttl = node.querySelector('.pg-title');
    const stg = node.querySelector('.pg-stage');
    let destroyed = false;
    let isInd = ind;
    function promoteToDeterminate() {
        if (destroyed || !isInd || !bar) return;
        isInd = false;
        bar.classList.remove('pg-bar--indeterminate');
        bar.classList.add('pg-bar--determinate');
        if (fill) fill.style.width = '0%';
        if (pct) pct.textContent = '0%';
    }
    return {
        set (fraction) {
            if (destroyed) return;
            if (isInd) promoteToDeterminate();
            const f = Math.max(0, Math.min(1, Number(fraction) || 0));
            const p = Math.round(f * 100);
            if (fill) fill.style.width = p + '%';
            if (pct) pct.textContent = p + '%';
        },
        promote: promoteToDeterminate,
        setText (t) {
            if (destroyed) return;
            txt.textContent = String(t == null ? '' : t);
        },
        setTitle (t) {
            if (destroyed || !ttl) return;
            ttl.textContent = String(t == null ? '' : t);
        },
        markStage (t) {
            if (destroyed || !stg) return;
            stg.textContent = String(t == null ? '' : t);
        },
        destroy () {
            if (destroyed) return;
            destroyed = true;
            dlg.destroy();
        }
    };
};
/**
 * Lê uma Response do fetch como Blob, atualizando a barra de progresso conforme bytes recebidos.
 * Usa Content-Length quando disponível (% real); caso contrário mostra o total recebido.
 */ async function $dd3b449d8cadbeb3$export$624f36fbda6d45c7(response, progressBox) {
    const ctype = response.headers.get('Content-Type') || '';
    const total = Number(response.headers.get('Content-Length')) || 0;
    if (!response.body || typeof response.body.getReader !== 'function') {
        if (progressBox) progressBox.setText("Recebendo arquivo\u2026");
        return await response.blob();
    }
    const reader = response.body.getReader();
    const chunks = [];
    let received = 0;
    // Quando há Content-Length confiável, promovemos a barra para determinate (0→100%).
    // Quando não há, simulamos progresso assintótico baseado em bytes recebidos.
    while(true){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        if (progressBox) {
            if (total > 0) {
                progressBox.set(received / total);
                progressBox.markStage(`${$dd3b449d8cadbeb3$var$formatBytes(received)} de ${$dd3b449d8cadbeb3$var$formatBytes(total)}`);
            } else {
                // Sem Content-Length: aproxima percentual com curva assintótica
                // que tende a 95% para nunca passar antes do fim real.
                const approx = 1 - Math.exp(-received / 5242880); // ~5MB → ~63%
                progressBox.set(Math.min(0.95, approx));
                progressBox.markStage(`Recebido: ${$dd3b449d8cadbeb3$var$formatBytes(received)}`);
            }
        }
    }
    if (progressBox) progressBox.set(1);
    return new Blob(chunks, {
        type: ctype
    });
}
function $dd3b449d8cadbeb3$var$formatBytes(n) {
    if (n < 1024) return `${n} B`;
    if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
    if (n < 1073741824) return `${(n / 1024 / 1024).toFixed(1)} MB`;
    return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
function $dd3b449d8cadbeb3$var$escHtml(s) {
    const t = document.createElement('template');
    t.textContent = String(s == null ? '' : s);
    return t.innerHTML;
}



function $95745c83cd57cc50$var$$(sel, root = document) {
    return root.querySelector(sel);
}
const $95745c83cd57cc50$var$PREVIEW_COLS = [
    [
        'empresa',
        'EMPRESA'
    ],
    [
        'sku',
        'SKU'
    ],
    [
        'produto',
        'PRODUTO'
    ],
    [
        'armazem',
        "ARMAZ\xc9M"
    ],
    [
        'posicao',
        "POSI\xc7\xc3O"
    ],
    [
        'qtd_disponivel',
        "QTD DISPON\xcdVEL"
    ],
    [
        'qtd_reservada',
        'QTD RESERVADA'
    ],
    [
        'saidas_que_reservaram',
        "SA\xcdDAS QUE RESERVARAM"
    ],
    [
        'qtd_bloqueada',
        'QTD BLOQUEADA'
    ],
    [
        'motivo_bloqueio',
        'MOTIVO BLOQUEIO'
    ]
];
function $95745c83cd57cc50$var$skuLabel(p) {
    if (!p?.sku) return '';
    return Array.isArray(p.sku) ? p.sku.join('') : String(p.sku);
}
function $95745c83cd57cc50$var$filterExprCompany(companyId) {
    return (0, $hWQyW.translate)({
        'field-0': 'company_id',
        'operator-0': 'eq',
        'value-0': companyId
    });
}
async function $95745c83cd57cc50$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch (e) {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
async function $95745c83cd57cc50$var$loadWarehouses(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const fe = encodeURIComponent($95745c83cd57cc50$var$filterExprCompany(companyId));
    const res = await (0, $9VcS9.default).list_warehouses(`?filter=${fe}&limit=0&sort=2`);
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), "Armaz\xe9ns");
        return;
    }
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const w of arr){
        const o = document.createElement('option');
        o.value = String(w.id);
        o.textContent = `${w.name ?? ''} (${w.id})`;
        sel.appendChild(o);
    }
}
async function $95745c83cd57cc50$var$loadPrograms(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const res = await (0, $9VcS9.default).list_programs_by_company(companyId);
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Programas');
        return;
    }
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const p of arr){
        const o = document.createElement('option');
        o.value = String(p.id);
        o.textContent = p.name || String(p.id);
        sel.appendChild(o);
    }
}
async function $95745c83cd57cc50$var$loadProductsForCompany(companyId, selectEl, searchInput) {
    selectEl.innerHTML = '';
    if (!companyId) {
        selectEl.innerHTML = '<option value="">\u2014 Escolha a empresa \u2014</option>';
        return;
    }
    selectEl.innerHTML = '<option value="">Carregando produtos\u2026</option>';
    selectEl.disabled = true;
    const mb = (0, $jUNyh.default)({
        animation: true,
        text: "Carregando produtos\u2026"
    });
    try {
        const fe = $95745c83cd57cc50$var$filterExprCompany(companyId);
        const batch = 500;
        const products = [];
        const seen = new Set();
        for(let offset = 0;; offset += batch){
            const q = `?filter=${encodeURIComponent(fe)}&limit=${batch}&offset=${offset}&sort=7&include_disabled=1`;
            const res = await (0, $9VcS9.default).list_products(q);
            if (!res.ok) {
                (0, $jUNyh.notify)(await res.text(), 'Produtos');
                selectEl.innerHTML = '<option value="">\u2014 Erro \u2014</option>';
                return;
            }
            const chunk = await res.json();
            if (!Array.isArray(chunk) || chunk.length === 0) break;
            for (const p of chunk){
                const id = p?.id;
                if (id == null || seen.has(id)) continue;
                seen.add(id);
                products.push(p);
            }
            if (chunk.length < batch) break;
        }
        selectEl.innerHTML = '<option value="">\u2014 Todos (ou filtre SKU/nome) \u2014</option>';
        for (const p of products){
            const sku = $95745c83cd57cc50$var$skuLabel(p);
            const name = (p.name || '').trim() || '(sem nome)';
            const o = document.createElement('option');
            o.value = String(p.id);
            const dis = p.is_disabled ? ' [inativo]' : '';
            o.textContent = `${sku} \u{2014} ${name} (id ${p.id})${dis}`;
            selectEl.appendChild(o);
        }
        if (searchInput) $95745c83cd57cc50$var$applyProductSearch(selectEl, searchInput.value);
    } finally{
        selectEl.disabled = false;
        mb.destroy();
    }
}
function $95745c83cd57cc50$var$applyProductSearch(selectEl, needle) {
    const n = (needle || '').trim().toLowerCase();
    if (!n) {
        for (const o of selectEl.options)o.hidden = false;
        return;
    }
    for (const o of selectEl.options){
        if (!o.value) {
            o.hidden = false;
            continue;
        }
        o.hidden = !String(o.textContent || '').toLowerCase().includes(n);
    }
}
function $95745c83cd57cc50$var$collectParams(node, format) {
    const companyId = $95745c83cd57cc50$var$$('#bsbd-company', node)?.value?.trim();
    if (!companyId) return null;
    const sp = new URLSearchParams();
    sp.set('format', format);
    const wh = $95745c83cd57cc50$var$$('#bsbd-warehouse', node)?.value?.trim();
    if (wh) sp.set('warehouse_id', wh);
    const prog = $95745c83cd57cc50$var$$('#bsbd-program', node)?.value?.trim();
    if (prog) sp.set('program_id', prog);
    const prod = $95745c83cd57cc50$var$$('#bsbd-product', node)?.value?.trim();
    if (prod) sp.set('product_id', prod);
    else {
        const ps = $95745c83cd57cc50$var$$('#bsbd-product-search', node)?.value?.trim();
        if (ps) sp.set('product_search', ps);
    }
    const lot = $95745c83cd57cc50$var$$('#bsbd-lot', node)?.value?.trim();
    if (lot) sp.set('lot_search', lot);
    const mode = $95745c83cd57cc50$var$$('#bsbd-mode', node)?.value || 'blocked';
    sp.set('mode', mode);
    if (format === 'json') {
        sp.set('limit', $95745c83cd57cc50$var$$('#bsbd-limit', node)?.value || '200');
        sp.set('offset', $95745c83cd57cc50$var$$('#bsbd-offset', node)?.value || '0');
    } else {
        const mx = $95745c83cd57cc50$var$$('#bsbd-max-rows', node)?.value?.trim();
        if (mx) sp.set('max_rows', mx);
    }
    return sp;
}
function $95745c83cd57cc50$var$escCell(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $95745c83cd57cc50$var$renderPreviewTable(container, rows) {
    if (!rows?.length) {
        container.innerHTML = '<p class="muted mts">Nenhuma linha (ajuste filtros ou permiss\xf5es).</p>';
        return;
    }
    const keys = $95745c83cd57cc50$var$PREVIEW_COLS.map((c)=>c[0]);
    const labels = $95745c83cd57cc50$var$PREVIEW_COLS.map((c)=>c[1]);
    let html = '<div class="bsbd-scroll mts"><table class="view fsx"><thead><tr>';
    for (const lbl of labels)html += `<th>${$95745c83cd57cc50$var$escCell(lbl)}</th>`;
    html += '</tr></thead><tbody>';
    for (const r of rows){
        html += '<tr>';
        for (const k of keys)html += `<td>${$95745c83cd57cc50$var$escCell(r[k])}</td>`;
        html += '</tr>';
    }
    html += '</tbody></table></div>';
    container.innerHTML = html;
}
function $95745c83cd57cc50$var$downloadCsv(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'bloqueios-descritivo.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $95745c83cd57cc50$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.bsbd-hint { color: #555; font-size: 0.9rem; max-width: 48rem; }
			.bsbd-scroll { overflow: auto; max-height: 65vh; }
			.bsbd-modal label { display: block; margin-top: 0.65rem; }
			.bsbd-modal .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; margin-top: 0.35rem; }
			.bsbd-modal .row > label { flex: 1 1 14rem; }
			.bsbd-product-select { width: 100%; min-height: 11rem; margin-top: 0.35rem; font-size: 0.88rem; }
			.bsbd-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
		</style>
		<div class="title">Bloqueios descritivo (BI)</div>
		<p class="mts bsbd-hint">Foco do relat\xf3rio: posi\xe7\xf5es com estoque <strong>BLOQUEADO</strong>. Mostra quantidades, \xfaltimo motivo de bloqueio e (opcional) sa\xeddas com reserva ATIVA na c\xe9lula. Linhas 100% zeradas nunca aparecem. Exporte <strong>CSV</strong> ou pr\xe9via na tela.</p>
		<p class="mts"><button type="button" class="button" id="bsbd-open-modal">Filtros e gera\xe7\xe3o</button></p>
		<div id="bsbd-preview-host" class="mts"></div>
	`;
    const previewHost = $95745c83cd57cc50$var$$('#bsbd-preview-host', work);
    const openModal = ()=>{
        const dlgHtml = `
<div class="msgbox bsbd-modal" style="min-width: min(40rem, 92vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Bloqueios descritivo \u{2014} filtros</div>
	<div class="mb-text" style="max-height: none;">
		<label>Empresa<sup>*</sup><select id="bsbd-company"></select></label>
		<div class="row">
			<label>Programa<select id="bsbd-program"></select></label>
			<label>Armaz\xe9m<select id="bsbd-warehouse"></select></label>
		</div>
		<label>Filtrar lista de produtos (SKU ou nome)<input type="search" id="bsbd-prod-filter" placeholder="opcional" autocomplete="off"></label>
		<label>Produto<select id="bsbd-product" class="bsbd-product-select" size="10"></select></label>
		<p class="muted fsxx" style="margin:0.25rem 0 0;">Deixe produto em \xabTodos\xbb e use o campo abaixo para buscar no servidor, ou escolha um item na lista.</p>
		<label>Busca produto (servidor)<input type="text" id="bsbd-product-search" placeholder="trecho SKU ou nome" autocomplete="off"></label>
		<label>Lote (cont\xe9m)<input type="text" id="bsbd-lot" placeholder="opcional" autocomplete="off"></label>
		<label>Modo
			<select id="bsbd-mode">
				<option value="blocked" selected>Apenas BLOQUEADOS (qtd bloqueada &gt; 0)</option>
				<option value="blocked_or_reserved">Bloqueados + Reservados</option>
				<option value="all">Todas as linhas com saldo (linhas 100% zeradas continuam ocultas)</option>
			</select>
		</label>
		<div class="row">
			<label>Pr\xe9via: limite<input type="number" id="bsbd-limit" value="200" min="1" max="5000" step="1"></label>
			<label>Pr\xe9via: offset<input type="number" id="bsbd-offset" value="0" min="0" step="1"></label>
			<label>CSV: m\xe1x. linhas<input type="number" id="bsbd-max-rows" value="50000" min="1" max="200000" step="1"></label>
		</div>
	</div>
	<div class="bsbd-actions">
		<button type="button" class="button bn_Preview">Pr\xe9via na tela</button>
		<button type="button" class="button bn_ExportCsv">Exportar CSV</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
        const dlg = (0, $dx9qz.default).create(dlgHtml, async (key)=>{
            const root = dlg.getNode();
            if (key === 'Escape') {
                dlg.destroy();
                return;
            }
            if (key !== 'Preview' && key !== 'ExportCsv') return;
            const sp = $95745c83cd57cc50$var$collectParams(root, key === 'Preview' ? 'json' : 'csv');
            if (!sp) {
                (0, $jUNyh.notify)('Selecione a empresa.');
                return;
            }
            const companyId = $95745c83cd57cc50$var$$('#bsbd-company', root).value.trim();
            if (key === 'Preview') {
                const mb = (0, $jUNyh.default)({
                    animation: true,
                    text: "Buscando linhas para pr\xe9via\u2026"
                });
                try {
                    const res = await (0, $9VcS9.default).stock_blocks_descriptive_report(companyId, sp.toString());
                    const raw = await res.text();
                    if (!res.ok) {
                        (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw) || res.statusText, 'Bloqueios descritivo');
                        return;
                    }
                    let data;
                    try {
                        data = JSON.parse(raw);
                    } catch (e) {
                        (0, $jUNyh.notify)("Resposta n\xe3o \xe9 JSON.", 'Bloqueios descritivo');
                        return;
                    }
                    if (!Array.isArray(data)) {
                        (0, $jUNyh.notify)('Formato inesperado da API.', 'Bloqueios descritivo');
                        return;
                    }
                    dlg.destroy();
                    $95745c83cd57cc50$var$renderPreviewTable(previewHost, data);
                    (0, $jUNyh.notify)(`Pr\xe9via: ${data.length} linha(s).`, 'Bloqueios descritivo');
                } catch (e) {
                    console.error(e);
                    (0, $jUNyh.notify)(e?.message || String(e), 'Bloqueios descritivo');
                } finally{
                    mb.destroy();
                }
                return;
            }
            const pg = (0, $dd3b449d8cadbeb3$export$2e2bcd8739ae039)({
                title: "Gerando CSV de bloqueios\u2026",
                text: "O servidor est\xe1 consolidando estoque, reservas e motivos de bloqueio. A barra fica indeterminada enquanto a query roda e passa a 0\u2192100% real assim que o download come\xe7a.",
                indeterminate: true
            });
            try {
                pg.markStage("Aguardando resposta do servidor (query SQL)\u2026");
                const res = await (0, $9VcS9.default).stock_blocks_descriptive_report(companyId, sp.toString());
                if (!res.ok) {
                    const t = await res.text();
                    (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, t), 'Bloqueios descritivo');
                    return;
                }
                pg.markStage("Recebendo CSV\u2026");
                const blob = await (0, $dd3b449d8cadbeb3$export$624f36fbda6d45c7)(res, pg);
                const cd = res.headers.get('Content-Disposition');
                let fname = 'bloqueios-descritivo.csv';
                if (cd) {
                    const m = cd.match(/filename="?([^";]+)"?/i);
                    if (m) fname = m[1];
                }
                $95745c83cd57cc50$var$downloadCsv(blob, fname);
                dlg.destroy();
                (0, $jUNyh.notify)('Download do CSV iniciado.', 'Bloqueios descritivo');
            } catch (e) {
                console.error(e);
                (0, $jUNyh.notify)(e?.message || String(e), 'Bloqueios descritivo');
            } finally{
                pg.destroy();
            }
        });
        const root = dlg.getNode();
        const selCo = $95745c83cd57cc50$var$$('#bsbd-company', root);
        const selWh = $95745c83cd57cc50$var$$('#bsbd-warehouse', root);
        const selPr = $95745c83cd57cc50$var$$('#bsbd-program', root);
        const selProd = $95745c83cd57cc50$var$$('#bsbd-product', root);
        const inpFilt = $95745c83cd57cc50$var$$('#bsbd-prod-filter', root);
        $95745c83cd57cc50$var$loadCompanies(selCo).then(()=>{});
        selCo.addEventListener('change', async ()=>{
            const id = selCo.value;
            await Promise.all([
                $95745c83cd57cc50$var$loadWarehouses(id, selWh),
                $95745c83cd57cc50$var$loadPrograms(id, selPr),
                $95745c83cd57cc50$var$loadProductsForCompany(id, selProd, inpFilt)
            ]);
        });
        inpFilt.addEventListener('input', ()=>$95745c83cd57cc50$var$applyProductSearch(selProd, inpFilt.value));
        selProd.addEventListener('change', ()=>$95745c83cd57cc50$var$applyProductSearch(selProd, inpFilt.value));
    };
    $95745c83cd57cc50$var$$('#bsbd-open-modal', work).addEventListener('click', openModal);
}


/**
 * BI — Auditoria (XLSX). Modal de tema (Entrada/Saída/Estoque) +
 * filtros dinâmicos. Faz POST JSON em /reports/audit e baixa o .xlsx.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $hWQyW = parcelRequire("hWQyW");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");


function $8aeea42f3245a670$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $8aeea42f3245a670$var$$all(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
}
function $8aeea42f3245a670$var$filterExprCompany(companyId) {
    return (0, $hWQyW.translate)({
        'field-0': 'company_id',
        'operator-0': 'eq',
        'value-0': companyId
    });
}
function $8aeea42f3245a670$var$skuLabel(p) {
    if (!p?.sku) return '';
    return Array.isArray(p.sku) ? p.sku.join('') : String(p.sku);
}
async function $8aeea42f3245a670$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch (e) {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
async function $8aeea42f3245a670$var$loadWarehouses(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const fe = encodeURIComponent($8aeea42f3245a670$var$filterExprCompany(companyId));
    const res = await (0, $9VcS9.default).list_warehouses(`?filter=${fe}&limit=0&sort=2`);
    if (!res.ok) return;
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const w of arr){
        const o = document.createElement('option');
        o.value = String(w.id);
        o.textContent = `${w.name ?? ''} (${w.id})`;
        sel.appendChild(o);
    }
}
async function $8aeea42f3245a670$var$loadPrograms(companyId, sel) {
    sel.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    const res = await (0, $9VcS9.default).list_programs_by_company(companyId);
    if (!res.ok) return;
    const arr = await res.json();
    if (!Array.isArray(arr)) return;
    for (const p of arr){
        const o = document.createElement('option');
        o.value = String(p.id);
        o.textContent = p.name || String(p.id);
        sel.appendChild(o);
    }
}
async function $8aeea42f3245a670$var$loadProductsForCompany(companyId, selectEl, searchInput) {
    selectEl.innerHTML = '';
    if (!companyId) {
        selectEl.innerHTML = '<option value="">\u2014 Escolha a empresa \u2014</option>';
        return;
    }
    selectEl.innerHTML = '<option value="">Carregando produtos\u2026</option>';
    selectEl.disabled = true;
    const mb = (0, $jUNyh.default)({
        animation: true,
        text: "Carregando produtos\u2026"
    });
    try {
        const fe = $8aeea42f3245a670$var$filterExprCompany(companyId);
        const batch = 500;
        const products = [];
        const seen = new Set();
        for(let offset = 0;; offset += batch){
            const q = `?filter=${encodeURIComponent(fe)}&limit=${batch}&offset=${offset}&sort=7&include_disabled=1`;
            const res = await (0, $9VcS9.default).list_products(q);
            if (!res.ok) {
                (0, $jUNyh.notify)(await res.text(), 'Produtos');
                selectEl.innerHTML = '<option value="">\u2014 Erro \u2014</option>';
                return;
            }
            const chunk = await res.json();
            if (!Array.isArray(chunk) || chunk.length === 0) break;
            for (const p of chunk){
                const id = p?.id;
                if (id == null || seen.has(id)) continue;
                seen.add(id);
                products.push(p);
            }
            if (chunk.length < batch) break;
        }
        selectEl.innerHTML = '<option value="">\u2014 Todos \u2014</option>';
        for (const p of products){
            const sku = $8aeea42f3245a670$var$skuLabel(p);
            const name = (p.name || '').trim() || '(sem nome)';
            const o = document.createElement('option');
            o.value = String(p.id);
            const dis = p.is_disabled ? ' [inativo]' : '';
            o.textContent = `${sku} \u{2014} ${name} (id ${p.id})${dis}`;
            selectEl.appendChild(o);
        }
        if (searchInput) $8aeea42f3245a670$var$applyProductSearch(selectEl, searchInput.value);
    } finally{
        selectEl.disabled = false;
        mb.destroy();
    }
}
function $8aeea42f3245a670$var$applyProductSearch(selectEl, needle) {
    const n = (needle || '').trim().toLowerCase();
    if (!n) {
        for (const o of selectEl.options)o.hidden = false;
        return;
    }
    for (const o of selectEl.options){
        if (!o.value) {
            o.hidden = false;
            continue;
        }
        o.hidden = !String(o.textContent || '').toLowerCase().includes(n);
    }
}
function $8aeea42f3245a670$var$nowDateTimeLocalDefault(daysAgo) {
    const d = new Date();
    if (daysAgo) d.setDate(d.getDate() - daysAgo);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
function $8aeea42f3245a670$var$readDatetime(input) {
    const v = (input?.value || '').trim();
    return v ? v.replace('T', ' ') + ':00' : '';
}
function $8aeea42f3245a670$var$buildPayload(node, theme) {
    const company_id = $8aeea42f3245a670$var$$('#bia-company', node)?.value?.trim();
    if (!company_id) return {
        error: 'Selecione a empresa.'
    };
    const date_from = $8aeea42f3245a670$var$readDatetime($8aeea42f3245a670$var$$('#bia-date-from', node));
    const date_to = $8aeea42f3245a670$var$readDatetime($8aeea42f3245a670$var$$('#bia-date-to', node));
    if (!date_from || !date_to) return {
        error: "Informe o per\xedodo (datas com hor\xe1rio)."
    };
    const filters = {
        date_from: date_from,
        date_to: date_to,
        product_id: $8aeea42f3245a670$var$$('#bia-product', node)?.value || null,
        program_id: $8aeea42f3245a670$var$$('#bia-program', node)?.value || null,
        lot_id: ($8aeea42f3245a670$var$$('#bia-lot', node)?.value || '').trim() || null
    };
    if (theme === 'input') {
        filters.input_id = ($8aeea42f3245a670$var$$('#bia-input-id', node)?.value || '').trim() || null;
        filters.invoice_number = ($8aeea42f3245a670$var$$('#bia-invoice-number', node)?.value || '').trim() || null;
        filters.supplier_id = ($8aeea42f3245a670$var$$('#bia-supplier-id', node)?.value || '').trim() || null;
    } else if (theme === 'output') {
        filters.output_id = ($8aeea42f3245a670$var$$('#bia-output-id', node)?.value || '').trim() || null;
        filters.output_order_id = ($8aeea42f3245a670$var$$('#bia-output-order-id', node)?.value || '').trim() || null;
        filters.customer_id = ($8aeea42f3245a670$var$$('#bia-customer-id', node)?.value || '').trim() || null;
    } else if (theme === 'stock') {
        filters.warehouse_id = $8aeea42f3245a670$var$$('#bia-warehouse', node)?.value || null;
        filters.location_id = ($8aeea42f3245a670$var$$('#bia-location-id', node)?.value || '').trim() || null;
    }
    for (const k of Object.keys(filters))if (filters[k] === '' || filters[k] == null) delete filters[k];
    return {
        company_id: company_id,
        payload: {
            theme: theme,
            filters: filters
        }
    };
}
function $8aeea42f3245a670$var$downloadXlsx(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'auditoria.xlsx';
    a.click();
    URL.revokeObjectURL(a.href);
}
function $8aeea42f3245a670$var$setBtnState(btn, loading, label) {
    if (!btn) return;
    if (loading) {
        btn.dataset.label = btn.textContent;
        btn.textContent = label || "Gerando\u2026";
        btn.disabled = true;
    } else {
        btn.textContent = btn.dataset.label || 'Gerar Excel';
        btn.disabled = false;
    }
}
async function $8aeea42f3245a670$var$postAudit(companyId, payload) {
    const res = await (0, $9VcS9.default).audit_report(companyId, payload);
    return res;
}
async function $8aeea42f3245a670$var$finishXlsx(res, dlg, pg) {
    if (!res.ok) {
        const t = await res.text();
        (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, t), 'Auditoria');
        return;
    }
    pg.markStage("Recebendo arquivo\u2026");
    const blob = await (0, $dd3b449d8cadbeb3$export$624f36fbda6d45c7)(res, pg);
    if (!blob || blob.size === 0) {
        (0, $jUNyh.notify)('Nenhum dado encontrado para os filtros aplicados.', 'Auditoria');
        return;
    }
    const cd = res.headers.get('Content-Disposition');
    let fname = 'auditoria.xlsx';
    if (cd) {
        const m = cd.match(/filename="?([^";]+)"?/i);
        if (m) fname = m[1];
    }
    $8aeea42f3245a670$var$downloadXlsx(blob, fname);
    dlg.destroy();
    (0, $jUNyh.notify)('Download do Excel iniciado.', 'Auditoria');
}
function $8aeea42f3245a670$var$themeFiltersHtml(theme) {
    if (theme === 'input') return `
			<div class="row">
				<label>Entrada (id Sial)<input type="number" id="bia-input-id" min="1" step="1" placeholder="opcional"></label>
				<label>N\xba NF<input type="text" id="bia-invoice-number" placeholder="opcional"></label>
				<label>Fornecedor (id)<input type="number" id="bia-supplier-id" min="1" step="1" placeholder="opcional"></label>
			</div>`;
    if (theme === 'output') return `
			<div class="row">
				<label>Sa\xedda (id Sial)<input type="number" id="bia-output-id" min="1" step="1" placeholder="opcional"></label>
				<label>Pedido de sa\xedda (id)<input type="number" id="bia-output-order-id" min="1" step="1" placeholder="opcional"></label>
				<label>Cliente (id)<input type="number" id="bia-customer-id" min="1" step="1" placeholder="opcional"></label>
			</div>`;
    return `
		<div class="row">
			<label>Armaz\xe9m<select id="bia-warehouse"></select></label>
			<label>Posi\xe7\xe3o (id)<input type="number" id="bia-location-id" min="1" step="1" placeholder="opcional"></label>
		</div>`;
}
async function $8aeea42f3245a670$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.bia-hint { color: #555; font-size: 0.9rem; max-width: 50rem; }
			.bia-modal label { display: block; margin-top: 0.65rem; }
			.bia-modal .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; margin-top: 0.35rem; }
			.bia-modal .row > label { flex: 1 1 14rem; }
			.bia-product-select { width: 100%; min-height: 9rem; margin-top: 0.35rem; font-size: 0.88rem; }
			.bia-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
			.bia-themes { display: flex; gap: 0.75rem; margin-top: 0.5rem; flex-wrap: wrap; }
			.bia-theme-card { flex: 1 1 11rem; min-height: 5.5rem; border: 2px solid #ccc; border-radius: 0.5rem; padding: 0.75rem; cursor: pointer; background: #fff; }
			.bia-theme-card.selected { border-color: #1F4E78; background: #E8F1FB; }
			.bia-theme-card .ti { font-size: 1.2rem; font-weight: bold; }
			.bia-theme-card .desc { color: #555; font-size: 0.85rem; margin-top: 0.25rem; }
			#bia-theme-fields { margin-top: 0.5rem; }
		</style>
		<div class="title">Auditoria (BI)</div>
		<p class="mts bia-hint">Gera um arquivo <strong>Excel (.xlsx)</strong> com 4 abas (Resumo, Hist\xf3rico de Status, Movimentos de Estoque, Participantes) para o tema escolhido. Hist\xf3rico de status \xe9 derivado das transa\xe7\xf5es de estoque. Limite padr\xe3o: 10 mil linhas por aba.</p>
		<p class="mts"><button type="button" class="button" id="bia-open-modal">Abrir filtros</button></p>
	`;
    const openModal = ()=>{
        const dlgHtml = `
<div class="msgbox bia-modal" style="min-width: min(46rem, 94vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Auditoria \u{2014} filtros</div>
	<div class="mb-text" style="max-height: none;">
		<label>Tema do relat\xf3rio<sup>*</sup></label>
		<div class="bia-themes" id="bia-theme-cards">
			<div class="bia-theme-card selected" data-theme="input">
				<div class="ti">Entrada</div>
				<div class="desc">Auditoria de uma entrada (recebimento, lotes vinculados, NF).</div>
			</div>
			<div class="bia-theme-card" data-theme="output">
				<div class="ti">Sa\xedda</div>
				<div class="desc">Auditoria de uma sa\xedda/pedido (separa\xe7\xe3o, expedi\xe7\xe3o, cancelamentos).</div>
			</div>
			<div class="bia-theme-card" data-theme="stock">
				<div class="ti">Estoque</div>
				<div class="desc">Auditoria por filtro composto (produto/lote/posi\xe7\xe3o) num per\xedodo.</div>
			</div>
		</div>
		<label>Empresa<sup>*</sup><select id="bia-company"></select></label>
		<div class="row">
			<label>Per\xedodo \u{2014} in\xedcio<sup>*</sup><input type="datetime-local" id="bia-date-from"></label>
			<label>Per\xedodo \u{2014} fim<sup>*</sup><input type="datetime-local" id="bia-date-to"></label>
		</div>
		<div class="row">
			<label>Programa<select id="bia-program"></select></label>
			<label>Lote (id)<input type="number" id="bia-lot" min="1" step="1" placeholder="opcional"></label>
		</div>
		<label>Filtrar lista de produtos (SKU ou nome)<input type="search" id="bia-prod-filter" placeholder="opcional" autocomplete="off"></label>
		<label>Produto<select id="bia-product" class="bia-product-select" size="8"></select></label>
		<div id="bia-theme-fields"></div>
	</div>
	<div class="bia-actions">
		<button type="button" class="button bn_Generate">Gerar Excel</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
        const dlg = (0, $dx9qz.default).create(dlgHtml, async (key)=>{
            const root = dlg.getNode();
            if (key === 'Escape') {
                dlg.destroy();
                return;
            }
            if (key !== 'Generate') return;
            const theme = root.querySelector('.bia-theme-card.selected')?.dataset?.theme || 'input';
            const built = $8aeea42f3245a670$var$buildPayload(root, theme);
            if (built.error) {
                (0, $jUNyh.notify)(built.error, 'Auditoria');
                return;
            }
            const btn = root.querySelector('.bn_Generate');
            $8aeea42f3245a670$var$setBtnState(btn, true, "Gerando\u2026");
            const pg = (0, $dd3b449d8cadbeb3$export$2e2bcd8739ae039)({
                title: "Gerando auditoria (XLSX)\u2026",
                text: "O servidor est\xe1 consultando transa\xe7\xf5es, status e participantes. Pode levar alguns instantes para conjuntos grandes.",
                indeterminate: true
            });
            try {
                pg.markStage("Aguardando resposta do servidor\u2026");
                let res = await $8aeea42f3245a670$var$postAudit(built.company_id, built.payload);
                if (res.status === 409) {
                    let info = {};
                    try {
                        info = await res.json();
                    } catch (e) {}
                    if (info?.exceeded) {
                        pg.destroy();
                        const ok = window.confirm(`A aba \xab${info.sheet}\xbb tem ${info.count} linhas (acima do limite recomendado de 10.000). ` + `O ficheiro ser\xe1 truncado nessa aba. Deseja continuar mesmo assim?`);
                        if (!ok) {
                            $8aeea42f3245a670$var$setBtnState(btn, false);
                            return;
                        }
                        const pg2 = (0, $dd3b449d8cadbeb3$export$2e2bcd8739ae039)({
                            title: "Gerando auditoria (XLSX) \u2014 modo estendido\u2026",
                            text: 'Confirmado: gerando arquivo com mais de 10 mil linhas em alguma aba.',
                            indeterminate: true
                        });
                        pg2.markStage("Aguardando resposta do servidor\u2026");
                        try {
                            res = await $8aeea42f3245a670$var$postAudit(built.company_id, {
                                ...built.payload,
                                confirm_over_limit: true
                            });
                            await $8aeea42f3245a670$var$finishXlsx(res, dlg, pg2);
                        } finally{
                            pg2.destroy();
                            $8aeea42f3245a670$var$setBtnState(btn, false);
                        }
                        return;
                    }
                }
                await $8aeea42f3245a670$var$finishXlsx(res, dlg, pg);
            } catch (e) {
                console.error(e);
                (0, $jUNyh.notify)(e?.message || String(e), 'Auditoria');
            } finally{
                pg.destroy();
                $8aeea42f3245a670$var$setBtnState(btn, false);
            }
        });
        const root = dlg.getNode();
        const selCo = $8aeea42f3245a670$var$$('#bia-company', root);
        const selPr = $8aeea42f3245a670$var$$('#bia-program', root);
        const selProd = $8aeea42f3245a670$var$$('#bia-product', root);
        const inpFilt = $8aeea42f3245a670$var$$('#bia-prod-filter', root);
        const dtFrom = $8aeea42f3245a670$var$$('#bia-date-from', root);
        const dtTo = $8aeea42f3245a670$var$$('#bia-date-to', root);
        const themeFields = $8aeea42f3245a670$var$$('#bia-theme-fields', root);
        const themeCards = $8aeea42f3245a670$var$$all('.bia-theme-card', root);
        dtFrom.value = $8aeea42f3245a670$var$nowDateTimeLocalDefault(7);
        dtTo.value = $8aeea42f3245a670$var$nowDateTimeLocalDefault(0);
        const renderThemeFields = (theme)=>{
            themeFields.innerHTML = $8aeea42f3245a670$var$themeFiltersHtml(theme);
            if (theme === 'stock') {
                const wh = $8aeea42f3245a670$var$$('#bia-warehouse', themeFields);
                if (wh) $8aeea42f3245a670$var$loadWarehouses(selCo.value, wh);
            }
        };
        renderThemeFields('input');
        themeCards.forEach((card)=>{
            card.addEventListener('click', ()=>{
                themeCards.forEach((c)=>c.classList.remove('selected'));
                card.classList.add('selected');
                renderThemeFields(card.dataset.theme);
            });
        });
        $8aeea42f3245a670$var$loadCompanies(selCo).then(()=>{});
        selCo.addEventListener('change', async ()=>{
            const id = selCo.value;
            await Promise.all([
                $8aeea42f3245a670$var$loadPrograms(id, selPr),
                $8aeea42f3245a670$var$loadProductsForCompany(id, selProd, inpFilt)
            ]);
            const wh = $8aeea42f3245a670$var$$('#bia-warehouse', themeFields);
            if (wh) await $8aeea42f3245a670$var$loadWarehouses(id, wh);
        });
        inpFilt.addEventListener('input', ()=>$8aeea42f3245a670$var$applyProductSearch(selProd, inpFilt.value));
    };
    $8aeea42f3245a670$var$$('#bia-open-modal', work).addEventListener('click', openModal);
}


/**
 * BI > Linhas de saída — modal de filtros, prévia JSON e CSV.
 * Base: doc/queries/bi-output-lines.sql (serviço `output_lines_report`).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");

function $022b4203f5491b3e$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $022b4203f5491b3e$var$defaultDateFirstOfMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function $022b4203f5491b3e$var$defaultToday() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
async function $022b4203f5491b3e$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch (e) {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
function $022b4203f5491b3e$var$collectParams(node, format) {
    const companyId = $022b4203f5491b3e$var$$('#biol-company', node)?.value?.trim();
    if (!companyId) {
        (0, $jUNyh.notify)('Selecione a empresa.');
        return null;
    }
    const df = $022b4203f5491b3e$var$$('#biol-date-from', node)?.value?.trim();
    if (!df) {
        (0, $jUNyh.notify)('Informe a data inicial.');
        return null;
    }
    const sp = new URLSearchParams();
    sp.set('format', format);
    sp.set('date_from', df);
    const dt = $022b4203f5491b3e$var$$('#biol-date-to', node)?.value?.trim();
    if (dt) sp.set('date_to', dt);
    if ($022b4203f5491b3e$var$$('#biol-include-disabled', node)?.checked) sp.set('include_disabled', '1');
    const sid = $022b4203f5491b3e$var$$('#biol-output-id', node)?.value?.trim();
    if (sid) sp.set('output_id', sid);
    const oid = $022b4203f5491b3e$var$$('#biol-order-id', node)?.value?.trim();
    if (oid) sp.set('output_order_id', oid);
    const pid = $022b4203f5491b3e$var$$('#biol-product-id', node)?.value?.trim();
    if (pid) sp.set('product_id', pid);
    else {
        const ps = $022b4203f5491b3e$var$$('#biol-product-search', node)?.value?.trim();
        if (ps) sp.set('product_search', ps);
    }
    if (format === 'json') {
        sp.set('limit', $022b4203f5491b3e$var$$('#biol-limit', node)?.value || '200');
        sp.set('offset', $022b4203f5491b3e$var$$('#biol-offset', node)?.value || '0');
    } else {
        const mx = $022b4203f5491b3e$var$$('#biol-max-rows', node)?.value?.trim();
        if (mx) sp.set('max_rows', mx);
    }
    return {
        companyId: companyId,
        sp: sp
    };
}
function $022b4203f5491b3e$var$escCell(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $022b4203f5491b3e$var$renderPreviewTable(container, rows) {
    if (!rows?.length) {
        container.innerHTML = '<p class="muted mts">Nenhuma linha (ajuste filtros ou permiss\xf5es).</p>';
        return;
    }
    const keys = Object.keys(rows[0]);
    let html = '<div class="biol-scroll mts"><table class="view fsx"><thead><tr>';
    for (const k of keys)html += `<th>${$022b4203f5491b3e$var$escCell(k)}</th>`;
    html += '</tr></thead><tbody>';
    for (const r of rows){
        html += '<tr>';
        for (const k of keys)html += `<td>${$022b4203f5491b3e$var$escCell(r[k])}</td>`;
        html += '</tr>';
    }
    html += '</tbody></table></div>';
    container.innerHTML = html;
}
function $022b4203f5491b3e$var$downloadCsv(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'bi-linhas-saida.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $022b4203f5491b3e$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.biol-hint { color: #555; font-size: 0.9rem; max-width: 48rem; }
			.biol-scroll { overflow: auto; max-height: 65vh; }
			.biol-modal label { display: block; margin-top: 0.65rem; }
			.biol-modal .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; margin-top: 0.35rem; }
			.biol-modal .row > label { flex: 1 1 12rem; }
			.biol-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
			.biol-check { margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem; }
		</style>
		<div class="title">Linhas de sa\xedda (BI)</div>
		<p class="mts biol-hint">Extra\xe7\xe3o por <strong>per\xedodo de cria\xe7\xe3o da sa\xedda</strong> (fuso Am\xe9rica/S\xe3o Paulo), com empresa, opcionalmente sa\xedda, pedido de sa\xedda e produto. Inclui status da sa\xedda e do pedido, cliente, lote, quantidades, <strong>armaz\xe9m</strong> e <strong>posi\xe7\xe3o (endere\xe7o)</strong> consumida em cada linha do item. Datas/hor\xe1rios (cria\xe7\xe3o e separa\xe7\xe3o) saem em <strong>hor\xe1rio de Bras\xedlia</strong>. Use <strong>Pr\xe9via</strong> ou <strong>CSV</strong>.</p>
		<p class="mts"><button type="button" class="button" id="biol-open-modal">Filtros e gera\xe7\xe3o</button></p>
		<div id="biol-preview-host" class="mts"></div>
	`;
    const previewHost = $022b4203f5491b3e$var$$('#biol-preview-host', work);
    const openModal = ()=>{
        const dlgHtml = `
<div class="msgbox biol-modal" style="min-width: min(38rem, 92vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Linhas de sa\xedda \u{2014} filtros</div>
	<div class="mb-text" style="max-height: none;">
		<label>Empresa<sup>*</sup><select id="biol-company"></select></label>
		<div class="row">
			<label>Data inicial<sup>*</sup><input type="date" id="biol-date-from" required></label>
			<label>Data final<input type="date" id="biol-date-to" title="Vazio = at\xe9 hoje (fuso SP)"></label>
		</div>
		<div class="biol-check">
			<input type="checkbox" id="biol-include-disabled">
			<label for="biol-include-disabled" style="margin:0;">Incluir sa\xeddas exclu\xeddas (status 999)</label>
		</div>
		<div class="row">
			<label>N\xba sa\xedda (opcional)<input type="number" id="biol-output-id" min="1" step="1" placeholder="id outputs"></label>
			<label>N\xba pedido sa\xedda (opcional)<input type="number" id="biol-order-id" min="1" step="1" placeholder="id output_orders"></label>
		</div>
		<div class="row">
			<label>ID produto (opcional)<input type="number" id="biol-product-id" min="1" step="1" placeholder="sobrepor busca texto"></label>
			<label>Busca produto (SKU ou nome)<input type="text" id="biol-product-search" placeholder="se n\xe3o informou ID" autocomplete="off"></label>
		</div>
		<div class="row">
			<label>Pr\xe9via: limite<input type="number" id="biol-limit" value="200" min="1" max="5000" step="1"></label>
			<label>Pr\xe9via: offset<input type="number" id="biol-offset" value="0" min="0" step="1"></label>
			<label>CSV: m\xe1x. linhas<input type="number" id="biol-max-rows" value="50000" min="1" max="200000" step="1"></label>
		</div>
	</div>
	<div class="biol-actions">
		<button type="button" class="button bn_Preview">Pr\xe9via na tela</button>
		<button type="button" class="button bn_ExportCsv">Exportar CSV</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
        const dlg = (0, $dx9qz.default).create(dlgHtml, async (key)=>{
            const root = dlg.getNode();
            if (key === 'Escape') {
                dlg.destroy();
                return;
            }
            if (key !== 'Preview' && key !== 'ExportCsv') return;
            const pack = $022b4203f5491b3e$var$collectParams(root, key === 'Preview' ? 'json' : 'csv');
            if (!pack) return;
            try {
                if (key === 'Preview') {
                    const res = await (0, $9VcS9.default).output_lines_report(pack.companyId, pack.sp.toString());
                    const raw = await res.text();
                    if (!res.ok) {
                        (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw), "Linhas de sa\xedda");
                        return;
                    }
                    let data;
                    try {
                        data = JSON.parse(raw);
                    } catch (e) {
                        (0, $jUNyh.notify)("Resposta n\xe3o \xe9 JSON.", "Linhas de sa\xedda");
                        return;
                    }
                    if (!Array.isArray(data)) {
                        (0, $jUNyh.notify)('Formato inesperado da API.', "Linhas de sa\xedda");
                        return;
                    }
                    dlg.destroy();
                    $022b4203f5491b3e$var$renderPreviewTable(previewHost, data);
                    (0, $jUNyh.notify)(`Pr\xe9via: ${data.length} linha(s).`, "Linhas de sa\xedda");
                    return;
                }
                const res = await (0, $9VcS9.default).output_lines_report(pack.companyId, pack.sp.toString());
                if (!res.ok) {
                    const t = await res.text();
                    (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, t), "Linhas de sa\xedda");
                    return;
                }
                const blob = await res.blob();
                const cd = res.headers.get('Content-Disposition');
                let fname = 'bi-linhas-saida.csv';
                if (cd) {
                    const m = cd.match(/filename="?([^";]+)"?/i);
                    if (m) fname = m[1];
                }
                $022b4203f5491b3e$var$downloadCsv(blob, fname);
                dlg.destroy();
                (0, $jUNyh.notify)('Download do CSV iniciado.', "Linhas de sa\xedda");
            } catch (e) {
                console.error(e);
                (0, $jUNyh.notify)(e?.message || String(e), "Linhas de sa\xedda");
            }
        });
        const root = dlg.getNode();
        const df = $022b4203f5491b3e$var$$('#biol-date-from', root);
        const dt = $022b4203f5491b3e$var$$('#biol-date-to', root);
        if (df && !df.value) df.value = $022b4203f5491b3e$var$defaultDateFirstOfMonth();
        if (dt && !dt.value) dt.value = $022b4203f5491b3e$var$defaultToday();
        $022b4203f5491b3e$var$loadCompanies($022b4203f5491b3e$var$$('#biol-company', root)).then(()=>{});
    };
    $022b4203f5491b3e$var$$('#biol-open-modal', work).addEventListener('click', openModal);
}


/**
 * BI > Produtividade por funcionário (#MT-D900606).
 * Separação + Conferência; início Separação = proxy; Conferência = checked_at (#MT-9C49478).
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

var $dx9qz = parcelRequire("dx9qz");


/** Máximo de linhas de detalhe renderizadas na prévia (evita travar o navegador). */ const $0e7b01c5410eb81b$var$PREVIEW_DETAIL_CAP = 80;
/** Alinhado à API: detalhe/prévia 31 dias; resumo 93. Evita 502 do nginx (timeout 300s). */ const $0e7b01c5410eb81b$var$MAX_DAYS_DETAIL = 31;
const $0e7b01c5410eb81b$var$MAX_DAYS_SUMMARY = 93;
function $0e7b01c5410eb81b$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $0e7b01c5410eb81b$var$defaultDateFirstOfMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function $0e7b01c5410eb81b$var$defaultToday() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function $0e7b01c5410eb81b$var$yieldToMain() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>setTimeout(resolve, 0));
    });
}
function $0e7b01c5410eb81b$var$setBtnState(btn, loading, label) {
    if (!btn) return;
    if (loading) {
        if (!btn.dataset.label) btn.dataset.label = btn.textContent;
        btn.textContent = label || "Gerando\u2026";
        btn.disabled = true;
    } else {
        btn.textContent = btn.dataset.label || btn.textContent;
        btn.disabled = false;
    }
}
function $0e7b01c5410eb81b$var$setModalBusy(root, busy) {
    const keys = [
        'Preview',
        'ExportCsv',
        'ExportSummary',
        'Escape'
    ];
    for (const k of keys){
        const btn = root.querySelector(`.bn_${k}`);
        if (!btn) continue;
        if (busy && k !== 'Escape') $0e7b01c5410eb81b$var$setBtnState(btn, true, "Gerando\u2026");
        else if (!busy) $0e7b01c5410eb81b$var$setBtnState(btn, false);
    }
}
async function $0e7b01c5410eb81b$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch (e) {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
function $0e7b01c5410eb81b$var$parseIsoDate(s) {
    if (!s) return null;
    const d = new Date(`${s}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
}
function $0e7b01c5410eb81b$var$inclusiveDays(fromStr, toStr) {
    const from = $0e7b01c5410eb81b$var$parseIsoDate(fromStr);
    if (!from) return 0;
    const to = $0e7b01c5410eb81b$var$parseIsoDate(toStr) || new Date();
    to.setHours(0, 0, 0, 0);
    from.setHours(0, 0, 0, 0);
    return Math.floor((to - from) / 86400000) + 1;
}
function $0e7b01c5410eb81b$var$maxDaysForView(view) {
    return view === 'summary' ? $0e7b01c5410eb81b$var$MAX_DAYS_SUMMARY : $0e7b01c5410eb81b$var$MAX_DAYS_DETAIL;
}
function $0e7b01c5410eb81b$var$windowError(fromStr, toStr, view) {
    if (!fromStr) return 'Informe a data inicial.';
    const days = $0e7b01c5410eb81b$var$inclusiveDays(fromStr, toStr);
    if (days < 1) return "A data final n\xe3o pode ser anterior \xe0 inicial.";
    const cap = $0e7b01c5410eb81b$var$maxDaysForView(view);
    if (days > cap) {
        const kind = view === 'summary' ? 'CSV resumo' : "pr\xe9via e CSV detalhe";
        return `Per\xedodo de ${days} dias excede o m\xe1ximo de ${cap} dias para ${kind}. Reduza as datas ou use o CSV resumo (at\xe9 ${$0e7b01c5410eb81b$var$MAX_DAYS_SUMMARY} dias).`;
    }
    return '';
}
function $0e7b01c5410eb81b$var$syncWindowGuard(root) {
    const df = $0e7b01c5410eb81b$var$$('#biop-date-from', root)?.value?.trim();
    const dt = $0e7b01c5410eb81b$var$$('#biop-date-to', root)?.value?.trim();
    const days = df ? $0e7b01c5410eb81b$var$inclusiveDays(df, dt) : 0;
    const hint = $0e7b01c5410eb81b$var$$('#biop-window-hint', root);
    const errDetail = $0e7b01c5410eb81b$var$windowError(df, dt, 'detail');
    const errSummary = $0e7b01c5410eb81b$var$windowError(df, dt, 'summary');
    if (hint) {
        if (!df) hint.textContent = `Pr\xe9via e CSV detalhe: no m\xe1ximo ${$0e7b01c5410eb81b$var$MAX_DAYS_DETAIL} dias. CSV resumo: at\xe9 ${$0e7b01c5410eb81b$var$MAX_DAYS_SUMMARY} dias.`;
        else if (errDetail && errSummary) hint.textContent = errSummary;
        else if (errDetail) hint.textContent = `${days} dia(s) no filtro. ${errDetail}`;
        else hint.textContent = `${days} dia(s) no filtro (m\xe1x. ${$0e7b01c5410eb81b$var$MAX_DAYS_DETAIL} no detalhe / ${$0e7b01c5410eb81b$var$MAX_DAYS_SUMMARY} no resumo).`;
    }
    const btnPrev = root.querySelector('.bn_Preview');
    const btnCsv = root.querySelector('.bn_ExportCsv');
    const btnSum = root.querySelector('.bn_ExportSummary');
    if (btnPrev) btnPrev.disabled = !df || !!errDetail;
    if (btnCsv) btnCsv.disabled = !df || !!errDetail;
    if (btnSum) btnSum.disabled = !df || !!errSummary;
}
function $0e7b01c5410eb81b$var$collectParams(node, format, view) {
    const companyId = $0e7b01c5410eb81b$var$$('#biop-company', node)?.value?.trim();
    if (!companyId) {
        (0, $jUNyh.notify)('Selecione a empresa.');
        return null;
    }
    const df = $0e7b01c5410eb81b$var$$('#biop-date-from', node)?.value?.trim();
    if (!df) {
        (0, $jUNyh.notify)('Informe a data inicial.');
        return null;
    }
    const dt = $0e7b01c5410eb81b$var$$('#biop-date-to', node)?.value?.trim();
    const winErr = $0e7b01c5410eb81b$var$windowError(df, dt, view === 'summary' ? 'summary' : 'detail');
    if (winErr) {
        (0, $jUNyh.notify)(winErr, 'Produtividade');
        return null;
    }
    const sp = new URLSearchParams();
    sp.set('format', format);
    sp.set('date_from', df);
    if (dt) sp.set('date_to', dt);
    sp.set('activity', $0e7b01c5410eb81b$var$$('#biop-activity', node)?.value || 'both');
    if (view) sp.set('view', view);
    if ($0e7b01c5410eb81b$var$$('#biop-include-disabled', node)?.checked) sp.set('include_disabled', '1');
    const uid = $0e7b01c5410eb81b$var$$('#biop-user-id', node)?.value?.trim();
    if (uid) sp.set('user_id', uid);
    else {
        const us = $0e7b01c5410eb81b$var$$('#biop-user-search', node)?.value?.trim();
        if (us) sp.set('user_search', us);
    }
    const sid = $0e7b01c5410eb81b$var$$('#biop-output-id', node)?.value?.trim();
    if (sid) sp.set('output_id', sid);
    const oid = $0e7b01c5410eb81b$var$$('#biop-order-id', node)?.value?.trim();
    if (oid) sp.set('output_order_id', oid);
    const pid = $0e7b01c5410eb81b$var$$('#biop-product-id', node)?.value?.trim();
    if (pid) sp.set('product_id', pid);
    else {
        const ps = $0e7b01c5410eb81b$var$$('#biop-product-search', node)?.value?.trim();
        if (ps) sp.set('product_search', ps);
    }
    if (format === 'json') {
        sp.set('limit', $0e7b01c5410eb81b$var$$('#biop-limit', node)?.value || '200');
        sp.set('offset', $0e7b01c5410eb81b$var$$('#biop-offset', node)?.value || '0');
        sp.set('max_rows', $0e7b01c5410eb81b$var$$('#biop-max-rows', node)?.value || '50000');
    } else {
        const mx = $0e7b01c5410eb81b$var$$('#biop-max-rows', node)?.value?.trim();
        if (mx) sp.set('max_rows', mx);
    }
    return {
        companyId: companyId,
        sp: sp
    };
}
function $0e7b01c5410eb81b$var$cellText(v) {
    if (v == null) return '';
    return String(v);
}
function $0e7b01c5410eb81b$var$fmtInd(v) {
    if (v == null || v === '') return "\u2014";
    return $0e7b01c5410eb81b$var$cellText(v);
}
/** Prévia com textContent (innerHTML + template.innerHTML vinha vazio no Chrome). */ function $0e7b01c5410eb81b$var$renderPreviewTable(container, rows, title, opts = {}) {
    container.replaceChildren();
    const cap = opts.cap != null ? opts.cap : rows?.length;
    const slice = (rows || []).slice(0, cap);
    const total = rows?.length || 0;
    if (!slice.length) {
        const p = document.createElement('p');
        p.className = 'muted mts';
        p.textContent = `${title}: nenhuma linha.`;
        container.appendChild(p);
        return;
    }
    const keys = Object.keys(slice[0]);
    const section = document.createElement('div');
    section.className = 'biop-section mts';
    const head = document.createElement('div');
    head.className = 'biop-section-title';
    head.append(title, ' ');
    const count = document.createElement('span');
    count.className = 'biop-count';
    count.textContent = `(${slice.length}${total > slice.length ? ` de ${total}` : ''})`;
    head.appendChild(count);
    section.appendChild(head);
    if (opts.note) {
        const note = document.createElement('p');
        note.className = 'biop-hint';
        note.textContent = opts.note;
        section.appendChild(note);
    }
    const scroll = document.createElement('div');
    scroll.className = 'biop-scroll';
    const table = document.createElement('table');
    table.className = 'ibe-table';
    const thead = document.createElement('thead');
    const hr = document.createElement('tr');
    for (const k of keys){
        const th = document.createElement('th');
        th.textContent = k;
        hr.appendChild(th);
    }
    thead.appendChild(hr);
    table.appendChild(thead);
    const tbody = document.createElement('tbody');
    const frag = document.createDocumentFragment();
    for (const r of slice){
        const tr = document.createElement('tr');
        for (const k of keys){
            const td = document.createElement('td');
            td.textContent = $0e7b01c5410eb81b$var$cellText(r[k]);
            tr.appendChild(td);
        }
        frag.appendChild(tr);
    }
    tbody.appendChild(frag);
    table.appendChild(tbody);
    scroll.appendChild(table);
    section.appendChild(scroll);
    container.appendChild(section);
}
function $0e7b01c5410eb81b$var$renderIndicators(container, ind, meta) {
    container.replaceChildren();
    const i = ind && typeof ind === 'object' ? ind : {};
    const wrap = document.createElement('div');
    wrap.className = 'biop-ind mts';
    const title = document.createElement('strong');
    title.textContent = "Indicadores do per\xedodo (filtro atual)";
    wrap.appendChild(title);
    const ul = document.createElement('ul');
    const items = [
        [
            "Sa\xeddas (atividades)",
            $0e7b01c5410eb81b$var$fmtInd(i.n_saidas)
        ],
        [
            "Funcion\xe1rios",
            $0e7b01c5410eb81b$var$fmtInd(i.n_funcionarios)
        ],
        [
            'Linhas SKU',
            $0e7b01c5410eb81b$var$fmtInd(i.n_linhas_sku)
        ],
        [
            'Qtd requerida / conferida',
            `${$0e7b01c5410eb81b$var$fmtInd(i.soma_qtd_requerida)} / ${$0e7b01c5410eb81b$var$fmtInd(i.soma_qtd_conferida)}`
        ],
        [
            "Tempo m\xe9dio / pedido",
            $0e7b01c5410eb81b$var$fmtInd(i.tempo_medio_pedido)
        ],
        [
            "Tempo m\xe9dio / linha SKU (proxy)",
            $0e7b01c5410eb81b$var$fmtInd(i.tempo_medio_sku)
        ],
        [
            "Itens/hora (qtd conferida \xf7 horas)",
            $0e7b01c5410eb81b$var$fmtInd(i.itens_por_hora)
        ]
    ];
    for (const [label, value] of items){
        const li = document.createElement('li');
        li.textContent = `${label}: `;
        const strong = document.createElement('strong');
        strong.textContent = value;
        li.appendChild(strong);
        ul.appendChild(li);
    }
    wrap.appendChild(ul);
    if (meta?.inicio_regra) {
        const hint = document.createElement('p');
        hint.className = 'biop-hint';
        hint.textContent = meta.inicio_regra;
        wrap.appendChild(hint);
    }
    container.appendChild(wrap);
}
function $0e7b01c5410eb81b$var$showPreviewLoading(indHost, summaryHost, previewHost) {
    indHost.replaceChildren();
    summaryHost.replaceChildren();
    previewHost.replaceChildren();
    const p = document.createElement('p');
    p.className = 'biop-loading muted mts';
    p.textContent = "Gerando relat\xf3rio\u2026 aguarde.";
    indHost.appendChild(p);
}
async function $0e7b01c5410eb81b$var$renderPreviewResults(indHost, summaryHost, previewHost, data, pg) {
    const meta = data.meta || {};
    const detail = data.detail || [];
    const summary = data.summary || [];
    const detailTotal = meta.detail_total ?? detail.length;
    const pageCount = detail.length;
    const showCount = Math.min(pageCount, $0e7b01c5410eb81b$var$PREVIEW_DETAIL_CAP);
    if (pg) pg.markStage("Montando indicadores\u2026");
    $0e7b01c5410eb81b$var$renderIndicators(indHost, data.indicators, meta);
    await $0e7b01c5410eb81b$var$yieldToMain();
    if (pg) pg.markStage("Montando resumo por funcion\xe1rio\u2026");
    $0e7b01c5410eb81b$var$renderPreviewTable(summaryHost, summary, "Resumo por funcion\xe1rio");
    await $0e7b01c5410eb81b$var$yieldToMain();
    let detailNote = null;
    if (pageCount > showCount) detailNote = `Exibindo ${showCount} de ${pageCount} linha(s) desta p\xe1gina (${detailTotal} no per\xedodo). Use CSV detalhe para o conjunto completo.`;
    else if (detailTotal > pageCount) detailNote = `P\xe1gina com ${pageCount} linha(s) de ${detailTotal} no per\xedodo (ajuste offset/limite ou exporte CSV).`;
    if (pg) pg.markStage("Montando amostra do detalhe\u2026");
    $0e7b01c5410eb81b$var$renderPreviewTable(previewHost, detail, "Detalhe (p\xe1gina)", {
        cap: $0e7b01c5410eb81b$var$PREVIEW_DETAIL_CAP,
        note: detailNote
    });
    await $0e7b01c5410eb81b$var$yieldToMain();
}
function $0e7b01c5410eb81b$var$downloadCsv(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'bi-produtividade.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $0e7b01c5410eb81b$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.biop-hint { color: #555; font-size: 0.9rem; max-width: 52rem; }
			.biop-scroll {
				overflow: auto;
				max-height: 55vh;
				margin-top: 0.35rem;
				border: 1px solid var(--color-border, #cbd5e1);
				border-radius: 2px;
				background: #fff;
			}
			.biop-modal label { display: block; margin-top: 0.65rem; }
			.biop-modal .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; margin-top: 0.35rem; }
			.biop-modal .row > label { flex: 1 1 12rem; }
			.biop-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
			.biop-check { margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem; }
			.biop-ind ul { margin: 0.35rem 0 0 1.1rem; }
			.biop-ind { max-width: 52rem; }
			.biop-section-title { font-weight: 600; font-size: 1rem; margin-bottom: 0.25rem; }
			.biop-count { font-weight: 400; color: #555; }
			.biop-loading { font-style: italic; }
		</style>
		<div class="title">Produtividade por funcion\xe1rio</div>
		<p class="mts biop-hint">
			Relat\xf3rio de <strong>Separa\xe7\xe3o</strong> e/ou <strong>Confer\xeancia</strong> por per\xedodo do
			<strong>fim da atividade</strong> (hor\xe1rio de Bras\xedlia). SKU e quantidades
			<strong>requerida</strong> e <strong>conferida</strong>.
			Na <strong>Separa\xe7\xe3o</strong>, in\xedcio \xe9 estimado (cria\xe7\xe3o / primeira reserva) e o tempo \xe9 por sa\xedda
			(repetido nas linhas de produto \u{2014} n\xe3o \xe9 cron\xf4metro por SKU).
			Na <strong>Confer\xeancia</strong>, in\xedcio e fim s\xe3o a <strong>data e hora em que a fatura foi conferida</strong>;
			o tempo gasto fica em branco (n\xe3o inclui a espera desde a separa\xe7\xe3o).
			In\xedcio real no coletor fica para fase futura.
		</p>
		<p class="mts"><button type="button" class="button" id="biop-open-modal">Filtros e gera\xe7\xe3o</button></p>
		<div id="biop-indicators" class="mts"></div>
		<div id="biop-summary-host" class="mts"></div>
		<div id="biop-preview-host" class="mts"></div>
	`;
    const previewHost = $0e7b01c5410eb81b$var$$('#biop-preview-host', work);
    const summaryHost = $0e7b01c5410eb81b$var$$('#biop-summary-host', work);
    const indHost = $0e7b01c5410eb81b$var$$('#biop-indicators', work);
    const openModal = ()=>{
        const dlgHtml = `
<div class="msgbox biop-modal" style="min-width: min(40rem, 92vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Produtividade \u{2014} filtros</div>
	<div class="mb-text" style="max-height: none;">
		<label>Empresa<sup>*</sup><select id="biop-company"></select></label>
		<div class="row">
			<label>Data inicial<sup>*</sup><input type="date" id="biop-date-from" required></label>
			<label>Data final<input type="date" id="biop-date-to" title="Vazio = at\xe9 hoje (fuso SP)"></label>
			<label>Tipo de atividade
				<select id="biop-activity">
					<option value="both">Separa\xe7\xe3o e Confer\xeancia</option>
					<option value="picking">S\xf3 Separa\xe7\xe3o</option>
					<option value="conference">S\xf3 Confer\xeancia</option>
				</select>
			</label>
		</div>
		<div class="biop-check">
			<input type="checkbox" id="biop-include-disabled">
			<label for="biop-include-disabled" style="margin:0;">Incluir sa\xeddas exclu\xeddas (status 999)</label>
		</div>
		<div class="row">
			<label>Funcion\xe1rio (UUID opcional)<input type="text" id="biop-user-id" placeholder="id do usu\xe1rio" autocomplete="off"></label>
			<label>Busca funcion\xe1rio (nome/login)<input type="text" id="biop-user-search" placeholder="se n\xe3o informou UUID" autocomplete="off"></label>
		</div>
		<div class="row">
			<label>N\xba sa\xedda (opcional)<input type="number" id="biop-output-id" min="1" step="1"></label>
			<label>N\xba pedido sa\xedda (opcional)<input type="number" id="biop-order-id" min="1" step="1"></label>
		</div>
		<div class="row">
			<label>ID produto (opcional)<input type="number" id="biop-product-id" min="1" step="1"></label>
			<label>Busca produto (SKU ou nome)<input type="text" id="biop-product-search" autocomplete="off"></label>
		</div>
		<div class="row">
			<label>Pr\xe9via: limite<input type="number" id="biop-limit" value="200" min="1" max="5000" step="1"></label>
			<label>Pr\xe9via: offset<input type="number" id="biop-offset" value="0" min="0" step="1"></label>
			<label>M\xe1x. linhas (resumo/CSV)<input type="number" id="biop-max-rows" value="50000" min="1" max="50000" step="1"></label>
		</div>
		<p class="biop-hint mts" id="biop-window-hint"></p>
		<p class="biop-hint mts">Pr\xe9via mostra indicadores + resumo por funcion\xe1rio + amostra do detalhe (at\xe9 ${$0e7b01c5410eb81b$var$PREVIEW_DETAIL_CAP} linhas na tela). O sistema <strong>n\xe3o aceita</strong> per\xedodo maior que o teto (evita falha 502).</p>
	</div>
	<div class="biop-actions">
		<button type="button" class="button bn_Preview">Pr\xe9via na tela</button>
		<button type="button" class="button bn_ExportCsv">CSV detalhe</button>
		<button type="button" class="button bn_ExportSummary">CSV resumo</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
        const dlg = (0, $dx9qz.default).create(dlgHtml, async (key)=>{
            const root = dlg.getNode();
            if (key === 'Escape') {
                dlg.destroy();
                return;
            }
            if (key !== 'Preview' && key !== 'ExportCsv' && key !== 'ExportSummary') return;
            const isPreview = key === 'Preview';
            const view = key === 'ExportSummary' ? 'summary' : 'detail';
            const pack = $0e7b01c5410eb81b$var$collectParams(root, isPreview ? 'json' : 'csv', isPreview ? null : view);
            if (!pack) return;
            const pg = (0, $dd3b449d8cadbeb3$export$2e2bcd8739ae039)({
                title: isPreview ? "Gerando pr\xe9via do relat\xf3rio\u2026" : "Gerando CSV\u2026",
                text: isPreview ? "Consultando separa\xe7\xe3o e confer\xeancia no servidor. Per\xedodos grandes podem levar alguns instantes." : "O servidor est\xe1 montando o arquivo. Aguarde o download.",
                indeterminate: true
            });
            $0e7b01c5410eb81b$var$setModalBusy(root, true);
            if (isPreview) {
                dlg.destroy();
                $0e7b01c5410eb81b$var$showPreviewLoading(indHost, summaryHost, previewHost);
            }
            try {
                pg.markStage("Aguardando resposta do servidor\u2026");
                if (typeof (0, $9VcS9.default).output_productivity_report !== 'function') {
                    (0, $jUNyh.notify)("Consulta de produtividade indispon\xedvel neste front. Recarregue a p\xe1gina (Ctrl+F5) ap\xf3s a atualiza\xe7\xe3o.", 'Produtividade');
                    if (isPreview) indHost.replaceChildren();
                    return;
                }
                const res = await (0, $9VcS9.default).output_productivity_report(pack.companyId, pack.sp.toString());
                if (isPreview) {
                    const raw = await res.text();
                    if (!res.ok) {
                        (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw), 'Produtividade');
                        indHost.replaceChildren();
                        return;
                    }
                    let data;
                    try {
                        data = JSON.parse(raw);
                    } catch (e) {
                        (0, $jUNyh.notify)("Resposta n\xe3o \xe9 JSON.", 'Produtividade');
                        indHost.replaceChildren();
                        return;
                    }
                    if (!data || typeof data !== 'object') {
                        (0, $jUNyh.notify)('Formato inesperado da API.', 'Produtividade');
                        indHost.replaceChildren();
                        return;
                    }
                    await $0e7b01c5410eb81b$var$renderPreviewResults(indHost, summaryHost, previewHost, data, pg);
                    const n = (data.detail || []).length;
                    const tot = data.meta?.detail_total ?? n;
                    const shown = Math.min(n, $0e7b01c5410eb81b$var$PREVIEW_DETAIL_CAP);
                    (0, $jUNyh.notify)(`Pr\xe9via pronta: ${shown} linha(s) de detalhe na tela (${n} nesta p\xe1gina, ${tot} no per\xedodo).`, 'Produtividade');
                    return;
                }
                if (!res.ok) {
                    const t = await res.text();
                    (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, t), 'Produtividade');
                    return;
                }
                pg.markStage("Recebendo arquivo\u2026");
                const blob = await res.blob();
                const cd = res.headers.get('Content-Disposition');
                let fname = view === 'summary' ? 'bi-produtividade-resumo.csv' : 'bi-produtividade-detalhe.csv';
                if (cd) {
                    const m = cd.match(/filename="?([^";]+)"?/i);
                    if (m) fname = m[1];
                }
                $0e7b01c5410eb81b$var$downloadCsv(blob, fname);
                dlg.destroy();
                (0, $jUNyh.notify)('Download do CSV iniciado.', 'Produtividade');
            } catch (e) {
                console.error(e);
                (0, $jUNyh.notify)(e?.message || String(e), 'Produtividade');
                if (isPreview) indHost.replaceChildren();
            } finally{
                pg.destroy();
                if (!isPreview) $0e7b01c5410eb81b$var$setModalBusy(root, false);
            }
        });
        const root = dlg.getNode();
        const df = $0e7b01c5410eb81b$var$$('#biop-date-from', root);
        const dt = $0e7b01c5410eb81b$var$$('#biop-date-to', root);
        if (df && !df.value) df.value = $0e7b01c5410eb81b$var$defaultDateFirstOfMonth();
        if (dt && !dt.value) dt.value = $0e7b01c5410eb81b$var$defaultToday();
        [
            'biop-date-from',
            'biop-date-to'
        ].forEach((id)=>{
            $0e7b01c5410eb81b$var$$(`#${id}`, root)?.addEventListener('change', ()=>$0e7b01c5410eb81b$var$syncWindowGuard(root));
            $0e7b01c5410eb81b$var$$(`#${id}`, root)?.addEventListener('input', ()=>$0e7b01c5410eb81b$var$syncWindowGuard(root));
        });
        $0e7b01c5410eb81b$var$syncWindowGuard(root);
        $0e7b01c5410eb81b$var$loadCompanies($0e7b01c5410eb81b$var$$('#biop-company', root)).then(()=>{});
    };
    $0e7b01c5410eb81b$var$$('#biop-open-modal', work).addEventListener('click', openModal);
}


/**
 * Comercial → Relatório Notas faturadas - Exclusivo (#MT-57E7612, #MT-CA07226, #MT-5311110).
 * Prévia JSON + CSV + PDF. Acesso via grupo RELATORIOS GERENCIAIS / Administradores.
 * Padrão UI: spinner msgbox (prévia) / barra progress (CSV·PDF); tabela estilo Kardex no #workarea.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

function $1c20395c759c7b39$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $1c20395c759c7b39$var$defaultDateFirstOfMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function $1c20395c759c7b39$var$defaultToday() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function $1c20395c759c7b39$var$fmtQty(v) {
    const n = Number(v);
    if (!Number.isFinite(n)) return v == null ? '' : String(v);
    return n.toLocaleString('pt-BR', {
        maximumFractionDigits: 4
    });
}
function $1c20395c759c7b39$var$fmtMoney(v, digits = 2) {
    const n = Number(v);
    if (!Number.isFinite(n)) return v == null ? '' : String(v);
    return n.toLocaleString('pt-BR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    });
}
function $1c20395c759c7b39$var$downloadBase64(b64, filename, mime) {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)bytes[i] = bin.charCodeAt(i);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([
        bytes
    ], {
        type: mime
    }));
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $1c20395c759c7b39$var$loadCompanies(selectEl) {
    const mb = (0, $jUNyh.default)({
        animation: true,
        text: "Carregando empresas\u2026"
    });
    try {
        const res = await (0, $9VcS9.default).list_all_companies();
        if (!res.ok) {
            (0, $jUNyh.notify)(await res.text(), 'Empresas');
            return;
        }
        let list;
        try {
            list = await res.json();
        } catch  {
            (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
            return;
        }
        if (!Array.isArray(list)) return;
        selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
        for (const c of list){
            const o = document.createElement('option');
            o.value = c.id;
            o.textContent = c.nick || c.name || c.id;
            selectEl.appendChild(o);
        }
    } finally{
        mb.destroy();
    }
}
/**
 * Carrega clientes da empresa no datalist (rótulo → id).
 * @returns {Promise<Map<string, string>>}
 */ async function $1c20395c759c7b39$var$loadCustomersDatalist(companyId, datalistEl) {
    const map = new Map();
    datalistEl.replaceChildren();
    if (!companyId) return map;
    try {
        const q = `?filter=company_id*eq*${encodeURIComponent(companyId)}&limit=5000`;
        const res = await (0, $9VcS9.default).list_customers(q);
        if (!res.ok) return map;
        let list;
        try {
            list = await res.json();
        } catch  {
            return map;
        }
        if (!Array.isArray(list)) return map;
        const frag = document.createDocumentFragment();
        for (const c of list){
            const nick = (c.nick || '').trim();
            const name = (c.name || '').trim();
            const label = [
                nick,
                name
            ].filter(Boolean).join(" \u2014 ") || `Cliente #${c.id}`;
            const opt = document.createElement('option');
            opt.value = label;
            frag.appendChild(opt);
            map.set(label.toLowerCase(), String(c.id));
            if (nick) map.set(nick.toLowerCase(), String(c.id));
            if (name && name.toLowerCase() !== nick.toLowerCase()) map.set(name.toLowerCase(), String(c.id));
        }
        datalistEl.appendChild(frag);
    } catch (e) {
        console.error(e);
    }
    return map;
}
/**
 * Carrega nomes de produto da empresa no datalist (mesmo padrão do cliente).
 * O valor da opção é o nome — o filtro da API continua sendo “contém”.
 */ async function $1c20395c759c7b39$var$loadProductsDatalist(companyId, datalistEl) {
    datalistEl.replaceChildren();
    if (!companyId) return;
    try {
        const q = `?filter=company_id*eq*${encodeURIComponent(companyId)}&limit=5000`;
        const res = await (0, $9VcS9.default).list_products(q);
        if (!res.ok) return;
        let list;
        try {
            list = await res.json();
        } catch  {
            return;
        }
        if (!Array.isArray(list)) return;
        const seen = new Set();
        const frag = document.createDocumentFragment();
        for (const p of list){
            if (p?.is_disabled) continue;
            const name = (p.name || '').trim();
            if (!name) continue;
            const key = name.toLowerCase();
            if (seen.has(key)) continue;
            seen.add(key);
            const opt = document.createElement('option');
            opt.value = name;
            frag.appendChild(opt);
        }
        datalistEl.appendChild(frag);
    } catch (e) {
        console.error(e);
    }
}
function $1c20395c759c7b39$var$syncCustomerIdFromName(filters, labelToId) {
    const nameEl = $1c20395c759c7b39$var$$('#ibe-customer-name', filters);
    const idEl = $1c20395c759c7b39$var$$('#ibe-customer-id', filters);
    if (!nameEl || !idEl) return;
    const raw = (nameEl.value || '').trim();
    if (!raw) return;
    const id = labelToId.get(raw.toLowerCase());
    if (id) idEl.value = id;
    else // Texto livre (trecho do nome): não usar ID antigo de seleção anterior.
    idEl.value = '';
}
function $1c20395c759c7b39$var$collectParams(node, format) {
    const companyId = $1c20395c759c7b39$var$$('#ibe-company', node)?.value?.trim();
    if (!companyId) {
        (0, $jUNyh.notify)('Selecione a empresa.');
        return null;
    }
    const df = $1c20395c759c7b39$var$$('#ibe-date-from', node)?.value?.trim();
    const dt = $1c20395c759c7b39$var$$('#ibe-date-to', node)?.value?.trim();
    if (!df || !dt) {
        (0, $jUNyh.notify)("Informe o per\xedodo (data inicial e final).");
        return null;
    }
    if (dt < df) {
        (0, $jUNyh.notify)("A data final deve ser igual ou posterior \xe0 inicial.");
        return null;
    }
    const params = {
        format: format,
        date_from: df,
        date_to: dt
    };
    const cnpj = $1c20395c759c7b39$var$$('#ibe-cnpj', node)?.value?.trim();
    if (cnpj) params.cnpj = cnpj;
    const cid = $1c20395c759c7b39$var$$('#ibe-customer-id', node)?.value?.trim();
    const cname = $1c20395c759c7b39$var$$('#ibe-customer-name', node)?.value?.trim();
    if (cid) params.customer_id = cid;
    else if (cname) params.customer_name = cname;
    const st = $1c20395c759c7b39$var$$('#ibe-status', node)?.value?.trim();
    if (st && st !== 'Todos') params.status = st;
    const sku = $1c20395c759c7b39$var$$('#ibe-sku', node)?.value?.trim();
    if (sku) params.sku = sku;
    const pname = $1c20395c759c7b39$var$$('#ibe-product-name', node)?.value?.trim();
    if (pname) params.product_name = pname;
    const p344 = $1c20395c759c7b39$var$$('#ibe-portaria-344', node)?.value?.trim();
    if (p344 && p344 !== 'Todos') params.portaria_344 = p344;
    if (format === 'json') {
        let lim = parseInt($1c20395c759c7b39$var$$('#ibe-limit', node)?.value || '200', 10);
        if (!Number.isFinite(lim) || lim < 1) lim = 200;
        if (lim > 5000) lim = 5000;
        params.limit = String(lim);
        params.offset = '0';
    }
    return {
        companyId: companyId,
        params: params
    };
}
const $1c20395c759c7b39$var$PREVIEW_COLS = [
    [
        'data_emissao',
        "Emiss\xe3o",
        'text'
    ],
    [
        'cliente',
        'Cliente',
        'text'
    ],
    [
        'cnpj',
        'CNPJ/CPF',
        'text'
    ],
    [
        'municipio',
        "Munic\xedpio",
        'text'
    ],
    [
        'uf',
        'UF',
        'center'
    ],
    [
        'nota_fiscal',
        'NF',
        'center'
    ],
    [
        'cfop',
        'CFOP',
        'center'
    ],
    [
        'sku',
        'SKU',
        'text'
    ],
    [
        'produto',
        'Produto',
        'text'
    ],
    [
        'lote',
        'Lote',
        'text'
    ],
    [
        'quantidade',
        'Qtd',
        'num'
    ],
    [
        'valor_unitario',
        'Vlr unit.',
        'money4'
    ],
    [
        'valor_total',
        'Vlr total',
        'money'
    ],
    [
        'status',
        'Status',
        'text'
    ]
];
function $1c20395c759c7b39$var$cellText(row, key, kind) {
    const v = row?.[key];
    if (kind === 'num') return $1c20395c759c7b39$var$fmtQty(v);
    if (kind === 'money') return $1c20395c759c7b39$var$fmtMoney(v, 2);
    if (kind === 'money4') return $1c20395c759c7b39$var$fmtMoney(v, 4);
    return v == null ? '' : String(v);
}
/**
 * Monta a prévia só com textContent (sem innerHTML/template — template.innerHTML vinha vazio).
 */ function $1c20395c759c7b39$var$renderPreview(container, payload) {
    container.replaceChildren();
    const rows = Array.isArray(payload?.rows) ? payload.rows : [];
    const total = payload?.total;
    const totalLabel = total == null || total === '' ? "\u2014" : String(total);
    if (!rows.length) {
        const p = document.createElement('p');
        p.className = 'muted mts';
        p.textContent = `Nenhuma linha no per\xedodo (total: ${totalLabel}).`;
        container.appendChild(p);
        return;
    }
    const summary = document.createElement('p');
    summary.className = 'mts';
    const s1 = document.createElement('strong');
    s1.textContent = String(rows.length);
    const s2 = document.createElement('strong');
    s2.textContent = totalLabel;
    const filterSum = Number(payload?.valor_total_sum);
    const pageSumRaw = payload?.valor_total_page;
    const pageSum = Number.isFinite(Number(pageSumRaw)) ? Number(pageSumRaw) : rows.reduce((acc, r)=>acc + (Number(r?.valor_total) || 0), 0);
    const truncated = payload?.truncated === true || Number.isFinite(Number(total)) && rows.length < Number(total);
    summary.append('Exibindo ', s1, ' de ', s2, ' linha(s).');
    if (Number.isFinite(filterSum)) {
        summary.append(' Subtotal Vlr total: ', document.createElement('strong'));
        summary.lastChild.textContent = $1c20395c759c7b39$var$fmtMoney(filterSum, 2);
        if (truncated) {
            summary.append(' (todas as linhas do filtro; nesta tela: ');
            const sPage = document.createElement('strong');
            sPage.textContent = $1c20395c759c7b39$var$fmtMoney(pageSum, 2);
            summary.append(sPage, ').');
        } else summary.append('.');
    }
    container.appendChild(summary);
    const scroll = document.createElement('div');
    scroll.className = 'ibe-scroll mts';
    const table = document.createElement('table');
    table.className = 'ibe-table';
    const thead = document.createElement('thead');
    const hr = document.createElement('tr');
    for (const [, label, kind] of $1c20395c759c7b39$var$PREVIEW_COLS){
        const th = document.createElement('th');
        if (kind === 'center') th.className = 'ibe-center';
        if (kind === 'num' || kind === 'money' || kind === 'money4') th.className = 'ibe-num';
        th.textContent = label;
        hr.appendChild(th);
    }
    thead.appendChild(hr);
    table.appendChild(thead);
    const tbody = document.createElement('tbody');
    const frag = document.createDocumentFragment();
    for (const r of rows){
        const tr = document.createElement('tr');
        for (const [key, , kind] of $1c20395c759c7b39$var$PREVIEW_COLS){
            const td = document.createElement('td');
            if (kind === 'center') td.className = 'ibe-center';
            if (kind === 'num' || kind === 'money' || kind === 'money4') td.className = 'ibe-num';
            td.textContent = $1c20395c759c7b39$var$cellText(r, key, kind);
            tr.appendChild(td);
        }
        frag.appendChild(tr);
    }
    tbody.appendChild(frag);
    table.appendChild(tbody);
    const moneyIdx = $1c20395c759c7b39$var$PREVIEW_COLS.findIndex(([key])=>key === 'valor_total');
    const tfoot = document.createElement('tfoot');
    const addFooterRow = (label, amount)=>{
        const tr = document.createElement('tr');
        tr.className = 'ibe-subtotal';
        for(let i = 0; i < $1c20395c759c7b39$var$PREVIEW_COLS.length; i++){
            const td = document.createElement('td');
            const [, , kind] = $1c20395c759c7b39$var$PREVIEW_COLS[i];
            if (kind === 'center') td.className = 'ibe-center';
            if (kind === 'num' || kind === 'money' || kind === 'money4') td.className = 'ibe-num';
            if (i === 0) td.textContent = label;
            else if (i === moneyIdx) td.textContent = $1c20395c759c7b39$var$fmtMoney(amount, 2);
            else td.textContent = '';
            tr.appendChild(td);
        }
        tfoot.appendChild(tr);
    };
    if (truncated && Number.isFinite(filterSum)) {
        addFooterRow('Subtotal (exibido)', pageSum);
        addFooterRow('Subtotal (filtro)', filterSum);
    } else addFooterRow('Subtotal', Number.isFinite(filterSum) ? filterSum : pageSum);
    table.appendChild(tfoot);
    scroll.appendChild(table);
    container.appendChild(scroll);
}
function $1c20395c759c7b39$var$setActionsDisabled(root, disabled) {
    for (const id of [
        'ibe-preview',
        'ibe-csv',
        'ibe-pdf'
    ]){
        const btn = $1c20395c759c7b39$var$$(`#${id}`, root);
        if (btn) btn.disabled = !!disabled;
    }
}
async function $1c20395c759c7b39$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.ibe-hint { color: #555; font-size: 0.9rem; max-width: 52rem; }
			.ibe-scroll {
				overflow: auto;
				max-height: 65vh;
				border: 1px solid var(--color-border, #cbd5e1);
				border-radius: 2px;
				background: #fff;
			}
			.ibe-filters label { display: block; margin-top: 0.5rem; font-size: 0.9rem; }
			.ibe-filters .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; }
			.ibe-filters .row > label { flex: 1 1 11rem; }
			.ibe-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
			.ibe-filters input, .ibe-filters select { width: 100%; max-width: 18rem; box-sizing: border-box; }
			.ibe-filters .ibe-panel {
				margin-top: 0.75rem;
				padding: 0.75rem 1rem 1rem;
				background: var(--color-secondary, #f8fafc);
				border: 1px solid var(--color-border, #e2e8f0);
			}
			.ibe-table tfoot td { background: #f1f5f9; font-weight: 600; }
			.ibe-table .ibe-subtotal td { border-top: 2px solid var(--color-border, #94a3b8); }
		</style>
		<div class="title">Relat\xf3rio Notas faturadas - Exclusivo</div>
		<p class="mts ibe-hint">
			Notas de sa\xedda no per\xedodo de <strong>emiss\xe3o</strong>, com filtros opcionais de
			<strong>nome do cliente</strong>, CNPJ/CPF, ID, <strong>status da nota</strong>,
			<strong>c\xf3digo SKU</strong>, <strong>descri\xe7\xe3o do produto</strong> e
			<strong>Portaria 344</strong> (cadastro de Produtos).
			Uma linha por produto e lote. A pr\xe9via e os arquivos (CSV/PDF) trazem o
			<strong>subtotal do Vlr total</strong> ao final. Acesso restrito ao grupo
			<strong>RELATORIOS GERENCIAIS</strong> (e Administradores).
		</p>
		<div class="ibe-filters mts" id="ibe-filters">
			<div class="ibe-panel">
				<div class="row">
					<label>Empresa<sup>*</sup>
						<select id="ibe-company" required></select>
					</label>
					<label>Emiss\xe3o de<sup>*</sup>
						<input type="date" id="ibe-date-from" required value="${$1c20395c759c7b39$var$defaultDateFirstOfMonth()}">
					</label>
					<label>at\xe9<sup>*</sup>
						<input type="date" id="ibe-date-to" required value="${$1c20395c759c7b39$var$defaultToday()}">
					</label>
					<label>Status da nota
						<select id="ibe-status">
							<option value="Todos" selected>Todos</option>
							<option value="Autorizada">Autorizada</option>
							<option value="Cancelada">Cancelada</option>
							<option value="Inutilizada">Inutilizada</option>
							<option value="Pendente">Pendente</option>
							<option value="Desabilitada">Desabilitada</option>
							<option value="Rejeitada">Rejeitada</option>
						</select>
					</label>
				</div>
				<div class="row">
					<label>Nome do cliente (opcional)
						<input type="text" id="ibe-customer-name" list="ibe-customers-dl"
							placeholder="digite nome ou apelido" maxlength="120" autocomplete="off">
						<datalist id="ibe-customers-dl"></datalist>
					</label>
					<label>CNPJ/CPF (opcional)
						<input type="text" id="ibe-cnpj" placeholder="somente d\xedgitos ou formatado" maxlength="18" autocomplete="off">
					</label>
					<label>ID cliente SIAL (opcional)
						<input type="number" id="ibe-customer-id" min="1" step="1" placeholder="ex.: 123">
					</label>
					<label>Limite pr\xe9via
						<input type="number" id="ibe-limit" min="1" max="5000" value="200" title="Padr\xe3o 200 (m\xe1x. 5000). Valores altos deixam a grade mais lenta.">
					</label>
				</div>
				<div class="row">
					<label>C\xf3digo SKU (opcional)
						<input type="text" id="ibe-sku" placeholder="ex.: 041523" maxlength="60" autocomplete="off">
					</label>
					<label>Descri\xe7\xe3o do produto (opcional)
						<input type="text" id="ibe-product-name" list="ibe-products-dl"
							placeholder="digite o nome (ex.: Diazepam)" maxlength="120" autocomplete="off">
						<datalist id="ibe-products-dl"></datalist>
					</label>
					<label>Portaria 344
						<select id="ibe-portaria-344" title="Cruza o SKU da NF com o cadastro de Produtos (flag Portaria 344)">
							<option value="Todos" selected>Todos</option>
							<option value="only">Somente Portaria 344</option>
							<option value="exclude">Somente sem Portaria 344</option>
						</select>
					</label>
				</div>
				<div class="ibe-actions">
					<button type="button" class="button" id="ibe-preview">Pr\xe9via</button>
					<button type="button" class="button" id="ibe-csv">CSV</button>
					<button type="button" class="button" id="ibe-pdf">PDF</button>
				</div>
			</div>
		</div>
		<div id="ibe-preview-host" class="mts"></div>
	`;
    const filters = $1c20395c759c7b39$var$$('#ibe-filters', work);
    const previewHost = $1c20395c759c7b39$var$$('#ibe-preview-host', work);
    const companySel = $1c20395c759c7b39$var$$('#ibe-company', filters);
    const customersDl = $1c20395c759c7b39$var$$('#ibe-customers-dl', filters);
    const productsDl = $1c20395c759c7b39$var$$('#ibe-products-dl', filters);
    let customerLabelToId = new Map();
    await $1c20395c759c7b39$var$loadCompanies(companySel);
    async function refreshLookups() {
        const cid = companySel?.value?.trim();
        const mb = (0, $jUNyh.default)({
            animation: true,
            text: "Carregando clientes e produtos\u2026"
        });
        try {
            const [cmap] = await Promise.all([
                $1c20395c759c7b39$var$loadCustomersDatalist(cid, customersDl),
                $1c20395c759c7b39$var$loadProductsDatalist(cid, productsDl)
            ]);
            customerLabelToId = cmap;
        } finally{
            mb.destroy();
        }
    }
    companySel?.addEventListener('change', async ()=>{
        $1c20395c759c7b39$var$$('#ibe-customer-name', filters).value = '';
        $1c20395c759c7b39$var$$('#ibe-customer-id', filters).value = '';
        $1c20395c759c7b39$var$$('#ibe-product-name', filters).value = '';
        $1c20395c759c7b39$var$$('#ibe-sku', filters).value = '';
        await refreshLookups();
    });
    $1c20395c759c7b39$var$$('#ibe-customer-name', filters)?.addEventListener('change', ()=>{
        $1c20395c759c7b39$var$syncCustomerIdFromName(filters, customerLabelToId);
    });
    $1c20395c759c7b39$var$$('#ibe-customer-name', filters)?.addEventListener('blur', ()=>{
        $1c20395c759c7b39$var$syncCustomerIdFromName(filters, customerLabelToId);
    });
    async function runPreview() {
        const collected = $1c20395c759c7b39$var$collectParams(filters, 'json');
        if (!collected) return;
        const { companyId: companyId, params: params } = collected;
        $1c20395c759c7b39$var$setActionsDisabled(filters, true);
        const mb = (0, $jUNyh.default)({
            animation: true,
            text: "Gerando pr\xe9via do relat\xf3rio\u2026"
        });
        try {
            const res = await (0, $9VcS9.default).invoices_billed_exclusive_report(companyId, params);
            if (!res.ok) {
                (0, $jUNyh.notify)(await res.text() || `Erro ${res.status}`, "Relat\xf3rio");
                return;
            }
            const data = await res.json();
            if (!data || typeof data !== 'object' || Array.isArray(data)) {
                (0, $jUNyh.notify)('Formato inesperado da API (esperado objeto com rows/total).', "Relat\xf3rio");
                return;
            }
            if (!Array.isArray(data.rows)) {
                (0, $jUNyh.notify)('Resposta sem lista de linhas (rows).', "Relat\xf3rio");
                return;
            }
            $1c20395c759c7b39$var$renderPreview(previewHost, data);
            const shown = data.rows.length;
            const tot = data.total ?? shown;
            (0, $jUNyh.notify)(`Pr\xe9via: ${shown} de ${tot} linha(s).`, "Relat\xf3rio");
        } catch (e) {
            console.error(e);
            (0, $jUNyh.notify)(String(e?.message || e), "Relat\xf3rio");
        } finally{
            mb.destroy();
            $1c20395c759c7b39$var$setActionsDisabled(filters, false);
        }
    }
    async function runExport(format) {
        const collected = $1c20395c759c7b39$var$collectParams(filters, format);
        if (!collected) return;
        const { companyId: companyId, params: params } = collected;
        $1c20395c759c7b39$var$setActionsDisabled(filters, true);
        const label = format === 'csv' ? 'CSV' : 'PDF';
        const pg = (0, $dd3b449d8cadbeb3$export$2e2bcd8739ae039)({
            title: `Gerando ${label}\u{2026}`,
            text: "Consultando notas no per\xedodo e montando o arquivo.",
            indeterminate: true
        });
        try {
            pg.markStage("Aguardando resposta do servidor\u2026");
            const res = await (0, $9VcS9.default).invoices_billed_exclusive_report(companyId, params);
            if (!res.ok) {
                (0, $jUNyh.notify)(await res.text() || `Erro ${res.status}`, "Relat\xf3rio");
                return;
            }
            pg.markStage("Processando arquivo\u2026");
            const data = await res.json();
            if (format === 'csv' && data.csv) {
                $1c20395c759c7b39$var$downloadBase64(data.csv, data.filename || 'notas-faturadas.csv', 'text/csv;charset=utf-8');
                (0, $jUNyh.notify)(`${data.rows || 0} linha(s) exportada(s).`, 'CSV');
                return;
            }
            if (format === 'pdf' && data.pdf) {
                $1c20395c759c7b39$var$downloadBase64(data.pdf, data.filename || 'notas-faturadas.pdf', 'application/pdf');
                (0, $jUNyh.notify)(`${data.rows || 0} linha(s) no PDF.`, 'PDF');
                return;
            }
            (0, $jUNyh.notify)('Resposta inesperada do servidor.', "Relat\xf3rio");
        } catch (e) {
            console.error(e);
            (0, $jUNyh.notify)(String(e?.message || e), "Relat\xf3rio");
        } finally{
            pg.destroy();
            $1c20395c759c7b39$var$setActionsDisabled(filters, false);
        }
    }
    $1c20395c759c7b39$var$$('#ibe-preview', filters)?.addEventListener('click', ()=>runPreview());
    $1c20395c759c7b39$var$$('#ibe-csv', filters)?.addEventListener('click', ()=>runExport('csv'));
    $1c20395c759c7b39$var$$('#ibe-pdf', filters)?.addEventListener('click', ()=>runExport('pdf'));
}


/**
 * Comercial → Itens a vencer (#MT-D552104).
 * Prévia + CSV. Janela = N meses civis seguintes, sem o mês atual.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");

function $23e301c8ec8bb92c$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $23e301c8ec8bb92c$var$fmtQty(v) {
    const n = Number(v);
    if (!Number.isFinite(n)) return v == null ? '' : String(v);
    return n.toLocaleString('pt-BR', {
        maximumFractionDigits: 0
    });
}
function $23e301c8ec8bb92c$var$fmtMoney(v, digits = 4) {
    const n = Number(v);
    if (!Number.isFinite(n)) return v == null ? '' : String(v);
    return n.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: digits
    });
}
function $23e301c8ec8bb92c$var$fmtIsoBr(iso) {
    if (!iso) return '';
    const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return String(iso);
    return `${m[3]}/${m[2]}/${m[1]}`;
}
function $23e301c8ec8bb92c$var$downloadBase64(b64, filename, mime) {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)bytes[i] = bin.charCodeAt(i);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([
        bytes
    ], {
        type: mime
    }));
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(a.href);
}
function $23e301c8ec8bb92c$export$75c3854f7e670c9a(monthsAhead, today = new Date()) {
    const months = Number(monthsAhead) || 3;
    const y = today.getFullYear();
    const m = today.getMonth();
    const start = new Date(y, m + 1, 1);
    const end = new Date(start.getFullYear(), start.getMonth() + months, 0);
    const iso = (d)=>{
        const yy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yy}-${mm}-${dd}`;
    };
    return {
        from: iso(start),
        to: iso(end)
    };
}
async function $23e301c8ec8bb92c$var$loadCompanies(selectEl) {
    const mb = (0, $jUNyh.default)({
        animation: true,
        text: "Carregando empresas\u2026"
    });
    try {
        const res = await (0, $9VcS9.default).list_all_companies();
        if (!res.ok) {
            (0, $jUNyh.notify)(await res.text(), 'Empresas');
            return;
        }
        let list;
        try {
            list = await res.json();
        } catch  {
            (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
            return;
        }
        if (!Array.isArray(list)) return;
        selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
        for (const c of list){
            const o = document.createElement('option');
            o.value = c.id;
            o.textContent = c.nick || c.name || c.id;
            selectEl.appendChild(o);
        }
    } finally{
        mb.destroy();
    }
}
async function $23e301c8ec8bb92c$var$loadPrograms(companyId, selectEl) {
    selectEl.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    try {
        const res = await (0, $9VcS9.default).list_programs_by_company(companyId);
        if (!res.ok) return;
        let list;
        try {
            list = await res.json();
        } catch  {
            return;
        }
        if (!Array.isArray(list)) return;
        for (const p of list){
            if (p?.is_disabled) continue;
            const o = document.createElement('option');
            o.value = p.id;
            o.textContent = p.name || `Programa ${p.id}`;
            selectEl.appendChild(o);
        }
    } catch (e) {
        console.error(e);
    }
}
function $23e301c8ec8bb92c$var$collectParams(node, format) {
    const companyId = $23e301c8ec8bb92c$var$$('#exi-company', node)?.value?.trim();
    if (!companyId) {
        (0, $jUNyh.notify)('Selecione a empresa.');
        return null;
    }
    let months = parseInt($23e301c8ec8bb92c$var$$('#exi-months', node)?.value || '3', 10);
    if (!Number.isFinite(months) || months < 1) months = 3;
    if (months > 12) months = 12;
    const params = {
        format: format,
        months_ahead: String(months)
    };
    const pid = $23e301c8ec8bb92c$var$$('#exi-program', node)?.value?.trim();
    if (pid) params.program_id = pid;
    if (format === 'json') {
        let lim = parseInt($23e301c8ec8bb92c$var$$('#exi-limit', node)?.value || '500', 10);
        if (!Number.isFinite(lim) || lim < 1) lim = 500;
        if (lim > 500) lim = 500;
        params.limit = String(lim);
    }
    return {
        companyId: companyId,
        params: params
    };
}
const $23e301c8ec8bb92c$var$PREVIEW_COLS = [
    [
        'sku',
        'SKU',
        'text'
    ],
    [
        'produto',
        "Descri\xe7\xe3o",
        'text'
    ],
    [
        'quantidade_disponivel',
        "Qtd dispon\xedvel",
        'num'
    ],
    [
        'lote',
        'Lote',
        'text'
    ],
    [
        'validade',
        'Validade',
        'text'
    ],
    [
        'fabricante',
        'Fabricante',
        'text'
    ],
    [
        'fornecedor',
        'Fornecedor',
        'text'
    ],
    [
        'custo_unitario',
        'Custo unit.',
        'money'
    ],
    [
        'programa',
        'Programa',
        'text'
    ]
];
function $23e301c8ec8bb92c$var$cellText(row, key, kind) {
    const v = row?.[key];
    if (kind === 'num') return $23e301c8ec8bb92c$var$fmtQty(v);
    if (kind === 'money') return v == null || v === '' ? '' : $23e301c8ec8bb92c$var$fmtMoney(v, 4);
    return v == null ? '' : String(v);
}
function $23e301c8ec8bb92c$var$renderPreview(container, payload) {
    container.replaceChildren();
    const rows = Array.isArray(payload?.rows) ? payload.rows : [];
    const winFrom = $23e301c8ec8bb92c$var$fmtIsoBr(payload?.date_from);
    const winTo = $23e301c8ec8bb92c$var$fmtIsoBr(payload?.date_to);
    const windowP = document.createElement('p');
    windowP.className = 'mts';
    windowP.append('Janela: ');
    const sFrom = document.createElement('strong');
    sFrom.textContent = winFrom || "\u2014";
    const sTo = document.createElement('strong');
    sTo.textContent = winTo || "\u2014";
    windowP.append(sFrom, ' a ', sTo, " (sem o m\xeas atual).");
    container.appendChild(windowP);
    if (!rows.length) {
        const p = document.createElement('p');
        p.className = 'muted mts';
        p.textContent = "Nenhum item dispon\xedvel para venda nesta janela.";
        container.appendChild(p);
        return;
    }
    const summary = document.createElement('p');
    summary.className = 'mts';
    const s1 = document.createElement('strong');
    s1.textContent = String(rows.length);
    summary.append('Exibindo ', s1, ' linha(s).');
    if (payload?.truncated) summary.append(" H\xe1 mais itens \u2014 baixe o CSV para a lista completa.");
    container.appendChild(summary);
    const scroll = document.createElement('div');
    scroll.className = 'ibe-scroll mts';
    const table = document.createElement('table');
    table.className = 'ibe-table';
    const thead = document.createElement('thead');
    const hr = document.createElement('tr');
    for (const [, label, kind] of $23e301c8ec8bb92c$var$PREVIEW_COLS){
        const th = document.createElement('th');
        if (kind === 'num' || kind === 'money') th.className = 'ibe-num';
        th.textContent = label;
        hr.appendChild(th);
    }
    thead.appendChild(hr);
    table.appendChild(thead);
    const tbody = document.createElement('tbody');
    const frag = document.createDocumentFragment();
    for (const r of rows){
        const tr = document.createElement('tr');
        for (const [key, , kind] of $23e301c8ec8bb92c$var$PREVIEW_COLS){
            const td = document.createElement('td');
            if (kind === 'num' || kind === 'money') td.className = 'ibe-num';
            td.textContent = $23e301c8ec8bb92c$var$cellText(r, key, kind);
            tr.appendChild(td);
        }
        frag.appendChild(tr);
    }
    tbody.appendChild(frag);
    table.appendChild(tbody);
    scroll.appendChild(table);
    container.appendChild(scroll);
}
function $23e301c8ec8bb92c$var$setActionsDisabled(root, disabled) {
    for (const id of [
        'exi-preview',
        'exi-csv'
    ]){
        const btn = $23e301c8ec8bb92c$var$$(`#${id}`, root);
        if (btn) btn.disabled = !!disabled;
    }
}
function $23e301c8ec8bb92c$var$refreshWindowHint(root) {
    const months = parseInt($23e301c8ec8bb92c$var$$('#exi-months', root)?.value || '3', 10);
    const { from: from, to: to } = $23e301c8ec8bb92c$export$75c3854f7e670c9a(months);
    const el = $23e301c8ec8bb92c$var$$('#exi-window-hint', root);
    // <input> exibe value — textContent não atualiza o campo na tela.
    if (el) el.value = `${$23e301c8ec8bb92c$var$fmtIsoBr(from)} a ${$23e301c8ec8bb92c$var$fmtIsoBr(to)}`;
}
async function $23e301c8ec8bb92c$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    work.innerHTML = `
		<style>
			.ibe-hint { color: #555; font-size: 0.9rem; max-width: 52rem; }
			.ibe-scroll {
				overflow: auto;
				max-height: 65vh;
				border: 1px solid var(--color-border, #cbd5e1);
				border-radius: 2px;
				background: #fff;
			}
			.ibe-filters label { display: block; margin-top: 0.5rem; font-size: 0.9rem; }
			.ibe-filters .row { display: flex; flex-wrap: wrap; gap: 0.75rem 1rem; align-items: flex-end; }
			.ibe-filters .row > label { flex: 1 1 11rem; }
			.ibe-actions { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; }
			.ibe-filters input, .ibe-filters select { width: 100%; max-width: 18rem; box-sizing: border-box; }
			.ibe-filters .ibe-panel {
				margin-top: 0.75rem;
				padding: 0.75rem 1rem 1rem;
				background: var(--color-secondary, #f8fafc);
				border: 1px solid var(--color-border, #e2e8f0);
			}
			.ibe-num { text-align: right; }
		</style>
		<div class="title">Itens a vencer</div>
		<p class="mts ibe-hint">
			Lotes <strong>dispon\xedveis para venda</strong> cuja validade cai nos
			<strong>meses seguintes</strong> (o m\xeas atual n\xe3o entra).
			Uma linha por lote. Baixe o <strong>CSV</strong> para abrir no Excel.
			Caminho: <strong>Comercial \u{2192} Itens a vencer</strong>.
		</p>
		<div class="ibe-filters mts" id="exi-filters">
			<div class="ibe-panel">
				<div class="row">
					<label>Empresa<sup>*</sup>
						<select id="exi-company" required></select>
					</label>
					<label>Meses \xe0 frente
						<select id="exi-months">
							<option value="1">1 m\xeas</option>
							<option value="2">2 meses</option>
							<option value="3" selected>3 meses</option>
							<option value="6">6 meses</option>
							<option value="12">12 meses</option>
						</select>
					</label>
					<label>Janela
						<input type="text" id="exi-window-hint" readonly
							title="Calculada sem o m\xeas atual. O servidor confirma na consulta.">
					</label>
					<label>Programa
						<select id="exi-program">
							<option value="">Todos</option>
						</select>
					</label>
					<label>Limite pr\xe9via
						<input type="number" id="exi-limit" min="1" max="500" value="500"
							title="Padr\xe3o 500. O CSV traz a lista completa.">
					</label>
				</div>
				<div class="ibe-actions">
					<button type="button" class="button" id="exi-preview">Pr\xe9via</button>
					<button type="button" class="button" id="exi-csv">CSV</button>
				</div>
			</div>
		</div>
		<div id="exi-preview-host" class="mts"></div>
	`;
    const filters = $23e301c8ec8bb92c$var$$('#exi-filters', work);
    const previewHost = $23e301c8ec8bb92c$var$$('#exi-preview-host', work);
    const companySel = $23e301c8ec8bb92c$var$$('#exi-company', filters);
    const programSel = $23e301c8ec8bb92c$var$$('#exi-program', filters);
    $23e301c8ec8bb92c$var$refreshWindowHint(filters);
    $23e301c8ec8bb92c$var$$('#exi-months', filters)?.addEventListener('change', ()=>$23e301c8ec8bb92c$var$refreshWindowHint(filters));
    await $23e301c8ec8bb92c$var$loadCompanies(companySel);
    companySel?.addEventListener('change', async ()=>{
        const mb = (0, $jUNyh.default)({
            animation: true,
            text: "Carregando programas\u2026"
        });
        try {
            await $23e301c8ec8bb92c$var$loadPrograms(companySel.value?.trim(), programSel);
        } finally{
            mb.destroy();
        }
    });
    async function runPreview() {
        const collected = $23e301c8ec8bb92c$var$collectParams(filters, 'json');
        if (!collected) return;
        const { companyId: companyId, params: params } = collected;
        $23e301c8ec8bb92c$var$setActionsDisabled(filters, true);
        const mb = (0, $jUNyh.default)({
            animation: true,
            text: "Gerando pr\xe9via\u2026"
        });
        try {
            const res = await (0, $9VcS9.default).expiring_items_report(companyId, params);
            if (!res.ok) {
                (0, $jUNyh.notify)(await res.text() || `Erro ${res.status}`, 'Itens a vencer');
                return;
            }
            const data = await res.json();
            if (!data || typeof data !== 'object' || Array.isArray(data) || !Array.isArray(data.rows)) {
                (0, $jUNyh.notify)('Formato inesperado da API.', 'Itens a vencer');
                return;
            }
            const hint = $23e301c8ec8bb92c$var$$('#exi-window-hint', filters);
            if (hint && data.date_from && data.date_to) hint.value = `${$23e301c8ec8bb92c$var$fmtIsoBr(data.date_from)} a ${$23e301c8ec8bb92c$var$fmtIsoBr(data.date_to)}`;
            $23e301c8ec8bb92c$var$renderPreview(previewHost, data);
            (0, $jUNyh.notify)(`Pr\xe9via: ${data.rows.length} linha(s).`, 'Itens a vencer');
        } catch (e) {
            console.error(e);
            (0, $jUNyh.notify)(String(e?.message || e), 'Itens a vencer');
        } finally{
            mb.destroy();
            $23e301c8ec8bb92c$var$setActionsDisabled(filters, false);
        }
    }
    async function runCsv() {
        const collected = $23e301c8ec8bb92c$var$collectParams(filters, 'csv');
        if (!collected) return;
        const { companyId: companyId, params: params } = collected;
        $23e301c8ec8bb92c$var$setActionsDisabled(filters, true);
        const pg = (0, $dd3b449d8cadbeb3$export$2e2bcd8739ae039)({
            title: "Gerando CSV\u2026",
            text: 'Consultando lotes a vencer e montando o arquivo.',
            indeterminate: true
        });
        try {
            pg.markStage("Aguardando resposta do servidor\u2026");
            const res = await (0, $9VcS9.default).expiring_items_report(companyId, params);
            if (!res.ok) {
                (0, $jUNyh.notify)(await res.text() || `Erro ${res.status}`, 'Itens a vencer');
                return;
            }
            pg.markStage("Processando arquivo\u2026");
            const data = await res.json();
            if (data.csv) {
                $23e301c8ec8bb92c$var$downloadBase64(data.csv, data.filename || 'itens-a-vencer.csv', 'text/csv;charset=utf-8');
                (0, $jUNyh.notify)(`${data.rows || 0} linha(s) exportada(s).`, 'CSV');
                return;
            }
            (0, $jUNyh.notify)('Resposta inesperada do servidor.', 'Itens a vencer');
        } catch (e) {
            console.error(e);
            (0, $jUNyh.notify)(String(e?.message || e), 'Itens a vencer');
        } finally{
            pg.destroy();
            $23e301c8ec8bb92c$var$setActionsDisabled(filters, false);
        }
    }
    $23e301c8ec8bb92c$var$$('#exi-preview', filters)?.addEventListener('click', ()=>runPreview());
    $23e301c8ec8bb92c$var$$('#exi-csv', filters)?.addEventListener('click', ()=>runCsv());
}


/**
 * Especial → SESSP → Gestão de Faturas (#MT-9B4E512) — Fases 1–3.
 * Fatura = saída / pedido SES. SLA = conclusão no armazém (não entrega).
 * Sem origem Farmanet/GSNET neste recorte.
 */ 
var $9VcS9 = parcelRequire("9VcS9");

var $jUNyh = parcelRequire("jUNyh");
/**
 * ACL do menu Especial — features por cliente (não globais).
 * Fonte: GET /especial/acl → { sessp: true, ... }
 */ 
var $9VcS9 = parcelRequire("9VcS9");
async function $13f9b1224978e2a9$export$8de14bff94900edc() {
    try {
        const res = await fetch(`${(0, $9VcS9.getSialApiHost)()}/especial/acl`, {
            credentials: 'include'
        });
        if (!res.ok) return {};
        const data = await res.json();
        return data && typeof data === 'object' ? data : {};
    } catch  {
        return {};
    }
}
function $13f9b1224978e2a9$export$5b42cd9c963e2b15(acl = {}) {
    const root = document.querySelector('[data-especial-root]');
    if (!root) return;
    document.querySelectorAll('[data-especial-tenant]').forEach((el)=>{
        const key = el.getAttribute('data-especial-tenant');
        el.hidden = !acl[key];
    });
    const visible = root.querySelector('[data-especial-tenant]:not([hidden])');
    root.hidden = !visible;
}
function $13f9b1224978e2a9$export$af431ba7e897fc39(tenant, acl = {}) {
    return Boolean(acl[tenant]);
}



const $96b2a8c6614c8ae7$var$MAX_DAYS = 93;
const $96b2a8c6614c8ae7$var$STATUS_OPTS = [
    {
        value: '',
        label: 'Todos'
    },
    {
        value: '10',
        label: 'Criada'
    },
    {
        value: '20',
        label: 'Separando'
    },
    {
        value: '30',
        label: 'Separada'
    },
    {
        value: '40',
        label: 'Conferindo'
    },
    {
        value: '50',
        label: 'Unpick'
    },
    {
        value: '60',
        label: 'Conferida'
    },
    {
        value: '65',
        label: 'Faturando'
    },
    {
        value: '70',
        label: 'Faturada'
    },
    {
        value: '75',
        label: "Doca Expedi\xe7\xe3o"
    },
    {
        value: '80',
        label: 'Despachando'
    },
    {
        value: '90',
        label: "Conclu\xedda"
    },
    {
        value: '100',
        label: 'Cancelada'
    }
];
function $96b2a8c6614c8ae7$var$$(sel, root = document) {
    return root.querySelector(sel);
}
function $96b2a8c6614c8ae7$var$esc(s) {
    if (s == null) return '';
    const t = document.createElement('template');
    t.textContent = String(s);
    return t.innerHTML;
}
function $96b2a8c6614c8ae7$var$defaultDateFirstOfMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function $96b2a8c6614c8ae7$var$defaultToday() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function $96b2a8c6614c8ae7$var$parseIsoDate(s) {
    if (!s) return null;
    const d = new Date(`${s}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
}
function $96b2a8c6614c8ae7$var$inclusiveDays(fromStr, toStr) {
    const from = $96b2a8c6614c8ae7$var$parseIsoDate(fromStr);
    if (!from) return 0;
    const to = $96b2a8c6614c8ae7$var$parseIsoDate(toStr) || new Date();
    to.setHours(0, 0, 0, 0);
    from.setHours(0, 0, 0, 0);
    return Math.floor((to - from) / 86400000) + 1;
}
function $96b2a8c6614c8ae7$var$money(n) {
    const v = Number(n);
    if (!Number.isFinite(v)) return 'R$ 0,00';
    return v.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
}
function $96b2a8c6614c8ae7$var$qty(n) {
    const v = Number(n);
    if (!Number.isFinite(v)) return '0';
    return v.toLocaleString('pt-BR');
}
function $96b2a8c6614c8ae7$var$noPermHtml() {
    return `
		<div class="title">Gest\xe3o de Faturas</div>
		<p class="mts" style="max-width: 40rem;">
			Seu usu\xe1rio n\xe3o tem permiss\xe3o para o m\xf3dulo <strong>Especial \u{2192} SESSP</strong>.
			Pe\xe7a ao administrador para incluir o endpoint
			<strong>GET /especial/sessp</strong> no grupo (grupo <strong>ESPECIAL SESSP</strong>
			ou equivalente).
		</p>
	`;
}
async function $96b2a8c6614c8ae7$var$loadCompanies(selectEl) {
    const res = await (0, $9VcS9.default).list_all_companies();
    if (!res.ok) {
        (0, $jUNyh.notify)(await res.text(), 'Empresas');
        return;
    }
    let list;
    try {
        list = await res.json();
    } catch  {
        (0, $jUNyh.notify)("Resposta de empresas inv\xe1lida.", 'Empresas');
        return;
    }
    if (!Array.isArray(list)) return;
    selectEl.innerHTML = '<option value="">\u2014 Selecione \u2014</option>';
    for (const c of list){
        const o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.nick || c.name || c.id;
        selectEl.appendChild(o);
    }
}
async function $96b2a8c6614c8ae7$var$loadPrograms(selectEl, companyId) {
    selectEl.innerHTML = '<option value="">Todos</option>';
    if (!companyId) return;
    try {
        const res = await (0, $9VcS9.default).list_programs_by_company(companyId);
        if (!res.ok) return;
        const list = await res.json();
        const arr = Array.isArray(list) ? list : [];
        for (const p of arr){
            const o = document.createElement('option');
            o.value = p.id;
            o.textContent = p.name || `Programa ${p.id}`;
            selectEl.appendChild(o);
        }
    } catch  {
    /* lista de programas é auxiliar */ }
}
function $96b2a8c6614c8ae7$var$fillStatusSelect(selectEl) {
    selectEl.innerHTML = '';
    for (const opt of $96b2a8c6614c8ae7$var$STATUS_OPTS){
        const o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.label;
        selectEl.appendChild(o);
    }
}
function $96b2a8c6614c8ae7$var$maxBar(rows, key) {
    let m = 0;
    for (const r of rows || []){
        const n = Number(r[key] || 0);
        if (n > m) m = n;
    }
    return m || 1;
}
function $96b2a8c6614c8ae7$var$renderBars(container, rows, labelKey, valueKey) {
    if (!rows?.length) {
        container.innerHTML = '<p class="muted">Sem dados no per\xedodo.</p>';
        return;
    }
    const max = $96b2a8c6614c8ae7$var$maxBar(rows, valueKey);
    let html = '<ul class="efat-bars">';
    for (const r of rows){
        const n = Number(r[valueKey] || 0);
        const pct = Math.max(2, Math.round(n / max * 100));
        html += `<li><span class="efat-bar-lab">${$96b2a8c6614c8ae7$var$esc(r[labelKey])}</span>
			<span class="efat-bar-track"><span class="efat-bar-fill" style="width:${pct}%"></span></span>
			<span class="efat-bar-n">${$96b2a8c6614c8ae7$var$qty(n)}</span></li>`;
    }
    html += '</ul>';
    container.innerHTML = html;
}
function $96b2a8c6614c8ae7$var$renderKpis(host, tot) {
    const t = tot || {};
    host.innerHTML = `
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.faturas)}</span><span>Sa\xeddas</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.itens)}</span><span>Itens</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.qtd_pedida)}</span><span>Qtd pedida</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.qtd_separada)}</span><span>Qtd separada</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$esc($96b2a8c6614c8ae7$var$money(t.valor_pedido))}</span><span>Valor (pedido)</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.sla_dentro)}</span><span>SLA dentro</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.sla_fora)}</span><span>SLA fora</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.sla_andamento)}</span><span>SLA em andamento</span></div>
		<div class="efat-kpi"><span class="efat-kpi-n">${$96b2a8c6614c8ae7$var$qty(t.sem_drs)}</span><span>Sem DRS</span></div>
	`;
}
function $96b2a8c6614c8ae7$var$renderTable(host, rows) {
    if (!rows?.length) {
        host.innerHTML = '<p class="muted mts">Nenhuma sa\xedda no per\xedodo (ajuste filtros ou permiss\xf5es).</p>';
        return;
    }
    let html = `<div class="efat-scroll mts"><table class="view fsx">
		<thead><tr>
			<th></th><th>Sa\xedda</th><th>Pedido</th><th>Refer\xeancia</th><th>Cliente</th>
			<th>Programa</th><th>DRS</th><th>Status</th><th>SLA WMS</th><th>Horas</th>
			<th>Itens</th><th>Qtd pedida</th>
			<th>Qtd sep.</th><th>Valor</th><th>Cria\xe7\xe3o</th>
		</tr></thead><tbody>`;
    for (const r of rows)html += `<tr data-saida="${$96b2a8c6614c8ae7$var$esc(r.saida_id)}">
			<td>
				<button type="button" class="button efat-open" data-saida="${$96b2a8c6614c8ae7$var$esc(r.saida_id)}">Itens</button>
				<button type="button" class="button efat-hist" data-saida="${$96b2a8c6614c8ae7$var$esc(r.saida_id)}">Hist\xf3rico</button>
			</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.saida_id)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.pedido_id ?? '')}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.referencia)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.cliente)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.programa)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.drs_code ? `${r.drs_code} ${r.drs}` : r.drs)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.saida_status_label)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.sla_label)}</td>
			<td>${r.horas_decorridas == null ? '' : $96b2a8c6614c8ae7$var$qty(r.horas_decorridas)}</td>
			<td>${$96b2a8c6614c8ae7$var$qty(r.itens)}</td>
			<td>${$96b2a8c6614c8ae7$var$qty(r.qtd_pedida)}</td>
			<td>${$96b2a8c6614c8ae7$var$qty(r.qtd_separada)}</td>
			<td>${$96b2a8c6614c8ae7$var$esc($96b2a8c6614c8ae7$var$money(r.valor_pedido))}</td>
			<td>${$96b2a8c6614c8ae7$var$esc(r.criada_em)}</td>
		</tr>
		<tr class="efat-detail" data-detail-for="${$96b2a8c6614c8ae7$var$esc(r.saida_id)}" hidden>
			<td colspan="15"><div class="efat-detail-box">Carregando\u{2026}</div></td>
		</tr>`;
    html += '</tbody></table></div>';
    host.innerHTML = html;
}
function $96b2a8c6614c8ae7$var$csvEscape(v) {
    const s = v == null ? '' : String(v);
    if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}
function $96b2a8c6614c8ae7$var$downloadListaCsv(data) {
    const rows = data?.faturas || [];
    const head = [
        'Saida',
        'Pedido',
        'Referencia',
        'Cliente',
        'Programa',
        'DRS',
        'Status',
        'SLA_WMS',
        'Horas',
        'Itens',
        'Qtd_pedida',
        'Qtd_separada',
        'Valor_pedido',
        'Criacao'
    ];
    const lines = [
        head.join(';')
    ];
    for (const r of rows)lines.push([
        r.saida_id,
        r.pedido_id,
        r.referencia,
        r.cliente,
        r.programa,
        r.drs,
        r.saida_status_label,
        r.sla_label,
        r.horas_decorridas,
        r.itens,
        r.qtd_pedida,
        r.qtd_separada,
        r.valor_pedido,
        r.criada_em
    ].map($96b2a8c6614c8ae7$var$csvEscape).join(';'));
    const blob = new Blob([
        '\ufeff' + lines.join('\n')
    ], {
        type: 'text/csv;charset=utf-8'
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'gestao-faturas-sessp.csv';
    a.click();
    URL.revokeObjectURL(a.href);
}
async function $96b2a8c6614c8ae7$export$2e2bcd8739ae039() {
    const work = document.getElementById('workarea');
    if (!work) return;
    const acl = await (0, $13f9b1224978e2a9$export$8de14bff94900edc)();
    if (!(0, $13f9b1224978e2a9$export$af431ba7e897fc39)('sessp', acl)) {
        work.innerHTML = $96b2a8c6614c8ae7$var$noPermHtml();
        return;
    }
    work.innerHTML = `
		<style>
			.efat-hint { color:#555; font-size:.9rem; max-width:52rem; }
			.efat-filters { display:flex; flex-wrap:wrap; gap:.75rem 1rem; align-items:flex-end; margin-top:.75rem; }
			.efat-filters label { display:flex; flex-direction:column; gap:.25rem; font-size:.85rem; }
			.efat-filters select, .efat-filters input[type=date] { min-width:10rem; }
			.efat-check { display:flex; align-items:center; gap:.4rem; padding-bottom:.15rem; }
			.efat-kpis { display:flex; flex-wrap:wrap; gap:.75rem; margin-top:1rem; }
			.efat-kpi { background:#f4f6f8; border:1px solid #dbe1e8; border-radius:6px; padding:.65rem .9rem; min-width:8.5rem; }
			.efat-kpi span { display:block; font-size:.75rem; color:#555; }
			.efat-kpi-n { font-size:1.15rem !important; font-weight:700; color:#1a1a1a !important; }
			.efat-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(16rem,1fr)); gap:1rem; margin-top:1rem; }
			.efat-card { border:1px solid #dbe1e8; border-radius:6px; padding:.75rem 1rem; background:#fff; }
			.efat-card h3 { margin:0 0 .5rem; font-size:.95rem; }
			.efat-bars { list-style:none; margin:0; padding:0; }
			.efat-bars li { display:grid; grid-template-columns:7.5rem 1fr 3rem; gap:.4rem; align-items:center; margin:.25rem 0; font-size:.8rem; }
			.efat-bar-lab { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
			.efat-bar-track { background:#e8eef4; height:.55rem; border-radius:4px; overflow:hidden; }
			.efat-bar-fill { display:block; height:100%; background:#3b6d9c; }
			.efat-bar-n { text-align:right; }
			.efat-scroll { overflow:auto; max-height:55vh; }
			.efat-detail-box { padding:.5rem .75rem; background:#f8fafc; }
			.efat-actions { display:flex; flex-wrap:wrap; gap:.5rem; margin-top:.75rem; }
			button.efat-open, button.efat-hist { font-size:.75rem; padding:.15rem .45rem; }
		</style>
		<div class="title">SESSP \u{2014} Gest\xe3o de Faturas</div>
		<p class="mts efat-hint">
			Vis\xe3o operacional das <strong>sa\xeddas</strong> no per\xedodo (cria\xe7\xe3o, fuso Bras\xedlia).
			Pedido / refer\xeancia = fatura SES \u{2014} <strong>n\xe3o \xe9 a NF-e</strong>.
			<strong>SLA</strong> = prazo at\xe9 a <strong>conclus\xe3o no armaz\xe9m</strong> (horas corridas desde a cria\xe7\xe3o),
			n\xe3o entrega na unidade. Origem Farmanet/GSNET fica de fora.
			Turnos: 07:00\u{2013}11:59 1\xba \xb7 12:00\u{2013}16:49 1\xba e 2\xba (n\xe3o soma duas vezes) \xb7 16:50\u{2013}21:48 2\xba \xb7 21:49\u{2013}06:59 3\xba.
			M\xe1ximo <strong>${$96b2a8c6614c8ae7$var$MAX_DAYS} dias</strong>. Itens tamb\xe9m em <strong>BI \u{2192} Linhas de sa\xedda</strong>.
		</p>
		<div class="efat-filters">
			<label>Empresa<sup>*</sup><select id="efat-company"></select></label>
			<label>Data inicial<sup>*</sup><input type="date" id="efat-from"></label>
			<label>Data final<input type="date" id="efat-to"></label>
			<label>Programa<select id="efat-program"><option value="">Todos</option></select></label>
			<label>Status da sa\xedda<select id="efat-status"></select></label>
			<label>DRS<select id="efat-drs"><option value="">Todos</option></select></label>
			<label>SLA WMS<select id="efat-sla">
				<option value="">Todos</option>
				<option value="dentro">Dentro do prazo</option>
				<option value="fora">Fora do prazo</option>
				<option value="em_andamento">Em andamento (no prazo)</option>
				<option value="sem_regra">Sem regra</option>
			</select></label>
			<div class="efat-check">
				<input type="checkbox" id="efat-canceled">
				<label for="efat-canceled" style="margin:0;">Incluir canceladas</label>
			</div>
			<button type="button" class="button" id="efat-go">Consultar</button>
		</div>
		<p class="mts muted" id="efat-window-hint"></p>
		<div class="efat-kpis" id="efat-kpis"></div>
		<div class="efat-grid">
			<div class="efat-card"><h3>Por m\xeas</h3><div id="efat-month"></div></div>
			<div class="efat-card"><h3>Por status</h3><div id="efat-bystatus"></div></div>
			<div class="efat-card"><h3>Por programa</h3><div id="efat-byprog"></div></div>
			<div class="efat-card"><h3>Por DRS</h3><div id="efat-bydrs"></div></div>
			<div class="efat-card"><h3>SLA WMS (conclus\xe3o no armaz\xe9m)</h3><div id="efat-bysla"></div></div>
			<div class="efat-card"><h3>Mudan\xe7as de status por turno</h3><div id="efat-byshift"></div></div>
			<div class="efat-card"><h3>Tempo m\xe9dio no status (min)</h3><div id="efat-bydwell"></div></div>
		</div>
		<p class="mts muted" id="efat-hist-aviso"></p>
		<div class="efat-actions">
			<button type="button" class="button" id="efat-csv" disabled>Exportar lista (CSV)</button>
		</div>
		<div id="efat-table"></div>
	`;
    const companyEl = $96b2a8c6614c8ae7$var$$('#efat-company', work);
    const fromEl = $96b2a8c6614c8ae7$var$$('#efat-from', work);
    const toEl = $96b2a8c6614c8ae7$var$$('#efat-to', work);
    const programEl = $96b2a8c6614c8ae7$var$$('#efat-program', work);
    const statusEl = $96b2a8c6614c8ae7$var$$('#efat-status', work);
    fromEl.value = $96b2a8c6614c8ae7$var$defaultDateFirstOfMonth();
    toEl.value = $96b2a8c6614c8ae7$var$defaultToday();
    $96b2a8c6614c8ae7$var$fillStatusSelect(statusEl);
    await $96b2a8c6614c8ae7$var$loadCompanies(companyEl);
    let lastData = null;
    const syncHint = ()=>{
        const df = fromEl.value?.trim();
        const dt = toEl.value?.trim();
        const hint = $96b2a8c6614c8ae7$var$$('#efat-window-hint', work);
        if (!df) {
            hint.textContent = `Informe a data inicial. M\xe1ximo ${$96b2a8c6614c8ae7$var$MAX_DAYS} dias.`;
            return;
        }
        const days = $96b2a8c6614c8ae7$var$inclusiveDays(df, dt);
        if (days > $96b2a8c6614c8ae7$var$MAX_DAYS) hint.textContent = `Per\xedodo de ${days} dias excede ${$96b2a8c6614c8ae7$var$MAX_DAYS} dias.`;
        else hint.textContent = `${days} dia(s) no filtro (m\xe1x. ${$96b2a8c6614c8ae7$var$MAX_DAYS}).`;
    };
    fromEl.addEventListener('change', syncHint);
    toEl.addEventListener('change', syncHint);
    syncHint();
    companyEl.addEventListener('change', async ()=>{
        await $96b2a8c6614c8ae7$var$loadPrograms(programEl, companyEl.value?.trim());
    });
    const consultar = async ()=>{
        const companyId = companyEl.value?.trim();
        if (!companyId) {
            (0, $jUNyh.notify)('Selecione a empresa.');
            return;
        }
        const df = fromEl.value?.trim();
        if (!df) {
            (0, $jUNyh.notify)('Informe a data inicial.');
            return;
        }
        const dt = toEl.value?.trim();
        const days = $96b2a8c6614c8ae7$var$inclusiveDays(df, dt);
        if (days > $96b2a8c6614c8ae7$var$MAX_DAYS) {
            (0, $jUNyh.notify)(`Per\xedodo de ${days} dias excede o m\xe1ximo de ${$96b2a8c6614c8ae7$var$MAX_DAYS} dias.`);
            return;
        }
        const sp = new URLSearchParams();
        sp.set('date_from', df);
        if (dt) sp.set('date_to', dt);
        const pid = programEl.value?.trim();
        if (pid) sp.set('program_id', pid);
        const st = statusEl.value?.trim();
        if (st) sp.set('status', st);
        const drs = $96b2a8c6614c8ae7$var$$('#efat-drs', work)?.value?.trim();
        if (drs) sp.set('drs_id', drs);
        const sla = $96b2a8c6614c8ae7$var$$('#efat-sla', work)?.value?.trim();
        if (sla) sp.set('sla_bucket', sla);
        if ($96b2a8c6614c8ae7$var$$('#efat-canceled', work)?.checked) sp.set('include_canceled', '1');
        sp.set('limit', '200');
        try {
            const res = await (0, $9VcS9.default).especial_sessp_faturas(companyId, sp.toString());
            const raw = await res.text();
            if (!res.ok) {
                (0, $jUNyh.notify)((0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw), "Gest\xe3o de Faturas");
                return;
            }
            const data = JSON.parse(raw);
            lastData = data;
            $96b2a8c6614c8ae7$var$renderKpis($96b2a8c6614c8ae7$var$$('#efat-kpis', work), data.totals);
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-month', work), data.by_month, 'mes_label', 'faturas');
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-bystatus', work), data.by_status, 'label', 'faturas');
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-byprog', work), data.by_program, 'programa', 'faturas');
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-bydrs', work), data.by_drs, 'drs', 'faturas');
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-bysla', work), data.by_sla, 'label', 'faturas');
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-byshift', work), data.by_shift, 'label', 'eventos');
            $96b2a8c6614c8ae7$var$renderBars($96b2a8c6614c8ae7$var$$('#efat-bydwell', work), data.by_status_time, 'label', 'minutos_medios');
            const histAv = $96b2a8c6614c8ae7$var$$('#efat-hist-aviso', work);
            if (histAv) histAv.textContent = data.historico_aviso || '';
            const drsSel = $96b2a8c6614c8ae7$var$$('#efat-drs', work);
            if (drsSel && Array.isArray(data.drs_catalog)) {
                const cur = drsSel.value;
                drsSel.innerHTML = '<option value="">Todos</option>';
                for (const d of data.drs_catalog){
                    const o = document.createElement('option');
                    o.value = d.id;
                    o.textContent = `${d.code || ''} ${d.name || ''}`.trim();
                    drsSel.appendChild(o);
                }
                drsSel.value = cur;
            }
            $96b2a8c6614c8ae7$var$renderTable($96b2a8c6614c8ae7$var$$('#efat-table', work), data.faturas);
            const csvBtn = $96b2a8c6614c8ae7$var$$('#efat-csv', work);
            if (csvBtn) csvBtn.disabled = !data.faturas?.length;
            const shown = data.faturas?.length || 0;
            const tot = data.totals?.faturas || 0;
            (0, $jUNyh.notify)(shown < tot ? `Lista: ${shown} de ${tot} sa\xeddas (teto 200). Use os filtros para recortar.` : `${tot} sa\xedda(s) no per\xedodo.`, "Gest\xe3o de Faturas");
        } catch (e) {
            (0, $jUNyh.notify)(e?.message || 'Falha ao consultar.', "Gest\xe3o de Faturas");
        }
    };
    $96b2a8c6614c8ae7$var$$('#efat-go', work).addEventListener('click', consultar);
    $96b2a8c6614c8ae7$var$$('#efat-csv', work).addEventListener('click', ()=>{
        if (!lastData?.faturas?.length) {
            (0, $jUNyh.notify)('Consulte antes de exportar.');
            return;
        }
        $96b2a8c6614c8ae7$var$downloadListaCsv(lastData);
    });
    work.addEventListener('click', async (ev)=>{
        const histBtn = ev.target.closest?.('.efat-hist');
        const btn = ev.target.closest?.('.efat-open');
        if (!btn && !histBtn || !work.contains(btn || histBtn)) return;
        const saida = (btn || histBtn).getAttribute('data-saida');
        const companyId = companyEl.value?.trim();
        if (!saida || !companyId) return;
        const detailRow = work.querySelector(`tr.efat-detail[data-detail-for="${saida}"]`);
        if (!detailRow) return;
        const box = detailRow.querySelector('.efat-detail-box');
        const kind = histBtn ? 'hist' : 'itens';
        if (!detailRow.hidden && box?.dataset.loaded === kind) {
            detailRow.hidden = true;
            return;
        }
        detailRow.hidden = false;
        if (box?.dataset.loaded === kind) return;
        box.dataset.loaded = '';
        box.textContent = kind === 'hist' ? "Carregando hist\xf3rico\u2026" : "Carregando itens\u2026";
        try {
            if (kind === 'hist') {
                const sp = new URLSearchParams({
                    output_id: saida
                });
                const res = await (0, $9VcS9.default).especial_sessp_faturas_historico(companyId, sp.toString());
                const raw = await res.text();
                if (!res.ok) {
                    box.textContent = (0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw);
                    return;
                }
                const data = JSON.parse(raw);
                const evs = Array.isArray(data.eventos) ? data.eventos : [];
                if (!evs.length) {
                    box.textContent = "Sem hist\xf3rico para esta sa\xedda.";
                    box.dataset.loaded = kind;
                    return;
                }
                const fonte = data.fonte === 'proxy' ? '<p class="muted">Ainda sem log gravado \u2014 hor\xe1rios aproximados (cria\xe7\xe3o / separa\xe7\xe3o / confer\xeancia / conclus\xe3o).</p>' : '';
                let h = `${fonte}<table class="view fsx"><thead><tr><th>Quando</th><th>Status</th><th>Turno</th><th>Min. at\xe9 o pr\xf3ximo</th></tr></thead><tbody>`;
                for (const it of evs)h += `<tr>
						<td>${$96b2a8c6614c8ae7$var$esc(it.changed_at)}</td>
						<td>${$96b2a8c6614c8ae7$var$esc(it.new_status_label)}</td>
						<td>${$96b2a8c6614c8ae7$var$esc(it.turno)} ${$96b2a8c6614c8ae7$var$esc(it.turno_janela)}</td>
						<td>${it.minutos_ate_proximo == null ? '' : $96b2a8c6614c8ae7$var$qty(it.minutos_ate_proximo)}</td>
					</tr>`;
                h += '</tbody></table>';
                box.innerHTML = h;
                box.dataset.loaded = kind;
                return;
            }
            const sp = new URLSearchParams({
                output_id: saida
            });
            const res = await (0, $9VcS9.default).especial_sessp_faturas_itens(companyId, sp.toString());
            const raw = await res.text();
            if (!res.ok) {
                box.textContent = (0, $c51c1c116667c9de$export$929b0fbc18b1377e)(res.status, raw);
                return;
            }
            const data = JSON.parse(raw);
            const itens = Array.isArray(data.itens) ? data.itens : [];
            if (!itens.length) {
                box.textContent = "Esta sa\xedda n\xe3o tem itens.";
                box.dataset.loaded = 'itens';
                return;
            }
            let h = '<table class="view fsx"><thead><tr><th>Linha</th><th>SKU</th><th>Produto</th><th>Lote</th><th>Qtd pedida</th><th>Qtd sep.</th><th>Pre\xe7o un.</th><th>Valor</th></tr></thead><tbody>';
            for (const it of itens)h += `<tr>
					<td>${$96b2a8c6614c8ae7$var$esc(it.linha)}</td>
					<td>${$96b2a8c6614c8ae7$var$esc(it.sku)}</td>
					<td>${$96b2a8c6614c8ae7$var$esc(it.produto)}</td>
					<td>${$96b2a8c6614c8ae7$var$esc(it.lote)}</td>
					<td>${$96b2a8c6614c8ae7$var$qty(it.qtd_pedida)}</td>
					<td>${it.qtd_separada == null ? '' : $96b2a8c6614c8ae7$var$qty(it.qtd_separada)}</td>
					<td>${$96b2a8c6614c8ae7$var$esc($96b2a8c6614c8ae7$var$money(it.preco_unit))}</td>
					<td>${$96b2a8c6614c8ae7$var$esc($96b2a8c6614c8ae7$var$money(it.valor))}</td>
				</tr>`;
            h += '</tbody></table>';
            box.innerHTML = h;
            box.dataset.loaded = 'itens';
        } catch (e) {
            box.textContent = e?.message || (kind === 'hist' ? "Falha ao carregar hist\xf3rico." : 'Falha ao carregar itens.');
        }
    });
}



// Título da aba por ambiente (hostname da página, não API_BASE)
if (typeof window !== 'undefined' && (window.location.hostname === '10.10.0.219' || window.location.hostname === 'qa.sial.run')) document.title = 'QA SIAL';
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#companies', (0, $4e09ec6288da1fd7$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#suppliers', (0, $b8958290655d6aea$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customers', (0, $814cf36e1b964bdf$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#customer-routes', (0, $63c95189ff1fc725$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#carriers', (0, $bf6317b83db2cd5d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#devices', (0, $72c9f6cb63809845$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-docks', (0, $9254eb1bc1602f3c$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#units', (0, $157d0f4971612fc5$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#classes', (0, $ffea07134e071bfc$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#categories', (0, $7113b1f3aa2dbdf1$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#manufacturers', (0, $63ee0a3c4d5a5d51$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#products', (0, $3b9ac53687e0fa72$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#product-packagings', (0, $7502d76b32eebada$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#warehouses', (0, $47151db783ea97b2$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#locations', (0, $2332a4e102178b91$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#stocks', (0, $b94ca141f2d5964b$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#stock-management', (0, $5595bfa8ce07cb50$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#transactions', (0, $d95b661ee91ff067$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#movements', (0, $6a3c457a33663b1a$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#dock-expedition', (0, $ab77588e26c17613$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-dock-schedules', (0, $2ab24e4cc07eea21$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#picking-waves', (0, $39d39362129bbd6c$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#replenishments', (0, $9433fae8a6136621$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#replenishment-orders', (0, $46eb3da09fc3b5ed$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#goto-replenishment-orders', ()=>{
    location.hash = '';
    location.hash = '#replenishment-orders';
});
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#goto-replenishment-rules', ()=>{
    location.hash = '';
    location.hash = '#replenishments';
});
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inventories', (0, $a856b19a551476c1$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-orders', (0, $41d7c55d2e4dc43d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#output-orders', (0, $b31c53df218c817e$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#inputs', (0, $ee2c059f60a8fc19$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#lots', (0, $a9f17bf16ff5b79a$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#outputs', (0, $9bfec621929b0c49$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#output-picking-boxes', (0, $f810a2183d631f22$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#output-picking-countbacks', (0, $94df30eeff58fec0$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#price-lists', (0, $5f8cf8bc5abf9d48$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#payment-terms', (0, $e5cbae575b333663$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#cfops', (0, $d5d475eb438dd51e$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#programs', (0, $e7e1d1109d9bcdea$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#receipt-types', (0, $fddcf708043881a5$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#input-cancel-reasons', (0, $8a1291ff72b4a75f$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#stock-block-kinds', (0, $61dd04bf6ff4dd5e$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#invoices', (0, $e8c0107621152558$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#invoice-lots', (0, $c15275aa38f8683d$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#nfe-emission-control', (0, $2a8fd6eadff71f40$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#groups', (0, $f9ccb4979589756b$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#users', (0, $fd46b4f29c53dd9f$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#logs', (0, $307409da5029dbc2$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#integration-events', (0, $0a73b38866ec3649$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#logout', (0, $ef33fadb70b8678b$export$2e2bcd8739ae039).logout);
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#about', (0, $754162cf0396517c$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#import-center', (0, $4858a4427bfed1ff$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#bi-kardex', (0, $f56259f2fdff9c56$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#bi-stock-analytical', (0, $88786ec43c4e99d0$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#bi-stock-blocks-descriptive', (0, $95745c83cd57cc50$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#bi-audit', (0, $8aeea42f3245a670$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#bi-output-lines', (0, $022b4203f5491b3e$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#bi-output-productivity', (0, $0e7b01c5410eb81b$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#invoices-billed-exclusive', (0, $1c20395c759c7b39$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#expiring-items', (0, $23e301c8ec8bb92c$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#especial-faturas', (0, $96b2a8c6614c8ae7$export$2e2bcd8739ae039));
(0, $a020c0121b2250d6$export$2e2bcd8739ae039).set('#especial-sessp-faturas', (0, $96b2a8c6614c8ae7$export$2e2bcd8739ae039));
const $12b3a5c9b54ca0c6$var$loadShell = function() {
    (0, $1cmSR.default).define([
        {
            store: 'endpoints',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'groups',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'users',
            keys: [
                'id',
                'username'
            ]
        },
        {
            store: 'cities',
            keys: [
                'id',
                [
                    'state',
                    'city'
                ],
                'state'
            ]
        },
        {
            store: 'companies',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'all_companies',
            keys: [
                'id',
                'name'
            ]
        },
        {
            store: 'warehouses',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'locations',
            keys: [
                [
                    'company_id',
                    'warehouse_id',
                    'id'
                ],
                [
                    'company_id',
                    'warehouse_id',
                    'address'
                ]
            ]
        },
        {
            store: 'units',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'classes',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'categories',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'manufacturers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'programs',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'receipt_types',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'code'
                ]
            ]
        },
        {
            store: 'input_docks',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'input_cancel_reasons',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'stock_block_kinds',
            keys: [
                [
                    'company_id',
                    'code'
                ]
            ]
        },
        {
            store: 'customer_routes',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'code'
                ]
            ]
        },
        {
            store: 'products',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'product_packagings',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'product_id'
                ]
            ]
        },
        {
            store: 'lots',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'product_id'
                ]
            ]
        },
        {
            store: 'payment_terms',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'price_lists',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'suppliers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'nick'
                ]
            ]
        },
        {
            store: 'customers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'nick'
                ]
            ]
        },
        {
            store: 'carriers',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'nick'
                ]
            ]
        },
        {
            store: 'devices',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'name'
                ]
            ]
        },
        {
            store: 'cfops',
            keys: [
                [
                    'company_id',
                    'id'
                ],
                [
                    'company_id',
                    'code'
                ]
            ]
        },
        {
            store: 'class_tribs',
            keys: [
                'code',
                'name'
            ]
        }
    ], 'sial', 7);
    let name = sessionStorage.username.split('.').map((name)=>name[0].toLocaleUpperCase() + name.slice(1)); // Always first.last
    document.body.innerHTML = (0, $a6c3e59798a8ecf3$export$2e2bcd8739ae039)(`${name[0]} ${name[1] || ''}`);
    (0, $13f9b1224978e2a9$export$8de14bff94900edc)().then((0, $13f9b1224978e2a9$export$5b42cd9c963e2b15));
    document.querySelector('.menu').addEventListener('click', (ev)=>{
        const item = ev.target.closest('[hash]');
        if (!item || !ev.currentTarget.contains(item)) return;
        const hash = item.getAttribute('hash');
        if (!hash) return;
        location.hash = '';
        location.hash = hash;
    });
    if (!sessionStorage.reset) {
        (0, $1cmSR.default).init();
        sessionStorage.setItem('reset', 'true');
    }
    (0, $a020c0121b2250d6$export$2e2bcd8739ae039).init();
};
if (!sessionStorage.username) (0, $ef33fadb70b8678b$export$2e2bcd8739ae039).login($12b3a5c9b54ca0c6$var$loadShell);
else $12b3a5c9b54ca0c6$var$loadShell();


//# sourceMappingURL=SIAL_DEV.e44db91e.js.map
